var np = Object.defineProperty;
var Pf = (Bi) => {
  throw TypeError(Bi);
};
var ip = (Bi, e, Ui) => e in Bi ? np(Bi, e, { enumerable: !0, configurable: !0, writable: !0, value: Ui }) : Bi[e] = Ui;
var hd = (Bi, e, Ui) => ip(Bi, typeof e != "symbol" ? e + "" : e, Ui), Jd = (Bi, e, Ui) => e.has(Bi) || Pf("Cannot " + Ui);
var Gl = (Bi, e, Ui) => (Jd(Bi, e, "read from private field"), Ui ? Ui.call(Bi) : e.get(Bi)), fc = (Bi, e, Ui) => e.has(Bi) ? Pf("Cannot add the same private member more than once") : e instanceof WeakSet ? e.add(Bi) : e.set(Bi, Ui), lu = (Bi, e, Ui, Zi) => (Jd(Bi, e, "write to private field"), Zi ? Zi.call(Bi, Ui) : e.set(Bi, Ui), Ui), lc = (Bi, e, Ui) => (Jd(Bi, e, "access private method"), Ui);
var ef = (Bi, e, Ui, Zi) => ({
  set _(ta) {
    lu(Bi, e, ta, Ui);
  },
  get _() {
    return Gl(Bi, e, Zi);
  }
});
import * as a$8 from "react";
import a__default, { useState, createContext, useContext, useLayoutEffect, useEffect, useRef, useCallback, useMemo, forwardRef, createElement as createElement$1, cloneElement, Children, isValidElement, Component, memo, PureComponent, useReducer, useImperativeHandle, Fragment } from "react";
import $4AOtR$reactdom, { flushSync as flushSync$1, createPortal, unstable_batchedUpdates } from "react-dom";
import styled, { keyframes as keyframes$2 } from "styled-components";
import { toast } from "react-toastify";
import { useMutation, useQuery, QueryClientProvider } from "@tanstack/react-query";
import { useField } from "formik";
import { Link } from "react-router-dom";
import { Outlet } from "react-router";
import * as Apollo from "@apollo/client";
import { gql } from "@apollo/client";
function getDefaultExportFromCjs(Bi) {
  return Bi && Bi.__esModule && Object.prototype.hasOwnProperty.call(Bi, "default") ? Bi.default : Bi;
}
function getAugmentedNamespace(Bi) {
  if (Object.prototype.hasOwnProperty.call(Bi, "__esModule")) return Bi;
  var e = Bi.default;
  if (typeof e == "function") {
    var Ui = function Zi() {
      return this instanceof Zi ? Reflect.construct(e, arguments, this.constructor) : e.apply(this, arguments);
    };
    Ui.prototype = e.prototype;
  } else Ui = {};
  return Object.defineProperty(Ui, "__esModule", { value: !0 }), Object.keys(Bi).forEach(function(Zi) {
    var ta = Object.getOwnPropertyDescriptor(Bi, Zi);
    Object.defineProperty(Ui, Zi, ta.get ? ta : {
      enumerable: !0,
      get: function() {
        return Bi[Zi];
      }
    });
  }), Ui;
}
var jsxRuntime = { exports: {} }, reactJsxRuntime_production_min = {};
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var hasRequiredReactJsxRuntime_production_min;
function requireReactJsxRuntime_production_min() {
  if (hasRequiredReactJsxRuntime_production_min) return reactJsxRuntime_production_min;
  hasRequiredReactJsxRuntime_production_min = 1;
  var Bi = a__default, e = Symbol.for("react.element"), Ui = Symbol.for("react.fragment"), Zi = Object.prototype.hasOwnProperty, ta = Bi.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, na = { key: !0, ref: !0, __self: !0, __source: !0 };
  function ia(aa, da, La) {
    var qa, io = {}, ao = null, oo = null;
    La !== void 0 && (ao = "" + La), da.key !== void 0 && (ao = "" + da.key), da.ref !== void 0 && (oo = da.ref);
    for (qa in da) Zi.call(da, qa) && !na.hasOwnProperty(qa) && (io[qa] = da[qa]);
    if (aa && aa.defaultProps) for (qa in da = aa.defaultProps, da) io[qa] === void 0 && (io[qa] = da[qa]);
    return { $$typeof: e, type: aa, key: ao, ref: oo, props: io, _owner: ta.current };
  }
  return reactJsxRuntime_production_min.Fragment = Ui, reactJsxRuntime_production_min.jsx = ia, reactJsxRuntime_production_min.jsxs = ia, reactJsxRuntime_production_min;
}
var reactJsxRuntime_development = {};
/**
 * @license React
 * react-jsx-runtime.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var hasRequiredReactJsxRuntime_development;
function requireReactJsxRuntime_development() {
  return hasRequiredReactJsxRuntime_development || (hasRequiredReactJsxRuntime_development = 1, process.env.NODE_ENV !== "production" && function() {
    var Bi = a__default, e = Symbol.for("react.element"), Ui = Symbol.for("react.portal"), Zi = Symbol.for("react.fragment"), ta = Symbol.for("react.strict_mode"), na = Symbol.for("react.profiler"), ia = Symbol.for("react.provider"), aa = Symbol.for("react.context"), da = Symbol.for("react.forward_ref"), La = Symbol.for("react.suspense"), qa = Symbol.for("react.suspense_list"), io = Symbol.for("react.memo"), ao = Symbol.for("react.lazy"), oo = Symbol.for("react.offscreen"), no = Symbol.iterator, lo = "@@iterator";
    function so(Ql) {
      if (Ql === null || typeof Ql != "object")
        return null;
      var uc = no && Ql[no] || Ql[lo];
      return typeof uc == "function" ? uc : null;
    }
    var bs = Bi.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function Rs(Ql) {
      {
        for (var uc = arguments.length, Ju = new Array(uc > 1 ? uc - 1 : 0), rd = 1; rd < uc; rd++)
          Ju[rd - 1] = arguments[rd];
        js("error", Ql, Ju);
      }
    }
    function js(Ql, uc, Ju) {
      {
        var rd = bs.ReactDebugCurrentFrame, cd = rd.getStackAddendum();
        cd !== "" && (uc += "%s", Ju = Ju.concat([cd]));
        var gd = Ju.map(function(ud) {
          return String(ud);
        });
        gd.unshift("Warning: " + uc), Function.prototype.apply.call(console[Ql], console, gd);
      }
    }
    var qs = !1, jo = !1, fs = !1, Ao = !1, co = !1, Co;
    Co = Symbol.for("react.module.reference");
    function Zs(Ql) {
      return !!(typeof Ql == "string" || typeof Ql == "function" || Ql === Zi || Ql === na || co || Ql === ta || Ql === La || Ql === qa || Ao || Ql === oo || qs || jo || fs || typeof Ql == "object" && Ql !== null && (Ql.$$typeof === ao || Ql.$$typeof === io || Ql.$$typeof === ia || Ql.$$typeof === aa || Ql.$$typeof === da || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      Ql.$$typeof === Co || Ql.getModuleId !== void 0));
    }
    function xl(Ql, uc, Ju) {
      var rd = Ql.displayName;
      if (rd)
        return rd;
      var cd = uc.displayName || uc.name || "";
      return cd !== "" ? Ju + "(" + cd + ")" : Ju;
    }
    function Cl(Ql) {
      return Ql.displayName || "Context";
    }
    function Al(Ql) {
      if (Ql == null)
        return null;
      if (typeof Ql.tag == "number" && Rs("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof Ql == "function")
        return Ql.displayName || Ql.name || null;
      if (typeof Ql == "string")
        return Ql;
      switch (Ql) {
        case Zi:
          return "Fragment";
        case Ui:
          return "Portal";
        case na:
          return "Profiler";
        case ta:
          return "StrictMode";
        case La:
          return "Suspense";
        case qa:
          return "SuspenseList";
      }
      if (typeof Ql == "object")
        switch (Ql.$$typeof) {
          case aa:
            var uc = Ql;
            return Cl(uc) + ".Consumer";
          case ia:
            var Ju = Ql;
            return Cl(Ju._context) + ".Provider";
          case da:
            return xl(Ql, Ql.render, "ForwardRef");
          case io:
            var rd = Ql.displayName || null;
            return rd !== null ? rd : Al(Ql.type) || "Memo";
          case ao: {
            var cd = Ql, gd = cd._payload, ud = cd._init;
            try {
              return Al(ud(gd));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    var Ol = Object.assign, Bl = 0, Ml, Vl, Ll, Yl, Zl, tc, Nl;
    function Tl() {
    }
    Tl.__reactDisabledLog = !0;
    function El() {
      {
        if (Bl === 0) {
          Ml = console.log, Vl = console.info, Ll = console.warn, Yl = console.error, Zl = console.group, tc = console.groupCollapsed, Nl = console.groupEnd;
          var Ql = {
            configurable: !0,
            enumerable: !0,
            value: Tl,
            writable: !0
          };
          Object.defineProperties(console, {
            info: Ql,
            log: Ql,
            warn: Ql,
            error: Ql,
            group: Ql,
            groupCollapsed: Ql,
            groupEnd: Ql
          });
        }
        Bl++;
      }
    }
    function Il() {
      {
        if (Bl--, Bl === 0) {
          var Ql = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: Ol({}, Ql, {
              value: Ml
            }),
            info: Ol({}, Ql, {
              value: Vl
            }),
            warn: Ol({}, Ql, {
              value: Ll
            }),
            error: Ol({}, Ql, {
              value: Yl
            }),
            group: Ol({}, Ql, {
              value: Zl
            }),
            groupCollapsed: Ol({}, Ql, {
              value: tc
            }),
            groupEnd: Ol({}, Ql, {
              value: Nl
            })
          });
        }
        Bl < 0 && Rs("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var Ul = bs.ReactCurrentDispatcher, Kl;
    function Rl(Ql, uc, Ju) {
      {
        if (Kl === void 0)
          try {
            throw Error();
          } catch (cd) {
            var rd = cd.stack.trim().match(/\n( *(at )?)/);
            Kl = rd && rd[1] || "";
          }
        return `
` + Kl + Ql;
      }
    }
    var uo = !1, Is;
    {
      var Sl = typeof WeakMap == "function" ? WeakMap : Map;
      Is = new Sl();
    }
    function wl(Ql, uc) {
      if (!Ql || uo)
        return "";
      {
        var Ju = Is.get(Ql);
        if (Ju !== void 0)
          return Ju;
      }
      var rd;
      uo = !0;
      var cd = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var gd;
      gd = Ul.current, Ul.current = null, El();
      try {
        if (uc) {
          var ud = function() {
            throw Error();
          };
          if (Object.defineProperty(ud.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(ud, []);
            } catch (Rd) {
              rd = Rd;
            }
            Reflect.construct(Ql, [], ud);
          } else {
            try {
              ud.call();
            } catch (Rd) {
              rd = Rd;
            }
            Ql.call(ud.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (Rd) {
            rd = Rd;
          }
          Ql();
        }
      } catch (Rd) {
        if (Rd && rd && typeof Rd.stack == "string") {
          for (var ld = Rd.stack.split(`
`), xd = rd.stack.split(`
`), bd = ld.length - 1, $d = xd.length - 1; bd >= 1 && $d >= 0 && ld[bd] !== xd[$d]; )
            $d--;
          for (; bd >= 1 && $d >= 0; bd--, $d--)
            if (ld[bd] !== xd[$d]) {
              if (bd !== 1 || $d !== 1)
                do
                  if (bd--, $d--, $d < 0 || ld[bd] !== xd[$d]) {
                    var Td = `
` + ld[bd].replace(" at new ", " at ");
                    return Ql.displayName && Td.includes("<anonymous>") && (Td = Td.replace("<anonymous>", Ql.displayName)), typeof Ql == "function" && Is.set(Ql, Td), Td;
                  }
                while (bd >= 1 && $d >= 0);
              break;
            }
        }
      } finally {
        uo = !1, Ul.current = gd, Il(), Error.prepareStackTrace = cd;
      }
      var Ld = Ql ? Ql.displayName || Ql.name : "", Of = Ld ? Rl(Ld) : "";
      return typeof Ql == "function" && Is.set(Ql, Of), Of;
    }
    function Pl(Ql, uc, Ju) {
      return wl(Ql, !1);
    }
    function jl(Ql) {
      var uc = Ql.prototype;
      return !!(uc && uc.isReactComponent);
    }
    function Dl(Ql, uc, Ju) {
      if (Ql == null)
        return "";
      if (typeof Ql == "function")
        return wl(Ql, jl(Ql));
      if (typeof Ql == "string")
        return Rl(Ql);
      switch (Ql) {
        case La:
          return Rl("Suspense");
        case qa:
          return Rl("SuspenseList");
      }
      if (typeof Ql == "object")
        switch (Ql.$$typeof) {
          case da:
            return Pl(Ql.render);
          case io:
            return Dl(Ql.type, uc, Ju);
          case ao: {
            var rd = Ql, cd = rd._payload, gd = rd._init;
            try {
              return Dl(gd(cd), uc, Ju);
            } catch {
            }
          }
        }
      return "";
    }
    var $l = Object.prototype.hasOwnProperty, kl = {}, zl = bs.ReactDebugCurrentFrame;
    function Hl(Ql) {
      if (Ql) {
        var uc = Ql._owner, Ju = Dl(Ql.type, Ql._source, uc ? uc.type : null);
        zl.setExtraStackFrame(Ju);
      } else
        zl.setExtraStackFrame(null);
    }
    function Wl(Ql, uc, Ju, rd, cd) {
      {
        var gd = Function.call.bind($l);
        for (var ud in Ql)
          if (gd(Ql, ud)) {
            var ld = void 0;
            try {
              if (typeof Ql[ud] != "function") {
                var xd = Error((rd || "React class") + ": " + Ju + " type `" + ud + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof Ql[ud] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw xd.name = "Invariant Violation", xd;
              }
              ld = Ql[ud](uc, ud, rd, Ju, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (bd) {
              ld = bd;
            }
            ld && !(ld instanceof Error) && (Hl(cd), Rs("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", rd || "React class", Ju, ud, typeof ld), Hl(null)), ld instanceof Error && !(ld.message in kl) && (kl[ld.message] = !0, Hl(cd), Rs("Failed %s type: %s", Ju, ld.message), Hl(null));
          }
      }
    }
    var ql = Array.isArray;
    function Jl(Ql) {
      return ql(Ql);
    }
    function ac(Ql) {
      {
        var uc = typeof Symbol == "function" && Symbol.toStringTag, Ju = uc && Ql[Symbol.toStringTag] || Ql.constructor.name || "Object";
        return Ju;
      }
    }
    function Xl(Ql) {
      try {
        return sc(Ql), !1;
      } catch {
        return !0;
      }
    }
    function sc(Ql) {
      return "" + Ql;
    }
    function Hu(Ql) {
      if (Xl(Ql))
        return Rs("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", ac(Ql)), sc(Ql);
    }
    var dc = bs.ReactCurrentOwner, td = {
      key: !0,
      ref: !0,
      __self: !0,
      __source: !0
    }, ad, od;
    function sd(Ql) {
      if ($l.call(Ql, "ref")) {
        var uc = Object.getOwnPropertyDescriptor(Ql, "ref").get;
        if (uc && uc.isReactWarning)
          return !1;
      }
      return Ql.ref !== void 0;
    }
    function dd(Ql) {
      if ($l.call(Ql, "key")) {
        var uc = Object.getOwnPropertyDescriptor(Ql, "key").get;
        if (uc && uc.isReactWarning)
          return !1;
      }
      return Ql.key !== void 0;
    }
    function pd(Ql, uc) {
      typeof Ql.ref == "string" && dc.current;
    }
    function fd(Ql, uc) {
      {
        var Ju = function() {
          ad || (ad = !0, Rs("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", uc));
        };
        Ju.isReactWarning = !0, Object.defineProperty(Ql, "key", {
          get: Ju,
          configurable: !0
        });
      }
    }
    function Ed(Ql, uc) {
      {
        var Ju = function() {
          od || (od = !0, Rs("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", uc));
        };
        Ju.isReactWarning = !0, Object.defineProperty(Ql, "ref", {
          get: Ju,
          configurable: !0
        });
      }
    }
    var wd = function(Ql, uc, Ju, rd, cd, gd, ud) {
      var ld = {
        // This tag allows us to uniquely identify this as a React Element
        $$typeof: e,
        // Built-in properties that belong on the element
        type: Ql,
        key: uc,
        ref: Ju,
        props: ud,
        // Record the component responsible for creating this element.
        _owner: gd
      };
      return ld._store = {}, Object.defineProperty(ld._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: !1
      }), Object.defineProperty(ld, "_self", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: rd
      }), Object.defineProperty(ld, "_source", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: cd
      }), Object.freeze && (Object.freeze(ld.props), Object.freeze(ld)), ld;
    };
    function Ad(Ql, uc, Ju, rd, cd) {
      {
        var gd, ud = {}, ld = null, xd = null;
        Ju !== void 0 && (Hu(Ju), ld = "" + Ju), dd(uc) && (Hu(uc.key), ld = "" + uc.key), sd(uc) && (xd = uc.ref, pd(uc, cd));
        for (gd in uc)
          $l.call(uc, gd) && !td.hasOwnProperty(gd) && (ud[gd] = uc[gd]);
        if (Ql && Ql.defaultProps) {
          var bd = Ql.defaultProps;
          for (gd in bd)
            ud[gd] === void 0 && (ud[gd] = bd[gd]);
        }
        if (ld || xd) {
          var $d = typeof Ql == "function" ? Ql.displayName || Ql.name || "Unknown" : Ql;
          ld && fd(ud, $d), xd && Ed(ud, $d);
        }
        return wd(Ql, ld, xd, cd, rd, dc.current, ud);
      }
    }
    var oc = bs.ReactCurrentOwner, rc = bs.ReactDebugCurrentFrame;
    function nc(Ql) {
      if (Ql) {
        var uc = Ql._owner, Ju = Dl(Ql.type, Ql._source, uc ? uc.type : null);
        rc.setExtraStackFrame(Ju);
      } else
        rc.setExtraStackFrame(null);
    }
    var ed;
    ed = !1;
    function nd(Ql) {
      return typeof Ql == "object" && Ql !== null && Ql.$$typeof === e;
    }
    function md() {
      {
        if (oc.current) {
          var Ql = Al(oc.current.type);
          if (Ql)
            return `

Check the render method of \`` + Ql + "`.";
        }
        return "";
      }
    }
    function vd(Ql) {
      return "";
    }
    var Cd = {};
    function Id(Ql) {
      {
        var uc = md();
        if (!uc) {
          var Ju = typeof Ql == "string" ? Ql : Ql.displayName || Ql.name;
          Ju && (uc = `

Check the top-level render call using <` + Ju + ">.");
        }
        return uc;
      }
    }
    function Pd(Ql, uc) {
      {
        if (!Ql._store || Ql._store.validated || Ql.key != null)
          return;
        Ql._store.validated = !0;
        var Ju = Id(uc);
        if (Cd[Ju])
          return;
        Cd[Ju] = !0;
        var rd = "";
        Ql && Ql._owner && Ql._owner !== oc.current && (rd = " It was passed a child from " + Al(Ql._owner.type) + "."), nc(Ql), Rs('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', Ju, rd), nc(null);
      }
    }
    function _d(Ql, uc) {
      {
        if (typeof Ql != "object")
          return;
        if (Jl(Ql))
          for (var Ju = 0; Ju < Ql.length; Ju++) {
            var rd = Ql[Ju];
            nd(rd) && Pd(rd, uc);
          }
        else if (nd(Ql))
          Ql._store && (Ql._store.validated = !0);
        else if (Ql) {
          var cd = so(Ql);
          if (typeof cd == "function" && cd !== Ql.entries)
            for (var gd = cd.call(Ql), ud; !(ud = gd.next()).done; )
              nd(ud.value) && Pd(ud.value, uc);
        }
      }
    }
    function Md(Ql) {
      {
        var uc = Ql.type;
        if (uc == null || typeof uc == "string")
          return;
        var Ju;
        if (typeof uc == "function")
          Ju = uc.propTypes;
        else if (typeof uc == "object" && (uc.$$typeof === da || // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        uc.$$typeof === io))
          Ju = uc.propTypes;
        else
          return;
        if (Ju) {
          var rd = Al(uc);
          Wl(Ju, Ql.props, "prop", rd, Ql);
        } else if (uc.PropTypes !== void 0 && !ed) {
          ed = !0;
          var cd = Al(uc);
          Rs("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", cd || "Unknown");
        }
        typeof uc.getDefaultProps == "function" && !uc.getDefaultProps.isReactClassApproved && Rs("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
      }
    }
    function kd(Ql) {
      {
        for (var uc = Object.keys(Ql.props), Ju = 0; Ju < uc.length; Ju++) {
          var rd = uc[Ju];
          if (rd !== "children" && rd !== "key") {
            nc(Ql), Rs("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", rd), nc(null);
            break;
          }
        }
        Ql.ref !== null && (nc(Ql), Rs("Invalid attribute `ref` supplied to `React.Fragment`."), nc(null));
      }
    }
    function jd(Ql, uc, Ju, rd, cd, gd) {
      {
        var ud = Zs(Ql);
        if (!ud) {
          var ld = "";
          (Ql === void 0 || typeof Ql == "object" && Ql !== null && Object.keys(Ql).length === 0) && (ld += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
          var xd = vd();
          xd ? ld += xd : ld += md();
          var bd;
          Ql === null ? bd = "null" : Jl(Ql) ? bd = "array" : Ql !== void 0 && Ql.$$typeof === e ? (bd = "<" + (Al(Ql.type) || "Unknown") + " />", ld = " Did you accidentally export a JSX literal instead of a component?") : bd = typeof Ql, Rs("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", bd, ld);
        }
        var $d = Ad(Ql, uc, Ju, cd, gd);
        if ($d == null)
          return $d;
        if (ud) {
          var Td = uc.children;
          if (Td !== void 0)
            if (rd)
              if (Jl(Td)) {
                for (var Ld = 0; Ld < Td.length; Ld++)
                  _d(Td[Ld], Ql);
                Object.freeze && Object.freeze(Td);
              } else
                Rs("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
            else
              _d(Td, Ql);
        }
        return Ql === Zi ? kd($d) : Md($d), $d;
      }
    }
    function yd(Ql, uc, Ju) {
      return jd(Ql, uc, Ju, !0);
    }
    function Fd(Ql, uc, Ju) {
      return jd(Ql, uc, Ju, !1);
    }
    var Nd = Fd, Ud = yd;
    reactJsxRuntime_development.Fragment = Zi, reactJsxRuntime_development.jsx = Nd, reactJsxRuntime_development.jsxs = Ud;
  }()), reactJsxRuntime_development;
}
var hasRequiredJsxRuntime;
function requireJsxRuntime() {
  return hasRequiredJsxRuntime || (hasRequiredJsxRuntime = 1, process.env.NODE_ENV === "production" ? jsxRuntime.exports = requireReactJsxRuntime_production_min() : jsxRuntime.exports = requireReactJsxRuntime_development()), jsxRuntime.exports;
}
var jsxRuntimeExports = requireJsxRuntime();
function twJoin() {
  for (var Bi = 0, e, Ui, Zi = ""; Bi < arguments.length; )
    (e = arguments[Bi++]) && (Ui = toValue(e)) && (Zi && (Zi += " "), Zi += Ui);
  return Zi;
}
function toValue(Bi) {
  if (typeof Bi == "string")
    return Bi;
  for (var e, Ui = "", Zi = 0; Zi < Bi.length; Zi++)
    Bi[Zi] && (e = toValue(Bi[Zi])) && (Ui && (Ui += " "), Ui += e);
  return Ui;
}
var CLASS_PART_SEPARATOR = "-";
function createClassUtils(Bi) {
  var e = createClassMap(Bi), Ui = Bi.conflictingClassGroups, Zi = Bi.conflictingClassGroupModifiers, ta = Zi === void 0 ? {} : Zi;
  function na(aa) {
    var da = aa.split(CLASS_PART_SEPARATOR);
    return da[0] === "" && da.length !== 1 && da.shift(), getGroupRecursive(da, e) || getGroupIdForArbitraryProperty(aa);
  }
  function ia(aa, da) {
    var La = Ui[aa] || [];
    return da && ta[aa] ? [].concat(La, ta[aa]) : La;
  }
  return {
    getClassGroupId: na,
    getConflictingClassGroupIds: ia
  };
}
function getGroupRecursive(Bi, e) {
  if (Bi.length === 0)
    return e.classGroupId;
  var Ui = Bi[0], Zi = e.nextPart.get(Ui), ta = Zi ? getGroupRecursive(Bi.slice(1), Zi) : void 0;
  if (ta)
    return ta;
  if (e.validators.length !== 0) {
    var na = Bi.join(CLASS_PART_SEPARATOR);
    return e.validators.find(function(ia) {
      var aa = ia.validator;
      return aa(na);
    })?.classGroupId;
  }
}
var arbitraryPropertyRegex = /^\[(.+)\]$/;
function getGroupIdForArbitraryProperty(Bi) {
  if (arbitraryPropertyRegex.test(Bi)) {
    var e = arbitraryPropertyRegex.exec(Bi)[1], Ui = e?.substring(0, e.indexOf(":"));
    if (Ui)
      return "arbitrary.." + Ui;
  }
}
function createClassMap(Bi) {
  var e = Bi.theme, Ui = Bi.prefix, Zi = {
    nextPart: /* @__PURE__ */ new Map(),
    validators: []
  }, ta = getPrefixedClassGroupEntries(Object.entries(Bi.classGroups), Ui);
  return ta.forEach(function(na) {
    var ia = na[0], aa = na[1];
    processClassesRecursively(aa, Zi, ia, e);
  }), Zi;
}
function processClassesRecursively(Bi, e, Ui, Zi) {
  Bi.forEach(function(ta) {
    if (typeof ta == "string") {
      var na = ta === "" ? e : getPart(e, ta);
      na.classGroupId = Ui;
      return;
    }
    if (typeof ta == "function") {
      if (isThemeGetter(ta)) {
        processClassesRecursively(ta(Zi), e, Ui, Zi);
        return;
      }
      e.validators.push({
        validator: ta,
        classGroupId: Ui
      });
      return;
    }
    Object.entries(ta).forEach(function(ia) {
      var aa = ia[0], da = ia[1];
      processClassesRecursively(da, getPart(e, aa), Ui, Zi);
    });
  });
}
function getPart(Bi, e) {
  var Ui = Bi;
  return e.split(CLASS_PART_SEPARATOR).forEach(function(Zi) {
    Ui.nextPart.has(Zi) || Ui.nextPart.set(Zi, {
      nextPart: /* @__PURE__ */ new Map(),
      validators: []
    }), Ui = Ui.nextPart.get(Zi);
  }), Ui;
}
function isThemeGetter(Bi) {
  return Bi.isThemeGetter;
}
function getPrefixedClassGroupEntries(Bi, e) {
  return e ? Bi.map(function(Ui) {
    var Zi = Ui[0], ta = Ui[1], na = ta.map(function(ia) {
      return typeof ia == "string" ? e + ia : typeof ia == "object" ? Object.fromEntries(Object.entries(ia).map(function(aa) {
        var da = aa[0], La = aa[1];
        return [e + da, La];
      })) : ia;
    });
    return [Zi, na];
  }) : Bi;
}
function createLruCache(Bi) {
  if (Bi < 1)
    return {
      get: function() {
      },
      set: function() {
      }
    };
  var e = 0, Ui = /* @__PURE__ */ new Map(), Zi = /* @__PURE__ */ new Map();
  function ta(na, ia) {
    Ui.set(na, ia), e++, e > Bi && (e = 0, Zi = Ui, Ui = /* @__PURE__ */ new Map());
  }
  return {
    get: function(ia) {
      var aa = Ui.get(ia);
      if (aa !== void 0)
        return aa;
      if ((aa = Zi.get(ia)) !== void 0)
        return ta(ia, aa), aa;
    },
    set: function(ia, aa) {
      Ui.has(ia) ? Ui.set(ia, aa) : ta(ia, aa);
    }
  };
}
var IMPORTANT_MODIFIER = "!";
function createSplitModifiers(Bi) {
  var e = Bi.separator || ":", Ui = e.length === 1, Zi = e[0], ta = e.length;
  return function(ia) {
    for (var aa = [], da = 0, La = 0, qa, io = 0; io < ia.length; io++) {
      var ao = ia[io];
      if (da === 0) {
        if (ao === Zi && (Ui || ia.slice(io, io + ta) === e)) {
          aa.push(ia.slice(La, io)), La = io + ta;
          continue;
        }
        if (ao === "/") {
          qa = io;
          continue;
        }
      }
      ao === "[" ? da++ : ao === "]" && da--;
    }
    var oo = aa.length === 0 ? ia : ia.substring(La), no = oo.startsWith(IMPORTANT_MODIFIER), lo = no ? oo.substring(1) : oo, so = qa && qa > La ? qa - La : void 0;
    return {
      modifiers: aa,
      hasImportantModifier: no,
      baseClassName: lo,
      maybePostfixModifierPosition: so
    };
  };
}
function sortModifiers(Bi) {
  if (Bi.length <= 1)
    return Bi;
  var e = [], Ui = [];
  return Bi.forEach(function(Zi) {
    var ta = Zi[0] === "[";
    ta ? (e.push.apply(e, Ui.sort().concat([Zi])), Ui = []) : Ui.push(Zi);
  }), e.push.apply(e, Ui.sort()), e;
}
function createConfigUtils(Bi) {
  return {
    cache: createLruCache(Bi.cacheSize),
    splitModifiers: createSplitModifiers(Bi),
    ...createClassUtils(Bi)
  };
}
var SPLIT_CLASSES_REGEX = /\s+/;
function mergeClassList(Bi, e) {
  var Ui = e.splitModifiers, Zi = e.getClassGroupId, ta = e.getConflictingClassGroupIds, na = /* @__PURE__ */ new Set();
  return Bi.trim().split(SPLIT_CLASSES_REGEX).map(function(ia) {
    var aa = Ui(ia), da = aa.modifiers, La = aa.hasImportantModifier, qa = aa.baseClassName, io = aa.maybePostfixModifierPosition, ao = Zi(io ? qa.substring(0, io) : qa), oo = !!io;
    if (!ao) {
      if (!io)
        return {
          isTailwindClass: !1,
          originalClassName: ia
        };
      if (ao = Zi(qa), !ao)
        return {
          isTailwindClass: !1,
          originalClassName: ia
        };
      oo = !1;
    }
    var no = sortModifiers(da).join(":"), lo = La ? no + IMPORTANT_MODIFIER : no;
    return {
      isTailwindClass: !0,
      modifierId: lo,
      classGroupId: ao,
      originalClassName: ia,
      hasPostfixModifier: oo
    };
  }).reverse().filter(function(ia) {
    if (!ia.isTailwindClass)
      return !0;
    var aa = ia.modifierId, da = ia.classGroupId, La = ia.hasPostfixModifier, qa = aa + da;
    return na.has(qa) ? !1 : (na.add(qa), ta(da, La).forEach(function(io) {
      return na.add(aa + io);
    }), !0);
  }).reverse().map(function(ia) {
    return ia.originalClassName;
  }).join(" ");
}
function createTailwindMerge() {
  for (var Bi = arguments.length, e = new Array(Bi), Ui = 0; Ui < Bi; Ui++)
    e[Ui] = arguments[Ui];
  var Zi, ta, na, ia = aa;
  function aa(La) {
    var qa = e[0], io = e.slice(1), ao = io.reduce(function(oo, no) {
      return no(oo);
    }, qa());
    return Zi = createConfigUtils(ao), ta = Zi.cache.get, na = Zi.cache.set, ia = da, da(La);
  }
  function da(La) {
    var qa = ta(La);
    if (qa)
      return qa;
    var io = mergeClassList(La, Zi);
    return na(La, io), io;
  }
  return function() {
    return ia(twJoin.apply(null, arguments));
  };
}
function fromTheme(Bi) {
  var e = function(Zi) {
    return Zi[Bi] || [];
  };
  return e.isThemeGetter = !0, e;
}
var arbitraryValueRegex = /^\[(?:([a-z-]+):)?(.+)\]$/i, fractionRegex = /^\d+\/\d+$/, stringLengths = /* @__PURE__ */ new Set(["px", "full", "screen"]), tshirtUnitRegex = /^(\d+(\.\d+)?)?(xs|sm|md|lg|xl)$/, lengthUnitRegex = /\d+(%|px|r?em|[sdl]?v([hwib]|min|max)|pt|pc|in|cm|mm|cap|ch|ex|r?lh|cq(w|h|i|b|min|max))|^0$/, shadowRegex = /^-?((\d+)?\.?(\d+)[a-z]+|0)_-?((\d+)?\.?(\d+)[a-z]+|0)/;
function isLength(Bi) {
  return isNumber(Bi) || stringLengths.has(Bi) || fractionRegex.test(Bi) || isArbitraryLength(Bi);
}
function isArbitraryLength(Bi) {
  return getIsArbitraryValue(Bi, "length", isLengthOnly);
}
function isArbitrarySize(Bi) {
  return getIsArbitraryValue(Bi, "size", isNever);
}
function isArbitraryPosition(Bi) {
  return getIsArbitraryValue(Bi, "position", isNever);
}
function isArbitraryUrl(Bi) {
  return getIsArbitraryValue(Bi, "url", isUrl);
}
function isArbitraryNumber(Bi) {
  return getIsArbitraryValue(Bi, "number", isNumber);
}
function isNumber(Bi) {
  return !Number.isNaN(Number(Bi));
}
function isPercent(Bi) {
  return Bi.endsWith("%") && isNumber(Bi.slice(0, -1));
}
function isInteger(Bi) {
  return isIntegerOnly(Bi) || getIsArbitraryValue(Bi, "number", isIntegerOnly);
}
function isArbitraryValue(Bi) {
  return arbitraryValueRegex.test(Bi);
}
function isAny() {
  return !0;
}
function isTshirtSize(Bi) {
  return tshirtUnitRegex.test(Bi);
}
function isArbitraryShadow(Bi) {
  return getIsArbitraryValue(Bi, "", isShadow);
}
function getIsArbitraryValue(Bi, e, Ui) {
  var Zi = arbitraryValueRegex.exec(Bi);
  return Zi ? Zi[1] ? Zi[1] === e : Ui(Zi[2]) : !1;
}
function isLengthOnly(Bi) {
  return lengthUnitRegex.test(Bi);
}
function isNever() {
  return !1;
}
function isUrl(Bi) {
  return Bi.startsWith("url(");
}
function isIntegerOnly(Bi) {
  return Number.isInteger(Number(Bi));
}
function isShadow(Bi) {
  return shadowRegex.test(Bi);
}
function getDefaultConfig() {
  var Bi = fromTheme("colors"), e = fromTheme("spacing"), Ui = fromTheme("blur"), Zi = fromTheme("brightness"), ta = fromTheme("borderColor"), na = fromTheme("borderRadius"), ia = fromTheme("borderSpacing"), aa = fromTheme("borderWidth"), da = fromTheme("contrast"), La = fromTheme("grayscale"), qa = fromTheme("hueRotate"), io = fromTheme("invert"), ao = fromTheme("gap"), oo = fromTheme("gradientColorStops"), no = fromTheme("gradientColorStopPositions"), lo = fromTheme("inset"), so = fromTheme("margin"), bs = fromTheme("opacity"), Rs = fromTheme("padding"), js = fromTheme("saturate"), qs = fromTheme("scale"), jo = fromTheme("sepia"), fs = fromTheme("skew"), Ao = fromTheme("space"), co = fromTheme("translate"), Co = function() {
    return ["auto", "contain", "none"];
  }, Zs = function() {
    return ["auto", "hidden", "clip", "visible", "scroll"];
  }, xl = function() {
    return ["auto", e];
  }, Cl = function() {
    return ["", isLength];
  }, Al = function() {
    return ["auto", isNumber, isArbitraryValue];
  }, Ol = function() {
    return ["bottom", "center", "left", "left-bottom", "left-top", "right", "right-bottom", "right-top", "top"];
  }, Bl = function() {
    return ["solid", "dashed", "dotted", "double", "none"];
  }, Ml = function() {
    return ["normal", "multiply", "screen", "overlay", "darken", "lighten", "color-dodge", "color-burn", "hard-light", "soft-light", "difference", "exclusion", "hue", "saturation", "color", "luminosity", "plus-lighter"];
  }, Vl = function() {
    return ["start", "end", "center", "between", "around", "evenly", "stretch"];
  }, Ll = function() {
    return ["", "0", isArbitraryValue];
  }, Yl = function() {
    return ["auto", "avoid", "all", "avoid-page", "page", "left", "right", "column"];
  }, Zl = function() {
    return [isNumber, isArbitraryNumber];
  }, tc = function() {
    return [isNumber, isArbitraryValue];
  };
  return {
    cacheSize: 500,
    theme: {
      colors: [isAny],
      spacing: [isLength],
      blur: ["none", "", isTshirtSize, isArbitraryLength],
      brightness: Zl(),
      borderColor: [Bi],
      borderRadius: ["none", "", "full", isTshirtSize, isArbitraryLength],
      borderSpacing: [e],
      borderWidth: Cl(),
      contrast: Zl(),
      grayscale: Ll(),
      hueRotate: tc(),
      invert: Ll(),
      gap: [e],
      gradientColorStops: [Bi],
      gradientColorStopPositions: [isPercent, isArbitraryLength],
      inset: xl(),
      margin: xl(),
      opacity: Zl(),
      padding: [e],
      saturate: Zl(),
      scale: Zl(),
      sepia: Ll(),
      skew: tc(),
      space: [e],
      translate: [e]
    },
    classGroups: {
      // Layout
      /**
       * Aspect Ratio
       * @see https://tailwindcss.com/docs/aspect-ratio
       */
      aspect: [{
        aspect: ["auto", "square", "video", isArbitraryValue]
      }],
      /**
       * Container
       * @see https://tailwindcss.com/docs/container
       */
      container: ["container"],
      /**
       * Columns
       * @see https://tailwindcss.com/docs/columns
       */
      columns: [{
        columns: [isTshirtSize]
      }],
      /**
       * Break After
       * @see https://tailwindcss.com/docs/break-after
       */
      "break-after": [{
        "break-after": Yl()
      }],
      /**
       * Break Before
       * @see https://tailwindcss.com/docs/break-before
       */
      "break-before": [{
        "break-before": Yl()
      }],
      /**
       * Break Inside
       * @see https://tailwindcss.com/docs/break-inside
       */
      "break-inside": [{
        "break-inside": ["auto", "avoid", "avoid-page", "avoid-column"]
      }],
      /**
       * Box Decoration Break
       * @see https://tailwindcss.com/docs/box-decoration-break
       */
      "box-decoration": [{
        "box-decoration": ["slice", "clone"]
      }],
      /**
       * Box Sizing
       * @see https://tailwindcss.com/docs/box-sizing
       */
      box: [{
        box: ["border", "content"]
      }],
      /**
       * Display
       * @see https://tailwindcss.com/docs/display
       */
      display: ["block", "inline-block", "inline", "flex", "inline-flex", "table", "inline-table", "table-caption", "table-cell", "table-column", "table-column-group", "table-footer-group", "table-header-group", "table-row-group", "table-row", "flow-root", "grid", "inline-grid", "contents", "list-item", "hidden"],
      /**
       * Floats
       * @see https://tailwindcss.com/docs/float
       */
      float: [{
        float: ["right", "left", "none"]
      }],
      /**
       * Clear
       * @see https://tailwindcss.com/docs/clear
       */
      clear: [{
        clear: ["left", "right", "both", "none"]
      }],
      /**
       * Isolation
       * @see https://tailwindcss.com/docs/isolation
       */
      isolation: ["isolate", "isolation-auto"],
      /**
       * Object Fit
       * @see https://tailwindcss.com/docs/object-fit
       */
      "object-fit": [{
        object: ["contain", "cover", "fill", "none", "scale-down"]
      }],
      /**
       * Object Position
       * @see https://tailwindcss.com/docs/object-position
       */
      "object-position": [{
        object: [].concat(Ol(), [isArbitraryValue])
      }],
      /**
       * Overflow
       * @see https://tailwindcss.com/docs/overflow
       */
      overflow: [{
        overflow: Zs()
      }],
      /**
       * Overflow X
       * @see https://tailwindcss.com/docs/overflow
       */
      "overflow-x": [{
        "overflow-x": Zs()
      }],
      /**
       * Overflow Y
       * @see https://tailwindcss.com/docs/overflow
       */
      "overflow-y": [{
        "overflow-y": Zs()
      }],
      /**
       * Overscroll Behavior
       * @see https://tailwindcss.com/docs/overscroll-behavior
       */
      overscroll: [{
        overscroll: Co()
      }],
      /**
       * Overscroll Behavior X
       * @see https://tailwindcss.com/docs/overscroll-behavior
       */
      "overscroll-x": [{
        "overscroll-x": Co()
      }],
      /**
       * Overscroll Behavior Y
       * @see https://tailwindcss.com/docs/overscroll-behavior
       */
      "overscroll-y": [{
        "overscroll-y": Co()
      }],
      /**
       * Position
       * @see https://tailwindcss.com/docs/position
       */
      position: ["static", "fixed", "absolute", "relative", "sticky"],
      /**
       * Top / Right / Bottom / Left
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      inset: [{
        inset: [lo]
      }],
      /**
       * Right / Left
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      "inset-x": [{
        "inset-x": [lo]
      }],
      /**
       * Top / Bottom
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      "inset-y": [{
        "inset-y": [lo]
      }],
      /**
       * Start
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      start: [{
        start: [lo]
      }],
      /**
       * End
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      end: [{
        end: [lo]
      }],
      /**
       * Top
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      top: [{
        top: [lo]
      }],
      /**
       * Right
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      right: [{
        right: [lo]
      }],
      /**
       * Bottom
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      bottom: [{
        bottom: [lo]
      }],
      /**
       * Left
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      left: [{
        left: [lo]
      }],
      /**
       * Visibility
       * @see https://tailwindcss.com/docs/visibility
       */
      visibility: ["visible", "invisible", "collapse"],
      /**
       * Z-Index
       * @see https://tailwindcss.com/docs/z-index
       */
      z: [{
        z: ["auto", isInteger]
      }],
      // Flexbox and Grid
      /**
       * Flex Basis
       * @see https://tailwindcss.com/docs/flex-basis
       */
      basis: [{
        basis: xl()
      }],
      /**
       * Flex Direction
       * @see https://tailwindcss.com/docs/flex-direction
       */
      "flex-direction": [{
        flex: ["row", "row-reverse", "col", "col-reverse"]
      }],
      /**
       * Flex Wrap
       * @see https://tailwindcss.com/docs/flex-wrap
       */
      "flex-wrap": [{
        flex: ["wrap", "wrap-reverse", "nowrap"]
      }],
      /**
       * Flex
       * @see https://tailwindcss.com/docs/flex
       */
      flex: [{
        flex: ["1", "auto", "initial", "none", isArbitraryValue]
      }],
      /**
       * Flex Grow
       * @see https://tailwindcss.com/docs/flex-grow
       */
      grow: [{
        grow: Ll()
      }],
      /**
       * Flex Shrink
       * @see https://tailwindcss.com/docs/flex-shrink
       */
      shrink: [{
        shrink: Ll()
      }],
      /**
       * Order
       * @see https://tailwindcss.com/docs/order
       */
      order: [{
        order: ["first", "last", "none", isInteger]
      }],
      /**
       * Grid Template Columns
       * @see https://tailwindcss.com/docs/grid-template-columns
       */
      "grid-cols": [{
        "grid-cols": [isAny]
      }],
      /**
       * Grid Column Start / End
       * @see https://tailwindcss.com/docs/grid-column
       */
      "col-start-end": [{
        col: ["auto", {
          span: [isInteger]
        }, isArbitraryValue]
      }],
      /**
       * Grid Column Start
       * @see https://tailwindcss.com/docs/grid-column
       */
      "col-start": [{
        "col-start": Al()
      }],
      /**
       * Grid Column End
       * @see https://tailwindcss.com/docs/grid-column
       */
      "col-end": [{
        "col-end": Al()
      }],
      /**
       * Grid Template Rows
       * @see https://tailwindcss.com/docs/grid-template-rows
       */
      "grid-rows": [{
        "grid-rows": [isAny]
      }],
      /**
       * Grid Row Start / End
       * @see https://tailwindcss.com/docs/grid-row
       */
      "row-start-end": [{
        row: ["auto", {
          span: [isInteger]
        }, isArbitraryValue]
      }],
      /**
       * Grid Row Start
       * @see https://tailwindcss.com/docs/grid-row
       */
      "row-start": [{
        "row-start": Al()
      }],
      /**
       * Grid Row End
       * @see https://tailwindcss.com/docs/grid-row
       */
      "row-end": [{
        "row-end": Al()
      }],
      /**
       * Grid Auto Flow
       * @see https://tailwindcss.com/docs/grid-auto-flow
       */
      "grid-flow": [{
        "grid-flow": ["row", "col", "dense", "row-dense", "col-dense"]
      }],
      /**
       * Grid Auto Columns
       * @see https://tailwindcss.com/docs/grid-auto-columns
       */
      "auto-cols": [{
        "auto-cols": ["auto", "min", "max", "fr", isArbitraryValue]
      }],
      /**
       * Grid Auto Rows
       * @see https://tailwindcss.com/docs/grid-auto-rows
       */
      "auto-rows": [{
        "auto-rows": ["auto", "min", "max", "fr", isArbitraryValue]
      }],
      /**
       * Gap
       * @see https://tailwindcss.com/docs/gap
       */
      gap: [{
        gap: [ao]
      }],
      /**
       * Gap X
       * @see https://tailwindcss.com/docs/gap
       */
      "gap-x": [{
        "gap-x": [ao]
      }],
      /**
       * Gap Y
       * @see https://tailwindcss.com/docs/gap
       */
      "gap-y": [{
        "gap-y": [ao]
      }],
      /**
       * Justify Content
       * @see https://tailwindcss.com/docs/justify-content
       */
      "justify-content": [{
        justify: ["normal"].concat(Vl())
      }],
      /**
       * Justify Items
       * @see https://tailwindcss.com/docs/justify-items
       */
      "justify-items": [{
        "justify-items": ["start", "end", "center", "stretch"]
      }],
      /**
       * Justify Self
       * @see https://tailwindcss.com/docs/justify-self
       */
      "justify-self": [{
        "justify-self": ["auto", "start", "end", "center", "stretch"]
      }],
      /**
       * Align Content
       * @see https://tailwindcss.com/docs/align-content
       */
      "align-content": [{
        content: ["normal"].concat(Vl(), ["baseline"])
      }],
      /**
       * Align Items
       * @see https://tailwindcss.com/docs/align-items
       */
      "align-items": [{
        items: ["start", "end", "center", "baseline", "stretch"]
      }],
      /**
       * Align Self
       * @see https://tailwindcss.com/docs/align-self
       */
      "align-self": [{
        self: ["auto", "start", "end", "center", "stretch", "baseline"]
      }],
      /**
       * Place Content
       * @see https://tailwindcss.com/docs/place-content
       */
      "place-content": [{
        "place-content": [].concat(Vl(), ["baseline"])
      }],
      /**
       * Place Items
       * @see https://tailwindcss.com/docs/place-items
       */
      "place-items": [{
        "place-items": ["start", "end", "center", "baseline", "stretch"]
      }],
      /**
       * Place Self
       * @see https://tailwindcss.com/docs/place-self
       */
      "place-self": [{
        "place-self": ["auto", "start", "end", "center", "stretch"]
      }],
      // Spacing
      /**
       * Padding
       * @see https://tailwindcss.com/docs/padding
       */
      p: [{
        p: [Rs]
      }],
      /**
       * Padding X
       * @see https://tailwindcss.com/docs/padding
       */
      px: [{
        px: [Rs]
      }],
      /**
       * Padding Y
       * @see https://tailwindcss.com/docs/padding
       */
      py: [{
        py: [Rs]
      }],
      /**
       * Padding Start
       * @see https://tailwindcss.com/docs/padding
       */
      ps: [{
        ps: [Rs]
      }],
      /**
       * Padding End
       * @see https://tailwindcss.com/docs/padding
       */
      pe: [{
        pe: [Rs]
      }],
      /**
       * Padding Top
       * @see https://tailwindcss.com/docs/padding
       */
      pt: [{
        pt: [Rs]
      }],
      /**
       * Padding Right
       * @see https://tailwindcss.com/docs/padding
       */
      pr: [{
        pr: [Rs]
      }],
      /**
       * Padding Bottom
       * @see https://tailwindcss.com/docs/padding
       */
      pb: [{
        pb: [Rs]
      }],
      /**
       * Padding Left
       * @see https://tailwindcss.com/docs/padding
       */
      pl: [{
        pl: [Rs]
      }],
      /**
       * Margin
       * @see https://tailwindcss.com/docs/margin
       */
      m: [{
        m: [so]
      }],
      /**
       * Margin X
       * @see https://tailwindcss.com/docs/margin
       */
      mx: [{
        mx: [so]
      }],
      /**
       * Margin Y
       * @see https://tailwindcss.com/docs/margin
       */
      my: [{
        my: [so]
      }],
      /**
       * Margin Start
       * @see https://tailwindcss.com/docs/margin
       */
      ms: [{
        ms: [so]
      }],
      /**
       * Margin End
       * @see https://tailwindcss.com/docs/margin
       */
      me: [{
        me: [so]
      }],
      /**
       * Margin Top
       * @see https://tailwindcss.com/docs/margin
       */
      mt: [{
        mt: [so]
      }],
      /**
       * Margin Right
       * @see https://tailwindcss.com/docs/margin
       */
      mr: [{
        mr: [so]
      }],
      /**
       * Margin Bottom
       * @see https://tailwindcss.com/docs/margin
       */
      mb: [{
        mb: [so]
      }],
      /**
       * Margin Left
       * @see https://tailwindcss.com/docs/margin
       */
      ml: [{
        ml: [so]
      }],
      /**
       * Space Between X
       * @see https://tailwindcss.com/docs/space
       */
      "space-x": [{
        "space-x": [Ao]
      }],
      /**
       * Space Between X Reverse
       * @see https://tailwindcss.com/docs/space
       */
      "space-x-reverse": ["space-x-reverse"],
      /**
       * Space Between Y
       * @see https://tailwindcss.com/docs/space
       */
      "space-y": [{
        "space-y": [Ao]
      }],
      /**
       * Space Between Y Reverse
       * @see https://tailwindcss.com/docs/space
       */
      "space-y-reverse": ["space-y-reverse"],
      // Sizing
      /**
       * Width
       * @see https://tailwindcss.com/docs/width
       */
      w: [{
        w: ["auto", "min", "max", "fit", e]
      }],
      /**
       * Min-Width
       * @see https://tailwindcss.com/docs/min-width
       */
      "min-w": [{
        "min-w": ["min", "max", "fit", isLength]
      }],
      /**
       * Max-Width
       * @see https://tailwindcss.com/docs/max-width
       */
      "max-w": [{
        "max-w": ["0", "none", "full", "min", "max", "fit", "prose", {
          screen: [isTshirtSize]
        }, isTshirtSize, isArbitraryLength]
      }],
      /**
       * Height
       * @see https://tailwindcss.com/docs/height
       */
      h: [{
        h: [e, "auto", "min", "max", "fit"]
      }],
      /**
       * Min-Height
       * @see https://tailwindcss.com/docs/min-height
       */
      "min-h": [{
        "min-h": ["min", "max", "fit", isLength]
      }],
      /**
       * Max-Height
       * @see https://tailwindcss.com/docs/max-height
       */
      "max-h": [{
        "max-h": [e, "min", "max", "fit"]
      }],
      // Typography
      /**
       * Font Size
       * @see https://tailwindcss.com/docs/font-size
       */
      "font-size": [{
        text: ["base", isTshirtSize, isArbitraryLength]
      }],
      /**
       * Font Smoothing
       * @see https://tailwindcss.com/docs/font-smoothing
       */
      "font-smoothing": ["antialiased", "subpixel-antialiased"],
      /**
       * Font Style
       * @see https://tailwindcss.com/docs/font-style
       */
      "font-style": ["italic", "not-italic"],
      /**
       * Font Weight
       * @see https://tailwindcss.com/docs/font-weight
       */
      "font-weight": [{
        font: ["thin", "extralight", "light", "normal", "medium", "semibold", "bold", "extrabold", "black", isArbitraryNumber]
      }],
      /**
       * Font Family
       * @see https://tailwindcss.com/docs/font-family
       */
      "font-family": [{
        font: [isAny]
      }],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-normal": ["normal-nums"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-ordinal": ["ordinal"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-slashed-zero": ["slashed-zero"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-figure": ["lining-nums", "oldstyle-nums"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-spacing": ["proportional-nums", "tabular-nums"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-fraction": ["diagonal-fractions", "stacked-fractons"],
      /**
       * Letter Spacing
       * @see https://tailwindcss.com/docs/letter-spacing
       */
      tracking: [{
        tracking: ["tighter", "tight", "normal", "wide", "wider", "widest", isArbitraryLength]
      }],
      /**
       * Line Clamp
       * @see https://tailwindcss.com/docs/line-clamp
       */
      "line-clamp": [{
        "line-clamp": ["none", isNumber, isArbitraryNumber]
      }],
      /**
       * Line Height
       * @see https://tailwindcss.com/docs/line-height
       */
      leading: [{
        leading: ["none", "tight", "snug", "normal", "relaxed", "loose", isLength]
      }],
      /**
       * List Style Image
       * @see https://tailwindcss.com/docs/list-style-image
       */
      "list-image": [{
        "list-image": ["none", isArbitraryValue]
      }],
      /**
       * List Style Type
       * @see https://tailwindcss.com/docs/list-style-type
       */
      "list-style-type": [{
        list: ["none", "disc", "decimal", isArbitraryValue]
      }],
      /**
       * List Style Position
       * @see https://tailwindcss.com/docs/list-style-position
       */
      "list-style-position": [{
        list: ["inside", "outside"]
      }],
      /**
       * Placeholder Color
       * @deprecated since Tailwind CSS v3.0.0
       * @see https://tailwindcss.com/docs/placeholder-color
       */
      "placeholder-color": [{
        placeholder: [Bi]
      }],
      /**
       * Placeholder Opacity
       * @see https://tailwindcss.com/docs/placeholder-opacity
       */
      "placeholder-opacity": [{
        "placeholder-opacity": [bs]
      }],
      /**
       * Text Alignment
       * @see https://tailwindcss.com/docs/text-align
       */
      "text-alignment": [{
        text: ["left", "center", "right", "justify", "start", "end"]
      }],
      /**
       * Text Color
       * @see https://tailwindcss.com/docs/text-color
       */
      "text-color": [{
        text: [Bi]
      }],
      /**
       * Text Opacity
       * @see https://tailwindcss.com/docs/text-opacity
       */
      "text-opacity": [{
        "text-opacity": [bs]
      }],
      /**
       * Text Decoration
       * @see https://tailwindcss.com/docs/text-decoration
       */
      "text-decoration": ["underline", "overline", "line-through", "no-underline"],
      /**
       * Text Decoration Style
       * @see https://tailwindcss.com/docs/text-decoration-style
       */
      "text-decoration-style": [{
        decoration: [].concat(Bl(), ["wavy"])
      }],
      /**
       * Text Decoration Thickness
       * @see https://tailwindcss.com/docs/text-decoration-thickness
       */
      "text-decoration-thickness": [{
        decoration: ["auto", "from-font", isLength]
      }],
      /**
       * Text Underline Offset
       * @see https://tailwindcss.com/docs/text-underline-offset
       */
      "underline-offset": [{
        "underline-offset": ["auto", isLength]
      }],
      /**
       * Text Decoration Color
       * @see https://tailwindcss.com/docs/text-decoration-color
       */
      "text-decoration-color": [{
        decoration: [Bi]
      }],
      /**
       * Text Transform
       * @see https://tailwindcss.com/docs/text-transform
       */
      "text-transform": ["uppercase", "lowercase", "capitalize", "normal-case"],
      /**
       * Text Overflow
       * @see https://tailwindcss.com/docs/text-overflow
       */
      "text-overflow": ["truncate", "text-ellipsis", "text-clip"],
      /**
       * Text Indent
       * @see https://tailwindcss.com/docs/text-indent
       */
      indent: [{
        indent: [e]
      }],
      /**
       * Vertical Alignment
       * @see https://tailwindcss.com/docs/vertical-align
       */
      "vertical-align": [{
        align: ["baseline", "top", "middle", "bottom", "text-top", "text-bottom", "sub", "super", isArbitraryLength]
      }],
      /**
       * Whitespace
       * @see https://tailwindcss.com/docs/whitespace
       */
      whitespace: [{
        whitespace: ["normal", "nowrap", "pre", "pre-line", "pre-wrap", "break-spaces"]
      }],
      /**
       * Word Break
       * @see https://tailwindcss.com/docs/word-break
       */
      break: [{
        break: ["normal", "words", "all", "keep"]
      }],
      /**
       * Hyphens
       * @see https://tailwindcss.com/docs/hyphens
       */
      hyphens: [{
        hyphens: ["none", "manual", "auto"]
      }],
      /**
       * Content
       * @see https://tailwindcss.com/docs/content
       */
      content: [{
        content: ["none", isArbitraryValue]
      }],
      // Backgrounds
      /**
       * Background Attachment
       * @see https://tailwindcss.com/docs/background-attachment
       */
      "bg-attachment": [{
        bg: ["fixed", "local", "scroll"]
      }],
      /**
       * Background Clip
       * @see https://tailwindcss.com/docs/background-clip
       */
      "bg-clip": [{
        "bg-clip": ["border", "padding", "content", "text"]
      }],
      /**
       * Background Opacity
       * @deprecated since Tailwind CSS v3.0.0
       * @see https://tailwindcss.com/docs/background-opacity
       */
      "bg-opacity": [{
        "bg-opacity": [bs]
      }],
      /**
       * Background Origin
       * @see https://tailwindcss.com/docs/background-origin
       */
      "bg-origin": [{
        "bg-origin": ["border", "padding", "content"]
      }],
      /**
       * Background Position
       * @see https://tailwindcss.com/docs/background-position
       */
      "bg-position": [{
        bg: [].concat(Ol(), [isArbitraryPosition])
      }],
      /**
       * Background Repeat
       * @see https://tailwindcss.com/docs/background-repeat
       */
      "bg-repeat": [{
        bg: ["no-repeat", {
          repeat: ["", "x", "y", "round", "space"]
        }]
      }],
      /**
       * Background Size
       * @see https://tailwindcss.com/docs/background-size
       */
      "bg-size": [{
        bg: ["auto", "cover", "contain", isArbitrarySize]
      }],
      /**
       * Background Image
       * @see https://tailwindcss.com/docs/background-image
       */
      "bg-image": [{
        bg: ["none", {
          "gradient-to": ["t", "tr", "r", "br", "b", "bl", "l", "tl"]
        }, isArbitraryUrl]
      }],
      /**
       * Background Color
       * @see https://tailwindcss.com/docs/background-color
       */
      "bg-color": [{
        bg: [Bi]
      }],
      /**
       * Gradient Color Stops From Position
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-from-pos": [{
        from: [no]
      }],
      /**
       * Gradient Color Stops Via Position
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-via-pos": [{
        via: [no]
      }],
      /**
       * Gradient Color Stops To Position
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-to-pos": [{
        to: [no]
      }],
      /**
       * Gradient Color Stops From
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-from": [{
        from: [oo]
      }],
      /**
       * Gradient Color Stops Via
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-via": [{
        via: [oo]
      }],
      /**
       * Gradient Color Stops To
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-to": [{
        to: [oo]
      }],
      // Borders
      /**
       * Border Radius
       * @see https://tailwindcss.com/docs/border-radius
       */
      rounded: [{
        rounded: [na]
      }],
      /**
       * Border Radius Start
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-s": [{
        "rounded-s": [na]
      }],
      /**
       * Border Radius End
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-e": [{
        "rounded-e": [na]
      }],
      /**
       * Border Radius Top
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-t": [{
        "rounded-t": [na]
      }],
      /**
       * Border Radius Right
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-r": [{
        "rounded-r": [na]
      }],
      /**
       * Border Radius Bottom
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-b": [{
        "rounded-b": [na]
      }],
      /**
       * Border Radius Left
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-l": [{
        "rounded-l": [na]
      }],
      /**
       * Border Radius Start Start
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-ss": [{
        "rounded-ss": [na]
      }],
      /**
       * Border Radius Start End
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-se": [{
        "rounded-se": [na]
      }],
      /**
       * Border Radius End End
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-ee": [{
        "rounded-ee": [na]
      }],
      /**
       * Border Radius End Start
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-es": [{
        "rounded-es": [na]
      }],
      /**
       * Border Radius Top Left
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-tl": [{
        "rounded-tl": [na]
      }],
      /**
       * Border Radius Top Right
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-tr": [{
        "rounded-tr": [na]
      }],
      /**
       * Border Radius Bottom Right
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-br": [{
        "rounded-br": [na]
      }],
      /**
       * Border Radius Bottom Left
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-bl": [{
        "rounded-bl": [na]
      }],
      /**
       * Border Width
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w": [{
        border: [aa]
      }],
      /**
       * Border Width X
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-x": [{
        "border-x": [aa]
      }],
      /**
       * Border Width Y
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-y": [{
        "border-y": [aa]
      }],
      /**
       * Border Width Start
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-s": [{
        "border-s": [aa]
      }],
      /**
       * Border Width End
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-e": [{
        "border-e": [aa]
      }],
      /**
       * Border Width Top
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-t": [{
        "border-t": [aa]
      }],
      /**
       * Border Width Right
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-r": [{
        "border-r": [aa]
      }],
      /**
       * Border Width Bottom
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-b": [{
        "border-b": [aa]
      }],
      /**
       * Border Width Left
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-l": [{
        "border-l": [aa]
      }],
      /**
       * Border Opacity
       * @see https://tailwindcss.com/docs/border-opacity
       */
      "border-opacity": [{
        "border-opacity": [bs]
      }],
      /**
       * Border Style
       * @see https://tailwindcss.com/docs/border-style
       */
      "border-style": [{
        border: [].concat(Bl(), ["hidden"])
      }],
      /**
       * Divide Width X
       * @see https://tailwindcss.com/docs/divide-width
       */
      "divide-x": [{
        "divide-x": [aa]
      }],
      /**
       * Divide Width X Reverse
       * @see https://tailwindcss.com/docs/divide-width
       */
      "divide-x-reverse": ["divide-x-reverse"],
      /**
       * Divide Width Y
       * @see https://tailwindcss.com/docs/divide-width
       */
      "divide-y": [{
        "divide-y": [aa]
      }],
      /**
       * Divide Width Y Reverse
       * @see https://tailwindcss.com/docs/divide-width
       */
      "divide-y-reverse": ["divide-y-reverse"],
      /**
       * Divide Opacity
       * @see https://tailwindcss.com/docs/divide-opacity
       */
      "divide-opacity": [{
        "divide-opacity": [bs]
      }],
      /**
       * Divide Style
       * @see https://tailwindcss.com/docs/divide-style
       */
      "divide-style": [{
        divide: Bl()
      }],
      /**
       * Border Color
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color": [{
        border: [ta]
      }],
      /**
       * Border Color X
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-x": [{
        "border-x": [ta]
      }],
      /**
       * Border Color Y
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-y": [{
        "border-y": [ta]
      }],
      /**
       * Border Color Top
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-t": [{
        "border-t": [ta]
      }],
      /**
       * Border Color Right
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-r": [{
        "border-r": [ta]
      }],
      /**
       * Border Color Bottom
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-b": [{
        "border-b": [ta]
      }],
      /**
       * Border Color Left
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-l": [{
        "border-l": [ta]
      }],
      /**
       * Divide Color
       * @see https://tailwindcss.com/docs/divide-color
       */
      "divide-color": [{
        divide: [ta]
      }],
      /**
       * Outline Style
       * @see https://tailwindcss.com/docs/outline-style
       */
      "outline-style": [{
        outline: [""].concat(Bl())
      }],
      /**
       * Outline Offset
       * @see https://tailwindcss.com/docs/outline-offset
       */
      "outline-offset": [{
        "outline-offset": [isLength]
      }],
      /**
       * Outline Width
       * @see https://tailwindcss.com/docs/outline-width
       */
      "outline-w": [{
        outline: [isLength]
      }],
      /**
       * Outline Color
       * @see https://tailwindcss.com/docs/outline-color
       */
      "outline-color": [{
        outline: [Bi]
      }],
      /**
       * Ring Width
       * @see https://tailwindcss.com/docs/ring-width
       */
      "ring-w": [{
        ring: Cl()
      }],
      /**
       * Ring Width Inset
       * @see https://tailwindcss.com/docs/ring-width
       */
      "ring-w-inset": ["ring-inset"],
      /**
       * Ring Color
       * @see https://tailwindcss.com/docs/ring-color
       */
      "ring-color": [{
        ring: [Bi]
      }],
      /**
       * Ring Opacity
       * @see https://tailwindcss.com/docs/ring-opacity
       */
      "ring-opacity": [{
        "ring-opacity": [bs]
      }],
      /**
       * Ring Offset Width
       * @see https://tailwindcss.com/docs/ring-offset-width
       */
      "ring-offset-w": [{
        "ring-offset": [isLength]
      }],
      /**
       * Ring Offset Color
       * @see https://tailwindcss.com/docs/ring-offset-color
       */
      "ring-offset-color": [{
        "ring-offset": [Bi]
      }],
      // Effects
      /**
       * Box Shadow
       * @see https://tailwindcss.com/docs/box-shadow
       */
      shadow: [{
        shadow: ["", "inner", "none", isTshirtSize, isArbitraryShadow]
      }],
      /**
       * Box Shadow Color
       * @see https://tailwindcss.com/docs/box-shadow-color
       */
      "shadow-color": [{
        shadow: [isAny]
      }],
      /**
       * Opacity
       * @see https://tailwindcss.com/docs/opacity
       */
      opacity: [{
        opacity: [bs]
      }],
      /**
       * Mix Blend Mode
       * @see https://tailwindcss.com/docs/mix-blend-mode
       */
      "mix-blend": [{
        "mix-blend": Ml()
      }],
      /**
       * Background Blend Mode
       * @see https://tailwindcss.com/docs/background-blend-mode
       */
      "bg-blend": [{
        "bg-blend": Ml()
      }],
      // Filters
      /**
       * Filter
       * @deprecated since Tailwind CSS v3.0.0
       * @see https://tailwindcss.com/docs/filter
       */
      filter: [{
        filter: ["", "none"]
      }],
      /**
       * Blur
       * @see https://tailwindcss.com/docs/blur
       */
      blur: [{
        blur: [Ui]
      }],
      /**
       * Brightness
       * @see https://tailwindcss.com/docs/brightness
       */
      brightness: [{
        brightness: [Zi]
      }],
      /**
       * Contrast
       * @see https://tailwindcss.com/docs/contrast
       */
      contrast: [{
        contrast: [da]
      }],
      /**
       * Drop Shadow
       * @see https://tailwindcss.com/docs/drop-shadow
       */
      "drop-shadow": [{
        "drop-shadow": ["", "none", isTshirtSize, isArbitraryValue]
      }],
      /**
       * Grayscale
       * @see https://tailwindcss.com/docs/grayscale
       */
      grayscale: [{
        grayscale: [La]
      }],
      /**
       * Hue Rotate
       * @see https://tailwindcss.com/docs/hue-rotate
       */
      "hue-rotate": [{
        "hue-rotate": [qa]
      }],
      /**
       * Invert
       * @see https://tailwindcss.com/docs/invert
       */
      invert: [{
        invert: [io]
      }],
      /**
       * Saturate
       * @see https://tailwindcss.com/docs/saturate
       */
      saturate: [{
        saturate: [js]
      }],
      /**
       * Sepia
       * @see https://tailwindcss.com/docs/sepia
       */
      sepia: [{
        sepia: [jo]
      }],
      /**
       * Backdrop Filter
       * @deprecated since Tailwind CSS v3.0.0
       * @see https://tailwindcss.com/docs/backdrop-filter
       */
      "backdrop-filter": [{
        "backdrop-filter": ["", "none"]
      }],
      /**
       * Backdrop Blur
       * @see https://tailwindcss.com/docs/backdrop-blur
       */
      "backdrop-blur": [{
        "backdrop-blur": [Ui]
      }],
      /**
       * Backdrop Brightness
       * @see https://tailwindcss.com/docs/backdrop-brightness
       */
      "backdrop-brightness": [{
        "backdrop-brightness": [Zi]
      }],
      /**
       * Backdrop Contrast
       * @see https://tailwindcss.com/docs/backdrop-contrast
       */
      "backdrop-contrast": [{
        "backdrop-contrast": [da]
      }],
      /**
       * Backdrop Grayscale
       * @see https://tailwindcss.com/docs/backdrop-grayscale
       */
      "backdrop-grayscale": [{
        "backdrop-grayscale": [La]
      }],
      /**
       * Backdrop Hue Rotate
       * @see https://tailwindcss.com/docs/backdrop-hue-rotate
       */
      "backdrop-hue-rotate": [{
        "backdrop-hue-rotate": [qa]
      }],
      /**
       * Backdrop Invert
       * @see https://tailwindcss.com/docs/backdrop-invert
       */
      "backdrop-invert": [{
        "backdrop-invert": [io]
      }],
      /**
       * Backdrop Opacity
       * @see https://tailwindcss.com/docs/backdrop-opacity
       */
      "backdrop-opacity": [{
        "backdrop-opacity": [bs]
      }],
      /**
       * Backdrop Saturate
       * @see https://tailwindcss.com/docs/backdrop-saturate
       */
      "backdrop-saturate": [{
        "backdrop-saturate": [js]
      }],
      /**
       * Backdrop Sepia
       * @see https://tailwindcss.com/docs/backdrop-sepia
       */
      "backdrop-sepia": [{
        "backdrop-sepia": [jo]
      }],
      // Tables
      /**
       * Border Collapse
       * @see https://tailwindcss.com/docs/border-collapse
       */
      "border-collapse": [{
        border: ["collapse", "separate"]
      }],
      /**
       * Border Spacing
       * @see https://tailwindcss.com/docs/border-spacing
       */
      "border-spacing": [{
        "border-spacing": [ia]
      }],
      /**
       * Border Spacing X
       * @see https://tailwindcss.com/docs/border-spacing
       */
      "border-spacing-x": [{
        "border-spacing-x": [ia]
      }],
      /**
       * Border Spacing Y
       * @see https://tailwindcss.com/docs/border-spacing
       */
      "border-spacing-y": [{
        "border-spacing-y": [ia]
      }],
      /**
       * Table Layout
       * @see https://tailwindcss.com/docs/table-layout
       */
      "table-layout": [{
        table: ["auto", "fixed"]
      }],
      /**
       * Caption Side
       * @see https://tailwindcss.com/docs/caption-side
       */
      caption: [{
        caption: ["top", "bottom"]
      }],
      // Transitions and Animation
      /**
       * Tranisition Property
       * @see https://tailwindcss.com/docs/transition-property
       */
      transition: [{
        transition: ["none", "all", "", "colors", "opacity", "shadow", "transform", isArbitraryValue]
      }],
      /**
       * Transition Duration
       * @see https://tailwindcss.com/docs/transition-duration
       */
      duration: [{
        duration: tc()
      }],
      /**
       * Transition Timing Function
       * @see https://tailwindcss.com/docs/transition-timing-function
       */
      ease: [{
        ease: ["linear", "in", "out", "in-out", isArbitraryValue]
      }],
      /**
       * Transition Delay
       * @see https://tailwindcss.com/docs/transition-delay
       */
      delay: [{
        delay: tc()
      }],
      /**
       * Animation
       * @see https://tailwindcss.com/docs/animation
       */
      animate: [{
        animate: ["none", "spin", "ping", "pulse", "bounce", isArbitraryValue]
      }],
      // Transforms
      /**
       * Transform
       * @see https://tailwindcss.com/docs/transform
       */
      transform: [{
        transform: ["", "gpu", "none"]
      }],
      /**
       * Scale
       * @see https://tailwindcss.com/docs/scale
       */
      scale: [{
        scale: [qs]
      }],
      /**
       * Scale X
       * @see https://tailwindcss.com/docs/scale
       */
      "scale-x": [{
        "scale-x": [qs]
      }],
      /**
       * Scale Y
       * @see https://tailwindcss.com/docs/scale
       */
      "scale-y": [{
        "scale-y": [qs]
      }],
      /**
       * Rotate
       * @see https://tailwindcss.com/docs/rotate
       */
      rotate: [{
        rotate: [isInteger, isArbitraryValue]
      }],
      /**
       * Translate X
       * @see https://tailwindcss.com/docs/translate
       */
      "translate-x": [{
        "translate-x": [co]
      }],
      /**
       * Translate Y
       * @see https://tailwindcss.com/docs/translate
       */
      "translate-y": [{
        "translate-y": [co]
      }],
      /**
       * Skew X
       * @see https://tailwindcss.com/docs/skew
       */
      "skew-x": [{
        "skew-x": [fs]
      }],
      /**
       * Skew Y
       * @see https://tailwindcss.com/docs/skew
       */
      "skew-y": [{
        "skew-y": [fs]
      }],
      /**
       * Transform Origin
       * @see https://tailwindcss.com/docs/transform-origin
       */
      "transform-origin": [{
        origin: ["center", "top", "top-right", "right", "bottom-right", "bottom", "bottom-left", "left", "top-left", isArbitraryValue]
      }],
      // Interactivity
      /**
       * Accent Color
       * @see https://tailwindcss.com/docs/accent-color
       */
      accent: [{
        accent: ["auto", Bi]
      }],
      /**
       * Appearance
       * @see https://tailwindcss.com/docs/appearance
       */
      appearance: ["appearance-none"],
      /**
       * Cursor
       * @see https://tailwindcss.com/docs/cursor
       */
      cursor: [{
        cursor: ["auto", "default", "pointer", "wait", "text", "move", "help", "not-allowed", "none", "context-menu", "progress", "cell", "crosshair", "vertical-text", "alias", "copy", "no-drop", "grab", "grabbing", "all-scroll", "col-resize", "row-resize", "n-resize", "e-resize", "s-resize", "w-resize", "ne-resize", "nw-resize", "se-resize", "sw-resize", "ew-resize", "ns-resize", "nesw-resize", "nwse-resize", "zoom-in", "zoom-out", isArbitraryValue]
      }],
      /**
       * Caret Color
       * @see https://tailwindcss.com/docs/just-in-time-mode#caret-color-utilities
       */
      "caret-color": [{
        caret: [Bi]
      }],
      /**
       * Pointer Events
       * @see https://tailwindcss.com/docs/pointer-events
       */
      "pointer-events": [{
        "pointer-events": ["none", "auto"]
      }],
      /**
       * Resize
       * @see https://tailwindcss.com/docs/resize
       */
      resize: [{
        resize: ["none", "y", "x", ""]
      }],
      /**
       * Scroll Behavior
       * @see https://tailwindcss.com/docs/scroll-behavior
       */
      "scroll-behavior": [{
        scroll: ["auto", "smooth"]
      }],
      /**
       * Scroll Margin
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-m": [{
        "scroll-m": [e]
      }],
      /**
       * Scroll Margin X
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-mx": [{
        "scroll-mx": [e]
      }],
      /**
       * Scroll Margin Y
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-my": [{
        "scroll-my": [e]
      }],
      /**
       * Scroll Margin Start
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-ms": [{
        "scroll-ms": [e]
      }],
      /**
       * Scroll Margin End
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-me": [{
        "scroll-me": [e]
      }],
      /**
       * Scroll Margin Top
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-mt": [{
        "scroll-mt": [e]
      }],
      /**
       * Scroll Margin Right
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-mr": [{
        "scroll-mr": [e]
      }],
      /**
       * Scroll Margin Bottom
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-mb": [{
        "scroll-mb": [e]
      }],
      /**
       * Scroll Margin Left
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-ml": [{
        "scroll-ml": [e]
      }],
      /**
       * Scroll Padding
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-p": [{
        "scroll-p": [e]
      }],
      /**
       * Scroll Padding X
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-px": [{
        "scroll-px": [e]
      }],
      /**
       * Scroll Padding Y
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-py": [{
        "scroll-py": [e]
      }],
      /**
       * Scroll Padding Start
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-ps": [{
        "scroll-ps": [e]
      }],
      /**
       * Scroll Padding End
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pe": [{
        "scroll-pe": [e]
      }],
      /**
       * Scroll Padding Top
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pt": [{
        "scroll-pt": [e]
      }],
      /**
       * Scroll Padding Right
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pr": [{
        "scroll-pr": [e]
      }],
      /**
       * Scroll Padding Bottom
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pb": [{
        "scroll-pb": [e]
      }],
      /**
       * Scroll Padding Left
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pl": [{
        "scroll-pl": [e]
      }],
      /**
       * Scroll Snap Align
       * @see https://tailwindcss.com/docs/scroll-snap-align
       */
      "snap-align": [{
        snap: ["start", "end", "center", "align-none"]
      }],
      /**
       * Scroll Snap Stop
       * @see https://tailwindcss.com/docs/scroll-snap-stop
       */
      "snap-stop": [{
        snap: ["normal", "always"]
      }],
      /**
       * Scroll Snap Type
       * @see https://tailwindcss.com/docs/scroll-snap-type
       */
      "snap-type": [{
        snap: ["none", "x", "y", "both"]
      }],
      /**
       * Scroll Snap Type Strictness
       * @see https://tailwindcss.com/docs/scroll-snap-type
       */
      "snap-strictness": [{
        snap: ["mandatory", "proximity"]
      }],
      /**
       * Touch Action
       * @see https://tailwindcss.com/docs/touch-action
       */
      touch: [{
        touch: ["auto", "none", "pinch-zoom", "manipulation", {
          pan: ["x", "left", "right", "y", "up", "down"]
        }]
      }],
      /**
       * User Select
       * @see https://tailwindcss.com/docs/user-select
       */
      select: [{
        select: ["none", "text", "all", "auto"]
      }],
      /**
       * Will Change
       * @see https://tailwindcss.com/docs/will-change
       */
      "will-change": [{
        "will-change": ["auto", "scroll", "contents", "transform", isArbitraryValue]
      }],
      // SVG
      /**
       * Fill
       * @see https://tailwindcss.com/docs/fill
       */
      fill: [{
        fill: [Bi, "none"]
      }],
      /**
       * Stroke Width
       * @see https://tailwindcss.com/docs/stroke-width
       */
      "stroke-w": [{
        stroke: [isLength, isArbitraryNumber]
      }],
      /**
       * Stroke
       * @see https://tailwindcss.com/docs/stroke
       */
      stroke: [{
        stroke: [Bi, "none"]
      }],
      // Accessibility
      /**
       * Screen Readers
       * @see https://tailwindcss.com/docs/screen-readers
       */
      sr: ["sr-only", "not-sr-only"]
    },
    conflictingClassGroups: {
      overflow: ["overflow-x", "overflow-y"],
      overscroll: ["overscroll-x", "overscroll-y"],
      inset: ["inset-x", "inset-y", "start", "end", "top", "right", "bottom", "left"],
      "inset-x": ["right", "left"],
      "inset-y": ["top", "bottom"],
      flex: ["basis", "grow", "shrink"],
      gap: ["gap-x", "gap-y"],
      p: ["px", "py", "ps", "pe", "pt", "pr", "pb", "pl"],
      px: ["pr", "pl"],
      py: ["pt", "pb"],
      m: ["mx", "my", "ms", "me", "mt", "mr", "mb", "ml"],
      mx: ["mr", "ml"],
      my: ["mt", "mb"],
      "font-size": ["leading"],
      "fvn-normal": ["fvn-ordinal", "fvn-slashed-zero", "fvn-figure", "fvn-spacing", "fvn-fraction"],
      "fvn-ordinal": ["fvn-normal"],
      "fvn-slashed-zero": ["fvn-normal"],
      "fvn-figure": ["fvn-normal"],
      "fvn-spacing": ["fvn-normal"],
      "fvn-fraction": ["fvn-normal"],
      rounded: ["rounded-s", "rounded-e", "rounded-t", "rounded-r", "rounded-b", "rounded-l", "rounded-ss", "rounded-se", "rounded-ee", "rounded-es", "rounded-tl", "rounded-tr", "rounded-br", "rounded-bl"],
      "rounded-s": ["rounded-ss", "rounded-es"],
      "rounded-e": ["rounded-se", "rounded-ee"],
      "rounded-t": ["rounded-tl", "rounded-tr"],
      "rounded-r": ["rounded-tr", "rounded-br"],
      "rounded-b": ["rounded-br", "rounded-bl"],
      "rounded-l": ["rounded-tl", "rounded-bl"],
      "border-spacing": ["border-spacing-x", "border-spacing-y"],
      "border-w": ["border-w-s", "border-w-e", "border-w-t", "border-w-r", "border-w-b", "border-w-l"],
      "border-w-x": ["border-w-r", "border-w-l"],
      "border-w-y": ["border-w-t", "border-w-b"],
      "border-color": ["border-color-t", "border-color-r", "border-color-b", "border-color-l"],
      "border-color-x": ["border-color-r", "border-color-l"],
      "border-color-y": ["border-color-t", "border-color-b"],
      "scroll-m": ["scroll-mx", "scroll-my", "scroll-ms", "scroll-me", "scroll-mt", "scroll-mr", "scroll-mb", "scroll-ml"],
      "scroll-mx": ["scroll-mr", "scroll-ml"],
      "scroll-my": ["scroll-mt", "scroll-mb"],
      "scroll-p": ["scroll-px", "scroll-py", "scroll-ps", "scroll-pe", "scroll-pt", "scroll-pr", "scroll-pb", "scroll-pl"],
      "scroll-px": ["scroll-pr", "scroll-pl"],
      "scroll-py": ["scroll-pt", "scroll-pb"]
    },
    conflictingClassGroupModifiers: {
      "font-size": ["leading"]
    }
  };
}
var twMerge = /* @__PURE__ */ createTailwindMerge(getDefaultConfig);
function Note(Bi) {
  const { className: e, children: Ui, ...Zi } = Bi;
  return /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: twMerge("p-8", e), ...Zi, children: /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "border border-orange-2 p-4 bg-orange-100", children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx("h2", { className: "text-2xl mb-4", children: Bi.heading || "Note" }),
    Ui
  ] }) });
}
const FlexBox = (Bi) => /* @__PURE__ */ jsxRuntimeExports.jsx("div", { ...Bi });
function r$3(Bi) {
  var e, Ui, Zi = "";
  if (typeof Bi == "string" || typeof Bi == "number") Zi += Bi;
  else if (typeof Bi == "object") if (Array.isArray(Bi)) {
    var ta = Bi.length;
    for (e = 0; e < ta; e++) Bi[e] && (Ui = r$3(Bi[e])) && (Zi && (Zi += " "), Zi += Ui);
  } else for (Ui in Bi) Bi[Ui] && (Zi && (Zi += " "), Zi += Ui);
  return Zi;
}
function clsx() {
  for (var Bi, e, Ui = 0, Zi = "", ta = arguments.length; Ui < ta; Ui++) (Bi = arguments[Ui]) && (e = r$3(Bi)) && (Zi && (Zi += " "), Zi += e);
  return Zi;
}
const falsyToString = (Bi) => typeof Bi == "boolean" ? "".concat(Bi) : Bi === 0 ? "0" : Bi, cx = clsx, cva = (Bi, e) => (Ui) => {
  var Zi;
  if (e?.variants == null) return cx(Bi, Ui?.class, Ui?.className);
  const { variants: ta, defaultVariants: na } = e, ia = Object.keys(ta).map((La) => {
    const qa = Ui?.[La], io = na?.[La];
    if (qa === null) return null;
    const ao = falsyToString(qa) || falsyToString(io);
    return ta[La][ao];
  }), aa = Ui && Object.entries(Ui).reduce((La, qa) => {
    let [io, ao] = qa;
    return ao === void 0 || (La[io] = ao), La;
  }, {}), da = e == null || (Zi = e.compoundVariants) === null || Zi === void 0 ? void 0 : Zi.reduce((La, qa) => {
    let { class: io, className: ao, ...oo } = qa;
    return Object.entries(oo).every((no) => {
      let [lo, so] = no;
      return Array.isArray(so) ? so.includes({
        ...na,
        ...aa
      }[lo]) : {
        ...na,
        ...aa
      }[lo] === so;
    }) ? [
      ...La,
      io,
      ao
    ] : La;
  }, []);
  return cx(Bi, ia, da, Ui?.class, Ui?.className);
}, buttonVariants = cva(
  [
    "z-0",
    "flex-grow-0",
    "px-4",
    "py-2",
    "text-sm",
    "text-white",
    "transition-all",
    "focus:outline-none",
    "focus:ring-2",
    "focus:ring-opacity-75",
    "disabled:opacity-50",
    "disabled:cursor-default"
  ],
  {
    variants: {
      variant: {
        green: "bg-green-400 focus:ring-green-400 hover:bg-green-500 disabled:bg-green-400",
        blue: "bg-blue-400",
        red: "bg-red-400 focus:ring-red-400 hover:bg-red-500 disabled:bg-red-400",
        gray: "text-black bg-neutral-200 focus:ring-gray-200 hover:bg-neutral-300 disabled:bg-neutral-200",
        black: "bg-black focus:ring-neutral-800 hover:bg-neutral-800 disabled:bg-neutral-800"
      }
    }
  }
), Button = ({
  variant: Bi = "black",
  className: e,
  ...Ui
}) => /* @__PURE__ */ jsxRuntimeExports.jsx(
  "button",
  {
    ...Ui,
    className: twMerge(buttonVariants({ variant: Bi }), e)
  }
);
/*!
 * Font Awesome Free 6.7.2 by @fontawesome - https://fontawesome.com
 * License - https://fontawesome.com/license/free (Icons: CC BY 4.0, Fonts: SIL OFL 1.1, Code: MIT License)
 * Copyright 2024 Fonticons, Inc.
 */
const faBars = {
  prefix: "fas",
  iconName: "bars",
  icon: [448, 512, ["navicon"], "f0c9", "M0 96C0 78.3 14.3 64 32 64l384 0c17.7 0 32 14.3 32 32s-14.3 32-32 32L32 128C14.3 128 0 113.7 0 96zM0 256c0-17.7 14.3-32 32-32l384 0c17.7 0 32 14.3 32 32s-14.3 32-32 32L32 288c-17.7 0-32-14.3-32-32zM448 416c0 17.7-14.3 32-32 32L32 448c-17.7 0-32-14.3-32-32s14.3-32 32-32l384 0c17.7 0 32 14.3 32 32z"]
}, faChevronUp = {
  prefix: "fas",
  iconName: "chevron-up",
  icon: [512, 512, [], "f077", "M233.4 105.4c12.5-12.5 32.8-12.5 45.3 0l192 192c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0L256 173.3 86.6 342.6c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3l192-192z"]
}, faClipboard = {
  prefix: "fas",
  iconName: "clipboard",
  icon: [384, 512, [128203], "f328", "M192 0c-41.8 0-77.4 26.7-90.5 64L64 64C28.7 64 0 92.7 0 128L0 448c0 35.3 28.7 64 64 64l256 0c35.3 0 64-28.7 64-64l0-320c0-35.3-28.7-64-64-64l-37.5 0C269.4 26.7 233.8 0 192 0zm0 64a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM112 192l160 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-160 0c-8.8 0-16-7.2-16-16s7.2-16 16-16z"]
}, faUserGear = {
  prefix: "fas",
  iconName: "user-gear",
  icon: [640, 512, ["user-cog"], "f4fe", "M224 0a128 128 0 1 1 0 256A128 128 0 1 1 224 0zM178.3 304l91.4 0c11.8 0 23.4 1.2 34.5 3.3c-2.1 18.5 7.4 35.6 21.8 44.8c-16.6 10.6-26.7 31.6-20 53.3c4 12.9 9.4 25.5 16.4 37.6s15.2 23.1 24.4 33c15.7 16.9 39.6 18.4 57.2 8.7l0 .9c0 9.2 2.7 18.5 7.9 26.3L29.7 512C13.3 512 0 498.7 0 482.3C0 383.8 79.8 304 178.3 304zM436 218.2c0-7 4.5-13.3 11.3-14.8c10.5-2.4 21.5-3.7 32.7-3.7s22.2 1.3 32.7 3.7c6.8 1.5 11.3 7.8 11.3 14.8l0 30.6c7.9 3.4 15.4 7.7 22.3 12.8l24.9-14.3c6.1-3.5 13.7-2.7 18.5 2.4c7.6 8.1 14.3 17.2 20.1 27.2s10.3 20.4 13.5 31c2.1 6.7-1.1 13.7-7.2 17.2l-25 14.4c.4 4 .7 8.1 .7 12.3s-.2 8.2-.7 12.3l25 14.4c6.1 3.5 9.2 10.5 7.2 17.2c-3.3 10.6-7.8 21-13.5 31s-12.5 19.1-20.1 27.2c-4.8 5.1-12.5 5.9-18.5 2.4l-24.9-14.3c-6.9 5.1-14.3 9.4-22.3 12.8l0 30.6c0 7-4.5 13.3-11.3 14.8c-10.5 2.4-21.5 3.7-32.7 3.7s-22.2-1.3-32.7-3.7c-6.8-1.5-11.3-7.8-11.3-14.8l0-30.5c-8-3.4-15.6-7.7-22.5-12.9l-24.7 14.3c-6.1 3.5-13.7 2.7-18.5-2.4c-7.6-8.1-14.3-17.2-20.1-27.2s-10.3-20.4-13.5-31c-2.1-6.7 1.1-13.7 7.2-17.2l24.8-14.3c-.4-4.1-.7-8.2-.7-12.4s.2-8.3 .7-12.4L343.8 325c-6.1-3.5-9.2-10.5-7.2-17.2c3.3-10.6 7.7-21 13.5-31s12.5-19.1 20.1-27.2c4.8-5.1 12.4-5.9 18.5-2.4l24.8 14.3c6.9-5.1 14.5-9.4 22.5-12.9l0-30.5zm92.1 133.5a48.1 48.1 0 1 0 -96.1 0 48.1 48.1 0 1 0 96.1 0z"]
}, faUserCog = faUserGear, faChevronDown = {
  prefix: "fas",
  iconName: "chevron-down",
  icon: [512, 512, [], "f078", "M233.4 406.6c12.5 12.5 32.8 12.5 45.3 0l192-192c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L256 338.7 86.6 169.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l192 192z"]
}, faX = {
  prefix: "fas",
  iconName: "x",
  icon: [384, 512, [120], "58", "M376.6 84.5c11.3-13.6 9.5-33.8-4.1-45.1s-33.8-9.5-45.1 4.1L192 206 56.6 43.5C45.3 29.9 25.1 28.1 11.5 39.4S-3.9 70.9 7.4 84.5L150.3 256 7.4 427.5c-11.3 13.6-9.5 33.8 4.1 45.1s33.8 9.5 45.1-4.1L192 306 327.4 468.5c11.3 13.6 31.5 15.4 45.1 4.1s15.4-31.5 4.1-45.1L233.7 256 376.6 84.5z"]
};
/*!
 * Font Awesome Free 6.7.2 by @fontawesome - https://fontawesome.com
 * License - https://fontawesome.com/license/free (Icons: CC BY 4.0, Fonts: SIL OFL 1.1, Code: MIT License)
 * Copyright 2024 Fonticons, Inc.
 */
function _defineProperty$8(Bi, e, Ui) {
  return (e = _toPropertyKey$1(e)) in Bi ? Object.defineProperty(Bi, e, {
    value: Ui,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : Bi[e] = Ui, Bi;
}
function ownKeys$4(Bi, e) {
  var Ui = Object.keys(Bi);
  if (Object.getOwnPropertySymbols) {
    var Zi = Object.getOwnPropertySymbols(Bi);
    e && (Zi = Zi.filter(function(ta) {
      return Object.getOwnPropertyDescriptor(Bi, ta).enumerable;
    })), Ui.push.apply(Ui, Zi);
  }
  return Ui;
}
function _objectSpread2$1(Bi) {
  for (var e = 1; e < arguments.length; e++) {
    var Ui = arguments[e] != null ? arguments[e] : {};
    e % 2 ? ownKeys$4(Object(Ui), !0).forEach(function(Zi) {
      _defineProperty$8(Bi, Zi, Ui[Zi]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(Bi, Object.getOwnPropertyDescriptors(Ui)) : ownKeys$4(Object(Ui)).forEach(function(Zi) {
      Object.defineProperty(Bi, Zi, Object.getOwnPropertyDescriptor(Ui, Zi));
    });
  }
  return Bi;
}
function _toPrimitive$1(Bi, e) {
  if (typeof Bi != "object" || !Bi) return Bi;
  var Ui = Bi[Symbol.toPrimitive];
  if (Ui !== void 0) {
    var Zi = Ui.call(Bi, e);
    if (typeof Zi != "object") return Zi;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (e === "string" ? String : Number)(Bi);
}
function _toPropertyKey$1(Bi) {
  var e = _toPrimitive$1(Bi, "string");
  return typeof e == "symbol" ? e : e + "";
}
const noop$2 = () => {
};
let _WINDOW = {}, _DOCUMENT = {}, _MUTATION_OBSERVER = null, _PERFORMANCE = {
  mark: noop$2,
  measure: noop$2
};
try {
  typeof window < "u" && (_WINDOW = window), typeof document < "u" && (_DOCUMENT = document), typeof MutationObserver < "u" && (_MUTATION_OBSERVER = MutationObserver), typeof performance < "u" && (_PERFORMANCE = performance);
} catch {
}
const {
  userAgent = ""
} = _WINDOW.navigator || {}, WINDOW = _WINDOW, DOCUMENT = _DOCUMENT, MUTATION_OBSERVER = _MUTATION_OBSERVER, PERFORMANCE = _PERFORMANCE;
WINDOW.document;
const IS_DOM = !!DOCUMENT.documentElement && !!DOCUMENT.head && typeof DOCUMENT.addEventListener == "function" && typeof DOCUMENT.createElement == "function", IS_IE = ~userAgent.indexOf("MSIE") || ~userAgent.indexOf("Trident/");
var p$4 = /fa(s|r|l|t|d|dr|dl|dt|b|k|kd|ss|sr|sl|st|sds|sdr|sdl|sdt)?[\-\ ]/, g$4 = /Font ?Awesome ?([56 ]*)(Solid|Regular|Light|Thin|Duotone|Brands|Free|Pro|Sharp Duotone|Sharp|Kit)?.*/i, S$2 = {
  classic: {
    fa: "solid",
    fas: "solid",
    "fa-solid": "solid",
    far: "regular",
    "fa-regular": "regular",
    fal: "light",
    "fa-light": "light",
    fat: "thin",
    "fa-thin": "thin",
    fab: "brands",
    "fa-brands": "brands"
  },
  duotone: {
    fa: "solid",
    fad: "solid",
    "fa-solid": "solid",
    "fa-duotone": "solid",
    fadr: "regular",
    "fa-regular": "regular",
    fadl: "light",
    "fa-light": "light",
    fadt: "thin",
    "fa-thin": "thin"
  },
  sharp: {
    fa: "solid",
    fass: "solid",
    "fa-solid": "solid",
    fasr: "regular",
    "fa-regular": "regular",
    fasl: "light",
    "fa-light": "light",
    fast: "thin",
    "fa-thin": "thin"
  },
  "sharp-duotone": {
    fa: "solid",
    fasds: "solid",
    "fa-solid": "solid",
    fasdr: "regular",
    "fa-regular": "regular",
    fasdl: "light",
    "fa-light": "light",
    fasdt: "thin",
    "fa-thin": "thin"
  }
}, A$3 = {
  GROUP: "duotone-group",
  PRIMARY: "primary",
  SECONDARY: "secondary"
}, P$4 = ["fa-classic", "fa-duotone", "fa-sharp", "fa-sharp-duotone"], s$5 = "classic", t$7 = "duotone", r$2 = "sharp", o$1 = "sharp-duotone", L$3 = [s$5, t$7, r$2, o$1], G$3 = {
  classic: {
    900: "fas",
    400: "far",
    normal: "far",
    300: "fal",
    100: "fat"
  },
  duotone: {
    900: "fad",
    400: "fadr",
    300: "fadl",
    100: "fadt"
  },
  sharp: {
    900: "fass",
    400: "fasr",
    300: "fasl",
    100: "fast"
  },
  "sharp-duotone": {
    900: "fasds",
    400: "fasdr",
    300: "fasdl",
    100: "fasdt"
  }
}, lt$3 = {
  "Font Awesome 6 Free": {
    900: "fas",
    400: "far"
  },
  "Font Awesome 6 Pro": {
    900: "fas",
    400: "far",
    normal: "far",
    300: "fal",
    100: "fat"
  },
  "Font Awesome 6 Brands": {
    400: "fab",
    normal: "fab"
  },
  "Font Awesome 6 Duotone": {
    900: "fad",
    400: "fadr",
    normal: "fadr",
    300: "fadl",
    100: "fadt"
  },
  "Font Awesome 6 Sharp": {
    900: "fass",
    400: "fasr",
    normal: "fasr",
    300: "fasl",
    100: "fast"
  },
  "Font Awesome 6 Sharp Duotone": {
    900: "fasds",
    400: "fasdr",
    normal: "fasdr",
    300: "fasdl",
    100: "fasdt"
  }
}, pt$3 = /* @__PURE__ */ new Map([["classic", {
  defaultShortPrefixId: "fas",
  defaultStyleId: "solid",
  styleIds: ["solid", "regular", "light", "thin", "brands"],
  futureStyleIds: [],
  defaultFontWeight: 900
}], ["sharp", {
  defaultShortPrefixId: "fass",
  defaultStyleId: "solid",
  styleIds: ["solid", "regular", "light", "thin"],
  futureStyleIds: [],
  defaultFontWeight: 900
}], ["duotone", {
  defaultShortPrefixId: "fad",
  defaultStyleId: "solid",
  styleIds: ["solid", "regular", "light", "thin"],
  futureStyleIds: [],
  defaultFontWeight: 900
}], ["sharp-duotone", {
  defaultShortPrefixId: "fasds",
  defaultStyleId: "solid",
  styleIds: ["solid", "regular", "light", "thin"],
  futureStyleIds: [],
  defaultFontWeight: 900
}]]), xt$3 = {
  classic: {
    solid: "fas",
    regular: "far",
    light: "fal",
    thin: "fat",
    brands: "fab"
  },
  duotone: {
    solid: "fad",
    regular: "fadr",
    light: "fadl",
    thin: "fadt"
  },
  sharp: {
    solid: "fass",
    regular: "fasr",
    light: "fasl",
    thin: "fast"
  },
  "sharp-duotone": {
    solid: "fasds",
    regular: "fasdr",
    light: "fasdl",
    thin: "fasdt"
  }
}, Ft$3 = ["fak", "fa-kit", "fakd", "fa-kit-duotone"], St$3 = {
  kit: {
    fak: "kit",
    "fa-kit": "kit"
  },
  "kit-duotone": {
    fakd: "kit-duotone",
    "fa-kit-duotone": "kit-duotone"
  }
}, At$3 = ["kit"], Ct$3 = {
  kit: {
    "fa-kit": "fak"
  }
}, Lt$3 = ["fak", "fakd"], Wt$3 = {
  kit: {
    fak: "fa-kit"
  }
}, Et$3 = {
  kit: {
    kit: "fak"
  },
  "kit-duotone": {
    "kit-duotone": "fakd"
  }
}, t$1$1 = {
  GROUP: "duotone-group",
  SWAP_OPACITY: "swap-opacity",
  PRIMARY: "primary",
  SECONDARY: "secondary"
}, r$1$1 = ["fa-classic", "fa-duotone", "fa-sharp", "fa-sharp-duotone"], bt$1$1 = ["fak", "fa-kit", "fakd", "fa-kit-duotone"], Yt$3 = {
  "Font Awesome Kit": {
    400: "fak",
    normal: "fak"
  },
  "Font Awesome Kit Duotone": {
    400: "fakd",
    normal: "fakd"
  }
}, ua$1 = {
  classic: {
    "fa-brands": "fab",
    "fa-duotone": "fad",
    "fa-light": "fal",
    "fa-regular": "far",
    "fa-solid": "fas",
    "fa-thin": "fat"
  },
  duotone: {
    "fa-regular": "fadr",
    "fa-light": "fadl",
    "fa-thin": "fadt"
  },
  sharp: {
    "fa-solid": "fass",
    "fa-regular": "fasr",
    "fa-light": "fasl",
    "fa-thin": "fast"
  },
  "sharp-duotone": {
    "fa-solid": "fasds",
    "fa-regular": "fasdr",
    "fa-light": "fasdl",
    "fa-thin": "fasdt"
  }
}, I$1$1 = {
  classic: ["fas", "far", "fal", "fat", "fad"],
  duotone: ["fadr", "fadl", "fadt"],
  sharp: ["fass", "fasr", "fasl", "fast"],
  "sharp-duotone": ["fasds", "fasdr", "fasdl", "fasdt"]
}, ga$1 = {
  classic: {
    fab: "fa-brands",
    fad: "fa-duotone",
    fal: "fa-light",
    far: "fa-regular",
    fas: "fa-solid",
    fat: "fa-thin"
  },
  duotone: {
    fadr: "fa-regular",
    fadl: "fa-light",
    fadt: "fa-thin"
  },
  sharp: {
    fass: "fa-solid",
    fasr: "fa-regular",
    fasl: "fa-light",
    fast: "fa-thin"
  },
  "sharp-duotone": {
    fasds: "fa-solid",
    fasdr: "fa-regular",
    fasdl: "fa-light",
    fasdt: "fa-thin"
  }
}, x$3 = ["fa-solid", "fa-regular", "fa-light", "fa-thin", "fa-duotone", "fa-brands"], Ia$1 = ["fa", "fas", "far", "fal", "fat", "fad", "fadr", "fadl", "fadt", "fab", "fass", "fasr", "fasl", "fast", "fasds", "fasdr", "fasdl", "fasdt", ...r$1$1, ...x$3], m$1$1 = ["solid", "regular", "light", "thin", "duotone", "brands"], c$1$1 = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10], F$1$1 = c$1$1.concat([11, 12, 13, 14, 15, 16, 17, 18, 19, 20]), ma$1 = [...Object.keys(I$1$1), ...m$1$1, "2xs", "xs", "sm", "lg", "xl", "2xl", "beat", "border", "fade", "beat-fade", "bounce", "flip-both", "flip-horizontal", "flip-vertical", "flip", "fw", "inverse", "layers-counter", "layers-text", "layers", "li", "pull-left", "pull-right", "pulse", "rotate-180", "rotate-270", "rotate-90", "rotate-by", "shake", "spin-pulse", "spin-reverse", "spin", "stack-1x", "stack-2x", "stack", "ul", t$1$1.GROUP, t$1$1.SWAP_OPACITY, t$1$1.PRIMARY, t$1$1.SECONDARY].concat(c$1$1.map((Bi) => "".concat(Bi, "x"))).concat(F$1$1.map((Bi) => "w-".concat(Bi))), wa$1 = {
  "Font Awesome 5 Free": {
    900: "fas",
    400: "far"
  },
  "Font Awesome 5 Pro": {
    900: "fas",
    400: "far",
    normal: "far",
    300: "fal"
  },
  "Font Awesome 5 Brands": {
    400: "fab",
    normal: "fab"
  },
  "Font Awesome 5 Duotone": {
    900: "fad"
  }
};
const NAMESPACE_IDENTIFIER = "___FONT_AWESOME___", UNITS_IN_GRID = 16, DEFAULT_CSS_PREFIX = "fa", DEFAULT_REPLACEMENT_CLASS = "svg-inline--fa", DATA_FA_I2SVG = "data-fa-i2svg", DATA_FA_PSEUDO_ELEMENT = "data-fa-pseudo-element", DATA_FA_PSEUDO_ELEMENT_PENDING = "data-fa-pseudo-element-pending", DATA_PREFIX = "data-prefix", DATA_ICON = "data-icon", HTML_CLASS_I2SVG_BASE_CLASS = "fontawesome-i2svg", MUTATION_APPROACH_ASYNC = "async", TAGNAMES_TO_SKIP_FOR_PSEUDOELEMENTS = ["HTML", "HEAD", "STYLE", "SCRIPT"], PRODUCTION$1 = (() => {
  try {
    return process.env.NODE_ENV === "production";
  } catch {
    return !1;
  }
})();
function familyProxy(Bi) {
  return new Proxy(Bi, {
    get(e, Ui) {
      return Ui in e ? e[Ui] : e[s$5];
    }
  });
}
const _PREFIX_TO_STYLE = _objectSpread2$1({}, S$2);
_PREFIX_TO_STYLE[s$5] = _objectSpread2$1(_objectSpread2$1(_objectSpread2$1(_objectSpread2$1({}, {
  "fa-duotone": "duotone"
}), S$2[s$5]), St$3.kit), St$3["kit-duotone"]);
const PREFIX_TO_STYLE = familyProxy(_PREFIX_TO_STYLE), _STYLE_TO_PREFIX = _objectSpread2$1({}, xt$3);
_STYLE_TO_PREFIX[s$5] = _objectSpread2$1(_objectSpread2$1(_objectSpread2$1(_objectSpread2$1({}, {
  duotone: "fad"
}), _STYLE_TO_PREFIX[s$5]), Et$3.kit), Et$3["kit-duotone"]);
const STYLE_TO_PREFIX = familyProxy(_STYLE_TO_PREFIX), _PREFIX_TO_LONG_STYLE = _objectSpread2$1({}, ga$1);
_PREFIX_TO_LONG_STYLE[s$5] = _objectSpread2$1(_objectSpread2$1({}, _PREFIX_TO_LONG_STYLE[s$5]), Wt$3.kit);
const PREFIX_TO_LONG_STYLE = familyProxy(_PREFIX_TO_LONG_STYLE), _LONG_STYLE_TO_PREFIX = _objectSpread2$1({}, ua$1);
_LONG_STYLE_TO_PREFIX[s$5] = _objectSpread2$1(_objectSpread2$1({}, _LONG_STYLE_TO_PREFIX[s$5]), Ct$3.kit);
familyProxy(_LONG_STYLE_TO_PREFIX);
const ICON_SELECTION_SYNTAX_PATTERN = p$4, LAYERS_TEXT_CLASSNAME = "fa-layers-text", FONT_FAMILY_PATTERN = g$4, _FONT_WEIGHT_TO_PREFIX = _objectSpread2$1({}, G$3);
familyProxy(_FONT_WEIGHT_TO_PREFIX);
const ATTRIBUTES_WATCHED_FOR_MUTATION = ["class", "data-prefix", "data-icon", "data-fa-transform", "data-fa-mask"], DUOTONE_CLASSES = A$3, RESERVED_CLASSES = [...At$3, ...ma$1], initial$1 = WINDOW.FontAwesomeConfig || {};
function getAttrConfig(Bi) {
  var e = DOCUMENT.querySelector("script[" + Bi + "]");
  if (e)
    return e.getAttribute(Bi);
}
function coerce(Bi) {
  return Bi === "" ? !0 : Bi === "false" ? !1 : Bi === "true" ? !0 : Bi;
}
DOCUMENT && typeof DOCUMENT.querySelector == "function" && [["data-family-prefix", "familyPrefix"], ["data-css-prefix", "cssPrefix"], ["data-family-default", "familyDefault"], ["data-style-default", "styleDefault"], ["data-replacement-class", "replacementClass"], ["data-auto-replace-svg", "autoReplaceSvg"], ["data-auto-add-css", "autoAddCss"], ["data-auto-a11y", "autoA11y"], ["data-search-pseudo-elements", "searchPseudoElements"], ["data-observe-mutations", "observeMutations"], ["data-mutate-approach", "mutateApproach"], ["data-keep-original-source", "keepOriginalSource"], ["data-measure-performance", "measurePerformance"], ["data-show-missing-icons", "showMissingIcons"]].forEach((e) => {
  let [Ui, Zi] = e;
  const ta = coerce(getAttrConfig(Ui));
  ta != null && (initial$1[Zi] = ta);
});
const _default = {
  styleDefault: "solid",
  familyDefault: s$5,
  cssPrefix: DEFAULT_CSS_PREFIX,
  replacementClass: DEFAULT_REPLACEMENT_CLASS,
  autoReplaceSvg: !0,
  autoAddCss: !0,
  autoA11y: !0,
  searchPseudoElements: !1,
  observeMutations: !0,
  mutateApproach: "async",
  keepOriginalSource: !0,
  measurePerformance: !1,
  showMissingIcons: !0
};
initial$1.familyPrefix && (initial$1.cssPrefix = initial$1.familyPrefix);
const _config = _objectSpread2$1(_objectSpread2$1({}, _default), initial$1);
_config.autoReplaceSvg || (_config.observeMutations = !1);
const config = {};
Object.keys(_default).forEach((Bi) => {
  Object.defineProperty(config, Bi, {
    enumerable: !0,
    set: function(e) {
      _config[Bi] = e, _onChangeCb.forEach((Ui) => Ui(config));
    },
    get: function() {
      return _config[Bi];
    }
  });
});
Object.defineProperty(config, "familyPrefix", {
  enumerable: !0,
  set: function(Bi) {
    _config.cssPrefix = Bi, _onChangeCb.forEach((e) => e(config));
  },
  get: function() {
    return _config.cssPrefix;
  }
});
WINDOW.FontAwesomeConfig = config;
const _onChangeCb = [];
function onChange(Bi) {
  return _onChangeCb.push(Bi), () => {
    _onChangeCb.splice(_onChangeCb.indexOf(Bi), 1);
  };
}
const d$2$1 = UNITS_IN_GRID, meaninglessTransform = {
  size: 16,
  x: 0,
  y: 0,
  rotate: 0,
  flipX: !1,
  flipY: !1
};
function insertCss(Bi) {
  if (!Bi || !IS_DOM)
    return;
  const e = DOCUMENT.createElement("style");
  e.setAttribute("type", "text/css"), e.innerHTML = Bi;
  const Ui = DOCUMENT.head.childNodes;
  let Zi = null;
  for (let ta = Ui.length - 1; ta > -1; ta--) {
    const na = Ui[ta], ia = (na.tagName || "").toUpperCase();
    ["STYLE", "LINK"].indexOf(ia) > -1 && (Zi = na);
  }
  return DOCUMENT.head.insertBefore(e, Zi), Bi;
}
const idPool = "0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ";
function nextUniqueId$1() {
  let Bi = 12, e = "";
  for (; Bi-- > 0; )
    e += idPool[Math.random() * 62 | 0];
  return e;
}
function toArray(Bi) {
  const e = [];
  for (let Ui = (Bi || []).length >>> 0; Ui--; )
    e[Ui] = Bi[Ui];
  return e;
}
function classArray(Bi) {
  return Bi.classList ? toArray(Bi.classList) : (Bi.getAttribute("class") || "").split(" ").filter((e) => e);
}
function htmlEscape(Bi) {
  return "".concat(Bi).replace(/&/g, "&amp;").replace(/"/g, "&quot;").replace(/'/g, "&#39;").replace(/</g, "&lt;").replace(/>/g, "&gt;");
}
function joinAttributes(Bi) {
  return Object.keys(Bi || {}).reduce((e, Ui) => e + "".concat(Ui, '="').concat(htmlEscape(Bi[Ui]), '" '), "").trim();
}
function joinStyles(Bi) {
  return Object.keys(Bi || {}).reduce((e, Ui) => e + "".concat(Ui, ": ").concat(Bi[Ui].trim(), ";"), "");
}
function transformIsMeaningful(Bi) {
  return Bi.size !== meaninglessTransform.size || Bi.x !== meaninglessTransform.x || Bi.y !== meaninglessTransform.y || Bi.rotate !== meaninglessTransform.rotate || Bi.flipX || Bi.flipY;
}
function transformForSvg(Bi) {
  let {
    transform: e,
    containerWidth: Ui,
    iconWidth: Zi
  } = Bi;
  const ta = {
    transform: "translate(".concat(Ui / 2, " 256)")
  }, na = "translate(".concat(e.x * 32, ", ").concat(e.y * 32, ") "), ia = "scale(".concat(e.size / 16 * (e.flipX ? -1 : 1), ", ").concat(e.size / 16 * (e.flipY ? -1 : 1), ") "), aa = "rotate(".concat(e.rotate, " 0 0)"), da = {
    transform: "".concat(na, " ").concat(ia, " ").concat(aa)
  }, La = {
    transform: "translate(".concat(Zi / 2 * -1, " -256)")
  };
  return {
    outer: ta,
    inner: da,
    path: La
  };
}
function transformForCss(Bi) {
  let {
    transform: e,
    width: Ui = UNITS_IN_GRID,
    height: Zi = UNITS_IN_GRID,
    startCentered: ta = !1
  } = Bi, na = "";
  return ta && IS_IE ? na += "translate(".concat(e.x / d$2$1 - Ui / 2, "em, ").concat(e.y / d$2$1 - Zi / 2, "em) ") : ta ? na += "translate(calc(-50% + ".concat(e.x / d$2$1, "em), calc(-50% + ").concat(e.y / d$2$1, "em)) ") : na += "translate(".concat(e.x / d$2$1, "em, ").concat(e.y / d$2$1, "em) "), na += "scale(".concat(e.size / d$2$1 * (e.flipX ? -1 : 1), ", ").concat(e.size / d$2$1 * (e.flipY ? -1 : 1), ") "), na += "rotate(".concat(e.rotate, "deg) "), na;
}
var baseStyles = `:root, :host {
  --fa-font-solid: normal 900 1em/1 "Font Awesome 6 Free";
  --fa-font-regular: normal 400 1em/1 "Font Awesome 6 Free";
  --fa-font-light: normal 300 1em/1 "Font Awesome 6 Pro";
  --fa-font-thin: normal 100 1em/1 "Font Awesome 6 Pro";
  --fa-font-duotone: normal 900 1em/1 "Font Awesome 6 Duotone";
  --fa-font-duotone-regular: normal 400 1em/1 "Font Awesome 6 Duotone";
  --fa-font-duotone-light: normal 300 1em/1 "Font Awesome 6 Duotone";
  --fa-font-duotone-thin: normal 100 1em/1 "Font Awesome 6 Duotone";
  --fa-font-brands: normal 400 1em/1 "Font Awesome 6 Brands";
  --fa-font-sharp-solid: normal 900 1em/1 "Font Awesome 6 Sharp";
  --fa-font-sharp-regular: normal 400 1em/1 "Font Awesome 6 Sharp";
  --fa-font-sharp-light: normal 300 1em/1 "Font Awesome 6 Sharp";
  --fa-font-sharp-thin: normal 100 1em/1 "Font Awesome 6 Sharp";
  --fa-font-sharp-duotone-solid: normal 900 1em/1 "Font Awesome 6 Sharp Duotone";
  --fa-font-sharp-duotone-regular: normal 400 1em/1 "Font Awesome 6 Sharp Duotone";
  --fa-font-sharp-duotone-light: normal 300 1em/1 "Font Awesome 6 Sharp Duotone";
  --fa-font-sharp-duotone-thin: normal 100 1em/1 "Font Awesome 6 Sharp Duotone";
}

svg:not(:root).svg-inline--fa, svg:not(:host).svg-inline--fa {
  overflow: visible;
  box-sizing: content-box;
}

.svg-inline--fa {
  display: var(--fa-display, inline-block);
  height: 1em;
  overflow: visible;
  vertical-align: -0.125em;
}
.svg-inline--fa.fa-2xs {
  vertical-align: 0.1em;
}
.svg-inline--fa.fa-xs {
  vertical-align: 0em;
}
.svg-inline--fa.fa-sm {
  vertical-align: -0.0714285705em;
}
.svg-inline--fa.fa-lg {
  vertical-align: -0.2em;
}
.svg-inline--fa.fa-xl {
  vertical-align: -0.25em;
}
.svg-inline--fa.fa-2xl {
  vertical-align: -0.3125em;
}
.svg-inline--fa.fa-pull-left {
  margin-right: var(--fa-pull-margin, 0.3em);
  width: auto;
}
.svg-inline--fa.fa-pull-right {
  margin-left: var(--fa-pull-margin, 0.3em);
  width: auto;
}
.svg-inline--fa.fa-li {
  width: var(--fa-li-width, 2em);
  top: 0.25em;
}
.svg-inline--fa.fa-fw {
  width: var(--fa-fw-width, 1.25em);
}

.fa-layers svg.svg-inline--fa {
  bottom: 0;
  left: 0;
  margin: auto;
  position: absolute;
  right: 0;
  top: 0;
}

.fa-layers-counter, .fa-layers-text {
  display: inline-block;
  position: absolute;
  text-align: center;
}

.fa-layers {
  display: inline-block;
  height: 1em;
  position: relative;
  text-align: center;
  vertical-align: -0.125em;
  width: 1em;
}
.fa-layers svg.svg-inline--fa {
  transform-origin: center center;
}

.fa-layers-text {
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  transform-origin: center center;
}

.fa-layers-counter {
  background-color: var(--fa-counter-background-color, #ff253a);
  border-radius: var(--fa-counter-border-radius, 1em);
  box-sizing: border-box;
  color: var(--fa-inverse, #fff);
  line-height: var(--fa-counter-line-height, 1);
  max-width: var(--fa-counter-max-width, 5em);
  min-width: var(--fa-counter-min-width, 1.5em);
  overflow: hidden;
  padding: var(--fa-counter-padding, 0.25em 0.5em);
  right: var(--fa-right, 0);
  text-overflow: ellipsis;
  top: var(--fa-top, 0);
  transform: scale(var(--fa-counter-scale, 0.25));
  transform-origin: top right;
}

.fa-layers-bottom-right {
  bottom: var(--fa-bottom, 0);
  right: var(--fa-right, 0);
  top: auto;
  transform: scale(var(--fa-layers-scale, 0.25));
  transform-origin: bottom right;
}

.fa-layers-bottom-left {
  bottom: var(--fa-bottom, 0);
  left: var(--fa-left, 0);
  right: auto;
  top: auto;
  transform: scale(var(--fa-layers-scale, 0.25));
  transform-origin: bottom left;
}

.fa-layers-top-right {
  top: var(--fa-top, 0);
  right: var(--fa-right, 0);
  transform: scale(var(--fa-layers-scale, 0.25));
  transform-origin: top right;
}

.fa-layers-top-left {
  left: var(--fa-left, 0);
  right: auto;
  top: var(--fa-top, 0);
  transform: scale(var(--fa-layers-scale, 0.25));
  transform-origin: top left;
}

.fa-1x {
  font-size: 1em;
}

.fa-2x {
  font-size: 2em;
}

.fa-3x {
  font-size: 3em;
}

.fa-4x {
  font-size: 4em;
}

.fa-5x {
  font-size: 5em;
}

.fa-6x {
  font-size: 6em;
}

.fa-7x {
  font-size: 7em;
}

.fa-8x {
  font-size: 8em;
}

.fa-9x {
  font-size: 9em;
}

.fa-10x {
  font-size: 10em;
}

.fa-2xs {
  font-size: 0.625em;
  line-height: 0.1em;
  vertical-align: 0.225em;
}

.fa-xs {
  font-size: 0.75em;
  line-height: 0.0833333337em;
  vertical-align: 0.125em;
}

.fa-sm {
  font-size: 0.875em;
  line-height: 0.0714285718em;
  vertical-align: 0.0535714295em;
}

.fa-lg {
  font-size: 1.25em;
  line-height: 0.05em;
  vertical-align: -0.075em;
}

.fa-xl {
  font-size: 1.5em;
  line-height: 0.0416666682em;
  vertical-align: -0.125em;
}

.fa-2xl {
  font-size: 2em;
  line-height: 0.03125em;
  vertical-align: -0.1875em;
}

.fa-fw {
  text-align: center;
  width: 1.25em;
}

.fa-ul {
  list-style-type: none;
  margin-left: var(--fa-li-margin, 2.5em);
  padding-left: 0;
}
.fa-ul > li {
  position: relative;
}

.fa-li {
  left: calc(-1 * var(--fa-li-width, 2em));
  position: absolute;
  text-align: center;
  width: var(--fa-li-width, 2em);
  line-height: inherit;
}

.fa-border {
  border-color: var(--fa-border-color, #eee);
  border-radius: var(--fa-border-radius, 0.1em);
  border-style: var(--fa-border-style, solid);
  border-width: var(--fa-border-width, 0.08em);
  padding: var(--fa-border-padding, 0.2em 0.25em 0.15em);
}

.fa-pull-left {
  float: left;
  margin-right: var(--fa-pull-margin, 0.3em);
}

.fa-pull-right {
  float: right;
  margin-left: var(--fa-pull-margin, 0.3em);
}

.fa-beat {
  animation-name: fa-beat;
  animation-delay: var(--fa-animation-delay, 0s);
  animation-direction: var(--fa-animation-direction, normal);
  animation-duration: var(--fa-animation-duration, 1s);
  animation-iteration-count: var(--fa-animation-iteration-count, infinite);
  animation-timing-function: var(--fa-animation-timing, ease-in-out);
}

.fa-bounce {
  animation-name: fa-bounce;
  animation-delay: var(--fa-animation-delay, 0s);
  animation-direction: var(--fa-animation-direction, normal);
  animation-duration: var(--fa-animation-duration, 1s);
  animation-iteration-count: var(--fa-animation-iteration-count, infinite);
  animation-timing-function: var(--fa-animation-timing, cubic-bezier(0.28, 0.84, 0.42, 1));
}

.fa-fade {
  animation-name: fa-fade;
  animation-delay: var(--fa-animation-delay, 0s);
  animation-direction: var(--fa-animation-direction, normal);
  animation-duration: var(--fa-animation-duration, 1s);
  animation-iteration-count: var(--fa-animation-iteration-count, infinite);
  animation-timing-function: var(--fa-animation-timing, cubic-bezier(0.4, 0, 0.6, 1));
}

.fa-beat-fade {
  animation-name: fa-beat-fade;
  animation-delay: var(--fa-animation-delay, 0s);
  animation-direction: var(--fa-animation-direction, normal);
  animation-duration: var(--fa-animation-duration, 1s);
  animation-iteration-count: var(--fa-animation-iteration-count, infinite);
  animation-timing-function: var(--fa-animation-timing, cubic-bezier(0.4, 0, 0.6, 1));
}

.fa-flip {
  animation-name: fa-flip;
  animation-delay: var(--fa-animation-delay, 0s);
  animation-direction: var(--fa-animation-direction, normal);
  animation-duration: var(--fa-animation-duration, 1s);
  animation-iteration-count: var(--fa-animation-iteration-count, infinite);
  animation-timing-function: var(--fa-animation-timing, ease-in-out);
}

.fa-shake {
  animation-name: fa-shake;
  animation-delay: var(--fa-animation-delay, 0s);
  animation-direction: var(--fa-animation-direction, normal);
  animation-duration: var(--fa-animation-duration, 1s);
  animation-iteration-count: var(--fa-animation-iteration-count, infinite);
  animation-timing-function: var(--fa-animation-timing, linear);
}

.fa-spin {
  animation-name: fa-spin;
  animation-delay: var(--fa-animation-delay, 0s);
  animation-direction: var(--fa-animation-direction, normal);
  animation-duration: var(--fa-animation-duration, 2s);
  animation-iteration-count: var(--fa-animation-iteration-count, infinite);
  animation-timing-function: var(--fa-animation-timing, linear);
}

.fa-spin-reverse {
  --fa-animation-direction: reverse;
}

.fa-pulse,
.fa-spin-pulse {
  animation-name: fa-spin;
  animation-direction: var(--fa-animation-direction, normal);
  animation-duration: var(--fa-animation-duration, 1s);
  animation-iteration-count: var(--fa-animation-iteration-count, infinite);
  animation-timing-function: var(--fa-animation-timing, steps(8));
}

@media (prefers-reduced-motion: reduce) {
  .fa-beat,
.fa-bounce,
.fa-fade,
.fa-beat-fade,
.fa-flip,
.fa-pulse,
.fa-shake,
.fa-spin,
.fa-spin-pulse {
    animation-delay: -1ms;
    animation-duration: 1ms;
    animation-iteration-count: 1;
    transition-delay: 0s;
    transition-duration: 0s;
  }
}
@keyframes fa-beat {
  0%, 90% {
    transform: scale(1);
  }
  45% {
    transform: scale(var(--fa-beat-scale, 1.25));
  }
}
@keyframes fa-bounce {
  0% {
    transform: scale(1, 1) translateY(0);
  }
  10% {
    transform: scale(var(--fa-bounce-start-scale-x, 1.1), var(--fa-bounce-start-scale-y, 0.9)) translateY(0);
  }
  30% {
    transform: scale(var(--fa-bounce-jump-scale-x, 0.9), var(--fa-bounce-jump-scale-y, 1.1)) translateY(var(--fa-bounce-height, -0.5em));
  }
  50% {
    transform: scale(var(--fa-bounce-land-scale-x, 1.05), var(--fa-bounce-land-scale-y, 0.95)) translateY(0);
  }
  57% {
    transform: scale(1, 1) translateY(var(--fa-bounce-rebound, -0.125em));
  }
  64% {
    transform: scale(1, 1) translateY(0);
  }
  100% {
    transform: scale(1, 1) translateY(0);
  }
}
@keyframes fa-fade {
  50% {
    opacity: var(--fa-fade-opacity, 0.4);
  }
}
@keyframes fa-beat-fade {
  0%, 100% {
    opacity: var(--fa-beat-fade-opacity, 0.4);
    transform: scale(1);
  }
  50% {
    opacity: 1;
    transform: scale(var(--fa-beat-fade-scale, 1.125));
  }
}
@keyframes fa-flip {
  50% {
    transform: rotate3d(var(--fa-flip-x, 0), var(--fa-flip-y, 1), var(--fa-flip-z, 0), var(--fa-flip-angle, -180deg));
  }
}
@keyframes fa-shake {
  0% {
    transform: rotate(-15deg);
  }
  4% {
    transform: rotate(15deg);
  }
  8%, 24% {
    transform: rotate(-18deg);
  }
  12%, 28% {
    transform: rotate(18deg);
  }
  16% {
    transform: rotate(-22deg);
  }
  20% {
    transform: rotate(22deg);
  }
  32% {
    transform: rotate(-12deg);
  }
  36% {
    transform: rotate(12deg);
  }
  40%, 100% {
    transform: rotate(0deg);
  }
}
@keyframes fa-spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
.fa-rotate-90 {
  transform: rotate(90deg);
}

.fa-rotate-180 {
  transform: rotate(180deg);
}

.fa-rotate-270 {
  transform: rotate(270deg);
}

.fa-flip-horizontal {
  transform: scale(-1, 1);
}

.fa-flip-vertical {
  transform: scale(1, -1);
}

.fa-flip-both,
.fa-flip-horizontal.fa-flip-vertical {
  transform: scale(-1, -1);
}

.fa-rotate-by {
  transform: rotate(var(--fa-rotate-angle, 0));
}

.fa-stack {
  display: inline-block;
  vertical-align: middle;
  height: 2em;
  position: relative;
  width: 2.5em;
}

.fa-stack-1x,
.fa-stack-2x {
  bottom: 0;
  left: 0;
  margin: auto;
  position: absolute;
  right: 0;
  top: 0;
  z-index: var(--fa-stack-z-index, auto);
}

.svg-inline--fa.fa-stack-1x {
  height: 1em;
  width: 1.25em;
}
.svg-inline--fa.fa-stack-2x {
  height: 2em;
  width: 2.5em;
}

.fa-inverse {
  color: var(--fa-inverse, #fff);
}

.sr-only,
.fa-sr-only {
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border-width: 0;
}

.sr-only-focusable:not(:focus),
.fa-sr-only-focusable:not(:focus) {
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border-width: 0;
}

.svg-inline--fa .fa-primary {
  fill: var(--fa-primary-color, currentColor);
  opacity: var(--fa-primary-opacity, 1);
}

.svg-inline--fa .fa-secondary {
  fill: var(--fa-secondary-color, currentColor);
  opacity: var(--fa-secondary-opacity, 0.4);
}

.svg-inline--fa.fa-swap-opacity .fa-primary {
  opacity: var(--fa-secondary-opacity, 0.4);
}

.svg-inline--fa.fa-swap-opacity .fa-secondary {
  opacity: var(--fa-primary-opacity, 1);
}

.svg-inline--fa mask .fa-primary,
.svg-inline--fa mask .fa-secondary {
  fill: black;
}`;
function css() {
  const Bi = DEFAULT_CSS_PREFIX, e = DEFAULT_REPLACEMENT_CLASS, Ui = config.cssPrefix, Zi = config.replacementClass;
  let ta = baseStyles;
  if (Ui !== Bi || Zi !== e) {
    const na = new RegExp("\\.".concat(Bi, "\\-"), "g"), ia = new RegExp("\\--".concat(Bi, "\\-"), "g"), aa = new RegExp("\\.".concat(e), "g");
    ta = ta.replace(na, ".".concat(Ui, "-")).replace(ia, "--".concat(Ui, "-")).replace(aa, ".".concat(Zi));
  }
  return ta;
}
let _cssInserted = !1;
function ensureCss() {
  config.autoAddCss && !_cssInserted && (insertCss(css()), _cssInserted = !0);
}
var InjectCSS = {
  mixout() {
    return {
      dom: {
        css,
        insertCss: ensureCss
      }
    };
  },
  hooks() {
    return {
      beforeDOMElementCreation() {
        ensureCss();
      },
      beforeI2svg() {
        ensureCss();
      }
    };
  }
};
const w$3 = WINDOW || {};
w$3[NAMESPACE_IDENTIFIER] || (w$3[NAMESPACE_IDENTIFIER] = {});
w$3[NAMESPACE_IDENTIFIER].styles || (w$3[NAMESPACE_IDENTIFIER].styles = {});
w$3[NAMESPACE_IDENTIFIER].hooks || (w$3[NAMESPACE_IDENTIFIER].hooks = {});
w$3[NAMESPACE_IDENTIFIER].shims || (w$3[NAMESPACE_IDENTIFIER].shims = []);
var namespace = w$3[NAMESPACE_IDENTIFIER];
const functions = [], listener = function() {
  DOCUMENT.removeEventListener("DOMContentLoaded", listener), loaded = 1, functions.map((Bi) => Bi());
};
let loaded = !1;
IS_DOM && (loaded = (DOCUMENT.documentElement.doScroll ? /^loaded|^c/ : /^loaded|^i|^c/).test(DOCUMENT.readyState), loaded || DOCUMENT.addEventListener("DOMContentLoaded", listener));
function domready(Bi) {
  IS_DOM && (loaded ? setTimeout(Bi, 0) : functions.push(Bi));
}
function toHtml(Bi) {
  const {
    tag: e,
    attributes: Ui = {},
    children: Zi = []
  } = Bi;
  return typeof Bi == "string" ? htmlEscape(Bi) : "<".concat(e, " ").concat(joinAttributes(Ui), ">").concat(Zi.map(toHtml).join(""), "</").concat(e, ">");
}
function iconFromMapping(Bi, e, Ui) {
  if (Bi && Bi[e] && Bi[e][Ui])
    return {
      prefix: e,
      iconName: Ui,
      icon: Bi[e][Ui]
    };
}
var reduce$6 = function(e, Ui, Zi, ta) {
  var na = Object.keys(e), ia = na.length, aa = Ui, da, La, qa;
  for (Zi === void 0 ? (da = 1, qa = e[na[0]]) : (da = 0, qa = Zi); da < ia; da++)
    La = na[da], qa = aa(qa, e[La], La, e);
  return qa;
};
function ucs2decode(Bi) {
  const e = [];
  let Ui = 0;
  const Zi = Bi.length;
  for (; Ui < Zi; ) {
    const ta = Bi.charCodeAt(Ui++);
    if (ta >= 55296 && ta <= 56319 && Ui < Zi) {
      const na = Bi.charCodeAt(Ui++);
      (na & 64512) == 56320 ? e.push(((ta & 1023) << 10) + (na & 1023) + 65536) : (e.push(ta), Ui--);
    } else
      e.push(ta);
  }
  return e;
}
function toHex(Bi) {
  const e = ucs2decode(Bi);
  return e.length === 1 ? e[0].toString(16) : null;
}
function codePointAt(Bi, e) {
  const Ui = Bi.length;
  let Zi = Bi.charCodeAt(e), ta;
  return Zi >= 55296 && Zi <= 56319 && Ui > e + 1 && (ta = Bi.charCodeAt(e + 1), ta >= 56320 && ta <= 57343) ? (Zi - 55296) * 1024 + ta - 56320 + 65536 : Zi;
}
function normalizeIcons(Bi) {
  return Object.keys(Bi).reduce((e, Ui) => {
    const Zi = Bi[Ui];
    return !!Zi.icon ? e[Zi.iconName] = Zi.icon : e[Ui] = Zi, e;
  }, {});
}
function defineIcons(Bi, e) {
  let Ui = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
  const {
    skipHooks: Zi = !1
  } = Ui, ta = normalizeIcons(e);
  typeof namespace.hooks.addPack == "function" && !Zi ? namespace.hooks.addPack(Bi, normalizeIcons(e)) : namespace.styles[Bi] = _objectSpread2$1(_objectSpread2$1({}, namespace.styles[Bi] || {}), ta), Bi === "fas" && defineIcons("fa", e);
}
const {
  styles: styles$1,
  shims
} = namespace, FAMILY_NAMES = Object.keys(PREFIX_TO_LONG_STYLE), PREFIXES_FOR_FAMILY = FAMILY_NAMES.reduce((Bi, e) => (Bi[e] = Object.keys(PREFIX_TO_LONG_STYLE[e]), Bi), {});
let _defaultUsablePrefix = null, _byUnicode = {}, _byLigature = {}, _byOldName = {}, _byOldUnicode = {}, _byAlias = {};
function isReserved(Bi) {
  return ~RESERVED_CLASSES.indexOf(Bi);
}
function getIconName(Bi, e) {
  const Ui = e.split("-"), Zi = Ui[0], ta = Ui.slice(1).join("-");
  return Zi === Bi && ta !== "" && !isReserved(ta) ? ta : null;
}
const build = () => {
  const Bi = (Zi) => reduce$6(styles$1, (ta, na, ia) => (ta[ia] = reduce$6(na, Zi, {}), ta), {});
  _byUnicode = Bi((Zi, ta, na) => (ta[3] && (Zi[ta[3]] = na), ta[2] && ta[2].filter((aa) => typeof aa == "number").forEach((aa) => {
    Zi[aa.toString(16)] = na;
  }), Zi)), _byLigature = Bi((Zi, ta, na) => (Zi[na] = na, ta[2] && ta[2].filter((aa) => typeof aa == "string").forEach((aa) => {
    Zi[aa] = na;
  }), Zi)), _byAlias = Bi((Zi, ta, na) => {
    const ia = ta[2];
    return Zi[na] = na, ia.forEach((aa) => {
      Zi[aa] = na;
    }), Zi;
  });
  const e = "far" in styles$1 || config.autoFetchSvg, Ui = reduce$6(shims, (Zi, ta) => {
    const na = ta[0];
    let ia = ta[1];
    const aa = ta[2];
    return ia === "far" && !e && (ia = "fas"), typeof na == "string" && (Zi.names[na] = {
      prefix: ia,
      iconName: aa
    }), typeof na == "number" && (Zi.unicodes[na.toString(16)] = {
      prefix: ia,
      iconName: aa
    }), Zi;
  }, {
    names: {},
    unicodes: {}
  });
  _byOldName = Ui.names, _byOldUnicode = Ui.unicodes, _defaultUsablePrefix = getCanonicalPrefix(config.styleDefault, {
    family: config.familyDefault
  });
};
onChange((Bi) => {
  _defaultUsablePrefix = getCanonicalPrefix(Bi.styleDefault, {
    family: config.familyDefault
  });
});
build();
function byUnicode(Bi, e) {
  return (_byUnicode[Bi] || {})[e];
}
function byLigature(Bi, e) {
  return (_byLigature[Bi] || {})[e];
}
function byAlias(Bi, e) {
  return (_byAlias[Bi] || {})[e];
}
function byOldName(Bi) {
  return _byOldName[Bi] || {
    prefix: null,
    iconName: null
  };
}
function byOldUnicode(Bi) {
  const e = _byOldUnicode[Bi], Ui = byUnicode("fas", Bi);
  return e || (Ui ? {
    prefix: "fas",
    iconName: Ui
  } : null) || {
    prefix: null,
    iconName: null
  };
}
function getDefaultUsablePrefix() {
  return _defaultUsablePrefix;
}
const emptyCanonicalIcon = () => ({
  prefix: null,
  iconName: null,
  rest: []
});
function getFamilyId(Bi) {
  let e = s$5;
  const Ui = FAMILY_NAMES.reduce((Zi, ta) => (Zi[ta] = "".concat(config.cssPrefix, "-").concat(ta), Zi), {});
  return L$3.forEach((Zi) => {
    (Bi.includes(Ui[Zi]) || Bi.some((ta) => PREFIXES_FOR_FAMILY[Zi].includes(ta))) && (e = Zi);
  }), e;
}
function getCanonicalPrefix(Bi) {
  let e = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
  const {
    family: Ui = s$5
  } = e, Zi = PREFIX_TO_STYLE[Ui][Bi];
  if (Ui === t$7 && !Bi)
    return "fad";
  const ta = STYLE_TO_PREFIX[Ui][Bi] || STYLE_TO_PREFIX[Ui][Zi], na = Bi in namespace.styles ? Bi : null;
  return ta || na || null;
}
function moveNonFaClassesToRest(Bi) {
  let e = [], Ui = null;
  return Bi.forEach((Zi) => {
    const ta = getIconName(config.cssPrefix, Zi);
    ta ? Ui = ta : Zi && e.push(Zi);
  }), {
    iconName: Ui,
    rest: e
  };
}
function sortedUniqueValues(Bi) {
  return Bi.sort().filter((e, Ui, Zi) => Zi.indexOf(e) === Ui);
}
function getCanonicalIcon(Bi) {
  let e = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
  const {
    skipLookups: Ui = !1
  } = e;
  let Zi = null;
  const ta = Ia$1.concat(bt$1$1), na = sortedUniqueValues(Bi.filter((io) => ta.includes(io))), ia = sortedUniqueValues(Bi.filter((io) => !Ia$1.includes(io))), aa = na.filter((io) => (Zi = io, !P$4.includes(io))), [da = null] = aa, La = getFamilyId(na), qa = _objectSpread2$1(_objectSpread2$1({}, moveNonFaClassesToRest(ia)), {}, {
    prefix: getCanonicalPrefix(da, {
      family: La
    })
  });
  return _objectSpread2$1(_objectSpread2$1(_objectSpread2$1({}, qa), getDefaultCanonicalPrefix({
    values: Bi,
    family: La,
    styles: styles$1,
    config,
    canonical: qa,
    givenPrefix: Zi
  })), applyShimAndAlias(Ui, Zi, qa));
}
function applyShimAndAlias(Bi, e, Ui) {
  let {
    prefix: Zi,
    iconName: ta
  } = Ui;
  if (Bi || !Zi || !ta)
    return {
      prefix: Zi,
      iconName: ta
    };
  const na = e === "fa" ? byOldName(ta) : {}, ia = byAlias(Zi, ta);
  return ta = na.iconName || ia || ta, Zi = na.prefix || Zi, Zi === "far" && !styles$1.far && styles$1.fas && !config.autoFetchSvg && (Zi = "fas"), {
    prefix: Zi,
    iconName: ta
  };
}
const newCanonicalFamilies = L$3.filter((Bi) => Bi !== s$5 || Bi !== t$7), newCanonicalStyles = Object.keys(ga$1).filter((Bi) => Bi !== s$5).map((Bi) => Object.keys(ga$1[Bi])).flat();
function getDefaultCanonicalPrefix(Bi) {
  const {
    values: e,
    family: Ui,
    canonical: Zi,
    givenPrefix: ta = "",
    styles: na = {},
    config: ia = {}
  } = Bi, aa = Ui === t$7, da = e.includes("fa-duotone") || e.includes("fad"), La = ia.familyDefault === "duotone", qa = Zi.prefix === "fad" || Zi.prefix === "fa-duotone";
  if (!aa && (da || La || qa) && (Zi.prefix = "fad"), (e.includes("fa-brands") || e.includes("fab")) && (Zi.prefix = "fab"), !Zi.prefix && newCanonicalFamilies.includes(Ui) && (Object.keys(na).find((ao) => newCanonicalStyles.includes(ao)) || ia.autoFetchSvg)) {
    const ao = pt$3.get(Ui).defaultShortPrefixId;
    Zi.prefix = ao, Zi.iconName = byAlias(Zi.prefix, Zi.iconName) || Zi.iconName;
  }
  return (Zi.prefix === "fa" || ta === "fa") && (Zi.prefix = getDefaultUsablePrefix() || "fas"), Zi;
}
class Library {
  constructor() {
    this.definitions = {};
  }
  add() {
    for (var e = arguments.length, Ui = new Array(e), Zi = 0; Zi < e; Zi++)
      Ui[Zi] = arguments[Zi];
    const ta = Ui.reduce(this._pullDefinitions, {});
    Object.keys(ta).forEach((na) => {
      this.definitions[na] = _objectSpread2$1(_objectSpread2$1({}, this.definitions[na] || {}), ta[na]), defineIcons(na, ta[na]);
      const ia = PREFIX_TO_LONG_STYLE[s$5][na];
      ia && defineIcons(ia, ta[na]), build();
    });
  }
  reset() {
    this.definitions = {};
  }
  _pullDefinitions(e, Ui) {
    const Zi = Ui.prefix && Ui.iconName && Ui.icon ? {
      0: Ui
    } : Ui;
    return Object.keys(Zi).map((ta) => {
      const {
        prefix: na,
        iconName: ia,
        icon: aa
      } = Zi[ta], da = aa[2];
      e[na] || (e[na] = {}), da.length > 0 && da.forEach((La) => {
        typeof La == "string" && (e[na][La] = aa);
      }), e[na][ia] = aa;
    }), e;
  }
}
let _plugins = [], _hooks = {};
const providers = {}, defaultProviderKeys = Object.keys(providers);
function registerPlugins(Bi, e) {
  let {
    mixoutsTo: Ui
  } = e;
  return _plugins = Bi, _hooks = {}, Object.keys(providers).forEach((Zi) => {
    defaultProviderKeys.indexOf(Zi) === -1 && delete providers[Zi];
  }), _plugins.forEach((Zi) => {
    const ta = Zi.mixout ? Zi.mixout() : {};
    if (Object.keys(ta).forEach((na) => {
      typeof ta[na] == "function" && (Ui[na] = ta[na]), typeof ta[na] == "object" && Object.keys(ta[na]).forEach((ia) => {
        Ui[na] || (Ui[na] = {}), Ui[na][ia] = ta[na][ia];
      });
    }), Zi.hooks) {
      const na = Zi.hooks();
      Object.keys(na).forEach((ia) => {
        _hooks[ia] || (_hooks[ia] = []), _hooks[ia].push(na[ia]);
      });
    }
    Zi.provides && Zi.provides(providers);
  }), Ui;
}
function chainHooks(Bi, e) {
  for (var Ui = arguments.length, Zi = new Array(Ui > 2 ? Ui - 2 : 0), ta = 2; ta < Ui; ta++)
    Zi[ta - 2] = arguments[ta];
  return (_hooks[Bi] || []).forEach((ia) => {
    e = ia.apply(null, [e, ...Zi]);
  }), e;
}
function callHooks(Bi) {
  for (var e = arguments.length, Ui = new Array(e > 1 ? e - 1 : 0), Zi = 1; Zi < e; Zi++)
    Ui[Zi - 1] = arguments[Zi];
  (_hooks[Bi] || []).forEach((na) => {
    na.apply(null, Ui);
  });
}
function callProvided() {
  const Bi = arguments[0], e = Array.prototype.slice.call(arguments, 1);
  return providers[Bi] ? providers[Bi].apply(null, e) : void 0;
}
function findIconDefinition(Bi) {
  Bi.prefix === "fa" && (Bi.prefix = "fas");
  let {
    iconName: e
  } = Bi;
  const Ui = Bi.prefix || getDefaultUsablePrefix();
  if (e)
    return e = byAlias(Ui, e) || e, iconFromMapping(library.definitions, Ui, e) || iconFromMapping(namespace.styles, Ui, e);
}
const library = new Library(), noAuto = () => {
  config.autoReplaceSvg = !1, config.observeMutations = !1, callHooks("noAuto");
}, dom = {
  i2svg: function() {
    let Bi = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    return IS_DOM ? (callHooks("beforeI2svg", Bi), callProvided("pseudoElements2svg", Bi), callProvided("i2svg", Bi)) : Promise.reject(new Error("Operation requires a DOM of some kind."));
  },
  watch: function() {
    let Bi = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    const {
      autoReplaceSvgRoot: e
    } = Bi;
    config.autoReplaceSvg === !1 && (config.autoReplaceSvg = !0), config.observeMutations = !0, domready(() => {
      autoReplace({
        autoReplaceSvgRoot: e
      }), callHooks("watch", Bi);
    });
  }
}, parse$1 = {
  icon: (Bi) => {
    if (Bi === null)
      return null;
    if (typeof Bi == "object" && Bi.prefix && Bi.iconName)
      return {
        prefix: Bi.prefix,
        iconName: byAlias(Bi.prefix, Bi.iconName) || Bi.iconName
      };
    if (Array.isArray(Bi) && Bi.length === 2) {
      const e = Bi[1].indexOf("fa-") === 0 ? Bi[1].slice(3) : Bi[1], Ui = getCanonicalPrefix(Bi[0]);
      return {
        prefix: Ui,
        iconName: byAlias(Ui, e) || e
      };
    }
    if (typeof Bi == "string" && (Bi.indexOf("".concat(config.cssPrefix, "-")) > -1 || Bi.match(ICON_SELECTION_SYNTAX_PATTERN))) {
      const e = getCanonicalIcon(Bi.split(" "), {
        skipLookups: !0
      });
      return {
        prefix: e.prefix || getDefaultUsablePrefix(),
        iconName: byAlias(e.prefix, e.iconName) || e.iconName
      };
    }
    if (typeof Bi == "string") {
      const e = getDefaultUsablePrefix();
      return {
        prefix: e,
        iconName: byAlias(e, Bi) || Bi
      };
    }
  }
}, api = {
  noAuto,
  config,
  dom,
  parse: parse$1,
  library,
  findIconDefinition,
  toHtml
}, autoReplace = function() {
  let Bi = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
  const {
    autoReplaceSvgRoot: e = DOCUMENT
  } = Bi;
  (Object.keys(namespace.styles).length > 0 || config.autoFetchSvg) && IS_DOM && config.autoReplaceSvg && api.dom.i2svg({
    node: e
  });
};
function domVariants(Bi, e) {
  return Object.defineProperty(Bi, "abstract", {
    get: e
  }), Object.defineProperty(Bi, "html", {
    get: function() {
      return Bi.abstract.map((Ui) => toHtml(Ui));
    }
  }), Object.defineProperty(Bi, "node", {
    get: function() {
      if (!IS_DOM) return;
      const Ui = DOCUMENT.createElement("div");
      return Ui.innerHTML = Bi.html, Ui.children;
    }
  }), Bi;
}
function asIcon(Bi) {
  let {
    children: e,
    main: Ui,
    mask: Zi,
    attributes: ta,
    styles: na,
    transform: ia
  } = Bi;
  if (transformIsMeaningful(ia) && Ui.found && !Zi.found) {
    const {
      width: aa,
      height: da
    } = Ui, La = {
      x: aa / da / 2,
      y: 0.5
    };
    ta.style = joinStyles(_objectSpread2$1(_objectSpread2$1({}, na), {}, {
      "transform-origin": "".concat(La.x + ia.x / 16, "em ").concat(La.y + ia.y / 16, "em")
    }));
  }
  return [{
    tag: "svg",
    attributes: ta,
    children: e
  }];
}
function asSymbol(Bi) {
  let {
    prefix: e,
    iconName: Ui,
    children: Zi,
    attributes: ta,
    symbol: na
  } = Bi;
  const ia = na === !0 ? "".concat(e, "-").concat(config.cssPrefix, "-").concat(Ui) : na;
  return [{
    tag: "svg",
    attributes: {
      style: "display: none;"
    },
    children: [{
      tag: "symbol",
      attributes: _objectSpread2$1(_objectSpread2$1({}, ta), {}, {
        id: ia
      }),
      children: Zi
    }]
  }];
}
function makeInlineSvgAbstract(Bi) {
  const {
    icons: {
      main: e,
      mask: Ui
    },
    prefix: Zi,
    iconName: ta,
    transform: na,
    symbol: ia,
    title: aa,
    maskId: da,
    titleId: La,
    extra: qa,
    watchable: io = !1
  } = Bi, {
    width: ao,
    height: oo
  } = Ui.found ? Ui : e, no = Lt$3.includes(Zi), lo = [config.replacementClass, ta ? "".concat(config.cssPrefix, "-").concat(ta) : ""].filter((jo) => qa.classes.indexOf(jo) === -1).filter((jo) => jo !== "" || !!jo).concat(qa.classes).join(" ");
  let so = {
    children: [],
    attributes: _objectSpread2$1(_objectSpread2$1({}, qa.attributes), {}, {
      "data-prefix": Zi,
      "data-icon": ta,
      class: lo,
      role: qa.attributes.role || "img",
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 ".concat(ao, " ").concat(oo)
    })
  };
  const bs = no && !~qa.classes.indexOf("fa-fw") ? {
    width: "".concat(ao / oo * 16 * 0.0625, "em")
  } : {};
  io && (so.attributes[DATA_FA_I2SVG] = ""), aa && (so.children.push({
    tag: "title",
    attributes: {
      id: so.attributes["aria-labelledby"] || "title-".concat(La || nextUniqueId$1())
    },
    children: [aa]
  }), delete so.attributes.title);
  const Rs = _objectSpread2$1(_objectSpread2$1({}, so), {}, {
    prefix: Zi,
    iconName: ta,
    main: e,
    mask: Ui,
    maskId: da,
    transform: na,
    symbol: ia,
    styles: _objectSpread2$1(_objectSpread2$1({}, bs), qa.styles)
  }), {
    children: js,
    attributes: qs
  } = Ui.found && e.found ? callProvided("generateAbstractMask", Rs) || {
    children: [],
    attributes: {}
  } : callProvided("generateAbstractIcon", Rs) || {
    children: [],
    attributes: {}
  };
  return Rs.children = js, Rs.attributes = qs, ia ? asSymbol(Rs) : asIcon(Rs);
}
function makeLayersTextAbstract(Bi) {
  const {
    content: e,
    width: Ui,
    height: Zi,
    transform: ta,
    title: na,
    extra: ia,
    watchable: aa = !1
  } = Bi, da = _objectSpread2$1(_objectSpread2$1(_objectSpread2$1({}, ia.attributes), na ? {
    title: na
  } : {}), {}, {
    class: ia.classes.join(" ")
  });
  aa && (da[DATA_FA_I2SVG] = "");
  const La = _objectSpread2$1({}, ia.styles);
  transformIsMeaningful(ta) && (La.transform = transformForCss({
    transform: ta,
    startCentered: !0,
    width: Ui,
    height: Zi
  }), La["-webkit-transform"] = La.transform);
  const qa = joinStyles(La);
  qa.length > 0 && (da.style = qa);
  const io = [];
  return io.push({
    tag: "span",
    attributes: da,
    children: [e]
  }), na && io.push({
    tag: "span",
    attributes: {
      class: "sr-only"
    },
    children: [na]
  }), io;
}
function makeLayersCounterAbstract(Bi) {
  const {
    content: e,
    title: Ui,
    extra: Zi
  } = Bi, ta = _objectSpread2$1(_objectSpread2$1(_objectSpread2$1({}, Zi.attributes), Ui ? {
    title: Ui
  } : {}), {}, {
    class: Zi.classes.join(" ")
  }), na = joinStyles(Zi.styles);
  na.length > 0 && (ta.style = na);
  const ia = [];
  return ia.push({
    tag: "span",
    attributes: ta,
    children: [e]
  }), Ui && ia.push({
    tag: "span",
    attributes: {
      class: "sr-only"
    },
    children: [Ui]
  }), ia;
}
const {
  styles: styles$1$1
} = namespace;
function asFoundIcon(Bi) {
  const e = Bi[0], Ui = Bi[1], [Zi] = Bi.slice(4);
  let ta = null;
  return Array.isArray(Zi) ? ta = {
    tag: "g",
    attributes: {
      class: "".concat(config.cssPrefix, "-").concat(DUOTONE_CLASSES.GROUP)
    },
    children: [{
      tag: "path",
      attributes: {
        class: "".concat(config.cssPrefix, "-").concat(DUOTONE_CLASSES.SECONDARY),
        fill: "currentColor",
        d: Zi[0]
      }
    }, {
      tag: "path",
      attributes: {
        class: "".concat(config.cssPrefix, "-").concat(DUOTONE_CLASSES.PRIMARY),
        fill: "currentColor",
        d: Zi[1]
      }
    }]
  } : ta = {
    tag: "path",
    attributes: {
      fill: "currentColor",
      d: Zi
    }
  }, {
    found: !0,
    width: e,
    height: Ui,
    icon: ta
  };
}
const missingIconResolutionMixin = {
  found: !1,
  width: 512,
  height: 512
};
function maybeNotifyMissing(Bi, e) {
  !PRODUCTION$1 && !config.showMissingIcons && Bi && console.error('Icon with name "'.concat(Bi, '" and prefix "').concat(e, '" is missing.'));
}
function findIcon(Bi, e) {
  let Ui = e;
  return e === "fa" && config.styleDefault !== null && (e = getDefaultUsablePrefix()), new Promise((Zi, ta) => {
    if (Ui === "fa") {
      const na = byOldName(Bi) || {};
      Bi = na.iconName || Bi, e = na.prefix || e;
    }
    if (Bi && e && styles$1$1[e] && styles$1$1[e][Bi]) {
      const na = styles$1$1[e][Bi];
      return Zi(asFoundIcon(na));
    }
    maybeNotifyMissing(Bi, e), Zi(_objectSpread2$1(_objectSpread2$1({}, missingIconResolutionMixin), {}, {
      icon: config.showMissingIcons && Bi ? callProvided("missingIconAbstract") || {} : {}
    }));
  });
}
const noop$1$1 = () => {
}, p$2$1 = config.measurePerformance && PERFORMANCE && PERFORMANCE.mark && PERFORMANCE.measure ? PERFORMANCE : {
  mark: noop$1$1,
  measure: noop$1$1
}, preamble = 'FA "6.7.2"', begin = (Bi) => (p$2$1.mark("".concat(preamble, " ").concat(Bi, " begins")), () => end(Bi)), end = (Bi) => {
  p$2$1.mark("".concat(preamble, " ").concat(Bi, " ends")), p$2$1.measure("".concat(preamble, " ").concat(Bi), "".concat(preamble, " ").concat(Bi, " begins"), "".concat(preamble, " ").concat(Bi, " ends"));
};
var perf = {
  begin,
  end
};
const noop$2$1 = () => {
};
function isWatched$1(Bi) {
  return typeof (Bi.getAttribute ? Bi.getAttribute(DATA_FA_I2SVG) : null) == "string";
}
function hasPrefixAndIcon(Bi) {
  const e = Bi.getAttribute ? Bi.getAttribute(DATA_PREFIX) : null, Ui = Bi.getAttribute ? Bi.getAttribute(DATA_ICON) : null;
  return e && Ui;
}
function hasBeenReplaced(Bi) {
  return Bi && Bi.classList && Bi.classList.contains && Bi.classList.contains(config.replacementClass);
}
function getMutator() {
  return config.autoReplaceSvg === !0 ? mutators.replace : mutators[config.autoReplaceSvg] || mutators.replace;
}
function createElementNS(Bi) {
  return DOCUMENT.createElementNS("http://www.w3.org/2000/svg", Bi);
}
function createElement(Bi) {
  return DOCUMENT.createElement(Bi);
}
function convertSVG(Bi) {
  let e = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
  const {
    ceFn: Ui = Bi.tag === "svg" ? createElementNS : createElement
  } = e;
  if (typeof Bi == "string")
    return DOCUMENT.createTextNode(Bi);
  const Zi = Ui(Bi.tag);
  return Object.keys(Bi.attributes || []).forEach(function(na) {
    Zi.setAttribute(na, Bi.attributes[na]);
  }), (Bi.children || []).forEach(function(na) {
    Zi.appendChild(convertSVG(na, {
      ceFn: Ui
    }));
  }), Zi;
}
function nodeAsComment(Bi) {
  let e = " ".concat(Bi.outerHTML, " ");
  return e = "".concat(e, "Font Awesome fontawesome.com "), e;
}
const mutators = {
  replace: function(Bi) {
    const e = Bi[0];
    if (e.parentNode)
      if (Bi[1].forEach((Ui) => {
        e.parentNode.insertBefore(convertSVG(Ui), e);
      }), e.getAttribute(DATA_FA_I2SVG) === null && config.keepOriginalSource) {
        let Ui = DOCUMENT.createComment(nodeAsComment(e));
        e.parentNode.replaceChild(Ui, e);
      } else
        e.remove();
  },
  nest: function(Bi) {
    const e = Bi[0], Ui = Bi[1];
    if (~classArray(e).indexOf(config.replacementClass))
      return mutators.replace(Bi);
    const Zi = new RegExp("".concat(config.cssPrefix, "-.*"));
    if (delete Ui[0].attributes.id, Ui[0].attributes.class) {
      const na = Ui[0].attributes.class.split(" ").reduce((ia, aa) => (aa === config.replacementClass || aa.match(Zi) ? ia.toSvg.push(aa) : ia.toNode.push(aa), ia), {
        toNode: [],
        toSvg: []
      });
      Ui[0].attributes.class = na.toSvg.join(" "), na.toNode.length === 0 ? e.removeAttribute("class") : e.setAttribute("class", na.toNode.join(" "));
    }
    const ta = Ui.map((na) => toHtml(na)).join(`
`);
    e.setAttribute(DATA_FA_I2SVG, ""), e.innerHTML = ta;
  }
};
function performOperationSync(Bi) {
  Bi();
}
function perform(Bi, e) {
  const Ui = typeof e == "function" ? e : noop$2$1;
  if (Bi.length === 0)
    Ui();
  else {
    let Zi = performOperationSync;
    config.mutateApproach === MUTATION_APPROACH_ASYNC && (Zi = WINDOW.requestAnimationFrame || performOperationSync), Zi(() => {
      const ta = getMutator(), na = perf.begin("mutate");
      Bi.map(ta), na(), Ui();
    });
  }
}
let disabled = !1;
function disableObservation() {
  disabled = !0;
}
function enableObservation() {
  disabled = !1;
}
let mo$1 = null;
function observe(Bi) {
  if (!MUTATION_OBSERVER || !config.observeMutations)
    return;
  const {
    treeCallback: e = noop$2$1,
    nodeCallback: Ui = noop$2$1,
    pseudoElementsCallback: Zi = noop$2$1,
    observeMutationsRoot: ta = DOCUMENT
  } = Bi;
  mo$1 = new MUTATION_OBSERVER((na) => {
    if (disabled) return;
    const ia = getDefaultUsablePrefix();
    toArray(na).forEach((aa) => {
      if (aa.type === "childList" && aa.addedNodes.length > 0 && !isWatched$1(aa.addedNodes[0]) && (config.searchPseudoElements && Zi(aa.target), e(aa.target)), aa.type === "attributes" && aa.target.parentNode && config.searchPseudoElements && Zi(aa.target.parentNode), aa.type === "attributes" && isWatched$1(aa.target) && ~ATTRIBUTES_WATCHED_FOR_MUTATION.indexOf(aa.attributeName))
        if (aa.attributeName === "class" && hasPrefixAndIcon(aa.target)) {
          const {
            prefix: da,
            iconName: La
          } = getCanonicalIcon(classArray(aa.target));
          aa.target.setAttribute(DATA_PREFIX, da || ia), La && aa.target.setAttribute(DATA_ICON, La);
        } else hasBeenReplaced(aa.target) && Ui(aa.target);
    });
  }), IS_DOM && mo$1.observe(ta, {
    childList: !0,
    attributes: !0,
    characterData: !0,
    subtree: !0
  });
}
function disconnect() {
  mo$1 && mo$1.disconnect();
}
function styleParser(Bi) {
  const e = Bi.getAttribute("style");
  let Ui = [];
  return e && (Ui = e.split(";").reduce((Zi, ta) => {
    const na = ta.split(":"), ia = na[0], aa = na.slice(1);
    return ia && aa.length > 0 && (Zi[ia] = aa.join(":").trim()), Zi;
  }, {})), Ui;
}
function classParser(Bi) {
  const e = Bi.getAttribute("data-prefix"), Ui = Bi.getAttribute("data-icon"), Zi = Bi.innerText !== void 0 ? Bi.innerText.trim() : "";
  let ta = getCanonicalIcon(classArray(Bi));
  return ta.prefix || (ta.prefix = getDefaultUsablePrefix()), e && Ui && (ta.prefix = e, ta.iconName = Ui), ta.iconName && ta.prefix || (ta.prefix && Zi.length > 0 && (ta.iconName = byLigature(ta.prefix, Bi.innerText) || byUnicode(ta.prefix, toHex(Bi.innerText))), !ta.iconName && config.autoFetchSvg && Bi.firstChild && Bi.firstChild.nodeType === Node.TEXT_NODE && (ta.iconName = Bi.firstChild.data)), ta;
}
function attributesParser(Bi) {
  const e = toArray(Bi.attributes).reduce((ta, na) => (ta.name !== "class" && ta.name !== "style" && (ta[na.name] = na.value), ta), {}), Ui = Bi.getAttribute("title"), Zi = Bi.getAttribute("data-fa-title-id");
  return config.autoA11y && (Ui ? e["aria-labelledby"] = "".concat(config.replacementClass, "-title-").concat(Zi || nextUniqueId$1()) : (e["aria-hidden"] = "true", e.focusable = "false")), e;
}
function blankMeta() {
  return {
    iconName: null,
    title: null,
    titleId: null,
    prefix: null,
    transform: meaninglessTransform,
    symbol: !1,
    mask: {
      iconName: null,
      prefix: null,
      rest: []
    },
    maskId: null,
    extra: {
      classes: [],
      styles: {},
      attributes: {}
    }
  };
}
function parseMeta(Bi) {
  let e = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {
    styleParser: !0
  };
  const {
    iconName: Ui,
    prefix: Zi,
    rest: ta
  } = classParser(Bi), na = attributesParser(Bi), ia = chainHooks("parseNodeAttributes", {}, Bi);
  let aa = e.styleParser ? styleParser(Bi) : [];
  return _objectSpread2$1({
    iconName: Ui,
    title: Bi.getAttribute("title"),
    titleId: Bi.getAttribute("data-fa-title-id"),
    prefix: Zi,
    transform: meaninglessTransform,
    mask: {
      iconName: null,
      prefix: null,
      rest: []
    },
    maskId: null,
    symbol: !1,
    extra: {
      classes: ta,
      styles: aa,
      attributes: na
    }
  }, ia);
}
const {
  styles: styles$2
} = namespace;
function generateMutation(Bi) {
  const e = config.autoReplaceSvg === "nest" ? parseMeta(Bi, {
    styleParser: !1
  }) : parseMeta(Bi);
  return ~e.extra.classes.indexOf(LAYERS_TEXT_CLASSNAME) ? callProvided("generateLayersText", Bi, e) : callProvided("generateSvgReplacementMutation", Bi, e);
}
function getKnownPrefixes() {
  return [...Ft$3, ...Ia$1];
}
function onTree(Bi) {
  let e = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : null;
  if (!IS_DOM) return Promise.resolve();
  const Ui = DOCUMENT.documentElement.classList, Zi = (qa) => Ui.add("".concat(HTML_CLASS_I2SVG_BASE_CLASS, "-").concat(qa)), ta = (qa) => Ui.remove("".concat(HTML_CLASS_I2SVG_BASE_CLASS, "-").concat(qa)), na = config.autoFetchSvg ? getKnownPrefixes() : P$4.concat(Object.keys(styles$2));
  na.includes("fa") || na.push("fa");
  const ia = [".".concat(LAYERS_TEXT_CLASSNAME, ":not([").concat(DATA_FA_I2SVG, "])")].concat(na.map((qa) => ".".concat(qa, ":not([").concat(DATA_FA_I2SVG, "])"))).join(", ");
  if (ia.length === 0)
    return Promise.resolve();
  let aa = [];
  try {
    aa = toArray(Bi.querySelectorAll(ia));
  } catch {
  }
  if (aa.length > 0)
    Zi("pending"), ta("complete");
  else
    return Promise.resolve();
  const da = perf.begin("onTree"), La = aa.reduce((qa, io) => {
    try {
      const ao = generateMutation(io);
      ao && qa.push(ao);
    } catch (ao) {
      PRODUCTION$1 || ao.name === "MissingIcon" && console.error(ao);
    }
    return qa;
  }, []);
  return new Promise((qa, io) => {
    Promise.all(La).then((ao) => {
      perform(ao, () => {
        Zi("active"), Zi("complete"), ta("pending"), typeof e == "function" && e(), da(), qa();
      });
    }).catch((ao) => {
      da(), io(ao);
    });
  });
}
function onNode(Bi) {
  let e = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : null;
  generateMutation(Bi).then((Ui) => {
    Ui && perform([Ui], e);
  });
}
function resolveIcons(Bi) {
  return function(e) {
    let Ui = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    const Zi = (e || {}).icon ? e : findIconDefinition(e || {});
    let {
      mask: ta
    } = Ui;
    return ta && (ta = (ta || {}).icon ? ta : findIconDefinition(ta || {})), Bi(Zi, _objectSpread2$1(_objectSpread2$1({}, Ui), {}, {
      mask: ta
    }));
  };
}
const render = function(Bi) {
  let e = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
  const {
    transform: Ui = meaninglessTransform,
    symbol: Zi = !1,
    mask: ta = null,
    maskId: na = null,
    title: ia = null,
    titleId: aa = null,
    classes: da = [],
    attributes: La = {},
    styles: qa = {}
  } = e;
  if (!Bi) return;
  const {
    prefix: io,
    iconName: ao,
    icon: oo
  } = Bi;
  return domVariants(_objectSpread2$1({
    type: "icon"
  }, Bi), () => (callHooks("beforeDOMElementCreation", {
    iconDefinition: Bi,
    params: e
  }), config.autoA11y && (ia ? La["aria-labelledby"] = "".concat(config.replacementClass, "-title-").concat(aa || nextUniqueId$1()) : (La["aria-hidden"] = "true", La.focusable = "false")), makeInlineSvgAbstract({
    icons: {
      main: asFoundIcon(oo),
      mask: ta ? asFoundIcon(ta.icon) : {
        found: !1,
        width: null,
        height: null,
        icon: {}
      }
    },
    prefix: io,
    iconName: ao,
    transform: _objectSpread2$1(_objectSpread2$1({}, meaninglessTransform), Ui),
    symbol: Zi,
    title: ia,
    maskId: na,
    titleId: aa,
    extra: {
      attributes: La,
      styles: qa,
      classes: da
    }
  })));
};
var ReplaceElements = {
  mixout() {
    return {
      icon: resolveIcons(render)
    };
  },
  hooks() {
    return {
      mutationObserverCallbacks(Bi) {
        return Bi.treeCallback = onTree, Bi.nodeCallback = onNode, Bi;
      }
    };
  },
  provides(Bi) {
    Bi.i2svg = function(e) {
      const {
        node: Ui = DOCUMENT,
        callback: Zi = () => {
        }
      } = e;
      return onTree(Ui, Zi);
    }, Bi.generateSvgReplacementMutation = function(e, Ui) {
      const {
        iconName: Zi,
        title: ta,
        titleId: na,
        prefix: ia,
        transform: aa,
        symbol: da,
        mask: La,
        maskId: qa,
        extra: io
      } = Ui;
      return new Promise((ao, oo) => {
        Promise.all([findIcon(Zi, ia), La.iconName ? findIcon(La.iconName, La.prefix) : Promise.resolve({
          found: !1,
          width: 512,
          height: 512,
          icon: {}
        })]).then((no) => {
          let [lo, so] = no;
          ao([e, makeInlineSvgAbstract({
            icons: {
              main: lo,
              mask: so
            },
            prefix: ia,
            iconName: Zi,
            transform: aa,
            symbol: da,
            maskId: qa,
            title: ta,
            titleId: na,
            extra: io,
            watchable: !0
          })]);
        }).catch(oo);
      });
    }, Bi.generateAbstractIcon = function(e) {
      let {
        children: Ui,
        attributes: Zi,
        main: ta,
        transform: na,
        styles: ia
      } = e;
      const aa = joinStyles(ia);
      aa.length > 0 && (Zi.style = aa);
      let da;
      return transformIsMeaningful(na) && (da = callProvided("generateAbstractTransformGrouping", {
        main: ta,
        transform: na,
        containerWidth: ta.width,
        iconWidth: ta.width
      })), Ui.push(da || ta.icon), {
        children: Ui,
        attributes: Zi
      };
    };
  }
}, Layers = {
  mixout() {
    return {
      layer(Bi) {
        let e = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
        const {
          classes: Ui = []
        } = e;
        return domVariants({
          type: "layer"
        }, () => {
          callHooks("beforeDOMElementCreation", {
            assembler: Bi,
            params: e
          });
          let Zi = [];
          return Bi((ta) => {
            Array.isArray(ta) ? ta.map((na) => {
              Zi = Zi.concat(na.abstract);
            }) : Zi = Zi.concat(ta.abstract);
          }), [{
            tag: "span",
            attributes: {
              class: ["".concat(config.cssPrefix, "-layers"), ...Ui].join(" ")
            },
            children: Zi
          }];
        });
      }
    };
  }
}, LayersCounter = {
  mixout() {
    return {
      counter(Bi) {
        let e = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
        const {
          title: Ui = null,
          classes: Zi = [],
          attributes: ta = {},
          styles: na = {}
        } = e;
        return domVariants({
          type: "counter",
          content: Bi
        }, () => (callHooks("beforeDOMElementCreation", {
          content: Bi,
          params: e
        }), makeLayersCounterAbstract({
          content: Bi.toString(),
          title: Ui,
          extra: {
            attributes: ta,
            styles: na,
            classes: ["".concat(config.cssPrefix, "-layers-counter"), ...Zi]
          }
        })));
      }
    };
  }
}, LayersText = {
  mixout() {
    return {
      text(Bi) {
        let e = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
        const {
          transform: Ui = meaninglessTransform,
          title: Zi = null,
          classes: ta = [],
          attributes: na = {},
          styles: ia = {}
        } = e;
        return domVariants({
          type: "text",
          content: Bi
        }, () => (callHooks("beforeDOMElementCreation", {
          content: Bi,
          params: e
        }), makeLayersTextAbstract({
          content: Bi,
          transform: _objectSpread2$1(_objectSpread2$1({}, meaninglessTransform), Ui),
          title: Zi,
          extra: {
            attributes: na,
            styles: ia,
            classes: ["".concat(config.cssPrefix, "-layers-text"), ...ta]
          }
        })));
      }
    };
  },
  provides(Bi) {
    Bi.generateLayersText = function(e, Ui) {
      const {
        title: Zi,
        transform: ta,
        extra: na
      } = Ui;
      let ia = null, aa = null;
      if (IS_IE) {
        const da = parseInt(getComputedStyle(e).fontSize, 10), La = e.getBoundingClientRect();
        ia = La.width / da, aa = La.height / da;
      }
      return config.autoA11y && !Zi && (na.attributes["aria-hidden"] = "true"), Promise.resolve([e, makeLayersTextAbstract({
        content: e.innerHTML,
        width: ia,
        height: aa,
        transform: ta,
        title: Zi,
        extra: na,
        watchable: !0
      })]);
    };
  }
};
const CLEAN_CONTENT_PATTERN = new RegExp('"', "ug"), SECONDARY_UNICODE_RANGE = [1105920, 1112319], _FONT_FAMILY_WEIGHT_TO_PREFIX = _objectSpread2$1(_objectSpread2$1(_objectSpread2$1(_objectSpread2$1({}, {
  FontAwesome: {
    normal: "fas",
    400: "fas"
  }
}), lt$3), wa$1), Yt$3), FONT_FAMILY_WEIGHT_TO_PREFIX = Object.keys(_FONT_FAMILY_WEIGHT_TO_PREFIX).reduce((Bi, e) => (Bi[e.toLowerCase()] = _FONT_FAMILY_WEIGHT_TO_PREFIX[e], Bi), {}), FONT_FAMILY_WEIGHT_FALLBACK = Object.keys(FONT_FAMILY_WEIGHT_TO_PREFIX).reduce((Bi, e) => {
  const Ui = FONT_FAMILY_WEIGHT_TO_PREFIX[e];
  return Bi[e] = Ui[900] || [...Object.entries(Ui)][0][1], Bi;
}, {});
function hexValueFromContent(Bi) {
  const e = Bi.replace(CLEAN_CONTENT_PATTERN, ""), Ui = codePointAt(e, 0), Zi = Ui >= SECONDARY_UNICODE_RANGE[0] && Ui <= SECONDARY_UNICODE_RANGE[1], ta = e.length === 2 ? e[0] === e[1] : !1;
  return {
    value: toHex(ta ? e[0] : e),
    isSecondary: Zi || ta
  };
}
function getPrefix(Bi, e) {
  const Ui = Bi.replace(/^['"]|['"]$/g, "").toLowerCase(), Zi = parseInt(e), ta = isNaN(Zi) ? "normal" : Zi;
  return (FONT_FAMILY_WEIGHT_TO_PREFIX[Ui] || {})[ta] || FONT_FAMILY_WEIGHT_FALLBACK[Ui];
}
function replaceForPosition(Bi, e) {
  const Ui = "".concat(DATA_FA_PSEUDO_ELEMENT_PENDING).concat(e.replace(":", "-"));
  return new Promise((Zi, ta) => {
    if (Bi.getAttribute(Ui) !== null)
      return Zi();
    const ia = toArray(Bi.children).filter((ao) => ao.getAttribute(DATA_FA_PSEUDO_ELEMENT) === e)[0], aa = WINDOW.getComputedStyle(Bi, e), da = aa.getPropertyValue("font-family"), La = da.match(FONT_FAMILY_PATTERN), qa = aa.getPropertyValue("font-weight"), io = aa.getPropertyValue("content");
    if (ia && !La)
      return Bi.removeChild(ia), Zi();
    if (La && io !== "none" && io !== "") {
      const ao = aa.getPropertyValue("content");
      let oo = getPrefix(da, qa);
      const {
        value: no,
        isSecondary: lo
      } = hexValueFromContent(ao), so = La[0].startsWith("FontAwesome");
      let bs = byUnicode(oo, no), Rs = bs;
      if (so) {
        const js = byOldUnicode(no);
        js.iconName && js.prefix && (bs = js.iconName, oo = js.prefix);
      }
      if (bs && !lo && (!ia || ia.getAttribute(DATA_PREFIX) !== oo || ia.getAttribute(DATA_ICON) !== Rs)) {
        Bi.setAttribute(Ui, Rs), ia && Bi.removeChild(ia);
        const js = blankMeta(), {
          extra: qs
        } = js;
        qs.attributes[DATA_FA_PSEUDO_ELEMENT] = e, findIcon(bs, oo).then((jo) => {
          const fs = makeInlineSvgAbstract(_objectSpread2$1(_objectSpread2$1({}, js), {}, {
            icons: {
              main: jo,
              mask: emptyCanonicalIcon()
            },
            prefix: oo,
            iconName: Rs,
            extra: qs,
            watchable: !0
          })), Ao = DOCUMENT.createElementNS("http://www.w3.org/2000/svg", "svg");
          e === "::before" ? Bi.insertBefore(Ao, Bi.firstChild) : Bi.appendChild(Ao), Ao.outerHTML = fs.map((co) => toHtml(co)).join(`
`), Bi.removeAttribute(Ui), Zi();
        }).catch(ta);
      } else
        Zi();
    } else
      Zi();
  });
}
function replace(Bi) {
  return Promise.all([replaceForPosition(Bi, "::before"), replaceForPosition(Bi, "::after")]);
}
function processable(Bi) {
  return Bi.parentNode !== document.head && !~TAGNAMES_TO_SKIP_FOR_PSEUDOELEMENTS.indexOf(Bi.tagName.toUpperCase()) && !Bi.getAttribute(DATA_FA_PSEUDO_ELEMENT) && (!Bi.parentNode || Bi.parentNode.tagName !== "svg");
}
function searchPseudoElements(Bi) {
  if (IS_DOM)
    return new Promise((e, Ui) => {
      const Zi = toArray(Bi.querySelectorAll("*")).filter(processable).map(replace), ta = perf.begin("searchPseudoElements");
      disableObservation(), Promise.all(Zi).then(() => {
        ta(), enableObservation(), e();
      }).catch(() => {
        ta(), enableObservation(), Ui();
      });
    });
}
var PseudoElements = {
  hooks() {
    return {
      mutationObserverCallbacks(Bi) {
        return Bi.pseudoElementsCallback = searchPseudoElements, Bi;
      }
    };
  },
  provides(Bi) {
    Bi.pseudoElements2svg = function(e) {
      const {
        node: Ui = DOCUMENT
      } = e;
      config.searchPseudoElements && searchPseudoElements(Ui);
    };
  }
};
let _unwatched = !1;
var MutationObserver$1 = {
  mixout() {
    return {
      dom: {
        unwatch() {
          disableObservation(), _unwatched = !0;
        }
      }
    };
  },
  hooks() {
    return {
      bootstrap() {
        observe(chainHooks("mutationObserverCallbacks", {}));
      },
      noAuto() {
        disconnect();
      },
      watch(Bi) {
        const {
          observeMutationsRoot: e
        } = Bi;
        _unwatched ? enableObservation() : observe(chainHooks("mutationObserverCallbacks", {
          observeMutationsRoot: e
        }));
      }
    };
  }
};
const parseTransformString = (Bi) => {
  let e = {
    size: 16,
    x: 0,
    y: 0,
    flipX: !1,
    flipY: !1,
    rotate: 0
  };
  return Bi.toLowerCase().split(" ").reduce((Ui, Zi) => {
    const ta = Zi.toLowerCase().split("-"), na = ta[0];
    let ia = ta.slice(1).join("-");
    if (na && ia === "h")
      return Ui.flipX = !0, Ui;
    if (na && ia === "v")
      return Ui.flipY = !0, Ui;
    if (ia = parseFloat(ia), isNaN(ia))
      return Ui;
    switch (na) {
      case "grow":
        Ui.size = Ui.size + ia;
        break;
      case "shrink":
        Ui.size = Ui.size - ia;
        break;
      case "left":
        Ui.x = Ui.x - ia;
        break;
      case "right":
        Ui.x = Ui.x + ia;
        break;
      case "up":
        Ui.y = Ui.y - ia;
        break;
      case "down":
        Ui.y = Ui.y + ia;
        break;
      case "rotate":
        Ui.rotate = Ui.rotate + ia;
        break;
    }
    return Ui;
  }, e);
};
var PowerTransforms = {
  mixout() {
    return {
      parse: {
        transform: (Bi) => parseTransformString(Bi)
      }
    };
  },
  hooks() {
    return {
      parseNodeAttributes(Bi, e) {
        const Ui = e.getAttribute("data-fa-transform");
        return Ui && (Bi.transform = parseTransformString(Ui)), Bi;
      }
    };
  },
  provides(Bi) {
    Bi.generateAbstractTransformGrouping = function(e) {
      let {
        main: Ui,
        transform: Zi,
        containerWidth: ta,
        iconWidth: na
      } = e;
      const ia = {
        transform: "translate(".concat(ta / 2, " 256)")
      }, aa = "translate(".concat(Zi.x * 32, ", ").concat(Zi.y * 32, ") "), da = "scale(".concat(Zi.size / 16 * (Zi.flipX ? -1 : 1), ", ").concat(Zi.size / 16 * (Zi.flipY ? -1 : 1), ") "), La = "rotate(".concat(Zi.rotate, " 0 0)"), qa = {
        transform: "".concat(aa, " ").concat(da, " ").concat(La)
      }, io = {
        transform: "translate(".concat(na / 2 * -1, " -256)")
      }, ao = {
        outer: ia,
        inner: qa,
        path: io
      };
      return {
        tag: "g",
        attributes: _objectSpread2$1({}, ao.outer),
        children: [{
          tag: "g",
          attributes: _objectSpread2$1({}, ao.inner),
          children: [{
            tag: Ui.icon.tag,
            children: Ui.icon.children,
            attributes: _objectSpread2$1(_objectSpread2$1({}, Ui.icon.attributes), ao.path)
          }]
        }]
      };
    };
  }
};
const ALL_SPACE = {
  x: 0,
  y: 0,
  width: "100%",
  height: "100%"
};
function fillBlack(Bi) {
  let e = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !0;
  return Bi.attributes && (Bi.attributes.fill || e) && (Bi.attributes.fill = "black"), Bi;
}
function deGroup(Bi) {
  return Bi.tag === "g" ? Bi.children : [Bi];
}
var Masks = {
  hooks() {
    return {
      parseNodeAttributes(Bi, e) {
        const Ui = e.getAttribute("data-fa-mask"), Zi = Ui ? getCanonicalIcon(Ui.split(" ").map((ta) => ta.trim())) : emptyCanonicalIcon();
        return Zi.prefix || (Zi.prefix = getDefaultUsablePrefix()), Bi.mask = Zi, Bi.maskId = e.getAttribute("data-fa-mask-id"), Bi;
      }
    };
  },
  provides(Bi) {
    Bi.generateAbstractMask = function(e) {
      let {
        children: Ui,
        attributes: Zi,
        main: ta,
        mask: na,
        maskId: ia,
        transform: aa
      } = e;
      const {
        width: da,
        icon: La
      } = ta, {
        width: qa,
        icon: io
      } = na, ao = transformForSvg({
        transform: aa,
        containerWidth: qa,
        iconWidth: da
      }), oo = {
        tag: "rect",
        attributes: _objectSpread2$1(_objectSpread2$1({}, ALL_SPACE), {}, {
          fill: "white"
        })
      }, no = La.children ? {
        children: La.children.map(fillBlack)
      } : {}, lo = {
        tag: "g",
        attributes: _objectSpread2$1({}, ao.inner),
        children: [fillBlack(_objectSpread2$1({
          tag: La.tag,
          attributes: _objectSpread2$1(_objectSpread2$1({}, La.attributes), ao.path)
        }, no))]
      }, so = {
        tag: "g",
        attributes: _objectSpread2$1({}, ao.outer),
        children: [lo]
      }, bs = "mask-".concat(ia || nextUniqueId$1()), Rs = "clip-".concat(ia || nextUniqueId$1()), js = {
        tag: "mask",
        attributes: _objectSpread2$1(_objectSpread2$1({}, ALL_SPACE), {}, {
          id: bs,
          maskUnits: "userSpaceOnUse",
          maskContentUnits: "userSpaceOnUse"
        }),
        children: [oo, so]
      }, qs = {
        tag: "defs",
        children: [{
          tag: "clipPath",
          attributes: {
            id: Rs
          },
          children: deGroup(io)
        }, js]
      };
      return Ui.push(qs, {
        tag: "rect",
        attributes: _objectSpread2$1({
          fill: "currentColor",
          "clip-path": "url(#".concat(Rs, ")"),
          mask: "url(#".concat(bs, ")")
        }, ALL_SPACE)
      }), {
        children: Ui,
        attributes: Zi
      };
    };
  }
}, MissingIconIndicator = {
  provides(Bi) {
    let e = !1;
    WINDOW.matchMedia && (e = WINDOW.matchMedia("(prefers-reduced-motion: reduce)").matches), Bi.missingIconAbstract = function() {
      const Ui = [], Zi = {
        fill: "currentColor"
      }, ta = {
        attributeType: "XML",
        repeatCount: "indefinite",
        dur: "2s"
      };
      Ui.push({
        tag: "path",
        attributes: _objectSpread2$1(_objectSpread2$1({}, Zi), {}, {
          d: "M156.5,447.7l-12.6,29.5c-18.7-9.5-35.9-21.2-51.5-34.9l22.7-22.7C127.6,430.5,141.5,440,156.5,447.7z M40.6,272H8.5 c1.4,21.2,5.4,41.7,11.7,61.1L50,321.2C45.1,305.5,41.8,289,40.6,272z M40.6,240c1.4-18.8,5.2-37,11.1-54.1l-29.5-12.6 C14.7,194.3,10,216.7,8.5,240H40.6z M64.3,156.5c7.8-14.9,17.2-28.8,28.1-41.5L69.7,92.3c-13.7,15.6-25.5,32.8-34.9,51.5 L64.3,156.5z M397,419.6c-13.9,12-29.4,22.3-46.1,30.4l11.9,29.8c20.7-9.9,39.8-22.6,56.9-37.6L397,419.6z M115,92.4 c13.9-12,29.4-22.3,46.1-30.4l-11.9-29.8c-20.7,9.9-39.8,22.6-56.8,37.6L115,92.4z M447.7,355.5c-7.8,14.9-17.2,28.8-28.1,41.5 l22.7,22.7c13.7-15.6,25.5-32.9,34.9-51.5L447.7,355.5z M471.4,272c-1.4,18.8-5.2,37-11.1,54.1l29.5,12.6 c7.5-21.1,12.2-43.5,13.6-66.8H471.4z M321.2,462c-15.7,5-32.2,8.2-49.2,9.4v32.1c21.2-1.4,41.7-5.4,61.1-11.7L321.2,462z M240,471.4c-18.8-1.4-37-5.2-54.1-11.1l-12.6,29.5c21.1,7.5,43.5,12.2,66.8,13.6V471.4z M462,190.8c5,15.7,8.2,32.2,9.4,49.2h32.1 c-1.4-21.2-5.4-41.7-11.7-61.1L462,190.8z M92.4,397c-12-13.9-22.3-29.4-30.4-46.1l-29.8,11.9c9.9,20.7,22.6,39.8,37.6,56.9 L92.4,397z M272,40.6c18.8,1.4,36.9,5.2,54.1,11.1l12.6-29.5C317.7,14.7,295.3,10,272,8.5V40.6z M190.8,50 c15.7-5,32.2-8.2,49.2-9.4V8.5c-21.2,1.4-41.7,5.4-61.1,11.7L190.8,50z M442.3,92.3L419.6,115c12,13.9,22.3,29.4,30.5,46.1 l29.8-11.9C470,128.5,457.3,109.4,442.3,92.3z M397,92.4l22.7-22.7c-15.6-13.7-32.8-25.5-51.5-34.9l-12.6,29.5 C370.4,72.1,384.4,81.5,397,92.4z"
        })
      });
      const na = _objectSpread2$1(_objectSpread2$1({}, ta), {}, {
        attributeName: "opacity"
      }), ia = {
        tag: "circle",
        attributes: _objectSpread2$1(_objectSpread2$1({}, Zi), {}, {
          cx: "256",
          cy: "364",
          r: "28"
        }),
        children: []
      };
      return e || ia.children.push({
        tag: "animate",
        attributes: _objectSpread2$1(_objectSpread2$1({}, ta), {}, {
          attributeName: "r",
          values: "28;14;28;28;14;28;"
        })
      }, {
        tag: "animate",
        attributes: _objectSpread2$1(_objectSpread2$1({}, na), {}, {
          values: "1;0;1;1;0;1;"
        })
      }), Ui.push(ia), Ui.push({
        tag: "path",
        attributes: _objectSpread2$1(_objectSpread2$1({}, Zi), {}, {
          opacity: "1",
          d: "M263.7,312h-16c-6.6,0-12-5.4-12-12c0-71,77.4-63.9,77.4-107.8c0-20-17.8-40.2-57.4-40.2c-29.1,0-44.3,9.6-59.2,28.7 c-3.9,5-11.1,6-16.2,2.4l-13.1-9.2c-5.6-3.9-6.9-11.8-2.6-17.2c21.2-27.2,46.4-44.7,91.2-44.7c52.3,0,97.4,29.8,97.4,80.2 c0,67.6-77.4,63.5-77.4,107.8C275.7,306.6,270.3,312,263.7,312z"
        }),
        children: e ? [] : [{
          tag: "animate",
          attributes: _objectSpread2$1(_objectSpread2$1({}, na), {}, {
            values: "1;0;0;0;0;1;"
          })
        }]
      }), e || Ui.push({
        tag: "path",
        attributes: _objectSpread2$1(_objectSpread2$1({}, Zi), {}, {
          opacity: "0",
          d: "M232.5,134.5l7,168c0.3,6.4,5.6,11.5,12,11.5h9c6.4,0,11.7-5.1,12-11.5l7-168c0.3-6.8-5.2-12.5-12-12.5h-23 C237.7,122,232.2,127.7,232.5,134.5z"
        }),
        children: [{
          tag: "animate",
          attributes: _objectSpread2$1(_objectSpread2$1({}, na), {}, {
            values: "0;0;1;1;0;0;"
          })
        }]
      }), {
        tag: "g",
        attributes: {
          class: "missing"
        },
        children: Ui
      };
    };
  }
}, SvgSymbols = {
  hooks() {
    return {
      parseNodeAttributes(Bi, e) {
        const Ui = e.getAttribute("data-fa-symbol"), Zi = Ui === null ? !1 : Ui === "" ? !0 : Ui;
        return Bi.symbol = Zi, Bi;
      }
    };
  }
}, plugins = [InjectCSS, ReplaceElements, Layers, LayersCounter, LayersText, PseudoElements, MutationObserver$1, PowerTransforms, Masks, MissingIconIndicator, SvgSymbols];
registerPlugins(plugins, {
  mixoutsTo: api
});
api.noAuto;
api.config;
api.library;
api.dom;
const parse$1$1 = api.parse;
api.findIconDefinition;
api.toHtml;
const icon = api.icon;
api.layer;
api.text;
api.counter;
var propTypes = { exports: {} }, reactIs = { exports: {} }, reactIs_production_min = {};
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var hasRequiredReactIs_production_min;
function requireReactIs_production_min() {
  if (hasRequiredReactIs_production_min) return reactIs_production_min;
  hasRequiredReactIs_production_min = 1;
  var Bi = typeof Symbol == "function" && Symbol.for, e = Bi ? Symbol.for("react.element") : 60103, Ui = Bi ? Symbol.for("react.portal") : 60106, Zi = Bi ? Symbol.for("react.fragment") : 60107, ta = Bi ? Symbol.for("react.strict_mode") : 60108, na = Bi ? Symbol.for("react.profiler") : 60114, ia = Bi ? Symbol.for("react.provider") : 60109, aa = Bi ? Symbol.for("react.context") : 60110, da = Bi ? Symbol.for("react.async_mode") : 60111, La = Bi ? Symbol.for("react.concurrent_mode") : 60111, qa = Bi ? Symbol.for("react.forward_ref") : 60112, io = Bi ? Symbol.for("react.suspense") : 60113, ao = Bi ? Symbol.for("react.suspense_list") : 60120, oo = Bi ? Symbol.for("react.memo") : 60115, no = Bi ? Symbol.for("react.lazy") : 60116, lo = Bi ? Symbol.for("react.block") : 60121, so = Bi ? Symbol.for("react.fundamental") : 60117, bs = Bi ? Symbol.for("react.responder") : 60118, Rs = Bi ? Symbol.for("react.scope") : 60119;
  function js(jo) {
    if (typeof jo == "object" && jo !== null) {
      var fs = jo.$$typeof;
      switch (fs) {
        case e:
          switch (jo = jo.type, jo) {
            case da:
            case La:
            case Zi:
            case na:
            case ta:
            case io:
              return jo;
            default:
              switch (jo = jo && jo.$$typeof, jo) {
                case aa:
                case qa:
                case no:
                case oo:
                case ia:
                  return jo;
                default:
                  return fs;
              }
          }
        case Ui:
          return fs;
      }
    }
  }
  function qs(jo) {
    return js(jo) === La;
  }
  return reactIs_production_min.AsyncMode = da, reactIs_production_min.ConcurrentMode = La, reactIs_production_min.ContextConsumer = aa, reactIs_production_min.ContextProvider = ia, reactIs_production_min.Element = e, reactIs_production_min.ForwardRef = qa, reactIs_production_min.Fragment = Zi, reactIs_production_min.Lazy = no, reactIs_production_min.Memo = oo, reactIs_production_min.Portal = Ui, reactIs_production_min.Profiler = na, reactIs_production_min.StrictMode = ta, reactIs_production_min.Suspense = io, reactIs_production_min.isAsyncMode = function(jo) {
    return qs(jo) || js(jo) === da;
  }, reactIs_production_min.isConcurrentMode = qs, reactIs_production_min.isContextConsumer = function(jo) {
    return js(jo) === aa;
  }, reactIs_production_min.isContextProvider = function(jo) {
    return js(jo) === ia;
  }, reactIs_production_min.isElement = function(jo) {
    return typeof jo == "object" && jo !== null && jo.$$typeof === e;
  }, reactIs_production_min.isForwardRef = function(jo) {
    return js(jo) === qa;
  }, reactIs_production_min.isFragment = function(jo) {
    return js(jo) === Zi;
  }, reactIs_production_min.isLazy = function(jo) {
    return js(jo) === no;
  }, reactIs_production_min.isMemo = function(jo) {
    return js(jo) === oo;
  }, reactIs_production_min.isPortal = function(jo) {
    return js(jo) === Ui;
  }, reactIs_production_min.isProfiler = function(jo) {
    return js(jo) === na;
  }, reactIs_production_min.isStrictMode = function(jo) {
    return js(jo) === ta;
  }, reactIs_production_min.isSuspense = function(jo) {
    return js(jo) === io;
  }, reactIs_production_min.isValidElementType = function(jo) {
    return typeof jo == "string" || typeof jo == "function" || jo === Zi || jo === La || jo === na || jo === ta || jo === io || jo === ao || typeof jo == "object" && jo !== null && (jo.$$typeof === no || jo.$$typeof === oo || jo.$$typeof === ia || jo.$$typeof === aa || jo.$$typeof === qa || jo.$$typeof === so || jo.$$typeof === bs || jo.$$typeof === Rs || jo.$$typeof === lo);
  }, reactIs_production_min.typeOf = js, reactIs_production_min;
}
var reactIs_development = {};
/** @license React v16.13.1
 * react-is.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var hasRequiredReactIs_development;
function requireReactIs_development() {
  return hasRequiredReactIs_development || (hasRequiredReactIs_development = 1, process.env.NODE_ENV !== "production" && function() {
    var Bi = typeof Symbol == "function" && Symbol.for, e = Bi ? Symbol.for("react.element") : 60103, Ui = Bi ? Symbol.for("react.portal") : 60106, Zi = Bi ? Symbol.for("react.fragment") : 60107, ta = Bi ? Symbol.for("react.strict_mode") : 60108, na = Bi ? Symbol.for("react.profiler") : 60114, ia = Bi ? Symbol.for("react.provider") : 60109, aa = Bi ? Symbol.for("react.context") : 60110, da = Bi ? Symbol.for("react.async_mode") : 60111, La = Bi ? Symbol.for("react.concurrent_mode") : 60111, qa = Bi ? Symbol.for("react.forward_ref") : 60112, io = Bi ? Symbol.for("react.suspense") : 60113, ao = Bi ? Symbol.for("react.suspense_list") : 60120, oo = Bi ? Symbol.for("react.memo") : 60115, no = Bi ? Symbol.for("react.lazy") : 60116, lo = Bi ? Symbol.for("react.block") : 60121, so = Bi ? Symbol.for("react.fundamental") : 60117, bs = Bi ? Symbol.for("react.responder") : 60118, Rs = Bi ? Symbol.for("react.scope") : 60119;
    function js(wl) {
      return typeof wl == "string" || typeof wl == "function" || // Note: its typeof might be other than 'symbol' or 'number' if it's a polyfill.
      wl === Zi || wl === La || wl === na || wl === ta || wl === io || wl === ao || typeof wl == "object" && wl !== null && (wl.$$typeof === no || wl.$$typeof === oo || wl.$$typeof === ia || wl.$$typeof === aa || wl.$$typeof === qa || wl.$$typeof === so || wl.$$typeof === bs || wl.$$typeof === Rs || wl.$$typeof === lo);
    }
    function qs(wl) {
      if (typeof wl == "object" && wl !== null) {
        var Pl = wl.$$typeof;
        switch (Pl) {
          case e:
            var jl = wl.type;
            switch (jl) {
              case da:
              case La:
              case Zi:
              case na:
              case ta:
              case io:
                return jl;
              default:
                var Dl = jl && jl.$$typeof;
                switch (Dl) {
                  case aa:
                  case qa:
                  case no:
                  case oo:
                  case ia:
                    return Dl;
                  default:
                    return Pl;
                }
            }
          case Ui:
            return Pl;
        }
      }
    }
    var jo = da, fs = La, Ao = aa, co = ia, Co = e, Zs = qa, xl = Zi, Cl = no, Al = oo, Ol = Ui, Bl = na, Ml = ta, Vl = io, Ll = !1;
    function Yl(wl) {
      return Ll || (Ll = !0, console.warn("The ReactIs.isAsyncMode() alias has been deprecated, and will be removed in React 17+. Update your code to use ReactIs.isConcurrentMode() instead. It has the exact same API.")), Zl(wl) || qs(wl) === da;
    }
    function Zl(wl) {
      return qs(wl) === La;
    }
    function tc(wl) {
      return qs(wl) === aa;
    }
    function Nl(wl) {
      return qs(wl) === ia;
    }
    function Tl(wl) {
      return typeof wl == "object" && wl !== null && wl.$$typeof === e;
    }
    function El(wl) {
      return qs(wl) === qa;
    }
    function Il(wl) {
      return qs(wl) === Zi;
    }
    function Ul(wl) {
      return qs(wl) === no;
    }
    function Kl(wl) {
      return qs(wl) === oo;
    }
    function Rl(wl) {
      return qs(wl) === Ui;
    }
    function uo(wl) {
      return qs(wl) === na;
    }
    function Is(wl) {
      return qs(wl) === ta;
    }
    function Sl(wl) {
      return qs(wl) === io;
    }
    reactIs_development.AsyncMode = jo, reactIs_development.ConcurrentMode = fs, reactIs_development.ContextConsumer = Ao, reactIs_development.ContextProvider = co, reactIs_development.Element = Co, reactIs_development.ForwardRef = Zs, reactIs_development.Fragment = xl, reactIs_development.Lazy = Cl, reactIs_development.Memo = Al, reactIs_development.Portal = Ol, reactIs_development.Profiler = Bl, reactIs_development.StrictMode = Ml, reactIs_development.Suspense = Vl, reactIs_development.isAsyncMode = Yl, reactIs_development.isConcurrentMode = Zl, reactIs_development.isContextConsumer = tc, reactIs_development.isContextProvider = Nl, reactIs_development.isElement = Tl, reactIs_development.isForwardRef = El, reactIs_development.isFragment = Il, reactIs_development.isLazy = Ul, reactIs_development.isMemo = Kl, reactIs_development.isPortal = Rl, reactIs_development.isProfiler = uo, reactIs_development.isStrictMode = Is, reactIs_development.isSuspense = Sl, reactIs_development.isValidElementType = js, reactIs_development.typeOf = qs;
  }()), reactIs_development;
}
var hasRequiredReactIs;
function requireReactIs() {
  return hasRequiredReactIs || (hasRequiredReactIs = 1, process.env.NODE_ENV === "production" ? reactIs.exports = requireReactIs_production_min() : reactIs.exports = requireReactIs_development()), reactIs.exports;
}
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/
var objectAssign, hasRequiredObjectAssign;
function requireObjectAssign() {
  if (hasRequiredObjectAssign) return objectAssign;
  hasRequiredObjectAssign = 1;
  var Bi = Object.getOwnPropertySymbols, e = Object.prototype.hasOwnProperty, Ui = Object.prototype.propertyIsEnumerable;
  function Zi(na) {
    if (na == null)
      throw new TypeError("Object.assign cannot be called with null or undefined");
    return Object(na);
  }
  function ta() {
    try {
      if (!Object.assign)
        return !1;
      var na = new String("abc");
      if (na[5] = "de", Object.getOwnPropertyNames(na)[0] === "5")
        return !1;
      for (var ia = {}, aa = 0; aa < 10; aa++)
        ia["_" + String.fromCharCode(aa)] = aa;
      var da = Object.getOwnPropertyNames(ia).map(function(qa) {
        return ia[qa];
      });
      if (da.join("") !== "0123456789")
        return !1;
      var La = {};
      return "abcdefghijklmnopqrst".split("").forEach(function(qa) {
        La[qa] = qa;
      }), Object.keys(Object.assign({}, La)).join("") === "abcdefghijklmnopqrst";
    } catch {
      return !1;
    }
  }
  return objectAssign = ta() ? Object.assign : function(na, ia) {
    for (var aa, da = Zi(na), La, qa = 1; qa < arguments.length; qa++) {
      aa = Object(arguments[qa]);
      for (var io in aa)
        e.call(aa, io) && (da[io] = aa[io]);
      if (Bi) {
        La = Bi(aa);
        for (var ao = 0; ao < La.length; ao++)
          Ui.call(aa, La[ao]) && (da[La[ao]] = aa[La[ao]]);
      }
    }
    return da;
  }, objectAssign;
}
var ReactPropTypesSecret_1, hasRequiredReactPropTypesSecret;
function requireReactPropTypesSecret() {
  if (hasRequiredReactPropTypesSecret) return ReactPropTypesSecret_1;
  hasRequiredReactPropTypesSecret = 1;
  var Bi = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
  return ReactPropTypesSecret_1 = Bi, ReactPropTypesSecret_1;
}
var has, hasRequiredHas;
function requireHas() {
  return hasRequiredHas || (hasRequiredHas = 1, has = Function.call.bind(Object.prototype.hasOwnProperty)), has;
}
var checkPropTypes_1, hasRequiredCheckPropTypes;
function requireCheckPropTypes() {
  if (hasRequiredCheckPropTypes) return checkPropTypes_1;
  hasRequiredCheckPropTypes = 1;
  var Bi = function() {
  };
  if (process.env.NODE_ENV !== "production") {
    var e = /* @__PURE__ */ requireReactPropTypesSecret(), Ui = {}, Zi = /* @__PURE__ */ requireHas();
    Bi = function(na) {
      var ia = "Warning: " + na;
      typeof console < "u" && console.error(ia);
      try {
        throw new Error(ia);
      } catch {
      }
    };
  }
  function ta(na, ia, aa, da, La) {
    if (process.env.NODE_ENV !== "production") {
      for (var qa in na)
        if (Zi(na, qa)) {
          var io;
          try {
            if (typeof na[qa] != "function") {
              var ao = Error(
                (da || "React class") + ": " + aa + " type `" + qa + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof na[qa] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`."
              );
              throw ao.name = "Invariant Violation", ao;
            }
            io = na[qa](ia, qa, da, aa, null, e);
          } catch (no) {
            io = no;
          }
          if (io && !(io instanceof Error) && Bi(
            (da || "React class") + ": type specification of " + aa + " `" + qa + "` is invalid; the type checker function must return `null` or an `Error` but returned a " + typeof io + ". You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument)."
          ), io instanceof Error && !(io.message in Ui)) {
            Ui[io.message] = !0;
            var oo = La ? La() : "";
            Bi(
              "Failed " + aa + " type: " + io.message + (oo ?? "")
            );
          }
        }
    }
  }
  return ta.resetWarningCache = function() {
    process.env.NODE_ENV !== "production" && (Ui = {});
  }, checkPropTypes_1 = ta, checkPropTypes_1;
}
var factoryWithTypeCheckers, hasRequiredFactoryWithTypeCheckers;
function requireFactoryWithTypeCheckers() {
  if (hasRequiredFactoryWithTypeCheckers) return factoryWithTypeCheckers;
  hasRequiredFactoryWithTypeCheckers = 1;
  var Bi = requireReactIs(), e = requireObjectAssign(), Ui = /* @__PURE__ */ requireReactPropTypesSecret(), Zi = /* @__PURE__ */ requireHas(), ta = /* @__PURE__ */ requireCheckPropTypes(), na = function() {
  };
  process.env.NODE_ENV !== "production" && (na = function(aa) {
    var da = "Warning: " + aa;
    typeof console < "u" && console.error(da);
    try {
      throw new Error(da);
    } catch {
    }
  });
  function ia() {
    return null;
  }
  return factoryWithTypeCheckers = function(aa, da) {
    var La = typeof Symbol == "function" && Symbol.iterator, qa = "@@iterator";
    function io(Zl) {
      var tc = Zl && (La && Zl[La] || Zl[qa]);
      if (typeof tc == "function")
        return tc;
    }
    var ao = "<<anonymous>>", oo = {
      array: bs("array"),
      bigint: bs("bigint"),
      bool: bs("boolean"),
      func: bs("function"),
      number: bs("number"),
      object: bs("object"),
      string: bs("string"),
      symbol: bs("symbol"),
      any: Rs(),
      arrayOf: js,
      element: qs(),
      elementType: jo(),
      instanceOf: fs,
      node: Zs(),
      objectOf: co,
      oneOf: Ao,
      oneOfType: Co,
      shape: Cl,
      exact: Al
    };
    function no(Zl, tc) {
      return Zl === tc ? Zl !== 0 || 1 / Zl === 1 / tc : Zl !== Zl && tc !== tc;
    }
    function lo(Zl, tc) {
      this.message = Zl, this.data = tc && typeof tc == "object" ? tc : {}, this.stack = "";
    }
    lo.prototype = Error.prototype;
    function so(Zl) {
      if (process.env.NODE_ENV !== "production")
        var tc = {}, Nl = 0;
      function Tl(Il, Ul, Kl, Rl, uo, Is, Sl) {
        if (Rl = Rl || ao, Is = Is || Kl, Sl !== Ui) {
          if (da) {
            var wl = new Error(
              "Calling PropTypes validators directly is not supported by the `prop-types` package. Use `PropTypes.checkPropTypes()` to call them. Read more at http://fb.me/use-check-prop-types"
            );
            throw wl.name = "Invariant Violation", wl;
          } else if (process.env.NODE_ENV !== "production" && typeof console < "u") {
            var Pl = Rl + ":" + Kl;
            !tc[Pl] && // Avoid spamming the console because they are often not actionable except for lib authors
            Nl < 3 && (na(
              "You are manually calling a React.PropTypes validation function for the `" + Is + "` prop on `" + Rl + "`. This is deprecated and will throw in the standalone `prop-types` package. You may be seeing this warning due to a third-party PropTypes library. See https://fb.me/react-warning-dont-call-proptypes for details."
            ), tc[Pl] = !0, Nl++);
          }
        }
        return Ul[Kl] == null ? Il ? Ul[Kl] === null ? new lo("The " + uo + " `" + Is + "` is marked as required " + ("in `" + Rl + "`, but its value is `null`.")) : new lo("The " + uo + " `" + Is + "` is marked as required in " + ("`" + Rl + "`, but its value is `undefined`.")) : null : Zl(Ul, Kl, Rl, uo, Is);
      }
      var El = Tl.bind(null, !1);
      return El.isRequired = Tl.bind(null, !0), El;
    }
    function bs(Zl) {
      function tc(Nl, Tl, El, Il, Ul, Kl) {
        var Rl = Nl[Tl], uo = Ml(Rl);
        if (uo !== Zl) {
          var Is = Vl(Rl);
          return new lo(
            "Invalid " + Il + " `" + Ul + "` of type " + ("`" + Is + "` supplied to `" + El + "`, expected ") + ("`" + Zl + "`."),
            { expectedType: Zl }
          );
        }
        return null;
      }
      return so(tc);
    }
    function Rs() {
      return so(ia);
    }
    function js(Zl) {
      function tc(Nl, Tl, El, Il, Ul) {
        if (typeof Zl != "function")
          return new lo("Property `" + Ul + "` of component `" + El + "` has invalid PropType notation inside arrayOf.");
        var Kl = Nl[Tl];
        if (!Array.isArray(Kl)) {
          var Rl = Ml(Kl);
          return new lo("Invalid " + Il + " `" + Ul + "` of type " + ("`" + Rl + "` supplied to `" + El + "`, expected an array."));
        }
        for (var uo = 0; uo < Kl.length; uo++) {
          var Is = Zl(Kl, uo, El, Il, Ul + "[" + uo + "]", Ui);
          if (Is instanceof Error)
            return Is;
        }
        return null;
      }
      return so(tc);
    }
    function qs() {
      function Zl(tc, Nl, Tl, El, Il) {
        var Ul = tc[Nl];
        if (!aa(Ul)) {
          var Kl = Ml(Ul);
          return new lo("Invalid " + El + " `" + Il + "` of type " + ("`" + Kl + "` supplied to `" + Tl + "`, expected a single ReactElement."));
        }
        return null;
      }
      return so(Zl);
    }
    function jo() {
      function Zl(tc, Nl, Tl, El, Il) {
        var Ul = tc[Nl];
        if (!Bi.isValidElementType(Ul)) {
          var Kl = Ml(Ul);
          return new lo("Invalid " + El + " `" + Il + "` of type " + ("`" + Kl + "` supplied to `" + Tl + "`, expected a single ReactElement type."));
        }
        return null;
      }
      return so(Zl);
    }
    function fs(Zl) {
      function tc(Nl, Tl, El, Il, Ul) {
        if (!(Nl[Tl] instanceof Zl)) {
          var Kl = Zl.name || ao, Rl = Yl(Nl[Tl]);
          return new lo("Invalid " + Il + " `" + Ul + "` of type " + ("`" + Rl + "` supplied to `" + El + "`, expected ") + ("instance of `" + Kl + "`."));
        }
        return null;
      }
      return so(tc);
    }
    function Ao(Zl) {
      if (!Array.isArray(Zl))
        return process.env.NODE_ENV !== "production" && (arguments.length > 1 ? na(
          "Invalid arguments supplied to oneOf, expected an array, got " + arguments.length + " arguments. A common mistake is to write oneOf(x, y, z) instead of oneOf([x, y, z])."
        ) : na("Invalid argument supplied to oneOf, expected an array.")), ia;
      function tc(Nl, Tl, El, Il, Ul) {
        for (var Kl = Nl[Tl], Rl = 0; Rl < Zl.length; Rl++)
          if (no(Kl, Zl[Rl]))
            return null;
        var uo = JSON.stringify(Zl, function(Sl, wl) {
          var Pl = Vl(wl);
          return Pl === "symbol" ? String(wl) : wl;
        });
        return new lo("Invalid " + Il + " `" + Ul + "` of value `" + String(Kl) + "` " + ("supplied to `" + El + "`, expected one of " + uo + "."));
      }
      return so(tc);
    }
    function co(Zl) {
      function tc(Nl, Tl, El, Il, Ul) {
        if (typeof Zl != "function")
          return new lo("Property `" + Ul + "` of component `" + El + "` has invalid PropType notation inside objectOf.");
        var Kl = Nl[Tl], Rl = Ml(Kl);
        if (Rl !== "object")
          return new lo("Invalid " + Il + " `" + Ul + "` of type " + ("`" + Rl + "` supplied to `" + El + "`, expected an object."));
        for (var uo in Kl)
          if (Zi(Kl, uo)) {
            var Is = Zl(Kl, uo, El, Il, Ul + "." + uo, Ui);
            if (Is instanceof Error)
              return Is;
          }
        return null;
      }
      return so(tc);
    }
    function Co(Zl) {
      if (!Array.isArray(Zl))
        return process.env.NODE_ENV !== "production" && na("Invalid argument supplied to oneOfType, expected an instance of array."), ia;
      for (var tc = 0; tc < Zl.length; tc++) {
        var Nl = Zl[tc];
        if (typeof Nl != "function")
          return na(
            "Invalid argument supplied to oneOfType. Expected an array of check functions, but received " + Ll(Nl) + " at index " + tc + "."
          ), ia;
      }
      function Tl(El, Il, Ul, Kl, Rl) {
        for (var uo = [], Is = 0; Is < Zl.length; Is++) {
          var Sl = Zl[Is], wl = Sl(El, Il, Ul, Kl, Rl, Ui);
          if (wl == null)
            return null;
          wl.data && Zi(wl.data, "expectedType") && uo.push(wl.data.expectedType);
        }
        var Pl = uo.length > 0 ? ", expected one of type [" + uo.join(", ") + "]" : "";
        return new lo("Invalid " + Kl + " `" + Rl + "` supplied to " + ("`" + Ul + "`" + Pl + "."));
      }
      return so(Tl);
    }
    function Zs() {
      function Zl(tc, Nl, Tl, El, Il) {
        return Ol(tc[Nl]) ? null : new lo("Invalid " + El + " `" + Il + "` supplied to " + ("`" + Tl + "`, expected a ReactNode."));
      }
      return so(Zl);
    }
    function xl(Zl, tc, Nl, Tl, El) {
      return new lo(
        (Zl || "React class") + ": " + tc + " type `" + Nl + "." + Tl + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + El + "`."
      );
    }
    function Cl(Zl) {
      function tc(Nl, Tl, El, Il, Ul) {
        var Kl = Nl[Tl], Rl = Ml(Kl);
        if (Rl !== "object")
          return new lo("Invalid " + Il + " `" + Ul + "` of type `" + Rl + "` " + ("supplied to `" + El + "`, expected `object`."));
        for (var uo in Zl) {
          var Is = Zl[uo];
          if (typeof Is != "function")
            return xl(El, Il, Ul, uo, Vl(Is));
          var Sl = Is(Kl, uo, El, Il, Ul + "." + uo, Ui);
          if (Sl)
            return Sl;
        }
        return null;
      }
      return so(tc);
    }
    function Al(Zl) {
      function tc(Nl, Tl, El, Il, Ul) {
        var Kl = Nl[Tl], Rl = Ml(Kl);
        if (Rl !== "object")
          return new lo("Invalid " + Il + " `" + Ul + "` of type `" + Rl + "` " + ("supplied to `" + El + "`, expected `object`."));
        var uo = e({}, Nl[Tl], Zl);
        for (var Is in uo) {
          var Sl = Zl[Is];
          if (Zi(Zl, Is) && typeof Sl != "function")
            return xl(El, Il, Ul, Is, Vl(Sl));
          if (!Sl)
            return new lo(
              "Invalid " + Il + " `" + Ul + "` key `" + Is + "` supplied to `" + El + "`.\nBad object: " + JSON.stringify(Nl[Tl], null, "  ") + `
Valid keys: ` + JSON.stringify(Object.keys(Zl), null, "  ")
            );
          var wl = Sl(Kl, Is, El, Il, Ul + "." + Is, Ui);
          if (wl)
            return wl;
        }
        return null;
      }
      return so(tc);
    }
    function Ol(Zl) {
      switch (typeof Zl) {
        case "number":
        case "string":
        case "undefined":
          return !0;
        case "boolean":
          return !Zl;
        case "object":
          if (Array.isArray(Zl))
            return Zl.every(Ol);
          if (Zl === null || aa(Zl))
            return !0;
          var tc = io(Zl);
          if (tc) {
            var Nl = tc.call(Zl), Tl;
            if (tc !== Zl.entries) {
              for (; !(Tl = Nl.next()).done; )
                if (!Ol(Tl.value))
                  return !1;
            } else
              for (; !(Tl = Nl.next()).done; ) {
                var El = Tl.value;
                if (El && !Ol(El[1]))
                  return !1;
              }
          } else
            return !1;
          return !0;
        default:
          return !1;
      }
    }
    function Bl(Zl, tc) {
      return Zl === "symbol" ? !0 : tc ? tc["@@toStringTag"] === "Symbol" || typeof Symbol == "function" && tc instanceof Symbol : !1;
    }
    function Ml(Zl) {
      var tc = typeof Zl;
      return Array.isArray(Zl) ? "array" : Zl instanceof RegExp ? "object" : Bl(tc, Zl) ? "symbol" : tc;
    }
    function Vl(Zl) {
      if (typeof Zl > "u" || Zl === null)
        return "" + Zl;
      var tc = Ml(Zl);
      if (tc === "object") {
        if (Zl instanceof Date)
          return "date";
        if (Zl instanceof RegExp)
          return "regexp";
      }
      return tc;
    }
    function Ll(Zl) {
      var tc = Vl(Zl);
      switch (tc) {
        case "array":
        case "object":
          return "an " + tc;
        case "boolean":
        case "date":
        case "regexp":
          return "a " + tc;
        default:
          return tc;
      }
    }
    function Yl(Zl) {
      return !Zl.constructor || !Zl.constructor.name ? ao : Zl.constructor.name;
    }
    return oo.checkPropTypes = ta, oo.resetWarningCache = ta.resetWarningCache, oo.PropTypes = oo, oo;
  }, factoryWithTypeCheckers;
}
var factoryWithThrowingShims, hasRequiredFactoryWithThrowingShims;
function requireFactoryWithThrowingShims() {
  if (hasRequiredFactoryWithThrowingShims) return factoryWithThrowingShims;
  hasRequiredFactoryWithThrowingShims = 1;
  var Bi = /* @__PURE__ */ requireReactPropTypesSecret();
  function e() {
  }
  function Ui() {
  }
  return Ui.resetWarningCache = e, factoryWithThrowingShims = function() {
    function Zi(ia, aa, da, La, qa, io) {
      if (io !== Bi) {
        var ao = new Error(
          "Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types"
        );
        throw ao.name = "Invariant Violation", ao;
      }
    }
    Zi.isRequired = Zi;
    function ta() {
      return Zi;
    }
    var na = {
      array: Zi,
      bigint: Zi,
      bool: Zi,
      func: Zi,
      number: Zi,
      object: Zi,
      string: Zi,
      symbol: Zi,
      any: Zi,
      arrayOf: ta,
      element: Zi,
      elementType: Zi,
      instanceOf: ta,
      node: Zi,
      objectOf: ta,
      oneOf: ta,
      oneOfType: ta,
      shape: ta,
      exact: ta,
      checkPropTypes: Ui,
      resetWarningCache: e
    };
    return na.PropTypes = na, na;
  }, factoryWithThrowingShims;
}
var hasRequiredPropTypes;
function requirePropTypes() {
  if (hasRequiredPropTypes) return propTypes.exports;
  if (hasRequiredPropTypes = 1, process.env.NODE_ENV !== "production") {
    var Bi = requireReactIs(), e = !0;
    propTypes.exports = /* @__PURE__ */ requireFactoryWithTypeCheckers()(Bi.isElement, e);
  } else
    propTypes.exports = /* @__PURE__ */ requireFactoryWithThrowingShims()();
  return propTypes.exports;
}
var propTypesExports = /* @__PURE__ */ requirePropTypes();
const PropTypes = /* @__PURE__ */ getDefaultExportFromCjs(propTypesExports);
function ownKeys$3(Bi, e) {
  var Ui = Object.keys(Bi);
  if (Object.getOwnPropertySymbols) {
    var Zi = Object.getOwnPropertySymbols(Bi);
    e && (Zi = Zi.filter(function(ta) {
      return Object.getOwnPropertyDescriptor(Bi, ta).enumerable;
    })), Ui.push.apply(Ui, Zi);
  }
  return Ui;
}
function _objectSpread2(Bi) {
  for (var e = 1; e < arguments.length; e++) {
    var Ui = arguments[e] != null ? arguments[e] : {};
    e % 2 ? ownKeys$3(Object(Ui), !0).forEach(function(Zi) {
      _defineProperty$7(Bi, Zi, Ui[Zi]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(Bi, Object.getOwnPropertyDescriptors(Ui)) : ownKeys$3(Object(Ui)).forEach(function(Zi) {
      Object.defineProperty(Bi, Zi, Object.getOwnPropertyDescriptor(Ui, Zi));
    });
  }
  return Bi;
}
function _typeof(Bi) {
  "@babel/helpers - typeof";
  return _typeof = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(e) {
    return typeof e;
  } : function(e) {
    return e && typeof Symbol == "function" && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
  }, _typeof(Bi);
}
function _defineProperty$7(Bi, e, Ui) {
  return e in Bi ? Object.defineProperty(Bi, e, {
    value: Ui,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : Bi[e] = Ui, Bi;
}
function _objectWithoutPropertiesLoose$2(Bi, e) {
  if (Bi == null) return {};
  var Ui = {}, Zi = Object.keys(Bi), ta, na;
  for (na = 0; na < Zi.length; na++)
    ta = Zi[na], !(e.indexOf(ta) >= 0) && (Ui[ta] = Bi[ta]);
  return Ui;
}
function _objectWithoutProperties$2(Bi, e) {
  if (Bi == null) return {};
  var Ui = _objectWithoutPropertiesLoose$2(Bi, e), Zi, ta;
  if (Object.getOwnPropertySymbols) {
    var na = Object.getOwnPropertySymbols(Bi);
    for (ta = 0; ta < na.length; ta++)
      Zi = na[ta], !(e.indexOf(Zi) >= 0) && Object.prototype.propertyIsEnumerable.call(Bi, Zi) && (Ui[Zi] = Bi[Zi]);
  }
  return Ui;
}
function _toConsumableArray$2(Bi) {
  return _arrayWithoutHoles$2(Bi) || _iterableToArray$2(Bi) || _unsupportedIterableToArray$3(Bi) || _nonIterableSpread$2();
}
function _arrayWithoutHoles$2(Bi) {
  if (Array.isArray(Bi)) return _arrayLikeToArray$3(Bi);
}
function _iterableToArray$2(Bi) {
  if (typeof Symbol < "u" && Bi[Symbol.iterator] != null || Bi["@@iterator"] != null) return Array.from(Bi);
}
function _unsupportedIterableToArray$3(Bi, e) {
  if (Bi) {
    if (typeof Bi == "string") return _arrayLikeToArray$3(Bi, e);
    var Ui = Object.prototype.toString.call(Bi).slice(8, -1);
    if (Ui === "Object" && Bi.constructor && (Ui = Bi.constructor.name), Ui === "Map" || Ui === "Set") return Array.from(Bi);
    if (Ui === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(Ui)) return _arrayLikeToArray$3(Bi, e);
  }
}
function _arrayLikeToArray$3(Bi, e) {
  (e == null || e > Bi.length) && (e = Bi.length);
  for (var Ui = 0, Zi = new Array(e); Ui < e; Ui++) Zi[Ui] = Bi[Ui];
  return Zi;
}
function _nonIterableSpread$2() {
  throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function classList(Bi) {
  var e, Ui = Bi.beat, Zi = Bi.fade, ta = Bi.beatFade, na = Bi.bounce, ia = Bi.shake, aa = Bi.flash, da = Bi.spin, La = Bi.spinPulse, qa = Bi.spinReverse, io = Bi.pulse, ao = Bi.fixedWidth, oo = Bi.inverse, no = Bi.border, lo = Bi.listItem, so = Bi.flip, bs = Bi.size, Rs = Bi.rotation, js = Bi.pull, qs = (e = {
    "fa-beat": Ui,
    "fa-fade": Zi,
    "fa-beat-fade": ta,
    "fa-bounce": na,
    "fa-shake": ia,
    "fa-flash": aa,
    "fa-spin": da,
    "fa-spin-reverse": qa,
    "fa-spin-pulse": La,
    "fa-pulse": io,
    "fa-fw": ao,
    "fa-inverse": oo,
    "fa-border": no,
    "fa-li": lo,
    "fa-flip-horizontal": so === "horizontal" || so === "both",
    "fa-flip-vertical": so === "vertical" || so === "both"
  }, _defineProperty$7(e, "fa-".concat(bs), typeof bs < "u" && bs !== null), _defineProperty$7(e, "fa-rotate-".concat(Rs), typeof Rs < "u" && Rs !== null && Rs !== 0), _defineProperty$7(e, "fa-pull-".concat(js), typeof js < "u" && js !== null), _defineProperty$7(e, "fa-swap-opacity", Bi.swapOpacity), e);
  return Object.keys(qs).map(function(jo) {
    return qs[jo] ? jo : null;
  }).filter(function(jo) {
    return jo;
  });
}
function _isNumerical(Bi) {
  return Bi = Bi - 0, Bi === Bi;
}
function camelize(Bi) {
  return _isNumerical(Bi) ? Bi : (Bi = Bi.replace(/[\-_\s]+(.)?/g, function(e, Ui) {
    return Ui ? Ui.toUpperCase() : "";
  }), Bi.substr(0, 1).toLowerCase() + Bi.substr(1));
}
var _excluded$1 = ["style"];
function capitalize(Bi) {
  return Bi.charAt(0).toUpperCase() + Bi.slice(1);
}
function styleToObject(Bi) {
  return Bi.split(";").map(function(e) {
    return e.trim();
  }).filter(function(e) {
    return e;
  }).reduce(function(e, Ui) {
    var Zi = Ui.indexOf(":"), ta = camelize(Ui.slice(0, Zi)), na = Ui.slice(Zi + 1).trim();
    return ta.startsWith("webkit") ? e[capitalize(ta)] = na : e[ta] = na, e;
  }, {});
}
function convert(Bi, e) {
  var Ui = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
  if (typeof e == "string")
    return e;
  var Zi = (e.children || []).map(function(da) {
    return convert(Bi, da);
  }), ta = Object.keys(e.attributes || {}).reduce(function(da, La) {
    var qa = e.attributes[La];
    switch (La) {
      case "class":
        da.attrs.className = qa, delete e.attributes.class;
        break;
      case "style":
        da.attrs.style = styleToObject(qa);
        break;
      default:
        La.indexOf("aria-") === 0 || La.indexOf("data-") === 0 ? da.attrs[La.toLowerCase()] = qa : da.attrs[camelize(La)] = qa;
    }
    return da;
  }, {
    attrs: {}
  }), na = Ui.style, ia = na === void 0 ? {} : na, aa = _objectWithoutProperties$2(Ui, _excluded$1);
  return ta.attrs.style = _objectSpread2(_objectSpread2({}, ta.attrs.style), ia), Bi.apply(void 0, [e.tag, _objectSpread2(_objectSpread2({}, ta.attrs), aa)].concat(_toConsumableArray$2(Zi)));
}
var PRODUCTION = !1;
try {
  PRODUCTION = process.env.NODE_ENV === "production";
} catch {
}
function log() {
  if (!PRODUCTION && console && typeof console.error == "function") {
    var Bi;
    (Bi = console).error.apply(Bi, arguments);
  }
}
function normalizeIconArgs(Bi) {
  if (Bi && _typeof(Bi) === "object" && Bi.prefix && Bi.iconName && Bi.icon)
    return Bi;
  if (parse$1$1.icon)
    return parse$1$1.icon(Bi);
  if (Bi === null)
    return null;
  if (Bi && _typeof(Bi) === "object" && Bi.prefix && Bi.iconName)
    return Bi;
  if (Array.isArray(Bi) && Bi.length === 2)
    return {
      prefix: Bi[0],
      iconName: Bi[1]
    };
  if (typeof Bi == "string")
    return {
      prefix: "fas",
      iconName: Bi
    };
}
function objectWithKey(Bi, e) {
  return Array.isArray(e) && e.length > 0 || !Array.isArray(e) && e ? _defineProperty$7({}, Bi, e) : {};
}
var _excluded$2 = ["forwardedRef"];
function FontAwesomeIcon(Bi) {
  var e = Bi.forwardedRef, Ui = _objectWithoutProperties$2(Bi, _excluded$2), Zi = Ui.icon, ta = Ui.mask, na = Ui.symbol, ia = Ui.className, aa = Ui.title, da = Ui.titleId, La = Ui.maskId, qa = normalizeIconArgs(Zi), io = objectWithKey("classes", [].concat(_toConsumableArray$2(classList(Ui)), _toConsumableArray$2(ia.split(" ")))), ao = objectWithKey("transform", typeof Ui.transform == "string" ? parse$1$1.transform(Ui.transform) : Ui.transform), oo = objectWithKey("mask", normalizeIconArgs(ta)), no = icon(qa, _objectSpread2(_objectSpread2(_objectSpread2(_objectSpread2({}, io), ao), oo), {}, {
    symbol: na,
    title: aa,
    titleId: da,
    maskId: La
  }));
  if (!no)
    return log("Could not find icon", qa), null;
  var lo = no.abstract, so = {
    ref: e
  };
  return Object.keys(Ui).forEach(function(bs) {
    FontAwesomeIcon.defaultProps.hasOwnProperty(bs) || (so[bs] = Ui[bs]);
  }), convertCurry(lo[0], so);
}
FontAwesomeIcon.displayName = "FontAwesomeIcon";
FontAwesomeIcon.propTypes = {
  beat: PropTypes.bool,
  border: PropTypes.bool,
  bounce: PropTypes.bool,
  className: PropTypes.string,
  fade: PropTypes.bool,
  flash: PropTypes.bool,
  mask: PropTypes.oneOfType([PropTypes.object, PropTypes.array, PropTypes.string]),
  maskId: PropTypes.string,
  fixedWidth: PropTypes.bool,
  inverse: PropTypes.bool,
  flip: PropTypes.oneOf(["horizontal", "vertical", "both"]),
  icon: PropTypes.oneOfType([PropTypes.object, PropTypes.array, PropTypes.string]),
  listItem: PropTypes.bool,
  pull: PropTypes.oneOf(["right", "left"]),
  pulse: PropTypes.bool,
  rotation: PropTypes.oneOf([0, 90, 180, 270]),
  shake: PropTypes.bool,
  size: PropTypes.oneOf(["2xs", "xs", "sm", "lg", "xl", "2xl", "1x", "2x", "3x", "4x", "5x", "6x", "7x", "8x", "9x", "10x"]),
  spin: PropTypes.bool,
  spinPulse: PropTypes.bool,
  spinReverse: PropTypes.bool,
  symbol: PropTypes.oneOfType([PropTypes.bool, PropTypes.string]),
  title: PropTypes.string,
  titleId: PropTypes.string,
  transform: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  swapOpacity: PropTypes.bool
};
FontAwesomeIcon.defaultProps = {
  border: !1,
  className: "",
  mask: null,
  maskId: null,
  fixedWidth: !1,
  inverse: !1,
  flip: null,
  icon: null,
  listItem: !1,
  pull: null,
  pulse: !1,
  rotation: null,
  size: null,
  spin: !1,
  beat: !1,
  fade: !1,
  beatFade: !1,
  bounce: !1,
  shake: !1,
  symbol: !1,
  title: "",
  titleId: null,
  transform: null,
  swapOpacity: !1
};
var convertCurry = convert.bind(null, a__default.createElement);
const copiedMessageStyles = cva(
  [
    "absolute",
    "p-1",
    "text-sm",
    "-translate-y-1/2",
    "top-1/2",
    "left-full",
    "text-neutral-800",
    "dark:text-neutral-100",
    "z-[9999]",
    "transition-opacity"
  ],
  {
    variants: {
      visible: {
        true: "opacity-100",
        false: "opacity-0"
      }
    }
  }
), CopiedMessage = (Bi) => /* @__PURE__ */ jsxRuntimeExports.jsx("p", { className: copiedMessageStyles({ visible: Bi.visible }), children: "Copied!" }), CopyButton = ({
  text: Bi,
  onCopy: e,
  element: Ui,
  copyElement: Zi,
  disabled: ta = !1,
  className: na = ""
}) => {
  const [ia, aa] = useState(!1);
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(
    "button",
    {
      disabled: ta,
      className: `${na} relative w-3 h-3`,
      onClick: () => {
        e?.(Bi), navigator.clipboard.writeText(Bi), aa(!0), setTimeout(() => aa(!1), 1500);
      },
      children: [
        Ui || /* @__PURE__ */ jsxRuntimeExports.jsx(
          FontAwesomeIcon,
          {
            className: "w-full h-full p-1 cursor-pointer place-items-center aspect-square",
            icon: faClipboard
          }
        ),
        /* @__PURE__ */ jsxRuntimeExports.jsx(CopiedMessage, { visible: ia, children: Zi || "Copied!" })
      ]
    }
  );
};
var extendStatics = function(Bi, e) {
  return extendStatics = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(Ui, Zi) {
    Ui.__proto__ = Zi;
  } || function(Ui, Zi) {
    for (var ta in Zi) Object.prototype.hasOwnProperty.call(Zi, ta) && (Ui[ta] = Zi[ta]);
  }, extendStatics(Bi, e);
};
function __extends(Bi, e) {
  if (typeof e != "function" && e !== null)
    throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
  extendStatics(Bi, e);
  function Ui() {
    this.constructor = Bi;
  }
  Bi.prototype = e === null ? Object.create(e) : (Ui.prototype = e.prototype, new Ui());
}
var __assign = function() {
  return __assign = Object.assign || function(e) {
    for (var Ui, Zi = 1, ta = arguments.length; Zi < ta; Zi++) {
      Ui = arguments[Zi];
      for (var na in Ui) Object.prototype.hasOwnProperty.call(Ui, na) && (e[na] = Ui[na]);
    }
    return e;
  }, __assign.apply(this, arguments);
};
function __rest$1(Bi, e) {
  var Ui = {};
  for (var Zi in Bi) Object.prototype.hasOwnProperty.call(Bi, Zi) && e.indexOf(Zi) < 0 && (Ui[Zi] = Bi[Zi]);
  if (Bi != null && typeof Object.getOwnPropertySymbols == "function")
    for (var ta = 0, Zi = Object.getOwnPropertySymbols(Bi); ta < Zi.length; ta++)
      e.indexOf(Zi[ta]) < 0 && Object.prototype.propertyIsEnumerable.call(Bi, Zi[ta]) && (Ui[Zi[ta]] = Bi[Zi[ta]]);
  return Ui;
}
function __values(Bi) {
  var e = typeof Symbol == "function" && Symbol.iterator, Ui = e && Bi[e], Zi = 0;
  if (Ui) return Ui.call(Bi);
  if (Bi && typeof Bi.length == "number") return {
    next: function() {
      return Bi && Zi >= Bi.length && (Bi = void 0), { value: Bi && Bi[Zi++], done: !Bi };
    }
  };
  throw new TypeError(e ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function __read(Bi, e) {
  var Ui = typeof Symbol == "function" && Bi[Symbol.iterator];
  if (!Ui) return Bi;
  var Zi = Ui.call(Bi), ta, na = [], ia;
  try {
    for (; (e === void 0 || e-- > 0) && !(ta = Zi.next()).done; ) na.push(ta.value);
  } catch (aa) {
    ia = { error: aa };
  } finally {
    try {
      ta && !ta.done && (Ui = Zi.return) && Ui.call(Zi);
    } finally {
      if (ia) throw ia.error;
    }
  }
  return na;
}
function __spreadArray(Bi, e, Ui) {
  if (Ui || arguments.length === 2) for (var Zi = 0, ta = e.length, na; Zi < ta; Zi++)
    (na || !(Zi in e)) && (na || (na = Array.prototype.slice.call(e, 0, Zi)), na[Zi] = e[Zi]);
  return Bi.concat(na || Array.prototype.slice.call(e));
}
typeof SuppressedError == "function" && SuppressedError;
var defaultEnvironment = "production", env = typeof process > "u" || process.env === void 0 ? defaultEnvironment : process.env.NODE_ENV || defaultEnvironment, createDefinition$1 = function(Bi) {
  return {
    isEnabled: function(e) {
      return Bi.some(function(Ui) {
        return !!e[Ui];
      });
    }
  };
}, featureDefinitions = {
  measureLayout: createDefinition$1(["layout", "layoutId", "drag"]),
  animation: createDefinition$1([
    "animate",
    "exit",
    "variants",
    "whileHover",
    "whileTap",
    "whileFocus",
    "whileDrag",
    "whileInView"
  ]),
  exit: createDefinition$1(["exit"]),
  drag: createDefinition$1(["drag", "dragControls"]),
  focus: createDefinition$1(["whileFocus"]),
  hover: createDefinition$1(["whileHover", "onHoverStart", "onHoverEnd"]),
  tap: createDefinition$1(["whileTap", "onTap", "onTapStart", "onTapCancel"]),
  pan: createDefinition$1([
    "onPan",
    "onPanStart",
    "onPanSessionStart",
    "onPanEnd"
  ]),
  inView: createDefinition$1([
    "whileInView",
    "onViewportEnter",
    "onViewportLeave"
  ])
};
function loadFeatures(Bi) {
  for (var e in Bi)
    Bi[e] !== null && (e === "projectionNodeConstructor" ? featureDefinitions.projectionNodeConstructor = Bi[e] : featureDefinitions[e].Component = Bi[e]);
}
var warning$1 = function() {
}, invariant$1 = function() {
};
process.env.NODE_ENV !== "production" && (warning$1 = function(Bi, e) {
  !Bi && typeof console < "u" && console.warn(e);
}, invariant$1 = function(Bi, e) {
  if (!Bi)
    throw new Error(e);
});
var LazyContext = createContext({ strict: !1 }), featureNames = Object.keys(featureDefinitions), numFeatures = featureNames.length;
function useFeatures(Bi, e, Ui) {
  var Zi = [], ta = useContext(LazyContext);
  if (!e)
    return null;
  env !== "production" && Ui && ta.strict && invariant$1(!1, "You have rendered a `motion` component within a `LazyMotion` component. This will break tree shaking. Import and render a `m` component instead.");
  for (var na = 0; na < numFeatures; na++) {
    var ia = featureNames[na], aa = featureDefinitions[ia], da = aa.isEnabled, La = aa.Component;
    da(Bi) && La && Zi.push(a$8.createElement(La, __assign({ key: ia }, Bi, { visualElement: e })));
  }
  return Zi;
}
var MotionConfigContext = createContext({
  transformPagePoint: function(Bi) {
    return Bi;
  },
  isStatic: !1,
  reducedMotion: "never"
}), MotionContext = createContext({});
function useVisualElementContext() {
  return useContext(MotionContext).visualElement;
}
var PresenceContext = createContext(null), isBrowser = typeof document < "u", useIsomorphicLayoutEffect$1 = isBrowser ? useLayoutEffect : useEffect, prefersReducedMotion = { current: null }, hasDetected = !1;
function initPrefersReducedMotion() {
  if (hasDetected = !0, !!isBrowser)
    if (window.matchMedia) {
      var Bi = window.matchMedia("(prefers-reduced-motion)"), e = function() {
        return prefersReducedMotion.current = Bi.matches;
      };
      Bi.addListener(e), e();
    } else
      prefersReducedMotion.current = !1;
}
function useReducedMotion() {
  !hasDetected && initPrefersReducedMotion();
  var Bi = __read(useState(prefersReducedMotion.current), 1), e = Bi[0];
  return e;
}
function useReducedMotionConfig() {
  var Bi = useReducedMotion(), e = useContext(MotionConfigContext).reducedMotion;
  return e === "never" ? !1 : e === "always" ? !0 : Bi;
}
function useVisualElement(Bi, e, Ui, Zi) {
  var ta = useContext(LazyContext), na = useVisualElementContext(), ia = useContext(PresenceContext), aa = useReducedMotionConfig(), da = useRef(void 0);
  Zi || (Zi = ta.renderer), !da.current && Zi && (da.current = Zi(Bi, {
    visualState: e,
    parent: na,
    props: Ui,
    presenceId: ia?.id,
    blockInitialAnimation: ia?.initial === !1,
    shouldReduceMotion: aa
  }));
  var La = da.current;
  return useIsomorphicLayoutEffect$1(function() {
    La?.syncRender();
  }), useEffect(function() {
    var qa;
    (qa = La?.animationState) === null || qa === void 0 || qa.animateChanges();
  }), useIsomorphicLayoutEffect$1(function() {
    return function() {
      return La?.notifyUnmount();
    };
  }, []), La;
}
function isRefObject(Bi) {
  return typeof Bi == "object" && Object.prototype.hasOwnProperty.call(Bi, "current");
}
function useMotionRef(Bi, e, Ui) {
  return useCallback(
    function(Zi) {
      var ta;
      Zi && ((ta = Bi.mount) === null || ta === void 0 || ta.call(Bi, Zi)), e && (Zi ? e.mount(Zi) : e.unmount()), Ui && (typeof Ui == "function" ? Ui(Zi) : isRefObject(Ui) && (Ui.current = Zi));
    },
    /**
     * Only pass a new ref callback to React if we've received a visual element
     * factory. Otherwise we'll be mounting/remounting every time externalRef
     * or other dependencies change.
     */
    [e]
  );
}
function isVariantLabels(Bi) {
  return Array.isArray(Bi);
}
function isVariantLabel(Bi) {
  return typeof Bi == "string" || isVariantLabels(Bi);
}
function getCurrent(Bi) {
  var e = {};
  return Bi.forEachValue(function(Ui, Zi) {
    return e[Zi] = Ui.get();
  }), e;
}
function getVelocity$1(Bi) {
  var e = {};
  return Bi.forEachValue(function(Ui, Zi) {
    return e[Zi] = Ui.getVelocity();
  }), e;
}
function resolveVariantFromProps(Bi, e, Ui, Zi, ta) {
  var na;
  return Zi === void 0 && (Zi = {}), ta === void 0 && (ta = {}), typeof e == "function" && (e = e(Ui ?? Bi.custom, Zi, ta)), typeof e == "string" && (e = (na = Bi.variants) === null || na === void 0 ? void 0 : na[e]), typeof e == "function" && (e = e(Ui ?? Bi.custom, Zi, ta)), e;
}
function resolveVariant(Bi, e, Ui) {
  var Zi = Bi.getProps();
  return resolveVariantFromProps(Zi, e, Ui ?? Zi.custom, getCurrent(Bi), getVelocity$1(Bi));
}
function checkIfControllingVariants(Bi) {
  var e;
  return typeof ((e = Bi.animate) === null || e === void 0 ? void 0 : e.start) == "function" || isVariantLabel(Bi.initial) || isVariantLabel(Bi.animate) || isVariantLabel(Bi.whileHover) || isVariantLabel(Bi.whileDrag) || isVariantLabel(Bi.whileTap) || isVariantLabel(Bi.whileFocus) || isVariantLabel(Bi.exit);
}
function checkIfVariantNode(Bi) {
  return !!(checkIfControllingVariants(Bi) || Bi.variants);
}
function getCurrentTreeVariants(Bi, e) {
  if (checkIfControllingVariants(Bi)) {
    var Ui = Bi.initial, Zi = Bi.animate;
    return {
      initial: Ui === !1 || isVariantLabel(Ui) ? Ui : void 0,
      animate: isVariantLabel(Zi) ? Zi : void 0
    };
  }
  return Bi.inherit !== !1 ? e : {};
}
function useCreateMotionContext(Bi) {
  var e = getCurrentTreeVariants(Bi, useContext(MotionContext)), Ui = e.initial, Zi = e.animate;
  return useMemo(function() {
    return { initial: Ui, animate: Zi };
  }, [variantLabelsAsDependency(Ui), variantLabelsAsDependency(Zi)]);
}
function variantLabelsAsDependency(Bi) {
  return Array.isArray(Bi) ? Bi.join(" ") : Bi;
}
function useConstant(Bi) {
  var e = useRef(null);
  return e.current === null && (e.current = Bi()), e.current;
}
var globalProjectionState = {
  /**
   * Global flag as to whether the tree has animated since the last time
   * we resized the window
   */
  hasAnimatedSinceResize: !0,
  /**
   * We set this to true once, on the first update. Any nodes added to the tree beyond that
   * update will be given a `data-projection-id` attribute.
   */
  hasEverUpdated: !1
}, id$1 = 1;
function useProjectionId() {
  return useConstant(function() {
    if (globalProjectionState.hasEverUpdated)
      return id$1++;
  });
}
var LayoutGroupContext = createContext({}), SwitchLayoutGroupContext = createContext({});
function useProjection(Bi, e, Ui, Zi) {
  var ta, na = e.layoutId, ia = e.layout, aa = e.drag, da = e.dragConstraints, La = e.layoutScroll, qa = useContext(SwitchLayoutGroupContext);
  !Zi || !Ui || Ui?.projection || (Ui.projection = new Zi(Bi, Ui.getLatestValues(), (ta = Ui.parent) === null || ta === void 0 ? void 0 : ta.projection), Ui.projection.setOptions({
    layoutId: na,
    layout: ia,
    alwaysMeasureLayout: !!aa || da && isRefObject(da),
    visualElement: Ui,
    scheduleRender: function() {
      return Ui.scheduleRender();
    },
    /**
     * TODO: Update options in an effect. This could be tricky as it'll be too late
     * to update by the time layout animations run.
     * We also need to fix this safeToRemove by linking it up to the one returned by usePresence,
     * ensuring it gets called if there's no potential layout animations.
     *
     */
    animationType: typeof ia == "string" ? ia : "both",
    initialPromotionConfig: qa,
    layoutScroll: La
  }));
}
var VisualElementHandler = (
  /** @class */
  function(Bi) {
    __extends(e, Bi);
    function e() {
      return Bi !== null && Bi.apply(this, arguments) || this;
    }
    return e.prototype.getSnapshotBeforeUpdate = function() {
      return this.updateProps(), null;
    }, e.prototype.componentDidUpdate = function() {
    }, e.prototype.updateProps = function() {
      var Ui = this.props, Zi = Ui.visualElement, ta = Ui.props;
      Zi && Zi.setProps(ta);
    }, e.prototype.render = function() {
      return this.props.children;
    }, e;
  }(a__default.Component)
);
function createMotionComponent(Bi) {
  var e = Bi.preloadedFeatures, Ui = Bi.createVisualElement, Zi = Bi.projectionNodeConstructor, ta = Bi.useRender, na = Bi.useVisualState, ia = Bi.Component;
  e && loadFeatures(e);
  function aa(da, La) {
    var qa = useLayoutId(da);
    da = __assign(__assign({}, da), { layoutId: qa });
    var io = useContext(MotionConfigContext), ao = null, oo = useCreateMotionContext(da), no = io.isStatic ? void 0 : useProjectionId(), lo = na(da, io.isStatic);
    return !io.isStatic && isBrowser && (oo.visualElement = useVisualElement(ia, lo, __assign(__assign({}, io), da), Ui), useProjection(no, da, oo.visualElement, Zi || featureDefinitions.projectionNodeConstructor), ao = useFeatures(da, oo.visualElement, e)), a$8.createElement(
      VisualElementHandler,
      { visualElement: oo.visualElement, props: __assign(__assign({}, io), da) },
      ao,
      a$8.createElement(MotionContext.Provider, { value: oo }, ta(ia, da, no, useMotionRef(lo, oo.visualElement, La), lo, io.isStatic, oo.visualElement))
    );
  }
  return forwardRef(aa);
}
function useLayoutId(Bi) {
  var e, Ui = Bi.layoutId, Zi = (e = useContext(LayoutGroupContext)) === null || e === void 0 ? void 0 : e.id;
  return Zi && Ui !== void 0 ? Zi + "-" + Ui : Ui;
}
function createMotionProxy(Bi) {
  function e(Zi, ta) {
    return ta === void 0 && (ta = {}), createMotionComponent(Bi(Zi, ta));
  }
  if (typeof Proxy > "u")
    return e;
  var Ui = /* @__PURE__ */ new Map();
  return new Proxy(e, {
    /**
     * Called when `motion` is referenced with a prop: `motion.div`, `motion.input` etc.
     * The prop name is passed through as `key` and we can use that to generate a `motion`
     * DOM component with that name.
     */
    get: function(Zi, ta) {
      return Ui.has(ta) || Ui.set(ta, e(ta)), Ui.get(ta);
    }
  });
}
var lowercaseSVGElements = [
  "animate",
  "circle",
  "defs",
  "desc",
  "ellipse",
  "g",
  "image",
  "line",
  "filter",
  "marker",
  "mask",
  "metadata",
  "path",
  "pattern",
  "polygon",
  "polyline",
  "rect",
  "stop",
  "svg",
  "switch",
  "symbol",
  "text",
  "tspan",
  "use",
  "view"
];
function isSVGComponent(Bi) {
  return (
    /**
     * If it's not a string, it's a custom React component. Currently we only support
     * HTML custom React components.
     */
    typeof Bi != "string" || /**
     * If it contains a dash, the element is a custom HTML webcomponent.
     */
    Bi.includes("-") ? !1 : (
      /**
       * If it's in our list of lowercase SVG tags, it's an SVG component
       */
      !!(lowercaseSVGElements.indexOf(Bi) > -1 || /**
       * If it contains a capital letter, it's an SVG component
       */
      /[A-Z]/.test(Bi))
    )
  );
}
var scaleCorrectors = {};
function addScaleCorrector(Bi) {
  Object.assign(scaleCorrectors, Bi);
}
var transformAxes = ["", "X", "Y", "Z"], order = ["translate", "scale", "rotate", "skew"], transformProps = ["transformPerspective", "x", "y", "z"];
order.forEach(function(Bi) {
  return transformAxes.forEach(function(e) {
    return transformProps.push(Bi + e);
  });
});
function sortTransformProps(Bi, e) {
  return transformProps.indexOf(Bi) - transformProps.indexOf(e);
}
var transformPropSet = new Set(transformProps);
function isTransformProp(Bi) {
  return transformPropSet.has(Bi);
}
var transformOriginProps = /* @__PURE__ */ new Set(["originX", "originY", "originZ"]);
function isTransformOriginProp(Bi) {
  return transformOriginProps.has(Bi);
}
function isForcedMotionValue(Bi, e) {
  var Ui = e.layout, Zi = e.layoutId;
  return isTransformProp(Bi) || isTransformOriginProp(Bi) || (Ui || Zi !== void 0) && (!!scaleCorrectors[Bi] || Bi === "opacity");
}
var isMotionValue = function(Bi) {
  return !!(Bi !== null && typeof Bi == "object" && Bi.getVelocity);
}, translateAlias = {
  x: "translateX",
  y: "translateY",
  z: "translateZ",
  transformPerspective: "perspective"
};
function buildTransform(Bi, e, Ui, Zi) {
  var ta = Bi.transform, na = Bi.transformKeys, ia = e.enableHardwareAcceleration, aa = ia === void 0 ? !0 : ia, da = e.allowTransformNone, La = da === void 0 ? !0 : da, qa = "";
  na.sort(sortTransformProps);
  for (var io = !1, ao = na.length, oo = 0; oo < ao; oo++) {
    var no = na[oo];
    qa += "".concat(translateAlias[no] || no, "(").concat(ta[no], ") "), no === "z" && (io = !0);
  }
  return !io && aa ? qa += "translateZ(0)" : qa = qa.trim(), Zi ? qa = Zi(ta, Ui ? "" : qa) : La && Ui && (qa = "none"), qa;
}
function buildTransformOrigin(Bi) {
  var e = Bi.originX, Ui = e === void 0 ? "50%" : e, Zi = Bi.originY, ta = Zi === void 0 ? "50%" : Zi, na = Bi.originZ, ia = na === void 0 ? 0 : na;
  return "".concat(Ui, " ").concat(ta, " ").concat(ia);
}
function isCSSVariable$1(Bi) {
  return Bi.startsWith("--");
}
var getValueAsType = function(Bi, e) {
  return e && typeof Bi == "number" ? e.transform(Bi) : Bi;
};
const clamp$1 = (Bi, e) => (Ui) => Math.max(Math.min(Ui, e), Bi), sanitize = (Bi) => Bi % 1 ? Number(Bi.toFixed(5)) : Bi, floatRegex = /(-)?([\d]*\.?[\d])+/g, colorRegex = /(#[0-9a-f]{6}|#[0-9a-f]{3}|#(?:[0-9a-f]{2}){2,4}|(rgb|hsl)a?\((-?[\d\.]+%?[,\s]+){2,3}\s*\/*\s*[\d\.]+%?\))/gi, singleColorRegex = /^(#[0-9a-f]{3}|#(?:[0-9a-f]{2}){2,4}|(rgb|hsl)a?\((-?[\d\.]+%?[,\s]+){2,3}\s*\/*\s*[\d\.]+%?\))$/i;
function isString$1(Bi) {
  return typeof Bi == "string";
}
const number = {
  test: (Bi) => typeof Bi == "number",
  parse: parseFloat,
  transform: (Bi) => Bi
}, alpha = Object.assign(Object.assign({}, number), { transform: clamp$1(0, 1) }), scale = Object.assign(Object.assign({}, number), { default: 1 }), createUnitType = (Bi) => ({
  test: (e) => isString$1(e) && e.endsWith(Bi) && e.split(" ").length === 1,
  parse: parseFloat,
  transform: (e) => `${e}${Bi}`
}), degrees = createUnitType("deg"), percent = createUnitType("%"), px = createUnitType("px"), vh = createUnitType("vh"), vw = createUnitType("vw"), progressPercentage = Object.assign(Object.assign({}, percent), { parse: (Bi) => percent.parse(Bi) / 100, transform: (Bi) => percent.transform(Bi * 100) }), isColorString = (Bi, e) => (Ui) => !!(isString$1(Ui) && singleColorRegex.test(Ui) && Ui.startsWith(Bi) || e && Object.prototype.hasOwnProperty.call(Ui, e)), splitColor = (Bi, e, Ui) => (Zi) => {
  if (!isString$1(Zi))
    return Zi;
  const [ta, na, ia, aa] = Zi.match(floatRegex);
  return {
    [Bi]: parseFloat(ta),
    [e]: parseFloat(na),
    [Ui]: parseFloat(ia),
    alpha: aa !== void 0 ? parseFloat(aa) : 1
  };
}, hsla = {
  test: isColorString("hsl", "hue"),
  parse: splitColor("hue", "saturation", "lightness"),
  transform: ({ hue: Bi, saturation: e, lightness: Ui, alpha: Zi = 1 }) => "hsla(" + Math.round(Bi) + ", " + percent.transform(sanitize(e)) + ", " + percent.transform(sanitize(Ui)) + ", " + sanitize(alpha.transform(Zi)) + ")"
}, clampRgbUnit = clamp$1(0, 255), rgbUnit = Object.assign(Object.assign({}, number), { transform: (Bi) => Math.round(clampRgbUnit(Bi)) }), rgba = {
  test: isColorString("rgb", "red"),
  parse: splitColor("red", "green", "blue"),
  transform: ({ red: Bi, green: e, blue: Ui, alpha: Zi = 1 }) => "rgba(" + rgbUnit.transform(Bi) + ", " + rgbUnit.transform(e) + ", " + rgbUnit.transform(Ui) + ", " + sanitize(alpha.transform(Zi)) + ")"
};
function parseHex(Bi) {
  let e = "", Ui = "", Zi = "", ta = "";
  return Bi.length > 5 ? (e = Bi.substr(1, 2), Ui = Bi.substr(3, 2), Zi = Bi.substr(5, 2), ta = Bi.substr(7, 2)) : (e = Bi.substr(1, 1), Ui = Bi.substr(2, 1), Zi = Bi.substr(3, 1), ta = Bi.substr(4, 1), e += e, Ui += Ui, Zi += Zi, ta += ta), {
    red: parseInt(e, 16),
    green: parseInt(Ui, 16),
    blue: parseInt(Zi, 16),
    alpha: ta ? parseInt(ta, 16) / 255 : 1
  };
}
const hex = {
  test: isColorString("#"),
  parse: parseHex,
  transform: rgba.transform
}, color = {
  test: (Bi) => rgba.test(Bi) || hex.test(Bi) || hsla.test(Bi),
  parse: (Bi) => rgba.test(Bi) ? rgba.parse(Bi) : hsla.test(Bi) ? hsla.parse(Bi) : hex.parse(Bi),
  transform: (Bi) => isString$1(Bi) ? Bi : Bi.hasOwnProperty("red") ? rgba.transform(Bi) : hsla.transform(Bi)
}, colorToken = "${c}", numberToken = "${n}";
function test(Bi) {
  var e, Ui, Zi, ta;
  return isNaN(Bi) && isString$1(Bi) && ((Ui = (e = Bi.match(floatRegex)) === null || e === void 0 ? void 0 : e.length) !== null && Ui !== void 0 ? Ui : 0) + ((ta = (Zi = Bi.match(colorRegex)) === null || Zi === void 0 ? void 0 : Zi.length) !== null && ta !== void 0 ? ta : 0) > 0;
}
function analyse$1(Bi) {
  typeof Bi == "number" && (Bi = `${Bi}`);
  const e = [];
  let Ui = 0;
  const Zi = Bi.match(colorRegex);
  Zi && (Ui = Zi.length, Bi = Bi.replace(colorRegex, colorToken), e.push(...Zi.map(color.parse)));
  const ta = Bi.match(floatRegex);
  return ta && (Bi = Bi.replace(floatRegex, numberToken), e.push(...ta.map(number.parse))), { values: e, numColors: Ui, tokenised: Bi };
}
function parse(Bi) {
  return analyse$1(Bi).values;
}
function createTransformer(Bi) {
  const { values: e, numColors: Ui, tokenised: Zi } = analyse$1(Bi), ta = e.length;
  return (na) => {
    let ia = Zi;
    for (let aa = 0; aa < ta; aa++)
      ia = ia.replace(aa < Ui ? colorToken : numberToken, aa < Ui ? color.transform(na[aa]) : sanitize(na[aa]));
    return ia;
  };
}
const convertNumbersToZero = (Bi) => typeof Bi == "number" ? 0 : Bi;
function getAnimatableNone$1(Bi) {
  const e = parse(Bi);
  return createTransformer(Bi)(e.map(convertNumbersToZero));
}
const complex = { test, parse, createTransformer, getAnimatableNone: getAnimatableNone$1 }, maxDefaults = /* @__PURE__ */ new Set(["brightness", "contrast", "saturate", "opacity"]);
function applyDefaultFilter(Bi) {
  let [e, Ui] = Bi.slice(0, -1).split("(");
  if (e === "drop-shadow")
    return Bi;
  const [Zi] = Ui.match(floatRegex) || [];
  if (!Zi)
    return Bi;
  const ta = Ui.replace(Zi, "");
  let na = maxDefaults.has(e) ? 1 : 0;
  return Zi !== Ui && (na *= 100), e + "(" + na + ta + ")";
}
const functionRegex = /([a-z-]*)\(.*?\)/g, filter = Object.assign(Object.assign({}, complex), { getAnimatableNone: (Bi) => {
  const e = Bi.match(functionRegex);
  return e ? e.map(applyDefaultFilter).join(" ") : Bi;
} });
var int = __assign(__assign({}, number), { transform: Math.round }), numberValueTypes = {
  // Border props
  borderWidth: px,
  borderTopWidth: px,
  borderRightWidth: px,
  borderBottomWidth: px,
  borderLeftWidth: px,
  borderRadius: px,
  radius: px,
  borderTopLeftRadius: px,
  borderTopRightRadius: px,
  borderBottomRightRadius: px,
  borderBottomLeftRadius: px,
  // Positioning props
  width: px,
  maxWidth: px,
  height: px,
  maxHeight: px,
  size: px,
  top: px,
  right: px,
  bottom: px,
  left: px,
  // Spacing props
  padding: px,
  paddingTop: px,
  paddingRight: px,
  paddingBottom: px,
  paddingLeft: px,
  margin: px,
  marginTop: px,
  marginRight: px,
  marginBottom: px,
  marginLeft: px,
  // Transform props
  rotate: degrees,
  rotateX: degrees,
  rotateY: degrees,
  rotateZ: degrees,
  scale,
  scaleX: scale,
  scaleY: scale,
  scaleZ: scale,
  skew: degrees,
  skewX: degrees,
  skewY: degrees,
  distance: px,
  translateX: px,
  translateY: px,
  translateZ: px,
  x: px,
  y: px,
  z: px,
  perspective: px,
  transformPerspective: px,
  opacity: alpha,
  originX: progressPercentage,
  originY: progressPercentage,
  originZ: px,
  // Misc
  zIndex: int,
  // SVG
  fillOpacity: alpha,
  strokeOpacity: alpha,
  numOctaves: int
};
function buildHTMLStyles(Bi, e, Ui, Zi) {
  var ta, na = Bi.style, ia = Bi.vars, aa = Bi.transform, da = Bi.transformKeys, La = Bi.transformOrigin;
  da.length = 0;
  var qa = !1, io = !1, ao = !0;
  for (var oo in e) {
    var no = e[oo];
    if (isCSSVariable$1(oo)) {
      ia[oo] = no;
      continue;
    }
    var lo = numberValueTypes[oo], so = getValueAsType(no, lo);
    if (isTransformProp(oo)) {
      if (qa = !0, aa[oo] = so, da.push(oo), !ao)
        continue;
      no !== ((ta = lo.default) !== null && ta !== void 0 ? ta : 0) && (ao = !1);
    } else isTransformOriginProp(oo) ? (La[oo] = so, io = !0) : na[oo] = so;
  }
  qa ? na.transform = buildTransform(Bi, Ui, ao, Zi) : Zi ? na.transform = Zi({}, "") : !e.transform && na.transform && (na.transform = "none"), io && (na.transformOrigin = buildTransformOrigin(La));
}
var createHtmlRenderState = function() {
  return {
    style: {},
    transform: {},
    transformKeys: [],
    transformOrigin: {},
    vars: {}
  };
};
function copyRawValuesOnly(Bi, e, Ui) {
  for (var Zi in e)
    !isMotionValue(e[Zi]) && !isForcedMotionValue(Zi, Ui) && (Bi[Zi] = e[Zi]);
}
function useInitialMotionValues(Bi, e, Ui) {
  var Zi = Bi.transformTemplate;
  return useMemo(function() {
    var ta = createHtmlRenderState();
    buildHTMLStyles(ta, e, { enableHardwareAcceleration: !Ui }, Zi);
    var na = ta.vars, ia = ta.style;
    return __assign(__assign({}, na), ia);
  }, [e]);
}
function useStyle(Bi, e, Ui) {
  var Zi = Bi.style || {}, ta = {};
  return copyRawValuesOnly(ta, Zi, Bi), Object.assign(ta, useInitialMotionValues(Bi, e, Ui)), Bi.transformValues && (ta = Bi.transformValues(ta)), ta;
}
function useHTMLProps(Bi, e, Ui) {
  var Zi = {}, ta = useStyle(Bi, e, Ui);
  return Bi.drag && Bi.dragListener !== !1 && (Zi.draggable = !1, ta.userSelect = ta.WebkitUserSelect = ta.WebkitTouchCallout = "none", ta.touchAction = Bi.drag === !0 ? "none" : "pan-".concat(Bi.drag === "x" ? "y" : "x")), Zi.style = ta, Zi;
}
var validMotionProps = /* @__PURE__ */ new Set([
  "initial",
  "animate",
  "exit",
  "style",
  "variants",
  "transition",
  "transformTemplate",
  "transformValues",
  "custom",
  "inherit",
  "layout",
  "layoutId",
  "layoutDependency",
  "onLayoutAnimationStart",
  "onLayoutAnimationComplete",
  "onLayoutMeasure",
  "onBeforeLayoutMeasure",
  "onAnimationStart",
  "onAnimationComplete",
  "onUpdate",
  "onDragStart",
  "onDrag",
  "onDragEnd",
  "onMeasureDragConstraints",
  "onDirectionLock",
  "onDragTransitionEnd",
  "drag",
  "dragControls",
  "dragListener",
  "dragConstraints",
  "dragDirectionLock",
  "dragSnapToOrigin",
  "_dragX",
  "_dragY",
  "dragElastic",
  "dragMomentum",
  "dragPropagation",
  "dragTransition",
  "whileDrag",
  "onPan",
  "onPanStart",
  "onPanEnd",
  "onPanSessionStart",
  "onTap",
  "onTapStart",
  "onTapCancel",
  "onHoverStart",
  "onHoverEnd",
  "whileFocus",
  "whileTap",
  "whileHover",
  "whileInView",
  "onViewportEnter",
  "onViewportLeave",
  "viewport",
  "layoutScroll"
]);
function isValidMotionProp(Bi) {
  return validMotionProps.has(Bi);
}
var shouldForward = function(Bi) {
  return !isValidMotionProp(Bi);
};
function loadExternalIsValidProp(Bi) {
  Bi && (shouldForward = function(e) {
    return e.startsWith("on") ? !isValidMotionProp(e) : Bi(e);
  });
}
try {
  loadExternalIsValidProp(require("@emotion/is-prop-valid").default);
} catch {
}
function filterProps(Bi, e, Ui) {
  var Zi = {};
  for (var ta in Bi)
    (shouldForward(ta) || Ui === !0 && isValidMotionProp(ta) || !e && !isValidMotionProp(ta) || // If trying to use native HTML drag events, forward drag listeners
    Bi.draggable && ta.startsWith("onDrag")) && (Zi[ta] = Bi[ta]);
  return Zi;
}
function calcOrigin$1(Bi, e, Ui) {
  return typeof Bi == "string" ? Bi : px.transform(e + Ui * Bi);
}
function calcSVGTransformOrigin(Bi, e, Ui) {
  var Zi = calcOrigin$1(e, Bi.x, Bi.width), ta = calcOrigin$1(Ui, Bi.y, Bi.height);
  return "".concat(Zi, " ").concat(ta);
}
var camelKeys = {
  offset: "strokeDashoffset",
  array: "strokeDasharray"
};
function buildSVGPath(Bi, e, Ui, Zi, ta) {
  Ui === void 0 && (Ui = 1), Zi === void 0 && (Zi = 0), Bi.pathLength = 1;
  var na = camelKeys;
  Bi[na.offset] = px.transform(-Zi);
  var ia = px.transform(e), aa = px.transform(Ui);
  Bi[na.array] = "".concat(ia, " ").concat(aa);
}
function buildSVGAttrs(Bi, e, Ui, Zi) {
  var ta = e.attrX, na = e.attrY, ia = e.originX, aa = e.originY, da = e.pathLength, La = e.pathSpacing, qa = La === void 0 ? 1 : La, io = e.pathOffset, ao = io === void 0 ? 0 : io, oo = __rest$1(e, ["attrX", "attrY", "originX", "originY", "pathLength", "pathSpacing", "pathOffset"]);
  buildHTMLStyles(Bi, oo, Ui, Zi), Bi.attrs = Bi.style, Bi.style = {};
  var no = Bi.attrs, lo = Bi.style, so = Bi.dimensions;
  no.transform && (so && (lo.transform = no.transform), delete no.transform), so && (ia !== void 0 || aa !== void 0 || lo.transform) && (lo.transformOrigin = calcSVGTransformOrigin(so, ia !== void 0 ? ia : 0.5, aa !== void 0 ? aa : 0.5)), ta !== void 0 && (no.x = ta), na !== void 0 && (no.y = na), da !== void 0 && buildSVGPath(no, da, qa, ao);
}
var createSvgRenderState = function() {
  return __assign(__assign({}, createHtmlRenderState()), { attrs: {} });
};
function useSVGProps(Bi, e) {
  var Ui = useMemo(function() {
    var ta = createSvgRenderState();
    return buildSVGAttrs(ta, e, { enableHardwareAcceleration: !1 }, Bi.transformTemplate), __assign(__assign({}, ta.attrs), { style: __assign({}, ta.style) });
  }, [e]);
  if (Bi.style) {
    var Zi = {};
    copyRawValuesOnly(Zi, Bi.style, Bi), Ui.style = __assign(__assign({}, Zi), Ui.style);
  }
  return Ui;
}
function createUseRender(Bi) {
  Bi === void 0 && (Bi = !1);
  var e = function(Ui, Zi, ta, na, ia, aa) {
    var da = ia.latestValues, La = isSVGComponent(Ui) ? useSVGProps : useHTMLProps, qa = La(Zi, da, aa), io = filterProps(Zi, typeof Ui == "string", Bi), ao = __assign(__assign(__assign({}, io), qa), { ref: na });
    return ta && (ao["data-projection-id"] = ta), createElement$1(Ui, ao);
  };
  return e;
}
var CAMEL_CASE_PATTERN = /([a-z])([A-Z])/g, REPLACE_TEMPLATE = "$1-$2", camelToDash = function(Bi) {
  return Bi.replace(CAMEL_CASE_PATTERN, REPLACE_TEMPLATE).toLowerCase();
};
function renderHTML(Bi, e, Ui, Zi) {
  var ta = e.style, na = e.vars;
  Object.assign(Bi.style, ta, Zi && Zi.getProjectionStyles(Ui));
  for (var ia in na)
    Bi.style.setProperty(ia, na[ia]);
}
var camelCaseAttributes = /* @__PURE__ */ new Set([
  "baseFrequency",
  "diffuseConstant",
  "kernelMatrix",
  "kernelUnitLength",
  "keySplines",
  "keyTimes",
  "limitingConeAngle",
  "markerHeight",
  "markerWidth",
  "numOctaves",
  "targetX",
  "targetY",
  "surfaceScale",
  "specularConstant",
  "specularExponent",
  "stdDeviation",
  "tableValues",
  "viewBox",
  "gradientTransform",
  "pathLength"
]);
function renderSVG(Bi, e, Ui, Zi) {
  renderHTML(Bi, e, void 0, Zi);
  for (var ta in e.attrs)
    Bi.setAttribute(camelCaseAttributes.has(ta) ? ta : camelToDash(ta), e.attrs[ta]);
}
function scrapeMotionValuesFromProps$1(Bi) {
  var e = Bi.style, Ui = {};
  for (var Zi in e)
    (isMotionValue(e[Zi]) || isForcedMotionValue(Zi, Bi)) && (Ui[Zi] = e[Zi]);
  return Ui;
}
function scrapeMotionValuesFromProps(Bi) {
  var e = scrapeMotionValuesFromProps$1(Bi);
  for (var Ui in Bi)
    if (isMotionValue(Bi[Ui])) {
      var Zi = Ui === "x" || Ui === "y" ? "attr" + Ui.toUpperCase() : Ui;
      e[Zi] = Bi[Ui];
    }
  return e;
}
function isAnimationControls(Bi) {
  return typeof Bi == "object" && typeof Bi.start == "function";
}
var isKeyframesTarget = function(Bi) {
  return Array.isArray(Bi);
}, isCustomValue = function(Bi) {
  return !!(Bi && typeof Bi == "object" && Bi.mix && Bi.toValue);
}, resolveFinalValueInKeyframes = function(Bi) {
  return isKeyframesTarget(Bi) ? Bi[Bi.length - 1] || 0 : Bi;
};
function resolveMotionValue(Bi) {
  var e = isMotionValue(Bi) ? Bi.get() : Bi;
  return isCustomValue(e) ? e.toValue() : e;
}
function makeState(Bi, e, Ui, Zi) {
  var ta = Bi.scrapeMotionValuesFromProps, na = Bi.createRenderState, ia = Bi.onMount, aa = {
    latestValues: makeLatestValues(e, Ui, Zi, ta),
    renderState: na()
  };
  return ia && (aa.mount = function(da) {
    return ia(e, da, aa);
  }), aa;
}
var makeUseVisualState = function(Bi) {
  return function(e, Ui) {
    var Zi = useContext(MotionContext), ta = useContext(PresenceContext);
    return Ui ? makeState(Bi, e, Zi, ta) : useConstant(function() {
      return makeState(Bi, e, Zi, ta);
    });
  };
};
function makeLatestValues(Bi, e, Ui, Zi) {
  var ta = {}, na = Ui?.initial === !1, ia = Zi(Bi);
  for (var aa in ia)
    ta[aa] = resolveMotionValue(ia[aa]);
  var da = Bi.initial, La = Bi.animate, qa = checkIfControllingVariants(Bi), io = checkIfVariantNode(Bi);
  e && io && !qa && Bi.inherit !== !1 && (da ?? (da = e.initial), La ?? (La = e.animate));
  var ao = na || da === !1, oo = ao ? La : da;
  if (oo && typeof oo != "boolean" && !isAnimationControls(oo)) {
    var no = Array.isArray(oo) ? oo : [oo];
    no.forEach(function(lo) {
      var so = resolveVariantFromProps(Bi, lo);
      if (so) {
        var bs = so.transitionEnd;
        so.transition;
        var Rs = __rest$1(so, ["transitionEnd", "transition"]);
        for (var js in Rs) {
          var qs = Rs[js];
          if (Array.isArray(qs)) {
            var jo = ao ? qs.length - 1 : 0;
            qs = qs[jo];
          }
          qs !== null && (ta[js] = qs);
        }
        for (var js in bs)
          ta[js] = bs[js];
      }
    });
  }
  return ta;
}
var svgMotionConfig = {
  useVisualState: makeUseVisualState({
    scrapeMotionValuesFromProps,
    createRenderState: createSvgRenderState,
    onMount: function(Bi, e, Ui) {
      var Zi = Ui.renderState, ta = Ui.latestValues;
      try {
        Zi.dimensions = typeof e.getBBox == "function" ? e.getBBox() : e.getBoundingClientRect();
      } catch {
        Zi.dimensions = {
          x: 0,
          y: 0,
          width: 0,
          height: 0
        };
      }
      buildSVGAttrs(Zi, ta, { enableHardwareAcceleration: !1 }, Bi.transformTemplate), renderSVG(e, Zi);
    }
  })
}, htmlMotionConfig = {
  useVisualState: makeUseVisualState({
    scrapeMotionValuesFromProps: scrapeMotionValuesFromProps$1,
    createRenderState: createHtmlRenderState
  })
};
function createDomMotionConfig(Bi, e, Ui, Zi, ta) {
  var na = e.forwardMotionProps, ia = na === void 0 ? !1 : na, aa = isSVGComponent(Bi) ? svgMotionConfig : htmlMotionConfig;
  return __assign(__assign({}, aa), { preloadedFeatures: Ui, useRender: createUseRender(ia), createVisualElement: Zi, projectionNodeConstructor: ta, Component: Bi });
}
var AnimationType;
(function(Bi) {
  Bi.Animate = "animate", Bi.Hover = "whileHover", Bi.Tap = "whileTap", Bi.Drag = "whileDrag", Bi.Focus = "whileFocus", Bi.InView = "whileInView", Bi.Exit = "exit";
})(AnimationType || (AnimationType = {}));
function addDomEvent(Bi, e, Ui, Zi) {
  return Zi === void 0 && (Zi = { passive: !0 }), Bi.addEventListener(e, Ui, Zi), function() {
    return Bi.removeEventListener(e, Ui);
  };
}
function useDomEvent(Bi, e, Ui, Zi) {
  useEffect(function() {
    var ta = Bi.current;
    if (Ui && ta)
      return addDomEvent(ta, e, Ui, Zi);
  }, [Bi, e, Ui, Zi]);
}
function useFocusGesture(Bi) {
  var e = Bi.whileFocus, Ui = Bi.visualElement, Zi = function() {
    var na;
    (na = Ui.animationState) === null || na === void 0 || na.setActive(AnimationType.Focus, !0);
  }, ta = function() {
    var na;
    (na = Ui.animationState) === null || na === void 0 || na.setActive(AnimationType.Focus, !1);
  };
  useDomEvent(Ui, "focus", e ? Zi : void 0), useDomEvent(Ui, "blur", e ? ta : void 0);
}
function isMouseEvent(Bi) {
  return typeof PointerEvent < "u" && Bi instanceof PointerEvent ? Bi.pointerType === "mouse" : Bi instanceof MouseEvent;
}
function isTouchEvent(Bi) {
  var e = !!Bi.touches;
  return e;
}
function filterPrimaryPointer(Bi) {
  return function(e) {
    var Ui = e instanceof MouseEvent, Zi = !Ui || Ui && e.button === 0;
    Zi && Bi(e);
  };
}
var defaultPagePoint = { pageX: 0, pageY: 0 };
function pointFromTouch(Bi, e) {
  e === void 0 && (e = "page");
  var Ui = Bi.touches[0] || Bi.changedTouches[0], Zi = Ui || defaultPagePoint;
  return {
    x: Zi[e + "X"],
    y: Zi[e + "Y"]
  };
}
function pointFromMouse(Bi, e) {
  return e === void 0 && (e = "page"), {
    x: Bi[e + "X"],
    y: Bi[e + "Y"]
  };
}
function extractEventInfo(Bi, e) {
  return e === void 0 && (e = "page"), {
    point: isTouchEvent(Bi) ? pointFromTouch(Bi, e) : pointFromMouse(Bi, e)
  };
}
var wrapHandler = function(Bi, e) {
  e === void 0 && (e = !1);
  var Ui = function(Zi) {
    return Bi(Zi, extractEventInfo(Zi));
  };
  return e ? filterPrimaryPointer(Ui) : Ui;
}, supportsPointerEvents = function() {
  return isBrowser && window.onpointerdown === null;
}, supportsTouchEvents = function() {
  return isBrowser && window.ontouchstart === null;
}, supportsMouseEvents = function() {
  return isBrowser && window.onmousedown === null;
}, mouseEventNames = {
  pointerdown: "mousedown",
  pointermove: "mousemove",
  pointerup: "mouseup",
  pointercancel: "mousecancel",
  pointerover: "mouseover",
  pointerout: "mouseout",
  pointerenter: "mouseenter",
  pointerleave: "mouseleave"
}, touchEventNames = {
  pointerdown: "touchstart",
  pointermove: "touchmove",
  pointerup: "touchend",
  pointercancel: "touchcancel"
};
function getPointerEventName(Bi) {
  return supportsPointerEvents() ? Bi : supportsTouchEvents() ? touchEventNames[Bi] : supportsMouseEvents() ? mouseEventNames[Bi] : Bi;
}
function addPointerEvent(Bi, e, Ui, Zi) {
  return addDomEvent(Bi, getPointerEventName(e), wrapHandler(Ui, e === "pointerdown"), Zi);
}
function usePointerEvent(Bi, e, Ui, Zi) {
  return useDomEvent(Bi, getPointerEventName(e), Ui && wrapHandler(Ui, e === "pointerdown"), Zi);
}
function createLock(Bi) {
  var e = null;
  return function() {
    var Ui = function() {
      e = null;
    };
    return e === null ? (e = Bi, Ui) : !1;
  };
}
var globalHorizontalLock = createLock("dragHorizontal"), globalVerticalLock = createLock("dragVertical");
function getGlobalLock(Bi) {
  var e = !1;
  if (Bi === "y")
    e = globalVerticalLock();
  else if (Bi === "x")
    e = globalHorizontalLock();
  else {
    var Ui = globalHorizontalLock(), Zi = globalVerticalLock();
    Ui && Zi ? e = function() {
      Ui(), Zi();
    } : (Ui && Ui(), Zi && Zi());
  }
  return e;
}
function isDragActive() {
  var Bi = getGlobalLock(!0);
  return Bi ? (Bi(), !1) : !0;
}
function createHoverEvent(Bi, e, Ui) {
  return function(Zi, ta) {
    var na;
    !isMouseEvent(Zi) || isDragActive() || ((na = Bi.animationState) === null || na === void 0 || na.setActive(AnimationType.Hover, e), Ui?.(Zi, ta));
  };
}
function useHoverGesture(Bi) {
  var e = Bi.onHoverStart, Ui = Bi.onHoverEnd, Zi = Bi.whileHover, ta = Bi.visualElement;
  usePointerEvent(ta, "pointerenter", e || Zi ? createHoverEvent(ta, !0, e) : void 0, { passive: !e }), usePointerEvent(ta, "pointerleave", Ui || Zi ? createHoverEvent(ta, !1, Ui) : void 0, { passive: !Ui });
}
var isNodeOrChild = function(Bi, e) {
  return e ? Bi === e ? !0 : isNodeOrChild(Bi, e.parentElement) : !1;
};
function useUnmountEffect(Bi) {
  return useEffect(function() {
    return function() {
      return Bi();
    };
  }, []);
}
function __rest(Bi, e) {
  var Ui = {};
  for (var Zi in Bi) Object.prototype.hasOwnProperty.call(Bi, Zi) && e.indexOf(Zi) < 0 && (Ui[Zi] = Bi[Zi]);
  if (Bi != null && typeof Object.getOwnPropertySymbols == "function")
    for (var ta = 0, Zi = Object.getOwnPropertySymbols(Bi); ta < Zi.length; ta++)
      e.indexOf(Zi[ta]) < 0 && Object.prototype.propertyIsEnumerable.call(Bi, Zi[ta]) && (Ui[Zi[ta]] = Bi[Zi[ta]]);
  return Ui;
}
function __awaiter(Bi, e, Ui, Zi) {
  function ta(na) {
    return na instanceof Ui ? na : new Ui(function(ia) {
      ia(na);
    });
  }
  return new (Ui || (Ui = Promise))(function(na, ia) {
    function aa(qa) {
      try {
        La(Zi.next(qa));
      } catch (io) {
        ia(io);
      }
    }
    function da(qa) {
      try {
        La(Zi.throw(qa));
      } catch (io) {
        ia(io);
      }
    }
    function La(qa) {
      qa.done ? na(qa.value) : ta(qa.value).then(aa, da);
    }
    La((Zi = Zi.apply(Bi, e || [])).next());
  });
}
typeof SuppressedError == "function" && SuppressedError;
const clamp = (Bi, e, Ui) => Math.min(Math.max(Ui, Bi), e), safeMin = 1e-3, minDuration = 0.01, maxDuration = 10, minDamping = 0.05, maxDamping = 1;
function findSpring({ duration: Bi = 800, bounce: e = 0.25, velocity: Ui = 0, mass: Zi = 1 }) {
  let ta, na;
  warning$1(Bi <= maxDuration * 1e3, "Spring duration must be 10 seconds or less");
  let ia = 1 - e;
  ia = clamp(minDamping, maxDamping, ia), Bi = clamp(minDuration, maxDuration, Bi / 1e3), ia < 1 ? (ta = (La) => {
    const qa = La * ia, io = qa * Bi, ao = qa - Ui, oo = calcAngularFreq(La, ia), no = Math.exp(-io);
    return safeMin - ao / oo * no;
  }, na = (La) => {
    const io = La * ia * Bi, ao = io * Ui + Ui, oo = Math.pow(ia, 2) * Math.pow(La, 2) * Bi, no = Math.exp(-io), lo = calcAngularFreq(Math.pow(La, 2), ia);
    return (-ta(La) + safeMin > 0 ? -1 : 1) * ((ao - oo) * no) / lo;
  }) : (ta = (La) => {
    const qa = Math.exp(-La * Bi), io = (La - Ui) * Bi + 1;
    return -safeMin + qa * io;
  }, na = (La) => {
    const qa = Math.exp(-La * Bi), io = (Ui - La) * (Bi * Bi);
    return qa * io;
  });
  const aa = 5 / Bi, da = approximateRoot(ta, na, aa);
  if (Bi = Bi * 1e3, isNaN(da))
    return {
      stiffness: 100,
      damping: 10,
      duration: Bi
    };
  {
    const La = Math.pow(da, 2) * Zi;
    return {
      stiffness: La,
      damping: ia * 2 * Math.sqrt(Zi * La),
      duration: Bi
    };
  }
}
const rootIterations = 12;
function approximateRoot(Bi, e, Ui) {
  let Zi = Ui;
  for (let ta = 1; ta < rootIterations; ta++)
    Zi = Zi - Bi(Zi) / e(Zi);
  return Zi;
}
function calcAngularFreq(Bi, e) {
  return Bi * Math.sqrt(1 - e * e);
}
const durationKeys = ["duration", "bounce"], physicsKeys = ["stiffness", "damping", "mass"];
function isSpringType(Bi, e) {
  return e.some((Ui) => Bi[Ui] !== void 0);
}
function getSpringOptions(Bi) {
  let e = Object.assign({ velocity: 0, stiffness: 100, damping: 10, mass: 1, isResolvedFromDuration: !1 }, Bi);
  if (!isSpringType(Bi, physicsKeys) && isSpringType(Bi, durationKeys)) {
    const Ui = findSpring(Bi);
    e = Object.assign(Object.assign(Object.assign({}, e), Ui), { velocity: 0, mass: 1 }), e.isResolvedFromDuration = !0;
  }
  return e;
}
function spring(Bi) {
  var { from: e = 0, to: Ui = 1, restSpeed: Zi = 2, restDelta: ta } = Bi, na = __rest(Bi, ["from", "to", "restSpeed", "restDelta"]);
  const ia = { done: !1, value: e };
  let { stiffness: aa, damping: da, mass: La, velocity: qa, duration: io, isResolvedFromDuration: ao } = getSpringOptions(na), oo = zero, no = zero;
  function lo() {
    const so = qa ? -(qa / 1e3) : 0, bs = Ui - e, Rs = da / (2 * Math.sqrt(aa * La)), js = Math.sqrt(aa / La) / 1e3;
    if (ta === void 0 && (ta = Math.min(Math.abs(Ui - e) / 100, 0.4)), Rs < 1) {
      const qs = calcAngularFreq(js, Rs);
      oo = (jo) => {
        const fs = Math.exp(-Rs * js * jo);
        return Ui - fs * ((so + Rs * js * bs) / qs * Math.sin(qs * jo) + bs * Math.cos(qs * jo));
      }, no = (jo) => {
        const fs = Math.exp(-Rs * js * jo);
        return Rs * js * fs * (Math.sin(qs * jo) * (so + Rs * js * bs) / qs + bs * Math.cos(qs * jo)) - fs * (Math.cos(qs * jo) * (so + Rs * js * bs) - qs * bs * Math.sin(qs * jo));
      };
    } else if (Rs === 1)
      oo = (qs) => Ui - Math.exp(-js * qs) * (bs + (so + js * bs) * qs);
    else {
      const qs = js * Math.sqrt(Rs * Rs - 1);
      oo = (jo) => {
        const fs = Math.exp(-Rs * js * jo), Ao = Math.min(qs * jo, 300);
        return Ui - fs * ((so + Rs * js * bs) * Math.sinh(Ao) + qs * bs * Math.cosh(Ao)) / qs;
      };
    }
  }
  return lo(), {
    next: (so) => {
      const bs = oo(so);
      if (ao)
        ia.done = so >= io;
      else {
        const Rs = no(so) * 1e3, js = Math.abs(Rs) <= Zi, qs = Math.abs(Ui - bs) <= ta;
        ia.done = js && qs;
      }
      return ia.value = ia.done ? Ui : bs, ia;
    },
    flipTarget: () => {
      qa = -qa, [e, Ui] = [Ui, e], lo();
    }
  };
}
spring.needsInterpolation = (Bi, e) => typeof Bi == "string" || typeof e == "string";
const zero = (Bi) => 0, progress = (Bi, e, Ui) => {
  const Zi = e - Bi;
  return Zi === 0 ? 1 : (Ui - Bi) / Zi;
}, mix = (Bi, e, Ui) => -Ui * Bi + Ui * e + Bi;
function hueToRgb(Bi, e, Ui) {
  return Ui < 0 && (Ui += 1), Ui > 1 && (Ui -= 1), Ui < 1 / 6 ? Bi + (e - Bi) * 6 * Ui : Ui < 1 / 2 ? e : Ui < 2 / 3 ? Bi + (e - Bi) * (2 / 3 - Ui) * 6 : Bi;
}
function hslaToRgba({ hue: Bi, saturation: e, lightness: Ui, alpha: Zi }) {
  Bi /= 360, e /= 100, Ui /= 100;
  let ta = 0, na = 0, ia = 0;
  if (!e)
    ta = na = ia = Ui;
  else {
    const aa = Ui < 0.5 ? Ui * (1 + e) : Ui + e - Ui * e, da = 2 * Ui - aa;
    ta = hueToRgb(da, aa, Bi + 1 / 3), na = hueToRgb(da, aa, Bi), ia = hueToRgb(da, aa, Bi - 1 / 3);
  }
  return {
    red: Math.round(ta * 255),
    green: Math.round(na * 255),
    blue: Math.round(ia * 255),
    alpha: Zi
  };
}
const mixLinearColor = (Bi, e, Ui) => {
  const Zi = Bi * Bi, ta = e * e;
  return Math.sqrt(Math.max(0, Ui * (ta - Zi) + Zi));
}, colorTypes = [hex, rgba, hsla], getColorType = (Bi) => colorTypes.find((e) => e.test(Bi)), notAnimatable = (Bi) => `'${Bi}' is not an animatable color. Use the equivalent color code instead.`, mixColor = (Bi, e) => {
  let Ui = getColorType(Bi), Zi = getColorType(e);
  invariant$1(!!Ui, notAnimatable(Bi)), invariant$1(!!Zi, notAnimatable(e));
  let ta = Ui.parse(Bi), na = Zi.parse(e);
  Ui === hsla && (ta = hslaToRgba(ta), Ui = rgba), Zi === hsla && (na = hslaToRgba(na), Zi = rgba);
  const ia = Object.assign({}, ta);
  return (aa) => {
    for (const da in ia)
      da !== "alpha" && (ia[da] = mixLinearColor(ta[da], na[da], aa));
    return ia.alpha = mix(ta.alpha, na.alpha, aa), Ui.transform(ia);
  };
}, isNum = (Bi) => typeof Bi == "number", combineFunctions = (Bi, e) => (Ui) => e(Bi(Ui)), pipe = (...Bi) => Bi.reduce(combineFunctions);
function getMixer(Bi, e) {
  return isNum(Bi) ? (Ui) => mix(Bi, e, Ui) : color.test(Bi) ? mixColor(Bi, e) : mixComplex(Bi, e);
}
const mixArray = (Bi, e) => {
  const Ui = [...Bi], Zi = Ui.length, ta = Bi.map((na, ia) => getMixer(na, e[ia]));
  return (na) => {
    for (let ia = 0; ia < Zi; ia++)
      Ui[ia] = ta[ia](na);
    return Ui;
  };
}, mixObject = (Bi, e) => {
  const Ui = Object.assign(Object.assign({}, Bi), e), Zi = {};
  for (const ta in Ui)
    Bi[ta] !== void 0 && e[ta] !== void 0 && (Zi[ta] = getMixer(Bi[ta], e[ta]));
  return (ta) => {
    for (const na in Zi)
      Ui[na] = Zi[na](ta);
    return Ui;
  };
};
function analyse(Bi) {
  const e = complex.parse(Bi), Ui = e.length;
  let Zi = 0, ta = 0, na = 0;
  for (let ia = 0; ia < Ui; ia++)
    Zi || typeof e[ia] == "number" ? Zi++ : e[ia].hue !== void 0 ? na++ : ta++;
  return { parsed: e, numNumbers: Zi, numRGB: ta, numHSL: na };
}
const mixComplex = (Bi, e) => {
  const Ui = complex.createTransformer(e), Zi = analyse(Bi), ta = analyse(e);
  return Zi.numHSL === ta.numHSL && Zi.numRGB === ta.numRGB && Zi.numNumbers >= ta.numNumbers ? pipe(mixArray(Zi.parsed, ta.parsed), Ui) : (warning$1(!0, `Complex values '${Bi}' and '${e}' too different to mix. Ensure all colors are of the same type, and that each contains the same quantity of number and color values. Falling back to instant transition.`), (ia) => `${ia > 0 ? e : Bi}`);
}, mixNumber = (Bi, e) => (Ui) => mix(Bi, e, Ui);
function detectMixerFactory(Bi) {
  if (typeof Bi == "number")
    return mixNumber;
  if (typeof Bi == "string")
    return color.test(Bi) ? mixColor : mixComplex;
  if (Array.isArray(Bi))
    return mixArray;
  if (typeof Bi == "object")
    return mixObject;
}
function createMixers(Bi, e, Ui) {
  const Zi = [], ta = Ui || detectMixerFactory(Bi[0]), na = Bi.length - 1;
  for (let ia = 0; ia < na; ia++) {
    let aa = ta(Bi[ia], Bi[ia + 1]);
    if (e) {
      const da = Array.isArray(e) ? e[ia] : e;
      aa = pipe(da, aa);
    }
    Zi.push(aa);
  }
  return Zi;
}
function fastInterpolate([Bi, e], [Ui]) {
  return (Zi) => Ui(progress(Bi, e, Zi));
}
function slowInterpolate(Bi, e) {
  const Ui = Bi.length, Zi = Ui - 1;
  return (ta) => {
    let na = 0, ia = !1;
    if (ta <= Bi[0] ? ia = !0 : ta >= Bi[Zi] && (na = Zi - 1, ia = !0), !ia) {
      let da = 1;
      for (; da < Ui && !(Bi[da] > ta || da === Zi); da++)
        ;
      na = da - 1;
    }
    const aa = progress(Bi[na], Bi[na + 1], ta);
    return e[na](aa);
  };
}
function interpolate(Bi, e, { clamp: Ui = !0, ease: Zi, mixer: ta } = {}) {
  const na = Bi.length;
  invariant$1(na === e.length, "Both input and output ranges must be the same length"), invariant$1(!Zi || !Array.isArray(Zi) || Zi.length === na - 1, "Array of easing functions must be of length `input.length - 1`, as it applies to the transitions **between** the defined values."), Bi[0] > Bi[na - 1] && (Bi = [].concat(Bi), e = [].concat(e), Bi.reverse(), e.reverse());
  const ia = createMixers(e, Zi, ta), aa = na === 2 ? fastInterpolate(Bi, ia) : slowInterpolate(Bi, ia);
  return Ui ? (da) => aa(clamp(Bi[0], Bi[na - 1], da)) : aa;
}
const reverseEasing = (Bi) => (e) => 1 - Bi(1 - e), mirrorEasing = (Bi) => (e) => e <= 0.5 ? Bi(2 * e) / 2 : (2 - Bi(2 * (1 - e))) / 2, createExpoIn = (Bi) => (e) => Math.pow(e, Bi), createBackIn = (Bi) => (e) => e * e * ((Bi + 1) * e - Bi), createAnticipate = (Bi) => {
  const e = createBackIn(Bi);
  return (Ui) => (Ui *= 2) < 1 ? 0.5 * e(Ui) : 0.5 * (2 - Math.pow(2, -10 * (Ui - 1)));
}, DEFAULT_OVERSHOOT_STRENGTH = 1.525, BOUNCE_FIRST_THRESHOLD = 4 / 11, BOUNCE_SECOND_THRESHOLD = 8 / 11, BOUNCE_THIRD_THRESHOLD = 9 / 10, linear = (Bi) => Bi, easeIn = createExpoIn(2), easeOut = reverseEasing(easeIn), easeInOut = mirrorEasing(easeIn), circIn = (Bi) => 1 - Math.sin(Math.acos(Bi)), circOut = reverseEasing(circIn), circInOut = mirrorEasing(circOut), backIn = createBackIn(DEFAULT_OVERSHOOT_STRENGTH), backOut = reverseEasing(backIn), backInOut = mirrorEasing(backIn), anticipate = createAnticipate(DEFAULT_OVERSHOOT_STRENGTH), ca$1 = 4356 / 361, cb = 35442 / 1805, cc = 16061 / 1805, bounceOut = (Bi) => {
  if (Bi === 1 || Bi === 0)
    return Bi;
  const e = Bi * Bi;
  return Bi < BOUNCE_FIRST_THRESHOLD ? 7.5625 * e : Bi < BOUNCE_SECOND_THRESHOLD ? 9.075 * e - 9.9 * Bi + 3.4 : Bi < BOUNCE_THIRD_THRESHOLD ? ca$1 * e - cb * Bi + cc : 10.8 * Bi * Bi - 20.52 * Bi + 10.72;
}, bounceIn = reverseEasing(bounceOut), bounceInOut = (Bi) => Bi < 0.5 ? 0.5 * (1 - bounceOut(1 - Bi * 2)) : 0.5 * bounceOut(Bi * 2 - 1) + 0.5;
function defaultEasing(Bi, e) {
  return Bi.map(() => e || easeInOut).splice(0, Bi.length - 1);
}
function defaultOffset(Bi) {
  const e = Bi.length;
  return Bi.map((Ui, Zi) => Zi !== 0 ? Zi / (e - 1) : 0);
}
function convertOffsetToTimes(Bi, e) {
  return Bi.map((Ui) => Ui * e);
}
function keyframes$1({ from: Bi = 0, to: e = 1, ease: Ui, offset: Zi, duration: ta = 300 }) {
  const na = { done: !1, value: Bi }, ia = Array.isArray(e) ? e : [Bi, e], aa = convertOffsetToTimes(Zi && Zi.length === ia.length ? Zi : defaultOffset(ia), ta);
  function da() {
    return interpolate(aa, ia, {
      ease: Array.isArray(Ui) ? Ui : defaultEasing(ia, Ui)
    });
  }
  let La = da();
  return {
    next: (qa) => (na.value = La(qa), na.done = qa >= ta, na),
    flipTarget: () => {
      ia.reverse(), La = da();
    }
  };
}
function decay({ velocity: Bi = 0, from: e = 0, power: Ui = 0.8, timeConstant: Zi = 350, restDelta: ta = 0.5, modifyTarget: na }) {
  const ia = { done: !1, value: e };
  let aa = Ui * Bi;
  const da = e + aa, La = na === void 0 ? da : na(da);
  return La !== da && (aa = La - e), {
    next: (qa) => {
      const io = -aa * Math.exp(-qa / Zi);
      return ia.done = !(io > ta || io < -ta), ia.value = ia.done ? La : La + io, ia;
    },
    flipTarget: () => {
    }
  };
}
const types = { keyframes: keyframes$1, spring, decay };
function detectAnimationFromOptions(Bi) {
  if (Array.isArray(Bi.to))
    return keyframes$1;
  if (types[Bi.type])
    return types[Bi.type];
  const e = new Set(Object.keys(Bi));
  return e.has("ease") || e.has("duration") && !e.has("dampingRatio") ? keyframes$1 : e.has("dampingRatio") || e.has("stiffness") || e.has("mass") || e.has("damping") || e.has("restSpeed") || e.has("restDelta") ? spring : keyframes$1;
}
const defaultTimestep = 1 / 60 * 1e3, getCurrentTime = typeof performance < "u" ? () => performance.now() : () => Date.now(), onNextFrame = typeof window < "u" ? (Bi) => window.requestAnimationFrame(Bi) : (Bi) => setTimeout(() => Bi(getCurrentTime()), defaultTimestep);
function createRenderStep(Bi) {
  let e = [], Ui = [], Zi = 0, ta = !1, na = !1;
  const ia = /* @__PURE__ */ new WeakSet(), aa = {
    schedule: (da, La = !1, qa = !1) => {
      const io = qa && ta, ao = io ? e : Ui;
      return La && ia.add(da), ao.indexOf(da) === -1 && (ao.push(da), io && ta && (Zi = e.length)), da;
    },
    cancel: (da) => {
      const La = Ui.indexOf(da);
      La !== -1 && Ui.splice(La, 1), ia.delete(da);
    },
    process: (da) => {
      if (ta) {
        na = !0;
        return;
      }
      if (ta = !0, [e, Ui] = [Ui, e], Ui.length = 0, Zi = e.length, Zi)
        for (let La = 0; La < Zi; La++) {
          const qa = e[La];
          qa(da), ia.has(qa) && (aa.schedule(qa), Bi());
        }
      ta = !1, na && (na = !1, aa.process(da));
    }
  };
  return aa;
}
const maxElapsed = 40;
let useDefaultElapsed = !0, runNextFrame = !1, isProcessing = !1;
const frame = {
  delta: 0,
  timestamp: 0
}, stepsOrder = [
  "read",
  "update",
  "preRender",
  "render",
  "postRender"
], steps = stepsOrder.reduce((Bi, e) => (Bi[e] = createRenderStep(() => runNextFrame = !0), Bi), {}), sync = stepsOrder.reduce((Bi, e) => {
  const Ui = steps[e];
  return Bi[e] = (Zi, ta = !1, na = !1) => (runNextFrame || startLoop(), Ui.schedule(Zi, ta, na)), Bi;
}, {}), cancelSync = stepsOrder.reduce((Bi, e) => (Bi[e] = steps[e].cancel, Bi), {}), flushSync = stepsOrder.reduce((Bi, e) => (Bi[e] = () => steps[e].process(frame), Bi), {}), processStep = (Bi) => steps[Bi].process(frame), processFrame = (Bi) => {
  runNextFrame = !1, frame.delta = useDefaultElapsed ? defaultTimestep : Math.max(Math.min(Bi - frame.timestamp, maxElapsed), 1), frame.timestamp = Bi, isProcessing = !0, stepsOrder.forEach(processStep), isProcessing = !1, runNextFrame && (useDefaultElapsed = !1, onNextFrame(processFrame));
}, startLoop = () => {
  runNextFrame = !0, useDefaultElapsed = !0, isProcessing || onNextFrame(processFrame);
}, getFrameData = () => frame;
function loopElapsed(Bi, e, Ui = 0) {
  return Bi - e - Ui;
}
function reverseElapsed(Bi, e, Ui = 0, Zi = !0) {
  return Zi ? loopElapsed(e + -Bi, e, Ui) : e - (Bi - e) + Ui;
}
function hasRepeatDelayElapsed(Bi, e, Ui, Zi) {
  return Zi ? Bi >= e + Ui : Bi <= -Ui;
}
const framesync = (Bi) => {
  const e = ({ delta: Ui }) => Bi(Ui);
  return {
    start: () => sync.update(e, !0),
    stop: () => cancelSync.update(e)
  };
};
function animate$1(Bi) {
  var e, Ui, { from: Zi, autoplay: ta = !0, driver: na = framesync, elapsed: ia = 0, repeat: aa = 0, repeatType: da = "loop", repeatDelay: La = 0, onPlay: qa, onStop: io, onComplete: ao, onRepeat: oo, onUpdate: no } = Bi, lo = __rest(Bi, ["from", "autoplay", "driver", "elapsed", "repeat", "repeatType", "repeatDelay", "onPlay", "onStop", "onComplete", "onRepeat", "onUpdate"]);
  let { to: so } = lo, bs, Rs = 0, js = lo.duration, qs, jo = !1, fs = !0, Ao;
  const co = detectAnimationFromOptions(lo);
  !((Ui = (e = co).needsInterpolation) === null || Ui === void 0) && Ui.call(e, Zi, so) && (Ao = interpolate([0, 100], [Zi, so], {
    clamp: !1
  }), Zi = 0, so = 100);
  const Co = co(Object.assign(Object.assign({}, lo), { from: Zi, to: so }));
  function Zs() {
    Rs++, da === "reverse" ? (fs = Rs % 2 === 0, ia = reverseElapsed(ia, js, La, fs)) : (ia = loopElapsed(ia, js, La), da === "mirror" && Co.flipTarget()), jo = !1, oo && oo();
  }
  function xl() {
    bs.stop(), ao && ao();
  }
  function Cl(Ol) {
    if (fs || (Ol = -Ol), ia += Ol, !jo) {
      const Bl = Co.next(Math.max(0, ia));
      qs = Bl.value, Ao && (qs = Ao(qs)), jo = fs ? Bl.done : ia <= 0;
    }
    no?.(qs), jo && (Rs === 0 && (js ?? (js = ia)), Rs < aa ? hasRepeatDelayElapsed(ia, js, La, fs) && Zs() : xl());
  }
  function Al() {
    qa?.(), bs = na(Cl), bs.start();
  }
  return ta && Al(), {
    stop: () => {
      io?.(), bs.stop();
    }
  };
}
function velocityPerSecond(Bi, e) {
  return e ? Bi * (1e3 / e) : 0;
}
function inertia({ from: Bi = 0, velocity: e = 0, min: Ui, max: Zi, power: ta = 0.8, timeConstant: na = 750, bounceStiffness: ia = 500, bounceDamping: aa = 10, restDelta: da = 1, modifyTarget: La, driver: qa, onUpdate: io, onComplete: ao, onStop: oo }) {
  let no;
  function lo(js) {
    return Ui !== void 0 && js < Ui || Zi !== void 0 && js > Zi;
  }
  function so(js) {
    return Ui === void 0 ? Zi : Zi === void 0 || Math.abs(Ui - js) < Math.abs(Zi - js) ? Ui : Zi;
  }
  function bs(js) {
    no?.stop(), no = animate$1(Object.assign(Object.assign({}, js), {
      driver: qa,
      onUpdate: (qs) => {
        var jo;
        io?.(qs), (jo = js.onUpdate) === null || jo === void 0 || jo.call(js, qs);
      },
      onComplete: ao,
      onStop: oo
    }));
  }
  function Rs(js) {
    bs(Object.assign({ type: "spring", stiffness: ia, damping: aa, restDelta: da }, js));
  }
  if (lo(Bi))
    Rs({ from: Bi, velocity: e, to: so(Bi) });
  else {
    let js = ta * e + Bi;
    typeof La < "u" && (js = La(js));
    const qs = so(js), jo = qs === Ui ? -1 : 1;
    let fs, Ao;
    const co = (Co) => {
      fs = Ao, Ao = Co, e = velocityPerSecond(Co - fs, getFrameData().delta), (jo === 1 && Co > qs || jo === -1 && Co < qs) && Rs({ from: Co, to: qs, velocity: e });
    };
    bs({
      type: "decay",
      from: Bi,
      velocity: e,
      timeConstant: na,
      power: ta,
      restDelta: da,
      modifyTarget: La,
      onUpdate: lo(js) ? co : void 0
    });
  }
  return {
    stop: () => no?.stop()
  };
}
const isPoint = (Bi) => Bi.hasOwnProperty("x") && Bi.hasOwnProperty("y"), isPoint3D = (Bi) => isPoint(Bi) && Bi.hasOwnProperty("z"), distance1D = (Bi, e) => Math.abs(Bi - e);
function distance(Bi, e) {
  if (isNum(Bi) && isNum(e))
    return distance1D(Bi, e);
  if (isPoint(Bi) && isPoint(e)) {
    const Ui = distance1D(Bi.x, e.x), Zi = distance1D(Bi.y, e.y), ta = isPoint3D(Bi) && isPoint3D(e) ? distance1D(Bi.z, e.z) : 0;
    return Math.sqrt(Math.pow(Ui, 2) + Math.pow(Zi, 2) + Math.pow(ta, 2));
  }
}
const a$7 = (Bi, e) => 1 - 3 * e + 3 * Bi, b$3 = (Bi, e) => 3 * e - 6 * Bi, c$6 = (Bi) => 3 * Bi, calcBezier = (Bi, e, Ui) => ((a$7(e, Ui) * Bi + b$3(e, Ui)) * Bi + c$6(e)) * Bi, getSlope = (Bi, e, Ui) => 3 * a$7(e, Ui) * Bi * Bi + 2 * b$3(e, Ui) * Bi + c$6(e), subdivisionPrecision = 1e-7, subdivisionMaxIterations = 10;
function binarySubdivide(Bi, e, Ui, Zi, ta) {
  let na, ia, aa = 0;
  do
    ia = e + (Ui - e) / 2, na = calcBezier(ia, Zi, ta) - Bi, na > 0 ? Ui = ia : e = ia;
  while (Math.abs(na) > subdivisionPrecision && ++aa < subdivisionMaxIterations);
  return ia;
}
const newtonIterations = 8, newtonMinSlope = 1e-3;
function newtonRaphsonIterate(Bi, e, Ui, Zi) {
  for (let ta = 0; ta < newtonIterations; ++ta) {
    const na = getSlope(e, Ui, Zi);
    if (na === 0)
      return e;
    const ia = calcBezier(e, Ui, Zi) - Bi;
    e -= ia / na;
  }
  return e;
}
const kSplineTableSize = 11, kSampleStepSize = 1 / (kSplineTableSize - 1);
function cubicBezier(Bi, e, Ui, Zi) {
  if (Bi === e && Ui === Zi)
    return linear;
  const ta = new Float32Array(kSplineTableSize);
  for (let ia = 0; ia < kSplineTableSize; ++ia)
    ta[ia] = calcBezier(ia * kSampleStepSize, Bi, Ui);
  function na(ia) {
    let aa = 0, da = 1;
    const La = kSplineTableSize - 1;
    for (; da !== La && ta[da] <= ia; ++da)
      aa += kSampleStepSize;
    --da;
    const qa = (ia - ta[da]) / (ta[da + 1] - ta[da]), io = aa + qa * kSampleStepSize, ao = getSlope(io, Bi, Ui);
    return ao >= newtonMinSlope ? newtonRaphsonIterate(ia, io, Bi, Ui) : ao === 0 ? io : binarySubdivide(ia, aa, aa + kSampleStepSize, Bi, Ui);
  }
  return (ia) => ia === 0 || ia === 1 ? ia : calcBezier(na(ia), e, Zi);
}
function useTapGesture(Bi) {
  var e = Bi.onTap, Ui = Bi.onTapStart, Zi = Bi.onTapCancel, ta = Bi.whileTap, na = Bi.visualElement, ia = e || Ui || Zi || ta, aa = useRef(!1), da = useRef(null), La = {
    passive: !(Ui || e || Zi || no)
  };
  function qa() {
    var lo;
    (lo = da.current) === null || lo === void 0 || lo.call(da), da.current = null;
  }
  function io() {
    var lo;
    return qa(), aa.current = !1, (lo = na.animationState) === null || lo === void 0 || lo.setActive(AnimationType.Tap, !1), !isDragActive();
  }
  function ao(lo, so) {
    io() && (isNodeOrChild(na.getInstance(), lo.target) ? e?.(lo, so) : Zi?.(lo, so));
  }
  function oo(lo, so) {
    io() && Zi?.(lo, so);
  }
  function no(lo, so) {
    var bs;
    qa(), !aa.current && (aa.current = !0, da.current = pipe(addPointerEvent(window, "pointerup", ao, La), addPointerEvent(window, "pointercancel", oo, La)), (bs = na.animationState) === null || bs === void 0 || bs.setActive(AnimationType.Tap, !0), Ui?.(lo, so));
  }
  usePointerEvent(na, "pointerdown", ia ? no : void 0, La), useUnmountEffect(qa);
}
var warned = /* @__PURE__ */ new Set();
function warnOnce(Bi, e, Ui) {
  Bi || warned.has(e) || (console.warn(e), warned.add(e));
}
var observerCallbacks = /* @__PURE__ */ new WeakMap(), observers = /* @__PURE__ */ new WeakMap(), fireObserverCallback = function(Bi) {
  var e;
  (e = observerCallbacks.get(Bi.target)) === null || e === void 0 || e(Bi);
}, fireAllObserverCallbacks = function(Bi) {
  Bi.forEach(fireObserverCallback);
};
function initIntersectionObserver(Bi) {
  var e = Bi.root, Ui = __rest$1(Bi, ["root"]), Zi = e || document;
  observers.has(Zi) || observers.set(Zi, {});
  var ta = observers.get(Zi), na = JSON.stringify(Ui);
  return ta[na] || (ta[na] = new IntersectionObserver(fireAllObserverCallbacks, __assign({ root: e }, Ui))), ta[na];
}
function observeIntersection(Bi, e, Ui) {
  var Zi = initIntersectionObserver(e);
  return observerCallbacks.set(Bi, Ui), Zi.observe(Bi), function() {
    observerCallbacks.delete(Bi), Zi.unobserve(Bi);
  };
}
function useViewport(Bi) {
  var e = Bi.visualElement, Ui = Bi.whileInView, Zi = Bi.onViewportEnter, ta = Bi.onViewportLeave, na = Bi.viewport, ia = na === void 0 ? {} : na, aa = useRef({
    hasEnteredView: !1,
    isInView: !1
  }), da = !!(Ui || Zi || ta);
  ia.once && aa.current.hasEnteredView && (da = !1);
  var La = typeof IntersectionObserver > "u" ? useMissingIntersectionObserver : useIntersectionObserver;
  La(da, aa.current, e, ia);
}
var thresholdNames = {
  some: 0,
  all: 1
};
function useIntersectionObserver(Bi, e, Ui, Zi) {
  var ta = Zi.root, na = Zi.margin, ia = Zi.amount, aa = ia === void 0 ? "some" : ia, da = Zi.once;
  useEffect(function() {
    if (Bi) {
      var La = {
        root: ta?.current,
        rootMargin: na,
        threshold: typeof aa == "number" ? aa : thresholdNames[aa]
      }, qa = function(io) {
        var ao, oo = io.isIntersecting;
        if (e.isInView !== oo && (e.isInView = oo, !(da && !oo && e.hasEnteredView))) {
          oo && (e.hasEnteredView = !0), (ao = Ui.animationState) === null || ao === void 0 || ao.setActive(AnimationType.InView, oo);
          var no = Ui.getProps(), lo = oo ? no.onViewportEnter : no.onViewportLeave;
          lo?.(io);
        }
      };
      return observeIntersection(Ui.getInstance(), La, qa);
    }
  }, [Bi, ta, na, aa]);
}
function useMissingIntersectionObserver(Bi, e, Ui, Zi) {
  var ta = Zi.fallback, na = ta === void 0 ? !0 : ta;
  useEffect(function() {
    !Bi || !na || (env !== "production" && warnOnce(!1, "IntersectionObserver not available on this device. whileInView animations will trigger on mount."), requestAnimationFrame(function() {
      var ia;
      e.hasEnteredView = !0;
      var aa = Ui.getProps().onViewportEnter;
      aa?.(null), (ia = Ui.animationState) === null || ia === void 0 || ia.setActive(AnimationType.InView, !0);
    }));
  }, [Bi]);
}
var makeRenderlessComponent = function(Bi) {
  return function(e) {
    return Bi(e), null;
  };
}, gestureAnimations = {
  inView: makeRenderlessComponent(useViewport),
  tap: makeRenderlessComponent(useTapGesture),
  focus: makeRenderlessComponent(useFocusGesture),
  hover: makeRenderlessComponent(useHoverGesture)
}, counter = 0, incrementId = function() {
  return counter++;
}, useId = function() {
  return useConstant(incrementId);
};
function usePresence() {
  var Bi = useContext(PresenceContext);
  if (Bi === null)
    return [!0, null];
  var e = Bi.isPresent, Ui = Bi.onExitComplete, Zi = Bi.register, ta = useId();
  useEffect(function() {
    return Zi(ta);
  }, []);
  var na = function() {
    return Ui?.(ta);
  };
  return !e && Ui ? [!1, na] : [!0];
}
function shallowCompare(Bi, e) {
  if (!Array.isArray(e))
    return !1;
  var Ui = e.length;
  if (Ui !== Bi.length)
    return !1;
  for (var Zi = 0; Zi < Ui; Zi++)
    if (e[Zi] !== Bi[Zi])
      return !1;
  return !0;
}
var secondsToMilliseconds = function(Bi) {
  return Bi * 1e3;
}, easingLookup = {
  linear,
  easeIn,
  easeInOut,
  easeOut,
  circIn,
  circInOut,
  circOut,
  backIn,
  backInOut,
  backOut,
  anticipate,
  bounceIn,
  bounceInOut,
  bounceOut
}, easingDefinitionToFunction = function(Bi) {
  if (Array.isArray(Bi)) {
    invariant$1(Bi.length === 4, "Cubic bezier arrays must contain four numerical values.");
    var e = __read(Bi, 4), Ui = e[0], Zi = e[1], ta = e[2], na = e[3];
    return cubicBezier(Ui, Zi, ta, na);
  } else if (typeof Bi == "string")
    return invariant$1(easingLookup[Bi] !== void 0, "Invalid easing type '".concat(Bi, "'")), easingLookup[Bi];
  return Bi;
}, isEasingArray = function(Bi) {
  return Array.isArray(Bi) && typeof Bi[0] != "number";
}, isAnimatable = function(Bi, e) {
  return Bi === "zIndex" ? !1 : !!(typeof e == "number" || Array.isArray(e) || typeof e == "string" && // It's animatable if we have a string
  complex.test(e) && // And it contains numbers and/or colors
  !e.startsWith("url("));
}, underDampedSpring = function() {
  return {
    type: "spring",
    stiffness: 500,
    damping: 25,
    restSpeed: 10
  };
}, criticallyDampedSpring = function(Bi) {
  return {
    type: "spring",
    stiffness: 550,
    damping: Bi === 0 ? 2 * Math.sqrt(550) : 30,
    restSpeed: 10
  };
}, linearTween = function() {
  return {
    type: "keyframes",
    ease: "linear",
    duration: 0.3
  };
}, keyframes = function(Bi) {
  return {
    type: "keyframes",
    duration: 0.8,
    values: Bi
  };
}, defaultTransitions = {
  x: underDampedSpring,
  y: underDampedSpring,
  z: underDampedSpring,
  rotate: underDampedSpring,
  rotateX: underDampedSpring,
  rotateY: underDampedSpring,
  rotateZ: underDampedSpring,
  scaleX: criticallyDampedSpring,
  scaleY: criticallyDampedSpring,
  scale: criticallyDampedSpring,
  opacity: linearTween,
  backgroundColor: linearTween,
  color: linearTween,
  default: criticallyDampedSpring
}, getDefaultTransition = function(Bi, e) {
  var Ui;
  return isKeyframesTarget(e) ? Ui = keyframes : Ui = defaultTransitions[Bi] || defaultTransitions.default, __assign({ to: e }, Ui(e));
}, defaultValueTypes = __assign(__assign({}, numberValueTypes), {
  // Color props
  color,
  backgroundColor: color,
  outlineColor: color,
  fill: color,
  stroke: color,
  // Border props
  borderColor: color,
  borderTopColor: color,
  borderRightColor: color,
  borderBottomColor: color,
  borderLeftColor: color,
  filter,
  WebkitFilter: filter
}), getDefaultValueType = function(Bi) {
  return defaultValueTypes[Bi];
};
function getAnimatableNone(Bi, e) {
  var Ui, Zi = getDefaultValueType(Bi);
  return Zi !== filter && (Zi = complex), (Ui = Zi.getAnimatableNone) === null || Ui === void 0 ? void 0 : Ui.call(Zi, e);
}
function isTransitionDefined(Bi) {
  Bi.when, Bi.delay, Bi.delayChildren, Bi.staggerChildren, Bi.staggerDirection, Bi.repeat, Bi.repeatType, Bi.repeatDelay, Bi.from;
  var e = __rest$1(Bi, ["when", "delay", "delayChildren", "staggerChildren", "staggerDirection", "repeat", "repeatType", "repeatDelay", "from"]);
  return !!Object.keys(e).length;
}
var legacyRepeatWarning = !1;
function convertTransitionToAnimationOptions(Bi) {
  var e = Bi.ease, Ui = Bi.times, Zi = Bi.yoyo, ta = Bi.flip, na = Bi.loop, ia = __rest$1(Bi, ["ease", "times", "yoyo", "flip", "loop"]), aa = __assign({}, ia);
  return Ui && (aa.offset = Ui), ia.duration && (aa.duration = secondsToMilliseconds(ia.duration)), ia.repeatDelay && (aa.repeatDelay = secondsToMilliseconds(ia.repeatDelay)), e && (aa.ease = isEasingArray(e) ? e.map(easingDefinitionToFunction) : easingDefinitionToFunction(e)), ia.type === "tween" && (aa.type = "keyframes"), (Zi || na || ta) && (warning$1(!legacyRepeatWarning, "yoyo, loop and flip have been removed from the API. Replace with repeat and repeatType options."), legacyRepeatWarning = !0, Zi ? aa.repeatType = "reverse" : na ? aa.repeatType = "loop" : ta && (aa.repeatType = "mirror"), aa.repeat = na || Zi || ta || ia.repeat), ia.type !== "spring" && (aa.type = "keyframes"), aa;
}
function getDelayFromTransition(Bi, e) {
  var Ui, Zi, ta = getValueTransition(Bi, e) || {};
  return (Zi = (Ui = ta.delay) !== null && Ui !== void 0 ? Ui : Bi.delay) !== null && Zi !== void 0 ? Zi : 0;
}
function hydrateKeyframes(Bi) {
  return Array.isArray(Bi.to) && Bi.to[0] === null && (Bi.to = __spreadArray([], __read(Bi.to), !1), Bi.to[0] = Bi.from), Bi;
}
function getPopmotionAnimationOptions(Bi, e, Ui) {
  var Zi;
  return Array.isArray(e.to) && ((Zi = Bi.duration) !== null && Zi !== void 0 || (Bi.duration = 0.8)), hydrateKeyframes(e), isTransitionDefined(Bi) || (Bi = __assign(__assign({}, Bi), getDefaultTransition(Ui, e.to))), __assign(__assign({}, e), convertTransitionToAnimationOptions(Bi));
}
function getAnimation(Bi, e, Ui, Zi, ta) {
  var na, ia = getValueTransition(Zi, Bi), aa = (na = ia.from) !== null && na !== void 0 ? na : e.get(), da = isAnimatable(Bi, Ui);
  aa === "none" && da && typeof Ui == "string" ? aa = getAnimatableNone(Bi, Ui) : isZero(aa) && typeof Ui == "string" ? aa = getZeroUnit(Ui) : !Array.isArray(Ui) && isZero(Ui) && typeof aa == "string" && (Ui = getZeroUnit(aa));
  var La = isAnimatable(Bi, aa);
  warning$1(La === da, "You are trying to animate ".concat(Bi, ' from "').concat(aa, '" to "').concat(Ui, '". ').concat(aa, " is not an animatable value - to enable this animation set ").concat(aa, " to a value animatable to ").concat(Ui, " via the `style` property."));
  function qa() {
    var ao = {
      from: aa,
      to: Ui,
      velocity: e.getVelocity(),
      onComplete: ta,
      onUpdate: function(oo) {
        return e.set(oo);
      }
    };
    return ia.type === "inertia" || ia.type === "decay" ? inertia(__assign(__assign({}, ao), ia)) : animate$1(__assign(__assign({}, getPopmotionAnimationOptions(ia, ao, Bi)), { onUpdate: function(oo) {
      var no;
      ao.onUpdate(oo), (no = ia.onUpdate) === null || no === void 0 || no.call(ia, oo);
    }, onComplete: function() {
      var oo;
      ao.onComplete(), (oo = ia.onComplete) === null || oo === void 0 || oo.call(ia);
    } }));
  }
  function io() {
    var ao, oo, no = resolveFinalValueInKeyframes(Ui);
    return e.set(no), ta(), (ao = ia?.onUpdate) === null || ao === void 0 || ao.call(ia, no), (oo = ia?.onComplete) === null || oo === void 0 || oo.call(ia), { stop: function() {
    } };
  }
  return !La || !da || ia.type === !1 ? io : qa;
}
function isZero(Bi) {
  return Bi === 0 || typeof Bi == "string" && parseFloat(Bi) === 0 && Bi.indexOf(" ") === -1;
}
function getZeroUnit(Bi) {
  return typeof Bi == "number" ? 0 : getAnimatableNone("", Bi);
}
function getValueTransition(Bi, e) {
  return Bi[e] || Bi.default || Bi;
}
function startAnimation(Bi, e, Ui, Zi) {
  return Zi === void 0 && (Zi = {}), e.start(function(ta) {
    var na, ia, aa = getAnimation(Bi, e, Ui, Zi, ta), da = getDelayFromTransition(Zi, Bi), La = function() {
      return ia = aa();
    };
    return da ? na = window.setTimeout(La, secondsToMilliseconds(da)) : La(), function() {
      clearTimeout(na), ia?.stop();
    };
  });
}
var isNumericalString = function(Bi) {
  return /^\-?\d*\.?\d+$/.test(Bi);
}, isZeroValueString = function(Bi) {
  return /^0[^.\s]+$/.test(Bi);
};
function addUniqueItem(Bi, e) {
  Bi.indexOf(e) === -1 && Bi.push(e);
}
function removeItem(Bi, e) {
  var Ui = Bi.indexOf(e);
  Ui > -1 && Bi.splice(Ui, 1);
}
var SubscriptionManager = (
  /** @class */
  function() {
    function Bi() {
      this.subscriptions = [];
    }
    return Bi.prototype.add = function(e) {
      var Ui = this;
      return addUniqueItem(this.subscriptions, e), function() {
        return removeItem(Ui.subscriptions, e);
      };
    }, Bi.prototype.notify = function(e, Ui, Zi) {
      var ta = this.subscriptions.length;
      if (ta)
        if (ta === 1)
          this.subscriptions[0](e, Ui, Zi);
        else
          for (var na = 0; na < ta; na++) {
            var ia = this.subscriptions[na];
            ia && ia(e, Ui, Zi);
          }
    }, Bi.prototype.getSize = function() {
      return this.subscriptions.length;
    }, Bi.prototype.clear = function() {
      this.subscriptions.length = 0;
    }, Bi;
  }()
), isFloat = function(Bi) {
  return !isNaN(parseFloat(Bi));
}, MotionValue = (
  /** @class */
  function() {
    function Bi(e) {
      var Ui = this;
      this.version = "6.5.1", this.timeDelta = 0, this.lastUpdated = 0, this.updateSubscribers = new SubscriptionManager(), this.velocityUpdateSubscribers = new SubscriptionManager(), this.renderSubscribers = new SubscriptionManager(), this.canTrackVelocity = !1, this.updateAndNotify = function(Zi, ta) {
        ta === void 0 && (ta = !0), Ui.prev = Ui.current, Ui.current = Zi;
        var na = getFrameData(), ia = na.delta, aa = na.timestamp;
        Ui.lastUpdated !== aa && (Ui.timeDelta = ia, Ui.lastUpdated = aa, sync.postRender(Ui.scheduleVelocityCheck)), Ui.prev !== Ui.current && Ui.updateSubscribers.notify(Ui.current), Ui.velocityUpdateSubscribers.getSize() && Ui.velocityUpdateSubscribers.notify(Ui.getVelocity()), ta && Ui.renderSubscribers.notify(Ui.current);
      }, this.scheduleVelocityCheck = function() {
        return sync.postRender(Ui.velocityCheck);
      }, this.velocityCheck = function(Zi) {
        var ta = Zi.timestamp;
        ta !== Ui.lastUpdated && (Ui.prev = Ui.current, Ui.velocityUpdateSubscribers.notify(Ui.getVelocity()));
      }, this.hasAnimated = !1, this.prev = this.current = e, this.canTrackVelocity = isFloat(this.current);
    }
    return Bi.prototype.onChange = function(e) {
      return this.updateSubscribers.add(e);
    }, Bi.prototype.clearListeners = function() {
      this.updateSubscribers.clear();
    }, Bi.prototype.onRenderRequest = function(e) {
      return e(this.get()), this.renderSubscribers.add(e);
    }, Bi.prototype.attach = function(e) {
      this.passiveEffect = e;
    }, Bi.prototype.set = function(e, Ui) {
      Ui === void 0 && (Ui = !0), !Ui || !this.passiveEffect ? this.updateAndNotify(e, Ui) : this.passiveEffect(e, this.updateAndNotify);
    }, Bi.prototype.get = function() {
      return this.current;
    }, Bi.prototype.getPrevious = function() {
      return this.prev;
    }, Bi.prototype.getVelocity = function() {
      return this.canTrackVelocity ? (
        // These casts could be avoided if parseFloat would be typed better
        velocityPerSecond(parseFloat(this.current) - parseFloat(this.prev), this.timeDelta)
      ) : 0;
    }, Bi.prototype.start = function(e) {
      var Ui = this;
      return this.stop(), new Promise(function(Zi) {
        Ui.hasAnimated = !0, Ui.stopAnimation = e(Zi);
      }).then(function() {
        return Ui.clearAnimation();
      });
    }, Bi.prototype.stop = function() {
      this.stopAnimation && this.stopAnimation(), this.clearAnimation();
    }, Bi.prototype.isAnimating = function() {
      return !!this.stopAnimation;
    }, Bi.prototype.clearAnimation = function() {
      this.stopAnimation = null;
    }, Bi.prototype.destroy = function() {
      this.updateSubscribers.clear(), this.renderSubscribers.clear(), this.stop();
    }, Bi;
  }()
);
function motionValue(Bi) {
  return new MotionValue(Bi);
}
var testValueType = function(Bi) {
  return function(e) {
    return e.test(Bi);
  };
}, auto = {
  test: function(Bi) {
    return Bi === "auto";
  },
  parse: function(Bi) {
    return Bi;
  }
}, dimensionValueTypes = [number, px, percent, degrees, vw, vh, auto], findDimensionValueType = function(Bi) {
  return dimensionValueTypes.find(testValueType(Bi));
}, valueTypes = __spreadArray(__spreadArray([], __read(dimensionValueTypes), !1), [color, complex], !1), findValueType = function(Bi) {
  return valueTypes.find(testValueType(Bi));
};
function setMotionValue(Bi, e, Ui) {
  Bi.hasValue(e) ? Bi.getValue(e).set(Ui) : Bi.addValue(e, motionValue(Ui));
}
function setTarget(Bi, e) {
  var Ui = resolveVariant(Bi, e), Zi = Ui ? Bi.makeTargetAnimatable(Ui, !1) : {}, ta = Zi.transitionEnd, na = ta === void 0 ? {} : ta;
  Zi.transition;
  var ia = __rest$1(Zi, ["transitionEnd", "transition"]);
  ia = __assign(__assign({}, ia), na);
  for (var aa in ia) {
    var da = resolveFinalValueInKeyframes(ia[aa]);
    setMotionValue(Bi, aa, da);
  }
}
function checkTargetForNewValues(Bi, e, Ui) {
  var Zi, ta, na, ia, aa = Object.keys(e).filter(function(oo) {
    return !Bi.hasValue(oo);
  }), da = aa.length;
  if (da)
    for (var La = 0; La < da; La++) {
      var qa = aa[La], io = e[qa], ao = null;
      Array.isArray(io) && (ao = io[0]), ao === null && (ao = (ta = (Zi = Ui[qa]) !== null && Zi !== void 0 ? Zi : Bi.readValue(qa)) !== null && ta !== void 0 ? ta : e[qa]), ao != null && (typeof ao == "string" && (isNumericalString(ao) || isZeroValueString(ao)) ? ao = parseFloat(ao) : !findValueType(ao) && complex.test(io) && (ao = getAnimatableNone(qa, io)), Bi.addValue(qa, motionValue(ao)), (na = (ia = Ui)[qa]) !== null && na !== void 0 || (ia[qa] = ao), Bi.setBaseTarget(qa, ao));
    }
}
function getOriginFromTransition(Bi, e) {
  if (e) {
    var Ui = e[Bi] || e.default || e;
    return Ui.from;
  }
}
function getOrigin(Bi, e, Ui) {
  var Zi, ta, na = {};
  for (var ia in Bi)
    na[ia] = (Zi = getOriginFromTransition(ia, e)) !== null && Zi !== void 0 ? Zi : (ta = Ui.getValue(ia)) === null || ta === void 0 ? void 0 : ta.get();
  return na;
}
function animateVisualElement(Bi, e, Ui) {
  Ui === void 0 && (Ui = {}), Bi.notifyAnimationStart(e);
  var Zi;
  if (Array.isArray(e)) {
    var ta = e.map(function(ia) {
      return animateVariant(Bi, ia, Ui);
    });
    Zi = Promise.all(ta);
  } else if (typeof e == "string")
    Zi = animateVariant(Bi, e, Ui);
  else {
    var na = typeof e == "function" ? resolveVariant(Bi, e, Ui.custom) : e;
    Zi = animateTarget(Bi, na, Ui);
  }
  return Zi.then(function() {
    return Bi.notifyAnimationComplete(e);
  });
}
function animateVariant(Bi, e, Ui) {
  var Zi;
  Ui === void 0 && (Ui = {});
  var ta = resolveVariant(Bi, e, Ui.custom), na = (ta || {}).transition, ia = na === void 0 ? Bi.getDefaultTransition() || {} : na;
  Ui.transitionOverride && (ia = Ui.transitionOverride);
  var aa = ta ? function() {
    return animateTarget(Bi, ta, Ui);
  } : function() {
    return Promise.resolve();
  }, da = !((Zi = Bi.variantChildren) === null || Zi === void 0) && Zi.size ? function(oo) {
    oo === void 0 && (oo = 0);
    var no = ia.delayChildren, lo = no === void 0 ? 0 : no, so = ia.staggerChildren, bs = ia.staggerDirection;
    return animateChildren(Bi, e, lo + oo, so, bs, Ui);
  } : function() {
    return Promise.resolve();
  }, La = ia.when;
  if (La) {
    var qa = __read(La === "beforeChildren" ? [aa, da] : [da, aa], 2), io = qa[0], ao = qa[1];
    return io().then(ao);
  } else
    return Promise.all([aa(), da(Ui.delay)]);
}
function animateTarget(Bi, e, Ui) {
  var Zi, ta = Ui === void 0 ? {} : Ui, na = ta.delay, ia = na === void 0 ? 0 : na, aa = ta.transitionOverride, da = ta.type, La = Bi.makeTargetAnimatable(e), qa = La.transition, io = qa === void 0 ? Bi.getDefaultTransition() : qa, ao = La.transitionEnd, oo = __rest$1(La, ["transition", "transitionEnd"]);
  aa && (io = aa);
  var no = [], lo = da && ((Zi = Bi.animationState) === null || Zi === void 0 ? void 0 : Zi.getState()[da]);
  for (var so in oo) {
    var bs = Bi.getValue(so), Rs = oo[so];
    if (!(!bs || Rs === void 0 || lo && shouldBlockAnimation(lo, so))) {
      var js = __assign({ delay: ia }, io);
      Bi.shouldReduceMotion && isTransformProp(so) && (js = __assign(__assign({}, js), { type: !1, delay: 0 }));
      var qs = startAnimation(so, bs, Rs, js);
      no.push(qs);
    }
  }
  return Promise.all(no).then(function() {
    ao && setTarget(Bi, ao);
  });
}
function animateChildren(Bi, e, Ui, Zi, ta, na) {
  Ui === void 0 && (Ui = 0), Zi === void 0 && (Zi = 0), ta === void 0 && (ta = 1);
  var ia = [], aa = (Bi.variantChildren.size - 1) * Zi, da = ta === 1 ? function(La) {
    return La === void 0 && (La = 0), La * Zi;
  } : function(La) {
    return La === void 0 && (La = 0), aa - La * Zi;
  };
  return Array.from(Bi.variantChildren).sort(sortByTreeOrder).forEach(function(La, qa) {
    ia.push(animateVariant(La, e, __assign(__assign({}, na), { delay: Ui + da(qa) })).then(function() {
      return La.notifyAnimationComplete(e);
    }));
  }), Promise.all(ia);
}
function sortByTreeOrder(Bi, e) {
  return Bi.sortNodePosition(e);
}
function shouldBlockAnimation(Bi, e) {
  var Ui = Bi.protectedKeys, Zi = Bi.needsAnimating, ta = Ui.hasOwnProperty(e) && Zi[e] !== !0;
  return Zi[e] = !1, ta;
}
var variantPriorityOrder = [
  AnimationType.Animate,
  AnimationType.InView,
  AnimationType.Focus,
  AnimationType.Hover,
  AnimationType.Tap,
  AnimationType.Drag,
  AnimationType.Exit
], reversePriorityOrder = __spreadArray([], __read(variantPriorityOrder), !1).reverse(), numAnimationTypes = variantPriorityOrder.length;
function animateList(Bi) {
  return function(e) {
    return Promise.all(e.map(function(Ui) {
      var Zi = Ui.animation, ta = Ui.options;
      return animateVisualElement(Bi, Zi, ta);
    }));
  };
}
function createAnimationState(Bi) {
  var e = animateList(Bi), Ui = createState(), Zi = {}, ta = !0, na = function(qa, io) {
    var ao = resolveVariant(Bi, io);
    if (ao) {
      ao.transition;
      var oo = ao.transitionEnd, no = __rest$1(ao, ["transition", "transitionEnd"]);
      qa = __assign(__assign(__assign({}, qa), no), oo);
    }
    return qa;
  };
  function ia(qa) {
    return Zi[qa] !== void 0;
  }
  function aa(qa) {
    e = qa(Bi);
  }
  function da(qa, io) {
    for (var ao, oo = Bi.getProps(), no = Bi.getVariantContext(!0) || {}, lo = [], so = /* @__PURE__ */ new Set(), bs = {}, Rs = 1 / 0, js = function(Ao) {
      var co = reversePriorityOrder[Ao], Co = Ui[co], Zs = (ao = oo[co]) !== null && ao !== void 0 ? ao : no[co], xl = isVariantLabel(Zs), Cl = co === io ? Co.isActive : null;
      Cl === !1 && (Rs = Ao);
      var Al = Zs === no[co] && Zs !== oo[co] && xl;
      if (Al && ta && Bi.manuallyAnimateOnMount && (Al = !1), Co.protectedKeys = __assign({}, bs), // If it isn't active and hasn't *just* been set as inactive
      !Co.isActive && Cl === null || // If we didn't and don't have any defined prop for this animation type
      !Zs && !Co.prevProp || // Or if the prop doesn't define an animation
      isAnimationControls(Zs) || typeof Zs == "boolean")
        return "continue";
      var Ol = checkVariantsDidChange(Co.prevProp, Zs), Bl = Ol || // If we're making this variant active, we want to always make it active
      co === io && Co.isActive && !Al && xl || // If we removed a higher-priority variant (i is in reverse order)
      Ao > Rs && xl, Ml = Array.isArray(Zs) ? Zs : [Zs], Vl = Ml.reduce(na, {});
      Cl === !1 && (Vl = {});
      var Ll = Co.prevResolvedValues, Yl = Ll === void 0 ? {} : Ll, Zl = __assign(__assign({}, Yl), Vl), tc = function(Il) {
        Bl = !0, so.delete(Il), Co.needsAnimating[Il] = !0;
      };
      for (var Nl in Zl) {
        var Tl = Vl[Nl], El = Yl[Nl];
        bs.hasOwnProperty(Nl) || (Tl !== El ? isKeyframesTarget(Tl) && isKeyframesTarget(El) ? !shallowCompare(Tl, El) || Ol ? tc(Nl) : Co.protectedKeys[Nl] = !0 : Tl !== void 0 ? tc(Nl) : so.add(Nl) : Tl !== void 0 && so.has(Nl) ? tc(Nl) : Co.protectedKeys[Nl] = !0);
      }
      Co.prevProp = Zs, Co.prevResolvedValues = Vl, Co.isActive && (bs = __assign(__assign({}, bs), Vl)), ta && Bi.blockInitialAnimation && (Bl = !1), Bl && !Al && lo.push.apply(lo, __spreadArray([], __read(Ml.map(function(Il) {
        return {
          animation: Il,
          options: __assign({ type: co }, qa)
        };
      })), !1));
    }, qs = 0; qs < numAnimationTypes; qs++)
      js(qs);
    if (Zi = __assign({}, bs), so.size) {
      var jo = {};
      so.forEach(function(Ao) {
        var co = Bi.getBaseTarget(Ao);
        co !== void 0 && (jo[Ao] = co);
      }), lo.push({ animation: jo });
    }
    var fs = !!lo.length;
    return ta && oo.initial === !1 && !Bi.manuallyAnimateOnMount && (fs = !1), ta = !1, fs ? e(lo) : Promise.resolve();
  }
  function La(qa, io, ao) {
    var oo;
    if (Ui[qa].isActive === io)
      return Promise.resolve();
    (oo = Bi.variantChildren) === null || oo === void 0 || oo.forEach(function(so) {
      var bs;
      return (bs = so.animationState) === null || bs === void 0 ? void 0 : bs.setActive(qa, io);
    }), Ui[qa].isActive = io;
    var no = da(ao, qa);
    for (var lo in Ui)
      Ui[lo].protectedKeys = {};
    return no;
  }
  return {
    isAnimated: ia,
    animateChanges: da,
    setActive: La,
    setAnimateFunction: aa,
    getState: function() {
      return Ui;
    }
  };
}
function checkVariantsDidChange(Bi, e) {
  return typeof e == "string" ? e !== Bi : isVariantLabels(e) ? !shallowCompare(e, Bi) : !1;
}
function createTypeState(Bi) {
  return Bi === void 0 && (Bi = !1), {
    isActive: Bi,
    protectedKeys: {},
    needsAnimating: {},
    prevResolvedValues: {}
  };
}
function createState() {
  var Bi;
  return Bi = {}, Bi[AnimationType.Animate] = createTypeState(!0), Bi[AnimationType.InView] = createTypeState(), Bi[AnimationType.Hover] = createTypeState(), Bi[AnimationType.Tap] = createTypeState(), Bi[AnimationType.Drag] = createTypeState(), Bi[AnimationType.Focus] = createTypeState(), Bi[AnimationType.Exit] = createTypeState(), Bi;
}
var animations = {
  animation: makeRenderlessComponent(function(Bi) {
    var e = Bi.visualElement, Ui = Bi.animate;
    e.animationState || (e.animationState = createAnimationState(e)), isAnimationControls(Ui) && useEffect(function() {
      return Ui.subscribe(e);
    }, [Ui]);
  }),
  exit: makeRenderlessComponent(function(Bi) {
    var e = Bi.custom, Ui = Bi.visualElement, Zi = __read(usePresence(), 2), ta = Zi[0], na = Zi[1], ia = useContext(PresenceContext);
    useEffect(function() {
      var aa, da;
      Ui.isPresent = ta;
      var La = (aa = Ui.animationState) === null || aa === void 0 ? void 0 : aa.setActive(AnimationType.Exit, !ta, { custom: (da = ia?.custom) !== null && da !== void 0 ? da : e });
      !ta && La?.then(na);
    }, [ta]);
  })
}, PanSession = (
  /** @class */
  function() {
    function Bi(e, Ui, Zi) {
      var ta = this, na = Zi === void 0 ? {} : Zi, ia = na.transformPagePoint;
      if (this.startEvent = null, this.lastMoveEvent = null, this.lastMoveEventInfo = null, this.handlers = {}, this.updatePoint = function() {
        if (ta.lastMoveEvent && ta.lastMoveEventInfo) {
          var ao = getPanInfo(ta.lastMoveEventInfo, ta.history), oo = ta.startEvent !== null, no = distance(ao.offset, { x: 0, y: 0 }) >= 3;
          if (!(!oo && !no)) {
            var lo = ao.point, so = getFrameData().timestamp;
            ta.history.push(__assign(__assign({}, lo), { timestamp: so }));
            var bs = ta.handlers, Rs = bs.onStart, js = bs.onMove;
            oo || (Rs && Rs(ta.lastMoveEvent, ao), ta.startEvent = ta.lastMoveEvent), js && js(ta.lastMoveEvent, ao);
          }
        }
      }, this.handlePointerMove = function(ao, oo) {
        if (ta.lastMoveEvent = ao, ta.lastMoveEventInfo = transformPoint(oo, ta.transformPagePoint), isMouseEvent(ao) && ao.buttons === 0) {
          ta.handlePointerUp(ao, oo);
          return;
        }
        sync.update(ta.updatePoint, !0);
      }, this.handlePointerUp = function(ao, oo) {
        ta.end();
        var no = ta.handlers, lo = no.onEnd, so = no.onSessionEnd, bs = getPanInfo(transformPoint(oo, ta.transformPagePoint), ta.history);
        ta.startEvent && lo && lo(ao, bs), so && so(ao, bs);
      }, !(isTouchEvent(e) && e.touches.length > 1)) {
        this.handlers = Ui, this.transformPagePoint = ia;
        var aa = extractEventInfo(e), da = transformPoint(aa, this.transformPagePoint), La = da.point, qa = getFrameData().timestamp;
        this.history = [__assign(__assign({}, La), { timestamp: qa })];
        var io = Ui.onSessionStart;
        io && io(e, getPanInfo(da, this.history)), this.removeListeners = pipe(addPointerEvent(window, "pointermove", this.handlePointerMove), addPointerEvent(window, "pointerup", this.handlePointerUp), addPointerEvent(window, "pointercancel", this.handlePointerUp));
      }
    }
    return Bi.prototype.updateHandlers = function(e) {
      this.handlers = e;
    }, Bi.prototype.end = function() {
      this.removeListeners && this.removeListeners(), cancelSync.update(this.updatePoint);
    }, Bi;
  }()
);
function transformPoint(Bi, e) {
  return e ? { point: e(Bi.point) } : Bi;
}
function subtractPoint(Bi, e) {
  return { x: Bi.x - e.x, y: Bi.y - e.y };
}
function getPanInfo(Bi, e) {
  var Ui = Bi.point;
  return {
    point: Ui,
    delta: subtractPoint(Ui, lastDevicePoint(e)),
    offset: subtractPoint(Ui, startDevicePoint(e)),
    velocity: getVelocity(e, 0.1)
  };
}
function startDevicePoint(Bi) {
  return Bi[0];
}
function lastDevicePoint(Bi) {
  return Bi[Bi.length - 1];
}
function getVelocity(Bi, e) {
  if (Bi.length < 2)
    return { x: 0, y: 0 };
  for (var Ui = Bi.length - 1, Zi = null, ta = lastDevicePoint(Bi); Ui >= 0 && (Zi = Bi[Ui], !(ta.timestamp - Zi.timestamp > secondsToMilliseconds(e))); )
    Ui--;
  if (!Zi)
    return { x: 0, y: 0 };
  var na = (ta.timestamp - Zi.timestamp) / 1e3;
  if (na === 0)
    return { x: 0, y: 0 };
  var ia = {
    x: (ta.x - Zi.x) / na,
    y: (ta.y - Zi.y) / na
  };
  return ia.x === 1 / 0 && (ia.x = 0), ia.y === 1 / 0 && (ia.y = 0), ia;
}
function calcLength(Bi) {
  return Bi.max - Bi.min;
}
function isNear(Bi, e, Ui) {
  return e === void 0 && (e = 0), Ui === void 0 && (Ui = 0.01), distance(Bi, e) < Ui;
}
function calcAxisDelta(Bi, e, Ui, Zi) {
  Zi === void 0 && (Zi = 0.5), Bi.origin = Zi, Bi.originPoint = mix(e.min, e.max, Bi.origin), Bi.scale = calcLength(Ui) / calcLength(e), (isNear(Bi.scale, 1, 1e-4) || isNaN(Bi.scale)) && (Bi.scale = 1), Bi.translate = mix(Ui.min, Ui.max, Bi.origin) - Bi.originPoint, (isNear(Bi.translate) || isNaN(Bi.translate)) && (Bi.translate = 0);
}
function calcBoxDelta(Bi, e, Ui, Zi) {
  calcAxisDelta(Bi.x, e.x, Ui.x, Zi?.originX), calcAxisDelta(Bi.y, e.y, Ui.y, Zi?.originY);
}
function calcRelativeAxis(Bi, e, Ui) {
  Bi.min = Ui.min + e.min, Bi.max = Bi.min + calcLength(e);
}
function calcRelativeBox(Bi, e, Ui) {
  calcRelativeAxis(Bi.x, e.x, Ui.x), calcRelativeAxis(Bi.y, e.y, Ui.y);
}
function calcRelativeAxisPosition(Bi, e, Ui) {
  Bi.min = e.min - Ui.min, Bi.max = Bi.min + calcLength(e);
}
function calcRelativePosition(Bi, e, Ui) {
  calcRelativeAxisPosition(Bi.x, e.x, Ui.x), calcRelativeAxisPosition(Bi.y, e.y, Ui.y);
}
function applyConstraints(Bi, e, Ui) {
  var Zi = e.min, ta = e.max;
  return Zi !== void 0 && Bi < Zi ? Bi = Ui ? mix(Zi, Bi, Ui.min) : Math.max(Bi, Zi) : ta !== void 0 && Bi > ta && (Bi = Ui ? mix(ta, Bi, Ui.max) : Math.min(Bi, ta)), Bi;
}
function calcRelativeAxisConstraints(Bi, e, Ui) {
  return {
    min: e !== void 0 ? Bi.min + e : void 0,
    max: Ui !== void 0 ? Bi.max + Ui - (Bi.max - Bi.min) : void 0
  };
}
function calcRelativeConstraints(Bi, e) {
  var Ui = e.top, Zi = e.left, ta = e.bottom, na = e.right;
  return {
    x: calcRelativeAxisConstraints(Bi.x, Zi, na),
    y: calcRelativeAxisConstraints(Bi.y, Ui, ta)
  };
}
function calcViewportAxisConstraints(Bi, e) {
  var Ui, Zi = e.min - Bi.min, ta = e.max - Bi.max;
  return e.max - e.min < Bi.max - Bi.min && (Ui = __read([ta, Zi], 2), Zi = Ui[0], ta = Ui[1]), { min: Zi, max: ta };
}
function calcViewportConstraints(Bi, e) {
  return {
    x: calcViewportAxisConstraints(Bi.x, e.x),
    y: calcViewportAxisConstraints(Bi.y, e.y)
  };
}
function calcOrigin(Bi, e) {
  var Ui = 0.5, Zi = calcLength(Bi), ta = calcLength(e);
  return ta > Zi ? Ui = progress(e.min, e.max - Zi, Bi.min) : Zi > ta && (Ui = progress(Bi.min, Bi.max - ta, e.min)), clamp(0, 1, Ui);
}
function rebaseAxisConstraints(Bi, e) {
  var Ui = {};
  return e.min !== void 0 && (Ui.min = e.min - Bi.min), e.max !== void 0 && (Ui.max = e.max - Bi.min), Ui;
}
var defaultElastic = 0.35;
function resolveDragElastic(Bi) {
  return Bi === void 0 && (Bi = defaultElastic), Bi === !1 ? Bi = 0 : Bi === !0 && (Bi = defaultElastic), {
    x: resolveAxisElastic(Bi, "left", "right"),
    y: resolveAxisElastic(Bi, "top", "bottom")
  };
}
function resolveAxisElastic(Bi, e, Ui) {
  return {
    min: resolvePointElastic(Bi, e),
    max: resolvePointElastic(Bi, Ui)
  };
}
function resolvePointElastic(Bi, e) {
  var Ui;
  return typeof Bi == "number" ? Bi : (Ui = Bi[e]) !== null && Ui !== void 0 ? Ui : 0;
}
var createAxisDelta = function() {
  return {
    translate: 0,
    scale: 1,
    origin: 0,
    originPoint: 0
  };
}, createDelta = function() {
  return {
    x: createAxisDelta(),
    y: createAxisDelta()
  };
}, createAxis = function() {
  return { min: 0, max: 0 };
}, createBox = function() {
  return {
    x: createAxis(),
    y: createAxis()
  };
};
function eachAxis(Bi) {
  return [Bi("x"), Bi("y")];
}
function convertBoundingBoxToBox(Bi) {
  var e = Bi.top, Ui = Bi.left, Zi = Bi.right, ta = Bi.bottom;
  return {
    x: { min: Ui, max: Zi },
    y: { min: e, max: ta }
  };
}
function convertBoxToBoundingBox(Bi) {
  var e = Bi.x, Ui = Bi.y;
  return { top: Ui.min, right: e.max, bottom: Ui.max, left: e.min };
}
function transformBoxPoints(Bi, e) {
  if (!e)
    return Bi;
  var Ui = e({ x: Bi.left, y: Bi.top }), Zi = e({ x: Bi.right, y: Bi.bottom });
  return {
    top: Ui.y,
    left: Ui.x,
    bottom: Zi.y,
    right: Zi.x
  };
}
function isIdentityScale(Bi) {
  return Bi === void 0 || Bi === 1;
}
function hasScale(Bi) {
  var e = Bi.scale, Ui = Bi.scaleX, Zi = Bi.scaleY;
  return !isIdentityScale(e) || !isIdentityScale(Ui) || !isIdentityScale(Zi);
}
function hasTransform(Bi) {
  return hasScale(Bi) || hasTranslate(Bi.x) || hasTranslate(Bi.y) || Bi.z || Bi.rotate || Bi.rotateX || Bi.rotateY;
}
function hasTranslate(Bi) {
  return Bi && Bi !== "0%";
}
function scalePoint(Bi, e, Ui) {
  var Zi = Bi - Ui, ta = e * Zi;
  return Ui + ta;
}
function applyPointDelta(Bi, e, Ui, Zi, ta) {
  return ta !== void 0 && (Bi = scalePoint(Bi, ta, Zi)), scalePoint(Bi, Ui, Zi) + e;
}
function applyAxisDelta(Bi, e, Ui, Zi, ta) {
  e === void 0 && (e = 0), Ui === void 0 && (Ui = 1), Bi.min = applyPointDelta(Bi.min, e, Ui, Zi, ta), Bi.max = applyPointDelta(Bi.max, e, Ui, Zi, ta);
}
function applyBoxDelta(Bi, e) {
  var Ui = e.x, Zi = e.y;
  applyAxisDelta(Bi.x, Ui.translate, Ui.scale, Ui.originPoint), applyAxisDelta(Bi.y, Zi.translate, Zi.scale, Zi.originPoint);
}
function applyTreeDeltas(Bi, e, Ui, Zi) {
  var ta, na;
  Zi === void 0 && (Zi = !1);
  var ia = Ui.length;
  if (ia) {
    e.x = e.y = 1;
    for (var aa, da, La = 0; La < ia; La++)
      aa = Ui[La], da = aa.projectionDelta, ((na = (ta = aa.instance) === null || ta === void 0 ? void 0 : ta.style) === null || na === void 0 ? void 0 : na.display) !== "contents" && (Zi && aa.options.layoutScroll && aa.scroll && aa !== aa.root && transformBox(Bi, { x: -aa.scroll.x, y: -aa.scroll.y }), da && (e.x *= da.x.scale, e.y *= da.y.scale, applyBoxDelta(Bi, da)), Zi && hasTransform(aa.latestValues) && transformBox(Bi, aa.latestValues));
  }
}
function translateAxis(Bi, e) {
  Bi.min = Bi.min + e, Bi.max = Bi.max + e;
}
function transformAxis(Bi, e, Ui) {
  var Zi = __read(Ui, 3), ta = Zi[0], na = Zi[1], ia = Zi[2], aa = e[ia] !== void 0 ? e[ia] : 0.5, da = mix(Bi.min, Bi.max, aa);
  applyAxisDelta(Bi, e[ta], e[na], da, e.scale);
}
var xKeys$1 = ["x", "scaleX", "originX"], yKeys$1 = ["y", "scaleY", "originY"];
function transformBox(Bi, e) {
  transformAxis(Bi.x, e, xKeys$1), transformAxis(Bi.y, e, yKeys$1);
}
function measureViewportBox(Bi, e) {
  return convertBoundingBoxToBox(transformBoxPoints(Bi.getBoundingClientRect(), e));
}
function measurePageBox(Bi, e, Ui) {
  var Zi = measureViewportBox(Bi, Ui), ta = e.scroll;
  return ta && (translateAxis(Zi.x, ta.x), translateAxis(Zi.y, ta.y)), Zi;
}
var elementDragControls = /* @__PURE__ */ new WeakMap(), VisualElementDragControls = (
  /** @class */
  function() {
    function Bi(e) {
      this.openGlobalLock = null, this.isDragging = !1, this.currentDirection = null, this.originPoint = { x: 0, y: 0 }, this.constraints = !1, this.hasMutatedConstraints = !1, this.elastic = createBox(), this.visualElement = e;
    }
    return Bi.prototype.start = function(e, Ui) {
      var Zi = this, ta = Ui === void 0 ? {} : Ui, na = ta.snapToCursor, ia = na === void 0 ? !1 : na;
      if (this.visualElement.isPresent !== !1) {
        var aa = function(io) {
          Zi.stopAnimation(), ia && Zi.snapToCursor(extractEventInfo(io, "page").point);
        }, da = function(io, ao) {
          var oo, no = Zi.getProps(), lo = no.drag, so = no.dragPropagation, bs = no.onDragStart;
          lo && !so && (Zi.openGlobalLock && Zi.openGlobalLock(), Zi.openGlobalLock = getGlobalLock(lo), !Zi.openGlobalLock) || (Zi.isDragging = !0, Zi.currentDirection = null, Zi.resolveConstraints(), Zi.visualElement.projection && (Zi.visualElement.projection.isAnimationBlocked = !0, Zi.visualElement.projection.target = void 0), eachAxis(function(Rs) {
            var js, qs, jo = Zi.getAxisMotionValue(Rs).get() || 0;
            if (percent.test(jo)) {
              var fs = (qs = (js = Zi.visualElement.projection) === null || js === void 0 ? void 0 : js.layout) === null || qs === void 0 ? void 0 : qs.actual[Rs];
              if (fs) {
                var Ao = calcLength(fs);
                jo = Ao * (parseFloat(jo) / 100);
              }
            }
            Zi.originPoint[Rs] = jo;
          }), bs?.(io, ao), (oo = Zi.visualElement.animationState) === null || oo === void 0 || oo.setActive(AnimationType.Drag, !0));
        }, La = function(io, ao) {
          var oo = Zi.getProps(), no = oo.dragPropagation, lo = oo.dragDirectionLock, so = oo.onDirectionLock, bs = oo.onDrag;
          if (!(!no && !Zi.openGlobalLock)) {
            var Rs = ao.offset;
            if (lo && Zi.currentDirection === null) {
              Zi.currentDirection = getCurrentDirection(Rs), Zi.currentDirection !== null && so?.(Zi.currentDirection);
              return;
            }
            Zi.updateAxis("x", ao.point, Rs), Zi.updateAxis("y", ao.point, Rs), Zi.visualElement.syncRender(), bs?.(io, ao);
          }
        }, qa = function(io, ao) {
          return Zi.stop(io, ao);
        };
        this.panSession = new PanSession(e, {
          onSessionStart: aa,
          onStart: da,
          onMove: La,
          onSessionEnd: qa
        }, { transformPagePoint: this.visualElement.getTransformPagePoint() });
      }
    }, Bi.prototype.stop = function(e, Ui) {
      var Zi = this.isDragging;
      if (this.cancel(), !!Zi) {
        var ta = Ui.velocity;
        this.startAnimation(ta);
        var na = this.getProps().onDragEnd;
        na?.(e, Ui);
      }
    }, Bi.prototype.cancel = function() {
      var e, Ui;
      this.isDragging = !1, this.visualElement.projection && (this.visualElement.projection.isAnimationBlocked = !1), (e = this.panSession) === null || e === void 0 || e.end(), this.panSession = void 0;
      var Zi = this.getProps().dragPropagation;
      !Zi && this.openGlobalLock && (this.openGlobalLock(), this.openGlobalLock = null), (Ui = this.visualElement.animationState) === null || Ui === void 0 || Ui.setActive(AnimationType.Drag, !1);
    }, Bi.prototype.updateAxis = function(e, Ui, Zi) {
      var ta = this.getProps().drag;
      if (!(!Zi || !shouldDrag(e, ta, this.currentDirection))) {
        var na = this.getAxisMotionValue(e), ia = this.originPoint[e] + Zi[e];
        this.constraints && this.constraints[e] && (ia = applyConstraints(ia, this.constraints[e], this.elastic[e])), na.set(ia);
      }
    }, Bi.prototype.resolveConstraints = function() {
      var e = this, Ui = this.getProps(), Zi = Ui.dragConstraints, ta = Ui.dragElastic, na = (this.visualElement.projection || {}).layout, ia = this.constraints;
      Zi && isRefObject(Zi) ? this.constraints || (this.constraints = this.resolveRefConstraints()) : Zi && na ? this.constraints = calcRelativeConstraints(na.actual, Zi) : this.constraints = !1, this.elastic = resolveDragElastic(ta), ia !== this.constraints && na && this.constraints && !this.hasMutatedConstraints && eachAxis(function(aa) {
        e.getAxisMotionValue(aa) && (e.constraints[aa] = rebaseAxisConstraints(na.actual[aa], e.constraints[aa]));
      });
    }, Bi.prototype.resolveRefConstraints = function() {
      var e = this.getProps(), Ui = e.dragConstraints, Zi = e.onMeasureDragConstraints;
      if (!Ui || !isRefObject(Ui))
        return !1;
      var ta = Ui.current;
      invariant$1(ta !== null, "If `dragConstraints` is set as a React ref, that ref must be passed to another component's `ref` prop.");
      var na = this.visualElement.projection;
      if (!na || !na.layout)
        return !1;
      var ia = measurePageBox(ta, na.root, this.visualElement.getTransformPagePoint()), aa = calcViewportConstraints(na.layout.actual, ia);
      if (Zi) {
        var da = Zi(convertBoxToBoundingBox(aa));
        this.hasMutatedConstraints = !!da, da && (aa = convertBoundingBoxToBox(da));
      }
      return aa;
    }, Bi.prototype.startAnimation = function(e) {
      var Ui = this, Zi = this.getProps(), ta = Zi.drag, na = Zi.dragMomentum, ia = Zi.dragElastic, aa = Zi.dragTransition, da = Zi.dragSnapToOrigin, La = Zi.onDragTransitionEnd, qa = this.constraints || {}, io = eachAxis(function(ao) {
        var oo;
        if (shouldDrag(ao, ta, Ui.currentDirection)) {
          var no = (oo = qa?.[ao]) !== null && oo !== void 0 ? oo : {};
          da && (no = { min: 0, max: 0 });
          var lo = ia ? 200 : 1e6, so = ia ? 40 : 1e7, bs = __assign(__assign({ type: "inertia", velocity: na ? e[ao] : 0, bounceStiffness: lo, bounceDamping: so, timeConstant: 750, restDelta: 1, restSpeed: 10 }, aa), no);
          return Ui.startAxisValueAnimation(ao, bs);
        }
      });
      return Promise.all(io).then(La);
    }, Bi.prototype.startAxisValueAnimation = function(e, Ui) {
      var Zi = this.getAxisMotionValue(e);
      return startAnimation(e, Zi, 0, Ui);
    }, Bi.prototype.stopAnimation = function() {
      var e = this;
      eachAxis(function(Ui) {
        return e.getAxisMotionValue(Ui).stop();
      });
    }, Bi.prototype.getAxisMotionValue = function(e) {
      var Ui, Zi, ta = "_drag" + e.toUpperCase(), na = this.visualElement.getProps()[ta];
      return na || this.visualElement.getValue(e, (Zi = (Ui = this.visualElement.getProps().initial) === null || Ui === void 0 ? void 0 : Ui[e]) !== null && Zi !== void 0 ? Zi : 0);
    }, Bi.prototype.snapToCursor = function(e) {
      var Ui = this;
      eachAxis(function(Zi) {
        var ta = Ui.getProps().drag;
        if (shouldDrag(Zi, ta, Ui.currentDirection)) {
          var na = Ui.visualElement.projection, ia = Ui.getAxisMotionValue(Zi);
          if (na && na.layout) {
            var aa = na.layout.actual[Zi], da = aa.min, La = aa.max;
            ia.set(e[Zi] - mix(da, La, 0.5));
          }
        }
      });
    }, Bi.prototype.scalePositionWithinConstraints = function() {
      var e = this, Ui, Zi = this.getProps(), ta = Zi.drag, na = Zi.dragConstraints, ia = this.visualElement.projection;
      if (!(!isRefObject(na) || !ia || !this.constraints)) {
        this.stopAnimation();
        var aa = { x: 0, y: 0 };
        eachAxis(function(La) {
          var qa = e.getAxisMotionValue(La);
          if (qa) {
            var io = qa.get();
            aa[La] = calcOrigin({ min: io, max: io }, e.constraints[La]);
          }
        });
        var da = this.visualElement.getProps().transformTemplate;
        this.visualElement.getInstance().style.transform = da ? da({}, "") : "none", (Ui = ia.root) === null || Ui === void 0 || Ui.updateScroll(), ia.updateLayout(), this.resolveConstraints(), eachAxis(function(La) {
          if (shouldDrag(La, ta, null)) {
            var qa = e.getAxisMotionValue(La), io = e.constraints[La], ao = io.min, oo = io.max;
            qa.set(mix(ao, oo, aa[La]));
          }
        });
      }
    }, Bi.prototype.addListeners = function() {
      var e = this, Ui;
      elementDragControls.set(this.visualElement, this);
      var Zi = this.visualElement.getInstance(), ta = addPointerEvent(Zi, "pointerdown", function(La) {
        var qa = e.getProps(), io = qa.drag, ao = qa.dragListener, oo = ao === void 0 ? !0 : ao;
        io && oo && e.start(La);
      }), na = function() {
        var La = e.getProps().dragConstraints;
        isRefObject(La) && (e.constraints = e.resolveRefConstraints());
      }, ia = this.visualElement.projection, aa = ia.addEventListener("measure", na);
      ia && !ia.layout && ((Ui = ia.root) === null || Ui === void 0 || Ui.updateScroll(), ia.updateLayout()), na();
      var da = addDomEvent(window, "resize", function() {
        return e.scalePositionWithinConstraints();
      });
      return ia.addEventListener("didUpdate", function(La) {
        var qa = La.delta, io = La.hasLayoutChanged;
        e.isDragging && io && (eachAxis(function(ao) {
          var oo = e.getAxisMotionValue(ao);
          oo && (e.originPoint[ao] += qa[ao].translate, oo.set(oo.get() + qa[ao].translate));
        }), e.visualElement.syncRender());
      }), function() {
        da(), ta(), aa();
      };
    }, Bi.prototype.getProps = function() {
      var e = this.visualElement.getProps(), Ui = e.drag, Zi = Ui === void 0 ? !1 : Ui, ta = e.dragDirectionLock, na = ta === void 0 ? !1 : ta, ia = e.dragPropagation, aa = ia === void 0 ? !1 : ia, da = e.dragConstraints, La = da === void 0 ? !1 : da, qa = e.dragElastic, io = qa === void 0 ? defaultElastic : qa, ao = e.dragMomentum, oo = ao === void 0 ? !0 : ao;
      return __assign(__assign({}, e), { drag: Zi, dragDirectionLock: na, dragPropagation: aa, dragConstraints: La, dragElastic: io, dragMomentum: oo });
    }, Bi;
  }()
);
function shouldDrag(Bi, e, Ui) {
  return (e === !0 || e === Bi) && (Ui === null || Ui === Bi);
}
function getCurrentDirection(Bi, e) {
  e === void 0 && (e = 10);
  var Ui = null;
  return Math.abs(Bi.y) > e ? Ui = "y" : Math.abs(Bi.x) > e && (Ui = "x"), Ui;
}
function useDrag$1(Bi) {
  var e = Bi.dragControls, Ui = Bi.visualElement, Zi = useConstant(function() {
    return new VisualElementDragControls(Ui);
  });
  useEffect(function() {
    return e && e.subscribe(Zi);
  }, [Zi, e]), useEffect(function() {
    return Zi.addListeners();
  }, [Zi]);
}
function usePanGesture(Bi) {
  var e = Bi.onPan, Ui = Bi.onPanStart, Zi = Bi.onPanEnd, ta = Bi.onPanSessionStart, na = Bi.visualElement, ia = e || Ui || Zi || ta, aa = useRef(null), da = useContext(MotionConfigContext).transformPagePoint, La = {
    onSessionStart: ta,
    onStart: Ui,
    onMove: e,
    onEnd: function(io, ao) {
      aa.current = null, Zi && Zi(io, ao);
    }
  };
  useEffect(function() {
    aa.current !== null && aa.current.updateHandlers(La);
  });
  function qa(io) {
    aa.current = new PanSession(io, La, {
      transformPagePoint: da
    });
  }
  usePointerEvent(na, "pointerdown", ia && qa), useUnmountEffect(function() {
    return aa.current && aa.current.end();
  });
}
var drag = {
  pan: makeRenderlessComponent(usePanGesture),
  drag: makeRenderlessComponent(useDrag$1)
}, names = [
  "LayoutMeasure",
  "BeforeLayoutMeasure",
  "LayoutUpdate",
  "ViewportBoxUpdate",
  "Update",
  "Render",
  "AnimationComplete",
  "LayoutAnimationComplete",
  "AnimationStart",
  "LayoutAnimationStart",
  "SetAxisTarget",
  "Unmount"
];
function createLifecycles() {
  var Bi = names.map(function() {
    return new SubscriptionManager();
  }), e = {}, Ui = {
    clearAllListeners: function() {
      return Bi.forEach(function(Zi) {
        return Zi.clear();
      });
    },
    updatePropListeners: function(Zi) {
      names.forEach(function(ta) {
        var na, ia = "on" + ta, aa = Zi[ia];
        (na = e[ta]) === null || na === void 0 || na.call(e), aa && (e[ta] = Ui[ia](aa));
      });
    }
  };
  return Bi.forEach(function(Zi, ta) {
    Ui["on" + names[ta]] = function(na) {
      return Zi.add(na);
    }, Ui["notify" + names[ta]] = function() {
      for (var na = [], ia = 0; ia < arguments.length; ia++)
        na[ia] = arguments[ia];
      return Zi.notify.apply(Zi, __spreadArray([], __read(na), !1));
    };
  }), Ui;
}
function updateMotionValuesFromProps(Bi, e, Ui) {
  var Zi;
  for (var ta in e) {
    var na = e[ta], ia = Ui[ta];
    if (isMotionValue(na))
      Bi.addValue(ta, na), process.env.NODE_ENV === "development" && warnOnce(na.version === "6.5.1", "Attempting to mix Framer Motion versions ".concat(na.version, " with 6.5.1 may not work as expected."));
    else if (isMotionValue(ia))
      Bi.addValue(ta, motionValue(na));
    else if (ia !== na)
      if (Bi.hasValue(ta)) {
        var aa = Bi.getValue(ta);
        !aa.hasAnimated && aa.set(na);
      } else
        Bi.addValue(ta, motionValue((Zi = Bi.getStaticValue(ta)) !== null && Zi !== void 0 ? Zi : na));
  }
  for (var ta in Ui)
    e[ta] === void 0 && Bi.removeValue(ta);
  return e;
}
var visualElement = function(Bi) {
  var e = Bi.treeType, Ui = e === void 0 ? "" : e, Zi = Bi.build, ta = Bi.getBaseTarget, na = Bi.makeTargetAnimatable, ia = Bi.measureViewportBox, aa = Bi.render, da = Bi.readValueFromInstance, La = Bi.removeValueFromRenderState, qa = Bi.sortNodePosition, io = Bi.scrapeMotionValuesFromProps;
  return function(ao, oo) {
    var no = ao.parent, lo = ao.props, so = ao.presenceId, bs = ao.blockInitialAnimation, Rs = ao.visualState, js = ao.shouldReduceMotion;
    oo === void 0 && (oo = {});
    var qs = !1, jo = Rs.latestValues, fs = Rs.renderState, Ao, co = createLifecycles(), Co = /* @__PURE__ */ new Map(), Zs = /* @__PURE__ */ new Map(), xl = {}, Cl = __assign({}, jo), Al;
    function Ol() {
      !Ao || !qs || (Bl(), aa(Ao, fs, lo.style, Tl.projection));
    }
    function Bl() {
      Zi(Tl, fs, jo, oo, lo);
    }
    function Ml() {
      co.notifyUpdate(jo);
    }
    function Vl(El, Il) {
      var Ul = Il.onChange(function(Rl) {
        jo[El] = Rl, lo.onUpdate && sync.update(Ml, !1, !0);
      }), Kl = Il.onRenderRequest(Tl.scheduleRender);
      Zs.set(El, function() {
        Ul(), Kl();
      });
    }
    var Ll = io(lo);
    for (var Yl in Ll) {
      var Zl = Ll[Yl];
      jo[Yl] !== void 0 && isMotionValue(Zl) && Zl.set(jo[Yl], !1);
    }
    var tc = checkIfControllingVariants(lo), Nl = checkIfVariantNode(lo), Tl = __assign(__assign({
      treeType: Ui,
      /**
       * This is a mirror of the internal instance prop, which keeps
       * VisualElement type-compatible with React's RefObject.
       */
      current: null,
      /**
       * The depth of this visual element within the visual element tree.
       */
      depth: no ? no.depth + 1 : 0,
      parent: no,
      children: /* @__PURE__ */ new Set(),
      /**
       *
       */
      presenceId: so,
      shouldReduceMotion: js,
      /**
       * If this component is part of the variant tree, it should track
       * any children that are also part of the tree. This is essentially
       * a shadow tree to simplify logic around how to stagger over children.
       */
      variantChildren: Nl ? /* @__PURE__ */ new Set() : void 0,
      /**
       * Whether this instance is visible. This can be changed imperatively
       * by the projection tree, is analogous to CSS's visibility in that
       * hidden elements should take up layout, and needs enacting by the configured
       * render function.
       */
      isVisible: void 0,
      /**
       * Normally, if a component is controlled by a parent's variants, it can
       * rely on that ancestor to trigger animations further down the tree.
       * However, if a component is created after its parent is mounted, the parent
       * won't trigger that mount animation so the child needs to.
       *
       * TODO: This might be better replaced with a method isParentMounted
       */
      manuallyAnimateOnMount: !!no?.isMounted(),
      /**
       * This can be set by AnimatePresence to force components that mount
       * at the same time as it to mount as if they have initial={false} set.
       */
      blockInitialAnimation: bs,
      /**
       * Determine whether this component has mounted yet. This is mostly used
       * by variant children to determine whether they need to trigger their
       * own animations on mount.
       */
      isMounted: function() {
        return !!Ao;
      },
      mount: function(El) {
        qs = !0, Ao = Tl.current = El, Tl.projection && Tl.projection.mount(El), Nl && no && !tc && (Al = no?.addVariantChild(Tl)), Co.forEach(function(Il, Ul) {
          return Vl(Ul, Il);
        }), no?.children.add(Tl), Tl.setProps(lo);
      },
      /**
       *
       */
      unmount: function() {
        var El;
        (El = Tl.projection) === null || El === void 0 || El.unmount(), cancelSync.update(Ml), cancelSync.render(Ol), Zs.forEach(function(Il) {
          return Il();
        }), Al?.(), no?.children.delete(Tl), co.clearAllListeners(), Ao = void 0, qs = !1;
      },
      /**
       * Add a child visual element to our set of children.
       */
      addVariantChild: function(El) {
        var Il, Ul = Tl.getClosestVariantNode();
        if (Ul)
          return (Il = Ul.variantChildren) === null || Il === void 0 || Il.add(El), function() {
            return Ul.variantChildren.delete(El);
          };
      },
      sortNodePosition: function(El) {
        return !qa || Ui !== El.treeType ? 0 : qa(Tl.getInstance(), El.getInstance());
      },
      /**
       * Returns the closest variant node in the tree starting from
       * this visual element.
       */
      getClosestVariantNode: function() {
        return Nl ? Tl : no?.getClosestVariantNode();
      },
      /**
       * Expose the latest layoutId prop.
       */
      getLayoutId: function() {
        return lo.layoutId;
      },
      /**
       * Returns the current instance.
       */
      getInstance: function() {
        return Ao;
      },
      /**
       * Get/set the latest static values.
       */
      getStaticValue: function(El) {
        return jo[El];
      },
      setStaticValue: function(El, Il) {
        return jo[El] = Il;
      },
      /**
       * Returns the latest motion value state. Currently only used to take
       * a snapshot of the visual element - perhaps this can return the whole
       * visual state
       */
      getLatestValues: function() {
        return jo;
      },
      /**
       * Set the visiblity of the visual element. If it's changed, schedule
       * a render to reflect these changes.
       */
      setVisibility: function(El) {
        Tl.isVisible !== El && (Tl.isVisible = El, Tl.scheduleRender());
      },
      /**
       * Make a target animatable by Popmotion. For instance, if we're
       * trying to animate width from 100px to 100vw we need to measure 100vw
       * in pixels to determine what we really need to animate to. This is also
       * pluggable to support Framer's custom value types like Color,
       * and CSS variables.
       */
      makeTargetAnimatable: function(El, Il) {
        return Il === void 0 && (Il = !0), na(Tl, El, lo, Il);
      },
      /**
       * Measure the current viewport box with or without transforms.
       * Only measures axis-aligned boxes, rotate and skew must be manually
       * removed with a re-render to work.
       */
      measureViewportBox: function() {
        return ia(Ao, lo);
      },
      // Motion values ========================
      /**
       * Add a motion value and bind it to this visual element.
       */
      addValue: function(El, Il) {
        Tl.hasValue(El) && Tl.removeValue(El), Co.set(El, Il), jo[El] = Il.get(), Vl(El, Il);
      },
      /**
       * Remove a motion value and unbind any active subscriptions.
       */
      removeValue: function(El) {
        var Il;
        Co.delete(El), (Il = Zs.get(El)) === null || Il === void 0 || Il(), Zs.delete(El), delete jo[El], La(El, fs);
      },
      /**
       * Check whether we have a motion value for this key
       */
      hasValue: function(El) {
        return Co.has(El);
      },
      /**
       * Get a motion value for this key. If called with a default
       * value, we'll create one if none exists.
       */
      getValue: function(El, Il) {
        var Ul = Co.get(El);
        return Ul === void 0 && Il !== void 0 && (Ul = motionValue(Il), Tl.addValue(El, Ul)), Ul;
      },
      /**
       * Iterate over our motion values.
       */
      forEachValue: function(El) {
        return Co.forEach(El);
      },
      /**
       * If we're trying to animate to a previously unencountered value,
       * we need to check for it in our state and as a last resort read it
       * directly from the instance (which might have performance implications).
       */
      readValue: function(El) {
        var Il;
        return (Il = jo[El]) !== null && Il !== void 0 ? Il : da(Ao, El, oo);
      },
      /**
       * Set the base target to later animate back to. This is currently
       * only hydrated on creation and when we first read a value.
       */
      setBaseTarget: function(El, Il) {
        Cl[El] = Il;
      },
      /**
       * Find the base target for a value thats been removed from all animation
       * props.
       */
      getBaseTarget: function(El) {
        if (ta) {
          var Il = ta(lo, El);
          if (Il !== void 0 && !isMotionValue(Il))
            return Il;
        }
        return Cl[El];
      }
    }, co), {
      /**
       * Build the renderer state based on the latest visual state.
       */
      build: function() {
        return Bl(), fs;
      },
      /**
       * Schedule a render on the next animation frame.
       */
      scheduleRender: function() {
        sync.render(Ol, !1, !0);
      },
      /**
       * Synchronously fire render. It's prefered that we batch renders but
       * in many circumstances, like layout measurement, we need to run this
       * synchronously. However in those instances other measures should be taken
       * to batch reads/writes.
       */
      syncRender: Ol,
      /**
       * Update the provided props. Ensure any newly-added motion values are
       * added to our map, old ones removed, and listeners updated.
       */
      setProps: function(El) {
        (El.transformTemplate || lo.transformTemplate) && Tl.scheduleRender(), lo = El, co.updatePropListeners(El), xl = updateMotionValuesFromProps(Tl, io(lo), xl);
      },
      getProps: function() {
        return lo;
      },
      // Variants ==============================
      /**
       * Returns the variant definition with a given name.
       */
      getVariant: function(El) {
        var Il;
        return (Il = lo.variants) === null || Il === void 0 ? void 0 : Il[El];
      },
      /**
       * Returns the defined default transition on this component.
       */
      getDefaultTransition: function() {
        return lo.transition;
      },
      getTransformPagePoint: function() {
        return lo.transformPagePoint;
      },
      /**
       * Used by child variant nodes to get the closest ancestor variant props.
       */
      getVariantContext: function(El) {
        if (El === void 0 && (El = !1), El)
          return no?.getVariantContext();
        if (!tc) {
          var Il = no?.getVariantContext() || {};
          return lo.initial !== void 0 && (Il.initial = lo.initial), Il;
        }
        for (var Ul = {}, Kl = 0; Kl < numVariantProps; Kl++) {
          var Rl = variantProps[Kl], uo = lo[Rl];
          (isVariantLabel(uo) || uo === !1) && (Ul[Rl] = uo);
        }
        return Ul;
      }
    });
    return Tl;
  };
}, variantProps = __spreadArray(["initial"], __read(variantPriorityOrder), !1), numVariantProps = variantProps.length;
function isCSSVariable(Bi) {
  return typeof Bi == "string" && Bi.startsWith("var(--");
}
var cssVariableRegex = /var\((--[a-zA-Z0-9-_]+),? ?([a-zA-Z0-9 ()%#.,-]+)?\)/;
function parseCSSVariable(Bi) {
  var e = cssVariableRegex.exec(Bi);
  if (!e)
    return [,];
  var Ui = __read(e, 3), Zi = Ui[1], ta = Ui[2];
  return [Zi, ta];
}
var maxDepth = 4;
function getVariableValue(Bi, e, Ui) {
  Ui === void 0 && (Ui = 1), invariant$1(Ui <= maxDepth, 'Max CSS variable fallback depth detected in property "'.concat(Bi, '". This may indicate a circular fallback dependency.'));
  var Zi = __read(parseCSSVariable(Bi), 2), ta = Zi[0], na = Zi[1];
  if (ta) {
    var ia = window.getComputedStyle(e).getPropertyValue(ta);
    return ia ? ia.trim() : isCSSVariable(na) ? getVariableValue(na, e, Ui + 1) : na;
  }
}
function resolveCSSVariables(Bi, e, Ui) {
  var Zi, ta = __rest$1(e, []), na = Bi.getInstance();
  if (!(na instanceof Element))
    return { target: ta, transitionEnd: Ui };
  Ui && (Ui = __assign({}, Ui)), Bi.forEachValue(function(La) {
    var qa = La.get();
    if (isCSSVariable(qa)) {
      var io = getVariableValue(qa, na);
      io && La.set(io);
    }
  });
  for (var ia in ta) {
    var aa = ta[ia];
    if (isCSSVariable(aa)) {
      var da = getVariableValue(aa, na);
      da && (ta[ia] = da, Ui && ((Zi = Ui[ia]) !== null && Zi !== void 0 || (Ui[ia] = aa)));
    }
  }
  return { target: ta, transitionEnd: Ui };
}
var positionalKeys = /* @__PURE__ */ new Set([
  "width",
  "height",
  "top",
  "left",
  "right",
  "bottom",
  "x",
  "y"
]), isPositionalKey = function(Bi) {
  return positionalKeys.has(Bi);
}, hasPositionalKey = function(Bi) {
  return Object.keys(Bi).some(isPositionalKey);
}, setAndResetVelocity = function(Bi, e) {
  Bi.set(e, !1), Bi.set(e);
}, isNumOrPxType = function(Bi) {
  return Bi === number || Bi === px;
}, BoundingBoxDimension;
(function(Bi) {
  Bi.width = "width", Bi.height = "height", Bi.left = "left", Bi.right = "right", Bi.top = "top", Bi.bottom = "bottom";
})(BoundingBoxDimension || (BoundingBoxDimension = {}));
var getPosFromMatrix = function(Bi, e) {
  return parseFloat(Bi.split(", ")[e]);
}, getTranslateFromMatrix = function(Bi, e) {
  return function(Ui, Zi) {
    var ta = Zi.transform;
    if (ta === "none" || !ta)
      return 0;
    var na = ta.match(/^matrix3d\((.+)\)$/);
    if (na)
      return getPosFromMatrix(na[1], e);
    var ia = ta.match(/^matrix\((.+)\)$/);
    return ia ? getPosFromMatrix(ia[1], Bi) : 0;
  };
}, transformKeys = /* @__PURE__ */ new Set(["x", "y", "z"]), nonTranslationalTransformKeys = transformProps.filter(function(Bi) {
  return !transformKeys.has(Bi);
});
function removeNonTranslationalTransform(Bi) {
  var e = [];
  return nonTranslationalTransformKeys.forEach(function(Ui) {
    var Zi = Bi.getValue(Ui);
    Zi !== void 0 && (e.push([Ui, Zi.get()]), Zi.set(Ui.startsWith("scale") ? 1 : 0));
  }), e.length && Bi.syncRender(), e;
}
var positionalValues = {
  // Dimensions
  width: function(Bi, e) {
    var Ui = Bi.x, Zi = e.paddingLeft, ta = Zi === void 0 ? "0" : Zi, na = e.paddingRight, ia = na === void 0 ? "0" : na;
    return Ui.max - Ui.min - parseFloat(ta) - parseFloat(ia);
  },
  height: function(Bi, e) {
    var Ui = Bi.y, Zi = e.paddingTop, ta = Zi === void 0 ? "0" : Zi, na = e.paddingBottom, ia = na === void 0 ? "0" : na;
    return Ui.max - Ui.min - parseFloat(ta) - parseFloat(ia);
  },
  top: function(Bi, e) {
    var Ui = e.top;
    return parseFloat(Ui);
  },
  left: function(Bi, e) {
    var Ui = e.left;
    return parseFloat(Ui);
  },
  bottom: function(Bi, e) {
    var Ui = Bi.y, Zi = e.top;
    return parseFloat(Zi) + (Ui.max - Ui.min);
  },
  right: function(Bi, e) {
    var Ui = Bi.x, Zi = e.left;
    return parseFloat(Zi) + (Ui.max - Ui.min);
  },
  // Transform
  x: getTranslateFromMatrix(4, 13),
  y: getTranslateFromMatrix(5, 14)
}, convertChangedValueTypes = function(Bi, e, Ui) {
  var Zi = e.measureViewportBox(), ta = e.getInstance(), na = getComputedStyle(ta), ia = na.display, aa = {};
  ia === "none" && e.setStaticValue("display", Bi.display || "block"), Ui.forEach(function(La) {
    aa[La] = positionalValues[La](Zi, na);
  }), e.syncRender();
  var da = e.measureViewportBox();
  return Ui.forEach(function(La) {
    var qa = e.getValue(La);
    setAndResetVelocity(qa, aa[La]), Bi[La] = positionalValues[La](da, na);
  }), Bi;
}, checkAndConvertChangedValueTypes = function(Bi, e, Ui, Zi) {
  Ui === void 0 && (Ui = {}), Zi === void 0 && (Zi = {}), e = __assign({}, e), Zi = __assign({}, Zi);
  var ta = Object.keys(e).filter(isPositionalKey), na = [], ia = !1, aa = [];
  if (ta.forEach(function(qa) {
    var io = Bi.getValue(qa);
    if (Bi.hasValue(qa)) {
      var ao = Ui[qa], oo = findDimensionValueType(ao), no = e[qa], lo;
      if (isKeyframesTarget(no)) {
        var so = no.length, bs = no[0] === null ? 1 : 0;
        ao = no[bs], oo = findDimensionValueType(ao);
        for (var Rs = bs; Rs < so; Rs++)
          lo ? invariant$1(findDimensionValueType(no[Rs]) === lo, "All keyframes must be of the same type") : (lo = findDimensionValueType(no[Rs]), invariant$1(lo === oo || isNumOrPxType(oo) && isNumOrPxType(lo), "Keyframes must be of the same dimension as the current value"));
      } else
        lo = findDimensionValueType(no);
      if (oo !== lo)
        if (isNumOrPxType(oo) && isNumOrPxType(lo)) {
          var js = io.get();
          typeof js == "string" && io.set(parseFloat(js)), typeof no == "string" ? e[qa] = parseFloat(no) : Array.isArray(no) && lo === px && (e[qa] = no.map(parseFloat));
        } else oo?.transform && lo?.transform && (ao === 0 || no === 0) ? ao === 0 ? io.set(lo.transform(ao)) : e[qa] = oo.transform(no) : (ia || (na = removeNonTranslationalTransform(Bi), ia = !0), aa.push(qa), Zi[qa] = Zi[qa] !== void 0 ? Zi[qa] : e[qa], setAndResetVelocity(io, no));
    }
  }), aa.length) {
    var da = aa.indexOf("height") >= 0 ? window.pageYOffset : null, La = convertChangedValueTypes(e, Bi, aa);
    return na.length && na.forEach(function(qa) {
      var io = __read(qa, 2), ao = io[0], oo = io[1];
      Bi.getValue(ao).set(oo);
    }), Bi.syncRender(), da !== null && window.scrollTo({ top: da }), { target: La, transitionEnd: Zi };
  } else
    return { target: e, transitionEnd: Zi };
};
function unitConversion(Bi, e, Ui, Zi) {
  return hasPositionalKey(e) ? checkAndConvertChangedValueTypes(Bi, e, Ui, Zi) : { target: e, transitionEnd: Zi };
}
var parseDomVariant = function(Bi, e, Ui, Zi) {
  var ta = resolveCSSVariables(Bi, e, Zi);
  return e = ta.target, Zi = ta.transitionEnd, unitConversion(Bi, e, Ui, Zi);
};
function getComputedStyle$1(Bi) {
  return window.getComputedStyle(Bi);
}
var htmlConfig = {
  treeType: "dom",
  readValueFromInstance: function(Bi, e) {
    if (isTransformProp(e)) {
      var Ui = getDefaultValueType(e);
      return Ui && Ui.default || 0;
    } else {
      var Zi = getComputedStyle$1(Bi);
      return (isCSSVariable$1(e) ? Zi.getPropertyValue(e) : Zi[e]) || 0;
    }
  },
  sortNodePosition: function(Bi, e) {
    return Bi.compareDocumentPosition(e) & 2 ? 1 : -1;
  },
  getBaseTarget: function(Bi, e) {
    var Ui;
    return (Ui = Bi.style) === null || Ui === void 0 ? void 0 : Ui[e];
  },
  measureViewportBox: function(Bi, e) {
    var Ui = e.transformPagePoint;
    return measureViewportBox(Bi, Ui);
  },
  /**
   * Reset the transform on the current Element. This is called as part
   * of a batched process across the entire layout tree. To remove this write
   * cycle it'd be interesting to see if it's possible to "undo" all the current
   * layout transforms up the tree in the same way this.getBoundingBoxWithoutTransforms
   * works
   */
  resetTransform: function(Bi, e, Ui) {
    var Zi = Ui.transformTemplate;
    e.style.transform = Zi ? Zi({}, "") : "none", Bi.scheduleRender();
  },
  restoreTransform: function(Bi, e) {
    Bi.style.transform = e.style.transform;
  },
  removeValueFromRenderState: function(Bi, e) {
    var Ui = e.vars, Zi = e.style;
    delete Ui[Bi], delete Zi[Bi];
  },
  /**
   * Ensure that HTML and Framer-specific value types like `px`->`%` and `Color`
   * can be animated by Motion.
   */
  makeTargetAnimatable: function(Bi, e, Ui, Zi) {
    var ta = Ui.transformValues;
    Zi === void 0 && (Zi = !0);
    var na = e.transition, ia = e.transitionEnd, aa = __rest$1(e, ["transition", "transitionEnd"]), da = getOrigin(aa, na || {}, Bi);
    if (ta && (ia && (ia = ta(ia)), aa && (aa = ta(aa)), da && (da = ta(da))), Zi) {
      checkTargetForNewValues(Bi, aa, da);
      var La = parseDomVariant(Bi, aa, da, ia);
      ia = La.transitionEnd, aa = La.target;
    }
    return __assign({ transition: na, transitionEnd: ia }, aa);
  },
  scrapeMotionValuesFromProps: scrapeMotionValuesFromProps$1,
  build: function(Bi, e, Ui, Zi, ta) {
    Bi.isVisible !== void 0 && (e.style.visibility = Bi.isVisible ? "visible" : "hidden"), buildHTMLStyles(e, Ui, Zi, ta.transformTemplate);
  },
  render: renderHTML
}, htmlVisualElement = visualElement(htmlConfig), svgVisualElement = visualElement(__assign(__assign({}, htmlConfig), { getBaseTarget: function(Bi, e) {
  return Bi[e];
}, readValueFromInstance: function(Bi, e) {
  var Ui;
  return isTransformProp(e) ? ((Ui = getDefaultValueType(e)) === null || Ui === void 0 ? void 0 : Ui.default) || 0 : (e = camelCaseAttributes.has(e) ? e : camelToDash(e), Bi.getAttribute(e));
}, scrapeMotionValuesFromProps, build: function(Bi, e, Ui, Zi, ta) {
  buildSVGAttrs(e, Ui, Zi, ta.transformTemplate);
}, render: renderSVG })), createDomVisualElement = function(Bi, e) {
  return isSVGComponent(Bi) ? svgVisualElement(e, { enableHardwareAcceleration: !1 }) : htmlVisualElement(e, { enableHardwareAcceleration: !0 });
};
function pixelsToPercent(Bi, e) {
  return e.max === e.min ? 0 : Bi / (e.max - e.min) * 100;
}
var correctBorderRadius = {
  correct: function(Bi, e) {
    if (!e.target)
      return Bi;
    if (typeof Bi == "string")
      if (px.test(Bi))
        Bi = parseFloat(Bi);
      else
        return Bi;
    var Ui = pixelsToPercent(Bi, e.target.x), Zi = pixelsToPercent(Bi, e.target.y);
    return "".concat(Ui, "% ").concat(Zi, "%");
  }
}, varToken = "_$css", correctBoxShadow = {
  correct: function(Bi, e) {
    var Ui = e.treeScale, Zi = e.projectionDelta, ta = Bi, na = Bi.includes("var("), ia = [];
    na && (Bi = Bi.replace(cssVariableRegex, function(lo) {
      return ia.push(lo), varToken;
    }));
    var aa = complex.parse(Bi);
    if (aa.length > 5)
      return ta;
    var da = complex.createTransformer(Bi), La = typeof aa[0] != "number" ? 1 : 0, qa = Zi.x.scale * Ui.x, io = Zi.y.scale * Ui.y;
    aa[0 + La] /= qa, aa[1 + La] /= io;
    var ao = mix(qa, io, 0.5);
    typeof aa[2 + La] == "number" && (aa[2 + La] /= ao), typeof aa[3 + La] == "number" && (aa[3 + La] /= ao);
    var oo = da(aa);
    if (na) {
      var no = 0;
      oo = oo.replace(varToken, function() {
        var lo = ia[no];
        return no++, lo;
      });
    }
    return oo;
  }
}, MeasureLayoutWithContext = (
  /** @class */
  function(Bi) {
    __extends(e, Bi);
    function e() {
      return Bi !== null && Bi.apply(this, arguments) || this;
    }
    return e.prototype.componentDidMount = function() {
      var Ui = this, Zi = this.props, ta = Zi.visualElement, na = Zi.layoutGroup, ia = Zi.switchLayoutGroup, aa = Zi.layoutId, da = ta.projection;
      addScaleCorrector(defaultScaleCorrectors), da && (na?.group && na.group.add(da), ia?.register && aa && ia.register(da), da.root.didUpdate(), da.addEventListener("animationComplete", function() {
        Ui.safeToRemove();
      }), da.setOptions(__assign(__assign({}, da.options), { onExitComplete: function() {
        return Ui.safeToRemove();
      } }))), globalProjectionState.hasEverUpdated = !0;
    }, e.prototype.getSnapshotBeforeUpdate = function(Ui) {
      var Zi = this, ta = this.props, na = ta.layoutDependency, ia = ta.visualElement, aa = ta.drag, da = ta.isPresent, La = ia.projection;
      return La && (La.isPresent = da, aa || Ui.layoutDependency !== na || na === void 0 ? La.willUpdate() : this.safeToRemove(), Ui.isPresent !== da && (da ? La.promote() : La.relegate() || sync.postRender(function() {
        var qa;
        !((qa = La.getStack()) === null || qa === void 0) && qa.members.length || Zi.safeToRemove();
      }))), null;
    }, e.prototype.componentDidUpdate = function() {
      var Ui = this.props.visualElement.projection;
      Ui && (Ui.root.didUpdate(), !Ui.currentAnimation && Ui.isLead() && this.safeToRemove());
    }, e.prototype.componentWillUnmount = function() {
      var Ui = this.props, Zi = Ui.visualElement, ta = Ui.layoutGroup, na = Ui.switchLayoutGroup, ia = Zi.projection;
      ia && (ia.scheduleCheckAfterUnmount(), ta?.group && ta.group.remove(ia), na?.deregister && na.deregister(ia));
    }, e.prototype.safeToRemove = function() {
      var Ui = this.props.safeToRemove;
      Ui?.();
    }, e.prototype.render = function() {
      return null;
    }, e;
  }(a__default.Component)
);
function MeasureLayout(Bi) {
  var e = __read(usePresence(), 2), Ui = e[0], Zi = e[1], ta = useContext(LayoutGroupContext);
  return a__default.createElement(MeasureLayoutWithContext, __assign({}, Bi, { layoutGroup: ta, switchLayoutGroup: useContext(SwitchLayoutGroupContext), isPresent: Ui, safeToRemove: Zi }));
}
var defaultScaleCorrectors = {
  borderRadius: __assign(__assign({}, correctBorderRadius), { applyTo: [
    "borderTopLeftRadius",
    "borderTopRightRadius",
    "borderBottomLeftRadius",
    "borderBottomRightRadius"
  ] }),
  borderTopLeftRadius: correctBorderRadius,
  borderTopRightRadius: correctBorderRadius,
  borderBottomLeftRadius: correctBorderRadius,
  borderBottomRightRadius: correctBorderRadius,
  boxShadow: correctBoxShadow
}, layoutFeatures = {
  measureLayout: MeasureLayout
};
function animate(Bi, e, Ui) {
  Ui === void 0 && (Ui = {});
  var Zi = isMotionValue(Bi) ? Bi : motionValue(Bi);
  return startAnimation("", Zi, e, Ui), {
    stop: function() {
      return Zi.stop();
    },
    isAnimating: function() {
      return Zi.isAnimating();
    }
  };
}
var borders = ["TopLeft", "TopRight", "BottomLeft", "BottomRight"], numBorders = borders.length, asNumber = function(Bi) {
  return typeof Bi == "string" ? parseFloat(Bi) : Bi;
}, isPx = function(Bi) {
  return typeof Bi == "number" || px.test(Bi);
};
function mixValues(Bi, e, Ui, Zi, ta, na) {
  var ia, aa, da, La;
  ta ? (Bi.opacity = mix(
    0,
    // (follow?.opacity as number) ?? 0,
    // TODO Reinstate this if only child
    (ia = Ui.opacity) !== null && ia !== void 0 ? ia : 1,
    easeCrossfadeIn(Zi)
  ), Bi.opacityExit = mix((aa = e.opacity) !== null && aa !== void 0 ? aa : 1, 0, easeCrossfadeOut(Zi))) : na && (Bi.opacity = mix((da = e.opacity) !== null && da !== void 0 ? da : 1, (La = Ui.opacity) !== null && La !== void 0 ? La : 1, Zi));
  for (var qa = 0; qa < numBorders; qa++) {
    var io = "border".concat(borders[qa], "Radius"), ao = getRadius(e, io), oo = getRadius(Ui, io);
    if (!(ao === void 0 && oo === void 0)) {
      ao || (ao = 0), oo || (oo = 0);
      var no = ao === 0 || oo === 0 || isPx(ao) === isPx(oo);
      no ? (Bi[io] = Math.max(mix(asNumber(ao), asNumber(oo), Zi), 0), (percent.test(oo) || percent.test(ao)) && (Bi[io] += "%")) : Bi[io] = oo;
    }
  }
  (e.rotate || Ui.rotate) && (Bi.rotate = mix(e.rotate || 0, Ui.rotate || 0, Zi));
}
function getRadius(Bi, e) {
  var Ui;
  return (Ui = Bi[e]) !== null && Ui !== void 0 ? Ui : Bi.borderRadius;
}
var easeCrossfadeIn = compress(0, 0.5, circOut), easeCrossfadeOut = compress(0.5, 0.95, linear);
function compress(Bi, e, Ui) {
  return function(Zi) {
    return Zi < Bi ? 0 : Zi > e ? 1 : Ui(progress(Bi, e, Zi));
  };
}
function copyAxisInto(Bi, e) {
  Bi.min = e.min, Bi.max = e.max;
}
function copyBoxInto(Bi, e) {
  copyAxisInto(Bi.x, e.x), copyAxisInto(Bi.y, e.y);
}
function removePointDelta(Bi, e, Ui, Zi, ta) {
  return Bi -= e, Bi = scalePoint(Bi, 1 / Ui, Zi), ta !== void 0 && (Bi = scalePoint(Bi, 1 / ta, Zi)), Bi;
}
function removeAxisDelta(Bi, e, Ui, Zi, ta, na, ia) {
  if (e === void 0 && (e = 0), Ui === void 0 && (Ui = 1), Zi === void 0 && (Zi = 0.5), na === void 0 && (na = Bi), ia === void 0 && (ia = Bi), percent.test(e)) {
    e = parseFloat(e);
    var aa = mix(ia.min, ia.max, e / 100);
    e = aa - ia.min;
  }
  if (typeof e == "number") {
    var da = mix(na.min, na.max, Zi);
    Bi === na && (da -= e), Bi.min = removePointDelta(Bi.min, e, Ui, da, ta), Bi.max = removePointDelta(Bi.max, e, Ui, da, ta);
  }
}
function removeAxisTransforms(Bi, e, Ui, Zi, ta) {
  var na = __read(Ui, 3), ia = na[0], aa = na[1], da = na[2];
  removeAxisDelta(Bi, e[ia], e[aa], e[da], e.scale, Zi, ta);
}
var xKeys = ["x", "scaleX", "originX"], yKeys = ["y", "scaleY", "originY"];
function removeBoxTransforms(Bi, e, Ui, Zi) {
  removeAxisTransforms(Bi.x, e, xKeys, Ui?.x, Zi?.x), removeAxisTransforms(Bi.y, e, yKeys, Ui?.y, Zi?.y);
}
function isAxisDeltaZero(Bi) {
  return Bi.translate === 0 && Bi.scale === 1;
}
function isDeltaZero(Bi) {
  return isAxisDeltaZero(Bi.x) && isAxisDeltaZero(Bi.y);
}
function boxEquals(Bi, e) {
  return Bi.x.min === e.x.min && Bi.x.max === e.x.max && Bi.y.min === e.y.min && Bi.y.max === e.y.max;
}
var NodeStack = (
  /** @class */
  function() {
    function Bi() {
      this.members = [];
    }
    return Bi.prototype.add = function(e) {
      addUniqueItem(this.members, e), e.scheduleRender();
    }, Bi.prototype.remove = function(e) {
      if (removeItem(this.members, e), e === this.prevLead && (this.prevLead = void 0), e === this.lead) {
        var Ui = this.members[this.members.length - 1];
        Ui && this.promote(Ui);
      }
    }, Bi.prototype.relegate = function(e) {
      var Ui = this.members.findIndex(function(ia) {
        return e === ia;
      });
      if (Ui === 0)
        return !1;
      for (var Zi, ta = Ui; ta >= 0; ta--) {
        var na = this.members[ta];
        if (na.isPresent !== !1) {
          Zi = na;
          break;
        }
      }
      return Zi ? (this.promote(Zi), !0) : !1;
    }, Bi.prototype.promote = function(e, Ui) {
      var Zi, ta = this.lead;
      if (e !== ta && (this.prevLead = ta, this.lead = e, e.show(), ta)) {
        ta.instance && ta.scheduleRender(), e.scheduleRender(), e.resumeFrom = ta, Ui && (e.resumeFrom.preserveOpacity = !0), ta.snapshot && (e.snapshot = ta.snapshot, e.snapshot.latestValues = ta.animationValues || ta.latestValues, e.snapshot.isShared = !0), !((Zi = e.root) === null || Zi === void 0) && Zi.isUpdating && (e.isLayoutDirty = !0);
        var na = e.options.crossfade;
        na === !1 && ta.hide();
      }
    }, Bi.prototype.exitAnimationComplete = function() {
      this.members.forEach(function(e) {
        var Ui, Zi, ta, na, ia;
        (Zi = (Ui = e.options).onExitComplete) === null || Zi === void 0 || Zi.call(Ui), (ia = (ta = e.resumingFrom) === null || ta === void 0 ? void 0 : (na = ta.options).onExitComplete) === null || ia === void 0 || ia.call(na);
      });
    }, Bi.prototype.scheduleRender = function() {
      this.members.forEach(function(e) {
        e.instance && e.scheduleRender(!1);
      });
    }, Bi.prototype.removeLeadSnapshot = function() {
      this.lead && this.lead.snapshot && (this.lead.snapshot = void 0);
    }, Bi;
  }()
), identityProjection = "translate3d(0px, 0px, 0) scale(1, 1) scale(1, 1)";
function buildProjectionTransform(Bi, e, Ui) {
  var Zi = Bi.x.translate / e.x, ta = Bi.y.translate / e.y, na = "translate3d(".concat(Zi, "px, ").concat(ta, "px, 0) ");
  if (na += "scale(".concat(1 / e.x, ", ").concat(1 / e.y, ") "), Ui) {
    var ia = Ui.rotate, aa = Ui.rotateX, da = Ui.rotateY;
    ia && (na += "rotate(".concat(ia, "deg) ")), aa && (na += "rotateX(".concat(aa, "deg) ")), da && (na += "rotateY(".concat(da, "deg) "));
  }
  var La = Bi.x.scale * e.x, qa = Bi.y.scale * e.y;
  return na += "scale(".concat(La, ", ").concat(qa, ")"), na === identityProjection ? "none" : na;
}
var compareByDepth = function(Bi, e) {
  return Bi.depth - e.depth;
}, FlatTree = (
  /** @class */
  function() {
    function Bi() {
      this.children = [], this.isDirty = !1;
    }
    return Bi.prototype.add = function(e) {
      addUniqueItem(this.children, e), this.isDirty = !0;
    }, Bi.prototype.remove = function(e) {
      removeItem(this.children, e), this.isDirty = !0;
    }, Bi.prototype.forEach = function(e) {
      this.isDirty && this.children.sort(compareByDepth), this.isDirty = !1, this.children.forEach(e);
    }, Bi;
  }()
), animationTarget = 1e3;
function createProjectionNode(Bi) {
  var e = Bi.attachResizeListener, Ui = Bi.defaultParent, Zi = Bi.measureScroll, ta = Bi.checkIsScrollRoot, na = Bi.resetTransform;
  return (
    /** @class */
    function() {
      function ia(aa, da, La) {
        var qa = this;
        da === void 0 && (da = {}), La === void 0 && (La = Ui?.()), this.children = /* @__PURE__ */ new Set(), this.options = {}, this.isTreeAnimating = !1, this.isAnimationBlocked = !1, this.isLayoutDirty = !1, this.updateManuallyBlocked = !1, this.updateBlockedByResize = !1, this.isUpdating = !1, this.isSVG = !1, this.needsReset = !1, this.shouldResetTransform = !1, this.treeScale = { x: 1, y: 1 }, this.eventHandlers = /* @__PURE__ */ new Map(), this.potentialNodes = /* @__PURE__ */ new Map(), this.checkUpdateFailed = function() {
          qa.isUpdating && (qa.isUpdating = !1, qa.clearAllSnapshots());
        }, this.updateProjection = function() {
          qa.nodes.forEach(resolveTargetDelta), qa.nodes.forEach(calcProjection);
        }, this.hasProjected = !1, this.isVisible = !0, this.animationProgress = 0, this.sharedNodes = /* @__PURE__ */ new Map(), this.id = aa, this.latestValues = da, this.root = La ? La.root || La : this, this.path = La ? __spreadArray(__spreadArray([], __read(La.path), !1), [La], !1) : [], this.parent = La, this.depth = La ? La.depth + 1 : 0, aa && this.root.registerPotentialNode(aa, this);
        for (var io = 0; io < this.path.length; io++)
          this.path[io].shouldResetTransform = !0;
        this.root === this && (this.nodes = new FlatTree());
      }
      return ia.prototype.addEventListener = function(aa, da) {
        return this.eventHandlers.has(aa) || this.eventHandlers.set(aa, new SubscriptionManager()), this.eventHandlers.get(aa).add(da);
      }, ia.prototype.notifyListeners = function(aa) {
        for (var da = [], La = 1; La < arguments.length; La++)
          da[La - 1] = arguments[La];
        var qa = this.eventHandlers.get(aa);
        qa?.notify.apply(qa, __spreadArray([], __read(da), !1));
      }, ia.prototype.hasListeners = function(aa) {
        return this.eventHandlers.has(aa);
      }, ia.prototype.registerPotentialNode = function(aa, da) {
        this.potentialNodes.set(aa, da);
      }, ia.prototype.mount = function(aa, da) {
        var La = this, qa;
        if (da === void 0 && (da = !1), !this.instance) {
          this.isSVG = aa instanceof SVGElement && aa.tagName !== "svg", this.instance = aa;
          var io = this.options, ao = io.layoutId, oo = io.layout, no = io.visualElement;
          if (no && !no.getInstance() && no.mount(aa), this.root.nodes.add(this), (qa = this.parent) === null || qa === void 0 || qa.children.add(this), this.id && this.root.potentialNodes.delete(this.id), da && (oo || ao) && (this.isLayoutDirty = !0), e) {
            var lo, so = function() {
              return La.root.updateBlockedByResize = !1;
            };
            e(aa, function() {
              La.root.updateBlockedByResize = !0, clearTimeout(lo), lo = window.setTimeout(so, 250), globalProjectionState.hasAnimatedSinceResize && (globalProjectionState.hasAnimatedSinceResize = !1, La.nodes.forEach(finishAnimation));
            });
          }
          ao && this.root.registerSharedNode(ao, this), this.options.animate !== !1 && no && (ao || oo) && this.addEventListener("didUpdate", function(bs) {
            var Rs, js, qs, jo, fs, Ao = bs.delta, co = bs.hasLayoutChanged, Co = bs.hasRelativeTargetChanged, Zs = bs.layout;
            if (La.isTreeAnimationBlocked()) {
              La.target = void 0, La.relativeTarget = void 0;
              return;
            }
            var xl = (js = (Rs = La.options.transition) !== null && Rs !== void 0 ? Rs : no.getDefaultTransition()) !== null && js !== void 0 ? js : defaultLayoutTransition, Cl = no.getProps(), Al = Cl.onLayoutAnimationStart, Ol = Cl.onLayoutAnimationComplete, Bl = !La.targetLayout || !boxEquals(La.targetLayout, Zs) || Co, Ml = !co && Co;
            if (!((qs = La.resumeFrom) === null || qs === void 0) && qs.instance || Ml || co && (Bl || !La.currentAnimation)) {
              La.resumeFrom && (La.resumingFrom = La.resumeFrom, La.resumingFrom.resumingFrom = void 0), La.setAnimationOrigin(Ao, Ml);
              var Vl = __assign(__assign({}, getValueTransition(xl, "layout")), { onPlay: Al, onComplete: Ol });
              no.shouldReduceMotion && (Vl.delay = 0, Vl.type = !1), La.startAnimation(Vl);
            } else
              !co && La.animationProgress === 0 && La.finishAnimation(), La.isLead() && ((fs = (jo = La.options).onExitComplete) === null || fs === void 0 || fs.call(jo));
            La.targetLayout = Zs;
          });
        }
      }, ia.prototype.unmount = function() {
        var aa, da;
        this.options.layoutId && this.willUpdate(), this.root.nodes.remove(this), (aa = this.getStack()) === null || aa === void 0 || aa.remove(this), (da = this.parent) === null || da === void 0 || da.children.delete(this), this.instance = void 0, cancelSync.preRender(this.updateProjection);
      }, ia.prototype.blockUpdate = function() {
        this.updateManuallyBlocked = !0;
      }, ia.prototype.unblockUpdate = function() {
        this.updateManuallyBlocked = !1;
      }, ia.prototype.isUpdateBlocked = function() {
        return this.updateManuallyBlocked || this.updateBlockedByResize;
      }, ia.prototype.isTreeAnimationBlocked = function() {
        var aa;
        return this.isAnimationBlocked || ((aa = this.parent) === null || aa === void 0 ? void 0 : aa.isTreeAnimationBlocked()) || !1;
      }, ia.prototype.startUpdate = function() {
        var aa;
        this.isUpdateBlocked() || (this.isUpdating = !0, (aa = this.nodes) === null || aa === void 0 || aa.forEach(resetRotation));
      }, ia.prototype.willUpdate = function(aa) {
        var da, La, qa;
        if (aa === void 0 && (aa = !0), this.root.isUpdateBlocked()) {
          (La = (da = this.options).onExitComplete) === null || La === void 0 || La.call(da);
          return;
        }
        if (!this.root.isUpdating && this.root.startUpdate(), !this.isLayoutDirty) {
          this.isLayoutDirty = !0;
          for (var io = 0; io < this.path.length; io++) {
            var ao = this.path[io];
            ao.shouldResetTransform = !0, ao.updateScroll();
          }
          var oo = this.options, no = oo.layoutId, lo = oo.layout;
          if (!(no === void 0 && !lo)) {
            var so = (qa = this.options.visualElement) === null || qa === void 0 ? void 0 : qa.getProps().transformTemplate;
            this.prevTransformTemplateValue = so?.(this.latestValues, ""), this.updateSnapshot(), aa && this.notifyListeners("willUpdate");
          }
        }
      }, ia.prototype.didUpdate = function() {
        var aa = this.isUpdateBlocked();
        if (aa) {
          this.unblockUpdate(), this.clearAllSnapshots(), this.nodes.forEach(clearMeasurements);
          return;
        }
        this.isUpdating && (this.isUpdating = !1, this.potentialNodes.size && (this.potentialNodes.forEach(mountNodeEarly), this.potentialNodes.clear()), this.nodes.forEach(resetTransformStyle), this.nodes.forEach(updateLayout), this.nodes.forEach(notifyLayoutUpdate), this.clearAllSnapshots(), flushSync.update(), flushSync.preRender(), flushSync.render());
      }, ia.prototype.clearAllSnapshots = function() {
        this.nodes.forEach(clearSnapshot), this.sharedNodes.forEach(removeLeadSnapshots);
      }, ia.prototype.scheduleUpdateProjection = function() {
        sync.preRender(this.updateProjection, !1, !0);
      }, ia.prototype.scheduleCheckAfterUnmount = function() {
        var aa = this;
        sync.postRender(function() {
          aa.isLayoutDirty ? aa.root.didUpdate() : aa.root.checkUpdateFailed();
        });
      }, ia.prototype.updateSnapshot = function() {
        if (!(this.snapshot || !this.instance)) {
          var aa = this.measure(), da = this.removeTransform(this.removeElementScroll(aa));
          roundBox(da), this.snapshot = {
            measured: aa,
            layout: da,
            latestValues: {}
          };
        }
      }, ia.prototype.updateLayout = function() {
        var aa;
        if (this.instance && (this.updateScroll(), !(!(this.options.alwaysMeasureLayout && this.isLead()) && !this.isLayoutDirty))) {
          if (this.resumeFrom && !this.resumeFrom.instance)
            for (var da = 0; da < this.path.length; da++) {
              var La = this.path[da];
              La.updateScroll();
            }
          var qa = this.measure();
          roundBox(qa);
          var io = this.layout;
          this.layout = {
            measured: qa,
            actual: this.removeElementScroll(qa)
          }, this.layoutCorrected = createBox(), this.isLayoutDirty = !1, this.projectionDelta = void 0, this.notifyListeners("measure", this.layout.actual), (aa = this.options.visualElement) === null || aa === void 0 || aa.notifyLayoutMeasure(this.layout.actual, io?.actual);
        }
      }, ia.prototype.updateScroll = function() {
        this.options.layoutScroll && this.instance && (this.isScrollRoot = ta(this.instance), this.scroll = Zi(this.instance));
      }, ia.prototype.resetTransform = function() {
        var aa;
        if (na) {
          var da = this.isLayoutDirty || this.shouldResetTransform, La = this.projectionDelta && !isDeltaZero(this.projectionDelta), qa = (aa = this.options.visualElement) === null || aa === void 0 ? void 0 : aa.getProps().transformTemplate, io = qa?.(this.latestValues, ""), ao = io !== this.prevTransformTemplateValue;
          da && (La || hasTransform(this.latestValues) || ao) && (na(this.instance, io), this.shouldResetTransform = !1, this.scheduleRender());
        }
      }, ia.prototype.measure = function() {
        var aa = this.options.visualElement;
        if (!aa)
          return createBox();
        var da = aa.measureViewportBox(), La = this.root.scroll;
        return La && (translateAxis(da.x, La.x), translateAxis(da.y, La.y)), da;
      }, ia.prototype.removeElementScroll = function(aa) {
        var da = createBox();
        copyBoxInto(da, aa);
        for (var La = 0; La < this.path.length; La++) {
          var qa = this.path[La], io = qa.scroll, ao = qa.options, oo = qa.isScrollRoot;
          if (qa !== this.root && io && ao.layoutScroll) {
            if (oo) {
              copyBoxInto(da, aa);
              var no = this.root.scroll;
              no && (translateAxis(da.x, -no.x), translateAxis(da.y, -no.y));
            }
            translateAxis(da.x, io.x), translateAxis(da.y, io.y);
          }
        }
        return da;
      }, ia.prototype.applyTransform = function(aa, da) {
        da === void 0 && (da = !1);
        var La = createBox();
        copyBoxInto(La, aa);
        for (var qa = 0; qa < this.path.length; qa++) {
          var io = this.path[qa];
          !da && io.options.layoutScroll && io.scroll && io !== io.root && transformBox(La, {
            x: -io.scroll.x,
            y: -io.scroll.y
          }), hasTransform(io.latestValues) && transformBox(La, io.latestValues);
        }
        return hasTransform(this.latestValues) && transformBox(La, this.latestValues), La;
      }, ia.prototype.removeTransform = function(aa) {
        var da, La = createBox();
        copyBoxInto(La, aa);
        for (var qa = 0; qa < this.path.length; qa++) {
          var io = this.path[qa];
          if (io.instance && hasTransform(io.latestValues)) {
            hasScale(io.latestValues) && io.updateSnapshot();
            var ao = createBox(), oo = io.measure();
            copyBoxInto(ao, oo), removeBoxTransforms(La, io.latestValues, (da = io.snapshot) === null || da === void 0 ? void 0 : da.layout, ao);
          }
        }
        return hasTransform(this.latestValues) && removeBoxTransforms(La, this.latestValues), La;
      }, ia.prototype.setTargetDelta = function(aa) {
        this.targetDelta = aa, this.root.scheduleUpdateProjection();
      }, ia.prototype.setOptions = function(aa) {
        var da;
        this.options = __assign(__assign(__assign({}, this.options), aa), { crossfade: (da = aa.crossfade) !== null && da !== void 0 ? da : !0 });
      }, ia.prototype.clearMeasurements = function() {
        this.scroll = void 0, this.layout = void 0, this.snapshot = void 0, this.prevTransformTemplateValue = void 0, this.targetDelta = void 0, this.target = void 0, this.isLayoutDirty = !1;
      }, ia.prototype.resolveTargetDelta = function() {
        var aa, da = this.options, La = da.layout, qa = da.layoutId;
        !this.layout || !(La || qa) || (!this.targetDelta && !this.relativeTarget && (this.relativeParent = this.getClosestProjectingParent(), this.relativeParent && this.relativeParent.layout && (this.relativeTarget = createBox(), this.relativeTargetOrigin = createBox(), calcRelativePosition(this.relativeTargetOrigin, this.layout.actual, this.relativeParent.layout.actual), copyBoxInto(this.relativeTarget, this.relativeTargetOrigin))), !(!this.relativeTarget && !this.targetDelta) && (this.target || (this.target = createBox(), this.targetWithTransforms = createBox()), this.relativeTarget && this.relativeTargetOrigin && (!((aa = this.relativeParent) === null || aa === void 0) && aa.target) ? calcRelativeBox(this.target, this.relativeTarget, this.relativeParent.target) : this.targetDelta ? (this.resumingFrom ? this.target = this.applyTransform(this.layout.actual) : copyBoxInto(this.target, this.layout.actual), applyBoxDelta(this.target, this.targetDelta)) : copyBoxInto(this.target, this.layout.actual), this.attemptToResolveRelativeTarget && (this.attemptToResolveRelativeTarget = !1, this.relativeParent = this.getClosestProjectingParent(), this.relativeParent && !!this.relativeParent.resumingFrom == !!this.resumingFrom && !this.relativeParent.options.layoutScroll && this.relativeParent.target && (this.relativeTarget = createBox(), this.relativeTargetOrigin = createBox(), calcRelativePosition(this.relativeTargetOrigin, this.target, this.relativeParent.target), copyBoxInto(this.relativeTarget, this.relativeTargetOrigin)))));
      }, ia.prototype.getClosestProjectingParent = function() {
        if (!(!this.parent || hasTransform(this.parent.latestValues)))
          return (this.parent.relativeTarget || this.parent.targetDelta) && this.parent.layout ? this.parent : this.parent.getClosestProjectingParent();
      }, ia.prototype.calcProjection = function() {
        var aa, da = this.options, La = da.layout, qa = da.layoutId;
        if (this.isTreeAnimating = !!(!((aa = this.parent) === null || aa === void 0) && aa.isTreeAnimating || this.currentAnimation || this.pendingAnimation), this.isTreeAnimating || (this.targetDelta = this.relativeTarget = void 0), !(!this.layout || !(La || qa))) {
          var io = this.getLead();
          copyBoxInto(this.layoutCorrected, this.layout.actual), applyTreeDeltas(this.layoutCorrected, this.treeScale, this.path, !!this.resumingFrom || this !== io);
          var ao = io.target;
          if (ao) {
            this.projectionDelta || (this.projectionDelta = createDelta(), this.projectionDeltaWithTransform = createDelta());
            var oo = this.treeScale.x, no = this.treeScale.y, lo = this.projectionTransform;
            calcBoxDelta(this.projectionDelta, this.layoutCorrected, ao, this.latestValues), this.projectionTransform = buildProjectionTransform(this.projectionDelta, this.treeScale), (this.projectionTransform !== lo || this.treeScale.x !== oo || this.treeScale.y !== no) && (this.hasProjected = !0, this.scheduleRender(), this.notifyListeners("projectionUpdate", ao));
          }
        }
      }, ia.prototype.hide = function() {
        this.isVisible = !1;
      }, ia.prototype.show = function() {
        this.isVisible = !0;
      }, ia.prototype.scheduleRender = function(aa) {
        var da, La, qa;
        aa === void 0 && (aa = !0), (La = (da = this.options).scheduleRender) === null || La === void 0 || La.call(da), aa && ((qa = this.getStack()) === null || qa === void 0 || qa.scheduleRender()), this.resumingFrom && !this.resumingFrom.instance && (this.resumingFrom = void 0);
      }, ia.prototype.setAnimationOrigin = function(aa, da) {
        var La = this, qa;
        da === void 0 && (da = !1);
        var io = this.snapshot, ao = io?.latestValues || {}, oo = __assign({}, this.latestValues), no = createDelta();
        this.relativeTarget = this.relativeTargetOrigin = void 0, this.attemptToResolveRelativeTarget = !da;
        var lo = createBox(), so = io?.isShared, bs = (((qa = this.getStack()) === null || qa === void 0 ? void 0 : qa.members.length) || 0) <= 1, Rs = !!(so && !bs && this.options.crossfade === !0 && !this.path.some(hasOpacityCrossfade));
        this.animationProgress = 0, this.mixTargetDelta = function(js) {
          var qs, jo = js / 1e3;
          mixAxisDelta(no.x, aa.x, jo), mixAxisDelta(no.y, aa.y, jo), La.setTargetDelta(no), La.relativeTarget && La.relativeTargetOrigin && La.layout && (!((qs = La.relativeParent) === null || qs === void 0) && qs.layout) && (calcRelativePosition(lo, La.layout.actual, La.relativeParent.layout.actual), mixBox(La.relativeTarget, La.relativeTargetOrigin, lo, jo)), so && (La.animationValues = oo, mixValues(oo, ao, La.latestValues, jo, Rs, bs)), La.root.scheduleUpdateProjection(), La.scheduleRender(), La.animationProgress = jo;
        }, this.mixTargetDelta(0);
      }, ia.prototype.startAnimation = function(aa) {
        var da = this, La, qa;
        this.notifyListeners("animationStart"), (La = this.currentAnimation) === null || La === void 0 || La.stop(), this.resumingFrom && ((qa = this.resumingFrom.currentAnimation) === null || qa === void 0 || qa.stop()), this.pendingAnimation && (cancelSync.update(this.pendingAnimation), this.pendingAnimation = void 0), this.pendingAnimation = sync.update(function() {
          globalProjectionState.hasAnimatedSinceResize = !0, da.currentAnimation = animate(0, animationTarget, __assign(__assign({}, aa), { onUpdate: function(io) {
            var ao;
            da.mixTargetDelta(io), (ao = aa.onUpdate) === null || ao === void 0 || ao.call(aa, io);
          }, onComplete: function() {
            var io;
            (io = aa.onComplete) === null || io === void 0 || io.call(aa), da.completeAnimation();
          } })), da.resumingFrom && (da.resumingFrom.currentAnimation = da.currentAnimation), da.pendingAnimation = void 0;
        });
      }, ia.prototype.completeAnimation = function() {
        var aa;
        this.resumingFrom && (this.resumingFrom.currentAnimation = void 0, this.resumingFrom.preserveOpacity = void 0), (aa = this.getStack()) === null || aa === void 0 || aa.exitAnimationComplete(), this.resumingFrom = this.currentAnimation = this.animationValues = void 0, this.notifyListeners("animationComplete");
      }, ia.prototype.finishAnimation = function() {
        var aa;
        this.currentAnimation && ((aa = this.mixTargetDelta) === null || aa === void 0 || aa.call(this, animationTarget), this.currentAnimation.stop()), this.completeAnimation();
      }, ia.prototype.applyTransformsToTarget = function() {
        var aa = this.getLead(), da = aa.targetWithTransforms, La = aa.target, qa = aa.layout, io = aa.latestValues;
        !da || !La || !qa || (copyBoxInto(da, La), transformBox(da, io), calcBoxDelta(this.projectionDeltaWithTransform, this.layoutCorrected, da, io));
      }, ia.prototype.registerSharedNode = function(aa, da) {
        var La, qa, io;
        this.sharedNodes.has(aa) || this.sharedNodes.set(aa, new NodeStack());
        var ao = this.sharedNodes.get(aa);
        ao.add(da), da.promote({
          transition: (La = da.options.initialPromotionConfig) === null || La === void 0 ? void 0 : La.transition,
          preserveFollowOpacity: (io = (qa = da.options.initialPromotionConfig) === null || qa === void 0 ? void 0 : qa.shouldPreserveFollowOpacity) === null || io === void 0 ? void 0 : io.call(qa, da)
        });
      }, ia.prototype.isLead = function() {
        var aa = this.getStack();
        return aa ? aa.lead === this : !0;
      }, ia.prototype.getLead = function() {
        var aa, da = this.options.layoutId;
        return da ? ((aa = this.getStack()) === null || aa === void 0 ? void 0 : aa.lead) || this : this;
      }, ia.prototype.getPrevLead = function() {
        var aa, da = this.options.layoutId;
        return da ? (aa = this.getStack()) === null || aa === void 0 ? void 0 : aa.prevLead : void 0;
      }, ia.prototype.getStack = function() {
        var aa = this.options.layoutId;
        if (aa)
          return this.root.sharedNodes.get(aa);
      }, ia.prototype.promote = function(aa) {
        var da = aa === void 0 ? {} : aa, La = da.needsReset, qa = da.transition, io = da.preserveFollowOpacity, ao = this.getStack();
        ao && ao.promote(this, io), La && (this.projectionDelta = void 0, this.needsReset = !0), qa && this.setOptions({ transition: qa });
      }, ia.prototype.relegate = function() {
        var aa = this.getStack();
        return aa ? aa.relegate(this) : !1;
      }, ia.prototype.resetRotation = function() {
        var aa = this.options.visualElement;
        if (aa) {
          for (var da = !1, La = {}, qa = 0; qa < transformAxes.length; qa++) {
            var io = transformAxes[qa], ao = "rotate" + io;
            aa.getStaticValue(ao) && (da = !0, La[ao] = aa.getStaticValue(ao), aa.setStaticValue(ao, 0));
          }
          if (da) {
            aa?.syncRender();
            for (var ao in La)
              aa.setStaticValue(ao, La[ao]);
            aa.scheduleRender();
          }
        }
      }, ia.prototype.getProjectionStyles = function(aa) {
        var da, La, qa, io, ao, oo;
        aa === void 0 && (aa = {});
        var no = {};
        if (!this.instance || this.isSVG)
          return no;
        if (this.isVisible)
          no.visibility = "";
        else
          return { visibility: "hidden" };
        var lo = (da = this.options.visualElement) === null || da === void 0 ? void 0 : da.getProps().transformTemplate;
        if (this.needsReset)
          return this.needsReset = !1, no.opacity = "", no.pointerEvents = resolveMotionValue(aa.pointerEvents) || "", no.transform = lo ? lo(this.latestValues, "") : "none", no;
        var so = this.getLead();
        if (!this.projectionDelta || !this.layout || !so.target) {
          var bs = {};
          return this.options.layoutId && (bs.opacity = (La = this.latestValues.opacity) !== null && La !== void 0 ? La : 1, bs.pointerEvents = resolveMotionValue(aa.pointerEvents) || ""), this.hasProjected && !hasTransform(this.latestValues) && (bs.transform = lo ? lo({}, "") : "none", this.hasProjected = !1), bs;
        }
        var Rs = so.animationValues || so.latestValues;
        this.applyTransformsToTarget(), no.transform = buildProjectionTransform(this.projectionDeltaWithTransform, this.treeScale, Rs), lo && (no.transform = lo(Rs, no.transform));
        var js = this.projectionDelta, qs = js.x, jo = js.y;
        no.transformOrigin = "".concat(qs.origin * 100, "% ").concat(jo.origin * 100, "% 0"), so.animationValues ? no.opacity = so === this ? (io = (qa = Rs.opacity) !== null && qa !== void 0 ? qa : this.latestValues.opacity) !== null && io !== void 0 ? io : 1 : this.preserveOpacity ? this.latestValues.opacity : Rs.opacityExit : no.opacity = so === this ? (ao = Rs.opacity) !== null && ao !== void 0 ? ao : "" : (oo = Rs.opacityExit) !== null && oo !== void 0 ? oo : 0;
        for (var fs in scaleCorrectors)
          if (Rs[fs] !== void 0) {
            var Ao = scaleCorrectors[fs], co = Ao.correct, Co = Ao.applyTo, Zs = co(Rs[fs], so);
            if (Co)
              for (var xl = Co.length, Cl = 0; Cl < xl; Cl++)
                no[Co[Cl]] = Zs;
            else
              no[fs] = Zs;
          }
        return this.options.layoutId && (no.pointerEvents = so === this ? resolveMotionValue(aa.pointerEvents) || "" : "none"), no;
      }, ia.prototype.clearSnapshot = function() {
        this.resumeFrom = this.snapshot = void 0;
      }, ia.prototype.resetTree = function() {
        this.root.nodes.forEach(function(aa) {
          var da;
          return (da = aa.currentAnimation) === null || da === void 0 ? void 0 : da.stop();
        }), this.root.nodes.forEach(clearMeasurements), this.root.sharedNodes.clear();
      }, ia;
    }()
  );
}
function updateLayout(Bi) {
  Bi.updateLayout();
}
function notifyLayoutUpdate(Bi) {
  var e, Ui, Zi, ta, na = (Ui = (e = Bi.resumeFrom) === null || e === void 0 ? void 0 : e.snapshot) !== null && Ui !== void 0 ? Ui : Bi.snapshot;
  if (Bi.isLead() && Bi.layout && na && Bi.hasListeners("didUpdate")) {
    var ia = Bi.layout, aa = ia.actual, da = ia.measured;
    Bi.options.animationType === "size" ? eachAxis(function(Rs) {
      var js = na.isShared ? na.measured[Rs] : na.layout[Rs], qs = calcLength(js);
      js.min = aa[Rs].min, js.max = js.min + qs;
    }) : Bi.options.animationType === "position" && eachAxis(function(Rs) {
      var js = na.isShared ? na.measured[Rs] : na.layout[Rs], qs = calcLength(aa[Rs]);
      js.max = js.min + qs;
    });
    var La = createDelta();
    calcBoxDelta(La, aa, na.layout);
    var qa = createDelta();
    na.isShared ? calcBoxDelta(qa, Bi.applyTransform(da, !0), na.measured) : calcBoxDelta(qa, aa, na.layout);
    var io = !isDeltaZero(La), ao = !1;
    if (!Bi.resumeFrom && (Bi.relativeParent = Bi.getClosestProjectingParent(), Bi.relativeParent && !Bi.relativeParent.resumeFrom)) {
      var oo = Bi.relativeParent, no = oo.snapshot, lo = oo.layout;
      if (no && lo) {
        var so = createBox();
        calcRelativePosition(so, na.layout, no.layout);
        var bs = createBox();
        calcRelativePosition(bs, aa, lo.actual), boxEquals(so, bs) || (ao = !0);
      }
    }
    Bi.notifyListeners("didUpdate", {
      layout: aa,
      snapshot: na,
      delta: qa,
      layoutDelta: La,
      hasLayoutChanged: io,
      hasRelativeTargetChanged: ao
    });
  } else Bi.isLead() && ((ta = (Zi = Bi.options).onExitComplete) === null || ta === void 0 || ta.call(Zi));
  Bi.options.transition = void 0;
}
function clearSnapshot(Bi) {
  Bi.clearSnapshot();
}
function clearMeasurements(Bi) {
  Bi.clearMeasurements();
}
function resetTransformStyle(Bi) {
  var e = Bi.options.visualElement;
  e?.getProps().onBeforeLayoutMeasure && e.notifyBeforeLayoutMeasure(), Bi.resetTransform();
}
function finishAnimation(Bi) {
  Bi.finishAnimation(), Bi.targetDelta = Bi.relativeTarget = Bi.target = void 0;
}
function resolveTargetDelta(Bi) {
  Bi.resolveTargetDelta();
}
function calcProjection(Bi) {
  Bi.calcProjection();
}
function resetRotation(Bi) {
  Bi.resetRotation();
}
function removeLeadSnapshots(Bi) {
  Bi.removeLeadSnapshot();
}
function mixAxisDelta(Bi, e, Ui) {
  Bi.translate = mix(e.translate, 0, Ui), Bi.scale = mix(e.scale, 1, Ui), Bi.origin = e.origin, Bi.originPoint = e.originPoint;
}
function mixAxis(Bi, e, Ui, Zi) {
  Bi.min = mix(e.min, Ui.min, Zi), Bi.max = mix(e.max, Ui.max, Zi);
}
function mixBox(Bi, e, Ui, Zi) {
  mixAxis(Bi.x, e.x, Ui.x, Zi), mixAxis(Bi.y, e.y, Ui.y, Zi);
}
function hasOpacityCrossfade(Bi) {
  return Bi.animationValues && Bi.animationValues.opacityExit !== void 0;
}
var defaultLayoutTransition = {
  duration: 0.45,
  ease: [0.4, 0, 0.1, 1]
};
function mountNodeEarly(Bi, e) {
  for (var Ui = Bi.root, Zi = Bi.path.length - 1; Zi >= 0; Zi--)
    if (Bi.path[Zi].instance) {
      Ui = Bi.path[Zi];
      break;
    }
  var ta = Ui && Ui !== Bi.root ? Ui.instance : document, na = ta.querySelector('[data-projection-id="'.concat(e, '"]'));
  na && Bi.mount(na, !0);
}
function roundAxis(Bi) {
  Bi.min = Math.round(Bi.min), Bi.max = Math.round(Bi.max);
}
function roundBox(Bi) {
  roundAxis(Bi.x), roundAxis(Bi.y);
}
var DocumentProjectionNode = createProjectionNode({
  attachResizeListener: function(Bi, e) {
    return addDomEvent(Bi, "resize", e);
  },
  measureScroll: function() {
    return {
      x: document.documentElement.scrollLeft || document.body.scrollLeft,
      y: document.documentElement.scrollTop || document.body.scrollTop
    };
  },
  checkIsScrollRoot: function() {
    return !0;
  }
}), rootProjectionNode = {
  current: void 0
}, HTMLProjectionNode = createProjectionNode({
  measureScroll: function(Bi) {
    return {
      x: Bi.scrollLeft,
      y: Bi.scrollTop
    };
  },
  defaultParent: function() {
    if (!rootProjectionNode.current) {
      var Bi = new DocumentProjectionNode(0, {});
      Bi.mount(window), Bi.setOptions({ layoutScroll: !0 }), rootProjectionNode.current = Bi;
    }
    return rootProjectionNode.current;
  },
  resetTransform: function(Bi, e) {
    Bi.style.transform = e ?? "none";
  },
  checkIsScrollRoot: function(Bi) {
    return window.getComputedStyle(Bi).position === "fixed";
  }
}), featureBundle = __assign(__assign(__assign(__assign({}, animations), gestureAnimations), drag), layoutFeatures), motion = /* @__PURE__ */ createMotionProxy(function(Bi, e) {
  return createDomMotionConfig(Bi, e, featureBundle, createDomVisualElement, HTMLProjectionNode);
});
function useIsMounted() {
  var Bi = useRef(!1);
  return useIsomorphicLayoutEffect$1(function() {
    return Bi.current = !0, function() {
      Bi.current = !1;
    };
  }, []), Bi;
}
function useForceUpdate() {
  var Bi = useIsMounted(), e = __read(useState(0), 2), Ui = e[0], Zi = e[1], ta = useCallback(function() {
    Bi.current && Zi(Ui + 1);
  }, [Ui]), na = useCallback(function() {
    return sync.postRender(ta);
  }, [ta]);
  return [na, Ui];
}
var PresenceChild = function(Bi) {
  var e = Bi.children, Ui = Bi.initial, Zi = Bi.isPresent, ta = Bi.onExitComplete, na = Bi.custom, ia = Bi.presenceAffectsLayout, aa = useConstant(newChildrenMap), da = useId(), La = useMemo(
    function() {
      return {
        id: da,
        initial: Ui,
        isPresent: Zi,
        custom: na,
        onExitComplete: function(qa) {
          var io, ao;
          aa.set(qa, !0);
          try {
            for (var oo = __values(aa.values()), no = oo.next(); !no.done; no = oo.next()) {
              var lo = no.value;
              if (!lo)
                return;
            }
          } catch (so) {
            io = { error: so };
          } finally {
            try {
              no && !no.done && (ao = oo.return) && ao.call(oo);
            } finally {
              if (io) throw io.error;
            }
          }
          ta?.();
        },
        register: function(qa) {
          return aa.set(qa, !1), function() {
            return aa.delete(qa);
          };
        }
      };
    },
    /**
     * If the presence of a child affects the layout of the components around it,
     * we want to make a new context value to ensure they get re-rendered
     * so they can detect that layout change.
     */
    ia ? void 0 : [Zi]
  );
  return useMemo(function() {
    aa.forEach(function(qa, io) {
      return aa.set(io, !1);
    });
  }, [Zi]), a$8.useEffect(function() {
    !Zi && !aa.size && ta?.();
  }, [Zi]), a$8.createElement(PresenceContext.Provider, { value: La }, e);
};
function newChildrenMap() {
  return /* @__PURE__ */ new Map();
}
var getChildKey = function(Bi) {
  return Bi.key || "";
};
function updateChildLookup(Bi, e) {
  Bi.forEach(function(Ui) {
    var Zi = getChildKey(Ui);
    e.set(Zi, Ui);
  });
}
function onlyElements(Bi) {
  var e = [];
  return Children.forEach(Bi, function(Ui) {
    isValidElement(Ui) && e.push(Ui);
  }), e;
}
var AnimatePresence = function(Bi) {
  var e = Bi.children, Ui = Bi.custom, Zi = Bi.initial, ta = Zi === void 0 ? !0 : Zi, na = Bi.onExitComplete, ia = Bi.exitBeforeEnter, aa = Bi.presenceAffectsLayout, da = aa === void 0 ? !0 : aa, La = __read(useForceUpdate(), 1), qa = La[0], io = useContext(LayoutGroupContext).forceRender;
  io && (qa = io);
  var ao = useIsMounted(), oo = onlyElements(e), no = oo, lo = /* @__PURE__ */ new Set(), so = useRef(no), bs = useRef(/* @__PURE__ */ new Map()).current, Rs = useRef(!0);
  if (useIsomorphicLayoutEffect$1(function() {
    Rs.current = !1, updateChildLookup(oo, bs), so.current = no;
  }), useUnmountEffect(function() {
    Rs.current = !0, bs.clear(), lo.clear();
  }), Rs.current)
    return a$8.createElement(a$8.Fragment, null, no.map(function(co) {
      return a$8.createElement(PresenceChild, { key: getChildKey(co), isPresent: !0, initial: ta ? void 0 : !1, presenceAffectsLayout: da }, co);
    }));
  no = __spreadArray([], __read(no), !1);
  for (var js = so.current.map(getChildKey), qs = oo.map(getChildKey), jo = js.length, fs = 0; fs < jo; fs++) {
    var Ao = js[fs];
    qs.indexOf(Ao) === -1 && lo.add(Ao);
  }
  return ia && lo.size && (no = []), lo.forEach(function(co) {
    if (qs.indexOf(co) === -1) {
      var Co = bs.get(co);
      if (Co) {
        var Zs = js.indexOf(co), xl = function() {
          bs.delete(co), lo.delete(co);
          var Cl = so.current.findIndex(function(Al) {
            return Al.key === co;
          });
          if (so.current.splice(Cl, 1), !lo.size) {
            if (so.current = oo, ao.current === !1)
              return;
            qa(), na && na();
          }
        };
        no.splice(Zs, 0, a$8.createElement(PresenceChild, { key: getChildKey(Co), isPresent: !1, onExitComplete: xl, custom: Ui, presenceAffectsLayout: da }, Co));
      }
    }
  }), no = no.map(function(co) {
    var Co = co.key;
    return lo.has(Co) ? co : a$8.createElement(PresenceChild, { key: getChildKey(co), isPresent: !0, presenceAffectsLayout: da }, co);
  }), env !== "production" && ia && no.length > 1 && console.warn("You're attempting to animate multiple children within AnimatePresence, but its exitBeforeEnter prop is set to true. This will lead to odd visual behaviour."), a$8.createElement(a$8.Fragment, null, lo.size ? no : no.map(function(co) {
    return cloneElement(co);
  }));
}, DeprecatedLayoutGroupContext = createContext(null), notify = function(Bi) {
  return !Bi.isLayoutDirty && Bi.willUpdate(!1);
};
function nodeGroup() {
  var Bi = /* @__PURE__ */ new Set(), e = /* @__PURE__ */ new WeakMap(), Ui = function() {
    return Bi.forEach(notify);
  };
  return {
    add: function(Zi) {
      Bi.add(Zi), e.set(Zi, Zi.addEventListener("willUpdate", Ui));
    },
    remove: function(Zi) {
      var ta;
      Bi.delete(Zi), (ta = e.get(Zi)) === null || ta === void 0 || ta(), e.delete(Zi), Ui();
    },
    dirty: Ui
  };
}
var shouldInheritGroup = function(Bi) {
  return Bi === !0;
}, shouldInheritId = function(Bi) {
  return shouldInheritGroup(Bi === !0) || Bi === "id";
}, LayoutGroup = function(Bi) {
  var e, Ui, Zi = Bi.children, ta = Bi.id, na = Bi.inheritId, ia = Bi.inherit, aa = ia === void 0 ? !0 : ia;
  na !== void 0 && (aa = na);
  var da = useContext(LayoutGroupContext), La = useContext(DeprecatedLayoutGroupContext), qa = __read(useForceUpdate(), 2), io = qa[0], ao = qa[1], oo = useRef(null), no = (e = da.id) !== null && e !== void 0 ? e : La;
  oo.current === null && (shouldInheritId(aa) && no && (ta = ta ? no + "-" + ta : no), oo.current = {
    id: ta,
    group: shouldInheritGroup(aa) && (Ui = da?.group) !== null && Ui !== void 0 ? Ui : nodeGroup()
  });
  var lo = useMemo(function() {
    return __assign(__assign({}, oo.current), { forceRender: io });
  }, [ao]);
  return a$8.createElement(LayoutGroupContext.Provider, { value: lo }, Zi);
}, id = 0, AnimateSharedLayout = function(Bi) {
  var e = Bi.children;
  return a$8.useEffect(function() {
    warning$1(!1, "AnimateSharedLayout is deprecated: https://www.framer.com/docs/guide-upgrade/##shared-layout-animations");
  }, []), a$8.createElement(LayoutGroup, { id: useConstant(function() {
    return "asl-".concat(id++);
  }) }, e);
};
const exit = {
  y: "-200%",
  top: "50%",
  left: "50%",
  x: "-50%"
}, initial = {
  y: "-50%",
  top: "50%",
  left: "50%",
  x: "-50%"
}, Delete = ({ onDelete: Bi, className: e = "" }) => {
  const [Ui, Zi] = useState(!1);
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(
    motion.button,
    {
      layout: !0,
      className: `${e} relative cursor-pointer bg-red-400 focus:ring-red-400 hover:bg-red-500 disabled:bg-red-400 z-0 px-4 py-2 text-sm text-white transition-all rounded-lg focus:outline-none focus:ring-2 focus:ring-opacity-75 disabled:opacity-50 disabled:cursor-default`,
      children: [
        /* @__PURE__ */ jsxRuntimeExports.jsx("p", { className: "opacity-0", children: Ui ? "Sure?" : "Delete" }),
        /* @__PURE__ */ jsxRuntimeExports.jsx(AnimatePresence, { children: /* @__PURE__ */ jsxRuntimeExports.jsx(
          motion.p,
          {
            className: "absolute text-white",
            onClick: () => Zi(!0),
            exit,
            initial,
            children: !Ui && "Delete"
          }
        ) }),
        /* @__PURE__ */ jsxRuntimeExports.jsx(AnimatePresence, { children: Ui && /* @__PURE__ */ jsxRuntimeExports.jsx(
          motion.p,
          {
            className: "absolute text-white",
            onClick: () => Bi(),
            initial: { y: "200%", top: "50%", left: "50%", x: "-50%" },
            animate: { y: "-50%", top: "50%", left: "50%", x: "-50%" },
            children: "Sure?"
          }
        ) })
      ]
    }
  );
}, Divider = () => /* @__PURE__ */ jsxRuntimeExports.jsx("hr", { className: "w-full h-px border-t-neutral-600" }), containerStyles$1 = cva(
  [
    "w-48",
    "h-screen",
    "fixed",
    "top-0",
    "left-[100vw]",
    "bg-white",
    "transition-transform"
  ],
  {
    variants: {
      visible: {
        true: "-translate-x-full",
        false: ""
      }
    }
  }
), Drawer = ({
  visible: Bi,
  children: e,
  onClose: Ui
}) => /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [
  Bi && /* @__PURE__ */ jsxRuntimeExports.jsx(
    "div",
    {
      className: "fixed top-0 left-0 w-screen h-screen bg-black opacity-50",
      onClick: () => Ui()
    }
  ),
  /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: containerStyles$1({ visible: Bi }), children: e })
] }), size = 16, DrawerButton = ({
  sideBarVisible: Bi,
  onClick: e,
  className: Ui = ""
}) => /* @__PURE__ */ jsxRuntimeExports.jsxs(
  motion.svg,
  {
    className: `my-auto cursor-pointer ${Ui}`,
    width: size,
    height: size,
    viewBox: `0 0 ${size} ${size}`,
    animate: Bi ? "open" : "closed",
    onClick: () => e(),
    children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx(
        motion.path,
        {
          className: "fill-transparent stroke-2 stroke-white",
          variants: {
            closed: { d: `M 0 1 L ${size} 1` },
            open: { d: `M ${size} 0 L 0 ${size}` }
          }
        }
      ),
      /* @__PURE__ */ jsxRuntimeExports.jsx(
        motion.path,
        {
          className: "fill-transparent stroke-2 stroke-white",
          d: `M 0 ${size / 2} L ${size} ${size / 2}`,
          variants: {
            closed: { opacity: 1 },
            open: { opacity: 0 }
          },
          transition: { duration: 0.1 }
        }
      ),
      /* @__PURE__ */ jsxRuntimeExports.jsx(
        motion.path,
        {
          className: "fill-transparent stroke-2 stroke-white",
          variants: {
            closed: { d: `M 0 ${size - 1} L ${size} ${size - 1}` },
            open: { d: `M 0 0 L ${size} ${size}` }
          }
        }
      )
    ]
  }
), $f0a04ccd8dbdd83b$export$e5c5a5f917a5871c = typeof document < "u" ? a__default.useLayoutEffect : () => {
};
function $8ae05eaa5c114e9c$export$7f54fc3180508a52(Bi) {
  const e = useRef(null);
  return $f0a04ccd8dbdd83b$export$e5c5a5f917a5871c(() => {
    e.current = Bi;
  }, [
    Bi
  ]), useCallback((...Ui) => {
    const Zi = e.current;
    return Zi?.(...Ui);
  }, []);
}
function $1dbecbe27a04f9af$export$14d238f342723f25(Bi) {
  let [e, Ui] = useState(Bi), Zi = useRef(null), ta = $8ae05eaa5c114e9c$export$7f54fc3180508a52(() => {
    if (!Zi.current) return;
    let ia = Zi.current.next();
    if (ia.done) {
      Zi.current = null;
      return;
    }
    e === ia.value ? ta() : Ui(ia.value);
  });
  $f0a04ccd8dbdd83b$export$e5c5a5f917a5871c(() => {
    Zi.current && ta();
  });
  let na = $8ae05eaa5c114e9c$export$7f54fc3180508a52((ia) => {
    Zi.current = ia(e), ta();
  });
  return [
    e,
    na
  ];
}
const $b5e257d569688ac6$var$defaultContext = {
  prefix: String(Math.round(Math.random() * 1e10)),
  current: 0
}, $b5e257d569688ac6$var$SSRContext = /* @__PURE__ */ a__default.createContext($b5e257d569688ac6$var$defaultContext), $b5e257d569688ac6$var$IsSSRContext = /* @__PURE__ */ a__default.createContext(!1);
let $b5e257d569688ac6$var$canUseDOM = !!(typeof window < "u" && window.document && window.document.createElement), $b5e257d569688ac6$var$componentIds = /* @__PURE__ */ new WeakMap();
function $b5e257d569688ac6$var$useCounter(Bi = !1) {
  let e = useContext($b5e257d569688ac6$var$SSRContext), Ui = useRef(null);
  if (Ui.current === null && !Bi) {
    var Zi, ta;
    let na = (ta = a__default.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED) === null || ta === void 0 || (Zi = ta.ReactCurrentOwner) === null || Zi === void 0 ? void 0 : Zi.current;
    if (na) {
      let ia = $b5e257d569688ac6$var$componentIds.get(na);
      ia == null ? $b5e257d569688ac6$var$componentIds.set(na, {
        id: e.current,
        state: na.memoizedState
      }) : na.memoizedState !== ia.state && (e.current = ia.id, $b5e257d569688ac6$var$componentIds.delete(na));
    }
    Ui.current = ++e.current;
  }
  return Ui.current;
}
function $b5e257d569688ac6$var$useLegacySSRSafeId(Bi) {
  let e = useContext($b5e257d569688ac6$var$SSRContext);
  e === $b5e257d569688ac6$var$defaultContext && !$b5e257d569688ac6$var$canUseDOM && console.warn("When server rendering, you must wrap your application in an <SSRProvider> to ensure consistent ids are generated between the client and server.");
  let Ui = $b5e257d569688ac6$var$useCounter(!!Bi), Zi = e === $b5e257d569688ac6$var$defaultContext && process.env.NODE_ENV === "test" ? "react-aria" : `react-aria${e.prefix}`;
  return Bi || `${Zi}-${Ui}`;
}
function $b5e257d569688ac6$var$useModernSSRSafeId(Bi) {
  let e = a__default.useId(), [Ui] = useState($b5e257d569688ac6$export$535bd6ca7f90a273()), Zi = Ui || process.env.NODE_ENV === "test" ? "react-aria" : `react-aria${$b5e257d569688ac6$var$defaultContext.prefix}`;
  return Bi || `${Zi}-${e}`;
}
const $b5e257d569688ac6$export$619500959fc48b26 = typeof a__default.useId == "function" ? $b5e257d569688ac6$var$useModernSSRSafeId : $b5e257d569688ac6$var$useLegacySSRSafeId;
function $b5e257d569688ac6$var$getSnapshot() {
  return !1;
}
function $b5e257d569688ac6$var$getServerSnapshot() {
  return !0;
}
function $b5e257d569688ac6$var$subscribe(Bi) {
  return () => {
  };
}
function $b5e257d569688ac6$export$535bd6ca7f90a273() {
  return typeof a__default.useSyncExternalStore == "function" ? a__default.useSyncExternalStore($b5e257d569688ac6$var$subscribe, $b5e257d569688ac6$var$getSnapshot, $b5e257d569688ac6$var$getServerSnapshot) : useContext($b5e257d569688ac6$var$IsSSRContext);
}
let $bdb11010cef70236$var$canUseDOM = !!(typeof window < "u" && window.document && window.document.createElement), $bdb11010cef70236$var$idsUpdaterMap = /* @__PURE__ */ new Map();
function $bdb11010cef70236$export$f680877a34711e37(Bi) {
  let [e, Ui] = useState(Bi), Zi = useRef(null), ta = $b5e257d569688ac6$export$619500959fc48b26(e), na = useCallback((ia) => {
    Zi.current = ia;
  }, []);
  return $bdb11010cef70236$var$canUseDOM && ($bdb11010cef70236$var$idsUpdaterMap.has(ta) && !$bdb11010cef70236$var$idsUpdaterMap.get(ta).includes(na) ? $bdb11010cef70236$var$idsUpdaterMap.set(ta, [
    ...$bdb11010cef70236$var$idsUpdaterMap.get(ta),
    na
  ]) : $bdb11010cef70236$var$idsUpdaterMap.set(ta, [
    na
  ])), $f0a04ccd8dbdd83b$export$e5c5a5f917a5871c(() => {
    let ia = ta;
    return () => {
      $bdb11010cef70236$var$idsUpdaterMap.delete(ia);
    };
  }, [
    ta
  ]), useEffect(() => {
    let ia = Zi.current;
    ia && (Zi.current = null, Ui(ia));
  }), ta;
}
function $bdb11010cef70236$export$cd8c9cb68f842629(Bi, e) {
  if (Bi === e) return Bi;
  let Ui = $bdb11010cef70236$var$idsUpdaterMap.get(Bi);
  if (Ui)
    return Ui.forEach((ta) => ta(e)), e;
  let Zi = $bdb11010cef70236$var$idsUpdaterMap.get(e);
  return Zi ? (Zi.forEach((ta) => ta(Bi)), Bi) : e;
}
function $bdb11010cef70236$export$b4cc09c592e8fdb8(Bi = []) {
  let e = $bdb11010cef70236$export$f680877a34711e37(), [Ui, Zi] = $1dbecbe27a04f9af$export$14d238f342723f25(e), ta = useCallback(() => {
    Zi(function* () {
      yield e, yield document.getElementById(e) ? e : void 0;
    });
  }, [
    e,
    Zi
  ]);
  return $f0a04ccd8dbdd83b$export$e5c5a5f917a5871c(ta, [
    e,
    ta,
    ...Bi
  ]), Ui;
}
function $ff5963eb1fccf552$export$e08e3b67e392101e(...Bi) {
  return (...e) => {
    for (let Ui of Bi) typeof Ui == "function" && Ui(...e);
  };
}
const $431fbd86ca7dc216$export$b204af158042fbac = (Bi) => {
  var e;
  return (e = Bi?.ownerDocument) !== null && e !== void 0 ? e : document;
}, $431fbd86ca7dc216$export$f21a1ffae260145a = (Bi) => Bi && "window" in Bi && Bi.window === Bi ? Bi : $431fbd86ca7dc216$export$b204af158042fbac(Bi).defaultView || window;
function $3ef42575df84b30b$export$9d1611c77c2fe928(...Bi) {
  let e = {
    ...Bi[0]
  };
  for (let Ui = 1; Ui < Bi.length; Ui++) {
    let Zi = Bi[Ui];
    for (let ta in Zi) {
      let na = e[ta], ia = Zi[ta];
      typeof na == "function" && typeof ia == "function" && // This is a lot faster than a regex.
      ta[0] === "o" && ta[1] === "n" && ta.charCodeAt(2) >= /* 'A' */
      65 && ta.charCodeAt(2) <= /* 'Z' */
      90 ? e[ta] = $ff5963eb1fccf552$export$e08e3b67e392101e(na, ia) : (ta === "className" || ta === "UNSAFE_className") && typeof na == "string" && typeof ia == "string" ? e[ta] = clsx(na, ia) : ta === "id" && na && ia ? e.id = $bdb11010cef70236$export$cd8c9cb68f842629(na, ia) : e[ta] = ia !== void 0 ? ia : na;
    }
  }
  return e;
}
function $5dc95899b306f630$export$c9058316764c140e(...Bi) {
  return Bi.length === 1 && Bi[0] ? Bi[0] : (e) => {
    for (let Ui of Bi)
      typeof Ui == "function" ? Ui(e) : Ui != null && (Ui.current = e);
  };
}
const $65484d02dcb7eb3e$var$DOMPropNames = /* @__PURE__ */ new Set([
  "id"
]), $65484d02dcb7eb3e$var$labelablePropNames = /* @__PURE__ */ new Set([
  "aria-label",
  "aria-labelledby",
  "aria-describedby",
  "aria-details"
]), $65484d02dcb7eb3e$var$linkPropNames = /* @__PURE__ */ new Set([
  "href",
  "hrefLang",
  "target",
  "rel",
  "download",
  "ping",
  "referrerPolicy"
]), $65484d02dcb7eb3e$var$propRe = /^(data-.*)$/;
function $65484d02dcb7eb3e$export$457c3d6518dd4c6f(Bi, e = {}) {
  let { labelable: Ui, isLink: Zi, propNames: ta } = e, na = {};
  for (const ia in Bi) Object.prototype.hasOwnProperty.call(Bi, ia) && ($65484d02dcb7eb3e$var$DOMPropNames.has(ia) || Ui && $65484d02dcb7eb3e$var$labelablePropNames.has(ia) || Zi && $65484d02dcb7eb3e$var$linkPropNames.has(ia) || ta?.has(ia) || $65484d02dcb7eb3e$var$propRe.test(ia)) && (na[ia] = Bi[ia]);
  return na;
}
function $7215afc6de606d6b$export$de79e2c695e052f3(Bi) {
  if ($7215afc6de606d6b$var$supportsPreventScroll()) Bi.focus({
    preventScroll: !0
  });
  else {
    let e = $7215afc6de606d6b$var$getScrollableElements(Bi);
    Bi.focus(), $7215afc6de606d6b$var$restoreScrollPosition(e);
  }
}
let $7215afc6de606d6b$var$supportsPreventScrollCached = null;
function $7215afc6de606d6b$var$supportsPreventScroll() {
  if ($7215afc6de606d6b$var$supportsPreventScrollCached == null) {
    $7215afc6de606d6b$var$supportsPreventScrollCached = !1;
    try {
      document.createElement("div").focus({
        get preventScroll() {
          return $7215afc6de606d6b$var$supportsPreventScrollCached = !0, !0;
        }
      });
    } catch {
    }
  }
  return $7215afc6de606d6b$var$supportsPreventScrollCached;
}
function $7215afc6de606d6b$var$getScrollableElements(Bi) {
  let e = Bi.parentNode, Ui = [], Zi = document.scrollingElement || document.documentElement;
  for (; e instanceof HTMLElement && e !== Zi; )
    (e.offsetHeight < e.scrollHeight || e.offsetWidth < e.scrollWidth) && Ui.push({
      element: e,
      scrollTop: e.scrollTop,
      scrollLeft: e.scrollLeft
    }), e = e.parentNode;
  return Zi instanceof HTMLElement && Ui.push({
    element: Zi,
    scrollTop: Zi.scrollTop,
    scrollLeft: Zi.scrollLeft
  }), Ui;
}
function $7215afc6de606d6b$var$restoreScrollPosition(Bi) {
  for (let { element: e, scrollTop: Ui, scrollLeft: Zi } of Bi)
    e.scrollTop = Ui, e.scrollLeft = Zi;
}
function $c87311424ea30a05$var$testUserAgent(Bi) {
  var e;
  return typeof window > "u" || window.navigator == null ? !1 : ((e = window.navigator.userAgentData) === null || e === void 0 ? void 0 : e.brands.some((Ui) => Bi.test(Ui.brand))) || Bi.test(window.navigator.userAgent);
}
function $c87311424ea30a05$var$testPlatform(Bi) {
  var e;
  return typeof window < "u" && window.navigator != null ? Bi.test(((e = window.navigator.userAgentData) === null || e === void 0 ? void 0 : e.platform) || window.navigator.platform) : !1;
}
function $c87311424ea30a05$var$cached(Bi) {
  let e = null;
  return () => (e == null && (e = Bi()), e);
}
const $c87311424ea30a05$export$9ac100e40613ea10 = $c87311424ea30a05$var$cached(function() {
  return $c87311424ea30a05$var$testPlatform(/^Mac/i);
}), $c87311424ea30a05$export$186c6964ca17d99 = $c87311424ea30a05$var$cached(function() {
  return $c87311424ea30a05$var$testPlatform(/^iPhone/i);
}), $c87311424ea30a05$export$7bef049ce92e4224 = $c87311424ea30a05$var$cached(function() {
  return $c87311424ea30a05$var$testPlatform(/^iPad/i) || // iPadOS 13 lies and says it's a Mac, but we can distinguish by detecting touch support.
  $c87311424ea30a05$export$9ac100e40613ea10() && navigator.maxTouchPoints > 1;
}), $c87311424ea30a05$export$fedb369cb70207f1 = $c87311424ea30a05$var$cached(function() {
  return $c87311424ea30a05$export$186c6964ca17d99() || $c87311424ea30a05$export$7bef049ce92e4224();
}), $c87311424ea30a05$export$e1865c3bedcd822b = $c87311424ea30a05$var$cached(function() {
  return $c87311424ea30a05$export$9ac100e40613ea10() || $c87311424ea30a05$export$fedb369cb70207f1();
}), $c87311424ea30a05$export$78551043582a6a98 = $c87311424ea30a05$var$cached(function() {
  return $c87311424ea30a05$var$testUserAgent(/AppleWebKit/i) && !$c87311424ea30a05$export$6446a186d09e379e();
}), $c87311424ea30a05$export$6446a186d09e379e = $c87311424ea30a05$var$cached(function() {
  return $c87311424ea30a05$var$testUserAgent(/Chrome/i);
}), $c87311424ea30a05$export$a11b0059900ceec8 = $c87311424ea30a05$var$cached(function() {
  return $c87311424ea30a05$var$testUserAgent(/Android/i);
}), $c87311424ea30a05$export$b7d78993b74f766d = $c87311424ea30a05$var$cached(function() {
  return $c87311424ea30a05$var$testUserAgent(/Firefox/i);
}), $ea8dcbcb9ea1b556$var$RouterContext = /* @__PURE__ */ createContext({
  isNative: !0,
  open: $ea8dcbcb9ea1b556$var$openSyntheticLink,
  useHref: (Bi) => Bi
});
function $ea8dcbcb9ea1b556$export$9a302a45f65d0572() {
  return useContext($ea8dcbcb9ea1b556$var$RouterContext);
}
function $ea8dcbcb9ea1b556$export$95185d699e05d4d7(Bi, e, Ui = !0) {
  var Zi, ta;
  let { metaKey: na, ctrlKey: ia, altKey: aa, shiftKey: da } = e;
  $c87311424ea30a05$export$b7d78993b74f766d() && (!((ta = window.event) === null || ta === void 0 || (Zi = ta.type) === null || Zi === void 0) && Zi.startsWith("key")) && Bi.target === "_blank" && ($c87311424ea30a05$export$9ac100e40613ea10() ? na = !0 : ia = !0);
  let La = $c87311424ea30a05$export$78551043582a6a98() && $c87311424ea30a05$export$9ac100e40613ea10() && !$c87311424ea30a05$export$7bef049ce92e4224() ? new KeyboardEvent("keydown", {
    keyIdentifier: "Enter",
    metaKey: na,
    ctrlKey: ia,
    altKey: aa,
    shiftKey: da
  }) : new MouseEvent("click", {
    metaKey: na,
    ctrlKey: ia,
    altKey: aa,
    shiftKey: da,
    bubbles: !0,
    cancelable: !0
  });
  $ea8dcbcb9ea1b556$export$95185d699e05d4d7.isOpening = Ui, $7215afc6de606d6b$export$de79e2c695e052f3(Bi), Bi.dispatchEvent(La), $ea8dcbcb9ea1b556$export$95185d699e05d4d7.isOpening = !1;
}
$ea8dcbcb9ea1b556$export$95185d699e05d4d7.isOpening = !1;
function $ea8dcbcb9ea1b556$var$getSyntheticLink(Bi, e) {
  if (Bi instanceof HTMLAnchorElement) e(Bi);
  else if (Bi.hasAttribute("data-href")) {
    let Ui = document.createElement("a");
    Ui.href = Bi.getAttribute("data-href"), Bi.hasAttribute("data-target") && (Ui.target = Bi.getAttribute("data-target")), Bi.hasAttribute("data-rel") && (Ui.rel = Bi.getAttribute("data-rel")), Bi.hasAttribute("data-download") && (Ui.download = Bi.getAttribute("data-download")), Bi.hasAttribute("data-ping") && (Ui.ping = Bi.getAttribute("data-ping")), Bi.hasAttribute("data-referrer-policy") && (Ui.referrerPolicy = Bi.getAttribute("data-referrer-policy")), Bi.appendChild(Ui), e(Ui), Bi.removeChild(Ui);
  }
}
function $ea8dcbcb9ea1b556$var$openSyntheticLink(Bi, e) {
  $ea8dcbcb9ea1b556$var$getSyntheticLink(Bi, (Ui) => $ea8dcbcb9ea1b556$export$95185d699e05d4d7(Ui, e));
}
function $ea8dcbcb9ea1b556$export$7e924b3091a3bd18(Bi) {
  let e = $ea8dcbcb9ea1b556$export$9a302a45f65d0572();
  var Ui;
  const Zi = e.useHref((Ui = Bi?.href) !== null && Ui !== void 0 ? Ui : "");
  return {
    href: Bi?.href ? Zi : void 0,
    target: Bi?.target,
    rel: Bi?.rel,
    download: Bi?.download,
    ping: Bi?.ping,
    referrerPolicy: Bi?.referrerPolicy
  };
}
let $bbed8b41f857bcc0$var$transitionsByElement = /* @__PURE__ */ new Map(), $bbed8b41f857bcc0$var$transitionCallbacks = /* @__PURE__ */ new Set();
function $bbed8b41f857bcc0$var$setupGlobalEvents() {
  if (typeof window > "u") return;
  function Bi(Zi) {
    return "propertyName" in Zi;
  }
  let e = (Zi) => {
    if (!Bi(Zi) || !Zi.target) return;
    let ta = $bbed8b41f857bcc0$var$transitionsByElement.get(Zi.target);
    ta || (ta = /* @__PURE__ */ new Set(), $bbed8b41f857bcc0$var$transitionsByElement.set(Zi.target, ta), Zi.target.addEventListener("transitioncancel", Ui, {
      once: !0
    })), ta.add(Zi.propertyName);
  }, Ui = (Zi) => {
    if (!Bi(Zi) || !Zi.target) return;
    let ta = $bbed8b41f857bcc0$var$transitionsByElement.get(Zi.target);
    if (ta && (ta.delete(Zi.propertyName), ta.size === 0 && (Zi.target.removeEventListener("transitioncancel", Ui), $bbed8b41f857bcc0$var$transitionsByElement.delete(Zi.target)), $bbed8b41f857bcc0$var$transitionsByElement.size === 0)) {
      for (let na of $bbed8b41f857bcc0$var$transitionCallbacks) na();
      $bbed8b41f857bcc0$var$transitionCallbacks.clear();
    }
  };
  document.body.addEventListener("transitionrun", e), document.body.addEventListener("transitionend", Ui);
}
typeof document < "u" && (document.readyState !== "loading" ? $bbed8b41f857bcc0$var$setupGlobalEvents() : document.addEventListener("DOMContentLoaded", $bbed8b41f857bcc0$var$setupGlobalEvents));
function $bbed8b41f857bcc0$export$24490316f764c430(Bi) {
  requestAnimationFrame(() => {
    $bbed8b41f857bcc0$var$transitionsByElement.size === 0 ? Bi() : $bbed8b41f857bcc0$var$transitionCallbacks.add(Bi);
  });
}
function $03deb23ff14920c4$export$4eaf04e54aa8eed6() {
  let Bi = useRef(/* @__PURE__ */ new Map()), e = useCallback((ta, na, ia, aa) => {
    let da = aa?.once ? (...La) => {
      Bi.current.delete(ia), ia(...La);
    } : ia;
    Bi.current.set(ia, {
      type: na,
      eventTarget: ta,
      fn: da,
      options: aa
    }), ta.addEventListener(na, da, aa);
  }, []), Ui = useCallback((ta, na, ia, aa) => {
    var da;
    let La = ((da = Bi.current.get(ia)) === null || da === void 0 ? void 0 : da.fn) || ia;
    ta.removeEventListener(na, La, aa), Bi.current.delete(ia);
  }, []), Zi = useCallback(() => {
    Bi.current.forEach((ta, na) => {
      Ui(ta.eventTarget, ta.type, na, ta.options);
    });
  }, [
    Ui
  ]);
  return useEffect(() => Zi, [
    Zi
  ]), {
    addGlobalListener: e,
    removeGlobalListener: Ui,
    removeAllGlobalListeners: Zi
  };
}
function $313b98861ee5dd6c$export$d6875122194c7b44(Bi, e) {
  let { id: Ui, "aria-label": Zi, "aria-labelledby": ta } = Bi;
  return Ui = $bdb11010cef70236$export$f680877a34711e37(Ui), ta && Zi ? ta = [
    .../* @__PURE__ */ new Set([
      Ui,
      ...ta.trim().split(/\s+/)
    ])
  ].join(" ") : ta && (ta = ta.trim().split(/\s+/).join(" ")), !Zi && !ta && e && (Zi = e), {
    id: Ui,
    "aria-label": Zi,
    "aria-labelledby": ta
  };
}
function $df56164dff5785e2$export$4338b53315abf666(Bi) {
  const e = useRef(null);
  return useMemo(() => ({
    get current() {
      return e.current;
    },
    set current(Ui) {
      e.current = Ui, typeof Bi == "function" ? Bi(Ui) : Bi && (Bi.current = Ui);
    }
  }), [
    Bi
  ]);
}
function $ca9b37712f007381$export$72ef708ab07251f1(Bi, e) {
  const Ui = useRef(!0), Zi = useRef(null);
  $f0a04ccd8dbdd83b$export$e5c5a5f917a5871c(() => (Ui.current = !0, () => {
    Ui.current = !1;
  }), []), $f0a04ccd8dbdd83b$export$e5c5a5f917a5871c(() => {
    Ui.current ? Ui.current = !1 : (!Zi.current || e.some((ta, na) => !Object.is(ta, Zi[na]))) && Bi(), Zi.current = e;
  }, e);
}
function $9daab02d461809db$var$hasResizeObserver() {
  return typeof window.ResizeObserver < "u";
}
function $9daab02d461809db$export$683480f191c0e3ea(Bi) {
  const { ref: e, box: Ui, onResize: Zi } = Bi;
  useEffect(() => {
    let ta = e?.current;
    if (ta)
      if ($9daab02d461809db$var$hasResizeObserver()) {
        const na = new window.ResizeObserver((ia) => {
          ia.length && Zi();
        });
        return na.observe(ta, {
          box: Ui
        }), () => {
          ta && na.unobserve(ta);
        };
      } else
        return window.addEventListener("resize", Zi, !1), () => {
          window.removeEventListener("resize", Zi, !1);
        };
  }, [
    Zi,
    e,
    Ui
  ]);
}
function $e7801be82b4b2a53$export$4debdb1a3f0fa79e(Bi, e) {
  $f0a04ccd8dbdd83b$export$e5c5a5f917a5871c(() => {
    if (Bi && Bi.ref && e)
      return Bi.ref.current = e.current, () => {
        Bi.ref && (Bi.ref.current = null);
      };
  });
}
function $cc38e7bd3fc7b213$export$2bb74740c4e19def(Bi, e) {
  if (!Bi) return !1;
  let Ui = window.getComputedStyle(Bi), Zi = /(auto|scroll)/.test(Ui.overflow + Ui.overflowX + Ui.overflowY);
  return Zi && e && (Zi = Bi.scrollHeight !== Bi.clientHeight || Bi.scrollWidth !== Bi.clientWidth), Zi;
}
function $62d8ded9296f3872$export$cfa2225e87938781(Bi, e) {
  let Ui = Bi;
  for ($cc38e7bd3fc7b213$export$2bb74740c4e19def(Ui, e) && (Ui = Ui.parentElement); Ui && !$cc38e7bd3fc7b213$export$2bb74740c4e19def(Ui, e); ) Ui = Ui.parentElement;
  return Ui || document.scrollingElement || document.documentElement;
}
function $a40c673dc9f6d9c7$export$94ed1c92c7beeb22(Bi, e) {
  const Ui = [];
  for (; Bi && Bi !== document.documentElement; )
    $cc38e7bd3fc7b213$export$2bb74740c4e19def(Bi, e) && Ui.push(Bi), Bi = Bi.parentElement;
  return Ui;
}
let $ef06256079686ba0$var$descriptionId = 0;
const $ef06256079686ba0$var$descriptionNodes = /* @__PURE__ */ new Map();
function $ef06256079686ba0$export$f8aeda7b10753fa1(Bi) {
  let [e, Ui] = useState();
  return $f0a04ccd8dbdd83b$export$e5c5a5f917a5871c(() => {
    if (!Bi) return;
    let Zi = $ef06256079686ba0$var$descriptionNodes.get(Bi);
    if (Zi)
      Ui(Zi.element.id);
    else {
      let ta = `react-aria-description-${$ef06256079686ba0$var$descriptionId++}`;
      Ui(ta);
      let na = document.createElement("div");
      na.id = ta, na.style.display = "none", na.textContent = Bi, document.body.appendChild(na), Zi = {
        refCount: 0,
        element: na
      }, $ef06256079686ba0$var$descriptionNodes.set(Bi, Zi);
    }
    return Zi.refCount++, () => {
      Zi && --Zi.refCount === 0 && (Zi.element.remove(), $ef06256079686ba0$var$descriptionNodes.delete(Bi));
    };
  }, [
    Bi
  ]), {
    "aria-describedby": Bi ? e : void 0
  };
}
function $e9faafb641e167db$export$90fc3a17d93f704c(Bi, e, Ui, Zi) {
  let ta = $8ae05eaa5c114e9c$export$7f54fc3180508a52(Ui), na = Ui == null;
  useEffect(() => {
    if (na || !Bi.current) return;
    let ia = Bi.current;
    return ia.addEventListener(e, ta, Zi), () => {
      ia.removeEventListener(e, ta, Zi);
    };
  }, [
    Bi,
    e,
    Zi,
    na,
    ta
  ]);
}
function $2f04cbc44ee30ce0$export$53a0910f038337bd(Bi, e) {
  let Ui = $2f04cbc44ee30ce0$var$relativeOffset(Bi, e, "left"), Zi = $2f04cbc44ee30ce0$var$relativeOffset(Bi, e, "top"), ta = e.offsetWidth, na = e.offsetHeight, ia = Bi.scrollLeft, aa = Bi.scrollTop, { borderTopWidth: da, borderLeftWidth: La, scrollPaddingTop: qa, scrollPaddingRight: io, scrollPaddingBottom: ao, scrollPaddingLeft: oo } = getComputedStyle(Bi), no = ia + parseInt(La, 10), lo = aa + parseInt(da, 10), so = no + Bi.clientWidth, bs = lo + Bi.clientHeight, Rs = parseInt(qa, 10) || 0, js = parseInt(ao, 10) || 0, qs = parseInt(io, 10) || 0, jo = parseInt(oo, 10) || 0;
  Ui <= ia + jo ? ia = Ui - parseInt(La, 10) - jo : Ui + ta > so - qs && (ia += Ui + ta - so + qs), Zi <= lo + Rs ? aa = Zi - parseInt(da, 10) - Rs : Zi + na > bs - js && (aa += Zi + na - bs + js), Bi.scrollLeft = ia, Bi.scrollTop = aa;
}
function $2f04cbc44ee30ce0$var$relativeOffset(Bi, e, Ui) {
  const Zi = Ui === "left" ? "offsetLeft" : "offsetTop";
  let ta = 0;
  for (; e.offsetParent && (ta += e[Zi], e.offsetParent !== Bi); ) {
    if (e.offsetParent.contains(Bi)) {
      ta -= Bi[Zi];
      break;
    }
    e = e.offsetParent;
  }
  return ta;
}
function $2f04cbc44ee30ce0$export$c826860796309d1b(Bi, e) {
  if (Bi && document.contains(Bi)) {
    let ia = document.scrollingElement || document.documentElement;
    if (window.getComputedStyle(ia).overflow === "hidden") {
      let da = $a40c673dc9f6d9c7$export$94ed1c92c7beeb22(Bi);
      for (let La of da) $2f04cbc44ee30ce0$export$53a0910f038337bd(La, Bi);
    } else {
      var Ui;
      let { left: da, top: La } = Bi.getBoundingClientRect();
      Bi == null || (Ui = Bi.scrollIntoView) === null || Ui === void 0 || Ui.call(Bi, {
        block: "nearest"
      });
      let { left: qa, top: io } = Bi.getBoundingClientRect();
      if (Math.abs(da - qa) > 1 || Math.abs(La - io) > 1) {
        var Zi, ta, na;
        e == null || (ta = e.containingElement) === null || ta === void 0 || (Zi = ta.scrollIntoView) === null || Zi === void 0 || Zi.call(ta, {
          block: "center",
          inline: "center"
        }), (na = Bi.scrollIntoView) === null || na === void 0 || na.call(Bi, {
          block: "nearest"
        });
      }
    }
  }
}
function $6a7db85432448f7f$export$60278871457622de(Bi) {
  return Bi.mozInputSource === 0 && Bi.isTrusted ? !0 : $c87311424ea30a05$export$a11b0059900ceec8() && Bi.pointerType ? Bi.type === "click" && Bi.buttons === 1 : Bi.detail === 0 && !Bi.pointerType;
}
function $6a7db85432448f7f$export$29bf1b5f2c56cf63(Bi) {
  return !$c87311424ea30a05$export$a11b0059900ceec8() && Bi.width === 0 && Bi.height === 0 || Bi.width === 1 && Bi.height === 1 && Bi.pressure === 0 && Bi.detail === 0 && Bi.pointerType === "mouse";
}
function $99facab73266f662$export$5add1d006293d136(Bi, e, Ui) {
  let Zi = useRef(e), ta = $8ae05eaa5c114e9c$export$7f54fc3180508a52(() => {
    Ui && Ui(Zi.current);
  });
  useEffect(() => {
    var na;
    let ia = Bi == null || (na = Bi.current) === null || na === void 0 ? void 0 : na.form;
    return ia?.addEventListener("reset", ta), () => {
      ia?.removeEventListener("reset", ta);
    };
  }, [
    Bi,
    ta
  ]);
}
const $5671b20cf9b562b2$export$447a38995de2c711 = "react-aria-clear-focus", $5671b20cf9b562b2$export$831c820ad60f9d12 = "react-aria-focus", $5671b20cf9b562b2$export$9db568f6321ad9dc = "react-aria-update-activedescendant";
function $21f1aa98acb08317$export$16792effe837dba3(Bi) {
  return $c87311424ea30a05$export$9ac100e40613ea10() ? Bi.metaKey : Bi.ctrlKey;
}
function $d3f049242431219c$export$6d3443f2c48bfc20(Bi, e = !0) {
  let [Ui, Zi] = useState(!0), ta = Ui && e;
  return $f0a04ccd8dbdd83b$export$e5c5a5f917a5871c(() => {
    if (ta && Bi.current && "getAnimations" in Bi.current)
      for (let na of Bi.current.getAnimations()) na instanceof CSSTransition && na.cancel();
  }, [
    Bi,
    ta
  ]), $d3f049242431219c$var$useAnimation(Bi, ta, useCallback(() => Zi(!1), [])), ta;
}
function $d3f049242431219c$export$45fda7c47f93fd48(Bi, e) {
  let [Ui, Zi] = useState(e ? "open" : "closed");
  switch (Ui) {
    case "open":
      e || Zi("exiting");
      break;
    case "closed":
    case "exiting":
      e && Zi("open");
      break;
  }
  let ta = Ui === "exiting";
  return $d3f049242431219c$var$useAnimation(Bi, ta, useCallback(() => {
    Zi((na) => na === "exiting" ? "closed" : na);
  }, [])), ta;
}
function $d3f049242431219c$var$useAnimation(Bi, e, Ui) {
  $f0a04ccd8dbdd83b$export$e5c5a5f917a5871c(() => {
    if (e && Bi.current) {
      if (!("getAnimations" in Bi.current)) {
        Ui();
        return;
      }
      let Zi = Bi.current.getAnimations();
      if (Zi.length === 0) {
        Ui();
        return;
      }
      let ta = !1;
      return Promise.all(Zi.map((na) => na.finished)).then(() => {
        ta || flushSync$1(() => {
          Ui();
        });
      }).catch(() => {
      }), () => {
        ta = !0;
      };
    }
  }, [
    Bi,
    e,
    Ui
  ]);
}
function $458b0a5536c1a7cf$export$40bfa8c7b0832715(Bi, e, Ui) {
  let [Zi, ta] = useState(Bi || e), na = useRef(Bi !== void 0), ia = Bi !== void 0;
  useEffect(() => {
    let La = na.current;
    La !== ia && console.warn(`WARN: A component changed from ${La ? "controlled" : "uncontrolled"} to ${ia ? "controlled" : "uncontrolled"}.`), na.current = ia;
  }, [
    ia
  ]);
  let aa = ia ? Bi : Zi, da = useCallback((La, ...qa) => {
    let io = (ao, ...oo) => {
      Ui && (Object.is(aa, ao) || Ui(ao, ...oo)), ia || (aa = ao);
    };
    typeof La == "function" ? (console.warn("We can not support a function callback. See Github Issues for details https://github.com/adobe/react-spectrum/issues/2320"), ta((oo, ...no) => {
      let lo = La(ia ? aa : oo, ...no);
      return io(lo, ...qa), ia ? oo : lo;
    })) : (ia || ta(La), io(La, ...qa));
  }, [
    ia,
    aa,
    Ui
  ]);
  return [
    aa,
    da
  ];
}
function $9446cca9a3875146$export$7d15b64cf5a3a4c4(Bi, e = -1 / 0, Ui = 1 / 0) {
  return Math.min(Math.max(Bi, e), Ui);
}
const $64fa3d84918910a7$export$c62b8e45d58ddad9 = Symbol("default");
function $64fa3d84918910a7$export$2881499e37b75b9a({ values: Bi, children: e }) {
  for (let [Ui, Zi] of Bi)
    e = /* @__PURE__ */ a__default.createElement(Ui.Provider, {
      value: Zi
    }, e);
  return e;
}
function $64fa3d84918910a7$export$4d86445c2cf5e3(Bi) {
  let { className: e, style: Ui, children: Zi, defaultClassName: ta, defaultChildren: na, defaultStyle: ia, values: aa } = Bi;
  return useMemo(() => {
    let da, La, qa;
    return typeof e == "function" ? da = e({
      ...aa,
      defaultClassName: ta
    }) : da = e, typeof Ui == "function" ? La = Ui({
      ...aa,
      defaultStyle: ia || {}
    }) : La = Ui, typeof Zi == "function" ? qa = Zi({
      ...aa,
      defaultChildren: na
    }) : Zi == null ? qa = na : qa = Zi, {
      className: da ?? ta,
      style: La || ia ? {
        ...ia,
        ...La
      } : void 0,
      children: qa ?? na,
      "data-rac": ""
    };
  }, [
    e,
    Ui,
    Zi,
    ta,
    na,
    ia,
    aa
  ]);
}
function $64fa3d84918910a7$export$fabf2dc03a41866e(Bi, e) {
  let Ui = useContext(Bi);
  if (e === null)
    return null;
  if (Ui && typeof Ui == "object" && "slots" in Ui && Ui.slots) {
    let Zi = new Intl.ListFormat().format(Object.keys(Ui.slots).map((na) => `"${na}"`));
    if (!e && !Ui.slots[$64fa3d84918910a7$export$c62b8e45d58ddad9]) throw new Error(`A slot prop is required. Valid slot names are ${Zi}.`);
    let ta = e || $64fa3d84918910a7$export$c62b8e45d58ddad9;
    if (!Ui.slots[ta])
      throw new Error(`Invalid slot "${e}". Valid slot names are ${Zi}.`);
    return Ui.slots[ta];
  }
  return Ui;
}
function $64fa3d84918910a7$export$29f1550f4b0d4415(Bi, e, Ui) {
  let Zi = $64fa3d84918910a7$export$fabf2dc03a41866e(Ui, Bi.slot) || {}, { ref: ta, ...na } = Zi, ia = $df56164dff5785e2$export$4338b53315abf666(useMemo(() => $5dc95899b306f630$export$c9058316764c140e(e, ta), [
    e,
    ta
  ])), aa = $3ef42575df84b30b$export$9d1611c77c2fe928(na, Bi);
  return "style" in na && na.style && "style" in Bi && Bi.style && (typeof na.style == "function" || typeof Bi.style == "function" ? aa.style = (da) => {
    let La = typeof na.style == "function" ? na.style(da) : na.style, qa = {
      ...da.defaultStyle,
      ...La
    }, io = typeof Bi.style == "function" ? Bi.style({
      ...da,
      defaultStyle: qa
    }) : Bi.style;
    return {
      ...qa,
      ...io
    };
  } : aa.style = {
    ...na.style,
    ...Bi.style
  }), [
    aa,
    ia
  ];
}
function $64fa3d84918910a7$export$9d4c57ee4c6ffdd8() {
  let [Bi, e] = useState(!0), Ui = useRef(!1), Zi = useCallback((ta) => {
    Ui.current = !0, e(!!ta);
  }, []);
  return $f0a04ccd8dbdd83b$export$e5c5a5f917a5871c(() => {
    Ui.current || e(!1);
  }, []), [
    Zi,
    Bi
  ];
}
function $64fa3d84918910a7$export$ef03459518577ad4(Bi) {
  const e = /^(data-.*)$/;
  let Ui = {};
  for (const Zi in Bi) e.test(Zi) || (Ui[Zi] = Bi[Zi]);
  return Ui;
}
class $23b9f4fcf0fe224b$export$d68d59712b04d9d1 {
  get childNodes() {
    throw new Error("childNodes is not supported");
  }
  clone() {
    let e = new $23b9f4fcf0fe224b$export$d68d59712b04d9d1(this.type, this.key);
    return e.value = this.value, e.level = this.level, e.hasChildNodes = this.hasChildNodes, e.rendered = this.rendered, e.textValue = this.textValue, e["aria-label"] = this["aria-label"], e.index = this.index, e.parentKey = this.parentKey, e.prevKey = this.prevKey, e.nextKey = this.nextKey, e.firstChildKey = this.firstChildKey, e.lastChildKey = this.lastChildKey, e.props = this.props, e.render = this.render, e;
  }
  constructor(e, Ui) {
    this.value = null, this.level = 0, this.hasChildNodes = !1, this.rendered = null, this.textValue = "", this["aria-label"] = void 0, this.index = 0, this.parentKey = null, this.prevKey = null, this.nextKey = null, this.firstChildKey = null, this.lastChildKey = null, this.props = {}, this.type = e, this.key = Ui;
  }
}
class $23b9f4fcf0fe224b$export$408d25a4e12db025 {
  get size() {
    return this.keyMap.size;
  }
  getKeys() {
    return this.keyMap.keys();
  }
  *[Symbol.iterator]() {
    let e = this.firstKey != null ? this.keyMap.get(this.firstKey) : void 0;
    for (; e; )
      yield e, e = e.nextKey != null ? this.keyMap.get(e.nextKey) : void 0;
  }
  getChildren(e) {
    let Ui = this.keyMap;
    return {
      *[Symbol.iterator]() {
        let Zi = Ui.get(e), ta = Zi?.firstChildKey != null ? Ui.get(Zi.firstChildKey) : null;
        for (; ta; )
          yield ta, ta = ta.nextKey != null ? Ui.get(ta.nextKey) : void 0;
      }
    };
  }
  getKeyBefore(e) {
    let Ui = this.keyMap.get(e);
    if (!Ui) return null;
    if (Ui.prevKey != null) {
      for (Ui = this.keyMap.get(Ui.prevKey); Ui && Ui.type !== "item" && Ui.lastChildKey != null; ) Ui = this.keyMap.get(Ui.lastChildKey);
      var Zi;
      return (Zi = Ui?.key) !== null && Zi !== void 0 ? Zi : null;
    }
    return Ui.parentKey;
  }
  getKeyAfter(e) {
    let Ui = this.keyMap.get(e);
    if (!Ui) return null;
    if (Ui.type !== "item" && Ui.firstChildKey != null) return Ui.firstChildKey;
    for (; Ui; ) {
      if (Ui.nextKey != null) return Ui.nextKey;
      if (Ui.parentKey != null) Ui = this.keyMap.get(Ui.parentKey);
      else return null;
    }
    return null;
  }
  getFirstKey() {
    return this.firstKey;
  }
  getLastKey() {
    let e = this.lastKey != null ? this.keyMap.get(this.lastKey) : null;
    for (; e?.lastChildKey != null; ) e = this.keyMap.get(e.lastChildKey);
    var Ui;
    return (Ui = e?.key) !== null && Ui !== void 0 ? Ui : null;
  }
  getItem(e) {
    var Ui;
    return (Ui = this.keyMap.get(e)) !== null && Ui !== void 0 ? Ui : null;
  }
  at() {
    throw new Error("Not implemented");
  }
  clone() {
    let e = this.constructor, Ui = new e();
    return Ui.keyMap = new Map(this.keyMap), Ui.firstKey = this.firstKey, Ui.lastKey = this.lastKey, Ui;
  }
  addNode(e) {
    if (this.frozen) throw new Error("Cannot add a node to a frozen collection");
    this.keyMap.set(e.key, e);
  }
  removeNode(e) {
    if (this.frozen) throw new Error("Cannot remove a node to a frozen collection");
    this.keyMap.delete(e);
  }
  commit(e, Ui, Zi = !1) {
    if (this.frozen) throw new Error("Cannot commit a frozen collection");
    this.firstKey = e, this.lastKey = Ui, this.frozen = !Zi;
  }
  // TODO: this is pretty specific to menu, will need to check if it is generic enough
  // Will need to handle varying levels I assume but will revisit after I get searchable menu working for base menu
  // TODO: an alternative is to simply walk the collection and add all item nodes that match the filter and any sections/separators we encounter
  // to an array, then walk that new array and fix all the next/Prev keys while adding them to the new collection
  filter(e) {
    let Ui = new $23b9f4fcf0fe224b$export$408d25a4e12db025(), Zi = null;
    for (let ta of this)
      if (ta.type === "section" && ta.hasChildNodes) {
        let na = ta.clone(), ia = null;
        for (let aa of this.getChildren(ta.key)) if (e(aa.textValue) || aa.type === "header") {
          let da = aa.clone();
          ia == null && (na.firstChildKey = da.key), Ui.firstKey == null && (Ui.firstKey = na.key), ia && ia.parentKey === da.parentKey ? (ia.nextKey = da.key, da.prevKey = ia.key) : da.prevKey = null, da.nextKey = null, Ui.addNode(da), ia = da;
        }
        ia && (ia.type !== "header" ? (na.lastChildKey = ia.key, Zi == null ? na.prevKey = null : (Zi.type === "section" || Zi.type === "separator") && (Zi.nextKey = na.key, na.prevKey = Zi.key), na.nextKey = null, Zi = na, Ui.addNode(na)) : (Ui.firstKey === na.key && (Ui.firstKey = null), Ui.removeNode(ia.key)));
      } else if (ta.type === "separator") {
        let na = ta.clone();
        na.nextKey = null, Zi?.type === "section" && (Zi.nextKey = na.key, na.prevKey = Zi.key, Zi = na, Ui.addNode(na));
      } else if (e(ta.textValue)) {
        let na = ta.clone();
        Ui.firstKey == null && (Ui.firstKey = na.key), Zi != null && Zi.type !== "section" && Zi.type !== "separator" && Zi.parentKey === na.parentKey ? (Zi.nextKey = na.key, na.prevKey = Zi.key) : na.prevKey = null, na.nextKey = null, Ui.addNode(na), Zi = na;
      }
    if (Zi?.type === "separator" && Zi.nextKey === null) {
      let ta;
      Zi.prevKey != null && (ta = Ui.getItem(Zi.prevKey), ta.nextKey = null), Ui.removeNode(Zi.key), Zi = ta;
    }
    return Ui.lastKey = Zi?.key || null, Ui;
  }
  constructor() {
    this.keyMap = /* @__PURE__ */ new Map(), this.firstKey = null, this.lastKey = null, this.frozen = !1;
  }
}
class $681cc3c98f569e39$export$410b0c854570d131 {
  *[Symbol.iterator]() {
    let e = this.firstChild;
    for (; e; )
      yield e, e = e.nextSibling;
  }
  get firstChild() {
    return this._firstChild;
  }
  set firstChild(e) {
    this._firstChild = e, this.ownerDocument.markDirty(this);
  }
  get lastChild() {
    return this._lastChild;
  }
  set lastChild(e) {
    this._lastChild = e, this.ownerDocument.markDirty(this);
  }
  get previousSibling() {
    return this._previousSibling;
  }
  set previousSibling(e) {
    this._previousSibling = e, this.ownerDocument.markDirty(this);
  }
  get nextSibling() {
    return this._nextSibling;
  }
  set nextSibling(e) {
    this._nextSibling = e, this.ownerDocument.markDirty(this);
  }
  get parentNode() {
    return this._parentNode;
  }
  set parentNode(e) {
    this._parentNode = e, this.ownerDocument.markDirty(this);
  }
  get isConnected() {
    var e;
    return ((e = this.parentNode) === null || e === void 0 ? void 0 : e.isConnected) || !1;
  }
  appendChild(e) {
    this.ownerDocument.startTransaction(), e.parentNode && e.parentNode.removeChild(e), this.firstChild == null && (this.firstChild = e), this.lastChild ? (this.lastChild.nextSibling = e, e.index = this.lastChild.index + 1, e.previousSibling = this.lastChild) : (e.previousSibling = null, e.index = 0), e.parentNode = this, e.nextSibling = null, this.lastChild = e, this.ownerDocument.markDirty(this), e.hasSetProps && this.ownerDocument.addNode(e), this.ownerDocument.endTransaction(), this.ownerDocument.queueUpdate();
  }
  insertBefore(e, Ui) {
    if (Ui == null) return this.appendChild(e);
    this.ownerDocument.startTransaction(), e.parentNode && e.parentNode.removeChild(e), e.nextSibling = Ui, e.previousSibling = Ui.previousSibling, e.index = Ui.index, this.firstChild === Ui ? this.firstChild = e : Ui.previousSibling && (Ui.previousSibling.nextSibling = e), Ui.previousSibling = e, e.parentNode = Ui.parentNode;
    let Zi = Ui;
    for (; Zi; )
      Zi.index++, Zi = Zi.nextSibling;
    e.hasSetProps && this.ownerDocument.addNode(e), this.ownerDocument.endTransaction(), this.ownerDocument.queueUpdate();
  }
  removeChild(e) {
    if (e.parentNode !== this || !this.ownerDocument.isMounted) return;
    this.ownerDocument.startTransaction();
    let Ui = e.nextSibling;
    for (; Ui; )
      Ui.index--, Ui = Ui.nextSibling;
    e.nextSibling && (e.nextSibling.previousSibling = e.previousSibling), e.previousSibling && (e.previousSibling.nextSibling = e.nextSibling), this.firstChild === e && (this.firstChild = e.nextSibling), this.lastChild === e && (this.lastChild = e.previousSibling), e.parentNode = null, e.nextSibling = null, e.previousSibling = null, e.index = 0, this.ownerDocument.removeNode(e), this.ownerDocument.endTransaction(), this.ownerDocument.queueUpdate();
  }
  addEventListener() {
  }
  removeEventListener() {
  }
  constructor(e) {
    this._firstChild = null, this._lastChild = null, this._previousSibling = null, this._nextSibling = null, this._parentNode = null, this.ownerDocument = e;
  }
}
class $681cc3c98f569e39$export$dc064fe9e59310fd extends $681cc3c98f569e39$export$410b0c854570d131 {
  get index() {
    return this._index;
  }
  set index(e) {
    this._index = e, this.ownerDocument.markDirty(this);
  }
  get level() {
    return this.parentNode instanceof $681cc3c98f569e39$export$dc064fe9e59310fd ? this.parentNode.level + (this.node.type === "item" ? 1 : 0) : 0;
  }
  updateNode() {
    var e, Ui, Zi, ta;
    let na = this.ownerDocument.getMutableNode(this);
    na.index = this.index, na.level = this.level, na.parentKey = this.parentNode instanceof $681cc3c98f569e39$export$dc064fe9e59310fd ? this.parentNode.node.key : null;
    var ia;
    na.prevKey = (ia = (e = this.previousSibling) === null || e === void 0 ? void 0 : e.node.key) !== null && ia !== void 0 ? ia : null;
    var aa;
    na.nextKey = (aa = (Ui = this.nextSibling) === null || Ui === void 0 ? void 0 : Ui.node.key) !== null && aa !== void 0 ? aa : null, na.hasChildNodes = !!this.firstChild;
    var da;
    na.firstChildKey = (da = (Zi = this.firstChild) === null || Zi === void 0 ? void 0 : Zi.node.key) !== null && da !== void 0 ? da : null;
    var La;
    na.lastChildKey = (La = (ta = this.lastChild) === null || ta === void 0 ? void 0 : ta.node.key) !== null && La !== void 0 ? La : null;
  }
  setProps(e, Ui, Zi, ta) {
    let na = this.ownerDocument.getMutableNode(this), { value: ia, textValue: aa, id: da, ...La } = e;
    if (La.ref = Ui, na.props = La, na.rendered = Zi, na.render = ta, na.value = ia, na.textValue = aa || (typeof La.children == "string" ? La.children : "") || e["aria-label"] || "", da != null && da !== na.key) {
      if (this.hasSetProps) throw new Error("Cannot change the id of an item");
      na.key = da;
    }
    this.hasSetProps || (this.ownerDocument.addNode(this), this.ownerDocument.endTransaction(), this.hasSetProps = !0), this.ownerDocument.queueUpdate();
  }
  get style() {
    return {};
  }
  hasAttribute() {
  }
  setAttribute() {
  }
  setAttributeNS() {
  }
  removeAttribute() {
  }
  constructor(e, Ui) {
    super(Ui), this.nodeType = 8, this._index = 0, this.hasSetProps = !1, this.node = new $23b9f4fcf0fe224b$export$d68d59712b04d9d1(e, `react-aria-${++Ui.nodeId}`), this.ownerDocument.startTransaction();
  }
}
class $681cc3c98f569e39$export$b34a105447964f9f extends $681cc3c98f569e39$export$410b0c854570d131 {
  get isConnected() {
    return this.isMounted;
  }
  createElement(e) {
    return new $681cc3c98f569e39$export$dc064fe9e59310fd(e, this);
  }
  /**
  * Lazily gets a mutable instance of a Node. If the node has already
  * been cloned during this update cycle, it just returns the existing one.
  */
  getMutableNode(e) {
    let Ui = e.node;
    return this.mutatedNodes.has(e) || (Ui = e.node.clone(), this.mutatedNodes.add(e), e.node = Ui), this.markDirty(e), Ui;
  }
  getMutableCollection() {
    return !this.isSSR && !this.collectionMutated && (this.collection = this.collection.clone(), this.collectionMutated = !0), this.collection;
  }
  markDirty(e) {
    this.dirtyNodes.add(e);
  }
  startTransaction() {
    this.transactionCount++;
  }
  endTransaction() {
    this.transactionCount--;
  }
  addNode(e) {
    let Ui = this.getMutableCollection();
    if (!Ui.getItem(e.node.key)) {
      Ui.addNode(e.node);
      for (let Zi of e) this.addNode(Zi);
    }
    this.markDirty(e);
  }
  removeNode(e) {
    for (let Zi of e) this.removeNode(Zi);
    this.getMutableCollection().removeNode(e.node.key), this.markDirty(e);
  }
  /** Finalizes the collection update, updating all nodes and freezing the collection. */
  getCollection() {
    return this.transactionCount > 0 ? this.collection : (this.updateCollection(), this.collection);
  }
  updateCollection() {
    for (let na of this.dirtyNodes) na instanceof $681cc3c98f569e39$export$dc064fe9e59310fd && na.isConnected && na.updateNode();
    if (this.dirtyNodes.clear(), this.mutatedNodes.size || this.collectionMutated) {
      var e, Ui;
      let na = this.getMutableCollection();
      for (let ia of this.mutatedNodes) ia.isConnected && na.addNode(ia.node);
      var Zi, ta;
      na.commit((Zi = (e = this.firstChild) === null || e === void 0 ? void 0 : e.node.key) !== null && Zi !== void 0 ? Zi : null, (ta = (Ui = this.lastChild) === null || Ui === void 0 ? void 0 : Ui.node.key) !== null && ta !== void 0 ? ta : null, this.isSSR), this.mutatedNodes.clear();
    }
    this.collectionMutated = !1;
  }
  queueUpdate() {
    if (!(this.dirtyNodes.size === 0 || this.transactionCount > 0))
      for (let e of this.subscriptions) e();
  }
  subscribe(e) {
    return this.subscriptions.add(e), () => this.subscriptions.delete(e);
  }
  resetAfterSSR() {
    this.isSSR && (this.isSSR = !1, this.firstChild = null, this.lastChild = null, this.nodeId = 0);
  }
  constructor(e) {
    super(null), this.nodeType = 11, this.ownerDocument = this, this.dirtyNodes = /* @__PURE__ */ new Set(), this.isSSR = !1, this.nodeId = 0, this.nodesByProps = /* @__PURE__ */ new WeakMap(), this.isMounted = !0, this.mutatedNodes = /* @__PURE__ */ new Set(), this.subscriptions = /* @__PURE__ */ new Set(), this.transactionCount = 0, this.collection = e, this.collectionMutated = !0;
  }
}
function $e948873055cbafe4$export$727c8fc270210f13(Bi) {
  let { children: e, items: Ui, idScope: Zi, addIdAndValue: ta, dependencies: na = [] } = Bi, ia = useMemo(() => /* @__PURE__ */ new WeakMap(), na);
  return useMemo(() => {
    if (Ui && typeof e == "function") {
      let La = [];
      for (let qa of Ui) {
        let io = ia.get(qa);
        if (!io) {
          io = e(qa);
          var aa, da;
          let ao = (da = (aa = io.props.id) !== null && aa !== void 0 ? aa : qa.key) !== null && da !== void 0 ? da : qa.id;
          if (ao == null) throw new Error("Could not determine key for item");
          Zi && (ao = Zi + ":" + ao), io = cloneElement(io, ta ? {
            key: ao,
            id: ao,
            value: qa
          } : {
            key: ao
          }), ia.set(qa, io);
        }
        La.push(io);
      }
      return La;
    } else if (typeof e != "function") return e;
  }, [
    e,
    Ui,
    ia,
    Zi,
    ta
  ]);
}
if (typeof HTMLTemplateElement < "u") {
  const Bi = Object.getOwnPropertyDescriptor(Node.prototype, "firstChild").get;
  Object.defineProperty(HTMLTemplateElement.prototype, "firstChild", {
    configurable: !0,
    enumerable: !0,
    get: function() {
      return this.dataset.reactAriaHidden ? this.content.firstChild : Bi.call(this);
    }
  });
}
const $f39a9eba43920ace$export$94b6d0abf7d33e8c = /* @__PURE__ */ createContext(!1), $f39a9eba43920ace$var$hiddenFragment = typeof DocumentFragment < "u" ? new DocumentFragment() : null;
function $f39a9eba43920ace$export$8dc98ba7eadeaa56(Bi) {
  let e = useContext($f39a9eba43920ace$export$94b6d0abf7d33e8c), Ui = $b5e257d569688ac6$export$535bd6ca7f90a273();
  if (e)
    return /* @__PURE__ */ a__default.createElement(a__default.Fragment, null, Bi.children);
  let Zi = /* @__PURE__ */ a__default.createElement($f39a9eba43920ace$export$94b6d0abf7d33e8c.Provider, {
    value: !0
  }, Bi.children);
  return Ui ? /* @__PURE__ */ a__default.createElement("template", {
    "data-react-aria-hidden": !0
  }, Zi) : /* @__PURE__ */ createPortal(Zi, $f39a9eba43920ace$var$hiddenFragment);
}
function $f39a9eba43920ace$export$86427a43e3e48ebb(Bi) {
  let e = (Ui, Zi) => useContext($f39a9eba43920ace$export$94b6d0abf7d33e8c) ? null : Bi(Ui, Zi);
  return e.displayName = Bi.displayName || Bi.name, forwardRef(e);
}
function $f39a9eba43920ace$export$b5d7cc18bb8d2b59() {
  return useContext($f39a9eba43920ace$export$94b6d0abf7d33e8c);
}
var shim = { exports: {} }, useSyncExternalStoreShim_production = {};
/**
 * @license React
 * use-sync-external-store-shim.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var hasRequiredUseSyncExternalStoreShim_production;
function requireUseSyncExternalStoreShim_production() {
  if (hasRequiredUseSyncExternalStoreShim_production) return useSyncExternalStoreShim_production;
  hasRequiredUseSyncExternalStoreShim_production = 1;
  var Bi = a__default;
  function e(io, ao) {
    return io === ao && (io !== 0 || 1 / io === 1 / ao) || io !== io && ao !== ao;
  }
  var Ui = typeof Object.is == "function" ? Object.is : e, Zi = Bi.useState, ta = Bi.useEffect, na = Bi.useLayoutEffect, ia = Bi.useDebugValue;
  function aa(io, ao) {
    var oo = ao(), no = Zi({ inst: { value: oo, getSnapshot: ao } }), lo = no[0].inst, so = no[1];
    return na(
      function() {
        lo.value = oo, lo.getSnapshot = ao, da(lo) && so({ inst: lo });
      },
      [io, oo, ao]
    ), ta(
      function() {
        return da(lo) && so({ inst: lo }), io(function() {
          da(lo) && so({ inst: lo });
        });
      },
      [io]
    ), ia(oo), oo;
  }
  function da(io) {
    var ao = io.getSnapshot;
    io = io.value;
    try {
      var oo = ao();
      return !Ui(io, oo);
    } catch {
      return !0;
    }
  }
  function La(io, ao) {
    return ao();
  }
  var qa = typeof window > "u" || typeof window.document > "u" || typeof window.document.createElement > "u" ? La : aa;
  return useSyncExternalStoreShim_production.useSyncExternalStore = Bi.useSyncExternalStore !== void 0 ? Bi.useSyncExternalStore : qa, useSyncExternalStoreShim_production;
}
var useSyncExternalStoreShim_development = {};
/**
 * @license React
 * use-sync-external-store-shim.development.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var hasRequiredUseSyncExternalStoreShim_development;
function requireUseSyncExternalStoreShim_development() {
  return hasRequiredUseSyncExternalStoreShim_development || (hasRequiredUseSyncExternalStoreShim_development = 1, process.env.NODE_ENV !== "production" && function() {
    function Bi(oo, no) {
      return oo === no && (oo !== 0 || 1 / oo === 1 / no) || oo !== oo && no !== no;
    }
    function e(oo, no) {
      qa || ta.startTransition === void 0 || (qa = !0, console.error(
        "You are using an outdated, pre-release alpha of React 18 that does not support useSyncExternalStore. The use-sync-external-store shim will not work correctly. Upgrade to a newer pre-release."
      ));
      var lo = no();
      if (!io) {
        var so = no();
        na(lo, so) || (console.error(
          "The result of getSnapshot should be cached to avoid an infinite loop"
        ), io = !0);
      }
      so = ia({
        inst: { value: lo, getSnapshot: no }
      });
      var bs = so[0].inst, Rs = so[1];
      return da(
        function() {
          bs.value = lo, bs.getSnapshot = no, Ui(bs) && Rs({ inst: bs });
        },
        [oo, lo, no]
      ), aa(
        function() {
          return Ui(bs) && Rs({ inst: bs }), oo(function() {
            Ui(bs) && Rs({ inst: bs });
          });
        },
        [oo]
      ), La(lo), lo;
    }
    function Ui(oo) {
      var no = oo.getSnapshot;
      oo = oo.value;
      try {
        var lo = no();
        return !na(oo, lo);
      } catch {
        return !0;
      }
    }
    function Zi(oo, no) {
      return no();
    }
    typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart == "function" && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart(Error());
    var ta = a__default, na = typeof Object.is == "function" ? Object.is : Bi, ia = ta.useState, aa = ta.useEffect, da = ta.useLayoutEffect, La = ta.useDebugValue, qa = !1, io = !1, ao = typeof window > "u" || typeof window.document > "u" || typeof window.document.createElement > "u" ? Zi : e;
    useSyncExternalStoreShim_development.useSyncExternalStore = ta.useSyncExternalStore !== void 0 ? ta.useSyncExternalStore : ao, typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop == "function" && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop(Error());
  }()), useSyncExternalStoreShim_development;
}
var hasRequiredShim;
function requireShim() {
  return hasRequiredShim || (hasRequiredShim = 1, process.env.NODE_ENV === "production" ? shim.exports = requireUseSyncExternalStoreShim_production() : shim.exports = requireUseSyncExternalStoreShim_development()), shim.exports;
}
var shimExports = requireShim();
const $e1995378a142960e$var$ShallowRenderContext = /* @__PURE__ */ createContext(!1), $e1995378a142960e$var$CollectionDocumentContext = /* @__PURE__ */ createContext(null);
function $e1995378a142960e$export$bf788dd355e3a401(Bi) {
  if (useContext($e1995378a142960e$var$CollectionDocumentContext))
    return Bi.content;
  let { collection: Ui, document: Zi } = $e1995378a142960e$var$useCollectionDocument(Bi.createCollection);
  return /* @__PURE__ */ a__default.createElement(a__default.Fragment, null, /* @__PURE__ */ a__default.createElement($f39a9eba43920ace$export$8dc98ba7eadeaa56, null, /* @__PURE__ */ a__default.createElement($e1995378a142960e$var$CollectionDocumentContext.Provider, {
    value: Zi
  }, Bi.content)), /* @__PURE__ */ a__default.createElement($e1995378a142960e$var$CollectionInner, {
    render: Bi.children,
    collection: Ui
  }));
}
function $e1995378a142960e$var$CollectionInner({ collection: Bi, render: e }) {
  return e(Bi);
}
function $e1995378a142960e$var$useSyncExternalStoreFallback(Bi, e, Ui) {
  let Zi = $b5e257d569688ac6$export$535bd6ca7f90a273(), ta = useRef(Zi);
  ta.current = Zi;
  let na = useCallback(() => ta.current ? Ui() : e(), [
    e,
    Ui
  ]);
  return shimExports.useSyncExternalStore(Bi, na);
}
const $e1995378a142960e$var$useSyncExternalStore = typeof a__default.useSyncExternalStore == "function" ? a__default.useSyncExternalStore : $e1995378a142960e$var$useSyncExternalStoreFallback;
function $e1995378a142960e$var$useCollectionDocument(Bi) {
  let [e] = useState(() => new $681cc3c98f569e39$export$b34a105447964f9f(Bi?.() || new $23b9f4fcf0fe224b$export$408d25a4e12db025())), Ui = useCallback((ia) => e.subscribe(ia), [
    e
  ]), Zi = useCallback(() => {
    let ia = e.getCollection();
    return e.isSSR && e.resetAfterSSR(), ia;
  }, [
    e
  ]), ta = useCallback(() => (e.isSSR = !0, e.getCollection()), [
    e
  ]), na = $e1995378a142960e$var$useSyncExternalStore(Ui, Zi, ta);
  return $f0a04ccd8dbdd83b$export$e5c5a5f917a5871c(() => (e.isMounted = !0, () => {
    e.isMounted = !1;
  }), [
    e
  ]), {
    collection: na,
    document: e
  };
}
const $e1995378a142960e$var$SSRContext = /* @__PURE__ */ createContext(null);
function $e1995378a142960e$var$useSSRCollectionNode(Bi, e, Ui, Zi, ta, na) {
  let ia = useCallback((da) => {
    da?.setProps(e, Ui, Zi, na);
  }, [
    e,
    Ui,
    Zi,
    na
  ]), aa = useContext($e1995378a142960e$var$SSRContext);
  if (aa) {
    let da = aa.ownerDocument.nodesByProps.get(e);
    return da || (da = aa.ownerDocument.createElement(Bi), da.setProps(e, Ui, Zi, na), aa.appendChild(da), aa.ownerDocument.updateCollection(), aa.ownerDocument.nodesByProps.set(e, da)), ta ? /* @__PURE__ */ a__default.createElement($e1995378a142960e$var$SSRContext.Provider, {
      value: da
    }, ta) : null;
  }
  return /* @__PURE__ */ a__default.createElement(Bi, {
    ref: ia
  }, ta);
}
function $e1995378a142960e$export$18af5c7a9e9b3664(Bi, e) {
  let Ui = ({ node: ta }) => e(ta.props, ta.props.ref, ta), Zi = forwardRef((ta, na) => {
    if (!useContext($e1995378a142960e$var$ShallowRenderContext)) {
      if (e.length >= 3) throw new Error(e.name + " cannot be rendered outside a collection.");
      return e(ta, na);
    }
    return $e1995378a142960e$var$useSSRCollectionNode(Bi, ta, na, "children" in ta ? ta.children : null, null, (aa) => /* @__PURE__ */ a__default.createElement(Ui, {
      node: aa
    }));
  });
  return Zi.displayName = e.name, Zi;
}
function $e1995378a142960e$var$useCollectionChildren(Bi) {
  return $e948873055cbafe4$export$727c8fc270210f13({
    ...Bi,
    addIdAndValue: !0
  });
}
const $e1995378a142960e$var$CollectionContext = /* @__PURE__ */ createContext(null);
function $e1995378a142960e$export$fb8073518f34e6ec(Bi) {
  let e = useContext($e1995378a142960e$var$CollectionContext), Ui = (e?.dependencies || []).concat(Bi.dependencies), Zi = Bi.idScope || e?.idScope, ta = $e1995378a142960e$var$useCollectionChildren({
    ...Bi,
    idScope: Zi,
    dependencies: Ui
  });
  return useContext($e1995378a142960e$var$CollectionDocumentContext) && (ta = /* @__PURE__ */ a__default.createElement($e1995378a142960e$var$CollectionRoot, null, ta)), e = useMemo(() => ({
    dependencies: Ui,
    idScope: Zi
  }), [
    Zi,
    ...Ui
  ]), /* @__PURE__ */ a__default.createElement($e1995378a142960e$var$CollectionContext.Provider, {
    value: e
  }, ta);
}
function $e1995378a142960e$var$CollectionRoot({ children: Bi }) {
  let e = useContext($e1995378a142960e$var$CollectionDocumentContext), Ui = useMemo(() => /* @__PURE__ */ a__default.createElement($e1995378a142960e$var$CollectionDocumentContext.Provider, {
    value: null
  }, /* @__PURE__ */ a__default.createElement($e1995378a142960e$var$ShallowRenderContext.Provider, {
    value: !0
  }, Bi)), [
    Bi
  ]);
  return $b5e257d569688ac6$export$535bd6ca7f90a273() ? /* @__PURE__ */ a__default.createElement($e1995378a142960e$var$SSRContext.Provider, {
    value: e
  }, Ui) : /* @__PURE__ */ createPortal(Ui, e);
}
const $01b77f81d0f07f68$export$75b6ee27786ba447 = /* @__PURE__ */ createContext({}), $01b77f81d0f07f68$export$b04be29aa201d4f5 = /* @__PURE__ */ $f39a9eba43920ace$export$86427a43e3e48ebb(function(e, Ui) {
  [e, Ui] = $64fa3d84918910a7$export$29f1550f4b0d4415(e, Ui, $01b77f81d0f07f68$export$75b6ee27786ba447);
  let { elementType: Zi = "label", ...ta } = e;
  return /* @__PURE__ */ a__default.createElement(Zi, {
    className: "react-aria-Label",
    ...ta,
    ref: Ui
  });
});
let $14c0b72509d70225$var$state = "default", $14c0b72509d70225$var$savedUserSelect = "", $14c0b72509d70225$var$modifiedElementMap = /* @__PURE__ */ new WeakMap();
function $14c0b72509d70225$export$16a4697467175487(Bi) {
  if ($c87311424ea30a05$export$fedb369cb70207f1()) {
    if ($14c0b72509d70225$var$state === "default") {
      const e = $431fbd86ca7dc216$export$b204af158042fbac(Bi);
      $14c0b72509d70225$var$savedUserSelect = e.documentElement.style.webkitUserSelect, e.documentElement.style.webkitUserSelect = "none";
    }
    $14c0b72509d70225$var$state = "disabled";
  } else (Bi instanceof HTMLElement || Bi instanceof SVGElement) && ($14c0b72509d70225$var$modifiedElementMap.set(Bi, Bi.style.userSelect), Bi.style.userSelect = "none");
}
function $14c0b72509d70225$export$b0d6fa1ab32e3295(Bi) {
  if ($c87311424ea30a05$export$fedb369cb70207f1()) {
    if ($14c0b72509d70225$var$state !== "disabled") return;
    $14c0b72509d70225$var$state = "restoring", setTimeout(() => {
      $bbed8b41f857bcc0$export$24490316f764c430(() => {
        if ($14c0b72509d70225$var$state === "restoring") {
          const e = $431fbd86ca7dc216$export$b204af158042fbac(Bi);
          e.documentElement.style.webkitUserSelect === "none" && (e.documentElement.style.webkitUserSelect = $14c0b72509d70225$var$savedUserSelect || ""), $14c0b72509d70225$var$savedUserSelect = "", $14c0b72509d70225$var$state = "default";
        }
      });
    }, 300);
  } else if ((Bi instanceof HTMLElement || Bi instanceof SVGElement) && Bi && $14c0b72509d70225$var$modifiedElementMap.has(Bi)) {
    let e = $14c0b72509d70225$var$modifiedElementMap.get(Bi);
    Bi.style.userSelect === "none" && (Bi.style.userSelect = e), Bi.getAttribute("style") === "" && Bi.removeAttribute("style"), $14c0b72509d70225$var$modifiedElementMap.delete(Bi);
  }
}
const $ae1eeba8b9eafd08$export$5165eccb35aaadb5 = a__default.createContext({
  register: () => {
  }
});
$ae1eeba8b9eafd08$export$5165eccb35aaadb5.displayName = "PressResponderContext";
function _class_apply_descriptor_get(Bi, e) {
  return e.get ? e.get.call(Bi) : e.value;
}
function _class_extract_field_descriptor(Bi, e, Ui) {
  if (!e.has(Bi)) throw new TypeError("attempted to " + Ui + " private field on non-instance");
  return e.get(Bi);
}
function _class_private_field_get(Bi, e) {
  var Ui = _class_extract_field_descriptor(Bi, e, "get");
  return _class_apply_descriptor_get(Bi, Ui);
}
function _check_private_redeclaration(Bi, e) {
  if (e.has(Bi))
    throw new TypeError("Cannot initialize the same private elements twice on an object");
}
function _class_private_field_init(Bi, e, Ui) {
  _check_private_redeclaration(Bi, e), e.set(Bi, Ui);
}
function _class_apply_descriptor_set(Bi, e, Ui) {
  if (e.set) e.set.call(Bi, Ui);
  else {
    if (!e.writable)
      throw new TypeError("attempted to set read only private field");
    e.value = Ui;
  }
}
function _class_private_field_set(Bi, e, Ui) {
  var Zi = _class_extract_field_descriptor(Bi, e, "set");
  return _class_apply_descriptor_set(Bi, Zi, Ui), Ui;
}
function $f6c31cce2adf654f$var$usePressResponderContext(Bi) {
  let e = useContext($ae1eeba8b9eafd08$export$5165eccb35aaadb5);
  if (e) {
    let { register: Ui, ...Zi } = e;
    Bi = $3ef42575df84b30b$export$9d1611c77c2fe928(Zi, Bi), Ui();
  }
  return $e7801be82b4b2a53$export$4debdb1a3f0fa79e(e, Bi.ref), Bi;
}
var $f6c31cce2adf654f$var$_shouldStopPropagation = /* @__PURE__ */ new WeakMap();
class $f6c31cce2adf654f$var$PressEvent {
  continuePropagation() {
    _class_private_field_set(this, $f6c31cce2adf654f$var$_shouldStopPropagation, !1);
  }
  get shouldStopPropagation() {
    return _class_private_field_get(this, $f6c31cce2adf654f$var$_shouldStopPropagation);
  }
  constructor(e, Ui, Zi, ta) {
    _class_private_field_init(this, $f6c31cce2adf654f$var$_shouldStopPropagation, {
      writable: !0,
      value: void 0
    }), _class_private_field_set(this, $f6c31cce2adf654f$var$_shouldStopPropagation, !0);
    var na;
    let ia = (na = ta?.target) !== null && na !== void 0 ? na : Zi.currentTarget;
    const aa = ia?.getBoundingClientRect();
    let da, La = 0, qa, io = null;
    Zi.clientX != null && Zi.clientY != null && (qa = Zi.clientX, io = Zi.clientY), aa && (qa != null && io != null ? (da = qa - aa.left, La = io - aa.top) : (da = aa.width / 2, La = aa.height / 2)), this.type = e, this.pointerType = Ui, this.target = Zi.currentTarget, this.shiftKey = Zi.shiftKey, this.metaKey = Zi.metaKey, this.ctrlKey = Zi.ctrlKey, this.altKey = Zi.altKey, this.x = da, this.y = La;
  }
}
const $f6c31cce2adf654f$var$LINK_CLICKED = Symbol("linkClicked");
function $f6c31cce2adf654f$export$45712eceda6fad21(Bi) {
  let {
    onPress: e,
    onPressChange: Ui,
    onPressStart: Zi,
    onPressEnd: ta,
    onPressUp: na,
    isDisabled: ia,
    isPressed: aa,
    preventFocusOnPress: da,
    shouldCancelOnPointerExit: La,
    allowTextSelectionOnPress: qa,
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    ref: io,
    ...ao
  } = $f6c31cce2adf654f$var$usePressResponderContext(Bi), [oo, no] = useState(!1), lo = useRef({
    isPressed: !1,
    ignoreEmulatedMouseEvents: !1,
    ignoreClickAfterPress: !1,
    didFirePressStart: !1,
    isTriggeringEvent: !1,
    activePointerId: null,
    target: null,
    isOverTarget: !1,
    pointerType: null
  }), { addGlobalListener: so, removeAllGlobalListeners: bs } = $03deb23ff14920c4$export$4eaf04e54aa8eed6(), Rs = $8ae05eaa5c114e9c$export$7f54fc3180508a52((co, Co) => {
    let Zs = lo.current;
    if (ia || Zs.didFirePressStart) return !1;
    let xl = !0;
    if (Zs.isTriggeringEvent = !0, Zi) {
      let Cl = new $f6c31cce2adf654f$var$PressEvent("pressstart", Co, co);
      Zi(Cl), xl = Cl.shouldStopPropagation;
    }
    return Ui && Ui(!0), Zs.isTriggeringEvent = !1, Zs.didFirePressStart = !0, no(!0), xl;
  }), js = $8ae05eaa5c114e9c$export$7f54fc3180508a52((co, Co, Zs = !0) => {
    let xl = lo.current;
    if (!xl.didFirePressStart) return !1;
    xl.ignoreClickAfterPress = !0, xl.didFirePressStart = !1, xl.isTriggeringEvent = !0;
    let Cl = !0;
    if (ta) {
      let Al = new $f6c31cce2adf654f$var$PressEvent("pressend", Co, co);
      ta(Al), Cl = Al.shouldStopPropagation;
    }
    if (Ui && Ui(!1), no(!1), e && Zs && !ia) {
      let Al = new $f6c31cce2adf654f$var$PressEvent("press", Co, co);
      e(Al), Cl && (Cl = Al.shouldStopPropagation);
    }
    return xl.isTriggeringEvent = !1, Cl;
  }), qs = $8ae05eaa5c114e9c$export$7f54fc3180508a52((co, Co) => {
    let Zs = lo.current;
    if (ia) return !1;
    if (na) {
      Zs.isTriggeringEvent = !0;
      let xl = new $f6c31cce2adf654f$var$PressEvent("pressup", Co, co);
      return na(xl), Zs.isTriggeringEvent = !1, xl.shouldStopPropagation;
    }
    return !0;
  }), jo = $8ae05eaa5c114e9c$export$7f54fc3180508a52((co) => {
    let Co = lo.current;
    Co.isPressed && Co.target && (Co.isOverTarget && Co.pointerType != null && js($f6c31cce2adf654f$var$createEvent(Co.target, co), Co.pointerType, !1), Co.isPressed = !1, Co.isOverTarget = !1, Co.activePointerId = null, Co.pointerType = null, bs(), qa || $14c0b72509d70225$export$b0d6fa1ab32e3295(Co.target));
  }), fs = $8ae05eaa5c114e9c$export$7f54fc3180508a52((co) => {
    La && jo(co);
  }), Ao = useMemo(() => {
    let co = lo.current, Co = {
      onKeyDown(xl) {
        if ($f6c31cce2adf654f$var$isValidKeyboardEvent(xl.nativeEvent, xl.currentTarget) && xl.currentTarget.contains(xl.target)) {
          var Cl;
          $f6c31cce2adf654f$var$shouldPreventDefaultKeyboard(xl.target, xl.key) && xl.preventDefault();
          let Al = !0;
          if (!co.isPressed && !xl.repeat) {
            co.target = xl.currentTarget, co.isPressed = !0, Al = Rs(xl, "keyboard");
            let Ol = xl.currentTarget, Bl = (Ml) => {
              $f6c31cce2adf654f$var$isValidKeyboardEvent(Ml, Ol) && !Ml.repeat && Ol.contains(Ml.target) && co.target && qs($f6c31cce2adf654f$var$createEvent(co.target, Ml), "keyboard");
            };
            so($431fbd86ca7dc216$export$b204af158042fbac(xl.currentTarget), "keyup", $ff5963eb1fccf552$export$e08e3b67e392101e(Bl, Zs), !0);
          }
          Al && xl.stopPropagation(), xl.metaKey && $c87311424ea30a05$export$9ac100e40613ea10() && ((Cl = co.metaKeyEvents) === null || Cl === void 0 || Cl.set(xl.key, xl.nativeEvent));
        } else xl.key === "Meta" && (co.metaKeyEvents = /* @__PURE__ */ new Map());
      },
      onClick(xl) {
        if (!(xl && !xl.currentTarget.contains(xl.target)) && xl && xl.button === 0 && !co.isTriggeringEvent && !$ea8dcbcb9ea1b556$export$95185d699e05d4d7.isOpening) {
          let Cl = !0;
          if (ia && xl.preventDefault(), !co.ignoreClickAfterPress && !co.ignoreEmulatedMouseEvents && !co.isPressed && (co.pointerType === "virtual" || $6a7db85432448f7f$export$60278871457622de(xl.nativeEvent))) {
            !ia && !da && $7215afc6de606d6b$export$de79e2c695e052f3(xl.currentTarget);
            let Al = Rs(xl, "virtual"), Ol = qs(xl, "virtual"), Bl = js(xl, "virtual");
            Cl = Al && Ol && Bl;
          }
          co.ignoreEmulatedMouseEvents = !1, co.ignoreClickAfterPress = !1, Cl && xl.stopPropagation();
        }
      }
    }, Zs = (xl) => {
      var Cl;
      if (co.isPressed && co.target && $f6c31cce2adf654f$var$isValidKeyboardEvent(xl, co.target)) {
        var Al;
        $f6c31cce2adf654f$var$shouldPreventDefaultKeyboard(xl.target, xl.key) && xl.preventDefault();
        let Bl = xl.target;
        js($f6c31cce2adf654f$var$createEvent(co.target, xl), "keyboard", co.target.contains(Bl)), bs(), xl.key !== "Enter" && $f6c31cce2adf654f$var$isHTMLAnchorLink(co.target) && co.target.contains(Bl) && !xl[$f6c31cce2adf654f$var$LINK_CLICKED] && (xl[$f6c31cce2adf654f$var$LINK_CLICKED] = !0, $ea8dcbcb9ea1b556$export$95185d699e05d4d7(co.target, xl, !1)), co.isPressed = !1, (Al = co.metaKeyEvents) === null || Al === void 0 || Al.delete(xl.key);
      } else if (xl.key === "Meta" && (!((Cl = co.metaKeyEvents) === null || Cl === void 0) && Cl.size)) {
        var Ol;
        let Bl = co.metaKeyEvents;
        co.metaKeyEvents = void 0;
        for (let Ml of Bl.values()) (Ol = co.target) === null || Ol === void 0 || Ol.dispatchEvent(new KeyboardEvent("keyup", Ml));
      }
    };
    if (typeof PointerEvent < "u") {
      Co.onPointerDown = (Ol) => {
        if (Ol.button !== 0 || !Ol.currentTarget.contains(Ol.target)) return;
        if ($6a7db85432448f7f$export$29bf1b5f2c56cf63(Ol.nativeEvent)) {
          co.pointerType = "virtual";
          return;
        }
        $f6c31cce2adf654f$var$shouldPreventDefaultDown(Ol.currentTarget) && Ol.preventDefault(), co.pointerType = Ol.pointerType;
        let Bl = !0;
        if (!co.isPressed) {
          co.isPressed = !0, co.isOverTarget = !0, co.activePointerId = Ol.pointerId, co.target = Ol.currentTarget, !ia && !da && $7215afc6de606d6b$export$de79e2c695e052f3(Ol.currentTarget), qa || $14c0b72509d70225$export$16a4697467175487(co.target), Bl = Rs(Ol, co.pointerType);
          let Ml = Ol.target;
          "releasePointerCapture" in Ml && Ml.releasePointerCapture(Ol.pointerId), so($431fbd86ca7dc216$export$b204af158042fbac(Ol.currentTarget), "pointerup", xl, !1), so($431fbd86ca7dc216$export$b204af158042fbac(Ol.currentTarget), "pointercancel", Al, !1);
        }
        Bl && Ol.stopPropagation();
      }, Co.onMouseDown = (Ol) => {
        Ol.currentTarget.contains(Ol.target) && Ol.button === 0 && ($f6c31cce2adf654f$var$shouldPreventDefaultDown(Ol.currentTarget) && Ol.preventDefault(), Ol.stopPropagation());
      }, Co.onPointerUp = (Ol) => {
        !Ol.currentTarget.contains(Ol.target) || co.pointerType === "virtual" || Ol.button === 0 && qs(Ol, co.pointerType || Ol.pointerType);
      }, Co.onPointerEnter = (Ol) => {
        Ol.pointerId === co.activePointerId && co.target && !co.isOverTarget && co.pointerType != null && (co.isOverTarget = !0, Rs($f6c31cce2adf654f$var$createEvent(co.target, Ol), co.pointerType));
      }, Co.onPointerLeave = (Ol) => {
        Ol.pointerId === co.activePointerId && co.target && co.isOverTarget && co.pointerType != null && (co.isOverTarget = !1, js($f6c31cce2adf654f$var$createEvent(co.target, Ol), co.pointerType, !1), fs(Ol));
      };
      let xl = (Ol) => {
        Ol.pointerId === co.activePointerId && co.isPressed && Ol.button === 0 && co.target && (co.target.contains(Ol.target) && co.pointerType != null ? js($f6c31cce2adf654f$var$createEvent(co.target, Ol), co.pointerType) : co.isOverTarget && co.pointerType != null && js($f6c31cce2adf654f$var$createEvent(co.target, Ol), co.pointerType, !1), co.isPressed = !1, co.isOverTarget = !1, co.activePointerId = null, co.pointerType = null, bs(), qa || $14c0b72509d70225$export$b0d6fa1ab32e3295(co.target), "ontouchend" in co.target && Ol.pointerType !== "mouse" && so(co.target, "touchend", Cl, {
          once: !0
        }));
      }, Cl = (Ol) => {
        $f6c31cce2adf654f$var$shouldPreventDefaultUp(Ol.currentTarget) && Ol.preventDefault();
      }, Al = (Ol) => {
        jo(Ol);
      };
      Co.onDragStart = (Ol) => {
        Ol.currentTarget.contains(Ol.target) && jo(Ol);
      };
    } else {
      Co.onMouseDown = (Al) => {
        if (Al.button !== 0 || !Al.currentTarget.contains(Al.target)) return;
        if ($f6c31cce2adf654f$var$shouldPreventDefaultDown(Al.currentTarget) && Al.preventDefault(), co.ignoreEmulatedMouseEvents) {
          Al.stopPropagation();
          return;
        }
        co.isPressed = !0, co.isOverTarget = !0, co.target = Al.currentTarget, co.pointerType = $6a7db85432448f7f$export$60278871457622de(Al.nativeEvent) ? "virtual" : "mouse", !ia && !da && $7215afc6de606d6b$export$de79e2c695e052f3(Al.currentTarget), Rs(Al, co.pointerType) && Al.stopPropagation(), so($431fbd86ca7dc216$export$b204af158042fbac(Al.currentTarget), "mouseup", xl, !1);
      }, Co.onMouseEnter = (Al) => {
        if (!Al.currentTarget.contains(Al.target)) return;
        let Ol = !0;
        co.isPressed && !co.ignoreEmulatedMouseEvents && co.pointerType != null && (co.isOverTarget = !0, Ol = Rs(Al, co.pointerType)), Ol && Al.stopPropagation();
      }, Co.onMouseLeave = (Al) => {
        if (!Al.currentTarget.contains(Al.target)) return;
        let Ol = !0;
        co.isPressed && !co.ignoreEmulatedMouseEvents && co.pointerType != null && (co.isOverTarget = !1, Ol = js(Al, co.pointerType, !1), fs(Al)), Ol && Al.stopPropagation();
      }, Co.onMouseUp = (Al) => {
        Al.currentTarget.contains(Al.target) && !co.ignoreEmulatedMouseEvents && Al.button === 0 && qs(Al, co.pointerType || "mouse");
      };
      let xl = (Al) => {
        if (Al.button === 0) {
          if (co.isPressed = !1, bs(), co.ignoreEmulatedMouseEvents) {
            co.ignoreEmulatedMouseEvents = !1;
            return;
          }
          co.target && $f6c31cce2adf654f$var$isOverTarget(Al, co.target) && co.pointerType != null ? js($f6c31cce2adf654f$var$createEvent(co.target, Al), co.pointerType) : co.target && co.isOverTarget && co.pointerType != null && js($f6c31cce2adf654f$var$createEvent(co.target, Al), co.pointerType, !1), co.isOverTarget = !1;
        }
      };
      Co.onTouchStart = (Al) => {
        if (!Al.currentTarget.contains(Al.target)) return;
        let Ol = $f6c31cce2adf654f$var$getTouchFromEvent(Al.nativeEvent);
        if (!Ol) return;
        co.activePointerId = Ol.identifier, co.ignoreEmulatedMouseEvents = !0, co.isOverTarget = !0, co.isPressed = !0, co.target = Al.currentTarget, co.pointerType = "touch", !ia && !da && $7215afc6de606d6b$export$de79e2c695e052f3(Al.currentTarget), qa || $14c0b72509d70225$export$16a4697467175487(co.target), Rs($f6c31cce2adf654f$var$createTouchEvent(co.target, Al), co.pointerType) && Al.stopPropagation(), so($431fbd86ca7dc216$export$f21a1ffae260145a(Al.currentTarget), "scroll", Cl, !0);
      }, Co.onTouchMove = (Al) => {
        if (!Al.currentTarget.contains(Al.target)) return;
        if (!co.isPressed) {
          Al.stopPropagation();
          return;
        }
        let Ol = $f6c31cce2adf654f$var$getTouchById(Al.nativeEvent, co.activePointerId), Bl = !0;
        Ol && $f6c31cce2adf654f$var$isOverTarget(Ol, Al.currentTarget) ? !co.isOverTarget && co.pointerType != null && (co.isOverTarget = !0, Bl = Rs($f6c31cce2adf654f$var$createTouchEvent(co.target, Al), co.pointerType)) : co.isOverTarget && co.pointerType != null && (co.isOverTarget = !1, Bl = js($f6c31cce2adf654f$var$createTouchEvent(co.target, Al), co.pointerType, !1), fs($f6c31cce2adf654f$var$createTouchEvent(co.target, Al))), Bl && Al.stopPropagation();
      }, Co.onTouchEnd = (Al) => {
        if (!Al.currentTarget.contains(Al.target)) return;
        if (!co.isPressed) {
          Al.stopPropagation();
          return;
        }
        let Ol = $f6c31cce2adf654f$var$getTouchById(Al.nativeEvent, co.activePointerId), Bl = !0;
        Ol && $f6c31cce2adf654f$var$isOverTarget(Ol, Al.currentTarget) && co.pointerType != null ? (qs($f6c31cce2adf654f$var$createTouchEvent(co.target, Al), co.pointerType), Bl = js($f6c31cce2adf654f$var$createTouchEvent(co.target, Al), co.pointerType)) : co.isOverTarget && co.pointerType != null && (Bl = js($f6c31cce2adf654f$var$createTouchEvent(co.target, Al), co.pointerType, !1)), Bl && Al.stopPropagation(), co.isPressed = !1, co.activePointerId = null, co.isOverTarget = !1, co.ignoreEmulatedMouseEvents = !0, co.target && !qa && $14c0b72509d70225$export$b0d6fa1ab32e3295(co.target), bs();
      }, Co.onTouchCancel = (Al) => {
        Al.currentTarget.contains(Al.target) && (Al.stopPropagation(), co.isPressed && jo($f6c31cce2adf654f$var$createTouchEvent(co.target, Al)));
      };
      let Cl = (Al) => {
        co.isPressed && Al.target.contains(co.target) && jo({
          currentTarget: co.target,
          shiftKey: !1,
          ctrlKey: !1,
          metaKey: !1,
          altKey: !1
        });
      };
      Co.onDragStart = (Al) => {
        Al.currentTarget.contains(Al.target) && jo(Al);
      };
    }
    return Co;
  }, [
    so,
    ia,
    da,
    bs,
    qa,
    jo,
    fs,
    js,
    Rs,
    qs
  ]);
  return useEffect(() => () => {
    var co;
    qa || $14c0b72509d70225$export$b0d6fa1ab32e3295((co = lo.current.target) !== null && co !== void 0 ? co : void 0);
  }, [
    qa
  ]), {
    isPressed: aa || oo,
    pressProps: $3ef42575df84b30b$export$9d1611c77c2fe928(ao, Ao)
  };
}
function $f6c31cce2adf654f$var$isHTMLAnchorLink(Bi) {
  return Bi.tagName === "A" && Bi.hasAttribute("href");
}
function $f6c31cce2adf654f$var$isValidKeyboardEvent(Bi, e) {
  const { key: Ui, code: Zi } = Bi, ta = e, na = ta.getAttribute("role");
  return (Ui === "Enter" || Ui === " " || Ui === "Spacebar" || Zi === "Space") && !(ta instanceof $431fbd86ca7dc216$export$f21a1ffae260145a(ta).HTMLInputElement && !$f6c31cce2adf654f$var$isValidInputKey(ta, Ui) || ta instanceof $431fbd86ca7dc216$export$f21a1ffae260145a(ta).HTMLTextAreaElement || ta.isContentEditable) && // Links should only trigger with Enter key
  !((na === "link" || !na && $f6c31cce2adf654f$var$isHTMLAnchorLink(ta)) && Ui !== "Enter");
}
function $f6c31cce2adf654f$var$getTouchFromEvent(Bi) {
  const { targetTouches: e } = Bi;
  return e.length > 0 ? e[0] : null;
}
function $f6c31cce2adf654f$var$getTouchById(Bi, e) {
  const Ui = Bi.changedTouches;
  for (let Zi = 0; Zi < Ui.length; Zi++) {
    const ta = Ui[Zi];
    if (ta.identifier === e) return ta;
  }
  return null;
}
function $f6c31cce2adf654f$var$createTouchEvent(Bi, e) {
  let Ui = 0, Zi = 0;
  return e.targetTouches && e.targetTouches.length === 1 && (Ui = e.targetTouches[0].clientX, Zi = e.targetTouches[0].clientY), {
    currentTarget: Bi,
    shiftKey: e.shiftKey,
    ctrlKey: e.ctrlKey,
    metaKey: e.metaKey,
    altKey: e.altKey,
    clientX: Ui,
    clientY: Zi
  };
}
function $f6c31cce2adf654f$var$createEvent(Bi, e) {
  let Ui = e.clientX, Zi = e.clientY;
  return {
    currentTarget: Bi,
    shiftKey: e.shiftKey,
    ctrlKey: e.ctrlKey,
    metaKey: e.metaKey,
    altKey: e.altKey,
    clientX: Ui,
    clientY: Zi
  };
}
function $f6c31cce2adf654f$var$getPointClientRect(Bi) {
  let e = 0, Ui = 0;
  return Bi.width !== void 0 ? e = Bi.width / 2 : Bi.radiusX !== void 0 && (e = Bi.radiusX), Bi.height !== void 0 ? Ui = Bi.height / 2 : Bi.radiusY !== void 0 && (Ui = Bi.radiusY), {
    top: Bi.clientY - Ui,
    right: Bi.clientX + e,
    bottom: Bi.clientY + Ui,
    left: Bi.clientX - e
  };
}
function $f6c31cce2adf654f$var$areRectanglesOverlapping(Bi, e) {
  return !(Bi.left > e.right || e.left > Bi.right || Bi.top > e.bottom || e.top > Bi.bottom);
}
function $f6c31cce2adf654f$var$isOverTarget(Bi, e) {
  let Ui = e.getBoundingClientRect(), Zi = $f6c31cce2adf654f$var$getPointClientRect(Bi);
  return $f6c31cce2adf654f$var$areRectanglesOverlapping(Ui, Zi);
}
function $f6c31cce2adf654f$var$shouldPreventDefaultDown(Bi) {
  return !(Bi instanceof HTMLElement) || !Bi.hasAttribute("draggable");
}
function $f6c31cce2adf654f$var$shouldPreventDefaultUp(Bi) {
  return Bi instanceof HTMLInputElement ? !1 : Bi instanceof HTMLButtonElement ? Bi.type !== "submit" && Bi.type !== "reset" : !$f6c31cce2adf654f$var$isHTMLAnchorLink(Bi);
}
function $f6c31cce2adf654f$var$shouldPreventDefaultKeyboard(Bi, e) {
  return Bi instanceof HTMLInputElement ? !$f6c31cce2adf654f$var$isValidInputKey(Bi, e) : $f6c31cce2adf654f$var$shouldPreventDefaultUp(Bi);
}
const $f6c31cce2adf654f$var$nonTextInputTypes = /* @__PURE__ */ new Set([
  "checkbox",
  "radio",
  "range",
  "color",
  "file",
  "image",
  "button",
  "submit",
  "reset"
]);
function $f6c31cce2adf654f$var$isValidInputKey(Bi, e) {
  return Bi.type === "checkbox" || Bi.type === "radio" ? e === " " : $f6c31cce2adf654f$var$nonTextInputTypes.has(Bi.type);
}
const $f1ab8c75478c6f73$export$3351871ee4b288b8 = /* @__PURE__ */ a__default.forwardRef(({ children: Bi, ...e }, Ui) => {
  let Zi = useRef(!1), ta = useContext($ae1eeba8b9eafd08$export$5165eccb35aaadb5);
  Ui = $df56164dff5785e2$export$4338b53315abf666(Ui || ta?.ref);
  let na = $3ef42575df84b30b$export$9d1611c77c2fe928(ta || {}, {
    ...e,
    ref: Ui,
    register() {
      Zi.current = !0, ta && ta.register();
    }
  });
  return $e7801be82b4b2a53$export$4debdb1a3f0fa79e(ta, Ui), useEffect(() => {
    Zi.current || (console.warn("A PressResponder was rendered without a pressable child. Either call the usePress hook, or wrap your DOM node with <Pressable> component."), Zi.current = !0);
  }, []), /* @__PURE__ */ a__default.createElement($ae1eeba8b9eafd08$export$5165eccb35aaadb5.Provider, {
    value: na
  }, Bi);
});
function $f1ab8c75478c6f73$export$cf75428e0b9ed1ea({ children: Bi }) {
  let e = useMemo(() => ({
    register: () => {
    }
  }), []);
  return /* @__PURE__ */ a__default.createElement($ae1eeba8b9eafd08$export$5165eccb35aaadb5.Provider, {
    value: e
  }, Bi);
}
class $8a9cb279dc87e130$export$905e7fc544a71f36 {
  isDefaultPrevented() {
    return this.nativeEvent.defaultPrevented;
  }
  preventDefault() {
    this.defaultPrevented = !0, this.nativeEvent.preventDefault();
  }
  stopPropagation() {
    this.nativeEvent.stopPropagation(), this.isPropagationStopped = () => !0;
  }
  isPropagationStopped() {
    return !1;
  }
  persist() {
  }
  constructor(e, Ui) {
    this.nativeEvent = Ui, this.target = Ui.target, this.currentTarget = Ui.currentTarget, this.relatedTarget = Ui.relatedTarget, this.bubbles = Ui.bubbles, this.cancelable = Ui.cancelable, this.defaultPrevented = Ui.defaultPrevented, this.eventPhase = Ui.eventPhase, this.isTrusted = Ui.isTrusted, this.timeStamp = Ui.timeStamp, this.type = e;
  }
}
function $8a9cb279dc87e130$export$715c682d09d639cc(Bi) {
  let e = useRef({
    isFocused: !1,
    observer: null
  });
  $f0a04ccd8dbdd83b$export$e5c5a5f917a5871c(() => {
    const Zi = e.current;
    return () => {
      Zi.observer && (Zi.observer.disconnect(), Zi.observer = null);
    };
  }, []);
  let Ui = $8ae05eaa5c114e9c$export$7f54fc3180508a52((Zi) => {
    Bi?.(Zi);
  });
  return useCallback((Zi) => {
    if (Zi.target instanceof HTMLButtonElement || Zi.target instanceof HTMLInputElement || Zi.target instanceof HTMLTextAreaElement || Zi.target instanceof HTMLSelectElement) {
      e.current.isFocused = !0;
      let ta = Zi.target, na = (ia) => {
        e.current.isFocused = !1, ta.disabled && Ui(new $8a9cb279dc87e130$export$905e7fc544a71f36("blur", ia)), e.current.observer && (e.current.observer.disconnect(), e.current.observer = null);
      };
      ta.addEventListener("focusout", na, {
        once: !0
      }), e.current.observer = new MutationObserver(() => {
        if (e.current.isFocused && ta.disabled) {
          var ia;
          (ia = e.current.observer) === null || ia === void 0 || ia.disconnect();
          let aa = ta === document.activeElement ? null : document.activeElement;
          ta.dispatchEvent(new FocusEvent("blur", {
            relatedTarget: aa
          })), ta.dispatchEvent(new FocusEvent("focusout", {
            bubbles: !0,
            relatedTarget: aa
          }));
        }
      }), e.current.observer.observe(ta, {
        attributes: !0,
        attributeFilter: [
          "disabled"
        ]
      });
    }
  }, [
    Ui
  ]);
}
function $a1ea59d68270f0dd$export$f8168d8dd8fd66e6(Bi) {
  let { isDisabled: e, onFocus: Ui, onBlur: Zi, onFocusChange: ta } = Bi;
  const na = useCallback((da) => {
    if (da.target === da.currentTarget)
      return Zi && Zi(da), ta && ta(!1), !0;
  }, [
    Zi,
    ta
  ]), ia = $8a9cb279dc87e130$export$715c682d09d639cc(na), aa = useCallback((da) => {
    const La = $431fbd86ca7dc216$export$b204af158042fbac(da.target);
    da.target === da.currentTarget && La.activeElement === da.target && (Ui && Ui(da), ta && ta(!0), ia(da));
  }, [
    ta,
    Ui,
    ia
  ]);
  return {
    focusProps: {
      onFocus: !e && (Ui || ta || Zi) ? aa : void 0,
      onBlur: !e && (Zi || ta) ? na : void 0
    }
  };
}
let $507fabe10e71c6fb$var$currentModality = null, $507fabe10e71c6fb$var$changeHandlers = /* @__PURE__ */ new Set(), $507fabe10e71c6fb$export$d90243b58daecda7 = /* @__PURE__ */ new Map(), $507fabe10e71c6fb$var$hasEventBeforeFocus = !1, $507fabe10e71c6fb$var$hasBlurredWindowRecently = !1;
const $507fabe10e71c6fb$var$FOCUS_VISIBLE_INPUT_KEYS = {
  Tab: !0,
  Escape: !0
};
function $507fabe10e71c6fb$var$triggerChangeHandlers(Bi, e) {
  for (let Ui of $507fabe10e71c6fb$var$changeHandlers) Ui(Bi, e);
}
function $507fabe10e71c6fb$var$isValidKey(Bi) {
  return !(Bi.metaKey || !$c87311424ea30a05$export$9ac100e40613ea10() && Bi.altKey || Bi.ctrlKey || Bi.key === "Control" || Bi.key === "Shift" || Bi.key === "Meta");
}
function $507fabe10e71c6fb$var$handleKeyboardEvent(Bi) {
  $507fabe10e71c6fb$var$hasEventBeforeFocus = !0, $507fabe10e71c6fb$var$isValidKey(Bi) && ($507fabe10e71c6fb$var$currentModality = "keyboard", $507fabe10e71c6fb$var$triggerChangeHandlers("keyboard", Bi));
}
function $507fabe10e71c6fb$var$handlePointerEvent(Bi) {
  $507fabe10e71c6fb$var$currentModality = "pointer", (Bi.type === "mousedown" || Bi.type === "pointerdown") && ($507fabe10e71c6fb$var$hasEventBeforeFocus = !0, $507fabe10e71c6fb$var$triggerChangeHandlers("pointer", Bi));
}
function $507fabe10e71c6fb$var$handleClickEvent(Bi) {
  $6a7db85432448f7f$export$60278871457622de(Bi) && ($507fabe10e71c6fb$var$hasEventBeforeFocus = !0, $507fabe10e71c6fb$var$currentModality = "virtual");
}
function $507fabe10e71c6fb$var$handleFocusEvent(Bi) {
  Bi.target === window || Bi.target === document || (!$507fabe10e71c6fb$var$hasEventBeforeFocus && !$507fabe10e71c6fb$var$hasBlurredWindowRecently && ($507fabe10e71c6fb$var$currentModality = "virtual", $507fabe10e71c6fb$var$triggerChangeHandlers("virtual", Bi)), $507fabe10e71c6fb$var$hasEventBeforeFocus = !1, $507fabe10e71c6fb$var$hasBlurredWindowRecently = !1);
}
function $507fabe10e71c6fb$var$handleWindowBlur() {
  $507fabe10e71c6fb$var$hasEventBeforeFocus = !1, $507fabe10e71c6fb$var$hasBlurredWindowRecently = !0;
}
function $507fabe10e71c6fb$var$setupGlobalFocusEvents(Bi) {
  if (typeof window > "u" || $507fabe10e71c6fb$export$d90243b58daecda7.get($431fbd86ca7dc216$export$f21a1ffae260145a(Bi))) return;
  const e = $431fbd86ca7dc216$export$f21a1ffae260145a(Bi), Ui = $431fbd86ca7dc216$export$b204af158042fbac(Bi);
  let Zi = e.HTMLElement.prototype.focus;
  e.HTMLElement.prototype.focus = function() {
    $507fabe10e71c6fb$var$hasEventBeforeFocus = !0, Zi.apply(this, arguments);
  }, Ui.addEventListener("keydown", $507fabe10e71c6fb$var$handleKeyboardEvent, !0), Ui.addEventListener("keyup", $507fabe10e71c6fb$var$handleKeyboardEvent, !0), Ui.addEventListener("click", $507fabe10e71c6fb$var$handleClickEvent, !0), e.addEventListener("focus", $507fabe10e71c6fb$var$handleFocusEvent, !0), e.addEventListener("blur", $507fabe10e71c6fb$var$handleWindowBlur, !1), typeof PointerEvent < "u" ? (Ui.addEventListener("pointerdown", $507fabe10e71c6fb$var$handlePointerEvent, !0), Ui.addEventListener("pointermove", $507fabe10e71c6fb$var$handlePointerEvent, !0), Ui.addEventListener("pointerup", $507fabe10e71c6fb$var$handlePointerEvent, !0)) : (Ui.addEventListener("mousedown", $507fabe10e71c6fb$var$handlePointerEvent, !0), Ui.addEventListener("mousemove", $507fabe10e71c6fb$var$handlePointerEvent, !0), Ui.addEventListener("mouseup", $507fabe10e71c6fb$var$handlePointerEvent, !0)), e.addEventListener("beforeunload", () => {
    $507fabe10e71c6fb$var$tearDownWindowFocusTracking(Bi);
  }, {
    once: !0
  }), $507fabe10e71c6fb$export$d90243b58daecda7.set(e, {
    focus: Zi
  });
}
const $507fabe10e71c6fb$var$tearDownWindowFocusTracking = (Bi, e) => {
  const Ui = $431fbd86ca7dc216$export$f21a1ffae260145a(Bi), Zi = $431fbd86ca7dc216$export$b204af158042fbac(Bi);
  e && Zi.removeEventListener("DOMContentLoaded", e), $507fabe10e71c6fb$export$d90243b58daecda7.has(Ui) && (Ui.HTMLElement.prototype.focus = $507fabe10e71c6fb$export$d90243b58daecda7.get(Ui).focus, Zi.removeEventListener("keydown", $507fabe10e71c6fb$var$handleKeyboardEvent, !0), Zi.removeEventListener("keyup", $507fabe10e71c6fb$var$handleKeyboardEvent, !0), Zi.removeEventListener("click", $507fabe10e71c6fb$var$handleClickEvent, !0), Ui.removeEventListener("focus", $507fabe10e71c6fb$var$handleFocusEvent, !0), Ui.removeEventListener("blur", $507fabe10e71c6fb$var$handleWindowBlur, !1), typeof PointerEvent < "u" ? (Zi.removeEventListener("pointerdown", $507fabe10e71c6fb$var$handlePointerEvent, !0), Zi.removeEventListener("pointermove", $507fabe10e71c6fb$var$handlePointerEvent, !0), Zi.removeEventListener("pointerup", $507fabe10e71c6fb$var$handlePointerEvent, !0)) : (Zi.removeEventListener("mousedown", $507fabe10e71c6fb$var$handlePointerEvent, !0), Zi.removeEventListener("mousemove", $507fabe10e71c6fb$var$handlePointerEvent, !0), Zi.removeEventListener("mouseup", $507fabe10e71c6fb$var$handlePointerEvent, !0)), $507fabe10e71c6fb$export$d90243b58daecda7.delete(Ui));
};
function $507fabe10e71c6fb$export$2f1888112f558a7d(Bi) {
  const e = $431fbd86ca7dc216$export$b204af158042fbac(Bi);
  let Ui;
  return e.readyState !== "loading" ? $507fabe10e71c6fb$var$setupGlobalFocusEvents(Bi) : (Ui = () => {
    $507fabe10e71c6fb$var$setupGlobalFocusEvents(Bi);
  }, e.addEventListener("DOMContentLoaded", Ui)), () => $507fabe10e71c6fb$var$tearDownWindowFocusTracking(Bi, Ui);
}
typeof document < "u" && $507fabe10e71c6fb$export$2f1888112f558a7d();
function $507fabe10e71c6fb$export$b9b3dfddab17db27() {
  return $507fabe10e71c6fb$var$currentModality !== "pointer";
}
function $507fabe10e71c6fb$export$630ff653c5ada6a9() {
  return $507fabe10e71c6fb$var$currentModality;
}
function $507fabe10e71c6fb$export$8397ddfc504fdb9a(Bi) {
  $507fabe10e71c6fb$var$currentModality = Bi, $507fabe10e71c6fb$var$triggerChangeHandlers(Bi, null);
}
const $507fabe10e71c6fb$var$nonTextInputTypes = /* @__PURE__ */ new Set([
  "checkbox",
  "radio",
  "range",
  "color",
  "file",
  "image",
  "button",
  "submit",
  "reset"
]);
function $507fabe10e71c6fb$var$isKeyboardFocusEvent(Bi, e, Ui) {
  var Zi;
  const ta = typeof window < "u" ? $431fbd86ca7dc216$export$f21a1ffae260145a(Ui?.target).HTMLInputElement : HTMLInputElement, na = typeof window < "u" ? $431fbd86ca7dc216$export$f21a1ffae260145a(Ui?.target).HTMLTextAreaElement : HTMLTextAreaElement, ia = typeof window < "u" ? $431fbd86ca7dc216$export$f21a1ffae260145a(Ui?.target).HTMLElement : HTMLElement, aa = typeof window < "u" ? $431fbd86ca7dc216$export$f21a1ffae260145a(Ui?.target).KeyboardEvent : KeyboardEvent;
  return Bi = Bi || Ui?.target instanceof ta && !$507fabe10e71c6fb$var$nonTextInputTypes.has(Ui == null || (Zi = Ui.target) === null || Zi === void 0 ? void 0 : Zi.type) || Ui?.target instanceof na || Ui?.target instanceof ia && Ui?.target.isContentEditable, !(Bi && e === "keyboard" && Ui instanceof aa && !$507fabe10e71c6fb$var$FOCUS_VISIBLE_INPUT_KEYS[Ui.key]);
}
function $507fabe10e71c6fb$export$ec71b4b83ac08ec3(Bi, e, Ui) {
  $507fabe10e71c6fb$var$setupGlobalFocusEvents(), useEffect(() => {
    let Zi = (ta, na) => {
      $507fabe10e71c6fb$var$isKeyboardFocusEvent(!!Ui?.isTextInput, ta, na) && Bi($507fabe10e71c6fb$export$b9b3dfddab17db27());
    };
    return $507fabe10e71c6fb$var$changeHandlers.add(Zi), () => {
      $507fabe10e71c6fb$var$changeHandlers.delete(Zi);
    };
  }, e);
}
function $9ab94262bd0047c7$export$420e68273165f4ec(Bi) {
  let { isDisabled: e, onBlurWithin: Ui, onFocusWithin: Zi, onFocusWithinChange: ta } = Bi, na = useRef({
    isFocusWithin: !1
  }), ia = useCallback((La) => {
    na.current.isFocusWithin && !La.currentTarget.contains(La.relatedTarget) && (na.current.isFocusWithin = !1, Ui && Ui(La), ta && ta(!1));
  }, [
    Ui,
    ta,
    na
  ]), aa = $8a9cb279dc87e130$export$715c682d09d639cc(ia), da = useCallback((La) => {
    !na.current.isFocusWithin && document.activeElement === La.target && (Zi && Zi(La), ta && ta(!0), na.current.isFocusWithin = !0, aa(La));
  }, [
    Zi,
    ta,
    aa
  ]);
  return e ? {
    focusWithinProps: {
      // These should not have been null, that would conflict in mergeProps
      onFocus: void 0,
      onBlur: void 0
    }
  } : {
    focusWithinProps: {
      onFocus: da,
      onBlur: ia
    }
  };
}
let $6179b936705e76d3$var$globalIgnoreEmulatedMouseEvents = !1, $6179b936705e76d3$var$hoverCount = 0;
function $6179b936705e76d3$var$setGlobalIgnoreEmulatedMouseEvents() {
  $6179b936705e76d3$var$globalIgnoreEmulatedMouseEvents = !0, setTimeout(() => {
    $6179b936705e76d3$var$globalIgnoreEmulatedMouseEvents = !1;
  }, 50);
}
function $6179b936705e76d3$var$handleGlobalPointerEvent(Bi) {
  Bi.pointerType === "touch" && $6179b936705e76d3$var$setGlobalIgnoreEmulatedMouseEvents();
}
function $6179b936705e76d3$var$setupGlobalTouchEvents() {
  if (!(typeof document > "u"))
    return typeof PointerEvent < "u" ? document.addEventListener("pointerup", $6179b936705e76d3$var$handleGlobalPointerEvent) : document.addEventListener("touchend", $6179b936705e76d3$var$setGlobalIgnoreEmulatedMouseEvents), $6179b936705e76d3$var$hoverCount++, () => {
      $6179b936705e76d3$var$hoverCount--, !($6179b936705e76d3$var$hoverCount > 0) && (typeof PointerEvent < "u" ? document.removeEventListener("pointerup", $6179b936705e76d3$var$handleGlobalPointerEvent) : document.removeEventListener("touchend", $6179b936705e76d3$var$setGlobalIgnoreEmulatedMouseEvents));
    };
}
function $6179b936705e76d3$export$ae780daf29e6d456(Bi) {
  let { onHoverStart: e, onHoverChange: Ui, onHoverEnd: Zi, isDisabled: ta } = Bi, [na, ia] = useState(!1), aa = useRef({
    isHovered: !1,
    ignoreEmulatedMouseEvents: !1,
    pointerType: "",
    target: null
  }).current;
  useEffect($6179b936705e76d3$var$setupGlobalTouchEvents, []);
  let { hoverProps: da, triggerHoverEnd: La } = useMemo(() => {
    let qa = (oo, no) => {
      if (aa.pointerType = no, ta || no === "touch" || aa.isHovered || !oo.currentTarget.contains(oo.target)) return;
      aa.isHovered = !0;
      let lo = oo.currentTarget;
      aa.target = lo, e && e({
        type: "hoverstart",
        target: lo,
        pointerType: no
      }), Ui && Ui(!0), ia(!0);
    }, io = (oo, no) => {
      if (aa.pointerType = "", aa.target = null, no === "touch" || !aa.isHovered) return;
      aa.isHovered = !1;
      let lo = oo.currentTarget;
      Zi && Zi({
        type: "hoverend",
        target: lo,
        pointerType: no
      }), Ui && Ui(!1), ia(!1);
    }, ao = {};
    return typeof PointerEvent < "u" ? (ao.onPointerEnter = (oo) => {
      $6179b936705e76d3$var$globalIgnoreEmulatedMouseEvents && oo.pointerType === "mouse" || qa(oo, oo.pointerType);
    }, ao.onPointerLeave = (oo) => {
      !ta && oo.currentTarget.contains(oo.target) && io(oo, oo.pointerType);
    }) : (ao.onTouchStart = () => {
      aa.ignoreEmulatedMouseEvents = !0;
    }, ao.onMouseEnter = (oo) => {
      !aa.ignoreEmulatedMouseEvents && !$6179b936705e76d3$var$globalIgnoreEmulatedMouseEvents && qa(oo, "mouse"), aa.ignoreEmulatedMouseEvents = !1;
    }, ao.onMouseLeave = (oo) => {
      !ta && oo.currentTarget.contains(oo.target) && io(oo, "mouse");
    }), {
      hoverProps: ao,
      triggerHoverEnd: io
    };
  }, [
    e,
    Ui,
    Zi,
    ta,
    aa
  ]);
  return useEffect(() => {
    ta && La({
      currentTarget: aa.target
    }, aa.pointerType);
  }, [
    ta
  ]), {
    hoverProps: da,
    isHovered: na
  };
}
function $e0b6e0b68ec7f50f$export$872b660ac5a1ff98(Bi) {
  let { ref: e, onInteractOutside: Ui, isDisabled: Zi, onInteractOutsideStart: ta } = Bi, na = useRef({
    isPointerDown: !1,
    ignoreEmulatedMouseEvents: !1
  }), ia = $8ae05eaa5c114e9c$export$7f54fc3180508a52((da) => {
    Ui && $e0b6e0b68ec7f50f$var$isValidEvent(da, e) && (ta && ta(da), na.current.isPointerDown = !0);
  }), aa = $8ae05eaa5c114e9c$export$7f54fc3180508a52((da) => {
    Ui && Ui(da);
  });
  useEffect(() => {
    let da = na.current;
    if (Zi) return;
    const La = e.current, qa = $431fbd86ca7dc216$export$b204af158042fbac(La);
    if (typeof PointerEvent < "u") {
      let io = (ao) => {
        da.isPointerDown && $e0b6e0b68ec7f50f$var$isValidEvent(ao, e) && aa(ao), da.isPointerDown = !1;
      };
      return qa.addEventListener("pointerdown", ia, !0), qa.addEventListener("pointerup", io, !0), () => {
        qa.removeEventListener("pointerdown", ia, !0), qa.removeEventListener("pointerup", io, !0);
      };
    } else {
      let io = (oo) => {
        da.ignoreEmulatedMouseEvents ? da.ignoreEmulatedMouseEvents = !1 : da.isPointerDown && $e0b6e0b68ec7f50f$var$isValidEvent(oo, e) && aa(oo), da.isPointerDown = !1;
      }, ao = (oo) => {
        da.ignoreEmulatedMouseEvents = !0, da.isPointerDown && $e0b6e0b68ec7f50f$var$isValidEvent(oo, e) && aa(oo), da.isPointerDown = !1;
      };
      return qa.addEventListener("mousedown", ia, !0), qa.addEventListener("mouseup", io, !0), qa.addEventListener("touchstart", ia, !0), qa.addEventListener("touchend", ao, !0), () => {
        qa.removeEventListener("mousedown", ia, !0), qa.removeEventListener("mouseup", io, !0), qa.removeEventListener("touchstart", ia, !0), qa.removeEventListener("touchend", ao, !0);
      };
    }
  }, [
    e,
    Zi,
    ia,
    aa
  ]);
}
function $e0b6e0b68ec7f50f$var$isValidEvent(Bi, e) {
  if (Bi.button > 0) return !1;
  if (Bi.target) {
    const Ui = Bi.target.ownerDocument;
    if (!Ui || !Ui.documentElement.contains(Bi.target) || Bi.target.closest("[data-react-aria-top-layer]")) return !1;
  }
  return e.current && !e.current.contains(Bi.target);
}
function $93925083ecbb358c$export$48d1ea6320830260(Bi) {
  if (!Bi) return;
  let e = !0;
  return (Ui) => {
    let Zi = {
      ...Ui,
      preventDefault() {
        Ui.preventDefault();
      },
      isDefaultPrevented() {
        return Ui.isDefaultPrevented();
      },
      stopPropagation() {
        e ? console.error("stopPropagation is now the default behavior for events in React Spectrum. You can use continuePropagation() to revert this behavior.") : e = !0;
      },
      continuePropagation() {
        e = !1;
      },
      isPropagationStopped() {
        return e;
      }
    };
    Bi(Zi), e && Ui.stopPropagation();
  };
}
function $46d819fcbaf35654$export$8f71654801c2f7cd(Bi) {
  return {
    keyboardProps: Bi.isDisabled ? {} : {
      onKeyDown: $93925083ecbb358c$export$48d1ea6320830260(Bi.onKeyDown),
      onKeyUp: $93925083ecbb358c$export$48d1ea6320830260(Bi.onKeyUp)
    }
  };
}
const $8a26561d2877236e$var$DEFAULT_THRESHOLD = 500;
function $8a26561d2877236e$export$c24ed0104d07eab9(Bi) {
  let { isDisabled: e, onLongPressStart: Ui, onLongPressEnd: Zi, onLongPress: ta, threshold: na = $8a26561d2877236e$var$DEFAULT_THRESHOLD, accessibilityDescription: ia } = Bi;
  const aa = useRef(void 0);
  let { addGlobalListener: da, removeGlobalListener: La } = $03deb23ff14920c4$export$4eaf04e54aa8eed6(), { pressProps: qa } = $f6c31cce2adf654f$export$45712eceda6fad21({
    isDisabled: e,
    onPressStart(ao) {
      if (ao.continuePropagation(), (ao.pointerType === "mouse" || ao.pointerType === "touch") && (Ui && Ui({
        ...ao,
        type: "longpressstart"
      }), aa.current = setTimeout(() => {
        ao.target.dispatchEvent(new PointerEvent("pointercancel", {
          bubbles: !0
        })), ta && ta({
          ...ao,
          type: "longpress"
        }), aa.current = void 0;
      }, na), ao.pointerType === "touch")) {
        let oo = (no) => {
          no.preventDefault();
        };
        da(ao.target, "contextmenu", oo, {
          once: !0
        }), da(window, "pointerup", () => {
          setTimeout(() => {
            La(ao.target, "contextmenu", oo);
          }, 30);
        }, {
          once: !0
        });
      }
    },
    onPressEnd(ao) {
      aa.current && clearTimeout(aa.current), Zi && (ao.pointerType === "mouse" || ao.pointerType === "touch") && Zi({
        ...ao,
        type: "longpressend"
      });
    }
  }), io = $ef06256079686ba0$export$f8aeda7b10753fa1(ta && !e ? ia : void 0);
  return {
    longPressProps: $3ef42575df84b30b$export$9d1611c77c2fe928(qa, io)
  };
}
function $6a99195332edec8b$export$80f3e147d781571c(Bi) {
  const e = $431fbd86ca7dc216$export$b204af158042fbac(Bi);
  if ($507fabe10e71c6fb$export$630ff653c5ada6a9() === "virtual") {
    let Ui = e.activeElement;
    $bbed8b41f857bcc0$export$24490316f764c430(() => {
      e.activeElement === Ui && Bi.isConnected && $7215afc6de606d6b$export$de79e2c695e052f3(Bi);
    });
  } else $7215afc6de606d6b$export$de79e2c695e052f3(Bi);
}
function $645f2e67b85a24c9$var$isStyleVisible(Bi) {
  const e = $431fbd86ca7dc216$export$f21a1ffae260145a(Bi);
  if (!(Bi instanceof e.HTMLElement) && !(Bi instanceof e.SVGElement)) return !1;
  let { display: Ui, visibility: Zi } = Bi.style, ta = Ui !== "none" && Zi !== "hidden" && Zi !== "collapse";
  if (ta) {
    const { getComputedStyle: na } = Bi.ownerDocument.defaultView;
    let { display: ia, visibility: aa } = na(Bi);
    ta = ia !== "none" && aa !== "hidden" && aa !== "collapse";
  }
  return ta;
}
function $645f2e67b85a24c9$var$isAttributeVisible(Bi, e) {
  return !Bi.hasAttribute("hidden") && // Ignore HiddenSelect when tree walking.
  !Bi.hasAttribute("data-react-aria-prevent-focus") && (Bi.nodeName === "DETAILS" && e && e.nodeName !== "SUMMARY" ? Bi.hasAttribute("open") : !0);
}
function $645f2e67b85a24c9$export$e989c0fffaa6b27a(Bi, e) {
  return Bi.nodeName !== "#comment" && $645f2e67b85a24c9$var$isStyleVisible(Bi) && $645f2e67b85a24c9$var$isAttributeVisible(Bi, e) && (!Bi.parentElement || $645f2e67b85a24c9$export$e989c0fffaa6b27a(Bi.parentElement, Bi));
}
const $9bf71ea28793e738$var$FocusContext = /* @__PURE__ */ a__default.createContext(null), $9bf71ea28793e738$var$RESTORE_FOCUS_EVENT = "react-aria-focus-scope-restore";
let $9bf71ea28793e738$var$activeScope = null;
function $9bf71ea28793e738$export$20e40289641fbbb6(Bi) {
  let { children: e, contain: Ui, restoreFocus: Zi, autoFocus: ta } = Bi, na = useRef(null), ia = useRef(null), aa = useRef([]), { parentNode: da } = useContext($9bf71ea28793e738$var$FocusContext) || {}, La = useMemo(() => new $9bf71ea28793e738$var$TreeNode({
    scopeRef: aa
  }), [
    aa
  ]);
  $f0a04ccd8dbdd83b$export$e5c5a5f917a5871c(() => {
    let ao = da || $9bf71ea28793e738$export$d06fae2ee68b101e.root;
    if ($9bf71ea28793e738$export$d06fae2ee68b101e.getTreeNode(ao.scopeRef) && $9bf71ea28793e738$var$activeScope && !$9bf71ea28793e738$var$isAncestorScope($9bf71ea28793e738$var$activeScope, ao.scopeRef)) {
      let oo = $9bf71ea28793e738$export$d06fae2ee68b101e.getTreeNode($9bf71ea28793e738$var$activeScope);
      oo && (ao = oo);
    }
    ao.addChild(La), $9bf71ea28793e738$export$d06fae2ee68b101e.addNode(La);
  }, [
    La,
    da
  ]), $f0a04ccd8dbdd83b$export$e5c5a5f917a5871c(() => {
    let ao = $9bf71ea28793e738$export$d06fae2ee68b101e.getTreeNode(aa);
    ao && (ao.contain = !!Ui);
  }, [
    Ui
  ]), $f0a04ccd8dbdd83b$export$e5c5a5f917a5871c(() => {
    var ao;
    let oo = (ao = na.current) === null || ao === void 0 ? void 0 : ao.nextSibling, no = [], lo = (so) => so.stopPropagation();
    for (; oo && oo !== ia.current; )
      no.push(oo), oo.addEventListener($9bf71ea28793e738$var$RESTORE_FOCUS_EVENT, lo), oo = oo.nextSibling;
    return aa.current = no, () => {
      for (let so of no) so.removeEventListener($9bf71ea28793e738$var$RESTORE_FOCUS_EVENT, lo);
    };
  }, [
    e
  ]), $9bf71ea28793e738$var$useActiveScopeTracker(aa, Zi, Ui), $9bf71ea28793e738$var$useFocusContainment(aa, Ui), $9bf71ea28793e738$var$useRestoreFocus(aa, Zi, Ui), $9bf71ea28793e738$var$useAutoFocus(aa, ta), useEffect(() => {
    const ao = $431fbd86ca7dc216$export$b204af158042fbac(aa.current ? aa.current[0] : void 0).activeElement;
    let oo = null;
    if ($9bf71ea28793e738$var$isElementInScope(ao, aa.current)) {
      for (let no of $9bf71ea28793e738$export$d06fae2ee68b101e.traverse()) no.scopeRef && $9bf71ea28793e738$var$isElementInScope(ao, no.scopeRef.current) && (oo = no);
      oo === $9bf71ea28793e738$export$d06fae2ee68b101e.getTreeNode(aa) && ($9bf71ea28793e738$var$activeScope = oo.scopeRef);
    }
  }, [
    aa
  ]), $f0a04ccd8dbdd83b$export$e5c5a5f917a5871c(() => () => {
    var ao, oo, no;
    let lo = (no = (oo = $9bf71ea28793e738$export$d06fae2ee68b101e.getTreeNode(aa)) === null || oo === void 0 || (ao = oo.parent) === null || ao === void 0 ? void 0 : ao.scopeRef) !== null && no !== void 0 ? no : null;
    (aa === $9bf71ea28793e738$var$activeScope || $9bf71ea28793e738$var$isAncestorScope(aa, $9bf71ea28793e738$var$activeScope)) && (!lo || $9bf71ea28793e738$export$d06fae2ee68b101e.getTreeNode(lo)) && ($9bf71ea28793e738$var$activeScope = lo), $9bf71ea28793e738$export$d06fae2ee68b101e.removeTreeNode(aa);
  }, [
    aa
  ]);
  let qa = useMemo(() => $9bf71ea28793e738$var$createFocusManagerForScope(aa), []), io = useMemo(() => ({
    focusManager: qa,
    parentNode: La
  }), [
    La,
    qa
  ]);
  return /* @__PURE__ */ a__default.createElement($9bf71ea28793e738$var$FocusContext.Provider, {
    value: io
  }, /* @__PURE__ */ a__default.createElement("span", {
    "data-focus-scope-start": !0,
    hidden: !0,
    ref: na
  }), e, /* @__PURE__ */ a__default.createElement("span", {
    "data-focus-scope-end": !0,
    hidden: !0,
    ref: ia
  }));
}
function $9bf71ea28793e738$var$createFocusManagerForScope(Bi) {
  return {
    focusNext(e = {}) {
      let Ui = Bi.current, { from: Zi, tabbable: ta, wrap: na, accept: ia } = e, aa = Zi || $431fbd86ca7dc216$export$b204af158042fbac(Ui[0]).activeElement, da = Ui[0].previousElementSibling, La = $9bf71ea28793e738$var$getScopeRoot(Ui), qa = $9bf71ea28793e738$export$2d6ec8fc375ceafa(La, {
        tabbable: ta,
        accept: ia
      }, Ui);
      qa.currentNode = $9bf71ea28793e738$var$isElementInScope(aa, Ui) ? aa : da;
      let io = qa.nextNode();
      return !io && na && (qa.currentNode = da, io = qa.nextNode()), io && $9bf71ea28793e738$var$focusElement(io, !0), io;
    },
    focusPrevious(e = {}) {
      let Ui = Bi.current, { from: Zi, tabbable: ta, wrap: na, accept: ia } = e, aa = Zi || $431fbd86ca7dc216$export$b204af158042fbac(Ui[0]).activeElement, da = Ui[Ui.length - 1].nextElementSibling, La = $9bf71ea28793e738$var$getScopeRoot(Ui), qa = $9bf71ea28793e738$export$2d6ec8fc375ceafa(La, {
        tabbable: ta,
        accept: ia
      }, Ui);
      qa.currentNode = $9bf71ea28793e738$var$isElementInScope(aa, Ui) ? aa : da;
      let io = qa.previousNode();
      return !io && na && (qa.currentNode = da, io = qa.previousNode()), io && $9bf71ea28793e738$var$focusElement(io, !0), io;
    },
    focusFirst(e = {}) {
      let Ui = Bi.current, { tabbable: Zi, accept: ta } = e, na = $9bf71ea28793e738$var$getScopeRoot(Ui), ia = $9bf71ea28793e738$export$2d6ec8fc375ceafa(na, {
        tabbable: Zi,
        accept: ta
      }, Ui);
      ia.currentNode = Ui[0].previousElementSibling;
      let aa = ia.nextNode();
      return aa && $9bf71ea28793e738$var$focusElement(aa, !0), aa;
    },
    focusLast(e = {}) {
      let Ui = Bi.current, { tabbable: Zi, accept: ta } = e, na = $9bf71ea28793e738$var$getScopeRoot(Ui), ia = $9bf71ea28793e738$export$2d6ec8fc375ceafa(na, {
        tabbable: Zi,
        accept: ta
      }, Ui);
      ia.currentNode = Ui[Ui.length - 1].nextElementSibling;
      let aa = ia.previousNode();
      return aa && $9bf71ea28793e738$var$focusElement(aa, !0), aa;
    }
  };
}
const $9bf71ea28793e738$var$focusableElements = [
  "input:not([disabled]):not([type=hidden])",
  "select:not([disabled])",
  "textarea:not([disabled])",
  "button:not([disabled])",
  "a[href]",
  "area[href]",
  "summary",
  "iframe",
  "object",
  "embed",
  "audio[controls]",
  "video[controls]",
  '[contenteditable]:not([contenteditable^="false"])'
], $9bf71ea28793e738$var$FOCUSABLE_ELEMENT_SELECTOR = $9bf71ea28793e738$var$focusableElements.join(":not([hidden]),") + ",[tabindex]:not([disabled]):not([hidden])";
$9bf71ea28793e738$var$focusableElements.push('[tabindex]:not([tabindex="-1"]):not([disabled])');
const $9bf71ea28793e738$var$TABBABLE_ELEMENT_SELECTOR = $9bf71ea28793e738$var$focusableElements.join(':not([hidden]):not([tabindex="-1"]),');
function $9bf71ea28793e738$var$getScopeRoot(Bi) {
  return Bi[0].parentElement;
}
function $9bf71ea28793e738$var$shouldContainFocus(Bi) {
  let e = $9bf71ea28793e738$export$d06fae2ee68b101e.getTreeNode($9bf71ea28793e738$var$activeScope);
  for (; e && e.scopeRef !== Bi; ) {
    if (e.contain) return !1;
    e = e.parent;
  }
  return !0;
}
function $9bf71ea28793e738$var$useFocusContainment(Bi, e) {
  let Ui = useRef(void 0), Zi = useRef(void 0);
  $f0a04ccd8dbdd83b$export$e5c5a5f917a5871c(() => {
    let ta = Bi.current;
    if (!e) {
      Zi.current && (cancelAnimationFrame(Zi.current), Zi.current = void 0);
      return;
    }
    const na = $431fbd86ca7dc216$export$b204af158042fbac(ta ? ta[0] : void 0);
    let ia = (La) => {
      if (La.key !== "Tab" || La.altKey || La.ctrlKey || La.metaKey || !$9bf71ea28793e738$var$shouldContainFocus(Bi) || La.isComposing) return;
      let qa = na.activeElement, io = Bi.current;
      if (!io || !$9bf71ea28793e738$var$isElementInScope(qa, io)) return;
      let ao = $9bf71ea28793e738$var$getScopeRoot(io), oo = $9bf71ea28793e738$export$2d6ec8fc375ceafa(ao, {
        tabbable: !0
      }, io);
      if (!qa) return;
      oo.currentNode = qa;
      let no = La.shiftKey ? oo.previousNode() : oo.nextNode();
      no || (oo.currentNode = La.shiftKey ? io[io.length - 1].nextElementSibling : io[0].previousElementSibling, no = La.shiftKey ? oo.previousNode() : oo.nextNode()), La.preventDefault(), no && $9bf71ea28793e738$var$focusElement(no, !0);
    }, aa = (La) => {
      (!$9bf71ea28793e738$var$activeScope || $9bf71ea28793e738$var$isAncestorScope($9bf71ea28793e738$var$activeScope, Bi)) && $9bf71ea28793e738$var$isElementInScope(La.target, Bi.current) ? ($9bf71ea28793e738$var$activeScope = Bi, Ui.current = La.target) : $9bf71ea28793e738$var$shouldContainFocus(Bi) && !$9bf71ea28793e738$var$isElementInChildScope(La.target, Bi) ? Ui.current ? Ui.current.focus() : $9bf71ea28793e738$var$activeScope && $9bf71ea28793e738$var$activeScope.current && $9bf71ea28793e738$var$focusFirstInScope($9bf71ea28793e738$var$activeScope.current) : $9bf71ea28793e738$var$shouldContainFocus(Bi) && (Ui.current = La.target);
    }, da = (La) => {
      Zi.current && cancelAnimationFrame(Zi.current), Zi.current = requestAnimationFrame(() => {
        let qa = $507fabe10e71c6fb$export$630ff653c5ada6a9();
        if (!((qa === "virtual" || qa === null) && $c87311424ea30a05$export$a11b0059900ceec8() && $c87311424ea30a05$export$6446a186d09e379e()) && na.activeElement && $9bf71ea28793e738$var$shouldContainFocus(Bi) && !$9bf71ea28793e738$var$isElementInChildScope(na.activeElement, Bi))
          if ($9bf71ea28793e738$var$activeScope = Bi, na.body.contains(La.target)) {
            var ao;
            Ui.current = La.target, (ao = Ui.current) === null || ao === void 0 || ao.focus();
          } else $9bf71ea28793e738$var$activeScope.current && $9bf71ea28793e738$var$focusFirstInScope($9bf71ea28793e738$var$activeScope.current);
      });
    };
    return na.addEventListener("keydown", ia, !1), na.addEventListener("focusin", aa, !1), ta?.forEach((La) => La.addEventListener("focusin", aa, !1)), ta?.forEach((La) => La.addEventListener("focusout", da, !1)), () => {
      na.removeEventListener("keydown", ia, !1), na.removeEventListener("focusin", aa, !1), ta?.forEach((La) => La.removeEventListener("focusin", aa, !1)), ta?.forEach((La) => La.removeEventListener("focusout", da, !1));
    };
  }, [
    Bi,
    e
  ]), $f0a04ccd8dbdd83b$export$e5c5a5f917a5871c(() => () => {
    Zi.current && cancelAnimationFrame(Zi.current);
  }, [
    Zi
  ]);
}
function $9bf71ea28793e738$var$isElementInAnyScope(Bi) {
  return $9bf71ea28793e738$var$isElementInChildScope(Bi);
}
function $9bf71ea28793e738$var$isElementInScope(Bi, e) {
  return !Bi || !e ? !1 : e.some((Ui) => Ui.contains(Bi));
}
function $9bf71ea28793e738$var$isElementInChildScope(Bi, e = null) {
  if (Bi instanceof Element && Bi.closest("[data-react-aria-top-layer]")) return !0;
  for (let { scopeRef: Ui } of $9bf71ea28793e738$export$d06fae2ee68b101e.traverse($9bf71ea28793e738$export$d06fae2ee68b101e.getTreeNode(e)))
    if (Ui && $9bf71ea28793e738$var$isElementInScope(Bi, Ui.current)) return !0;
  return !1;
}
function $9bf71ea28793e738$export$1258395f99bf9cbf(Bi) {
  return $9bf71ea28793e738$var$isElementInChildScope(Bi, $9bf71ea28793e738$var$activeScope);
}
function $9bf71ea28793e738$var$isAncestorScope(Bi, e) {
  var Ui;
  let Zi = (Ui = $9bf71ea28793e738$export$d06fae2ee68b101e.getTreeNode(e)) === null || Ui === void 0 ? void 0 : Ui.parent;
  for (; Zi; ) {
    if (Zi.scopeRef === Bi) return !0;
    Zi = Zi.parent;
  }
  return !1;
}
function $9bf71ea28793e738$var$focusElement(Bi, e = !1) {
  if (Bi != null && !e) try {
    $6a99195332edec8b$export$80f3e147d781571c(Bi);
  } catch {
  }
  else if (Bi != null) try {
    Bi.focus();
  } catch {
  }
}
function $9bf71ea28793e738$var$getFirstInScope(Bi, e = !0) {
  let Ui = Bi[0].previousElementSibling, Zi = $9bf71ea28793e738$var$getScopeRoot(Bi), ta = $9bf71ea28793e738$export$2d6ec8fc375ceafa(Zi, {
    tabbable: e
  }, Bi);
  ta.currentNode = Ui;
  let na = ta.nextNode();
  return e && !na && (Zi = $9bf71ea28793e738$var$getScopeRoot(Bi), ta = $9bf71ea28793e738$export$2d6ec8fc375ceafa(Zi, {
    tabbable: !1
  }, Bi), ta.currentNode = Ui, na = ta.nextNode()), na;
}
function $9bf71ea28793e738$var$focusFirstInScope(Bi, e = !0) {
  $9bf71ea28793e738$var$focusElement($9bf71ea28793e738$var$getFirstInScope(Bi, e));
}
function $9bf71ea28793e738$var$useAutoFocus(Bi, e) {
  const Ui = a__default.useRef(e);
  useEffect(() => {
    if (Ui.current) {
      $9bf71ea28793e738$var$activeScope = Bi;
      const Zi = $431fbd86ca7dc216$export$b204af158042fbac(Bi.current ? Bi.current[0] : void 0);
      !$9bf71ea28793e738$var$isElementInScope(Zi.activeElement, $9bf71ea28793e738$var$activeScope.current) && Bi.current && $9bf71ea28793e738$var$focusFirstInScope(Bi.current);
    }
    Ui.current = !1;
  }, [
    Bi
  ]);
}
function $9bf71ea28793e738$var$useActiveScopeTracker(Bi, e, Ui) {
  $f0a04ccd8dbdd83b$export$e5c5a5f917a5871c(() => {
    if (e || Ui) return;
    let Zi = Bi.current;
    const ta = $431fbd86ca7dc216$export$b204af158042fbac(Zi ? Zi[0] : void 0);
    let na = (ia) => {
      let aa = ia.target;
      $9bf71ea28793e738$var$isElementInScope(aa, Bi.current) ? $9bf71ea28793e738$var$activeScope = Bi : $9bf71ea28793e738$var$isElementInAnyScope(aa) || ($9bf71ea28793e738$var$activeScope = null);
    };
    return ta.addEventListener("focusin", na, !1), Zi?.forEach((ia) => ia.addEventListener("focusin", na, !1)), () => {
      ta.removeEventListener("focusin", na, !1), Zi?.forEach((ia) => ia.removeEventListener("focusin", na, !1));
    };
  }, [
    Bi,
    e,
    Ui
  ]);
}
function $9bf71ea28793e738$var$shouldRestoreFocus(Bi) {
  let e = $9bf71ea28793e738$export$d06fae2ee68b101e.getTreeNode($9bf71ea28793e738$var$activeScope);
  for (; e && e.scopeRef !== Bi; ) {
    if (e.nodeToRestore) return !1;
    e = e.parent;
  }
  return e?.scopeRef === Bi;
}
function $9bf71ea28793e738$var$useRestoreFocus(Bi, e, Ui) {
  const Zi = useRef(typeof document < "u" ? $431fbd86ca7dc216$export$b204af158042fbac(Bi.current ? Bi.current[0] : void 0).activeElement : null);
  $f0a04ccd8dbdd83b$export$e5c5a5f917a5871c(() => {
    let ta = Bi.current;
    const na = $431fbd86ca7dc216$export$b204af158042fbac(ta ? ta[0] : void 0);
    if (!e || Ui) return;
    let ia = () => {
      (!$9bf71ea28793e738$var$activeScope || $9bf71ea28793e738$var$isAncestorScope($9bf71ea28793e738$var$activeScope, Bi)) && $9bf71ea28793e738$var$isElementInScope(na.activeElement, Bi.current) && ($9bf71ea28793e738$var$activeScope = Bi);
    };
    return na.addEventListener("focusin", ia, !1), ta?.forEach((aa) => aa.addEventListener("focusin", ia, !1)), () => {
      na.removeEventListener("focusin", ia, !1), ta?.forEach((aa) => aa.removeEventListener("focusin", ia, !1));
    };
  }, [
    Bi,
    Ui
  ]), $f0a04ccd8dbdd83b$export$e5c5a5f917a5871c(() => {
    const ta = $431fbd86ca7dc216$export$b204af158042fbac(Bi.current ? Bi.current[0] : void 0);
    if (!e) return;
    let na = (ia) => {
      if (ia.key !== "Tab" || ia.altKey || ia.ctrlKey || ia.metaKey || !$9bf71ea28793e738$var$shouldContainFocus(Bi) || ia.isComposing) return;
      let aa = ta.activeElement;
      if (!$9bf71ea28793e738$var$isElementInChildScope(aa, Bi) || !$9bf71ea28793e738$var$shouldRestoreFocus(Bi)) return;
      let da = $9bf71ea28793e738$export$d06fae2ee68b101e.getTreeNode(Bi);
      if (!da) return;
      let La = da.nodeToRestore, qa = $9bf71ea28793e738$export$2d6ec8fc375ceafa(ta.body, {
        tabbable: !0
      });
      qa.currentNode = aa;
      let io = ia.shiftKey ? qa.previousNode() : qa.nextNode();
      if ((!La || !ta.body.contains(La) || La === ta.body) && (La = void 0, da.nodeToRestore = void 0), (!io || !$9bf71ea28793e738$var$isElementInChildScope(io, Bi)) && La) {
        qa.currentNode = La;
        do
          io = ia.shiftKey ? qa.previousNode() : qa.nextNode();
        while ($9bf71ea28793e738$var$isElementInChildScope(io, Bi));
        ia.preventDefault(), ia.stopPropagation(), io ? $9bf71ea28793e738$var$focusElement(io, !0) : $9bf71ea28793e738$var$isElementInAnyScope(La) ? $9bf71ea28793e738$var$focusElement(La, !0) : aa.blur();
      }
    };
    return Ui || ta.addEventListener("keydown", na, !0), () => {
      Ui || ta.removeEventListener("keydown", na, !0);
    };
  }, [
    Bi,
    e,
    Ui
  ]), $f0a04ccd8dbdd83b$export$e5c5a5f917a5871c(() => {
    const ta = $431fbd86ca7dc216$export$b204af158042fbac(Bi.current ? Bi.current[0] : void 0);
    if (!e) return;
    let na = $9bf71ea28793e738$export$d06fae2ee68b101e.getTreeNode(Bi);
    if (na) {
      var ia;
      return na.nodeToRestore = (ia = Zi.current) !== null && ia !== void 0 ? ia : void 0, () => {
        let aa = $9bf71ea28793e738$export$d06fae2ee68b101e.getTreeNode(Bi);
        if (!aa) return;
        let da = aa.nodeToRestore;
        if (e && da && (ta.activeElement && $9bf71ea28793e738$var$isElementInChildScope(ta.activeElement, Bi) || ta.activeElement === ta.body && $9bf71ea28793e738$var$shouldRestoreFocus(Bi))) {
          let La = $9bf71ea28793e738$export$d06fae2ee68b101e.clone();
          requestAnimationFrame(() => {
            if (ta.activeElement === ta.body) {
              let qa = La.getTreeNode(Bi);
              for (; qa; ) {
                if (qa.nodeToRestore && qa.nodeToRestore.isConnected) {
                  $9bf71ea28793e738$var$restoreFocusToElement(qa.nodeToRestore);
                  return;
                }
                qa = qa.parent;
              }
              for (qa = La.getTreeNode(Bi); qa; ) {
                if (qa.scopeRef && qa.scopeRef.current && $9bf71ea28793e738$export$d06fae2ee68b101e.getTreeNode(qa.scopeRef)) {
                  let io = $9bf71ea28793e738$var$getFirstInScope(qa.scopeRef.current, !0);
                  $9bf71ea28793e738$var$restoreFocusToElement(io);
                  return;
                }
                qa = qa.parent;
              }
            }
          });
        }
      };
    }
  }, [
    Bi,
    e
  ]);
}
function $9bf71ea28793e738$var$restoreFocusToElement(Bi) {
  Bi.dispatchEvent(new CustomEvent($9bf71ea28793e738$var$RESTORE_FOCUS_EVENT, {
    bubbles: !0,
    cancelable: !0
  })) && $9bf71ea28793e738$var$focusElement(Bi);
}
function $9bf71ea28793e738$export$2d6ec8fc375ceafa(Bi, e, Ui) {
  let Zi = e?.tabbable ? $9bf71ea28793e738$var$TABBABLE_ELEMENT_SELECTOR : $9bf71ea28793e738$var$FOCUSABLE_ELEMENT_SELECTOR, ta = $431fbd86ca7dc216$export$b204af158042fbac(Bi).createTreeWalker(Bi, NodeFilter.SHOW_ELEMENT, {
    acceptNode(na) {
      var ia;
      return !(e == null || (ia = e.from) === null || ia === void 0) && ia.contains(na) ? NodeFilter.FILTER_REJECT : na.matches(Zi) && $645f2e67b85a24c9$export$e989c0fffaa6b27a(na) && (!Ui || $9bf71ea28793e738$var$isElementInScope(na, Ui)) && (!e?.accept || e.accept(na)) ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_SKIP;
    }
  });
  return e?.from && (ta.currentNode = e.from), ta;
}
class $9bf71ea28793e738$var$Tree {
  get size() {
    return this.fastMap.size;
  }
  getTreeNode(e) {
    return this.fastMap.get(e);
  }
  addTreeNode(e, Ui, Zi) {
    let ta = this.fastMap.get(Ui ?? null);
    if (!ta) return;
    let na = new $9bf71ea28793e738$var$TreeNode({
      scopeRef: e
    });
    ta.addChild(na), na.parent = ta, this.fastMap.set(e, na), Zi && (na.nodeToRestore = Zi);
  }
  addNode(e) {
    this.fastMap.set(e.scopeRef, e);
  }
  removeTreeNode(e) {
    if (e === null) return;
    let Ui = this.fastMap.get(e);
    if (!Ui) return;
    let Zi = Ui.parent;
    for (let na of this.traverse()) na !== Ui && Ui.nodeToRestore && na.nodeToRestore && Ui.scopeRef && Ui.scopeRef.current && $9bf71ea28793e738$var$isElementInScope(na.nodeToRestore, Ui.scopeRef.current) && (na.nodeToRestore = Ui.nodeToRestore);
    let ta = Ui.children;
    Zi && (Zi.removeChild(Ui), ta.size > 0 && ta.forEach((na) => Zi && Zi.addChild(na))), this.fastMap.delete(Ui.scopeRef);
  }
  // Pre Order Depth First
  *traverse(e = this.root) {
    if (e.scopeRef != null && (yield e), e.children.size > 0) for (let Ui of e.children) yield* this.traverse(Ui);
  }
  clone() {
    var e;
    let Ui = new $9bf71ea28793e738$var$Tree();
    var Zi;
    for (let ta of this.traverse()) Ui.addTreeNode(ta.scopeRef, (Zi = (e = ta.parent) === null || e === void 0 ? void 0 : e.scopeRef) !== null && Zi !== void 0 ? Zi : null, ta.nodeToRestore);
    return Ui;
  }
  constructor() {
    this.fastMap = /* @__PURE__ */ new Map(), this.root = new $9bf71ea28793e738$var$TreeNode({
      scopeRef: null
    }), this.fastMap.set(null, this.root);
  }
}
class $9bf71ea28793e738$var$TreeNode {
  addChild(e) {
    this.children.add(e), e.parent = this;
  }
  removeChild(e) {
    this.children.delete(e), e.parent = void 0;
  }
  constructor(e) {
    this.children = /* @__PURE__ */ new Set(), this.contain = !1, this.scopeRef = e.scopeRef;
  }
}
let $9bf71ea28793e738$export$d06fae2ee68b101e = new $9bf71ea28793e738$var$Tree();
function $f7dceffc5ad7768b$export$4e328f61c538687f(Bi = {}) {
  let { autoFocus: e = !1, isTextInput: Ui, within: Zi } = Bi, ta = useRef({
    isFocused: !1,
    isFocusVisible: e || $507fabe10e71c6fb$export$b9b3dfddab17db27()
  }), [na, ia] = useState(!1), [aa, da] = useState(() => ta.current.isFocused && ta.current.isFocusVisible), La = useCallback(() => da(ta.current.isFocused && ta.current.isFocusVisible), []), qa = useCallback((oo) => {
    ta.current.isFocused = oo, ia(oo), La();
  }, [
    La
  ]);
  $507fabe10e71c6fb$export$ec71b4b83ac08ec3((oo) => {
    ta.current.isFocusVisible = oo, La();
  }, [], {
    isTextInput: Ui
  });
  let { focusProps: io } = $a1ea59d68270f0dd$export$f8168d8dd8fd66e6({
    isDisabled: Zi,
    onFocusChange: qa
  }), { focusWithinProps: ao } = $9ab94262bd0047c7$export$420e68273165f4ec({
    isDisabled: !Zi,
    onFocusWithinChange: qa
  });
  return {
    isFocused: na,
    isFocusVisible: aa,
    focusProps: Zi ? ao : io
  };
}
let $e6afbd83fe6ebbd2$var$FocusableContext = /* @__PURE__ */ a__default.createContext(null);
function $e6afbd83fe6ebbd2$var$useFocusableContext(Bi) {
  let e = useContext($e6afbd83fe6ebbd2$var$FocusableContext) || {};
  $e7801be82b4b2a53$export$4debdb1a3f0fa79e(e, Bi);
  let { ref: Ui, ...Zi } = e;
  return Zi;
}
function $e6afbd83fe6ebbd2$export$4c014de7c8940b4c(Bi, e) {
  let { focusProps: Ui } = $a1ea59d68270f0dd$export$f8168d8dd8fd66e6(Bi), { keyboardProps: Zi } = $46d819fcbaf35654$export$8f71654801c2f7cd(Bi), ta = $3ef42575df84b30b$export$9d1611c77c2fe928(Ui, Zi), na = $e6afbd83fe6ebbd2$var$useFocusableContext(e), ia = Bi.isDisabled ? {} : na, aa = useRef(Bi.autoFocus);
  return useEffect(() => {
    aa.current && e.current && $6a99195332edec8b$export$80f3e147d781571c(e.current), aa.current = !1;
  }, [
    e
  ]), {
    focusableProps: $3ef42575df84b30b$export$9d1611c77c2fe928({
      ...ta,
      tabIndex: Bi.excludeFromTabOrder && !Bi.isDisabled ? -1 : void 0
    }, ia)
  };
}
const $148a7a147e38ea7f$var$RTL_SCRIPTS = /* @__PURE__ */ new Set([
  "Arab",
  "Syrc",
  "Samr",
  "Mand",
  "Thaa",
  "Mend",
  "Nkoo",
  "Adlm",
  "Rohg",
  "Hebr"
]), $148a7a147e38ea7f$var$RTL_LANGS = /* @__PURE__ */ new Set([
  "ae",
  "ar",
  "arc",
  "bcc",
  "bqi",
  "ckb",
  "dv",
  "fa",
  "glk",
  "he",
  "ku",
  "mzn",
  "nqo",
  "pnb",
  "ps",
  "sd",
  "ug",
  "ur",
  "yi"
]);
function $148a7a147e38ea7f$export$702d680b21cbd764(Bi) {
  if (Intl.Locale) {
    let Ui = new Intl.Locale(Bi).maximize(), Zi = typeof Ui.getTextInfo == "function" ? Ui.getTextInfo() : Ui.textInfo;
    if (Zi) return Zi.direction === "rtl";
    if (Ui.script) return $148a7a147e38ea7f$var$RTL_SCRIPTS.has(Ui.script);
  }
  let e = Bi.split("-")[0];
  return $148a7a147e38ea7f$var$RTL_LANGS.has(e);
}
const $1e5a04cdaf7d1af8$var$localeSymbol = Symbol.for("react-aria.i18n.locale");
function $1e5a04cdaf7d1af8$export$f09106e7c6677ec5() {
  let Bi = typeof window < "u" && window[$1e5a04cdaf7d1af8$var$localeSymbol] || typeof navigator < "u" && (navigator.language || navigator.userLanguage) || "en-US";
  try {
    Intl.DateTimeFormat.supportedLocalesOf([
      Bi
    ]);
  } catch {
    Bi = "en-US";
  }
  return {
    locale: Bi,
    direction: $148a7a147e38ea7f$export$702d680b21cbd764(Bi) ? "rtl" : "ltr"
  };
}
let $1e5a04cdaf7d1af8$var$currentLocale = $1e5a04cdaf7d1af8$export$f09106e7c6677ec5(), $1e5a04cdaf7d1af8$var$listeners = /* @__PURE__ */ new Set();
function $1e5a04cdaf7d1af8$var$updateLocale() {
  $1e5a04cdaf7d1af8$var$currentLocale = $1e5a04cdaf7d1af8$export$f09106e7c6677ec5();
  for (let Bi of $1e5a04cdaf7d1af8$var$listeners) Bi($1e5a04cdaf7d1af8$var$currentLocale);
}
function $1e5a04cdaf7d1af8$export$188ec29ebc2bdc3a() {
  let Bi = $b5e257d569688ac6$export$535bd6ca7f90a273(), [e, Ui] = useState($1e5a04cdaf7d1af8$var$currentLocale);
  return useEffect(() => ($1e5a04cdaf7d1af8$var$listeners.size === 0 && window.addEventListener("languagechange", $1e5a04cdaf7d1af8$var$updateLocale), $1e5a04cdaf7d1af8$var$listeners.add(Ui), () => {
    $1e5a04cdaf7d1af8$var$listeners.delete(Ui), $1e5a04cdaf7d1af8$var$listeners.size === 0 && window.removeEventListener("languagechange", $1e5a04cdaf7d1af8$var$updateLocale);
  }), []), Bi ? {
    locale: "en-US",
    direction: "ltr"
  } : e;
}
const $18f2051aff69b9bf$var$I18nContext = /* @__PURE__ */ a__default.createContext(null);
function $18f2051aff69b9bf$export$43bb16f9c6d9e3f7() {
  let Bi = $1e5a04cdaf7d1af8$export$188ec29ebc2bdc3a();
  return useContext($18f2051aff69b9bf$var$I18nContext) || Bi;
}
const $5b160d28a433310d$var$localeSymbol = Symbol.for("react-aria.i18n.locale"), $5b160d28a433310d$var$stringsSymbol = Symbol.for("react-aria.i18n.strings");
let $5b160d28a433310d$var$cachedGlobalStrings;
class $5b160d28a433310d$export$c17fa47878dc55b6 {
  /** Returns a localized string for the given key and locale. */
  getStringForLocale(e, Ui) {
    let ta = this.getStringsForLocale(Ui)[e];
    if (!ta) throw new Error(`Could not find intl message ${e} in ${Ui} locale`);
    return ta;
  }
  /** Returns all localized strings for the given locale. */
  getStringsForLocale(e) {
    let Ui = this.strings[e];
    return Ui || (Ui = $5b160d28a433310d$var$getStringsForLocale(e, this.strings, this.defaultLocale), this.strings[e] = Ui), Ui;
  }
  static getGlobalDictionaryForPackage(e) {
    if (typeof window > "u") return null;
    let Ui = window[$5b160d28a433310d$var$localeSymbol];
    if ($5b160d28a433310d$var$cachedGlobalStrings === void 0) {
      let ta = window[$5b160d28a433310d$var$stringsSymbol];
      if (!ta) return null;
      $5b160d28a433310d$var$cachedGlobalStrings = {};
      for (let na in ta) $5b160d28a433310d$var$cachedGlobalStrings[na] = new $5b160d28a433310d$export$c17fa47878dc55b6({
        [Ui]: ta[na]
      }, Ui);
    }
    let Zi = $5b160d28a433310d$var$cachedGlobalStrings?.[e];
    if (!Zi) throw new Error(`Strings for package "${e}" were not included by LocalizedStringProvider. Please add it to the list passed to createLocalizedStringDictionary.`);
    return Zi;
  }
  constructor(e, Ui = "en-US") {
    this.strings = Object.fromEntries(Object.entries(e).filter(([, Zi]) => Zi)), this.defaultLocale = Ui;
  }
}
function $5b160d28a433310d$var$getStringsForLocale(Bi, e, Ui = "en-US") {
  if (e[Bi]) return e[Bi];
  let Zi = $5b160d28a433310d$var$getLanguage(Bi);
  if (e[Zi]) return e[Zi];
  for (let ta in e)
    if (ta.startsWith(Zi + "-")) return e[ta];
  return e[Ui];
}
function $5b160d28a433310d$var$getLanguage(Bi) {
  return Intl.Locale ? new Intl.Locale(Bi).language : Bi.split("-")[0];
}
const $6db58dc88e78b024$var$pluralRulesCache = /* @__PURE__ */ new Map(), $6db58dc88e78b024$var$numberFormatCache = /* @__PURE__ */ new Map();
class $6db58dc88e78b024$export$2f817fcdc4b89ae0 {
  /** Formats a localized string for the given key with the provided variables. */
  format(e, Ui) {
    let Zi = this.strings.getStringForLocale(e, this.locale);
    return typeof Zi == "function" ? Zi(Ui, this) : Zi;
  }
  plural(e, Ui, Zi = "cardinal") {
    let ta = Ui["=" + e];
    if (ta) return typeof ta == "function" ? ta() : ta;
    let na = this.locale + ":" + Zi, ia = $6db58dc88e78b024$var$pluralRulesCache.get(na);
    ia || (ia = new Intl.PluralRules(this.locale, {
      type: Zi
    }), $6db58dc88e78b024$var$pluralRulesCache.set(na, ia));
    let aa = ia.select(e);
    return ta = Ui[aa] || Ui.other, typeof ta == "function" ? ta() : ta;
  }
  number(e) {
    let Ui = $6db58dc88e78b024$var$numberFormatCache.get(this.locale);
    return Ui || (Ui = new Intl.NumberFormat(this.locale), $6db58dc88e78b024$var$numberFormatCache.set(this.locale, Ui)), Ui.format(e);
  }
  select(e, Ui) {
    let Zi = e[Ui] || e.other;
    return typeof Zi == "function" ? Zi() : Zi;
  }
  constructor(e, Ui) {
    this.locale = e, this.strings = Ui;
  }
}
const $fca6afa0e843324b$var$cache = /* @__PURE__ */ new WeakMap();
function $fca6afa0e843324b$var$getCachedDictionary(Bi) {
  let e = $fca6afa0e843324b$var$cache.get(Bi);
  return e || (e = new $5b160d28a433310d$export$c17fa47878dc55b6(Bi), $fca6afa0e843324b$var$cache.set(Bi, e)), e;
}
function $fca6afa0e843324b$export$87b761675e8eaa10(Bi, e) {
  return e && $5b160d28a433310d$export$c17fa47878dc55b6.getGlobalDictionaryForPackage(e) || $fca6afa0e843324b$var$getCachedDictionary(Bi);
}
function $fca6afa0e843324b$export$f12b703ca79dfbb1(Bi, e) {
  let { locale: Ui } = $18f2051aff69b9bf$export$43bb16f9c6d9e3f7(), Zi = $fca6afa0e843324b$export$87b761675e8eaa10(Bi, e);
  return useMemo(() => new $6db58dc88e78b024$export$2f817fcdc4b89ae0(Ui, Zi), [
    Ui,
    Zi
  ]);
}
let $325a3faab7a68acd$var$cache = /* @__PURE__ */ new Map();
function $325a3faab7a68acd$export$a16aca283550c30d(Bi) {
  let { locale: e } = $18f2051aff69b9bf$export$43bb16f9c6d9e3f7(), Ui = e + (Bi ? Object.entries(Bi).sort((ta, na) => ta[0] < na[0] ? -1 : 1).join() : "");
  if ($325a3faab7a68acd$var$cache.has(Ui)) return $325a3faab7a68acd$var$cache.get(Ui);
  let Zi = new Intl.Collator(e, Bi);
  return $325a3faab7a68acd$var$cache.set(Ui, Zi), Zi;
}
function $701a24aa0da5b062$export$ea18c227d4417cc3(Bi, e) {
  let {
    elementType: Ui = "button",
    isDisabled: Zi,
    onPress: ta,
    onPressStart: na,
    onPressEnd: ia,
    onPressUp: aa,
    onPressChange: da,
    preventFocusOnPress: La,
    allowFocusWhenDisabled: qa,
    // @ts-ignore
    onClick: io,
    href: ao,
    target: oo,
    rel: no,
    type: lo = "button"
  } = Bi, so;
  Ui === "button" ? so = {
    type: lo,
    disabled: Zi
  } : so = {
    role: "button",
    tabIndex: Zi ? void 0 : 0,
    href: Ui === "a" && !Zi ? ao : void 0,
    target: Ui === "a" ? oo : void 0,
    type: Ui === "input" ? lo : void 0,
    disabled: Ui === "input" ? Zi : void 0,
    "aria-disabled": !Zi || Ui === "input" ? void 0 : Zi,
    rel: Ui === "a" ? no : void 0
  };
  let { pressProps: bs, isPressed: Rs } = $f6c31cce2adf654f$export$45712eceda6fad21({
    onPressStart: na,
    onPressEnd: ia,
    onPressChange: da,
    onPress: ta,
    onPressUp: aa,
    isDisabled: Zi,
    preventFocusOnPress: La,
    ref: e
  }), { focusableProps: js } = $e6afbd83fe6ebbd2$export$4c014de7c8940b4c(Bi, e);
  qa && (js.tabIndex = Zi ? -1 : js.tabIndex);
  let qs = $3ef42575df84b30b$export$9d1611c77c2fe928(js, bs, $65484d02dcb7eb3e$export$457c3d6518dd4c6f(Bi, {
    labelable: !0
  }));
  return {
    isPressed: Rs,
    buttonProps: $3ef42575df84b30b$export$9d1611c77c2fe928(so, qs, {
      "aria-haspopup": Bi["aria-haspopup"],
      "aria-expanded": Bi["aria-expanded"],
      "aria-controls": Bi["aria-controls"],
      "aria-pressed": Bi["aria-pressed"],
      onClick: (jo) => {
        io && (io(jo), console.warn("onClick is deprecated, please use onPress"));
      }
    })
  };
}
const $319e236875307eab$var$LIVEREGION_TIMEOUT_DELAY = 7e3;
let $319e236875307eab$var$liveAnnouncer = null;
function $319e236875307eab$export$a9b970dcc4ae71a9(Bi, e = "assertive", Ui = $319e236875307eab$var$LIVEREGION_TIMEOUT_DELAY) {
  $319e236875307eab$var$liveAnnouncer ? $319e236875307eab$var$liveAnnouncer.announce(Bi, e, Ui) : ($319e236875307eab$var$liveAnnouncer = new $319e236875307eab$var$LiveAnnouncer(), (typeof IS_REACT_ACT_ENVIRONMENT == "boolean" ? IS_REACT_ACT_ENVIRONMENT : typeof jest < "u") ? $319e236875307eab$var$liveAnnouncer.announce(Bi, e, Ui) : setTimeout(() => {
    $319e236875307eab$var$liveAnnouncer?.isAttached() && $319e236875307eab$var$liveAnnouncer?.announce(Bi, e, Ui);
  }, 100));
}
class $319e236875307eab$var$LiveAnnouncer {
  isAttached() {
    var e;
    return (e = this.node) === null || e === void 0 ? void 0 : e.isConnected;
  }
  createLog(e) {
    let Ui = document.createElement("div");
    return Ui.setAttribute("role", "log"), Ui.setAttribute("aria-live", e), Ui.setAttribute("aria-relevant", "additions"), Ui;
  }
  destroy() {
    this.node && (document.body.removeChild(this.node), this.node = null);
  }
  announce(e, Ui = "assertive", Zi = $319e236875307eab$var$LIVEREGION_TIMEOUT_DELAY) {
    var ta, na;
    if (!this.node) return;
    let ia = document.createElement("div");
    typeof e == "object" ? (ia.setAttribute("role", "img"), ia.setAttribute("aria-labelledby", e["aria-labelledby"])) : ia.textContent = e, Ui === "assertive" ? (ta = this.assertiveLog) === null || ta === void 0 || ta.appendChild(ia) : (na = this.politeLog) === null || na === void 0 || na.appendChild(ia), e !== "" && setTimeout(() => {
      ia.remove();
    }, Zi);
  }
  clear(e) {
    this.node && ((!e || e === "assertive") && this.assertiveLog && (this.assertiveLog.innerHTML = ""), (!e || e === "polite") && this.politeLog && (this.politeLog.innerHTML = ""));
  }
  constructor() {
    this.node = null, this.assertiveLog = null, this.politeLog = null, typeof document < "u" && (this.node = document.createElement("div"), this.node.dataset.liveAnnouncer = "true", Object.assign(this.node.style, {
      border: 0,
      clip: "rect(0 0 0 0)",
      clipPath: "inset(50%)",
      height: "1px",
      margin: "-1px",
      overflow: "hidden",
      padding: 0,
      position: "absolute",
      width: "1px",
      whiteSpace: "nowrap"
    }), this.assertiveLog = this.createLog("assertive"), this.node.appendChild(this.assertiveLog), this.politeLog = this.createLog("polite"), this.node.appendChild(this.politeLog), document.body.prepend(this.node));
  }
}
const $e5be200c675c3b3a$export$aca958c65c314e6c = {
  badInput: !1,
  customError: !1,
  patternMismatch: !1,
  rangeOverflow: !1,
  rangeUnderflow: !1,
  stepMismatch: !1,
  tooLong: !1,
  tooShort: !1,
  typeMismatch: !1,
  valueMissing: !1,
  valid: !0
}, $e5be200c675c3b3a$var$CUSTOM_VALIDITY_STATE = {
  ...$e5be200c675c3b3a$export$aca958c65c314e6c,
  customError: !0,
  valid: !1
}, $e5be200c675c3b3a$export$dad6ae84456c676a = {
  isInvalid: !1,
  validationDetails: $e5be200c675c3b3a$export$aca958c65c314e6c,
  validationErrors: []
}, $e5be200c675c3b3a$export$571b5131b7e65c11 = createContext({}), $e5be200c675c3b3a$export$a763b9476acd3eb = "__formValidationState" + Date.now();
function $e5be200c675c3b3a$export$fc1a364ae1f3ff10(Bi) {
  if (Bi[$e5be200c675c3b3a$export$a763b9476acd3eb]) {
    let { realtimeValidation: e, displayValidation: Ui, updateValidation: Zi, resetValidation: ta, commitValidation: na } = Bi[$e5be200c675c3b3a$export$a763b9476acd3eb];
    return {
      realtimeValidation: e,
      displayValidation: Ui,
      updateValidation: Zi,
      resetValidation: ta,
      commitValidation: na
    };
  }
  return $e5be200c675c3b3a$var$useFormValidationStateImpl(Bi);
}
function $e5be200c675c3b3a$var$useFormValidationStateImpl(Bi) {
  let { isInvalid: e, validationState: Ui, name: Zi, value: ta, builtinValidation: na, validate: ia, validationBehavior: aa = "aria" } = Bi;
  Ui && (e || (e = Ui === "invalid"));
  let da = e !== void 0 ? {
    isInvalid: e,
    validationErrors: [],
    validationDetails: $e5be200c675c3b3a$var$CUSTOM_VALIDITY_STATE
  } : null, La = useMemo(() => {
    if (!ia || ta == null) return null;
    let Zs = $e5be200c675c3b3a$var$runValidate(ia, ta);
    return $e5be200c675c3b3a$var$getValidationResult(Zs);
  }, [
    ia,
    ta
  ]);
  na?.validationDetails.valid && (na = void 0);
  let qa = useContext($e5be200c675c3b3a$export$571b5131b7e65c11), io = useMemo(() => Zi ? Array.isArray(Zi) ? Zi.flatMap((Zs) => $e5be200c675c3b3a$var$asArray(qa[Zs])) : $e5be200c675c3b3a$var$asArray(qa[Zi]) : [], [
    qa,
    Zi
  ]), [ao, oo] = useState(qa), [no, lo] = useState(!1);
  qa !== ao && (oo(qa), lo(!1));
  let so = useMemo(() => $e5be200c675c3b3a$var$getValidationResult(no ? [] : io), [
    no,
    io
  ]), bs = useRef($e5be200c675c3b3a$export$dad6ae84456c676a), [Rs, js] = useState($e5be200c675c3b3a$export$dad6ae84456c676a), qs = useRef($e5be200c675c3b3a$export$dad6ae84456c676a), jo = () => {
    if (!fs) return;
    Ao(!1);
    let Zs = La || na || bs.current;
    $e5be200c675c3b3a$var$isEqualValidation(Zs, qs.current) || (qs.current = Zs, js(Zs));
  }, [fs, Ao] = useState(!1);
  return useEffect(jo), {
    realtimeValidation: da || so || La || na || $e5be200c675c3b3a$export$dad6ae84456c676a,
    displayValidation: aa === "native" ? da || so || Rs : da || so || La || na || Rs,
    updateValidation(Zs) {
      aa === "aria" && !$e5be200c675c3b3a$var$isEqualValidation(Rs, Zs) ? js(Zs) : bs.current = Zs;
    },
    resetValidation() {
      let Zs = $e5be200c675c3b3a$export$dad6ae84456c676a;
      $e5be200c675c3b3a$var$isEqualValidation(Zs, qs.current) || (qs.current = Zs, js(Zs)), aa === "native" && Ao(!1), lo(!0);
    },
    commitValidation() {
      aa === "native" && Ao(!0), lo(!0);
    }
  };
}
function $e5be200c675c3b3a$var$asArray(Bi) {
  return Bi ? Array.isArray(Bi) ? Bi : [
    Bi
  ] : [];
}
function $e5be200c675c3b3a$var$runValidate(Bi, e) {
  if (typeof Bi == "function") {
    let Ui = Bi(e);
    if (Ui && typeof Ui != "boolean") return $e5be200c675c3b3a$var$asArray(Ui);
  }
  return [];
}
function $e5be200c675c3b3a$var$getValidationResult(Bi) {
  return Bi.length ? {
    isInvalid: !0,
    validationErrors: Bi,
    validationDetails: $e5be200c675c3b3a$var$CUSTOM_VALIDITY_STATE
  } : null;
}
function $e5be200c675c3b3a$var$isEqualValidation(Bi, e) {
  return Bi === e ? !0 : !!Bi && !!e && Bi.isInvalid === e.isInvalid && Bi.validationErrors.length === e.validationErrors.length && Bi.validationErrors.every((Ui, Zi) => Ui === e.validationErrors[Zi]) && Object.entries(Bi.validationDetails).every(([Ui, Zi]) => e.validationDetails[Ui] === Zi);
}
function $e93e671b31057976$export$b8473d3665f3a75a(Bi, e, Ui) {
  let { validationBehavior: Zi, focus: ta } = Bi;
  $f0a04ccd8dbdd83b$export$e5c5a5f917a5871c(() => {
    if (Zi === "native" && Ui?.current && !Ui.current.disabled) {
      let da = e.realtimeValidation.isInvalid ? e.realtimeValidation.validationErrors.join(" ") || "Invalid value." : "";
      Ui.current.setCustomValidity(da), Ui.current.hasAttribute("title") || (Ui.current.title = ""), e.realtimeValidation.isInvalid || e.updateValidation($e93e671b31057976$var$getNativeValidity(Ui.current));
    }
  });
  let na = $8ae05eaa5c114e9c$export$7f54fc3180508a52(() => {
    e.resetValidation();
  }), ia = $8ae05eaa5c114e9c$export$7f54fc3180508a52((da) => {
    var La;
    e.displayValidation.isInvalid || e.commitValidation();
    let qa = Ui == null || (La = Ui.current) === null || La === void 0 ? void 0 : La.form;
    if (!da.defaultPrevented && Ui && qa && $e93e671b31057976$var$getFirstInvalidInput(qa) === Ui.current) {
      var io;
      ta ? ta() : (io = Ui.current) === null || io === void 0 || io.focus(), $507fabe10e71c6fb$export$8397ddfc504fdb9a("keyboard");
    }
    da.preventDefault();
  }), aa = $8ae05eaa5c114e9c$export$7f54fc3180508a52(() => {
    e.commitValidation();
  });
  useEffect(() => {
    let da = Ui?.current;
    if (!da) return;
    let La = da.form;
    return da.addEventListener("invalid", ia), da.addEventListener("change", aa), La?.addEventListener("reset", na), () => {
      da.removeEventListener("invalid", ia), da.removeEventListener("change", aa), La?.removeEventListener("reset", na);
    };
  }, [
    Ui,
    ia,
    aa,
    na,
    Zi
  ]);
}
function $e93e671b31057976$var$getValidity(Bi) {
  let e = Bi.validity;
  return {
    badInput: e.badInput,
    customError: e.customError,
    patternMismatch: e.patternMismatch,
    rangeOverflow: e.rangeOverflow,
    rangeUnderflow: e.rangeUnderflow,
    stepMismatch: e.stepMismatch,
    tooLong: e.tooLong,
    tooShort: e.tooShort,
    typeMismatch: e.typeMismatch,
    valueMissing: e.valueMissing,
    valid: e.valid
  };
}
function $e93e671b31057976$var$getNativeValidity(Bi) {
  return {
    isInvalid: !Bi.validity.valid,
    validationDetails: $e93e671b31057976$var$getValidity(Bi),
    validationErrors: Bi.validationMessage ? [
      Bi.validationMessage
    ] : []
  };
}
function $e93e671b31057976$var$getFirstInvalidInput(Bi) {
  for (let e = 0; e < Bi.elements.length; e++) {
    let Ui = Bi.elements[e];
    if (!Ui.validity.valid) return Ui;
  }
  return null;
}
function $d191a55c9702f145$export$8467354a121f1b9f(Bi) {
  let { id: e, label: Ui, "aria-labelledby": Zi, "aria-label": ta, labelElementType: na = "label" } = Bi;
  e = $bdb11010cef70236$export$f680877a34711e37(e);
  let ia = $bdb11010cef70236$export$f680877a34711e37(), aa = {};
  Ui ? (Zi = Zi ? `${ia} ${Zi}` : ia, aa = {
    id: ia,
    htmlFor: na === "label" ? e : void 0
  }) : !Zi && !ta && console.warn("If you do not provide a visible label, you must specify an aria-label or aria-labelledby attribute for accessibility");
  let da = $313b98861ee5dd6c$export$d6875122194c7b44({
    id: e,
    "aria-label": ta,
    "aria-labelledby": Zi
  });
  return {
    labelProps: aa,
    fieldProps: da
  };
}
function $2baaea4c71418dea$export$294aa081a6c6f55d(Bi) {
  let { description: e, errorMessage: Ui, isInvalid: Zi, validationState: ta } = Bi, { labelProps: na, fieldProps: ia } = $d191a55c9702f145$export$8467354a121f1b9f(Bi), aa = $bdb11010cef70236$export$b4cc09c592e8fdb8([
    !!e,
    !!Ui,
    Zi,
    ta
  ]), da = $bdb11010cef70236$export$b4cc09c592e8fdb8([
    !!e,
    !!Ui,
    Zi,
    ta
  ]);
  return ia = $3ef42575df84b30b$export$9d1611c77c2fe928(ia, {
    "aria-describedby": [
      aa,
      // Use aria-describedby for error message because aria-errormessage is unsupported using VoiceOver or NVDA. See https://github.com/adobe/react-spectrum/issues/1346#issuecomment-740136268
      da,
      Bi["aria-describedby"]
    ].filter(Boolean).join(" ") || void 0
  }), {
    labelProps: na,
    fieldProps: ia,
    descriptionProps: {
      id: aa
    },
    errorMessageProps: {
      id: da
    }
  };
}
const $5c3e21d68f1c4674$var$styles = {
  border: 0,
  clip: "rect(0 0 0 0)",
  clipPath: "inset(50%)",
  height: "1px",
  margin: "-1px",
  overflow: "hidden",
  padding: 0,
  position: "absolute",
  width: "1px",
  whiteSpace: "nowrap"
};
function $5c3e21d68f1c4674$export$a966af930f325cab(Bi = {}) {
  let { style: e, isFocusable: Ui } = Bi, [Zi, ta] = useState(!1), { focusWithinProps: na } = $9ab94262bd0047c7$export$420e68273165f4ec({
    isDisabled: !Ui,
    onFocusWithinChange: (aa) => ta(aa)
  }), ia = useMemo(() => Zi ? e : e ? {
    ...$5c3e21d68f1c4674$var$styles,
    ...e
  } : $5c3e21d68f1c4674$var$styles, [
    Zi
  ]);
  return {
    visuallyHiddenProps: {
      ...na,
      style: ia
    }
  };
}
function $5c3e21d68f1c4674$export$439d29a4e110a164(Bi) {
  let { children: e, elementType: Ui = "div", isFocusable: Zi, style: ta, ...na } = Bi, { visuallyHiddenProps: ia } = $5c3e21d68f1c4674$export$a966af930f325cab(Bi);
  return /* @__PURE__ */ a__default.createElement(Ui, $3ef42575df84b30b$export$9d1611c77c2fe928(na, ia), e);
}
const $edcf132a9284368a$var$AXIS = {
  top: "top",
  bottom: "top",
  left: "left",
  right: "left"
}, $edcf132a9284368a$var$FLIPPED_DIRECTION = {
  top: "bottom",
  bottom: "top",
  left: "right",
  right: "left"
}, $edcf132a9284368a$var$CROSS_AXIS = {
  top: "left",
  left: "top"
}, $edcf132a9284368a$var$AXIS_SIZE = {
  top: "height",
  left: "width"
}, $edcf132a9284368a$var$TOTAL_SIZE = {
  width: "totalWidth",
  height: "totalHeight"
}, $edcf132a9284368a$var$PARSED_PLACEMENT_CACHE = {};
let $edcf132a9284368a$var$visualViewport = typeof document < "u" ? window.visualViewport : null;
function $edcf132a9284368a$var$getContainerDimensions(Bi) {
  let e = 0, Ui = 0, Zi = 0, ta = 0, na = 0, ia = 0, aa = {};
  var da;
  let La = ((da = $edcf132a9284368a$var$visualViewport?.scale) !== null && da !== void 0 ? da : 1) > 1;
  if (Bi.tagName === "BODY") {
    let no = document.documentElement;
    Zi = no.clientWidth, ta = no.clientHeight;
    var qa;
    e = (qa = $edcf132a9284368a$var$visualViewport?.width) !== null && qa !== void 0 ? qa : Zi;
    var io;
    Ui = (io = $edcf132a9284368a$var$visualViewport?.height) !== null && io !== void 0 ? io : ta, aa.top = no.scrollTop || Bi.scrollTop, aa.left = no.scrollLeft || Bi.scrollLeft, $edcf132a9284368a$var$visualViewport && (na = $edcf132a9284368a$var$visualViewport.offsetTop, ia = $edcf132a9284368a$var$visualViewport.offsetLeft);
  } else
    ({ width: e, height: Ui, top: na, left: ia } = $edcf132a9284368a$var$getOffset(Bi)), aa.top = Bi.scrollTop, aa.left = Bi.scrollLeft, Zi = e, ta = Ui;
  if ($c87311424ea30a05$export$78551043582a6a98() && (Bi.tagName === "BODY" || Bi.tagName === "HTML") && La) {
    aa.top = 0, aa.left = 0;
    var ao;
    na = (ao = $edcf132a9284368a$var$visualViewport?.pageTop) !== null && ao !== void 0 ? ao : 0;
    var oo;
    ia = (oo = $edcf132a9284368a$var$visualViewport?.pageLeft) !== null && oo !== void 0 ? oo : 0;
  }
  return {
    width: e,
    height: Ui,
    totalWidth: Zi,
    totalHeight: ta,
    scroll: aa,
    top: na,
    left: ia
  };
}
function $edcf132a9284368a$var$getScroll(Bi) {
  return {
    top: Bi.scrollTop,
    left: Bi.scrollLeft,
    width: Bi.scrollWidth,
    height: Bi.scrollHeight
  };
}
function $edcf132a9284368a$var$getDelta(Bi, e, Ui, Zi, ta, na, ia) {
  var aa;
  let da = (aa = ta.scroll[Bi]) !== null && aa !== void 0 ? aa : 0, La = Zi[$edcf132a9284368a$var$AXIS_SIZE[Bi]], qa = Zi.scroll[$edcf132a9284368a$var$AXIS[Bi]] + na, io = La + Zi.scroll[$edcf132a9284368a$var$AXIS[Bi]] - na, ao = e - da + ia[Bi] - Zi[$edcf132a9284368a$var$AXIS[Bi]], oo = e - da + Ui + ia[Bi] - Zi[$edcf132a9284368a$var$AXIS[Bi]];
  return ao < qa ? qa - ao : oo > io ? Math.max(io - oo, qa - ao) : 0;
}
function $edcf132a9284368a$var$getMargins(Bi) {
  let e = window.getComputedStyle(Bi);
  return {
    top: parseInt(e.marginTop, 10) || 0,
    bottom: parseInt(e.marginBottom, 10) || 0,
    left: parseInt(e.marginLeft, 10) || 0,
    right: parseInt(e.marginRight, 10) || 0
  };
}
function $edcf132a9284368a$var$parsePlacement(Bi) {
  if ($edcf132a9284368a$var$PARSED_PLACEMENT_CACHE[Bi]) return $edcf132a9284368a$var$PARSED_PLACEMENT_CACHE[Bi];
  let [e, Ui] = Bi.split(" "), Zi = $edcf132a9284368a$var$AXIS[e] || "right", ta = $edcf132a9284368a$var$CROSS_AXIS[Zi];
  $edcf132a9284368a$var$AXIS[Ui] || (Ui = "center");
  let na = $edcf132a9284368a$var$AXIS_SIZE[Zi], ia = $edcf132a9284368a$var$AXIS_SIZE[ta];
  return $edcf132a9284368a$var$PARSED_PLACEMENT_CACHE[Bi] = {
    placement: e,
    crossPlacement: Ui,
    axis: Zi,
    crossAxis: ta,
    size: na,
    crossSize: ia
  }, $edcf132a9284368a$var$PARSED_PLACEMENT_CACHE[Bi];
}
function $edcf132a9284368a$var$computePosition(Bi, e, Ui, Zi, ta, na, ia, aa, da, La) {
  let { placement: qa, crossPlacement: io, axis: ao, crossAxis: oo, size: no, crossSize: lo } = Zi, so = {};
  var bs;
  so[oo] = (bs = Bi[oo]) !== null && bs !== void 0 ? bs : 0;
  var Rs, js, qs, jo;
  io === "center" ? so[oo] += (((Rs = Bi[lo]) !== null && Rs !== void 0 ? Rs : 0) - ((js = Ui[lo]) !== null && js !== void 0 ? js : 0)) / 2 : io !== oo && (so[oo] += ((qs = Bi[lo]) !== null && qs !== void 0 ? qs : 0) - ((jo = Ui[lo]) !== null && jo !== void 0 ? jo : 0)), so[oo] += na;
  const fs = Bi[oo] - Ui[lo] + da + La, Ao = Bi[oo] + Bi[lo] - da - La;
  if (so[oo] = $9446cca9a3875146$export$7d15b64cf5a3a4c4(so[oo], fs, Ao), qa === ao) {
    const co = aa ? ia[no] : e[$edcf132a9284368a$var$TOTAL_SIZE[no]];
    so[$edcf132a9284368a$var$FLIPPED_DIRECTION[ao]] = Math.floor(co - Bi[ao] + ta);
  } else so[ao] = Math.floor(Bi[ao] + Bi[no] + ta);
  return so;
}
function $edcf132a9284368a$var$getMaxHeight(Bi, e, Ui, Zi, ta, na, ia, aa) {
  const da = Zi ? Ui.height : e[$edcf132a9284368a$var$TOTAL_SIZE.height];
  var La;
  let qa = Bi.top != null ? Ui.top + Bi.top : Ui.top + (da - ((La = Bi.bottom) !== null && La !== void 0 ? La : 0) - ia);
  var io, ao, oo, no, lo, so;
  let bs = aa !== "top" ? (
    // We want the distance between the top of the overlay to the bottom of the boundary
    Math.max(0, e.height + e.top + ((io = e.scroll.top) !== null && io !== void 0 ? io : 0) - qa - (((ao = ta.top) !== null && ao !== void 0 ? ao : 0) + ((oo = ta.bottom) !== null && oo !== void 0 ? oo : 0) + na))
  ) : Math.max(0, qa + ia - (e.top + ((no = e.scroll.top) !== null && no !== void 0 ? no : 0)) - (((lo = ta.top) !== null && lo !== void 0 ? lo : 0) + ((so = ta.bottom) !== null && so !== void 0 ? so : 0) + na));
  return Math.min(e.height - na * 2, bs);
}
function $edcf132a9284368a$var$getAvailableSpace(Bi, e, Ui, Zi, ta, na) {
  let { placement: ia, axis: aa, size: da } = na;
  var La, qa;
  if (ia === aa) return Math.max(0, Ui[aa] - Bi[aa] - ((La = Bi.scroll[aa]) !== null && La !== void 0 ? La : 0) + e[aa] - ((qa = Zi[aa]) !== null && qa !== void 0 ? qa : 0) - Zi[$edcf132a9284368a$var$FLIPPED_DIRECTION[aa]] - ta);
  var io;
  return Math.max(0, Bi[da] + Bi[aa] + Bi.scroll[aa] - e[aa] - Ui[aa] - Ui[da] - ((io = Zi[aa]) !== null && io !== void 0 ? io : 0) - Zi[$edcf132a9284368a$var$FLIPPED_DIRECTION[aa]] - ta);
}
function $edcf132a9284368a$export$6839422d1f33cee9(Bi, e, Ui, Zi, ta, na, ia, aa, da, La, qa, io, ao, oo, no, lo) {
  let so = $edcf132a9284368a$var$parsePlacement(Bi), { size: bs, crossAxis: Rs, crossSize: js, placement: qs, crossPlacement: jo } = so, fs = $edcf132a9284368a$var$computePosition(e, aa, Ui, so, qa, io, La, ao, no, lo), Ao = qa, co = $edcf132a9284368a$var$getAvailableSpace(aa, La, e, ta, na + qa, so);
  if (ia && Zi[bs] > co) {
    let El = $edcf132a9284368a$var$parsePlacement(`${$edcf132a9284368a$var$FLIPPED_DIRECTION[qs]} ${jo}`), Il = $edcf132a9284368a$var$computePosition(e, aa, Ui, El, qa, io, La, ao, no, lo);
    $edcf132a9284368a$var$getAvailableSpace(aa, La, e, ta, na + qa, El) > co && (so = El, fs = Il, Ao = qa);
  }
  let Co = "bottom";
  so.axis === "top" ? so.placement === "top" ? Co = "top" : so.placement === "bottom" && (Co = "bottom") : so.crossAxis === "top" && (so.crossPlacement === "top" ? Co = "bottom" : so.crossPlacement === "bottom" && (Co = "top"));
  let Zs = $edcf132a9284368a$var$getDelta(Rs, fs[Rs], Ui[js], aa, da, na, La);
  fs[Rs] += Zs;
  let xl = $edcf132a9284368a$var$getMaxHeight(fs, aa, La, ao, ta, na, Ui.height, Co);
  oo && oo < xl && (xl = oo), Ui.height = Math.min(Ui.height, xl), fs = $edcf132a9284368a$var$computePosition(e, aa, Ui, so, Ao, io, La, ao, no, lo), Zs = $edcf132a9284368a$var$getDelta(Rs, fs[Rs], Ui[js], aa, da, na, La), fs[Rs] += Zs;
  let Cl = {}, Al = e[Rs] + 0.5 * e[js] - fs[Rs] - ta[$edcf132a9284368a$var$AXIS[Rs]];
  const Ol = no / 2 + lo;
  var Bl, Ml, Vl, Ll;
  const Yl = $edcf132a9284368a$var$AXIS[Rs] === "left" ? ((Bl = ta.left) !== null && Bl !== void 0 ? Bl : 0) + ((Ml = ta.right) !== null && Ml !== void 0 ? Ml : 0) : ((Vl = ta.top) !== null && Vl !== void 0 ? Vl : 0) + ((Ll = ta.bottom) !== null && Ll !== void 0 ? Ll : 0), Zl = Ui[js] - Yl - no / 2 - lo, tc = e[Rs] + no / 2 - (fs[Rs] + ta[$edcf132a9284368a$var$AXIS[Rs]]), Nl = e[Rs] + e[js] - no / 2 - (fs[Rs] + ta[$edcf132a9284368a$var$AXIS[Rs]]), Tl = $9446cca9a3875146$export$7d15b64cf5a3a4c4(Al, tc, Nl);
  return Cl[Rs] = $9446cca9a3875146$export$7d15b64cf5a3a4c4(Tl, Ol, Zl), {
    position: fs,
    maxHeight: xl,
    arrowOffsetLeft: Cl.left,
    arrowOffsetTop: Cl.top,
    placement: so.placement
  };
}
function $edcf132a9284368a$export$b3ceb0cbf1056d98(Bi) {
  let { placement: e, targetNode: Ui, overlayNode: Zi, scrollNode: ta, padding: na, shouldFlip: ia, boundaryElement: aa, offset: da, crossOffset: La, maxHeight: qa, arrowSize: io = 0, arrowBoundaryOffset: ao = 0 } = Bi, oo = Zi instanceof HTMLElement ? $edcf132a9284368a$var$getContainingBlock(Zi) : document.documentElement, no = oo === document.documentElement;
  const lo = window.getComputedStyle(oo).position;
  let so = !!lo && lo !== "static", bs = no ? $edcf132a9284368a$var$getOffset(Ui) : $edcf132a9284368a$var$getPosition(Ui, oo);
  if (!no) {
    let { marginTop: Cl, marginLeft: Al } = window.getComputedStyle(Ui);
    bs.top += parseInt(Cl, 10) || 0, bs.left += parseInt(Al, 10) || 0;
  }
  let Rs = $edcf132a9284368a$var$getOffset(Zi), js = $edcf132a9284368a$var$getMargins(Zi);
  var qs, jo;
  Rs.width += ((qs = js.left) !== null && qs !== void 0 ? qs : 0) + ((jo = js.right) !== null && jo !== void 0 ? jo : 0);
  var fs, Ao;
  Rs.height += ((fs = js.top) !== null && fs !== void 0 ? fs : 0) + ((Ao = js.bottom) !== null && Ao !== void 0 ? Ao : 0);
  let co = $edcf132a9284368a$var$getScroll(ta), Co = $edcf132a9284368a$var$getContainerDimensions(aa), Zs = $edcf132a9284368a$var$getContainerDimensions(oo), xl = aa.tagName === "BODY" ? $edcf132a9284368a$var$getOffset(oo) : $edcf132a9284368a$var$getPosition(oo, aa);
  return oo.tagName === "HTML" && aa.tagName === "BODY" && (Zs.scroll.top = 0, Zs.scroll.left = 0), $edcf132a9284368a$export$6839422d1f33cee9(e, bs, Rs, co, js, na, ia, Co, Zs, xl, da, La, so, qa, io, ao);
}
function $edcf132a9284368a$var$getOffset(Bi) {
  let { top: e, left: Ui, width: Zi, height: ta } = Bi.getBoundingClientRect(), { scrollTop: na, scrollLeft: ia, clientTop: aa, clientLeft: da } = document.documentElement;
  return {
    top: e + na - aa,
    left: Ui + ia - da,
    width: Zi,
    height: ta
  };
}
function $edcf132a9284368a$var$getPosition(Bi, e) {
  let Ui = window.getComputedStyle(Bi), Zi;
  if (Ui.position === "fixed") {
    let { top: ta, left: na, width: ia, height: aa } = Bi.getBoundingClientRect();
    Zi = {
      top: ta,
      left: na,
      width: ia,
      height: aa
    };
  } else {
    Zi = $edcf132a9284368a$var$getOffset(Bi);
    let ta = $edcf132a9284368a$var$getOffset(e), na = window.getComputedStyle(e);
    ta.top += (parseInt(na.borderTopWidth, 10) || 0) - e.scrollTop, ta.left += (parseInt(na.borderLeftWidth, 10) || 0) - e.scrollLeft, Zi.top -= ta.top, Zi.left -= ta.left;
  }
  return Zi.top -= parseInt(Ui.marginTop, 10) || 0, Zi.left -= parseInt(Ui.marginLeft, 10) || 0, Zi;
}
function $edcf132a9284368a$var$getContainingBlock(Bi) {
  let e = Bi.offsetParent;
  if (e && e === document.body && window.getComputedStyle(e).position === "static" && !$edcf132a9284368a$var$isContainingBlock(e) && (e = document.documentElement), e == null)
    for (e = Bi.parentElement; e && !$edcf132a9284368a$var$isContainingBlock(e); ) e = e.parentElement;
  return e || document.documentElement;
}
function $edcf132a9284368a$var$isContainingBlock(Bi) {
  let e = window.getComputedStyle(Bi);
  return e.transform !== "none" || /transform|perspective/.test(e.willChange) || e.filter !== "none" || e.contain === "paint" || "backdropFilter" in e && e.backdropFilter !== "none" || "WebkitBackdropFilter" in e && e.WebkitBackdropFilter !== "none";
}
const $dd149f63282afbbf$export$f6211563215e3b37 = /* @__PURE__ */ new WeakMap();
function $dd149f63282afbbf$export$18fc8428861184da(Bi) {
  let { triggerRef: e, isOpen: Ui, onClose: Zi } = Bi;
  useEffect(() => {
    if (!Ui || Zi === null) return;
    let ta = (na) => {
      let ia = na.target;
      if (!e.current || ia instanceof Node && !ia.contains(e.current) || na.target instanceof HTMLInputElement || na.target instanceof HTMLTextAreaElement) return;
      let aa = Zi || $dd149f63282afbbf$export$f6211563215e3b37.get(e.current);
      aa && aa();
    };
    return window.addEventListener("scroll", ta, !0), () => {
      window.removeEventListener("scroll", ta, !0);
    };
  }, [
    Ui,
    Zi,
    e
  ]);
}
let $2a41e45df1593e64$var$visualViewport = typeof document < "u" ? window.visualViewport : null;
function $2a41e45df1593e64$export$d39e1813b3bdd0e1(Bi) {
  let { direction: e } = $18f2051aff69b9bf$export$43bb16f9c6d9e3f7(), { arrowSize: Ui = 0, targetRef: Zi, overlayRef: ta, scrollRef: na = ta, placement: ia = "bottom", containerPadding: aa = 12, shouldFlip: da = !0, boundaryElement: La = typeof document < "u" ? document.body : null, offset: qa = 0, crossOffset: io = 0, shouldUpdatePosition: ao = !0, isOpen: oo = !0, onClose: no, maxHeight: lo, arrowBoundaryOffset: so = 0 } = Bi, [bs, Rs] = useState(null), js = [
    ao,
    ia,
    ta.current,
    Zi.current,
    na.current,
    aa,
    da,
    La,
    qa,
    io,
    oo,
    e,
    lo,
    so,
    Ui
  ], qs = useRef($2a41e45df1593e64$var$visualViewport?.scale);
  useEffect(() => {
    oo && (qs.current = $2a41e45df1593e64$var$visualViewport?.scale);
  }, [
    oo
  ]);
  let jo = useCallback(() => {
    if (ao === !1 || !oo || !ta.current || !Zi.current || !La || $2a41e45df1593e64$var$visualViewport?.scale !== qs.current) return;
    let Zs = null;
    if (na.current && na.current.contains(document.activeElement)) {
      var xl;
      let Ll = (xl = document.activeElement) === null || xl === void 0 ? void 0 : xl.getBoundingClientRect(), Yl = na.current.getBoundingClientRect();
      var Cl;
      if (Zs = {
        type: "top",
        offset: ((Cl = Ll?.top) !== null && Cl !== void 0 ? Cl : 0) - Yl.top
      }, Zs.offset > Yl.height / 2) {
        Zs.type = "bottom";
        var Al;
        Zs.offset = ((Al = Ll?.bottom) !== null && Al !== void 0 ? Al : 0) - Yl.bottom;
      }
    }
    let Ol = ta.current;
    if (!lo && ta.current) {
      var Bl;
      Ol.style.top = "0px", Ol.style.bottom = "";
      var Ml;
      Ol.style.maxHeight = ((Ml = (Bl = window.visualViewport) === null || Bl === void 0 ? void 0 : Bl.height) !== null && Ml !== void 0 ? Ml : window.innerHeight) + "px";
    }
    let Vl = $edcf132a9284368a$export$b3ceb0cbf1056d98({
      placement: $2a41e45df1593e64$var$translateRTL(ia, e),
      overlayNode: ta.current,
      targetNode: Zi.current,
      scrollNode: na.current || ta.current,
      padding: aa,
      shouldFlip: da,
      boundaryElement: La,
      offset: qa,
      crossOffset: io,
      maxHeight: lo,
      arrowSize: Ui,
      arrowBoundaryOffset: so
    });
    if (Vl.position) {
      if (Ol.style.top = "", Ol.style.bottom = "", Ol.style.left = "", Ol.style.right = "", Object.keys(Vl.position).forEach((Ll) => Ol.style[Ll] = Vl.position[Ll] + "px"), Ol.style.maxHeight = Vl.maxHeight != null ? Vl.maxHeight + "px" : "", Zs && document.activeElement && na.current) {
        let Ll = document.activeElement.getBoundingClientRect(), Yl = na.current.getBoundingClientRect(), Zl = Ll[Zs.type] - Yl[Zs.type];
        na.current.scrollTop += Zl - Zs.offset;
      }
      Rs(Vl);
    }
  }, js);
  $f0a04ccd8dbdd83b$export$e5c5a5f917a5871c(jo, js), $2a41e45df1593e64$var$useResize(jo), $9daab02d461809db$export$683480f191c0e3ea({
    ref: ta,
    onResize: jo
  }), $9daab02d461809db$export$683480f191c0e3ea({
    ref: Zi,
    onResize: jo
  });
  let fs = useRef(!1);
  $f0a04ccd8dbdd83b$export$e5c5a5f917a5871c(() => {
    let Zs, xl = () => {
      fs.current = !0, clearTimeout(Zs), Zs = setTimeout(() => {
        fs.current = !1;
      }, 500), jo();
    }, Cl = () => {
      fs.current && xl();
    };
    return $2a41e45df1593e64$var$visualViewport?.addEventListener("resize", xl), $2a41e45df1593e64$var$visualViewport?.addEventListener("scroll", Cl), () => {
      $2a41e45df1593e64$var$visualViewport?.removeEventListener("resize", xl), $2a41e45df1593e64$var$visualViewport?.removeEventListener("scroll", Cl);
    };
  }, [
    jo
  ]);
  let Ao = useCallback(() => {
    fs.current || no?.();
  }, [
    no,
    fs
  ]);
  $dd149f63282afbbf$export$18fc8428861184da({
    triggerRef: Zi,
    isOpen: oo,
    onClose: no && Ao
  });
  var co, Co;
  return {
    overlayProps: {
      style: {
        position: "absolute",
        zIndex: 1e5,
        ...bs?.position,
        maxHeight: (co = bs?.maxHeight) !== null && co !== void 0 ? co : "100vh"
      }
    },
    placement: (Co = bs?.placement) !== null && Co !== void 0 ? Co : null,
    arrowProps: {
      "aria-hidden": "true",
      role: "presentation",
      style: {
        left: bs?.arrowOffsetLeft,
        top: bs?.arrowOffsetTop
      }
    },
    updatePosition: jo
  };
}
function $2a41e45df1593e64$var$useResize(Bi) {
  $f0a04ccd8dbdd83b$export$e5c5a5f917a5871c(() => (window.addEventListener("resize", Bi, !1), () => {
    window.removeEventListener("resize", Bi, !1);
  }), [
    Bi
  ]);
}
function $2a41e45df1593e64$var$translateRTL(Bi, e) {
  return e === "rtl" ? Bi.replace("start", "right").replace("end", "left") : Bi.replace("start", "left").replace("end", "right");
}
const $a11501f3d1d39e6c$var$visibleOverlays = [];
function $a11501f3d1d39e6c$export$ea8f71083e90600f(Bi, e) {
  let { onClose: Ui, shouldCloseOnBlur: Zi, isOpen: ta, isDismissable: na = !1, isKeyboardDismissDisabled: ia = !1, shouldCloseOnInteractOutside: aa } = Bi;
  useEffect(() => (ta && $a11501f3d1d39e6c$var$visibleOverlays.push(e), () => {
    let no = $a11501f3d1d39e6c$var$visibleOverlays.indexOf(e);
    no >= 0 && $a11501f3d1d39e6c$var$visibleOverlays.splice(no, 1);
  }), [
    ta,
    e
  ]);
  let da = () => {
    $a11501f3d1d39e6c$var$visibleOverlays[$a11501f3d1d39e6c$var$visibleOverlays.length - 1] === e && Ui && Ui();
  }, La = (no) => {
    (!aa || aa(no.target)) && $a11501f3d1d39e6c$var$visibleOverlays[$a11501f3d1d39e6c$var$visibleOverlays.length - 1] === e && (no.stopPropagation(), no.preventDefault());
  }, qa = (no) => {
    (!aa || aa(no.target)) && ($a11501f3d1d39e6c$var$visibleOverlays[$a11501f3d1d39e6c$var$visibleOverlays.length - 1] === e && (no.stopPropagation(), no.preventDefault()), da());
  }, io = (no) => {
    no.key === "Escape" && !ia && !no.nativeEvent.isComposing && (no.stopPropagation(), no.preventDefault(), da());
  };
  $e0b6e0b68ec7f50f$export$872b660ac5a1ff98({
    ref: e,
    onInteractOutside: na && ta ? qa : void 0,
    onInteractOutsideStart: La
  });
  let { focusWithinProps: ao } = $9ab94262bd0047c7$export$420e68273165f4ec({
    isDisabled: !Zi,
    onBlurWithin: (no) => {
      !no.relatedTarget || $9bf71ea28793e738$export$1258395f99bf9cbf(no.relatedTarget) || (!aa || aa(no.relatedTarget)) && Ui?.();
    }
  }), oo = (no) => {
    no.target === no.currentTarget && no.preventDefault();
  };
  return {
    overlayProps: {
      onKeyDown: io,
      ...ao
    },
    underlayProps: {
      onPointerDown: oo
    }
  };
}
function $628037886ba31236$export$f9d5c8beee7d008d(Bi, e, Ui) {
  let { type: Zi } = Bi, { isOpen: ta } = e;
  useEffect(() => {
    Ui && Ui.current && $dd149f63282afbbf$export$f6211563215e3b37.set(Ui.current, e.close);
  });
  let na;
  Zi === "menu" ? na = !0 : Zi === "listbox" && (na = "listbox");
  let ia = $bdb11010cef70236$export$f680877a34711e37();
  return {
    triggerProps: {
      "aria-haspopup": na,
      "aria-expanded": ta,
      "aria-controls": ta ? ia : void 0,
      onPress: e.toggle
    },
    overlayProps: {
      id: ia
    }
  };
}
const $49c51c25361d4cd2$var$visualViewport = typeof document < "u" && window.visualViewport, $49c51c25361d4cd2$var$nonTextInputTypes = /* @__PURE__ */ new Set([
  "checkbox",
  "radio",
  "range",
  "color",
  "file",
  "image",
  "button",
  "submit",
  "reset"
]);
let $49c51c25361d4cd2$var$preventScrollCount = 0, $49c51c25361d4cd2$var$restore;
function $49c51c25361d4cd2$export$ee0f7cc6afcd1c18(Bi = {}) {
  let { isDisabled: e } = Bi;
  $f0a04ccd8dbdd83b$export$e5c5a5f917a5871c(() => {
    if (!e)
      return $49c51c25361d4cd2$var$preventScrollCount++, $49c51c25361d4cd2$var$preventScrollCount === 1 && ($c87311424ea30a05$export$fedb369cb70207f1() ? $49c51c25361d4cd2$var$restore = $49c51c25361d4cd2$var$preventScrollMobileSafari() : $49c51c25361d4cd2$var$restore = $49c51c25361d4cd2$var$preventScrollStandard()), () => {
        $49c51c25361d4cd2$var$preventScrollCount--, $49c51c25361d4cd2$var$preventScrollCount === 0 && $49c51c25361d4cd2$var$restore();
      };
  }, [
    e
  ]);
}
function $49c51c25361d4cd2$var$preventScrollStandard() {
  return $ff5963eb1fccf552$export$e08e3b67e392101e($49c51c25361d4cd2$var$setStyle(document.documentElement, "paddingRight", `${window.innerWidth - document.documentElement.clientWidth}px`), $49c51c25361d4cd2$var$setStyle(document.documentElement, "overflow", "hidden"));
}
function $49c51c25361d4cd2$var$preventScrollMobileSafari() {
  let Bi, e, Ui = (La) => {
    Bi = $62d8ded9296f3872$export$cfa2225e87938781(La.target, !0), !(Bi === document.documentElement && Bi === document.body) && Bi instanceof HTMLElement && window.getComputedStyle(Bi).overscrollBehavior === "auto" && (e = $49c51c25361d4cd2$var$setStyle(Bi, "overscrollBehavior", "contain"));
  }, Zi = (La) => {
    if (!Bi || Bi === document.documentElement || Bi === document.body) {
      La.preventDefault();
      return;
    }
    Bi.scrollHeight === Bi.clientHeight && Bi.scrollWidth === Bi.clientWidth && La.preventDefault();
  }, ta = () => {
    e && e();
  }, na = (La) => {
    let qa = La.target;
    $49c51c25361d4cd2$var$willOpenKeyboard(qa) && (aa(), qa.style.transform = "translateY(-2000px)", requestAnimationFrame(() => {
      qa.style.transform = "", $49c51c25361d4cd2$var$visualViewport && ($49c51c25361d4cd2$var$visualViewport.height < window.innerHeight ? requestAnimationFrame(() => {
        $49c51c25361d4cd2$var$scrollIntoView(qa);
      }) : $49c51c25361d4cd2$var$visualViewport.addEventListener("resize", () => $49c51c25361d4cd2$var$scrollIntoView(qa), {
        once: !0
      }));
    }));
  }, ia = null, aa = () => {
    if (ia) return;
    let La = () => {
      window.scrollTo(0, 0);
    }, qa = window.pageXOffset, io = window.pageYOffset;
    ia = $ff5963eb1fccf552$export$e08e3b67e392101e($49c51c25361d4cd2$var$addEvent(window, "scroll", La), $49c51c25361d4cd2$var$setStyle(document.documentElement, "paddingRight", `${window.innerWidth - document.documentElement.clientWidth}px`), $49c51c25361d4cd2$var$setStyle(document.documentElement, "overflow", "hidden"), $49c51c25361d4cd2$var$setStyle(document.body, "marginTop", `-${io}px`), () => {
      window.scrollTo(qa, io);
    }), window.scrollTo(0, 0);
  }, da = $ff5963eb1fccf552$export$e08e3b67e392101e($49c51c25361d4cd2$var$addEvent(document, "touchstart", Ui, {
    passive: !1,
    capture: !0
  }), $49c51c25361d4cd2$var$addEvent(document, "touchmove", Zi, {
    passive: !1,
    capture: !0
  }), $49c51c25361d4cd2$var$addEvent(document, "touchend", ta, {
    passive: !1,
    capture: !0
  }), $49c51c25361d4cd2$var$addEvent(document, "focus", na, !0));
  return () => {
    e?.(), ia?.(), da();
  };
}
function $49c51c25361d4cd2$var$setStyle(Bi, e, Ui) {
  let Zi = Bi.style[e];
  return Bi.style[e] = Ui, () => {
    Bi.style[e] = Zi;
  };
}
function $49c51c25361d4cd2$var$addEvent(Bi, e, Ui, Zi) {
  return Bi.addEventListener(e, Ui, Zi), () => {
    Bi.removeEventListener(e, Ui, Zi);
  };
}
function $49c51c25361d4cd2$var$scrollIntoView(Bi) {
  let e = document.scrollingElement || document.documentElement, Ui = Bi;
  for (; Ui && Ui !== e; ) {
    let Zi = $62d8ded9296f3872$export$cfa2225e87938781(Ui);
    if (Zi !== document.documentElement && Zi !== document.body && Zi !== Ui) {
      let ta = Zi.getBoundingClientRect().top, na = Ui.getBoundingClientRect().top;
      na > ta + Ui.clientHeight && (Zi.scrollTop += na - ta);
    }
    Ui = Zi.parentElement;
  }
}
function $49c51c25361d4cd2$var$willOpenKeyboard(Bi) {
  return Bi instanceof HTMLInputElement && !$49c51c25361d4cd2$var$nonTextInputTypes.has(Bi.type) || Bi instanceof HTMLTextAreaElement || Bi instanceof HTMLElement && Bi.isContentEditable;
}
var $773d5888b972f1cf$exports = {};
$773d5888b972f1cf$exports = {
  dismiss: "تجاهل"
};
var $d11f19852b941573$exports = {};
$d11f19852b941573$exports = {
  dismiss: "Отхвърляне"
};
var $b983974c2ee1efb3$exports = {};
$b983974c2ee1efb3$exports = {
  dismiss: "Odstranit"
};
var $5809cc9d4e92de73$exports = {};
$5809cc9d4e92de73$exports = {
  dismiss: "Luk"
};
var $c68c2e4fc74398d1$exports = {};
$c68c2e4fc74398d1$exports = {
  dismiss: "Schließen"
};
var $0898b4c153db2b77$exports = {};
$0898b4c153db2b77$exports = {
  dismiss: "Απόρριψη"
};
var $6d74810286a15183$exports = {};
$6d74810286a15183$exports = {
  dismiss: "Dismiss"
};
var $309d73dc65f78055$exports = {};
$309d73dc65f78055$exports = {
  dismiss: "Descartar"
};
var $44ad94f7205cf593$exports = {};
$44ad94f7205cf593$exports = {
  dismiss: "Lõpeta"
};
var $7c28f5687f0779a9$exports = {};
$7c28f5687f0779a9$exports = {
  dismiss: "Hylkää"
};
var $e6d75df4b68bd73a$exports = {};
$e6d75df4b68bd73a$exports = {
  dismiss: "Rejeter"
};
var $87505c9dab186d0f$exports = {};
$87505c9dab186d0f$exports = {
  dismiss: "התעלם"
};
var $553439c3ffb3e492$exports = {};
$553439c3ffb3e492$exports = {
  dismiss: "Odbaci"
};
var $74cf411061b983a2$exports = {};
$74cf411061b983a2$exports = {
  dismiss: "Elutasítás"
};
var $e933f298574dc435$exports = {};
$e933f298574dc435$exports = {
  dismiss: "Ignora"
};
var $ac91fc9fe02f71f6$exports = {};
$ac91fc9fe02f71f6$exports = {
  dismiss: "閉じる"
};
var $52b96f86422025af$exports = {};
$52b96f86422025af$exports = {
  dismiss: "무시"
};
var $c0d724c3e51dafa6$exports = {};
$c0d724c3e51dafa6$exports = {
  dismiss: "Atmesti"
};
var $c92899672a3fe72e$exports = {};
$c92899672a3fe72e$exports = {
  dismiss: "Nerādīt"
};
var $9f576b39d8e7a9d6$exports = {};
$9f576b39d8e7a9d6$exports = {
  dismiss: "Lukk"
};
var $9d025808aeec81a7$exports = {};
$9d025808aeec81a7$exports = {
  dismiss: "Negeren"
};
var $fce709921e2c0fa6$exports = {};
$fce709921e2c0fa6$exports = {
  dismiss: "Zignoruj"
};
var $2599cf0c4ab37f59$exports = {};
$2599cf0c4ab37f59$exports = {
  dismiss: "Descartar"
};
var $3c220ae7ef8a35fd$exports = {};
$3c220ae7ef8a35fd$exports = {
  dismiss: "Dispensar"
};
var $93562b5094072f54$exports = {};
$93562b5094072f54$exports = {
  dismiss: "Revocare"
};
var $cd9e2abd0d06c7b4$exports = {};
$cd9e2abd0d06c7b4$exports = {
  dismiss: "Пропустить"
};
var $45375701f409adf1$exports = {};
$45375701f409adf1$exports = {
  dismiss: "Zrušiť"
};
var $27fab53a576de9dd$exports = {};
$27fab53a576de9dd$exports = {
  dismiss: "Opusti"
};
var $4438748d9952e7c7$exports = {};
$4438748d9952e7c7$exports = {
  dismiss: "Odbaci"
};
var $0936d7347ef4da4c$exports = {};
$0936d7347ef4da4c$exports = {
  dismiss: "Avvisa"
};
var $29700c92185d38f8$exports = {};
$29700c92185d38f8$exports = {
  dismiss: "Kapat"
};
var $662ccaf2be4c25b3$exports = {};
$662ccaf2be4c25b3$exports = {
  dismiss: "Скасувати"
};
var $d80a27deda7cdb3c$exports = {};
$d80a27deda7cdb3c$exports = {
  dismiss: "取消"
};
var $2b2734393847c884$exports = {};
$2b2734393847c884$exports = {
  dismiss: "關閉"
};
var $a2f21f5f14f60553$exports = {};
$a2f21f5f14f60553$exports = {
  "ar-AE": $773d5888b972f1cf$exports,
  "bg-BG": $d11f19852b941573$exports,
  "cs-CZ": $b983974c2ee1efb3$exports,
  "da-DK": $5809cc9d4e92de73$exports,
  "de-DE": $c68c2e4fc74398d1$exports,
  "el-GR": $0898b4c153db2b77$exports,
  "en-US": $6d74810286a15183$exports,
  "es-ES": $309d73dc65f78055$exports,
  "et-EE": $44ad94f7205cf593$exports,
  "fi-FI": $7c28f5687f0779a9$exports,
  "fr-FR": $e6d75df4b68bd73a$exports,
  "he-IL": $87505c9dab186d0f$exports,
  "hr-HR": $553439c3ffb3e492$exports,
  "hu-HU": $74cf411061b983a2$exports,
  "it-IT": $e933f298574dc435$exports,
  "ja-JP": $ac91fc9fe02f71f6$exports,
  "ko-KR": $52b96f86422025af$exports,
  "lt-LT": $c0d724c3e51dafa6$exports,
  "lv-LV": $c92899672a3fe72e$exports,
  "nb-NO": $9f576b39d8e7a9d6$exports,
  "nl-NL": $9d025808aeec81a7$exports,
  "pl-PL": $fce709921e2c0fa6$exports,
  "pt-BR": $2599cf0c4ab37f59$exports,
  "pt-PT": $3c220ae7ef8a35fd$exports,
  "ro-RO": $93562b5094072f54$exports,
  "ru-RU": $cd9e2abd0d06c7b4$exports,
  "sk-SK": $45375701f409adf1$exports,
  "sl-SI": $27fab53a576de9dd$exports,
  "sr-SP": $4438748d9952e7c7$exports,
  "sv-SE": $0936d7347ef4da4c$exports,
  "tr-TR": $29700c92185d38f8$exports,
  "uk-UA": $662ccaf2be4c25b3$exports,
  "zh-CN": $d80a27deda7cdb3c$exports,
  "zh-TW": $2b2734393847c884$exports
};
function $parcel$interopDefault$1(Bi) {
  return Bi && Bi.__esModule ? Bi.default : Bi;
}
function $86ea4cb521eb2e37$export$2317d149ed6f78c4(Bi) {
  let { onDismiss: e, ...Ui } = Bi, Zi = $fca6afa0e843324b$export$f12b703ca79dfbb1($parcel$interopDefault$1($a2f21f5f14f60553$exports), "@react-aria/overlays"), ta = $313b98861ee5dd6c$export$d6875122194c7b44(Ui, Zi.format("dismiss")), na = () => {
    e && e();
  };
  return /* @__PURE__ */ a__default.createElement($5c3e21d68f1c4674$export$439d29a4e110a164, null, /* @__PURE__ */ a__default.createElement("button", {
    ...ta,
    tabIndex: -1,
    onClick: na,
    style: {
      width: 1,
      height: 1
    }
  }));
}
let $5e3802645cc19319$var$refCountMap = /* @__PURE__ */ new WeakMap(), $5e3802645cc19319$var$observerStack = [];
function $5e3802645cc19319$export$1c3ebcada18427bf(Bi, e = document.body) {
  let Ui = new Set(Bi), Zi = /* @__PURE__ */ new Set(), ta = (da) => {
    for (let ao of da.querySelectorAll("[data-live-announcer], [data-react-aria-top-layer]")) Ui.add(ao);
    let La = (ao) => {
      if (Ui.has(ao) || ao.parentElement && Zi.has(ao.parentElement) && ao.parentElement.getAttribute("role") !== "row") return NodeFilter.FILTER_REJECT;
      for (let oo of Ui)
        if (ao.contains(oo)) return NodeFilter.FILTER_SKIP;
      return NodeFilter.FILTER_ACCEPT;
    }, qa = document.createTreeWalker(da, NodeFilter.SHOW_ELEMENT, {
      acceptNode: La
    }), io = La(da);
    if (io === NodeFilter.FILTER_ACCEPT && na(da), io !== NodeFilter.FILTER_REJECT) {
      let ao = qa.nextNode();
      for (; ao != null; )
        na(ao), ao = qa.nextNode();
    }
  }, na = (da) => {
    var La;
    let qa = (La = $5e3802645cc19319$var$refCountMap.get(da)) !== null && La !== void 0 ? La : 0;
    da.getAttribute("aria-hidden") === "true" && qa === 0 || (qa === 0 && da.setAttribute("aria-hidden", "true"), Zi.add(da), $5e3802645cc19319$var$refCountMap.set(da, qa + 1));
  };
  $5e3802645cc19319$var$observerStack.length && $5e3802645cc19319$var$observerStack[$5e3802645cc19319$var$observerStack.length - 1].disconnect(), ta(e);
  let ia = new MutationObserver((da) => {
    for (let La of da)
      if (!(La.type !== "childList" || La.addedNodes.length === 0) && ![
        ...Ui,
        ...Zi
      ].some((qa) => qa.contains(La.target))) {
        for (let qa of La.removedNodes) qa instanceof Element && (Ui.delete(qa), Zi.delete(qa));
        for (let qa of La.addedNodes)
          (qa instanceof HTMLElement || qa instanceof SVGElement) && (qa.dataset.liveAnnouncer === "true" || qa.dataset.reactAriaTopLayer === "true") ? Ui.add(qa) : qa instanceof Element && ta(qa);
      }
  });
  ia.observe(e, {
    childList: !0,
    subtree: !0
  });
  let aa = {
    observe() {
      ia.observe(e, {
        childList: !0,
        subtree: !0
      });
    },
    disconnect() {
      ia.disconnect();
    }
  };
  return $5e3802645cc19319$var$observerStack.push(aa), () => {
    ia.disconnect();
    for (let da of Zi) {
      let La = $5e3802645cc19319$var$refCountMap.get(da);
      La != null && (La === 1 ? (da.removeAttribute("aria-hidden"), $5e3802645cc19319$var$refCountMap.delete(da)) : $5e3802645cc19319$var$refCountMap.set(da, La - 1));
    }
    aa === $5e3802645cc19319$var$observerStack[$5e3802645cc19319$var$observerStack.length - 1] ? ($5e3802645cc19319$var$observerStack.pop(), $5e3802645cc19319$var$observerStack.length && $5e3802645cc19319$var$observerStack[$5e3802645cc19319$var$observerStack.length - 1].observe()) : $5e3802645cc19319$var$observerStack.splice($5e3802645cc19319$var$observerStack.indexOf(aa), 1);
  };
}
function $f2f8a6077418541e$export$542a6fd13ac93354(Bi, e) {
  let { triggerRef: Ui, popoverRef: Zi, isNonModal: ta, isKeyboardDismissDisabled: na, shouldCloseOnInteractOutside: ia, ...aa } = Bi, { overlayProps: da, underlayProps: La } = $a11501f3d1d39e6c$export$ea8f71083e90600f({
    // If popover is in the top layer, it should not prevent other popovers from being dismissed.
    isOpen: e.isOpen && !aa["data-react-aria-top-layer"],
    onClose: e.close,
    shouldCloseOnBlur: !0,
    isDismissable: !ta,
    isKeyboardDismissDisabled: na,
    shouldCloseOnInteractOutside: ia
  }, Zi), { overlayProps: qa, arrowProps: io, placement: ao } = $2a41e45df1593e64$export$d39e1813b3bdd0e1({
    ...aa,
    targetRef: Ui,
    overlayRef: Zi,
    isOpen: e.isOpen,
    onClose: ta ? e.close : null
  });
  return $49c51c25361d4cd2$export$ee0f7cc6afcd1c18({
    isDisabled: ta || !e.isOpen
  }), $f0a04ccd8dbdd83b$export$e5c5a5f917a5871c(() => {
    if (e.isOpen && !ta && Zi.current) return $5e3802645cc19319$export$1c3ebcada18427bf([
      Zi.current
    ]);
  }, [
    ta,
    e.isOpen,
    Zi
  ]), {
    popoverProps: $3ef42575df84b30b$export$9d1611c77c2fe928(da, qa),
    arrowProps: io,
    underlayProps: La,
    placement: ao
  };
}
const $96b38030c423d352$export$60d741e20e0aa309 = /* @__PURE__ */ createContext({});
function $96b38030c423d352$export$574e9b0fb070c3b0() {
  var Bi;
  return (Bi = useContext($96b38030c423d352$export$60d741e20e0aa309)) !== null && Bi !== void 0 ? Bi : {};
}
const $337b884510726a0d$export$a2200b96afd16271 = /* @__PURE__ */ a__default.createContext(null);
function $337b884510726a0d$export$c6fdb837b070b4ff(Bi) {
  let e = $b5e257d569688ac6$export$535bd6ca7f90a273(), { portalContainer: Ui = e ? null : document.body, isExiting: Zi } = Bi, [ta, na] = useState(!1), ia = useMemo(() => ({
    contain: ta,
    setContain: na
  }), [
    ta,
    na
  ]), { getContainer: aa } = $96b38030c423d352$export$574e9b0fb070c3b0();
  if (!Bi.portalContainer && aa && (Ui = aa()), !Ui) return null;
  let da = Bi.children;
  return Bi.disableFocusManagement || (da = /* @__PURE__ */ a__default.createElement($9bf71ea28793e738$export$20e40289641fbbb6, {
    restoreFocus: !0,
    contain: ta && !Zi
  }, da)), da = /* @__PURE__ */ a__default.createElement($337b884510726a0d$export$a2200b96afd16271.Provider, {
    value: ia
  }, /* @__PURE__ */ a__default.createElement($f1ab8c75478c6f73$export$cf75428e0b9ed1ea, null, da)), /* @__PURE__ */ $4AOtR$reactdom.createPortal(da, Ui);
}
const $b1f0cad8af73213b$export$3585ede4d035bf14 = /* @__PURE__ */ new WeakMap();
function $b1f0cad8af73213b$var$normalizeKey(Bi) {
  return typeof Bi == "string" ? Bi.replace(/\s*/g, "") : "" + Bi;
}
function $b1f0cad8af73213b$export$9145995848b05025(Bi, e) {
  let Ui = $b1f0cad8af73213b$export$3585ede4d035bf14.get(Bi);
  if (!Ui) throw new Error("Unknown list");
  return `${Ui.id}-option-${$b1f0cad8af73213b$var$normalizeKey(e)}`;
}
function $feb5ffebff200149$export$d3e3bd3e26688c04(Bi) {
  return $c87311424ea30a05$export$e1865c3bedcd822b() ? Bi.altKey : Bi.ctrlKey;
}
const $fb3050f43d946246$var$TYPEAHEAD_DEBOUNCE_WAIT_MS = 1e3;
function $fb3050f43d946246$export$e32c88dfddc6e1d8(Bi) {
  let { keyboardDelegate: e, selectionManager: Ui, onTypeSelect: Zi } = Bi, ta = useRef({
    search: "",
    timeout: void 0
  }).current, na = (ia) => {
    let aa = $fb3050f43d946246$var$getStringForKey(ia.key);
    if (!(!aa || ia.ctrlKey || ia.metaKey || !ia.currentTarget.contains(ia.target))) {
      if (aa === " " && ta.search.trim().length > 0 && (ia.preventDefault(), "continuePropagation" in ia || ia.stopPropagation()), ta.search += aa, e.getKeyForSearch != null) {
        let da = e.getKeyForSearch(ta.search, Ui.focusedKey);
        da == null && (da = e.getKeyForSearch(ta.search)), da != null && (Ui.setFocusedKey(da), Zi && Zi(da));
      }
      clearTimeout(ta.timeout), ta.timeout = setTimeout(() => {
        ta.search = "";
      }, $fb3050f43d946246$var$TYPEAHEAD_DEBOUNCE_WAIT_MS);
    }
  };
  return {
    typeSelectProps: {
      // Using a capturing listener to catch the keydown event before
      // other hooks in order to handle the Spacebar event.
      onKeyDownCapture: e.getKeyForSearch ? na : void 0
    }
  };
}
function $fb3050f43d946246$var$getStringForKey(Bi) {
  return Bi.length === 1 || !/^[A-Z]/i.test(Bi) ? Bi : "";
}
function $ae20dd8cbca75726$export$d6daf82dcd84e87c(Bi) {
  let { selectionManager: e, keyboardDelegate: Ui, ref: Zi, autoFocus: ta = !1, shouldFocusWrap: na = !1, disallowEmptySelection: ia = !1, disallowSelectAll: aa = !1, selectOnFocus: da = e.selectionBehavior === "replace", disallowTypeAhead: La = !1, shouldUseVirtualFocus: qa, allowsTabNavigation: io = !1, isVirtualized: ao, scrollRef: oo = Zi, linkBehavior: no = "action" } = Bi, { direction: lo } = $18f2051aff69b9bf$export$43bb16f9c6d9e3f7(), so = $ea8dcbcb9ea1b556$export$9a302a45f65d0572(), bs = (Al) => {
    var Ol;
    if (Al.altKey && Al.key === "Tab" && Al.preventDefault(), !(!((Ol = Zi.current) === null || Ol === void 0) && Ol.contains(Al.target))) return;
    const Bl = (Rl, uo) => {
      if (Rl != null) {
        if (e.isLink(Rl) && no === "selection" && da && !$feb5ffebff200149$export$d3e3bd3e26688c04(Al)) {
          var Is;
          flushSync$1(() => {
            e.setFocusedKey(Rl, uo);
          });
          let Sl = (Is = oo.current) === null || Is === void 0 ? void 0 : Is.querySelector(`[data-key="${CSS.escape(Rl.toString())}"]`), wl = e.getItemProps(Rl);
          Sl && so.open(Sl, Al, wl.href, wl.routerOptions);
          return;
        }
        if (e.setFocusedKey(Rl, uo), e.isLink(Rl) && no === "override") return;
        Al.shiftKey && e.selectionMode === "multiple" ? e.extendSelection(Rl) : da && !$feb5ffebff200149$export$d3e3bd3e26688c04(Al) && e.replaceSelection(Rl);
      }
    };
    switch (Al.key) {
      case "ArrowDown":
        if (Ui.getKeyBelow) {
          var Ml, Vl, Ll;
          let Rl = e.focusedKey != null ? (Ml = Ui.getKeyBelow) === null || Ml === void 0 ? void 0 : Ml.call(Ui, e.focusedKey) : (Vl = Ui.getFirstKey) === null || Vl === void 0 ? void 0 : Vl.call(Ui);
          Rl == null && na && (Rl = (Ll = Ui.getFirstKey) === null || Ll === void 0 ? void 0 : Ll.call(Ui, e.focusedKey)), Rl != null && (Al.preventDefault(), Bl(Rl));
        }
        break;
      case "ArrowUp":
        if (Ui.getKeyAbove) {
          var Yl, Zl, tc;
          let Rl = e.focusedKey != null ? (Yl = Ui.getKeyAbove) === null || Yl === void 0 ? void 0 : Yl.call(Ui, e.focusedKey) : (Zl = Ui.getLastKey) === null || Zl === void 0 ? void 0 : Zl.call(Ui);
          Rl == null && na && (Rl = (tc = Ui.getLastKey) === null || tc === void 0 ? void 0 : tc.call(Ui, e.focusedKey)), Rl != null && (Al.preventDefault(), Bl(Rl));
        }
        break;
      case "ArrowLeft":
        if (Ui.getKeyLeftOf) {
          var Nl, Tl, El;
          let Rl = e.focusedKey != null ? (Nl = Ui.getKeyLeftOf) === null || Nl === void 0 ? void 0 : Nl.call(Ui, e.focusedKey) : null;
          Rl == null && na && (Rl = lo === "rtl" ? (Tl = Ui.getFirstKey) === null || Tl === void 0 ? void 0 : Tl.call(Ui, e.focusedKey) : (El = Ui.getLastKey) === null || El === void 0 ? void 0 : El.call(Ui, e.focusedKey)), Rl != null && (Al.preventDefault(), Bl(Rl, lo === "rtl" ? "first" : "last"));
        }
        break;
      case "ArrowRight":
        if (Ui.getKeyRightOf) {
          var Il, Ul, Kl;
          let Rl = e.focusedKey != null ? (Il = Ui.getKeyRightOf) === null || Il === void 0 ? void 0 : Il.call(Ui, e.focusedKey) : null;
          Rl == null && na && (Rl = lo === "rtl" ? (Ul = Ui.getLastKey) === null || Ul === void 0 ? void 0 : Ul.call(Ui, e.focusedKey) : (Kl = Ui.getFirstKey) === null || Kl === void 0 ? void 0 : Kl.call(Ui, e.focusedKey)), Rl != null && (Al.preventDefault(), Bl(Rl, lo === "rtl" ? "last" : "first"));
        }
        break;
      case "Home":
        if (Ui.getFirstKey) {
          if (e.focusedKey === null && Al.shiftKey) return;
          Al.preventDefault();
          let Rl = Ui.getFirstKey(e.focusedKey, $21f1aa98acb08317$export$16792effe837dba3(Al));
          e.setFocusedKey(Rl), Rl != null && ($21f1aa98acb08317$export$16792effe837dba3(Al) && Al.shiftKey && e.selectionMode === "multiple" ? e.extendSelection(Rl) : da && e.replaceSelection(Rl));
        }
        break;
      case "End":
        if (Ui.getLastKey) {
          if (e.focusedKey === null && Al.shiftKey) return;
          Al.preventDefault();
          let Rl = Ui.getLastKey(e.focusedKey, $21f1aa98acb08317$export$16792effe837dba3(Al));
          e.setFocusedKey(Rl), Rl != null && ($21f1aa98acb08317$export$16792effe837dba3(Al) && Al.shiftKey && e.selectionMode === "multiple" ? e.extendSelection(Rl) : da && e.replaceSelection(Rl));
        }
        break;
      case "PageDown":
        if (Ui.getKeyPageBelow && e.focusedKey != null) {
          let Rl = Ui.getKeyPageBelow(e.focusedKey);
          Rl != null && (Al.preventDefault(), Bl(Rl));
        }
        break;
      case "PageUp":
        if (Ui.getKeyPageAbove && e.focusedKey != null) {
          let Rl = Ui.getKeyPageAbove(e.focusedKey);
          Rl != null && (Al.preventDefault(), Bl(Rl));
        }
        break;
      case "a":
        $21f1aa98acb08317$export$16792effe837dba3(Al) && e.selectionMode === "multiple" && aa !== !0 && (Al.preventDefault(), e.selectAll());
        break;
      case "Escape":
        !ia && e.selectedKeys.size !== 0 && (Al.stopPropagation(), Al.preventDefault(), e.clearSelection());
        break;
      case "Tab":
        if (!io) {
          if (Al.shiftKey) Zi.current.focus();
          else {
            let Rl = $9bf71ea28793e738$export$2d6ec8fc375ceafa(Zi.current, {
              tabbable: !0
            }), uo, Is;
            do
              Is = Rl.lastChild(), Is && (uo = Is);
            while (Is);
            uo && !uo.contains(document.activeElement) && $7215afc6de606d6b$export$de79e2c695e052f3(uo);
          }
          break;
        }
    }
  }, Rs = useRef({
    top: 0,
    left: 0
  });
  $e9faafb641e167db$export$90fc3a17d93f704c(oo, "scroll", ao ? void 0 : () => {
    var Al, Ol, Bl, Ml;
    Rs.current = {
      top: (Bl = (Al = oo.current) === null || Al === void 0 ? void 0 : Al.scrollTop) !== null && Bl !== void 0 ? Bl : 0,
      left: (Ml = (Ol = oo.current) === null || Ol === void 0 ? void 0 : Ol.scrollLeft) !== null && Ml !== void 0 ? Ml : 0
    };
  });
  let js = (Al) => {
    if (e.isFocused) {
      Al.currentTarget.contains(Al.target) || e.setFocused(!1);
      return;
    }
    if (Al.currentTarget.contains(Al.target)) {
      if (e.setFocused(!0), e.focusedKey == null) {
        var Ol, Bl;
        let Ll = (Zl) => {
          Zl != null && (e.setFocusedKey(Zl), da && e.replaceSelection(Zl));
        }, Yl = Al.relatedTarget;
        var Ml, Vl;
        Yl && Al.currentTarget.compareDocumentPosition(Yl) & Node.DOCUMENT_POSITION_FOLLOWING ? Ll((Ml = e.lastSelectedKey) !== null && Ml !== void 0 ? Ml : (Ol = Ui.getLastKey) === null || Ol === void 0 ? void 0 : Ol.call(Ui)) : Ll((Vl = e.firstSelectedKey) !== null && Vl !== void 0 ? Vl : (Bl = Ui.getFirstKey) === null || Bl === void 0 ? void 0 : Bl.call(Ui));
      } else !ao && oo.current && (oo.current.scrollTop = Rs.current.top, oo.current.scrollLeft = Rs.current.left);
      if (e.focusedKey != null && oo.current) {
        let Ll = oo.current.querySelector(`[data-key="${CSS.escape(e.focusedKey.toString())}"]`);
        Ll && (Ll.contains(document.activeElement) || $7215afc6de606d6b$export$de79e2c695e052f3(Ll), $507fabe10e71c6fb$export$630ff653c5ada6a9() === "keyboard" && $2f04cbc44ee30ce0$export$c826860796309d1b(Ll, {
          containingElement: Zi.current
        }));
      }
    }
  }, qs = (Al) => {
    Al.currentTarget.contains(Al.relatedTarget) || e.setFocused(!1);
  }, jo = useRef(!1);
  $e9faafb641e167db$export$90fc3a17d93f704c(Zi, $5671b20cf9b562b2$export$831c820ad60f9d12, qa ? (Al) => {
    let { detail: Ol } = Al;
    Al.stopPropagation(), e.setFocused(!0), Ol?.focusStrategy === "first" && (jo.current = !0);
  } : void 0);
  let fs = $8ae05eaa5c114e9c$export$7f54fc3180508a52(() => {
    var Al, Ol;
    let Bl = (Ol = (Al = Ui.getFirstKey) === null || Al === void 0 ? void 0 : Al.call(Ui)) !== null && Ol !== void 0 ? Ol : null;
    if (Bl == null) {
      var Ml;
      (Ml = Zi.current) === null || Ml === void 0 || Ml.dispatchEvent(new CustomEvent($5671b20cf9b562b2$export$9db568f6321ad9dc, {
        cancelable: !0,
        bubbles: !0
      })), e.collection.size > 0 && (jo.current = !1);
    } else
      e.setFocusedKey(Bl), jo.current = !1;
  });
  $ca9b37712f007381$export$72ef708ab07251f1(() => {
    jo.current && fs();
  }, [
    e.collection,
    fs
  ]);
  let Ao = $8ae05eaa5c114e9c$export$7f54fc3180508a52(() => {
    e.collection.size > 0 && (jo.current = !1);
  });
  $ca9b37712f007381$export$72ef708ab07251f1(() => {
    Ao();
  }, [
    e.focusedKey,
    Ao
  ]), $e9faafb641e167db$export$90fc3a17d93f704c(Zi, $5671b20cf9b562b2$export$447a38995de2c711, qa ? (Al) => {
    Al.stopPropagation(), e.setFocused(!1), e.setFocusedKey(null);
  } : void 0);
  const co = useRef(ta);
  useEffect(() => {
    if (co.current) {
      var Al, Ol;
      let Vl = null;
      var Bl;
      ta === "first" && (Vl = (Bl = (Al = Ui.getFirstKey) === null || Al === void 0 ? void 0 : Al.call(Ui)) !== null && Bl !== void 0 ? Bl : null);
      var Ml;
      ta === "last" && (Vl = (Ml = (Ol = Ui.getLastKey) === null || Ol === void 0 ? void 0 : Ol.call(Ui)) !== null && Ml !== void 0 ? Ml : null);
      let Ll = e.selectedKeys;
      if (Ll.size) {
        for (let Yl of Ll) if (e.canSelectItem(Yl)) {
          Vl = Yl;
          break;
        }
      }
      e.setFocused(!0), e.setFocusedKey(Vl), Vl == null && !qa && Zi.current && $6a99195332edec8b$export$80f3e147d781571c(Zi.current);
    }
  }, []);
  let Co = useRef(e.focusedKey);
  useEffect(() => {
    if (e.isFocused && e.focusedKey != null && (e.focusedKey !== Co.current || co.current) && oo.current && Zi.current) {
      let Al = $507fabe10e71c6fb$export$630ff653c5ada6a9(), Ol = Zi.current.querySelector(`[data-key="${CSS.escape(e.focusedKey.toString())}"]`);
      if (!Ol)
        return;
      (Al === "keyboard" || co.current) && ($2f04cbc44ee30ce0$export$53a0910f038337bd(oo.current, Ol), Al !== "virtual" && $2f04cbc44ee30ce0$export$c826860796309d1b(Ol, {
        containingElement: Zi.current
      }));
    }
    !qa && e.isFocused && e.focusedKey == null && Co.current != null && Zi.current && $6a99195332edec8b$export$80f3e147d781571c(Zi.current), Co.current = e.focusedKey, co.current = !1;
  }), $e9faafb641e167db$export$90fc3a17d93f704c(Zi, "react-aria-focus-scope-restore", (Al) => {
    Al.preventDefault(), e.setFocused(!0);
  });
  let Zs = {
    onKeyDown: bs,
    onFocus: js,
    onBlur: qs,
    onMouseDown(Al) {
      oo.current === Al.target && Al.preventDefault();
    }
  }, { typeSelectProps: xl } = $fb3050f43d946246$export$e32c88dfddc6e1d8({
    keyboardDelegate: Ui,
    selectionManager: e
  });
  La || (Zs = $3ef42575df84b30b$export$9d1611c77c2fe928(xl, Zs));
  let Cl;
  return qa ? Cl = -1 : Cl = e.focusedKey == null ? 0 : -1, {
    collectionProps: {
      ...Zs,
      tabIndex: Cl
    }
  };
}
function $880e95eb8b93ba9a$export$ecf600387e221c37(Bi) {
  let { id: e, selectionManager: Ui, key: Zi, ref: ta, shouldSelectOnPressUp: na, shouldUseVirtualFocus: ia, focus: aa, isDisabled: da, onAction: La, allowsDifferentPressOrigin: qa, linkBehavior: io = "action" } = Bi, ao = $ea8dcbcb9ea1b556$export$9a302a45f65d0572();
  e = $bdb11010cef70236$export$f680877a34711e37(e);
  let oo = (Ll) => {
    if (Ll.pointerType === "keyboard" && $feb5ffebff200149$export$d3e3bd3e26688c04(Ll)) Ui.toggleSelection(Zi);
    else {
      if (Ui.selectionMode === "none") return;
      if (Ui.isLink(Zi)) {
        if (io === "selection" && ta.current) {
          let Yl = Ui.getItemProps(Zi);
          ao.open(ta.current, Ll, Yl.href, Yl.routerOptions), Ui.setSelectedKeys(Ui.selectedKeys);
          return;
        } else if (io === "override" || io === "none") return;
      }
      Ui.selectionMode === "single" ? Ui.isSelected(Zi) && !Ui.disallowEmptySelection ? Ui.toggleSelection(Zi) : Ui.replaceSelection(Zi) : Ll && Ll.shiftKey ? Ui.extendSelection(Zi) : Ui.selectionBehavior === "toggle" || Ll && ($21f1aa98acb08317$export$16792effe837dba3(Ll) || Ll.pointerType === "touch" || Ll.pointerType === "virtual") ? Ui.toggleSelection(Zi) : Ui.replaceSelection(Zi);
    }
  };
  useEffect(() => {
    if (Zi === Ui.focusedKey && Ui.isFocused)
      if (!ia)
        aa ? aa() : document.activeElement !== ta.current && ta.current && $6a99195332edec8b$export$80f3e147d781571c(ta.current);
      else {
        var Yl;
        let Zl = new CustomEvent($5671b20cf9b562b2$export$9db568f6321ad9dc, {
          cancelable: !0,
          bubbles: !0
        });
        (Yl = ta.current) === null || Yl === void 0 || Yl.dispatchEvent(Zl);
      }
  }, [
    ta,
    Zi,
    Ui.focusedKey,
    Ui.childFocusStrategy,
    Ui.isFocused,
    ia
  ]), da = da || Ui.isDisabled(Zi);
  let no = {};
  !ia && !da ? no = {
    tabIndex: Zi === Ui.focusedKey ? 0 : -1,
    onFocus(Ll) {
      Ll.target === ta.current && Ui.setFocusedKey(Zi);
    }
  } : da && (no.onMouseDown = (Ll) => {
    Ll.preventDefault();
  });
  let lo = Ui.isLink(Zi) && io === "override", so = Ui.isLink(Zi) && io !== "selection" && io !== "none", bs = !da && Ui.canSelectItem(Zi) && !lo, Rs = (La || so) && !da, js = Rs && (Ui.selectionBehavior === "replace" ? !bs : !bs || Ui.isEmpty), qs = Rs && bs && Ui.selectionBehavior === "replace", jo = js || qs, fs = useRef(null), Ao = jo && bs, co = useRef(!1), Co = useRef(!1), Zs = (Ll) => {
    if (La && La(), so && ta.current) {
      let Yl = Ui.getItemProps(Zi);
      ao.open(ta.current, Ll, Yl.href, Yl.routerOptions);
    }
  }, xl = {};
  na ? (xl.onPressStart = (Ll) => {
    fs.current = Ll.pointerType, co.current = Ao, Ll.pointerType === "keyboard" && (!jo || $880e95eb8b93ba9a$var$isSelectionKey()) && oo(Ll);
  }, qa ? (xl.onPressUp = js ? void 0 : (Ll) => {
    Ll.pointerType === "mouse" && bs && oo(Ll);
  }, xl.onPress = js ? Zs : (Ll) => {
    Ll.pointerType !== "keyboard" && Ll.pointerType !== "mouse" && bs && oo(Ll);
  }) : xl.onPress = (Ll) => {
    if (js || qs && Ll.pointerType !== "mouse") {
      if (Ll.pointerType === "keyboard" && !$880e95eb8b93ba9a$var$isActionKey()) return;
      Zs(Ll);
    } else Ll.pointerType !== "keyboard" && bs && oo(Ll);
  }) : (xl.onPressStart = (Ll) => {
    fs.current = Ll.pointerType, co.current = Ao, Co.current = js, bs && (Ll.pointerType === "mouse" && !js || Ll.pointerType === "keyboard" && (!Rs || $880e95eb8b93ba9a$var$isSelectionKey())) && oo(Ll);
  }, xl.onPress = (Ll) => {
    (Ll.pointerType === "touch" || Ll.pointerType === "pen" || Ll.pointerType === "virtual" || Ll.pointerType === "keyboard" && jo && $880e95eb8b93ba9a$var$isActionKey() || Ll.pointerType === "mouse" && Co.current) && (jo ? Zs(Ll) : bs && oo(Ll));
  }), no["data-key"] = Zi, xl.preventFocusOnPress = ia;
  let { pressProps: Cl, isPressed: Al } = $f6c31cce2adf654f$export$45712eceda6fad21(xl), Ol = qs ? (Ll) => {
    fs.current === "mouse" && (Ll.stopPropagation(), Ll.preventDefault(), Zs(Ll));
  } : void 0, { longPressProps: Bl } = $8a26561d2877236e$export$c24ed0104d07eab9({
    isDisabled: !Ao,
    onLongPress(Ll) {
      Ll.pointerType === "touch" && (oo(Ll), Ui.setSelectionBehavior("toggle"));
    }
  }), Ml = (Ll) => {
    fs.current === "touch" && co.current && Ll.preventDefault();
  }, Vl = Ui.isLink(Zi) ? (Ll) => {
    $ea8dcbcb9ea1b556$export$95185d699e05d4d7.isOpening || Ll.preventDefault();
  } : void 0;
  return {
    itemProps: $3ef42575df84b30b$export$9d1611c77c2fe928(no, bs || js ? Cl : {}, Ao ? Bl : {}, {
      onDoubleClick: Ol,
      onDragStartCapture: Ml,
      onClick: Vl,
      id: e
    }),
    isPressed: Al,
    isSelected: Ui.isSelected(Zi),
    isFocused: Ui.isFocused && Ui.focusedKey === Zi,
    isDisabled: da,
    allowsSelection: bs,
    hasAction: jo
  };
}
function $880e95eb8b93ba9a$var$isActionKey() {
  let Bi = window.event;
  return Bi?.key === "Enter";
}
function $880e95eb8b93ba9a$var$isSelectionKey() {
  let Bi = window.event;
  return Bi?.key === " " || Bi?.code === "Space";
}
class $657e4dc4a6e88df0$export$8f5ed9ff9f511381 {
  getItemRect(e) {
    let Ui = this.ref.current;
    if (!Ui) return null;
    let Zi = e != null ? Ui.querySelector(`[data-key="${CSS.escape(e.toString())}"]`) : null;
    if (!Zi) return null;
    let ta = Ui.getBoundingClientRect(), na = Zi.getBoundingClientRect();
    return {
      x: na.left - ta.left + Ui.scrollLeft,
      y: na.top - ta.top + Ui.scrollTop,
      width: na.width,
      height: na.height
    };
  }
  getContentSize() {
    let e = this.ref.current;
    var Ui, Zi;
    return {
      width: (Ui = e?.scrollWidth) !== null && Ui !== void 0 ? Ui : 0,
      height: (Zi = e?.scrollHeight) !== null && Zi !== void 0 ? Zi : 0
    };
  }
  getVisibleRect() {
    let e = this.ref.current;
    var Ui, Zi, ta, na;
    return {
      x: (Ui = e?.scrollLeft) !== null && Ui !== void 0 ? Ui : 0,
      y: (Zi = e?.scrollTop) !== null && Zi !== void 0 ? Zi : 0,
      width: (ta = e?.offsetWidth) !== null && ta !== void 0 ? ta : 0,
      height: (na = e?.offsetHeight) !== null && na !== void 0 ? na : 0
    };
  }
  constructor(e) {
    this.ref = e;
  }
}
class $2a25aae57d74318e$export$a05409b8bb224a5a {
  isDisabled(e) {
    var Ui;
    return this.disabledBehavior === "all" && (((Ui = e.props) === null || Ui === void 0 ? void 0 : Ui.isDisabled) || this.disabledKeys.has(e.key));
  }
  findNextNonDisabled(e, Ui) {
    let Zi = e;
    for (; Zi != null; ) {
      let ta = this.collection.getItem(Zi);
      if (ta?.type === "item" && !this.isDisabled(ta)) return Zi;
      Zi = Ui(Zi);
    }
    return null;
  }
  getNextKey(e) {
    let Ui = e;
    return Ui = this.collection.getKeyAfter(Ui), this.findNextNonDisabled(Ui, (Zi) => this.collection.getKeyAfter(Zi));
  }
  getPreviousKey(e) {
    let Ui = e;
    return Ui = this.collection.getKeyBefore(Ui), this.findNextNonDisabled(Ui, (Zi) => this.collection.getKeyBefore(Zi));
  }
  findKey(e, Ui, Zi) {
    let ta = e, na = this.layoutDelegate.getItemRect(ta);
    if (!na || ta == null) return null;
    let ia = na;
    do {
      if (ta = Ui(ta), ta == null) break;
      na = this.layoutDelegate.getItemRect(ta);
    } while (na && Zi(ia, na) && ta != null);
    return ta;
  }
  isSameRow(e, Ui) {
    return e.y === Ui.y || e.x !== Ui.x;
  }
  isSameColumn(e, Ui) {
    return e.x === Ui.x || e.y !== Ui.y;
  }
  getKeyBelow(e) {
    return this.layout === "grid" && this.orientation === "vertical" ? this.findKey(e, (Ui) => this.getNextKey(Ui), this.isSameRow) : this.getNextKey(e);
  }
  getKeyAbove(e) {
    return this.layout === "grid" && this.orientation === "vertical" ? this.findKey(e, (Ui) => this.getPreviousKey(Ui), this.isSameRow) : this.getPreviousKey(e);
  }
  getNextColumn(e, Ui) {
    return Ui ? this.getPreviousKey(e) : this.getNextKey(e);
  }
  getKeyRightOf(e) {
    let Ui = this.direction === "ltr" ? "getKeyRightOf" : "getKeyLeftOf";
    return this.layoutDelegate[Ui] ? (e = this.layoutDelegate[Ui](e), this.findNextNonDisabled(e, (Zi) => this.layoutDelegate[Ui](Zi))) : this.layout === "grid" ? this.orientation === "vertical" ? this.getNextColumn(e, this.direction === "rtl") : this.findKey(e, (Zi) => this.getNextColumn(Zi, this.direction === "rtl"), this.isSameColumn) : this.orientation === "horizontal" ? this.getNextColumn(e, this.direction === "rtl") : null;
  }
  getKeyLeftOf(e) {
    let Ui = this.direction === "ltr" ? "getKeyLeftOf" : "getKeyRightOf";
    return this.layoutDelegate[Ui] ? (e = this.layoutDelegate[Ui](e), this.findNextNonDisabled(e, (Zi) => this.layoutDelegate[Ui](Zi))) : this.layout === "grid" ? this.orientation === "vertical" ? this.getNextColumn(e, this.direction === "ltr") : this.findKey(e, (Zi) => this.getNextColumn(Zi, this.direction === "ltr"), this.isSameColumn) : this.orientation === "horizontal" ? this.getNextColumn(e, this.direction === "ltr") : null;
  }
  getFirstKey() {
    let e = this.collection.getFirstKey();
    return this.findNextNonDisabled(e, (Ui) => this.collection.getKeyAfter(Ui));
  }
  getLastKey() {
    let e = this.collection.getLastKey();
    return this.findNextNonDisabled(e, (Ui) => this.collection.getKeyBefore(Ui));
  }
  getKeyPageAbove(e) {
    let Ui = this.ref.current, Zi = this.layoutDelegate.getItemRect(e);
    if (!Zi) return null;
    if (Ui && !$cc38e7bd3fc7b213$export$2bb74740c4e19def(Ui)) return this.getFirstKey();
    let ta = e;
    if (this.orientation === "horizontal") {
      let na = Math.max(0, Zi.x + Zi.width - this.layoutDelegate.getVisibleRect().width);
      for (; Zi && Zi.x > na && ta != null; )
        ta = this.getKeyAbove(ta), Zi = ta == null ? null : this.layoutDelegate.getItemRect(ta);
    } else {
      let na = Math.max(0, Zi.y + Zi.height - this.layoutDelegate.getVisibleRect().height);
      for (; Zi && Zi.y > na && ta != null; )
        ta = this.getKeyAbove(ta), Zi = ta == null ? null : this.layoutDelegate.getItemRect(ta);
    }
    return ta ?? this.getFirstKey();
  }
  getKeyPageBelow(e) {
    let Ui = this.ref.current, Zi = this.layoutDelegate.getItemRect(e);
    if (!Zi) return null;
    if (Ui && !$cc38e7bd3fc7b213$export$2bb74740c4e19def(Ui)) return this.getLastKey();
    let ta = e;
    if (this.orientation === "horizontal") {
      let na = Math.min(this.layoutDelegate.getContentSize().width, Zi.y - Zi.width + this.layoutDelegate.getVisibleRect().width);
      for (; Zi && Zi.x < na && ta != null; )
        ta = this.getKeyBelow(ta), Zi = ta == null ? null : this.layoutDelegate.getItemRect(ta);
    } else {
      let na = Math.min(this.layoutDelegate.getContentSize().height, Zi.y - Zi.height + this.layoutDelegate.getVisibleRect().height);
      for (; Zi && Zi.y < na && ta != null; )
        ta = this.getKeyBelow(ta), Zi = ta == null ? null : this.layoutDelegate.getItemRect(ta);
    }
    return ta ?? this.getLastKey();
  }
  getKeyForSearch(e, Ui) {
    if (!this.collator) return null;
    let Zi = this.collection, ta = Ui || this.getFirstKey();
    for (; ta != null; ) {
      let na = Zi.getItem(ta);
      if (!na) return null;
      let ia = na.textValue.slice(0, e.length);
      if (na.textValue && this.collator.compare(ia, e) === 0) return ta;
      ta = this.getNextKey(ta);
    }
    return null;
  }
  constructor(...e) {
    if (e.length === 1) {
      let Ui = e[0];
      this.collection = Ui.collection, this.ref = Ui.ref, this.collator = Ui.collator, this.disabledKeys = Ui.disabledKeys || /* @__PURE__ */ new Set(), this.disabledBehavior = Ui.disabledBehavior || "all", this.orientation = Ui.orientation || "vertical", this.direction = Ui.direction, this.layout = Ui.layout || "stack", this.layoutDelegate = Ui.layoutDelegate || new $657e4dc4a6e88df0$export$8f5ed9ff9f511381(Ui.ref);
    } else
      this.collection = e[0], this.disabledKeys = e[1], this.ref = e[2], this.collator = e[3], this.layout = "stack", this.orientation = "vertical", this.disabledBehavior = "all", this.layoutDelegate = new $657e4dc4a6e88df0$export$8f5ed9ff9f511381(this.ref);
    this.layout === "stack" && this.orientation === "vertical" && (this.getKeyLeftOf = void 0, this.getKeyRightOf = void 0);
  }
}
function $982254629710d113$export$b95089534ab7c1fd(Bi) {
  let { selectionManager: e, collection: Ui, disabledKeys: Zi, ref: ta, keyboardDelegate: na, layoutDelegate: ia } = Bi, aa = $325a3faab7a68acd$export$a16aca283550c30d({
    usage: "search",
    sensitivity: "base"
  }), da = e.disabledBehavior, La = useMemo(() => na || new $2a25aae57d74318e$export$a05409b8bb224a5a({
    collection: Ui,
    disabledKeys: Zi,
    disabledBehavior: da,
    ref: ta,
    collator: aa,
    layoutDelegate: ia
  }), [
    na,
    ia,
    Ui,
    Zi,
    ta,
    aa,
    da
  ]), { collectionProps: qa } = $ae20dd8cbca75726$export$d6daf82dcd84e87c({
    ...Bi,
    ref: ta,
    selectionManager: e,
    keyboardDelegate: La
  });
  return {
    listProps: qa
  };
}
function $c132121280ec012d$export$50eacbbf140a3141(Bi, e, Ui) {
  let Zi = $65484d02dcb7eb3e$export$457c3d6518dd4c6f(Bi, {
    labelable: !0
  }), ta = Bi.selectionBehavior || "toggle", na = Bi.linkBehavior || (ta === "replace" ? "action" : "override");
  ta === "toggle" && na === "action" && (na = "override");
  let { listProps: ia } = $982254629710d113$export$b95089534ab7c1fd({
    ...Bi,
    ref: Ui,
    selectionManager: e.selectionManager,
    collection: e.collection,
    disabledKeys: e.disabledKeys,
    linkBehavior: na
  }), { focusWithinProps: aa } = $9ab94262bd0047c7$export$420e68273165f4ec({
    onFocusWithin: Bi.onFocus,
    onBlurWithin: Bi.onBlur,
    onFocusWithinChange: Bi.onFocusChange
  }), da = $bdb11010cef70236$export$f680877a34711e37(Bi.id);
  $b1f0cad8af73213b$export$3585ede4d035bf14.set(e, {
    id: da,
    shouldUseVirtualFocus: Bi.shouldUseVirtualFocus,
    shouldSelectOnPressUp: Bi.shouldSelectOnPressUp,
    shouldFocusOnHover: Bi.shouldFocusOnHover,
    isVirtualized: Bi.isVirtualized,
    onAction: Bi.onAction,
    linkBehavior: na
  });
  let { labelProps: La, fieldProps: qa } = $d191a55c9702f145$export$8467354a121f1b9f({
    ...Bi,
    id: da,
    // listbox is not an HTML input element so it
    // shouldn't be labeled by a <label> element.
    labelElementType: "span"
  });
  return {
    labelProps: La,
    listBoxProps: $3ef42575df84b30b$export$9d1611c77c2fe928(Zi, aa, e.selectionManager.selectionMode === "multiple" ? {
      "aria-multiselectable": "true"
    } : {}, {
      role: "listbox",
      ...$3ef42575df84b30b$export$9d1611c77c2fe928(qa, ia)
    })
  };
}
class $eb2240fc39a57fa5$export$bf788dd355e3a401 {
  build(e, Ui) {
    return this.context = Ui, $eb2240fc39a57fa5$var$iterable(() => this.iterateCollection(e));
  }
  *iterateCollection(e) {
    let { children: Ui, items: Zi } = e;
    if (a__default.isValidElement(Ui) && Ui.type === a__default.Fragment) yield* this.iterateCollection({
      children: Ui.props.children,
      items: Zi
    });
    else if (typeof Ui == "function") {
      if (!Zi) throw new Error("props.children was a function but props.items is missing");
      let ta = 0;
      for (let na of Zi)
        yield* this.getFullNode({
          value: na,
          index: ta
        }, {
          renderer: Ui
        }), ta++;
    } else {
      let ta = [];
      a__default.Children.forEach(Ui, (ia) => {
        ia && ta.push(ia);
      });
      let na = 0;
      for (let ia of ta) {
        let aa = this.getFullNode({
          element: ia,
          index: na
        }, {});
        for (let da of aa)
          na++, yield da;
      }
    }
  }
  getKey(e, Ui, Zi, ta) {
    if (e.key != null) return e.key;
    if (Ui.type === "cell" && Ui.key != null) return `${ta}${Ui.key}`;
    let na = Ui.value;
    if (na != null) {
      var ia;
      let aa = (ia = na.key) !== null && ia !== void 0 ? ia : na.id;
      if (aa == null) throw new Error("No key found for item");
      return aa;
    }
    return ta ? `${ta}.${Ui.index}` : `$.${Ui.index}`;
  }
  getChildState(e, Ui) {
    return {
      renderer: Ui.renderer || e.renderer
    };
  }
  *getFullNode(e, Ui, Zi, ta) {
    if (a__default.isValidElement(e.element) && e.element.type === a__default.Fragment) {
      let so = [];
      a__default.Children.forEach(e.element.props.children, (Rs) => {
        so.push(Rs);
      });
      var na;
      let bs = (na = e.index) !== null && na !== void 0 ? na : 0;
      for (const Rs of so) yield* this.getFullNode({
        element: Rs,
        index: bs++
      }, Ui, Zi, ta);
      return;
    }
    let ia = e.element;
    if (!ia && e.value && Ui && Ui.renderer) {
      let so = this.cache.get(e.value);
      if (so && (!so.shouldInvalidate || !so.shouldInvalidate(this.context))) {
        so.index = e.index, so.parentKey = ta ? ta.key : null, yield so;
        return;
      }
      ia = Ui.renderer(e.value);
    }
    if (a__default.isValidElement(ia)) {
      let so = ia.type;
      if (typeof so != "function" && typeof so.getCollectionNode != "function") {
        let qs = ia.type;
        throw new Error(`Unknown element <${qs}> in collection.`);
      }
      let bs = so.getCollectionNode(ia.props, this.context);
      var aa;
      let Rs = (aa = e.index) !== null && aa !== void 0 ? aa : 0, js = bs.next();
      for (; !js.done && js.value; ) {
        let qs = js.value;
        e.index = Rs;
        var da;
        let jo = (da = qs.key) !== null && da !== void 0 ? da : null;
        jo == null && (jo = qs.element ? null : this.getKey(ia, e, Ui, Zi));
        let Ao = [
          ...this.getFullNode({
            ...qs,
            key: jo,
            index: Rs,
            wrapper: $eb2240fc39a57fa5$var$compose(e.wrapper, qs.wrapper)
          }, this.getChildState(Ui, qs), Zi ? `${Zi}${ia.key}` : ia.key, ta)
        ];
        for (let co of Ao) {
          var La, qa;
          co.value = (qa = (La = qs.value) !== null && La !== void 0 ? La : e.value) !== null && qa !== void 0 ? qa : null, co.value && this.cache.set(co.value, co);
          var io;
          if (e.type && co.type !== e.type) throw new Error(`Unsupported type <${$eb2240fc39a57fa5$var$capitalize(co.type)}> in <${$eb2240fc39a57fa5$var$capitalize((io = ta?.type) !== null && io !== void 0 ? io : "unknown parent type")}>. Only <${$eb2240fc39a57fa5$var$capitalize(e.type)}> is supported.`);
          Rs++, yield co;
        }
        js = bs.next(Ao);
      }
      return;
    }
    if (e.key == null || e.type == null) return;
    let ao = this;
    var oo, no;
    let lo = {
      type: e.type,
      props: e.props,
      key: e.key,
      parentKey: ta ? ta.key : null,
      value: (oo = e.value) !== null && oo !== void 0 ? oo : null,
      level: ta ? ta.level + 1 : 0,
      index: e.index,
      rendered: e.rendered,
      textValue: (no = e.textValue) !== null && no !== void 0 ? no : "",
      "aria-label": e["aria-label"],
      wrapper: e.wrapper,
      shouldInvalidate: e.shouldInvalidate,
      hasChildNodes: e.hasChildNodes || !1,
      childNodes: $eb2240fc39a57fa5$var$iterable(function* () {
        if (!e.hasChildNodes || !e.childNodes) return;
        let so = 0;
        for (let bs of e.childNodes()) {
          bs.key != null && (bs.key = `${lo.key}${bs.key}`);
          let Rs = ao.getFullNode({
            ...bs,
            index: so
          }, ao.getChildState(Ui, bs), lo.key, lo);
          for (let js of Rs)
            so++, yield js;
        }
      })
    };
    yield lo;
  }
  constructor() {
    this.cache = /* @__PURE__ */ new WeakMap();
  }
}
function $eb2240fc39a57fa5$var$iterable(Bi) {
  let e = [], Ui = null;
  return {
    *[Symbol.iterator]() {
      for (let Zi of e) yield Zi;
      Ui || (Ui = Bi());
      for (let Zi of Ui)
        e.push(Zi), yield Zi;
    }
  };
}
function $eb2240fc39a57fa5$var$compose(Bi, e) {
  if (Bi && e) return (Ui) => Bi(e(Ui));
  if (Bi) return Bi;
  if (e) return e;
}
function $eb2240fc39a57fa5$var$capitalize(Bi) {
  return Bi[0].toUpperCase() + Bi.slice(1);
}
function $7613b1592d41b092$export$6cd28814d92fa9c9(Bi, e, Ui) {
  let Zi = useMemo(() => new $eb2240fc39a57fa5$export$bf788dd355e3a401(), []), { children: ta, items: na, collection: ia } = Bi;
  return useMemo(() => {
    if (ia) return ia;
    let da = Zi.build({
      children: ta,
      items: na
    }, Ui);
    return e(da);
  }, [
    Zi,
    ta,
    na,
    ia,
    Ui,
    e
  ]);
}
function $c5a24bc478652b5f$export$1005530eda016c13(Bi, e) {
  return typeof e.getChildren == "function" ? e.getChildren(Bi.key) : Bi.childNodes;
}
function $c5a24bc478652b5f$export$fbdeaa6a76694f71(Bi) {
  return $c5a24bc478652b5f$export$5f3398f8733f90e2(Bi);
}
function $c5a24bc478652b5f$export$5f3398f8733f90e2(Bi, e) {
  for (let Ui of Bi)
    return Ui;
}
function $c5a24bc478652b5f$export$8c434b3a7a4dad6(Bi, e, Ui) {
  if (e.parentKey === Ui.parentKey) return e.index - Ui.index;
  let Zi = [
    ...$c5a24bc478652b5f$var$getAncestors(Bi, e),
    e
  ], ta = [
    ...$c5a24bc478652b5f$var$getAncestors(Bi, Ui),
    Ui
  ], na = Zi.slice(0, ta.length).findIndex((ia, aa) => ia !== ta[aa]);
  return na !== -1 ? (e = Zi[na], Ui = ta[na], e.index - Ui.index) : Zi.findIndex((ia) => ia === Ui) >= 0 ? 1 : (ta.findIndex((ia) => ia === e) >= 0, -1);
}
function $c5a24bc478652b5f$var$getAncestors(Bi, e) {
  let Ui = [], Zi = e;
  for (; Zi?.parentKey != null; )
    Zi = Bi.getItem(Zi.parentKey), Zi && Ui.unshift(Zi);
  return Ui;
}
const $453cc9f0df89c0a5$var$cache = /* @__PURE__ */ new WeakMap();
function $453cc9f0df89c0a5$export$77d5aafae4e095b2(Bi) {
  let e = $453cc9f0df89c0a5$var$cache.get(Bi);
  if (e != null) return e;
  let Ui = 0, Zi = (ta) => {
    for (let na of ta) na.type === "section" ? Zi($c5a24bc478652b5f$export$1005530eda016c13(na, Bi)) : Ui++;
  };
  return Zi(Bi), $453cc9f0df89c0a5$var$cache.set(Bi, Ui), Ui;
}
function $293f70390ea03370$export$497855f14858aa34(Bi, e, Ui) {
  var Zi, ta;
  let { key: na } = Bi, ia = $b1f0cad8af73213b$export$3585ede4d035bf14.get(e);
  var aa;
  let da = (aa = Bi.isDisabled) !== null && aa !== void 0 ? aa : e.selectionManager.isDisabled(na);
  var La;
  let qa = (La = Bi.isSelected) !== null && La !== void 0 ? La : e.selectionManager.isSelected(na);
  var io;
  let ao = (io = Bi.shouldSelectOnPressUp) !== null && io !== void 0 ? io : ia?.shouldSelectOnPressUp;
  var oo;
  let no = (oo = Bi.shouldFocusOnHover) !== null && oo !== void 0 ? oo : ia?.shouldFocusOnHover;
  var lo;
  let so = (lo = Bi.shouldUseVirtualFocus) !== null && lo !== void 0 ? lo : ia?.shouldUseVirtualFocus;
  var bs;
  let Rs = (bs = Bi.isVirtualized) !== null && bs !== void 0 ? bs : ia?.isVirtualized, js = $bdb11010cef70236$export$b4cc09c592e8fdb8(), qs = $bdb11010cef70236$export$b4cc09c592e8fdb8(), jo = {
    role: "option",
    "aria-disabled": da || void 0,
    "aria-selected": e.selectionManager.selectionMode !== "none" ? qa : void 0
  };
  $c87311424ea30a05$export$9ac100e40613ea10() && $c87311424ea30a05$export$78551043582a6a98() || (jo["aria-label"] = Bi["aria-label"], jo["aria-labelledby"] = js, jo["aria-describedby"] = qs);
  let fs = e.collection.getItem(na);
  if (Rs) {
    let Vl = Number(fs?.index);
    jo["aria-posinset"] = Number.isNaN(Vl) ? void 0 : Vl + 1, jo["aria-setsize"] = $453cc9f0df89c0a5$export$77d5aafae4e095b2(e.collection);
  }
  let Ao = ia?.onAction ? () => {
    var Vl;
    return ia == null || (Vl = ia.onAction) === null || Vl === void 0 ? void 0 : Vl.call(ia, na);
  } : void 0, co = $b1f0cad8af73213b$export$9145995848b05025(e, na), { itemProps: Co, isPressed: Zs, isFocused: xl, hasAction: Cl, allowsSelection: Al } = $880e95eb8b93ba9a$export$ecf600387e221c37({
    selectionManager: e.selectionManager,
    key: na,
    ref: Ui,
    shouldSelectOnPressUp: ao,
    allowsDifferentPressOrigin: ao && no,
    isVirtualized: Rs,
    shouldUseVirtualFocus: so,
    isDisabled: da,
    onAction: Ao || !(fs == null || (Zi = fs.props) === null || Zi === void 0) && Zi.onAction ? $ff5963eb1fccf552$export$e08e3b67e392101e(fs == null || (ta = fs.props) === null || ta === void 0 ? void 0 : ta.onAction, Ao) : void 0,
    linkBehavior: ia?.linkBehavior,
    id: co
  }), { hoverProps: Ol } = $6179b936705e76d3$export$ae780daf29e6d456({
    isDisabled: da || !no,
    onHoverStart() {
      $507fabe10e71c6fb$export$b9b3dfddab17db27() || (e.selectionManager.setFocused(!0), e.selectionManager.setFocusedKey(na));
    }
  }), Bl = $65484d02dcb7eb3e$export$457c3d6518dd4c6f(fs?.props);
  delete Bl.id;
  let Ml = $ea8dcbcb9ea1b556$export$7e924b3091a3bd18(fs?.props);
  return {
    optionProps: {
      ...jo,
      ...$3ef42575df84b30b$export$9d1611c77c2fe928(Bl, Co, Ol, Ml),
      id: co
    },
    labelProps: {
      id: js
    },
    descriptionProps: {
      id: qs
    },
    isFocused: xl,
    isFocusVisible: xl && $507fabe10e71c6fb$export$b9b3dfddab17db27(),
    isSelected: qa,
    isDisabled: da,
    isPressed: Zs,
    allowsSelection: Al,
    hasAction: Cl
  };
}
function $af383d3bef1cfdc9$export$c3f9f39876e4bc7(Bi) {
  let { heading: e, "aria-label": Ui } = Bi, Zi = $bdb11010cef70236$export$f680877a34711e37();
  return {
    itemProps: {
      role: "presentation"
    },
    headingProps: e ? {
      // Techincally, listbox cannot contain headings according to ARIA.
      // We hide the heading from assistive technology, using role="presentation",
      // and only use it as a visual label for the nested group.
      id: Zi,
      role: "presentation"
    } : {},
    groupProps: {
      role: "group",
      "aria-label": Ui,
      "aria-labelledby": e ? Zi : void 0
    }
  };
}
var $c0398ad35c3639b7$exports = {};
$c0398ad35c3639b7$exports = {
  longPressMessage: "اضغط مطولاً أو اضغط على Alt + السهم لأسفل لفتح القائمة"
};
var $7af657c4165927c3$exports = {};
$7af657c4165927c3$exports = {
  longPressMessage: "Натиснете продължително или натиснете Alt+ стрелка надолу, за да отворите менюто"
};
var $d95d4da6d531ab81$exports = {};
$d95d4da6d531ab81$exports = {
  longPressMessage: "Dlouhým stiskem nebo stisknutím kláves Alt + šipka dolů otevřete nabídku"
};
var $24ebda9c775dca17$exports = {};
$24ebda9c775dca17$exports = {
  longPressMessage: "Langt tryk eller tryk på Alt + pil ned for at åbne menuen"
};
var $743e0dfca6cab1e9$exports = {};
$743e0dfca6cab1e9$exports = {
  longPressMessage: "Drücken Sie lange oder drücken Sie Alt + Nach-unten, um das Menü zu öffnen"
};
var $a2f41026e05f1c84$exports = {};
$a2f41026e05f1c84$exports = {
  longPressMessage: "Πιέστε παρατεταμένα ή πατήστε Alt + κάτω βέλος για να ανοίξετε το μενού"
};
var $43b800e97c901737$exports = {};
$43b800e97c901737$exports = {
  longPressMessage: "Long press or press Alt + ArrowDown to open menu"
};
var $442f5f6ac211e29f$exports = {};
$442f5f6ac211e29f$exports = {
  longPressMessage: "Mantenga pulsado o pulse Alt + flecha abajo para abrir el menú"
};
var $dff280acfeb2d8ac$exports = {};
$dff280acfeb2d8ac$exports = {
  longPressMessage: "Menüü avamiseks vajutage pikalt või vajutage klahve Alt + allanool"
};
var $51608325613944d7$exports = {};
$51608325613944d7$exports = {
  longPressMessage: "Avaa valikko painamalla pohjassa tai näppäinyhdistelmällä Alt + Alanuoli"
};
var $c4a1b1eabeaa87be$exports = {};
$c4a1b1eabeaa87be$exports = {
  longPressMessage: "Appuyez de manière prolongée ou appuyez sur Alt + Flèche vers le bas pour ouvrir le menu."
};
var $8c74815cdee18d1b$exports = {};
$8c74815cdee18d1b$exports = {
  longPressMessage: "לחץ לחיצה ארוכה או הקש Alt + ArrowDown כדי לפתוח את התפריט"
};
var $fd0e9ef6a7fe0ec9$exports = {};
$fd0e9ef6a7fe0ec9$exports = {
  longPressMessage: "Dugo pritisnite ili pritisnite Alt + strelicu prema dolje za otvaranje izbornika"
};
var $a89a74a39eba465a$exports = {};
$a89a74a39eba465a$exports = {
  longPressMessage: "Nyomja meg hosszan, vagy nyomja meg az Alt + lefele nyíl gombot a menü megnyitásához"
};
var $edc7c66594a0ae8a$exports = {};
$edc7c66594a0ae8a$exports = {
  longPressMessage: "Premere a lungo o premere Alt + Freccia giù per aprire il menu"
};
var $f1ab51510712db52$exports = {};
$f1ab51510712db52$exports = {
  longPressMessage: "長押しまたは Alt+下矢印キーでメニューを開く"
};
var $f9b672d9b82fa3d6$exports = {};
$f9b672d9b82fa3d6$exports = {
  longPressMessage: "길게 누르거나 Alt + 아래쪽 화살표를 눌러 메뉴 열기"
};
var $a385f3910feda499$exports = {};
$a385f3910feda499$exports = {
  longPressMessage: "Norėdami atidaryti meniu, nuspaudę palaikykite arba paspauskite „Alt + ArrowDown“."
};
var $4f1bde932c441789$exports = {};
$4f1bde932c441789$exports = {
  longPressMessage: "Lai atvērtu izvēlni, turiet nospiestu vai nospiediet taustiņu kombināciju Alt + lejupvērstā bultiņa"
};
var $914a51a8a594d5be$exports = {};
$914a51a8a594d5be$exports = {
  longPressMessage: "Langt trykk eller trykk Alt + PilNed for å åpne menyen"
};
var $89aaf803103bb500$exports = {};
$89aaf803103bb500$exports = {
  longPressMessage: "Druk lang op Alt + pijl-omlaag of druk op Alt om het menu te openen"
};
var $c685891476dbaaca$exports = {};
$c685891476dbaaca$exports = {
  longPressMessage: "Naciśnij i przytrzymaj lub naciśnij klawisze Alt + Strzałka w dół, aby otworzyć menu"
};
var $885879b9b10c2959$exports = {};
$885879b9b10c2959$exports = {
  longPressMessage: "Pressione e segure ou pressione Alt + Seta para baixo para abrir o menu"
};
var $6b39616688a51692$exports = {};
$6b39616688a51692$exports = {
  longPressMessage: "Prima continuamente ou prima Alt + Seta Para Baixo para abrir o menu"
};
var $f26362aed63f47e2$exports = {};
$f26362aed63f47e2$exports = {
  longPressMessage: "Apăsați lung sau apăsați pe Alt + săgeată în jos pentru a deschide meniul"
};
var $06cbade644558bf0$exports = {};
$06cbade644558bf0$exports = {
  longPressMessage: "Нажмите и удерживайте или нажмите Alt + Стрелка вниз, чтобы открыть меню"
};
var $0a391ff68f9d59b1$exports = {};
$0a391ff68f9d59b1$exports = {
  longPressMessage: "Ponuku otvoríte dlhým stlačením alebo stlačením klávesu Alt + klávesu so šípkou nadol"
};
var $8193cf0e649c7928$exports = {};
$8193cf0e649c7928$exports = {
  longPressMessage: "Za odprtje menija pritisnite in držite gumb ali pritisnite Alt+puščica navzdol"
};
var $f398debcce5a5c55$exports = {};
$f398debcce5a5c55$exports = {
  longPressMessage: "Dugo pritisnite ili pritisnite Alt + strelicu prema dole da otvorite meni"
};
var $9e9fef000aa4c013$exports = {};
$9e9fef000aa4c013$exports = {
  longPressMessage: "Håll nedtryckt eller tryck på Alt + pil nedåt för att öppna menyn"
};
var $c016c8183bbe3d68$exports = {};
$c016c8183bbe3d68$exports = {
  longPressMessage: "Menüyü açmak için uzun basın veya Alt + Aşağı Ok tuşuna basın"
};
var $ca4f6c8462244e62$exports = {};
$ca4f6c8462244e62$exports = {
  longPressMessage: "Довго або звичайно натисніть комбінацію клавіш Alt і стрілка вниз, щоб відкрити меню"
};
var $2d9960c02ccac927$exports = {};
$2d9960c02ccac927$exports = {
  longPressMessage: "长按或按 Alt + 向下方向键以打开菜单"
};
var $f1b682a4c8c5631c$exports = {};
$f1b682a4c8c5631c$exports = {
  longPressMessage: "長按或按 Alt+向下鍵以開啟功能表"
};
var $2cbb7ca666678a14$exports = {};
$2cbb7ca666678a14$exports = {
  "ar-AE": $c0398ad35c3639b7$exports,
  "bg-BG": $7af657c4165927c3$exports,
  "cs-CZ": $d95d4da6d531ab81$exports,
  "da-DK": $24ebda9c775dca17$exports,
  "de-DE": $743e0dfca6cab1e9$exports,
  "el-GR": $a2f41026e05f1c84$exports,
  "en-US": $43b800e97c901737$exports,
  "es-ES": $442f5f6ac211e29f$exports,
  "et-EE": $dff280acfeb2d8ac$exports,
  "fi-FI": $51608325613944d7$exports,
  "fr-FR": $c4a1b1eabeaa87be$exports,
  "he-IL": $8c74815cdee18d1b$exports,
  "hr-HR": $fd0e9ef6a7fe0ec9$exports,
  "hu-HU": $a89a74a39eba465a$exports,
  "it-IT": $edc7c66594a0ae8a$exports,
  "ja-JP": $f1ab51510712db52$exports,
  "ko-KR": $f9b672d9b82fa3d6$exports,
  "lt-LT": $a385f3910feda499$exports,
  "lv-LV": $4f1bde932c441789$exports,
  "nb-NO": $914a51a8a594d5be$exports,
  "nl-NL": $89aaf803103bb500$exports,
  "pl-PL": $c685891476dbaaca$exports,
  "pt-BR": $885879b9b10c2959$exports,
  "pt-PT": $6b39616688a51692$exports,
  "ro-RO": $f26362aed63f47e2$exports,
  "ru-RU": $06cbade644558bf0$exports,
  "sk-SK": $0a391ff68f9d59b1$exports,
  "sl-SI": $8193cf0e649c7928$exports,
  "sr-SP": $f398debcce5a5c55$exports,
  "sv-SE": $9e9fef000aa4c013$exports,
  "tr-TR": $c016c8183bbe3d68$exports,
  "uk-UA": $ca4f6c8462244e62$exports,
  "zh-CN": $2d9960c02ccac927$exports,
  "zh-TW": $f1b682a4c8c5631c$exports
};
function $parcel$interopDefault(Bi) {
  return Bi && Bi.__esModule ? Bi.default : Bi;
}
function $168583247155ddda$export$dc9c12ed27dd1b49(Bi, e, Ui) {
  let { type: Zi = "menu", isDisabled: ta, trigger: na = "press" } = Bi, ia = $bdb11010cef70236$export$f680877a34711e37(), { triggerProps: aa, overlayProps: da } = $628037886ba31236$export$f9d5c8beee7d008d({
    type: Zi
  }, e, Ui), La = (oo) => {
    if (!ta && !(na === "longPress" && !oo.altKey) && Ui && Ui.current)
      switch (oo.key) {
        case "Enter":
        case " ":
          if (na === "longPress") return;
        // fallthrough
        case "ArrowDown":
          "continuePropagation" in oo || oo.stopPropagation(), oo.preventDefault(), e.toggle("first");
          break;
        case "ArrowUp":
          "continuePropagation" in oo || oo.stopPropagation(), oo.preventDefault(), e.toggle("last");
          break;
        default:
          "continuePropagation" in oo && oo.continuePropagation();
      }
  }, qa = $fca6afa0e843324b$export$f12b703ca79dfbb1($parcel$interopDefault($2cbb7ca666678a14$exports), "@react-aria/menu"), { longPressProps: io } = $8a26561d2877236e$export$c24ed0104d07eab9({
    isDisabled: ta || na !== "longPress",
    accessibilityDescription: qa.format("longPressMessage"),
    onLongPressStart() {
      e.close();
    },
    onLongPress() {
      e.open("first");
    }
  }), ao = {
    onPressStart(oo) {
      oo.pointerType !== "touch" && oo.pointerType !== "keyboard" && !ta && e.open(oo.pointerType === "virtual" ? "first" : null);
    },
    onPress(oo) {
      oo.pointerType === "touch" && !ta && e.toggle();
    }
  };
  return delete aa.onPress, {
    // @ts-ignore - TODO we pass out both DOMAttributes AND AriaButtonProps, but useButton will discard the longPress event handlers, it's only through PressResponder magic that this works for RSP and RAC. it does not work in aria examples
    menuTriggerProps: {
      ...aa,
      ...na === "press" ? ao : io,
      id: ia,
      onKeyDown: La
    },
    menuProps: {
      ...da,
      "aria-labelledby": ia,
      autoFocus: e.focusStrategy || !0,
      onClose: e.close
    }
  };
}
const $fc79756100351201$export$6f49b4016bfc8d56 = /* @__PURE__ */ new WeakMap();
function $d5336fe17ce95402$export$38eaa17faae8f579(Bi, e, Ui) {
  let { shouldFocusWrap: Zi = !0, onKeyDown: ta, onKeyUp: na, ...ia } = Bi;
  !Bi["aria-label"] && !Bi["aria-labelledby"] && console.warn("An aria-label or aria-labelledby prop is required for accessibility.");
  let aa = $65484d02dcb7eb3e$export$457c3d6518dd4c6f(Bi, {
    labelable: !0
  }), { listProps: da } = $982254629710d113$export$b95089534ab7c1fd({
    ...ia,
    ref: Ui,
    selectionManager: e.selectionManager,
    collection: e.collection,
    disabledKeys: e.disabledKeys,
    shouldFocusWrap: Zi,
    linkBehavior: "override"
  });
  return $fc79756100351201$export$6f49b4016bfc8d56.set(e, {
    onClose: Bi.onClose,
    onAction: Bi.onAction,
    shouldUseVirtualFocus: Bi.shouldUseVirtualFocus
  }), {
    menuProps: $3ef42575df84b30b$export$9d1611c77c2fe928(aa, {
      onKeyDown: ta,
      onKeyUp: na
    }, {
      role: "menu",
      ...da,
      onKeyDown: (La) => {
        var qa;
        (La.key !== "Escape" || Bi.shouldUseVirtualFocus) && ((qa = da.onKeyDown) === null || qa === void 0 || qa.call(da, La));
      }
    })
  };
}
function $a2e5df62f93c7633$export$9d32628fc2aea7da(Bi, e, Ui) {
  let { id: Zi, key: ta, closeOnSelect: na, isVirtualized: ia, "aria-haspopup": aa, onPressStart: da, onPressUp: La, onPress: qa, onPressChange: io, onPressEnd: ao, onHoverStart: oo, onHoverChange: no, onHoverEnd: lo, onKeyDown: so, onKeyUp: bs, onFocus: Rs, onFocusChange: js, onBlur: qs, selectionManager: jo = e.selectionManager } = Bi, fs = !!aa, Ao = fs && Bi["aria-expanded"] === "true";
  var co;
  let Co = (co = Bi.isDisabled) !== null && co !== void 0 ? co : jo.isDisabled(ta);
  var Zs;
  let xl = (Zs = Bi.isSelected) !== null && Zs !== void 0 ? Zs : jo.isSelected(ta), Cl = $fc79756100351201$export$6f49b4016bfc8d56.get(e), Al = e.collection.getItem(ta), Ol = Bi.onClose || Cl.onClose, Bl = $ea8dcbcb9ea1b556$export$9a302a45f65d0572(), Ml = (Dl) => {
    var $l;
    if (!fs) {
      if (!(Al == null || ($l = Al.props) === null || $l === void 0) && $l.onAction ? Al.props.onAction() : Bi.onAction && Bi.onAction(ta), Cl.onAction) {
        let kl = Cl.onAction;
        kl(ta);
      }
      Dl.target instanceof HTMLAnchorElement && Al && Bl.open(Dl.target, Dl, Al.props.href, Al.props.routerOptions);
    }
  }, Vl = "menuitem";
  fs || (jo.selectionMode === "single" ? Vl = "menuitemradio" : jo.selectionMode === "multiple" && (Vl = "menuitemcheckbox"));
  let Ll = $bdb11010cef70236$export$b4cc09c592e8fdb8(), Yl = $bdb11010cef70236$export$b4cc09c592e8fdb8(), Zl = $bdb11010cef70236$export$b4cc09c592e8fdb8(), tc = {
    id: Zi,
    "aria-disabled": Co || void 0,
    role: Vl,
    "aria-label": Bi["aria-label"],
    "aria-labelledby": Ll,
    "aria-describedby": [
      Yl,
      Zl
    ].filter(Boolean).join(" ") || void 0,
    "aria-controls": Bi["aria-controls"],
    "aria-haspopup": aa,
    "aria-expanded": Bi["aria-expanded"]
  };
  jo.selectionMode !== "none" && !fs && (tc["aria-checked"] = xl), ia && (tc["aria-posinset"] = Al?.index, tc["aria-setsize"] = $453cc9f0df89c0a5$export$77d5aafae4e095b2(e.collection));
  let Nl = (Dl) => {
    Dl.pointerType === "keyboard" && Ml(Dl), da?.(Dl);
  }, Tl = () => {
    !fs && Ol && (na ?? (jo.selectionMode !== "multiple" || jo.isLink(ta))) && Ol();
  }, El = (Dl) => {
    Dl.pointerType === "mouse" && (Ml(Dl), Tl()), La?.(Dl);
  }, Il = (Dl) => {
    Dl.pointerType !== "keyboard" && Dl.pointerType !== "mouse" && (Ml(Dl), Tl()), qa?.(Dl);
  }, { itemProps: Ul, isFocused: Kl } = $880e95eb8b93ba9a$export$ecf600387e221c37({
    id: Zi,
    selectionManager: jo,
    key: ta,
    ref: Ui,
    shouldSelectOnPressUp: !0,
    allowsDifferentPressOrigin: !0,
    // Disable all handling of links in useSelectable item
    // because we handle it ourselves. The behavior of menus
    // is slightly different from other collections because
    // actions are performed on key down rather than key up.
    linkBehavior: "none",
    shouldUseVirtualFocus: Cl.shouldUseVirtualFocus
  }), { pressProps: Rl, isPressed: uo } = $f6c31cce2adf654f$export$45712eceda6fad21({
    onPressStart: Nl,
    onPress: Il,
    onPressUp: El,
    onPressChange: io,
    onPressEnd: ao,
    isDisabled: Co
  }), { hoverProps: Is } = $6179b936705e76d3$export$ae780daf29e6d456({
    isDisabled: Co,
    onHoverStart(Dl) {
      !$507fabe10e71c6fb$export$b9b3dfddab17db27() && !(Ao && aa === "dialog") && (jo.setFocused(!0), jo.setFocusedKey(ta)), oo?.(Dl);
    },
    onHoverChange: no,
    onHoverEnd: lo
  }), { keyboardProps: Sl } = $46d819fcbaf35654$export$8f71654801c2f7cd({
    onKeyDown: (Dl) => {
      if (Dl.repeat) {
        Dl.continuePropagation();
        return;
      }
      switch (Dl.key) {
        case " ":
          !Co && jo.selectionMode === "none" && !fs && na !== !1 && Ol && Ol();
          break;
        case "Enter":
          !Co && na !== !1 && !fs && Ol && Ol();
          break;
        default:
          fs || Dl.continuePropagation(), so?.(Dl);
          break;
      }
    },
    onKeyUp: bs
  }), { focusProps: wl } = $a1ea59d68270f0dd$export$f8168d8dd8fd66e6({
    onBlur: qs,
    onFocus: Rs,
    onFocusChange: js
  }), Pl = $65484d02dcb7eb3e$export$457c3d6518dd4c6f(Al?.props);
  delete Pl.id;
  let jl = $ea8dcbcb9ea1b556$export$7e924b3091a3bd18(Al?.props);
  return {
    menuItemProps: {
      ...tc,
      ...$3ef42575df84b30b$export$9d1611c77c2fe928(Pl, jl, fs ? {
        onFocus: Ul.onFocus,
        "data-key": Ul["data-key"]
      } : Ul, Rl, Is, Sl, wl),
      // If a submenu is expanded, set the tabIndex to -1 so that shift tabbing goes out of the menu instead of the parent menu item.
      tabIndex: Ul.tabIndex != null && Ao ? -1 : Ul.tabIndex
    },
    labelProps: {
      id: Ll
    },
    descriptionProps: {
      id: Yl
    },
    keyboardShortcutProps: {
      id: Zl
    },
    isFocused: Kl,
    isSelected: xl,
    isPressed: uo,
    isDisabled: Co
  };
}
function $3e5eb2498db5b506$export$73f7a44322579622(Bi) {
  let { heading: e, "aria-label": Ui } = Bi, Zi = $bdb11010cef70236$export$f680877a34711e37();
  return {
    itemProps: {
      role: "presentation"
    },
    headingProps: e ? {
      // Techincally, menus cannot contain headings according to ARIA.
      // We hide the heading from assistive technology, using role="presentation",
      // and only use it as a label for the nested group.
      id: Zi,
      role: "presentation"
    } : {},
    groupProps: {
      role: "group",
      "aria-label": Ui,
      "aria-labelledby": e ? Zi : void 0
    }
  };
}
const $58aed456727eb0f3$export$703601b7e90536f8 = /* @__PURE__ */ new WeakMap();
function $58aed456727eb0f3$export$e64b2f635402ca43(Bi, e, Ui) {
  let { keyboardDelegate: Zi, isDisabled: ta, isRequired: na, name: ia, validationBehavior: aa = "aria" } = Bi, da = $325a3faab7a68acd$export$a16aca283550c30d({
    usage: "search",
    sensitivity: "base"
  }), La = useMemo(() => Zi || new $2a25aae57d74318e$export$a05409b8bb224a5a(e.collection, e.disabledKeys, Ui, da), [
    Zi,
    e.collection,
    e.disabledKeys,
    da
  ]), { menuTriggerProps: qa, menuProps: io } = $168583247155ddda$export$dc9c12ed27dd1b49({
    isDisabled: ta,
    type: "listbox"
  }, e, Ui), ao = (co) => {
    switch (co.key) {
      case "ArrowLeft": {
        var Co, Zs;
        co.preventDefault();
        let Al = e.selectedKey != null ? (Co = La.getKeyAbove) === null || Co === void 0 ? void 0 : Co.call(La, e.selectedKey) : (Zs = La.getFirstKey) === null || Zs === void 0 ? void 0 : Zs.call(La);
        Al && e.setSelectedKey(Al);
        break;
      }
      case "ArrowRight": {
        var xl, Cl;
        co.preventDefault();
        let Al = e.selectedKey != null ? (xl = La.getKeyBelow) === null || xl === void 0 ? void 0 : xl.call(La, e.selectedKey) : (Cl = La.getFirstKey) === null || Cl === void 0 ? void 0 : Cl.call(La);
        Al && e.setSelectedKey(Al);
        break;
      }
    }
  }, { typeSelectProps: oo } = $fb3050f43d946246$export$e32c88dfddc6e1d8({
    keyboardDelegate: La,
    selectionManager: e.selectionManager,
    onTypeSelect(co) {
      e.setSelectedKey(co);
    }
  }), { isInvalid: no, validationErrors: lo, validationDetails: so } = e.displayValidation, { labelProps: bs, fieldProps: Rs, descriptionProps: js, errorMessageProps: qs } = $2baaea4c71418dea$export$294aa081a6c6f55d({
    ...Bi,
    labelElementType: "span",
    isInvalid: no,
    errorMessage: Bi.errorMessage || lo
  });
  oo.onKeyDown = oo.onKeyDownCapture, delete oo.onKeyDownCapture;
  let jo = $65484d02dcb7eb3e$export$457c3d6518dd4c6f(Bi, {
    labelable: !0
  }), fs = $3ef42575df84b30b$export$9d1611c77c2fe928(oo, qa, Rs), Ao = $bdb11010cef70236$export$f680877a34711e37();
  return $58aed456727eb0f3$export$703601b7e90536f8.set(e, {
    isDisabled: ta,
    isRequired: na,
    name: ia,
    validationBehavior: aa
  }), {
    labelProps: {
      ...bs,
      onClick: () => {
        if (!Bi.isDisabled) {
          var co;
          (co = Ui.current) === null || co === void 0 || co.focus(), $507fabe10e71c6fb$export$8397ddfc504fdb9a("keyboard");
        }
      }
    },
    triggerProps: $3ef42575df84b30b$export$9d1611c77c2fe928(jo, {
      ...fs,
      isDisabled: ta,
      onKeyDown: $ff5963eb1fccf552$export$e08e3b67e392101e(fs.onKeyDown, ao, Bi.onKeyDown),
      onKeyUp: Bi.onKeyUp,
      "aria-labelledby": [
        Ao,
        fs["aria-labelledby"],
        fs["aria-label"] && !fs["aria-labelledby"] ? fs.id : null
      ].filter(Boolean).join(" "),
      onFocus(co) {
        e.isFocused || (Bi.onFocus && Bi.onFocus(co), Bi.onFocusChange && Bi.onFocusChange(!0), e.setFocused(!0));
      },
      onBlur(co) {
        e.isOpen || (Bi.onBlur && Bi.onBlur(co), Bi.onFocusChange && Bi.onFocusChange(!1), e.setFocused(!1));
      }
    }),
    valueProps: {
      id: Ao
    },
    menuProps: {
      ...io,
      autoFocus: e.focusStrategy || !0,
      shouldSelectOnPressUp: !0,
      shouldFocusOnHover: !0,
      disallowEmptySelection: !0,
      linkBehavior: "selection",
      onBlur: (co) => {
        co.currentTarget.contains(co.relatedTarget) || (Bi.onBlur && Bi.onBlur(co), Bi.onFocusChange && Bi.onFocusChange(!1), e.setFocused(!1));
      },
      "aria-labelledby": [
        Rs["aria-labelledby"],
        fs["aria-label"] && !Rs["aria-labelledby"] ? fs.id : null
      ].filter(Boolean).join(" ")
    },
    descriptionProps: js,
    errorMessageProps: qs,
    isInvalid: no,
    validationErrors: lo,
    validationDetails: so
  };
}
function $bdd25dc72710631f$export$f809e80f58e251d1(Bi, e, Ui) {
  let Zi = $58aed456727eb0f3$export$703601b7e90536f8.get(e) || {}, { autoComplete: ta, name: na = Zi.name, isDisabled: ia = Zi.isDisabled } = Bi, { validationBehavior: aa, isRequired: da } = Zi, { visuallyHiddenProps: La } = $5c3e21d68f1c4674$export$a966af930f325cab();
  $99facab73266f662$export$5add1d006293d136(Bi.selectRef, e.selectedKey, e.setSelectedKey), $e93e671b31057976$export$b8473d3665f3a75a({
    validationBehavior: aa,
    focus: () => {
      var io;
      return (io = Ui.current) === null || io === void 0 ? void 0 : io.focus();
    }
  }, e, Bi.selectRef);
  var qa;
  return {
    containerProps: {
      ...La,
      "aria-hidden": !0,
      // @ts-ignore
      "data-react-aria-prevent-focus": !0,
      // @ts-ignore
      "data-a11y-ignore": "aria-hidden-focus"
    },
    inputProps: {
      style: {
        display: "none"
      }
    },
    selectProps: {
      tabIndex: -1,
      autoComplete: ta,
      disabled: ia,
      required: aa === "native" && da,
      name: na,
      value: (qa = e.selectedKey) !== null && qa !== void 0 ? qa : "",
      onChange: (io) => e.setSelectedKey(io.target.value)
    }
  };
}
function $bdd25dc72710631f$export$cbd84cdb2e668835(Bi) {
  let { state: e, triggerRef: Ui, label: Zi, name: ta, isDisabled: na } = Bi, ia = useRef(null), { containerProps: aa, selectProps: da } = $bdd25dc72710631f$export$f809e80f58e251d1({
    ...Bi,
    selectRef: ia
  }, e, Ui);
  var La;
  return e.collection.size <= 300 ? /* @__PURE__ */ a__default.createElement("div", {
    ...aa,
    "data-testid": "hidden-select-container"
  }, /* @__PURE__ */ a__default.createElement("label", null, Zi, /* @__PURE__ */ a__default.createElement("select", {
    ...da,
    ref: ia
  }, /* @__PURE__ */ a__default.createElement("option", null), [
    ...e.collection.getKeys()
  ].map((qa) => {
    let io = e.collection.getItem(qa);
    if (io && io.type === "item") return /* @__PURE__ */ a__default.createElement("option", {
      key: io.key,
      value: io.key
    }, io.textValue);
  })))) : ta ? /* @__PURE__ */ a__default.createElement("input", {
    type: "hidden",
    autoComplete: da.autoComplete,
    name: ta,
    disabled: na,
    value: (La = e.selectedKey) !== null && La !== void 0 ? La : ""
  }) : null;
}
const $0393f8ab869a0f1a$export$e9f3bf65a26ce129 = /* @__PURE__ */ createContext(null), $d2b4bc8c273e7be6$var$additionalButtonHTMLAttributes = /* @__PURE__ */ new Set([
  "form",
  "formAction",
  "formEncType",
  "formMethod",
  "formNoValidate",
  "formTarget",
  "name",
  "value"
]), $d2b4bc8c273e7be6$export$24d547caef80ccd1 = /* @__PURE__ */ createContext({}), $d2b4bc8c273e7be6$export$353f5b6fc5456de1 = /* @__PURE__ */ $f39a9eba43920ace$export$86427a43e3e48ebb(function(e, Ui) {
  [e, Ui] = $64fa3d84918910a7$export$29f1550f4b0d4415(e, Ui, $d2b4bc8c273e7be6$export$24d547caef80ccd1), e = $d2b4bc8c273e7be6$var$disablePendingProps(e);
  let Zi = e, { isPending: ta } = Zi, { buttonProps: na, isPressed: ia } = $701a24aa0da5b062$export$ea18c227d4417cc3(e, Ui), { focusProps: aa, isFocused: da, isFocusVisible: La } = $f7dceffc5ad7768b$export$4e328f61c538687f(e), { hoverProps: qa, isHovered: io } = $6179b936705e76d3$export$ae780daf29e6d456({
    ...e,
    isDisabled: e.isDisabled || ta
  }), ao = {
    isHovered: io,
    isPressed: (Zi.isPressed || ia) && !ta,
    isFocused: da,
    isFocusVisible: La,
    isDisabled: e.isDisabled || !1,
    isPending: ta ?? !1
  }, oo = $64fa3d84918910a7$export$4d86445c2cf5e3({
    ...e,
    values: ao,
    defaultClassName: "react-aria-Button"
  }), no = $bdb11010cef70236$export$f680877a34711e37(na.id), lo = $bdb11010cef70236$export$f680877a34711e37(), so = na["aria-labelledby"];
  ta && (so ? so = `${so} ${lo}` : na["aria-label"] && (so = `${no} ${lo}`));
  let bs = useRef(ta);
  return useEffect(() => {
    let Rs = {
      "aria-labelledby": so || no
    };
    (!bs.current && da && ta || bs.current && da && !ta) && $319e236875307eab$export$a9b970dcc4ae71a9(Rs, "assertive"), bs.current = ta;
  }, [
    ta,
    da,
    so,
    no
  ]), /* @__PURE__ */ a__default.createElement("button", {
    ...$65484d02dcb7eb3e$export$457c3d6518dd4c6f(e, {
      propNames: $d2b4bc8c273e7be6$var$additionalButtonHTMLAttributes
    }),
    ...$3ef42575df84b30b$export$9d1611c77c2fe928(na, aa, qa),
    ...oo,
    type: na.type === "submit" && ta ? "button" : na.type,
    id: no,
    ref: Ui,
    "aria-labelledby": so,
    slot: e.slot || void 0,
    "aria-disabled": ta ? "true" : na["aria-disabled"],
    "data-disabled": e.isDisabled || void 0,
    "data-pressed": ao.isPressed || void 0,
    "data-hovered": io || void 0,
    "data-focused": da || void 0,
    "data-pending": ta || void 0,
    "data-focus-visible": La || void 0
  }, /* @__PURE__ */ a__default.createElement($0393f8ab869a0f1a$export$e9f3bf65a26ce129.Provider, {
    value: {
      id: lo
    }
  }, oo.children));
});
function $d2b4bc8c273e7be6$var$disablePendingProps(Bi) {
  return Bi.isPending && (Bi.onPress = void 0, Bi.onPressStart = void 0, Bi.onPressEnd = void 0, Bi.onPressChange = void 0, Bi.onPressUp = void 0, Bi.onKeyDown = void 0, Bi.onKeyUp = void 0, Bi.onClick = void 0, Bi.href = void 0), Bi;
}
const $514c0188e459b4c0$export$9afb8bc826b033ea = /* @__PURE__ */ createContext({}), $ee014567cb39d3f0$export$ff05c3ac10437e03 = /* @__PURE__ */ createContext(null);
class $a02d57049d202695$export$d085fb9e920b5ca7 {
  *[Symbol.iterator]() {
    yield* this.iterable;
  }
  get size() {
    return this.keyMap.size;
  }
  getKeys() {
    return this.keyMap.keys();
  }
  getKeyBefore(e) {
    let Ui = this.keyMap.get(e);
    var Zi;
    return Ui && (Zi = Ui.prevKey) !== null && Zi !== void 0 ? Zi : null;
  }
  getKeyAfter(e) {
    let Ui = this.keyMap.get(e);
    var Zi;
    return Ui && (Zi = Ui.nextKey) !== null && Zi !== void 0 ? Zi : null;
  }
  getFirstKey() {
    return this.firstKey;
  }
  getLastKey() {
    return this.lastKey;
  }
  getItem(e) {
    var Ui;
    return (Ui = this.keyMap.get(e)) !== null && Ui !== void 0 ? Ui : null;
  }
  at(e) {
    const Ui = [
      ...this.getKeys()
    ];
    return this.getItem(Ui[e]);
  }
  getChildren(e) {
    let Ui = this.keyMap.get(e);
    return Ui?.childNodes || [];
  }
  constructor(e) {
    this.keyMap = /* @__PURE__ */ new Map(), this.firstKey = null, this.lastKey = null, this.iterable = e;
    let Ui = (ia) => {
      if (this.keyMap.set(ia.key, ia), ia.childNodes && ia.type === "section") for (let aa of ia.childNodes) Ui(aa);
    };
    for (let ia of e) Ui(ia);
    let Zi = null, ta = 0;
    for (let [ia, aa] of this.keyMap)
      Zi ? (Zi.nextKey = ia, aa.prevKey = Zi.key) : (this.firstKey = ia, aa.prevKey = void 0), aa.type === "item" && (aa.index = ta++), Zi = aa, Zi.nextKey = void 0;
    var na;
    this.lastKey = (na = Zi?.key) !== null && na !== void 0 ? na : null;
  }
}
class $e40ea825a81a3709$export$52baac22726c72bf extends Set {
  constructor(e, Ui, Zi) {
    super(e), e instanceof $e40ea825a81a3709$export$52baac22726c72bf ? (this.anchorKey = Ui ?? e.anchorKey, this.currentKey = Zi ?? e.currentKey) : (this.anchorKey = Ui ?? null, this.currentKey = Zi ?? null);
  }
}
function $7af3f5b51489e0b5$var$equalSets(Bi, e) {
  if (Bi.size !== e.size) return !1;
  for (let Ui of Bi)
    if (!e.has(Ui)) return !1;
  return !0;
}
function $7af3f5b51489e0b5$export$253fe78d46329472(Bi) {
  let { selectionMode: e = "none", disallowEmptySelection: Ui = !1, allowDuplicateSelectionEvents: Zi, selectionBehavior: ta = "toggle", disabledBehavior: na = "all" } = Bi, ia = useRef(!1), [, aa] = useState(!1), da = useRef(null), La = useRef(null), [, qa] = useState(null), io = useMemo(() => $7af3f5b51489e0b5$var$convertSelection(Bi.selectedKeys), [
    Bi.selectedKeys
  ]), ao = useMemo(() => $7af3f5b51489e0b5$var$convertSelection(Bi.defaultSelectedKeys, new $e40ea825a81a3709$export$52baac22726c72bf()), [
    Bi.defaultSelectedKeys
  ]), [oo, no] = $458b0a5536c1a7cf$export$40bfa8c7b0832715(io, ao, Bi.onSelectionChange), lo = useMemo(() => Bi.disabledKeys ? new Set(Bi.disabledKeys) : /* @__PURE__ */ new Set(), [
    Bi.disabledKeys
  ]), [so, bs] = useState(ta);
  ta === "replace" && so === "toggle" && typeof oo == "object" && oo.size === 0 && bs("replace");
  let Rs = useRef(ta);
  return useEffect(() => {
    ta !== Rs.current && (bs(ta), Rs.current = ta);
  }, [
    ta
  ]), {
    selectionMode: e,
    disallowEmptySelection: Ui,
    selectionBehavior: so,
    setSelectionBehavior: bs,
    get isFocused() {
      return ia.current;
    },
    setFocused(js) {
      ia.current = js, aa(js);
    },
    get focusedKey() {
      return da.current;
    },
    get childFocusStrategy() {
      return La.current;
    },
    setFocusedKey(js, qs = "first") {
      da.current = js, La.current = qs, qa(js);
    },
    selectedKeys: oo,
    setSelectedKeys(js) {
      (Zi || !$7af3f5b51489e0b5$var$equalSets(js, oo)) && no(js);
    },
    disabledKeys: lo,
    disabledBehavior: na
  };
}
function $7af3f5b51489e0b5$var$convertSelection(Bi, e) {
  return Bi ? Bi === "all" ? "all" : new $e40ea825a81a3709$export$52baac22726c72bf(Bi) : e;
}
class $d496c0a20b6e58ec$export$6c8a5aaad13c9852 {
  /**
  * The type of selection that is allowed in the collection.
  */
  get selectionMode() {
    return this.state.selectionMode;
  }
  /**
  * Whether the collection allows empty selection.
  */
  get disallowEmptySelection() {
    return this.state.disallowEmptySelection;
  }
  /**
  * The selection behavior for the collection.
  */
  get selectionBehavior() {
    return this.state.selectionBehavior;
  }
  /**
  * Sets the selection behavior for the collection.
  */
  setSelectionBehavior(e) {
    this.state.setSelectionBehavior(e);
  }
  /**
  * Whether the collection is currently focused.
  */
  get isFocused() {
    return this.state.isFocused;
  }
  /**
  * Sets whether the collection is focused.
  */
  setFocused(e) {
    this.state.setFocused(e);
  }
  /**
  * The current focused key in the collection.
  */
  get focusedKey() {
    return this.state.focusedKey;
  }
  /** Whether the first or last child of the focused key should receive focus. */
  get childFocusStrategy() {
    return this.state.childFocusStrategy;
  }
  /**
  * Sets the focused key.
  */
  setFocusedKey(e, Ui) {
    (e == null || this.collection.getItem(e)) && this.state.setFocusedKey(e, Ui);
  }
  /**
  * The currently selected keys in the collection.
  */
  get selectedKeys() {
    return this.state.selectedKeys === "all" ? new Set(this.getSelectAllKeys()) : this.state.selectedKeys;
  }
  /**
  * The raw selection value for the collection.
  * Either 'all' for select all, or a set of keys.
  */
  get rawSelection() {
    return this.state.selectedKeys;
  }
  /**
  * Returns whether a key is selected.
  */
  isSelected(e) {
    if (this.state.selectionMode === "none") return !1;
    let Ui = this.getKey(e);
    return Ui == null ? !1 : this.state.selectedKeys === "all" ? this.canSelectItem(Ui) : this.state.selectedKeys.has(Ui);
  }
  /**
  * Whether the selection is empty.
  */
  get isEmpty() {
    return this.state.selectedKeys !== "all" && this.state.selectedKeys.size === 0;
  }
  /**
  * Whether all items in the collection are selected.
  */
  get isSelectAll() {
    if (this.isEmpty) return !1;
    if (this.state.selectedKeys === "all") return !0;
    if (this._isSelectAll != null) return this._isSelectAll;
    let e = this.getSelectAllKeys(), Ui = this.state.selectedKeys;
    return this._isSelectAll = e.every((Zi) => Ui.has(Zi)), this._isSelectAll;
  }
  get firstSelectedKey() {
    let e = null;
    for (let Zi of this.state.selectedKeys) {
      let ta = this.collection.getItem(Zi);
      (!e || ta && $c5a24bc478652b5f$export$8c434b3a7a4dad6(this.collection, ta, e) < 0) && (e = ta);
    }
    var Ui;
    return (Ui = e?.key) !== null && Ui !== void 0 ? Ui : null;
  }
  get lastSelectedKey() {
    let e = null;
    for (let Zi of this.state.selectedKeys) {
      let ta = this.collection.getItem(Zi);
      (!e || ta && $c5a24bc478652b5f$export$8c434b3a7a4dad6(this.collection, ta, e) > 0) && (e = ta);
    }
    var Ui;
    return (Ui = e?.key) !== null && Ui !== void 0 ? Ui : null;
  }
  get disabledKeys() {
    return this.state.disabledKeys;
  }
  get disabledBehavior() {
    return this.state.disabledBehavior;
  }
  /**
  * Extends the selection to the given key.
  */
  extendSelection(e) {
    if (this.selectionMode === "none") return;
    if (this.selectionMode === "single") {
      this.replaceSelection(e);
      return;
    }
    let Ui = this.getKey(e);
    if (Ui == null) return;
    let Zi;
    if (this.state.selectedKeys === "all") Zi = new $e40ea825a81a3709$export$52baac22726c72bf([
      Ui
    ], Ui, Ui);
    else {
      let ia = this.state.selectedKeys;
      var ta;
      let aa = (ta = ia.anchorKey) !== null && ta !== void 0 ? ta : Ui;
      Zi = new $e40ea825a81a3709$export$52baac22726c72bf(ia, aa, Ui);
      var na;
      for (let da of this.getKeyRange(aa, (na = ia.currentKey) !== null && na !== void 0 ? na : Ui)) Zi.delete(da);
      for (let da of this.getKeyRange(Ui, aa)) this.canSelectItem(da) && Zi.add(da);
    }
    this.state.setSelectedKeys(Zi);
  }
  getKeyRange(e, Ui) {
    let Zi = this.collection.getItem(e), ta = this.collection.getItem(Ui);
    return Zi && ta ? $c5a24bc478652b5f$export$8c434b3a7a4dad6(this.collection, Zi, ta) <= 0 ? this.getKeyRangeInternal(e, Ui) : this.getKeyRangeInternal(Ui, e) : [];
  }
  getKeyRangeInternal(e, Ui) {
    var Zi;
    if (!((Zi = this.layoutDelegate) === null || Zi === void 0) && Zi.getKeyRange) return this.layoutDelegate.getKeyRange(e, Ui);
    let ta = [], na = e;
    for (; na != null; ) {
      let ia = this.collection.getItem(na);
      if (ia && (ia.type === "item" || ia.type === "cell" && this.allowsCellSelection) && ta.push(na), na === Ui) return ta;
      na = this.collection.getKeyAfter(na);
    }
    return [];
  }
  getKey(e) {
    let Ui = this.collection.getItem(e);
    if (!Ui || Ui.type === "cell" && this.allowsCellSelection) return e;
    for (; Ui && Ui.type !== "item" && Ui.parentKey != null; ) Ui = this.collection.getItem(Ui.parentKey);
    return !Ui || Ui.type !== "item" ? null : Ui.key;
  }
  /**
  * Toggles whether the given key is selected.
  */
  toggleSelection(e) {
    if (this.selectionMode === "none") return;
    if (this.selectionMode === "single" && !this.isSelected(e)) {
      this.replaceSelection(e);
      return;
    }
    let Ui = this.getKey(e);
    if (Ui == null) return;
    let Zi = new $e40ea825a81a3709$export$52baac22726c72bf(this.state.selectedKeys === "all" ? this.getSelectAllKeys() : this.state.selectedKeys);
    Zi.has(Ui) ? Zi.delete(Ui) : this.canSelectItem(Ui) && (Zi.add(Ui), Zi.anchorKey = Ui, Zi.currentKey = Ui), !(this.disallowEmptySelection && Zi.size === 0) && this.state.setSelectedKeys(Zi);
  }
  /**
  * Replaces the selection with only the given key.
  */
  replaceSelection(e) {
    if (this.selectionMode === "none") return;
    let Ui = this.getKey(e);
    if (Ui == null) return;
    let Zi = this.canSelectItem(Ui) ? new $e40ea825a81a3709$export$52baac22726c72bf([
      Ui
    ], Ui, Ui) : new $e40ea825a81a3709$export$52baac22726c72bf();
    this.state.setSelectedKeys(Zi);
  }
  /**
  * Replaces the selection with the given keys.
  */
  setSelectedKeys(e) {
    if (this.selectionMode === "none") return;
    let Ui = new $e40ea825a81a3709$export$52baac22726c72bf();
    for (let Zi of e) {
      let ta = this.getKey(Zi);
      if (ta != null && (Ui.add(ta), this.selectionMode === "single"))
        break;
    }
    this.state.setSelectedKeys(Ui);
  }
  getSelectAllKeys() {
    let e = [], Ui = (Zi) => {
      for (; Zi != null; ) {
        if (this.canSelectItem(Zi)) {
          var ta;
          let ia = this.collection.getItem(Zi);
          ia?.type === "item" && e.push(Zi);
          var na;
          ia?.hasChildNodes && (this.allowsCellSelection || ia.type !== "item") && Ui((na = (ta = $c5a24bc478652b5f$export$fbdeaa6a76694f71($c5a24bc478652b5f$export$1005530eda016c13(ia, this.collection))) === null || ta === void 0 ? void 0 : ta.key) !== null && na !== void 0 ? na : null);
        }
        Zi = this.collection.getKeyAfter(Zi);
      }
    };
    return Ui(this.collection.getFirstKey()), e;
  }
  /**
  * Selects all items in the collection.
  */
  selectAll() {
    !this.isSelectAll && this.selectionMode === "multiple" && this.state.setSelectedKeys("all");
  }
  /**
  * Removes all keys from the selection.
  */
  clearSelection() {
    !this.disallowEmptySelection && (this.state.selectedKeys === "all" || this.state.selectedKeys.size > 0) && this.state.setSelectedKeys(new $e40ea825a81a3709$export$52baac22726c72bf());
  }
  /**
  * Toggles between select all and an empty selection.
  */
  toggleSelectAll() {
    this.isSelectAll ? this.clearSelection() : this.selectAll();
  }
  select(e, Ui) {
    this.selectionMode !== "none" && (this.selectionMode === "single" ? this.isSelected(e) && !this.disallowEmptySelection ? this.toggleSelection(e) : this.replaceSelection(e) : this.selectionBehavior === "toggle" || Ui && (Ui.pointerType === "touch" || Ui.pointerType === "virtual") ? this.toggleSelection(e) : this.replaceSelection(e));
  }
  /**
  * Returns whether the current selection is equal to the given selection.
  */
  isSelectionEqual(e) {
    if (e === this.state.selectedKeys) return !0;
    let Ui = this.selectedKeys;
    if (e.size !== Ui.size) return !1;
    for (let Zi of e)
      if (!Ui.has(Zi)) return !1;
    for (let Zi of Ui)
      if (!e.has(Zi)) return !1;
    return !0;
  }
  canSelectItem(e) {
    var Ui;
    if (this.state.selectionMode === "none" || this.state.disabledKeys.has(e)) return !1;
    let Zi = this.collection.getItem(e);
    return !(!Zi || !(Zi == null || (Ui = Zi.props) === null || Ui === void 0) && Ui.isDisabled || Zi.type === "cell" && !this.allowsCellSelection);
  }
  isDisabled(e) {
    var Ui, Zi;
    return this.state.disabledBehavior === "all" && (this.state.disabledKeys.has(e) || !!(!((Zi = this.collection.getItem(e)) === null || Zi === void 0 || (Ui = Zi.props) === null || Ui === void 0) && Ui.isDisabled));
  }
  isLink(e) {
    var Ui, Zi;
    return !!(!((Zi = this.collection.getItem(e)) === null || Zi === void 0 || (Ui = Zi.props) === null || Ui === void 0) && Ui.href);
  }
  getItemProps(e) {
    var Ui;
    return (Ui = this.collection.getItem(e)) === null || Ui === void 0 ? void 0 : Ui.props;
  }
  constructor(e, Ui, Zi) {
    this.collection = e, this.state = Ui;
    var ta;
    this.allowsCellSelection = (ta = Zi?.allowsCellSelection) !== null && ta !== void 0 ? ta : !1, this._isSelectAll = null, this.layoutDelegate = Zi?.layoutDelegate || null;
  }
}
function $e72dd72e1c76a225$export$2f645645f7bca764(Bi) {
  let { filter: e, layoutDelegate: Ui } = Bi, Zi = $7af3f5b51489e0b5$export$253fe78d46329472(Bi), ta = useMemo(() => Bi.disabledKeys ? new Set(Bi.disabledKeys) : /* @__PURE__ */ new Set(), [
    Bi.disabledKeys
  ]), na = useCallback((qa) => e ? new $a02d57049d202695$export$d085fb9e920b5ca7(e(qa)) : new $a02d57049d202695$export$d085fb9e920b5ca7(qa), [
    e
  ]), ia = useMemo(() => ({
    suppressTextValueWarning: Bi.suppressTextValueWarning
  }), [
    Bi.suppressTextValueWarning
  ]), aa = $7613b1592d41b092$export$6cd28814d92fa9c9(Bi, na, ia), da = useMemo(() => new $d496c0a20b6e58ec$export$6c8a5aaad13c9852(aa, Zi, {
    layoutDelegate: Ui
  }), [
    aa,
    Zi,
    Ui
  ]);
  const La = useRef(null);
  return useEffect(() => {
    if (Zi.focusedKey != null && !aa.getItem(Zi.focusedKey) && La.current) {
      const bs = La.current.getItem(Zi.focusedKey), Rs = [
        ...La.current.getKeys()
      ].map((co) => {
        const Co = La.current.getItem(co);
        return Co?.type === "item" ? Co : null;
      }).filter((co) => co !== null), js = [
        ...aa.getKeys()
      ].map((co) => {
        const Co = aa.getItem(co);
        return Co?.type === "item" ? Co : null;
      }).filter((co) => co !== null);
      var qa, io;
      const qs = ((qa = Rs?.length) !== null && qa !== void 0 ? qa : 0) - ((io = js?.length) !== null && io !== void 0 ? io : 0);
      var ao, oo, no;
      let jo = Math.min(qs > 1 ? Math.max(((ao = bs?.index) !== null && ao !== void 0 ? ao : 0) - qs + 1, 0) : (oo = bs?.index) !== null && oo !== void 0 ? oo : 0, ((no = js?.length) !== null && no !== void 0 ? no : 0) - 1), fs = null, Ao = !1;
      for (; jo >= 0; ) {
        if (!da.isDisabled(js[jo].key)) {
          fs = js[jo];
          break;
        }
        if (jo < js.length - 1 && !Ao) jo++;
        else {
          Ao = !0;
          var lo, so;
          jo > ((lo = bs?.index) !== null && lo !== void 0 ? lo : 0) && (jo = (so = bs?.index) !== null && so !== void 0 ? so : 0), jo--;
        }
      }
      Zi.setFocusedKey(fs ? fs.key : null);
    }
    La.current = aa;
  }, [
    aa,
    da,
    Zi,
    Zi.focusedKey
  ]), {
    collection: aa,
    disabledKeys: ta,
    selectionManager: da
  };
}
function $a0d645289fe9b86b$export$e7f05e985daf4b5f(Bi) {
  var e;
  let [Ui, Zi] = $458b0a5536c1a7cf$export$40bfa8c7b0832715(Bi.selectedKey, (e = Bi.defaultSelectedKey) !== null && e !== void 0 ? e : null, Bi.onSelectionChange), ta = useMemo(() => Ui != null ? [
    Ui
  ] : [], [
    Ui
  ]), { collection: na, disabledKeys: ia, selectionManager: aa } = $e72dd72e1c76a225$export$2f645645f7bca764({
    ...Bi,
    selectionMode: "single",
    disallowEmptySelection: !0,
    allowDuplicateSelectionEvents: !0,
    selectedKeys: ta,
    onSelectionChange: (La) => {
      if (La === "all") return;
      var qa;
      let io = (qa = La.values().next().value) !== null && qa !== void 0 ? qa : null;
      io === Ui && Bi.onSelectionChange && Bi.onSelectionChange(io), Zi(io);
    }
  }), da = Ui != null ? na.getItem(Ui) : null;
  return {
    collection: na,
    disabledKeys: ia,
    selectionManager: aa,
    selectedKey: Ui,
    setSelectedKey: Zi,
    selectedItem: da
  };
}
function $fc909762b330b746$export$61c6a8c84e605fb6(Bi) {
  let [e, Ui] = $458b0a5536c1a7cf$export$40bfa8c7b0832715(Bi.isOpen, Bi.defaultOpen || !1, Bi.onOpenChange);
  const Zi = useCallback(() => {
    Ui(!0);
  }, [
    Ui
  ]), ta = useCallback(() => {
    Ui(!1);
  }, [
    Ui
  ]), na = useCallback(() => {
    Ui(!e);
  }, [
    Ui,
    e
  ]);
  return {
    isOpen: e,
    setOpen: Ui,
    open: Zi,
    close: ta,
    toggle: na
  };
}
function $a28c903ee9ad8dc5$export$79fefeb1c2091ac3(Bi) {
  let e = $fc909762b330b746$export$61c6a8c84e605fb6(Bi), [Ui, Zi] = useState(null), [ta, na] = useState([]), ia = () => {
    na([]), e.close();
  };
  return {
    focusStrategy: Ui,
    ...e,
    open(La = null) {
      Zi(La), e.open();
    },
    toggle(La = null) {
      Zi(La), e.toggle();
    },
    close() {
      ia();
    },
    expandedKeysStack: ta,
    openSubmenu: (La, qa) => {
      na((io) => qa > io.length ? io : [
        ...io.slice(0, qa),
        La
      ]);
    },
    closeSubmenu: (La, qa) => {
      na((io) => io[qa] === La ? io.slice(0, qa) : io);
    }
  };
}
function $2bc3a590c5373a4e$export$5159ec8b34d4ec12(Bi) {
  let e = $fc909762b330b746$export$61c6a8c84e605fb6(Bi), [Ui, Zi] = useState(null), ta = $a0d645289fe9b86b$export$e7f05e985daf4b5f({
    ...Bi,
    onSelectionChange: (da) => {
      Bi.onSelectionChange != null && Bi.onSelectionChange(da), e.close(), na.commitValidation();
    }
  }), na = $e5be200c675c3b3a$export$fc1a364ae1f3ff10({
    ...Bi,
    value: ta.selectedKey
  }), [ia, aa] = useState(!1);
  return {
    ...na,
    ...ta,
    ...e,
    focusStrategy: Ui,
    open(da = null) {
      ta.collection.size !== 0 && (Zi(da), e.open());
    },
    toggle(da = null) {
      ta.collection.size !== 0 && (Zi(da), e.toggle());
    },
    isFocused: ia,
    setFocused: aa
  };
}
class $05ca4cd7c4a5a999$export$863faf230ee2118a {
  *[Symbol.iterator]() {
    yield* this.iterable;
  }
  get size() {
    return this.keyMap.size;
  }
  getKeys() {
    return this.keyMap.keys();
  }
  getKeyBefore(e) {
    let Ui = this.keyMap.get(e);
    var Zi;
    return Ui && (Zi = Ui.prevKey) !== null && Zi !== void 0 ? Zi : null;
  }
  getKeyAfter(e) {
    let Ui = this.keyMap.get(e);
    var Zi;
    return Ui && (Zi = Ui.nextKey) !== null && Zi !== void 0 ? Zi : null;
  }
  getFirstKey() {
    return this.firstKey;
  }
  getLastKey() {
    return this.lastKey;
  }
  getItem(e) {
    var Ui;
    return (Ui = this.keyMap.get(e)) !== null && Ui !== void 0 ? Ui : null;
  }
  at(e) {
    const Ui = [
      ...this.getKeys()
    ];
    return this.getItem(Ui[e]);
  }
  constructor(e, { expandedKeys: Ui } = {}) {
    this.keyMap = /* @__PURE__ */ new Map(), this.firstKey = null, this.lastKey = null, this.iterable = e, Ui = Ui || /* @__PURE__ */ new Set();
    let Zi = (aa) => {
      if (this.keyMap.set(aa.key, aa), aa.childNodes && (aa.type === "section" || Ui.has(aa.key))) for (let da of aa.childNodes) Zi(da);
    };
    for (let aa of e) Zi(aa);
    let ta = null, na = 0;
    for (let [aa, da] of this.keyMap)
      ta ? (ta.nextKey = aa, da.prevKey = ta.key) : (this.firstKey = aa, da.prevKey = void 0), da.type === "item" && (da.index = na++), ta = da, ta.nextKey = void 0;
    var ia;
    this.lastKey = (ia = ta?.key) !== null && ia !== void 0 ? ia : null;
  }
}
function $875d6693e12af071$export$728d6ba534403756(Bi) {
  let { onExpandedChange: e } = Bi, [Ui, Zi] = $458b0a5536c1a7cf$export$40bfa8c7b0832715(Bi.expandedKeys ? new Set(Bi.expandedKeys) : void 0, Bi.defaultExpandedKeys ? new Set(Bi.defaultExpandedKeys) : /* @__PURE__ */ new Set(), e), ta = $7af3f5b51489e0b5$export$253fe78d46329472(Bi), na = useMemo(() => Bi.disabledKeys ? new Set(Bi.disabledKeys) : /* @__PURE__ */ new Set(), [
    Bi.disabledKeys
  ]), ia = $7613b1592d41b092$export$6cd28814d92fa9c9(Bi, useCallback((da) => new $05ca4cd7c4a5a999$export$863faf230ee2118a(da, {
    expandedKeys: Ui
  }), [
    Ui
  ]), null);
  return useEffect(() => {
    ta.focusedKey != null && !ia.getItem(ta.focusedKey) && ta.setFocusedKey(null);
  }, [
    ia,
    ta.focusedKey
  ]), {
    collection: ia,
    expandedKeys: Ui,
    disabledKeys: na,
    toggleKey: (da) => {
      Zi($875d6693e12af071$var$toggleKey(Ui, da));
    },
    setExpandedKeys: Zi,
    selectionManager: new $d496c0a20b6e58ec$export$6c8a5aaad13c9852(ia, ta)
  };
}
function $875d6693e12af071$var$toggleKey(Bi, e) {
  let Ui = new Set(Bi);
  return Ui.has(e) ? Ui.delete(e) : Ui.add(e), Ui;
}
const $d3e0e05bdfcf66bd$export$c24727297075ec6a = /* @__PURE__ */ createContext(null), $3985021b0ad6602f$export$37fb8590cf2c088c = /* @__PURE__ */ createContext({});
let $3985021b0ad6602f$var$filterHoverProps = (Bi) => {
  let { onHoverStart: e, onHoverChange: Ui, onHoverEnd: Zi, ...ta } = Bi;
  return ta;
};
const $3985021b0ad6602f$export$f5b8910cec6cf069 = /* @__PURE__ */ $f39a9eba43920ace$export$86427a43e3e48ebb(function(e, Ui) {
  [e, Ui] = $64fa3d84918910a7$export$29f1550f4b0d4415(e, Ui, $3985021b0ad6602f$export$37fb8590cf2c088c);
  let { hoverProps: Zi, isHovered: ta } = $6179b936705e76d3$export$ae780daf29e6d456(e), { isFocused: na, isFocusVisible: ia, focusProps: aa } = $f7dceffc5ad7768b$export$4e328f61c538687f({
    isTextInput: !0,
    autoFocus: e.autoFocus
  }), da = !!e["aria-invalid"] && e["aria-invalid"] !== "false", La = $64fa3d84918910a7$export$4d86445c2cf5e3({
    ...e,
    values: {
      isHovered: ta,
      isFocused: na,
      isFocusVisible: ia,
      isDisabled: e.disabled || !1,
      isInvalid: da
    },
    defaultClassName: "react-aria-Input"
  });
  return /* @__PURE__ */ a__default.createElement("input", {
    ...$3ef42575df84b30b$export$9d1611c77c2fe928($3985021b0ad6602f$var$filterHoverProps(e), aa, Zi),
    ...La,
    ref: Ui,
    "data-focused": na || void 0,
    "data-disabled": e.disabled || void 0,
    "data-hovered": ta || void 0,
    "data-focus-visible": ia || void 0,
    "data-invalid": da || void 0
  });
}), $d2f53cda644affe3$export$65d2a03b8800d6e3 = /* @__PURE__ */ createContext(null), $7135fc7d473fd974$export$d40e14dec8b060a8 = /* @__PURE__ */ createContext(null), $7135fc7d473fd974$export$a164736487e3f0ae = {
  CollectionRoot({ collection: Bi, renderDropIndicator: e }) {
    return $7135fc7d473fd974$var$useCollectionRender(Bi, null, e);
  },
  CollectionBranch({ collection: Bi, parent: e, renderDropIndicator: Ui }) {
    return $7135fc7d473fd974$var$useCollectionRender(Bi, e, Ui);
  }
};
function $7135fc7d473fd974$var$useCollectionRender(Bi, e, Ui) {
  return $e948873055cbafe4$export$727c8fc270210f13({
    items: e ? Bi.getChildren(e.key) : Bi,
    dependencies: [
      Ui
    ],
    children(Zi) {
      var ta;
      let na = Zi.render(Zi);
      if (!Ui || Zi.type !== "item") return na;
      let ia = Zi.key, aa = Bi.getKeyAfter(ia);
      return /* @__PURE__ */ a__default.createElement(a__default.Fragment, null, Ui({
        type: "item",
        key: ia,
        dropPosition: "before"
      }), na, (aa == null || ((ta = Bi.getItem(aa)) === null || ta === void 0 ? void 0 : ta.type) !== "item") && Ui({
        type: "item",
        key: ia,
        dropPosition: "after"
      }));
    }
  });
}
const $7135fc7d473fd974$export$4feb769f8ddf26c5 = /* @__PURE__ */ createContext($7135fc7d473fd974$export$a164736487e3f0ae);
function $7135fc7d473fd974$export$90e00781bc59d8f9(Bi) {
  return useMemo(() => Bi != null ? /* @__PURE__ */ new Set([
    Bi
  ]) : null, [
    Bi
  ]);
}
const $612b8eb6cb90e02d$export$d188a835a7bc5783 = /* @__PURE__ */ createContext({}), $612b8eb6cb90e02d$export$f55761759794cf55 = /* @__PURE__ */ createContext(null), $612b8eb6cb90e02d$export$62ed72bc21f6b8a6 = /* @__PURE__ */ forwardRef(function(e, Ui) {
  let { render: Zi } = useContext($612b8eb6cb90e02d$export$f55761759794cf55);
  return /* @__PURE__ */ a__default.createElement(a__default.Fragment, null, Zi(e, Ui));
});
function $612b8eb6cb90e02d$export$971707d8a129a1f7(Bi, e) {
  var Ui;
  let Zi = Bi?.renderDropIndicator, ta = Bi == null || (Ui = Bi.isVirtualDragging) === null || Ui === void 0 ? void 0 : Ui.call(Bi), na = useCallback((ia) => {
    if (ta || e?.isDropTarget(ia)) return Zi ? Zi(ia) : /* @__PURE__ */ a__default.createElement($612b8eb6cb90e02d$export$62ed72bc21f6b8a6, {
      target: ia
    });
  }, [
    e?.target,
    ta,
    Zi
  ]);
  return Bi?.useDropIndicator ? na : void 0;
}
function $612b8eb6cb90e02d$export$d1e8e3fbb7461f6(Bi, e, Ui) {
  var Zi, ta;
  let na = Bi.focusedKey, ia = null;
  if (!(e == null || (Zi = e.isVirtualDragging) === null || Zi === void 0) && Zi.call(e) && (Ui == null || (ta = Ui.target) === null || ta === void 0 ? void 0 : ta.type) === "item") {
    ia = Ui.target.key;
    var aa;
    Ui.target.dropPosition === "after" && (ia = (aa = Ui.collection.getKeyAfter(ia)) !== null && aa !== void 0 ? aa : ia);
  }
  return useMemo(() => new Set([
    na,
    ia
  ].filter((da) => da != null)), [
    na,
    ia
  ]);
}
const $72a5793c14baf454$export$e0e4026c12a8bdbb = /* @__PURE__ */ createContext({}), $431f98aba6844401$export$6615d83f6de245ce = /* @__PURE__ */ createContext({}), $eed445e0843c11d0$export$7ff8f37d2d81a48d = /* @__PURE__ */ createContext(null), $eed445e0843c11d0$export$7c5906fe4f1f2af2 = /* @__PURE__ */ createContext(null), $eed445e0843c11d0$export$41f133550aa26f48 = /* @__PURE__ */ forwardRef(function(e, Ui) {
  [e, Ui] = $64fa3d84918910a7$export$29f1550f4b0d4415(e, Ui, $eed445e0843c11d0$export$7ff8f37d2d81a48d);
  let Zi = useContext($eed445e0843c11d0$export$7c5906fe4f1f2af2);
  return Zi ? /* @__PURE__ */ a__default.createElement($eed445e0843c11d0$var$ListBoxInner, {
    state: Zi,
    props: e,
    listBoxRef: Ui
  }) : /* @__PURE__ */ a__default.createElement($e1995378a142960e$export$bf788dd355e3a401, {
    content: /* @__PURE__ */ a__default.createElement($e1995378a142960e$export$fb8073518f34e6ec, e)
  }, (ta) => /* @__PURE__ */ a__default.createElement($eed445e0843c11d0$var$StandaloneListBox, {
    props: e,
    listBoxRef: Ui,
    collection: ta
  }));
});
function $eed445e0843c11d0$var$StandaloneListBox({ props: Bi, listBoxRef: e, collection: Ui }) {
  Bi = {
    ...Bi,
    collection: Ui,
    children: null,
    items: null
  };
  let { layoutDelegate: Zi } = useContext($7135fc7d473fd974$export$4feb769f8ddf26c5), { filterFn: ta, collectionProps: na, collectionRef: ia } = useContext($d2f53cda644affe3$export$65d2a03b8800d6e3) || {};
  e = $df56164dff5785e2$export$4338b53315abf666(useMemo(() => $5dc95899b306f630$export$c9058316764c140e(e, ia !== void 0 ? ia : null), [
    ia,
    e
  ]));
  let aa = useMemo(() => ta ? Ui.filter(ta) : Ui, [
    Ui,
    ta
  ]), da = $e72dd72e1c76a225$export$2f645645f7bca764({
    ...Bi,
    collection: aa,
    layoutDelegate: Zi
  });
  return /* @__PURE__ */ a__default.createElement($eed445e0843c11d0$var$ListBoxInner, {
    state: da,
    props: {
      ...Bi,
      ...na
    },
    listBoxRef: e
  });
}
function $eed445e0843c11d0$var$ListBoxInner({ state: Bi, props: e, listBoxRef: Ui }) {
  let { dragAndDropHooks: Zi, layout: ta = "stack", orientation: na = "vertical" } = e, { collection: ia, selectionManager: aa } = Bi, da = !!Zi?.useDraggableCollectionState, La = !!Zi?.useDroppableCollectionState, { direction: qa } = $18f2051aff69b9bf$export$43bb16f9c6d9e3f7(), { disabledBehavior: io, disabledKeys: ao } = aa, oo = $325a3faab7a68acd$export$a16aca283550c30d({
    usage: "search",
    sensitivity: "base"
  }), { isVirtualized: no, layoutDelegate: lo, dropTargetDelegate: so, CollectionRoot: bs } = useContext($7135fc7d473fd974$export$4feb769f8ddf26c5), Rs = useMemo(() => e.keyboardDelegate || new $2a25aae57d74318e$export$a05409b8bb224a5a({
    collection: ia,
    collator: oo,
    ref: Ui,
    disabledKeys: ao,
    disabledBehavior: io,
    layout: ta,
    orientation: na,
    direction: qa,
    layoutDelegate: lo
  }), [
    ia,
    oo,
    Ui,
    io,
    ao,
    na,
    qa,
    e.keyboardDelegate,
    ta,
    lo
  ]), { listBoxProps: js } = $c132121280ec012d$export$50eacbbf140a3141({
    ...e,
    shouldSelectOnPressUp: da || e.shouldSelectOnPressUp,
    keyboardDelegate: Rs,
    isVirtualized: no
  }, Bi, Ui), qs = useRef(da), jo = useRef(La);
  useEffect(() => {
    qs.current !== da && console.warn("Drag hooks were provided during one render, but not another. This should be avoided as it may produce unexpected behavior."), jo.current !== La && console.warn("Drop hooks were provided during one render, but not another. This should be avoided as it may produce unexpected behavior.");
  }, [
    da,
    La
  ]);
  let fs, Ao, co, Co = !1, Zs = null, xl = useRef(null);
  if (da && Zi) {
    fs = Zi.useDraggableCollectionState({
      collection: ia,
      selectionManager: aa,
      preview: Zi.renderDragPreview ? xl : void 0
    }), Zi.useDraggableCollection({}, fs, Ui);
    let Ll = Zi.DragPreview;
    Zs = Zi.renderDragPreview ? /* @__PURE__ */ a__default.createElement(Ll, {
      ref: xl
    }, Zi.renderDragPreview) : null;
  }
  if (La && Zi) {
    Ao = Zi.useDroppableCollectionState({
      collection: ia,
      selectionManager: aa
    });
    let Ll = Zi.dropTargetDelegate || so || new Zi.ListDropTargetDelegate(ia, Ui, {
      orientation: na,
      layout: ta,
      direction: qa
    });
    co = Zi.useDroppableCollection({
      keyboardDelegate: Rs,
      dropTargetDelegate: Ll
    }, Ao, Ui), Co = Ao.isDropTarget({
      type: "root"
    });
  }
  let { focusProps: Cl, isFocused: Al, isFocusVisible: Ol } = $f7dceffc5ad7768b$export$4e328f61c538687f(), Bl = {
    isDropTarget: Co,
    isEmpty: Bi.collection.size === 0,
    isFocused: Al,
    isFocusVisible: Ol,
    layout: e.layout || "stack",
    state: Bi
  }, Ml = $64fa3d84918910a7$export$4d86445c2cf5e3({
    className: e.className,
    style: e.style,
    defaultClassName: "react-aria-ListBox",
    values: Bl
  }), Vl = null;
  return Bi.collection.size === 0 && e.renderEmptyState && (Vl = /* @__PURE__ */ a__default.createElement("div", {
    // eslint-disable-next-line
    role: "option",
    style: {
      display: "contents"
    }
  }, e.renderEmptyState(Bl))), /* @__PURE__ */ a__default.createElement($9bf71ea28793e738$export$20e40289641fbbb6, null, /* @__PURE__ */ a__default.createElement("div", {
    ...$65484d02dcb7eb3e$export$457c3d6518dd4c6f(e),
    ...$3ef42575df84b30b$export$9d1611c77c2fe928(js, Cl, co?.collectionProps),
    ...Ml,
    ref: Ui,
    slot: e.slot || void 0,
    onScroll: e.onScroll,
    "data-drop-target": Co || void 0,
    "data-empty": Bi.collection.size === 0 || void 0,
    "data-focused": Al || void 0,
    "data-focus-visible": Ol || void 0,
    "data-layout": e.layout || "stack",
    "data-orientation": e.orientation || "vertical"
  }, /* @__PURE__ */ a__default.createElement($64fa3d84918910a7$export$2881499e37b75b9a, {
    values: [
      [
        $eed445e0843c11d0$export$7ff8f37d2d81a48d,
        e
      ],
      [
        $eed445e0843c11d0$export$7c5906fe4f1f2af2,
        Bi
      ],
      [
        $612b8eb6cb90e02d$export$d188a835a7bc5783,
        {
          dragAndDropHooks: Zi,
          dragState: fs,
          dropState: Ao
        }
      ],
      [
        $431f98aba6844401$export$6615d83f6de245ce,
        {
          elementType: "div"
        }
      ],
      [
        $612b8eb6cb90e02d$export$f55761759794cf55,
        {
          render: $eed445e0843c11d0$var$ListBoxDropIndicatorWrapper
        }
      ],
      [
        $7135fc7d473fd974$export$d40e14dec8b060a8,
        {
          name: "ListBoxSection",
          render: $eed445e0843c11d0$var$ListBoxSectionInner
        }
      ]
    ]
  }, /* @__PURE__ */ a__default.createElement(bs, {
    collection: ia,
    scrollRef: Ui,
    persistedKeys: $612b8eb6cb90e02d$export$d1e8e3fbb7461f6(aa, Zi, Ao),
    renderDropIndicator: $612b8eb6cb90e02d$export$971707d8a129a1f7(Zi, Ao)
  })), Vl, Zs));
}
function $eed445e0843c11d0$var$ListBoxSectionInner(Bi, e, Ui, Zi = "react-aria-ListBoxSection") {
  let ta = useContext($eed445e0843c11d0$export$7c5906fe4f1f2af2), { dragAndDropHooks: na, dropState: ia } = useContext($612b8eb6cb90e02d$export$d188a835a7bc5783), { CollectionBranch: aa } = useContext($7135fc7d473fd974$export$4feb769f8ddf26c5), [da, La] = $64fa3d84918910a7$export$9d4c57ee4c6ffdd8();
  var qa;
  let { headingProps: io, groupProps: ao } = $af383d3bef1cfdc9$export$c3f9f39876e4bc7({
    heading: La,
    "aria-label": (qa = Bi["aria-label"]) !== null && qa !== void 0 ? qa : void 0
  }), oo = $64fa3d84918910a7$export$4d86445c2cf5e3({
    defaultClassName: Zi,
    className: Bi.className,
    style: Bi.style,
    values: {}
  });
  return /* @__PURE__ */ a__default.createElement("section", {
    ...$65484d02dcb7eb3e$export$457c3d6518dd4c6f(Bi),
    ...ao,
    ...oo,
    ref: e
  }, /* @__PURE__ */ a__default.createElement($72a5793c14baf454$export$e0e4026c12a8bdbb.Provider, {
    value: {
      ...io,
      ref: da
    }
  }, /* @__PURE__ */ a__default.createElement(aa, {
    collection: ta.collection,
    parent: Ui,
    renderDropIndicator: $612b8eb6cb90e02d$export$971707d8a129a1f7(na, ia)
  })));
}
const $eed445e0843c11d0$export$a11e76429ed99b4 = /* @__PURE__ */ $e1995378a142960e$export$18af5c7a9e9b3664("item", function(e, Ui, Zi) {
  let ta = $df56164dff5785e2$export$4338b53315abf666(Ui), na = useContext($eed445e0843c11d0$export$7c5906fe4f1f2af2), { dragAndDropHooks: ia, dragState: aa, dropState: da } = useContext($612b8eb6cb90e02d$export$d188a835a7bc5783), { optionProps: La, labelProps: qa, descriptionProps: io, ...ao } = $293f70390ea03370$export$497855f14858aa34({
    key: Zi.key,
    "aria-label": e?.["aria-label"]
  }, na, ta), { hoverProps: oo, isHovered: no } = $6179b936705e76d3$export$ae780daf29e6d456({
    isDisabled: !ao.allowsSelection && !ao.hasAction,
    onHoverStart: Zi.props.onHoverStart,
    onHoverChange: Zi.props.onHoverChange,
    onHoverEnd: Zi.props.onHoverEnd
  }), lo = null;
  aa && ia && (lo = ia.useDraggableItem({
    key: Zi.key
  }, aa));
  let so = null;
  da && ia && (so = ia.useDroppableItem({
    target: {
      type: "item",
      key: Zi.key,
      dropPosition: "on"
    }
  }, da, ta));
  let bs = aa && aa.isDragging(Zi.key), Rs = $64fa3d84918910a7$export$4d86445c2cf5e3({
    ...e,
    id: void 0,
    children: e.children,
    defaultClassName: "react-aria-ListBoxItem",
    values: {
      ...ao,
      isHovered: no,
      selectionMode: na.selectionManager.selectionMode,
      selectionBehavior: na.selectionManager.selectionBehavior,
      allowsDragging: !!aa,
      isDragging: bs,
      isDropTarget: so?.isDropTarget
    }
  });
  useEffect(() => {
    Zi.textValue || console.warn("A `textValue` prop is required for <ListBoxItem> elements with non-plain text children in order to support accessibility features such as type to select.");
  }, [
    Zi.textValue
  ]);
  let js = e.href ? "a" : "div";
  return /* @__PURE__ */ a__default.createElement(js, {
    ...$3ef42575df84b30b$export$9d1611c77c2fe928(La, oo, lo?.dragProps, so?.dropProps),
    ...Rs,
    ref: ta,
    "data-allows-dragging": !!aa || void 0,
    "data-selected": ao.isSelected || void 0,
    "data-disabled": ao.isDisabled || void 0,
    "data-hovered": no || void 0,
    "data-focused": ao.isFocused || void 0,
    "data-focus-visible": ao.isFocusVisible || void 0,
    "data-pressed": ao.isPressed || void 0,
    "data-dragging": bs || void 0,
    "data-drop-target": so?.isDropTarget || void 0,
    "data-selection-mode": na.selectionManager.selectionMode === "none" ? void 0 : na.selectionManager.selectionMode
  }, /* @__PURE__ */ a__default.createElement($64fa3d84918910a7$export$2881499e37b75b9a, {
    values: [
      [
        $514c0188e459b4c0$export$9afb8bc826b033ea,
        {
          slots: {
            label: qa,
            description: io
          }
        }
      ]
    ]
  }, Rs.children));
});
function $eed445e0843c11d0$var$ListBoxDropIndicatorWrapper(Bi, e) {
  e = $df56164dff5785e2$export$4338b53315abf666(e);
  let { dragAndDropHooks: Ui, dropState: Zi } = useContext($612b8eb6cb90e02d$export$d188a835a7bc5783), { dropIndicatorProps: ta, isHidden: na, isDropTarget: ia } = Ui.useDropIndicator(Bi, Zi, e);
  return na ? null : /* @__PURE__ */ a__default.createElement($eed445e0843c11d0$var$ListBoxDropIndicatorForwardRef, {
    ...Bi,
    dropIndicatorProps: ta,
    isDropTarget: ia,
    ref: e
  });
}
function $eed445e0843c11d0$var$ListBoxDropIndicator(Bi, e) {
  let { dropIndicatorProps: Ui, isDropTarget: Zi, ...ta } = Bi, na = $64fa3d84918910a7$export$4d86445c2cf5e3({
    ...ta,
    defaultClassName: "react-aria-DropIndicator",
    values: {
      isDropTarget: Zi
    }
  });
  return /* @__PURE__ */ a__default.createElement("div", {
    ...Ui,
    ...na,
    // eslint-disable-next-line
    role: "option",
    ref: e,
    "data-drop-target": Zi || void 0
  });
}
const $eed445e0843c11d0$var$ListBoxDropIndicatorForwardRef = /* @__PURE__ */ forwardRef($eed445e0843c11d0$var$ListBoxDropIndicator), $44f671af83e7d9e0$export$2de4954e8ae13b9f = /* @__PURE__ */ createContext({
  placement: "bottom"
}), $07b14b47974efb58$export$9b9a0cd73afb7ca4 = /* @__PURE__ */ createContext(null), $07b14b47974efb58$export$5b6b19405a83ff9d = /* @__PURE__ */ forwardRef(function(e, Ui) {
  [e, Ui] = $64fa3d84918910a7$export$29f1550f4b0d4415(e, Ui, $07b14b47974efb58$export$9b9a0cd73afb7ca4);
  let Zi = useContext($de32f1b87079253c$export$d2f961adcb0afbe), ta = $fc909762b330b746$export$61c6a8c84e605fb6(e), na = e.isOpen != null || e.defaultOpen != null || !Zi ? ta : Zi, ia = $d3f049242431219c$export$45fda7c47f93fd48(Ui, na.isOpen) || e.isExiting || !1;
  if ($f39a9eba43920ace$export$b5d7cc18bb8d2b59()) {
    let da = e.children;
    return typeof da == "function" && (da = da({
      trigger: e.trigger || null,
      placement: "bottom",
      isEntering: !1,
      isExiting: !1,
      defaultChildren: null
    })), /* @__PURE__ */ a__default.createElement(a__default.Fragment, null, da);
  }
  return na && !na.isOpen && !ia ? null : /* @__PURE__ */ a__default.createElement($07b14b47974efb58$var$PopoverInner, {
    ...e,
    triggerRef: e.triggerRef,
    state: na,
    popoverRef: Ui,
    isExiting: ia
  });
});
function $07b14b47974efb58$var$PopoverInner({ state: Bi, isExiting: e, UNSTABLE_portalContainer: Ui, ...Zi }) {
  let ta = useRef(null), [na, ia] = useState(0);
  $f0a04ccd8dbdd83b$export$e5c5a5f917a5871c(() => {
    ta.current && Bi.isOpen && ia(ta.current.getBoundingClientRect().width);
  }, [
    Bi.isOpen,
    ta
  ]);
  var aa;
  let { popoverProps: da, underlayProps: La, arrowProps: qa, placement: io } = $f2f8a6077418541e$export$542a6fd13ac93354({
    ...Zi,
    offset: (aa = Zi.offset) !== null && aa !== void 0 ? aa : 8,
    arrowSize: na
  }, Bi), ao = Zi.popoverRef, oo = $d3f049242431219c$export$6d3443f2c48bfc20(ao, !!io) || Zi.isEntering || !1, no = $64fa3d84918910a7$export$4d86445c2cf5e3({
    ...Zi,
    defaultClassName: "react-aria-Popover",
    values: {
      trigger: Zi.trigger || null,
      placement: io,
      isEntering: oo,
      isExiting: e
    }
  }), lo = {
    ...da.style,
    ...no.style
  };
  return /* @__PURE__ */ a__default.createElement($337b884510726a0d$export$c6fdb837b070b4ff, {
    ...Zi,
    isExiting: e,
    portalContainer: Ui
  }, !Zi.isNonModal && Bi.isOpen && /* @__PURE__ */ a__default.createElement("div", {
    "data-testid": "underlay",
    ...La,
    style: {
      position: "fixed",
      inset: 0
    }
  }), /* @__PURE__ */ a__default.createElement("div", {
    ...$3ef42575df84b30b$export$9d1611c77c2fe928($65484d02dcb7eb3e$export$457c3d6518dd4c6f(Zi), da),
    ...no,
    ref: ao,
    slot: Zi.slot || void 0,
    style: lo,
    "data-trigger": Zi.trigger,
    "data-placement": io,
    "data-entering": oo || void 0,
    "data-exiting": e || void 0
  }, !Zi.isNonModal && /* @__PURE__ */ a__default.createElement($86ea4cb521eb2e37$export$2317d149ed6f78c4, {
    onDismiss: Bi.close
  }), /* @__PURE__ */ a__default.createElement($44f671af83e7d9e0$export$2de4954e8ae13b9f.Provider, {
    value: {
      ...qa,
      placement: io,
      ref: ta
    }
  }, no.children), /* @__PURE__ */ a__default.createElement($86ea4cb521eb2e37$export$2317d149ed6f78c4, {
    onDismiss: Bi.close
  })));
}
const $63df2425e2108aa8$export$744d98a3b8a94e1c = /* @__PURE__ */ createContext({}), $3674c52c6b3c5bce$export$c7e742effb1c51e2 = /* @__PURE__ */ createContext(null), $3674c52c6b3c5bce$export$24aad8519b95b41b = /* @__PURE__ */ createContext(null), $3674c52c6b3c5bce$export$795aec4671cbae19 = /* @__PURE__ */ createContext(null), $3674c52c6b3c5bce$var$SelectionManagerContext = /* @__PURE__ */ createContext(null);
function $3674c52c6b3c5bce$export$27d2ad3c5815583e(Bi) {
  let e = $a28c903ee9ad8dc5$export$79fefeb1c2091ac3(Bi), Ui = useRef(null), { menuTriggerProps: Zi, menuProps: ta } = $168583247155ddda$export$dc9c12ed27dd1b49({
    ...Bi,
    type: "menu"
  }, e, Ui), [na, ia] = useState(null), aa = useCallback(() => {
    Ui.current && ia(Ui.current.offsetWidth + "px");
  }, [
    Ui
  ]);
  $9daab02d461809db$export$683480f191c0e3ea({
    ref: Ui,
    onResize: aa
  });
  let da = useRef(null);
  return /* @__PURE__ */ a__default.createElement($64fa3d84918910a7$export$2881499e37b75b9a, {
    values: [
      [
        $3674c52c6b3c5bce$export$c7e742effb1c51e2,
        {
          ...ta,
          ref: da
        }
      ],
      [
        $de32f1b87079253c$export$d2f961adcb0afbe,
        e
      ],
      [
        $3674c52c6b3c5bce$export$795aec4671cbae19,
        e
      ],
      [
        $07b14b47974efb58$export$9b9a0cd73afb7ca4,
        {
          trigger: "MenuTrigger",
          triggerRef: Ui,
          scrollRef: da,
          placement: "bottom start",
          style: {
            "--trigger-width": na
          }
        }
      ]
    ]
  }, /* @__PURE__ */ a__default.createElement($f1ab8c75478c6f73$export$3351871ee4b288b8, {
    ...Zi,
    ref: Ui,
    isPressed: e.isOpen
  }, Bi.children));
}
const $3674c52c6b3c5bce$var$SubmenuTriggerContext = /* @__PURE__ */ createContext(null), $3674c52c6b3c5bce$export$d9b273488cd8ce6f = /* @__PURE__ */ forwardRef(function(e, Ui) {
  return [e, Ui] = $64fa3d84918910a7$export$29f1550f4b0d4415(e, Ui, $3674c52c6b3c5bce$export$c7e742effb1c51e2), /* @__PURE__ */ a__default.createElement($e1995378a142960e$export$bf788dd355e3a401, {
    content: /* @__PURE__ */ a__default.createElement($e1995378a142960e$export$fb8073518f34e6ec, e)
  }, (Zi) => Zi.size > 0 && /* @__PURE__ */ a__default.createElement($3674c52c6b3c5bce$var$MenuInner, {
    props: e,
    collection: Zi,
    menuRef: Ui
  }));
});
function $3674c52c6b3c5bce$var$MenuInner({ props: Bi, collection: e, menuRef: Ui }) {
  let { filterFn: Zi, collectionProps: ta, collectionRef: na } = useContext($d2f53cda644affe3$export$65d2a03b8800d6e3) || {};
  Ui = $df56164dff5785e2$export$4338b53315abf666(useMemo(() => $5dc95899b306f630$export$c9058316764c140e(Ui, na !== void 0 ? na : null), [
    na,
    Ui
  ]));
  let ia = useMemo(() => Zi ? e.filter(Zi) : e, [
    e,
    Zi
  ]), aa = $875d6693e12af071$export$728d6ba534403756({
    ...Bi,
    collection: ia,
    children: void 0
  }), da = useContext($3674c52c6b3c5bce$export$795aec4671cbae19), { isVirtualized: La, CollectionRoot: qa } = useContext($7135fc7d473fd974$export$4feb769f8ddf26c5), { menuProps: io } = $d5336fe17ce95402$export$38eaa17faae8f579({
    ...Bi,
    ...ta,
    isVirtualized: La,
    onClose: Bi.onClose || da?.close
  }, aa, Ui), ao = $64fa3d84918910a7$export$4d86445c2cf5e3({
    defaultClassName: "react-aria-Menu",
    className: Bi.className,
    style: Bi.style,
    values: {}
  });
  return /* @__PURE__ */ a__default.createElement($9bf71ea28793e738$export$20e40289641fbbb6, null, /* @__PURE__ */ a__default.createElement("div", {
    ...$65484d02dcb7eb3e$export$457c3d6518dd4c6f(Bi),
    ...io,
    ...ao,
    ref: Ui,
    slot: Bi.slot || void 0,
    onScroll: Bi.onScroll
  }, /* @__PURE__ */ a__default.createElement($64fa3d84918910a7$export$2881499e37b75b9a, {
    values: [
      [
        $3674c52c6b3c5bce$export$24aad8519b95b41b,
        aa
      ],
      [
        $431f98aba6844401$export$6615d83f6de245ce,
        {
          elementType: "div"
        }
      ],
      [
        $7135fc7d473fd974$export$d40e14dec8b060a8,
        {
          name: "MenuSection",
          render: $3674c52c6b3c5bce$var$MenuSectionInner
        }
      ],
      [
        $3674c52c6b3c5bce$var$SubmenuTriggerContext,
        {
          parentMenuRef: Ui
        }
      ],
      [
        $3674c52c6b3c5bce$var$MenuItemContext,
        null
      ],
      [
        $3674c52c6b3c5bce$var$SelectionManagerContext,
        aa.selectionManager
      ]
    ]
  }, /* @__PURE__ */ a__default.createElement(qa, {
    collection: aa.collection,
    persistedKeys: $7135fc7d473fd974$export$90e00781bc59d8f9(aa.selectionManager.focusedKey),
    scrollRef: Ui
  }))));
}
class $3674c52c6b3c5bce$var$GroupSelectionManager extends $d496c0a20b6e58ec$export$6c8a5aaad13c9852 {
  get focusedKey() {
    return this.parent.focusedKey;
  }
  get isFocused() {
    return this.parent.isFocused;
  }
  setFocusedKey(e, Ui) {
    return this.parent.setFocusedKey(e, Ui);
  }
  setFocused(e) {
    this.parent.setFocused(e);
  }
  get childFocusStrategy() {
    return this.parent.childFocusStrategy;
  }
  constructor(e, Ui) {
    super(e.collection, Ui), this.parent = e;
  }
}
function $3674c52c6b3c5bce$var$MenuSectionInner(Bi, e, Ui, Zi = "react-aria-MenuSection") {
  var ta, na;
  let ia = useContext($3674c52c6b3c5bce$export$24aad8519b95b41b), { CollectionBranch: aa } = useContext($7135fc7d473fd974$export$4feb769f8ddf26c5), [da, La] = $64fa3d84918910a7$export$9d4c57ee4c6ffdd8();
  var qa;
  let { headingProps: io, groupProps: ao } = $3e5eb2498db5b506$export$73f7a44322579622({
    heading: La,
    "aria-label": (qa = Ui.props["aria-label"]) !== null && qa !== void 0 ? qa : void 0
  }), oo = $64fa3d84918910a7$export$4d86445c2cf5e3({
    defaultClassName: Zi,
    className: (ta = Ui.props) === null || ta === void 0 ? void 0 : ta.className,
    style: (na = Ui.props) === null || na === void 0 ? void 0 : na.style,
    values: {}
  }), no = useContext($3674c52c6b3c5bce$var$SelectionManagerContext), lo = $7af3f5b51489e0b5$export$253fe78d46329472(Bi), so = Bi.selectionMode != null ? new $3674c52c6b3c5bce$var$GroupSelectionManager(no, lo) : no;
  return /* @__PURE__ */ a__default.createElement("section", {
    ...$65484d02dcb7eb3e$export$457c3d6518dd4c6f(Bi),
    ...ao,
    ...oo,
    ref: e
  }, /* @__PURE__ */ a__default.createElement($64fa3d84918910a7$export$2881499e37b75b9a, {
    values: [
      [
        $72a5793c14baf454$export$e0e4026c12a8bdbb,
        {
          ...io,
          ref: da
        }
      ],
      [
        $3674c52c6b3c5bce$var$SelectionManagerContext,
        so
      ]
    ]
  }, /* @__PURE__ */ a__default.createElement(aa, {
    collection: ia.collection,
    parent: Ui
  })));
}
const $3674c52c6b3c5bce$var$MenuItemContext = /* @__PURE__ */ createContext(null), $3674c52c6b3c5bce$export$2ce376c2cc3355c8 = /* @__PURE__ */ $e1995378a142960e$export$18af5c7a9e9b3664("item", function(e, Ui, Zi) {
  var ta;
  [e, Ui] = $64fa3d84918910a7$export$29f1550f4b0d4415(e, Ui, $3674c52c6b3c5bce$var$MenuItemContext);
  let na = (ta = $64fa3d84918910a7$export$fabf2dc03a41866e($3674c52c6b3c5bce$var$MenuItemContext)) === null || ta === void 0 ? void 0 : ta.id, ia = useContext($3674c52c6b3c5bce$export$24aad8519b95b41b), aa = $df56164dff5785e2$export$4338b53315abf666(Ui), da = useContext($3674c52c6b3c5bce$var$SelectionManagerContext), { menuItemProps: La, labelProps: qa, descriptionProps: io, keyboardShortcutProps: ao, ...oo } = $a2e5df62f93c7633$export$9d32628fc2aea7da({
    ...e,
    id: na,
    key: Zi.key,
    selectionManager: da
  }, ia, aa), { isFocusVisible: no, focusProps: lo } = $f7dceffc5ad7768b$export$4e328f61c538687f(), { hoverProps: so, isHovered: bs } = $6179b936705e76d3$export$ae780daf29e6d456({
    isDisabled: oo.isDisabled
  }), Rs = $64fa3d84918910a7$export$4d86445c2cf5e3({
    ...e,
    id: void 0,
    children: Zi.rendered,
    defaultClassName: "react-aria-MenuItem",
    values: {
      ...oo,
      isHovered: bs,
      isFocusVisible: no,
      selectionMode: da.selectionMode,
      selectionBehavior: da.selectionBehavior,
      hasSubmenu: !!e["aria-haspopup"],
      isOpen: e["aria-expanded"] === "true"
    }
  }), js = e.href ? "a" : "div";
  return /* @__PURE__ */ a__default.createElement(js, {
    ...$3ef42575df84b30b$export$9d1611c77c2fe928(La, lo, so),
    ...Rs,
    ref: aa,
    "data-disabled": oo.isDisabled || void 0,
    "data-hovered": bs || void 0,
    "data-focused": oo.isFocused || void 0,
    "data-focus-visible": no || void 0,
    "data-pressed": oo.isPressed || void 0,
    "data-selected": oo.isSelected || void 0,
    "data-selection-mode": da.selectionMode === "none" ? void 0 : da.selectionMode,
    "data-has-submenu": !!e["aria-haspopup"] || void 0,
    "data-open": e["aria-expanded"] === "true" || void 0
  }, /* @__PURE__ */ a__default.createElement($64fa3d84918910a7$export$2881499e37b75b9a, {
    values: [
      [
        $514c0188e459b4c0$export$9afb8bc826b033ea,
        {
          slots: {
            label: qa,
            description: io
          }
        }
      ],
      [
        $63df2425e2108aa8$export$744d98a3b8a94e1c,
        ao
      ]
    ]
  }, Rs.children));
}), $de32f1b87079253c$export$d2f961adcb0afbe = /* @__PURE__ */ createContext(null), $1e2864c73f66a4da$export$6fb4a10d2c950550 = /* @__PURE__ */ forwardRef(function(e, Ui) {
  let { onSelect: Zi, acceptedFileTypes: ta, allowsMultiple: na, defaultCamera: ia, children: aa, acceptDirectory: da, ...La } = e, qa = $df56164dff5785e2$export$4338b53315abf666(Ui), io = $65484d02dcb7eb3e$export$457c3d6518dd4c6f(La);
  return /* @__PURE__ */ a__default.createElement(a__default.Fragment, null, /* @__PURE__ */ a__default.createElement($f1ab8c75478c6f73$export$3351871ee4b288b8, {
    onPress: () => {
      var ao, oo;
      !((ao = qa.current) === null || ao === void 0) && ao.value && (qa.current.value = ""), (oo = qa.current) === null || oo === void 0 || oo.click();
    }
  }, aa), /* @__PURE__ */ a__default.createElement($3985021b0ad6602f$export$f5b8910cec6cf069, {
    ...io,
    type: "file",
    ref: qa,
    style: {
      display: "none"
    },
    accept: ta?.toString(),
    onChange: (ao) => Zi?.(ao.target.files),
    capture: ia,
    multiple: na,
    // @ts-expect-error
    webkitdirectory: da ? "" : void 0
  }));
}), $82d7e5349645de74$export$7540cee5be7dc19b = /* @__PURE__ */ createContext(null), $82d7e5349645de74$export$ef445b55be0601bd = /* @__PURE__ */ createContext(null), $82d7e5349645de74$export$ef9b1a59e592288f = /* @__PURE__ */ forwardRef(function(e, Ui) {
  [e, Ui] = $64fa3d84918910a7$export$29f1550f4b0d4415(e, Ui, $82d7e5349645de74$export$7540cee5be7dc19b);
  let { children: Zi, isDisabled: ta = !1, isInvalid: na = !1, isRequired: ia = !1 } = e, aa = useMemo(() => typeof Zi == "function" ? Zi({
    isOpen: !1,
    isDisabled: ta,
    isInvalid: na,
    isRequired: ia,
    isFocused: !1,
    isFocusVisible: !1,
    defaultChildren: null
  }) : Zi, [
    Zi,
    ta,
    na,
    ia
  ]);
  return /* @__PURE__ */ a__default.createElement($e1995378a142960e$export$bf788dd355e3a401, {
    content: aa
  }, (da) => /* @__PURE__ */ a__default.createElement($82d7e5349645de74$var$SelectInner, {
    props: e,
    collection: da,
    selectRef: Ui
  }));
});
function $82d7e5349645de74$var$SelectInner({ props: Bi, selectRef: e, collection: Ui }) {
  let { validationBehavior: Zi } = $64fa3d84918910a7$export$fabf2dc03a41866e($d3e0e05bdfcf66bd$export$c24727297075ec6a) || {};
  var ta, na;
  let ia = (na = (ta = Bi.validationBehavior) !== null && ta !== void 0 ? ta : Zi) !== null && na !== void 0 ? na : "native", aa = $2bc3a590c5373a4e$export$5159ec8b34d4ec12({
    ...Bi,
    collection: Ui,
    children: void 0,
    validationBehavior: ia
  }), { isFocusVisible: da, focusProps: La } = $f7dceffc5ad7768b$export$4e328f61c538687f({
    within: !0
  }), qa = useRef(null), [io, ao] = $64fa3d84918910a7$export$9d4c57ee4c6ffdd8(), { labelProps: oo, triggerProps: no, valueProps: lo, menuProps: so, descriptionProps: bs, errorMessageProps: Rs, ...js } = $58aed456727eb0f3$export$e64b2f635402ca43({
    ...$64fa3d84918910a7$export$ef03459518577ad4(Bi),
    label: ao,
    validationBehavior: ia
  }, aa, qa), [qs, jo] = useState(null), fs = useCallback(() => {
    qa.current && jo(qa.current.offsetWidth + "px");
  }, [
    qa
  ]);
  $9daab02d461809db$export$683480f191c0e3ea({
    ref: qa,
    onResize: fs
  });
  let Ao = useMemo(() => ({
    isOpen: aa.isOpen,
    isFocused: aa.isFocused,
    isFocusVisible: da,
    isDisabled: Bi.isDisabled || !1,
    isInvalid: js.isInvalid || !1,
    isRequired: Bi.isRequired || !1
  }), [
    aa.isOpen,
    aa.isFocused,
    da,
    Bi.isDisabled,
    js.isInvalid,
    Bi.isRequired
  ]), co = $64fa3d84918910a7$export$4d86445c2cf5e3({
    ...Bi,
    values: Ao,
    defaultClassName: "react-aria-Select"
  }), Co = $65484d02dcb7eb3e$export$457c3d6518dd4c6f(Bi);
  delete Co.id;
  let Zs = useRef(null);
  return /* @__PURE__ */ a__default.createElement($64fa3d84918910a7$export$2881499e37b75b9a, {
    values: [
      [
        $82d7e5349645de74$export$7540cee5be7dc19b,
        Bi
      ],
      [
        $82d7e5349645de74$export$ef445b55be0601bd,
        aa
      ],
      [
        $82d7e5349645de74$export$f8f745c04421623f,
        lo
      ],
      [
        $01b77f81d0f07f68$export$75b6ee27786ba447,
        {
          ...oo,
          ref: io,
          elementType: "span"
        }
      ],
      [
        $d2b4bc8c273e7be6$export$24d547caef80ccd1,
        {
          ...no,
          ref: qa,
          isPressed: aa.isOpen
        }
      ],
      [
        $de32f1b87079253c$export$d2f961adcb0afbe,
        aa
      ],
      [
        $07b14b47974efb58$export$9b9a0cd73afb7ca4,
        {
          trigger: "Select",
          triggerRef: qa,
          scrollRef: Zs,
          placement: "bottom start",
          style: {
            "--trigger-width": qs
          }
        }
      ],
      [
        $eed445e0843c11d0$export$7ff8f37d2d81a48d,
        {
          ...so,
          ref: Zs
        }
      ],
      [
        $eed445e0843c11d0$export$7c5906fe4f1f2af2,
        aa
      ],
      [
        $514c0188e459b4c0$export$9afb8bc826b033ea,
        {
          slots: {
            description: bs,
            errorMessage: Rs
          }
        }
      ],
      [
        $ee014567cb39d3f0$export$ff05c3ac10437e03,
        js
      ]
    ]
  }, /* @__PURE__ */ a__default.createElement("div", {
    ...Co,
    ...co,
    ...La,
    ref: e,
    slot: Bi.slot || void 0,
    "data-focused": aa.isFocused || void 0,
    "data-focus-visible": da || void 0,
    "data-open": aa.isOpen || void 0,
    "data-disabled": Bi.isDisabled || void 0,
    "data-invalid": js.isInvalid || void 0,
    "data-required": Bi.isRequired || void 0
  }), /* @__PURE__ */ a__default.createElement($bdd25dc72710631f$export$cbd84cdb2e668835, {
    autoComplete: Bi.autoComplete,
    state: aa,
    triggerRef: qa,
    label: ao,
    name: Bi.name,
    isDisabled: Bi.isDisabled
  }));
}
const $82d7e5349645de74$export$f8f745c04421623f = /* @__PURE__ */ createContext(null), Dropdown = ({
  options: Bi,
  onSelect: e,
  label: Ui,
  className: Zi = ""
}) => /* @__PURE__ */ jsxRuntimeExports.jsxs(
  $82d7e5349645de74$export$ef9b1a59e592288f,
  {
    className: Zi,
    onSelectionChange: (ta) => {
      e(ta);
    },
    children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx($d2b4bc8c273e7be6$export$353f5b6fc5456de1, { children: /* @__PURE__ */ jsxRuntimeExports.jsxs("span", { "aria-hidden": "true", children: [
        Ui && /* @__PURE__ */ jsxRuntimeExports.jsx($01b77f81d0f07f68$export$b04be29aa201d4f5, { children: Ui }),
        /* @__PURE__ */ jsxRuntimeExports.jsx(FontAwesomeIcon, { className: "px-2", icon: faChevronDown, size: "sm" })
      ] }) }),
      /* @__PURE__ */ jsxRuntimeExports.jsx($07b14b47974efb58$export$5b6b19405a83ff9d, { className: "bg-white border border-black", children: /* @__PURE__ */ jsxRuntimeExports.jsx($eed445e0843c11d0$export$41f133550aa26f48, { children: Bi.map((ta) => /* @__PURE__ */ jsxRuntimeExports.jsx($eed445e0843c11d0$export$a11e76429ed99b4, { id: ta.id, children: /* @__PURE__ */ jsxRuntimeExports.jsx("span", { className: "p-1 bg-white w-full block cursor-auto focus:outline-2 focus:outline-neutral-800 ", children: ta.label }) }, `dropdown-${ta.id}`)) }) })
    ]
  }
), Field = forwardRef(({ className: Bi, ...e }, Ui) => /* @__PURE__ */ jsxRuntimeExports.jsx("input", { ref: Ui, className: twMerge(
  "bg-neutral-200 p-2 block h-auto max-h-8 my-2 border-black border dark:bg-neutral-500 dark:text-neutral-100 placeholder-neutral-400 dark:placeholder-neutral-400",
  Bi
), ...e })), Select = forwardRef(({ className: Bi, ...e }, Ui) => /* @__PURE__ */ jsxRuntimeExports.jsx("select", { ref: Ui, ...e, className: twMerge("bg-neutral-200 rounded-md p-2 block h-auto", Bi) })), DynamicFormInput = forwardRef(({ field: Bi, onChange: e, other: Ui, ...Zi }, ta) => {
  const [na, ia] = useState(!1);
  switch (Bi.type) {
    case "textarea":
      return /* @__PURE__ */ jsxRuntimeExports.jsx(
        "textarea",
        {
          ref: ta,
          onChange: e,
          ...Zi
        }
      );
    case "select":
      return /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [
        /* @__PURE__ */ jsxRuntimeExports.jsxs(
          Select,
          {
            ref: ta,
            required: !Bi.optional,
            onChange: (aa) => {
              aa.target.value === "other" ? ia(!0) : ia(!1), e && e(aa);
            },
            ...Zi,
            children: [
              Bi.options.map((aa, da) => /* @__PURE__ */ jsxRuntimeExports.jsx("option", { value: aa, children: aa }, da)),
              Bi?.allowOther && /* @__PURE__ */ jsxRuntimeExports.jsx("option", { value: "other", children: "Other" })
            ]
          }
        ),
        na && Ui?.()
      ] });
    case "submit":
      return /* @__PURE__ */ jsxRuntimeExports.jsx(
        Button,
        {
          ref: ta,
          onChange: e,
          ...Zi,
          type: "submit",
          children: Bi.text
        }
      );
    case "email":
      return /* @__PURE__ */ jsxRuntimeExports.jsx(
        Field,
        {
          required: !Bi.optional,
          ref: ta,
          onChange: e,
          type: "email",
          ...Zi
        }
      );
    default:
      return /* @__PURE__ */ jsxRuntimeExports.jsx(
        Field,
        {
          required: !Bi.optional,
          ref: ta,
          onChange: e,
          ...Zi
        }
      );
  }
}), ellispes = keyframes$2`
    0% {
        opacity: 0;
    }
    50% {
        opacity: 1;
    }
    100% {
        opacity: 0;
    }
`, Dot = styled.span`
  animation: ${ellispes} 3s linear infinite;
  animation-delay: ${({ index: Bi }) => Bi * 0.1}s;
`, Ellipses = () => /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [
  /* @__PURE__ */ jsxRuntimeExports.jsx(Dot, { index: 0, children: "." }),
  /* @__PURE__ */ jsxRuntimeExports.jsx(Dot, { index: 1, children: "." }),
  /* @__PURE__ */ jsxRuntimeExports.jsx(Dot, { index: 2, children: "." })
] }), Error$1 = (Bi) => /* @__PURE__ */ jsxRuntimeExports.jsx("p", { ...Bi, className: "text-red-500 text-sm" });
class ErrorBoundary extends Component {
  constructor() {
    super(...arguments);
    hd(this, "state", {
      hasError: !1
    });
  }
  static getDerivedStateFromError(Ui) {
    return { hasError: !0 };
  }
  componentDidCatch(Ui, Zi) {
    console.error("Uncaught error:", Ui, Zi);
  }
  render() {
    return this.state.hasError ? /* @__PURE__ */ jsxRuntimeExports.jsx("h1", { children: "Sorry.. there was an error" }) : this.props.children;
  }
}
var Re$2 = /* @__PURE__ */ ((Bi) => (Bi.ALL = "all", Bi.NONE = "none", Bi.FILE = "file", Bi.DIR = "dir", Bi.FILE_LIST = "file_list", Bi.DIR_LIST = "dir_list", Bi))(Re$2 || {}), b$2;
(function(Bi) {
  Bi.assertEqual = (ta) => ta;
  function e(ta) {
  }
  Bi.assertIs = e;
  function Ui(ta) {
    throw new Error();
  }
  Bi.assertNever = Ui, Bi.arrayToEnum = (ta) => {
    const na = {};
    for (const ia of ta)
      na[ia] = ia;
    return na;
  }, Bi.getValidEnumValues = (ta) => {
    const na = Bi.objectKeys(ta).filter((aa) => typeof ta[ta[aa]] != "number"), ia = {};
    for (const aa of na)
      ia[aa] = ta[aa];
    return Bi.objectValues(ia);
  }, Bi.objectValues = (ta) => Bi.objectKeys(ta).map(function(na) {
    return ta[na];
  }), Bi.objectKeys = typeof Object.keys == "function" ? (ta) => Object.keys(ta) : (ta) => {
    const na = [];
    for (const ia in ta)
      Object.prototype.hasOwnProperty.call(ta, ia) && na.push(ia);
    return na;
  }, Bi.find = (ta, na) => {
    for (const ia of ta)
      if (na(ia))
        return ia;
  }, Bi.isInteger = typeof Number.isInteger == "function" ? (ta) => Number.isInteger(ta) : (ta) => typeof ta == "number" && isFinite(ta) && Math.floor(ta) === ta;
  function Zi(ta, na = " | ") {
    return ta.map((ia) => typeof ia == "string" ? `'${ia}'` : ia).join(na);
  }
  Bi.joinValues = Zi, Bi.jsonStringifyReplacer = (ta, na) => typeof na == "bigint" ? na.toString() : na;
})(b$2 || (b$2 = {}));
var we;
(function(Bi) {
  Bi.mergeShapes = (e, Ui) => ({
    ...e,
    ...Ui
    // second overwrites first
  });
})(we || (we = {}));
const f$6 = b$2.arrayToEnum([
  "string",
  "nan",
  "number",
  "integer",
  "float",
  "boolean",
  "date",
  "bigint",
  "symbol",
  "function",
  "undefined",
  "null",
  "array",
  "object",
  "unknown",
  "promise",
  "void",
  "never",
  "map",
  "set"
]), N$1 = (Bi) => {
  switch (typeof Bi) {
    case "undefined":
      return f$6.undefined;
    case "string":
      return f$6.string;
    case "number":
      return isNaN(Bi) ? f$6.nan : f$6.number;
    case "boolean":
      return f$6.boolean;
    case "function":
      return f$6.function;
    case "bigint":
      return f$6.bigint;
    case "symbol":
      return f$6.symbol;
    case "object":
      return Array.isArray(Bi) ? f$6.array : Bi === null ? f$6.null : Bi.then && typeof Bi.then == "function" && Bi.catch && typeof Bi.catch == "function" ? f$6.promise : typeof Map < "u" && Bi instanceof Map ? f$6.map : typeof Set < "u" && Bi instanceof Set ? f$6.set : typeof Date < "u" && Bi instanceof Date ? f$6.date : f$6.object;
    default:
      return f$6.unknown;
  }
}, d$3 = b$2.arrayToEnum([
  "invalid_type",
  "invalid_literal",
  "custom",
  "invalid_union",
  "invalid_union_discriminator",
  "invalid_enum_value",
  "unrecognized_keys",
  "invalid_arguments",
  "invalid_return_type",
  "invalid_date",
  "invalid_string",
  "too_small",
  "too_big",
  "invalid_intersection_types",
  "not_multiple_of",
  "not_finite"
]), We$2 = (Bi) => JSON.stringify(Bi, null, 2).replace(/"([^"]+)":/g, "$1:");
let S$1 = class kf extends Error {
  get errors() {
    return this.issues;
  }
  constructor(e) {
    super(), this.issues = [], this.addIssue = (Zi) => {
      this.issues = [...this.issues, Zi];
    }, this.addIssues = (Zi = []) => {
      this.issues = [...this.issues, ...Zi];
    };
    const Ui = new.target.prototype;
    Object.setPrototypeOf ? Object.setPrototypeOf(this, Ui) : this.__proto__ = Ui, this.name = "ZodError", this.issues = e;
  }
  format(e) {
    const Ui = e || function(na) {
      return na.message;
    }, Zi = { _errors: [] }, ta = (na) => {
      for (const ia of na.issues)
        if (ia.code === "invalid_union")
          ia.unionErrors.map(ta);
        else if (ia.code === "invalid_return_type")
          ta(ia.returnTypeError);
        else if (ia.code === "invalid_arguments")
          ta(ia.argumentsError);
        else if (ia.path.length === 0)
          Zi._errors.push(Ui(ia));
        else {
          let aa = Zi, da = 0;
          for (; da < ia.path.length; ) {
            const La = ia.path[da];
            da === ia.path.length - 1 ? (aa[La] = aa[La] || { _errors: [] }, aa[La]._errors.push(Ui(ia))) : aa[La] = aa[La] || { _errors: [] }, aa = aa[La], da++;
          }
        }
    };
    return ta(this), Zi;
  }
  static assert(e) {
    if (!(e instanceof kf))
      throw new Error(`Not a ZodError: ${e}`);
  }
  toString() {
    return this.message;
  }
  get message() {
    return JSON.stringify(this.issues, b$2.jsonStringifyReplacer, 2);
  }
  get isEmpty() {
    return this.issues.length === 0;
  }
  flatten(e = (Ui) => Ui.message) {
    const Ui = {}, Zi = [];
    for (const ta of this.issues)
      ta.path.length > 0 ? (Ui[ta.path[0]] = Ui[ta.path[0]] || [], Ui[ta.path[0]].push(e(ta))) : Zi.push(e(ta));
    return { formErrors: Zi, fieldErrors: Ui };
  }
  get formErrors() {
    return this.flatten();
  }
};
S$1.create = (Bi) => new S$1(Bi);
const J$1 = (Bi, e) => {
  let Ui;
  switch (Bi.code) {
    case d$3.invalid_type:
      Bi.received === f$6.undefined ? Ui = "Required" : Ui = `Expected ${Bi.expected}, received ${Bi.received}`;
      break;
    case d$3.invalid_literal:
      Ui = `Invalid literal value, expected ${JSON.stringify(Bi.expected, b$2.jsonStringifyReplacer)}`;
      break;
    case d$3.unrecognized_keys:
      Ui = `Unrecognized key(s) in object: ${b$2.joinValues(Bi.keys, ", ")}`;
      break;
    case d$3.invalid_union:
      Ui = "Invalid input";
      break;
    case d$3.invalid_union_discriminator:
      Ui = `Invalid discriminator value. Expected ${b$2.joinValues(Bi.options)}`;
      break;
    case d$3.invalid_enum_value:
      Ui = `Invalid enum value. Expected ${b$2.joinValues(Bi.options)}, received '${Bi.received}'`;
      break;
    case d$3.invalid_arguments:
      Ui = "Invalid function arguments";
      break;
    case d$3.invalid_return_type:
      Ui = "Invalid function return type";
      break;
    case d$3.invalid_date:
      Ui = "Invalid date";
      break;
    case d$3.invalid_string:
      typeof Bi.validation == "object" ? "includes" in Bi.validation ? (Ui = `Invalid input: must include "${Bi.validation.includes}"`, typeof Bi.validation.position == "number" && (Ui = `${Ui} at one or more positions greater than or equal to ${Bi.validation.position}`)) : "startsWith" in Bi.validation ? Ui = `Invalid input: must start with "${Bi.validation.startsWith}"` : "endsWith" in Bi.validation ? Ui = `Invalid input: must end with "${Bi.validation.endsWith}"` : b$2.assertNever(Bi.validation) : Bi.validation !== "regex" ? Ui = `Invalid ${Bi.validation}` : Ui = "Invalid";
      break;
    case d$3.too_small:
      Bi.type === "array" ? Ui = `Array must contain ${Bi.exact ? "exactly" : Bi.inclusive ? "at least" : "more than"} ${Bi.minimum} element(s)` : Bi.type === "string" ? Ui = `String must contain ${Bi.exact ? "exactly" : Bi.inclusive ? "at least" : "over"} ${Bi.minimum} character(s)` : Bi.type === "number" ? Ui = `Number must be ${Bi.exact ? "exactly equal to " : Bi.inclusive ? "greater than or equal to " : "greater than "}${Bi.minimum}` : Bi.type === "date" ? Ui = `Date must be ${Bi.exact ? "exactly equal to " : Bi.inclusive ? "greater than or equal to " : "greater than "}${new Date(Number(Bi.minimum))}` : Ui = "Invalid input";
      break;
    case d$3.too_big:
      Bi.type === "array" ? Ui = `Array must contain ${Bi.exact ? "exactly" : Bi.inclusive ? "at most" : "less than"} ${Bi.maximum} element(s)` : Bi.type === "string" ? Ui = `String must contain ${Bi.exact ? "exactly" : Bi.inclusive ? "at most" : "under"} ${Bi.maximum} character(s)` : Bi.type === "number" ? Ui = `Number must be ${Bi.exact ? "exactly" : Bi.inclusive ? "less than or equal to" : "less than"} ${Bi.maximum}` : Bi.type === "bigint" ? Ui = `BigInt must be ${Bi.exact ? "exactly" : Bi.inclusive ? "less than or equal to" : "less than"} ${Bi.maximum}` : Bi.type === "date" ? Ui = `Date must be ${Bi.exact ? "exactly" : Bi.inclusive ? "smaller than or equal to" : "smaller than"} ${new Date(Number(Bi.maximum))}` : Ui = "Invalid input";
      break;
    case d$3.custom:
      Ui = "Invalid input";
      break;
    case d$3.invalid_intersection_types:
      Ui = "Intersection results could not be merged";
      break;
    case d$3.not_multiple_of:
      Ui = `Number must be a multiple of ${Bi.multipleOf}`;
      break;
    case d$3.not_finite:
      Ui = "Number must be finite";
      break;
    default:
      Ui = e.defaultError, b$2.assertNever(Bi);
  }
  return { message: Ui };
};
let Ae$1 = J$1;
function qe$2(Bi) {
  Ae$1 = Bi;
}
function fe$2() {
  return Ae$1;
}
const pe$2 = (Bi) => {
  const { data: e, path: Ui, errorMaps: Zi, issueData: ta } = Bi, na = [...Ui, ...ta.path || []], ia = {
    ...ta,
    path: na
  };
  if (ta.message !== void 0)
    return {
      ...ta,
      path: na,
      message: ta.message
    };
  let aa = "";
  const da = Zi.filter((La) => !!La).slice().reverse();
  for (const La of da)
    aa = La(ia, { data: e, defaultError: aa }).message;
  return {
    ...ta,
    path: na,
    message: aa
  };
}, Je$2 = [];
function u(Bi, e) {
  const Ui = fe$2(), Zi = pe$2({
    issueData: e,
    data: Bi.data,
    path: Bi.path,
    errorMaps: [
      Bi.common.contextualErrorMap,
      // contextual error map is first priority
      Bi.schemaErrorMap,
      // then schema-bound map if available
      Ui,
      // then global override map
      Ui === J$1 ? void 0 : J$1
      // then global default map
    ].filter((ta) => !!ta)
  });
  Bi.common.issues.push(Zi);
}
class k {
  constructor() {
    this.value = "valid";
  }
  dirty() {
    this.value === "valid" && (this.value = "dirty");
  }
  abort() {
    this.value !== "aborted" && (this.value = "aborted");
  }
  static mergeArray(e, Ui) {
    const Zi = [];
    for (const ta of Ui) {
      if (ta.status === "aborted")
        return y$3;
      ta.status === "dirty" && e.dirty(), Zi.push(ta.value);
    }
    return { status: e.value, value: Zi };
  }
  static async mergeObjectAsync(e, Ui) {
    const Zi = [];
    for (const ta of Ui) {
      const na = await ta.key, ia = await ta.value;
      Zi.push({
        key: na,
        value: ia
      });
    }
    return k.mergeObjectSync(e, Zi);
  }
  static mergeObjectSync(e, Ui) {
    const Zi = {};
    for (const ta of Ui) {
      const { key: na, value: ia } = ta;
      if (na.status === "aborted" || ia.status === "aborted")
        return y$3;
      na.status === "dirty" && e.dirty(), ia.status === "dirty" && e.dirty(), na.value !== "__proto__" && (typeof ia.value < "u" || ta.alwaysSet) && (Zi[na.value] = ia.value);
    }
    return { status: e.value, value: Zi };
  }
}
const y$3 = Object.freeze({
  status: "aborted"
}), W$2 = (Bi) => ({ status: "dirty", value: Bi }), T$2 = (Bi) => ({ status: "valid", value: Bi }), Te$2 = (Bi) => Bi.status === "aborted", Se$2 = (Bi) => Bi.status === "dirty", V$1 = (Bi) => Bi.status === "valid", X$2 = (Bi) => typeof Promise < "u" && Bi instanceof Promise;
function me$2(Bi, e, Ui, Zi) {
  if (typeof e == "function" ? Bi !== e || !0 : !e.has(Bi)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
  return e.get(Bi);
}
function Ne$2(Bi, e, Ui, Zi, ta) {
  if (typeof e == "function" ? Bi !== e || !0 : !e.has(Bi)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
  return e.set(Bi, Ui), Ui;
}
var p$3;
(function(Bi) {
  Bi.errToObj = (e) => typeof e == "string" ? { message: e } : e || {}, Bi.toString = (e) => typeof e == "string" ? e : e?.message;
})(p$3 || (p$3 = {}));
var H$3, K$1;
let O$2 = class {
  constructor(e, Ui, Zi, ta) {
    this._cachedPath = [], this.parent = e, this.data = Ui, this._path = Zi, this._key = ta;
  }
  get path() {
    return this._cachedPath.length || (this._key instanceof Array ? this._cachedPath.push(...this._path, ...this._key) : this._cachedPath.push(...this._path, this._key)), this._cachedPath;
  }
};
const Ee$2 = (Bi, e) => {
  if (V$1(e))
    return { success: !0, data: e.value };
  if (!Bi.common.issues.length)
    throw new Error("Validation failed but no issues detected.");
  return {
    success: !1,
    get error() {
      if (this._error)
        return this._error;
      const Ui = new S$1(Bi.common.issues);
      return this._error = Ui, this._error;
    }
  };
};
function _(Bi) {
  if (!Bi)
    return {};
  const { errorMap: e, invalid_type_error: Ui, required_error: Zi, description: ta } = Bi;
  if (e && (Ui || Zi))
    throw new Error(`Can't use "invalid_type_error" or "required_error" in conjunction with custom error map.`);
  return e ? { errorMap: e, description: ta } : { errorMap: (na, ia) => {
    var aa, da;
    const { message: La } = Bi;
    return na.code === "invalid_enum_value" ? { message: La ?? ia.defaultError } : typeof ia.data > "u" ? { message: (aa = La ?? Zi) !== null && aa !== void 0 ? aa : ia.defaultError } : na.code !== "invalid_type" ? { message: ia.defaultError } : { message: (da = La ?? Ui) !== null && da !== void 0 ? da : ia.defaultError };
  }, description: ta };
}
class v {
  get description() {
    return this._def.description;
  }
  _getType(e) {
    return N$1(e.data);
  }
  _getOrReturnCtx(e, Ui) {
    return Ui || {
      common: e.parent.common,
      data: e.data,
      parsedType: N$1(e.data),
      schemaErrorMap: this._def.errorMap,
      path: e.path,
      parent: e.parent
    };
  }
  _processInputParams(e) {
    return {
      status: new k(),
      ctx: {
        common: e.parent.common,
        data: e.data,
        parsedType: N$1(e.data),
        schemaErrorMap: this._def.errorMap,
        path: e.path,
        parent: e.parent
      }
    };
  }
  _parseSync(e) {
    const Ui = this._parse(e);
    if (X$2(Ui))
      throw new Error("Synchronous parse encountered promise.");
    return Ui;
  }
  _parseAsync(e) {
    const Ui = this._parse(e);
    return Promise.resolve(Ui);
  }
  parse(e, Ui) {
    const Zi = this.safeParse(e, Ui);
    if (Zi.success)
      return Zi.data;
    throw Zi.error;
  }
  safeParse(e, Ui) {
    var Zi;
    const ta = {
      common: {
        issues: [],
        async: (Zi = Ui?.async) !== null && Zi !== void 0 ? Zi : !1,
        contextualErrorMap: Ui?.errorMap
      },
      path: Ui?.path || [],
      schemaErrorMap: this._def.errorMap,
      parent: null,
      data: e,
      parsedType: N$1(e)
    }, na = this._parseSync({ data: e, path: ta.path, parent: ta });
    return Ee$2(ta, na);
  }
  "~validate"(e) {
    var Ui, Zi;
    const ta = {
      common: {
        issues: [],
        async: !!this["~standard"].async
      },
      path: [],
      schemaErrorMap: this._def.errorMap,
      parent: null,
      data: e,
      parsedType: N$1(e)
    };
    if (!this["~standard"].async)
      try {
        const na = this._parseSync({ data: e, path: [], parent: ta });
        return V$1(na) ? {
          value: na.value
        } : {
          issues: ta.common.issues
        };
      } catch (na) {
        !((Zi = (Ui = na?.message) === null || Ui === void 0 ? void 0 : Ui.toLowerCase()) === null || Zi === void 0) && Zi.includes("encountered") && (this["~standard"].async = !0), ta.common = {
          issues: [],
          async: !0
        };
      }
    return this._parseAsync({ data: e, path: [], parent: ta }).then((na) => V$1(na) ? {
      value: na.value
    } : {
      issues: ta.common.issues
    });
  }
  async parseAsync(e, Ui) {
    const Zi = await this.safeParseAsync(e, Ui);
    if (Zi.success)
      return Zi.data;
    throw Zi.error;
  }
  async safeParseAsync(e, Ui) {
    const Zi = {
      common: {
        issues: [],
        contextualErrorMap: Ui?.errorMap,
        async: !0
      },
      path: Ui?.path || [],
      schemaErrorMap: this._def.errorMap,
      parent: null,
      data: e,
      parsedType: N$1(e)
    }, ta = this._parse({ data: e, path: Zi.path, parent: Zi }), na = await (X$2(ta) ? ta : Promise.resolve(ta));
    return Ee$2(Zi, na);
  }
  refine(e, Ui) {
    const Zi = (ta) => typeof Ui == "string" || typeof Ui > "u" ? { message: Ui } : typeof Ui == "function" ? Ui(ta) : Ui;
    return this._refinement((ta, na) => {
      const ia = e(ta), aa = () => na.addIssue({
        code: d$3.custom,
        ...Zi(ta)
      });
      return typeof Promise < "u" && ia instanceof Promise ? ia.then((da) => da ? !0 : (aa(), !1)) : ia ? !0 : (aa(), !1);
    });
  }
  refinement(e, Ui) {
    return this._refinement((Zi, ta) => e(Zi) ? !0 : (ta.addIssue(typeof Ui == "function" ? Ui(Zi, ta) : Ui), !1));
  }
  _refinement(e) {
    return new E$2({
      schema: this,
      typeName: g$3.ZodEffects,
      effect: { type: "refinement", refinement: e }
    });
  }
  superRefine(e) {
    return this._refinement(e);
  }
  constructor(e) {
    this.spa = this.safeParseAsync, this._def = e, this.parse = this.parse.bind(this), this.safeParse = this.safeParse.bind(this), this.parseAsync = this.parseAsync.bind(this), this.safeParseAsync = this.safeParseAsync.bind(this), this.spa = this.spa.bind(this), this.refine = this.refine.bind(this), this.refinement = this.refinement.bind(this), this.superRefine = this.superRefine.bind(this), this.optional = this.optional.bind(this), this.nullable = this.nullable.bind(this), this.nullish = this.nullish.bind(this), this.array = this.array.bind(this), this.promise = this.promise.bind(this), this.or = this.or.bind(this), this.and = this.and.bind(this), this.transform = this.transform.bind(this), this.brand = this.brand.bind(this), this.default = this.default.bind(this), this.catch = this.catch.bind(this), this.describe = this.describe.bind(this), this.pipe = this.pipe.bind(this), this.readonly = this.readonly.bind(this), this.isNullable = this.isNullable.bind(this), this.isOptional = this.isOptional.bind(this), this["~standard"] = {
      version: 1,
      vendor: "zod",
      validate: (Ui) => this["~validate"](Ui)
    };
  }
  optional() {
    return j$1.create(this, this._def);
  }
  nullable() {
    return $$1.create(this, this._def);
  }
  nullish() {
    return this.nullable().optional();
  }
  array() {
    return Z$2.create(this);
  }
  promise() {
    return G$2.create(this, this._def);
  }
  or(e) {
    return re$2.create([this, e], this._def);
  }
  and(e) {
    return ne$1.create(this, e, this._def);
  }
  transform(e) {
    return new E$2({
      ..._(this._def),
      schema: this,
      typeName: g$3.ZodEffects,
      effect: { type: "transform", transform: e }
    });
  }
  default(e) {
    const Ui = typeof e == "function" ? e : () => e;
    return new ce$2({
      ..._(this._def),
      innerType: this,
      defaultValue: Ui,
      typeName: g$3.ZodDefault
    });
  }
  brand() {
    return new Ze$2({
      typeName: g$3.ZodBranded,
      type: this,
      ..._(this._def)
    });
  }
  catch(e) {
    const Ui = typeof e == "function" ? e : () => e;
    return new de$2({
      ..._(this._def),
      innerType: this,
      catchValue: Ui,
      typeName: g$3.ZodCatch
    });
  }
  describe(e) {
    const Ui = this.constructor;
    return new Ui({
      ...this._def,
      description: e
    });
  }
  pipe(e) {
    return ue$1.create(this, e);
  }
  readonly() {
    return le$1.create(this);
  }
  isOptional() {
    return this.safeParse(void 0).success;
  }
  isNullable() {
    return this.safeParse(null).success;
  }
}
const Ye$2 = /^c[^\s-]{8,}$/i, Ge$2 = /^[0-9a-z]+$/, He$2 = /^[0-9A-HJKMNP-TV-Z]{26}$/i, Ke$2 = /^[0-9a-fA-F]{8}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{12}$/i, Xe$2 = /^[a-z0-9_-]{21}$/i, Qe$2 = /^[A-Za-z0-9-_]+\.[A-Za-z0-9-_]+\.[A-Za-z0-9-_]*$/, et$2 = /^[-+]?P(?!$)(?:(?:[-+]?\d+Y)|(?:[-+]?\d+[.,]\d+Y$))?(?:(?:[-+]?\d+M)|(?:[-+]?\d+[.,]\d+M$))?(?:(?:[-+]?\d+W)|(?:[-+]?\d+[.,]\d+W$))?(?:(?:[-+]?\d+D)|(?:[-+]?\d+[.,]\d+D$))?(?:T(?=[\d+-])(?:(?:[-+]?\d+H)|(?:[-+]?\d+[.,]\d+H$))?(?:(?:[-+]?\d+M)|(?:[-+]?\d+[.,]\d+M$))?(?:[-+]?\d+(?:[.,]\d+)?S)?)??$/, tt$1 = /^(?!\.)(?!.*\.\.)([A-Z0-9_'+\-\.]*)[A-Z0-9_+-]@([A-Z0-9][A-Z0-9\-]*\.)+[A-Z]{2,}$/i, rt$2 = "^(\\p{Extended_Pictographic}|\\p{Emoji_Component})+$";
let ke$1;
const nt$1 = /^(?:(?:25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])\.){3}(?:25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])$/, st$2 = /^(?:(?:25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])\.){3}(?:25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])\/(3[0-2]|[12]?[0-9])$/, at$1 = /^(([0-9a-fA-F]{1,4}:){7,7}[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,7}:|([0-9a-fA-F]{1,4}:){1,6}:[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,5}(:[0-9a-fA-F]{1,4}){1,2}|([0-9a-fA-F]{1,4}:){1,4}(:[0-9a-fA-F]{1,4}){1,3}|([0-9a-fA-F]{1,4}:){1,3}(:[0-9a-fA-F]{1,4}){1,4}|([0-9a-fA-F]{1,4}:){1,2}(:[0-9a-fA-F]{1,4}){1,5}|[0-9a-fA-F]{1,4}:((:[0-9a-fA-F]{1,4}){1,6})|:((:[0-9a-fA-F]{1,4}){1,7}|:)|fe80:(:[0-9a-fA-F]{0,4}){0,4}%[0-9a-zA-Z]{1,}|::(ffff(:0{1,4}){0,1}:){0,1}((25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])\.){3,3}(25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])|([0-9a-fA-F]{1,4}:){1,4}:((25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])\.){3,3}(25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9]))$/, it$2 = /^(([0-9a-fA-F]{1,4}:){7,7}[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,7}:|([0-9a-fA-F]{1,4}:){1,6}:[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,5}(:[0-9a-fA-F]{1,4}){1,2}|([0-9a-fA-F]{1,4}:){1,4}(:[0-9a-fA-F]{1,4}){1,3}|([0-9a-fA-F]{1,4}:){1,3}(:[0-9a-fA-F]{1,4}){1,4}|([0-9a-fA-F]{1,4}:){1,2}(:[0-9a-fA-F]{1,4}){1,5}|[0-9a-fA-F]{1,4}:((:[0-9a-fA-F]{1,4}){1,6})|:((:[0-9a-fA-F]{1,4}){1,7}|:)|fe80:(:[0-9a-fA-F]{0,4}){0,4}%[0-9a-zA-Z]{1,}|::(ffff(:0{1,4}){0,1}:){0,1}((25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])\.){3,3}(25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])|([0-9a-fA-F]{1,4}:){1,4}:((25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])\.){3,3}(25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9]))\/(12[0-8]|1[01][0-9]|[1-9]?[0-9])$/, ot$2 = /^([0-9a-zA-Z+/]{4})*(([0-9a-zA-Z+/]{2}==)|([0-9a-zA-Z+/]{3}=))?$/, ct$2 = /^([0-9a-zA-Z-_]{4})*(([0-9a-zA-Z-_]{2}(==)?)|([0-9a-zA-Z-_]{3}(=)?))?$/, Ie$2 = "((\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-((0[13578]|1[02])-(0[1-9]|[12]\\d|3[01])|(0[469]|11)-(0[1-9]|[12]\\d|30)|(02)-(0[1-9]|1\\d|2[0-8])))", dt$2 = new RegExp(`^${Ie$2}$`);
function Me$2(Bi) {
  let e = "([01]\\d|2[0-3]):[0-5]\\d:[0-5]\\d";
  return Bi.precision ? e = `${e}\\.\\d{${Bi.precision}}` : Bi.precision == null && (e = `${e}(\\.\\d+)?`), e;
}
function lt$2(Bi) {
  return new RegExp(`^${Me$2(Bi)}$`);
}
function De$1(Bi) {
  let e = `${Ie$2}T${Me$2(Bi)}`;
  const Ui = [];
  return Ui.push(Bi.local ? "Z?" : "Z"), Bi.offset && Ui.push("([+-]\\d{2}:?\\d{2})"), e = `${e}(${Ui.join("|")})`, new RegExp(`^${e}$`);
}
function ut$1(Bi, e) {
  return !!((e === "v4" || !e) && nt$1.test(Bi) || (e === "v6" || !e) && at$1.test(Bi));
}
function ht$2(Bi, e) {
  if (!Qe$2.test(Bi))
    return !1;
  try {
    const [Ui] = Bi.split("."), Zi = Ui.replace(/-/g, "+").replace(/_/g, "/").padEnd(Ui.length + (4 - Ui.length % 4) % 4, "="), ta = JSON.parse(atob(Zi));
    return !(typeof ta != "object" || ta === null || !ta.typ || !ta.alg || e && ta.alg !== e);
  } catch {
    return !1;
  }
}
function ft$2(Bi, e) {
  return !!((e === "v4" || !e) && st$2.test(Bi) || (e === "v6" || !e) && it$2.test(Bi));
}
let C$2 = class zd extends v {
  _parse(e) {
    if (this._def.coerce && (e.data = String(e.data)), this._getType(e) !== f$6.string) {
      const ta = this._getOrReturnCtx(e);
      return u(ta, {
        code: d$3.invalid_type,
        expected: f$6.string,
        received: ta.parsedType
      }), y$3;
    }
    const Ui = new k();
    let Zi;
    for (const ta of this._def.checks)
      if (ta.kind === "min")
        e.data.length < ta.value && (Zi = this._getOrReturnCtx(e, Zi), u(Zi, {
          code: d$3.too_small,
          minimum: ta.value,
          type: "string",
          inclusive: !0,
          exact: !1,
          message: ta.message
        }), Ui.dirty());
      else if (ta.kind === "max")
        e.data.length > ta.value && (Zi = this._getOrReturnCtx(e, Zi), u(Zi, {
          code: d$3.too_big,
          maximum: ta.value,
          type: "string",
          inclusive: !0,
          exact: !1,
          message: ta.message
        }), Ui.dirty());
      else if (ta.kind === "length") {
        const na = e.data.length > ta.value, ia = e.data.length < ta.value;
        (na || ia) && (Zi = this._getOrReturnCtx(e, Zi), na ? u(Zi, {
          code: d$3.too_big,
          maximum: ta.value,
          type: "string",
          inclusive: !0,
          exact: !0,
          message: ta.message
        }) : ia && u(Zi, {
          code: d$3.too_small,
          minimum: ta.value,
          type: "string",
          inclusive: !0,
          exact: !0,
          message: ta.message
        }), Ui.dirty());
      } else if (ta.kind === "email")
        tt$1.test(e.data) || (Zi = this._getOrReturnCtx(e, Zi), u(Zi, {
          validation: "email",
          code: d$3.invalid_string,
          message: ta.message
        }), Ui.dirty());
      else if (ta.kind === "emoji")
        ke$1 || (ke$1 = new RegExp(rt$2, "u")), ke$1.test(e.data) || (Zi = this._getOrReturnCtx(e, Zi), u(Zi, {
          validation: "emoji",
          code: d$3.invalid_string,
          message: ta.message
        }), Ui.dirty());
      else if (ta.kind === "uuid")
        Ke$2.test(e.data) || (Zi = this._getOrReturnCtx(e, Zi), u(Zi, {
          validation: "uuid",
          code: d$3.invalid_string,
          message: ta.message
        }), Ui.dirty());
      else if (ta.kind === "nanoid")
        Xe$2.test(e.data) || (Zi = this._getOrReturnCtx(e, Zi), u(Zi, {
          validation: "nanoid",
          code: d$3.invalid_string,
          message: ta.message
        }), Ui.dirty());
      else if (ta.kind === "cuid")
        Ye$2.test(e.data) || (Zi = this._getOrReturnCtx(e, Zi), u(Zi, {
          validation: "cuid",
          code: d$3.invalid_string,
          message: ta.message
        }), Ui.dirty());
      else if (ta.kind === "cuid2")
        Ge$2.test(e.data) || (Zi = this._getOrReturnCtx(e, Zi), u(Zi, {
          validation: "cuid2",
          code: d$3.invalid_string,
          message: ta.message
        }), Ui.dirty());
      else if (ta.kind === "ulid")
        He$2.test(e.data) || (Zi = this._getOrReturnCtx(e, Zi), u(Zi, {
          validation: "ulid",
          code: d$3.invalid_string,
          message: ta.message
        }), Ui.dirty());
      else if (ta.kind === "url")
        try {
          new URL(e.data);
        } catch {
          Zi = this._getOrReturnCtx(e, Zi), u(Zi, {
            validation: "url",
            code: d$3.invalid_string,
            message: ta.message
          }), Ui.dirty();
        }
      else ta.kind === "regex" ? (ta.regex.lastIndex = 0, ta.regex.test(e.data) || (Zi = this._getOrReturnCtx(e, Zi), u(Zi, {
        validation: "regex",
        code: d$3.invalid_string,
        message: ta.message
      }), Ui.dirty())) : ta.kind === "trim" ? e.data = e.data.trim() : ta.kind === "includes" ? e.data.includes(ta.value, ta.position) || (Zi = this._getOrReturnCtx(e, Zi), u(Zi, {
        code: d$3.invalid_string,
        validation: { includes: ta.value, position: ta.position },
        message: ta.message
      }), Ui.dirty()) : ta.kind === "toLowerCase" ? e.data = e.data.toLowerCase() : ta.kind === "toUpperCase" ? e.data = e.data.toUpperCase() : ta.kind === "startsWith" ? e.data.startsWith(ta.value) || (Zi = this._getOrReturnCtx(e, Zi), u(Zi, {
        code: d$3.invalid_string,
        validation: { startsWith: ta.value },
        message: ta.message
      }), Ui.dirty()) : ta.kind === "endsWith" ? e.data.endsWith(ta.value) || (Zi = this._getOrReturnCtx(e, Zi), u(Zi, {
        code: d$3.invalid_string,
        validation: { endsWith: ta.value },
        message: ta.message
      }), Ui.dirty()) : ta.kind === "datetime" ? De$1(ta).test(e.data) || (Zi = this._getOrReturnCtx(e, Zi), u(Zi, {
        code: d$3.invalid_string,
        validation: "datetime",
        message: ta.message
      }), Ui.dirty()) : ta.kind === "date" ? dt$2.test(e.data) || (Zi = this._getOrReturnCtx(e, Zi), u(Zi, {
        code: d$3.invalid_string,
        validation: "date",
        message: ta.message
      }), Ui.dirty()) : ta.kind === "time" ? lt$2(ta).test(e.data) || (Zi = this._getOrReturnCtx(e, Zi), u(Zi, {
        code: d$3.invalid_string,
        validation: "time",
        message: ta.message
      }), Ui.dirty()) : ta.kind === "duration" ? et$2.test(e.data) || (Zi = this._getOrReturnCtx(e, Zi), u(Zi, {
        validation: "duration",
        code: d$3.invalid_string,
        message: ta.message
      }), Ui.dirty()) : ta.kind === "ip" ? ut$1(e.data, ta.version) || (Zi = this._getOrReturnCtx(e, Zi), u(Zi, {
        validation: "ip",
        code: d$3.invalid_string,
        message: ta.message
      }), Ui.dirty()) : ta.kind === "jwt" ? ht$2(e.data, ta.alg) || (Zi = this._getOrReturnCtx(e, Zi), u(Zi, {
        validation: "jwt",
        code: d$3.invalid_string,
        message: ta.message
      }), Ui.dirty()) : ta.kind === "cidr" ? ft$2(e.data, ta.version) || (Zi = this._getOrReturnCtx(e, Zi), u(Zi, {
        validation: "cidr",
        code: d$3.invalid_string,
        message: ta.message
      }), Ui.dirty()) : ta.kind === "base64" ? ot$2.test(e.data) || (Zi = this._getOrReturnCtx(e, Zi), u(Zi, {
        validation: "base64",
        code: d$3.invalid_string,
        message: ta.message
      }), Ui.dirty()) : ta.kind === "base64url" ? ct$2.test(e.data) || (Zi = this._getOrReturnCtx(e, Zi), u(Zi, {
        validation: "base64url",
        code: d$3.invalid_string,
        message: ta.message
      }), Ui.dirty()) : b$2.assertNever(ta);
    return { status: Ui.value, value: e.data };
  }
  _regex(e, Ui, Zi) {
    return this.refinement((ta) => e.test(ta), {
      validation: Ui,
      code: d$3.invalid_string,
      ...p$3.errToObj(Zi)
    });
  }
  _addCheck(e) {
    return new zd({
      ...this._def,
      checks: [...this._def.checks, e]
    });
  }
  email(e) {
    return this._addCheck({ kind: "email", ...p$3.errToObj(e) });
  }
  url(e) {
    return this._addCheck({ kind: "url", ...p$3.errToObj(e) });
  }
  emoji(e) {
    return this._addCheck({ kind: "emoji", ...p$3.errToObj(e) });
  }
  uuid(e) {
    return this._addCheck({ kind: "uuid", ...p$3.errToObj(e) });
  }
  nanoid(e) {
    return this._addCheck({ kind: "nanoid", ...p$3.errToObj(e) });
  }
  cuid(e) {
    return this._addCheck({ kind: "cuid", ...p$3.errToObj(e) });
  }
  cuid2(e) {
    return this._addCheck({ kind: "cuid2", ...p$3.errToObj(e) });
  }
  ulid(e) {
    return this._addCheck({ kind: "ulid", ...p$3.errToObj(e) });
  }
  base64(e) {
    return this._addCheck({ kind: "base64", ...p$3.errToObj(e) });
  }
  base64url(e) {
    return this._addCheck({
      kind: "base64url",
      ...p$3.errToObj(e)
    });
  }
  jwt(e) {
    return this._addCheck({ kind: "jwt", ...p$3.errToObj(e) });
  }
  ip(e) {
    return this._addCheck({ kind: "ip", ...p$3.errToObj(e) });
  }
  cidr(e) {
    return this._addCheck({ kind: "cidr", ...p$3.errToObj(e) });
  }
  datetime(e) {
    var Ui, Zi;
    return typeof e == "string" ? this._addCheck({
      kind: "datetime",
      precision: null,
      offset: !1,
      local: !1,
      message: e
    }) : this._addCheck({
      kind: "datetime",
      precision: typeof e?.precision > "u" ? null : e?.precision,
      offset: (Ui = e?.offset) !== null && Ui !== void 0 ? Ui : !1,
      local: (Zi = e?.local) !== null && Zi !== void 0 ? Zi : !1,
      ...p$3.errToObj(e?.message)
    });
  }
  date(e) {
    return this._addCheck({ kind: "date", message: e });
  }
  time(e) {
    return typeof e == "string" ? this._addCheck({
      kind: "time",
      precision: null,
      message: e
    }) : this._addCheck({
      kind: "time",
      precision: typeof e?.precision > "u" ? null : e?.precision,
      ...p$3.errToObj(e?.message)
    });
  }
  duration(e) {
    return this._addCheck({ kind: "duration", ...p$3.errToObj(e) });
  }
  regex(e, Ui) {
    return this._addCheck({
      kind: "regex",
      regex: e,
      ...p$3.errToObj(Ui)
    });
  }
  includes(e, Ui) {
    return this._addCheck({
      kind: "includes",
      value: e,
      position: Ui?.position,
      ...p$3.errToObj(Ui?.message)
    });
  }
  startsWith(e, Ui) {
    return this._addCheck({
      kind: "startsWith",
      value: e,
      ...p$3.errToObj(Ui)
    });
  }
  endsWith(e, Ui) {
    return this._addCheck({
      kind: "endsWith",
      value: e,
      ...p$3.errToObj(Ui)
    });
  }
  min(e, Ui) {
    return this._addCheck({
      kind: "min",
      value: e,
      ...p$3.errToObj(Ui)
    });
  }
  max(e, Ui) {
    return this._addCheck({
      kind: "max",
      value: e,
      ...p$3.errToObj(Ui)
    });
  }
  length(e, Ui) {
    return this._addCheck({
      kind: "length",
      value: e,
      ...p$3.errToObj(Ui)
    });
  }
  /**
   * Equivalent to `.min(1)`
   */
  nonempty(e) {
    return this.min(1, p$3.errToObj(e));
  }
  trim() {
    return new zd({
      ...this._def,
      checks: [...this._def.checks, { kind: "trim" }]
    });
  }
  toLowerCase() {
    return new zd({
      ...this._def,
      checks: [...this._def.checks, { kind: "toLowerCase" }]
    });
  }
  toUpperCase() {
    return new zd({
      ...this._def,
      checks: [...this._def.checks, { kind: "toUpperCase" }]
    });
  }
  get isDatetime() {
    return !!this._def.checks.find((e) => e.kind === "datetime");
  }
  get isDate() {
    return !!this._def.checks.find((e) => e.kind === "date");
  }
  get isTime() {
    return !!this._def.checks.find((e) => e.kind === "time");
  }
  get isDuration() {
    return !!this._def.checks.find((e) => e.kind === "duration");
  }
  get isEmail() {
    return !!this._def.checks.find((e) => e.kind === "email");
  }
  get isURL() {
    return !!this._def.checks.find((e) => e.kind === "url");
  }
  get isEmoji() {
    return !!this._def.checks.find((e) => e.kind === "emoji");
  }
  get isUUID() {
    return !!this._def.checks.find((e) => e.kind === "uuid");
  }
  get isNANOID() {
    return !!this._def.checks.find((e) => e.kind === "nanoid");
  }
  get isCUID() {
    return !!this._def.checks.find((e) => e.kind === "cuid");
  }
  get isCUID2() {
    return !!this._def.checks.find((e) => e.kind === "cuid2");
  }
  get isULID() {
    return !!this._def.checks.find((e) => e.kind === "ulid");
  }
  get isIP() {
    return !!this._def.checks.find((e) => e.kind === "ip");
  }
  get isCIDR() {
    return !!this._def.checks.find((e) => e.kind === "cidr");
  }
  get isBase64() {
    return !!this._def.checks.find((e) => e.kind === "base64");
  }
  get isBase64url() {
    return !!this._def.checks.find((e) => e.kind === "base64url");
  }
  get minLength() {
    let e = null;
    for (const Ui of this._def.checks)
      Ui.kind === "min" && (e === null || Ui.value > e) && (e = Ui.value);
    return e;
  }
  get maxLength() {
    let e = null;
    for (const Ui of this._def.checks)
      Ui.kind === "max" && (e === null || Ui.value < e) && (e = Ui.value);
    return e;
  }
};
C$2.create = (Bi) => {
  var e;
  return new C$2({
    checks: [],
    typeName: g$3.ZodString,
    coerce: (e = Bi?.coerce) !== null && e !== void 0 ? e : !1,
    ..._(Bi)
  });
};
function pt$2(Bi, e) {
  const Ui = (Bi.toString().split(".")[1] || "").length, Zi = (e.toString().split(".")[1] || "").length, ta = Ui > Zi ? Ui : Zi, na = parseInt(Bi.toFixed(ta).replace(".", "")), ia = parseInt(e.toFixed(ta).replace(".", ""));
  return na % ia / Math.pow(10, ta);
}
let M$2 = class tf extends v {
  constructor() {
    super(...arguments), this.min = this.gte, this.max = this.lte, this.step = this.multipleOf;
  }
  _parse(e) {
    if (this._def.coerce && (e.data = Number(e.data)), this._getType(e) !== f$6.number) {
      const ta = this._getOrReturnCtx(e);
      return u(ta, {
        code: d$3.invalid_type,
        expected: f$6.number,
        received: ta.parsedType
      }), y$3;
    }
    let Ui;
    const Zi = new k();
    for (const ta of this._def.checks)
      ta.kind === "int" ? b$2.isInteger(e.data) || (Ui = this._getOrReturnCtx(e, Ui), u(Ui, {
        code: d$3.invalid_type,
        expected: "integer",
        received: "float",
        message: ta.message
      }), Zi.dirty()) : ta.kind === "min" ? (ta.inclusive ? e.data < ta.value : e.data <= ta.value) && (Ui = this._getOrReturnCtx(e, Ui), u(Ui, {
        code: d$3.too_small,
        minimum: ta.value,
        type: "number",
        inclusive: ta.inclusive,
        exact: !1,
        message: ta.message
      }), Zi.dirty()) : ta.kind === "max" ? (ta.inclusive ? e.data > ta.value : e.data >= ta.value) && (Ui = this._getOrReturnCtx(e, Ui), u(Ui, {
        code: d$3.too_big,
        maximum: ta.value,
        type: "number",
        inclusive: ta.inclusive,
        exact: !1,
        message: ta.message
      }), Zi.dirty()) : ta.kind === "multipleOf" ? pt$2(e.data, ta.value) !== 0 && (Ui = this._getOrReturnCtx(e, Ui), u(Ui, {
        code: d$3.not_multiple_of,
        multipleOf: ta.value,
        message: ta.message
      }), Zi.dirty()) : ta.kind === "finite" ? Number.isFinite(e.data) || (Ui = this._getOrReturnCtx(e, Ui), u(Ui, {
        code: d$3.not_finite,
        message: ta.message
      }), Zi.dirty()) : b$2.assertNever(ta);
    return { status: Zi.value, value: e.data };
  }
  gte(e, Ui) {
    return this.setLimit("min", e, !0, p$3.toString(Ui));
  }
  gt(e, Ui) {
    return this.setLimit("min", e, !1, p$3.toString(Ui));
  }
  lte(e, Ui) {
    return this.setLimit("max", e, !0, p$3.toString(Ui));
  }
  lt(e, Ui) {
    return this.setLimit("max", e, !1, p$3.toString(Ui));
  }
  setLimit(e, Ui, Zi, ta) {
    return new tf({
      ...this._def,
      checks: [
        ...this._def.checks,
        {
          kind: e,
          value: Ui,
          inclusive: Zi,
          message: p$3.toString(ta)
        }
      ]
    });
  }
  _addCheck(e) {
    return new tf({
      ...this._def,
      checks: [...this._def.checks, e]
    });
  }
  int(e) {
    return this._addCheck({
      kind: "int",
      message: p$3.toString(e)
    });
  }
  positive(e) {
    return this._addCheck({
      kind: "min",
      value: 0,
      inclusive: !1,
      message: p$3.toString(e)
    });
  }
  negative(e) {
    return this._addCheck({
      kind: "max",
      value: 0,
      inclusive: !1,
      message: p$3.toString(e)
    });
  }
  nonpositive(e) {
    return this._addCheck({
      kind: "max",
      value: 0,
      inclusive: !0,
      message: p$3.toString(e)
    });
  }
  nonnegative(e) {
    return this._addCheck({
      kind: "min",
      value: 0,
      inclusive: !0,
      message: p$3.toString(e)
    });
  }
  multipleOf(e, Ui) {
    return this._addCheck({
      kind: "multipleOf",
      value: e,
      message: p$3.toString(Ui)
    });
  }
  finite(e) {
    return this._addCheck({
      kind: "finite",
      message: p$3.toString(e)
    });
  }
  safe(e) {
    return this._addCheck({
      kind: "min",
      inclusive: !0,
      value: Number.MIN_SAFE_INTEGER,
      message: p$3.toString(e)
    })._addCheck({
      kind: "max",
      inclusive: !0,
      value: Number.MAX_SAFE_INTEGER,
      message: p$3.toString(e)
    });
  }
  get minValue() {
    let e = null;
    for (const Ui of this._def.checks)
      Ui.kind === "min" && (e === null || Ui.value > e) && (e = Ui.value);
    return e;
  }
  get maxValue() {
    let e = null;
    for (const Ui of this._def.checks)
      Ui.kind === "max" && (e === null || Ui.value < e) && (e = Ui.value);
    return e;
  }
  get isInt() {
    return !!this._def.checks.find((e) => e.kind === "int" || e.kind === "multipleOf" && b$2.isInteger(e.value));
  }
  get isFinite() {
    let e = null, Ui = null;
    for (const Zi of this._def.checks) {
      if (Zi.kind === "finite" || Zi.kind === "int" || Zi.kind === "multipleOf")
        return !0;
      Zi.kind === "min" ? (Ui === null || Zi.value > Ui) && (Ui = Zi.value) : Zi.kind === "max" && (e === null || Zi.value < e) && (e = Zi.value);
    }
    return Number.isFinite(Ui) && Number.isFinite(e);
  }
};
M$2.create = (Bi) => new M$2({
  checks: [],
  typeName: g$3.ZodNumber,
  coerce: Bi?.coerce || !1,
  ..._(Bi)
});
let D$1 = class rf extends v {
  constructor() {
    super(...arguments), this.min = this.gte, this.max = this.lte;
  }
  _parse(e) {
    if (this._def.coerce)
      try {
        e.data = BigInt(e.data);
      } catch {
        return this._getInvalidInput(e);
      }
    if (this._getType(e) !== f$6.bigint)
      return this._getInvalidInput(e);
    let Ui;
    const Zi = new k();
    for (const ta of this._def.checks)
      ta.kind === "min" ? (ta.inclusive ? e.data < ta.value : e.data <= ta.value) && (Ui = this._getOrReturnCtx(e, Ui), u(Ui, {
        code: d$3.too_small,
        type: "bigint",
        minimum: ta.value,
        inclusive: ta.inclusive,
        message: ta.message
      }), Zi.dirty()) : ta.kind === "max" ? (ta.inclusive ? e.data > ta.value : e.data >= ta.value) && (Ui = this._getOrReturnCtx(e, Ui), u(Ui, {
        code: d$3.too_big,
        type: "bigint",
        maximum: ta.value,
        inclusive: ta.inclusive,
        message: ta.message
      }), Zi.dirty()) : ta.kind === "multipleOf" ? e.data % ta.value !== BigInt(0) && (Ui = this._getOrReturnCtx(e, Ui), u(Ui, {
        code: d$3.not_multiple_of,
        multipleOf: ta.value,
        message: ta.message
      }), Zi.dirty()) : b$2.assertNever(ta);
    return { status: Zi.value, value: e.data };
  }
  _getInvalidInput(e) {
    const Ui = this._getOrReturnCtx(e);
    return u(Ui, {
      code: d$3.invalid_type,
      expected: f$6.bigint,
      received: Ui.parsedType
    }), y$3;
  }
  gte(e, Ui) {
    return this.setLimit("min", e, !0, p$3.toString(Ui));
  }
  gt(e, Ui) {
    return this.setLimit("min", e, !1, p$3.toString(Ui));
  }
  lte(e, Ui) {
    return this.setLimit("max", e, !0, p$3.toString(Ui));
  }
  lt(e, Ui) {
    return this.setLimit("max", e, !1, p$3.toString(Ui));
  }
  setLimit(e, Ui, Zi, ta) {
    return new rf({
      ...this._def,
      checks: [
        ...this._def.checks,
        {
          kind: e,
          value: Ui,
          inclusive: Zi,
          message: p$3.toString(ta)
        }
      ]
    });
  }
  _addCheck(e) {
    return new rf({
      ...this._def,
      checks: [...this._def.checks, e]
    });
  }
  positive(e) {
    return this._addCheck({
      kind: "min",
      value: BigInt(0),
      inclusive: !1,
      message: p$3.toString(e)
    });
  }
  negative(e) {
    return this._addCheck({
      kind: "max",
      value: BigInt(0),
      inclusive: !1,
      message: p$3.toString(e)
    });
  }
  nonpositive(e) {
    return this._addCheck({
      kind: "max",
      value: BigInt(0),
      inclusive: !0,
      message: p$3.toString(e)
    });
  }
  nonnegative(e) {
    return this._addCheck({
      kind: "min",
      value: BigInt(0),
      inclusive: !0,
      message: p$3.toString(e)
    });
  }
  multipleOf(e, Ui) {
    return this._addCheck({
      kind: "multipleOf",
      value: e,
      message: p$3.toString(Ui)
    });
  }
  get minValue() {
    let e = null;
    for (const Ui of this._def.checks)
      Ui.kind === "min" && (e === null || Ui.value > e) && (e = Ui.value);
    return e;
  }
  get maxValue() {
    let e = null;
    for (const Ui of this._def.checks)
      Ui.kind === "max" && (e === null || Ui.value < e) && (e = Ui.value);
    return e;
  }
};
D$1.create = (Bi) => {
  var e;
  return new D$1({
    checks: [],
    typeName: g$3.ZodBigInt,
    coerce: (e = Bi?.coerce) !== null && e !== void 0 ? e : !1,
    ..._(Bi)
  });
};
let Q$2 = class extends v {
  _parse(e) {
    if (this._def.coerce && (e.data = !!e.data), this._getType(e) !== f$6.boolean) {
      const Ui = this._getOrReturnCtx(e);
      return u(Ui, {
        code: d$3.invalid_type,
        expected: f$6.boolean,
        received: Ui.parsedType
      }), y$3;
    }
    return T$2(e.data);
  }
};
Q$2.create = (Bi) => new Q$2({
  typeName: g$3.ZodBoolean,
  coerce: Bi?.coerce || !1,
  ..._(Bi)
});
let z$1 = class Df extends v {
  _parse(e) {
    if (this._def.coerce && (e.data = new Date(e.data)), this._getType(e) !== f$6.date) {
      const ta = this._getOrReturnCtx(e);
      return u(ta, {
        code: d$3.invalid_type,
        expected: f$6.date,
        received: ta.parsedType
      }), y$3;
    }
    if (isNaN(e.data.getTime())) {
      const ta = this._getOrReturnCtx(e);
      return u(ta, {
        code: d$3.invalid_date
      }), y$3;
    }
    const Ui = new k();
    let Zi;
    for (const ta of this._def.checks)
      ta.kind === "min" ? e.data.getTime() < ta.value && (Zi = this._getOrReturnCtx(e, Zi), u(Zi, {
        code: d$3.too_small,
        message: ta.message,
        inclusive: !0,
        exact: !1,
        minimum: ta.value,
        type: "date"
      }), Ui.dirty()) : ta.kind === "max" ? e.data.getTime() > ta.value && (Zi = this._getOrReturnCtx(e, Zi), u(Zi, {
        code: d$3.too_big,
        message: ta.message,
        inclusive: !0,
        exact: !1,
        maximum: ta.value,
        type: "date"
      }), Ui.dirty()) : b$2.assertNever(ta);
    return {
      status: Ui.value,
      value: new Date(e.data.getTime())
    };
  }
  _addCheck(e) {
    return new Df({
      ...this._def,
      checks: [...this._def.checks, e]
    });
  }
  min(e, Ui) {
    return this._addCheck({
      kind: "min",
      value: e.getTime(),
      message: p$3.toString(Ui)
    });
  }
  max(e, Ui) {
    return this._addCheck({
      kind: "max",
      value: e.getTime(),
      message: p$3.toString(Ui)
    });
  }
  get minDate() {
    let e = null;
    for (const Ui of this._def.checks)
      Ui.kind === "min" && (e === null || Ui.value > e) && (e = Ui.value);
    return e != null ? new Date(e) : null;
  }
  get maxDate() {
    let e = null;
    for (const Ui of this._def.checks)
      Ui.kind === "max" && (e === null || Ui.value < e) && (e = Ui.value);
    return e != null ? new Date(e) : null;
  }
};
z$1.create = (Bi) => new z$1({
  checks: [],
  coerce: Bi?.coerce || !1,
  typeName: g$3.ZodDate,
  ..._(Bi)
});
let ge$2 = class extends v {
  _parse(e) {
    if (this._getType(e) !== f$6.symbol) {
      const Ui = this._getOrReturnCtx(e);
      return u(Ui, {
        code: d$3.invalid_type,
        expected: f$6.symbol,
        received: Ui.parsedType
      }), y$3;
    }
    return T$2(e.data);
  }
};
ge$2.create = (Bi) => new ge$2({
  typeName: g$3.ZodSymbol,
  ..._(Bi)
});
let ee$2 = class extends v {
  _parse(e) {
    if (this._getType(e) !== f$6.undefined) {
      const Ui = this._getOrReturnCtx(e);
      return u(Ui, {
        code: d$3.invalid_type,
        expected: f$6.undefined,
        received: Ui.parsedType
      }), y$3;
    }
    return T$2(e.data);
  }
};
ee$2.create = (Bi) => new ee$2({
  typeName: g$3.ZodUndefined,
  ..._(Bi)
});
let te$2 = class extends v {
  _parse(e) {
    if (this._getType(e) !== f$6.null) {
      const Ui = this._getOrReturnCtx(e);
      return u(Ui, {
        code: d$3.invalid_type,
        expected: f$6.null,
        received: Ui.parsedType
      }), y$3;
    }
    return T$2(e.data);
  }
};
te$2.create = (Bi) => new te$2({
  typeName: g$3.ZodNull,
  ..._(Bi)
});
let Y$2 = class extends v {
  constructor() {
    super(...arguments), this._any = !0;
  }
  _parse(e) {
    return T$2(e.data);
  }
};
Y$2.create = (Bi) => new Y$2({
  typeName: g$3.ZodAny,
  ..._(Bi)
});
let L$2 = class extends v {
  constructor() {
    super(...arguments), this._unknown = !0;
  }
  _parse(e) {
    return T$2(e.data);
  }
};
L$2.create = (Bi) => new L$2({
  typeName: g$3.ZodUnknown,
  ..._(Bi)
});
let I$2 = class extends v {
  _parse(e) {
    const Ui = this._getOrReturnCtx(e);
    return u(Ui, {
      code: d$3.invalid_type,
      expected: f$6.never,
      received: Ui.parsedType
    }), y$3;
  }
};
I$2.create = (Bi) => new I$2({
  typeName: g$3.ZodNever,
  ..._(Bi)
});
let ye$2 = class extends v {
  _parse(e) {
    if (this._getType(e) !== f$6.undefined) {
      const Ui = this._getOrReturnCtx(e);
      return u(Ui, {
        code: d$3.invalid_type,
        expected: f$6.void,
        received: Ui.parsedType
      }), y$3;
    }
    return T$2(e.data);
  }
};
ye$2.create = (Bi) => new ye$2({
  typeName: g$3.ZodVoid,
  ..._(Bi)
});
let Z$2 = class qd extends v {
  _parse(e) {
    const { ctx: Ui, status: Zi } = this._processInputParams(e), ta = this._def;
    if (Ui.parsedType !== f$6.array)
      return u(Ui, {
        code: d$3.invalid_type,
        expected: f$6.array,
        received: Ui.parsedType
      }), y$3;
    if (ta.exactLength !== null) {
      const ia = Ui.data.length > ta.exactLength.value, aa = Ui.data.length < ta.exactLength.value;
      (ia || aa) && (u(Ui, {
        code: ia ? d$3.too_big : d$3.too_small,
        minimum: aa ? ta.exactLength.value : void 0,
        maximum: ia ? ta.exactLength.value : void 0,
        type: "array",
        inclusive: !0,
        exact: !0,
        message: ta.exactLength.message
      }), Zi.dirty());
    }
    if (ta.minLength !== null && Ui.data.length < ta.minLength.value && (u(Ui, {
      code: d$3.too_small,
      minimum: ta.minLength.value,
      type: "array",
      inclusive: !0,
      exact: !1,
      message: ta.minLength.message
    }), Zi.dirty()), ta.maxLength !== null && Ui.data.length > ta.maxLength.value && (u(Ui, {
      code: d$3.too_big,
      maximum: ta.maxLength.value,
      type: "array",
      inclusive: !0,
      exact: !1,
      message: ta.maxLength.message
    }), Zi.dirty()), Ui.common.async)
      return Promise.all([...Ui.data].map((ia, aa) => ta.type._parseAsync(new O$2(Ui, ia, Ui.path, aa)))).then((ia) => k.mergeArray(Zi, ia));
    const na = [...Ui.data].map((ia, aa) => ta.type._parseSync(new O$2(Ui, ia, Ui.path, aa)));
    return k.mergeArray(Zi, na);
  }
  get element() {
    return this._def.type;
  }
  min(e, Ui) {
    return new qd({
      ...this._def,
      minLength: { value: e, message: p$3.toString(Ui) }
    });
  }
  max(e, Ui) {
    return new qd({
      ...this._def,
      maxLength: { value: e, message: p$3.toString(Ui) }
    });
  }
  length(e, Ui) {
    return new qd({
      ...this._def,
      exactLength: { value: e, message: p$3.toString(Ui) }
    });
  }
  nonempty(e) {
    return this.min(1, e);
  }
};
Z$2.create = (Bi, e) => new Z$2({
  type: Bi,
  minLength: null,
  maxLength: null,
  exactLength: null,
  typeName: g$3.ZodArray,
  ..._(e)
});
function B$2(Bi) {
  if (Bi instanceof x$2) {
    const e = {};
    for (const Ui in Bi.shape) {
      const Zi = Bi.shape[Ui];
      e[Ui] = j$1.create(B$2(Zi));
    }
    return new x$2({
      ...Bi._def,
      shape: () => e
    });
  } else return Bi instanceof Z$2 ? new Z$2({
    ...Bi._def,
    type: B$2(Bi.element)
  }) : Bi instanceof j$1 ? j$1.create(B$2(Bi.unwrap())) : Bi instanceof $$1 ? $$1.create(B$2(Bi.unwrap())) : Bi instanceof R$2 ? R$2.create(Bi.items.map((e) => B$2(e))) : Bi;
}
let x$2 = class Od extends v {
  constructor() {
    super(...arguments), this._cached = null, this.nonstrict = this.passthrough, this.augment = this.extend;
  }
  _getCached() {
    if (this._cached !== null)
      return this._cached;
    const e = this._def.shape(), Ui = b$2.objectKeys(e);
    return this._cached = { shape: e, keys: Ui };
  }
  _parse(e) {
    if (this._getType(e) !== f$6.object) {
      const da = this._getOrReturnCtx(e);
      return u(da, {
        code: d$3.invalid_type,
        expected: f$6.object,
        received: da.parsedType
      }), y$3;
    }
    const { status: Ui, ctx: Zi } = this._processInputParams(e), { shape: ta, keys: na } = this._getCached(), ia = [];
    if (!(this._def.catchall instanceof I$2 && this._def.unknownKeys === "strip"))
      for (const da in Zi.data)
        na.includes(da) || ia.push(da);
    const aa = [];
    for (const da of na) {
      const La = ta[da], qa = Zi.data[da];
      aa.push({
        key: { status: "valid", value: da },
        value: La._parse(new O$2(Zi, qa, Zi.path, da)),
        alwaysSet: da in Zi.data
      });
    }
    if (this._def.catchall instanceof I$2) {
      const da = this._def.unknownKeys;
      if (da === "passthrough")
        for (const La of ia)
          aa.push({
            key: { status: "valid", value: La },
            value: { status: "valid", value: Zi.data[La] }
          });
      else if (da === "strict")
        ia.length > 0 && (u(Zi, {
          code: d$3.unrecognized_keys,
          keys: ia
        }), Ui.dirty());
      else if (da !== "strip") throw new Error("Internal ZodObject error: invalid unknownKeys value.");
    } else {
      const da = this._def.catchall;
      for (const La of ia) {
        const qa = Zi.data[La];
        aa.push({
          key: { status: "valid", value: La },
          value: da._parse(
            new O$2(Zi, qa, Zi.path, La)
            //, ctx.child(key), value, getParsedType(value)
          ),
          alwaysSet: La in Zi.data
        });
      }
    }
    return Zi.common.async ? Promise.resolve().then(async () => {
      const da = [];
      for (const La of aa) {
        const qa = await La.key, io = await La.value;
        da.push({
          key: qa,
          value: io,
          alwaysSet: La.alwaysSet
        });
      }
      return da;
    }).then((da) => k.mergeObjectSync(Ui, da)) : k.mergeObjectSync(Ui, aa);
  }
  get shape() {
    return this._def.shape();
  }
  strict(e) {
    return p$3.errToObj, new Od({
      ...this._def,
      unknownKeys: "strict",
      ...e !== void 0 ? {
        errorMap: (Ui, Zi) => {
          var ta, na, ia, aa;
          const da = (ia = (na = (ta = this._def).errorMap) === null || na === void 0 ? void 0 : na.call(ta, Ui, Zi).message) !== null && ia !== void 0 ? ia : Zi.defaultError;
          return Ui.code === "unrecognized_keys" ? {
            message: (aa = p$3.errToObj(e).message) !== null && aa !== void 0 ? aa : da
          } : {
            message: da
          };
        }
      } : {}
    });
  }
  strip() {
    return new Od({
      ...this._def,
      unknownKeys: "strip"
    });
  }
  passthrough() {
    return new Od({
      ...this._def,
      unknownKeys: "passthrough"
    });
  }
  // const AugmentFactory =
  //   <Def extends ZodObjectDef>(def: Def) =>
  //   <Augmentation extends ZodRawShape>(
  //     augmentation: Augmentation
  //   ): ZodObject<
  //     extendShape<ReturnType<Def["shape"]>, Augmentation>,
  //     Def["unknownKeys"],
  //     Def["catchall"]
  //   > => {
  //     return new ZodObject({
  //       ...def,
  //       shape: () => ({
  //         ...def.shape(),
  //         ...augmentation,
  //       }),
  //     }) as any;
  //   };
  extend(e) {
    return new Od({
      ...this._def,
      shape: () => ({
        ...this._def.shape(),
        ...e
      })
    });
  }
  /**
   * Prior to zod@1.0.12 there was a bug in the
   * inferred type of merged objects. Please
   * upgrade if you are experiencing issues.
   */
  merge(e) {
    return new Od({
      unknownKeys: e._def.unknownKeys,
      catchall: e._def.catchall,
      shape: () => ({
        ...this._def.shape(),
        ...e._def.shape()
      }),
      typeName: g$3.ZodObject
    });
  }
  // merge<
  //   Incoming extends AnyZodObject,
  //   Augmentation extends Incoming["shape"],
  //   NewOutput extends {
  //     [k in keyof Augmentation | keyof Output]: k extends keyof Augmentation
  //       ? Augmentation[k]["_output"]
  //       : k extends keyof Output
  //       ? Output[k]
  //       : never;
  //   },
  //   NewInput extends {
  //     [k in keyof Augmentation | keyof Input]: k extends keyof Augmentation
  //       ? Augmentation[k]["_input"]
  //       : k extends keyof Input
  //       ? Input[k]
  //       : never;
  //   }
  // >(
  //   merging: Incoming
  // ): ZodObject<
  //   extendShape<T, ReturnType<Incoming["_def"]["shape"]>>,
  //   Incoming["_def"]["unknownKeys"],
  //   Incoming["_def"]["catchall"],
  //   NewOutput,
  //   NewInput
  // > {
  //   const merged: any = new ZodObject({
  //     unknownKeys: merging._def.unknownKeys,
  //     catchall: merging._def.catchall,
  //     shape: () =>
  //       objectUtil.mergeShapes(this._def.shape(), merging._def.shape()),
  //     typeName: ZodFirstPartyTypeKind.ZodObject,
  //   }) as any;
  //   return merged;
  // }
  setKey(e, Ui) {
    return this.augment({ [e]: Ui });
  }
  // merge<Incoming extends AnyZodObject>(
  //   merging: Incoming
  // ): //ZodObject<T & Incoming["_shape"], UnknownKeys, Catchall> = (merging) => {
  // ZodObject<
  //   extendShape<T, ReturnType<Incoming["_def"]["shape"]>>,
  //   Incoming["_def"]["unknownKeys"],
  //   Incoming["_def"]["catchall"]
  // > {
  //   // const mergedShape = objectUtil.mergeShapes(
  //   //   this._def.shape(),
  //   //   merging._def.shape()
  //   // );
  //   const merged: any = new ZodObject({
  //     unknownKeys: merging._def.unknownKeys,
  //     catchall: merging._def.catchall,
  //     shape: () =>
  //       objectUtil.mergeShapes(this._def.shape(), merging._def.shape()),
  //     typeName: ZodFirstPartyTypeKind.ZodObject,
  //   }) as any;
  //   return merged;
  // }
  catchall(e) {
    return new Od({
      ...this._def,
      catchall: e
    });
  }
  pick(e) {
    const Ui = {};
    return b$2.objectKeys(e).forEach((Zi) => {
      e[Zi] && this.shape[Zi] && (Ui[Zi] = this.shape[Zi]);
    }), new Od({
      ...this._def,
      shape: () => Ui
    });
  }
  omit(e) {
    const Ui = {};
    return b$2.objectKeys(this.shape).forEach((Zi) => {
      e[Zi] || (Ui[Zi] = this.shape[Zi]);
    }), new Od({
      ...this._def,
      shape: () => Ui
    });
  }
  /**
   * @deprecated
   */
  deepPartial() {
    return B$2(this);
  }
  partial(e) {
    const Ui = {};
    return b$2.objectKeys(this.shape).forEach((Zi) => {
      const ta = this.shape[Zi];
      e && !e[Zi] ? Ui[Zi] = ta : Ui[Zi] = ta.optional();
    }), new Od({
      ...this._def,
      shape: () => Ui
    });
  }
  required(e) {
    const Ui = {};
    return b$2.objectKeys(this.shape).forEach((Zi) => {
      if (e && !e[Zi])
        Ui[Zi] = this.shape[Zi];
      else {
        let ta = this.shape[Zi];
        for (; ta instanceof j$1; )
          ta = ta._def.innerType;
        Ui[Zi] = ta;
      }
    }), new Od({
      ...this._def,
      shape: () => Ui
    });
  }
  keyof() {
    return Pe$2(b$2.objectKeys(this.shape));
  }
};
x$2.create = (Bi, e) => new x$2({
  shape: () => Bi,
  unknownKeys: "strip",
  catchall: I$2.create(),
  typeName: g$3.ZodObject,
  ..._(e)
});
x$2.strictCreate = (Bi, e) => new x$2({
  shape: () => Bi,
  unknownKeys: "strict",
  catchall: I$2.create(),
  typeName: g$3.ZodObject,
  ..._(e)
});
x$2.lazycreate = (Bi, e) => new x$2({
  shape: Bi,
  unknownKeys: "strip",
  catchall: I$2.create(),
  typeName: g$3.ZodObject,
  ..._(e)
});
let re$2 = class extends v {
  _parse(e) {
    const { ctx: Ui } = this._processInputParams(e), Zi = this._def.options;
    function ta(na) {
      for (const aa of na)
        if (aa.result.status === "valid")
          return aa.result;
      for (const aa of na)
        if (aa.result.status === "dirty")
          return Ui.common.issues.push(...aa.ctx.common.issues), aa.result;
      const ia = na.map((aa) => new S$1(aa.ctx.common.issues));
      return u(Ui, {
        code: d$3.invalid_union,
        unionErrors: ia
      }), y$3;
    }
    if (Ui.common.async)
      return Promise.all(Zi.map(async (na) => {
        const ia = {
          ...Ui,
          common: {
            ...Ui.common,
            issues: []
          },
          parent: null
        };
        return {
          result: await na._parseAsync({
            data: Ui.data,
            path: Ui.path,
            parent: ia
          }),
          ctx: ia
        };
      })).then(ta);
    {
      let na;
      const ia = [];
      for (const da of Zi) {
        const La = {
          ...Ui,
          common: {
            ...Ui.common,
            issues: []
          },
          parent: null
        }, qa = da._parseSync({
          data: Ui.data,
          path: Ui.path,
          parent: La
        });
        if (qa.status === "valid")
          return qa;
        qa.status === "dirty" && !na && (na = { result: qa, ctx: La }), La.common.issues.length && ia.push(La.common.issues);
      }
      if (na)
        return Ui.common.issues.push(...na.ctx.common.issues), na.result;
      const aa = ia.map((da) => new S$1(da));
      return u(Ui, {
        code: d$3.invalid_union,
        unionErrors: aa
      }), y$3;
    }
  }
  get options() {
    return this._def.options;
  }
};
re$2.create = (Bi, e) => new re$2({
  options: Bi,
  typeName: g$3.ZodUnion,
  ..._(e)
});
const A$2 = (Bi) => Bi instanceof ae$2 ? A$2(Bi.schema) : Bi instanceof E$2 ? A$2(Bi.innerType()) : Bi instanceof ie$1 ? [Bi.value] : Bi instanceof P$3 ? Bi.options : Bi instanceof oe$2 ? b$2.objectValues(Bi.enum) : Bi instanceof ce$2 ? A$2(Bi._def.innerType) : Bi instanceof ee$2 ? [void 0] : Bi instanceof te$2 ? [null] : Bi instanceof j$1 ? [void 0, ...A$2(Bi.unwrap())] : Bi instanceof $$1 ? [null, ...A$2(Bi.unwrap())] : Bi instanceof Ze$2 || Bi instanceof le$1 ? A$2(Bi.unwrap()) : Bi instanceof de$2 ? A$2(Bi._def.innerType) : [];
let be$2 = class Rf extends v {
  _parse(e) {
    const { ctx: Ui } = this._processInputParams(e);
    if (Ui.parsedType !== f$6.object)
      return u(Ui, {
        code: d$3.invalid_type,
        expected: f$6.object,
        received: Ui.parsedType
      }), y$3;
    const Zi = this.discriminator, ta = Ui.data[Zi], na = this.optionsMap.get(ta);
    return na ? Ui.common.async ? na._parseAsync({
      data: Ui.data,
      path: Ui.path,
      parent: Ui
    }) : na._parseSync({
      data: Ui.data,
      path: Ui.path,
      parent: Ui
    }) : (u(Ui, {
      code: d$3.invalid_union_discriminator,
      options: Array.from(this.optionsMap.keys()),
      path: [Zi]
    }), y$3);
  }
  get discriminator() {
    return this._def.discriminator;
  }
  get options() {
    return this._def.options;
  }
  get optionsMap() {
    return this._def.optionsMap;
  }
  /**
   * The constructor of the discriminated union schema. Its behaviour is very similar to that of the normal z.union() constructor.
   * However, it only allows a union of objects, all of which need to share a discriminator property. This property must
   * have a different value for each object in the union.
   * @param discriminator the name of the discriminator property
   * @param types an array of object schemas
   * @param params
   */
  static create(e, Ui, Zi) {
    const ta = /* @__PURE__ */ new Map();
    for (const na of Ui) {
      const ia = A$2(na.shape[e]);
      if (!ia.length)
        throw new Error(`A discriminator value for key \`${e}\` could not be extracted from all schema options`);
      for (const aa of ia) {
        if (ta.has(aa))
          throw new Error(`Discriminator property ${String(e)} has duplicate value ${String(aa)}`);
        ta.set(aa, na);
      }
    }
    return new Rf({
      typeName: g$3.ZodDiscriminatedUnion,
      discriminator: e,
      options: Ui,
      optionsMap: ta,
      ..._(Zi)
    });
  }
};
function Ce$2(Bi, e) {
  const Ui = N$1(Bi), Zi = N$1(e);
  if (Bi === e)
    return { valid: !0, data: Bi };
  if (Ui === f$6.object && Zi === f$6.object) {
    const ta = b$2.objectKeys(e), na = b$2.objectKeys(Bi).filter((aa) => ta.indexOf(aa) !== -1), ia = { ...Bi, ...e };
    for (const aa of na) {
      const da = Ce$2(Bi[aa], e[aa]);
      if (!da.valid)
        return { valid: !1 };
      ia[aa] = da.data;
    }
    return { valid: !0, data: ia };
  } else if (Ui === f$6.array && Zi === f$6.array) {
    if (Bi.length !== e.length)
      return { valid: !1 };
    const ta = [];
    for (let na = 0; na < Bi.length; na++) {
      const ia = Bi[na], aa = e[na], da = Ce$2(ia, aa);
      if (!da.valid)
        return { valid: !1 };
      ta.push(da.data);
    }
    return { valid: !0, data: ta };
  } else return Ui === f$6.date && Zi === f$6.date && +Bi == +e ? { valid: !0, data: Bi } : { valid: !1 };
}
let ne$1 = class extends v {
  _parse(e) {
    const { status: Ui, ctx: Zi } = this._processInputParams(e), ta = (na, ia) => {
      if (Te$2(na) || Te$2(ia))
        return y$3;
      const aa = Ce$2(na.value, ia.value);
      return aa.valid ? ((Se$2(na) || Se$2(ia)) && Ui.dirty(), { status: Ui.value, value: aa.data }) : (u(Zi, {
        code: d$3.invalid_intersection_types
      }), y$3);
    };
    return Zi.common.async ? Promise.all([
      this._def.left._parseAsync({
        data: Zi.data,
        path: Zi.path,
        parent: Zi
      }),
      this._def.right._parseAsync({
        data: Zi.data,
        path: Zi.path,
        parent: Zi
      })
    ]).then(([na, ia]) => ta(na, ia)) : ta(this._def.left._parseSync({
      data: Zi.data,
      path: Zi.path,
      parent: Zi
    }), this._def.right._parseSync({
      data: Zi.data,
      path: Zi.path,
      parent: Zi
    }));
  }
};
ne$1.create = (Bi, e, Ui) => new ne$1({
  left: Bi,
  right: e,
  typeName: g$3.ZodIntersection,
  ..._(Ui)
});
let R$2 = class If extends v {
  _parse(e) {
    const { status: Ui, ctx: Zi } = this._processInputParams(e);
    if (Zi.parsedType !== f$6.array)
      return u(Zi, {
        code: d$3.invalid_type,
        expected: f$6.array,
        received: Zi.parsedType
      }), y$3;
    if (Zi.data.length < this._def.items.length)
      return u(Zi, {
        code: d$3.too_small,
        minimum: this._def.items.length,
        inclusive: !0,
        exact: !1,
        type: "array"
      }), y$3;
    !this._def.rest && Zi.data.length > this._def.items.length && (u(Zi, {
      code: d$3.too_big,
      maximum: this._def.items.length,
      inclusive: !0,
      exact: !1,
      type: "array"
    }), Ui.dirty());
    const ta = [...Zi.data].map((na, ia) => {
      const aa = this._def.items[ia] || this._def.rest;
      return aa ? aa._parse(new O$2(Zi, na, Zi.path, ia)) : null;
    }).filter((na) => !!na);
    return Zi.common.async ? Promise.all(ta).then((na) => k.mergeArray(Ui, na)) : k.mergeArray(Ui, ta);
  }
  get items() {
    return this._def.items;
  }
  rest(e) {
    return new If({
      ...this._def,
      rest: e
    });
  }
};
R$2.create = (Bi, e) => {
  if (!Array.isArray(Bi))
    throw new Error("You must pass an array of schemas to z.tuple([ ... ])");
  return new R$2({
    items: Bi,
    typeName: g$3.ZodTuple,
    rest: null,
    ..._(e)
  });
};
let se$2 = class nf extends v {
  get keySchema() {
    return this._def.keyType;
  }
  get valueSchema() {
    return this._def.valueType;
  }
  _parse(e) {
    const { status: Ui, ctx: Zi } = this._processInputParams(e);
    if (Zi.parsedType !== f$6.object)
      return u(Zi, {
        code: d$3.invalid_type,
        expected: f$6.object,
        received: Zi.parsedType
      }), y$3;
    const ta = [], na = this._def.keyType, ia = this._def.valueType;
    for (const aa in Zi.data)
      ta.push({
        key: na._parse(new O$2(Zi, aa, Zi.path, aa)),
        value: ia._parse(new O$2(Zi, Zi.data[aa], Zi.path, aa)),
        alwaysSet: aa in Zi.data
      });
    return Zi.common.async ? k.mergeObjectAsync(Ui, ta) : k.mergeObjectSync(Ui, ta);
  }
  get element() {
    return this._def.valueType;
  }
  static create(e, Ui, Zi) {
    return Ui instanceof v ? new nf({
      keyType: e,
      valueType: Ui,
      typeName: g$3.ZodRecord,
      ..._(Zi)
    }) : new nf({
      keyType: C$2.create(),
      valueType: e,
      typeName: g$3.ZodRecord,
      ..._(Ui)
    });
  }
}, _e$1 = class extends v {
  get keySchema() {
    return this._def.keyType;
  }
  get valueSchema() {
    return this._def.valueType;
  }
  _parse(e) {
    const { status: Ui, ctx: Zi } = this._processInputParams(e);
    if (Zi.parsedType !== f$6.map)
      return u(Zi, {
        code: d$3.invalid_type,
        expected: f$6.map,
        received: Zi.parsedType
      }), y$3;
    const ta = this._def.keyType, na = this._def.valueType, ia = [...Zi.data.entries()].map(([aa, da], La) => ({
      key: ta._parse(new O$2(Zi, aa, Zi.path, [La, "key"])),
      value: na._parse(new O$2(Zi, da, Zi.path, [La, "value"]))
    }));
    if (Zi.common.async) {
      const aa = /* @__PURE__ */ new Map();
      return Promise.resolve().then(async () => {
        for (const da of ia) {
          const La = await da.key, qa = await da.value;
          if (La.status === "aborted" || qa.status === "aborted")
            return y$3;
          (La.status === "dirty" || qa.status === "dirty") && Ui.dirty(), aa.set(La.value, qa.value);
        }
        return { status: Ui.value, value: aa };
      });
    } else {
      const aa = /* @__PURE__ */ new Map();
      for (const da of ia) {
        const La = da.key, qa = da.value;
        if (La.status === "aborted" || qa.status === "aborted")
          return y$3;
        (La.status === "dirty" || qa.status === "dirty") && Ui.dirty(), aa.set(La.value, qa.value);
      }
      return { status: Ui.value, value: aa };
    }
  }
};
_e$1.create = (Bi, e, Ui) => new _e$1({
  valueType: e,
  keyType: Bi,
  typeName: g$3.ZodMap,
  ..._(Ui)
});
let F$1 = class af extends v {
  _parse(e) {
    const { status: Ui, ctx: Zi } = this._processInputParams(e);
    if (Zi.parsedType !== f$6.set)
      return u(Zi, {
        code: d$3.invalid_type,
        expected: f$6.set,
        received: Zi.parsedType
      }), y$3;
    const ta = this._def;
    ta.minSize !== null && Zi.data.size < ta.minSize.value && (u(Zi, {
      code: d$3.too_small,
      minimum: ta.minSize.value,
      type: "set",
      inclusive: !0,
      exact: !1,
      message: ta.minSize.message
    }), Ui.dirty()), ta.maxSize !== null && Zi.data.size > ta.maxSize.value && (u(Zi, {
      code: d$3.too_big,
      maximum: ta.maxSize.value,
      type: "set",
      inclusive: !0,
      exact: !1,
      message: ta.maxSize.message
    }), Ui.dirty());
    const na = this._def.valueType;
    function ia(da) {
      const La = /* @__PURE__ */ new Set();
      for (const qa of da) {
        if (qa.status === "aborted")
          return y$3;
        qa.status === "dirty" && Ui.dirty(), La.add(qa.value);
      }
      return { status: Ui.value, value: La };
    }
    const aa = [...Zi.data.values()].map((da, La) => na._parse(new O$2(Zi, da, Zi.path, La)));
    return Zi.common.async ? Promise.all(aa).then((da) => ia(da)) : ia(aa);
  }
  min(e, Ui) {
    return new af({
      ...this._def,
      minSize: { value: e, message: p$3.toString(Ui) }
    });
  }
  max(e, Ui) {
    return new af({
      ...this._def,
      maxSize: { value: e, message: p$3.toString(Ui) }
    });
  }
  size(e, Ui) {
    return this.min(e, Ui).max(e, Ui);
  }
  nonempty(e) {
    return this.min(1, e);
  }
};
F$1.create = (Bi, e) => new F$1({
  valueType: Bi,
  minSize: null,
  maxSize: null,
  typeName: g$3.ZodSet,
  ..._(e)
});
let q$1 = class Wd extends v {
  constructor() {
    super(...arguments), this.validate = this.implement;
  }
  _parse(e) {
    const { ctx: Ui } = this._processInputParams(e);
    if (Ui.parsedType !== f$6.function)
      return u(Ui, {
        code: d$3.invalid_type,
        expected: f$6.function,
        received: Ui.parsedType
      }), y$3;
    function Zi(aa, da) {
      return pe$2({
        data: aa,
        path: Ui.path,
        errorMaps: [
          Ui.common.contextualErrorMap,
          Ui.schemaErrorMap,
          fe$2(),
          J$1
        ].filter((La) => !!La),
        issueData: {
          code: d$3.invalid_arguments,
          argumentsError: da
        }
      });
    }
    function ta(aa, da) {
      return pe$2({
        data: aa,
        path: Ui.path,
        errorMaps: [
          Ui.common.contextualErrorMap,
          Ui.schemaErrorMap,
          fe$2(),
          J$1
        ].filter((La) => !!La),
        issueData: {
          code: d$3.invalid_return_type,
          returnTypeError: da
        }
      });
    }
    const na = { errorMap: Ui.common.contextualErrorMap }, ia = Ui.data;
    if (this._def.returns instanceof G$2) {
      const aa = this;
      return T$2(async function(...da) {
        const La = new S$1([]), qa = await aa._def.args.parseAsync(da, na).catch((ao) => {
          throw La.addIssue(Zi(da, ao)), La;
        }), io = await Reflect.apply(ia, this, qa);
        return await aa._def.returns._def.type.parseAsync(io, na).catch((ao) => {
          throw La.addIssue(ta(io, ao)), La;
        });
      });
    } else {
      const aa = this;
      return T$2(function(...da) {
        const La = aa._def.args.safeParse(da, na);
        if (!La.success)
          throw new S$1([Zi(da, La.error)]);
        const qa = Reflect.apply(ia, this, La.data), io = aa._def.returns.safeParse(qa, na);
        if (!io.success)
          throw new S$1([ta(qa, io.error)]);
        return io.data;
      });
    }
  }
  parameters() {
    return this._def.args;
  }
  returnType() {
    return this._def.returns;
  }
  args(...e) {
    return new Wd({
      ...this._def,
      args: R$2.create(e).rest(L$2.create())
    });
  }
  returns(e) {
    return new Wd({
      ...this._def,
      returns: e
    });
  }
  implement(e) {
    return this.parse(e);
  }
  strictImplement(e) {
    return this.parse(e);
  }
  static create(e, Ui, Zi) {
    return new Wd({
      args: e || R$2.create([]).rest(L$2.create()),
      returns: Ui || L$2.create(),
      typeName: g$3.ZodFunction,
      ..._(Zi)
    });
  }
}, ae$2 = class extends v {
  get schema() {
    return this._def.getter();
  }
  _parse(e) {
    const { ctx: Ui } = this._processInputParams(e);
    return this._def.getter()._parse({ data: Ui.data, path: Ui.path, parent: Ui });
  }
};
ae$2.create = (Bi, e) => new ae$2({
  getter: Bi,
  typeName: g$3.ZodLazy,
  ..._(e)
});
let ie$1 = class extends v {
  _parse(e) {
    if (e.data !== this._def.value) {
      const Ui = this._getOrReturnCtx(e);
      return u(Ui, {
        received: Ui.data,
        code: d$3.invalid_literal,
        expected: this._def.value
      }), y$3;
    }
    return { status: "valid", value: e.data };
  }
  get value() {
    return this._def.value;
  }
};
ie$1.create = (Bi, e) => new ie$1({
  value: Bi,
  typeName: g$3.ZodLiteral,
  ..._(e)
});
function Pe$2(Bi, e) {
  return new P$3({
    values: Bi,
    typeName: g$3.ZodEnum,
    ..._(e)
  });
}
let P$3 = class of extends v {
  constructor() {
    super(...arguments), H$3.set(this, void 0);
  }
  _parse(e) {
    if (typeof e.data != "string") {
      const Ui = this._getOrReturnCtx(e), Zi = this._def.values;
      return u(Ui, {
        expected: b$2.joinValues(Zi),
        received: Ui.parsedType,
        code: d$3.invalid_type
      }), y$3;
    }
    if (me$2(this, H$3) || Ne$2(this, H$3, new Set(this._def.values)), !me$2(this, H$3).has(e.data)) {
      const Ui = this._getOrReturnCtx(e), Zi = this._def.values;
      return u(Ui, {
        received: Ui.data,
        code: d$3.invalid_enum_value,
        options: Zi
      }), y$3;
    }
    return T$2(e.data);
  }
  get options() {
    return this._def.values;
  }
  get enum() {
    const e = {};
    for (const Ui of this._def.values)
      e[Ui] = Ui;
    return e;
  }
  get Values() {
    const e = {};
    for (const Ui of this._def.values)
      e[Ui] = Ui;
    return e;
  }
  get Enum() {
    const e = {};
    for (const Ui of this._def.values)
      e[Ui] = Ui;
    return e;
  }
  extract(e, Ui = this._def) {
    return of.create(e, {
      ...this._def,
      ...Ui
    });
  }
  exclude(e, Ui = this._def) {
    return of.create(this.options.filter((Zi) => !e.includes(Zi)), {
      ...this._def,
      ...Ui
    });
  }
};
H$3 = /* @__PURE__ */ new WeakMap();
P$3.create = Pe$2;
let oe$2 = class extends v {
  constructor() {
    super(...arguments), K$1.set(this, void 0);
  }
  _parse(e) {
    const Ui = b$2.getValidEnumValues(this._def.values), Zi = this._getOrReturnCtx(e);
    if (Zi.parsedType !== f$6.string && Zi.parsedType !== f$6.number) {
      const ta = b$2.objectValues(Ui);
      return u(Zi, {
        expected: b$2.joinValues(ta),
        received: Zi.parsedType,
        code: d$3.invalid_type
      }), y$3;
    }
    if (me$2(this, K$1) || Ne$2(this, K$1, new Set(b$2.getValidEnumValues(this._def.values))), !me$2(this, K$1).has(e.data)) {
      const ta = b$2.objectValues(Ui);
      return u(Zi, {
        received: Zi.data,
        code: d$3.invalid_enum_value,
        options: ta
      }), y$3;
    }
    return T$2(e.data);
  }
  get enum() {
    return this._def.values;
  }
};
K$1 = /* @__PURE__ */ new WeakMap();
oe$2.create = (Bi, e) => new oe$2({
  values: Bi,
  typeName: g$3.ZodNativeEnum,
  ..._(e)
});
let G$2 = class extends v {
  unwrap() {
    return this._def.type;
  }
  _parse(e) {
    const { ctx: Ui } = this._processInputParams(e);
    if (Ui.parsedType !== f$6.promise && Ui.common.async === !1)
      return u(Ui, {
        code: d$3.invalid_type,
        expected: f$6.promise,
        received: Ui.parsedType
      }), y$3;
    const Zi = Ui.parsedType === f$6.promise ? Ui.data : Promise.resolve(Ui.data);
    return T$2(Zi.then((ta) => this._def.type.parseAsync(ta, {
      path: Ui.path,
      errorMap: Ui.common.contextualErrorMap
    })));
  }
};
G$2.create = (Bi, e) => new G$2({
  type: Bi,
  typeName: g$3.ZodPromise,
  ..._(e)
});
let E$2 = class extends v {
  innerType() {
    return this._def.schema;
  }
  sourceType() {
    return this._def.schema._def.typeName === g$3.ZodEffects ? this._def.schema.sourceType() : this._def.schema;
  }
  _parse(e) {
    const { status: Ui, ctx: Zi } = this._processInputParams(e), ta = this._def.effect || null, na = {
      addIssue: (ia) => {
        u(Zi, ia), ia.fatal ? Ui.abort() : Ui.dirty();
      },
      get path() {
        return Zi.path;
      }
    };
    if (na.addIssue = na.addIssue.bind(na), ta.type === "preprocess") {
      const ia = ta.transform(Zi.data, na);
      if (Zi.common.async)
        return Promise.resolve(ia).then(async (aa) => {
          if (Ui.value === "aborted")
            return y$3;
          const da = await this._def.schema._parseAsync({
            data: aa,
            path: Zi.path,
            parent: Zi
          });
          return da.status === "aborted" ? y$3 : da.status === "dirty" || Ui.value === "dirty" ? W$2(da.value) : da;
        });
      {
        if (Ui.value === "aborted")
          return y$3;
        const aa = this._def.schema._parseSync({
          data: ia,
          path: Zi.path,
          parent: Zi
        });
        return aa.status === "aborted" ? y$3 : aa.status === "dirty" || Ui.value === "dirty" ? W$2(aa.value) : aa;
      }
    }
    if (ta.type === "refinement") {
      const ia = (aa) => {
        const da = ta.refinement(aa, na);
        if (Zi.common.async)
          return Promise.resolve(da);
        if (da instanceof Promise)
          throw new Error("Async refinement encountered during synchronous parse operation. Use .parseAsync instead.");
        return aa;
      };
      if (Zi.common.async === !1) {
        const aa = this._def.schema._parseSync({
          data: Zi.data,
          path: Zi.path,
          parent: Zi
        });
        return aa.status === "aborted" ? y$3 : (aa.status === "dirty" && Ui.dirty(), ia(aa.value), { status: Ui.value, value: aa.value });
      } else
        return this._def.schema._parseAsync({ data: Zi.data, path: Zi.path, parent: Zi }).then((aa) => aa.status === "aborted" ? y$3 : (aa.status === "dirty" && Ui.dirty(), ia(aa.value).then(() => ({ status: Ui.value, value: aa.value }))));
    }
    if (ta.type === "transform")
      if (Zi.common.async === !1) {
        const ia = this._def.schema._parseSync({
          data: Zi.data,
          path: Zi.path,
          parent: Zi
        });
        if (!V$1(ia))
          return ia;
        const aa = ta.transform(ia.value, na);
        if (aa instanceof Promise)
          throw new Error("Asynchronous transform encountered during synchronous parse operation. Use .parseAsync instead.");
        return { status: Ui.value, value: aa };
      } else
        return this._def.schema._parseAsync({ data: Zi.data, path: Zi.path, parent: Zi }).then((ia) => V$1(ia) ? Promise.resolve(ta.transform(ia.value, na)).then((aa) => ({ status: Ui.value, value: aa })) : ia);
    b$2.assertNever(ta);
  }
};
E$2.create = (Bi, e, Ui) => new E$2({
  schema: Bi,
  typeName: g$3.ZodEffects,
  effect: e,
  ..._(Ui)
});
E$2.createWithPreprocess = (Bi, e, Ui) => new E$2({
  schema: e,
  effect: { type: "preprocess", transform: Bi },
  typeName: g$3.ZodEffects,
  ..._(Ui)
});
let j$1 = class extends v {
  _parse(e) {
    return this._getType(e) === f$6.undefined ? T$2(void 0) : this._def.innerType._parse(e);
  }
  unwrap() {
    return this._def.innerType;
  }
};
j$1.create = (Bi, e) => new j$1({
  innerType: Bi,
  typeName: g$3.ZodOptional,
  ..._(e)
});
let $$1 = class extends v {
  _parse(e) {
    return this._getType(e) === f$6.null ? T$2(null) : this._def.innerType._parse(e);
  }
  unwrap() {
    return this._def.innerType;
  }
};
$$1.create = (Bi, e) => new $$1({
  innerType: Bi,
  typeName: g$3.ZodNullable,
  ..._(e)
});
let ce$2 = class extends v {
  _parse(e) {
    const { ctx: Ui } = this._processInputParams(e);
    let Zi = Ui.data;
    return Ui.parsedType === f$6.undefined && (Zi = this._def.defaultValue()), this._def.innerType._parse({
      data: Zi,
      path: Ui.path,
      parent: Ui
    });
  }
  removeDefault() {
    return this._def.innerType;
  }
};
ce$2.create = (Bi, e) => new ce$2({
  innerType: Bi,
  typeName: g$3.ZodDefault,
  defaultValue: typeof e.default == "function" ? e.default : () => e.default,
  ..._(e)
});
let de$2 = class extends v {
  _parse(e) {
    const { ctx: Ui } = this._processInputParams(e), Zi = {
      ...Ui,
      common: {
        ...Ui.common,
        issues: []
      }
    }, ta = this._def.innerType._parse({
      data: Zi.data,
      path: Zi.path,
      parent: {
        ...Zi
      }
    });
    return X$2(ta) ? ta.then((na) => ({
      status: "valid",
      value: na.status === "valid" ? na.value : this._def.catchValue({
        get error() {
          return new S$1(Zi.common.issues);
        },
        input: Zi.data
      })
    })) : {
      status: "valid",
      value: ta.status === "valid" ? ta.value : this._def.catchValue({
        get error() {
          return new S$1(Zi.common.issues);
        },
        input: Zi.data
      })
    };
  }
  removeCatch() {
    return this._def.innerType;
  }
};
de$2.create = (Bi, e) => new de$2({
  innerType: Bi,
  typeName: g$3.ZodCatch,
  catchValue: typeof e.catch == "function" ? e.catch : () => e.catch,
  ..._(e)
});
let ve$2 = class extends v {
  _parse(e) {
    if (this._getType(e) !== f$6.nan) {
      const Ui = this._getOrReturnCtx(e);
      return u(Ui, {
        code: d$3.invalid_type,
        expected: f$6.nan,
        received: Ui.parsedType
      }), y$3;
    }
    return { status: "valid", value: e.data };
  }
};
ve$2.create = (Bi) => new ve$2({
  typeName: g$3.ZodNaN,
  ..._(Bi)
});
const mt$2 = Symbol("zod_brand");
let Ze$2 = class extends v {
  _parse(e) {
    const { ctx: Ui } = this._processInputParams(e), Zi = Ui.data;
    return this._def.type._parse({
      data: Zi,
      path: Ui.path,
      parent: Ui
    });
  }
  unwrap() {
    return this._def.type;
  }
}, ue$1 = class jf extends v {
  _parse(e) {
    const { status: Ui, ctx: Zi } = this._processInputParams(e);
    if (Zi.common.async)
      return (async () => {
        const ta = await this._def.in._parseAsync({
          data: Zi.data,
          path: Zi.path,
          parent: Zi
        });
        return ta.status === "aborted" ? y$3 : ta.status === "dirty" ? (Ui.dirty(), W$2(ta.value)) : this._def.out._parseAsync({
          data: ta.value,
          path: Zi.path,
          parent: Zi
        });
      })();
    {
      const ta = this._def.in._parseSync({
        data: Zi.data,
        path: Zi.path,
        parent: Zi
      });
      return ta.status === "aborted" ? y$3 : ta.status === "dirty" ? (Ui.dirty(), {
        status: "dirty",
        value: ta.value
      }) : this._def.out._parseSync({
        data: ta.value,
        path: Zi.path,
        parent: Zi
      });
    }
  }
  static create(e, Ui) {
    return new jf({
      in: e,
      out: Ui,
      typeName: g$3.ZodPipeline
    });
  }
}, le$1 = class extends v {
  _parse(e) {
    const Ui = this._def.innerType._parse(e), Zi = (ta) => (V$1(ta) && (ta.value = Object.freeze(ta.value)), ta);
    return X$2(Ui) ? Ui.then((ta) => Zi(ta)) : Zi(Ui);
  }
  unwrap() {
    return this._def.innerType;
  }
};
le$1.create = (Bi, e) => new le$1({
  innerType: Bi,
  typeName: g$3.ZodReadonly,
  ..._(e)
});
function je$2(Bi, e) {
  const Ui = typeof Bi == "function" ? Bi(e) : typeof Bi == "string" ? { message: Bi } : Bi;
  return typeof Ui == "string" ? { message: Ui } : Ui;
}
function $e$1(Bi, e = {}, Ui) {
  return Bi ? Y$2.create().superRefine((Zi, ta) => {
    var na, ia;
    const aa = Bi(Zi);
    if (aa instanceof Promise)
      return aa.then((da) => {
        var La, qa;
        if (!da) {
          const io = je$2(e, Zi), ao = (qa = (La = io.fatal) !== null && La !== void 0 ? La : Ui) !== null && qa !== void 0 ? qa : !0;
          ta.addIssue({ code: "custom", ...io, fatal: ao });
        }
      });
    if (!aa) {
      const da = je$2(e, Zi), La = (ia = (na = da.fatal) !== null && na !== void 0 ? na : Ui) !== null && ia !== void 0 ? ia : !0;
      ta.addIssue({ code: "custom", ...da, fatal: La });
    }
  }) : Y$2.create();
}
const gt$2 = {
  object: x$2.lazycreate
};
var g$3;
(function(Bi) {
  Bi.ZodString = "ZodString", Bi.ZodNumber = "ZodNumber", Bi.ZodNaN = "ZodNaN", Bi.ZodBigInt = "ZodBigInt", Bi.ZodBoolean = "ZodBoolean", Bi.ZodDate = "ZodDate", Bi.ZodSymbol = "ZodSymbol", Bi.ZodUndefined = "ZodUndefined", Bi.ZodNull = "ZodNull", Bi.ZodAny = "ZodAny", Bi.ZodUnknown = "ZodUnknown", Bi.ZodNever = "ZodNever", Bi.ZodVoid = "ZodVoid", Bi.ZodArray = "ZodArray", Bi.ZodObject = "ZodObject", Bi.ZodUnion = "ZodUnion", Bi.ZodDiscriminatedUnion = "ZodDiscriminatedUnion", Bi.ZodIntersection = "ZodIntersection", Bi.ZodTuple = "ZodTuple", Bi.ZodRecord = "ZodRecord", Bi.ZodMap = "ZodMap", Bi.ZodSet = "ZodSet", Bi.ZodFunction = "ZodFunction", Bi.ZodLazy = "ZodLazy", Bi.ZodLiteral = "ZodLiteral", Bi.ZodEnum = "ZodEnum", Bi.ZodEffects = "ZodEffects", Bi.ZodNativeEnum = "ZodNativeEnum", Bi.ZodOptional = "ZodOptional", Bi.ZodNullable = "ZodNullable", Bi.ZodDefault = "ZodDefault", Bi.ZodCatch = "ZodCatch", Bi.ZodPromise = "ZodPromise", Bi.ZodBranded = "ZodBranded", Bi.ZodPipeline = "ZodPipeline", Bi.ZodReadonly = "ZodReadonly";
})(g$3 || (g$3 = {}));
const yt$2 = (Bi, e = {
  message: `Input not instance of ${Bi.name}`
}) => $e$1((Ui) => Ui instanceof Bi, e), Le$2 = C$2.create, Ve$2 = M$2.create, _t$2 = ve$2.create, vt$2 = D$1.create, ze$2 = Q$2.create, bt$2 = z$1.create, xt$2 = ge$2.create, kt$1 = ee$2.create, wt$2 = te$2.create, Tt$1 = Y$2.create, St$2 = L$2.create, Ct$2 = I$2.create, Zt$2 = ye$2.create, Et$2 = Z$2.create, jt$2 = x$2.create, Ot$2 = x$2.strictCreate, Rt$2 = re$2.create, At$2 = be$2.create, Nt$2 = ne$1.create, It$2 = R$2.create, Mt$2 = se$2.create, Dt$2 = _e$1.create, Pt$2 = F$1.create, $t$2 = q$1.create, Lt$2 = ae$2.create, Vt$2 = ie$1.create, zt$2 = P$3.create, Ft$2 = oe$2.create, Ut$2 = G$2.create, Oe$2 = E$2.create, Bt$2 = j$1.create, Wt$2 = $$1.create, qt$2 = E$2.createWithPreprocess, Jt$1 = ue$1.create, Yt$2 = () => Le$2().optional(), Gt$2 = () => Ve$2().optional(), Ht$2 = () => ze$2().optional(), Kt$1 = {
  string: (Bi) => C$2.create({ ...Bi, coerce: !0 }),
  number: (Bi) => M$2.create({ ...Bi, coerce: !0 }),
  boolean: (Bi) => Q$2.create({
    ...Bi,
    coerce: !0
  }),
  bigint: (Bi) => D$1.create({ ...Bi, coerce: !0 }),
  date: (Bi) => z$1.create({ ...Bi, coerce: !0 })
}, Xt$2 = y$3;
var i$6 = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  defaultErrorMap: J$1,
  setErrorMap: qe$2,
  getErrorMap: fe$2,
  makeIssue: pe$2,
  EMPTY_PATH: Je$2,
  addIssueToContext: u,
  ParseStatus: k,
  INVALID: y$3,
  DIRTY: W$2,
  OK: T$2,
  isAborted: Te$2,
  isDirty: Se$2,
  isValid: V$1,
  isAsync: X$2,
  get util() {
    return b$2;
  },
  get objectUtil() {
    return we;
  },
  ZodParsedType: f$6,
  getParsedType: N$1,
  ZodType: v,
  datetimeRegex: De$1,
  ZodString: C$2,
  ZodNumber: M$2,
  ZodBigInt: D$1,
  ZodBoolean: Q$2,
  ZodDate: z$1,
  ZodSymbol: ge$2,
  ZodUndefined: ee$2,
  ZodNull: te$2,
  ZodAny: Y$2,
  ZodUnknown: L$2,
  ZodNever: I$2,
  ZodVoid: ye$2,
  ZodArray: Z$2,
  ZodObject: x$2,
  ZodUnion: re$2,
  ZodDiscriminatedUnion: be$2,
  ZodIntersection: ne$1,
  ZodTuple: R$2,
  ZodRecord: se$2,
  ZodMap: _e$1,
  ZodSet: F$1,
  ZodFunction: q$1,
  ZodLazy: ae$2,
  ZodLiteral: ie$1,
  ZodEnum: P$3,
  ZodNativeEnum: oe$2,
  ZodPromise: G$2,
  ZodEffects: E$2,
  ZodTransformer: E$2,
  ZodOptional: j$1,
  ZodNullable: $$1,
  ZodDefault: ce$2,
  ZodCatch: de$2,
  ZodNaN: ve$2,
  BRAND: mt$2,
  ZodBranded: Ze$2,
  ZodPipeline: ue$1,
  ZodReadonly: le$1,
  custom: $e$1,
  Schema: v,
  ZodSchema: v,
  late: gt$2,
  get ZodFirstPartyTypeKind() {
    return g$3;
  },
  coerce: Kt$1,
  any: Tt$1,
  array: Et$2,
  bigint: vt$2,
  boolean: ze$2,
  date: bt$2,
  discriminatedUnion: At$2,
  effect: Oe$2,
  enum: zt$2,
  function: $t$2,
  instanceof: yt$2,
  intersection: Nt$2,
  lazy: Lt$2,
  literal: Vt$2,
  map: Dt$2,
  nan: _t$2,
  nativeEnum: Ft$2,
  never: Ct$2,
  null: wt$2,
  nullable: Wt$2,
  number: Ve$2,
  object: jt$2,
  oboolean: Ht$2,
  onumber: Gt$2,
  optional: Bt$2,
  ostring: Yt$2,
  pipeline: Jt$1,
  preprocess: qt$2,
  promise: Ut$2,
  record: Mt$2,
  set: Pt$2,
  strictObject: Ot$2,
  string: Le$2,
  symbol: xt$2,
  transformer: Oe$2,
  tuple: It$2,
  undefined: kt$1,
  union: Rt$2,
  unknown: St$2,
  void: Zt$2,
  NEVER: Xt$2,
  ZodIssueCode: d$3,
  quotelessJson: We$2,
  ZodError: S$1
});
const Qt$2 = i$6.object({
  _type: i$6.literal("string"),
  _validation: i$6.string().optional(),
  _value: i$6.string().optional(),
  _optional: i$6.boolean().optional()
}), er$2 = i$6.object({
  _type: i$6.literal("boolean"),
  _value: i$6.boolean().optional(),
  _optional: i$6.boolean().optional()
}), tr$2 = i$6.object({
  _type: i$6.literal("selection"),
  _options: i$6.array(i$6.string()),
  _optional: i$6.boolean().optional(),
  _value: i$6.string().optional()
}), Fe$2 = i$6.object({
  bucketId: i$6.number(),
  isFolder: i$6.boolean(),
  path: i$6.string()
}), rr$1 = i$6.nativeEnum(Re$2), U$1 = i$6.lazy(
  () => i$6.union([
    ar$2,
    nr$2,
    tr$2,
    Qt$2,
    sr$2,
    er$2
  ])
), nr$2 = i$6.object({
  _type: i$6.literal("path"),
  _value: i$6.union([i$6.array(Fe$2), i$6.array(i$6.string())]).optional(),
  // _value: z.array(s3PathSchema).optional(),
  _regexp: i$6.string().optional(),
  _optional: i$6.boolean().optional(),
  _pathType: rr$1
}), sr$2 = i$6.lazy(
  () => i$6.object({
    _type: i$6.literal("list"),
    _value: i$6.array(U$1).optional(),
    _optional: i$6.boolean().optional(),
    _schema: U$1
  })
), ar$2 = i$6.lazy(
  () => i$6.object({
    _type: i$6.literal("object"),
    _optional: i$6.boolean().optional(),
    _fields: i$6.record(U$1),
    _value: i$6.record(U$1).optional()
  })
);
i$6.record(
  i$6.coerce.number(),
  U$1
);
i$6.record(
  i$6.string(),
  U$1
);
const ir$2 = i$6.object({
  type: i$6.literal("pattern"),
  pattern: i$6.string()
}), or$2 = i$6.object({
  type: i$6.literal("value"),
  value: i$6.union([i$6.string(), i$6.number(), i$6.boolean(), i$6.array(Fe$2)])
}), cr$2 = i$6.object({
  type: i$6.literal("code"),
  codeBase64: i$6.string()
}), dr$2 = i$6.union([
  ir$2,
  or$2,
  cr$2
]);
U$1.and(
  i$6.object({
    _actionData: dr$2.optional()
  })
);
const Ue$2 = i$6.object({
  permissions: i$6.string(),
  links: i$6.string(),
  owner: i$6.string(),
  group: i$6.string(),
  size: i$6.string(),
  month: i$6.string(),
  date: i$6.string(),
  yearOrTime: i$6.string(),
  name: i$6.string(),
  fullPath: i$6.string()
}), lr$2 = i$6.array(Ue$2);
i$6.object({
  url: i$6.string()
});
i$6.object({
  socketId: i$6.string(),
  hasSavedSession: i$6.boolean().nullish()
});
i$6.object({
  path: i$6.string()
});
i$6.object({
  directory: i$6.string(),
  contents: lr$2
});
i$6.object({
  syncPwd: i$6.boolean()
});
i$6.object({
  defaultDirectory: i$6.string(),
  termState: i$6.string().nullish()
});
i$6.object({
  path: i$6.string()
});
i$6.object({
  query: i$6.string()
});
i$6.object({
  results: i$6.array(Ue$2),
  date: i$6.string(),
  query: i$6.string()
});
i$6.object({
  tinkerBoxId: i$6.number(),
  rows: i$6.number(),
  cols: i$6.number(),
  syncPwd: i$6.boolean().nullish()
});
i$6.object({
  path: i$6.string()
});
i$6.object({
  path: i$6.string()
});
i$6.object({
  termState: i$6.string()
});
const ur$2 = i$6.object({
  name: i$6.string(),
  type: i$6.literal("select"),
  options: i$6.array(i$6.string()),
  optional: i$6.boolean().optional(),
  allowOther: i$6.boolean().optional(),
  validate: i$6.string().optional(),
  question: i$6.string().optional()
}), hr$2 = i$6.object({
  name: i$6.string(),
  type: i$6.union([i$6.literal("text"), i$6.literal("textarea")]),
  optional: i$6.boolean().optional(),
  validate: i$6.string().optional(),
  question: i$6.string().optional()
}), fr$2 = i$6.object({
  name: i$6.string(),
  type: i$6.literal("email"),
  optional: i$6.boolean().optional(),
  validate: i$6.string().optional(),
  question: i$6.string().optional()
}), pr$2 = i$6.object({
  name: i$6.string(),
  type: i$6.literal("submit"),
  text: i$6.string().optional(),
  optional: i$6.boolean().optional(),
  validate: i$6.string().optional(),
  question: i$6.string().optional()
});
i$6.array(
  i$6.object({
    name: i$6.string(),
    value: i$6.string()
  })
);
const mr$2 = i$6.union([
  ur$2,
  hr$2,
  fr$2,
  pr$2
]);
i$6.array(mr$2);
const gr$2 = i$6.object({
  id: i$6.number(),
  name: i$6.string(),
  labId: i$6.number(),
  status: i$6.string(),
  ipAddress: i$6.string().nullable(),
  lastLogin: i$6.date().nullable()
});
i$6.object({
  tinkerboxes: i$6.array(gr$2)
});
const yr$2 = i$6.object({
  key: i$6.string(),
  name: i$6.string(),
  isFolder: i$6.boolean(),
  bucket: i$6.string(),
  fullPath: i$6.string()
});
i$6.object({
  contents: i$6.array(yr$2)
});
i$6.object({
  buckets: i$6.array(
    i$6.object({
      id: i$6.number().int(),
      bucket: i$6.string(),
      region: i$6.string(),
      prefix: i$6.string().nullish()
    })
  )
});
var niceErrors = {
  0: "Invalid value for configuration 'enforceActions', expected 'never', 'always' or 'observed'",
  1: function(e, Ui) {
    return "Cannot apply '" + e + "' to '" + Ui.toString() + "': Field not found.";
  },
  /*
  2(prop) {
      return `invalid decorator for '${prop.toString()}'`
  },
  3(prop) {
      return `Cannot decorate '${prop.toString()}': action can only be used on properties with a function value.`
  },
  4(prop) {
      return `Cannot decorate '${prop.toString()}': computed can only be used on getter properties.`
  },
  */
  5: "'keys()' can only be used on observable objects, arrays, sets and maps",
  6: "'values()' can only be used on observable objects, arrays, sets and maps",
  7: "'entries()' can only be used on observable objects, arrays and maps",
  8: "'set()' can only be used on observable objects, arrays and maps",
  9: "'remove()' can only be used on observable objects, arrays and maps",
  10: "'has()' can only be used on observable objects, arrays and maps",
  11: "'get()' can only be used on observable objects, arrays and maps",
  12: "Invalid annotation",
  13: "Dynamic observable objects cannot be frozen. If you're passing observables to 3rd party component/function that calls Object.freeze, pass copy instead: toJS(observable)",
  14: "Intercept handlers should return nothing or a change object",
  15: "Observable arrays cannot be frozen. If you're passing observables to 3rd party component/function that calls Object.freeze, pass copy instead: toJS(observable)",
  16: "Modification exception: the internal structure of an observable array was changed.",
  17: function(e, Ui) {
    return "[mobx.array] Index out of bounds, " + e + " is larger than " + Ui;
  },
  18: "mobx.map requires Map polyfill for the current browser. Check babel-polyfill or core-js/es6/map.js",
  19: function(e) {
    return "Cannot initialize from classes that inherit from Map: " + e.constructor.name;
  },
  20: function(e) {
    return "Cannot initialize map from " + e;
  },
  21: function(e) {
    return "Cannot convert to map from '" + e + "'";
  },
  22: "mobx.set requires Set polyfill for the current browser. Check babel-polyfill or core-js/es6/set.js",
  23: "It is not possible to get index atoms from arrays",
  24: function(e) {
    return "Cannot obtain administration from " + e;
  },
  25: function(e, Ui) {
    return "the entry '" + e + "' does not exist in the observable map '" + Ui + "'";
  },
  26: "please specify a property",
  27: function(e, Ui) {
    return "no observable property '" + e.toString() + "' found on the observable object '" + Ui + "'";
  },
  28: function(e) {
    return "Cannot obtain atom from " + e;
  },
  29: "Expecting some object",
  30: "invalid action stack. did you forget to finish an action?",
  31: "missing option for computed: get",
  32: function(e, Ui) {
    return "Cycle detected in computation " + e + ": " + Ui;
  },
  33: function(e) {
    return "The setter of computed value '" + e + "' is trying to update itself. Did you intend to update an _observable_ value, instead of the computed property?";
  },
  34: function(e) {
    return "[ComputedValue '" + e + "'] It is not possible to assign a new value to a computed value.";
  },
  35: "There are multiple, different versions of MobX active. Make sure MobX is loaded only once or use `configure({ isolateGlobalState: true })`",
  36: "isolateGlobalState should be called before MobX is running any reactions",
  37: function(e) {
    return "[mobx] `observableArray." + e + "()` mutates the array in-place, which is not allowed inside a derivation. Use `array.slice()." + e + "()` instead";
  },
  38: "'ownKeys()' can only be used on observable objects",
  39: "'defineProperty()' can only be used on observable objects"
}, errors = process.env.NODE_ENV !== "production" ? niceErrors : {};
function die(Bi) {
  for (var e = arguments.length, Ui = new Array(e > 1 ? e - 1 : 0), Zi = 1; Zi < e; Zi++)
    Ui[Zi - 1] = arguments[Zi];
  if (process.env.NODE_ENV !== "production") {
    var ta = typeof Bi == "string" ? Bi : errors[Bi];
    throw typeof ta == "function" && (ta = ta.apply(null, Ui)), new Error("[MobX] " + ta);
  }
  throw new Error(typeof Bi == "number" ? "[MobX] minified error nr: " + Bi + (Ui.length ? " " + Ui.map(String).join(",") : "") + ". Find the full error at: https://github.com/mobxjs/mobx/blob/main/packages/mobx/src/errors.ts" : "[MobX] " + Bi);
}
var mockGlobal = {};
function getGlobal() {
  return typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : mockGlobal;
}
var assign = Object.assign, getDescriptor = Object.getOwnPropertyDescriptor, defineProperty = Object.defineProperty, objectPrototype = Object.prototype, EMPTY_ARRAY = [];
Object.freeze(EMPTY_ARRAY);
var EMPTY_OBJECT = {};
Object.freeze(EMPTY_OBJECT);
var hasProxy = typeof Proxy < "u", plainObjectString = /* @__PURE__ */ Object.toString();
function assertProxies() {
  hasProxy || die(process.env.NODE_ENV !== "production" ? "`Proxy` objects are not available in the current environment. Please configure MobX to enable a fallback implementation.`" : "Proxy not available");
}
function warnAboutProxyRequirement(Bi) {
  process.env.NODE_ENV !== "production" && globalState.verifyProxies && die("MobX is currently configured to be able to run in ES5 mode, but in ES5 MobX won't be able to " + Bi);
}
function getNextId() {
  return ++globalState.mobxGuid;
}
function once(Bi) {
  var e = !1;
  return function() {
    if (!e)
      return e = !0, Bi.apply(this, arguments);
  };
}
var noop$1 = function() {
};
function isFunction$1(Bi) {
  return typeof Bi == "function";
}
function isStringish(Bi) {
  var e = typeof Bi;
  switch (e) {
    case "string":
    case "symbol":
    case "number":
      return !0;
  }
  return !1;
}
function isObject$3(Bi) {
  return Bi !== null && typeof Bi == "object";
}
function isPlainObject$2(Bi) {
  if (!isObject$3(Bi))
    return !1;
  var e = Object.getPrototypeOf(Bi);
  if (e == null)
    return !0;
  var Ui = Object.hasOwnProperty.call(e, "constructor") && e.constructor;
  return typeof Ui == "function" && Ui.toString() === plainObjectString;
}
function isGenerator(Bi) {
  var e = Bi?.constructor;
  return e ? e.name === "GeneratorFunction" || e.displayName === "GeneratorFunction" : !1;
}
function addHiddenProp(Bi, e, Ui) {
  defineProperty(Bi, e, {
    enumerable: !1,
    writable: !0,
    configurable: !0,
    value: Ui
  });
}
function addHiddenFinalProp(Bi, e, Ui) {
  defineProperty(Bi, e, {
    enumerable: !1,
    writable: !1,
    configurable: !0,
    value: Ui
  });
}
function createInstanceofPredicate(Bi, e) {
  var Ui = "isMobX" + Bi;
  return e.prototype[Ui] = !0, function(Zi) {
    return isObject$3(Zi) && Zi[Ui] === !0;
  };
}
function isES6Map(Bi) {
  return Bi instanceof Map;
}
function isES6Set(Bi) {
  return Bi instanceof Set;
}
var hasGetOwnPropertySymbols = typeof Object.getOwnPropertySymbols < "u";
function getPlainObjectKeys(Bi) {
  var e = Object.keys(Bi);
  if (!hasGetOwnPropertySymbols)
    return e;
  var Ui = Object.getOwnPropertySymbols(Bi);
  return Ui.length ? [].concat(e, Ui.filter(function(Zi) {
    return objectPrototype.propertyIsEnumerable.call(Bi, Zi);
  })) : e;
}
var ownKeys$2 = typeof Reflect < "u" && Reflect.ownKeys ? Reflect.ownKeys : hasGetOwnPropertySymbols ? function(Bi) {
  return Object.getOwnPropertyNames(Bi).concat(Object.getOwnPropertySymbols(Bi));
} : (
  /* istanbul ignore next */
  Object.getOwnPropertyNames
);
function stringifyKey(Bi) {
  return typeof Bi == "string" ? Bi : typeof Bi == "symbol" ? Bi.toString() : new String(Bi).toString();
}
function toPrimitive(Bi) {
  return Bi === null ? null : typeof Bi == "object" ? "" + Bi : Bi;
}
function hasProp(Bi, e) {
  return objectPrototype.hasOwnProperty.call(Bi, e);
}
var getOwnPropertyDescriptors = Object.getOwnPropertyDescriptors || function(e) {
  var Ui = {};
  return ownKeys$2(e).forEach(function(Zi) {
    Ui[Zi] = getDescriptor(e, Zi);
  }), Ui;
};
function _defineProperties(Bi, e) {
  for (var Ui = 0; Ui < e.length; Ui++) {
    var Zi = e[Ui];
    Zi.enumerable = Zi.enumerable || !1, Zi.configurable = !0, "value" in Zi && (Zi.writable = !0), Object.defineProperty(Bi, _toPropertyKey(Zi.key), Zi);
  }
}
function _createClass(Bi, e, Ui) {
  return e && _defineProperties(Bi.prototype, e), Object.defineProperty(Bi, "prototype", {
    writable: !1
  }), Bi;
}
function _extends() {
  return _extends = Object.assign ? Object.assign.bind() : function(Bi) {
    for (var e = 1; e < arguments.length; e++) {
      var Ui = arguments[e];
      for (var Zi in Ui)
        Object.prototype.hasOwnProperty.call(Ui, Zi) && (Bi[Zi] = Ui[Zi]);
    }
    return Bi;
  }, _extends.apply(this, arguments);
}
function _inheritsLoose(Bi, e) {
  Bi.prototype = Object.create(e.prototype), Bi.prototype.constructor = Bi, _setPrototypeOf(Bi, e);
}
function _setPrototypeOf(Bi, e) {
  return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(Zi, ta) {
    return Zi.__proto__ = ta, Zi;
  }, _setPrototypeOf(Bi, e);
}
function _assertThisInitialized(Bi) {
  if (Bi === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return Bi;
}
function _unsupportedIterableToArray$2(Bi, e) {
  if (Bi) {
    if (typeof Bi == "string") return _arrayLikeToArray$2(Bi, e);
    var Ui = Object.prototype.toString.call(Bi).slice(8, -1);
    if (Ui === "Object" && Bi.constructor && (Ui = Bi.constructor.name), Ui === "Map" || Ui === "Set") return Array.from(Bi);
    if (Ui === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(Ui)) return _arrayLikeToArray$2(Bi, e);
  }
}
function _arrayLikeToArray$2(Bi, e) {
  (e == null || e > Bi.length) && (e = Bi.length);
  for (var Ui = 0, Zi = new Array(e); Ui < e; Ui++) Zi[Ui] = Bi[Ui];
  return Zi;
}
function _createForOfIteratorHelperLoose(Bi, e) {
  var Ui = typeof Symbol < "u" && Bi[Symbol.iterator] || Bi["@@iterator"];
  if (Ui) return (Ui = Ui.call(Bi)).next.bind(Ui);
  if (Array.isArray(Bi) || (Ui = _unsupportedIterableToArray$2(Bi)) || e) {
    Ui && (Bi = Ui);
    var Zi = 0;
    return function() {
      return Zi >= Bi.length ? {
        done: !0
      } : {
        done: !1,
        value: Bi[Zi++]
      };
    };
  }
  throw new TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function _toPrimitive(Bi, e) {
  if (typeof Bi != "object" || Bi === null) return Bi;
  var Ui = Bi[Symbol.toPrimitive];
  if (Ui !== void 0) {
    var Zi = Ui.call(Bi, e);
    if (typeof Zi != "object") return Zi;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return String(Bi);
}
function _toPropertyKey(Bi) {
  var e = _toPrimitive(Bi, "string");
  return typeof e == "symbol" ? e : String(e);
}
var storedAnnotationsSymbol = /* @__PURE__ */ Symbol("mobx-stored-annotations");
function createDecoratorAnnotation(Bi) {
  function e(Ui, Zi) {
    if (is20223Decorator(Zi))
      return Bi.decorate_20223_(Ui, Zi);
    storeAnnotation(Ui, Zi, Bi);
  }
  return Object.assign(e, Bi);
}
function storeAnnotation(Bi, e, Ui) {
  if (hasProp(Bi, storedAnnotationsSymbol) || addHiddenProp(Bi, storedAnnotationsSymbol, _extends({}, Bi[storedAnnotationsSymbol])), process.env.NODE_ENV !== "production" && isOverride(Ui) && !hasProp(Bi[storedAnnotationsSymbol], e)) {
    var Zi = Bi.constructor.name + ".prototype." + e.toString();
    die("'" + Zi + "' is decorated with 'override', but no such decorated member was found on prototype.");
  }
  assertNotDecorated(Bi, Ui, e), isOverride(Ui) || (Bi[storedAnnotationsSymbol][e] = Ui);
}
function assertNotDecorated(Bi, e, Ui) {
  if (process.env.NODE_ENV !== "production" && !isOverride(e) && hasProp(Bi[storedAnnotationsSymbol], Ui)) {
    var Zi = Bi.constructor.name + ".prototype." + Ui.toString(), ta = Bi[storedAnnotationsSymbol][Ui].annotationType_, na = e.annotationType_;
    die("Cannot apply '@" + na + "' to '" + Zi + "':" + (`
The field is already decorated with '@` + ta + "'.") + `
Re-decorating fields is not allowed.
Use '@override' decorator for methods overridden by subclass.`);
  }
}
function collectStoredAnnotations(Bi) {
  return hasProp(Bi, storedAnnotationsSymbol) || addHiddenProp(Bi, storedAnnotationsSymbol, _extends({}, Bi[storedAnnotationsSymbol])), Bi[storedAnnotationsSymbol];
}
function is20223Decorator(Bi) {
  return typeof Bi == "object" && typeof Bi.kind == "string";
}
function assert20223DecoratorType(Bi, e) {
  process.env.NODE_ENV !== "production" && !e.includes(Bi.kind) && die("The decorator applied to '" + String(Bi.name) + "' cannot be used on a " + Bi.kind + " element");
}
var $mobx = /* @__PURE__ */ Symbol("mobx administration"), Atom = /* @__PURE__ */ function() {
  function Bi(Ui) {
    Ui === void 0 && (Ui = process.env.NODE_ENV !== "production" ? "Atom@" + getNextId() : "Atom"), this.name_ = void 0, this.isPendingUnobservation_ = !1, this.isBeingObserved_ = !1, this.observers_ = /* @__PURE__ */ new Set(), this.diffValue_ = 0, this.lastAccessedBy_ = 0, this.lowestObserverState_ = IDerivationState_.NOT_TRACKING_, this.onBOL = void 0, this.onBUOL = void 0, this.name_ = Ui;
  }
  var e = Bi.prototype;
  return e.onBO = function() {
    this.onBOL && this.onBOL.forEach(function(Zi) {
      return Zi();
    });
  }, e.onBUO = function() {
    this.onBUOL && this.onBUOL.forEach(function(Zi) {
      return Zi();
    });
  }, e.reportObserved = function() {
    return reportObserved(this);
  }, e.reportChanged = function() {
    startBatch(), propagateChanged(this), endBatch();
  }, e.toString = function() {
    return this.name_;
  }, Bi;
}(), isAtom = /* @__PURE__ */ createInstanceofPredicate("Atom", Atom);
function createAtom(Bi, e, Ui) {
  e === void 0 && (e = noop$1), Ui === void 0 && (Ui = noop$1);
  var Zi = new Atom(Bi);
  return e !== noop$1 && onBecomeObserved(Zi, e), Ui !== noop$1 && onBecomeUnobserved(Zi, Ui), Zi;
}
function structuralComparer(Bi, e) {
  return deepEqual$1(Bi, e);
}
function defaultComparer(Bi, e) {
  return Object.is ? Object.is(Bi, e) : Bi === e ? Bi !== 0 || 1 / Bi === 1 / e : Bi !== Bi && e !== e;
}
var comparer = {
  structural: structuralComparer,
  default: defaultComparer
};
function deepEnhancer(Bi, e, Ui) {
  return isObservable(Bi) ? Bi : Array.isArray(Bi) ? observable.array(Bi, {
    name: Ui
  }) : isPlainObject$2(Bi) ? observable.object(Bi, void 0, {
    name: Ui
  }) : isES6Map(Bi) ? observable.map(Bi, {
    name: Ui
  }) : isES6Set(Bi) ? observable.set(Bi, {
    name: Ui
  }) : typeof Bi == "function" && !isAction(Bi) && !isFlow(Bi) ? isGenerator(Bi) ? flow(Bi) : autoAction(Ui, Bi) : Bi;
}
function shallowEnhancer(Bi, e, Ui) {
  if (Bi == null || isObservableObject(Bi) || isObservableArray(Bi) || isObservableMap(Bi) || isObservableSet(Bi))
    return Bi;
  if (Array.isArray(Bi))
    return observable.array(Bi, {
      name: Ui,
      deep: !1
    });
  if (isPlainObject$2(Bi))
    return observable.object(Bi, void 0, {
      name: Ui,
      deep: !1
    });
  if (isES6Map(Bi))
    return observable.map(Bi, {
      name: Ui,
      deep: !1
    });
  if (isES6Set(Bi))
    return observable.set(Bi, {
      name: Ui,
      deep: !1
    });
  process.env.NODE_ENV !== "production" && die("The shallow modifier / decorator can only used in combination with arrays, objects, maps and sets");
}
function referenceEnhancer(Bi) {
  return Bi;
}
function refStructEnhancer(Bi, e) {
  return process.env.NODE_ENV !== "production" && isObservable(Bi) && die("observable.struct should not be used with observable values"), deepEqual$1(Bi, e) ? e : Bi;
}
var OVERRIDE = "override";
function isOverride(Bi) {
  return Bi.annotationType_ === OVERRIDE;
}
function createActionAnnotation(Bi, e) {
  return {
    annotationType_: Bi,
    options_: e,
    make_: make_$1,
    extend_: extend_$1,
    decorate_20223_: decorate_20223_$1
  };
}
function make_$1(Bi, e, Ui, Zi) {
  var ta;
  if ((ta = this.options_) != null && ta.bound)
    return this.extend_(Bi, e, Ui, !1) === null ? 0 : 1;
  if (Zi === Bi.target_)
    return this.extend_(Bi, e, Ui, !1) === null ? 0 : 2;
  if (isAction(Ui.value))
    return 1;
  var na = createActionDescriptor(Bi, this, e, Ui, !1);
  return defineProperty(Zi, e, na), 2;
}
function extend_$1(Bi, e, Ui, Zi) {
  var ta = createActionDescriptor(Bi, this, e, Ui);
  return Bi.defineProperty_(e, ta, Zi);
}
function decorate_20223_$1(Bi, e) {
  process.env.NODE_ENV !== "production" && assert20223DecoratorType(e, ["method", "field"]);
  var Ui = e.kind, Zi = e.name, ta = e.addInitializer, na = this, ia = function(La) {
    var qa, io, ao, oo;
    return createAction((qa = (io = na.options_) == null ? void 0 : io.name) != null ? qa : Zi.toString(), La, (ao = (oo = na.options_) == null ? void 0 : oo.autoAction) != null ? ao : !1);
  };
  if (Ui == "field") {
    ta(function() {
      storeAnnotation(this, Zi, na);
    });
    return;
  }
  if (Ui == "method") {
    var aa;
    return isAction(Bi) || (Bi = ia(Bi)), (aa = this.options_) != null && aa.bound && ta(function() {
      var da = this, La = da[Zi].bind(da);
      La.isMobxAction = !0, da[Zi] = La;
    }), Bi;
  }
  die("Cannot apply '" + na.annotationType_ + "' to '" + String(Zi) + "' (kind: " + Ui + "):" + (`
'` + na.annotationType_ + "' can only be used on properties with a function value."));
}
function assertActionDescriptor(Bi, e, Ui, Zi) {
  var ta = e.annotationType_, na = Zi.value;
  process.env.NODE_ENV !== "production" && !isFunction$1(na) && die("Cannot apply '" + ta + "' to '" + Bi.name_ + "." + Ui.toString() + "':" + (`
'` + ta + "' can only be used on properties with a function value."));
}
function createActionDescriptor(Bi, e, Ui, Zi, ta) {
  var na, ia, aa, da, La, qa, io;
  ta === void 0 && (ta = globalState.safeDescriptors), assertActionDescriptor(Bi, e, Ui, Zi);
  var ao = Zi.value;
  if ((na = e.options_) != null && na.bound) {
    var oo;
    ao = ao.bind((oo = Bi.proxy_) != null ? oo : Bi.target_);
  }
  return {
    value: createAction(
      (ia = (aa = e.options_) == null ? void 0 : aa.name) != null ? ia : Ui.toString(),
      ao,
      (da = (La = e.options_) == null ? void 0 : La.autoAction) != null ? da : !1,
      // https://github.com/mobxjs/mobx/discussions/3140
      (qa = e.options_) != null && qa.bound ? (io = Bi.proxy_) != null ? io : Bi.target_ : void 0
    ),
    // Non-configurable for classes
    // prevents accidental field redefinition in subclass
    configurable: ta ? Bi.isPlainObject_ : !0,
    // https://github.com/mobxjs/mobx/pull/2641#issuecomment-737292058
    enumerable: !1,
    // Non-obsevable, therefore non-writable
    // Also prevents rewriting in subclass constructor
    writable: !ta
  };
}
function createFlowAnnotation(Bi, e) {
  return {
    annotationType_: Bi,
    options_: e,
    make_: make_$2,
    extend_: extend_$2,
    decorate_20223_: decorate_20223_$2
  };
}
function make_$2(Bi, e, Ui, Zi) {
  var ta;
  if (Zi === Bi.target_)
    return this.extend_(Bi, e, Ui, !1) === null ? 0 : 2;
  if ((ta = this.options_) != null && ta.bound && (!hasProp(Bi.target_, e) || !isFlow(Bi.target_[e])) && this.extend_(Bi, e, Ui, !1) === null)
    return 0;
  if (isFlow(Ui.value))
    return 1;
  var na = createFlowDescriptor(Bi, this, e, Ui, !1, !1);
  return defineProperty(Zi, e, na), 2;
}
function extend_$2(Bi, e, Ui, Zi) {
  var ta, na = createFlowDescriptor(Bi, this, e, Ui, (ta = this.options_) == null ? void 0 : ta.bound);
  return Bi.defineProperty_(e, na, Zi);
}
function decorate_20223_$2(Bi, e) {
  var Ui;
  process.env.NODE_ENV !== "production" && assert20223DecoratorType(e, ["method"]);
  var Zi = e.name, ta = e.addInitializer;
  return isFlow(Bi) || (Bi = flow(Bi)), (Ui = this.options_) != null && Ui.bound && ta(function() {
    var na = this, ia = na[Zi].bind(na);
    ia.isMobXFlow = !0, na[Zi] = ia;
  }), Bi;
}
function assertFlowDescriptor(Bi, e, Ui, Zi) {
  var ta = e.annotationType_, na = Zi.value;
  process.env.NODE_ENV !== "production" && !isFunction$1(na) && die("Cannot apply '" + ta + "' to '" + Bi.name_ + "." + Ui.toString() + "':" + (`
'` + ta + "' can only be used on properties with a generator function value."));
}
function createFlowDescriptor(Bi, e, Ui, Zi, ta, na) {
  na === void 0 && (na = globalState.safeDescriptors), assertFlowDescriptor(Bi, e, Ui, Zi);
  var ia = Zi.value;
  if (isFlow(ia) || (ia = flow(ia)), ta) {
    var aa;
    ia = ia.bind((aa = Bi.proxy_) != null ? aa : Bi.target_), ia.isMobXFlow = !0;
  }
  return {
    value: ia,
    // Non-configurable for classes
    // prevents accidental field redefinition in subclass
    configurable: na ? Bi.isPlainObject_ : !0,
    // https://github.com/mobxjs/mobx/pull/2641#issuecomment-737292058
    enumerable: !1,
    // Non-obsevable, therefore non-writable
    // Also prevents rewriting in subclass constructor
    writable: !na
  };
}
function createComputedAnnotation(Bi, e) {
  return {
    annotationType_: Bi,
    options_: e,
    make_: make_$3,
    extend_: extend_$3,
    decorate_20223_: decorate_20223_$3
  };
}
function make_$3(Bi, e, Ui) {
  return this.extend_(Bi, e, Ui, !1) === null ? 0 : 1;
}
function extend_$3(Bi, e, Ui, Zi) {
  return assertComputedDescriptor(Bi, this, e, Ui), Bi.defineComputedProperty_(e, _extends({}, this.options_, {
    get: Ui.get,
    set: Ui.set
  }), Zi);
}
function decorate_20223_$3(Bi, e) {
  process.env.NODE_ENV !== "production" && assert20223DecoratorType(e, ["getter"]);
  var Ui = this, Zi = e.name, ta = e.addInitializer;
  return ta(function() {
    var na = asObservableObject(this)[$mobx], ia = _extends({}, Ui.options_, {
      get: Bi,
      context: this
    });
    ia.name || (ia.name = process.env.NODE_ENV !== "production" ? na.name_ + "." + Zi.toString() : "ObservableObject." + Zi.toString()), na.values_.set(Zi, new ComputedValue(ia));
  }), function() {
    return this[$mobx].getObservablePropValue_(Zi);
  };
}
function assertComputedDescriptor(Bi, e, Ui, Zi) {
  var ta = e.annotationType_, na = Zi.get;
  process.env.NODE_ENV !== "production" && !na && die("Cannot apply '" + ta + "' to '" + Bi.name_ + "." + Ui.toString() + "':" + (`
'` + ta + "' can only be used on getter(+setter) properties."));
}
function createObservableAnnotation(Bi, e) {
  return {
    annotationType_: Bi,
    options_: e,
    make_: make_$4,
    extend_: extend_$4,
    decorate_20223_: decorate_20223_$4
  };
}
function make_$4(Bi, e, Ui) {
  return this.extend_(Bi, e, Ui, !1) === null ? 0 : 1;
}
function extend_$4(Bi, e, Ui, Zi) {
  var ta, na;
  return assertObservableDescriptor(Bi, this, e, Ui), Bi.defineObservableProperty_(e, Ui.value, (ta = (na = this.options_) == null ? void 0 : na.enhancer) != null ? ta : deepEnhancer, Zi);
}
function decorate_20223_$4(Bi, e) {
  if (process.env.NODE_ENV !== "production") {
    if (e.kind === "field")
      throw die("Please use `@observable accessor " + String(e.name) + "` instead of `@observable " + String(e.name) + "`");
    assert20223DecoratorType(e, ["accessor"]);
  }
  var Ui = this, Zi = e.kind, ta = e.name, na = /* @__PURE__ */ new WeakSet();
  function ia(aa, da) {
    var La, qa, io = asObservableObject(aa)[$mobx], ao = new ObservableValue(da, (La = (qa = Ui.options_) == null ? void 0 : qa.enhancer) != null ? La : deepEnhancer, process.env.NODE_ENV !== "production" ? io.name_ + "." + ta.toString() : "ObservableObject." + ta.toString(), !1);
    io.values_.set(ta, ao), na.add(aa);
  }
  if (Zi == "accessor")
    return {
      get: function() {
        return na.has(this) || ia(this, Bi.get.call(this)), this[$mobx].getObservablePropValue_(ta);
      },
      set: function(da) {
        return na.has(this) || ia(this, da), this[$mobx].setObservablePropValue_(ta, da);
      },
      init: function(da) {
        return na.has(this) || ia(this, da), da;
      }
    };
}
function assertObservableDescriptor(Bi, e, Ui, Zi) {
  var ta = e.annotationType_;
  process.env.NODE_ENV !== "production" && !("value" in Zi) && die("Cannot apply '" + ta + "' to '" + Bi.name_ + "." + Ui.toString() + "':" + (`
'` + ta + "' cannot be used on getter/setter properties"));
}
var AUTO = "true", autoAnnotation = /* @__PURE__ */ createAutoAnnotation();
function createAutoAnnotation(Bi) {
  return {
    annotationType_: AUTO,
    options_: Bi,
    make_: make_$5,
    extend_: extend_$5,
    decorate_20223_: decorate_20223_$5
  };
}
function make_$5(Bi, e, Ui, Zi) {
  var ta, na;
  if (Ui.get)
    return computed.make_(Bi, e, Ui, Zi);
  if (Ui.set) {
    var ia = createAction(e.toString(), Ui.set);
    return Zi === Bi.target_ ? Bi.defineProperty_(e, {
      configurable: globalState.safeDescriptors ? Bi.isPlainObject_ : !0,
      set: ia
    }) === null ? 0 : 2 : (defineProperty(Zi, e, {
      configurable: !0,
      set: ia
    }), 2);
  }
  if (Zi !== Bi.target_ && typeof Ui.value == "function") {
    var aa;
    if (isGenerator(Ui.value)) {
      var da, La = (da = this.options_) != null && da.autoBind ? flow.bound : flow;
      return La.make_(Bi, e, Ui, Zi);
    }
    var qa = (aa = this.options_) != null && aa.autoBind ? autoAction.bound : autoAction;
    return qa.make_(Bi, e, Ui, Zi);
  }
  var io = ((ta = this.options_) == null ? void 0 : ta.deep) === !1 ? observable.ref : observable;
  if (typeof Ui.value == "function" && (na = this.options_) != null && na.autoBind) {
    var ao;
    Ui.value = Ui.value.bind((ao = Bi.proxy_) != null ? ao : Bi.target_);
  }
  return io.make_(Bi, e, Ui, Zi);
}
function extend_$5(Bi, e, Ui, Zi) {
  var ta, na;
  if (Ui.get)
    return computed.extend_(Bi, e, Ui, Zi);
  if (Ui.set)
    return Bi.defineProperty_(e, {
      configurable: globalState.safeDescriptors ? Bi.isPlainObject_ : !0,
      set: createAction(e.toString(), Ui.set)
    }, Zi);
  if (typeof Ui.value == "function" && (ta = this.options_) != null && ta.autoBind) {
    var ia;
    Ui.value = Ui.value.bind((ia = Bi.proxy_) != null ? ia : Bi.target_);
  }
  var aa = ((na = this.options_) == null ? void 0 : na.deep) === !1 ? observable.ref : observable;
  return aa.extend_(Bi, e, Ui, Zi);
}
function decorate_20223_$5(Bi, e) {
  die("'" + this.annotationType_ + "' cannot be used as a decorator");
}
var OBSERVABLE = "observable", OBSERVABLE_REF = "observable.ref", OBSERVABLE_SHALLOW = "observable.shallow", OBSERVABLE_STRUCT = "observable.struct", defaultCreateObservableOptions = {
  deep: !0,
  name: void 0,
  defaultDecorator: void 0,
  proxy: !0
};
Object.freeze(defaultCreateObservableOptions);
function asCreateObservableOptions(Bi) {
  return Bi || defaultCreateObservableOptions;
}
var observableAnnotation = /* @__PURE__ */ createObservableAnnotation(OBSERVABLE), observableRefAnnotation = /* @__PURE__ */ createObservableAnnotation(OBSERVABLE_REF, {
  enhancer: referenceEnhancer
}), observableShallowAnnotation = /* @__PURE__ */ createObservableAnnotation(OBSERVABLE_SHALLOW, {
  enhancer: shallowEnhancer
}), observableStructAnnotation = /* @__PURE__ */ createObservableAnnotation(OBSERVABLE_STRUCT, {
  enhancer: refStructEnhancer
}), observableDecoratorAnnotation = /* @__PURE__ */ createDecoratorAnnotation(observableAnnotation);
function getEnhancerFromOptions(Bi) {
  return Bi.deep === !0 ? deepEnhancer : Bi.deep === !1 ? referenceEnhancer : getEnhancerFromAnnotation(Bi.defaultDecorator);
}
function getAnnotationFromOptions(Bi) {
  var e;
  return Bi ? (e = Bi.defaultDecorator) != null ? e : createAutoAnnotation(Bi) : void 0;
}
function getEnhancerFromAnnotation(Bi) {
  var e, Ui;
  return Bi && (e = (Ui = Bi.options_) == null ? void 0 : Ui.enhancer) != null ? e : deepEnhancer;
}
function createObservable(Bi, e, Ui) {
  if (is20223Decorator(e))
    return observableAnnotation.decorate_20223_(Bi, e);
  if (isStringish(e)) {
    storeAnnotation(Bi, e, observableAnnotation);
    return;
  }
  return isObservable(Bi) ? Bi : isPlainObject$2(Bi) ? observable.object(Bi, e, Ui) : Array.isArray(Bi) ? observable.array(Bi, e) : isES6Map(Bi) ? observable.map(Bi, e) : isES6Set(Bi) ? observable.set(Bi, e) : typeof Bi == "object" && Bi !== null ? Bi : observable.box(Bi, e);
}
assign(createObservable, observableDecoratorAnnotation);
var observableFactories = {
  box: function(e, Ui) {
    var Zi = asCreateObservableOptions(Ui);
    return new ObservableValue(e, getEnhancerFromOptions(Zi), Zi.name, !0, Zi.equals);
  },
  array: function(e, Ui) {
    var Zi = asCreateObservableOptions(Ui);
    return (globalState.useProxies === !1 || Zi.proxy === !1 ? createLegacyArray : createObservableArray)(e, getEnhancerFromOptions(Zi), Zi.name);
  },
  map: function(e, Ui) {
    var Zi = asCreateObservableOptions(Ui);
    return new ObservableMap(e, getEnhancerFromOptions(Zi), Zi.name);
  },
  set: function(e, Ui) {
    var Zi = asCreateObservableOptions(Ui);
    return new ObservableSet(e, getEnhancerFromOptions(Zi), Zi.name);
  },
  object: function(e, Ui, Zi) {
    return initObservable(function() {
      return extendObservable(globalState.useProxies === !1 || Zi?.proxy === !1 ? asObservableObject({}, Zi) : asDynamicObservableObject({}, Zi), e, Ui);
    });
  },
  ref: /* @__PURE__ */ createDecoratorAnnotation(observableRefAnnotation),
  shallow: /* @__PURE__ */ createDecoratorAnnotation(observableShallowAnnotation),
  deep: observableDecoratorAnnotation,
  struct: /* @__PURE__ */ createDecoratorAnnotation(observableStructAnnotation)
}, observable = /* @__PURE__ */ assign(createObservable, observableFactories), COMPUTED = "computed", COMPUTED_STRUCT = "computed.struct", computedAnnotation = /* @__PURE__ */ createComputedAnnotation(COMPUTED), computedStructAnnotation = /* @__PURE__ */ createComputedAnnotation(COMPUTED_STRUCT, {
  equals: comparer.structural
}), computed = function(e, Ui) {
  if (is20223Decorator(Ui))
    return computedAnnotation.decorate_20223_(e, Ui);
  if (isStringish(Ui))
    return storeAnnotation(e, Ui, computedAnnotation);
  if (isPlainObject$2(e))
    return createDecoratorAnnotation(createComputedAnnotation(COMPUTED, e));
  process.env.NODE_ENV !== "production" && (isFunction$1(e) || die("First argument to `computed` should be an expression."), isFunction$1(Ui) && die("A setter as second argument is no longer supported, use `{ set: fn }` option instead"));
  var Zi = isPlainObject$2(Ui) ? Ui : {};
  return Zi.get = e, Zi.name || (Zi.name = e.name || ""), new ComputedValue(Zi);
};
Object.assign(computed, computedAnnotation);
computed.struct = /* @__PURE__ */ createDecoratorAnnotation(computedStructAnnotation);
var _getDescriptor$config, _getDescriptor, currentActionId = 0, nextActionId = 1, isFunctionNameConfigurable = (_getDescriptor$config = (_getDescriptor = /* @__PURE__ */ getDescriptor(function() {
}, "name")) == null ? void 0 : _getDescriptor.configurable) != null ? _getDescriptor$config : !1, tmpNameDescriptor = {
  value: "action",
  configurable: !0,
  writable: !1,
  enumerable: !1
};
function createAction(Bi, e, Ui, Zi) {
  Ui === void 0 && (Ui = !1), process.env.NODE_ENV !== "production" && (isFunction$1(e) || die("`action` can only be invoked on functions"), (typeof Bi != "string" || !Bi) && die("actions should have valid names, got: '" + Bi + "'"));
  function ta() {
    return executeAction(Bi, Ui, e, Zi || this, arguments);
  }
  return ta.isMobxAction = !0, ta.toString = function() {
    return e.toString();
  }, isFunctionNameConfigurable && (tmpNameDescriptor.value = Bi, defineProperty(ta, "name", tmpNameDescriptor)), ta;
}
function executeAction(Bi, e, Ui, Zi, ta) {
  var na = _startAction(Bi, e, Zi, ta);
  try {
    return Ui.apply(Zi, ta);
  } catch (ia) {
    throw na.error_ = ia, ia;
  } finally {
    _endAction(na);
  }
}
function _startAction(Bi, e, Ui, Zi) {
  var ta = process.env.NODE_ENV !== "production" && isSpyEnabled() && !!Bi, na = 0;
  if (process.env.NODE_ENV !== "production" && ta) {
    na = Date.now();
    var ia = Zi ? Array.from(Zi) : EMPTY_ARRAY;
    spyReportStart({
      type: ACTION,
      name: Bi,
      object: Ui,
      arguments: ia
    });
  }
  var aa = globalState.trackingDerivation, da = !e || !aa;
  startBatch();
  var La = globalState.allowStateChanges;
  da && (untrackedStart(), La = allowStateChangesStart(!0));
  var qa = allowStateReadsStart(!0), io = {
    runAsAction_: da,
    prevDerivation_: aa,
    prevAllowStateChanges_: La,
    prevAllowStateReads_: qa,
    notifySpy_: ta,
    startTime_: na,
    actionId_: nextActionId++,
    parentActionId_: currentActionId
  };
  return currentActionId = io.actionId_, io;
}
function _endAction(Bi) {
  currentActionId !== Bi.actionId_ && die(30), currentActionId = Bi.parentActionId_, Bi.error_ !== void 0 && (globalState.suppressReactionErrors = !0), allowStateChangesEnd(Bi.prevAllowStateChanges_), allowStateReadsEnd(Bi.prevAllowStateReads_), endBatch(), Bi.runAsAction_ && untrackedEnd(Bi.prevDerivation_), process.env.NODE_ENV !== "production" && Bi.notifySpy_ && spyReportEnd({
    time: Date.now() - Bi.startTime_
  }), globalState.suppressReactionErrors = !1;
}
function allowStateChanges(Bi, e) {
  var Ui = allowStateChangesStart(Bi);
  try {
    return e();
  } finally {
    allowStateChangesEnd(Ui);
  }
}
function allowStateChangesStart(Bi) {
  var e = globalState.allowStateChanges;
  return globalState.allowStateChanges = Bi, e;
}
function allowStateChangesEnd(Bi) {
  globalState.allowStateChanges = Bi;
}
var _Symbol$toPrimitive, CREATE = "create";
_Symbol$toPrimitive = Symbol.toPrimitive;
var ObservableValue = /* @__PURE__ */ function(Bi) {
  _inheritsLoose(e, Bi);
  function e(Zi, ta, na, ia, aa) {
    var da;
    return na === void 0 && (na = process.env.NODE_ENV !== "production" ? "ObservableValue@" + getNextId() : "ObservableValue"), ia === void 0 && (ia = !0), aa === void 0 && (aa = comparer.default), da = Bi.call(this, na) || this, da.enhancer = void 0, da.name_ = void 0, da.equals = void 0, da.hasUnreportedChange_ = !1, da.interceptors_ = void 0, da.changeListeners_ = void 0, da.value_ = void 0, da.dehancer = void 0, da.enhancer = ta, da.name_ = na, da.equals = aa, da.value_ = ta(Zi, void 0, na), process.env.NODE_ENV !== "production" && ia && isSpyEnabled() && spyReport({
      type: CREATE,
      object: _assertThisInitialized(da),
      observableKind: "value",
      debugObjectName: da.name_,
      newValue: "" + da.value_
    }), da;
  }
  var Ui = e.prototype;
  return Ui.dehanceValue = function(ta) {
    return this.dehancer !== void 0 ? this.dehancer(ta) : ta;
  }, Ui.set = function(ta) {
    var na = this.value_;
    if (ta = this.prepareNewValue_(ta), ta !== globalState.UNCHANGED) {
      var ia = isSpyEnabled();
      process.env.NODE_ENV !== "production" && ia && spyReportStart({
        type: UPDATE,
        object: this,
        observableKind: "value",
        debugObjectName: this.name_,
        newValue: ta,
        oldValue: na
      }), this.setNewValue_(ta), process.env.NODE_ENV !== "production" && ia && spyReportEnd();
    }
  }, Ui.prepareNewValue_ = function(ta) {
    if (checkIfStateModificationsAreAllowed(this), hasInterceptors(this)) {
      var na = interceptChange(this, {
        object: this,
        type: UPDATE,
        newValue: ta
      });
      if (!na)
        return globalState.UNCHANGED;
      ta = na.newValue;
    }
    return ta = this.enhancer(ta, this.value_, this.name_), this.equals(this.value_, ta) ? globalState.UNCHANGED : ta;
  }, Ui.setNewValue_ = function(ta) {
    var na = this.value_;
    this.value_ = ta, this.reportChanged(), hasListeners(this) && notifyListeners(this, {
      type: UPDATE,
      object: this,
      newValue: ta,
      oldValue: na
    });
  }, Ui.get = function() {
    return this.reportObserved(), this.dehanceValue(this.value_);
  }, Ui.intercept_ = function(ta) {
    return registerInterceptor(this, ta);
  }, Ui.observe_ = function(ta, na) {
    return na && ta({
      observableKind: "value",
      debugObjectName: this.name_,
      object: this,
      type: UPDATE,
      newValue: this.value_,
      oldValue: void 0
    }), registerListener(this, ta);
  }, Ui.raw = function() {
    return this.value_;
  }, Ui.toJSON = function() {
    return this.get();
  }, Ui.toString = function() {
    return this.name_ + "[" + this.value_ + "]";
  }, Ui.valueOf = function() {
    return toPrimitive(this.get());
  }, Ui[_Symbol$toPrimitive] = function() {
    return this.valueOf();
  }, e;
}(Atom), _Symbol$toPrimitive$1;
_Symbol$toPrimitive$1 = Symbol.toPrimitive;
var ComputedValue = /* @__PURE__ */ function() {
  function Bi(Ui) {
    this.dependenciesState_ = IDerivationState_.NOT_TRACKING_, this.observing_ = [], this.newObserving_ = null, this.isBeingObserved_ = !1, this.isPendingUnobservation_ = !1, this.observers_ = /* @__PURE__ */ new Set(), this.diffValue_ = 0, this.runId_ = 0, this.lastAccessedBy_ = 0, this.lowestObserverState_ = IDerivationState_.UP_TO_DATE_, this.unboundDepsCount_ = 0, this.value_ = new CaughtException(null), this.name_ = void 0, this.triggeredBy_ = void 0, this.isComputing_ = !1, this.isRunningSetter_ = !1, this.derivation = void 0, this.setter_ = void 0, this.isTracing_ = TraceMode.NONE, this.scope_ = void 0, this.equals_ = void 0, this.requiresReaction_ = void 0, this.keepAlive_ = void 0, this.onBOL = void 0, this.onBUOL = void 0, Ui.get || die(31), this.derivation = Ui.get, this.name_ = Ui.name || (process.env.NODE_ENV !== "production" ? "ComputedValue@" + getNextId() : "ComputedValue"), Ui.set && (this.setter_ = createAction(process.env.NODE_ENV !== "production" ? this.name_ + "-setter" : "ComputedValue-setter", Ui.set)), this.equals_ = Ui.equals || (Ui.compareStructural || Ui.struct ? comparer.structural : comparer.default), this.scope_ = Ui.context, this.requiresReaction_ = Ui.requiresReaction, this.keepAlive_ = !!Ui.keepAlive;
  }
  var e = Bi.prototype;
  return e.onBecomeStale_ = function() {
    propagateMaybeChanged(this);
  }, e.onBO = function() {
    this.onBOL && this.onBOL.forEach(function(Zi) {
      return Zi();
    });
  }, e.onBUO = function() {
    this.onBUOL && this.onBUOL.forEach(function(Zi) {
      return Zi();
    });
  }, e.get = function() {
    if (this.isComputing_ && die(32, this.name_, this.derivation), globalState.inBatch === 0 && // !globalState.trackingDerivatpion &&
    this.observers_.size === 0 && !this.keepAlive_)
      shouldCompute(this) && (this.warnAboutUntrackedRead_(), startBatch(), this.value_ = this.computeValue_(!1), endBatch());
    else if (reportObserved(this), shouldCompute(this)) {
      var Zi = globalState.trackingContext;
      this.keepAlive_ && !Zi && (globalState.trackingContext = this), this.trackAndCompute() && propagateChangeConfirmed(this), globalState.trackingContext = Zi;
    }
    var ta = this.value_;
    if (isCaughtException(ta))
      throw ta.cause;
    return ta;
  }, e.set = function(Zi) {
    if (this.setter_) {
      this.isRunningSetter_ && die(33, this.name_), this.isRunningSetter_ = !0;
      try {
        this.setter_.call(this.scope_, Zi);
      } finally {
        this.isRunningSetter_ = !1;
      }
    } else
      die(34, this.name_);
  }, e.trackAndCompute = function() {
    var Zi = this.value_, ta = (
      /* see #1208 */
      this.dependenciesState_ === IDerivationState_.NOT_TRACKING_
    ), na = this.computeValue_(!0), ia = ta || isCaughtException(Zi) || isCaughtException(na) || !this.equals_(Zi, na);
    return ia && (this.value_ = na, process.env.NODE_ENV !== "production" && isSpyEnabled() && spyReport({
      observableKind: "computed",
      debugObjectName: this.name_,
      object: this.scope_,
      type: "update",
      oldValue: Zi,
      newValue: na
    })), ia;
  }, e.computeValue_ = function(Zi) {
    this.isComputing_ = !0;
    var ta = allowStateChangesStart(!1), na;
    if (Zi)
      na = trackDerivedFunction(this, this.derivation, this.scope_);
    else if (globalState.disableErrorBoundaries === !0)
      na = this.derivation.call(this.scope_);
    else
      try {
        na = this.derivation.call(this.scope_);
      } catch (ia) {
        na = new CaughtException(ia);
      }
    return allowStateChangesEnd(ta), this.isComputing_ = !1, na;
  }, e.suspend_ = function() {
    this.keepAlive_ || (clearObserving(this), this.value_ = void 0, process.env.NODE_ENV !== "production" && this.isTracing_ !== TraceMode.NONE && console.log("[mobx.trace] Computed value '" + this.name_ + "' was suspended and it will recompute on the next access."));
  }, e.observe_ = function(Zi, ta) {
    var na = this, ia = !0, aa = void 0;
    return autorun(function() {
      var da = na.get();
      if (!ia || ta) {
        var La = untrackedStart();
        Zi({
          observableKind: "computed",
          debugObjectName: na.name_,
          type: UPDATE,
          object: na,
          newValue: da,
          oldValue: aa
        }), untrackedEnd(La);
      }
      ia = !1, aa = da;
    });
  }, e.warnAboutUntrackedRead_ = function() {
    process.env.NODE_ENV !== "production" && (this.isTracing_ !== TraceMode.NONE && console.log("[mobx.trace] Computed value '" + this.name_ + "' is being read outside a reactive context. Doing a full recompute."), (typeof this.requiresReaction_ == "boolean" ? this.requiresReaction_ : globalState.computedRequiresReaction) && console.warn("[mobx] Computed value '" + this.name_ + "' is being read outside a reactive context. Doing a full recompute."));
  }, e.toString = function() {
    return this.name_ + "[" + this.derivation.toString() + "]";
  }, e.valueOf = function() {
    return toPrimitive(this.get());
  }, e[_Symbol$toPrimitive$1] = function() {
    return this.valueOf();
  }, Bi;
}(), isComputedValue = /* @__PURE__ */ createInstanceofPredicate("ComputedValue", ComputedValue), IDerivationState_;
(function(Bi) {
  Bi[Bi.NOT_TRACKING_ = -1] = "NOT_TRACKING_", Bi[Bi.UP_TO_DATE_ = 0] = "UP_TO_DATE_", Bi[Bi.POSSIBLY_STALE_ = 1] = "POSSIBLY_STALE_", Bi[Bi.STALE_ = 2] = "STALE_";
})(IDerivationState_ || (IDerivationState_ = {}));
var TraceMode;
(function(Bi) {
  Bi[Bi.NONE = 0] = "NONE", Bi[Bi.LOG = 1] = "LOG", Bi[Bi.BREAK = 2] = "BREAK";
})(TraceMode || (TraceMode = {}));
var CaughtException = function(e) {
  this.cause = void 0, this.cause = e;
};
function isCaughtException(Bi) {
  return Bi instanceof CaughtException;
}
function shouldCompute(Bi) {
  switch (Bi.dependenciesState_) {
    case IDerivationState_.UP_TO_DATE_:
      return !1;
    case IDerivationState_.NOT_TRACKING_:
    case IDerivationState_.STALE_:
      return !0;
    case IDerivationState_.POSSIBLY_STALE_: {
      for (var e = allowStateReadsStart(!0), Ui = untrackedStart(), Zi = Bi.observing_, ta = Zi.length, na = 0; na < ta; na++) {
        var ia = Zi[na];
        if (isComputedValue(ia)) {
          if (globalState.disableErrorBoundaries)
            ia.get();
          else
            try {
              ia.get();
            } catch {
              return untrackedEnd(Ui), allowStateReadsEnd(e), !0;
            }
          if (Bi.dependenciesState_ === IDerivationState_.STALE_)
            return untrackedEnd(Ui), allowStateReadsEnd(e), !0;
        }
      }
      return changeDependenciesStateTo0(Bi), untrackedEnd(Ui), allowStateReadsEnd(e), !1;
    }
  }
}
function checkIfStateModificationsAreAllowed(Bi) {
  if (process.env.NODE_ENV !== "production") {
    var e = Bi.observers_.size > 0;
    !globalState.allowStateChanges && (e || globalState.enforceActions === "always") && console.warn("[MobX] " + (globalState.enforceActions ? "Since strict-mode is enabled, changing (observed) observable values without using an action is not allowed. Tried to modify: " : "Side effects like changing state are not allowed at this point. Are you trying to modify state from, for example, a computed value or the render function of a React component? You can wrap side effects in 'runInAction' (or decorate functions with 'action') if needed. Tried to modify: ") + Bi.name_);
  }
}
function checkIfStateReadsAreAllowed(Bi) {
  process.env.NODE_ENV !== "production" && !globalState.allowStateReads && globalState.observableRequiresReaction && console.warn("[mobx] Observable '" + Bi.name_ + "' being read outside a reactive context.");
}
function trackDerivedFunction(Bi, e, Ui) {
  var Zi = allowStateReadsStart(!0);
  changeDependenciesStateTo0(Bi), Bi.newObserving_ = new Array(Bi.observing_.length + 100), Bi.unboundDepsCount_ = 0, Bi.runId_ = ++globalState.runId;
  var ta = globalState.trackingDerivation;
  globalState.trackingDerivation = Bi, globalState.inBatch++;
  var na;
  if (globalState.disableErrorBoundaries === !0)
    na = e.call(Ui);
  else
    try {
      na = e.call(Ui);
    } catch (ia) {
      na = new CaughtException(ia);
    }
  return globalState.inBatch--, globalState.trackingDerivation = ta, bindDependencies(Bi), warnAboutDerivationWithoutDependencies(Bi), allowStateReadsEnd(Zi), na;
}
function warnAboutDerivationWithoutDependencies(Bi) {
  process.env.NODE_ENV !== "production" && Bi.observing_.length === 0 && (typeof Bi.requiresObservable_ == "boolean" ? Bi.requiresObservable_ : globalState.reactionRequiresObservable) && console.warn("[mobx] Derivation '" + Bi.name_ + "' is created/updated without reading any observable value.");
}
function bindDependencies(Bi) {
  for (var e = Bi.observing_, Ui = Bi.observing_ = Bi.newObserving_, Zi = IDerivationState_.UP_TO_DATE_, ta = 0, na = Bi.unboundDepsCount_, ia = 0; ia < na; ia++) {
    var aa = Ui[ia];
    aa.diffValue_ === 0 && (aa.diffValue_ = 1, ta !== ia && (Ui[ta] = aa), ta++), aa.dependenciesState_ > Zi && (Zi = aa.dependenciesState_);
  }
  for (Ui.length = ta, Bi.newObserving_ = null, na = e.length; na--; ) {
    var da = e[na];
    da.diffValue_ === 0 && removeObserver(da, Bi), da.diffValue_ = 0;
  }
  for (; ta--; ) {
    var La = Ui[ta];
    La.diffValue_ === 1 && (La.diffValue_ = 0, addObserver(La, Bi));
  }
  Zi !== IDerivationState_.UP_TO_DATE_ && (Bi.dependenciesState_ = Zi, Bi.onBecomeStale_());
}
function clearObserving(Bi) {
  var e = Bi.observing_;
  Bi.observing_ = [];
  for (var Ui = e.length; Ui--; )
    removeObserver(e[Ui], Bi);
  Bi.dependenciesState_ = IDerivationState_.NOT_TRACKING_;
}
function untracked(Bi) {
  var e = untrackedStart();
  try {
    return Bi();
  } finally {
    untrackedEnd(e);
  }
}
function untrackedStart() {
  var Bi = globalState.trackingDerivation;
  return globalState.trackingDerivation = null, Bi;
}
function untrackedEnd(Bi) {
  globalState.trackingDerivation = Bi;
}
function allowStateReadsStart(Bi) {
  var e = globalState.allowStateReads;
  return globalState.allowStateReads = Bi, e;
}
function allowStateReadsEnd(Bi) {
  globalState.allowStateReads = Bi;
}
function changeDependenciesStateTo0(Bi) {
  if (Bi.dependenciesState_ !== IDerivationState_.UP_TO_DATE_) {
    Bi.dependenciesState_ = IDerivationState_.UP_TO_DATE_;
    for (var e = Bi.observing_, Ui = e.length; Ui--; )
      e[Ui].lowestObserverState_ = IDerivationState_.UP_TO_DATE_;
  }
}
var MobXGlobals = function() {
  this.version = 6, this.UNCHANGED = {}, this.trackingDerivation = null, this.trackingContext = null, this.runId = 0, this.mobxGuid = 0, this.inBatch = 0, this.pendingUnobservations = [], this.pendingReactions = [], this.isRunningReactions = !1, this.allowStateChanges = !1, this.allowStateReads = !0, this.enforceActions = !0, this.spyListeners = [], this.globalReactionErrorHandlers = [], this.computedRequiresReaction = !1, this.reactionRequiresObservable = !1, this.observableRequiresReaction = !1, this.disableErrorBoundaries = !1, this.suppressReactionErrors = !1, this.useProxies = !0, this.verifyProxies = !1, this.safeDescriptors = !0;
}, canMergeGlobalState = !0, isolateCalled = !1, globalState = /* @__PURE__ */ function() {
  var Bi = /* @__PURE__ */ getGlobal();
  return Bi.__mobxInstanceCount > 0 && !Bi.__mobxGlobals && (canMergeGlobalState = !1), Bi.__mobxGlobals && Bi.__mobxGlobals.version !== new MobXGlobals().version && (canMergeGlobalState = !1), canMergeGlobalState ? Bi.__mobxGlobals ? (Bi.__mobxInstanceCount += 1, Bi.__mobxGlobals.UNCHANGED || (Bi.__mobxGlobals.UNCHANGED = {}), Bi.__mobxGlobals) : (Bi.__mobxInstanceCount = 1, Bi.__mobxGlobals = /* @__PURE__ */ new MobXGlobals()) : (setTimeout(function() {
    isolateCalled || die(35);
  }, 1), new MobXGlobals());
}();
function isolateGlobalState() {
  if ((globalState.pendingReactions.length || globalState.inBatch || globalState.isRunningReactions) && die(36), isolateCalled = !0, canMergeGlobalState) {
    var Bi = getGlobal();
    --Bi.__mobxInstanceCount === 0 && (Bi.__mobxGlobals = void 0), globalState = new MobXGlobals();
  }
}
function getGlobalState() {
  return globalState;
}
function addObserver(Bi, e) {
  Bi.observers_.add(e), Bi.lowestObserverState_ > e.dependenciesState_ && (Bi.lowestObserverState_ = e.dependenciesState_);
}
function removeObserver(Bi, e) {
  Bi.observers_.delete(e), Bi.observers_.size === 0 && queueForUnobservation(Bi);
}
function queueForUnobservation(Bi) {
  Bi.isPendingUnobservation_ === !1 && (Bi.isPendingUnobservation_ = !0, globalState.pendingUnobservations.push(Bi));
}
function startBatch() {
  globalState.inBatch++;
}
function endBatch() {
  if (--globalState.inBatch === 0) {
    runReactions();
    for (var Bi = globalState.pendingUnobservations, e = 0; e < Bi.length; e++) {
      var Ui = Bi[e];
      Ui.isPendingUnobservation_ = !1, Ui.observers_.size === 0 && (Ui.isBeingObserved_ && (Ui.isBeingObserved_ = !1, Ui.onBUO()), Ui instanceof ComputedValue && Ui.suspend_());
    }
    globalState.pendingUnobservations = [];
  }
}
function reportObserved(Bi) {
  checkIfStateReadsAreAllowed(Bi);
  var e = globalState.trackingDerivation;
  return e !== null ? (e.runId_ !== Bi.lastAccessedBy_ && (Bi.lastAccessedBy_ = e.runId_, e.newObserving_[e.unboundDepsCount_++] = Bi, !Bi.isBeingObserved_ && globalState.trackingContext && (Bi.isBeingObserved_ = !0, Bi.onBO())), Bi.isBeingObserved_) : (Bi.observers_.size === 0 && globalState.inBatch > 0 && queueForUnobservation(Bi), !1);
}
function propagateChanged(Bi) {
  Bi.lowestObserverState_ !== IDerivationState_.STALE_ && (Bi.lowestObserverState_ = IDerivationState_.STALE_, Bi.observers_.forEach(function(e) {
    e.dependenciesState_ === IDerivationState_.UP_TO_DATE_ && (process.env.NODE_ENV !== "production" && e.isTracing_ !== TraceMode.NONE && logTraceInfo(e, Bi), e.onBecomeStale_()), e.dependenciesState_ = IDerivationState_.STALE_;
  }));
}
function propagateChangeConfirmed(Bi) {
  Bi.lowestObserverState_ !== IDerivationState_.STALE_ && (Bi.lowestObserverState_ = IDerivationState_.STALE_, Bi.observers_.forEach(function(e) {
    e.dependenciesState_ === IDerivationState_.POSSIBLY_STALE_ ? (e.dependenciesState_ = IDerivationState_.STALE_, process.env.NODE_ENV !== "production" && e.isTracing_ !== TraceMode.NONE && logTraceInfo(e, Bi)) : e.dependenciesState_ === IDerivationState_.UP_TO_DATE_ && (Bi.lowestObserverState_ = IDerivationState_.UP_TO_DATE_);
  }));
}
function propagateMaybeChanged(Bi) {
  Bi.lowestObserverState_ === IDerivationState_.UP_TO_DATE_ && (Bi.lowestObserverState_ = IDerivationState_.POSSIBLY_STALE_, Bi.observers_.forEach(function(e) {
    e.dependenciesState_ === IDerivationState_.UP_TO_DATE_ && (e.dependenciesState_ = IDerivationState_.POSSIBLY_STALE_, e.onBecomeStale_());
  }));
}
function logTraceInfo(Bi, e) {
  if (console.log("[mobx.trace] '" + Bi.name_ + "' is invalidated due to a change in: '" + e.name_ + "'"), Bi.isTracing_ === TraceMode.BREAK) {
    var Ui = [];
    printDepTree(getDependencyTree(Bi), Ui, 1), new Function(`debugger;
/*
Tracing '` + Bi.name_ + `'

You are entering this break point because derivation '` + Bi.name_ + "' is being traced and '" + e.name_ + `' is now forcing it to update.
Just follow the stacktrace you should now see in the devtools to see precisely what piece of your code is causing this update
The stackframe you are looking for is at least ~6-8 stack-frames up.

` + (Bi instanceof ComputedValue ? Bi.derivation.toString().replace(/[*]\//g, "/") : "") + `

The dependencies for this derivation are:

` + Ui.join(`
`) + `
*/
    `)();
  }
}
function printDepTree(Bi, e, Ui) {
  if (e.length >= 1e3) {
    e.push("(and many more)");
    return;
  }
  e.push("" + "	".repeat(Ui - 1) + Bi.name), Bi.dependencies && Bi.dependencies.forEach(function(Zi) {
    return printDepTree(Zi, e, Ui + 1);
  });
}
var Reaction = /* @__PURE__ */ function() {
  function Bi(Ui, Zi, ta, na) {
    Ui === void 0 && (Ui = process.env.NODE_ENV !== "production" ? "Reaction@" + getNextId() : "Reaction"), this.name_ = void 0, this.onInvalidate_ = void 0, this.errorHandler_ = void 0, this.requiresObservable_ = void 0, this.observing_ = [], this.newObserving_ = [], this.dependenciesState_ = IDerivationState_.NOT_TRACKING_, this.diffValue_ = 0, this.runId_ = 0, this.unboundDepsCount_ = 0, this.isDisposed_ = !1, this.isScheduled_ = !1, this.isTrackPending_ = !1, this.isRunning_ = !1, this.isTracing_ = TraceMode.NONE, this.name_ = Ui, this.onInvalidate_ = Zi, this.errorHandler_ = ta, this.requiresObservable_ = na;
  }
  var e = Bi.prototype;
  return e.onBecomeStale_ = function() {
    this.schedule_();
  }, e.schedule_ = function() {
    this.isScheduled_ || (this.isScheduled_ = !0, globalState.pendingReactions.push(this), runReactions());
  }, e.isScheduled = function() {
    return this.isScheduled_;
  }, e.runReaction_ = function() {
    if (!this.isDisposed_) {
      startBatch(), this.isScheduled_ = !1;
      var Zi = globalState.trackingContext;
      if (globalState.trackingContext = this, shouldCompute(this)) {
        this.isTrackPending_ = !0;
        try {
          this.onInvalidate_(), process.env.NODE_ENV !== "production" && this.isTrackPending_ && isSpyEnabled() && spyReport({
            name: this.name_,
            type: "scheduled-reaction"
          });
        } catch (ta) {
          this.reportExceptionInDerivation_(ta);
        }
      }
      globalState.trackingContext = Zi, endBatch();
    }
  }, e.track = function(Zi) {
    if (!this.isDisposed_) {
      startBatch();
      var ta = isSpyEnabled(), na;
      process.env.NODE_ENV !== "production" && ta && (na = Date.now(), spyReportStart({
        name: this.name_,
        type: "reaction"
      })), this.isRunning_ = !0;
      var ia = globalState.trackingContext;
      globalState.trackingContext = this;
      var aa = trackDerivedFunction(this, Zi, void 0);
      globalState.trackingContext = ia, this.isRunning_ = !1, this.isTrackPending_ = !1, this.isDisposed_ && clearObserving(this), isCaughtException(aa) && this.reportExceptionInDerivation_(aa.cause), process.env.NODE_ENV !== "production" && ta && spyReportEnd({
        time: Date.now() - na
      }), endBatch();
    }
  }, e.reportExceptionInDerivation_ = function(Zi) {
    var ta = this;
    if (this.errorHandler_) {
      this.errorHandler_(Zi, this);
      return;
    }
    if (globalState.disableErrorBoundaries)
      throw Zi;
    var na = process.env.NODE_ENV !== "production" ? "[mobx] Encountered an uncaught exception that was thrown by a reaction or observer component, in: '" + this + "'" : "[mobx] uncaught error in '" + this + "'";
    globalState.suppressReactionErrors ? process.env.NODE_ENV !== "production" && console.warn("[mobx] (error in reaction '" + this.name_ + "' suppressed, fix error of causing action below)") : console.error(na, Zi), process.env.NODE_ENV !== "production" && isSpyEnabled() && spyReport({
      type: "error",
      name: this.name_,
      message: na,
      error: "" + Zi
    }), globalState.globalReactionErrorHandlers.forEach(function(ia) {
      return ia(Zi, ta);
    });
  }, e.dispose = function() {
    this.isDisposed_ || (this.isDisposed_ = !0, this.isRunning_ || (startBatch(), clearObserving(this), endBatch()));
  }, e.getDisposer_ = function(Zi) {
    var ta = this, na = function ia() {
      ta.dispose(), Zi == null || Zi.removeEventListener == null || Zi.removeEventListener("abort", ia);
    };
    return Zi == null || Zi.addEventListener == null || Zi.addEventListener("abort", na), na[$mobx] = this, na;
  }, e.toString = function() {
    return "Reaction[" + this.name_ + "]";
  }, e.trace = function(Zi) {
    Zi === void 0 && (Zi = !1), trace(this, Zi);
  }, Bi;
}(), MAX_REACTION_ITERATIONS = 100, reactionScheduler = function(e) {
  return e();
};
function runReactions() {
  globalState.inBatch > 0 || globalState.isRunningReactions || reactionScheduler(runReactionsHelper);
}
function runReactionsHelper() {
  globalState.isRunningReactions = !0;
  for (var Bi = globalState.pendingReactions, e = 0; Bi.length > 0; ) {
    ++e === MAX_REACTION_ITERATIONS && (console.error(process.env.NODE_ENV !== "production" ? "Reaction doesn't converge to a stable state after " + MAX_REACTION_ITERATIONS + " iterations." + (" Probably there is a cycle in the reactive function: " + Bi[0]) : "[mobx] cycle in reaction: " + Bi[0]), Bi.splice(0));
    for (var Ui = Bi.splice(0), Zi = 0, ta = Ui.length; Zi < ta; Zi++)
      Ui[Zi].runReaction_();
  }
  globalState.isRunningReactions = !1;
}
var isReaction = /* @__PURE__ */ createInstanceofPredicate("Reaction", Reaction);
function setReactionScheduler(Bi) {
  var e = reactionScheduler;
  reactionScheduler = function(Zi) {
    return Bi(function() {
      return e(Zi);
    });
  };
}
function isSpyEnabled() {
  return process.env.NODE_ENV !== "production" && !!globalState.spyListeners.length;
}
function spyReport(Bi) {
  if (process.env.NODE_ENV !== "production" && globalState.spyListeners.length)
    for (var e = globalState.spyListeners, Ui = 0, Zi = e.length; Ui < Zi; Ui++)
      e[Ui](Bi);
}
function spyReportStart(Bi) {
  if (process.env.NODE_ENV !== "production") {
    var e = _extends({}, Bi, {
      spyReportStart: !0
    });
    spyReport(e);
  }
}
var END_EVENT = {
  type: "report-end",
  spyReportEnd: !0
};
function spyReportEnd(Bi) {
  process.env.NODE_ENV !== "production" && spyReport(Bi ? _extends({}, Bi, {
    type: "report-end",
    spyReportEnd: !0
  }) : END_EVENT);
}
function spy(Bi) {
  return process.env.NODE_ENV === "production" ? (console.warn("[mobx.spy] Is a no-op in production builds"), function() {
  }) : (globalState.spyListeners.push(Bi), once(function() {
    globalState.spyListeners = globalState.spyListeners.filter(function(e) {
      return e !== Bi;
    });
  }));
}
var ACTION = "action", ACTION_BOUND = "action.bound", AUTOACTION = "autoAction", AUTOACTION_BOUND = "autoAction.bound", DEFAULT_ACTION_NAME = "<unnamed action>", actionAnnotation = /* @__PURE__ */ createActionAnnotation(ACTION), actionBoundAnnotation = /* @__PURE__ */ createActionAnnotation(ACTION_BOUND, {
  bound: !0
}), autoActionAnnotation = /* @__PURE__ */ createActionAnnotation(AUTOACTION, {
  autoAction: !0
}), autoActionBoundAnnotation = /* @__PURE__ */ createActionAnnotation(AUTOACTION_BOUND, {
  autoAction: !0,
  bound: !0
});
function createActionFactory(Bi) {
  var e = function(Zi, ta) {
    if (isFunction$1(Zi))
      return createAction(Zi.name || DEFAULT_ACTION_NAME, Zi, Bi);
    if (isFunction$1(ta))
      return createAction(Zi, ta, Bi);
    if (is20223Decorator(ta))
      return (Bi ? autoActionAnnotation : actionAnnotation).decorate_20223_(Zi, ta);
    if (isStringish(ta))
      return storeAnnotation(Zi, ta, Bi ? autoActionAnnotation : actionAnnotation);
    if (isStringish(Zi))
      return createDecoratorAnnotation(createActionAnnotation(Bi ? AUTOACTION : ACTION, {
        name: Zi,
        autoAction: Bi
      }));
    process.env.NODE_ENV !== "production" && die("Invalid arguments for `action`");
  };
  return e;
}
var action = /* @__PURE__ */ createActionFactory(!1);
Object.assign(action, actionAnnotation);
var autoAction = /* @__PURE__ */ createActionFactory(!0);
Object.assign(autoAction, autoActionAnnotation);
action.bound = /* @__PURE__ */ createDecoratorAnnotation(actionBoundAnnotation);
autoAction.bound = /* @__PURE__ */ createDecoratorAnnotation(autoActionBoundAnnotation);
function isAction(Bi) {
  return isFunction$1(Bi) && Bi.isMobxAction === !0;
}
function autorun(Bi, e) {
  var Ui, Zi, ta, na, ia;
  e === void 0 && (e = EMPTY_OBJECT), process.env.NODE_ENV !== "production" && (isFunction$1(Bi) || die("Autorun expects a function as first argument"), isAction(Bi) && die("Autorun does not accept actions since actions are untrackable"));
  var aa = (Ui = (Zi = e) == null ? void 0 : Zi.name) != null ? Ui : process.env.NODE_ENV !== "production" ? Bi.name || "Autorun@" + getNextId() : "Autorun", da = !e.scheduler && !e.delay, La;
  if (da)
    La = new Reaction(aa, function() {
      this.track(ao);
    }, e.onError, e.requiresObservable);
  else {
    var qa = createSchedulerFromOptions(e), io = !1;
    La = new Reaction(aa, function() {
      io || (io = !0, qa(function() {
        io = !1, La.isDisposed_ || La.track(ao);
      }));
    }, e.onError, e.requiresObservable);
  }
  function ao() {
    Bi(La);
  }
  return (ta = e) != null && (na = ta.signal) != null && na.aborted || La.schedule_(), La.getDisposer_((ia = e) == null ? void 0 : ia.signal);
}
var run = function(e) {
  return e();
};
function createSchedulerFromOptions(Bi) {
  return Bi.scheduler ? Bi.scheduler : Bi.delay ? function(e) {
    return setTimeout(e, Bi.delay);
  } : run;
}
var ON_BECOME_OBSERVED = "onBO", ON_BECOME_UNOBSERVED = "onBUO";
function onBecomeObserved(Bi, e, Ui) {
  return interceptHook(ON_BECOME_OBSERVED, Bi, e, Ui);
}
function onBecomeUnobserved(Bi, e, Ui) {
  return interceptHook(ON_BECOME_UNOBSERVED, Bi, e, Ui);
}
function interceptHook(Bi, e, Ui, Zi) {
  var ta = getAtom(e), na = isFunction$1(Zi) ? Zi : Ui, ia = Bi + "L";
  return ta[ia] ? ta[ia].add(na) : ta[ia] = /* @__PURE__ */ new Set([na]), function() {
    var aa = ta[ia];
    aa && (aa.delete(na), aa.size === 0 && delete ta[ia]);
  };
}
var NEVER = "never", ALWAYS = "always", OBSERVED = "observed";
function configure(Bi) {
  Bi.isolateGlobalState === !0 && isolateGlobalState();
  var e = Bi.useProxies, Ui = Bi.enforceActions;
  if (e !== void 0 && (globalState.useProxies = e === ALWAYS ? !0 : e === NEVER ? !1 : typeof Proxy < "u"), e === "ifavailable" && (globalState.verifyProxies = !0), Ui !== void 0) {
    var Zi = Ui === ALWAYS ? ALWAYS : Ui === OBSERVED;
    globalState.enforceActions = Zi, globalState.allowStateChanges = !(Zi === !0 || Zi === ALWAYS);
  }
  ["computedRequiresReaction", "reactionRequiresObservable", "observableRequiresReaction", "disableErrorBoundaries", "safeDescriptors"].forEach(function(ta) {
    ta in Bi && (globalState[ta] = !!Bi[ta]);
  }), globalState.allowStateReads = !globalState.observableRequiresReaction, process.env.NODE_ENV !== "production" && globalState.disableErrorBoundaries === !0 && console.warn("WARNING: Debug feature only. MobX will NOT recover from errors when `disableErrorBoundaries` is enabled."), Bi.reactionScheduler && setReactionScheduler(Bi.reactionScheduler);
}
function extendObservable(Bi, e, Ui, Zi) {
  process.env.NODE_ENV !== "production" && (arguments.length > 4 && die("'extendObservable' expected 2-4 arguments"), typeof Bi != "object" && die("'extendObservable' expects an object as first argument"), isObservableMap(Bi) && die("'extendObservable' should not be used on maps, use map.merge instead"), isPlainObject$2(e) || die("'extendObservable' only accepts plain objects as second argument"), (isObservable(e) || isObservable(Ui)) && die("Extending an object with another observable (object) is not supported"));
  var ta = getOwnPropertyDescriptors(e);
  return initObservable(function() {
    var na = asObservableObject(Bi, Zi)[$mobx];
    ownKeys$2(ta).forEach(function(ia) {
      na.extend_(
        ia,
        ta[ia],
        // must pass "undefined" for { key: undefined }
        Ui && ia in Ui ? Ui[ia] : !0
      );
    });
  }), Bi;
}
function getDependencyTree(Bi, e) {
  return nodeToDependencyTree(getAtom(Bi, e));
}
function nodeToDependencyTree(Bi) {
  var e = {
    name: Bi.name_
  };
  return Bi.observing_ && Bi.observing_.length > 0 && (e.dependencies = unique(Bi.observing_).map(nodeToDependencyTree)), e;
}
function unique(Bi) {
  return Array.from(new Set(Bi));
}
var generatorId = 0;
function FlowCancellationError() {
  this.message = "FLOW_CANCELLED";
}
FlowCancellationError.prototype = /* @__PURE__ */ Object.create(Error.prototype);
var flowAnnotation = /* @__PURE__ */ createFlowAnnotation("flow"), flowBoundAnnotation = /* @__PURE__ */ createFlowAnnotation("flow.bound", {
  bound: !0
}), flow = /* @__PURE__ */ Object.assign(function(e, Ui) {
  if (is20223Decorator(Ui))
    return flowAnnotation.decorate_20223_(e, Ui);
  if (isStringish(Ui))
    return storeAnnotation(e, Ui, flowAnnotation);
  process.env.NODE_ENV !== "production" && arguments.length !== 1 && die("Flow expects single argument with generator function");
  var Zi = e, ta = Zi.name || "<unnamed flow>", na = function() {
    var aa = this, da = arguments, La = ++generatorId, qa = action(ta + " - runid: " + La + " - init", Zi).apply(aa, da), io, ao = void 0, oo = new Promise(function(no, lo) {
      var so = 0;
      io = lo;
      function bs(qs) {
        ao = void 0;
        var jo;
        try {
          jo = action(ta + " - runid: " + La + " - yield " + so++, qa.next).call(qa, qs);
        } catch (fs) {
          return lo(fs);
        }
        js(jo);
      }
      function Rs(qs) {
        ao = void 0;
        var jo;
        try {
          jo = action(ta + " - runid: " + La + " - yield " + so++, qa.throw).call(qa, qs);
        } catch (fs) {
          return lo(fs);
        }
        js(jo);
      }
      function js(qs) {
        if (isFunction$1(qs?.then)) {
          qs.then(js, lo);
          return;
        }
        return qs.done ? no(qs.value) : (ao = Promise.resolve(qs.value), ao.then(bs, Rs));
      }
      bs(void 0);
    });
    return oo.cancel = action(ta + " - runid: " + La + " - cancel", function() {
      try {
        ao && cancelPromise(ao);
        var no = qa.return(void 0), lo = Promise.resolve(no.value);
        lo.then(noop$1, noop$1), cancelPromise(lo), io(new FlowCancellationError());
      } catch (so) {
        io(so);
      }
    }), oo;
  };
  return na.isMobXFlow = !0, na;
}, flowAnnotation);
flow.bound = /* @__PURE__ */ createDecoratorAnnotation(flowBoundAnnotation);
function cancelPromise(Bi) {
  isFunction$1(Bi.cancel) && Bi.cancel();
}
function isFlow(Bi) {
  return Bi?.isMobXFlow === !0;
}
function _isObservable(Bi, e) {
  return Bi ? isObservableObject(Bi) || !!Bi[$mobx] || isAtom(Bi) || isReaction(Bi) || isComputedValue(Bi) : !1;
}
function isObservable(Bi) {
  return process.env.NODE_ENV !== "production" && arguments.length !== 1 && die("isObservable expects only 1 argument. Use isObservableProp to inspect the observability of a property"), _isObservable(Bi);
}
function trace() {
  if (process.env.NODE_ENV !== "production") {
    for (var Bi = !1, e = arguments.length, Ui = new Array(e), Zi = 0; Zi < e; Zi++)
      Ui[Zi] = arguments[Zi];
    typeof Ui[Ui.length - 1] == "boolean" && (Bi = Ui.pop());
    var ta = getAtomFromArgs(Ui);
    if (!ta)
      return die("'trace(break?)' can only be used inside a tracked computed value or a Reaction. Consider passing in the computed value or reaction explicitly");
    ta.isTracing_ === TraceMode.NONE && console.log("[mobx.trace] '" + ta.name_ + "' tracing enabled"), ta.isTracing_ = Bi ? TraceMode.BREAK : TraceMode.LOG;
  }
}
function getAtomFromArgs(Bi) {
  switch (Bi.length) {
    case 0:
      return globalState.trackingDerivation;
    case 1:
      return getAtom(Bi[0]);
    case 2:
      return getAtom(Bi[0], Bi[1]);
  }
}
function transaction(Bi, e) {
  e === void 0 && (e = void 0), startBatch();
  try {
    return Bi.apply(e);
  } finally {
    endBatch();
  }
}
function getAdm(Bi) {
  return Bi[$mobx];
}
var objectProxyTraps = {
  has: function(e, Ui) {
    return process.env.NODE_ENV !== "production" && globalState.trackingDerivation && warnAboutProxyRequirement("detect new properties using the 'in' operator. Use 'has' from 'mobx' instead."), getAdm(e).has_(Ui);
  },
  get: function(e, Ui) {
    return getAdm(e).get_(Ui);
  },
  set: function(e, Ui, Zi) {
    var ta;
    return isStringish(Ui) ? (process.env.NODE_ENV !== "production" && !getAdm(e).values_.has(Ui) && warnAboutProxyRequirement("add a new observable property through direct assignment. Use 'set' from 'mobx' instead."), (ta = getAdm(e).set_(Ui, Zi, !0)) != null ? ta : !0) : !1;
  },
  deleteProperty: function(e, Ui) {
    var Zi;
    return process.env.NODE_ENV !== "production" && warnAboutProxyRequirement("delete properties from an observable object. Use 'remove' from 'mobx' instead."), isStringish(Ui) ? (Zi = getAdm(e).delete_(Ui, !0)) != null ? Zi : !0 : !1;
  },
  defineProperty: function(e, Ui, Zi) {
    var ta;
    return process.env.NODE_ENV !== "production" && warnAboutProxyRequirement("define property on an observable object. Use 'defineProperty' from 'mobx' instead."), (ta = getAdm(e).defineProperty_(Ui, Zi)) != null ? ta : !0;
  },
  ownKeys: function(e) {
    return process.env.NODE_ENV !== "production" && globalState.trackingDerivation && warnAboutProxyRequirement("iterate keys to detect added / removed properties. Use 'keys' from 'mobx' instead."), getAdm(e).ownKeys_();
  },
  preventExtensions: function(e) {
    die(13);
  }
};
function asDynamicObservableObject(Bi, e) {
  var Ui, Zi;
  return assertProxies(), Bi = asObservableObject(Bi, e), (Zi = (Ui = Bi[$mobx]).proxy_) != null ? Zi : Ui.proxy_ = new Proxy(Bi, objectProxyTraps);
}
function hasInterceptors(Bi) {
  return Bi.interceptors_ !== void 0 && Bi.interceptors_.length > 0;
}
function registerInterceptor(Bi, e) {
  var Ui = Bi.interceptors_ || (Bi.interceptors_ = []);
  return Ui.push(e), once(function() {
    var Zi = Ui.indexOf(e);
    Zi !== -1 && Ui.splice(Zi, 1);
  });
}
function interceptChange(Bi, e) {
  var Ui = untrackedStart();
  try {
    for (var Zi = [].concat(Bi.interceptors_ || []), ta = 0, na = Zi.length; ta < na && (e = Zi[ta](e), e && !e.type && die(14), !!e); ta++)
      ;
    return e;
  } finally {
    untrackedEnd(Ui);
  }
}
function hasListeners(Bi) {
  return Bi.changeListeners_ !== void 0 && Bi.changeListeners_.length > 0;
}
function registerListener(Bi, e) {
  var Ui = Bi.changeListeners_ || (Bi.changeListeners_ = []);
  return Ui.push(e), once(function() {
    var Zi = Ui.indexOf(e);
    Zi !== -1 && Ui.splice(Zi, 1);
  });
}
function notifyListeners(Bi, e) {
  var Ui = untrackedStart(), Zi = Bi.changeListeners_;
  if (Zi) {
    Zi = Zi.slice();
    for (var ta = 0, na = Zi.length; ta < na; ta++)
      Zi[ta](e);
    untrackedEnd(Ui);
  }
}
function makeObservable(Bi, e, Ui) {
  return initObservable(function() {
    var Zi, ta = asObservableObject(Bi, Ui)[$mobx];
    process.env.NODE_ENV !== "production" && e && Bi[storedAnnotationsSymbol] && die("makeObservable second arg must be nullish when using decorators. Mixing @decorator syntax with annotations is not supported."), (Zi = e) != null || (e = collectStoredAnnotations(Bi)), ownKeys$2(e).forEach(function(na) {
      return ta.make_(na, e[na]);
    });
  }), Bi;
}
var keysSymbol = /* @__PURE__ */ Symbol("mobx-keys");
function makeAutoObservable(Bi, e, Ui) {
  return process.env.NODE_ENV !== "production" && (!isPlainObject$2(Bi) && !isPlainObject$2(Object.getPrototypeOf(Bi)) && die("'makeAutoObservable' can only be used for classes that don't have a superclass"), isObservableObject(Bi) && die("makeAutoObservable can only be used on objects not already made observable")), isPlainObject$2(Bi) ? extendObservable(Bi, Bi, e, Ui) : (initObservable(function() {
    var Zi = asObservableObject(Bi, Ui)[$mobx];
    if (!Bi[keysSymbol]) {
      var ta = Object.getPrototypeOf(Bi), na = new Set([].concat(ownKeys$2(Bi), ownKeys$2(ta)));
      na.delete("constructor"), na.delete($mobx), addHiddenProp(ta, keysSymbol, na);
    }
    Bi[keysSymbol].forEach(function(ia) {
      return Zi.make_(
        ia,
        // must pass "undefined" for { key: undefined }
        e && ia in e ? e[ia] : !0
      );
    });
  }), Bi);
}
var SPLICE = "splice", UPDATE = "update", MAX_SPLICE_SIZE = 1e4, arrayTraps = {
  get: function(e, Ui) {
    var Zi = e[$mobx];
    return Ui === $mobx ? Zi : Ui === "length" ? Zi.getArrayLength_() : typeof Ui == "string" && !isNaN(Ui) ? Zi.get_(parseInt(Ui)) : hasProp(arrayExtensions, Ui) ? arrayExtensions[Ui] : e[Ui];
  },
  set: function(e, Ui, Zi) {
    var ta = e[$mobx];
    return Ui === "length" && ta.setArrayLength_(Zi), typeof Ui == "symbol" || isNaN(Ui) ? e[Ui] = Zi : ta.set_(parseInt(Ui), Zi), !0;
  },
  preventExtensions: function() {
    die(15);
  }
}, ObservableArrayAdministration = /* @__PURE__ */ function() {
  function Bi(Ui, Zi, ta, na) {
    Ui === void 0 && (Ui = process.env.NODE_ENV !== "production" ? "ObservableArray@" + getNextId() : "ObservableArray"), this.owned_ = void 0, this.legacyMode_ = void 0, this.atom_ = void 0, this.values_ = [], this.interceptors_ = void 0, this.changeListeners_ = void 0, this.enhancer_ = void 0, this.dehancer = void 0, this.proxy_ = void 0, this.lastKnownLength_ = 0, this.owned_ = ta, this.legacyMode_ = na, this.atom_ = new Atom(Ui), this.enhancer_ = function(ia, aa) {
      return Zi(ia, aa, process.env.NODE_ENV !== "production" ? Ui + "[..]" : "ObservableArray[..]");
    };
  }
  var e = Bi.prototype;
  return e.dehanceValue_ = function(Zi) {
    return this.dehancer !== void 0 ? this.dehancer(Zi) : Zi;
  }, e.dehanceValues_ = function(Zi) {
    return this.dehancer !== void 0 && Zi.length > 0 ? Zi.map(this.dehancer) : Zi;
  }, e.intercept_ = function(Zi) {
    return registerInterceptor(this, Zi);
  }, e.observe_ = function(Zi, ta) {
    return ta === void 0 && (ta = !1), ta && Zi({
      observableKind: "array",
      object: this.proxy_,
      debugObjectName: this.atom_.name_,
      type: "splice",
      index: 0,
      added: this.values_.slice(),
      addedCount: this.values_.length,
      removed: [],
      removedCount: 0
    }), registerListener(this, Zi);
  }, e.getArrayLength_ = function() {
    return this.atom_.reportObserved(), this.values_.length;
  }, e.setArrayLength_ = function(Zi) {
    (typeof Zi != "number" || isNaN(Zi) || Zi < 0) && die("Out of range: " + Zi);
    var ta = this.values_.length;
    if (Zi !== ta)
      if (Zi > ta) {
        for (var na = new Array(Zi - ta), ia = 0; ia < Zi - ta; ia++)
          na[ia] = void 0;
        this.spliceWithArray_(ta, 0, na);
      } else
        this.spliceWithArray_(Zi, ta - Zi);
  }, e.updateArrayLength_ = function(Zi, ta) {
    Zi !== this.lastKnownLength_ && die(16), this.lastKnownLength_ += ta, this.legacyMode_ && ta > 0 && reserveArrayBuffer(Zi + ta + 1);
  }, e.spliceWithArray_ = function(Zi, ta, na) {
    var ia = this;
    checkIfStateModificationsAreAllowed(this.atom_);
    var aa = this.values_.length;
    if (Zi === void 0 ? Zi = 0 : Zi > aa ? Zi = aa : Zi < 0 && (Zi = Math.max(0, aa + Zi)), arguments.length === 1 ? ta = aa - Zi : ta == null ? ta = 0 : ta = Math.max(0, Math.min(ta, aa - Zi)), na === void 0 && (na = EMPTY_ARRAY), hasInterceptors(this)) {
      var da = interceptChange(this, {
        object: this.proxy_,
        type: SPLICE,
        index: Zi,
        removedCount: ta,
        added: na
      });
      if (!da)
        return EMPTY_ARRAY;
      ta = da.removedCount, na = da.added;
    }
    if (na = na.length === 0 ? na : na.map(function(io) {
      return ia.enhancer_(io, void 0);
    }), this.legacyMode_ || process.env.NODE_ENV !== "production") {
      var La = na.length - ta;
      this.updateArrayLength_(aa, La);
    }
    var qa = this.spliceItemsIntoValues_(Zi, ta, na);
    return (ta !== 0 || na.length !== 0) && this.notifyArraySplice_(Zi, na, qa), this.dehanceValues_(qa);
  }, e.spliceItemsIntoValues_ = function(Zi, ta, na) {
    if (na.length < MAX_SPLICE_SIZE) {
      var ia;
      return (ia = this.values_).splice.apply(ia, [Zi, ta].concat(na));
    } else {
      var aa = this.values_.slice(Zi, Zi + ta), da = this.values_.slice(Zi + ta);
      this.values_.length += na.length - ta;
      for (var La = 0; La < na.length; La++)
        this.values_[Zi + La] = na[La];
      for (var qa = 0; qa < da.length; qa++)
        this.values_[Zi + na.length + qa] = da[qa];
      return aa;
    }
  }, e.notifyArrayChildUpdate_ = function(Zi, ta, na) {
    var ia = !this.owned_ && isSpyEnabled(), aa = hasListeners(this), da = aa || ia ? {
      observableKind: "array",
      object: this.proxy_,
      type: UPDATE,
      debugObjectName: this.atom_.name_,
      index: Zi,
      newValue: ta,
      oldValue: na
    } : null;
    process.env.NODE_ENV !== "production" && ia && spyReportStart(da), this.atom_.reportChanged(), aa && notifyListeners(this, da), process.env.NODE_ENV !== "production" && ia && spyReportEnd();
  }, e.notifyArraySplice_ = function(Zi, ta, na) {
    var ia = !this.owned_ && isSpyEnabled(), aa = hasListeners(this), da = aa || ia ? {
      observableKind: "array",
      object: this.proxy_,
      debugObjectName: this.atom_.name_,
      type: SPLICE,
      index: Zi,
      removed: na,
      added: ta,
      removedCount: na.length,
      addedCount: ta.length
    } : null;
    process.env.NODE_ENV !== "production" && ia && spyReportStart(da), this.atom_.reportChanged(), aa && notifyListeners(this, da), process.env.NODE_ENV !== "production" && ia && spyReportEnd();
  }, e.get_ = function(Zi) {
    if (this.legacyMode_ && Zi >= this.values_.length) {
      console.warn(process.env.NODE_ENV !== "production" ? "[mobx.array] Attempt to read an array index (" + Zi + ") that is out of bounds (" + this.values_.length + "). Please check length first. Out of bound indices will not be tracked by MobX" : "[mobx] Out of bounds read: " + Zi);
      return;
    }
    return this.atom_.reportObserved(), this.dehanceValue_(this.values_[Zi]);
  }, e.set_ = function(Zi, ta) {
    var na = this.values_;
    if (this.legacyMode_ && Zi > na.length && die(17, Zi, na.length), Zi < na.length) {
      checkIfStateModificationsAreAllowed(this.atom_);
      var ia = na[Zi];
      if (hasInterceptors(this)) {
        var aa = interceptChange(this, {
          type: UPDATE,
          object: this.proxy_,
          index: Zi,
          newValue: ta
        });
        if (!aa)
          return;
        ta = aa.newValue;
      }
      ta = this.enhancer_(ta, ia);
      var da = ta !== ia;
      da && (na[Zi] = ta, this.notifyArrayChildUpdate_(Zi, ta, ia));
    } else {
      for (var La = new Array(Zi + 1 - na.length), qa = 0; qa < La.length - 1; qa++)
        La[qa] = void 0;
      La[La.length - 1] = ta, this.spliceWithArray_(na.length, 0, La);
    }
  }, Bi;
}();
function createObservableArray(Bi, e, Ui, Zi) {
  return Ui === void 0 && (Ui = process.env.NODE_ENV !== "production" ? "ObservableArray@" + getNextId() : "ObservableArray"), Zi === void 0 && (Zi = !1), assertProxies(), initObservable(function() {
    var ta = new ObservableArrayAdministration(Ui, e, Zi, !1);
    addHiddenFinalProp(ta.values_, $mobx, ta);
    var na = new Proxy(ta.values_, arrayTraps);
    return ta.proxy_ = na, Bi && Bi.length && ta.spliceWithArray_(0, 0, Bi), na;
  });
}
var arrayExtensions = {
  clear: function() {
    return this.splice(0);
  },
  replace: function(e) {
    var Ui = this[$mobx];
    return Ui.spliceWithArray_(0, Ui.values_.length, e);
  },
  // Used by JSON.stringify
  toJSON: function() {
    return this.slice();
  },
  /*
   * functions that do alter the internal structure of the array, (based on lib.es6.d.ts)
   * since these functions alter the inner structure of the array, the have side effects.
   * Because the have side effects, they should not be used in computed function,
   * and for that reason the do not call dependencyState.notifyObserved
   */
  splice: function(e, Ui) {
    for (var Zi = arguments.length, ta = new Array(Zi > 2 ? Zi - 2 : 0), na = 2; na < Zi; na++)
      ta[na - 2] = arguments[na];
    var ia = this[$mobx];
    switch (arguments.length) {
      case 0:
        return [];
      case 1:
        return ia.spliceWithArray_(e);
      case 2:
        return ia.spliceWithArray_(e, Ui);
    }
    return ia.spliceWithArray_(e, Ui, ta);
  },
  spliceWithArray: function(e, Ui, Zi) {
    return this[$mobx].spliceWithArray_(e, Ui, Zi);
  },
  push: function() {
    for (var e = this[$mobx], Ui = arguments.length, Zi = new Array(Ui), ta = 0; ta < Ui; ta++)
      Zi[ta] = arguments[ta];
    return e.spliceWithArray_(e.values_.length, 0, Zi), e.values_.length;
  },
  pop: function() {
    return this.splice(Math.max(this[$mobx].values_.length - 1, 0), 1)[0];
  },
  shift: function() {
    return this.splice(0, 1)[0];
  },
  unshift: function() {
    for (var e = this[$mobx], Ui = arguments.length, Zi = new Array(Ui), ta = 0; ta < Ui; ta++)
      Zi[ta] = arguments[ta];
    return e.spliceWithArray_(0, 0, Zi), e.values_.length;
  },
  reverse: function() {
    return globalState.trackingDerivation && die(37, "reverse"), this.replace(this.slice().reverse()), this;
  },
  sort: function() {
    globalState.trackingDerivation && die(37, "sort");
    var e = this.slice();
    return e.sort.apply(e, arguments), this.replace(e), this;
  },
  remove: function(e) {
    var Ui = this[$mobx], Zi = Ui.dehanceValues_(Ui.values_).indexOf(e);
    return Zi > -1 ? (this.splice(Zi, 1), !0) : !1;
  }
};
addArrayExtension("at", simpleFunc);
addArrayExtension("concat", simpleFunc);
addArrayExtension("flat", simpleFunc);
addArrayExtension("includes", simpleFunc);
addArrayExtension("indexOf", simpleFunc);
addArrayExtension("join", simpleFunc);
addArrayExtension("lastIndexOf", simpleFunc);
addArrayExtension("slice", simpleFunc);
addArrayExtension("toString", simpleFunc);
addArrayExtension("toLocaleString", simpleFunc);
addArrayExtension("toSorted", simpleFunc);
addArrayExtension("toSpliced", simpleFunc);
addArrayExtension("with", simpleFunc);
addArrayExtension("every", mapLikeFunc);
addArrayExtension("filter", mapLikeFunc);
addArrayExtension("find", mapLikeFunc);
addArrayExtension("findIndex", mapLikeFunc);
addArrayExtension("findLast", mapLikeFunc);
addArrayExtension("findLastIndex", mapLikeFunc);
addArrayExtension("flatMap", mapLikeFunc);
addArrayExtension("forEach", mapLikeFunc);
addArrayExtension("map", mapLikeFunc);
addArrayExtension("some", mapLikeFunc);
addArrayExtension("toReversed", mapLikeFunc);
addArrayExtension("reduce", reduceLikeFunc);
addArrayExtension("reduceRight", reduceLikeFunc);
function addArrayExtension(Bi, e) {
  typeof Array.prototype[Bi] == "function" && (arrayExtensions[Bi] = e(Bi));
}
function simpleFunc(Bi) {
  return function() {
    var e = this[$mobx];
    e.atom_.reportObserved();
    var Ui = e.dehanceValues_(e.values_);
    return Ui[Bi].apply(Ui, arguments);
  };
}
function mapLikeFunc(Bi) {
  return function(e, Ui) {
    var Zi = this, ta = this[$mobx];
    ta.atom_.reportObserved();
    var na = ta.dehanceValues_(ta.values_);
    return na[Bi](function(ia, aa) {
      return e.call(Ui, ia, aa, Zi);
    });
  };
}
function reduceLikeFunc(Bi) {
  return function() {
    var e = this, Ui = this[$mobx];
    Ui.atom_.reportObserved();
    var Zi = Ui.dehanceValues_(Ui.values_), ta = arguments[0];
    return arguments[0] = function(na, ia, aa) {
      return ta(na, ia, aa, e);
    }, Zi[Bi].apply(Zi, arguments);
  };
}
var isObservableArrayAdministration = /* @__PURE__ */ createInstanceofPredicate("ObservableArrayAdministration", ObservableArrayAdministration);
function isObservableArray(Bi) {
  return isObject$3(Bi) && isObservableArrayAdministration(Bi[$mobx]);
}
var _Symbol$iterator, _Symbol$toStringTag, ObservableMapMarker = {}, ADD = "add", DELETE = "delete";
_Symbol$iterator = Symbol.iterator;
_Symbol$toStringTag = Symbol.toStringTag;
var ObservableMap = /* @__PURE__ */ function() {
  function Bi(Ui, Zi, ta) {
    var na = this;
    Zi === void 0 && (Zi = deepEnhancer), ta === void 0 && (ta = process.env.NODE_ENV !== "production" ? "ObservableMap@" + getNextId() : "ObservableMap"), this.enhancer_ = void 0, this.name_ = void 0, this[$mobx] = ObservableMapMarker, this.data_ = void 0, this.hasMap_ = void 0, this.keysAtom_ = void 0, this.interceptors_ = void 0, this.changeListeners_ = void 0, this.dehancer = void 0, this.enhancer_ = Zi, this.name_ = ta, isFunction$1(Map) || die(18), initObservable(function() {
      na.keysAtom_ = createAtom(process.env.NODE_ENV !== "production" ? na.name_ + ".keys()" : "ObservableMap.keys()"), na.data_ = /* @__PURE__ */ new Map(), na.hasMap_ = /* @__PURE__ */ new Map(), Ui && na.merge(Ui);
    });
  }
  var e = Bi.prototype;
  return e.has_ = function(Zi) {
    return this.data_.has(Zi);
  }, e.has = function(Zi) {
    var ta = this;
    if (!globalState.trackingDerivation)
      return this.has_(Zi);
    var na = this.hasMap_.get(Zi);
    if (!na) {
      var ia = na = new ObservableValue(this.has_(Zi), referenceEnhancer, process.env.NODE_ENV !== "production" ? this.name_ + "." + stringifyKey(Zi) + "?" : "ObservableMap.key?", !1);
      this.hasMap_.set(Zi, ia), onBecomeUnobserved(ia, function() {
        return ta.hasMap_.delete(Zi);
      });
    }
    return na.get();
  }, e.set = function(Zi, ta) {
    var na = this.has_(Zi);
    if (hasInterceptors(this)) {
      var ia = interceptChange(this, {
        type: na ? UPDATE : ADD,
        object: this,
        newValue: ta,
        name: Zi
      });
      if (!ia)
        return this;
      ta = ia.newValue;
    }
    return na ? this.updateValue_(Zi, ta) : this.addValue_(Zi, ta), this;
  }, e.delete = function(Zi) {
    var ta = this;
    if (checkIfStateModificationsAreAllowed(this.keysAtom_), hasInterceptors(this)) {
      var na = interceptChange(this, {
        type: DELETE,
        object: this,
        name: Zi
      });
      if (!na)
        return !1;
    }
    if (this.has_(Zi)) {
      var ia = isSpyEnabled(), aa = hasListeners(this), da = aa || ia ? {
        observableKind: "map",
        debugObjectName: this.name_,
        type: DELETE,
        object: this,
        oldValue: this.data_.get(Zi).value_,
        name: Zi
      } : null;
      return process.env.NODE_ENV !== "production" && ia && spyReportStart(da), transaction(function() {
        var La;
        ta.keysAtom_.reportChanged(), (La = ta.hasMap_.get(Zi)) == null || La.setNewValue_(!1);
        var qa = ta.data_.get(Zi);
        qa.setNewValue_(void 0), ta.data_.delete(Zi);
      }), aa && notifyListeners(this, da), process.env.NODE_ENV !== "production" && ia && spyReportEnd(), !0;
    }
    return !1;
  }, e.updateValue_ = function(Zi, ta) {
    var na = this.data_.get(Zi);
    if (ta = na.prepareNewValue_(ta), ta !== globalState.UNCHANGED) {
      var ia = isSpyEnabled(), aa = hasListeners(this), da = aa || ia ? {
        observableKind: "map",
        debugObjectName: this.name_,
        type: UPDATE,
        object: this,
        oldValue: na.value_,
        name: Zi,
        newValue: ta
      } : null;
      process.env.NODE_ENV !== "production" && ia && spyReportStart(da), na.setNewValue_(ta), aa && notifyListeners(this, da), process.env.NODE_ENV !== "production" && ia && spyReportEnd();
    }
  }, e.addValue_ = function(Zi, ta) {
    var na = this;
    checkIfStateModificationsAreAllowed(this.keysAtom_), transaction(function() {
      var La, qa = new ObservableValue(ta, na.enhancer_, process.env.NODE_ENV !== "production" ? na.name_ + "." + stringifyKey(Zi) : "ObservableMap.key", !1);
      na.data_.set(Zi, qa), ta = qa.value_, (La = na.hasMap_.get(Zi)) == null || La.setNewValue_(!0), na.keysAtom_.reportChanged();
    });
    var ia = isSpyEnabled(), aa = hasListeners(this), da = aa || ia ? {
      observableKind: "map",
      debugObjectName: this.name_,
      type: ADD,
      object: this,
      name: Zi,
      newValue: ta
    } : null;
    process.env.NODE_ENV !== "production" && ia && spyReportStart(da), aa && notifyListeners(this, da), process.env.NODE_ENV !== "production" && ia && spyReportEnd();
  }, e.get = function(Zi) {
    return this.has(Zi) ? this.dehanceValue_(this.data_.get(Zi).get()) : this.dehanceValue_(void 0);
  }, e.dehanceValue_ = function(Zi) {
    return this.dehancer !== void 0 ? this.dehancer(Zi) : Zi;
  }, e.keys = function() {
    return this.keysAtom_.reportObserved(), this.data_.keys();
  }, e.values = function() {
    var Zi = this, ta = this.keys();
    return makeIterable({
      next: function() {
        var ia = ta.next(), aa = ia.done, da = ia.value;
        return {
          done: aa,
          value: aa ? void 0 : Zi.get(da)
        };
      }
    });
  }, e.entries = function() {
    var Zi = this, ta = this.keys();
    return makeIterable({
      next: function() {
        var ia = ta.next(), aa = ia.done, da = ia.value;
        return {
          done: aa,
          value: aa ? void 0 : [da, Zi.get(da)]
        };
      }
    });
  }, e[_Symbol$iterator] = function() {
    return this.entries();
  }, e.forEach = function(Zi, ta) {
    for (var na = _createForOfIteratorHelperLoose(this), ia; !(ia = na()).done; ) {
      var aa = ia.value, da = aa[0], La = aa[1];
      Zi.call(ta, La, da, this);
    }
  }, e.merge = function(Zi) {
    var ta = this;
    return isObservableMap(Zi) && (Zi = new Map(Zi)), transaction(function() {
      isPlainObject$2(Zi) ? getPlainObjectKeys(Zi).forEach(function(na) {
        return ta.set(na, Zi[na]);
      }) : Array.isArray(Zi) ? Zi.forEach(function(na) {
        var ia = na[0], aa = na[1];
        return ta.set(ia, aa);
      }) : isES6Map(Zi) ? (Zi.constructor !== Map && die(19, Zi), Zi.forEach(function(na, ia) {
        return ta.set(ia, na);
      })) : Zi != null && die(20, Zi);
    }), this;
  }, e.clear = function() {
    var Zi = this;
    transaction(function() {
      untracked(function() {
        for (var ta = _createForOfIteratorHelperLoose(Zi.keys()), na; !(na = ta()).done; ) {
          var ia = na.value;
          Zi.delete(ia);
        }
      });
    });
  }, e.replace = function(Zi) {
    var ta = this;
    return transaction(function() {
      for (var na = convertToMap(Zi), ia = /* @__PURE__ */ new Map(), aa = !1, da = _createForOfIteratorHelperLoose(ta.data_.keys()), La; !(La = da()).done; ) {
        var qa = La.value;
        if (!na.has(qa)) {
          var io = ta.delete(qa);
          if (io)
            aa = !0;
          else {
            var ao = ta.data_.get(qa);
            ia.set(qa, ao);
          }
        }
      }
      for (var oo = _createForOfIteratorHelperLoose(na.entries()), no; !(no = oo()).done; ) {
        var lo = no.value, so = lo[0], bs = lo[1], Rs = ta.data_.has(so);
        if (ta.set(so, bs), ta.data_.has(so)) {
          var js = ta.data_.get(so);
          ia.set(so, js), Rs || (aa = !0);
        }
      }
      if (!aa)
        if (ta.data_.size !== ia.size)
          ta.keysAtom_.reportChanged();
        else
          for (var qs = ta.data_.keys(), jo = ia.keys(), fs = qs.next(), Ao = jo.next(); !fs.done; ) {
            if (fs.value !== Ao.value) {
              ta.keysAtom_.reportChanged();
              break;
            }
            fs = qs.next(), Ao = jo.next();
          }
      ta.data_ = ia;
    }), this;
  }, e.toString = function() {
    return "[object ObservableMap]";
  }, e.toJSON = function() {
    return Array.from(this);
  }, e.observe_ = function(Zi, ta) {
    return process.env.NODE_ENV !== "production" && ta === !0 && die("`observe` doesn't support fireImmediately=true in combination with maps."), registerListener(this, Zi);
  }, e.intercept_ = function(Zi) {
    return registerInterceptor(this, Zi);
  }, _createClass(Bi, [{
    key: "size",
    get: function() {
      return this.keysAtom_.reportObserved(), this.data_.size;
    }
  }, {
    key: _Symbol$toStringTag,
    get: function() {
      return "Map";
    }
  }]), Bi;
}(), isObservableMap = /* @__PURE__ */ createInstanceofPredicate("ObservableMap", ObservableMap);
function convertToMap(Bi) {
  if (isES6Map(Bi) || isObservableMap(Bi))
    return Bi;
  if (Array.isArray(Bi))
    return new Map(Bi);
  if (isPlainObject$2(Bi)) {
    var e = /* @__PURE__ */ new Map();
    for (var Ui in Bi)
      e.set(Ui, Bi[Ui]);
    return e;
  } else
    return die(21, Bi);
}
var _Symbol$iterator$1, _Symbol$toStringTag$1, ObservableSetMarker = {};
_Symbol$iterator$1 = Symbol.iterator;
_Symbol$toStringTag$1 = Symbol.toStringTag;
var ObservableSet = /* @__PURE__ */ function() {
  function Bi(Ui, Zi, ta) {
    var na = this;
    Zi === void 0 && (Zi = deepEnhancer), ta === void 0 && (ta = process.env.NODE_ENV !== "production" ? "ObservableSet@" + getNextId() : "ObservableSet"), this.name_ = void 0, this[$mobx] = ObservableSetMarker, this.data_ = /* @__PURE__ */ new Set(), this.atom_ = void 0, this.changeListeners_ = void 0, this.interceptors_ = void 0, this.dehancer = void 0, this.enhancer_ = void 0, this.name_ = ta, isFunction$1(Set) || die(22), this.enhancer_ = function(ia, aa) {
      return Zi(ia, aa, ta);
    }, initObservable(function() {
      na.atom_ = createAtom(na.name_), Ui && na.replace(Ui);
    });
  }
  var e = Bi.prototype;
  return e.dehanceValue_ = function(Zi) {
    return this.dehancer !== void 0 ? this.dehancer(Zi) : Zi;
  }, e.clear = function() {
    var Zi = this;
    transaction(function() {
      untracked(function() {
        for (var ta = _createForOfIteratorHelperLoose(Zi.data_.values()), na; !(na = ta()).done; ) {
          var ia = na.value;
          Zi.delete(ia);
        }
      });
    });
  }, e.forEach = function(Zi, ta) {
    for (var na = _createForOfIteratorHelperLoose(this), ia; !(ia = na()).done; ) {
      var aa = ia.value;
      Zi.call(ta, aa, aa, this);
    }
  }, e.add = function(Zi) {
    var ta = this;
    if (checkIfStateModificationsAreAllowed(this.atom_), hasInterceptors(this)) {
      var na = interceptChange(this, {
        type: ADD,
        object: this,
        newValue: Zi
      });
      if (!na)
        return this;
    }
    if (!this.has(Zi)) {
      transaction(function() {
        ta.data_.add(ta.enhancer_(Zi, void 0)), ta.atom_.reportChanged();
      });
      var ia = process.env.NODE_ENV !== "production" && isSpyEnabled(), aa = hasListeners(this), da = aa || ia ? {
        observableKind: "set",
        debugObjectName: this.name_,
        type: ADD,
        object: this,
        newValue: Zi
      } : null;
      ia && process.env.NODE_ENV !== "production" && spyReportStart(da), aa && notifyListeners(this, da), ia && process.env.NODE_ENV !== "production" && spyReportEnd();
    }
    return this;
  }, e.delete = function(Zi) {
    var ta = this;
    if (hasInterceptors(this)) {
      var na = interceptChange(this, {
        type: DELETE,
        object: this,
        oldValue: Zi
      });
      if (!na)
        return !1;
    }
    if (this.has(Zi)) {
      var ia = process.env.NODE_ENV !== "production" && isSpyEnabled(), aa = hasListeners(this), da = aa || ia ? {
        observableKind: "set",
        debugObjectName: this.name_,
        type: DELETE,
        object: this,
        oldValue: Zi
      } : null;
      return ia && process.env.NODE_ENV !== "production" && spyReportStart(da), transaction(function() {
        ta.atom_.reportChanged(), ta.data_.delete(Zi);
      }), aa && notifyListeners(this, da), ia && process.env.NODE_ENV !== "production" && spyReportEnd(), !0;
    }
    return !1;
  }, e.has = function(Zi) {
    return this.atom_.reportObserved(), this.data_.has(this.dehanceValue_(Zi));
  }, e.entries = function() {
    var Zi = 0, ta = Array.from(this.keys()), na = Array.from(this.values());
    return makeIterable({
      next: function() {
        var aa = Zi;
        return Zi += 1, aa < na.length ? {
          value: [ta[aa], na[aa]],
          done: !1
        } : {
          done: !0
        };
      }
    });
  }, e.keys = function() {
    return this.values();
  }, e.values = function() {
    this.atom_.reportObserved();
    var Zi = this, ta = 0, na = Array.from(this.data_.values());
    return makeIterable({
      next: function() {
        return ta < na.length ? {
          value: Zi.dehanceValue_(na[ta++]),
          done: !1
        } : {
          done: !0
        };
      }
    });
  }, e.replace = function(Zi) {
    var ta = this;
    return isObservableSet(Zi) && (Zi = new Set(Zi)), transaction(function() {
      Array.isArray(Zi) ? (ta.clear(), Zi.forEach(function(na) {
        return ta.add(na);
      })) : isES6Set(Zi) ? (ta.clear(), Zi.forEach(function(na) {
        return ta.add(na);
      })) : Zi != null && die("Cannot initialize set from " + Zi);
    }), this;
  }, e.observe_ = function(Zi, ta) {
    return process.env.NODE_ENV !== "production" && ta === !0 && die("`observe` doesn't support fireImmediately=true in combination with sets."), registerListener(this, Zi);
  }, e.intercept_ = function(Zi) {
    return registerInterceptor(this, Zi);
  }, e.toJSON = function() {
    return Array.from(this);
  }, e.toString = function() {
    return "[object ObservableSet]";
  }, e[_Symbol$iterator$1] = function() {
    return this.values();
  }, _createClass(Bi, [{
    key: "size",
    get: function() {
      return this.atom_.reportObserved(), this.data_.size;
    }
  }, {
    key: _Symbol$toStringTag$1,
    get: function() {
      return "Set";
    }
  }]), Bi;
}(), isObservableSet = /* @__PURE__ */ createInstanceofPredicate("ObservableSet", ObservableSet), descriptorCache = /* @__PURE__ */ Object.create(null), REMOVE = "remove", ObservableObjectAdministration = /* @__PURE__ */ function() {
  function Bi(Ui, Zi, ta, na) {
    Zi === void 0 && (Zi = /* @__PURE__ */ new Map()), na === void 0 && (na = autoAnnotation), this.target_ = void 0, this.values_ = void 0, this.name_ = void 0, this.defaultAnnotation_ = void 0, this.keysAtom_ = void 0, this.changeListeners_ = void 0, this.interceptors_ = void 0, this.proxy_ = void 0, this.isPlainObject_ = void 0, this.appliedAnnotations_ = void 0, this.pendingKeys_ = void 0, this.target_ = Ui, this.values_ = Zi, this.name_ = ta, this.defaultAnnotation_ = na, this.keysAtom_ = new Atom(process.env.NODE_ENV !== "production" ? this.name_ + ".keys" : "ObservableObject.keys"), this.isPlainObject_ = isPlainObject$2(this.target_), process.env.NODE_ENV !== "production" && !isAnnotation(this.defaultAnnotation_) && die("defaultAnnotation must be valid annotation"), process.env.NODE_ENV !== "production" && (this.appliedAnnotations_ = {});
  }
  var e = Bi.prototype;
  return e.getObservablePropValue_ = function(Zi) {
    return this.values_.get(Zi).get();
  }, e.setObservablePropValue_ = function(Zi, ta) {
    var na = this.values_.get(Zi);
    if (na instanceof ComputedValue)
      return na.set(ta), !0;
    if (hasInterceptors(this)) {
      var ia = interceptChange(this, {
        type: UPDATE,
        object: this.proxy_ || this.target_,
        name: Zi,
        newValue: ta
      });
      if (!ia)
        return null;
      ta = ia.newValue;
    }
    if (ta = na.prepareNewValue_(ta), ta !== globalState.UNCHANGED) {
      var aa = hasListeners(this), da = process.env.NODE_ENV !== "production" && isSpyEnabled(), La = aa || da ? {
        type: UPDATE,
        observableKind: "object",
        debugObjectName: this.name_,
        object: this.proxy_ || this.target_,
        oldValue: na.value_,
        name: Zi,
        newValue: ta
      } : null;
      process.env.NODE_ENV !== "production" && da && spyReportStart(La), na.setNewValue_(ta), aa && notifyListeners(this, La), process.env.NODE_ENV !== "production" && da && spyReportEnd();
    }
    return !0;
  }, e.get_ = function(Zi) {
    return globalState.trackingDerivation && !hasProp(this.target_, Zi) && this.has_(Zi), this.target_[Zi];
  }, e.set_ = function(Zi, ta, na) {
    return na === void 0 && (na = !1), hasProp(this.target_, Zi) ? this.values_.has(Zi) ? this.setObservablePropValue_(Zi, ta) : na ? Reflect.set(this.target_, Zi, ta) : (this.target_[Zi] = ta, !0) : this.extend_(Zi, {
      value: ta,
      enumerable: !0,
      writable: !0,
      configurable: !0
    }, this.defaultAnnotation_, na);
  }, e.has_ = function(Zi) {
    if (!globalState.trackingDerivation)
      return Zi in this.target_;
    this.pendingKeys_ || (this.pendingKeys_ = /* @__PURE__ */ new Map());
    var ta = this.pendingKeys_.get(Zi);
    return ta || (ta = new ObservableValue(Zi in this.target_, referenceEnhancer, process.env.NODE_ENV !== "production" ? this.name_ + "." + stringifyKey(Zi) + "?" : "ObservableObject.key?", !1), this.pendingKeys_.set(Zi, ta)), ta.get();
  }, e.make_ = function(Zi, ta) {
    if (ta === !0 && (ta = this.defaultAnnotation_), ta !== !1) {
      if (assertAnnotable(this, ta, Zi), !(Zi in this.target_)) {
        var na;
        if ((na = this.target_[storedAnnotationsSymbol]) != null && na[Zi])
          return;
        die(1, ta.annotationType_, this.name_ + "." + Zi.toString());
      }
      for (var ia = this.target_; ia && ia !== objectPrototype; ) {
        var aa = getDescriptor(ia, Zi);
        if (aa) {
          var da = ta.make_(this, Zi, aa, ia);
          if (da === 0)
            return;
          if (da === 1)
            break;
        }
        ia = Object.getPrototypeOf(ia);
      }
      recordAnnotationApplied(this, ta, Zi);
    }
  }, e.extend_ = function(Zi, ta, na, ia) {
    if (ia === void 0 && (ia = !1), na === !0 && (na = this.defaultAnnotation_), na === !1)
      return this.defineProperty_(Zi, ta, ia);
    assertAnnotable(this, na, Zi);
    var aa = na.extend_(this, Zi, ta, ia);
    return aa && recordAnnotationApplied(this, na, Zi), aa;
  }, e.defineProperty_ = function(Zi, ta, na) {
    na === void 0 && (na = !1), checkIfStateModificationsAreAllowed(this.keysAtom_);
    try {
      startBatch();
      var ia = this.delete_(Zi);
      if (!ia)
        return ia;
      if (hasInterceptors(this)) {
        var aa = interceptChange(this, {
          object: this.proxy_ || this.target_,
          name: Zi,
          type: ADD,
          newValue: ta.value
        });
        if (!aa)
          return null;
        var da = aa.newValue;
        ta.value !== da && (ta = _extends({}, ta, {
          value: da
        }));
      }
      if (na) {
        if (!Reflect.defineProperty(this.target_, Zi, ta))
          return !1;
      } else
        defineProperty(this.target_, Zi, ta);
      this.notifyPropertyAddition_(Zi, ta.value);
    } finally {
      endBatch();
    }
    return !0;
  }, e.defineObservableProperty_ = function(Zi, ta, na, ia) {
    ia === void 0 && (ia = !1), checkIfStateModificationsAreAllowed(this.keysAtom_);
    try {
      startBatch();
      var aa = this.delete_(Zi);
      if (!aa)
        return aa;
      if (hasInterceptors(this)) {
        var da = interceptChange(this, {
          object: this.proxy_ || this.target_,
          name: Zi,
          type: ADD,
          newValue: ta
        });
        if (!da)
          return null;
        ta = da.newValue;
      }
      var La = getCachedObservablePropDescriptor(Zi), qa = {
        configurable: globalState.safeDescriptors ? this.isPlainObject_ : !0,
        enumerable: !0,
        get: La.get,
        set: La.set
      };
      if (ia) {
        if (!Reflect.defineProperty(this.target_, Zi, qa))
          return !1;
      } else
        defineProperty(this.target_, Zi, qa);
      var io = new ObservableValue(ta, na, process.env.NODE_ENV !== "production" ? this.name_ + "." + Zi.toString() : "ObservableObject.key", !1);
      this.values_.set(Zi, io), this.notifyPropertyAddition_(Zi, io.value_);
    } finally {
      endBatch();
    }
    return !0;
  }, e.defineComputedProperty_ = function(Zi, ta, na) {
    na === void 0 && (na = !1), checkIfStateModificationsAreAllowed(this.keysAtom_);
    try {
      startBatch();
      var ia = this.delete_(Zi);
      if (!ia)
        return ia;
      if (hasInterceptors(this)) {
        var aa = interceptChange(this, {
          object: this.proxy_ || this.target_,
          name: Zi,
          type: ADD,
          newValue: void 0
        });
        if (!aa)
          return null;
      }
      ta.name || (ta.name = process.env.NODE_ENV !== "production" ? this.name_ + "." + Zi.toString() : "ObservableObject.key"), ta.context = this.proxy_ || this.target_;
      var da = getCachedObservablePropDescriptor(Zi), La = {
        configurable: globalState.safeDescriptors ? this.isPlainObject_ : !0,
        enumerable: !1,
        get: da.get,
        set: da.set
      };
      if (na) {
        if (!Reflect.defineProperty(this.target_, Zi, La))
          return !1;
      } else
        defineProperty(this.target_, Zi, La);
      this.values_.set(Zi, new ComputedValue(ta)), this.notifyPropertyAddition_(Zi, void 0);
    } finally {
      endBatch();
    }
    return !0;
  }, e.delete_ = function(Zi, ta) {
    if (ta === void 0 && (ta = !1), checkIfStateModificationsAreAllowed(this.keysAtom_), !hasProp(this.target_, Zi))
      return !0;
    if (hasInterceptors(this)) {
      var na = interceptChange(this, {
        object: this.proxy_ || this.target_,
        name: Zi,
        type: REMOVE
      });
      if (!na)
        return null;
    }
    try {
      var ia, aa;
      startBatch();
      var da = hasListeners(this), La = process.env.NODE_ENV !== "production" && isSpyEnabled(), qa = this.values_.get(Zi), io = void 0;
      if (!qa && (da || La)) {
        var ao;
        io = (ao = getDescriptor(this.target_, Zi)) == null ? void 0 : ao.value;
      }
      if (ta) {
        if (!Reflect.deleteProperty(this.target_, Zi))
          return !1;
      } else
        delete this.target_[Zi];
      if (process.env.NODE_ENV !== "production" && delete this.appliedAnnotations_[Zi], qa && (this.values_.delete(Zi), qa instanceof ObservableValue && (io = qa.value_), propagateChanged(qa)), this.keysAtom_.reportChanged(), (ia = this.pendingKeys_) == null || (aa = ia.get(Zi)) == null || aa.set(Zi in this.target_), da || La) {
        var oo = {
          type: REMOVE,
          observableKind: "object",
          object: this.proxy_ || this.target_,
          debugObjectName: this.name_,
          oldValue: io,
          name: Zi
        };
        process.env.NODE_ENV !== "production" && La && spyReportStart(oo), da && notifyListeners(this, oo), process.env.NODE_ENV !== "production" && La && spyReportEnd();
      }
    } finally {
      endBatch();
    }
    return !0;
  }, e.observe_ = function(Zi, ta) {
    return process.env.NODE_ENV !== "production" && ta === !0 && die("`observe` doesn't support the fire immediately property for observable objects."), registerListener(this, Zi);
  }, e.intercept_ = function(Zi) {
    return registerInterceptor(this, Zi);
  }, e.notifyPropertyAddition_ = function(Zi, ta) {
    var na, ia, aa = hasListeners(this), da = process.env.NODE_ENV !== "production" && isSpyEnabled();
    if (aa || da) {
      var La = aa || da ? {
        type: ADD,
        observableKind: "object",
        debugObjectName: this.name_,
        object: this.proxy_ || this.target_,
        name: Zi,
        newValue: ta
      } : null;
      process.env.NODE_ENV !== "production" && da && spyReportStart(La), aa && notifyListeners(this, La), process.env.NODE_ENV !== "production" && da && spyReportEnd();
    }
    (na = this.pendingKeys_) == null || (ia = na.get(Zi)) == null || ia.set(!0), this.keysAtom_.reportChanged();
  }, e.ownKeys_ = function() {
    return this.keysAtom_.reportObserved(), ownKeys$2(this.target_);
  }, e.keys_ = function() {
    return this.keysAtom_.reportObserved(), Object.keys(this.target_);
  }, Bi;
}();
function asObservableObject(Bi, e) {
  var Ui;
  if (process.env.NODE_ENV !== "production" && e && isObservableObject(Bi) && die("Options can't be provided for already observable objects."), hasProp(Bi, $mobx))
    return process.env.NODE_ENV !== "production" && !(getAdministration$1(Bi) instanceof ObservableObjectAdministration) && die("Cannot convert '" + getDebugName(Bi) + `' into observable object:
The target is already observable of different type.
Extending builtins is not supported.`), Bi;
  process.env.NODE_ENV !== "production" && !Object.isExtensible(Bi) && die("Cannot make the designated object observable; it is not extensible");
  var Zi = (Ui = e?.name) != null ? Ui : process.env.NODE_ENV !== "production" ? (isPlainObject$2(Bi) ? "ObservableObject" : Bi.constructor.name) + "@" + getNextId() : "ObservableObject", ta = new ObservableObjectAdministration(Bi, /* @__PURE__ */ new Map(), String(Zi), getAnnotationFromOptions(e));
  return addHiddenProp(Bi, $mobx, ta), Bi;
}
var isObservableObjectAdministration = /* @__PURE__ */ createInstanceofPredicate("ObservableObjectAdministration", ObservableObjectAdministration);
function getCachedObservablePropDescriptor(Bi) {
  return descriptorCache[Bi] || (descriptorCache[Bi] = {
    get: function() {
      return this[$mobx].getObservablePropValue_(Bi);
    },
    set: function(Ui) {
      return this[$mobx].setObservablePropValue_(Bi, Ui);
    }
  });
}
function isObservableObject(Bi) {
  return isObject$3(Bi) ? isObservableObjectAdministration(Bi[$mobx]) : !1;
}
function recordAnnotationApplied(Bi, e, Ui) {
  var Zi;
  process.env.NODE_ENV !== "production" && (Bi.appliedAnnotations_[Ui] = e), (Zi = Bi.target_[storedAnnotationsSymbol]) == null || delete Zi[Ui];
}
function assertAnnotable(Bi, e, Ui) {
  if (process.env.NODE_ENV !== "production" && !isAnnotation(e) && die("Cannot annotate '" + Bi.name_ + "." + Ui.toString() + "': Invalid annotation."), process.env.NODE_ENV !== "production" && !isOverride(e) && hasProp(Bi.appliedAnnotations_, Ui)) {
    var Zi = Bi.name_ + "." + Ui.toString(), ta = Bi.appliedAnnotations_[Ui].annotationType_, na = e.annotationType_;
    die("Cannot apply '" + na + "' to '" + Zi + "':" + (`
The field is already annotated with '` + ta + "'.") + `
Re-annotating fields is not allowed.
Use 'override' annotation for methods overridden by subclass.`);
  }
}
var ENTRY_0 = /* @__PURE__ */ createArrayEntryDescriptor(0), safariPrototypeSetterInheritanceBug = /* @__PURE__ */ function() {
  var Bi = !1, e = {};
  return Object.defineProperty(e, "0", {
    set: function() {
      Bi = !0;
    }
  }), Object.create(e)[0] = 1, Bi === !1;
}(), OBSERVABLE_ARRAY_BUFFER_SIZE = 0, StubArray = function() {
};
function inherit(Bi, e) {
  Object.setPrototypeOf ? Object.setPrototypeOf(Bi.prototype, e) : Bi.prototype.__proto__ !== void 0 ? Bi.prototype.__proto__ = e : Bi.prototype = e;
}
inherit(StubArray, Array.prototype);
var LegacyObservableArray = /* @__PURE__ */ function(Bi, e, Ui) {
  _inheritsLoose(Zi, Bi);
  function Zi(na, ia, aa, da) {
    var La;
    return aa === void 0 && (aa = process.env.NODE_ENV !== "production" ? "ObservableArray@" + getNextId() : "ObservableArray"), da === void 0 && (da = !1), La = Bi.call(this) || this, initObservable(function() {
      var qa = new ObservableArrayAdministration(aa, ia, da, !0);
      qa.proxy_ = _assertThisInitialized(La), addHiddenFinalProp(_assertThisInitialized(La), $mobx, qa), na && na.length && La.spliceWithArray(0, 0, na), safariPrototypeSetterInheritanceBug && Object.defineProperty(_assertThisInitialized(La), "0", ENTRY_0);
    }), La;
  }
  var ta = Zi.prototype;
  return ta.concat = function() {
    this[$mobx].atom_.reportObserved();
    for (var ia = arguments.length, aa = new Array(ia), da = 0; da < ia; da++)
      aa[da] = arguments[da];
    return Array.prototype.concat.apply(
      this.slice(),
      //@ts-ignore
      aa.map(function(La) {
        return isObservableArray(La) ? La.slice() : La;
      })
    );
  }, ta[Ui] = function() {
    var na = this, ia = 0;
    return makeIterable({
      next: function() {
        return ia < na.length ? {
          value: na[ia++],
          done: !1
        } : {
          done: !0,
          value: void 0
        };
      }
    });
  }, _createClass(Zi, [{
    key: "length",
    get: function() {
      return this[$mobx].getArrayLength_();
    },
    set: function(ia) {
      this[$mobx].setArrayLength_(ia);
    }
  }, {
    key: e,
    get: function() {
      return "Array";
    }
  }]), Zi;
}(StubArray, Symbol.toStringTag, Symbol.iterator);
Object.entries(arrayExtensions).forEach(function(Bi) {
  var e = Bi[0], Ui = Bi[1];
  e !== "concat" && addHiddenProp(LegacyObservableArray.prototype, e, Ui);
});
function createArrayEntryDescriptor(Bi) {
  return {
    enumerable: !1,
    configurable: !0,
    get: function() {
      return this[$mobx].get_(Bi);
    },
    set: function(Ui) {
      this[$mobx].set_(Bi, Ui);
    }
  };
}
function createArrayBufferItem(Bi) {
  defineProperty(LegacyObservableArray.prototype, "" + Bi, createArrayEntryDescriptor(Bi));
}
function reserveArrayBuffer(Bi) {
  if (Bi > OBSERVABLE_ARRAY_BUFFER_SIZE) {
    for (var e = OBSERVABLE_ARRAY_BUFFER_SIZE; e < Bi + 100; e++)
      createArrayBufferItem(e);
    OBSERVABLE_ARRAY_BUFFER_SIZE = Bi;
  }
}
reserveArrayBuffer(1e3);
function createLegacyArray(Bi, e, Ui) {
  return new LegacyObservableArray(Bi, e, Ui);
}
function getAtom(Bi, e) {
  if (typeof Bi == "object" && Bi !== null) {
    if (isObservableArray(Bi))
      return e !== void 0 && die(23), Bi[$mobx].atom_;
    if (isObservableSet(Bi))
      return Bi.atom_;
    if (isObservableMap(Bi)) {
      if (e === void 0)
        return Bi.keysAtom_;
      var Ui = Bi.data_.get(e) || Bi.hasMap_.get(e);
      return Ui || die(25, e, getDebugName(Bi)), Ui;
    }
    if (isObservableObject(Bi)) {
      if (!e)
        return die(26);
      var Zi = Bi[$mobx].values_.get(e);
      return Zi || die(27, e, getDebugName(Bi)), Zi;
    }
    if (isAtom(Bi) || isComputedValue(Bi) || isReaction(Bi))
      return Bi;
  } else if (isFunction$1(Bi) && isReaction(Bi[$mobx]))
    return Bi[$mobx];
  die(28);
}
function getAdministration$1(Bi, e) {
  if (Bi || die(29), isAtom(Bi) || isComputedValue(Bi) || isReaction(Bi) || isObservableMap(Bi) || isObservableSet(Bi))
    return Bi;
  if (Bi[$mobx])
    return Bi[$mobx];
  die(24, Bi);
}
function getDebugName(Bi, e) {
  var Ui;
  if (e !== void 0)
    Ui = getAtom(Bi, e);
  else {
    if (isAction(Bi))
      return Bi.name;
    isObservableObject(Bi) || isObservableMap(Bi) || isObservableSet(Bi) ? Ui = getAdministration$1(Bi) : Ui = getAtom(Bi);
  }
  return Ui.name_;
}
function initObservable(Bi) {
  var e = untrackedStart(), Ui = allowStateChangesStart(!0);
  startBatch();
  try {
    return Bi();
  } finally {
    endBatch(), allowStateChangesEnd(Ui), untrackedEnd(e);
  }
}
var toString = objectPrototype.toString;
function deepEqual$1(Bi, e, Ui) {
  return Ui === void 0 && (Ui = -1), eq(Bi, e, Ui);
}
function eq(Bi, e, Ui, Zi, ta) {
  if (Bi === e)
    return Bi !== 0 || 1 / Bi === 1 / e;
  if (Bi == null || e == null)
    return !1;
  if (Bi !== Bi)
    return e !== e;
  var na = typeof Bi;
  if (na !== "function" && na !== "object" && typeof e != "object")
    return !1;
  var ia = toString.call(Bi);
  if (ia !== toString.call(e))
    return !1;
  switch (ia) {
    // Strings, numbers, regular expressions, dates, and booleans are compared by value.
    case "[object RegExp]":
    // RegExps are coerced to strings for comparison (Note: '' + /a/i === '/a/i')
    case "[object String]":
      return "" + Bi == "" + e;
    case "[object Number]":
      return +Bi != +Bi ? +e != +e : +Bi == 0 ? 1 / +Bi === 1 / e : +Bi == +e;
    case "[object Date]":
    case "[object Boolean]":
      return +Bi == +e;
    case "[object Symbol]":
      return typeof Symbol < "u" && Symbol.valueOf.call(Bi) === Symbol.valueOf.call(e);
    case "[object Map]":
    case "[object Set]":
      Ui >= 0 && Ui++;
      break;
  }
  Bi = unwrap(Bi), e = unwrap(e);
  var aa = ia === "[object Array]";
  if (!aa) {
    if (typeof Bi != "object" || typeof e != "object")
      return !1;
    var da = Bi.constructor, La = e.constructor;
    if (da !== La && !(isFunction$1(da) && da instanceof da && isFunction$1(La) && La instanceof La) && "constructor" in Bi && "constructor" in e)
      return !1;
  }
  if (Ui === 0)
    return !1;
  Ui < 0 && (Ui = -1), Zi = Zi || [], ta = ta || [];
  for (var qa = Zi.length; qa--; )
    if (Zi[qa] === Bi)
      return ta[qa] === e;
  if (Zi.push(Bi), ta.push(e), aa) {
    if (qa = Bi.length, qa !== e.length)
      return !1;
    for (; qa--; )
      if (!eq(Bi[qa], e[qa], Ui - 1, Zi, ta))
        return !1;
  } else {
    var io = Object.keys(Bi), ao;
    if (qa = io.length, Object.keys(e).length !== qa)
      return !1;
    for (; qa--; )
      if (ao = io[qa], !(hasProp(e, ao) && eq(Bi[ao], e[ao], Ui - 1, Zi, ta)))
        return !1;
  }
  return Zi.pop(), ta.pop(), !0;
}
function unwrap(Bi) {
  return isObservableArray(Bi) ? Bi.slice() : isES6Map(Bi) || isObservableMap(Bi) || isES6Set(Bi) || isObservableSet(Bi) ? Array.from(Bi.entries()) : Bi;
}
function makeIterable(Bi) {
  return Bi[Symbol.iterator] = getSelf, Bi;
}
function getSelf() {
  return this;
}
function isAnnotation(Bi) {
  return (
    // Can be function
    Bi instanceof Object && typeof Bi.annotationType_ == "string" && isFunction$1(Bi.make_) && isFunction$1(Bi.extend_)
  );
}
["Symbol", "Map", "Set"].forEach(function(Bi) {
  var e = getGlobal();
  typeof e[Bi] > "u" && die("MobX requires global '" + Bi + "' to be available or polyfilled");
});
typeof __MOBX_DEVTOOLS_GLOBAL_HOOK__ == "object" && __MOBX_DEVTOOLS_GLOBAL_HOOK__.injectMobx({
  spy,
  extras: {
    getDebugName
  },
  $mobx
});
if (!useState)
  throw new Error("mobx-react-lite requires React with Hooks support");
if (!makeObservable)
  throw new Error("mobx-react-lite@3 requires mobx at least version 6 to be available");
function defaultNoopBatch(Bi) {
  Bi();
}
function observerBatching(Bi) {
  Bi || (Bi = defaultNoopBatch, process.env.NODE_ENV !== "production" && console.warn("[MobX] Failed to get unstable_batched updates from react-dom / react-native")), configure({ reactionScheduler: Bi });
}
function printDebugValue(Bi) {
  return getDependencyTree(Bi);
}
var REGISTRY_FINALIZE_AFTER = 1e4, REGISTRY_SWEEP_INTERVAL = 1e4, TimerBasedFinalizationRegistry = (
  /** @class */
  function() {
    function Bi(e) {
      var Ui = this;
      Object.defineProperty(this, "finalize", {
        enumerable: !0,
        configurable: !0,
        writable: !0,
        value: e
      }), Object.defineProperty(this, "registrations", {
        enumerable: !0,
        configurable: !0,
        writable: !0,
        value: /* @__PURE__ */ new Map()
      }), Object.defineProperty(this, "sweepTimeout", {
        enumerable: !0,
        configurable: !0,
        writable: !0,
        value: void 0
      }), Object.defineProperty(this, "sweep", {
        enumerable: !0,
        configurable: !0,
        writable: !0,
        value: function(Zi) {
          Zi === void 0 && (Zi = REGISTRY_FINALIZE_AFTER), clearTimeout(Ui.sweepTimeout), Ui.sweepTimeout = void 0;
          var ta = Date.now();
          Ui.registrations.forEach(function(na, ia) {
            ta - na.registeredAt >= Zi && (Ui.finalize(na.value), Ui.registrations.delete(ia));
          }), Ui.registrations.size > 0 && Ui.scheduleSweep();
        }
      }), Object.defineProperty(this, "finalizeAllImmediately", {
        enumerable: !0,
        configurable: !0,
        writable: !0,
        value: function() {
          Ui.sweep(0);
        }
      });
    }
    return Object.defineProperty(Bi.prototype, "register", {
      enumerable: !1,
      configurable: !0,
      writable: !0,
      value: function(e, Ui, Zi) {
        this.registrations.set(Zi, {
          value: Ui,
          registeredAt: Date.now()
        }), this.scheduleSweep();
      }
    }), Object.defineProperty(Bi.prototype, "unregister", {
      enumerable: !1,
      configurable: !0,
      writable: !0,
      value: function(e) {
        this.registrations.delete(e);
      }
    }), Object.defineProperty(Bi.prototype, "scheduleSweep", {
      enumerable: !1,
      configurable: !0,
      writable: !0,
      value: function() {
        this.sweepTimeout === void 0 && (this.sweepTimeout = setTimeout(this.sweep, REGISTRY_SWEEP_INTERVAL));
      }
    }), Bi;
  }()
), UniversalFinalizationRegistry = typeof FinalizationRegistry < "u" ? FinalizationRegistry : TimerBasedFinalizationRegistry, observerFinalizationRegistry = new UniversalFinalizationRegistry(function(Bi) {
  var e;
  (e = Bi.reaction) === null || e === void 0 || e.dispose(), Bi.reaction = null;
}), getServerSnapshot = function() {
};
function createReaction$1(Bi) {
  Bi.reaction = new Reaction("observer".concat(Bi.name), function() {
    var e;
    Bi.stateVersion = Symbol(), (e = Bi.onStoreChange) === null || e === void 0 || e.call(Bi);
  });
}
function useObserver(Bi, e) {
  e === void 0 && (e = "observed");
  var Ui = a__default.useRef(null);
  if (!Ui.current) {
    var Zi = {
      reaction: null,
      onStoreChange: null,
      stateVersion: Symbol(),
      name: e,
      subscribe: function(aa) {
        return observerFinalizationRegistry.unregister(Zi), Zi.onStoreChange = aa, Zi.reaction || (createReaction$1(Zi), Zi.stateVersion = Symbol()), function() {
          var da;
          Zi.onStoreChange = null, (da = Zi.reaction) === null || da === void 0 || da.dispose(), Zi.reaction = null;
        };
      },
      getSnapshot: function() {
        return Zi.stateVersion;
      }
    };
    Ui.current = Zi;
  }
  var ta = Ui.current;
  ta.reaction || (createReaction$1(ta), observerFinalizationRegistry.register(Ui, ta, ta)), a__default.useDebugValue(ta.reaction, printDebugValue), shimExports.useSyncExternalStore(
    // Both of these must be stable, otherwise it would keep resubscribing every render.
    ta.subscribe,
    ta.getSnapshot,
    getServerSnapshot
  );
  var na, ia;
  if (ta.reaction.track(function() {
    try {
      na = Bi();
    } catch (aa) {
      ia = aa;
    }
  }), ia)
    throw ia;
  return na;
}
var warnObserverOptionsDeprecated = !0, hasSymbol = typeof Symbol == "function" && Symbol.for, ReactForwardRefSymbol = hasSymbol ? Symbol.for("react.forward_ref") : typeof forwardRef == "function" && forwardRef(function(Bi) {
  return null;
}).$$typeof, ReactMemoSymbol = hasSymbol ? Symbol.for("react.memo") : typeof memo == "function" && memo(function(Bi) {
  return null;
}).$$typeof;
function observer$1(Bi, e) {
  var Ui;
  if (process.env.NODE_ENV, ReactMemoSymbol && Bi.$$typeof === ReactMemoSymbol)
    throw new Error("[mobx-react-lite] You are trying to use `observer` on a function component wrapped in either another `observer` or `React.memo`. The observer already applies 'React.memo' for you.");
  var Zi = (Ui = void 0) !== null && Ui !== void 0 ? Ui : !1, ta = Bi, na = Bi.displayName || Bi.name;
  if (ReactForwardRefSymbol && Bi.$$typeof === ReactForwardRefSymbol && (Zi = !0, ta = Bi.render, typeof ta != "function"))
    throw new Error("[mobx-react-lite] `render` property of ForwardRef was not a function");
  var ia = function(aa, da) {
    return useObserver(function() {
      return ta(aa, da);
    }, na);
  };
  return ia.displayName = Bi.displayName, Object.defineProperty(ia, "name", {
    value: Bi.name,
    writable: !0,
    configurable: !0
  }), Bi.contextTypes && (ia.contextTypes = Bi.contextTypes), Zi && (ia = forwardRef(ia)), ia = memo(ia), copyStaticProperties(Bi, ia), process.env.NODE_ENV !== "production" && Object.defineProperty(ia, "contextTypes", {
    set: function() {
      var aa, da;
      throw new Error("[mobx-react-lite] `".concat(this.displayName || ((aa = this.type) === null || aa === void 0 ? void 0 : aa.displayName) || ((da = this.type) === null || da === void 0 ? void 0 : da.name) || "Component", ".contextTypes` must be set before applying `observer`."));
    }
  }), ia;
}
var hoistBlackList = {
  $$typeof: !0,
  render: !0,
  compare: !0,
  type: !0,
  // Don't redefine `displayName`,
  // it's defined as getter-setter pair on `memo` (see #3192).
  displayName: !0
};
function copyStaticProperties(Bi, e) {
  Object.keys(Bi).forEach(function(Ui) {
    hoistBlackList[Ui] || Object.defineProperty(e, Ui, Object.getOwnPropertyDescriptor(Bi, Ui));
  });
}
process.env.NODE_ENV;
function useLocalObservable(Bi, e) {
  return useState(function() {
    return observable(Bi(), e, { autoBind: !0 });
  })[0];
}
var _a$1;
observerBatching(unstable_batchedUpdates);
_a$1 = observerFinalizationRegistry.finalizeAllImmediately;
function shallowEqual$1(Bi, e) {
  if (is$1(Bi, e))
    return !0;
  if (typeof Bi != "object" || Bi === null || typeof e != "object" || e === null)
    return !1;
  var Ui = Object.keys(Bi), Zi = Object.keys(e);
  if (Ui.length !== Zi.length)
    return !1;
  for (var ta = 0; ta < Ui.length; ta++)
    if (!Object.hasOwnProperty.call(e, Ui[ta]) || !is$1(Bi[Ui[ta]], e[Ui[ta]]))
      return !1;
  return !0;
}
function is$1(Bi, e) {
  return Bi === e ? Bi !== 0 || 1 / Bi === 1 / e : Bi !== Bi && e !== e;
}
var mobxMixins = /* @__PURE__ */ Symbol("patchMixins"), mobxPatchedDefinition = /* @__PURE__ */ Symbol("patchedDefinition");
function getMixins(Bi, e) {
  var Ui = Bi[mobxMixins] = Bi[mobxMixins] || {}, Zi = Ui[e] = Ui[e] || {};
  return Zi.locks = Zi.locks || 0, Zi.methods = Zi.methods || [], Zi;
}
function wrapper(Bi, e) {
  for (var Ui = this, Zi = arguments.length, ta = new Array(Zi > 2 ? Zi - 2 : 0), na = 2; na < Zi; na++)
    ta[na - 2] = arguments[na];
  e.locks++;
  try {
    var ia;
    return Bi != null && (ia = Bi.apply(this, ta)), ia;
  } finally {
    e.locks--, e.locks === 0 && e.methods.forEach(function(aa) {
      aa.apply(Ui, ta);
    });
  }
}
function wrapFunction(Bi, e) {
  var Ui = function() {
    for (var ta = arguments.length, na = new Array(ta), ia = 0; ia < ta; ia++)
      na[ia] = arguments[ia];
    wrapper.call.apply(wrapper, [this, Bi, e].concat(na));
  };
  return Ui;
}
function patch(Bi, e, Ui) {
  var Zi = getMixins(Bi, e);
  Zi.methods.indexOf(Ui) < 0 && Zi.methods.push(Ui);
  var ta = Object.getOwnPropertyDescriptor(Bi, e);
  if (!(ta && ta[mobxPatchedDefinition])) {
    var na = Bi[e], ia = createDefinition(Bi, e, ta ? ta.enumerable : void 0, Zi, na);
    Object.defineProperty(Bi, e, ia);
  }
}
function createDefinition(Bi, e, Ui, Zi, ta) {
  var na, ia = wrapFunction(ta, Zi);
  return na = {}, na[mobxPatchedDefinition] = !0, na.get = function() {
    return ia;
  }, na.set = function(da) {
    if (this === Bi)
      ia = wrapFunction(da, Zi);
    else {
      var La = createDefinition(this, e, Ui, Zi, da);
      Object.defineProperty(this, e, La);
    }
  }, na.configurable = !0, na.enumerable = Ui, na;
}
var administrationSymbol = /* @__PURE__ */ Symbol("ObserverAdministration"), isMobXReactObserverSymbol = /* @__PURE__ */ Symbol("isMobXReactObserver"), observablePropDescriptors;
process.env.NODE_ENV !== "production" && (observablePropDescriptors = {
  props: /* @__PURE__ */ createObservablePropDescriptor("props"),
  state: /* @__PURE__ */ createObservablePropDescriptor("state"),
  context: /* @__PURE__ */ createObservablePropDescriptor("context")
});
function getAdministration(Bi) {
  var e;
  return (e = Bi[administrationSymbol]) != null ? e : Bi[administrationSymbol] = {
    reaction: null,
    mounted: !1,
    reactionInvalidatedBeforeMount: !1,
    forceUpdate: null,
    name: getDisplayName(Bi.constructor),
    state: void 0,
    props: void 0,
    context: void 0
  };
}
function makeClassComponentObserver(Bi) {
  var e = Bi.prototype;
  if (Bi[isMobXReactObserverSymbol]) {
    var Ui = getDisplayName(Bi);
    throw new Error("The provided component class (" + Ui + ") has already been declared as an observer component.");
  } else
    Bi[isMobXReactObserverSymbol] = !0;
  if (e.componentWillReact)
    throw new Error("The componentWillReact life-cycle event is no longer supported");
  if (Bi.__proto__ !== PureComponent) {
    if (!e.shouldComponentUpdate)
      e.shouldComponentUpdate = observerSCU;
    else if (e.shouldComponentUpdate !== observerSCU)
      throw new Error("It is not allowed to use shouldComponentUpdate in observer based components.");
  }
  process.env.NODE_ENV !== "production" && Object.defineProperties(e, observablePropDescriptors);
  var Zi = e.render;
  if (typeof Zi != "function") {
    var ta = getDisplayName(Bi);
    throw new Error("[mobx-react] class component (" + ta + ") is missing `render` method.\n`observer` requires `render` being a function defined on prototype.\n`render = () => {}` or `render = function() {}` is not supported.");
  }
  e.render = function() {
    return Object.defineProperty(this, "render", {
      // There is no safe way to replace render, therefore it's forbidden.
      configurable: !1,
      writable: !1,
      value: createReactiveRender.call(this, Zi)
    }), this.render();
  };
  var na = e.componentDidMount;
  return e.componentDidMount = function() {
    var ia = this;
    if (process.env.NODE_ENV !== "production" && this.componentDidMount !== Object.getPrototypeOf(this).componentDidMount) {
      var aa = getDisplayName(Bi);
      throw new Error("[mobx-react] `observer(" + aa + ").componentDidMount` must be defined on prototype.\n`componentDidMount = () => {}` or `componentDidMount = function() {}` is not supported.");
    }
    var da = getAdministration(this);
    return da.mounted = !0, observerFinalizationRegistry.unregister(this), da.forceUpdate = function() {
      return ia.forceUpdate();
    }, (!da.reaction || da.reactionInvalidatedBeforeMount) && da.forceUpdate(), na?.apply(this, arguments);
  }, patch(e, "componentWillUnmount", function() {
    var ia, aa = getAdministration(this);
    (ia = aa.reaction) == null || ia.dispose(), aa.reaction = null, aa.forceUpdate = null, aa.mounted = !1, aa.reactionInvalidatedBeforeMount = !1;
  }), Bi;
}
function getDisplayName(Bi) {
  return Bi.displayName || Bi.name || "<component>";
}
function createReactiveRender(Bi) {
  var e = Bi.bind(this), Ui = getAdministration(this);
  function Zi() {
    Ui.reaction || (Ui.reaction = createReaction(Ui), Ui.mounted || observerFinalizationRegistry.register(this, Ui, this));
    var ta = void 0, na = void 0;
    if (Ui.reaction.track(function() {
      try {
        na = allowStateChanges(!1, e);
      } catch (ia) {
        ta = ia;
      }
    }), ta)
      throw ta;
    return na;
  }
  return Zi;
}
function createReaction(Bi) {
  return new Reaction(Bi.name + ".render()", function() {
    if (!Bi.mounted) {
      Bi.reactionInvalidatedBeforeMount = !0;
      return;
    }
    try {
      Bi.forceUpdate == null || Bi.forceUpdate();
    } catch {
      var e;
      (e = Bi.reaction) == null || e.dispose(), Bi.reaction = null;
    }
  });
}
function observerSCU(Bi, e) {
  return this.state !== e ? !0 : !shallowEqual$1(this.props, Bi);
}
function createObservablePropDescriptor(Bi) {
  return {
    configurable: !0,
    enumerable: !0,
    get: function() {
      var Ui = getAdministration(this), Zi = getGlobalState().trackingDerivation;
      if (Zi && Zi !== Ui.reaction)
        throw new Error('[mobx-react] Cannot read "' + Ui.name + "." + Bi + `" in a reactive context, as it isn't observable.
                    Please use component lifecycle method to copy the value into a local observable first.
                    See https://github.com/mobxjs/mobx/blob/main/packages/mobx-react/README.md#note-on-using-props-and-state-in-derivations`);
      return Ui[Bi];
    },
    set: function(Ui) {
      getAdministration(this)[Bi] = Ui;
    }
  };
}
function observer(Bi, e) {
  return Bi.isMobxInjector === !0 && console.warn("Mobx observer: You are trying to use `observer` on a component that already has `inject`. Please apply `observer` before applying `inject`"), Object.prototype.isPrototypeOf.call(Component, Bi) || Object.prototype.isPrototypeOf.call(PureComponent, Bi) ? makeClassComponentObserver(Bi) : observer$1(Bi);
}
a__default.version.split(".")[0];
if (!Component)
  throw new Error("mobx-react requires React to be available");
if (!observable)
  throw new Error("mobx-react requires mobx to be available");
const DndContext = createContext({
  dragDropManager: void 0
});
function formatProdErrorMessage(Bi) {
  return "Minified Redux error #" + Bi + "; visit https://redux.js.org/Errors?code=" + Bi + " for the full message or use the non-minified dev environment for full errors. ";
}
var $$observable = function() {
  return typeof Symbol == "function" && Symbol.observable || "@@observable";
}(), randomString = function() {
  return Math.random().toString(36).substring(7).split("").join(".");
}, ActionTypes = {
  INIT: "@@redux/INIT" + randomString(),
  REPLACE: "@@redux/REPLACE" + randomString()
};
function isPlainObject$1(Bi) {
  if (typeof Bi != "object" || Bi === null) return !1;
  for (var e = Bi; Object.getPrototypeOf(e) !== null; )
    e = Object.getPrototypeOf(e);
  return Object.getPrototypeOf(Bi) === e;
}
function miniKindOf(Bi) {
  if (Bi === void 0) return "undefined";
  if (Bi === null) return "null";
  var e = typeof Bi;
  switch (e) {
    case "boolean":
    case "string":
    case "number":
    case "symbol":
    case "function":
      return e;
  }
  if (Array.isArray(Bi)) return "array";
  if (isDate(Bi)) return "date";
  if (isError(Bi)) return "error";
  var Ui = ctorName(Bi);
  switch (Ui) {
    case "Symbol":
    case "Promise":
    case "WeakMap":
    case "WeakSet":
    case "Map":
    case "Set":
      return Ui;
  }
  return e.slice(8, -1).toLowerCase().replace(/\s/g, "");
}
function ctorName(Bi) {
  return typeof Bi.constructor == "function" ? Bi.constructor.name : null;
}
function isError(Bi) {
  return Bi instanceof Error || typeof Bi.message == "string" && Bi.constructor && typeof Bi.constructor.stackTraceLimit == "number";
}
function isDate(Bi) {
  return Bi instanceof Date ? !0 : typeof Bi.toDateString == "function" && typeof Bi.getDate == "function" && typeof Bi.setDate == "function";
}
function kindOf(Bi) {
  var e = typeof Bi;
  return process.env.NODE_ENV !== "production" && (e = miniKindOf(Bi)), e;
}
function createStore(Bi, e, Ui) {
  var Zi;
  if (typeof e == "function" && typeof Ui == "function" || typeof Ui == "function" && typeof arguments[3] == "function")
    throw new Error(process.env.NODE_ENV === "production" ? formatProdErrorMessage(0) : "It looks like you are passing several store enhancers to createStore(). This is not supported. Instead, compose them together to a single function. See https://redux.js.org/tutorials/fundamentals/part-4-store#creating-a-store-with-enhancers for an example.");
  if (typeof e == "function" && typeof Ui > "u" && (Ui = e, e = void 0), typeof Ui < "u") {
    if (typeof Ui != "function")
      throw new Error(process.env.NODE_ENV === "production" ? formatProdErrorMessage(1) : "Expected the enhancer to be a function. Instead, received: '" + kindOf(Ui) + "'");
    return Ui(createStore)(Bi, e);
  }
  if (typeof Bi != "function")
    throw new Error(process.env.NODE_ENV === "production" ? formatProdErrorMessage(2) : "Expected the root reducer to be a function. Instead, received: '" + kindOf(Bi) + "'");
  var ta = Bi, na = e, ia = [], aa = ia, da = !1;
  function La() {
    aa === ia && (aa = ia.slice());
  }
  function qa() {
    if (da)
      throw new Error(process.env.NODE_ENV === "production" ? formatProdErrorMessage(3) : "You may not call store.getState() while the reducer is executing. The reducer has already received the state as an argument. Pass it down from the top reducer instead of reading it from the store.");
    return na;
  }
  function io(lo) {
    if (typeof lo != "function")
      throw new Error(process.env.NODE_ENV === "production" ? formatProdErrorMessage(4) : "Expected the listener to be a function. Instead, received: '" + kindOf(lo) + "'");
    if (da)
      throw new Error(process.env.NODE_ENV === "production" ? formatProdErrorMessage(5) : "You may not call store.subscribe() while the reducer is executing. If you would like to be notified after the store has been updated, subscribe from a component and invoke store.getState() in the callback to access the latest state. See https://redux.js.org/api/store#subscribelistener for more details.");
    var so = !0;
    return La(), aa.push(lo), function() {
      if (so) {
        if (da)
          throw new Error(process.env.NODE_ENV === "production" ? formatProdErrorMessage(6) : "You may not unsubscribe from a store listener while the reducer is executing. See https://redux.js.org/api/store#subscribelistener for more details.");
        so = !1, La();
        var Rs = aa.indexOf(lo);
        aa.splice(Rs, 1), ia = null;
      }
    };
  }
  function ao(lo) {
    if (!isPlainObject$1(lo))
      throw new Error(process.env.NODE_ENV === "production" ? formatProdErrorMessage(7) : "Actions must be plain objects. Instead, the actual type was: '" + kindOf(lo) + "'. You may need to add middleware to your store setup to handle dispatching other values, such as 'redux-thunk' to handle dispatching functions. See https://redux.js.org/tutorials/fundamentals/part-4-store#middleware and https://redux.js.org/tutorials/fundamentals/part-6-async-logic#using-the-redux-thunk-middleware for examples.");
    if (typeof lo.type > "u")
      throw new Error(process.env.NODE_ENV === "production" ? formatProdErrorMessage(8) : 'Actions may not have an undefined "type" property. You may have misspelled an action type string constant.');
    if (da)
      throw new Error(process.env.NODE_ENV === "production" ? formatProdErrorMessage(9) : "Reducers may not dispatch actions.");
    try {
      da = !0, na = ta(na, lo);
    } finally {
      da = !1;
    }
    for (var so = ia = aa, bs = 0; bs < so.length; bs++) {
      var Rs = so[bs];
      Rs();
    }
    return lo;
  }
  function oo(lo) {
    if (typeof lo != "function")
      throw new Error(process.env.NODE_ENV === "production" ? formatProdErrorMessage(10) : "Expected the nextReducer to be a function. Instead, received: '" + kindOf(lo));
    ta = lo, ao({
      type: ActionTypes.REPLACE
    });
  }
  function no() {
    var lo, so = io;
    return lo = {
      /**
       * The minimal observable subscription method.
       * @param {Object} observer Any object that can be used as an observer.
       * The observer object should have a `next` method.
       * @returns {subscription} An object with an `unsubscribe` method that can
       * be used to unsubscribe the observable from the store, and prevent further
       * emission of values from the observable.
       */
      subscribe: function(Rs) {
        if (typeof Rs != "object" || Rs === null)
          throw new Error(process.env.NODE_ENV === "production" ? formatProdErrorMessage(11) : "Expected the observer to be an object. Instead, received: '" + kindOf(Rs) + "'");
        function js() {
          Rs.next && Rs.next(qa());
        }
        js();
        var qs = so(js);
        return {
          unsubscribe: qs
        };
      }
    }, lo[$$observable] = function() {
      return this;
    }, lo;
  }
  return ao({
    type: ActionTypes.INIT
  }), Zi = {
    dispatch: ao,
    subscribe: io,
    getState: qa,
    replaceReducer: oo
  }, Zi[$$observable] = no, Zi;
}
function warning(Bi) {
  typeof console < "u" && typeof console.error == "function" && console.error(Bi);
  try {
    throw new Error(Bi);
  } catch {
  }
}
function isCrushed() {
}
process.env.NODE_ENV !== "production" && typeof isCrushed.name == "string" && isCrushed.name !== "isCrushed" && warning('You are currently using minified code outside of NODE_ENV === "production". This means that you are running a slower development build of Redux. You can use loose-envify (https://github.com/zertosh/loose-envify) for browserify or setting mode to production in webpack (https://webpack.js.org/concepts/mode/) to ensure you have the correct code for your production build.');
function invariant(Bi, e, ...Ui) {
  if (isProduction() && e === void 0)
    throw new Error("invariant requires an error message argument");
  if (!Bi) {
    let Zi;
    if (e === void 0)
      Zi = new Error("Minified exception occurred; use the non-minified dev environment for the full error message and additional helpful warnings.");
    else {
      let ta = 0;
      Zi = new Error(e.replace(/%s/g, function() {
        return Ui[ta++];
      })), Zi.name = "Invariant Violation";
    }
    throw Zi.framesToPop = 1, Zi;
  }
}
function isProduction() {
  return typeof process < "u" && process.env.NODE_ENV === "production";
}
function get$1(Bi, e, Ui) {
  return e.split(".").reduce(
    (Zi, ta) => Zi && Zi[ta] ? Zi[ta] : Ui || null,
    Bi
  );
}
function without$1(Bi, e) {
  return Bi.filter(
    (Ui) => Ui !== e
  );
}
function isObject$2(Bi) {
  return typeof Bi == "object";
}
function xor(Bi, e) {
  const Ui = /* @__PURE__ */ new Map(), Zi = (na) => {
    Ui.set(na, Ui.has(na) ? Ui.get(na) + 1 : 1);
  };
  Bi.forEach(Zi), e.forEach(Zi);
  const ta = [];
  return Ui.forEach((na, ia) => {
    na === 1 && ta.push(ia);
  }), ta;
}
function intersection(Bi, e) {
  return Bi.filter(
    (Ui) => e.indexOf(Ui) > -1
  );
}
const INIT_COORDS = "dnd-core/INIT_COORDS", BEGIN_DRAG = "dnd-core/BEGIN_DRAG", PUBLISH_DRAG_SOURCE = "dnd-core/PUBLISH_DRAG_SOURCE", HOVER = "dnd-core/HOVER", DROP = "dnd-core/DROP", END_DRAG = "dnd-core/END_DRAG";
function setClientOffset(Bi, e) {
  return {
    type: INIT_COORDS,
    payload: {
      sourceClientOffset: e || null,
      clientOffset: Bi || null
    }
  };
}
const ResetCoordinatesAction = {
  type: INIT_COORDS,
  payload: {
    clientOffset: null,
    sourceClientOffset: null
  }
};
function createBeginDrag(Bi) {
  return function(Ui = [], Zi = {
    publishSource: !0
  }) {
    const { publishSource: ta = !0, clientOffset: na, getSourceClientOffset: ia } = Zi, aa = Bi.getMonitor(), da = Bi.getRegistry();
    Bi.dispatch(setClientOffset(na)), verifyInvariants$1(Ui, aa, da);
    const La = getDraggableSource(Ui, aa);
    if (La == null) {
      Bi.dispatch(ResetCoordinatesAction);
      return;
    }
    let qa = null;
    if (na) {
      if (!ia)
        throw new Error("getSourceClientOffset must be defined");
      verifyGetSourceClientOffsetIsFunction(ia), qa = ia(La);
    }
    Bi.dispatch(setClientOffset(na, qa));
    const ao = da.getSource(La).beginDrag(aa, La);
    if (ao == null)
      return;
    verifyItemIsObject(ao), da.pinSource(La);
    const oo = da.getSourceType(La);
    return {
      type: BEGIN_DRAG,
      payload: {
        itemType: oo,
        item: ao,
        sourceId: La,
        clientOffset: na || null,
        sourceClientOffset: qa || null,
        isSourcePublic: !!ta
      }
    };
  };
}
function verifyInvariants$1(Bi, e, Ui) {
  invariant(!e.isDragging(), "Cannot call beginDrag while dragging."), Bi.forEach(function(Zi) {
    invariant(Ui.getSource(Zi), "Expected sourceIds to be registered.");
  });
}
function verifyGetSourceClientOffsetIsFunction(Bi) {
  invariant(typeof Bi == "function", "When clientOffset is provided, getSourceClientOffset must be a function.");
}
function verifyItemIsObject(Bi) {
  invariant(isObject$2(Bi), "Item must be an object.");
}
function getDraggableSource(Bi, e) {
  let Ui = null;
  for (let Zi = Bi.length - 1; Zi >= 0; Zi--)
    if (e.canDragSource(Bi[Zi])) {
      Ui = Bi[Zi];
      break;
    }
  return Ui;
}
function _defineProperty$6(Bi, e, Ui) {
  return e in Bi ? Object.defineProperty(Bi, e, {
    value: Ui,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : Bi[e] = Ui, Bi;
}
function _objectSpread$6(Bi) {
  for (var e = 1; e < arguments.length; e++) {
    var Ui = arguments[e] != null ? arguments[e] : {}, Zi = Object.keys(Ui);
    typeof Object.getOwnPropertySymbols == "function" && (Zi = Zi.concat(Object.getOwnPropertySymbols(Ui).filter(function(ta) {
      return Object.getOwnPropertyDescriptor(Ui, ta).enumerable;
    }))), Zi.forEach(function(ta) {
      _defineProperty$6(Bi, ta, Ui[ta]);
    });
  }
  return Bi;
}
function createDrop(Bi) {
  return function(Ui = {}) {
    const Zi = Bi.getMonitor(), ta = Bi.getRegistry();
    verifyInvariants(Zi), getDroppableTargets(Zi).forEach((ia, aa) => {
      const da = determineDropResult(ia, aa, ta, Zi), La = {
        type: DROP,
        payload: {
          dropResult: _objectSpread$6({}, Ui, da)
        }
      };
      Bi.dispatch(La);
    });
  };
}
function verifyInvariants(Bi) {
  invariant(Bi.isDragging(), "Cannot call drop while not dragging."), invariant(!Bi.didDrop(), "Cannot call drop twice during one drag operation.");
}
function determineDropResult(Bi, e, Ui, Zi) {
  const ta = Ui.getTarget(Bi);
  let na = ta ? ta.drop(Zi, Bi) : void 0;
  return verifyDropResultType(na), typeof na > "u" && (na = e === 0 ? {} : Zi.getDropResult()), na;
}
function verifyDropResultType(Bi) {
  invariant(typeof Bi > "u" || isObject$2(Bi), "Drop result must either be an object or undefined.");
}
function getDroppableTargets(Bi) {
  const e = Bi.getTargetIds().filter(Bi.canDropOnTarget, Bi);
  return e.reverse(), e;
}
function createEndDrag(Bi) {
  return function() {
    const Ui = Bi.getMonitor(), Zi = Bi.getRegistry();
    verifyIsDragging(Ui);
    const ta = Ui.getSourceId();
    return ta != null && (Zi.getSource(ta, !0).endDrag(Ui, ta), Zi.unpinSource()), {
      type: END_DRAG
    };
  };
}
function verifyIsDragging(Bi) {
  invariant(Bi.isDragging(), "Cannot call endDrag while not dragging.");
}
function matchesType(Bi, e) {
  return e === null ? Bi === null : Array.isArray(Bi) ? Bi.some(
    (Ui) => Ui === e
  ) : Bi === e;
}
function createHover(Bi) {
  return function(Ui, { clientOffset: Zi } = {}) {
    verifyTargetIdsIsArray(Ui);
    const ta = Ui.slice(0), na = Bi.getMonitor(), ia = Bi.getRegistry(), aa = na.getItemType();
    return removeNonMatchingTargetIds(ta, ia, aa), checkInvariants(ta, na, ia), hoverAllTargets(ta, na, ia), {
      type: HOVER,
      payload: {
        targetIds: ta,
        clientOffset: Zi || null
      }
    };
  };
}
function verifyTargetIdsIsArray(Bi) {
  invariant(Array.isArray(Bi), "Expected targetIds to be an array.");
}
function checkInvariants(Bi, e, Ui) {
  invariant(e.isDragging(), "Cannot call hover while not dragging."), invariant(!e.didDrop(), "Cannot call hover after drop.");
  for (let Zi = 0; Zi < Bi.length; Zi++) {
    const ta = Bi[Zi];
    invariant(Bi.lastIndexOf(ta) === Zi, "Expected targetIds to be unique in the passed array.");
    const na = Ui.getTarget(ta);
    invariant(na, "Expected targetIds to be registered.");
  }
}
function removeNonMatchingTargetIds(Bi, e, Ui) {
  for (let Zi = Bi.length - 1; Zi >= 0; Zi--) {
    const ta = Bi[Zi], na = e.getTargetType(ta);
    matchesType(na, Ui) || Bi.splice(Zi, 1);
  }
}
function hoverAllTargets(Bi, e, Ui) {
  Bi.forEach(function(Zi) {
    Ui.getTarget(Zi).hover(e, Zi);
  });
}
function createPublishDragSource(Bi) {
  return function() {
    if (Bi.getMonitor().isDragging())
      return {
        type: PUBLISH_DRAG_SOURCE
      };
  };
}
function createDragDropActions(Bi) {
  return {
    beginDrag: createBeginDrag(Bi),
    publishDragSource: createPublishDragSource(Bi),
    hover: createHover(Bi),
    drop: createDrop(Bi),
    endDrag: createEndDrag(Bi)
  };
}
class DragDropManagerImpl {
  receiveBackend(e) {
    this.backend = e;
  }
  getMonitor() {
    return this.monitor;
  }
  getBackend() {
    return this.backend;
  }
  getRegistry() {
    return this.monitor.registry;
  }
  getActions() {
    const e = this, { dispatch: Ui } = this.store;
    function Zi(na) {
      return (...ia) => {
        const aa = na.apply(e, ia);
        typeof aa < "u" && Ui(aa);
      };
    }
    const ta = createDragDropActions(this);
    return Object.keys(ta).reduce((na, ia) => {
      const aa = ta[ia];
      return na[ia] = Zi(aa), na;
    }, {});
  }
  dispatch(e) {
    this.store.dispatch(e);
  }
  constructor(e, Ui) {
    this.isSetUp = !1, this.handleRefCountChange = () => {
      const Zi = this.store.getState().refCount > 0;
      this.backend && (Zi && !this.isSetUp ? (this.backend.setup(), this.isSetUp = !0) : !Zi && this.isSetUp && (this.backend.teardown(), this.isSetUp = !1));
    }, this.store = e, this.monitor = Ui, e.subscribe(this.handleRefCountChange);
  }
}
function add(Bi, e) {
  return {
    x: Bi.x + e.x,
    y: Bi.y + e.y
  };
}
function subtract(Bi, e) {
  return {
    x: Bi.x - e.x,
    y: Bi.y - e.y
  };
}
function getSourceClientOffset(Bi) {
  const { clientOffset: e, initialClientOffset: Ui, initialSourceClientOffset: Zi } = Bi;
  return !e || !Ui || !Zi ? null : subtract(add(e, Zi), Ui);
}
function getDifferenceFromInitialOffset(Bi) {
  const { clientOffset: e, initialClientOffset: Ui } = Bi;
  return !e || !Ui ? null : subtract(e, Ui);
}
const NONE = [], ALL = [];
NONE.__IS_NONE__ = !0;
ALL.__IS_ALL__ = !0;
function areDirty(Bi, e) {
  return Bi === NONE ? !1 : Bi === ALL || typeof e > "u" ? !0 : intersection(e, Bi).length > 0;
}
class DragDropMonitorImpl {
  subscribeToStateChange(e, Ui = {}) {
    const { handlerIds: Zi } = Ui;
    invariant(typeof e == "function", "listener must be a function."), invariant(typeof Zi > "u" || Array.isArray(Zi), "handlerIds, when specified, must be an array of strings.");
    let ta = this.store.getState().stateId;
    const na = () => {
      const ia = this.store.getState(), aa = ia.stateId;
      try {
        aa === ta || aa === ta + 1 && !areDirty(ia.dirtyHandlerIds, Zi) || e();
      } finally {
        ta = aa;
      }
    };
    return this.store.subscribe(na);
  }
  subscribeToOffsetChange(e) {
    invariant(typeof e == "function", "listener must be a function.");
    let Ui = this.store.getState().dragOffset;
    const Zi = () => {
      const ta = this.store.getState().dragOffset;
      ta !== Ui && (Ui = ta, e());
    };
    return this.store.subscribe(Zi);
  }
  canDragSource(e) {
    if (!e)
      return !1;
    const Ui = this.registry.getSource(e);
    return invariant(Ui, `Expected to find a valid source. sourceId=${e}`), this.isDragging() ? !1 : Ui.canDrag(this, e);
  }
  canDropOnTarget(e) {
    if (!e)
      return !1;
    const Ui = this.registry.getTarget(e);
    if (invariant(Ui, `Expected to find a valid target. targetId=${e}`), !this.isDragging() || this.didDrop())
      return !1;
    const Zi = this.registry.getTargetType(e), ta = this.getItemType();
    return matchesType(Zi, ta) && Ui.canDrop(this, e);
  }
  isDragging() {
    return !!this.getItemType();
  }
  isDraggingSource(e) {
    if (!e)
      return !1;
    const Ui = this.registry.getSource(e, !0);
    if (invariant(Ui, `Expected to find a valid source. sourceId=${e}`), !this.isDragging() || !this.isSourcePublic())
      return !1;
    const Zi = this.registry.getSourceType(e), ta = this.getItemType();
    return Zi !== ta ? !1 : Ui.isDragging(this, e);
  }
  isOverTarget(e, Ui = {
    shallow: !1
  }) {
    if (!e)
      return !1;
    const { shallow: Zi } = Ui;
    if (!this.isDragging())
      return !1;
    const ta = this.registry.getTargetType(e), na = this.getItemType();
    if (na && !matchesType(ta, na))
      return !1;
    const ia = this.getTargetIds();
    if (!ia.length)
      return !1;
    const aa = ia.indexOf(e);
    return Zi ? aa === ia.length - 1 : aa > -1;
  }
  getItemType() {
    return this.store.getState().dragOperation.itemType;
  }
  getItem() {
    return this.store.getState().dragOperation.item;
  }
  getSourceId() {
    return this.store.getState().dragOperation.sourceId;
  }
  getTargetIds() {
    return this.store.getState().dragOperation.targetIds;
  }
  getDropResult() {
    return this.store.getState().dragOperation.dropResult;
  }
  didDrop() {
    return this.store.getState().dragOperation.didDrop;
  }
  isSourcePublic() {
    return !!this.store.getState().dragOperation.isSourcePublic;
  }
  getInitialClientOffset() {
    return this.store.getState().dragOffset.initialClientOffset;
  }
  getInitialSourceClientOffset() {
    return this.store.getState().dragOffset.initialSourceClientOffset;
  }
  getClientOffset() {
    return this.store.getState().dragOffset.clientOffset;
  }
  getSourceClientOffset() {
    return getSourceClientOffset(this.store.getState().dragOffset);
  }
  getDifferenceFromInitialOffset() {
    return getDifferenceFromInitialOffset(this.store.getState().dragOffset);
  }
  constructor(e, Ui) {
    this.store = e, this.registry = Ui;
  }
}
const scope = typeof global < "u" ? global : self, BrowserMutationObserver = scope.MutationObserver || scope.WebKitMutationObserver;
function makeRequestCallFromTimer(Bi) {
  return function() {
    const Ui = setTimeout(ta, 0), Zi = setInterval(ta, 50);
    function ta() {
      clearTimeout(Ui), clearInterval(Zi), Bi();
    }
  };
}
function makeRequestCallFromMutationObserver(Bi) {
  let e = 1;
  const Ui = new BrowserMutationObserver(Bi), Zi = document.createTextNode("");
  return Ui.observe(Zi, {
    characterData: !0
  }), function() {
    e = -e, Zi.data = e;
  };
}
const makeRequestCall = typeof BrowserMutationObserver == "function" ? (
  // reliably everywhere they are implemented.
  // They are implemented in all modern browsers.
  //
  // - Android 4-4.3
  // - Chrome 26-34
  // - Firefox 14-29
  // - Internet Explorer 11
  // - iPad Safari 6-7.1
  // - iPhone Safari 7-7.1
  // - Safari 6-7
  makeRequestCallFromMutationObserver
) : (
  // task queue, are implemented in Internet Explorer 10, Safari 5.0-1, and Opera
  // 11-12, and in web workers in many engines.
  // Although message channels yield to any queued rendering and IO tasks, they
  // would be better than imposing the 4ms delay of timers.
  // However, they do not work reliably in Internet Explorer or Safari.
  // Internet Explorer 10 is the only browser that has setImmediate but does
  // not have MutationObservers.
  // Although setImmediate yields to the browser's renderer, it would be
  // preferrable to falling back to setTimeout since it does not have
  // the minimum 4ms penalty.
  // Unfortunately there appears to be a bug in Internet Explorer 10 Mobile (and
  // Desktop to a lesser extent) that renders both setImmediate and
  // MessageChannel useless for the purposes of ASAP.
  // https://github.com/kriskowal/q/issues/396
  // Timers are implemented universally.
  // We fall back to timers in workers in most engines, and in foreground
  // contexts in the following browsers.
  // However, note that even this simple case requires nuances to operate in a
  // broad spectrum of browsers.
  //
  // - Firefox 3-13
  // - Internet Explorer 6-9
  // - iPad Safari 4.3
  // - Lynx 2.8.7
  makeRequestCallFromTimer
);
class AsapQueue {
  // Use the fastest means possible to execute a task in its own turn, with
  // priority over other events including IO, animation, reflow, and redraw
  // events in browsers.
  //
  // An exception thrown by a task will permanently interrupt the processing of
  // subsequent tasks. The higher level `asap` function ensures that if an
  // exception is thrown by a task, that the task queue will continue flushing as
  // soon as possible, but if you use `rawAsap` directly, you are responsible to
  // either ensure that no exceptions are thrown from your task, or to manually
  // call `rawAsap.requestFlush` if an exception is thrown.
  enqueueTask(e) {
    const { queue: Ui, requestFlush: Zi } = this;
    Ui.length || (Zi(), this.flushing = !0), Ui[Ui.length] = e;
  }
  constructor() {
    this.queue = [], this.pendingErrors = [], this.flushing = !1, this.index = 0, this.capacity = 1024, this.flush = () => {
      const { queue: e } = this;
      for (; this.index < e.length; ) {
        const Ui = this.index;
        if (this.index++, e[Ui].call(), this.index > this.capacity) {
          for (let Zi = 0, ta = e.length - this.index; Zi < ta; Zi++)
            e[Zi] = e[Zi + this.index];
          e.length -= this.index, this.index = 0;
        }
      }
      e.length = 0, this.index = 0, this.flushing = !1;
    }, this.registerPendingError = (e) => {
      this.pendingErrors.push(e), this.requestErrorThrow();
    }, this.requestFlush = makeRequestCall(this.flush), this.requestErrorThrow = makeRequestCallFromTimer(() => {
      if (this.pendingErrors.length)
        throw this.pendingErrors.shift();
    });
  }
}
class RawTask {
  call() {
    try {
      this.task && this.task();
    } catch (e) {
      this.onError(e);
    } finally {
      this.task = null, this.release(this);
    }
  }
  constructor(e, Ui) {
    this.onError = e, this.release = Ui, this.task = null;
  }
}
class TaskFactory {
  create(e) {
    const Ui = this.freeTasks, Zi = Ui.length ? Ui.pop() : new RawTask(
      this.onError,
      (ta) => Ui[Ui.length] = ta
    );
    return Zi.task = e, Zi;
  }
  constructor(e) {
    this.onError = e, this.freeTasks = [];
  }
}
const asapQueue = new AsapQueue(), taskFactory = new TaskFactory(asapQueue.registerPendingError);
function asap(Bi) {
  asapQueue.enqueueTask(taskFactory.create(Bi));
}
const ADD_SOURCE = "dnd-core/ADD_SOURCE", ADD_TARGET = "dnd-core/ADD_TARGET", REMOVE_SOURCE = "dnd-core/REMOVE_SOURCE", REMOVE_TARGET = "dnd-core/REMOVE_TARGET";
function addSource(Bi) {
  return {
    type: ADD_SOURCE,
    payload: {
      sourceId: Bi
    }
  };
}
function addTarget(Bi) {
  return {
    type: ADD_TARGET,
    payload: {
      targetId: Bi
    }
  };
}
function removeSource(Bi) {
  return {
    type: REMOVE_SOURCE,
    payload: {
      sourceId: Bi
    }
  };
}
function removeTarget(Bi) {
  return {
    type: REMOVE_TARGET,
    payload: {
      targetId: Bi
    }
  };
}
function validateSourceContract(Bi) {
  invariant(typeof Bi.canDrag == "function", "Expected canDrag to be a function."), invariant(typeof Bi.beginDrag == "function", "Expected beginDrag to be a function."), invariant(typeof Bi.endDrag == "function", "Expected endDrag to be a function.");
}
function validateTargetContract(Bi) {
  invariant(typeof Bi.canDrop == "function", "Expected canDrop to be a function."), invariant(typeof Bi.hover == "function", "Expected hover to be a function."), invariant(typeof Bi.drop == "function", "Expected beginDrag to be a function.");
}
function validateType(Bi, e) {
  if (e && Array.isArray(Bi)) {
    Bi.forEach(
      (Ui) => validateType(Ui, !1)
    );
    return;
  }
  invariant(typeof Bi == "string" || typeof Bi == "symbol", e ? "Type can only be a string, a symbol, or an array of either." : "Type can only be a string or a symbol.");
}
var HandlerRole;
(function(Bi) {
  Bi.SOURCE = "SOURCE", Bi.TARGET = "TARGET";
})(HandlerRole || (HandlerRole = {}));
let nextUniqueId = 0;
function getNextUniqueId() {
  return nextUniqueId++;
}
function getNextHandlerId(Bi) {
  const e = getNextUniqueId().toString();
  switch (Bi) {
    case HandlerRole.SOURCE:
      return `S${e}`;
    case HandlerRole.TARGET:
      return `T${e}`;
    default:
      throw new Error(`Unknown Handler Role: ${Bi}`);
  }
}
function parseRoleFromHandlerId(Bi) {
  switch (Bi[0]) {
    case "S":
      return HandlerRole.SOURCE;
    case "T":
      return HandlerRole.TARGET;
    default:
      throw new Error(`Cannot parse handler ID: ${Bi}`);
  }
}
function mapContainsValue(Bi, e) {
  const Ui = Bi.entries();
  let Zi = !1;
  do {
    const { done: ta, value: [, na] } = Ui.next();
    if (na === e)
      return !0;
    Zi = !!ta;
  } while (!Zi);
  return !1;
}
class HandlerRegistryImpl {
  addSource(e, Ui) {
    validateType(e), validateSourceContract(Ui);
    const Zi = this.addHandler(HandlerRole.SOURCE, e, Ui);
    return this.store.dispatch(addSource(Zi)), Zi;
  }
  addTarget(e, Ui) {
    validateType(e, !0), validateTargetContract(Ui);
    const Zi = this.addHandler(HandlerRole.TARGET, e, Ui);
    return this.store.dispatch(addTarget(Zi)), Zi;
  }
  containsHandler(e) {
    return mapContainsValue(this.dragSources, e) || mapContainsValue(this.dropTargets, e);
  }
  getSource(e, Ui = !1) {
    return invariant(this.isSourceId(e), "Expected a valid source ID."), Ui && e === this.pinnedSourceId ? this.pinnedSource : this.dragSources.get(e);
  }
  getTarget(e) {
    return invariant(this.isTargetId(e), "Expected a valid target ID."), this.dropTargets.get(e);
  }
  getSourceType(e) {
    return invariant(this.isSourceId(e), "Expected a valid source ID."), this.types.get(e);
  }
  getTargetType(e) {
    return invariant(this.isTargetId(e), "Expected a valid target ID."), this.types.get(e);
  }
  isSourceId(e) {
    return parseRoleFromHandlerId(e) === HandlerRole.SOURCE;
  }
  isTargetId(e) {
    return parseRoleFromHandlerId(e) === HandlerRole.TARGET;
  }
  removeSource(e) {
    invariant(this.getSource(e), "Expected an existing source."), this.store.dispatch(removeSource(e)), asap(() => {
      this.dragSources.delete(e), this.types.delete(e);
    });
  }
  removeTarget(e) {
    invariant(this.getTarget(e), "Expected an existing target."), this.store.dispatch(removeTarget(e)), this.dropTargets.delete(e), this.types.delete(e);
  }
  pinSource(e) {
    const Ui = this.getSource(e);
    invariant(Ui, "Expected an existing source."), this.pinnedSourceId = e, this.pinnedSource = Ui;
  }
  unpinSource() {
    invariant(this.pinnedSource, "No source is pinned at the time."), this.pinnedSourceId = null, this.pinnedSource = null;
  }
  addHandler(e, Ui, Zi) {
    const ta = getNextHandlerId(e);
    return this.types.set(ta, Ui), e === HandlerRole.SOURCE ? this.dragSources.set(ta, Zi) : e === HandlerRole.TARGET && this.dropTargets.set(ta, Zi), ta;
  }
  constructor(e) {
    this.types = /* @__PURE__ */ new Map(), this.dragSources = /* @__PURE__ */ new Map(), this.dropTargets = /* @__PURE__ */ new Map(), this.pinnedSourceId = null, this.pinnedSource = null, this.store = e;
  }
}
const strictEquality = (Bi, e) => Bi === e;
function areCoordsEqual(Bi, e) {
  return !Bi && !e ? !0 : !Bi || !e ? !1 : Bi.x === e.x && Bi.y === e.y;
}
function areArraysEqual(Bi, e, Ui = strictEquality) {
  if (Bi.length !== e.length)
    return !1;
  for (let Zi = 0; Zi < Bi.length; ++Zi)
    if (!Ui(Bi[Zi], e[Zi]))
      return !1;
  return !0;
}
function reduce$5(Bi = NONE, e) {
  switch (e.type) {
    case HOVER:
      break;
    case ADD_SOURCE:
    case ADD_TARGET:
    case REMOVE_TARGET:
    case REMOVE_SOURCE:
      return NONE;
    case BEGIN_DRAG:
    case PUBLISH_DRAG_SOURCE:
    case END_DRAG:
    case DROP:
    default:
      return ALL;
  }
  const { targetIds: Ui = [], prevTargetIds: Zi = [] } = e.payload, ta = xor(Ui, Zi);
  if (!(ta.length > 0 || !areArraysEqual(Ui, Zi)))
    return NONE;
  const ia = Zi[Zi.length - 1], aa = Ui[Ui.length - 1];
  return ia !== aa && (ia && ta.push(ia), aa && ta.push(aa)), ta;
}
function _defineProperty$5(Bi, e, Ui) {
  return e in Bi ? Object.defineProperty(Bi, e, {
    value: Ui,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : Bi[e] = Ui, Bi;
}
function _objectSpread$5(Bi) {
  for (var e = 1; e < arguments.length; e++) {
    var Ui = arguments[e] != null ? arguments[e] : {}, Zi = Object.keys(Ui);
    typeof Object.getOwnPropertySymbols == "function" && (Zi = Zi.concat(Object.getOwnPropertySymbols(Ui).filter(function(ta) {
      return Object.getOwnPropertyDescriptor(Ui, ta).enumerable;
    }))), Zi.forEach(function(ta) {
      _defineProperty$5(Bi, ta, Ui[ta]);
    });
  }
  return Bi;
}
const initialState$2 = {
  initialSourceClientOffset: null,
  initialClientOffset: null,
  clientOffset: null
};
function reduce$4(Bi = initialState$2, e) {
  const { payload: Ui } = e;
  switch (e.type) {
    case INIT_COORDS:
    case BEGIN_DRAG:
      return {
        initialSourceClientOffset: Ui.sourceClientOffset,
        initialClientOffset: Ui.clientOffset,
        clientOffset: Ui.clientOffset
      };
    case HOVER:
      return areCoordsEqual(Bi.clientOffset, Ui.clientOffset) ? Bi : _objectSpread$5({}, Bi, {
        clientOffset: Ui.clientOffset
      });
    case END_DRAG:
    case DROP:
      return initialState$2;
    default:
      return Bi;
  }
}
function _defineProperty$4(Bi, e, Ui) {
  return e in Bi ? Object.defineProperty(Bi, e, {
    value: Ui,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : Bi[e] = Ui, Bi;
}
function _objectSpread$4(Bi) {
  for (var e = 1; e < arguments.length; e++) {
    var Ui = arguments[e] != null ? arguments[e] : {}, Zi = Object.keys(Ui);
    typeof Object.getOwnPropertySymbols == "function" && (Zi = Zi.concat(Object.getOwnPropertySymbols(Ui).filter(function(ta) {
      return Object.getOwnPropertyDescriptor(Ui, ta).enumerable;
    }))), Zi.forEach(function(ta) {
      _defineProperty$4(Bi, ta, Ui[ta]);
    });
  }
  return Bi;
}
const initialState$1 = {
  itemType: null,
  item: null,
  sourceId: null,
  targetIds: [],
  dropResult: null,
  didDrop: !1,
  isSourcePublic: null
};
function reduce$3(Bi = initialState$1, e) {
  const { payload: Ui } = e;
  switch (e.type) {
    case BEGIN_DRAG:
      return _objectSpread$4({}, Bi, {
        itemType: Ui.itemType,
        item: Ui.item,
        sourceId: Ui.sourceId,
        isSourcePublic: Ui.isSourcePublic,
        dropResult: null,
        didDrop: !1
      });
    case PUBLISH_DRAG_SOURCE:
      return _objectSpread$4({}, Bi, {
        isSourcePublic: !0
      });
    case HOVER:
      return _objectSpread$4({}, Bi, {
        targetIds: Ui.targetIds
      });
    case REMOVE_TARGET:
      return Bi.targetIds.indexOf(Ui.targetId) === -1 ? Bi : _objectSpread$4({}, Bi, {
        targetIds: without$1(Bi.targetIds, Ui.targetId)
      });
    case DROP:
      return _objectSpread$4({}, Bi, {
        dropResult: Ui.dropResult,
        didDrop: !0,
        targetIds: []
      });
    case END_DRAG:
      return _objectSpread$4({}, Bi, {
        itemType: null,
        item: null,
        sourceId: null,
        dropResult: null,
        didDrop: !1,
        isSourcePublic: null,
        targetIds: []
      });
    default:
      return Bi;
  }
}
function reduce$2(Bi = 0, e) {
  switch (e.type) {
    case ADD_SOURCE:
    case ADD_TARGET:
      return Bi + 1;
    case REMOVE_SOURCE:
    case REMOVE_TARGET:
      return Bi - 1;
    default:
      return Bi;
  }
}
function reduce$1(Bi = 0) {
  return Bi + 1;
}
function _defineProperty$3(Bi, e, Ui) {
  return e in Bi ? Object.defineProperty(Bi, e, {
    value: Ui,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : Bi[e] = Ui, Bi;
}
function _objectSpread$3(Bi) {
  for (var e = 1; e < arguments.length; e++) {
    var Ui = arguments[e] != null ? arguments[e] : {}, Zi = Object.keys(Ui);
    typeof Object.getOwnPropertySymbols == "function" && (Zi = Zi.concat(Object.getOwnPropertySymbols(Ui).filter(function(ta) {
      return Object.getOwnPropertyDescriptor(Ui, ta).enumerable;
    }))), Zi.forEach(function(ta) {
      _defineProperty$3(Bi, ta, Ui[ta]);
    });
  }
  return Bi;
}
function reduce(Bi = {}, e) {
  return {
    dirtyHandlerIds: reduce$5(Bi.dirtyHandlerIds, {
      type: e.type,
      payload: _objectSpread$3({}, e.payload, {
        prevTargetIds: get$1(Bi, "dragOperation.targetIds", [])
      })
    }),
    dragOffset: reduce$4(Bi.dragOffset, e),
    refCount: reduce$2(Bi.refCount, e),
    dragOperation: reduce$3(Bi.dragOperation, e),
    stateId: reduce$1(Bi.stateId)
  };
}
function createDragDropManager(Bi, e = void 0, Ui = {}, Zi = !1) {
  const ta = makeStoreInstance(Zi), na = new DragDropMonitorImpl(ta, new HandlerRegistryImpl(ta)), ia = new DragDropManagerImpl(ta, na), aa = Bi(ia, e, Ui);
  return ia.receiveBackend(aa), ia;
}
function makeStoreInstance(Bi) {
  const e = typeof window < "u" && window.__REDUX_DEVTOOLS_EXTENSION__;
  return createStore(reduce, Bi && e && e({
    name: "dnd-core",
    instanceId: "dnd-core"
  }));
}
function _objectWithoutProperties$1(Bi, e) {
  if (Bi == null) return {};
  var Ui = _objectWithoutPropertiesLoose$1(Bi, e), Zi, ta;
  if (Object.getOwnPropertySymbols) {
    var na = Object.getOwnPropertySymbols(Bi);
    for (ta = 0; ta < na.length; ta++)
      Zi = na[ta], !(e.indexOf(Zi) >= 0) && Object.prototype.propertyIsEnumerable.call(Bi, Zi) && (Ui[Zi] = Bi[Zi]);
  }
  return Ui;
}
function _objectWithoutPropertiesLoose$1(Bi, e) {
  if (Bi == null) return {};
  var Ui = {}, Zi = Object.keys(Bi), ta, na;
  for (na = 0; na < Zi.length; na++)
    ta = Zi[na], !(e.indexOf(ta) >= 0) && (Ui[ta] = Bi[ta]);
  return Ui;
}
let refCount = 0;
const INSTANCE_SYM = Symbol.for("__REACT_DND_CONTEXT_INSTANCE__");
var DndProvider = /* @__PURE__ */ memo(function(e) {
  var { children: Ui } = e, Zi = _objectWithoutProperties$1(e, [
    "children"
  ]);
  const [ta, na] = getDndContextValue(Zi);
  return useEffect(() => {
    if (na) {
      const ia = getGlobalContext();
      return ++refCount, () => {
        --refCount === 0 && (ia[INSTANCE_SYM] = null);
      };
    }
  }, []), /* @__PURE__ */ jsxRuntimeExports.jsx(DndContext.Provider, {
    value: ta,
    children: Ui
  });
});
function getDndContextValue(Bi) {
  if ("manager" in Bi)
    return [
      {
        dragDropManager: Bi.manager
      },
      !1
    ];
  const e = createSingletonDndContext(Bi.backend, Bi.context, Bi.options, Bi.debugMode), Ui = !Bi.context;
  return [
    e,
    Ui
  ];
}
function createSingletonDndContext(Bi, e = getGlobalContext(), Ui, Zi) {
  const ta = e;
  return ta[INSTANCE_SYM] || (ta[INSTANCE_SYM] = {
    dragDropManager: createDragDropManager(Bi, e, Ui, Zi)
  }), ta[INSTANCE_SYM];
}
function getGlobalContext() {
  return typeof global < "u" ? global : window;
}
var fastDeepEqual, hasRequiredFastDeepEqual;
function requireFastDeepEqual() {
  return hasRequiredFastDeepEqual || (hasRequiredFastDeepEqual = 1, fastDeepEqual = function Bi(e, Ui) {
    if (e === Ui) return !0;
    if (e && Ui && typeof e == "object" && typeof Ui == "object") {
      if (e.constructor !== Ui.constructor) return !1;
      var Zi, ta, na;
      if (Array.isArray(e)) {
        if (Zi = e.length, Zi != Ui.length) return !1;
        for (ta = Zi; ta-- !== 0; )
          if (!Bi(e[ta], Ui[ta])) return !1;
        return !0;
      }
      if (e.constructor === RegExp) return e.source === Ui.source && e.flags === Ui.flags;
      if (e.valueOf !== Object.prototype.valueOf) return e.valueOf() === Ui.valueOf();
      if (e.toString !== Object.prototype.toString) return e.toString() === Ui.toString();
      if (na = Object.keys(e), Zi = na.length, Zi !== Object.keys(Ui).length) return !1;
      for (ta = Zi; ta-- !== 0; )
        if (!Object.prototype.hasOwnProperty.call(Ui, na[ta])) return !1;
      for (ta = Zi; ta-- !== 0; ) {
        var ia = na[ta];
        if (!Bi(e[ia], Ui[ia])) return !1;
      }
      return !0;
    }
    return e !== e && Ui !== Ui;
  }), fastDeepEqual;
}
var fastDeepEqualExports = requireFastDeepEqual();
const equal = /* @__PURE__ */ getDefaultExportFromCjs(fastDeepEqualExports), useIsomorphicLayoutEffect = typeof window < "u" ? useLayoutEffect : useEffect;
function useCollector(Bi, e, Ui) {
  const [Zi, ta] = useState(
    () => e(Bi)
  ), na = useCallback(() => {
    const ia = e(Bi);
    equal(Zi, ia) || (ta(ia), Ui && Ui());
  }, [
    Zi,
    Bi,
    Ui
  ]);
  return useIsomorphicLayoutEffect(na), [
    Zi,
    na
  ];
}
function useMonitorOutput(Bi, e, Ui) {
  const [Zi, ta] = useCollector(Bi, e, Ui);
  return useIsomorphicLayoutEffect(function() {
    const ia = Bi.getHandlerId();
    if (ia != null)
      return Bi.subscribeToStateChange(ta, {
        handlerIds: [
          ia
        ]
      });
  }, [
    Bi,
    ta
  ]), Zi;
}
function useCollectedProps(Bi, e, Ui) {
  return useMonitorOutput(
    e,
    Bi || (() => ({})),
    () => Ui.reconnect()
  );
}
function useOptionalFactory(Bi, e) {
  const Ui = [];
  return typeof Bi != "function" && Ui.push(Bi), useMemo(() => typeof Bi == "function" ? Bi() : Bi, Ui);
}
function useConnectDragSource(Bi) {
  return useMemo(
    () => Bi.hooks.dragSource(),
    [
      Bi
    ]
  );
}
function useConnectDragPreview(Bi) {
  return useMemo(
    () => Bi.hooks.dragPreview(),
    [
      Bi
    ]
  );
}
let isCallingCanDrag = !1, isCallingIsDragging = !1;
class DragSourceMonitorImpl {
  receiveHandlerId(e) {
    this.sourceId = e;
  }
  getHandlerId() {
    return this.sourceId;
  }
  canDrag() {
    invariant(!isCallingCanDrag, "You may not call monitor.canDrag() inside your canDrag() implementation. Read more: http://react-dnd.github.io/react-dnd/docs/api/drag-source-monitor");
    try {
      return isCallingCanDrag = !0, this.internalMonitor.canDragSource(this.sourceId);
    } finally {
      isCallingCanDrag = !1;
    }
  }
  isDragging() {
    if (!this.sourceId)
      return !1;
    invariant(!isCallingIsDragging, "You may not call monitor.isDragging() inside your isDragging() implementation. Read more: http://react-dnd.github.io/react-dnd/docs/api/drag-source-monitor");
    try {
      return isCallingIsDragging = !0, this.internalMonitor.isDraggingSource(this.sourceId);
    } finally {
      isCallingIsDragging = !1;
    }
  }
  subscribeToStateChange(e, Ui) {
    return this.internalMonitor.subscribeToStateChange(e, Ui);
  }
  isDraggingSource(e) {
    return this.internalMonitor.isDraggingSource(e);
  }
  isOverTarget(e, Ui) {
    return this.internalMonitor.isOverTarget(e, Ui);
  }
  getTargetIds() {
    return this.internalMonitor.getTargetIds();
  }
  isSourcePublic() {
    return this.internalMonitor.isSourcePublic();
  }
  getSourceId() {
    return this.internalMonitor.getSourceId();
  }
  subscribeToOffsetChange(e) {
    return this.internalMonitor.subscribeToOffsetChange(e);
  }
  canDragSource(e) {
    return this.internalMonitor.canDragSource(e);
  }
  canDropOnTarget(e) {
    return this.internalMonitor.canDropOnTarget(e);
  }
  getItemType() {
    return this.internalMonitor.getItemType();
  }
  getItem() {
    return this.internalMonitor.getItem();
  }
  getDropResult() {
    return this.internalMonitor.getDropResult();
  }
  didDrop() {
    return this.internalMonitor.didDrop();
  }
  getInitialClientOffset() {
    return this.internalMonitor.getInitialClientOffset();
  }
  getInitialSourceClientOffset() {
    return this.internalMonitor.getInitialSourceClientOffset();
  }
  getSourceClientOffset() {
    return this.internalMonitor.getSourceClientOffset();
  }
  getClientOffset() {
    return this.internalMonitor.getClientOffset();
  }
  getDifferenceFromInitialOffset() {
    return this.internalMonitor.getDifferenceFromInitialOffset();
  }
  constructor(e) {
    this.sourceId = null, this.internalMonitor = e.getMonitor();
  }
}
let isCallingCanDrop = !1;
class DropTargetMonitorImpl {
  receiveHandlerId(e) {
    this.targetId = e;
  }
  getHandlerId() {
    return this.targetId;
  }
  subscribeToStateChange(e, Ui) {
    return this.internalMonitor.subscribeToStateChange(e, Ui);
  }
  canDrop() {
    if (!this.targetId)
      return !1;
    invariant(!isCallingCanDrop, "You may not call monitor.canDrop() inside your canDrop() implementation. Read more: http://react-dnd.github.io/react-dnd/docs/api/drop-target-monitor");
    try {
      return isCallingCanDrop = !0, this.internalMonitor.canDropOnTarget(this.targetId);
    } finally {
      isCallingCanDrop = !1;
    }
  }
  isOver(e) {
    return this.targetId ? this.internalMonitor.isOverTarget(this.targetId, e) : !1;
  }
  getItemType() {
    return this.internalMonitor.getItemType();
  }
  getItem() {
    return this.internalMonitor.getItem();
  }
  getDropResult() {
    return this.internalMonitor.getDropResult();
  }
  didDrop() {
    return this.internalMonitor.didDrop();
  }
  getInitialClientOffset() {
    return this.internalMonitor.getInitialClientOffset();
  }
  getInitialSourceClientOffset() {
    return this.internalMonitor.getInitialSourceClientOffset();
  }
  getSourceClientOffset() {
    return this.internalMonitor.getSourceClientOffset();
  }
  getClientOffset() {
    return this.internalMonitor.getClientOffset();
  }
  getDifferenceFromInitialOffset() {
    return this.internalMonitor.getDifferenceFromInitialOffset();
  }
  constructor(e) {
    this.targetId = null, this.internalMonitor = e.getMonitor();
  }
}
function registerTarget(Bi, e, Ui) {
  const Zi = Ui.getRegistry(), ta = Zi.addTarget(Bi, e);
  return [
    ta,
    () => Zi.removeTarget(ta)
  ];
}
function registerSource(Bi, e, Ui) {
  const Zi = Ui.getRegistry(), ta = Zi.addSource(Bi, e);
  return [
    ta,
    () => Zi.removeSource(ta)
  ];
}
function shallowEqual(Bi, e, Ui, Zi) {
  let ta;
  if (ta !== void 0)
    return !!ta;
  if (Bi === e)
    return !0;
  if (typeof Bi != "object" || !Bi || typeof e != "object" || !e)
    return !1;
  const na = Object.keys(Bi), ia = Object.keys(e);
  if (na.length !== ia.length)
    return !1;
  const aa = Object.prototype.hasOwnProperty.bind(e);
  for (let da = 0; da < na.length; da++) {
    const La = na[da];
    if (!aa(La))
      return !1;
    const qa = Bi[La], io = e[La];
    if (ta = void 0, ta === !1 || ta === void 0 && qa !== io)
      return !1;
  }
  return !0;
}
function isRef(Bi) {
  return (
    // eslint-disable-next-line no-prototype-builtins
    Bi !== null && typeof Bi == "object" && Object.prototype.hasOwnProperty.call(Bi, "current")
  );
}
function throwIfCompositeComponentElement(Bi) {
  if (typeof Bi.type == "string")
    return;
  const e = Bi.type.displayName || Bi.type.name || "the component";
  throw new Error(`Only native element nodes can now be passed to React DnD connectors.You can either wrap ${e} into a <div>, or turn it into a drag source or a drop target itself.`);
}
function wrapHookToRecognizeElement(Bi) {
  return (e = null, Ui = null) => {
    if (!isValidElement(e)) {
      const na = e;
      return Bi(na, Ui), na;
    }
    const Zi = e;
    return throwIfCompositeComponentElement(Zi), cloneWithRef(Zi, Ui ? (na) => Bi(na, Ui) : Bi);
  };
}
function wrapConnectorHooks(Bi) {
  const e = {};
  return Object.keys(Bi).forEach((Ui) => {
    const Zi = Bi[Ui];
    if (Ui.endsWith("Ref"))
      e[Ui] = Bi[Ui];
    else {
      const ta = wrapHookToRecognizeElement(Zi);
      e[Ui] = () => ta;
    }
  }), e;
}
function setRef(Bi, e) {
  typeof Bi == "function" ? Bi(e) : Bi.current = e;
}
function cloneWithRef(Bi, e) {
  const Ui = Bi.ref;
  return invariant(typeof Ui != "string", "Cannot connect React DnD to an element with an existing string ref. Please convert it to use a callback ref instead, or wrap it into a <span> or <div>. Read more: https://reactjs.org/docs/refs-and-the-dom.html#callback-refs"), Ui ? cloneElement(Bi, {
    ref: (Zi) => {
      setRef(Ui, Zi), setRef(e, Zi);
    }
  }) : cloneElement(Bi, {
    ref: e
  });
}
class SourceConnector {
  receiveHandlerId(e) {
    this.handlerId !== e && (this.handlerId = e, this.reconnect());
  }
  get connectTarget() {
    return this.dragSource;
  }
  get dragSourceOptions() {
    return this.dragSourceOptionsInternal;
  }
  set dragSourceOptions(e) {
    this.dragSourceOptionsInternal = e;
  }
  get dragPreviewOptions() {
    return this.dragPreviewOptionsInternal;
  }
  set dragPreviewOptions(e) {
    this.dragPreviewOptionsInternal = e;
  }
  reconnect() {
    const e = this.reconnectDragSource();
    this.reconnectDragPreview(e);
  }
  reconnectDragSource() {
    const e = this.dragSource, Ui = this.didHandlerIdChange() || this.didConnectedDragSourceChange() || this.didDragSourceOptionsChange();
    return Ui && this.disconnectDragSource(), this.handlerId ? e ? (Ui && (this.lastConnectedHandlerId = this.handlerId, this.lastConnectedDragSource = e, this.lastConnectedDragSourceOptions = this.dragSourceOptions, this.dragSourceUnsubscribe = this.backend.connectDragSource(this.handlerId, e, this.dragSourceOptions)), Ui) : (this.lastConnectedDragSource = e, Ui) : Ui;
  }
  reconnectDragPreview(e = !1) {
    const Ui = this.dragPreview, Zi = e || this.didHandlerIdChange() || this.didConnectedDragPreviewChange() || this.didDragPreviewOptionsChange();
    if (Zi && this.disconnectDragPreview(), !!this.handlerId) {
      if (!Ui) {
        this.lastConnectedDragPreview = Ui;
        return;
      }
      Zi && (this.lastConnectedHandlerId = this.handlerId, this.lastConnectedDragPreview = Ui, this.lastConnectedDragPreviewOptions = this.dragPreviewOptions, this.dragPreviewUnsubscribe = this.backend.connectDragPreview(this.handlerId, Ui, this.dragPreviewOptions));
    }
  }
  didHandlerIdChange() {
    return this.lastConnectedHandlerId !== this.handlerId;
  }
  didConnectedDragSourceChange() {
    return this.lastConnectedDragSource !== this.dragSource;
  }
  didConnectedDragPreviewChange() {
    return this.lastConnectedDragPreview !== this.dragPreview;
  }
  didDragSourceOptionsChange() {
    return !shallowEqual(this.lastConnectedDragSourceOptions, this.dragSourceOptions);
  }
  didDragPreviewOptionsChange() {
    return !shallowEqual(this.lastConnectedDragPreviewOptions, this.dragPreviewOptions);
  }
  disconnectDragSource() {
    this.dragSourceUnsubscribe && (this.dragSourceUnsubscribe(), this.dragSourceUnsubscribe = void 0);
  }
  disconnectDragPreview() {
    this.dragPreviewUnsubscribe && (this.dragPreviewUnsubscribe(), this.dragPreviewUnsubscribe = void 0, this.dragPreviewNode = null, this.dragPreviewRef = null);
  }
  get dragSource() {
    return this.dragSourceNode || this.dragSourceRef && this.dragSourceRef.current;
  }
  get dragPreview() {
    return this.dragPreviewNode || this.dragPreviewRef && this.dragPreviewRef.current;
  }
  clearDragSource() {
    this.dragSourceNode = null, this.dragSourceRef = null;
  }
  clearDragPreview() {
    this.dragPreviewNode = null, this.dragPreviewRef = null;
  }
  constructor(e) {
    this.hooks = wrapConnectorHooks({
      dragSource: (Ui, Zi) => {
        this.clearDragSource(), this.dragSourceOptions = Zi || null, isRef(Ui) ? this.dragSourceRef = Ui : this.dragSourceNode = Ui, this.reconnectDragSource();
      },
      dragPreview: (Ui, Zi) => {
        this.clearDragPreview(), this.dragPreviewOptions = Zi || null, isRef(Ui) ? this.dragPreviewRef = Ui : this.dragPreviewNode = Ui, this.reconnectDragPreview();
      }
    }), this.handlerId = null, this.dragSourceRef = null, this.dragSourceOptionsInternal = null, this.dragPreviewRef = null, this.dragPreviewOptionsInternal = null, this.lastConnectedHandlerId = null, this.lastConnectedDragSource = null, this.lastConnectedDragSourceOptions = null, this.lastConnectedDragPreview = null, this.lastConnectedDragPreviewOptions = null, this.backend = e;
  }
}
class TargetConnector {
  get connectTarget() {
    return this.dropTarget;
  }
  reconnect() {
    const e = this.didHandlerIdChange() || this.didDropTargetChange() || this.didOptionsChange();
    e && this.disconnectDropTarget();
    const Ui = this.dropTarget;
    if (this.handlerId) {
      if (!Ui) {
        this.lastConnectedDropTarget = Ui;
        return;
      }
      e && (this.lastConnectedHandlerId = this.handlerId, this.lastConnectedDropTarget = Ui, this.lastConnectedDropTargetOptions = this.dropTargetOptions, this.unsubscribeDropTarget = this.backend.connectDropTarget(this.handlerId, Ui, this.dropTargetOptions));
    }
  }
  receiveHandlerId(e) {
    e !== this.handlerId && (this.handlerId = e, this.reconnect());
  }
  get dropTargetOptions() {
    return this.dropTargetOptionsInternal;
  }
  set dropTargetOptions(e) {
    this.dropTargetOptionsInternal = e;
  }
  didHandlerIdChange() {
    return this.lastConnectedHandlerId !== this.handlerId;
  }
  didDropTargetChange() {
    return this.lastConnectedDropTarget !== this.dropTarget;
  }
  didOptionsChange() {
    return !shallowEqual(this.lastConnectedDropTargetOptions, this.dropTargetOptions);
  }
  disconnectDropTarget() {
    this.unsubscribeDropTarget && (this.unsubscribeDropTarget(), this.unsubscribeDropTarget = void 0);
  }
  get dropTarget() {
    return this.dropTargetNode || this.dropTargetRef && this.dropTargetRef.current;
  }
  clearDropTarget() {
    this.dropTargetRef = null, this.dropTargetNode = null;
  }
  constructor(e) {
    this.hooks = wrapConnectorHooks({
      dropTarget: (Ui, Zi) => {
        this.clearDropTarget(), this.dropTargetOptions = Zi, isRef(Ui) ? this.dropTargetRef = Ui : this.dropTargetNode = Ui, this.reconnect();
      }
    }), this.handlerId = null, this.dropTargetRef = null, this.dropTargetOptionsInternal = null, this.lastConnectedHandlerId = null, this.lastConnectedDropTarget = null, this.lastConnectedDropTargetOptions = null, this.backend = e;
  }
}
function useDragDropManager() {
  const { dragDropManager: Bi } = useContext(DndContext);
  return invariant(Bi != null, "Expected drag drop context"), Bi;
}
function useDragSourceConnector(Bi, e) {
  const Ui = useDragDropManager(), Zi = useMemo(
    () => new SourceConnector(Ui.getBackend()),
    [
      Ui
    ]
  );
  return useIsomorphicLayoutEffect(() => (Zi.dragSourceOptions = Bi || null, Zi.reconnect(), () => Zi.disconnectDragSource()), [
    Zi,
    Bi
  ]), useIsomorphicLayoutEffect(() => (Zi.dragPreviewOptions = e || null, Zi.reconnect(), () => Zi.disconnectDragPreview()), [
    Zi,
    e
  ]), Zi;
}
function useDragSourceMonitor() {
  const Bi = useDragDropManager();
  return useMemo(
    () => new DragSourceMonitorImpl(Bi),
    [
      Bi
    ]
  );
}
class DragSourceImpl {
  beginDrag() {
    const e = this.spec, Ui = this.monitor;
    let Zi = null;
    return typeof e.item == "object" ? Zi = e.item : typeof e.item == "function" ? Zi = e.item(Ui) : Zi = {}, Zi ?? null;
  }
  canDrag() {
    const e = this.spec, Ui = this.monitor;
    return typeof e.canDrag == "boolean" ? e.canDrag : typeof e.canDrag == "function" ? e.canDrag(Ui) : !0;
  }
  isDragging(e, Ui) {
    const Zi = this.spec, ta = this.monitor, { isDragging: na } = Zi;
    return na ? na(ta) : Ui === e.getSourceId();
  }
  endDrag() {
    const e = this.spec, Ui = this.monitor, Zi = this.connector, { end: ta } = e;
    ta && ta(Ui.getItem(), Ui), Zi.reconnect();
  }
  constructor(e, Ui, Zi) {
    this.spec = e, this.monitor = Ui, this.connector = Zi;
  }
}
function useDragSource(Bi, e, Ui) {
  const Zi = useMemo(
    () => new DragSourceImpl(Bi, e, Ui),
    [
      e,
      Ui
    ]
  );
  return useEffect(() => {
    Zi.spec = Bi;
  }, [
    Bi
  ]), Zi;
}
function useDragType(Bi) {
  return useMemo(() => {
    const e = Bi.type;
    return invariant(e != null, "spec.type must be defined"), e;
  }, [
    Bi
  ]);
}
function useRegisteredDragSource(Bi, e, Ui) {
  const Zi = useDragDropManager(), ta = useDragSource(Bi, e, Ui), na = useDragType(Bi);
  useIsomorphicLayoutEffect(function() {
    if (na != null) {
      const [aa, da] = registerSource(na, ta, Zi);
      return e.receiveHandlerId(aa), Ui.receiveHandlerId(aa), da;
    }
  }, [
    Zi,
    e,
    Ui,
    ta,
    na
  ]);
}
function useDrag(Bi, e) {
  const Ui = useOptionalFactory(Bi);
  invariant(!Ui.begin, "useDrag::spec.begin was deprecated in v14. Replace spec.begin() with spec.item(). (see more here - https://react-dnd.github.io/react-dnd/docs/api/use-drag)");
  const Zi = useDragSourceMonitor(), ta = useDragSourceConnector(Ui.options, Ui.previewOptions);
  return useRegisteredDragSource(Ui, Zi, ta), [
    useCollectedProps(Ui.collect, Zi, ta),
    useConnectDragSource(ta),
    useConnectDragPreview(ta)
  ];
}
function useConnectDropTarget(Bi) {
  return useMemo(
    () => Bi.hooks.dropTarget(),
    [
      Bi
    ]
  );
}
function useDropTargetConnector(Bi) {
  const e = useDragDropManager(), Ui = useMemo(
    () => new TargetConnector(e.getBackend()),
    [
      e
    ]
  );
  return useIsomorphicLayoutEffect(() => (Ui.dropTargetOptions = Bi || null, Ui.reconnect(), () => Ui.disconnectDropTarget()), [
    Bi
  ]), Ui;
}
function useDropTargetMonitor() {
  const Bi = useDragDropManager();
  return useMemo(
    () => new DropTargetMonitorImpl(Bi),
    [
      Bi
    ]
  );
}
function useAccept(Bi) {
  const { accept: e } = Bi;
  return useMemo(() => (invariant(Bi.accept != null, "accept must be defined"), Array.isArray(e) ? e : [
    e
  ]), [
    e
  ]);
}
class DropTargetImpl {
  canDrop() {
    const e = this.spec, Ui = this.monitor;
    return e.canDrop ? e.canDrop(Ui.getItem(), Ui) : !0;
  }
  hover() {
    const e = this.spec, Ui = this.monitor;
    e.hover && e.hover(Ui.getItem(), Ui);
  }
  drop() {
    const e = this.spec, Ui = this.monitor;
    if (e.drop)
      return e.drop(Ui.getItem(), Ui);
  }
  constructor(e, Ui) {
    this.spec = e, this.monitor = Ui;
  }
}
function useDropTarget(Bi, e) {
  const Ui = useMemo(
    () => new DropTargetImpl(Bi, e),
    [
      e
    ]
  );
  return useEffect(() => {
    Ui.spec = Bi;
  }, [
    Bi
  ]), Ui;
}
function useRegisteredDropTarget(Bi, e, Ui) {
  const Zi = useDragDropManager(), ta = useDropTarget(Bi, e), na = useAccept(Bi);
  useIsomorphicLayoutEffect(function() {
    const [aa, da] = registerTarget(na, ta, Zi);
    return e.receiveHandlerId(aa), Ui.receiveHandlerId(aa), da;
  }, [
    Zi,
    e,
    ta,
    Ui,
    na.map(
      (ia) => ia.toString()
    ).join("|")
  ]);
}
function useDrop(Bi, e) {
  const Ui = useOptionalFactory(Bi), Zi = useDropTargetMonitor(), ta = useDropTargetConnector(Ui.options);
  return useRegisteredDropTarget(Ui, Zi, ta), [
    useCollectedProps(Ui.collect, Zi, ta),
    useConnectDropTarget(ta)
  ];
}
function memoize(Bi) {
  let e = null;
  return () => (e == null && (e = Bi()), e);
}
function without(Bi, e) {
  return Bi.filter(
    (Ui) => Ui !== e
  );
}
function union(Bi, e) {
  const Ui = /* @__PURE__ */ new Set(), Zi = (na) => Ui.add(na);
  Bi.forEach(Zi), e.forEach(Zi);
  const ta = [];
  return Ui.forEach(
    (na) => ta.push(na)
  ), ta;
}
class EnterLeaveCounter {
  enter(e) {
    const Ui = this.entered.length, Zi = (ta) => this.isNodeInDocument(ta) && (!ta.contains || ta.contains(e));
    return this.entered = union(this.entered.filter(Zi), [
      e
    ]), Ui === 0 && this.entered.length > 0;
  }
  leave(e) {
    const Ui = this.entered.length;
    return this.entered = without(this.entered.filter(this.isNodeInDocument), e), Ui > 0 && this.entered.length === 0;
  }
  reset() {
    this.entered = [];
  }
  constructor(e) {
    this.entered = [], this.isNodeInDocument = e;
  }
}
class NativeDragSource {
  initializeExposedProperties() {
    Object.keys(this.config.exposeProperties).forEach((e) => {
      Object.defineProperty(this.item, e, {
        configurable: !0,
        enumerable: !0,
        get() {
          return console.warn(`Browser doesn't allow reading "${e}" until the drop event.`), null;
        }
      });
    });
  }
  loadDataTransfer(e) {
    if (e) {
      const Ui = {};
      Object.keys(this.config.exposeProperties).forEach((Zi) => {
        const ta = this.config.exposeProperties[Zi];
        ta != null && (Ui[Zi] = {
          value: ta(e, this.config.matchesTypes),
          configurable: !0,
          enumerable: !0
        });
      }), Object.defineProperties(this.item, Ui);
    }
  }
  canDrag() {
    return !0;
  }
  beginDrag() {
    return this.item;
  }
  isDragging(e, Ui) {
    return Ui === e.getSourceId();
  }
  endDrag() {
  }
  constructor(e) {
    this.config = e, this.item = {}, this.initializeExposedProperties();
  }
}
const FILE = "__NATIVE_FILE__", URL$1 = "__NATIVE_URL__", TEXT = "__NATIVE_TEXT__", HTML = "__NATIVE_HTML__", NativeTypes = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  FILE,
  HTML,
  TEXT,
  URL: URL$1
}, Symbol.toStringTag, { value: "Module" }));
function getDataFromDataTransfer(Bi, e, Ui) {
  const Zi = e.reduce(
    (ta, na) => ta || Bi.getData(na),
    ""
  );
  return Zi ?? Ui;
}
const nativeTypesConfig = {
  [FILE]: {
    exposeProperties: {
      files: (Bi) => Array.prototype.slice.call(Bi.files),
      items: (Bi) => Bi.items,
      dataTransfer: (Bi) => Bi
    },
    matchesTypes: [
      "Files"
    ]
  },
  [HTML]: {
    exposeProperties: {
      html: (Bi, e) => getDataFromDataTransfer(Bi, e, ""),
      dataTransfer: (Bi) => Bi
    },
    matchesTypes: [
      "Html",
      "text/html"
    ]
  },
  [URL$1]: {
    exposeProperties: {
      urls: (Bi, e) => getDataFromDataTransfer(Bi, e, "").split(`
`),
      dataTransfer: (Bi) => Bi
    },
    matchesTypes: [
      "Url",
      "text/uri-list"
    ]
  },
  [TEXT]: {
    exposeProperties: {
      text: (Bi, e) => getDataFromDataTransfer(Bi, e, ""),
      dataTransfer: (Bi) => Bi
    },
    matchesTypes: [
      "Text",
      "text/plain"
    ]
  }
};
function createNativeDragSource(Bi, e) {
  const Ui = nativeTypesConfig[Bi];
  if (!Ui)
    throw new Error(`native type ${Bi} has no configuration`);
  const Zi = new NativeDragSource(Ui);
  return Zi.loadDataTransfer(e), Zi;
}
function matchNativeItemType(Bi) {
  if (!Bi)
    return null;
  const e = Array.prototype.slice.call(Bi.types || []);
  return Object.keys(nativeTypesConfig).filter((Ui) => {
    const Zi = nativeTypesConfig[Ui];
    return Zi?.matchesTypes ? Zi.matchesTypes.some(
      (ta) => e.indexOf(ta) > -1
    ) : !1;
  })[0] || null;
}
const isFirefox = memoize(
  () => /firefox/i.test(navigator.userAgent)
), isSafari = memoize(
  () => !!window.safari
);
class MonotonicInterpolant {
  interpolate(e) {
    const { xs: Ui, ys: Zi, c1s: ta, c2s: na, c3s: ia } = this;
    let aa = Ui.length - 1;
    if (e === Ui[aa])
      return Zi[aa];
    let da = 0, La = ia.length - 1, qa;
    for (; da <= La; ) {
      qa = Math.floor(0.5 * (da + La));
      const oo = Ui[qa];
      if (oo < e)
        da = qa + 1;
      else if (oo > e)
        La = qa - 1;
      else
        return Zi[qa];
    }
    aa = Math.max(0, La);
    const io = e - Ui[aa], ao = io * io;
    return Zi[aa] + ta[aa] * io + na[aa] * ao + ia[aa] * io * ao;
  }
  constructor(e, Ui) {
    const { length: Zi } = e, ta = [];
    for (let oo = 0; oo < Zi; oo++)
      ta.push(oo);
    ta.sort(
      (oo, no) => e[oo] < e[no] ? -1 : 1
    );
    const na = [], ia = [];
    let aa, da;
    for (let oo = 0; oo < Zi - 1; oo++)
      aa = e[oo + 1] - e[oo], da = Ui[oo + 1] - Ui[oo], na.push(aa), ia.push(da / aa);
    const La = [
      ia[0]
    ];
    for (let oo = 0; oo < na.length - 1; oo++) {
      const no = ia[oo], lo = ia[oo + 1];
      if (no * lo <= 0)
        La.push(0);
      else {
        aa = na[oo];
        const so = na[oo + 1], bs = aa + so;
        La.push(3 * bs / ((bs + so) / no + (bs + aa) / lo));
      }
    }
    La.push(ia[ia.length - 1]);
    const qa = [], io = [];
    let ao;
    for (let oo = 0; oo < La.length - 1; oo++) {
      ao = ia[oo];
      const no = La[oo], lo = 1 / na[oo], so = no + La[oo + 1] - ao - ao;
      qa.push((ao - no - so) * lo), io.push(so * lo * lo);
    }
    this.xs = e, this.ys = Ui, this.c1s = La, this.c2s = qa, this.c3s = io;
  }
}
const ELEMENT_NODE = 1;
function getNodeClientOffset(Bi) {
  const e = Bi.nodeType === ELEMENT_NODE ? Bi : Bi.parentElement;
  if (!e)
    return null;
  const { top: Ui, left: Zi } = e.getBoundingClientRect();
  return {
    x: Zi,
    y: Ui
  };
}
function getEventClientOffset(Bi) {
  return {
    x: Bi.clientX,
    y: Bi.clientY
  };
}
function isImageNode(Bi) {
  var e;
  return Bi.nodeName === "IMG" && (isFirefox() || !(!((e = document.documentElement) === null || e === void 0) && e.contains(Bi)));
}
function getDragPreviewSize(Bi, e, Ui, Zi) {
  let ta = Bi ? e.width : Ui, na = Bi ? e.height : Zi;
  return isSafari() && Bi && (na /= window.devicePixelRatio, ta /= window.devicePixelRatio), {
    dragPreviewWidth: ta,
    dragPreviewHeight: na
  };
}
function getDragPreviewOffset(Bi, e, Ui, Zi, ta) {
  const na = isImageNode(e), aa = getNodeClientOffset(na ? Bi : e), da = {
    x: Ui.x - aa.x,
    y: Ui.y - aa.y
  }, { offsetWidth: La, offsetHeight: qa } = Bi, { anchorX: io, anchorY: ao } = Zi, { dragPreviewWidth: oo, dragPreviewHeight: no } = getDragPreviewSize(na, e, La, qa), lo = () => {
    let fs = new MonotonicInterpolant([
      0,
      0.5,
      1
    ], [
      // Dock to the top
      da.y,
      // Align at the center
      da.y / qa * no,
      // Dock to the bottom
      da.y + no - qa
    ]).interpolate(ao);
    return isSafari() && na && (fs += (window.devicePixelRatio - 1) * no), fs;
  }, so = () => new MonotonicInterpolant([
    0,
    0.5,
    1
  ], [
    // Dock to the left
    da.x,
    // Align at the center
    da.x / La * oo,
    // Dock to the right
    da.x + oo - La
  ]).interpolate(io), { offsetX: bs, offsetY: Rs } = ta, js = bs === 0 || bs, qs = Rs === 0 || Rs;
  return {
    x: js ? bs : so(),
    y: qs ? Rs : lo()
  };
}
class OptionsReader {
  get window() {
    if (this.globalContext)
      return this.globalContext;
    if (typeof window < "u")
      return window;
  }
  get document() {
    var e;
    return !((e = this.globalContext) === null || e === void 0) && e.document ? this.globalContext.document : this.window ? this.window.document : void 0;
  }
  get rootElement() {
    var e;
    return ((e = this.optionsArgs) === null || e === void 0 ? void 0 : e.rootElement) || this.window;
  }
  constructor(e, Ui) {
    this.ownerDocument = null, this.globalContext = e, this.optionsArgs = Ui;
  }
}
function _defineProperty$2(Bi, e, Ui) {
  return e in Bi ? Object.defineProperty(Bi, e, {
    value: Ui,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : Bi[e] = Ui, Bi;
}
function _objectSpread$2(Bi) {
  for (var e = 1; e < arguments.length; e++) {
    var Ui = arguments[e] != null ? arguments[e] : {}, Zi = Object.keys(Ui);
    typeof Object.getOwnPropertySymbols == "function" && (Zi = Zi.concat(Object.getOwnPropertySymbols(Ui).filter(function(ta) {
      return Object.getOwnPropertyDescriptor(Ui, ta).enumerable;
    }))), Zi.forEach(function(ta) {
      _defineProperty$2(Bi, ta, Ui[ta]);
    });
  }
  return Bi;
}
class HTML5BackendImpl {
  /**
  * Generate profiling statistics for the HTML5Backend.
  */
  profile() {
    var e, Ui;
    return {
      sourcePreviewNodes: this.sourcePreviewNodes.size,
      sourcePreviewNodeOptions: this.sourcePreviewNodeOptions.size,
      sourceNodeOptions: this.sourceNodeOptions.size,
      sourceNodes: this.sourceNodes.size,
      dragStartSourceIds: ((e = this.dragStartSourceIds) === null || e === void 0 ? void 0 : e.length) || 0,
      dropTargetIds: this.dropTargetIds.length,
      dragEnterTargetIds: this.dragEnterTargetIds.length,
      dragOverTargetIds: ((Ui = this.dragOverTargetIds) === null || Ui === void 0 ? void 0 : Ui.length) || 0
    };
  }
  // public for test
  get window() {
    return this.options.window;
  }
  get document() {
    return this.options.document;
  }
  /**
  * Get the root element to use for event subscriptions
  */
  get rootElement() {
    return this.options.rootElement;
  }
  setup() {
    const e = this.rootElement;
    if (e !== void 0) {
      if (e.__isReactDndBackendSetUp)
        throw new Error("Cannot have two HTML5 backends at the same time.");
      e.__isReactDndBackendSetUp = !0, this.addEventListeners(e);
    }
  }
  teardown() {
    const e = this.rootElement;
    if (e !== void 0 && (e.__isReactDndBackendSetUp = !1, this.removeEventListeners(this.rootElement), this.clearCurrentDragSourceNode(), this.asyncEndDragFrameId)) {
      var Ui;
      (Ui = this.window) === null || Ui === void 0 || Ui.cancelAnimationFrame(this.asyncEndDragFrameId);
    }
  }
  connectDragPreview(e, Ui, Zi) {
    return this.sourcePreviewNodeOptions.set(e, Zi), this.sourcePreviewNodes.set(e, Ui), () => {
      this.sourcePreviewNodes.delete(e), this.sourcePreviewNodeOptions.delete(e);
    };
  }
  connectDragSource(e, Ui, Zi) {
    this.sourceNodes.set(e, Ui), this.sourceNodeOptions.set(e, Zi);
    const ta = (ia) => this.handleDragStart(ia, e), na = (ia) => this.handleSelectStart(ia);
    return Ui.setAttribute("draggable", "true"), Ui.addEventListener("dragstart", ta), Ui.addEventListener("selectstart", na), () => {
      this.sourceNodes.delete(e), this.sourceNodeOptions.delete(e), Ui.removeEventListener("dragstart", ta), Ui.removeEventListener("selectstart", na), Ui.setAttribute("draggable", "false");
    };
  }
  connectDropTarget(e, Ui) {
    const Zi = (ia) => this.handleDragEnter(ia, e), ta = (ia) => this.handleDragOver(ia, e), na = (ia) => this.handleDrop(ia, e);
    return Ui.addEventListener("dragenter", Zi), Ui.addEventListener("dragover", ta), Ui.addEventListener("drop", na), () => {
      Ui.removeEventListener("dragenter", Zi), Ui.removeEventListener("dragover", ta), Ui.removeEventListener("drop", na);
    };
  }
  addEventListeners(e) {
    e.addEventListener && (e.addEventListener("dragstart", this.handleTopDragStart), e.addEventListener("dragstart", this.handleTopDragStartCapture, !0), e.addEventListener("dragend", this.handleTopDragEndCapture, !0), e.addEventListener("dragenter", this.handleTopDragEnter), e.addEventListener("dragenter", this.handleTopDragEnterCapture, !0), e.addEventListener("dragleave", this.handleTopDragLeaveCapture, !0), e.addEventListener("dragover", this.handleTopDragOver), e.addEventListener("dragover", this.handleTopDragOverCapture, !0), e.addEventListener("drop", this.handleTopDrop), e.addEventListener("drop", this.handleTopDropCapture, !0));
  }
  removeEventListeners(e) {
    e.removeEventListener && (e.removeEventListener("dragstart", this.handleTopDragStart), e.removeEventListener("dragstart", this.handleTopDragStartCapture, !0), e.removeEventListener("dragend", this.handleTopDragEndCapture, !0), e.removeEventListener("dragenter", this.handleTopDragEnter), e.removeEventListener("dragenter", this.handleTopDragEnterCapture, !0), e.removeEventListener("dragleave", this.handleTopDragLeaveCapture, !0), e.removeEventListener("dragover", this.handleTopDragOver), e.removeEventListener("dragover", this.handleTopDragOverCapture, !0), e.removeEventListener("drop", this.handleTopDrop), e.removeEventListener("drop", this.handleTopDropCapture, !0));
  }
  getCurrentSourceNodeOptions() {
    const e = this.monitor.getSourceId(), Ui = this.sourceNodeOptions.get(e);
    return _objectSpread$2({
      dropEffect: this.altKeyPressed ? "copy" : "move"
    }, Ui || {});
  }
  getCurrentDropEffect() {
    return this.isDraggingNativeItem() ? "copy" : this.getCurrentSourceNodeOptions().dropEffect;
  }
  getCurrentSourcePreviewNodeOptions() {
    const e = this.monitor.getSourceId(), Ui = this.sourcePreviewNodeOptions.get(e);
    return _objectSpread$2({
      anchorX: 0.5,
      anchorY: 0.5,
      captureDraggingState: !1
    }, Ui || {});
  }
  isDraggingNativeItem() {
    const e = this.monitor.getItemType();
    return Object.keys(NativeTypes).some(
      (Ui) => NativeTypes[Ui] === e
    );
  }
  beginDragNativeItem(e, Ui) {
    this.clearCurrentDragSourceNode(), this.currentNativeSource = createNativeDragSource(e, Ui), this.currentNativeHandle = this.registry.addSource(e, this.currentNativeSource), this.actions.beginDrag([
      this.currentNativeHandle
    ]);
  }
  setCurrentDragSourceNode(e) {
    this.clearCurrentDragSourceNode(), this.currentDragSourceNode = e;
    const Ui = 1e3;
    this.mouseMoveTimeoutTimer = setTimeout(() => {
      var Zi;
      return (Zi = this.rootElement) === null || Zi === void 0 ? void 0 : Zi.addEventListener("mousemove", this.endDragIfSourceWasRemovedFromDOM, !0);
    }, Ui);
  }
  clearCurrentDragSourceNode() {
    if (this.currentDragSourceNode) {
      if (this.currentDragSourceNode = null, this.rootElement) {
        var e;
        (e = this.window) === null || e === void 0 || e.clearTimeout(this.mouseMoveTimeoutTimer || void 0), this.rootElement.removeEventListener("mousemove", this.endDragIfSourceWasRemovedFromDOM, !0);
      }
      return this.mouseMoveTimeoutTimer = null, !0;
    }
    return !1;
  }
  handleDragStart(e, Ui) {
    e.defaultPrevented || (this.dragStartSourceIds || (this.dragStartSourceIds = []), this.dragStartSourceIds.unshift(Ui));
  }
  handleDragEnter(e, Ui) {
    this.dragEnterTargetIds.unshift(Ui);
  }
  handleDragOver(e, Ui) {
    this.dragOverTargetIds === null && (this.dragOverTargetIds = []), this.dragOverTargetIds.unshift(Ui);
  }
  handleDrop(e, Ui) {
    this.dropTargetIds.unshift(Ui);
  }
  constructor(e, Ui, Zi) {
    this.sourcePreviewNodes = /* @__PURE__ */ new Map(), this.sourcePreviewNodeOptions = /* @__PURE__ */ new Map(), this.sourceNodes = /* @__PURE__ */ new Map(), this.sourceNodeOptions = /* @__PURE__ */ new Map(), this.dragStartSourceIds = null, this.dropTargetIds = [], this.dragEnterTargetIds = [], this.currentNativeSource = null, this.currentNativeHandle = null, this.currentDragSourceNode = null, this.altKeyPressed = !1, this.mouseMoveTimeoutTimer = null, this.asyncEndDragFrameId = null, this.dragOverTargetIds = null, this.lastClientOffset = null, this.hoverRafId = null, this.getSourceClientOffset = (ta) => {
      const na = this.sourceNodes.get(ta);
      return na && getNodeClientOffset(na) || null;
    }, this.endDragNativeItem = () => {
      this.isDraggingNativeItem() && (this.actions.endDrag(), this.currentNativeHandle && this.registry.removeSource(this.currentNativeHandle), this.currentNativeHandle = null, this.currentNativeSource = null);
    }, this.isNodeInDocument = (ta) => !!(ta && this.document && this.document.body && this.document.body.contains(ta)), this.endDragIfSourceWasRemovedFromDOM = () => {
      const ta = this.currentDragSourceNode;
      ta == null || this.isNodeInDocument(ta) || (this.clearCurrentDragSourceNode() && this.monitor.isDragging() && this.actions.endDrag(), this.cancelHover());
    }, this.scheduleHover = (ta) => {
      this.hoverRafId === null && typeof requestAnimationFrame < "u" && (this.hoverRafId = requestAnimationFrame(() => {
        this.monitor.isDragging() && this.actions.hover(ta || [], {
          clientOffset: this.lastClientOffset
        }), this.hoverRafId = null;
      }));
    }, this.cancelHover = () => {
      this.hoverRafId !== null && typeof cancelAnimationFrame < "u" && (cancelAnimationFrame(this.hoverRafId), this.hoverRafId = null);
    }, this.handleTopDragStartCapture = () => {
      this.clearCurrentDragSourceNode(), this.dragStartSourceIds = [];
    }, this.handleTopDragStart = (ta) => {
      if (ta.defaultPrevented)
        return;
      const { dragStartSourceIds: na } = this;
      this.dragStartSourceIds = null;
      const ia = getEventClientOffset(ta);
      this.monitor.isDragging() && (this.actions.endDrag(), this.cancelHover()), this.actions.beginDrag(na || [], {
        publishSource: !1,
        getSourceClientOffset: this.getSourceClientOffset,
        clientOffset: ia
      });
      const { dataTransfer: aa } = ta, da = matchNativeItemType(aa);
      if (this.monitor.isDragging()) {
        if (aa && typeof aa.setDragImage == "function") {
          const qa = this.monitor.getSourceId(), io = this.sourceNodes.get(qa), ao = this.sourcePreviewNodes.get(qa) || io;
          if (ao) {
            const { anchorX: oo, anchorY: no, offsetX: lo, offsetY: so } = this.getCurrentSourcePreviewNodeOptions(), js = getDragPreviewOffset(io, ao, ia, {
              anchorX: oo,
              anchorY: no
            }, {
              offsetX: lo,
              offsetY: so
            });
            aa.setDragImage(ao, js.x, js.y);
          }
        }
        try {
          aa?.setData("application/json", {});
        } catch {
        }
        this.setCurrentDragSourceNode(ta.target);
        const { captureDraggingState: La } = this.getCurrentSourcePreviewNodeOptions();
        La ? this.actions.publishDragSource() : setTimeout(
          () => this.actions.publishDragSource(),
          0
        );
      } else if (da)
        this.beginDragNativeItem(da);
      else {
        if (aa && !aa.types && (ta.target && !ta.target.hasAttribute || !ta.target.hasAttribute("draggable")))
          return;
        ta.preventDefault();
      }
    }, this.handleTopDragEndCapture = () => {
      this.clearCurrentDragSourceNode() && this.monitor.isDragging() && this.actions.endDrag(), this.cancelHover();
    }, this.handleTopDragEnterCapture = (ta) => {
      if (this.dragEnterTargetIds = [], this.isDraggingNativeItem()) {
        var na;
        (na = this.currentNativeSource) === null || na === void 0 || na.loadDataTransfer(ta.dataTransfer);
      }
      if (!this.enterLeaveCounter.enter(ta.target) || this.monitor.isDragging())
        return;
      const { dataTransfer: aa } = ta, da = matchNativeItemType(aa);
      da && this.beginDragNativeItem(da, aa);
    }, this.handleTopDragEnter = (ta) => {
      const { dragEnterTargetIds: na } = this;
      if (this.dragEnterTargetIds = [], !this.monitor.isDragging())
        return;
      this.altKeyPressed = ta.altKey, na.length > 0 && this.actions.hover(na, {
        clientOffset: getEventClientOffset(ta)
      }), na.some(
        (aa) => this.monitor.canDropOnTarget(aa)
      ) && (ta.preventDefault(), ta.dataTransfer && (ta.dataTransfer.dropEffect = this.getCurrentDropEffect()));
    }, this.handleTopDragOverCapture = (ta) => {
      if (this.dragOverTargetIds = [], this.isDraggingNativeItem()) {
        var na;
        (na = this.currentNativeSource) === null || na === void 0 || na.loadDataTransfer(ta.dataTransfer);
      }
    }, this.handleTopDragOver = (ta) => {
      const { dragOverTargetIds: na } = this;
      if (this.dragOverTargetIds = [], !this.monitor.isDragging()) {
        ta.preventDefault(), ta.dataTransfer && (ta.dataTransfer.dropEffect = "none");
        return;
      }
      this.altKeyPressed = ta.altKey, this.lastClientOffset = getEventClientOffset(ta), this.scheduleHover(na), (na || []).some(
        (aa) => this.monitor.canDropOnTarget(aa)
      ) ? (ta.preventDefault(), ta.dataTransfer && (ta.dataTransfer.dropEffect = this.getCurrentDropEffect())) : this.isDraggingNativeItem() ? ta.preventDefault() : (ta.preventDefault(), ta.dataTransfer && (ta.dataTransfer.dropEffect = "none"));
    }, this.handleTopDragLeaveCapture = (ta) => {
      this.isDraggingNativeItem() && ta.preventDefault(), this.enterLeaveCounter.leave(ta.target) && (this.isDraggingNativeItem() && setTimeout(
        () => this.endDragNativeItem(),
        0
      ), this.cancelHover());
    }, this.handleTopDropCapture = (ta) => {
      if (this.dropTargetIds = [], this.isDraggingNativeItem()) {
        var na;
        ta.preventDefault(), (na = this.currentNativeSource) === null || na === void 0 || na.loadDataTransfer(ta.dataTransfer);
      } else matchNativeItemType(ta.dataTransfer) && ta.preventDefault();
      this.enterLeaveCounter.reset();
    }, this.handleTopDrop = (ta) => {
      const { dropTargetIds: na } = this;
      this.dropTargetIds = [], this.actions.hover(na, {
        clientOffset: getEventClientOffset(ta)
      }), this.actions.drop({
        dropEffect: this.getCurrentDropEffect()
      }), this.isDraggingNativeItem() ? this.endDragNativeItem() : this.monitor.isDragging() && this.actions.endDrag(), this.cancelHover();
    }, this.handleSelectStart = (ta) => {
      const na = ta.target;
      typeof na.dragDrop == "function" && (na.tagName === "INPUT" || na.tagName === "SELECT" || na.tagName === "TEXTAREA" || na.isContentEditable || (ta.preventDefault(), na.dragDrop()));
    }, this.options = new OptionsReader(Ui, Zi), this.actions = e.getActions(), this.monitor = e.getMonitor(), this.registry = e.getRegistry(), this.enterLeaveCounter = new EnterLeaveCounter(this.isNodeInDocument);
  }
}
const HTML5Backend = function(e, Ui, Zi) {
  return new HTML5BackendImpl(e, Ui, Zi);
}, COMMON_MIME_TYPES = /* @__PURE__ */ new Map([
  // https://github.com/guzzle/psr7/blob/2d9260799e713f1c475d3c5fdc3d6561ff7441b2/src/MimeType.php
  ["1km", "application/vnd.1000minds.decision-model+xml"],
  ["3dml", "text/vnd.in3d.3dml"],
  ["3ds", "image/x-3ds"],
  ["3g2", "video/3gpp2"],
  ["3gp", "video/3gp"],
  ["3gpp", "video/3gpp"],
  ["3mf", "model/3mf"],
  ["7z", "application/x-7z-compressed"],
  ["7zip", "application/x-7z-compressed"],
  ["123", "application/vnd.lotus-1-2-3"],
  ["aab", "application/x-authorware-bin"],
  ["aac", "audio/x-acc"],
  ["aam", "application/x-authorware-map"],
  ["aas", "application/x-authorware-seg"],
  ["abw", "application/x-abiword"],
  ["ac", "application/vnd.nokia.n-gage.ac+xml"],
  ["ac3", "audio/ac3"],
  ["acc", "application/vnd.americandynamics.acc"],
  ["ace", "application/x-ace-compressed"],
  ["acu", "application/vnd.acucobol"],
  ["acutc", "application/vnd.acucorp"],
  ["adp", "audio/adpcm"],
  ["aep", "application/vnd.audiograph"],
  ["afm", "application/x-font-type1"],
  ["afp", "application/vnd.ibm.modcap"],
  ["ahead", "application/vnd.ahead.space"],
  ["ai", "application/pdf"],
  ["aif", "audio/x-aiff"],
  ["aifc", "audio/x-aiff"],
  ["aiff", "audio/x-aiff"],
  ["air", "application/vnd.adobe.air-application-installer-package+zip"],
  ["ait", "application/vnd.dvb.ait"],
  ["ami", "application/vnd.amiga.ami"],
  ["amr", "audio/amr"],
  ["apk", "application/vnd.android.package-archive"],
  ["apng", "image/apng"],
  ["appcache", "text/cache-manifest"],
  ["application", "application/x-ms-application"],
  ["apr", "application/vnd.lotus-approach"],
  ["arc", "application/x-freearc"],
  ["arj", "application/x-arj"],
  ["asc", "application/pgp-signature"],
  ["asf", "video/x-ms-asf"],
  ["asm", "text/x-asm"],
  ["aso", "application/vnd.accpac.simply.aso"],
  ["asx", "video/x-ms-asf"],
  ["atc", "application/vnd.acucorp"],
  ["atom", "application/atom+xml"],
  ["atomcat", "application/atomcat+xml"],
  ["atomdeleted", "application/atomdeleted+xml"],
  ["atomsvc", "application/atomsvc+xml"],
  ["atx", "application/vnd.antix.game-component"],
  ["au", "audio/x-au"],
  ["avi", "video/x-msvideo"],
  ["avif", "image/avif"],
  ["aw", "application/applixware"],
  ["azf", "application/vnd.airzip.filesecure.azf"],
  ["azs", "application/vnd.airzip.filesecure.azs"],
  ["azv", "image/vnd.airzip.accelerator.azv"],
  ["azw", "application/vnd.amazon.ebook"],
  ["b16", "image/vnd.pco.b16"],
  ["bat", "application/x-msdownload"],
  ["bcpio", "application/x-bcpio"],
  ["bdf", "application/x-font-bdf"],
  ["bdm", "application/vnd.syncml.dm+wbxml"],
  ["bdoc", "application/x-bdoc"],
  ["bed", "application/vnd.realvnc.bed"],
  ["bh2", "application/vnd.fujitsu.oasysprs"],
  ["bin", "application/octet-stream"],
  ["blb", "application/x-blorb"],
  ["blorb", "application/x-blorb"],
  ["bmi", "application/vnd.bmi"],
  ["bmml", "application/vnd.balsamiq.bmml+xml"],
  ["bmp", "image/bmp"],
  ["book", "application/vnd.framemaker"],
  ["box", "application/vnd.previewsystems.box"],
  ["boz", "application/x-bzip2"],
  ["bpk", "application/octet-stream"],
  ["bpmn", "application/octet-stream"],
  ["bsp", "model/vnd.valve.source.compiled-map"],
  ["btif", "image/prs.btif"],
  ["buffer", "application/octet-stream"],
  ["bz", "application/x-bzip"],
  ["bz2", "application/x-bzip2"],
  ["c", "text/x-c"],
  ["c4d", "application/vnd.clonk.c4group"],
  ["c4f", "application/vnd.clonk.c4group"],
  ["c4g", "application/vnd.clonk.c4group"],
  ["c4p", "application/vnd.clonk.c4group"],
  ["c4u", "application/vnd.clonk.c4group"],
  ["c11amc", "application/vnd.cluetrust.cartomobile-config"],
  ["c11amz", "application/vnd.cluetrust.cartomobile-config-pkg"],
  ["cab", "application/vnd.ms-cab-compressed"],
  ["caf", "audio/x-caf"],
  ["cap", "application/vnd.tcpdump.pcap"],
  ["car", "application/vnd.curl.car"],
  ["cat", "application/vnd.ms-pki.seccat"],
  ["cb7", "application/x-cbr"],
  ["cba", "application/x-cbr"],
  ["cbr", "application/x-cbr"],
  ["cbt", "application/x-cbr"],
  ["cbz", "application/x-cbr"],
  ["cc", "text/x-c"],
  ["cco", "application/x-cocoa"],
  ["cct", "application/x-director"],
  ["ccxml", "application/ccxml+xml"],
  ["cdbcmsg", "application/vnd.contact.cmsg"],
  ["cda", "application/x-cdf"],
  ["cdf", "application/x-netcdf"],
  ["cdfx", "application/cdfx+xml"],
  ["cdkey", "application/vnd.mediastation.cdkey"],
  ["cdmia", "application/cdmi-capability"],
  ["cdmic", "application/cdmi-container"],
  ["cdmid", "application/cdmi-domain"],
  ["cdmio", "application/cdmi-object"],
  ["cdmiq", "application/cdmi-queue"],
  ["cdr", "application/cdr"],
  ["cdx", "chemical/x-cdx"],
  ["cdxml", "application/vnd.chemdraw+xml"],
  ["cdy", "application/vnd.cinderella"],
  ["cer", "application/pkix-cert"],
  ["cfs", "application/x-cfs-compressed"],
  ["cgm", "image/cgm"],
  ["chat", "application/x-chat"],
  ["chm", "application/vnd.ms-htmlhelp"],
  ["chrt", "application/vnd.kde.kchart"],
  ["cif", "chemical/x-cif"],
  ["cii", "application/vnd.anser-web-certificate-issue-initiation"],
  ["cil", "application/vnd.ms-artgalry"],
  ["cjs", "application/node"],
  ["cla", "application/vnd.claymore"],
  ["class", "application/octet-stream"],
  ["clkk", "application/vnd.crick.clicker.keyboard"],
  ["clkp", "application/vnd.crick.clicker.palette"],
  ["clkt", "application/vnd.crick.clicker.template"],
  ["clkw", "application/vnd.crick.clicker.wordbank"],
  ["clkx", "application/vnd.crick.clicker"],
  ["clp", "application/x-msclip"],
  ["cmc", "application/vnd.cosmocaller"],
  ["cmdf", "chemical/x-cmdf"],
  ["cml", "chemical/x-cml"],
  ["cmp", "application/vnd.yellowriver-custom-menu"],
  ["cmx", "image/x-cmx"],
  ["cod", "application/vnd.rim.cod"],
  ["coffee", "text/coffeescript"],
  ["com", "application/x-msdownload"],
  ["conf", "text/plain"],
  ["cpio", "application/x-cpio"],
  ["cpp", "text/x-c"],
  ["cpt", "application/mac-compactpro"],
  ["crd", "application/x-mscardfile"],
  ["crl", "application/pkix-crl"],
  ["crt", "application/x-x509-ca-cert"],
  ["crx", "application/x-chrome-extension"],
  ["cryptonote", "application/vnd.rig.cryptonote"],
  ["csh", "application/x-csh"],
  ["csl", "application/vnd.citationstyles.style+xml"],
  ["csml", "chemical/x-csml"],
  ["csp", "application/vnd.commonspace"],
  ["csr", "application/octet-stream"],
  ["css", "text/css"],
  ["cst", "application/x-director"],
  ["csv", "text/csv"],
  ["cu", "application/cu-seeme"],
  ["curl", "text/vnd.curl"],
  ["cww", "application/prs.cww"],
  ["cxt", "application/x-director"],
  ["cxx", "text/x-c"],
  ["dae", "model/vnd.collada+xml"],
  ["daf", "application/vnd.mobius.daf"],
  ["dart", "application/vnd.dart"],
  ["dataless", "application/vnd.fdsn.seed"],
  ["davmount", "application/davmount+xml"],
  ["dbf", "application/vnd.dbf"],
  ["dbk", "application/docbook+xml"],
  ["dcr", "application/x-director"],
  ["dcurl", "text/vnd.curl.dcurl"],
  ["dd2", "application/vnd.oma.dd2+xml"],
  ["ddd", "application/vnd.fujixerox.ddd"],
  ["ddf", "application/vnd.syncml.dmddf+xml"],
  ["dds", "image/vnd.ms-dds"],
  ["deb", "application/x-debian-package"],
  ["def", "text/plain"],
  ["deploy", "application/octet-stream"],
  ["der", "application/x-x509-ca-cert"],
  ["dfac", "application/vnd.dreamfactory"],
  ["dgc", "application/x-dgc-compressed"],
  ["dic", "text/x-c"],
  ["dir", "application/x-director"],
  ["dis", "application/vnd.mobius.dis"],
  ["disposition-notification", "message/disposition-notification"],
  ["dist", "application/octet-stream"],
  ["distz", "application/octet-stream"],
  ["djv", "image/vnd.djvu"],
  ["djvu", "image/vnd.djvu"],
  ["dll", "application/octet-stream"],
  ["dmg", "application/x-apple-diskimage"],
  ["dmn", "application/octet-stream"],
  ["dmp", "application/vnd.tcpdump.pcap"],
  ["dms", "application/octet-stream"],
  ["dna", "application/vnd.dna"],
  ["doc", "application/msword"],
  ["docm", "application/vnd.ms-word.template.macroEnabled.12"],
  ["docx", "application/vnd.openxmlformats-officedocument.wordprocessingml.document"],
  ["dot", "application/msword"],
  ["dotm", "application/vnd.ms-word.template.macroEnabled.12"],
  ["dotx", "application/vnd.openxmlformats-officedocument.wordprocessingml.template"],
  ["dp", "application/vnd.osgi.dp"],
  ["dpg", "application/vnd.dpgraph"],
  ["dra", "audio/vnd.dra"],
  ["drle", "image/dicom-rle"],
  ["dsc", "text/prs.lines.tag"],
  ["dssc", "application/dssc+der"],
  ["dtb", "application/x-dtbook+xml"],
  ["dtd", "application/xml-dtd"],
  ["dts", "audio/vnd.dts"],
  ["dtshd", "audio/vnd.dts.hd"],
  ["dump", "application/octet-stream"],
  ["dvb", "video/vnd.dvb.file"],
  ["dvi", "application/x-dvi"],
  ["dwd", "application/atsc-dwd+xml"],
  ["dwf", "model/vnd.dwf"],
  ["dwg", "image/vnd.dwg"],
  ["dxf", "image/vnd.dxf"],
  ["dxp", "application/vnd.spotfire.dxp"],
  ["dxr", "application/x-director"],
  ["ear", "application/java-archive"],
  ["ecelp4800", "audio/vnd.nuera.ecelp4800"],
  ["ecelp7470", "audio/vnd.nuera.ecelp7470"],
  ["ecelp9600", "audio/vnd.nuera.ecelp9600"],
  ["ecma", "application/ecmascript"],
  ["edm", "application/vnd.novadigm.edm"],
  ["edx", "application/vnd.novadigm.edx"],
  ["efif", "application/vnd.picsel"],
  ["ei6", "application/vnd.pg.osasli"],
  ["elc", "application/octet-stream"],
  ["emf", "image/emf"],
  ["eml", "message/rfc822"],
  ["emma", "application/emma+xml"],
  ["emotionml", "application/emotionml+xml"],
  ["emz", "application/x-msmetafile"],
  ["eol", "audio/vnd.digital-winds"],
  ["eot", "application/vnd.ms-fontobject"],
  ["eps", "application/postscript"],
  ["epub", "application/epub+zip"],
  ["es", "application/ecmascript"],
  ["es3", "application/vnd.eszigno3+xml"],
  ["esa", "application/vnd.osgi.subsystem"],
  ["esf", "application/vnd.epson.esf"],
  ["et3", "application/vnd.eszigno3+xml"],
  ["etx", "text/x-setext"],
  ["eva", "application/x-eva"],
  ["evy", "application/x-envoy"],
  ["exe", "application/octet-stream"],
  ["exi", "application/exi"],
  ["exp", "application/express"],
  ["exr", "image/aces"],
  ["ext", "application/vnd.novadigm.ext"],
  ["ez", "application/andrew-inset"],
  ["ez2", "application/vnd.ezpix-album"],
  ["ez3", "application/vnd.ezpix-package"],
  ["f", "text/x-fortran"],
  ["f4v", "video/mp4"],
  ["f77", "text/x-fortran"],
  ["f90", "text/x-fortran"],
  ["fbs", "image/vnd.fastbidsheet"],
  ["fcdt", "application/vnd.adobe.formscentral.fcdt"],
  ["fcs", "application/vnd.isac.fcs"],
  ["fdf", "application/vnd.fdf"],
  ["fdt", "application/fdt+xml"],
  ["fe_launch", "application/vnd.denovo.fcselayout-link"],
  ["fg5", "application/vnd.fujitsu.oasysgp"],
  ["fgd", "application/x-director"],
  ["fh", "image/x-freehand"],
  ["fh4", "image/x-freehand"],
  ["fh5", "image/x-freehand"],
  ["fh7", "image/x-freehand"],
  ["fhc", "image/x-freehand"],
  ["fig", "application/x-xfig"],
  ["fits", "image/fits"],
  ["flac", "audio/x-flac"],
  ["fli", "video/x-fli"],
  ["flo", "application/vnd.micrografx.flo"],
  ["flv", "video/x-flv"],
  ["flw", "application/vnd.kde.kivio"],
  ["flx", "text/vnd.fmi.flexstor"],
  ["fly", "text/vnd.fly"],
  ["fm", "application/vnd.framemaker"],
  ["fnc", "application/vnd.frogans.fnc"],
  ["fo", "application/vnd.software602.filler.form+xml"],
  ["for", "text/x-fortran"],
  ["fpx", "image/vnd.fpx"],
  ["frame", "application/vnd.framemaker"],
  ["fsc", "application/vnd.fsc.weblaunch"],
  ["fst", "image/vnd.fst"],
  ["ftc", "application/vnd.fluxtime.clip"],
  ["fti", "application/vnd.anser-web-funds-transfer-initiation"],
  ["fvt", "video/vnd.fvt"],
  ["fxp", "application/vnd.adobe.fxp"],
  ["fxpl", "application/vnd.adobe.fxp"],
  ["fzs", "application/vnd.fuzzysheet"],
  ["g2w", "application/vnd.geoplan"],
  ["g3", "image/g3fax"],
  ["g3w", "application/vnd.geospace"],
  ["gac", "application/vnd.groove-account"],
  ["gam", "application/x-tads"],
  ["gbr", "application/rpki-ghostbusters"],
  ["gca", "application/x-gca-compressed"],
  ["gdl", "model/vnd.gdl"],
  ["gdoc", "application/vnd.google-apps.document"],
  ["geo", "application/vnd.dynageo"],
  ["geojson", "application/geo+json"],
  ["gex", "application/vnd.geometry-explorer"],
  ["ggb", "application/vnd.geogebra.file"],
  ["ggt", "application/vnd.geogebra.tool"],
  ["ghf", "application/vnd.groove-help"],
  ["gif", "image/gif"],
  ["gim", "application/vnd.groove-identity-message"],
  ["glb", "model/gltf-binary"],
  ["gltf", "model/gltf+json"],
  ["gml", "application/gml+xml"],
  ["gmx", "application/vnd.gmx"],
  ["gnumeric", "application/x-gnumeric"],
  ["gpg", "application/gpg-keys"],
  ["gph", "application/vnd.flographit"],
  ["gpx", "application/gpx+xml"],
  ["gqf", "application/vnd.grafeq"],
  ["gqs", "application/vnd.grafeq"],
  ["gram", "application/srgs"],
  ["gramps", "application/x-gramps-xml"],
  ["gre", "application/vnd.geometry-explorer"],
  ["grv", "application/vnd.groove-injector"],
  ["grxml", "application/srgs+xml"],
  ["gsf", "application/x-font-ghostscript"],
  ["gsheet", "application/vnd.google-apps.spreadsheet"],
  ["gslides", "application/vnd.google-apps.presentation"],
  ["gtar", "application/x-gtar"],
  ["gtm", "application/vnd.groove-tool-message"],
  ["gtw", "model/vnd.gtw"],
  ["gv", "text/vnd.graphviz"],
  ["gxf", "application/gxf"],
  ["gxt", "application/vnd.geonext"],
  ["gz", "application/gzip"],
  ["gzip", "application/gzip"],
  ["h", "text/x-c"],
  ["h261", "video/h261"],
  ["h263", "video/h263"],
  ["h264", "video/h264"],
  ["hal", "application/vnd.hal+xml"],
  ["hbci", "application/vnd.hbci"],
  ["hbs", "text/x-handlebars-template"],
  ["hdd", "application/x-virtualbox-hdd"],
  ["hdf", "application/x-hdf"],
  ["heic", "image/heic"],
  ["heics", "image/heic-sequence"],
  ["heif", "image/heif"],
  ["heifs", "image/heif-sequence"],
  ["hej2", "image/hej2k"],
  ["held", "application/atsc-held+xml"],
  ["hh", "text/x-c"],
  ["hjson", "application/hjson"],
  ["hlp", "application/winhlp"],
  ["hpgl", "application/vnd.hp-hpgl"],
  ["hpid", "application/vnd.hp-hpid"],
  ["hps", "application/vnd.hp-hps"],
  ["hqx", "application/mac-binhex40"],
  ["hsj2", "image/hsj2"],
  ["htc", "text/x-component"],
  ["htke", "application/vnd.kenameaapp"],
  ["htm", "text/html"],
  ["html", "text/html"],
  ["hvd", "application/vnd.yamaha.hv-dic"],
  ["hvp", "application/vnd.yamaha.hv-voice"],
  ["hvs", "application/vnd.yamaha.hv-script"],
  ["i2g", "application/vnd.intergeo"],
  ["icc", "application/vnd.iccprofile"],
  ["ice", "x-conference/x-cooltalk"],
  ["icm", "application/vnd.iccprofile"],
  ["ico", "image/x-icon"],
  ["ics", "text/calendar"],
  ["ief", "image/ief"],
  ["ifb", "text/calendar"],
  ["ifm", "application/vnd.shana.informed.formdata"],
  ["iges", "model/iges"],
  ["igl", "application/vnd.igloader"],
  ["igm", "application/vnd.insors.igm"],
  ["igs", "model/iges"],
  ["igx", "application/vnd.micrografx.igx"],
  ["iif", "application/vnd.shana.informed.interchange"],
  ["img", "application/octet-stream"],
  ["imp", "application/vnd.accpac.simply.imp"],
  ["ims", "application/vnd.ms-ims"],
  ["in", "text/plain"],
  ["ini", "text/plain"],
  ["ink", "application/inkml+xml"],
  ["inkml", "application/inkml+xml"],
  ["install", "application/x-install-instructions"],
  ["iota", "application/vnd.astraea-software.iota"],
  ["ipfix", "application/ipfix"],
  ["ipk", "application/vnd.shana.informed.package"],
  ["irm", "application/vnd.ibm.rights-management"],
  ["irp", "application/vnd.irepository.package+xml"],
  ["iso", "application/x-iso9660-image"],
  ["itp", "application/vnd.shana.informed.formtemplate"],
  ["its", "application/its+xml"],
  ["ivp", "application/vnd.immervision-ivp"],
  ["ivu", "application/vnd.immervision-ivu"],
  ["jad", "text/vnd.sun.j2me.app-descriptor"],
  ["jade", "text/jade"],
  ["jam", "application/vnd.jam"],
  ["jar", "application/java-archive"],
  ["jardiff", "application/x-java-archive-diff"],
  ["java", "text/x-java-source"],
  ["jhc", "image/jphc"],
  ["jisp", "application/vnd.jisp"],
  ["jls", "image/jls"],
  ["jlt", "application/vnd.hp-jlyt"],
  ["jng", "image/x-jng"],
  ["jnlp", "application/x-java-jnlp-file"],
  ["joda", "application/vnd.joost.joda-archive"],
  ["jp2", "image/jp2"],
  ["jpe", "image/jpeg"],
  ["jpeg", "image/jpeg"],
  ["jpf", "image/jpx"],
  ["jpg", "image/jpeg"],
  ["jpg2", "image/jp2"],
  ["jpgm", "video/jpm"],
  ["jpgv", "video/jpeg"],
  ["jph", "image/jph"],
  ["jpm", "video/jpm"],
  ["jpx", "image/jpx"],
  ["js", "application/javascript"],
  ["json", "application/json"],
  ["json5", "application/json5"],
  ["jsonld", "application/ld+json"],
  // https://jsonlines.org/
  ["jsonl", "application/jsonl"],
  ["jsonml", "application/jsonml+json"],
  ["jsx", "text/jsx"],
  ["jxr", "image/jxr"],
  ["jxra", "image/jxra"],
  ["jxrs", "image/jxrs"],
  ["jxs", "image/jxs"],
  ["jxsc", "image/jxsc"],
  ["jxsi", "image/jxsi"],
  ["jxss", "image/jxss"],
  ["kar", "audio/midi"],
  ["karbon", "application/vnd.kde.karbon"],
  ["kdb", "application/octet-stream"],
  ["kdbx", "application/x-keepass2"],
  ["key", "application/x-iwork-keynote-sffkey"],
  ["kfo", "application/vnd.kde.kformula"],
  ["kia", "application/vnd.kidspiration"],
  ["kml", "application/vnd.google-earth.kml+xml"],
  ["kmz", "application/vnd.google-earth.kmz"],
  ["kne", "application/vnd.kinar"],
  ["knp", "application/vnd.kinar"],
  ["kon", "application/vnd.kde.kontour"],
  ["kpr", "application/vnd.kde.kpresenter"],
  ["kpt", "application/vnd.kde.kpresenter"],
  ["kpxx", "application/vnd.ds-keypoint"],
  ["ksp", "application/vnd.kde.kspread"],
  ["ktr", "application/vnd.kahootz"],
  ["ktx", "image/ktx"],
  ["ktx2", "image/ktx2"],
  ["ktz", "application/vnd.kahootz"],
  ["kwd", "application/vnd.kde.kword"],
  ["kwt", "application/vnd.kde.kword"],
  ["lasxml", "application/vnd.las.las+xml"],
  ["latex", "application/x-latex"],
  ["lbd", "application/vnd.llamagraphics.life-balance.desktop"],
  ["lbe", "application/vnd.llamagraphics.life-balance.exchange+xml"],
  ["les", "application/vnd.hhe.lesson-player"],
  ["less", "text/less"],
  ["lgr", "application/lgr+xml"],
  ["lha", "application/octet-stream"],
  ["link66", "application/vnd.route66.link66+xml"],
  ["list", "text/plain"],
  ["list3820", "application/vnd.ibm.modcap"],
  ["listafp", "application/vnd.ibm.modcap"],
  ["litcoffee", "text/coffeescript"],
  ["lnk", "application/x-ms-shortcut"],
  ["log", "text/plain"],
  ["lostxml", "application/lost+xml"],
  ["lrf", "application/octet-stream"],
  ["lrm", "application/vnd.ms-lrm"],
  ["ltf", "application/vnd.frogans.ltf"],
  ["lua", "text/x-lua"],
  ["luac", "application/x-lua-bytecode"],
  ["lvp", "audio/vnd.lucent.voice"],
  ["lwp", "application/vnd.lotus-wordpro"],
  ["lzh", "application/octet-stream"],
  ["m1v", "video/mpeg"],
  ["m2a", "audio/mpeg"],
  ["m2v", "video/mpeg"],
  ["m3a", "audio/mpeg"],
  ["m3u", "text/plain"],
  ["m3u8", "application/vnd.apple.mpegurl"],
  ["m4a", "audio/x-m4a"],
  ["m4p", "application/mp4"],
  ["m4s", "video/iso.segment"],
  ["m4u", "application/vnd.mpegurl"],
  ["m4v", "video/x-m4v"],
  ["m13", "application/x-msmediaview"],
  ["m14", "application/x-msmediaview"],
  ["m21", "application/mp21"],
  ["ma", "application/mathematica"],
  ["mads", "application/mads+xml"],
  ["maei", "application/mmt-aei+xml"],
  ["mag", "application/vnd.ecowin.chart"],
  ["maker", "application/vnd.framemaker"],
  ["man", "text/troff"],
  ["manifest", "text/cache-manifest"],
  ["map", "application/json"],
  ["mar", "application/octet-stream"],
  ["markdown", "text/markdown"],
  ["mathml", "application/mathml+xml"],
  ["mb", "application/mathematica"],
  ["mbk", "application/vnd.mobius.mbk"],
  ["mbox", "application/mbox"],
  ["mc1", "application/vnd.medcalcdata"],
  ["mcd", "application/vnd.mcd"],
  ["mcurl", "text/vnd.curl.mcurl"],
  ["md", "text/markdown"],
  ["mdb", "application/x-msaccess"],
  ["mdi", "image/vnd.ms-modi"],
  ["mdx", "text/mdx"],
  ["me", "text/troff"],
  ["mesh", "model/mesh"],
  ["meta4", "application/metalink4+xml"],
  ["metalink", "application/metalink+xml"],
  ["mets", "application/mets+xml"],
  ["mfm", "application/vnd.mfmp"],
  ["mft", "application/rpki-manifest"],
  ["mgp", "application/vnd.osgeo.mapguide.package"],
  ["mgz", "application/vnd.proteus.magazine"],
  ["mid", "audio/midi"],
  ["midi", "audio/midi"],
  ["mie", "application/x-mie"],
  ["mif", "application/vnd.mif"],
  ["mime", "message/rfc822"],
  ["mj2", "video/mj2"],
  ["mjp2", "video/mj2"],
  ["mjs", "application/javascript"],
  ["mk3d", "video/x-matroska"],
  ["mka", "audio/x-matroska"],
  ["mkd", "text/x-markdown"],
  ["mks", "video/x-matroska"],
  ["mkv", "video/x-matroska"],
  ["mlp", "application/vnd.dolby.mlp"],
  ["mmd", "application/vnd.chipnuts.karaoke-mmd"],
  ["mmf", "application/vnd.smaf"],
  ["mml", "text/mathml"],
  ["mmr", "image/vnd.fujixerox.edmics-mmr"],
  ["mng", "video/x-mng"],
  ["mny", "application/x-msmoney"],
  ["mobi", "application/x-mobipocket-ebook"],
  ["mods", "application/mods+xml"],
  ["mov", "video/quicktime"],
  ["movie", "video/x-sgi-movie"],
  ["mp2", "audio/mpeg"],
  ["mp2a", "audio/mpeg"],
  ["mp3", "audio/mpeg"],
  ["mp4", "video/mp4"],
  ["mp4a", "audio/mp4"],
  ["mp4s", "application/mp4"],
  ["mp4v", "video/mp4"],
  ["mp21", "application/mp21"],
  ["mpc", "application/vnd.mophun.certificate"],
  ["mpd", "application/dash+xml"],
  ["mpe", "video/mpeg"],
  ["mpeg", "video/mpeg"],
  ["mpg", "video/mpeg"],
  ["mpg4", "video/mp4"],
  ["mpga", "audio/mpeg"],
  ["mpkg", "application/vnd.apple.installer+xml"],
  ["mpm", "application/vnd.blueice.multipass"],
  ["mpn", "application/vnd.mophun.application"],
  ["mpp", "application/vnd.ms-project"],
  ["mpt", "application/vnd.ms-project"],
  ["mpy", "application/vnd.ibm.minipay"],
  ["mqy", "application/vnd.mobius.mqy"],
  ["mrc", "application/marc"],
  ["mrcx", "application/marcxml+xml"],
  ["ms", "text/troff"],
  ["mscml", "application/mediaservercontrol+xml"],
  ["mseed", "application/vnd.fdsn.mseed"],
  ["mseq", "application/vnd.mseq"],
  ["msf", "application/vnd.epson.msf"],
  ["msg", "application/vnd.ms-outlook"],
  ["msh", "model/mesh"],
  ["msi", "application/x-msdownload"],
  ["msl", "application/vnd.mobius.msl"],
  ["msm", "application/octet-stream"],
  ["msp", "application/octet-stream"],
  ["msty", "application/vnd.muvee.style"],
  ["mtl", "model/mtl"],
  ["mts", "model/vnd.mts"],
  ["mus", "application/vnd.musician"],
  ["musd", "application/mmt-usd+xml"],
  ["musicxml", "application/vnd.recordare.musicxml+xml"],
  ["mvb", "application/x-msmediaview"],
  ["mvt", "application/vnd.mapbox-vector-tile"],
  ["mwf", "application/vnd.mfer"],
  ["mxf", "application/mxf"],
  ["mxl", "application/vnd.recordare.musicxml"],
  ["mxmf", "audio/mobile-xmf"],
  ["mxml", "application/xv+xml"],
  ["mxs", "application/vnd.triscape.mxs"],
  ["mxu", "video/vnd.mpegurl"],
  ["n-gage", "application/vnd.nokia.n-gage.symbian.install"],
  ["n3", "text/n3"],
  ["nb", "application/mathematica"],
  ["nbp", "application/vnd.wolfram.player"],
  ["nc", "application/x-netcdf"],
  ["ncx", "application/x-dtbncx+xml"],
  ["nfo", "text/x-nfo"],
  ["ngdat", "application/vnd.nokia.n-gage.data"],
  ["nitf", "application/vnd.nitf"],
  ["nlu", "application/vnd.neurolanguage.nlu"],
  ["nml", "application/vnd.enliven"],
  ["nnd", "application/vnd.noblenet-directory"],
  ["nns", "application/vnd.noblenet-sealer"],
  ["nnw", "application/vnd.noblenet-web"],
  ["npx", "image/vnd.net-fpx"],
  ["nq", "application/n-quads"],
  ["nsc", "application/x-conference"],
  ["nsf", "application/vnd.lotus-notes"],
  ["nt", "application/n-triples"],
  ["ntf", "application/vnd.nitf"],
  ["numbers", "application/x-iwork-numbers-sffnumbers"],
  ["nzb", "application/x-nzb"],
  ["oa2", "application/vnd.fujitsu.oasys2"],
  ["oa3", "application/vnd.fujitsu.oasys3"],
  ["oas", "application/vnd.fujitsu.oasys"],
  ["obd", "application/x-msbinder"],
  ["obgx", "application/vnd.openblox.game+xml"],
  ["obj", "model/obj"],
  ["oda", "application/oda"],
  ["odb", "application/vnd.oasis.opendocument.database"],
  ["odc", "application/vnd.oasis.opendocument.chart"],
  ["odf", "application/vnd.oasis.opendocument.formula"],
  ["odft", "application/vnd.oasis.opendocument.formula-template"],
  ["odg", "application/vnd.oasis.opendocument.graphics"],
  ["odi", "application/vnd.oasis.opendocument.image"],
  ["odm", "application/vnd.oasis.opendocument.text-master"],
  ["odp", "application/vnd.oasis.opendocument.presentation"],
  ["ods", "application/vnd.oasis.opendocument.spreadsheet"],
  ["odt", "application/vnd.oasis.opendocument.text"],
  ["oga", "audio/ogg"],
  ["ogex", "model/vnd.opengex"],
  ["ogg", "audio/ogg"],
  ["ogv", "video/ogg"],
  ["ogx", "application/ogg"],
  ["omdoc", "application/omdoc+xml"],
  ["onepkg", "application/onenote"],
  ["onetmp", "application/onenote"],
  ["onetoc", "application/onenote"],
  ["onetoc2", "application/onenote"],
  ["opf", "application/oebps-package+xml"],
  ["opml", "text/x-opml"],
  ["oprc", "application/vnd.palm"],
  ["opus", "audio/ogg"],
  ["org", "text/x-org"],
  ["osf", "application/vnd.yamaha.openscoreformat"],
  ["osfpvg", "application/vnd.yamaha.openscoreformat.osfpvg+xml"],
  ["osm", "application/vnd.openstreetmap.data+xml"],
  ["otc", "application/vnd.oasis.opendocument.chart-template"],
  ["otf", "font/otf"],
  ["otg", "application/vnd.oasis.opendocument.graphics-template"],
  ["oth", "application/vnd.oasis.opendocument.text-web"],
  ["oti", "application/vnd.oasis.opendocument.image-template"],
  ["otp", "application/vnd.oasis.opendocument.presentation-template"],
  ["ots", "application/vnd.oasis.opendocument.spreadsheet-template"],
  ["ott", "application/vnd.oasis.opendocument.text-template"],
  ["ova", "application/x-virtualbox-ova"],
  ["ovf", "application/x-virtualbox-ovf"],
  ["owl", "application/rdf+xml"],
  ["oxps", "application/oxps"],
  ["oxt", "application/vnd.openofficeorg.extension"],
  ["p", "text/x-pascal"],
  ["p7a", "application/x-pkcs7-signature"],
  ["p7b", "application/x-pkcs7-certificates"],
  ["p7c", "application/pkcs7-mime"],
  ["p7m", "application/pkcs7-mime"],
  ["p7r", "application/x-pkcs7-certreqresp"],
  ["p7s", "application/pkcs7-signature"],
  ["p8", "application/pkcs8"],
  ["p10", "application/x-pkcs10"],
  ["p12", "application/x-pkcs12"],
  ["pac", "application/x-ns-proxy-autoconfig"],
  ["pages", "application/x-iwork-pages-sffpages"],
  ["pas", "text/x-pascal"],
  ["paw", "application/vnd.pawaafile"],
  ["pbd", "application/vnd.powerbuilder6"],
  ["pbm", "image/x-portable-bitmap"],
  ["pcap", "application/vnd.tcpdump.pcap"],
  ["pcf", "application/x-font-pcf"],
  ["pcl", "application/vnd.hp-pcl"],
  ["pclxl", "application/vnd.hp-pclxl"],
  ["pct", "image/x-pict"],
  ["pcurl", "application/vnd.curl.pcurl"],
  ["pcx", "image/x-pcx"],
  ["pdb", "application/x-pilot"],
  ["pde", "text/x-processing"],
  ["pdf", "application/pdf"],
  ["pem", "application/x-x509-user-cert"],
  ["pfa", "application/x-font-type1"],
  ["pfb", "application/x-font-type1"],
  ["pfm", "application/x-font-type1"],
  ["pfr", "application/font-tdpfr"],
  ["pfx", "application/x-pkcs12"],
  ["pgm", "image/x-portable-graymap"],
  ["pgn", "application/x-chess-pgn"],
  ["pgp", "application/pgp"],
  ["php", "application/x-httpd-php"],
  ["php3", "application/x-httpd-php"],
  ["php4", "application/x-httpd-php"],
  ["phps", "application/x-httpd-php-source"],
  ["phtml", "application/x-httpd-php"],
  ["pic", "image/x-pict"],
  ["pkg", "application/octet-stream"],
  ["pki", "application/pkixcmp"],
  ["pkipath", "application/pkix-pkipath"],
  ["pkpass", "application/vnd.apple.pkpass"],
  ["pl", "application/x-perl"],
  ["plb", "application/vnd.3gpp.pic-bw-large"],
  ["plc", "application/vnd.mobius.plc"],
  ["plf", "application/vnd.pocketlearn"],
  ["pls", "application/pls+xml"],
  ["pm", "application/x-perl"],
  ["pml", "application/vnd.ctc-posml"],
  ["png", "image/png"],
  ["pnm", "image/x-portable-anymap"],
  ["portpkg", "application/vnd.macports.portpkg"],
  ["pot", "application/vnd.ms-powerpoint"],
  ["potm", "application/vnd.ms-powerpoint.presentation.macroEnabled.12"],
  ["potx", "application/vnd.openxmlformats-officedocument.presentationml.template"],
  ["ppa", "application/vnd.ms-powerpoint"],
  ["ppam", "application/vnd.ms-powerpoint.addin.macroEnabled.12"],
  ["ppd", "application/vnd.cups-ppd"],
  ["ppm", "image/x-portable-pixmap"],
  ["pps", "application/vnd.ms-powerpoint"],
  ["ppsm", "application/vnd.ms-powerpoint.slideshow.macroEnabled.12"],
  ["ppsx", "application/vnd.openxmlformats-officedocument.presentationml.slideshow"],
  ["ppt", "application/powerpoint"],
  ["pptm", "application/vnd.ms-powerpoint.presentation.macroEnabled.12"],
  ["pptx", "application/vnd.openxmlformats-officedocument.presentationml.presentation"],
  ["pqa", "application/vnd.palm"],
  ["prc", "application/x-pilot"],
  ["pre", "application/vnd.lotus-freelance"],
  ["prf", "application/pics-rules"],
  ["provx", "application/provenance+xml"],
  ["ps", "application/postscript"],
  ["psb", "application/vnd.3gpp.pic-bw-small"],
  ["psd", "application/x-photoshop"],
  ["psf", "application/x-font-linux-psf"],
  ["pskcxml", "application/pskc+xml"],
  ["pti", "image/prs.pti"],
  ["ptid", "application/vnd.pvi.ptid1"],
  ["pub", "application/x-mspublisher"],
  ["pvb", "application/vnd.3gpp.pic-bw-var"],
  ["pwn", "application/vnd.3m.post-it-notes"],
  ["pya", "audio/vnd.ms-playready.media.pya"],
  ["pyv", "video/vnd.ms-playready.media.pyv"],
  ["qam", "application/vnd.epson.quickanime"],
  ["qbo", "application/vnd.intu.qbo"],
  ["qfx", "application/vnd.intu.qfx"],
  ["qps", "application/vnd.publishare-delta-tree"],
  ["qt", "video/quicktime"],
  ["qwd", "application/vnd.quark.quarkxpress"],
  ["qwt", "application/vnd.quark.quarkxpress"],
  ["qxb", "application/vnd.quark.quarkxpress"],
  ["qxd", "application/vnd.quark.quarkxpress"],
  ["qxl", "application/vnd.quark.quarkxpress"],
  ["qxt", "application/vnd.quark.quarkxpress"],
  ["ra", "audio/x-realaudio"],
  ["ram", "audio/x-pn-realaudio"],
  ["raml", "application/raml+yaml"],
  ["rapd", "application/route-apd+xml"],
  ["rar", "application/x-rar"],
  ["ras", "image/x-cmu-raster"],
  ["rcprofile", "application/vnd.ipunplugged.rcprofile"],
  ["rdf", "application/rdf+xml"],
  ["rdz", "application/vnd.data-vision.rdz"],
  ["relo", "application/p2p-overlay+xml"],
  ["rep", "application/vnd.businessobjects"],
  ["res", "application/x-dtbresource+xml"],
  ["rgb", "image/x-rgb"],
  ["rif", "application/reginfo+xml"],
  ["rip", "audio/vnd.rip"],
  ["ris", "application/x-research-info-systems"],
  ["rl", "application/resource-lists+xml"],
  ["rlc", "image/vnd.fujixerox.edmics-rlc"],
  ["rld", "application/resource-lists-diff+xml"],
  ["rm", "audio/x-pn-realaudio"],
  ["rmi", "audio/midi"],
  ["rmp", "audio/x-pn-realaudio-plugin"],
  ["rms", "application/vnd.jcp.javame.midlet-rms"],
  ["rmvb", "application/vnd.rn-realmedia-vbr"],
  ["rnc", "application/relax-ng-compact-syntax"],
  ["rng", "application/xml"],
  ["roa", "application/rpki-roa"],
  ["roff", "text/troff"],
  ["rp9", "application/vnd.cloanto.rp9"],
  ["rpm", "audio/x-pn-realaudio-plugin"],
  ["rpss", "application/vnd.nokia.radio-presets"],
  ["rpst", "application/vnd.nokia.radio-preset"],
  ["rq", "application/sparql-query"],
  ["rs", "application/rls-services+xml"],
  ["rsa", "application/x-pkcs7"],
  ["rsat", "application/atsc-rsat+xml"],
  ["rsd", "application/rsd+xml"],
  ["rsheet", "application/urc-ressheet+xml"],
  ["rss", "application/rss+xml"],
  ["rtf", "text/rtf"],
  ["rtx", "text/richtext"],
  ["run", "application/x-makeself"],
  ["rusd", "application/route-usd+xml"],
  ["rv", "video/vnd.rn-realvideo"],
  ["s", "text/x-asm"],
  ["s3m", "audio/s3m"],
  ["saf", "application/vnd.yamaha.smaf-audio"],
  ["sass", "text/x-sass"],
  ["sbml", "application/sbml+xml"],
  ["sc", "application/vnd.ibm.secure-container"],
  ["scd", "application/x-msschedule"],
  ["scm", "application/vnd.lotus-screencam"],
  ["scq", "application/scvp-cv-request"],
  ["scs", "application/scvp-cv-response"],
  ["scss", "text/x-scss"],
  ["scurl", "text/vnd.curl.scurl"],
  ["sda", "application/vnd.stardivision.draw"],
  ["sdc", "application/vnd.stardivision.calc"],
  ["sdd", "application/vnd.stardivision.impress"],
  ["sdkd", "application/vnd.solent.sdkm+xml"],
  ["sdkm", "application/vnd.solent.sdkm+xml"],
  ["sdp", "application/sdp"],
  ["sdw", "application/vnd.stardivision.writer"],
  ["sea", "application/octet-stream"],
  ["see", "application/vnd.seemail"],
  ["seed", "application/vnd.fdsn.seed"],
  ["sema", "application/vnd.sema"],
  ["semd", "application/vnd.semd"],
  ["semf", "application/vnd.semf"],
  ["senmlx", "application/senml+xml"],
  ["sensmlx", "application/sensml+xml"],
  ["ser", "application/java-serialized-object"],
  ["setpay", "application/set-payment-initiation"],
  ["setreg", "application/set-registration-initiation"],
  ["sfd-hdstx", "application/vnd.hydrostatix.sof-data"],
  ["sfs", "application/vnd.spotfire.sfs"],
  ["sfv", "text/x-sfv"],
  ["sgi", "image/sgi"],
  ["sgl", "application/vnd.stardivision.writer-global"],
  ["sgm", "text/sgml"],
  ["sgml", "text/sgml"],
  ["sh", "application/x-sh"],
  ["shar", "application/x-shar"],
  ["shex", "text/shex"],
  ["shf", "application/shf+xml"],
  ["shtml", "text/html"],
  ["sid", "image/x-mrsid-image"],
  ["sieve", "application/sieve"],
  ["sig", "application/pgp-signature"],
  ["sil", "audio/silk"],
  ["silo", "model/mesh"],
  ["sis", "application/vnd.symbian.install"],
  ["sisx", "application/vnd.symbian.install"],
  ["sit", "application/x-stuffit"],
  ["sitx", "application/x-stuffitx"],
  ["siv", "application/sieve"],
  ["skd", "application/vnd.koan"],
  ["skm", "application/vnd.koan"],
  ["skp", "application/vnd.koan"],
  ["skt", "application/vnd.koan"],
  ["sldm", "application/vnd.ms-powerpoint.slide.macroenabled.12"],
  ["sldx", "application/vnd.openxmlformats-officedocument.presentationml.slide"],
  ["slim", "text/slim"],
  ["slm", "text/slim"],
  ["sls", "application/route-s-tsid+xml"],
  ["slt", "application/vnd.epson.salt"],
  ["sm", "application/vnd.stepmania.stepchart"],
  ["smf", "application/vnd.stardivision.math"],
  ["smi", "application/smil"],
  ["smil", "application/smil"],
  ["smv", "video/x-smv"],
  ["smzip", "application/vnd.stepmania.package"],
  ["snd", "audio/basic"],
  ["snf", "application/x-font-snf"],
  ["so", "application/octet-stream"],
  ["spc", "application/x-pkcs7-certificates"],
  ["spdx", "text/spdx"],
  ["spf", "application/vnd.yamaha.smaf-phrase"],
  ["spl", "application/x-futuresplash"],
  ["spot", "text/vnd.in3d.spot"],
  ["spp", "application/scvp-vp-response"],
  ["spq", "application/scvp-vp-request"],
  ["spx", "audio/ogg"],
  ["sql", "application/x-sql"],
  ["src", "application/x-wais-source"],
  ["srt", "application/x-subrip"],
  ["sru", "application/sru+xml"],
  ["srx", "application/sparql-results+xml"],
  ["ssdl", "application/ssdl+xml"],
  ["sse", "application/vnd.kodak-descriptor"],
  ["ssf", "application/vnd.epson.ssf"],
  ["ssml", "application/ssml+xml"],
  ["sst", "application/octet-stream"],
  ["st", "application/vnd.sailingtracker.track"],
  ["stc", "application/vnd.sun.xml.calc.template"],
  ["std", "application/vnd.sun.xml.draw.template"],
  ["stf", "application/vnd.wt.stf"],
  ["sti", "application/vnd.sun.xml.impress.template"],
  ["stk", "application/hyperstudio"],
  ["stl", "model/stl"],
  ["stpx", "model/step+xml"],
  ["stpxz", "model/step-xml+zip"],
  ["stpz", "model/step+zip"],
  ["str", "application/vnd.pg.format"],
  ["stw", "application/vnd.sun.xml.writer.template"],
  ["styl", "text/stylus"],
  ["stylus", "text/stylus"],
  ["sub", "text/vnd.dvb.subtitle"],
  ["sus", "application/vnd.sus-calendar"],
  ["susp", "application/vnd.sus-calendar"],
  ["sv4cpio", "application/x-sv4cpio"],
  ["sv4crc", "application/x-sv4crc"],
  ["svc", "application/vnd.dvb.service"],
  ["svd", "application/vnd.svd"],
  ["svg", "image/svg+xml"],
  ["svgz", "image/svg+xml"],
  ["swa", "application/x-director"],
  ["swf", "application/x-shockwave-flash"],
  ["swi", "application/vnd.aristanetworks.swi"],
  ["swidtag", "application/swid+xml"],
  ["sxc", "application/vnd.sun.xml.calc"],
  ["sxd", "application/vnd.sun.xml.draw"],
  ["sxg", "application/vnd.sun.xml.writer.global"],
  ["sxi", "application/vnd.sun.xml.impress"],
  ["sxm", "application/vnd.sun.xml.math"],
  ["sxw", "application/vnd.sun.xml.writer"],
  ["t", "text/troff"],
  ["t3", "application/x-t3vm-image"],
  ["t38", "image/t38"],
  ["taglet", "application/vnd.mynfc"],
  ["tao", "application/vnd.tao.intent-module-archive"],
  ["tap", "image/vnd.tencent.tap"],
  ["tar", "application/x-tar"],
  ["tcap", "application/vnd.3gpp2.tcap"],
  ["tcl", "application/x-tcl"],
  ["td", "application/urc-targetdesc+xml"],
  ["teacher", "application/vnd.smart.teacher"],
  ["tei", "application/tei+xml"],
  ["teicorpus", "application/tei+xml"],
  ["tex", "application/x-tex"],
  ["texi", "application/x-texinfo"],
  ["texinfo", "application/x-texinfo"],
  ["text", "text/plain"],
  ["tfi", "application/thraud+xml"],
  ["tfm", "application/x-tex-tfm"],
  ["tfx", "image/tiff-fx"],
  ["tga", "image/x-tga"],
  ["tgz", "application/x-tar"],
  ["thmx", "application/vnd.ms-officetheme"],
  ["tif", "image/tiff"],
  ["tiff", "image/tiff"],
  ["tk", "application/x-tcl"],
  ["tmo", "application/vnd.tmobile-livetv"],
  ["toml", "application/toml"],
  ["torrent", "application/x-bittorrent"],
  ["tpl", "application/vnd.groove-tool-template"],
  ["tpt", "application/vnd.trid.tpt"],
  ["tr", "text/troff"],
  ["tra", "application/vnd.trueapp"],
  ["trig", "application/trig"],
  ["trm", "application/x-msterminal"],
  ["ts", "video/mp2t"],
  ["tsd", "application/timestamped-data"],
  ["tsv", "text/tab-separated-values"],
  ["ttc", "font/collection"],
  ["ttf", "font/ttf"],
  ["ttl", "text/turtle"],
  ["ttml", "application/ttml+xml"],
  ["twd", "application/vnd.simtech-mindmapper"],
  ["twds", "application/vnd.simtech-mindmapper"],
  ["txd", "application/vnd.genomatix.tuxedo"],
  ["txf", "application/vnd.mobius.txf"],
  ["txt", "text/plain"],
  ["u8dsn", "message/global-delivery-status"],
  ["u8hdr", "message/global-headers"],
  ["u8mdn", "message/global-disposition-notification"],
  ["u8msg", "message/global"],
  ["u32", "application/x-authorware-bin"],
  ["ubj", "application/ubjson"],
  ["udeb", "application/x-debian-package"],
  ["ufd", "application/vnd.ufdl"],
  ["ufdl", "application/vnd.ufdl"],
  ["ulx", "application/x-glulx"],
  ["umj", "application/vnd.umajin"],
  ["unityweb", "application/vnd.unity"],
  ["uoml", "application/vnd.uoml+xml"],
  ["uri", "text/uri-list"],
  ["uris", "text/uri-list"],
  ["urls", "text/uri-list"],
  ["usdz", "model/vnd.usdz+zip"],
  ["ustar", "application/x-ustar"],
  ["utz", "application/vnd.uiq.theme"],
  ["uu", "text/x-uuencode"],
  ["uva", "audio/vnd.dece.audio"],
  ["uvd", "application/vnd.dece.data"],
  ["uvf", "application/vnd.dece.data"],
  ["uvg", "image/vnd.dece.graphic"],
  ["uvh", "video/vnd.dece.hd"],
  ["uvi", "image/vnd.dece.graphic"],
  ["uvm", "video/vnd.dece.mobile"],
  ["uvp", "video/vnd.dece.pd"],
  ["uvs", "video/vnd.dece.sd"],
  ["uvt", "application/vnd.dece.ttml+xml"],
  ["uvu", "video/vnd.uvvu.mp4"],
  ["uvv", "video/vnd.dece.video"],
  ["uvva", "audio/vnd.dece.audio"],
  ["uvvd", "application/vnd.dece.data"],
  ["uvvf", "application/vnd.dece.data"],
  ["uvvg", "image/vnd.dece.graphic"],
  ["uvvh", "video/vnd.dece.hd"],
  ["uvvi", "image/vnd.dece.graphic"],
  ["uvvm", "video/vnd.dece.mobile"],
  ["uvvp", "video/vnd.dece.pd"],
  ["uvvs", "video/vnd.dece.sd"],
  ["uvvt", "application/vnd.dece.ttml+xml"],
  ["uvvu", "video/vnd.uvvu.mp4"],
  ["uvvv", "video/vnd.dece.video"],
  ["uvvx", "application/vnd.dece.unspecified"],
  ["uvvz", "application/vnd.dece.zip"],
  ["uvx", "application/vnd.dece.unspecified"],
  ["uvz", "application/vnd.dece.zip"],
  ["vbox", "application/x-virtualbox-vbox"],
  ["vbox-extpack", "application/x-virtualbox-vbox-extpack"],
  ["vcard", "text/vcard"],
  ["vcd", "application/x-cdlink"],
  ["vcf", "text/x-vcard"],
  ["vcg", "application/vnd.groove-vcard"],
  ["vcs", "text/x-vcalendar"],
  ["vcx", "application/vnd.vcx"],
  ["vdi", "application/x-virtualbox-vdi"],
  ["vds", "model/vnd.sap.vds"],
  ["vhd", "application/x-virtualbox-vhd"],
  ["vis", "application/vnd.visionary"],
  ["viv", "video/vnd.vivo"],
  ["vlc", "application/videolan"],
  ["vmdk", "application/x-virtualbox-vmdk"],
  ["vob", "video/x-ms-vob"],
  ["vor", "application/vnd.stardivision.writer"],
  ["vox", "application/x-authorware-bin"],
  ["vrml", "model/vrml"],
  ["vsd", "application/vnd.visio"],
  ["vsf", "application/vnd.vsf"],
  ["vss", "application/vnd.visio"],
  ["vst", "application/vnd.visio"],
  ["vsw", "application/vnd.visio"],
  ["vtf", "image/vnd.valve.source.texture"],
  ["vtt", "text/vtt"],
  ["vtu", "model/vnd.vtu"],
  ["vxml", "application/voicexml+xml"],
  ["w3d", "application/x-director"],
  ["wad", "application/x-doom"],
  ["wadl", "application/vnd.sun.wadl+xml"],
  ["war", "application/java-archive"],
  ["wasm", "application/wasm"],
  ["wav", "audio/x-wav"],
  ["wax", "audio/x-ms-wax"],
  ["wbmp", "image/vnd.wap.wbmp"],
  ["wbs", "application/vnd.criticaltools.wbs+xml"],
  ["wbxml", "application/wbxml"],
  ["wcm", "application/vnd.ms-works"],
  ["wdb", "application/vnd.ms-works"],
  ["wdp", "image/vnd.ms-photo"],
  ["weba", "audio/webm"],
  ["webapp", "application/x-web-app-manifest+json"],
  ["webm", "video/webm"],
  ["webmanifest", "application/manifest+json"],
  ["webp", "image/webp"],
  ["wg", "application/vnd.pmi.widget"],
  ["wgt", "application/widget"],
  ["wks", "application/vnd.ms-works"],
  ["wm", "video/x-ms-wm"],
  ["wma", "audio/x-ms-wma"],
  ["wmd", "application/x-ms-wmd"],
  ["wmf", "image/wmf"],
  ["wml", "text/vnd.wap.wml"],
  ["wmlc", "application/wmlc"],
  ["wmls", "text/vnd.wap.wmlscript"],
  ["wmlsc", "application/vnd.wap.wmlscriptc"],
  ["wmv", "video/x-ms-wmv"],
  ["wmx", "video/x-ms-wmx"],
  ["wmz", "application/x-msmetafile"],
  ["woff", "font/woff"],
  ["woff2", "font/woff2"],
  ["word", "application/msword"],
  ["wpd", "application/vnd.wordperfect"],
  ["wpl", "application/vnd.ms-wpl"],
  ["wps", "application/vnd.ms-works"],
  ["wqd", "application/vnd.wqd"],
  ["wri", "application/x-mswrite"],
  ["wrl", "model/vrml"],
  ["wsc", "message/vnd.wfa.wsc"],
  ["wsdl", "application/wsdl+xml"],
  ["wspolicy", "application/wspolicy+xml"],
  ["wtb", "application/vnd.webturbo"],
  ["wvx", "video/x-ms-wvx"],
  ["x3d", "model/x3d+xml"],
  ["x3db", "model/x3d+fastinfoset"],
  ["x3dbz", "model/x3d+binary"],
  ["x3dv", "model/x3d-vrml"],
  ["x3dvz", "model/x3d+vrml"],
  ["x3dz", "model/x3d+xml"],
  ["x32", "application/x-authorware-bin"],
  ["x_b", "model/vnd.parasolid.transmit.binary"],
  ["x_t", "model/vnd.parasolid.transmit.text"],
  ["xaml", "application/xaml+xml"],
  ["xap", "application/x-silverlight-app"],
  ["xar", "application/vnd.xara"],
  ["xav", "application/xcap-att+xml"],
  ["xbap", "application/x-ms-xbap"],
  ["xbd", "application/vnd.fujixerox.docuworks.binder"],
  ["xbm", "image/x-xbitmap"],
  ["xca", "application/xcap-caps+xml"],
  ["xcs", "application/calendar+xml"],
  ["xdf", "application/xcap-diff+xml"],
  ["xdm", "application/vnd.syncml.dm+xml"],
  ["xdp", "application/vnd.adobe.xdp+xml"],
  ["xdssc", "application/dssc+xml"],
  ["xdw", "application/vnd.fujixerox.docuworks"],
  ["xel", "application/xcap-el+xml"],
  ["xenc", "application/xenc+xml"],
  ["xer", "application/patch-ops-error+xml"],
  ["xfdf", "application/vnd.adobe.xfdf"],
  ["xfdl", "application/vnd.xfdl"],
  ["xht", "application/xhtml+xml"],
  ["xhtml", "application/xhtml+xml"],
  ["xhvml", "application/xv+xml"],
  ["xif", "image/vnd.xiff"],
  ["xl", "application/excel"],
  ["xla", "application/vnd.ms-excel"],
  ["xlam", "application/vnd.ms-excel.addin.macroEnabled.12"],
  ["xlc", "application/vnd.ms-excel"],
  ["xlf", "application/xliff+xml"],
  ["xlm", "application/vnd.ms-excel"],
  ["xls", "application/vnd.ms-excel"],
  ["xlsb", "application/vnd.ms-excel.sheet.binary.macroEnabled.12"],
  ["xlsm", "application/vnd.ms-excel.sheet.macroEnabled.12"],
  ["xlsx", "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"],
  ["xlt", "application/vnd.ms-excel"],
  ["xltm", "application/vnd.ms-excel.template.macroEnabled.12"],
  ["xltx", "application/vnd.openxmlformats-officedocument.spreadsheetml.template"],
  ["xlw", "application/vnd.ms-excel"],
  ["xm", "audio/xm"],
  ["xml", "application/xml"],
  ["xns", "application/xcap-ns+xml"],
  ["xo", "application/vnd.olpc-sugar"],
  ["xop", "application/xop+xml"],
  ["xpi", "application/x-xpinstall"],
  ["xpl", "application/xproc+xml"],
  ["xpm", "image/x-xpixmap"],
  ["xpr", "application/vnd.is-xpr"],
  ["xps", "application/vnd.ms-xpsdocument"],
  ["xpw", "application/vnd.intercon.formnet"],
  ["xpx", "application/vnd.intercon.formnet"],
  ["xsd", "application/xml"],
  ["xsl", "application/xml"],
  ["xslt", "application/xslt+xml"],
  ["xsm", "application/vnd.syncml+xml"],
  ["xspf", "application/xspf+xml"],
  ["xul", "application/vnd.mozilla.xul+xml"],
  ["xvm", "application/xv+xml"],
  ["xvml", "application/xv+xml"],
  ["xwd", "image/x-xwindowdump"],
  ["xyz", "chemical/x-xyz"],
  ["xz", "application/x-xz"],
  ["yaml", "text/yaml"],
  ["yang", "application/yang"],
  ["yin", "application/yin+xml"],
  ["yml", "text/yaml"],
  ["ymp", "text/x-suse-ymp"],
  ["z", "application/x-compress"],
  ["z1", "application/x-zmachine"],
  ["z2", "application/x-zmachine"],
  ["z3", "application/x-zmachine"],
  ["z4", "application/x-zmachine"],
  ["z5", "application/x-zmachine"],
  ["z6", "application/x-zmachine"],
  ["z7", "application/x-zmachine"],
  ["z8", "application/x-zmachine"],
  ["zaz", "application/vnd.zzazz.deck+xml"],
  ["zip", "application/zip"],
  ["zir", "application/vnd.zul"],
  ["zirz", "application/vnd.zul"],
  ["zmm", "application/vnd.handheld-entertainment+xml"],
  ["zsh", "text/x-scriptzsh"]
]);
function toFileWithPath(Bi, e, Ui) {
  const Zi = withMimeType(Bi), { webkitRelativePath: ta } = Bi, na = typeof e == "string" ? e : typeof ta == "string" && ta.length > 0 ? ta : `./${Bi.name}`;
  return typeof Zi.path != "string" && setObjProp(Zi, "path", na), setObjProp(Zi, "relativePath", na), Zi;
}
function withMimeType(Bi) {
  const { name: e } = Bi;
  if (e && e.lastIndexOf(".") !== -1 && !Bi.type) {
    const Zi = e.split(".").pop().toLowerCase(), ta = COMMON_MIME_TYPES.get(Zi);
    ta && Object.defineProperty(Bi, "type", {
      value: ta,
      writable: !1,
      configurable: !1,
      enumerable: !0
    });
  }
  return Bi;
}
function setObjProp(Bi, e, Ui) {
  Object.defineProperty(Bi, e, {
    value: Ui,
    writable: !1,
    configurable: !1,
    enumerable: !0
  });
}
const FILES_TO_IGNORE = [
  // Thumbnail cache files for macOS and Windows
  ".DS_Store",
  // macOs
  "Thumbs.db"
  // Windows
];
function fromEvent(Bi) {
  return __awaiter(this, void 0, void 0, function* () {
    return isObject$1(Bi) && isDataTransfer(Bi.dataTransfer) ? getDataTransferFiles(Bi.dataTransfer, Bi.type) : isChangeEvt(Bi) ? getInputFiles(Bi) : Array.isArray(Bi) && Bi.every((e) => "getFile" in e && typeof e.getFile == "function") ? getFsHandleFiles(Bi) : [];
  });
}
function isDataTransfer(Bi) {
  return isObject$1(Bi);
}
function isChangeEvt(Bi) {
  return isObject$1(Bi) && isObject$1(Bi.target);
}
function isObject$1(Bi) {
  return typeof Bi == "object" && Bi !== null;
}
function getInputFiles(Bi) {
  return fromList(Bi.target.files).map((e) => toFileWithPath(e));
}
function getFsHandleFiles(Bi) {
  return __awaiter(this, void 0, void 0, function* () {
    return (yield Promise.all(Bi.map((Ui) => Ui.getFile()))).map((Ui) => toFileWithPath(Ui));
  });
}
function getDataTransferFiles(Bi, e) {
  return __awaiter(this, void 0, void 0, function* () {
    if (Bi.items) {
      const Ui = fromList(Bi.items).filter((ta) => ta.kind === "file");
      if (e !== "drop")
        return Ui;
      const Zi = yield Promise.all(Ui.map(toFilePromises));
      return noIgnoredFiles(flatten(Zi));
    }
    return noIgnoredFiles(fromList(Bi.files).map((Ui) => toFileWithPath(Ui)));
  });
}
function noIgnoredFiles(Bi) {
  return Bi.filter((e) => FILES_TO_IGNORE.indexOf(e.name) === -1);
}
function fromList(Bi) {
  if (Bi === null)
    return [];
  const e = [];
  for (let Ui = 0; Ui < Bi.length; Ui++) {
    const Zi = Bi[Ui];
    e.push(Zi);
  }
  return e;
}
function toFilePromises(Bi) {
  if (typeof Bi.webkitGetAsEntry != "function")
    return fromDataTransferItem(Bi);
  const e = Bi.webkitGetAsEntry();
  return e && e.isDirectory ? fromDirEntry(e) : fromDataTransferItem(Bi, e);
}
function flatten(Bi) {
  return Bi.reduce((e, Ui) => [
    ...e,
    ...Array.isArray(Ui) ? flatten(Ui) : [Ui]
  ], []);
}
function fromDataTransferItem(Bi, e) {
  return __awaiter(this, void 0, void 0, function* () {
    var Ui;
    if (globalThis.isSecureContext && typeof Bi.getAsFileSystemHandle == "function") {
      const na = yield Bi.getAsFileSystemHandle();
      if (na === null)
        throw new Error(`${Bi} is not a File`);
      if (na !== void 0) {
        const ia = yield na.getFile();
        return ia.handle = na, toFileWithPath(ia);
      }
    }
    const Zi = Bi.getAsFile();
    if (!Zi)
      throw new Error(`${Bi} is not a File`);
    return toFileWithPath(Zi, (Ui = e?.fullPath) !== null && Ui !== void 0 ? Ui : void 0);
  });
}
function fromEntry(Bi) {
  return __awaiter(this, void 0, void 0, function* () {
    return Bi.isDirectory ? fromDirEntry(Bi) : fromFileEntry(Bi);
  });
}
function fromDirEntry(Bi) {
  const e = Bi.createReader();
  return new Promise((Ui, Zi) => {
    const ta = [];
    function na() {
      e.readEntries((ia) => __awaiter(this, void 0, void 0, function* () {
        if (ia.length) {
          const aa = Promise.all(ia.map(fromEntry));
          ta.push(aa), na();
        } else
          try {
            const aa = yield Promise.all(ta);
            Ui(aa);
          } catch (aa) {
            Zi(aa);
          }
      }), (ia) => {
        Zi(ia);
      });
    }
    na();
  });
}
function fromFileEntry(Bi) {
  return __awaiter(this, void 0, void 0, function* () {
    return new Promise((e, Ui) => {
      Bi.file((Zi) => {
        const ta = toFileWithPath(Zi, Bi.fullPath);
        e(ta);
      }, (Zi) => {
        Ui(Zi);
      });
    });
  });
}
var es$1 = {}, hasRequiredEs;
function requireEs() {
  return hasRequiredEs || (hasRequiredEs = 1, es$1.__esModule = !0, es$1.default = function(Bi, e) {
    if (Bi && e) {
      var Ui = Array.isArray(e) ? e : e.split(",");
      if (Ui.length === 0)
        return !0;
      var Zi = Bi.name || "", ta = (Bi.type || "").toLowerCase(), na = ta.replace(/\/.*$/, "");
      return Ui.some(function(ia) {
        var aa = ia.trim().toLowerCase();
        return aa.charAt(0) === "." ? Zi.toLowerCase().endsWith(aa) : aa.endsWith("/*") ? na === aa.replace(/\/.*$/, "") : ta === aa;
      });
    }
    return !0;
  }), es$1;
}
var esExports = requireEs();
const _accepts = /* @__PURE__ */ getDefaultExportFromCjs(esExports);
function _toConsumableArray$1(Bi) {
  return _arrayWithoutHoles$1(Bi) || _iterableToArray$1(Bi) || _unsupportedIterableToArray$1(Bi) || _nonIterableSpread$1();
}
function _nonIterableSpread$1() {
  throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function _iterableToArray$1(Bi) {
  if (typeof Symbol < "u" && Bi[Symbol.iterator] != null || Bi["@@iterator"] != null) return Array.from(Bi);
}
function _arrayWithoutHoles$1(Bi) {
  if (Array.isArray(Bi)) return _arrayLikeToArray$1(Bi);
}
function ownKeys$1(Bi, e) {
  var Ui = Object.keys(Bi);
  if (Object.getOwnPropertySymbols) {
    var Zi = Object.getOwnPropertySymbols(Bi);
    e && (Zi = Zi.filter(function(ta) {
      return Object.getOwnPropertyDescriptor(Bi, ta).enumerable;
    })), Ui.push.apply(Ui, Zi);
  }
  return Ui;
}
function _objectSpread$1(Bi) {
  for (var e = 1; e < arguments.length; e++) {
    var Ui = arguments[e] != null ? arguments[e] : {};
    e % 2 ? ownKeys$1(Object(Ui), !0).forEach(function(Zi) {
      _defineProperty$1(Bi, Zi, Ui[Zi]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(Bi, Object.getOwnPropertyDescriptors(Ui)) : ownKeys$1(Object(Ui)).forEach(function(Zi) {
      Object.defineProperty(Bi, Zi, Object.getOwnPropertyDescriptor(Ui, Zi));
    });
  }
  return Bi;
}
function _defineProperty$1(Bi, e, Ui) {
  return e in Bi ? Object.defineProperty(Bi, e, { value: Ui, enumerable: !0, configurable: !0, writable: !0 }) : Bi[e] = Ui, Bi;
}
function _slicedToArray$1(Bi, e) {
  return _arrayWithHoles$1(Bi) || _iterableToArrayLimit$1(Bi, e) || _unsupportedIterableToArray$1(Bi, e) || _nonIterableRest$1();
}
function _nonIterableRest$1() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function _unsupportedIterableToArray$1(Bi, e) {
  if (Bi) {
    if (typeof Bi == "string") return _arrayLikeToArray$1(Bi, e);
    var Ui = Object.prototype.toString.call(Bi).slice(8, -1);
    if (Ui === "Object" && Bi.constructor && (Ui = Bi.constructor.name), Ui === "Map" || Ui === "Set") return Array.from(Bi);
    if (Ui === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(Ui)) return _arrayLikeToArray$1(Bi, e);
  }
}
function _arrayLikeToArray$1(Bi, e) {
  (e == null || e > Bi.length) && (e = Bi.length);
  for (var Ui = 0, Zi = new Array(e); Ui < e; Ui++)
    Zi[Ui] = Bi[Ui];
  return Zi;
}
function _iterableToArrayLimit$1(Bi, e) {
  var Ui = Bi == null ? null : typeof Symbol < "u" && Bi[Symbol.iterator] || Bi["@@iterator"];
  if (Ui != null) {
    var Zi = [], ta = !0, na = !1, ia, aa;
    try {
      for (Ui = Ui.call(Bi); !(ta = (ia = Ui.next()).done) && (Zi.push(ia.value), !(e && Zi.length === e)); ta = !0)
        ;
    } catch (da) {
      na = !0, aa = da;
    } finally {
      try {
        !ta && Ui.return != null && Ui.return();
      } finally {
        if (na) throw aa;
      }
    }
    return Zi;
  }
}
function _arrayWithHoles$1(Bi) {
  if (Array.isArray(Bi)) return Bi;
}
var accepts = typeof _accepts == "function" ? _accepts : _accepts.default, FILE_INVALID_TYPE = "file-invalid-type", FILE_TOO_LARGE = "file-too-large", FILE_TOO_SMALL = "file-too-small", TOO_MANY_FILES = "too-many-files", getInvalidTypeRejectionErr = function() {
  var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "", Ui = e.split(","), Zi = Ui.length > 1 ? "one of ".concat(Ui.join(", ")) : Ui[0];
  return {
    code: FILE_INVALID_TYPE,
    message: "File type must be ".concat(Zi)
  };
}, getTooLargeRejectionErr = function(e) {
  return {
    code: FILE_TOO_LARGE,
    message: "File is larger than ".concat(e, " ").concat(e === 1 ? "byte" : "bytes")
  };
}, getTooSmallRejectionErr = function(e) {
  return {
    code: FILE_TOO_SMALL,
    message: "File is smaller than ".concat(e, " ").concat(e === 1 ? "byte" : "bytes")
  };
}, TOO_MANY_FILES_REJECTION = {
  code: TOO_MANY_FILES,
  message: "Too many files"
};
function fileAccepted(Bi, e) {
  var Ui = Bi.type === "application/x-moz-file" || accepts(Bi, e);
  return [Ui, Ui ? null : getInvalidTypeRejectionErr(e)];
}
function fileMatchSize(Bi, e, Ui) {
  if (isDefined(Bi.size))
    if (isDefined(e) && isDefined(Ui)) {
      if (Bi.size > Ui) return [!1, getTooLargeRejectionErr(Ui)];
      if (Bi.size < e) return [!1, getTooSmallRejectionErr(e)];
    } else {
      if (isDefined(e) && Bi.size < e) return [!1, getTooSmallRejectionErr(e)];
      if (isDefined(Ui) && Bi.size > Ui) return [!1, getTooLargeRejectionErr(Ui)];
    }
  return [!0, null];
}
function isDefined(Bi) {
  return Bi != null;
}
function allFilesAccepted(Bi) {
  var e = Bi.files, Ui = Bi.accept, Zi = Bi.minSize, ta = Bi.maxSize, na = Bi.multiple, ia = Bi.maxFiles, aa = Bi.validator;
  return !na && e.length > 1 || na && ia >= 1 && e.length > ia ? !1 : e.every(function(da) {
    var La = fileAccepted(da, Ui), qa = _slicedToArray$1(La, 1), io = qa[0], ao = fileMatchSize(da, Zi, ta), oo = _slicedToArray$1(ao, 1), no = oo[0], lo = aa ? aa(da) : null;
    return io && no && !lo;
  });
}
function isPropagationStopped(Bi) {
  return typeof Bi.isPropagationStopped == "function" ? Bi.isPropagationStopped() : typeof Bi.cancelBubble < "u" ? Bi.cancelBubble : !1;
}
function isEvtWithFiles(Bi) {
  return Bi.dataTransfer ? Array.prototype.some.call(Bi.dataTransfer.types, function(e) {
    return e === "Files" || e === "application/x-moz-file";
  }) : !!Bi.target && !!Bi.target.files;
}
function onDocumentDragOver(Bi) {
  Bi.preventDefault();
}
function isIe(Bi) {
  return Bi.indexOf("MSIE") !== -1 || Bi.indexOf("Trident/") !== -1;
}
function isEdge(Bi) {
  return Bi.indexOf("Edge/") !== -1;
}
function isIeOrEdge() {
  var Bi = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : window.navigator.userAgent;
  return isIe(Bi) || isEdge(Bi);
}
function composeEventHandlers() {
  for (var Bi = arguments.length, e = new Array(Bi), Ui = 0; Ui < Bi; Ui++)
    e[Ui] = arguments[Ui];
  return function(Zi) {
    for (var ta = arguments.length, na = new Array(ta > 1 ? ta - 1 : 0), ia = 1; ia < ta; ia++)
      na[ia - 1] = arguments[ia];
    return e.some(function(aa) {
      return !isPropagationStopped(Zi) && aa && aa.apply(void 0, [Zi].concat(na)), isPropagationStopped(Zi);
    });
  };
}
function canUseFileSystemAccessAPI() {
  return "showOpenFilePicker" in window;
}
function pickerOptionsFromAccept(Bi) {
  if (isDefined(Bi)) {
    var e = Object.entries(Bi).filter(function(Ui) {
      var Zi = _slicedToArray$1(Ui, 2), ta = Zi[0], na = Zi[1], ia = !0;
      return isMIMEType(ta) || (console.warn('Skipped "'.concat(ta, '" because it is not a valid MIME type. Check https://developer.mozilla.org/en-US/docs/Web/HTTP/Basics_of_HTTP/MIME_types/Common_types for a list of valid MIME types.')), ia = !1), (!Array.isArray(na) || !na.every(isExt)) && (console.warn('Skipped "'.concat(ta, '" because an invalid file extension was provided.')), ia = !1), ia;
    }).reduce(function(Ui, Zi) {
      var ta = _slicedToArray$1(Zi, 2), na = ta[0], ia = ta[1];
      return _objectSpread$1(_objectSpread$1({}, Ui), {}, _defineProperty$1({}, na, ia));
    }, {});
    return [{
      // description is required due to https://crbug.com/1264708
      description: "Files",
      accept: e
    }];
  }
  return Bi;
}
function acceptPropAsAcceptAttr(Bi) {
  if (isDefined(Bi))
    return Object.entries(Bi).reduce(function(e, Ui) {
      var Zi = _slicedToArray$1(Ui, 2), ta = Zi[0], na = Zi[1];
      return [].concat(_toConsumableArray$1(e), [ta], _toConsumableArray$1(na));
    }, []).filter(function(e) {
      return isMIMEType(e) || isExt(e);
    }).join(",");
}
function isAbort(Bi) {
  return Bi instanceof DOMException && (Bi.name === "AbortError" || Bi.code === Bi.ABORT_ERR);
}
function isSecurityError(Bi) {
  return Bi instanceof DOMException && (Bi.name === "SecurityError" || Bi.code === Bi.SECURITY_ERR);
}
function isMIMEType(Bi) {
  return Bi === "audio/*" || Bi === "video/*" || Bi === "image/*" || Bi === "text/*" || Bi === "application/*" || /\w+\/[-+.\w]+/g.test(Bi);
}
function isExt(Bi) {
  return /^.*\.[\w]+$/.test(Bi);
}
var _excluded = ["children"], _excluded2 = ["open"], _excluded3 = ["refKey", "role", "onKeyDown", "onFocus", "onBlur", "onClick", "onDragEnter", "onDragOver", "onDragLeave", "onDrop"], _excluded4 = ["refKey", "onChange", "onClick"];
function _toConsumableArray(Bi) {
  return _arrayWithoutHoles(Bi) || _iterableToArray(Bi) || _unsupportedIterableToArray(Bi) || _nonIterableSpread();
}
function _nonIterableSpread() {
  throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function _iterableToArray(Bi) {
  if (typeof Symbol < "u" && Bi[Symbol.iterator] != null || Bi["@@iterator"] != null) return Array.from(Bi);
}
function _arrayWithoutHoles(Bi) {
  if (Array.isArray(Bi)) return _arrayLikeToArray(Bi);
}
function _slicedToArray(Bi, e) {
  return _arrayWithHoles(Bi) || _iterableToArrayLimit(Bi, e) || _unsupportedIterableToArray(Bi, e) || _nonIterableRest();
}
function _nonIterableRest() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function _unsupportedIterableToArray(Bi, e) {
  if (Bi) {
    if (typeof Bi == "string") return _arrayLikeToArray(Bi, e);
    var Ui = Object.prototype.toString.call(Bi).slice(8, -1);
    if (Ui === "Object" && Bi.constructor && (Ui = Bi.constructor.name), Ui === "Map" || Ui === "Set") return Array.from(Bi);
    if (Ui === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(Ui)) return _arrayLikeToArray(Bi, e);
  }
}
function _arrayLikeToArray(Bi, e) {
  (e == null || e > Bi.length) && (e = Bi.length);
  for (var Ui = 0, Zi = new Array(e); Ui < e; Ui++)
    Zi[Ui] = Bi[Ui];
  return Zi;
}
function _iterableToArrayLimit(Bi, e) {
  var Ui = Bi == null ? null : typeof Symbol < "u" && Bi[Symbol.iterator] || Bi["@@iterator"];
  if (Ui != null) {
    var Zi = [], ta = !0, na = !1, ia, aa;
    try {
      for (Ui = Ui.call(Bi); !(ta = (ia = Ui.next()).done) && (Zi.push(ia.value), !(e && Zi.length === e)); ta = !0)
        ;
    } catch (da) {
      na = !0, aa = da;
    } finally {
      try {
        !ta && Ui.return != null && Ui.return();
      } finally {
        if (na) throw aa;
      }
    }
    return Zi;
  }
}
function _arrayWithHoles(Bi) {
  if (Array.isArray(Bi)) return Bi;
}
function ownKeys(Bi, e) {
  var Ui = Object.keys(Bi);
  if (Object.getOwnPropertySymbols) {
    var Zi = Object.getOwnPropertySymbols(Bi);
    e && (Zi = Zi.filter(function(ta) {
      return Object.getOwnPropertyDescriptor(Bi, ta).enumerable;
    })), Ui.push.apply(Ui, Zi);
  }
  return Ui;
}
function _objectSpread(Bi) {
  for (var e = 1; e < arguments.length; e++) {
    var Ui = arguments[e] != null ? arguments[e] : {};
    e % 2 ? ownKeys(Object(Ui), !0).forEach(function(Zi) {
      _defineProperty(Bi, Zi, Ui[Zi]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(Bi, Object.getOwnPropertyDescriptors(Ui)) : ownKeys(Object(Ui)).forEach(function(Zi) {
      Object.defineProperty(Bi, Zi, Object.getOwnPropertyDescriptor(Ui, Zi));
    });
  }
  return Bi;
}
function _defineProperty(Bi, e, Ui) {
  return e in Bi ? Object.defineProperty(Bi, e, { value: Ui, enumerable: !0, configurable: !0, writable: !0 }) : Bi[e] = Ui, Bi;
}
function _objectWithoutProperties(Bi, e) {
  if (Bi == null) return {};
  var Ui = _objectWithoutPropertiesLoose(Bi, e), Zi, ta;
  if (Object.getOwnPropertySymbols) {
    var na = Object.getOwnPropertySymbols(Bi);
    for (ta = 0; ta < na.length; ta++)
      Zi = na[ta], !(e.indexOf(Zi) >= 0) && Object.prototype.propertyIsEnumerable.call(Bi, Zi) && (Ui[Zi] = Bi[Zi]);
  }
  return Ui;
}
function _objectWithoutPropertiesLoose(Bi, e) {
  if (Bi == null) return {};
  var Ui = {}, Zi = Object.keys(Bi), ta, na;
  for (na = 0; na < Zi.length; na++)
    ta = Zi[na], !(e.indexOf(ta) >= 0) && (Ui[ta] = Bi[ta]);
  return Ui;
}
var Dropzone = /* @__PURE__ */ forwardRef(function(Bi, e) {
  var Ui = Bi.children, Zi = _objectWithoutProperties(Bi, _excluded), ta = useDropzone(Zi), na = ta.open, ia = _objectWithoutProperties(ta, _excluded2);
  return useImperativeHandle(e, function() {
    return {
      open: na
    };
  }, [na]), /* @__PURE__ */ a__default.createElement(Fragment, null, Ui(_objectSpread(_objectSpread({}, ia), {}, {
    open: na
  })));
});
Dropzone.displayName = "Dropzone";
var defaultProps = {
  disabled: !1,
  getFilesFromEvent: fromEvent,
  maxSize: 1 / 0,
  minSize: 0,
  multiple: !0,
  maxFiles: 0,
  preventDropOnDocument: !0,
  noClick: !1,
  noKeyboard: !1,
  noDrag: !1,
  noDragEventsBubbling: !1,
  validator: null,
  useFsAccessApi: !1,
  autoFocus: !1
};
Dropzone.defaultProps = defaultProps;
Dropzone.propTypes = {
  /**
   * Render function that exposes the dropzone state and prop getter fns
   *
   * @param {object} params
   * @param {Function} params.getRootProps Returns the props you should apply to the root drop container you render
   * @param {Function} params.getInputProps Returns the props you should apply to hidden file input you render
   * @param {Function} params.open Open the native file selection dialog
   * @param {boolean} params.isFocused Dropzone area is in focus
   * @param {boolean} params.isFileDialogActive File dialog is opened
   * @param {boolean} params.isDragActive Active drag is in progress
   * @param {boolean} params.isDragAccept Dragged files are accepted
   * @param {boolean} params.isDragReject Some dragged files are rejected
   * @param {File[]} params.acceptedFiles Accepted files
   * @param {FileRejection[]} params.fileRejections Rejected files and why they were rejected
   */
  children: PropTypes.func,
  /**
   * Set accepted file types.
   * Checkout https://developer.mozilla.org/en-US/docs/Web/API/window/showOpenFilePicker types option for more information.
   * Keep in mind that mime type determination is not reliable across platforms. CSV files,
   * for example, are reported as text/plain under macOS but as application/vnd.ms-excel under
   * Windows. In some cases there might not be a mime type set at all (https://github.com/react-dropzone/react-dropzone/issues/276).
   */
  accept: PropTypes.objectOf(PropTypes.arrayOf(PropTypes.string)),
  /**
   * Allow drag 'n' drop (or selection from the file dialog) of multiple files
   */
  multiple: PropTypes.bool,
  /**
   * If false, allow dropped items to take over the current browser window
   */
  preventDropOnDocument: PropTypes.bool,
  /**
   * If true, disables click to open the native file selection dialog
   */
  noClick: PropTypes.bool,
  /**
   * If true, disables SPACE/ENTER to open the native file selection dialog.
   * Note that it also stops tracking the focus state.
   */
  noKeyboard: PropTypes.bool,
  /**
   * If true, disables drag 'n' drop
   */
  noDrag: PropTypes.bool,
  /**
   * If true, stops drag event propagation to parents
   */
  noDragEventsBubbling: PropTypes.bool,
  /**
   * Minimum file size (in bytes)
   */
  minSize: PropTypes.number,
  /**
   * Maximum file size (in bytes)
   */
  maxSize: PropTypes.number,
  /**
   * Maximum accepted number of files
   * The default value is 0 which means there is no limitation to how many files are accepted.
   */
  maxFiles: PropTypes.number,
  /**
   * Enable/disable the dropzone
   */
  disabled: PropTypes.bool,
  /**
   * Use this to provide a custom file aggregator
   *
   * @param {(DragEvent|Event)} event A drag event or input change event (if files were selected via the file dialog)
   */
  getFilesFromEvent: PropTypes.func,
  /**
   * Cb for when closing the file dialog with no selection
   */
  onFileDialogCancel: PropTypes.func,
  /**
   * Cb for when opening the file dialog
   */
  onFileDialogOpen: PropTypes.func,
  /**
   * Set to true to use the https://developer.mozilla.org/en-US/docs/Web/API/File_System_Access_API
   * to open the file picker instead of using an `<input type="file">` click event.
   */
  useFsAccessApi: PropTypes.bool,
  /**
   * Set to true to focus the root element on render
   */
  autoFocus: PropTypes.bool,
  /**
   * Cb for when the `dragenter` event occurs.
   *
   * @param {DragEvent} event
   */
  onDragEnter: PropTypes.func,
  /**
   * Cb for when the `dragleave` event occurs
   *
   * @param {DragEvent} event
   */
  onDragLeave: PropTypes.func,
  /**
   * Cb for when the `dragover` event occurs
   *
   * @param {DragEvent} event
   */
  onDragOver: PropTypes.func,
  /**
   * Cb for when the `drop` event occurs.
   * Note that this callback is invoked after the `getFilesFromEvent` callback is done.
   *
   * Files are accepted or rejected based on the `accept`, `multiple`, `minSize` and `maxSize` props.
   * `accept` must be a valid [MIME type](http://www.iana.org/assignments/media-types/media-types.xhtml) according to [input element specification](https://www.w3.org/wiki/HTML/Elements/input/file) or a valid file extension.
   * If `multiple` is set to false and additional files are dropped,
   * all files besides the first will be rejected.
   * Any file which does not have a size in the [`minSize`, `maxSize`] range, will be rejected as well.
   *
   * Note that the `onDrop` callback will always be invoked regardless if the dropped files were accepted or rejected.
   * If you'd like to react to a specific scenario, use the `onDropAccepted`/`onDropRejected` props.
   *
   * `onDrop` will provide you with an array of [File](https://developer.mozilla.org/en-US/docs/Web/API/File) objects which you can then process and send to a server.
   * For example, with [SuperAgent](https://github.com/visionmedia/superagent) as a http/ajax library:
   *
   * ```js
   * function onDrop(acceptedFiles) {
   *   const req = request.post('/upload')
   *   acceptedFiles.forEach(file => {
   *     req.attach(file.name, file)
   *   })
   *   req.end(callback)
   * }
   * ```
   *
   * @param {File[]} acceptedFiles
   * @param {FileRejection[]} fileRejections
   * @param {(DragEvent|Event)} event A drag event or input change event (if files were selected via the file dialog)
   */
  onDrop: PropTypes.func,
  /**
   * Cb for when the `drop` event occurs.
   * Note that if no files are accepted, this callback is not invoked.
   *
   * @param {File[]} files
   * @param {(DragEvent|Event)} event
   */
  onDropAccepted: PropTypes.func,
  /**
   * Cb for when the `drop` event occurs.
   * Note that if no files are rejected, this callback is not invoked.
   *
   * @param {FileRejection[]} fileRejections
   * @param {(DragEvent|Event)} event
   */
  onDropRejected: PropTypes.func,
  /**
   * Cb for when there's some error from any of the promises.
   *
   * @param {Error} error
   */
  onError: PropTypes.func,
  /**
   * Custom validation function. It must return null if there's no errors.
   * @param {File} file
   * @returns {FileError|FileError[]|null}
   */
  validator: PropTypes.func
};
var initialState = {
  isFocused: !1,
  isFileDialogActive: !1,
  isDragActive: !1,
  isDragAccept: !1,
  isDragReject: !1,
  acceptedFiles: [],
  fileRejections: []
};
function useDropzone() {
  var Bi = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, e = _objectSpread(_objectSpread({}, defaultProps), Bi), Ui = e.accept, Zi = e.disabled, ta = e.getFilesFromEvent, na = e.maxSize, ia = e.minSize, aa = e.multiple, da = e.maxFiles, La = e.onDragEnter, qa = e.onDragLeave, io = e.onDragOver, ao = e.onDrop, oo = e.onDropAccepted, no = e.onDropRejected, lo = e.onFileDialogCancel, so = e.onFileDialogOpen, bs = e.useFsAccessApi, Rs = e.autoFocus, js = e.preventDropOnDocument, qs = e.noClick, jo = e.noKeyboard, fs = e.noDrag, Ao = e.noDragEventsBubbling, co = e.onError, Co = e.validator, Zs = useMemo(function() {
    return acceptPropAsAcceptAttr(Ui);
  }, [Ui]), xl = useMemo(function() {
    return pickerOptionsFromAccept(Ui);
  }, [Ui]), Cl = useMemo(function() {
    return typeof so == "function" ? so : noop;
  }, [so]), Al = useMemo(function() {
    return typeof lo == "function" ? lo : noop;
  }, [lo]), Ol = useRef(null), Bl = useRef(null), Ml = useReducer(reducer, initialState), Vl = _slicedToArray(Ml, 2), Ll = Vl[0], Yl = Vl[1], Zl = Ll.isFocused, tc = Ll.isFileDialogActive, Nl = useRef(typeof window < "u" && window.isSecureContext && bs && canUseFileSystemAccessAPI()), Tl = function() {
    !Nl.current && tc && setTimeout(function() {
      if (Bl.current) {
        var sc = Bl.current.files;
        sc.length || (Yl({
          type: "closeDialog"
        }), Al());
      }
    }, 300);
  };
  useEffect(function() {
    return window.addEventListener("focus", Tl, !1), function() {
      window.removeEventListener("focus", Tl, !1);
    };
  }, [Bl, tc, Al, Nl]);
  var El = useRef([]), Il = function(sc) {
    Ol.current && Ol.current.contains(sc.target) || (sc.preventDefault(), El.current = []);
  };
  useEffect(function() {
    return js && (document.addEventListener("dragover", onDocumentDragOver, !1), document.addEventListener("drop", Il, !1)), function() {
      js && (document.removeEventListener("dragover", onDocumentDragOver), document.removeEventListener("drop", Il));
    };
  }, [Ol, js]), useEffect(function() {
    return !Zi && Rs && Ol.current && Ol.current.focus(), function() {
    };
  }, [Ol, Rs, Zi]);
  var Ul = useCallback(function(Xl) {
    co ? co(Xl) : console.error(Xl);
  }, [co]), Kl = useCallback(function(Xl) {
    Xl.preventDefault(), Xl.persist(), Wl(Xl), El.current = [].concat(_toConsumableArray(El.current), [Xl.target]), isEvtWithFiles(Xl) && Promise.resolve(ta(Xl)).then(function(sc) {
      if (!(isPropagationStopped(Xl) && !Ao)) {
        var Hu = sc.length, dc = Hu > 0 && allFilesAccepted({
          files: sc,
          accept: Zs,
          minSize: ia,
          maxSize: na,
          multiple: aa,
          maxFiles: da,
          validator: Co
        }), td = Hu > 0 && !dc;
        Yl({
          isDragAccept: dc,
          isDragReject: td,
          isDragActive: !0,
          type: "setDraggedFiles"
        }), La && La(Xl);
      }
    }).catch(function(sc) {
      return Ul(sc);
    });
  }, [ta, La, Ul, Ao, Zs, ia, na, aa, da, Co]), Rl = useCallback(function(Xl) {
    Xl.preventDefault(), Xl.persist(), Wl(Xl);
    var sc = isEvtWithFiles(Xl);
    if (sc && Xl.dataTransfer)
      try {
        Xl.dataTransfer.dropEffect = "copy";
      } catch {
      }
    return sc && io && io(Xl), !1;
  }, [io, Ao]), uo = useCallback(function(Xl) {
    Xl.preventDefault(), Xl.persist(), Wl(Xl);
    var sc = El.current.filter(function(dc) {
      return Ol.current && Ol.current.contains(dc);
    }), Hu = sc.indexOf(Xl.target);
    Hu !== -1 && sc.splice(Hu, 1), El.current = sc, !(sc.length > 0) && (Yl({
      type: "setDraggedFiles",
      isDragActive: !1,
      isDragAccept: !1,
      isDragReject: !1
    }), isEvtWithFiles(Xl) && qa && qa(Xl));
  }, [Ol, qa, Ao]), Is = useCallback(function(Xl, sc) {
    var Hu = [], dc = [];
    Xl.forEach(function(td) {
      var ad = fileAccepted(td, Zs), od = _slicedToArray(ad, 2), sd = od[0], dd = od[1], pd = fileMatchSize(td, ia, na), fd = _slicedToArray(pd, 2), Ed = fd[0], wd = fd[1], Ad = Co ? Co(td) : null;
      if (sd && Ed && !Ad)
        Hu.push(td);
      else {
        var oc = [dd, wd];
        Ad && (oc = oc.concat(Ad)), dc.push({
          file: td,
          errors: oc.filter(function(rc) {
            return rc;
          })
        });
      }
    }), (!aa && Hu.length > 1 || aa && da >= 1 && Hu.length > da) && (Hu.forEach(function(td) {
      dc.push({
        file: td,
        errors: [TOO_MANY_FILES_REJECTION]
      });
    }), Hu.splice(0)), Yl({
      acceptedFiles: Hu,
      fileRejections: dc,
      isDragReject: dc.length > 0,
      type: "setFiles"
    }), ao && ao(Hu, dc, sc), dc.length > 0 && no && no(dc, sc), Hu.length > 0 && oo && oo(Hu, sc);
  }, [Yl, aa, Zs, ia, na, da, ao, oo, no, Co]), Sl = useCallback(function(Xl) {
    Xl.preventDefault(), Xl.persist(), Wl(Xl), El.current = [], isEvtWithFiles(Xl) && Promise.resolve(ta(Xl)).then(function(sc) {
      isPropagationStopped(Xl) && !Ao || Is(sc, Xl);
    }).catch(function(sc) {
      return Ul(sc);
    }), Yl({
      type: "reset"
    });
  }, [ta, Is, Ul, Ao]), wl = useCallback(function() {
    if (Nl.current) {
      Yl({
        type: "openDialog"
      }), Cl();
      var Xl = {
        multiple: aa,
        types: xl
      };
      window.showOpenFilePicker(Xl).then(function(sc) {
        return ta(sc);
      }).then(function(sc) {
        Is(sc, null), Yl({
          type: "closeDialog"
        });
      }).catch(function(sc) {
        isAbort(sc) ? (Al(sc), Yl({
          type: "closeDialog"
        })) : isSecurityError(sc) ? (Nl.current = !1, Bl.current ? (Bl.current.value = null, Bl.current.click()) : Ul(new Error("Cannot open the file picker because the https://developer.mozilla.org/en-US/docs/Web/API/File_System_Access_API is not supported and no <input> was provided."))) : Ul(sc);
      });
      return;
    }
    Bl.current && (Yl({
      type: "openDialog"
    }), Cl(), Bl.current.value = null, Bl.current.click());
  }, [Yl, Cl, Al, bs, Is, Ul, xl, aa]), Pl = useCallback(function(Xl) {
    !Ol.current || !Ol.current.isEqualNode(Xl.target) || (Xl.key === " " || Xl.key === "Enter" || Xl.keyCode === 32 || Xl.keyCode === 13) && (Xl.preventDefault(), wl());
  }, [Ol, wl]), jl = useCallback(function() {
    Yl({
      type: "focus"
    });
  }, []), Dl = useCallback(function() {
    Yl({
      type: "blur"
    });
  }, []), $l = useCallback(function() {
    qs || (isIeOrEdge() ? setTimeout(wl, 0) : wl());
  }, [qs, wl]), kl = function(sc) {
    return Zi ? null : sc;
  }, zl = function(sc) {
    return jo ? null : kl(sc);
  }, Hl = function(sc) {
    return fs ? null : kl(sc);
  }, Wl = function(sc) {
    Ao && sc.stopPropagation();
  }, ql = useMemo(function() {
    return function() {
      var Xl = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, sc = Xl.refKey, Hu = sc === void 0 ? "ref" : sc, dc = Xl.role, td = Xl.onKeyDown, ad = Xl.onFocus, od = Xl.onBlur, sd = Xl.onClick, dd = Xl.onDragEnter, pd = Xl.onDragOver, fd = Xl.onDragLeave, Ed = Xl.onDrop, wd = _objectWithoutProperties(Xl, _excluded3);
      return _objectSpread(_objectSpread(_defineProperty({
        onKeyDown: zl(composeEventHandlers(td, Pl)),
        onFocus: zl(composeEventHandlers(ad, jl)),
        onBlur: zl(composeEventHandlers(od, Dl)),
        onClick: kl(composeEventHandlers(sd, $l)),
        onDragEnter: Hl(composeEventHandlers(dd, Kl)),
        onDragOver: Hl(composeEventHandlers(pd, Rl)),
        onDragLeave: Hl(composeEventHandlers(fd, uo)),
        onDrop: Hl(composeEventHandlers(Ed, Sl)),
        role: typeof dc == "string" && dc !== "" ? dc : "presentation"
      }, Hu, Ol), !Zi && !jo ? {
        tabIndex: 0
      } : {}), wd);
    };
  }, [Ol, Pl, jl, Dl, $l, Kl, Rl, uo, Sl, jo, fs, Zi]), Jl = useCallback(function(Xl) {
    Xl.stopPropagation();
  }, []), ac = useMemo(function() {
    return function() {
      var Xl = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, sc = Xl.refKey, Hu = sc === void 0 ? "ref" : sc, dc = Xl.onChange, td = Xl.onClick, ad = _objectWithoutProperties(Xl, _excluded4), od = _defineProperty({
        accept: Zs,
        multiple: aa,
        type: "file",
        style: {
          border: 0,
          clip: "rect(0, 0, 0, 0)",
          clipPath: "inset(50%)",
          height: "1px",
          margin: "0 -1px -1px 0",
          overflow: "hidden",
          padding: 0,
          position: "absolute",
          width: "1px",
          whiteSpace: "nowrap"
        },
        onChange: kl(composeEventHandlers(dc, Sl)),
        onClick: kl(composeEventHandlers(td, Jl)),
        tabIndex: -1
      }, Hu, Bl);
      return _objectSpread(_objectSpread({}, od), ad);
    };
  }, [Bl, Ui, aa, Sl, Zi]);
  return _objectSpread(_objectSpread({}, Ll), {}, {
    isFocused: Zl && !Zi,
    getRootProps: ql,
    getInputProps: ac,
    rootRef: Ol,
    inputRef: Bl,
    open: kl(wl)
  });
}
function reducer(Bi, e) {
  switch (e.type) {
    case "focus":
      return _objectSpread(_objectSpread({}, Bi), {}, {
        isFocused: !0
      });
    case "blur":
      return _objectSpread(_objectSpread({}, Bi), {}, {
        isFocused: !1
      });
    case "openDialog":
      return _objectSpread(_objectSpread({}, initialState), {}, {
        isFileDialogActive: !0
      });
    case "closeDialog":
      return _objectSpread(_objectSpread({}, Bi), {}, {
        isFileDialogActive: !1
      });
    case "setDraggedFiles":
      return _objectSpread(_objectSpread({}, Bi), {}, {
        isDragActive: e.isDragActive,
        isDragAccept: e.isDragAccept,
        isDragReject: e.isDragReject
      });
    case "setFiles":
      return _objectSpread(_objectSpread({}, Bi), {}, {
        acceptedFiles: e.acceptedFiles,
        fileRejections: e.fileRejections,
        isDragReject: e.isDragReject
      });
    case "reset":
      return _objectSpread({}, initialState);
    default:
      return Bi;
  }
}
function noop() {
}
const CheckBox = (Bi) => /* @__PURE__ */ jsxRuntimeExports.jsx("input", { type: "checkbox", ...Bi, className: "bg-neutral-600 checkbox" });
var isCheckBoxInput = (Bi) => Bi.type === "checkbox", isDateObject = (Bi) => Bi instanceof Date, isNullOrUndefined = (Bi) => Bi == null;
const isObjectType = (Bi) => typeof Bi == "object";
var isObject = (Bi) => !isNullOrUndefined(Bi) && !Array.isArray(Bi) && isObjectType(Bi) && !isDateObject(Bi), getEventValue = (Bi) => isObject(Bi) && Bi.target ? isCheckBoxInput(Bi.target) ? Bi.target.checked : Bi.target.value : Bi, getNodeParentName = (Bi) => Bi.substring(0, Bi.search(/\.\d+(\.|$)/)) || Bi, isNameInFieldArray = (Bi, e) => Bi.has(getNodeParentName(e)), isPlainObject = (Bi) => {
  const e = Bi.constructor && Bi.constructor.prototype;
  return isObject(e) && e.hasOwnProperty("isPrototypeOf");
}, isWeb = typeof window < "u" && typeof window.HTMLElement < "u" && typeof document < "u";
function cloneObject(Bi) {
  let e;
  const Ui = Array.isArray(Bi);
  if (Bi instanceof Date)
    e = new Date(Bi);
  else if (Bi instanceof Set)
    e = new Set(Bi);
  else if (!(isWeb && (Bi instanceof Blob || Bi instanceof FileList)) && (Ui || isObject(Bi)))
    if (e = Ui ? [] : {}, !Ui && !isPlainObject(Bi))
      e = Bi;
    else
      for (const Zi in Bi)
        Bi.hasOwnProperty(Zi) && (e[Zi] = cloneObject(Bi[Zi]));
  else
    return Bi;
  return e;
}
var compact = (Bi) => Array.isArray(Bi) ? Bi.filter(Boolean) : [], isUndefined = (Bi) => Bi === void 0, get = (Bi, e, Ui) => {
  if (!e || !isObject(Bi))
    return Ui;
  const Zi = compact(e.split(/[,[\].]+?/)).reduce((ta, na) => isNullOrUndefined(ta) ? ta : ta[na], Bi);
  return isUndefined(Zi) || Zi === Bi ? isUndefined(Bi[e]) ? Ui : Bi[e] : Zi;
};
const EVENTS = {
  BLUR: "blur",
  FOCUS_OUT: "focusout"
}, VALIDATION_MODE = {
  onBlur: "onBlur",
  onChange: "onChange",
  onSubmit: "onSubmit",
  onTouched: "onTouched",
  all: "all"
}, INPUT_VALIDATION_RULES = {
  max: "max",
  min: "min",
  maxLength: "maxLength",
  minLength: "minLength",
  pattern: "pattern",
  required: "required",
  validate: "validate"
};
a__default.createContext(null);
var getProxyFormState = (Bi, e, Ui, Zi = !0) => {
  const ta = {
    defaultValues: e._defaultValues
  };
  for (const na in Bi)
    Object.defineProperty(ta, na, {
      get: () => {
        const ia = na;
        return e._proxyFormState[ia] !== VALIDATION_MODE.all && (e._proxyFormState[ia] = !Zi || VALIDATION_MODE.all), Bi[ia];
      }
    });
  return ta;
}, isEmptyObject = (Bi) => isObject(Bi) && !Object.keys(Bi).length, shouldRenderFormState = (Bi, e, Ui, Zi) => {
  Ui(Bi);
  const { name: ta, ...na } = Bi;
  return isEmptyObject(na) || Object.keys(na).length >= Object.keys(e).length || Object.keys(na).find((ia) => e[ia] === VALIDATION_MODE.all);
}, convertToArrayPayload = (Bi) => Array.isArray(Bi) ? Bi : [Bi];
function useSubscribe(Bi) {
  const e = a__default.useRef(Bi);
  e.current = Bi, a__default.useEffect(() => {
    const Ui = !Bi.disabled && e.current.subject && e.current.subject.subscribe({
      next: e.current.next
    });
    return () => {
      Ui && Ui.unsubscribe();
    };
  }, [Bi.disabled]);
}
var isString = (Bi) => typeof Bi == "string", generateWatchOutput = (Bi, e, Ui, Zi, ta) => isString(Bi) ? (Zi && e.watch.add(Bi), get(Ui, Bi, ta)) : Array.isArray(Bi) ? Bi.map((na) => (Zi && e.watch.add(na), get(Ui, na))) : (Zi && (e.watchAll = !0), Ui), isKey = (Bi) => /^\w*$/.test(Bi), stringToPath = (Bi) => compact(Bi.replace(/["|']|\]/g, "").split(/\.|\[/));
function set(Bi, e, Ui) {
  let Zi = -1;
  const ta = isKey(e) ? [e] : stringToPath(e), na = ta.length, ia = na - 1;
  for (; ++Zi < na; ) {
    const aa = ta[Zi];
    let da = Ui;
    if (Zi !== ia) {
      const La = Bi[aa];
      da = isObject(La) || Array.isArray(La) ? La : isNaN(+ta[Zi + 1]) ? {} : [];
    }
    Bi[aa] = da, Bi = Bi[aa];
  }
  return Bi;
}
var appendErrors = (Bi, e, Ui, Zi, ta) => e ? {
  ...Ui[Bi],
  types: {
    ...Ui[Bi] && Ui[Bi].types ? Ui[Bi].types : {},
    [Zi]: ta || !0
  }
} : {};
const focusFieldBy = (Bi, e, Ui) => {
  for (const Zi of Ui || Object.keys(Bi)) {
    const ta = get(Bi, Zi);
    if (ta) {
      const { _f: na, ...ia } = ta;
      if (na && e(na.name)) {
        if (na.ref.focus) {
          na.ref.focus();
          break;
        } else if (na.refs && na.refs[0].focus) {
          na.refs[0].focus();
          break;
        }
      } else isObject(ia) && focusFieldBy(ia, e);
    }
  }
};
var getValidationModes = (Bi) => ({
  isOnSubmit: !Bi || Bi === VALIDATION_MODE.onSubmit,
  isOnBlur: Bi === VALIDATION_MODE.onBlur,
  isOnChange: Bi === VALIDATION_MODE.onChange,
  isOnAll: Bi === VALIDATION_MODE.all,
  isOnTouch: Bi === VALIDATION_MODE.onTouched
}), isWatched = (Bi, e, Ui) => !Ui && (e.watchAll || e.watch.has(Bi) || [...e.watch].some((Zi) => Bi.startsWith(Zi) && /^\.\w+/.test(Bi.slice(Zi.length)))), updateFieldArrayRootError = (Bi, e, Ui) => {
  const Zi = compact(get(Bi, Ui));
  return set(Zi, "root", e[Ui]), set(Bi, Ui, Zi), Bi;
}, isBoolean$1 = (Bi) => typeof Bi == "boolean", isFileInput = (Bi) => Bi.type === "file", isFunction = (Bi) => typeof Bi == "function", isHTMLElement = (Bi) => {
  if (!isWeb)
    return !1;
  const e = Bi ? Bi.ownerDocument : 0;
  return Bi instanceof (e && e.defaultView ? e.defaultView.HTMLElement : HTMLElement);
}, isMessage = (Bi) => isString(Bi), isRadioInput = (Bi) => Bi.type === "radio", isRegex = (Bi) => Bi instanceof RegExp;
const defaultResult = {
  value: !1,
  isValid: !1
}, validResult = { value: !0, isValid: !0 };
var getCheckboxValue = (Bi) => {
  if (Array.isArray(Bi)) {
    if (Bi.length > 1) {
      const e = Bi.filter((Ui) => Ui && Ui.checked && !Ui.disabled).map((Ui) => Ui.value);
      return { value: e, isValid: !!e.length };
    }
    return Bi[0].checked && !Bi[0].disabled ? (
      // @ts-expect-error expected to work in the browser
      Bi[0].attributes && !isUndefined(Bi[0].attributes.value) ? isUndefined(Bi[0].value) || Bi[0].value === "" ? validResult : { value: Bi[0].value, isValid: !0 } : validResult
    ) : defaultResult;
  }
  return defaultResult;
};
const defaultReturn = {
  isValid: !1,
  value: null
};
var getRadioValue = (Bi) => Array.isArray(Bi) ? Bi.reduce((e, Ui) => Ui && Ui.checked && !Ui.disabled ? {
  isValid: !0,
  value: Ui.value
} : e, defaultReturn) : defaultReturn;
function getValidateError(Bi, e, Ui = "validate") {
  if (isMessage(Bi) || Array.isArray(Bi) && Bi.every(isMessage) || isBoolean$1(Bi) && !Bi)
    return {
      type: Ui,
      message: isMessage(Bi) ? Bi : "",
      ref: e
    };
}
var getValueAndMessage = (Bi) => isObject(Bi) && !isRegex(Bi) ? Bi : {
  value: Bi,
  message: ""
}, validateField = async (Bi, e, Ui, Zi, ta) => {
  const { ref: na, refs: ia, required: aa, maxLength: da, minLength: La, min: qa, max: io, pattern: ao, validate: oo, name: no, valueAsNumber: lo, mount: so, disabled: bs } = Bi._f, Rs = get(e, no);
  if (!so || bs)
    return {};
  const js = ia ? ia[0] : na, qs = (Cl) => {
    Zi && js.reportValidity && (js.setCustomValidity(isBoolean$1(Cl) ? "" : Cl || ""), js.reportValidity());
  }, jo = {}, fs = isRadioInput(na), Ao = isCheckBoxInput(na), co = fs || Ao, Co = (lo || isFileInput(na)) && isUndefined(na.value) && isUndefined(Rs) || isHTMLElement(na) && na.value === "" || Rs === "" || Array.isArray(Rs) && !Rs.length, Zs = appendErrors.bind(null, no, Ui, jo), xl = (Cl, Al, Ol, Bl = INPUT_VALIDATION_RULES.maxLength, Ml = INPUT_VALIDATION_RULES.minLength) => {
    const Vl = Cl ? Al : Ol;
    jo[no] = {
      type: Cl ? Bl : Ml,
      message: Vl,
      ref: na,
      ...Zs(Cl ? Bl : Ml, Vl)
    };
  };
  if (ta ? !Array.isArray(Rs) || !Rs.length : aa && (!co && (Co || isNullOrUndefined(Rs)) || isBoolean$1(Rs) && !Rs || Ao && !getCheckboxValue(ia).isValid || fs && !getRadioValue(ia).isValid)) {
    const { value: Cl, message: Al } = isMessage(aa) ? { value: !!aa, message: aa } : getValueAndMessage(aa);
    if (Cl && (jo[no] = {
      type: INPUT_VALIDATION_RULES.required,
      message: Al,
      ref: js,
      ...Zs(INPUT_VALIDATION_RULES.required, Al)
    }, !Ui))
      return qs(Al), jo;
  }
  if (!Co && (!isNullOrUndefined(qa) || !isNullOrUndefined(io))) {
    let Cl, Al;
    const Ol = getValueAndMessage(io), Bl = getValueAndMessage(qa);
    if (!isNullOrUndefined(Rs) && !isNaN(Rs)) {
      const Ml = na.valueAsNumber || Rs && +Rs;
      isNullOrUndefined(Ol.value) || (Cl = Ml > Ol.value), isNullOrUndefined(Bl.value) || (Al = Ml < Bl.value);
    } else {
      const Ml = na.valueAsDate || new Date(Rs), Vl = (Zl) => /* @__PURE__ */ new Date((/* @__PURE__ */ new Date()).toDateString() + " " + Zl), Ll = na.type == "time", Yl = na.type == "week";
      isString(Ol.value) && Rs && (Cl = Ll ? Vl(Rs) > Vl(Ol.value) : Yl ? Rs > Ol.value : Ml > new Date(Ol.value)), isString(Bl.value) && Rs && (Al = Ll ? Vl(Rs) < Vl(Bl.value) : Yl ? Rs < Bl.value : Ml < new Date(Bl.value));
    }
    if ((Cl || Al) && (xl(!!Cl, Ol.message, Bl.message, INPUT_VALIDATION_RULES.max, INPUT_VALIDATION_RULES.min), !Ui))
      return qs(jo[no].message), jo;
  }
  if ((da || La) && !Co && (isString(Rs) || ta && Array.isArray(Rs))) {
    const Cl = getValueAndMessage(da), Al = getValueAndMessage(La), Ol = !isNullOrUndefined(Cl.value) && Rs.length > +Cl.value, Bl = !isNullOrUndefined(Al.value) && Rs.length < +Al.value;
    if ((Ol || Bl) && (xl(Ol, Cl.message, Al.message), !Ui))
      return qs(jo[no].message), jo;
  }
  if (ao && !Co && isString(Rs)) {
    const { value: Cl, message: Al } = getValueAndMessage(ao);
    if (isRegex(Cl) && !Rs.match(Cl) && (jo[no] = {
      type: INPUT_VALIDATION_RULES.pattern,
      message: Al,
      ref: na,
      ...Zs(INPUT_VALIDATION_RULES.pattern, Al)
    }, !Ui))
      return qs(Al), jo;
  }
  if (oo) {
    if (isFunction(oo)) {
      const Cl = await oo(Rs, e), Al = getValidateError(Cl, js);
      if (Al && (jo[no] = {
        ...Al,
        ...Zs(INPUT_VALIDATION_RULES.validate, Al.message)
      }, !Ui))
        return qs(Al.message), jo;
    } else if (isObject(oo)) {
      let Cl = {};
      for (const Al in oo) {
        if (!isEmptyObject(Cl) && !Ui)
          break;
        const Ol = getValidateError(await oo[Al](Rs, e), js, Al);
        Ol && (Cl = {
          ...Ol,
          ...Zs(Al, Ol.message)
        }, qs(Ol.message), Ui && (jo[no] = Cl));
      }
      if (!isEmptyObject(Cl) && (jo[no] = {
        ref: js,
        ...Cl
      }, !Ui))
        return jo;
    }
  }
  return qs(!0), jo;
};
function baseGet(Bi, e) {
  const Ui = e.slice(0, -1).length;
  let Zi = 0;
  for (; Zi < Ui; )
    Bi = isUndefined(Bi) ? Zi++ : Bi[e[Zi++]];
  return Bi;
}
function isEmptyArray(Bi) {
  for (const e in Bi)
    if (Bi.hasOwnProperty(e) && !isUndefined(Bi[e]))
      return !1;
  return !0;
}
function unset(Bi, e) {
  const Ui = Array.isArray(e) ? e : isKey(e) ? [e] : stringToPath(e), Zi = Ui.length === 1 ? Bi : baseGet(Bi, Ui), ta = Ui.length - 1, na = Ui[ta];
  return Zi && delete Zi[na], ta !== 0 && (isObject(Zi) && isEmptyObject(Zi) || Array.isArray(Zi) && isEmptyArray(Zi)) && unset(Bi, Ui.slice(0, -1)), Bi;
}
function createSubject() {
  let Bi = [];
  return {
    get observers() {
      return Bi;
    },
    next: (ta) => {
      for (const na of Bi)
        na.next && na.next(ta);
    },
    subscribe: (ta) => (Bi.push(ta), {
      unsubscribe: () => {
        Bi = Bi.filter((na) => na !== ta);
      }
    }),
    unsubscribe: () => {
      Bi = [];
    }
  };
}
var isPrimitive = (Bi) => isNullOrUndefined(Bi) || !isObjectType(Bi);
function deepEqual(Bi, e) {
  if (isPrimitive(Bi) || isPrimitive(e))
    return Bi === e;
  if (isDateObject(Bi) && isDateObject(e))
    return Bi.getTime() === e.getTime();
  const Ui = Object.keys(Bi), Zi = Object.keys(e);
  if (Ui.length !== Zi.length)
    return !1;
  for (const ta of Ui) {
    const na = Bi[ta];
    if (!Zi.includes(ta))
      return !1;
    if (ta !== "ref") {
      const ia = e[ta];
      if (isDateObject(na) && isDateObject(ia) || isObject(na) && isObject(ia) || Array.isArray(na) && Array.isArray(ia) ? !deepEqual(na, ia) : na !== ia)
        return !1;
    }
  }
  return !0;
}
var isMultipleSelect = (Bi) => Bi.type === "select-multiple", isRadioOrCheckbox = (Bi) => isRadioInput(Bi) || isCheckBoxInput(Bi), live = (Bi) => isHTMLElement(Bi) && Bi.isConnected, objectHasFunction = (Bi) => {
  for (const e in Bi)
    if (isFunction(Bi[e]))
      return !0;
  return !1;
};
function markFieldsDirty(Bi, e = {}) {
  const Ui = Array.isArray(Bi);
  if (isObject(Bi) || Ui)
    for (const Zi in Bi)
      Array.isArray(Bi[Zi]) || isObject(Bi[Zi]) && !objectHasFunction(Bi[Zi]) ? (e[Zi] = Array.isArray(Bi[Zi]) ? [] : {}, markFieldsDirty(Bi[Zi], e[Zi])) : isNullOrUndefined(Bi[Zi]) || (e[Zi] = !0);
  return e;
}
function getDirtyFieldsFromDefaultValues(Bi, e, Ui) {
  const Zi = Array.isArray(Bi);
  if (isObject(Bi) || Zi)
    for (const ta in Bi)
      Array.isArray(Bi[ta]) || isObject(Bi[ta]) && !objectHasFunction(Bi[ta]) ? isUndefined(e) || isPrimitive(Ui[ta]) ? Ui[ta] = Array.isArray(Bi[ta]) ? markFieldsDirty(Bi[ta], []) : { ...markFieldsDirty(Bi[ta]) } : getDirtyFieldsFromDefaultValues(Bi[ta], isNullOrUndefined(e) ? {} : e[ta], Ui[ta]) : Ui[ta] = !deepEqual(Bi[ta], e[ta]);
  return Ui;
}
var getDirtyFields = (Bi, e) => getDirtyFieldsFromDefaultValues(Bi, e, markFieldsDirty(e)), getFieldValueAs = (Bi, { valueAsNumber: e, valueAsDate: Ui, setValueAs: Zi }) => isUndefined(Bi) ? Bi : e ? Bi === "" ? NaN : Bi && +Bi : Ui && isString(Bi) ? new Date(Bi) : Zi ? Zi(Bi) : Bi;
function getFieldValue(Bi) {
  const e = Bi.ref;
  if (!(Bi.refs ? Bi.refs.every((Ui) => Ui.disabled) : e.disabled))
    return isFileInput(e) ? e.files : isRadioInput(e) ? getRadioValue(Bi.refs).value : isMultipleSelect(e) ? [...e.selectedOptions].map(({ value: Ui }) => Ui) : isCheckBoxInput(e) ? getCheckboxValue(Bi.refs).value : getFieldValueAs(isUndefined(e.value) ? Bi.ref.value : e.value, Bi);
}
var getResolverOptions = (Bi, e, Ui, Zi) => {
  const ta = {};
  for (const na of Bi) {
    const ia = get(e, na);
    ia && set(ta, na, ia._f);
  }
  return {
    criteriaMode: Ui,
    names: [...Bi],
    fields: ta,
    shouldUseNativeValidation: Zi
  };
}, getRuleValue = (Bi) => isUndefined(Bi) ? Bi : isRegex(Bi) ? Bi.source : isObject(Bi) ? isRegex(Bi.value) ? Bi.value.source : Bi.value : Bi, hasValidation = (Bi) => Bi.mount && (Bi.required || Bi.min || Bi.max || Bi.maxLength || Bi.minLength || Bi.pattern || Bi.validate);
function schemaErrorLookup(Bi, e, Ui) {
  const Zi = get(Bi, Ui);
  if (Zi || isKey(Ui))
    return {
      error: Zi,
      name: Ui
    };
  const ta = Ui.split(".");
  for (; ta.length; ) {
    const na = ta.join("."), ia = get(e, na), aa = get(Bi, na);
    if (ia && !Array.isArray(ia) && Ui !== na)
      return { name: Ui };
    if (aa && aa.type)
      return {
        name: na,
        error: aa
      };
    ta.pop();
  }
  return {
    name: Ui
  };
}
var skipValidation = (Bi, e, Ui, Zi, ta) => ta.isOnAll ? !1 : !Ui && ta.isOnTouch ? !(e || Bi) : (Ui ? Zi.isOnBlur : ta.isOnBlur) ? !Bi : (Ui ? Zi.isOnChange : ta.isOnChange) ? Bi : !0, unsetEmptyArray = (Bi, e) => !compact(get(Bi, e)).length && unset(Bi, e);
const defaultOptions$1 = {
  mode: VALIDATION_MODE.onSubmit,
  reValidateMode: VALIDATION_MODE.onChange,
  shouldFocusError: !0
};
function createFormControl(Bi = {}, e) {
  let Ui = {
    ...defaultOptions$1,
    ...Bi
  }, Zi = {
    submitCount: 0,
    isDirty: !1,
    isLoading: isFunction(Ui.defaultValues),
    isValidating: !1,
    isSubmitted: !1,
    isSubmitting: !1,
    isSubmitSuccessful: !1,
    isValid: !1,
    touchedFields: {},
    dirtyFields: {},
    errors: {}
  }, ta = {}, na = isObject(Ui.defaultValues) || isObject(Ui.values) ? cloneObject(Ui.defaultValues || Ui.values) || {} : {}, ia = Ui.shouldUnregister ? {} : cloneObject(na), aa = {
    action: !1,
    mount: !1,
    watch: !1
  }, da = {
    mount: /* @__PURE__ */ new Set(),
    unMount: /* @__PURE__ */ new Set(),
    array: /* @__PURE__ */ new Set(),
    watch: /* @__PURE__ */ new Set()
  }, La, qa = 0;
  const io = {
    isDirty: !1,
    dirtyFields: !1,
    touchedFields: !1,
    isValidating: !1,
    isValid: !1,
    errors: !1
  }, ao = {
    values: createSubject(),
    array: createSubject(),
    state: createSubject()
  }, oo = Bi.resetOptions && Bi.resetOptions.keepDirtyValues, no = getValidationModes(Ui.mode), lo = getValidationModes(Ui.reValidateMode), so = Ui.criteriaMode === VALIDATION_MODE.all, bs = ($l) => (kl) => {
    clearTimeout(qa), qa = setTimeout($l, kl);
  }, Rs = async ($l) => {
    if (io.isValid || $l) {
      const kl = Ui.resolver ? isEmptyObject((await Co()).errors) : await xl(ta, !0);
      kl !== Zi.isValid && ao.state.next({
        isValid: kl
      });
    }
  }, js = ($l) => io.isValidating && ao.state.next({
    isValidating: $l
  }), qs = ($l, kl = [], zl, Hl, Wl = !0, ql = !0) => {
    if (Hl && zl) {
      if (aa.action = !0, ql && Array.isArray(get(ta, $l))) {
        const Jl = zl(get(ta, $l), Hl.argA, Hl.argB);
        Wl && set(ta, $l, Jl);
      }
      if (ql && Array.isArray(get(Zi.errors, $l))) {
        const Jl = zl(get(Zi.errors, $l), Hl.argA, Hl.argB);
        Wl && set(Zi.errors, $l, Jl), unsetEmptyArray(Zi.errors, $l);
      }
      if (io.touchedFields && ql && Array.isArray(get(Zi.touchedFields, $l))) {
        const Jl = zl(get(Zi.touchedFields, $l), Hl.argA, Hl.argB);
        Wl && set(Zi.touchedFields, $l, Jl);
      }
      io.dirtyFields && (Zi.dirtyFields = getDirtyFields(na, ia)), ao.state.next({
        name: $l,
        isDirty: Al($l, kl),
        dirtyFields: Zi.dirtyFields,
        errors: Zi.errors,
        isValid: Zi.isValid
      });
    } else
      set(ia, $l, kl);
  }, jo = ($l, kl) => {
    set(Zi.errors, $l, kl), ao.state.next({
      errors: Zi.errors
    });
  }, fs = ($l, kl, zl, Hl) => {
    const Wl = get(ta, $l);
    if (Wl) {
      const ql = get(ia, $l, isUndefined(zl) ? get(na, $l) : zl);
      isUndefined(ql) || Hl && Hl.defaultChecked || kl ? set(ia, $l, kl ? ql : getFieldValue(Wl._f)) : Ml($l, ql), aa.mount && Rs();
    }
  }, Ao = ($l, kl, zl, Hl, Wl) => {
    let ql = !1, Jl = !1;
    const ac = {
      name: $l
    };
    if (!zl || Hl) {
      io.isDirty && (Jl = Zi.isDirty, Zi.isDirty = ac.isDirty = Al(), ql = Jl !== ac.isDirty);
      const Xl = deepEqual(get(na, $l), kl);
      Jl = get(Zi.dirtyFields, $l), Xl ? unset(Zi.dirtyFields, $l) : set(Zi.dirtyFields, $l, !0), ac.dirtyFields = Zi.dirtyFields, ql = ql || io.dirtyFields && Jl !== !Xl;
    }
    if (zl) {
      const Xl = get(Zi.touchedFields, $l);
      Xl || (set(Zi.touchedFields, $l, zl), ac.touchedFields = Zi.touchedFields, ql = ql || io.touchedFields && Xl !== zl);
    }
    return ql && Wl && ao.state.next(ac), ql ? ac : {};
  }, co = ($l, kl, zl, Hl) => {
    const Wl = get(Zi.errors, $l), ql = io.isValid && isBoolean$1(kl) && Zi.isValid !== kl;
    if (Bi.delayError && zl ? (La = bs(() => jo($l, zl)), La(Bi.delayError)) : (clearTimeout(qa), La = null, zl ? set(Zi.errors, $l, zl) : unset(Zi.errors, $l)), (zl ? !deepEqual(Wl, zl) : Wl) || !isEmptyObject(Hl) || ql) {
      const Jl = {
        ...Hl,
        ...ql && isBoolean$1(kl) ? { isValid: kl } : {},
        errors: Zi.errors,
        name: $l
      };
      Zi = {
        ...Zi,
        ...Jl
      }, ao.state.next(Jl);
    }
    js(!1);
  }, Co = async ($l) => Ui.resolver(ia, Ui.context, getResolverOptions($l || da.mount, ta, Ui.criteriaMode, Ui.shouldUseNativeValidation)), Zs = async ($l) => {
    const { errors: kl } = await Co();
    if ($l)
      for (const zl of $l) {
        const Hl = get(kl, zl);
        Hl ? set(Zi.errors, zl, Hl) : unset(Zi.errors, zl);
      }
    else
      Zi.errors = kl;
    return kl;
  }, xl = async ($l, kl, zl = {
    valid: !0
  }) => {
    for (const Hl in $l) {
      const Wl = $l[Hl];
      if (Wl) {
        const { _f: ql, ...Jl } = Wl;
        if (ql) {
          const ac = da.array.has(ql.name), Xl = await validateField(Wl, ia, so, Ui.shouldUseNativeValidation && !kl, ac);
          if (Xl[ql.name] && (zl.valid = !1, kl))
            break;
          !kl && (get(Xl, ql.name) ? ac ? updateFieldArrayRootError(Zi.errors, Xl, ql.name) : set(Zi.errors, ql.name, Xl[ql.name]) : unset(Zi.errors, ql.name));
        }
        Jl && await xl(Jl, kl, zl);
      }
    }
    return zl.valid;
  }, Cl = () => {
    for (const $l of da.unMount) {
      const kl = get(ta, $l);
      kl && (kl._f.refs ? kl._f.refs.every((zl) => !live(zl)) : !live(kl._f.ref)) && Ul($l);
    }
    da.unMount = /* @__PURE__ */ new Set();
  }, Al = ($l, kl) => ($l && kl && set(ia, $l, kl), !deepEqual(tc(), na)), Ol = ($l, kl, zl) => generateWatchOutput($l, da, {
    ...aa.mount ? ia : isUndefined(kl) ? na : isString($l) ? { [$l]: kl } : kl
  }, zl, kl), Bl = ($l) => compact(get(aa.mount ? ia : na, $l, Bi.shouldUnregister ? get(na, $l, []) : [])), Ml = ($l, kl, zl = {}) => {
    const Hl = get(ta, $l);
    let Wl = kl;
    if (Hl) {
      const ql = Hl._f;
      ql && (!ql.disabled && set(ia, $l, getFieldValueAs(kl, ql)), Wl = isHTMLElement(ql.ref) && isNullOrUndefined(kl) ? "" : kl, isMultipleSelect(ql.ref) ? [...ql.ref.options].forEach((Jl) => Jl.selected = Wl.includes(Jl.value)) : ql.refs ? isCheckBoxInput(ql.ref) ? ql.refs.length > 1 ? ql.refs.forEach((Jl) => (!Jl.defaultChecked || !Jl.disabled) && (Jl.checked = Array.isArray(Wl) ? !!Wl.find((ac) => ac === Jl.value) : Wl === Jl.value)) : ql.refs[0] && (ql.refs[0].checked = !!Wl) : ql.refs.forEach((Jl) => Jl.checked = Jl.value === Wl) : isFileInput(ql.ref) ? ql.ref.value = "" : (ql.ref.value = Wl, ql.ref.type || ao.values.next({
        name: $l,
        values: { ...ia }
      })));
    }
    (zl.shouldDirty || zl.shouldTouch) && Ao($l, Wl, zl.shouldTouch, zl.shouldDirty, !0), zl.shouldValidate && Zl($l);
  }, Vl = ($l, kl, zl) => {
    for (const Hl in kl) {
      const Wl = kl[Hl], ql = `${$l}.${Hl}`, Jl = get(ta, ql);
      (da.array.has($l) || !isPrimitive(Wl) || Jl && !Jl._f) && !isDateObject(Wl) ? Vl(ql, Wl, zl) : Ml(ql, Wl, zl);
    }
  }, Ll = ($l, kl, zl = {}) => {
    const Hl = get(ta, $l), Wl = da.array.has($l), ql = cloneObject(kl);
    set(ia, $l, ql), Wl ? (ao.array.next({
      name: $l,
      values: { ...ia }
    }), (io.isDirty || io.dirtyFields) && zl.shouldDirty && ao.state.next({
      name: $l,
      dirtyFields: getDirtyFields(na, ia),
      isDirty: Al($l, ql)
    })) : Hl && !Hl._f && !isNullOrUndefined(ql) ? Vl($l, ql, zl) : Ml($l, ql, zl), isWatched($l, da) && ao.state.next({ ...Zi }), ao.values.next({
      name: $l,
      values: { ...ia }
    }), !aa.mount && e();
  }, Yl = async ($l) => {
    const kl = $l.target;
    let zl = kl.name, Hl = !0;
    const Wl = get(ta, zl), ql = () => kl.type ? getFieldValue(Wl._f) : getEventValue($l);
    if (Wl) {
      let Jl, ac;
      const Xl = ql(), sc = $l.type === EVENTS.BLUR || $l.type === EVENTS.FOCUS_OUT, Hu = !hasValidation(Wl._f) && !Ui.resolver && !get(Zi.errors, zl) && !Wl._f.deps || skipValidation(sc, get(Zi.touchedFields, zl), Zi.isSubmitted, lo, no), dc = isWatched(zl, da, sc);
      set(ia, zl, Xl), sc ? (Wl._f.onBlur && Wl._f.onBlur($l), La && La(0)) : Wl._f.onChange && Wl._f.onChange($l);
      const td = Ao(zl, Xl, sc, !1), ad = !isEmptyObject(td) || dc;
      if (!sc && ao.values.next({
        name: zl,
        type: $l.type,
        values: { ...ia }
      }), Hu)
        return io.isValid && Rs(), ad && ao.state.next({ name: zl, ...dc ? {} : td });
      if (!sc && dc && ao.state.next({ ...Zi }), js(!0), Ui.resolver) {
        const { errors: od } = await Co([zl]), sd = schemaErrorLookup(Zi.errors, ta, zl), dd = schemaErrorLookup(od, ta, sd.name || zl);
        Jl = dd.error, zl = dd.name, ac = isEmptyObject(od);
      } else
        Jl = (await validateField(Wl, ia, so, Ui.shouldUseNativeValidation))[zl], Hl = isNaN(Xl) || Xl === get(ia, zl, Xl), Hl && (Jl ? ac = !1 : io.isValid && (ac = await xl(ta, !0)));
      Hl && (Wl._f.deps && Zl(Wl._f.deps), co(zl, ac, Jl, td));
    }
  }, Zl = async ($l, kl = {}) => {
    let zl, Hl;
    const Wl = convertToArrayPayload($l);
    if (js(!0), Ui.resolver) {
      const ql = await Zs(isUndefined($l) ? $l : Wl);
      zl = isEmptyObject(ql), Hl = $l ? !Wl.some((Jl) => get(ql, Jl)) : zl;
    } else $l ? (Hl = (await Promise.all(Wl.map(async (ql) => {
      const Jl = get(ta, ql);
      return await xl(Jl && Jl._f ? { [ql]: Jl } : Jl);
    }))).every(Boolean), !(!Hl && !Zi.isValid) && Rs()) : Hl = zl = await xl(ta);
    return ao.state.next({
      ...!isString($l) || io.isValid && zl !== Zi.isValid ? {} : { name: $l },
      ...Ui.resolver || !$l ? { isValid: zl } : {},
      errors: Zi.errors,
      isValidating: !1
    }), kl.shouldFocus && !Hl && focusFieldBy(ta, (ql) => ql && get(Zi.errors, ql), $l ? Wl : da.mount), Hl;
  }, tc = ($l) => {
    const kl = {
      ...na,
      ...aa.mount ? ia : {}
    };
    return isUndefined($l) ? kl : isString($l) ? get(kl, $l) : $l.map((zl) => get(kl, zl));
  }, Nl = ($l, kl) => ({
    invalid: !!get((kl || Zi).errors, $l),
    isDirty: !!get((kl || Zi).dirtyFields, $l),
    isTouched: !!get((kl || Zi).touchedFields, $l),
    error: get((kl || Zi).errors, $l)
  }), Tl = ($l) => {
    $l && convertToArrayPayload($l).forEach((kl) => unset(Zi.errors, kl)), ao.state.next({
      errors: $l ? Zi.errors : {}
    });
  }, El = ($l, kl, zl) => {
    const Hl = (get(ta, $l, { _f: {} })._f || {}).ref;
    set(Zi.errors, $l, {
      ...kl,
      ref: Hl
    }), ao.state.next({
      name: $l,
      errors: Zi.errors,
      isValid: !1
    }), zl && zl.shouldFocus && Hl && Hl.focus && Hl.focus();
  }, Il = ($l, kl) => isFunction($l) ? ao.values.subscribe({
    next: (zl) => $l(Ol(void 0, kl), zl)
  }) : Ol($l, kl, !0), Ul = ($l, kl = {}) => {
    for (const zl of $l ? convertToArrayPayload($l) : da.mount)
      da.mount.delete(zl), da.array.delete(zl), kl.keepValue || (unset(ta, zl), unset(ia, zl)), !kl.keepError && unset(Zi.errors, zl), !kl.keepDirty && unset(Zi.dirtyFields, zl), !kl.keepTouched && unset(Zi.touchedFields, zl), !Ui.shouldUnregister && !kl.keepDefaultValue && unset(na, zl);
    ao.values.next({
      values: { ...ia }
    }), ao.state.next({
      ...Zi,
      ...kl.keepDirty ? { isDirty: Al() } : {}
    }), !kl.keepIsValid && Rs();
  }, Kl = ($l, kl = {}) => {
    let zl = get(ta, $l);
    const Hl = isBoolean$1(kl.disabled);
    return set(ta, $l, {
      ...zl || {},
      _f: {
        ...zl && zl._f ? zl._f : { ref: { name: $l } },
        name: $l,
        mount: !0,
        ...kl
      }
    }), da.mount.add($l), zl ? Hl && set(ia, $l, kl.disabled ? void 0 : get(ia, $l, getFieldValue(zl._f))) : fs($l, !0, kl.value), {
      ...Hl ? { disabled: kl.disabled } : {},
      ...Ui.progressive ? {
        required: !!kl.required,
        min: getRuleValue(kl.min),
        max: getRuleValue(kl.max),
        minLength: getRuleValue(kl.minLength),
        maxLength: getRuleValue(kl.maxLength),
        pattern: getRuleValue(kl.pattern)
      } : {},
      name: $l,
      onChange: Yl,
      onBlur: Yl,
      ref: (Wl) => {
        if (Wl) {
          Kl($l, kl), zl = get(ta, $l);
          const ql = isUndefined(Wl.value) && Wl.querySelectorAll && Wl.querySelectorAll("input,select,textarea")[0] || Wl, Jl = isRadioOrCheckbox(ql), ac = zl._f.refs || [];
          if (Jl ? ac.find((Xl) => Xl === ql) : ql === zl._f.ref)
            return;
          set(ta, $l, {
            _f: {
              ...zl._f,
              ...Jl ? {
                refs: [
                  ...ac.filter(live),
                  ql,
                  ...Array.isArray(get(na, $l)) ? [{}] : []
                ],
                ref: { type: ql.type, name: $l }
              } : { ref: ql }
            }
          }), fs($l, !1, void 0, ql);
        } else
          zl = get(ta, $l, {}), zl._f && (zl._f.mount = !1), (Ui.shouldUnregister || kl.shouldUnregister) && !(isNameInFieldArray(da.array, $l) && aa.action) && da.unMount.add($l);
      }
    };
  }, Rl = () => Ui.shouldFocusError && focusFieldBy(ta, ($l) => $l && get(Zi.errors, $l), da.mount), uo = ($l, kl) => async (zl) => {
    zl && (zl.preventDefault && zl.preventDefault(), zl.persist && zl.persist());
    let Hl = cloneObject(ia);
    if (ao.state.next({
      isSubmitting: !0
    }), Ui.resolver) {
      const { errors: Wl, values: ql } = await Co();
      Zi.errors = Wl, Hl = ql;
    } else
      await xl(ta);
    unset(Zi.errors, "root"), isEmptyObject(Zi.errors) ? (ao.state.next({
      errors: {}
    }), await $l(Hl, zl)) : (kl && await kl({ ...Zi.errors }, zl), Rl(), setTimeout(Rl)), ao.state.next({
      isSubmitted: !0,
      isSubmitting: !1,
      isSubmitSuccessful: isEmptyObject(Zi.errors),
      submitCount: Zi.submitCount + 1,
      errors: Zi.errors
    });
  }, Is = ($l, kl = {}) => {
    get(ta, $l) && (isUndefined(kl.defaultValue) ? Ll($l, get(na, $l)) : (Ll($l, kl.defaultValue), set(na, $l, kl.defaultValue)), kl.keepTouched || unset(Zi.touchedFields, $l), kl.keepDirty || (unset(Zi.dirtyFields, $l), Zi.isDirty = kl.defaultValue ? Al($l, get(na, $l)) : Al()), kl.keepError || (unset(Zi.errors, $l), io.isValid && Rs()), ao.state.next({ ...Zi }));
  }, Sl = ($l, kl = {}) => {
    const zl = $l || na, Hl = cloneObject(zl), Wl = $l && !isEmptyObject($l) ? Hl : na;
    if (kl.keepDefaultValues || (na = zl), !kl.keepValues) {
      if (kl.keepDirtyValues || oo)
        for (const ql of da.mount)
          get(Zi.dirtyFields, ql) ? set(Wl, ql, get(ia, ql)) : Ll(ql, get(Wl, ql));
      else {
        if (isWeb && isUndefined($l))
          for (const ql of da.mount) {
            const Jl = get(ta, ql);
            if (Jl && Jl._f) {
              const ac = Array.isArray(Jl._f.refs) ? Jl._f.refs[0] : Jl._f.ref;
              if (isHTMLElement(ac)) {
                const Xl = ac.closest("form");
                if (Xl) {
                  Xl.reset();
                  break;
                }
              }
            }
          }
        ta = {};
      }
      ia = Bi.shouldUnregister ? kl.keepDefaultValues ? cloneObject(na) : {} : cloneObject(Wl), ao.array.next({
        values: { ...Wl }
      }), ao.values.next({
        values: { ...Wl }
      });
    }
    da = {
      mount: /* @__PURE__ */ new Set(),
      unMount: /* @__PURE__ */ new Set(),
      array: /* @__PURE__ */ new Set(),
      watch: /* @__PURE__ */ new Set(),
      watchAll: !1,
      focus: ""
    }, !aa.mount && e(), aa.mount = !io.isValid || !!kl.keepIsValid, aa.watch = !!Bi.shouldUnregister, ao.state.next({
      submitCount: kl.keepSubmitCount ? Zi.submitCount : 0,
      isDirty: kl.keepDirty ? Zi.isDirty : !!(kl.keepDefaultValues && !deepEqual($l, na)),
      isSubmitted: kl.keepIsSubmitted ? Zi.isSubmitted : !1,
      dirtyFields: kl.keepDirtyValues ? Zi.dirtyFields : kl.keepDefaultValues && $l ? getDirtyFields(na, $l) : {},
      touchedFields: kl.keepTouched ? Zi.touchedFields : {},
      errors: kl.keepErrors ? Zi.errors : {},
      isSubmitting: !1,
      isSubmitSuccessful: !1
    });
  }, wl = ($l, kl) => Sl(isFunction($l) ? $l(ia) : $l, kl);
  return {
    control: {
      register: Kl,
      unregister: Ul,
      getFieldState: Nl,
      handleSubmit: uo,
      setError: El,
      _executeSchema: Co,
      _getWatch: Ol,
      _getDirty: Al,
      _updateValid: Rs,
      _removeUnmounted: Cl,
      _updateFieldArray: qs,
      _getFieldArray: Bl,
      _reset: Sl,
      _resetDefaultValues: () => isFunction(Ui.defaultValues) && Ui.defaultValues().then(($l) => {
        wl($l, Ui.resetOptions), ao.state.next({
          isLoading: !1
        });
      }),
      _updateFormState: ($l) => {
        Zi = {
          ...Zi,
          ...$l
        };
      },
      _subjects: ao,
      _proxyFormState: io,
      get _fields() {
        return ta;
      },
      get _formValues() {
        return ia;
      },
      get _state() {
        return aa;
      },
      set _state($l) {
        aa = $l;
      },
      get _defaultValues() {
        return na;
      },
      get _names() {
        return da;
      },
      set _names($l) {
        da = $l;
      },
      get _formState() {
        return Zi;
      },
      set _formState($l) {
        Zi = $l;
      },
      get _options() {
        return Ui;
      },
      set _options($l) {
        Ui = {
          ...Ui,
          ...$l
        };
      }
    },
    trigger: Zl,
    register: Kl,
    handleSubmit: uo,
    watch: Il,
    setValue: Ll,
    getValues: tc,
    reset: wl,
    resetField: Is,
    clearErrors: Tl,
    unregister: Ul,
    setError: El,
    setFocus: ($l, kl = {}) => {
      const zl = get(ta, $l), Hl = zl && zl._f;
      if (Hl) {
        const Wl = Hl.refs ? Hl.refs[0] : Hl.ref;
        Wl.focus && (Wl.focus(), kl.shouldSelect && Wl.select());
      }
    },
    getFieldState: Nl
  };
}
function useForm(Bi = {}) {
  const e = a__default.useRef(), Ui = a__default.useRef(), [Zi, ta] = a__default.useState({
    isDirty: !1,
    isValidating: !1,
    isLoading: isFunction(Bi.defaultValues),
    isSubmitted: !1,
    isSubmitting: !1,
    isSubmitSuccessful: !1,
    isValid: !1,
    submitCount: 0,
    dirtyFields: {},
    touchedFields: {},
    errors: {},
    defaultValues: isFunction(Bi.defaultValues) ? void 0 : Bi.defaultValues
  });
  e.current || (e.current = {
    ...createFormControl(Bi, () => ta((ia) => ({ ...ia }))),
    formState: Zi
  });
  const na = e.current.control;
  return na._options = Bi, useSubscribe({
    subject: na._subjects.state,
    next: (ia) => {
      shouldRenderFormState(ia, na._proxyFormState, na._updateFormState) && ta({ ...na._formState });
    }
  }), a__default.useEffect(() => {
    Bi.values && !deepEqual(Bi.values, Ui.current) ? (na._reset(Bi.values, na._options.resetOptions), Ui.current = Bi.values) : na._resetDefaultValues();
  }, [Bi.values, na]), a__default.useEffect(() => {
    na._state.mount || (na._updateValid(), na._state.mount = !0), na._state.watch && (na._state.watch = !1, na._subjects.state.next({ ...na._formState })), na._removeUnmounted();
  }), e.current.formState = getProxyFormState(Zi, na), e.current;
}
const Input = forwardRef(
  ({ className: Bi, ...e }, Ui) => /* @__PURE__ */ jsxRuntimeExports.jsx(
    "input",
    {
      ref: Ui,
      ...e,
      className: twMerge(
        "dark:bg-neutral-800 dark:text-neutral-200 bg-white text-black px-2 border-black border font-body",
        Bi
      )
    }
  )
), vi$1 = (Bi, e) => {
  const Ui = (Zi) => {
    Bi.current && !Bi.current.contains(Zi.target) && e();
  };
  useEffect(() => (document.addEventListener("click", Ui), () => {
    document.removeEventListener("click", Ui);
  }));
};
function li$1(Bi, e, Ui = 250) {
  const [Zi, ta] = useState(0);
  return useEffect(() => {
    const na = setTimeout(() => {
      ta(0);
    }, Ui);
    return Zi === 2 && e(), () => clearTimeout(na);
  }, [Zi]), () => ta((na) => na + 1);
}
var Bt$1 = "delete", m$4 = 5, B$1 = 1 << m$4, b$1 = B$1 - 1, y$2 = {};
function pr$1() {
  return { value: !1 };
}
function U(Bi) {
  Bi && (Bi.value = !0);
}
function Er$1() {
}
function ct$1(Bi) {
  return Bi.size === void 0 && (Bi.size = Bi.__iterate(Ee$1)), Bi.size;
}
function rt$1(Bi, e) {
  if (typeof e != "number") {
    var Ui = e >>> 0;
    if ("" + Ui !== e || Ui === 4294967295)
      return NaN;
    e = Ui;
  }
  return e < 0 ? ct$1(Bi) + e : e;
}
function Ee$1() {
  return !0;
}
function tr$1(Bi, e, Ui) {
  return (Bi === 0 && !ze$1(Bi) || Ui !== void 0 && Bi <= -Ui) && (e === void 0 || Ui !== void 0 && e >= Ui);
}
function Ut$1(Bi, e) {
  return Oe$1(Bi, e, 0);
}
function rr(Bi, e) {
  return Oe$1(Bi, e, e);
}
function Oe$1(Bi, e, Ui) {
  return Bi === void 0 ? Ui : ze$1(Bi) ? e === 1 / 0 ? e : Math.max(0, e + Bi) | 0 : e === void 0 || e === Bi ? Bi : Math.min(e, Bi) | 0;
}
function ze$1(Bi) {
  return Bi < 0 || Bi === 0 && 1 / Bi === -1 / 0;
}
var Ie$1 = "@@__IMMUTABLE_ITERABLE__@@";
function L$1(Bi) {
  return !!(Bi && Bi[Ie$1]);
}
var Me$1 = "@@__IMMUTABLE_KEYED__@@";
function O$1(Bi) {
  return !!(Bi && Bi[Me$1]);
}
var qe$1 = "@@__IMMUTABLE_INDEXED__@@";
function T$1(Bi) {
  return !!(Bi && Bi[qe$1]);
}
function er$1(Bi) {
  return O$1(Bi) || T$1(Bi);
}
var z = function(Bi) {
  return L$1(Bi) ? Bi : N(Bi);
}, K = /* @__PURE__ */ function(Bi) {
  function e(Ui) {
    return O$1(Ui) ? Ui : it$1(Ui);
  }
  return Bi && (e.__proto__ = Bi), e.prototype = Object.create(Bi && Bi.prototype), e.prototype.constructor = e, e;
}(z), at = /* @__PURE__ */ function(Bi) {
  function e(Ui) {
    return T$1(Ui) ? Ui : H$2(Ui);
  }
  return Bi && (e.__proto__ = Bi), e.prototype = Object.create(Bi && Bi.prototype), e.prototype.constructor = e, e;
}(z), gt$1 = /* @__PURE__ */ function(Bi) {
  function e(Ui) {
    return L$1(Ui) && !er$1(Ui) ? Ui : Et$1(Ui);
  }
  return Bi && (e.__proto__ = Bi), e.prototype = Object.create(Bi && Bi.prototype), e.prototype.constructor = e, e;
}(z);
z.Keyed = K;
z.Indexed = at;
z.Set = gt$1;
var Ae = "@@__IMMUTABLE_SEQ__@@";
function Or$1(Bi) {
  return !!(Bi && Bi[Ae]);
}
var be$1 = "@@__IMMUTABLE_RECORD__@@";
function St$1(Bi) {
  return !!(Bi && Bi[be$1]);
}
function Z$1(Bi) {
  return L$1(Bi) || St$1(Bi);
}
var mt$1 = "@@__IMMUTABLE_ORDERED__@@";
function W$1(Bi) {
  return !!(Bi && Bi[mt$1]);
}
var Pt$1 = 0, Y$1 = 1, C$1 = 2, vr$1 = typeof Symbol == "function" && Symbol.iterator, Re$1 = "@@iterator", nr$1 = vr$1 || Re$1, l$6 = function(Bi) {
  this.next = Bi;
};
l$6.prototype.toString = function() {
  return "[Iterator]";
};
l$6.KEYS = Pt$1;
l$6.VALUES = Y$1;
l$6.ENTRIES = C$1;
l$6.prototype.inspect = l$6.prototype.toSource = function() {
  return this.toString();
};
l$6.prototype[nr$1] = function() {
  return this;
};
function E$1(Bi, e, Ui, Zi) {
  var ta = Bi === 0 ? e : Bi === 1 ? Ui : [e, Ui];
  return Zi ? Zi.value = ta : Zi = {
    value: ta,
    done: !1
  }, Zi;
}
function j() {
  return { value: void 0, done: !0 };
}
function Te$1(Bi) {
  return Array.isArray(Bi) ? !0 : !!ir$1(Bi);
}
function Gr$1(Bi) {
  return Bi && typeof Bi.next == "function";
}
function dr$1(Bi) {
  var e = ir$1(Bi);
  return e && e.call(Bi);
}
function ir$1(Bi) {
  var e = Bi && (vr$1 && Bi[vr$1] || Bi[Re$1]);
  if (typeof e == "function")
    return e;
}
function gn$1(Bi) {
  var e = ir$1(Bi);
  return e && e === Bi.entries;
}
function Sn$1(Bi) {
  var e = ir$1(Bi);
  return e && e === Bi.keys;
}
var wt$1 = Object.prototype.hasOwnProperty;
function Le$1(Bi) {
  return Array.isArray(Bi) || typeof Bi == "string" ? !0 : Bi && typeof Bi == "object" && Number.isInteger(Bi.length) && Bi.length >= 0 && (Bi.length === 0 ? Object.keys(Bi).length === 1 : Bi.hasOwnProperty(Bi.length - 1));
}
var N = /* @__PURE__ */ function(Bi) {
  function e(Ui) {
    return Ui == null ? Ir() : Z$1(Ui) ? Ui.toSeq() : wn$1(Ui);
  }
  return Bi && (e.__proto__ = Bi), e.prototype = Object.create(Bi && Bi.prototype), e.prototype.constructor = e, e.prototype.toSeq = function() {
    return this;
  }, e.prototype.toString = function() {
    return this.__toString("Seq {", "}");
  }, e.prototype.cacheResult = function() {
    return !this._cache && this.__iterateUncached && (this._cache = this.entrySeq().toArray(), this.size = this._cache.length), this;
  }, e.prototype.__iterate = function(Ui, Zi) {
    var ta = this._cache;
    if (ta) {
      for (var na = ta.length, ia = 0; ia !== na; ) {
        var aa = ta[Zi ? na - ++ia : ia++];
        if (Ui(aa[1], aa[0], this) === !1)
          break;
      }
      return ia;
    }
    return this.__iterateUncached(Ui, Zi);
  }, e.prototype.__iterator = function(Ui, Zi) {
    var ta = this._cache;
    if (ta) {
      var na = ta.length, ia = 0;
      return new l$6(function() {
        if (ia === na)
          return j();
        var aa = ta[Zi ? na - ++ia : ia++];
        return E$1(Ui, aa[0], aa[1]);
      });
    }
    return this.__iteratorUncached(Ui, Zi);
  }, e;
}(z), it$1 = /* @__PURE__ */ function(Bi) {
  function e(Ui) {
    return Ui == null ? Ir().toKeyedSeq() : L$1(Ui) ? O$1(Ui) ? Ui.toSeq() : Ui.fromEntrySeq() : St$1(Ui) ? Ui.toSeq() : Mr$1(Ui);
  }
  return Bi && (e.__proto__ = Bi), e.prototype = Object.create(Bi && Bi.prototype), e.prototype.constructor = e, e.prototype.toKeyedSeq = function() {
    return this;
  }, e;
}(N), H$2 = /* @__PURE__ */ function(Bi) {
  function e(Ui) {
    return Ui == null ? Ir() : L$1(Ui) ? O$1(Ui) ? Ui.entrySeq() : Ui.toIndexedSeq() : St$1(Ui) ? Ui.toSeq().entrySeq() : je$1(Ui);
  }
  return Bi && (e.__proto__ = Bi), e.prototype = Object.create(Bi && Bi.prototype), e.prototype.constructor = e, e.of = function() {
    return e(arguments);
  }, e.prototype.toIndexedSeq = function() {
    return this;
  }, e.prototype.toString = function() {
    return this.__toString("Seq [", "]");
  }, e;
}(N), Et$1 = /* @__PURE__ */ function(Bi) {
  function e(Ui) {
    return (L$1(Ui) && !er$1(Ui) ? Ui : H$2(Ui)).toSetSeq();
  }
  return Bi && (e.__proto__ = Bi), e.prototype = Object.create(Bi && Bi.prototype), e.prototype.constructor = e, e.of = function() {
    return e(arguments);
  }, e.prototype.toSetSeq = function() {
    return this;
  }, e;
}(N);
N.isSeq = Or$1;
N.Keyed = it$1;
N.Set = Et$1;
N.Indexed = H$2;
N.prototype[Ae] = !0;
var st$1 = /* @__PURE__ */ function(Bi) {
  function e(Ui) {
    this._array = Ui, this.size = Ui.length;
  }
  return Bi && (e.__proto__ = Bi), e.prototype = Object.create(Bi && Bi.prototype), e.prototype.constructor = e, e.prototype.get = function(Ui, Zi) {
    return this.has(Ui) ? this._array[rt$1(this, Ui)] : Zi;
  }, e.prototype.__iterate = function(Ui, Zi) {
    for (var ta = this._array, na = ta.length, ia = 0; ia !== na; ) {
      var aa = Zi ? na - ++ia : ia++;
      if (Ui(ta[aa], aa, this) === !1)
        break;
    }
    return ia;
  }, e.prototype.__iterator = function(Ui, Zi) {
    var ta = this._array, na = ta.length, ia = 0;
    return new l$6(function() {
      if (ia === na)
        return j();
      var aa = Zi ? na - ++ia : ia++;
      return E$1(Ui, aa, ta[aa]);
    });
  }, e;
}(H$2), zr$1 = /* @__PURE__ */ function(Bi) {
  function e(Ui) {
    var Zi = Object.keys(Ui).concat(
      Object.getOwnPropertySymbols ? Object.getOwnPropertySymbols(Ui) : []
    );
    this._object = Ui, this._keys = Zi, this.size = Zi.length;
  }
  return Bi && (e.__proto__ = Bi), e.prototype = Object.create(Bi && Bi.prototype), e.prototype.constructor = e, e.prototype.get = function(Ui, Zi) {
    return Zi !== void 0 && !this.has(Ui) ? Zi : this._object[Ui];
  }, e.prototype.has = function(Ui) {
    return wt$1.call(this._object, Ui);
  }, e.prototype.__iterate = function(Ui, Zi) {
    for (var ta = this._object, na = this._keys, ia = na.length, aa = 0; aa !== ia; ) {
      var da = na[Zi ? ia - ++aa : aa++];
      if (Ui(ta[da], da, this) === !1)
        break;
    }
    return aa;
  }, e.prototype.__iterator = function(Ui, Zi) {
    var ta = this._object, na = this._keys, ia = na.length, aa = 0;
    return new l$6(function() {
      if (aa === ia)
        return j();
      var da = na[Zi ? ia - ++aa : aa++];
      return E$1(Ui, da, ta[da]);
    });
  }, e;
}(it$1);
zr$1.prototype[mt$1] = !0;
var mn$1 = /* @__PURE__ */ function(Bi) {
  function e(Ui) {
    this._collection = Ui, this.size = Ui.length || Ui.size;
  }
  return Bi && (e.__proto__ = Bi), e.prototype = Object.create(Bi && Bi.prototype), e.prototype.constructor = e, e.prototype.__iterateUncached = function(Ui, Zi) {
    if (Zi)
      return this.cacheResult().__iterate(Ui, Zi);
    var ta = this._collection, na = dr$1(ta), ia = 0;
    if (Gr$1(na))
      for (var aa; !(aa = na.next()).done && Ui(aa.value, ia++, this) !== !1; )
        ;
    return ia;
  }, e.prototype.__iteratorUncached = function(Ui, Zi) {
    if (Zi)
      return this.cacheResult().__iterator(Ui, Zi);
    var ta = this._collection, na = dr$1(ta);
    if (!Gr$1(na))
      return new l$6(j);
    var ia = 0;
    return new l$6(function() {
      var aa = na.next();
      return aa.done ? aa : E$1(Ui, ia++, aa.value);
    });
  }, e;
}(H$2), Qr$1;
function Ir() {
  return Qr$1 || (Qr$1 = new st$1([]));
}
function Mr$1(Bi) {
  var e = qr$1(Bi);
  if (e)
    return e.fromEntrySeq();
  if (typeof Bi == "object")
    return new zr$1(Bi);
  throw new TypeError(
    "Expected Array or collection object of [k, v] entries, or keyed object: " + Bi
  );
}
function je$1(Bi) {
  var e = qr$1(Bi);
  if (e)
    return e;
  throw new TypeError(
    "Expected Array or collection object of values: " + Bi
  );
}
function wn$1(Bi) {
  var e = qr$1(Bi);
  if (e)
    return gn$1(Bi) ? e.fromEntrySeq() : Sn$1(Bi) ? e.toSetSeq() : e;
  if (typeof Bi == "object")
    return new zr$1(Bi);
  throw new TypeError(
    "Expected Array or collection object of values, or keyed object: " + Bi
  );
}
function qr$1(Bi) {
  return Le$1(Bi) ? new st$1(Bi) : Te$1(Bi) ? new mn$1(Bi) : void 0;
}
var ke = "@@__IMMUTABLE_MAP__@@";
function Ar$1(Bi) {
  return !!(Bi && Bi[ke]);
}
function $e(Bi) {
  return Ar$1(Bi) && W$1(Bi);
}
function Vr(Bi) {
  return !!(Bi && typeof Bi.equals == "function" && typeof Bi.hashCode == "function");
}
function D(Bi, e) {
  if (Bi === e || Bi !== Bi && e !== e)
    return !0;
  if (!Bi || !e)
    return !1;
  if (typeof Bi.valueOf == "function" && typeof e.valueOf == "function") {
    if (Bi = Bi.valueOf(), e = e.valueOf(), Bi === e || Bi !== Bi && e !== e)
      return !0;
    if (!Bi || !e)
      return !1;
  }
  return !!(Vr(Bi) && Vr(e) && Bi.equals(e));
}
var Mt$1 = typeof Math.imul == "function" && Math.imul(4294967295, 2) === -2 ? Math.imul : function(Bi, e) {
  Bi |= 0, e |= 0;
  var Ui = Bi & 65535, Zi = e & 65535;
  return Ui * Zi + ((Bi >>> 16) * Zi + Ui * (e >>> 16) << 16 >>> 0) | 0;
};
function ur$1(Bi) {
  return Bi >>> 1 & 1073741824 | Bi & 3221225471;
}
var En$1 = Object.prototype.valueOf;
function $(Bi) {
  if (Bi == null)
    return xr(Bi);
  if (typeof Bi.hashCode == "function")
    return ur$1(Bi.hashCode(Bi));
  var e = An$1(Bi);
  if (e == null)
    return xr(e);
  switch (typeof e) {
    case "boolean":
      return e ? 1108378657 : 1108378656;
    case "number":
      return On(e);
    case "string":
      return e.length > bn$1 ? zn$1(e) : yr$1(e);
    case "object":
    case "function":
      return Mn$1(e);
    case "symbol":
      return In$1(e);
    default:
      if (typeof e.toString == "function")
        return yr$1(e.toString());
      throw new Error("Value type " + typeof e + " cannot be hashed.");
  }
}
function xr(Bi) {
  return Bi === null ? 1108378658 : 1108378659;
}
function On(Bi) {
  if (Bi !== Bi || Bi === 1 / 0)
    return 0;
  var e = Bi | 0;
  for (e !== Bi && (e ^= Bi * 4294967295); Bi > 4294967295; )
    Bi /= 4294967295, e ^= Bi;
  return ur$1(e);
}
function zn$1(Bi) {
  var e = hr$1[Bi];
  return e === void 0 && (e = yr$1(Bi), fr$1 === Rn$1 && (fr$1 = 0, hr$1 = {}), fr$1++, hr$1[Bi] = e), e;
}
function yr$1(Bi) {
  for (var e = 0, Ui = 0; Ui < Bi.length; Ui++)
    e = 31 * e + Bi.charCodeAt(Ui) | 0;
  return ur$1(e);
}
function In$1(Bi) {
  var e = ee$1[Bi];
  return e !== void 0 || (e = De(), ee$1[Bi] = e), e;
}
function Mn$1(Bi) {
  var e;
  if (lr$1 && (e = gr$1.get(Bi), e !== void 0) || (e = Bi[ot$1], e !== void 0) || !re$1 && (e = Bi.propertyIsEnumerable && Bi.propertyIsEnumerable[ot$1], e !== void 0 || (e = qn$1(Bi), e !== void 0)))
    return e;
  if (e = De(), lr$1)
    gr$1.set(Bi, e);
  else {
    if (te$1 !== void 0 && te$1(Bi) === !1)
      throw new Error("Non-extensible objects are not allowed as keys.");
    if (re$1)
      Object.defineProperty(Bi, ot$1, {
        enumerable: !1,
        configurable: !1,
        writable: !1,
        value: e
      });
    else if (Bi.propertyIsEnumerable !== void 0 && Bi.propertyIsEnumerable === Bi.constructor.prototype.propertyIsEnumerable)
      Bi.propertyIsEnumerable = function() {
        return this.constructor.prototype.propertyIsEnumerable.apply(
          this,
          arguments
        );
      }, Bi.propertyIsEnumerable[ot$1] = e;
    else if (Bi.nodeType !== void 0)
      Bi[ot$1] = e;
    else
      throw new Error("Unable to set a non-enumerable property on object.");
  }
  return e;
}
var te$1 = Object.isExtensible, re$1 = function() {
  try {
    return Object.defineProperty({}, "@", {}), !0;
  } catch {
    return !1;
  }
}();
function qn$1(Bi) {
  if (Bi && Bi.nodeType > 0)
    switch (Bi.nodeType) {
      case 1:
        return Bi.uniqueID;
      case 9:
        return Bi.documentElement && Bi.documentElement.uniqueID;
    }
}
function An$1(Bi) {
  return Bi.valueOf !== En$1 && typeof Bi.valueOf == "function" ? Bi.valueOf(Bi) : Bi;
}
function De() {
  var Bi = ++ar$1;
  return ar$1 & 1073741824 && (ar$1 = 0), Bi;
}
var lr$1 = typeof WeakMap == "function", gr$1;
lr$1 && (gr$1 = /* @__PURE__ */ new WeakMap());
var ee$1 = /* @__PURE__ */ Object.create(null), ar$1 = 0, ot$1 = "__immutablehash__";
typeof Symbol == "function" && (ot$1 = Symbol(ot$1));
var bn$1 = 16, Rn$1 = 255, fr$1 = 0, hr$1 = {}, or$1 = /* @__PURE__ */ function(Bi) {
  function e(Ui, Zi) {
    this._iter = Ui, this._useKeys = Zi, this.size = Ui.size;
  }
  return Bi && (e.__proto__ = Bi), e.prototype = Object.create(Bi && Bi.prototype), e.prototype.constructor = e, e.prototype.get = function(Ui, Zi) {
    return this._iter.get(Ui, Zi);
  }, e.prototype.has = function(Ui) {
    return this._iter.has(Ui);
  }, e.prototype.valueSeq = function() {
    return this._iter.valueSeq();
  }, e.prototype.reverse = function() {
    var Ui = this, Zi = br$1(this, !0);
    return this._useKeys || (Zi.valueSeq = function() {
      return Ui._iter.toSeq().reverse();
    }), Zi;
  }, e.prototype.map = function(Ui, Zi) {
    var ta = this, na = Ce$1(this, Ui, Zi);
    return this._useKeys || (na.valueSeq = function() {
      return ta._iter.toSeq().map(Ui, Zi);
    }), na;
  }, e.prototype.__iterate = function(Ui, Zi) {
    var ta = this;
    return this._iter.__iterate(function(na, ia) {
      return Ui(na, ia, ta);
    }, Zi);
  }, e.prototype.__iterator = function(Ui, Zi) {
    return this._iter.__iterator(Ui, Zi);
  }, e;
}(it$1);
or$1.prototype[mt$1] = !0;
var Ne$1 = /* @__PURE__ */ function(Bi) {
  function e(Ui) {
    this._iter = Ui, this.size = Ui.size;
  }
  return Bi && (e.__proto__ = Bi), e.prototype = Object.create(Bi && Bi.prototype), e.prototype.constructor = e, e.prototype.includes = function(Ui) {
    return this._iter.includes(Ui);
  }, e.prototype.__iterate = function(Ui, Zi) {
    var ta = this, na = 0;
    return Zi && ct$1(this), this._iter.__iterate(
      function(ia) {
        return Ui(ia, Zi ? ta.size - ++na : na++, ta);
      },
      Zi
    );
  }, e.prototype.__iterator = function(Ui, Zi) {
    var ta = this, na = this._iter.__iterator(Y$1, Zi), ia = 0;
    return Zi && ct$1(this), new l$6(function() {
      var aa = na.next();
      return aa.done ? aa : E$1(
        Ui,
        Zi ? ta.size - ++ia : ia++,
        aa.value,
        aa
      );
    });
  }, e;
}(H$2), Be$1 = /* @__PURE__ */ function(Bi) {
  function e(Ui) {
    this._iter = Ui, this.size = Ui.size;
  }
  return Bi && (e.__proto__ = Bi), e.prototype = Object.create(Bi && Bi.prototype), e.prototype.constructor = e, e.prototype.has = function(Ui) {
    return this._iter.includes(Ui);
  }, e.prototype.__iterate = function(Ui, Zi) {
    var ta = this;
    return this._iter.__iterate(function(na) {
      return Ui(na, na, ta);
    }, Zi);
  }, e.prototype.__iterator = function(Ui, Zi) {
    var ta = this._iter.__iterator(Y$1, Zi);
    return new l$6(function() {
      var na = ta.next();
      return na.done ? na : E$1(Ui, na.value, na.value, na);
    });
  }, e;
}(Et$1), Ue$1 = /* @__PURE__ */ function(Bi) {
  function e(Ui) {
    this._iter = Ui, this.size = Ui.size;
  }
  return Bi && (e.__proto__ = Bi), e.prototype = Object.create(Bi && Bi.prototype), e.prototype.constructor = e, e.prototype.entrySeq = function() {
    return this._iter.toSeq();
  }, e.prototype.__iterate = function(Ui, Zi) {
    var ta = this;
    return this._iter.__iterate(function(na) {
      if (na) {
        ie(na);
        var ia = L$1(na);
        return Ui(
          ia ? na.get(1) : na[1],
          ia ? na.get(0) : na[0],
          ta
        );
      }
    }, Zi);
  }, e.prototype.__iterator = function(Ui, Zi) {
    var ta = this._iter.__iterator(Y$1, Zi);
    return new l$6(function() {
      for (; ; ) {
        var na = ta.next();
        if (na.done)
          return na;
        var ia = na.value;
        if (ia) {
          ie(ia);
          var aa = L$1(ia);
          return E$1(
            Ui,
            aa ? ia.get(0) : ia[0],
            aa ? ia.get(1) : ia[1],
            na
          );
        }
      }
    });
  }, e;
}(it$1);
Ne$1.prototype.cacheResult = or$1.prototype.cacheResult = Be$1.prototype.cacheResult = Ue$1.prototype.cacheResult = Tr$1;
function Pe$1(Bi) {
  var e = G$1(Bi);
  return e._iter = Bi, e.size = Bi.size, e.flip = function() {
    return Bi;
  }, e.reverse = function() {
    var Ui = Bi.reverse.apply(this);
    return Ui.flip = function() {
      return Bi.reverse();
    }, Ui;
  }, e.has = function(Ui) {
    return Bi.includes(Ui);
  }, e.includes = function(Ui) {
    return Bi.has(Ui);
  }, e.cacheResult = Tr$1, e.__iterateUncached = function(Ui, Zi) {
    var ta = this;
    return Bi.__iterate(function(na, ia) {
      return Ui(ia, na, ta) !== !1;
    }, Zi);
  }, e.__iteratorUncached = function(Ui, Zi) {
    if (Ui === C$1) {
      var ta = Bi.__iterator(Ui, Zi);
      return new l$6(function() {
        var na = ta.next();
        if (!na.done) {
          var ia = na.value[0];
          na.value[0] = na.value[1], na.value[1] = ia;
        }
        return na;
      });
    }
    return Bi.__iterator(
      Ui === Y$1 ? Pt$1 : Y$1,
      Zi
    );
  }, e;
}
function Ce$1(Bi, e, Ui) {
  var Zi = G$1(Bi);
  return Zi.size = Bi.size, Zi.has = function(ta) {
    return Bi.has(ta);
  }, Zi.get = function(ta, na) {
    var ia = Bi.get(ta, y$2);
    return ia === y$2 ? na : e.call(Ui, ia, ta, Bi);
  }, Zi.__iterateUncached = function(ta, na) {
    var ia = this;
    return Bi.__iterate(
      function(aa, da, La) {
        return ta(e.call(Ui, aa, da, La), da, ia) !== !1;
      },
      na
    );
  }, Zi.__iteratorUncached = function(ta, na) {
    var ia = Bi.__iterator(C$1, na);
    return new l$6(function() {
      var aa = ia.next();
      if (aa.done)
        return aa;
      var da = aa.value, La = da[0];
      return E$1(
        ta,
        La,
        e.call(Ui, da[1], La, Bi),
        aa
      );
    });
  }, Zi;
}
function br$1(Bi, e) {
  var Ui = this, Zi = G$1(Bi);
  return Zi._iter = Bi, Zi.size = Bi.size, Zi.reverse = function() {
    return Bi;
  }, Bi.flip && (Zi.flip = function() {
    var ta = Pe$1(Bi);
    return ta.reverse = function() {
      return Bi.flip();
    }, ta;
  }), Zi.get = function(ta, na) {
    return Bi.get(e ? ta : -1 - ta, na);
  }, Zi.has = function(ta) {
    return Bi.has(e ? ta : -1 - ta);
  }, Zi.includes = function(ta) {
    return Bi.includes(ta);
  }, Zi.cacheResult = Tr$1, Zi.__iterate = function(ta, na) {
    var ia = this, aa = 0;
    return na && ct$1(Bi), Bi.__iterate(
      function(da, La) {
        return ta(da, e ? La : na ? ia.size - ++aa : aa++, ia);
      },
      !na
    );
  }, Zi.__iterator = function(ta, na) {
    var ia = 0;
    na && ct$1(Bi);
    var aa = Bi.__iterator(C$1, !na);
    return new l$6(function() {
      var da = aa.next();
      if (da.done)
        return da;
      var La = da.value;
      return E$1(
        ta,
        e ? La[0] : na ? Ui.size - ++ia : ia++,
        La[1],
        da
      );
    });
  }, Zi;
}
function Ke$1(Bi, e, Ui, Zi) {
  var ta = G$1(Bi);
  return Zi && (ta.has = function(na) {
    var ia = Bi.get(na, y$2);
    return ia !== y$2 && !!e.call(Ui, ia, na, Bi);
  }, ta.get = function(na, ia) {
    var aa = Bi.get(na, y$2);
    return aa !== y$2 && e.call(Ui, aa, na, Bi) ? aa : ia;
  }), ta.__iterateUncached = function(na, ia) {
    var aa = this, da = 0;
    return Bi.__iterate(function(La, qa, io) {
      if (e.call(Ui, La, qa, io))
        return da++, na(La, Zi ? qa : da - 1, aa);
    }, ia), da;
  }, ta.__iteratorUncached = function(na, ia) {
    var aa = Bi.__iterator(C$1, ia), da = 0;
    return new l$6(function() {
      for (; ; ) {
        var La = aa.next();
        if (La.done)
          return La;
        var qa = La.value, io = qa[0], ao = qa[1];
        if (e.call(Ui, ao, io, Bi))
          return E$1(na, Zi ? io : da++, ao, La);
      }
    });
  }, ta;
}
function Tn$1(Bi, e, Ui) {
  var Zi = zt$1().asMutable();
  return Bi.__iterate(function(ta, na) {
    Zi.update(e.call(Ui, ta, na, Bi), 0, function(ia) {
      return ia + 1;
    });
  }), Zi.asImmutable();
}
function Ln$1(Bi, e, Ui) {
  var Zi = O$1(Bi), ta = (W$1(Bi) ? V() : zt$1()).asMutable();
  Bi.__iterate(function(ia, aa) {
    ta.update(
      e.call(Ui, ia, aa, Bi),
      function(da) {
        return da = da || [], da.push(Zi ? [aa, ia] : ia), da;
      }
    );
  });
  var na = Ye$1(Bi);
  return ta.map(function(ia) {
    return g$2(Bi, na(ia));
  }).asImmutable();
}
function Rr$1(Bi, e, Ui, Zi) {
  var ta = Bi.size;
  if (tr$1(e, Ui, ta))
    return Bi;
  var na = Ut$1(e, ta), ia = rr(Ui, ta);
  if (na !== na || ia !== ia)
    return Rr$1(Bi.toSeq().cacheResult(), e, Ui, Zi);
  var aa = ia - na, da;
  aa === aa && (da = aa < 0 ? 0 : aa);
  var La = G$1(Bi);
  return La.size = da === 0 ? da : Bi.size && da || void 0, !Zi && Or$1(Bi) && da >= 0 && (La.get = function(qa, io) {
    return qa = rt$1(this, qa), qa >= 0 && qa < da ? Bi.get(qa + na, io) : io;
  }), La.__iterateUncached = function(qa, io) {
    var ao = this;
    if (da === 0)
      return 0;
    if (io)
      return this.cacheResult().__iterate(qa, io);
    var oo = 0, no = !0, lo = 0;
    return Bi.__iterate(function(so, bs) {
      if (!(no && (no = oo++ < na)))
        return lo++, qa(so, Zi ? bs : lo - 1, ao) !== !1 && lo !== da;
    }), lo;
  }, La.__iteratorUncached = function(qa, io) {
    if (da !== 0 && io)
      return this.cacheResult().__iterator(qa, io);
    if (da === 0)
      return new l$6(j);
    var ao = Bi.__iterator(qa, io), oo = 0, no = 0;
    return new l$6(function() {
      for (; oo++ < na; )
        ao.next();
      if (++no > da)
        return j();
      var lo = ao.next();
      return Zi || qa === Y$1 || lo.done ? lo : qa === Pt$1 ? E$1(qa, no - 1, void 0, lo) : E$1(qa, no - 1, lo.value[1], lo);
    });
  }, La;
}
function jn$1(Bi, e, Ui) {
  var Zi = G$1(Bi);
  return Zi.__iterateUncached = function(ta, na) {
    var ia = this;
    if (na)
      return this.cacheResult().__iterate(ta, na);
    var aa = 0;
    return Bi.__iterate(
      function(da, La, qa) {
        return e.call(Ui, da, La, qa) && ++aa && ta(da, La, ia);
      }
    ), aa;
  }, Zi.__iteratorUncached = function(ta, na) {
    var ia = this;
    if (na)
      return this.cacheResult().__iterator(ta, na);
    var aa = Bi.__iterator(C$1, na), da = !0;
    return new l$6(function() {
      if (!da)
        return j();
      var La = aa.next();
      if (La.done)
        return La;
      var qa = La.value, io = qa[0], ao = qa[1];
      return e.call(Ui, ao, io, ia) ? ta === C$1 ? La : E$1(ta, io, ao, La) : (da = !1, j());
    });
  }, Zi;
}
function Fe$1(Bi, e, Ui, Zi) {
  var ta = G$1(Bi);
  return ta.__iterateUncached = function(na, ia) {
    var aa = this;
    if (ia)
      return this.cacheResult().__iterate(na, ia);
    var da = !0, La = 0;
    return Bi.__iterate(function(qa, io, ao) {
      if (!(da && (da = e.call(Ui, qa, io, ao))))
        return La++, na(qa, Zi ? io : La - 1, aa);
    }), La;
  }, ta.__iteratorUncached = function(na, ia) {
    var aa = this;
    if (ia)
      return this.cacheResult().__iterator(na, ia);
    var da = Bi.__iterator(C$1, ia), La = !0, qa = 0;
    return new l$6(function() {
      var io, ao, oo;
      do {
        if (io = da.next(), io.done)
          return Zi || na === Y$1 ? io : na === Pt$1 ? E$1(na, qa++, void 0, io) : E$1(na, qa++, io.value[1], io);
        var no = io.value;
        ao = no[0], oo = no[1], La && (La = e.call(Ui, oo, ao, aa));
      } while (La);
      return na === C$1 ? io : E$1(na, ao, oo, io);
    });
  }, ta;
}
function kn$1(Bi, e) {
  var Ui = O$1(Bi), Zi = [Bi].concat(e).map(function(ia) {
    return L$1(ia) ? Ui && (ia = K(ia)) : ia = Ui ? Mr$1(ia) : je$1(Array.isArray(ia) ? ia : [ia]), ia;
  }).filter(function(ia) {
    return ia.size !== 0;
  });
  if (Zi.length === 0)
    return Bi;
  if (Zi.length === 1) {
    var ta = Zi[0];
    if (ta === Bi || Ui && O$1(ta) || T$1(Bi) && T$1(ta))
      return ta;
  }
  var na = new st$1(Zi);
  return Ui ? na = na.toKeyedSeq() : T$1(Bi) || (na = na.toSetSeq()), na = na.flatten(!0), na.size = Zi.reduce(function(ia, aa) {
    if (ia !== void 0) {
      var da = aa.size;
      if (da !== void 0)
        return ia + da;
    }
  }, 0), na;
}
function We$1(Bi, e, Ui) {
  var Zi = G$1(Bi);
  return Zi.__iterateUncached = function(ta, na) {
    if (na)
      return this.cacheResult().__iterate(ta, na);
    var ia = 0, aa = !1;
    function da(La, qa) {
      La.__iterate(function(io, ao) {
        return (!e || qa < e) && L$1(io) ? da(io, qa + 1) : (ia++, ta(io, Ui ? ao : ia - 1, Zi) === !1 && (aa = !0)), !aa;
      }, na);
    }
    return da(Bi, 0), ia;
  }, Zi.__iteratorUncached = function(ta, na) {
    if (na)
      return this.cacheResult().__iterator(ta, na);
    var ia = Bi.__iterator(ta, na), aa = [], da = 0;
    return new l$6(function() {
      for (; ia; ) {
        var La = ia.next();
        if (La.done !== !1) {
          ia = aa.pop();
          continue;
        }
        var qa = La.value;
        if (ta === C$1 && (qa = qa[1]), (!e || aa.length < e) && L$1(qa))
          aa.push(ia), ia = qa.__iterator(ta, na);
        else
          return Ui ? La : E$1(ta, da++, qa, La);
      }
      return j();
    });
  }, Zi;
}
function $n$1(Bi, e, Ui) {
  var Zi = Ye$1(Bi);
  return Bi.toSeq().map(function(ta, na) {
    return Zi(e.call(Ui, ta, na, Bi));
  }).flatten(!0);
}
function Dn$1(Bi, e) {
  var Ui = G$1(Bi);
  return Ui.size = Bi.size && Bi.size * 2 - 1, Ui.__iterateUncached = function(Zi, ta) {
    var na = this, ia = 0;
    return Bi.__iterate(
      function(aa) {
        return (!ia || Zi(e, ia++, na) !== !1) && Zi(aa, ia++, na) !== !1;
      },
      ta
    ), ia;
  }, Ui.__iteratorUncached = function(Zi, ta) {
    var na = Bi.__iterator(Y$1, ta), ia = 0, aa;
    return new l$6(function() {
      return (!aa || ia % 2) && (aa = na.next(), aa.done) ? aa : ia % 2 ? E$1(Zi, ia++, e) : E$1(Zi, ia++, aa.value, aa);
    });
  }, Ui;
}
function _t$1(Bi, e, Ui) {
  e || (e = He$1);
  var Zi = O$1(Bi), ta = 0, na = Bi.toSeq().map(function(ia, aa) {
    return [aa, ia, ta++, Ui ? Ui(ia, aa, Bi) : ia];
  }).valueSeq().toArray();
  return na.sort(function(ia, aa) {
    return e(ia[3], aa[3]) || ia[2] - aa[2];
  }).forEach(
    Zi ? function(ia, aa) {
      na[aa].length = 2;
    } : function(ia, aa) {
      na[aa] = ia[1];
    }
  ), Zi ? it$1(na) : T$1(Bi) ? H$2(na) : Et$1(na);
}
function Ht$1(Bi, e, Ui) {
  if (e || (e = He$1), Ui) {
    var Zi = Bi.toSeq().map(function(ta, na) {
      return [ta, Ui(ta, na, Bi)];
    }).reduce(function(ta, na) {
      return ne(e, ta[1], na[1]) ? na : ta;
    });
    return Zi && Zi[0];
  }
  return Bi.reduce(function(ta, na) {
    return ne(e, ta, na) ? na : ta;
  });
}
function ne(Bi, e, Ui) {
  var Zi = Bi(Ui, e);
  return Zi === 0 && Ui !== e && (Ui == null || Ui !== Ui) || Zi > 0;
}
function Jt(Bi, e, Ui, Zi) {
  var ta = G$1(Bi), na = new st$1(Ui).map(function(ia) {
    return ia.size;
  });
  return ta.size = Zi ? na.max() : na.min(), ta.__iterate = function(ia, aa) {
    for (var da = this.__iterator(Y$1, aa), La, qa = 0; !(La = da.next()).done && ia(La.value, qa++, this) !== !1; )
      ;
    return qa;
  }, ta.__iteratorUncached = function(ia, aa) {
    var da = Ui.map(
      function(io) {
        return io = z(io), dr$1(aa ? io.reverse() : io);
      }
    ), La = 0, qa = !1;
    return new l$6(function() {
      var io;
      return qa || (io = da.map(function(ao) {
        return ao.next();
      }), qa = Zi ? io.every(function(ao) {
        return ao.done;
      }) : io.some(function(ao) {
        return ao.done;
      })), qa ? j() : E$1(
        ia,
        La++,
        e.apply(
          null,
          io.map(function(ao) {
            return ao.value;
          })
        )
      );
    });
  }, ta;
}
function g$2(Bi, e) {
  return Bi === e ? Bi : Or$1(Bi) ? e : Bi.constructor(e);
}
function ie(Bi) {
  if (Bi !== Object(Bi))
    throw new TypeError("Expected [K, V] tuple: " + Bi);
}
function Ye$1(Bi) {
  return O$1(Bi) ? K : T$1(Bi) ? at : gt$1;
}
function G$1(Bi) {
  return Object.create(
    (O$1(Bi) ? it$1 : T$1(Bi) ? H$2 : Et$1).prototype
  );
}
function Tr$1() {
  return this._iter.cacheResult ? (this._iter.cacheResult(), this.size = this._iter.size, this) : N.prototype.cacheResult.call(this);
}
function He$1(Bi, e) {
  return Bi === void 0 && e === void 0 ? 0 : Bi === void 0 ? 1 : e === void 0 ? -1 : Bi > e ? 1 : Bi < e ? -1 : 0;
}
function X$1(Bi, e) {
  e = e || 0;
  for (var Ui = Math.max(0, Bi.length - e), Zi = new Array(Ui), ta = 0; ta < Ui; ta++)
    Zi[ta] = Bi[ta + e];
  return Zi;
}
function Lr(Bi, e) {
  if (!Bi)
    throw new Error(e);
}
function P$2(Bi) {
  Lr(
    Bi !== 1 / 0,
    "Cannot perform this action with an infinite size."
  );
}
function Je$1(Bi) {
  if (Le$1(Bi) && typeof Bi != "string")
    return Bi;
  if (W$1(Bi))
    return Bi.toArray();
  throw new TypeError(
    "Invalid keyPath: expected Ordered Collection or Array: " + Bi
  );
}
var Nn$1 = Object.prototype.toString;
function Bn$1(Bi) {
  if (!Bi || typeof Bi != "object" || Nn$1.call(Bi) !== "[object Object]")
    return !1;
  var e = Object.getPrototypeOf(Bi);
  if (e === null)
    return !0;
  for (var Ui = e, Zi = Object.getPrototypeOf(e); Zi !== null; )
    Ui = Zi, Zi = Object.getPrototypeOf(Ui);
  return Ui === e;
}
function et$1(Bi) {
  return typeof Bi == "object" && (Z$1(Bi) || Array.isArray(Bi) || Bn$1(Bi));
}
function Lt$1(Bi) {
  try {
    return typeof Bi == "string" ? JSON.stringify(Bi) : String(Bi);
  } catch {
    return JSON.stringify(Bi);
  }
}
function Un$1(Bi, e) {
  return Z$1(Bi) ? Bi.has(e) : et$1(Bi) && wt$1.call(Bi, e);
}
function Xe$1(Bi, e, Ui) {
  return Z$1(Bi) ? Bi.get(e, Ui) : Un$1(Bi, e) ? typeof Bi.get == "function" ? Bi.get(e) : Bi[e] : Ui;
}
function Vt$1(Bi) {
  if (Array.isArray(Bi))
    return X$1(Bi);
  var e = {};
  for (var Ui in Bi)
    wt$1.call(Bi, Ui) && (e[Ui] = Bi[Ui]);
  return e;
}
function Pn$1(Bi, e) {
  if (!et$1(Bi))
    throw new TypeError(
      "Cannot update non-data-structure value: " + Bi
    );
  if (Z$1(Bi)) {
    if (!Bi.remove)
      throw new TypeError(
        "Cannot update immutable value without .remove() method: " + Bi
      );
    return Bi.remove(e);
  }
  if (!wt$1.call(Bi, e))
    return Bi;
  var Ui = Vt$1(Bi);
  return Array.isArray(Ui) ? Ui.splice(e, 1) : delete Ui[e], Ui;
}
function Cn$1(Bi, e, Ui) {
  if (!et$1(Bi))
    throw new TypeError(
      "Cannot update non-data-structure value: " + Bi
    );
  if (Z$1(Bi)) {
    if (!Bi.set)
      throw new TypeError(
        "Cannot update immutable value without .set() method: " + Bi
      );
    return Bi.set(e, Ui);
  }
  if (wt$1.call(Bi, e) && Ui === Bi[e])
    return Bi;
  var Zi = Vt$1(Bi);
  return Zi[e] = Ui, Zi;
}
function Ot$1(Bi, e, Ui, Zi) {
  Zi || (Zi = Ui, Ui = void 0);
  var ta = Ze$1(
    Z$1(Bi),
    Bi,
    Je$1(e),
    0,
    Ui,
    Zi
  );
  return ta === y$2 ? Ui : ta;
}
function Ze$1(Bi, e, Ui, Zi, ta, na) {
  var ia = e === y$2;
  if (Zi === Ui.length) {
    var aa = ia ? ta : e, da = na(aa);
    return da === aa ? e : da;
  }
  if (!ia && !et$1(e))
    throw new TypeError(
      "Cannot update within non-data-structure value in path [" + Ui.slice(0, Zi).map(Lt$1) + "]: " + e
    );
  var La = Ui[Zi], qa = ia ? y$2 : Xe$1(e, La, y$2), io = Ze$1(
    qa === y$2 ? Bi : Z$1(qa),
    qa,
    Ui,
    Zi + 1,
    ta,
    na
  );
  return io === qa ? e : io === y$2 ? Pn$1(e, La) : Cn$1(
    ia ? Bi ? F() : {} : e,
    La,
    io
  );
}
function Kn$1(Bi, e, Ui) {
  return Ot$1(Bi, e, y$2, function() {
    return Ui;
  });
}
function jr$1(Bi, e) {
  return Kn$1(this, Bi, e);
}
function Fn$1(Bi, e) {
  return Ot$1(Bi, e, function() {
    return y$2;
  });
}
function kr$1(Bi) {
  return Fn$1(this, Bi);
}
function Ge$1(Bi, e, Ui, Zi) {
  return Ot$1(Bi, [e], Ui, Zi);
}
function $r$1(Bi, e, Ui) {
  return arguments.length === 1 ? Bi(this) : Ge$1(this, Bi, e, Ui);
}
function Dr(Bi, e, Ui) {
  return Ot$1(this, Bi, e, Ui);
}
function Qe$1() {
  for (var Bi = [], e = arguments.length; e--; )
    Bi[e] = arguments[e];
  return xe$1(this, Bi);
}
function Ve$1(Bi) {
  for (var e = [], Ui = arguments.length - 1; Ui-- > 0; )
    e[Ui] = arguments[Ui + 1];
  if (typeof Bi != "function")
    throw new TypeError("Invalid merger function: " + Bi);
  return xe$1(this, e, Bi);
}
function xe$1(Bi, e, Ui) {
  for (var Zi = [], ta = 0; ta < e.length; ta++) {
    var na = K(e[ta]);
    na.size !== 0 && Zi.push(na);
  }
  return Zi.length === 0 ? Bi : Bi.toSeq().size === 0 && !Bi.__ownerID && Zi.length === 1 ? Bi.constructor(Zi[0]) : Bi.withMutations(function(ia) {
    for (var aa = Ui ? function(La, qa) {
      Ge$1(
        ia,
        qa,
        y$2,
        function(io) {
          return io === y$2 ? La : Ui(io, La, qa);
        }
      );
    } : function(La, qa) {
      ia.set(qa, La);
    }, da = 0; da < Zi.length; da++)
      Zi[da].forEach(aa);
  });
}
function Nr$1(Bi, e, Ui) {
  return Br$1(Bi, e, Wn$1(Ui));
}
function Br$1(Bi, e, Ui) {
  if (!et$1(Bi))
    throw new TypeError(
      "Cannot merge into non-data-structure value: " + Bi
    );
  if (Z$1(Bi))
    return typeof Ui == "function" && Bi.mergeWith ? Bi.mergeWith.apply(Bi, [Ui].concat(e)) : Bi.merge ? Bi.merge.apply(Bi, e) : Bi.concat.apply(Bi, e);
  for (var Zi = Array.isArray(Bi), ta = Bi, na = Zi ? at : K, ia = Zi ? function(da) {
    ta === Bi && (ta = Vt$1(ta)), ta.push(da);
  } : function(da, La) {
    var qa = wt$1.call(ta, La), io = qa && Ui ? Ui(ta[La], da, La) : da;
    (!qa || io !== ta[La]) && (ta === Bi && (ta = Vt$1(ta)), ta[La] = io);
  }, aa = 0; aa < e.length; aa++)
    na(e[aa]).forEach(ia);
  return ta;
}
function Wn$1(Bi) {
  function e(Ui, Zi, ta) {
    return et$1(Ui) && et$1(Zi) && Yn$1(Ui, Zi) ? Br$1(Ui, [Zi], e) : Bi ? Bi(Ui, Zi, ta) : Zi;
  }
  return e;
}
function Yn$1(Bi, e) {
  var Ui = N(Bi), Zi = N(e);
  return T$1(Ui) === T$1(Zi) && O$1(Ui) === O$1(Zi);
}
function tn$1() {
  for (var Bi = [], e = arguments.length; e--; )
    Bi[e] = arguments[e];
  return Nr$1(this, Bi);
}
function rn$1(Bi) {
  for (var e = [], Ui = arguments.length - 1; Ui-- > 0; )
    e[Ui] = arguments[Ui + 1];
  return Nr$1(this, e, Bi);
}
function Ur$1(Bi) {
  for (var e = [], Ui = arguments.length - 1; Ui-- > 0; )
    e[Ui] = arguments[Ui + 1];
  return Ot$1(this, Bi, F(), function(Zi) {
    return Br$1(Zi, e);
  });
}
function Pr$1(Bi) {
  for (var e = [], Ui = arguments.length - 1; Ui-- > 0; )
    e[Ui] = arguments[Ui + 1];
  return Ot$1(
    this,
    Bi,
    F(),
    function(Zi) {
      return Nr$1(Zi, e);
    }
  );
}
function Ct$1(Bi) {
  var e = this.asMutable();
  return Bi(e), e.wasAltered() ? e.__ensureOwner(this.__ownerID) : this;
}
function Kt() {
  return this.__ownerID ? this : this.__ensureOwner(new Er$1());
}
function Ft$1() {
  return this.__ensureOwner();
}
function Cr$1() {
  return this.__altered;
}
var zt$1 = /* @__PURE__ */ function(Bi) {
  function e(Ui) {
    return Ui == null ? F() : Ar$1(Ui) && !W$1(Ui) ? Ui : F().withMutations(function(Zi) {
      var ta = Bi(Ui);
      P$2(ta.size), ta.forEach(function(na, ia) {
        return Zi.set(ia, na);
      });
    });
  }
  return Bi && (e.__proto__ = Bi), e.prototype = Object.create(Bi && Bi.prototype), e.prototype.constructor = e, e.of = function() {
    for (var Ui = [], Zi = arguments.length; Zi--; )
      Ui[Zi] = arguments[Zi];
    return F().withMutations(function(ta) {
      for (var na = 0; na < Ui.length; na += 2) {
        if (na + 1 >= Ui.length)
          throw new Error("Missing value for key: " + Ui[na]);
        ta.set(Ui[na], Ui[na + 1]);
      }
    });
  }, e.prototype.toString = function() {
    return this.__toString("Map {", "}");
  }, e.prototype.get = function(Ui, Zi) {
    return this._root ? this._root.get(0, void 0, Ui, Zi) : Zi;
  }, e.prototype.set = function(Ui, Zi) {
    return se$1(this, Ui, Zi);
  }, e.prototype.remove = function(Ui) {
    return se$1(this, Ui, y$2);
  }, e.prototype.deleteAll = function(Ui) {
    var Zi = z(Ui);
    return Zi.size === 0 ? this : this.withMutations(function(ta) {
      Zi.forEach(function(na) {
        return ta.remove(na);
      });
    });
  }, e.prototype.clear = function() {
    return this.size === 0 ? this : this.__ownerID ? (this.size = 0, this._root = null, this.__hash = void 0, this.__altered = !0, this) : F();
  }, e.prototype.sort = function(Ui) {
    return V(_t$1(this, Ui));
  }, e.prototype.sortBy = function(Ui, Zi) {
    return V(_t$1(this, Zi, Ui));
  }, e.prototype.map = function(Ui, Zi) {
    var ta = this;
    return this.withMutations(function(na) {
      na.forEach(function(ia, aa) {
        na.set(aa, Ui.call(Zi, ia, aa, ta));
      });
    });
  }, e.prototype.__iterator = function(Ui, Zi) {
    return new Hn$1(this, Ui, Zi);
  }, e.prototype.__iterate = function(Ui, Zi) {
    var ta = this, na = 0;
    return this._root && this._root.iterate(function(ia) {
      return na++, Ui(ia[1], ia[0], ta);
    }, Zi), na;
  }, e.prototype.__ensureOwner = function(Ui) {
    return Ui === this.__ownerID ? this : Ui ? Kr$1(this.size, this._root, Ui, this.__hash) : this.size === 0 ? F() : (this.__ownerID = Ui, this.__altered = !1, this);
  }, e;
}(K);
zt$1.isMap = Ar$1;
var w$2 = zt$1.prototype;
w$2[ke] = !0;
w$2[Bt$1] = w$2.remove;
w$2.removeAll = w$2.deleteAll;
w$2.setIn = jr$1;
w$2.removeIn = w$2.deleteIn = kr$1;
w$2.update = $r$1;
w$2.updateIn = Dr;
w$2.merge = w$2.concat = Qe$1;
w$2.mergeWith = Ve$1;
w$2.mergeDeep = tn$1;
w$2.mergeDeepWith = rn$1;
w$2.mergeIn = Ur$1;
w$2.mergeDeepIn = Pr$1;
w$2.withMutations = Ct$1;
w$2.wasAltered = Cr$1;
w$2.asImmutable = Ft$1;
w$2["@@transducer/init"] = w$2.asMutable = Kt;
w$2["@@transducer/step"] = function(Bi, e) {
  return Bi.set(e[0], e[1]);
};
w$2["@@transducer/result"] = function(Bi) {
  return Bi.asImmutable();
};
var jt$1 = function(Bi, e) {
  this.ownerID = Bi, this.entries = e;
};
jt$1.prototype.get = function(Bi, e, Ui, Zi) {
  for (var ta = this.entries, na = 0, ia = ta.length; na < ia; na++)
    if (D(Ui, ta[na][0]))
      return ta[na][1];
  return Zi;
};
jt$1.prototype.update = function(Bi, e, Ui, Zi, ta, na, ia) {
  for (var aa = ta === y$2, da = this.entries, La = 0, qa = da.length; La < qa && !D(Zi, da[La][0]); La++)
    ;
  var io = La < qa;
  if (io ? da[La][1] === ta : aa)
    return this;
  if (U(ia), (aa || !io) && U(na), !(aa && da.length === 1)) {
    if (!io && !aa && da.length >= Vn$1)
      return Jn$1(Bi, da, Zi, ta);
    var ao = Bi && Bi === this.ownerID, oo = ao ? da : X$1(da);
    return io ? aa ? La === qa - 1 ? oo.pop() : oo[La] = oo.pop() : oo[La] = [Zi, ta] : oo.push([Zi, ta]), ao ? (this.entries = oo, this) : new jt$1(Bi, oo);
  }
};
var pt$1 = function(Bi, e, Ui) {
  this.ownerID = Bi, this.bitmap = e, this.nodes = Ui;
};
pt$1.prototype.get = function(Bi, e, Ui, Zi) {
  e === void 0 && (e = $(Ui));
  var ta = 1 << ((Bi === 0 ? e : e >>> Bi) & b$1), na = this.bitmap;
  return (na & ta) === 0 ? Zi : this.nodes[en(na & ta - 1)].get(
    Bi + m$4,
    e,
    Ui,
    Zi
  );
};
pt$1.prototype.update = function(Bi, e, Ui, Zi, ta, na, ia) {
  Ui === void 0 && (Ui = $(Zi));
  var aa = (e === 0 ? Ui : Ui >>> e) & b$1, da = 1 << aa, La = this.bitmap, qa = (La & da) !== 0;
  if (!qa && ta === y$2)
    return this;
  var io = en(La & da - 1), ao = this.nodes, oo = qa ? ao[io] : void 0, no = Fr$1(
    oo,
    Bi,
    e + m$4,
    Ui,
    Zi,
    ta,
    na,
    ia
  );
  if (no === oo)
    return this;
  if (!qa && no && ao.length >= xn$1)
    return Zn$1(Bi, ao, La, aa, no);
  if (qa && !no && ao.length === 2 && ae$1(ao[io ^ 1]))
    return ao[io ^ 1];
  if (qa && no && ao.length === 1 && ae$1(no))
    return no;
  var lo = Bi && Bi === this.ownerID, so = qa ? no ? La : La ^ da : La | da, bs = qa ? no ? nn$1(ao, io, no, lo) : Qn$1(ao, io, lo) : Gn$1(ao, io, no, lo);
  return lo ? (this.bitmap = so, this.nodes = bs, this) : new pt$1(Bi, so, bs);
};
var kt = function(Bi, e, Ui) {
  this.ownerID = Bi, this.count = e, this.nodes = Ui;
};
kt.prototype.get = function(Bi, e, Ui, Zi) {
  e === void 0 && (e = $(Ui));
  var ta = (Bi === 0 ? e : e >>> Bi) & b$1, na = this.nodes[ta];
  return na ? na.get(Bi + m$4, e, Ui, Zi) : Zi;
};
kt.prototype.update = function(Bi, e, Ui, Zi, ta, na, ia) {
  Ui === void 0 && (Ui = $(Zi));
  var aa = (e === 0 ? Ui : Ui >>> e) & b$1, da = ta === y$2, La = this.nodes, qa = La[aa];
  if (da && !qa)
    return this;
  var io = Fr$1(
    qa,
    Bi,
    e + m$4,
    Ui,
    Zi,
    ta,
    na,
    ia
  );
  if (io === qa)
    return this;
  var ao = this.count;
  if (!qa)
    ao++;
  else if (!io && (ao--, ao < ti$1))
    return Xn$1(Bi, La, ao, aa);
  var oo = Bi && Bi === this.ownerID, no = nn$1(La, aa, io, oo);
  return oo ? (this.count = ao, this.nodes = no, this) : new kt(Bi, ao, no);
};
var vt$1 = function(Bi, e, Ui) {
  this.ownerID = Bi, this.keyHash = e, this.entries = Ui;
};
vt$1.prototype.get = function(Bi, e, Ui, Zi) {
  for (var ta = this.entries, na = 0, ia = ta.length; na < ia; na++)
    if (D(Ui, ta[na][0]))
      return ta[na][1];
  return Zi;
};
vt$1.prototype.update = function(Bi, e, Ui, Zi, ta, na, ia) {
  Ui === void 0 && (Ui = $(Zi));
  var aa = ta === y$2;
  if (Ui !== this.keyHash)
    return aa ? this : (U(ia), U(na), Wr$1(this, Bi, e, Ui, [Zi, ta]));
  for (var da = this.entries, La = 0, qa = da.length; La < qa && !D(Zi, da[La][0]); La++)
    ;
  var io = La < qa;
  if (io ? da[La][1] === ta : aa)
    return this;
  if (U(ia), (aa || !io) && U(na), aa && qa === 2)
    return new Q$1(Bi, this.keyHash, da[La ^ 1]);
  var ao = Bi && Bi === this.ownerID, oo = ao ? da : X$1(da);
  return io ? aa ? La === qa - 1 ? oo.pop() : oo[La] = oo.pop() : oo[La] = [Zi, ta] : oo.push([Zi, ta]), ao ? (this.entries = oo, this) : new vt$1(Bi, this.keyHash, oo);
};
var Q$1 = function(Bi, e, Ui) {
  this.ownerID = Bi, this.keyHash = e, this.entry = Ui;
};
Q$1.prototype.get = function(Bi, e, Ui, Zi) {
  return D(Ui, this.entry[0]) ? this.entry[1] : Zi;
};
Q$1.prototype.update = function(Bi, e, Ui, Zi, ta, na, ia) {
  var aa = ta === y$2, da = D(Zi, this.entry[0]);
  if (da ? ta === this.entry[1] : aa)
    return this;
  if (U(ia), aa) {
    U(na);
    return;
  }
  return da ? Bi && Bi === this.ownerID ? (this.entry[1] = ta, this) : new Q$1(Bi, this.keyHash, [Zi, ta]) : (U(na), Wr$1(this, Bi, e, $(Zi), [Zi, ta]));
};
jt$1.prototype.iterate = vt$1.prototype.iterate = function(Bi, e) {
  for (var Ui = this.entries, Zi = 0, ta = Ui.length - 1; Zi <= ta; Zi++)
    if (Bi(Ui[e ? ta - Zi : Zi]) === !1)
      return !1;
};
pt$1.prototype.iterate = kt.prototype.iterate = function(Bi, e) {
  for (var Ui = this.nodes, Zi = 0, ta = Ui.length - 1; Zi <= ta; Zi++) {
    var na = Ui[e ? ta - Zi : Zi];
    if (na && na.iterate(Bi, e) === !1)
      return !1;
  }
};
Q$1.prototype.iterate = function(Bi, e) {
  return Bi(this.entry);
};
var Hn$1 = /* @__PURE__ */ function(Bi) {
  function e(Ui, Zi, ta) {
    this._type = Zi, this._reverse = ta, this._stack = Ui._root && ue(Ui._root);
  }
  return Bi && (e.__proto__ = Bi), e.prototype = Object.create(Bi && Bi.prototype), e.prototype.constructor = e, e.prototype.next = function() {
    for (var Ui = this._type, Zi = this._stack; Zi; ) {
      var ta = Zi.node, na = Zi.index++, ia = void 0;
      if (ta.entry) {
        if (na === 0)
          return cr$1(Ui, ta.entry);
      } else if (ta.entries) {
        if (ia = ta.entries.length - 1, na <= ia)
          return cr$1(
            Ui,
            ta.entries[this._reverse ? ia - na : na]
          );
      } else if (ia = ta.nodes.length - 1, na <= ia) {
        var aa = ta.nodes[this._reverse ? ia - na : na];
        if (aa) {
          if (aa.entry)
            return cr$1(Ui, aa.entry);
          Zi = this._stack = ue(aa, Zi);
        }
        continue;
      }
      Zi = this._stack = this._stack.__prev;
    }
    return j();
  }, e;
}(l$6);
function cr$1(Bi, e) {
  return E$1(Bi, e[0], e[1]);
}
function ue(Bi, e) {
  return {
    node: Bi,
    index: 0,
    __prev: e
  };
}
function Kr$1(Bi, e, Ui, Zi) {
  var ta = Object.create(w$2);
  return ta.size = Bi, ta._root = e, ta.__ownerID = Ui, ta.__hash = Zi, ta.__altered = !1, ta;
}
var oe$1;
function F() {
  return oe$1 || (oe$1 = Kr$1(0));
}
function se$1(Bi, e, Ui) {
  var Zi, ta;
  if (Bi._root) {
    var na = pr$1(), ia = pr$1();
    if (Zi = Fr$1(
      Bi._root,
      Bi.__ownerID,
      0,
      void 0,
      e,
      Ui,
      na,
      ia
    ), !ia.value)
      return Bi;
    ta = Bi.size + (na.value ? Ui === y$2 ? -1 : 1 : 0);
  } else {
    if (Ui === y$2)
      return Bi;
    ta = 1, Zi = new jt$1(Bi.__ownerID, [[e, Ui]]);
  }
  return Bi.__ownerID ? (Bi.size = ta, Bi._root = Zi, Bi.__hash = void 0, Bi.__altered = !0, Bi) : Zi ? Kr$1(ta, Zi) : F();
}
function Fr$1(Bi, e, Ui, Zi, ta, na, ia, aa) {
  return Bi ? Bi.update(
    e,
    Ui,
    Zi,
    ta,
    na,
    ia,
    aa
  ) : na === y$2 ? Bi : (U(aa), U(ia), new Q$1(e, Zi, [ta, na]));
}
function ae$1(Bi) {
  return Bi.constructor === Q$1 || Bi.constructor === vt$1;
}
function Wr$1(Bi, e, Ui, Zi, ta) {
  if (Bi.keyHash === Zi)
    return new vt$1(e, Zi, [Bi.entry, ta]);
  var na = (Ui === 0 ? Bi.keyHash : Bi.keyHash >>> Ui) & b$1, ia = (Ui === 0 ? Zi : Zi >>> Ui) & b$1, aa, da = na === ia ? [Wr$1(Bi, e, Ui + m$4, Zi, ta)] : (aa = new Q$1(e, Zi, ta), na < ia ? [Bi, aa] : [aa, Bi]);
  return new pt$1(e, 1 << na | 1 << ia, da);
}
function Jn$1(Bi, e, Ui, Zi) {
  Bi || (Bi = new Er$1());
  for (var ta = new Q$1(Bi, $(Ui), [Ui, Zi]), na = 0; na < e.length; na++) {
    var ia = e[na];
    ta = ta.update(Bi, 0, void 0, ia[0], ia[1]);
  }
  return ta;
}
function Xn$1(Bi, e, Ui, Zi) {
  for (var ta = 0, na = 0, ia = new Array(Ui), aa = 0, da = 1, La = e.length; aa < La; aa++, da <<= 1) {
    var qa = e[aa];
    qa !== void 0 && aa !== Zi && (ta |= da, ia[na++] = qa);
  }
  return new pt$1(Bi, ta, ia);
}
function Zn$1(Bi, e, Ui, Zi, ta) {
  for (var na = 0, ia = new Array(B$1), aa = 0; Ui !== 0; aa++, Ui >>>= 1)
    ia[aa] = Ui & 1 ? e[na++] : void 0;
  return ia[Zi] = ta, new kt(Bi, na + 1, ia);
}
function en(Bi) {
  return Bi -= Bi >> 1 & 1431655765, Bi = (Bi & 858993459) + (Bi >> 2 & 858993459), Bi = Bi + (Bi >> 4) & 252645135, Bi += Bi >> 8, Bi += Bi >> 16, Bi & 127;
}
function nn$1(Bi, e, Ui, Zi) {
  var ta = Zi ? Bi : X$1(Bi);
  return ta[e] = Ui, ta;
}
function Gn$1(Bi, e, Ui, Zi) {
  var ta = Bi.length + 1;
  if (Zi && e + 1 === ta)
    return Bi[e] = Ui, Bi;
  for (var na = new Array(ta), ia = 0, aa = 0; aa < ta; aa++)
    aa === e ? (na[aa] = Ui, ia = -1) : na[aa] = Bi[aa + ia];
  return na;
}
function Qn$1(Bi, e, Ui) {
  var Zi = Bi.length - 1;
  if (Ui && e === Zi)
    return Bi.pop(), Bi;
  for (var ta = new Array(Zi), na = 0, ia = 0; ia < Zi; ia++)
    ia === e && (na = 1), ta[ia] = Bi[ia + na];
  return ta;
}
var Vn$1 = B$1 / 4, xn$1 = B$1 / 2, ti$1 = B$1 / 4, un$1 = "@@__IMMUTABLE_LIST__@@";
function on$1(Bi) {
  return !!(Bi && Bi[un$1]);
}
var sr$1 = /* @__PURE__ */ function(Bi) {
  function e(Ui) {
    var Zi = Qt$1();
    if (Ui == null)
      return Zi;
    if (on$1(Ui))
      return Ui;
    var ta = Bi(Ui), na = ta.size;
    return na === 0 ? Zi : (P$2(na), na > 0 && na < B$1 ? $t$1(0, na, m$4, null, new tt(ta.toArray())) : Zi.withMutations(function(ia) {
      ia.setSize(na), ta.forEach(function(aa, da) {
        return ia.set(da, aa);
      });
    }));
  }
  return Bi && (e.__proto__ = Bi), e.prototype = Object.create(Bi && Bi.prototype), e.prototype.constructor = e, e.of = function() {
    return this(arguments);
  }, e.prototype.toString = function() {
    return this.__toString("List [", "]");
  }, e.prototype.get = function(Ui, Zi) {
    if (Ui = rt$1(this, Ui), Ui >= 0 && Ui < this.size) {
      Ui += this._origin;
      var ta = sn$1(this, Ui);
      return ta && ta.array[Ui & b$1];
    }
    return Zi;
  }, e.prototype.set = function(Ui, Zi) {
    return ri(this, Ui, Zi);
  }, e.prototype.remove = function(Ui) {
    return this.has(Ui) ? Ui === 0 ? this.shift() : Ui === this.size - 1 ? this.pop() : this.splice(Ui, 1) : this;
  }, e.prototype.insert = function(Ui, Zi) {
    return this.splice(Ui, 0, Zi);
  }, e.prototype.clear = function() {
    return this.size === 0 ? this : this.__ownerID ? (this.size = this._origin = this._capacity = 0, this._level = m$4, this._root = this._tail = this.__hash = void 0, this.__altered = !0, this) : Qt$1();
  }, e.prototype.push = function() {
    var Ui = arguments, Zi = this.size;
    return this.withMutations(function(ta) {
      x$1(ta, 0, Zi + Ui.length);
      for (var na = 0; na < Ui.length; na++)
        ta.set(Zi + na, Ui[na]);
    });
  }, e.prototype.pop = function() {
    return x$1(this, 0, -1);
  }, e.prototype.unshift = function() {
    var Ui = arguments;
    return this.withMutations(function(Zi) {
      x$1(Zi, -Ui.length);
      for (var ta = 0; ta < Ui.length; ta++)
        Zi.set(ta, Ui[ta]);
    });
  }, e.prototype.shift = function() {
    return x$1(this, 1);
  }, e.prototype.concat = function() {
    for (var Ui = arguments, Zi = [], ta = 0; ta < arguments.length; ta++) {
      var na = Ui[ta], ia = Bi(
        typeof na != "string" && Te$1(na) ? na : [na]
      );
      ia.size !== 0 && Zi.push(ia);
    }
    return Zi.length === 0 ? this : this.size === 0 && !this.__ownerID && Zi.length === 1 ? this.constructor(Zi[0]) : this.withMutations(function(aa) {
      Zi.forEach(function(da) {
        return da.forEach(function(La) {
          return aa.push(La);
        });
      });
    });
  }, e.prototype.setSize = function(Ui) {
    return x$1(this, 0, Ui);
  }, e.prototype.map = function(Ui, Zi) {
    var ta = this;
    return this.withMutations(function(na) {
      for (var ia = 0; ia < ta.size; ia++)
        na.set(ia, Ui.call(Zi, na.get(ia), ia, ta));
    });
  }, e.prototype.slice = function(Ui, Zi) {
    var ta = this.size;
    return tr$1(Ui, Zi, ta) ? this : x$1(
      this,
      Ut$1(Ui, ta),
      rr(Zi, ta)
    );
  }, e.prototype.__iterator = function(Ui, Zi) {
    var ta = Zi ? this.size : 0, na = fe$1(this, Zi);
    return new l$6(function() {
      var ia = na();
      return ia === Rt$1 ? j() : E$1(Ui, Zi ? --ta : ta++, ia);
    });
  }, e.prototype.__iterate = function(Ui, Zi) {
    for (var ta = Zi ? this.size : 0, na = fe$1(this, Zi), ia; (ia = na()) !== Rt$1 && Ui(ia, Zi ? --ta : ta++, this) !== !1; )
      ;
    return ta;
  }, e.prototype.__ensureOwner = function(Ui) {
    return Ui === this.__ownerID ? this : Ui ? $t$1(
      this._origin,
      this._capacity,
      this._level,
      this._root,
      this._tail,
      Ui,
      this.__hash
    ) : this.size === 0 ? Qt$1() : (this.__ownerID = Ui, this.__altered = !1, this);
  }, e;
}(at);
sr$1.isList = on$1;
var I$1 = sr$1.prototype;
I$1[un$1] = !0;
I$1[Bt$1] = I$1.remove;
I$1.merge = I$1.concat;
I$1.setIn = jr$1;
I$1.deleteIn = I$1.removeIn = kr$1;
I$1.update = $r$1;
I$1.updateIn = Dr;
I$1.mergeIn = Ur$1;
I$1.mergeDeepIn = Pr$1;
I$1.withMutations = Ct$1;
I$1.wasAltered = Cr$1;
I$1.asImmutable = Ft$1;
I$1["@@transducer/init"] = I$1.asMutable = Kt;
I$1["@@transducer/step"] = function(Bi, e) {
  return Bi.push(e);
};
I$1["@@transducer/result"] = function(Bi) {
  return Bi.asImmutable();
};
var tt = function(Bi, e) {
  this.array = Bi, this.ownerID = e;
};
tt.prototype.removeBefore = function(Bi, e, Ui) {
  if (Ui === e ? 1 << e : this.array.length === 0)
    return this;
  var Zi = Ui >>> e & b$1;
  if (Zi >= this.array.length)
    return new tt([], Bi);
  var ta = Zi === 0, na;
  if (e > 0) {
    var ia = this.array[Zi];
    if (na = ia && ia.removeBefore(Bi, e - m$4, Ui), na === ia && ta)
      return this;
  }
  if (ta && !na)
    return this;
  var aa = dt$1(this, Bi);
  if (!ta)
    for (var da = 0; da < Zi; da++)
      aa.array[da] = void 0;
  return na && (aa.array[Zi] = na), aa;
};
tt.prototype.removeAfter = function(Bi, e, Ui) {
  if (Ui === (e ? 1 << e : 0) || this.array.length === 0)
    return this;
  var Zi = Ui - 1 >>> e & b$1;
  if (Zi >= this.array.length)
    return this;
  var ta;
  if (e > 0) {
    var na = this.array[Zi];
    if (ta = na && na.removeAfter(Bi, e - m$4, Ui), ta === na && Zi === this.array.length - 1)
      return this;
  }
  var ia = dt$1(this, Bi);
  return ia.array.splice(Zi + 1), ta && (ia.array[Zi] = ta), ia;
};
var Rt$1 = {};
function fe$1(Bi, e) {
  var Ui = Bi._origin, Zi = Bi._capacity, ta = Dt$1(Zi), na = Bi._tail;
  return ia(Bi._root, Bi._level, 0);
  function ia(La, qa, io) {
    return qa === 0 ? aa(La, io) : da(La, qa, io);
  }
  function aa(La, qa) {
    var io = qa === ta ? na && na.array : La && La.array, ao = qa > Ui ? 0 : Ui - qa, oo = Zi - qa;
    return oo > B$1 && (oo = B$1), function() {
      if (ao === oo)
        return Rt$1;
      var no = e ? --oo : ao++;
      return io && io[no];
    };
  }
  function da(La, qa, io) {
    var ao, oo = La && La.array, no = io > Ui ? 0 : Ui - io >> qa, lo = (Zi - io >> qa) + 1;
    return lo > B$1 && (lo = B$1), function() {
      for (; ; ) {
        if (ao) {
          var so = ao();
          if (so !== Rt$1)
            return so;
          ao = null;
        }
        if (no === lo)
          return Rt$1;
        var bs = e ? --lo : no++;
        ao = ia(
          oo && oo[bs],
          qa - m$4,
          io + (bs << qa)
        );
      }
    };
  }
}
function $t$1(Bi, e, Ui, Zi, ta, na, ia) {
  var aa = Object.create(I$1);
  return aa.size = e - Bi, aa._origin = Bi, aa._capacity = e, aa._level = Ui, aa._root = Zi, aa._tail = ta, aa.__ownerID = na, aa.__hash = ia, aa.__altered = !1, aa;
}
var he$1;
function Qt$1() {
  return he$1 || (he$1 = $t$1(0, 0, m$4));
}
function ri(Bi, e, Ui) {
  if (e = rt$1(Bi, e), e !== e)
    return Bi;
  if (e >= Bi.size || e < 0)
    return Bi.withMutations(function(ia) {
      e < 0 ? x$1(ia, e).set(0, Ui) : x$1(ia, 0, e + 1).set(e, Ui);
    });
  e += Bi._origin;
  var Zi = Bi._tail, ta = Bi._root, na = pr$1();
  return e >= Dt$1(Bi._capacity) ? Zi = Sr$1(Zi, Bi.__ownerID, 0, e, Ui, na) : ta = Sr$1(
    ta,
    Bi.__ownerID,
    Bi._level,
    e,
    Ui,
    na
  ), na.value ? Bi.__ownerID ? (Bi._root = ta, Bi._tail = Zi, Bi.__hash = void 0, Bi.__altered = !0, Bi) : $t$1(Bi._origin, Bi._capacity, Bi._level, ta, Zi) : Bi;
}
function Sr$1(Bi, e, Ui, Zi, ta, na) {
  var ia = Zi >>> Ui & b$1, aa = Bi && ia < Bi.array.length;
  if (!aa && ta === void 0)
    return Bi;
  var da;
  if (Ui > 0) {
    var La = Bi && Bi.array[ia], qa = Sr$1(
      La,
      e,
      Ui - m$4,
      Zi,
      ta,
      na
    );
    return qa === La ? Bi : (da = dt$1(Bi, e), da.array[ia] = qa, da);
  }
  return aa && Bi.array[ia] === ta ? Bi : (na && U(na), da = dt$1(Bi, e), ta === void 0 && ia === da.array.length - 1 ? da.array.pop() : da.array[ia] = ta, da);
}
function dt$1(Bi, e) {
  return e && Bi && e === Bi.ownerID ? Bi : new tt(Bi ? Bi.array.slice() : [], e);
}
function sn$1(Bi, e) {
  if (e >= Dt$1(Bi._capacity))
    return Bi._tail;
  if (e < 1 << Bi._level + m$4) {
    for (var Ui = Bi._root, Zi = Bi._level; Ui && Zi > 0; )
      Ui = Ui.array[e >>> Zi & b$1], Zi -= m$4;
    return Ui;
  }
}
function x$1(Bi, e, Ui) {
  e !== void 0 && (e |= 0), Ui !== void 0 && (Ui |= 0);
  var Zi = Bi.__ownerID || new Er$1(), ta = Bi._origin, na = Bi._capacity, ia = ta + e, aa = Ui === void 0 ? na : Ui < 0 ? na + Ui : ta + Ui;
  if (ia === ta && aa === na)
    return Bi;
  if (ia >= aa)
    return Bi.clear();
  for (var da = Bi._level, La = Bi._root, qa = 0; ia + qa < 0; )
    La = new tt(
      La && La.array.length ? [void 0, La] : [],
      Zi
    ), da += m$4, qa += 1 << da;
  qa && (ia += qa, ta += qa, aa += qa, na += qa);
  for (var io = Dt$1(na), ao = Dt$1(aa); ao >= 1 << da + m$4; )
    La = new tt(
      La && La.array.length ? [La] : [],
      Zi
    ), da += m$4;
  var oo = Bi._tail, no = ao < io ? sn$1(Bi, aa - 1) : ao > io ? new tt([], Zi) : oo;
  if (oo && ao > io && ia < na && oo.array.length) {
    La = dt$1(La, Zi);
    for (var lo = La, so = da; so > m$4; so -= m$4) {
      var bs = io >>> so & b$1;
      lo = lo.array[bs] = dt$1(lo.array[bs], Zi);
    }
    lo.array[io >>> m$4 & b$1] = oo;
  }
  if (aa < na && (no = no && no.removeAfter(Zi, 0, aa)), ia >= ao)
    ia -= ao, aa -= ao, da = m$4, La = null, no = no && no.removeBefore(Zi, 0, ia);
  else if (ia > ta || ao < io) {
    for (qa = 0; La; ) {
      var Rs = ia >>> da & b$1;
      if (Rs !== ao >>> da & b$1)
        break;
      Rs && (qa += (1 << da) * Rs), da -= m$4, La = La.array[Rs];
    }
    La && ia > ta && (La = La.removeBefore(Zi, da, ia - qa)), La && ao < io && (La = La.removeAfter(
      Zi,
      da,
      ao - qa
    )), qa && (ia -= qa, aa -= qa);
  }
  return Bi.__ownerID ? (Bi.size = aa - ia, Bi._origin = ia, Bi._capacity = aa, Bi._level = da, Bi._root = La, Bi._tail = no, Bi.__hash = void 0, Bi.__altered = !0, Bi) : $t$1(ia, aa, da, La, no);
}
function Dt$1(Bi) {
  return Bi < B$1 ? 0 : Bi - 1 >>> m$4 << m$4;
}
var V = /* @__PURE__ */ function(Bi) {
  function e(Ui) {
    return Ui == null ? qt$1() : $e(Ui) ? Ui : qt$1().withMutations(function(Zi) {
      var ta = K(Ui);
      P$2(ta.size), ta.forEach(function(na, ia) {
        return Zi.set(ia, na);
      });
    });
  }
  return Bi && (e.__proto__ = Bi), e.prototype = Object.create(Bi && Bi.prototype), e.prototype.constructor = e, e.of = function() {
    return this(arguments);
  }, e.prototype.toString = function() {
    return this.__toString("OrderedMap {", "}");
  }, e.prototype.get = function(Ui, Zi) {
    var ta = this._map.get(Ui);
    return ta !== void 0 ? this._list.get(ta)[1] : Zi;
  }, e.prototype.clear = function() {
    return this.size === 0 ? this : this.__ownerID ? (this.size = 0, this._map.clear(), this._list.clear(), this.__altered = !0, this) : qt$1();
  }, e.prototype.set = function(Ui, Zi) {
    return _e(this, Ui, Zi);
  }, e.prototype.remove = function(Ui) {
    return _e(this, Ui, y$2);
  }, e.prototype.__iterate = function(Ui, Zi) {
    var ta = this;
    return this._list.__iterate(
      function(na) {
        return na && Ui(na[1], na[0], ta);
      },
      Zi
    );
  }, e.prototype.__iterator = function(Ui, Zi) {
    return this._list.fromEntrySeq().__iterator(Ui, Zi);
  }, e.prototype.__ensureOwner = function(Ui) {
    if (Ui === this.__ownerID)
      return this;
    var Zi = this._map.__ensureOwner(Ui), ta = this._list.__ensureOwner(Ui);
    return Ui ? Yr$1(Zi, ta, Ui, this.__hash) : this.size === 0 ? qt$1() : (this.__ownerID = Ui, this.__altered = !1, this._map = Zi, this._list = ta, this);
  }, e;
}(zt$1);
V.isOrderedMap = $e;
V.prototype[mt$1] = !0;
V.prototype[Bt$1] = V.prototype.remove;
function Yr$1(Bi, e, Ui, Zi) {
  var ta = Object.create(V.prototype);
  return ta.size = Bi ? Bi.size : 0, ta._map = Bi, ta._list = e, ta.__ownerID = Ui, ta.__hash = Zi, ta.__altered = !1, ta;
}
var ce$1;
function qt$1() {
  return ce$1 || (ce$1 = Yr$1(F(), Qt$1()));
}
function _e(Bi, e, Ui) {
  var Zi = Bi._map, ta = Bi._list, na = Zi.get(e), ia = na !== void 0, aa, da;
  if (Ui === y$2) {
    if (!ia)
      return Bi;
    ta.size >= B$1 && ta.size >= Zi.size * 2 ? (da = ta.filter(function(La, qa) {
      return La !== void 0 && na !== qa;
    }), aa = da.toKeyedSeq().map(function(La) {
      return La[0];
    }).flip().toMap(), Bi.__ownerID && (aa.__ownerID = da.__ownerID = Bi.__ownerID)) : (aa = Zi.remove(e), da = na === ta.size - 1 ? ta.pop() : ta.set(na, void 0));
  } else if (ia) {
    if (Ui === ta.get(na)[1])
      return Bi;
    aa = Zi, da = ta.set(na, [e, Ui]);
  } else
    aa = Zi.set(e, ta.size), da = ta.set(ta.size, [e, Ui]);
  return Bi.__ownerID ? (Bi.size = aa.size, Bi._map = aa, Bi._list = da, Bi.__hash = void 0, Bi.__altered = !0, Bi) : Yr$1(aa, da);
}
var an$1 = "@@__IMMUTABLE_STACK__@@";
function mr$1(Bi) {
  return !!(Bi && Bi[an$1]);
}
var Hr$1 = /* @__PURE__ */ function(Bi) {
  function e(Ui) {
    return Ui == null ? Xt$1() : mr$1(Ui) ? Ui : Xt$1().pushAll(Ui);
  }
  return Bi && (e.__proto__ = Bi), e.prototype = Object.create(Bi && Bi.prototype), e.prototype.constructor = e, e.of = function() {
    return this(arguments);
  }, e.prototype.toString = function() {
    return this.__toString("Stack [", "]");
  }, e.prototype.get = function(Ui, Zi) {
    var ta = this._head;
    for (Ui = rt$1(this, Ui); ta && Ui--; )
      ta = ta.next;
    return ta ? ta.value : Zi;
  }, e.prototype.peek = function() {
    return this._head && this._head.value;
  }, e.prototype.push = function() {
    var Ui = arguments;
    if (arguments.length === 0)
      return this;
    for (var Zi = this.size + arguments.length, ta = this._head, na = arguments.length - 1; na >= 0; na--)
      ta = {
        value: Ui[na],
        next: ta
      };
    return this.__ownerID ? (this.size = Zi, this._head = ta, this.__hash = void 0, this.__altered = !0, this) : At$1(Zi, ta);
  }, e.prototype.pushAll = function(Ui) {
    if (Ui = Bi(Ui), Ui.size === 0)
      return this;
    if (this.size === 0 && mr$1(Ui))
      return Ui;
    P$2(Ui.size);
    var Zi = this.size, ta = this._head;
    return Ui.__iterate(function(na) {
      Zi++, ta = {
        value: na,
        next: ta
      };
    }, !0), this.__ownerID ? (this.size = Zi, this._head = ta, this.__hash = void 0, this.__altered = !0, this) : At$1(Zi, ta);
  }, e.prototype.pop = function() {
    return this.slice(1);
  }, e.prototype.clear = function() {
    return this.size === 0 ? this : this.__ownerID ? (this.size = 0, this._head = void 0, this.__hash = void 0, this.__altered = !0, this) : Xt$1();
  }, e.prototype.slice = function(Ui, Zi) {
    if (tr$1(Ui, Zi, this.size))
      return this;
    var ta = Ut$1(Ui, this.size), na = rr(Zi, this.size);
    if (na !== this.size)
      return Bi.prototype.slice.call(this, Ui, Zi);
    for (var ia = this.size - ta, aa = this._head; ta--; )
      aa = aa.next;
    return this.__ownerID ? (this.size = ia, this._head = aa, this.__hash = void 0, this.__altered = !0, this) : At$1(ia, aa);
  }, e.prototype.__ensureOwner = function(Ui) {
    return Ui === this.__ownerID ? this : Ui ? At$1(this.size, this._head, Ui, this.__hash) : this.size === 0 ? Xt$1() : (this.__ownerID = Ui, this.__altered = !1, this);
  }, e.prototype.__iterate = function(Ui, Zi) {
    var ta = this;
    if (Zi)
      return new st$1(this.toArray()).__iterate(
        function(aa, da) {
          return Ui(aa, da, ta);
        },
        Zi
      );
    for (var na = 0, ia = this._head; ia && Ui(ia.value, na++, this) !== !1; )
      ia = ia.next;
    return na;
  }, e.prototype.__iterator = function(Ui, Zi) {
    if (Zi)
      return new st$1(this.toArray()).__iterator(Ui, Zi);
    var ta = 0, na = this._head;
    return new l$6(function() {
      if (na) {
        var ia = na.value;
        return na = na.next, E$1(Ui, ta++, ia);
      }
      return j();
    });
  }, e;
}(at);
Hr$1.isStack = mr$1;
var R$1 = Hr$1.prototype;
R$1[an$1] = !0;
R$1.shift = R$1.pop;
R$1.unshift = R$1.push;
R$1.unshiftAll = R$1.pushAll;
R$1.withMutations = Ct$1;
R$1.wasAltered = Cr$1;
R$1.asImmutable = Ft$1;
R$1["@@transducer/init"] = R$1.asMutable = Kt;
R$1["@@transducer/step"] = function(Bi, e) {
  return Bi.unshift(e);
};
R$1["@@transducer/result"] = function(Bi) {
  return Bi.asImmutable();
};
function At$1(Bi, e, Ui, Zi) {
  var ta = Object.create(R$1);
  return ta.size = Bi, ta._head = e, ta.__ownerID = Ui, ta.__hash = Zi, ta.__altered = !1, ta;
}
var pe$1;
function Xt$1() {
  return pe$1 || (pe$1 = At$1(0));
}
var fn$1 = "@@__IMMUTABLE_SET__@@";
function Jr$1(Bi) {
  return !!(Bi && Bi[fn$1]);
}
function hn$1(Bi) {
  return Jr$1(Bi) && W$1(Bi);
}
function cn$1(Bi, e) {
  if (Bi === e)
    return !0;
  if (!L$1(e) || Bi.size !== void 0 && e.size !== void 0 && Bi.size !== e.size || Bi.__hash !== void 0 && e.__hash !== void 0 && Bi.__hash !== e.__hash || O$1(Bi) !== O$1(e) || T$1(Bi) !== T$1(e) || W$1(Bi) !== W$1(e))
    return !1;
  if (Bi.size === 0 && e.size === 0)
    return !0;
  var Ui = !er$1(Bi);
  if (W$1(Bi)) {
    var Zi = Bi.entries();
    return e.every(function(da, La) {
      var qa = Zi.next().value;
      return qa && D(qa[1], da) && (Ui || D(qa[0], La));
    }) && Zi.next().done;
  }
  var ta = !1;
  if (Bi.size === void 0)
    if (e.size === void 0)
      typeof Bi.cacheResult == "function" && Bi.cacheResult();
    else {
      ta = !0;
      var na = Bi;
      Bi = e, e = na;
    }
  var ia = !0, aa = e.__iterate(function(da, La) {
    if (Ui ? !Bi.has(da) : ta ? !D(da, Bi.get(La, y$2)) : !D(Bi.get(La, y$2), da))
      return ia = !1, !1;
  });
  return ia && Bi.size === aa;
}
function ft$1(Bi, e) {
  var Ui = function(Zi) {
    Bi.prototype[Zi] = e[Zi];
  };
  return Object.keys(e).forEach(Ui), Object.getOwnPropertySymbols && Object.getOwnPropertySymbols(e).forEach(Ui), Bi;
}
function xt$1(Bi) {
  if (!Bi || typeof Bi != "object")
    return Bi;
  if (!L$1(Bi)) {
    if (!et$1(Bi))
      return Bi;
    Bi = N(Bi);
  }
  if (O$1(Bi)) {
    var e = {};
    return Bi.__iterate(function(Zi, ta) {
      e[ta] = xt$1(Zi);
    }), e;
  }
  var Ui = [];
  return Bi.__iterate(function(Zi) {
    Ui.push(xt$1(Zi));
  }), Ui;
}
var Wt$1 = /* @__PURE__ */ function(Bi) {
  function e(Ui) {
    return Ui == null ? bt$1() : Jr$1(Ui) && !W$1(Ui) ? Ui : bt$1().withMutations(function(Zi) {
      var ta = Bi(Ui);
      P$2(ta.size), ta.forEach(function(na) {
        return Zi.add(na);
      });
    });
  }
  return Bi && (e.__proto__ = Bi), e.prototype = Object.create(Bi && Bi.prototype), e.prototype.constructor = e, e.of = function() {
    return this(arguments);
  }, e.fromKeys = function(Ui) {
    return this(K(Ui).keySeq());
  }, e.intersect = function(Ui) {
    return Ui = z(Ui).toArray(), Ui.length ? q.intersect.apply(e(Ui.pop()), Ui) : bt$1();
  }, e.union = function(Ui) {
    return Ui = z(Ui).toArray(), Ui.length ? q.union.apply(e(Ui.pop()), Ui) : bt$1();
  }, e.prototype.toString = function() {
    return this.__toString("Set {", "}");
  }, e.prototype.has = function(Ui) {
    return this._map.has(Ui);
  }, e.prototype.add = function(Ui) {
    return Zt$1(this, this._map.set(Ui, Ui));
  }, e.prototype.remove = function(Ui) {
    return Zt$1(this, this._map.remove(Ui));
  }, e.prototype.clear = function() {
    return Zt$1(this, this._map.clear());
  }, e.prototype.map = function(Ui, Zi) {
    var ta = this, na = !1, ia = Zt$1(
      this,
      this._map.mapEntries(function(aa) {
        var da = aa[1], La = Ui.call(Zi, da, da, ta);
        return La !== da && (na = !0), [La, La];
      }, Zi)
    );
    return na ? ia : this;
  }, e.prototype.union = function() {
    for (var Ui = [], Zi = arguments.length; Zi--; )
      Ui[Zi] = arguments[Zi];
    return Ui = Ui.filter(function(ta) {
      return ta.size !== 0;
    }), Ui.length === 0 ? this : this.size === 0 && !this.__ownerID && Ui.length === 1 ? this.constructor(Ui[0]) : this.withMutations(function(ta) {
      for (var na = 0; na < Ui.length; na++)
        Bi(Ui[na]).forEach(function(ia) {
          return ta.add(ia);
        });
    });
  }, e.prototype.intersect = function() {
    for (var Ui = [], Zi = arguments.length; Zi--; )
      Ui[Zi] = arguments[Zi];
    if (Ui.length === 0)
      return this;
    Ui = Ui.map(function(na) {
      return Bi(na);
    });
    var ta = [];
    return this.forEach(function(na) {
      Ui.every(function(ia) {
        return ia.includes(na);
      }) || ta.push(na);
    }), this.withMutations(function(na) {
      ta.forEach(function(ia) {
        na.remove(ia);
      });
    });
  }, e.prototype.subtract = function() {
    for (var Ui = [], Zi = arguments.length; Zi--; )
      Ui[Zi] = arguments[Zi];
    if (Ui.length === 0)
      return this;
    Ui = Ui.map(function(na) {
      return Bi(na);
    });
    var ta = [];
    return this.forEach(function(na) {
      Ui.some(function(ia) {
        return ia.includes(na);
      }) && ta.push(na);
    }), this.withMutations(function(na) {
      ta.forEach(function(ia) {
        na.remove(ia);
      });
    });
  }, e.prototype.sort = function(Ui) {
    return Nt$1(_t$1(this, Ui));
  }, e.prototype.sortBy = function(Ui, Zi) {
    return Nt$1(_t$1(this, Zi, Ui));
  }, e.prototype.wasAltered = function() {
    return this._map.wasAltered();
  }, e.prototype.__iterate = function(Ui, Zi) {
    var ta = this;
    return this._map.__iterate(function(na) {
      return Ui(na, na, ta);
    }, Zi);
  }, e.prototype.__iterator = function(Ui, Zi) {
    return this._map.__iterator(Ui, Zi);
  }, e.prototype.__ensureOwner = function(Ui) {
    if (Ui === this.__ownerID)
      return this;
    var Zi = this._map.__ensureOwner(Ui);
    return Ui ? this.__make(Zi, Ui) : this.size === 0 ? this.__empty() : (this.__ownerID = Ui, this._map = Zi, this);
  }, e;
}(gt$1);
Wt$1.isSet = Jr$1;
var q = Wt$1.prototype;
q[fn$1] = !0;
q[Bt$1] = q.remove;
q.merge = q.concat = q.union;
q.withMutations = Ct$1;
q.asImmutable = Ft$1;
q["@@transducer/init"] = q.asMutable = Kt;
q["@@transducer/step"] = function(Bi, e) {
  return Bi.add(e);
};
q["@@transducer/result"] = function(Bi) {
  return Bi.asImmutable();
};
q.__empty = bt$1;
q.__make = _n$1;
function Zt$1(Bi, e) {
  return Bi.__ownerID ? (Bi.size = e.size, Bi._map = e, Bi) : e === Bi._map ? Bi : e.size === 0 ? Bi.__empty() : Bi.__make(e);
}
function _n$1(Bi, e) {
  var Ui = Object.create(q);
  return Ui.size = Bi ? Bi.size : 0, Ui._map = Bi, Ui.__ownerID = e, Ui;
}
var ve$1;
function bt$1() {
  return ve$1 || (ve$1 = _n$1(F()));
}
var ei$1 = /* @__PURE__ */ function(Bi) {
  function e(Ui, Zi, ta) {
    if (!(this instanceof e))
      return new e(Ui, Zi, ta);
    if (Lr(ta !== 0, "Cannot step a Range by 0"), Ui = Ui || 0, Zi === void 0 && (Zi = 1 / 0), ta = ta === void 0 ? 1 : Math.abs(ta), Zi < Ui && (ta = -ta), this._start = Ui, this._end = Zi, this._step = ta, this.size = Math.max(0, Math.ceil((Zi - Ui) / ta - 1) + 1), this.size === 0) {
      if (_r$1)
        return _r$1;
      _r$1 = this;
    }
  }
  return Bi && (e.__proto__ = Bi), e.prototype = Object.create(Bi && Bi.prototype), e.prototype.constructor = e, e.prototype.toString = function() {
    return this.size === 0 ? "Range []" : "Range [ " + this._start + "..." + this._end + (this._step !== 1 ? " by " + this._step : "") + " ]";
  }, e.prototype.get = function(Ui, Zi) {
    return this.has(Ui) ? this._start + rt$1(this, Ui) * this._step : Zi;
  }, e.prototype.includes = function(Ui) {
    var Zi = (Ui - this._start) / this._step;
    return Zi >= 0 && Zi < this.size && Zi === Math.floor(Zi);
  }, e.prototype.slice = function(Ui, Zi) {
    return tr$1(Ui, Zi, this.size) ? this : (Ui = Ut$1(Ui, this.size), Zi = rr(Zi, this.size), Zi <= Ui ? new e(0, 0) : new e(
      this.get(Ui, this._end),
      this.get(Zi, this._end),
      this._step
    ));
  }, e.prototype.indexOf = function(Ui) {
    var Zi = Ui - this._start;
    if (Zi % this._step === 0) {
      var ta = Zi / this._step;
      if (ta >= 0 && ta < this.size)
        return ta;
    }
    return -1;
  }, e.prototype.lastIndexOf = function(Ui) {
    return this.indexOf(Ui);
  }, e.prototype.__iterate = function(Ui, Zi) {
    for (var ta = this.size, na = this._step, ia = Zi ? this._start + (ta - 1) * na : this._start, aa = 0; aa !== ta && Ui(ia, Zi ? ta - ++aa : aa++, this) !== !1; )
      ia += Zi ? -na : na;
    return aa;
  }, e.prototype.__iterator = function(Ui, Zi) {
    var ta = this.size, na = this._step, ia = Zi ? this._start + (ta - 1) * na : this._start, aa = 0;
    return new l$6(function() {
      if (aa === ta)
        return j();
      var da = ia;
      return ia += Zi ? -na : na, E$1(Ui, Zi ? ta - ++aa : aa++, da);
    });
  }, e.prototype.equals = function(Ui) {
    return Ui instanceof e ? this._start === Ui._start && this._end === Ui._end && this._step === Ui._step : cn$1(this, Ui);
  }, e;
}(H$2), _r$1;
function pn$1(Bi, e, Ui) {
  for (var Zi = Je$1(e), ta = 0; ta !== Zi.length; )
    if (Bi = Xe$1(Bi, Zi[ta++], y$2), Bi === y$2)
      return Ui;
  return Bi;
}
function vn$1(Bi, e) {
  return pn$1(this, Bi, e);
}
function ni$1(Bi, e) {
  return pn$1(Bi, e, y$2) !== y$2;
}
function ii(Bi) {
  return ni$1(this, Bi);
}
function dn() {
  P$2(this.size);
  var Bi = {};
  return this.__iterate(function(e, Ui) {
    Bi[Ui] = e;
  }), Bi;
}
z.isIterable = L$1;
z.isKeyed = O$1;
z.isIndexed = T$1;
z.isAssociative = er$1;
z.isOrdered = W$1;
z.Iterator = l$6;
ft$1(z, {
  toArray: function() {
    P$2(this.size);
    var Bi = new Array(this.size || 0), e = O$1(this), Ui = 0;
    return this.__iterate(function(Zi, ta) {
      Bi[Ui++] = e ? [ta, Zi] : Zi;
    }), Bi;
  },
  toIndexedSeq: function() {
    return new Ne$1(this);
  },
  toJS: function() {
    return xt$1(this);
  },
  toKeyedSeq: function() {
    return new or$1(this, !0);
  },
  toMap: function() {
    return zt$1(this.toKeyedSeq());
  },
  toObject: dn,
  toOrderedMap: function() {
    return V(this.toKeyedSeq());
  },
  toOrderedSet: function() {
    return Nt$1(O$1(this) ? this.valueSeq() : this);
  },
  toSet: function() {
    return Wt$1(O$1(this) ? this.valueSeq() : this);
  },
  toSetSeq: function() {
    return new Be$1(this);
  },
  toSeq: function() {
    return T$1(this) ? this.toIndexedSeq() : O$1(this) ? this.toKeyedSeq() : this.toSetSeq();
  },
  toStack: function() {
    return Hr$1(O$1(this) ? this.valueSeq() : this);
  },
  toList: function() {
    return sr$1(O$1(this) ? this.valueSeq() : this);
  },
  toString: function() {
    return "[Collection]";
  },
  __toString: function(Bi, e) {
    return this.size === 0 ? Bi + e : Bi + " " + this.toSeq().map(this.__toStringMapper).join(", ") + " " + e;
  },
  concat: function() {
    for (var Bi = [], e = arguments.length; e--; )
      Bi[e] = arguments[e];
    return g$2(this, kn$1(this, Bi));
  },
  includes: function(Bi) {
    return this.some(function(e) {
      return D(e, Bi);
    });
  },
  entries: function() {
    return this.__iterator(C$1);
  },
  every: function(Bi, e) {
    P$2(this.size);
    var Ui = !0;
    return this.__iterate(function(Zi, ta, na) {
      if (!Bi.call(e, Zi, ta, na))
        return Ui = !1, !1;
    }), Ui;
  },
  filter: function(Bi, e) {
    return g$2(this, Ke$1(this, Bi, e, !0));
  },
  find: function(Bi, e, Ui) {
    var Zi = this.findEntry(Bi, e);
    return Zi ? Zi[1] : Ui;
  },
  forEach: function(Bi, e) {
    return P$2(this.size), this.__iterate(e ? Bi.bind(e) : Bi);
  },
  join: function(Bi) {
    P$2(this.size), Bi = Bi !== void 0 ? "" + Bi : ",";
    var e = "", Ui = !0;
    return this.__iterate(function(Zi) {
      Ui ? Ui = !1 : e += Bi, e += Zi != null ? Zi.toString() : "";
    }), e;
  },
  keys: function() {
    return this.__iterator(Pt$1);
  },
  map: function(Bi, e) {
    return g$2(this, Ce$1(this, Bi, e));
  },
  reduce: function(Bi, e, Ui) {
    return de$1(
      this,
      Bi,
      e,
      Ui,
      arguments.length < 2,
      !1
    );
  },
  reduceRight: function(Bi, e, Ui) {
    return de$1(
      this,
      Bi,
      e,
      Ui,
      arguments.length < 2,
      !0
    );
  },
  reverse: function() {
    return g$2(this, br$1(this, !0));
  },
  slice: function(Bi, e) {
    return g$2(this, Rr$1(this, Bi, e, !0));
  },
  some: function(Bi, e) {
    return !this.every(Gt$1(Bi), e);
  },
  sort: function(Bi) {
    return g$2(this, _t$1(this, Bi));
  },
  values: function() {
    return this.__iterator(Y$1);
  },
  butLast: function() {
    return this.slice(0, -1);
  },
  isEmpty: function() {
    return this.size !== void 0 ? this.size === 0 : !this.some(function() {
      return !0;
    });
  },
  count: function(Bi, e) {
    return ct$1(
      Bi ? this.toSeq().filter(Bi, e) : this
    );
  },
  countBy: function(Bi, e) {
    return Tn$1(this, Bi, e);
  },
  equals: function(Bi) {
    return cn$1(this, Bi);
  },
  entrySeq: function() {
    var Bi = this;
    if (Bi._cache)
      return new st$1(Bi._cache);
    var e = Bi.toSeq().map(oi$1).toIndexedSeq();
    return e.fromEntrySeq = function() {
      return Bi.toSeq();
    }, e;
  },
  filterNot: function(Bi, e) {
    return this.filter(Gt$1(Bi), e);
  },
  findEntry: function(Bi, e, Ui) {
    var Zi = Ui;
    return this.__iterate(function(ta, na, ia) {
      if (Bi.call(e, ta, na, ia))
        return Zi = [na, ta], !1;
    }), Zi;
  },
  findKey: function(Bi, e) {
    var Ui = this.findEntry(Bi, e);
    return Ui && Ui[0];
  },
  findLast: function(Bi, e, Ui) {
    return this.toKeyedSeq().reverse().find(Bi, e, Ui);
  },
  findLastEntry: function(Bi, e, Ui) {
    return this.toKeyedSeq().reverse().findEntry(Bi, e, Ui);
  },
  findLastKey: function(Bi, e) {
    return this.toKeyedSeq().reverse().findKey(Bi, e);
  },
  first: function(Bi) {
    return this.find(Ee$1, null, Bi);
  },
  flatMap: function(Bi, e) {
    return g$2(this, $n$1(this, Bi, e));
  },
  flatten: function(Bi) {
    return g$2(this, We$1(this, Bi, !0));
  },
  fromEntrySeq: function() {
    return new Ue$1(this);
  },
  get: function(Bi, e) {
    return this.find(function(Ui, Zi) {
      return D(Zi, Bi);
    }, void 0, e);
  },
  getIn: vn$1,
  groupBy: function(Bi, e) {
    return Ln$1(this, Bi, e);
  },
  has: function(Bi) {
    return this.get(Bi, y$2) !== y$2;
  },
  hasIn: ii,
  isSubset: function(Bi) {
    return Bi = typeof Bi.includes == "function" ? Bi : z(Bi), this.every(function(e) {
      return Bi.includes(e);
    });
  },
  isSuperset: function(Bi) {
    return Bi = typeof Bi.isSubset == "function" ? Bi : z(Bi), Bi.isSubset(this);
  },
  keyOf: function(Bi) {
    return this.findKey(function(e) {
      return D(e, Bi);
    });
  },
  keySeq: function() {
    return this.toSeq().map(ui$1).toIndexedSeq();
  },
  last: function(Bi) {
    return this.toSeq().reverse().first(Bi);
  },
  lastKeyOf: function(Bi) {
    return this.toKeyedSeq().reverse().keyOf(Bi);
  },
  max: function(Bi) {
    return Ht$1(this, Bi);
  },
  maxBy: function(Bi, e) {
    return Ht$1(this, e, Bi);
  },
  min: function(Bi) {
    return Ht$1(
      this,
      Bi ? ye$1(Bi) : ge$1
    );
  },
  minBy: function(Bi, e) {
    return Ht$1(
      this,
      e ? ye$1(e) : ge$1,
      Bi
    );
  },
  rest: function() {
    return this.slice(1);
  },
  skip: function(Bi) {
    return Bi === 0 ? this : this.slice(Math.max(0, Bi));
  },
  skipLast: function(Bi) {
    return Bi === 0 ? this : this.slice(0, -Math.max(0, Bi));
  },
  skipWhile: function(Bi, e) {
    return g$2(this, Fe$1(this, Bi, e, !0));
  },
  skipUntil: function(Bi, e) {
    return this.skipWhile(Gt$1(Bi), e);
  },
  sortBy: function(Bi, e) {
    return g$2(this, _t$1(this, e, Bi));
  },
  take: function(Bi) {
    return this.slice(0, Math.max(0, Bi));
  },
  takeLast: function(Bi) {
    return this.slice(-Math.max(0, Bi));
  },
  takeWhile: function(Bi, e) {
    return g$2(this, jn$1(this, Bi, e));
  },
  takeUntil: function(Bi, e) {
    return this.takeWhile(Gt$1(Bi), e);
  },
  update: function(Bi) {
    return Bi(this);
  },
  valueSeq: function() {
    return this.toIndexedSeq();
  },
  hashCode: function() {
    return this.__hash || (this.__hash = si$1(this));
  }
});
var A$1 = z.prototype;
A$1[Ie$1] = !0;
A$1[nr$1] = A$1.values;
A$1.toJSON = A$1.toArray;
A$1.__toStringMapper = Lt$1;
A$1.inspect = A$1.toSource = function() {
  return this.toString();
};
A$1.chain = A$1.flatMap;
A$1.contains = A$1.includes;
ft$1(K, {
  flip: function() {
    return g$2(this, Pe$1(this));
  },
  mapEntries: function(Bi, e) {
    var Ui = this, Zi = 0;
    return g$2(
      this,
      this.toSeq().map(function(ta, na) {
        return Bi.call(e, [na, ta], Zi++, Ui);
      }).fromEntrySeq()
    );
  },
  mapKeys: function(Bi, e) {
    var Ui = this;
    return g$2(
      this,
      this.toSeq().flip().map(function(Zi, ta) {
        return Bi.call(e, Zi, ta, Ui);
      }).flip()
    );
  }
});
var Yt$1 = K.prototype;
Yt$1[Me$1] = !0;
Yt$1[nr$1] = A$1.entries;
Yt$1.toJSON = dn;
Yt$1.__toStringMapper = function(Bi, e) {
  return Lt$1(e) + ": " + Lt$1(Bi);
};
ft$1(at, {
  toKeyedSeq: function() {
    return new or$1(this, !1);
  },
  filter: function(Bi, e) {
    return g$2(this, Ke$1(this, Bi, e, !1));
  },
  findIndex: function(Bi, e) {
    var Ui = this.findEntry(Bi, e);
    return Ui ? Ui[0] : -1;
  },
  indexOf: function(Bi) {
    var e = this.keyOf(Bi);
    return e === void 0 ? -1 : e;
  },
  lastIndexOf: function(Bi) {
    var e = this.lastKeyOf(Bi);
    return e === void 0 ? -1 : e;
  },
  reverse: function() {
    return g$2(this, br$1(this, !1));
  },
  slice: function(Bi, e) {
    return g$2(this, Rr$1(this, Bi, e, !1));
  },
  splice: function(Bi, e) {
    var Ui = arguments.length;
    if (e = Math.max(e || 0, 0), Ui === 0 || Ui === 2 && !e)
      return this;
    Bi = Ut$1(Bi, Bi < 0 ? this.count() : this.size);
    var Zi = this.slice(0, Bi);
    return g$2(
      this,
      Ui === 1 ? Zi : Zi.concat(X$1(arguments, 2), this.slice(Bi + e))
    );
  },
  findLastIndex: function(Bi, e) {
    var Ui = this.findLastEntry(Bi, e);
    return Ui ? Ui[0] : -1;
  },
  first: function(Bi) {
    return this.get(0, Bi);
  },
  flatten: function(Bi) {
    return g$2(this, We$1(this, Bi, !1));
  },
  get: function(Bi, e) {
    return Bi = rt$1(this, Bi), Bi < 0 || this.size === 1 / 0 || this.size !== void 0 && Bi > this.size ? e : this.find(function(Ui, Zi) {
      return Zi === Bi;
    }, void 0, e);
  },
  has: function(Bi) {
    return Bi = rt$1(this, Bi), Bi >= 0 && (this.size !== void 0 ? this.size === 1 / 0 || Bi < this.size : this.indexOf(Bi) !== -1);
  },
  interpose: function(Bi) {
    return g$2(this, Dn$1(this, Bi));
  },
  interleave: function() {
    var Bi = [this].concat(X$1(arguments)), e = Jt(this.toSeq(), H$2.of, Bi), Ui = e.flatten(!0);
    return e.size && (Ui.size = e.size * Bi.length), g$2(this, Ui);
  },
  keySeq: function() {
    return ei$1(0, this.size);
  },
  last: function(Bi) {
    return this.get(-1, Bi);
  },
  skipWhile: function(Bi, e) {
    return g$2(this, Fe$1(this, Bi, e, !1));
  },
  zip: function() {
    var Bi = [this].concat(X$1(arguments));
    return g$2(this, Jt(this, le, Bi));
  },
  zipAll: function() {
    var Bi = [this].concat(X$1(arguments));
    return g$2(this, Jt(this, le, Bi, !0));
  },
  zipWith: function(Bi) {
    var e = X$1(arguments);
    return e[0] = this, g$2(this, Jt(this, Bi, e));
  }
});
var It$1 = at.prototype;
It$1[qe$1] = !0;
It$1[mt$1] = !0;
ft$1(gt$1, {
  get: function(Bi, e) {
    return this.has(Bi) ? Bi : e;
  },
  includes: function(Bi) {
    return this.has(Bi);
  },
  keySeq: function() {
    return this.valueSeq();
  }
});
var yt$1 = gt$1.prototype;
yt$1.has = A$1.includes;
yt$1.contains = yt$1.includes;
yt$1.keys = yt$1.values;
ft$1(it$1, Yt$1);
ft$1(H$2, It$1);
ft$1(Et$1, yt$1);
function de$1(Bi, e, Ui, Zi, ta, na) {
  return P$2(Bi.size), Bi.__iterate(function(ia, aa, da) {
    ta ? (ta = !1, Ui = ia) : Ui = e.call(Zi, Ui, ia, aa, da);
  }, na), Ui;
}
function ui$1(Bi, e) {
  return e;
}
function oi$1(Bi, e) {
  return [e, Bi];
}
function Gt$1(Bi) {
  return function() {
    return !Bi.apply(this, arguments);
  };
}
function ye$1(Bi) {
  return function() {
    return -Bi.apply(this, arguments);
  };
}
function le() {
  return X$1(arguments);
}
function ge$1(Bi, e) {
  return Bi < e ? 1 : Bi > e ? -1 : 0;
}
function si$1(Bi) {
  if (Bi.size === 1 / 0)
    return 0;
  var e = W$1(Bi), Ui = O$1(Bi), Zi = e ? 1 : 0, ta = Bi.__iterate(
    Ui ? e ? function(na, ia) {
      Zi = 31 * Zi + Se$1($(na), $(ia)) | 0;
    } : function(na, ia) {
      Zi = Zi + Se$1($(na), $(ia)) | 0;
    } : e ? function(na) {
      Zi = 31 * Zi + $(na) | 0;
    } : function(na) {
      Zi = Zi + $(na) | 0;
    }
  );
  return ai(ta, Zi);
}
function ai(Bi, e) {
  return e = Mt$1(e, 3432918353), e = Mt$1(e << 15 | e >>> -15, 461845907), e = Mt$1(e << 13 | e >>> -13, 5), e = (e + 3864292196 | 0) ^ Bi, e = Mt$1(e ^ e >>> 16, 2246822507), e = Mt$1(e ^ e >>> 13, 3266489909), e = ur$1(e ^ e >>> 16), e;
}
function Se$1(Bi, e) {
  return Bi ^ e + 2654435769 + (Bi << 6) + (Bi >> 2) | 0;
}
var Nt$1 = /* @__PURE__ */ function(Bi) {
  function e(Ui) {
    return Ui == null ? wr$1() : hn$1(Ui) ? Ui : wr$1().withMutations(function(Zi) {
      var ta = gt$1(Ui);
      P$2(ta.size), ta.forEach(function(na) {
        return Zi.add(na);
      });
    });
  }
  return Bi && (e.__proto__ = Bi), e.prototype = Object.create(Bi && Bi.prototype), e.prototype.constructor = e, e.of = function() {
    return this(arguments);
  }, e.fromKeys = function(Ui) {
    return this(K(Ui).keySeq());
  }, e.prototype.toString = function() {
    return this.__toString("OrderedSet {", "}");
  }, e;
}(Wt$1);
Nt$1.isOrderedSet = hn$1;
var ht$1 = Nt$1.prototype;
ht$1[mt$1] = !0;
ht$1.zip = It$1.zip;
ht$1.zipWith = It$1.zipWith;
ht$1.zipAll = It$1.zipAll;
ht$1.__empty = wr$1;
ht$1.__make = yn$1;
function yn$1(Bi, e) {
  var Ui = Object.create(ht$1);
  return Ui.size = Bi ? Bi.size : 0, Ui._map = Bi, Ui.__ownerID = e, Ui;
}
var me$1;
function wr$1() {
  return me$1 || (me$1 = yn$1(qt$1()));
}
function fi$1(Bi) {
  if (St$1(Bi))
    throw new Error(
      "Can not call `Record` with an immutable Record as default values. Use a plain javascript object instead."
    );
  if (Z$1(Bi))
    throw new Error(
      "Can not call `Record` with an immutable Collection as default values. Use a plain javascript object instead."
    );
  if (Bi === null || typeof Bi != "object")
    throw new Error(
      "Can not call `Record` with a non-object as default values. Use a plain javascript object instead."
    );
}
var M$1 = function(Bi, e) {
  var Ui;
  fi$1(Bi);
  var Zi = function(na) {
    var ia = this;
    if (na instanceof Zi)
      return na;
    if (!(this instanceof Zi))
      return new Zi(na);
    if (!Ui) {
      Ui = !0;
      var aa = Object.keys(Bi), da = ta._indices = {};
      ta._name = e, ta._keys = aa, ta._defaultValues = Bi;
      for (var La = 0; La < aa.length; La++) {
        var qa = aa[La];
        da[qa] = La, ta[qa] ? typeof console == "object" && console.warn && console.warn(
          "Cannot define " + Zr$1(this) + ' with property "' + qa + '" since that property name is part of the Record API.'
        ) : hi$1(ta, qa);
      }
    }
    return this.__ownerID = void 0, this._values = sr$1().withMutations(function(io) {
      io.setSize(ia._keys.length), K(na).forEach(function(ao, oo) {
        io.set(ia._indices[oo], ao === ia._defaultValues[oo] ? void 0 : ao);
      });
    }), this;
  }, ta = Zi.prototype = Object.create(S);
  return ta.constructor = Zi, e && (Zi.displayName = e), Zi;
};
M$1.prototype.toString = function() {
  for (var Bi = Zr$1(this) + " { ", e = this._keys, Ui, Zi = 0, ta = e.length; Zi !== ta; Zi++)
    Ui = e[Zi], Bi += (Zi ? ", " : "") + Ui + ": " + Lt$1(this.get(Ui));
  return Bi + " }";
};
M$1.prototype.equals = function(Bi) {
  return this === Bi || St$1(Bi) && lt$1(this).equals(lt$1(Bi));
};
M$1.prototype.hashCode = function() {
  return lt$1(this).hashCode();
};
M$1.prototype.has = function(Bi) {
  return this._indices.hasOwnProperty(Bi);
};
M$1.prototype.get = function(Bi, e) {
  if (!this.has(Bi))
    return e;
  var Ui = this._indices[Bi], Zi = this._values.get(Ui);
  return Zi === void 0 ? this._defaultValues[Bi] : Zi;
};
M$1.prototype.set = function(Bi, e) {
  if (this.has(Bi)) {
    var Ui = this._values.set(
      this._indices[Bi],
      e === this._defaultValues[Bi] ? void 0 : e
    );
    if (Ui !== this._values && !this.__ownerID)
      return Xr$1(this, Ui);
  }
  return this;
};
M$1.prototype.remove = function(Bi) {
  return this.set(Bi);
};
M$1.prototype.clear = function() {
  var Bi = this._values.clear().setSize(this._keys.length);
  return this.__ownerID ? this : Xr$1(this, Bi);
};
M$1.prototype.wasAltered = function() {
  return this._values.wasAltered();
};
M$1.prototype.toSeq = function() {
  return lt$1(this);
};
M$1.prototype.toJS = function() {
  return xt$1(this);
};
M$1.prototype.entries = function() {
  return this.__iterator(C$1);
};
M$1.prototype.__iterator = function(Bi, e) {
  return lt$1(this).__iterator(Bi, e);
};
M$1.prototype.__iterate = function(Bi, e) {
  return lt$1(this).__iterate(Bi, e);
};
M$1.prototype.__ensureOwner = function(Bi) {
  if (Bi === this.__ownerID)
    return this;
  var e = this._values.__ensureOwner(Bi);
  return Bi ? Xr$1(this, e, Bi) : (this.__ownerID = Bi, this._values = e, this);
};
M$1.isRecord = St$1;
M$1.getDescriptiveName = Zr$1;
var S = M$1.prototype;
S[be$1] = !0;
S[Bt$1] = S.remove;
S.deleteIn = S.removeIn = kr$1;
S.getIn = vn$1;
S.hasIn = A$1.hasIn;
S.merge = Qe$1;
S.mergeWith = Ve$1;
S.mergeIn = Ur$1;
S.mergeDeep = tn$1;
S.mergeDeepWith = rn$1;
S.mergeDeepIn = Pr$1;
S.setIn = jr$1;
S.update = $r$1;
S.updateIn = Dr;
S.withMutations = Ct$1;
S.asMutable = Kt;
S.asImmutable = Ft$1;
S[nr$1] = S.entries;
S.toJSON = S.toObject = A$1.toObject;
S.inspect = S.toSource = function() {
  return this.toString();
};
function Xr$1(Bi, e, Ui) {
  var Zi = Object.create(Object.getPrototypeOf(Bi));
  return Zi._values = e, Zi.__ownerID = Ui, Zi;
}
function Zr$1(Bi) {
  return Bi.constructor.displayName || Bi.constructor.name || "Record";
}
function lt$1(Bi) {
  return Mr$1(Bi._keys.map(function(e) {
    return [e, Bi.get(e)];
  }));
}
function hi$1(Bi, e) {
  try {
    Object.defineProperty(Bi, e, {
      get: function() {
        return this.get(e);
      },
      set: function(Ui) {
        Lr(this.__ownerID, "Cannot set on an immutable record."), this.set(e, Ui);
      }
    });
  } catch {
  }
}
const Si$1 = (Bi, e) => {
  useEffect(() => (document.addEventListener("keydown", (Ui) => {
    Bi[Ui.key] && Bi[Ui.key]();
  }), () => {
    document.removeEventListener("keydown", () => null);
  }), e || []);
}, containerVariants = cva(
  [
    "dark:bg-neutral-900",
    "dark:text-neutral-200",
    "absolute",
    "transform",
    "shadow-sm",
    "border",
    "border-black",
    "top-1/2",
    "left-1/2",
    "bg-neutral-100",
    "max-h-[75vh]",
    "z-50"
  ],
  {
    variants: {
      size: {
        fit: ["w-auto", "h-auto"],
        sm: ["w-sm", "h-[50vh]"],
        md: ["w-md", "h-[50vh]"],
        lg: ["w-lg", "h-[50vh]"]
      }
    }
  }
), Modal = ({
  children: Bi,
  visible: e,
  onClose: Ui,
  className: Zi,
  containerClassName: ta = "modal-root",
  variant: na = "lg"
}) => {
  const ia = useRef(null), { root: aa } = useModalContext();
  return Si$1({
    Escape: Ui
  }), aa ? e ? createPortal(
    /* @__PURE__ */ jsxRuntimeExports.jsx(AnimatePresence, { children: /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx(
        motion.div,
        {
          className: twMerge(
            "fixed top-0 left-0 w-screen h-screen opacity-80 bg-neutral-700 z-40 overlay",
            Zi
          ),
          onClick: () => Ui(),
          initial: { opacity: 0 },
          animate: { opacity: 0.8 }
        }
      ),
      /* @__PURE__ */ jsxRuntimeExports.jsx(
        motion.div,
        {
          className: twMerge(
            containerVariants({ size: na }),
            ta
          ),
          ref: ia,
          initial: {
            left: "50vw",
            opacity: 1,
            transform: "translateX(-50%) translateY(-50%)",
            top: "100vh"
          },
          animate: {
            left: "50vw",
            opacity: 1,
            transform: "translateX(-50%) translateY(-50%)",
            top: "50vh"
          },
          exit: {
            left: "50vw",
            opacity: 1,
            transform: "translateX(-50%) ",
            top: "100vh"
          },
          children: Bi
        }
      )
    ] }) }),
    aa
  ) : null : (console.error("No root element found"), null);
}, ModalContext = createContext({ root: null }), useModalContext = () => a__default.useContext(ModalContext), ModalContainer = ({
  className: Bi = "modal-root",
  children: e
}) => {
  const [Ui, Zi] = a__default.useState(null);
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(ModalContext.Provider, { value: { root: Ui }, children: [
    e,
    /* @__PURE__ */ jsxRuntimeExports.jsx("div", { ref: Zi, className: Bi })
  ] });
}, CreateFolderModal = ({
  visible: Bi,
  onClose: e,
  onCreateFolder: Ui
}) => {
  const { register: Zi, handleSubmit: ta, reset: na } = useForm({ defaultValues: { name: "" } }), { ref: ia, ...aa } = Zi("name"), [da, La] = useState(null);
  return useEffect(() => {
    da && da.focus();
  }, [da]), /* @__PURE__ */ jsxRuntimeExports.jsx(
    Modal,
    {
      visible: Bi,
      onClose: () => e(!1),
      variant: "fit",
      children: /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "border-black border w-full h-full bg-white p-4", children: [
        /* @__PURE__ */ jsxRuntimeExports.jsx("h1", { children: "create folder" }),
        /* @__PURE__ */ jsxRuntimeExports.jsxs(
          "form",
          {
            className: "flex flex-col items-center justify-center gap-4",
            onSubmit: ta((qa) => {
              na(), Ui(qa.name);
            }),
            children: [
              /* @__PURE__ */ jsxRuntimeExports.jsx(
                Input,
                {
                  ref: (qa) => {
                    ia(qa), La(qa);
                  },
                  className: "block",
                  ...aa,
                  type: "text",
                  placeholder: "folder name"
                }
              ),
              /* @__PURE__ */ jsxRuntimeExports.jsx(Button, { children: "Create" })
            ]
          }
        )
      ] })
    }
  );
}, t$6 = /* @__PURE__ */ new Map([
  [
    "bold",
    /* @__PURE__ */ a__default.createElement(a__default.Fragment, null, /* @__PURE__ */ a__default.createElement("path", { d: "M216.49,79.52l-56-56A12,12,0,0,0,152,20H56A20,20,0,0,0,36,40V216a20,20,0,0,0,20,20H200a20,20,0,0,0,20-20V88A12,12,0,0,0,216.49,79.52ZM160,57l23,23H160ZM60,212V44h76V92a12,12,0,0,0,12,12h48V212Z" }))
  ],
  [
    "duotone",
    /* @__PURE__ */ a__default.createElement(a__default.Fragment, null, /* @__PURE__ */ a__default.createElement("path", { d: "M208,88H152V32Z", opacity: "0.2" }), /* @__PURE__ */ a__default.createElement("path", { d: "M213.66,82.34l-56-56A8,8,0,0,0,152,24H56A16,16,0,0,0,40,40V216a16,16,0,0,0,16,16H200a16,16,0,0,0,16-16V88A8,8,0,0,0,213.66,82.34ZM160,51.31,188.69,80H160ZM200,216H56V40h88V88a8,8,0,0,0,8,8h48V216Z" }))
  ],
  [
    "fill",
    /* @__PURE__ */ a__default.createElement(a__default.Fragment, null, /* @__PURE__ */ a__default.createElement("path", { d: "M213.66,82.34l-56-56A8,8,0,0,0,152,24H56A16,16,0,0,0,40,40V216a16,16,0,0,0,16,16H200a16,16,0,0,0,16-16V88A8,8,0,0,0,213.66,82.34ZM152,88V44l44,44Z" }))
  ],
  [
    "light",
    /* @__PURE__ */ a__default.createElement(a__default.Fragment, null, /* @__PURE__ */ a__default.createElement("path", { d: "M212.24,83.76l-56-56A6,6,0,0,0,152,26H56A14,14,0,0,0,42,40V216a14,14,0,0,0,14,14H200a14,14,0,0,0,14-14V88A6,6,0,0,0,212.24,83.76ZM158,46.48,193.52,82H158ZM200,218H56a2,2,0,0,1-2-2V40a2,2,0,0,1,2-2h90V88a6,6,0,0,0,6,6h50V216A2,2,0,0,1,200,218Z" }))
  ],
  [
    "regular",
    /* @__PURE__ */ a__default.createElement(a__default.Fragment, null, /* @__PURE__ */ a__default.createElement("path", { d: "M213.66,82.34l-56-56A8,8,0,0,0,152,24H56A16,16,0,0,0,40,40V216a16,16,0,0,0,16,16H200a16,16,0,0,0,16-16V88A8,8,0,0,0,213.66,82.34ZM160,51.31,188.69,80H160ZM200,216H56V40h88V88a8,8,0,0,0,8,8h48V216Z" }))
  ],
  [
    "thin",
    /* @__PURE__ */ a__default.createElement(a__default.Fragment, null, /* @__PURE__ */ a__default.createElement("path", { d: "M210.83,85.17l-56-56A4,4,0,0,0,152,28H56A12,12,0,0,0,44,40V216a12,12,0,0,0,12,12H200a12,12,0,0,0,12-12V88A4,4,0,0,0,210.83,85.17ZM156,41.65,198.34,84H156ZM200,220H56a4,4,0,0,1-4-4V40a4,4,0,0,1,4-4h92V88a4,4,0,0,0,4,4h52V216A4,4,0,0,1,200,220Z" }))
  ]
]), a$6 = /* @__PURE__ */ new Map([
  [
    "bold",
    /* @__PURE__ */ a__default.createElement(a__default.Fragment, null, /* @__PURE__ */ a__default.createElement("path", { d: "M216,68H133.39l-26-29.29a20,20,0,0,0-15-6.71H40A20,20,0,0,0,20,52V200.62A19.41,19.41,0,0,0,39.38,220H216.89A19.13,19.13,0,0,0,236,200.89V88A20,20,0,0,0,216,68ZM44,56H90.61l10.67,12H44ZM212,196H44V92H212Z" }))
  ],
  [
    "duotone",
    /* @__PURE__ */ a__default.createElement(a__default.Fragment, null, /* @__PURE__ */ a__default.createElement(
      "path",
      {
        d: "M128,80H32V56a8,8,0,0,1,8-8H92.69a8,8,0,0,1,5.65,2.34Z",
        opacity: "0.2"
      }
    ), /* @__PURE__ */ a__default.createElement("path", { d: "M216,72H131.31L104,44.69A15.86,15.86,0,0,0,92.69,40H40A16,16,0,0,0,24,56V200.62A15.4,15.4,0,0,0,39.38,216H216.89A15.13,15.13,0,0,0,232,200.89V88A16,16,0,0,0,216,72ZM92.69,56l16,16H40V56ZM216,200H40V88H216Z" }))
  ],
  [
    "fill",
    /* @__PURE__ */ a__default.createElement(a__default.Fragment, null, /* @__PURE__ */ a__default.createElement("path", { d: "M216,72H131.31L104,44.69A15.88,15.88,0,0,0,92.69,40H40A16,16,0,0,0,24,56V200.62A15.41,15.41,0,0,0,39.39,216h177.5A15.13,15.13,0,0,0,232,200.89V88A16,16,0,0,0,216,72ZM40,56H92.69l16,16H40Z" }))
  ],
  [
    "light",
    /* @__PURE__ */ a__default.createElement(a__default.Fragment, null, /* @__PURE__ */ a__default.createElement("path", { d: "M216,74H130.49l-27.9-27.9a13.94,13.94,0,0,0-9.9-4.1H40A14,14,0,0,0,26,56V200.62A13.39,13.39,0,0,0,39.38,214H216.89A13.12,13.12,0,0,0,230,200.89V88A14,14,0,0,0,216,74ZM40,54H92.69a2,2,0,0,1,1.41.59L113.51,74H38V56A2,2,0,0,1,40,54ZM218,200.89a1.11,1.11,0,0,1-1.11,1.11H39.38A1.4,1.4,0,0,1,38,200.62V86H216a2,2,0,0,1,2,2Z" }))
  ],
  [
    "regular",
    /* @__PURE__ */ a__default.createElement(a__default.Fragment, null, /* @__PURE__ */ a__default.createElement("path", { d: "M216,72H131.31L104,44.69A15.86,15.86,0,0,0,92.69,40H40A16,16,0,0,0,24,56V200.62A15.4,15.4,0,0,0,39.38,216H216.89A15.13,15.13,0,0,0,232,200.89V88A16,16,0,0,0,216,72ZM40,56H92.69l16,16H40ZM216,200H40V88H216Z" }))
  ],
  [
    "thin",
    /* @__PURE__ */ a__default.createElement(a__default.Fragment, null, /* @__PURE__ */ a__default.createElement("path", { d: "M216,76H129.66L101.17,47.52A11.9,11.9,0,0,0,92.69,44H40A12,12,0,0,0,28,56V200.62A11.4,11.4,0,0,0,39.38,212H216.89A11.12,11.12,0,0,0,228,200.89V88A12,12,0,0,0,216,76ZM36,56a4,4,0,0,1,4-4H92.69a4,4,0,0,1,2.82,1.17L118.34,76H36ZM220,200.89a3.12,3.12,0,0,1-3.11,3.11H39.38A3.39,3.39,0,0,1,36,200.62V84H216a4,4,0,0,1,4,4Z" }))
  ]
]), H$1 = /* @__PURE__ */ new Map([
  [
    "bold",
    /* @__PURE__ */ a__default.createElement(a__default.Fragment, null, /* @__PURE__ */ a__default.createElement("path", { d: "M216,68H133.39l-26-29.29a20,20,0,0,0-15-6.71H40A20,20,0,0,0,20,52V200.62A19.41,19.41,0,0,0,39.38,220H216.89A19.13,19.13,0,0,0,236,200.89V88A20,20,0,0,0,216,68ZM90.61,56l10.67,12H44V56ZM212,196H44V92H212Zm-72-76v12h12a12,12,0,0,1,0,24H140v12a12,12,0,0,1-24,0V156H104a12,12,0,0,1,0-24h12V120a12,12,0,0,1,24,0Z" }))
  ],
  [
    "duotone",
    /* @__PURE__ */ a__default.createElement(a__default.Fragment, null, /* @__PURE__ */ a__default.createElement(
      "path",
      {
        d: "M128,80H32V56a8,8,0,0,1,8-8H92.69a8,8,0,0,1,5.65,2.34Z",
        opacity: "0.2"
      }
    ), /* @__PURE__ */ a__default.createElement("path", { d: "M216,72H131.31L104,44.69A15.86,15.86,0,0,0,92.69,40H40A16,16,0,0,0,24,56V200.62A15.4,15.4,0,0,0,39.38,216H216.89A15.13,15.13,0,0,0,232,200.89V88A16,16,0,0,0,216,72ZM92.69,56l16,16H40V56ZM216,200H40V88H216Zm-88-88a8,8,0,0,1,8,8v16h16a8,8,0,0,1,0,16H136v16a8,8,0,0,1-16,0V152H104a8,8,0,0,1,0-16h16V120A8,8,0,0,1,128,112Z" }))
  ],
  [
    "fill",
    /* @__PURE__ */ a__default.createElement(a__default.Fragment, null, /* @__PURE__ */ a__default.createElement("path", { d: "M216,72H131.31L104,44.69A15.88,15.88,0,0,0,92.69,40H40A16,16,0,0,0,24,56V200.62A15.41,15.41,0,0,0,39.39,216h177.5A15.13,15.13,0,0,0,232,200.89V88A16,16,0,0,0,216,72ZM40,56H92.69l16,16H40Zm112,96H136v16a8,8,0,0,1-16,0V152H104a8,8,0,0,1,0-16h16V120a8,8,0,0,1,16,0v16h16a8,8,0,0,1,0,16Z" }))
  ],
  [
    "light",
    /* @__PURE__ */ a__default.createElement(a__default.Fragment, null, /* @__PURE__ */ a__default.createElement("path", { d: "M216,74H130.49l-27.9-27.9a13.94,13.94,0,0,0-9.9-4.1H40A14,14,0,0,0,26,56V200.62A13.39,13.39,0,0,0,39.38,214H216.89A13.12,13.12,0,0,0,230,200.89V88A14,14,0,0,0,216,74ZM40,54H92.69a2,2,0,0,1,1.41.59L113.51,74H38V56A2,2,0,0,1,40,54ZM218,200.89a1.11,1.11,0,0,1-1.11,1.11H39.38A1.4,1.4,0,0,1,38,200.62V86H216a2,2,0,0,1,2,2ZM158,144a6,6,0,0,1-6,6H134v18a6,6,0,0,1-12,0V150H104a6,6,0,0,1,0-12h18V120a6,6,0,0,1,12,0v18h18A6,6,0,0,1,158,144Z" }))
  ],
  [
    "regular",
    /* @__PURE__ */ a__default.createElement(a__default.Fragment, null, /* @__PURE__ */ a__default.createElement("path", { d: "M216,72H131.31L104,44.69A15.86,15.86,0,0,0,92.69,40H40A16,16,0,0,0,24,56V200.62A15.4,15.4,0,0,0,39.38,216H216.89A15.13,15.13,0,0,0,232,200.89V88A16,16,0,0,0,216,72ZM92.69,56l16,16H40V56ZM216,200H40V88H216Zm-88-88a8,8,0,0,1,8,8v16h16a8,8,0,0,1,0,16H136v16a8,8,0,0,1-16,0V152H104a8,8,0,0,1,0-16h16V120A8,8,0,0,1,128,112Z" }))
  ],
  [
    "thin",
    /* @__PURE__ */ a__default.createElement(a__default.Fragment, null, /* @__PURE__ */ a__default.createElement("path", { d: "M216,76H129.66L101.17,47.52A11.9,11.9,0,0,0,92.69,44H40A12,12,0,0,0,28,56V200.62A11.4,11.4,0,0,0,39.38,212H216.89A11.12,11.12,0,0,0,228,200.89V88A12,12,0,0,0,216,76ZM40,52H92.69a4,4,0,0,1,2.82,1.17L118.34,76H36V56A4,4,0,0,1,40,52ZM220,200.89a3.12,3.12,0,0,1-3.11,3.11H39.38A3.39,3.39,0,0,1,36,200.62V84H216a4,4,0,0,1,4,4ZM156,144a4,4,0,0,1-4,4H132v20a4,4,0,0,1-8,0V148H104a4,4,0,0,1,0-8h20V120a4,4,0,0,1,8,0v20h20A4,4,0,0,1,156,144Z" }))
  ]
]), t$5 = /* @__PURE__ */ new Map([
  [
    "bold",
    /* @__PURE__ */ a__default.createElement(a__default.Fragment, null, /* @__PURE__ */ a__default.createElement("path", { d: "M228,128a12,12,0,0,1-12,12H40a12,12,0,0,1,0-24H216A12,12,0,0,1,228,128ZM40,76H216a12,12,0,0,0,0-24H40a12,12,0,0,0,0,24ZM216,180H40a12,12,0,0,0,0,24H216a12,12,0,0,0,0-24Z" }))
  ],
  [
    "duotone",
    /* @__PURE__ */ a__default.createElement(a__default.Fragment, null, /* @__PURE__ */ a__default.createElement("path", { d: "M216,64V192H40V64Z", opacity: "0.2" }), /* @__PURE__ */ a__default.createElement("path", { d: "M224,128a8,8,0,0,1-8,8H40a8,8,0,0,1,0-16H216A8,8,0,0,1,224,128ZM40,72H216a8,8,0,0,0,0-16H40a8,8,0,0,0,0,16ZM216,184H40a8,8,0,0,0,0,16H216a8,8,0,0,0,0-16Z" }))
  ],
  [
    "fill",
    /* @__PURE__ */ a__default.createElement(a__default.Fragment, null, /* @__PURE__ */ a__default.createElement("path", { d: "M208,32H48A16,16,0,0,0,32,48V208a16,16,0,0,0,16,16H208a16,16,0,0,0,16-16V48A16,16,0,0,0,208,32ZM192,184H64a8,8,0,0,1,0-16H192a8,8,0,0,1,0,16Zm0-48H64a8,8,0,0,1,0-16H192a8,8,0,0,1,0,16Zm0-48H64a8,8,0,0,1,0-16H192a8,8,0,0,1,0,16Z" }))
  ],
  [
    "light",
    /* @__PURE__ */ a__default.createElement(a__default.Fragment, null, /* @__PURE__ */ a__default.createElement("path", { d: "M222,128a6,6,0,0,1-6,6H40a6,6,0,0,1,0-12H216A6,6,0,0,1,222,128ZM40,70H216a6,6,0,0,0,0-12H40a6,6,0,0,0,0,12ZM216,186H40a6,6,0,0,0,0,12H216a6,6,0,0,0,0-12Z" }))
  ],
  [
    "regular",
    /* @__PURE__ */ a__default.createElement(a__default.Fragment, null, /* @__PURE__ */ a__default.createElement("path", { d: "M224,128a8,8,0,0,1-8,8H40a8,8,0,0,1,0-16H216A8,8,0,0,1,224,128ZM40,72H216a8,8,0,0,0,0-16H40a8,8,0,0,0,0,16ZM216,184H40a8,8,0,0,0,0,16H216a8,8,0,0,0,0-16Z" }))
  ],
  [
    "thin",
    /* @__PURE__ */ a__default.createElement(a__default.Fragment, null, /* @__PURE__ */ a__default.createElement("path", { d: "M220,128a4,4,0,0,1-4,4H40a4,4,0,0,1,0-8H216A4,4,0,0,1,220,128ZM40,68H216a4,4,0,0,0,0-8H40a4,4,0,0,0,0,8ZM216,188H40a4,4,0,0,0,0,8H216a4,4,0,0,0,0-8Z" }))
  ]
]), t$4 = /* @__PURE__ */ new Map([
  [
    "bold",
    /* @__PURE__ */ a__default.createElement(a__default.Fragment, null, /* @__PURE__ */ a__default.createElement("path", { d: "M228,144v64a12,12,0,0,1-12,12H40a12,12,0,0,1-12-12V144a12,12,0,0,1,24,0v52H204V144a12,12,0,0,1,24,0ZM96.49,80.49,116,61v83a12,12,0,0,0,24,0V61l19.51,19.52a12,12,0,1,0,17-17l-40-40a12,12,0,0,0-17,0l-40,40a12,12,0,1,0,17,17Z" }))
  ],
  [
    "duotone",
    /* @__PURE__ */ a__default.createElement(a__default.Fragment, null, /* @__PURE__ */ a__default.createElement(
      "path",
      {
        d: "M216,48V208H40V48A16,16,0,0,1,56,32H200A16,16,0,0,1,216,48Z",
        opacity: "0.2"
      }
    ), /* @__PURE__ */ a__default.createElement("path", { d: "M224,144v64a8,8,0,0,1-8,8H40a8,8,0,0,1-8-8V144a8,8,0,0,1,16,0v56H208V144a8,8,0,0,1,16,0ZM93.66,77.66,120,51.31V144a8,8,0,0,0,16,0V51.31l26.34,26.35a8,8,0,0,0,11.32-11.32l-40-40a8,8,0,0,0-11.32,0l-40,40A8,8,0,0,0,93.66,77.66Z" }))
  ],
  [
    "fill",
    /* @__PURE__ */ a__default.createElement(a__default.Fragment, null, /* @__PURE__ */ a__default.createElement("path", { d: "M224,144v64a8,8,0,0,1-8,8H40a8,8,0,0,1-8-8V144a8,8,0,0,1,16,0v56H208V144a8,8,0,0,1,16,0ZM88,80h32v64a8,8,0,0,0,16,0V80h32a8,8,0,0,0,5.66-13.66l-40-40a8,8,0,0,0-11.32,0l-40,40A8,8,0,0,0,88,80Z" }))
  ],
  [
    "light",
    /* @__PURE__ */ a__default.createElement(a__default.Fragment, null, /* @__PURE__ */ a__default.createElement("path", { d: "M222,144v64a6,6,0,0,1-6,6H40a6,6,0,0,1-6-6V144a6,6,0,0,1,12,0v58H210V144a6,6,0,0,1,12,0ZM92.24,76.24,122,46.49V144a6,6,0,0,0,12,0V46.49l29.76,29.75a6,6,0,0,0,8.48-8.48l-40-40a6,6,0,0,0-8.48,0l-40,40a6,6,0,0,0,8.48,8.48Z" }))
  ],
  [
    "regular",
    /* @__PURE__ */ a__default.createElement(a__default.Fragment, null, /* @__PURE__ */ a__default.createElement("path", { d: "M224,144v64a8,8,0,0,1-8,8H40a8,8,0,0,1-8-8V144a8,8,0,0,1,16,0v56H208V144a8,8,0,0,1,16,0ZM93.66,77.66,120,51.31V144a8,8,0,0,0,16,0V51.31l26.34,26.35a8,8,0,0,0,11.32-11.32l-40-40a8,8,0,0,0-11.32,0l-40,40A8,8,0,0,0,93.66,77.66Z" }))
  ],
  [
    "thin",
    /* @__PURE__ */ a__default.createElement(a__default.Fragment, null, /* @__PURE__ */ a__default.createElement("path", { d: "M220,144v64a4,4,0,0,1-4,4H40a4,4,0,0,1-4-4V144a4,4,0,0,1,8,0v60H212V144a4,4,0,0,1,8,0ZM90.83,74.83,124,41.66V144a4,4,0,0,0,8,0V41.66l33.17,33.17a4,4,0,1,0,5.66-5.66l-40-40a4,4,0,0,0-5.66,0l-40,40a4,4,0,0,0,5.66,5.66Z" }))
  ]
]), o = createContext({
  color: "currentColor",
  size: "1em",
  weight: "regular",
  mirrored: !1
});
var y$1 = Object.defineProperty, c$5 = Object.getOwnPropertySymbols, f$5 = Object.prototype.hasOwnProperty, g$1 = Object.prototype.propertyIsEnumerable, d$2 = (Bi, e, Ui) => e in Bi ? y$1(Bi, e, { enumerable: !0, configurable: !0, writable: !0, value: Ui }) : Bi[e] = Ui, l$5 = (Bi, e) => {
  for (var Ui in e || (e = {}))
    f$5.call(e, Ui) && d$2(Bi, Ui, e[Ui]);
  if (c$5)
    for (var Ui of c$5(e))
      g$1.call(e, Ui) && d$2(Bi, Ui, e[Ui]);
  return Bi;
}, a$5 = (Bi, e) => {
  var Ui = {};
  for (var Zi in Bi)
    f$5.call(Bi, Zi) && e.indexOf(Zi) < 0 && (Ui[Zi] = Bi[Zi]);
  if (Bi != null && c$5)
    for (var Zi of c$5(Bi))
      e.indexOf(Zi) < 0 && g$1.call(Bi, Zi) && (Ui[Zi] = Bi[Zi]);
  return Ui;
};
const h = forwardRef((Bi, e) => {
  const Ui = Bi, {
    alt: Zi,
    color: ta,
    size: na,
    weight: ia,
    mirrored: aa,
    children: da,
    weights: La
  } = Ui, qa = a$5(Ui, [
    "alt",
    "color",
    "size",
    "weight",
    "mirrored",
    "children",
    "weights"
  ]), io = useContext(o), {
    color: ao = "currentColor",
    size: oo,
    weight: no = "regular",
    mirrored: lo = !1
  } = io, so = a$5(io, [
    "color",
    "size",
    "weight",
    "mirrored"
  ]);
  return /* @__PURE__ */ a__default.createElement(
    "svg",
    l$5(l$5({
      ref: e,
      xmlns: "http://www.w3.org/2000/svg",
      width: na ?? oo,
      height: na ?? oo,
      fill: ta ?? ao,
      viewBox: "0 0 256 256",
      transform: aa || lo ? "scale(-1, 1)" : void 0
    }, so), qa),
    !!Zi && /* @__PURE__ */ a__default.createElement("title", null, Zi),
    da,
    La.get(ia ?? no)
  );
});
h.displayName = "IconBase";
const b = h;
var f$4 = Object.defineProperty, p$2 = Object.defineProperties, s$4 = Object.getOwnPropertyDescriptors, t$3 = Object.getOwnPropertySymbols, c$4 = Object.prototype.hasOwnProperty, l$4 = Object.prototype.propertyIsEnumerable, m$3 = (Bi, e, Ui) => e in Bi ? f$4(Bi, e, { enumerable: !0, configurable: !0, writable: !0, value: Ui }) : Bi[e] = Ui, a$4 = (Bi, e) => {
  for (var Ui in e || (e = {}))
    c$4.call(e, Ui) && m$3(Bi, Ui, e[Ui]);
  if (t$3)
    for (var Ui of t$3(e))
      l$4.call(e, Ui) && m$3(Bi, Ui, e[Ui]);
  return Bi;
}, i$5 = (Bi, e) => p$2(Bi, s$4(e));
const I = forwardRef((Bi, e) => /* @__PURE__ */ a__default.createElement(b, i$5(a$4({ ref: e }, Bi), { weights: t$6 })));
I.displayName = "File";
var c$3 = Object.defineProperty, d$1 = Object.defineProperties, f$3 = Object.getOwnPropertyDescriptors, t$2 = Object.getOwnPropertySymbols, i$4 = Object.prototype.hasOwnProperty, l$3 = Object.prototype.propertyIsEnumerable, a$3 = (Bi, e, Ui) => e in Bi ? c$3(Bi, e, { enumerable: !0, configurable: !0, writable: !0, value: Ui }) : Bi[e] = Ui, m$2 = (Bi, e) => {
  for (var Ui in e || (e = {}))
    i$4.call(e, Ui) && a$3(Bi, Ui, e[Ui]);
  if (t$2)
    for (var Ui of t$2(e))
      l$3.call(e, Ui) && a$3(Bi, Ui, e[Ui]);
  return Bi;
}, s$3 = (Bi, e) => d$1(Bi, f$3(e));
const w$1 = forwardRef((Bi, e) => /* @__PURE__ */ a__default.createElement(b, s$3(m$2({ ref: e }, Bi), { weights: a$6 })));
w$1.displayName = "Folder";
var m$1 = Object.defineProperty, c$2 = Object.defineProperties, d = Object.getOwnPropertyDescriptors, t$1 = Object.getOwnPropertySymbols, f$2 = Object.prototype.hasOwnProperty, i$3 = Object.prototype.propertyIsEnumerable, s$2 = (Bi, e, Ui) => e in Bi ? m$1(Bi, e, { enumerable: !0, configurable: !0, writable: !0, value: Ui }) : Bi[e] = Ui, a$2 = (Bi, e) => {
  for (var Ui in e || (e = {}))
    f$2.call(e, Ui) && s$2(Bi, Ui, e[Ui]);
  if (t$1)
    for (var Ui of t$1(e))
      i$3.call(e, Ui) && s$2(Bi, Ui, e[Ui]);
  return Bi;
}, l$2 = (Bi, e) => c$2(Bi, d(e));
const P$1 = forwardRef((Bi, e) => /* @__PURE__ */ a__default.createElement(b, l$2(a$2({ ref: e }, Bi), { weights: H$1 })));
P$1.displayName = "FolderPlus";
var s$1 = Object.defineProperty, f$1 = Object.defineProperties, p$1 = Object.getOwnPropertyDescriptors, r$1 = Object.getOwnPropertySymbols, c$1 = Object.prototype.hasOwnProperty, n = Object.prototype.propertyIsEnumerable, m = (Bi, e, Ui) => e in Bi ? s$1(Bi, e, { enumerable: !0, configurable: !0, writable: !0, value: Ui }) : Bi[e] = Ui, a$1 = (Bi, e) => {
  for (var Ui in e || (e = {}))
    c$1.call(e, Ui) && m(Bi, Ui, e[Ui]);
  if (r$1)
    for (var Ui of r$1(e))
      n.call(e, Ui) && m(Bi, Ui, e[Ui]);
  return Bi;
}, i$2 = (Bi, e) => f$1(Bi, p$1(e));
const L = forwardRef((Bi, e) => /* @__PURE__ */ a__default.createElement(b, i$2(a$1({ ref: e }, Bi), { weights: t$5 })));
L.displayName = "List";
var i$1 = Object.defineProperty, l$1 = Object.defineProperties, f = Object.getOwnPropertyDescriptors, r = Object.getOwnPropertySymbols, s = Object.prototype.hasOwnProperty, c = Object.prototype.propertyIsEnumerable, a = (Bi, e, Ui) => e in Bi ? i$1(Bi, e, { enumerable: !0, configurable: !0, writable: !0, value: Ui }) : Bi[e] = Ui, p = (Bi, e) => {
  for (var Ui in e || (e = {}))
    s.call(e, Ui) && a(Bi, Ui, e[Ui]);
  if (r)
    for (var Ui of r(e))
      c.call(e, Ui) && a(Bi, Ui, e[Ui]);
  return Bi;
}, t = (Bi, e) => l$1(Bi, f(e));
const R = forwardRef((Bi, e) => /* @__PURE__ */ a__default.createElement(b, t(p({ ref: e }, Bi), { weights: t$4 })));
R.displayName = "UploadSimple";
var pathBrowserify, hasRequiredPathBrowserify;
function requirePathBrowserify() {
  if (hasRequiredPathBrowserify) return pathBrowserify;
  hasRequiredPathBrowserify = 1;
  function Bi(ta) {
    if (typeof ta != "string")
      throw new TypeError("Path must be a string. Received " + JSON.stringify(ta));
  }
  function e(ta, na) {
    for (var ia = "", aa = 0, da = -1, La = 0, qa, io = 0; io <= ta.length; ++io) {
      if (io < ta.length)
        qa = ta.charCodeAt(io);
      else {
        if (qa === 47)
          break;
        qa = 47;
      }
      if (qa === 47) {
        if (!(da === io - 1 || La === 1)) if (da !== io - 1 && La === 2) {
          if (ia.length < 2 || aa !== 2 || ia.charCodeAt(ia.length - 1) !== 46 || ia.charCodeAt(ia.length - 2) !== 46) {
            if (ia.length > 2) {
              var ao = ia.lastIndexOf("/");
              if (ao !== ia.length - 1) {
                ao === -1 ? (ia = "", aa = 0) : (ia = ia.slice(0, ao), aa = ia.length - 1 - ia.lastIndexOf("/")), da = io, La = 0;
                continue;
              }
            } else if (ia.length === 2 || ia.length === 1) {
              ia = "", aa = 0, da = io, La = 0;
              continue;
            }
          }
          na && (ia.length > 0 ? ia += "/.." : ia = "..", aa = 2);
        } else
          ia.length > 0 ? ia += "/" + ta.slice(da + 1, io) : ia = ta.slice(da + 1, io), aa = io - da - 1;
        da = io, La = 0;
      } else qa === 46 && La !== -1 ? ++La : La = -1;
    }
    return ia;
  }
  function Ui(ta, na) {
    var ia = na.dir || na.root, aa = na.base || (na.name || "") + (na.ext || "");
    return ia ? ia === na.root ? ia + aa : ia + ta + aa : aa;
  }
  var Zi = {
    // path.resolve([from ...], to)
    resolve: function() {
      for (var na = "", ia = !1, aa, da = arguments.length - 1; da >= -1 && !ia; da--) {
        var La;
        da >= 0 ? La = arguments[da] : (aa === void 0 && (aa = process.cwd()), La = aa), Bi(La), La.length !== 0 && (na = La + "/" + na, ia = La.charCodeAt(0) === 47);
      }
      return na = e(na, !ia), ia ? na.length > 0 ? "/" + na : "/" : na.length > 0 ? na : ".";
    },
    normalize: function(na) {
      if (Bi(na), na.length === 0) return ".";
      var ia = na.charCodeAt(0) === 47, aa = na.charCodeAt(na.length - 1) === 47;
      return na = e(na, !ia), na.length === 0 && !ia && (na = "."), na.length > 0 && aa && (na += "/"), ia ? "/" + na : na;
    },
    isAbsolute: function(na) {
      return Bi(na), na.length > 0 && na.charCodeAt(0) === 47;
    },
    join: function() {
      if (arguments.length === 0)
        return ".";
      for (var na, ia = 0; ia < arguments.length; ++ia) {
        var aa = arguments[ia];
        Bi(aa), aa.length > 0 && (na === void 0 ? na = aa : na += "/" + aa);
      }
      return na === void 0 ? "." : Zi.normalize(na);
    },
    relative: function(na, ia) {
      if (Bi(na), Bi(ia), na === ia || (na = Zi.resolve(na), ia = Zi.resolve(ia), na === ia)) return "";
      for (var aa = 1; aa < na.length && na.charCodeAt(aa) === 47; ++aa)
        ;
      for (var da = na.length, La = da - aa, qa = 1; qa < ia.length && ia.charCodeAt(qa) === 47; ++qa)
        ;
      for (var io = ia.length, ao = io - qa, oo = La < ao ? La : ao, no = -1, lo = 0; lo <= oo; ++lo) {
        if (lo === oo) {
          if (ao > oo) {
            if (ia.charCodeAt(qa + lo) === 47)
              return ia.slice(qa + lo + 1);
            if (lo === 0)
              return ia.slice(qa + lo);
          } else La > oo && (na.charCodeAt(aa + lo) === 47 ? no = lo : lo === 0 && (no = 0));
          break;
        }
        var so = na.charCodeAt(aa + lo), bs = ia.charCodeAt(qa + lo);
        if (so !== bs)
          break;
        so === 47 && (no = lo);
      }
      var Rs = "";
      for (lo = aa + no + 1; lo <= da; ++lo)
        (lo === da || na.charCodeAt(lo) === 47) && (Rs.length === 0 ? Rs += ".." : Rs += "/..");
      return Rs.length > 0 ? Rs + ia.slice(qa + no) : (qa += no, ia.charCodeAt(qa) === 47 && ++qa, ia.slice(qa));
    },
    _makeLong: function(na) {
      return na;
    },
    dirname: function(na) {
      if (Bi(na), na.length === 0) return ".";
      for (var ia = na.charCodeAt(0), aa = ia === 47, da = -1, La = !0, qa = na.length - 1; qa >= 1; --qa)
        if (ia = na.charCodeAt(qa), ia === 47) {
          if (!La) {
            da = qa;
            break;
          }
        } else
          La = !1;
      return da === -1 ? aa ? "/" : "." : aa && da === 1 ? "//" : na.slice(0, da);
    },
    basename: function(na, ia) {
      if (ia !== void 0 && typeof ia != "string") throw new TypeError('"ext" argument must be a string');
      Bi(na);
      var aa = 0, da = -1, La = !0, qa;
      if (ia !== void 0 && ia.length > 0 && ia.length <= na.length) {
        if (ia.length === na.length && ia === na) return "";
        var io = ia.length - 1, ao = -1;
        for (qa = na.length - 1; qa >= 0; --qa) {
          var oo = na.charCodeAt(qa);
          if (oo === 47) {
            if (!La) {
              aa = qa + 1;
              break;
            }
          } else
            ao === -1 && (La = !1, ao = qa + 1), io >= 0 && (oo === ia.charCodeAt(io) ? --io === -1 && (da = qa) : (io = -1, da = ao));
        }
        return aa === da ? da = ao : da === -1 && (da = na.length), na.slice(aa, da);
      } else {
        for (qa = na.length - 1; qa >= 0; --qa)
          if (na.charCodeAt(qa) === 47) {
            if (!La) {
              aa = qa + 1;
              break;
            }
          } else da === -1 && (La = !1, da = qa + 1);
        return da === -1 ? "" : na.slice(aa, da);
      }
    },
    extname: function(na) {
      Bi(na);
      for (var ia = -1, aa = 0, da = -1, La = !0, qa = 0, io = na.length - 1; io >= 0; --io) {
        var ao = na.charCodeAt(io);
        if (ao === 47) {
          if (!La) {
            aa = io + 1;
            break;
          }
          continue;
        }
        da === -1 && (La = !1, da = io + 1), ao === 46 ? ia === -1 ? ia = io : qa !== 1 && (qa = 1) : ia !== -1 && (qa = -1);
      }
      return ia === -1 || da === -1 || // We saw a non-dot character immediately before the dot
      qa === 0 || // The (right-most) trimmed path component is exactly '..'
      qa === 1 && ia === da - 1 && ia === aa + 1 ? "" : na.slice(ia, da);
    },
    format: function(na) {
      if (na === null || typeof na != "object")
        throw new TypeError('The "pathObject" argument must be of type Object. Received type ' + typeof na);
      return Ui("/", na);
    },
    parse: function(na) {
      Bi(na);
      var ia = { root: "", dir: "", base: "", ext: "", name: "" };
      if (na.length === 0) return ia;
      var aa = na.charCodeAt(0), da = aa === 47, La;
      da ? (ia.root = "/", La = 1) : La = 0;
      for (var qa = -1, io = 0, ao = -1, oo = !0, no = na.length - 1, lo = 0; no >= La; --no) {
        if (aa = na.charCodeAt(no), aa === 47) {
          if (!oo) {
            io = no + 1;
            break;
          }
          continue;
        }
        ao === -1 && (oo = !1, ao = no + 1), aa === 46 ? qa === -1 ? qa = no : lo !== 1 && (lo = 1) : qa !== -1 && (lo = -1);
      }
      return qa === -1 || ao === -1 || // We saw a non-dot character immediately before the dot
      lo === 0 || // The (right-most) trimmed path component is exactly '..'
      lo === 1 && qa === ao - 1 && qa === io + 1 ? ao !== -1 && (io === 0 && da ? ia.base = ia.name = na.slice(1, ao) : ia.base = ia.name = na.slice(io, ao)) : (io === 0 && da ? (ia.name = na.slice(1, qa), ia.base = na.slice(1, ao)) : (ia.name = na.slice(io, qa), ia.base = na.slice(io, ao)), ia.ext = na.slice(qa, ao)), io > 0 ? ia.dir = na.slice(0, io - 1) : da && (ia.dir = "/"), ia;
    },
    sep: "/",
    delimiter: ":",
    win32: null,
    posix: null
  };
  return Zi.posix = Zi, pathBrowserify = Zi, pathBrowserify;
}
var pathBrowserifyExports = requirePathBrowserify();
const MenuItemStyle = cva([
  "dark:hover:bg-neutral-300",
  "dark:hover:text-neutral-700",
  "hover:bg-neutral-100",
  "p-1",
  "items-center",
  "gap-2",
  "whitespace-nowrap",
  "w-full",
  "flex",
  "text-left",
  "text-sm",
  "disabled:text-neutral-500",
  "disabled:hover:bg-none",
  "cursor-default"
]);
function MenuItem({ className: Bi = "", ...e }) {
  return /* @__PURE__ */ jsxRuntimeExports.jsx($3674c52c6b3c5bce$export$2ce376c2cc3355c8, { ...e, className: MenuItemStyle({}) });
}
const MenuStyle = cva([
  "bg-white",
  "text-black",
  "border-b",
  "border",
  "shadow-md",
  "p-2"
]);
function Menu({ children: Bi, button: e, className: Ui, isOpen: Zi, setOpen: ta }) {
  return /* @__PURE__ */ jsxRuntimeExports.jsxs($3674c52c6b3c5bce$export$27d2ad3c5815583e, { isOpen: Zi, onOpenChange: ta, children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx($d2b4bc8c273e7be6$export$353f5b6fc5456de1, { children: e || /* @__PURE__ */ jsxRuntimeExports.jsx(
      FontAwesomeIcon,
      {
        className: "dark:text-neutral-300 text-neutral-700",
        icon: faBars
      }
    ) }),
    /* @__PURE__ */ jsxRuntimeExports.jsx($07b14b47974efb58$export$5b6b19405a83ff9d, { children: /* @__PURE__ */ jsxRuntimeExports.jsx($3674c52c6b3c5bce$export$d9b273488cd8ce6f, { className: twMerge(MenuStyle({}), Ui), children: Bi }) })
  ] });
}
const FileBrowserHeader = observer(
  ({
    store: Bi,
    homeDirectory: e,
    searchDisabled: Ui,
    searchBarExtras: Zi
  }) => /* @__PURE__ */ jsxRuntimeExports.jsxs("header", { className: "row-start-1 w-full", children: [
    /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "px-2 flex w-full gap-4 border border-black", children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "flex w-full", children: /* @__PURE__ */ jsxRuntimeExports.jsx(
        "input",
        {
          disabled: Ui,
          value: Bi.searchQuery ?? "",
          onChange: (ta) => Bi.setSearchQuery(ta.target.value),
          className: "w-full p-1 rounded border-none h-6 my-auto flex-grow bg-white dark:bg-neutral-300 text-neutral-600 focus:outline-none",
          type: "text",
          placeholder: "search..."
        }
      ) }),
      /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "flex gap-2", children: [
        /* @__PURE__ */ jsxRuntimeExports.jsx(
          $1e2864c73f66a4da$export$6fb4a10d2c950550,
          {
            onSelect: (ta) => {
              ta && Bi.onDrop(Array.from(ta));
            },
            children: /* @__PURE__ */ jsxRuntimeExports.jsx($d2b4bc8c273e7be6$export$353f5b6fc5456de1, { className: MenuItemStyle(), children: /* @__PURE__ */ jsxRuntimeExports.jsx(R, { size: 18 }) })
          }
        ),
        Zi && Zi(Bi.searchQuery ?? ""),
        /* @__PURE__ */ jsxRuntimeExports.jsx(Menu, { children: /* @__PURE__ */ jsxRuntimeExports.jsxs(MenuItem, { onAction: () => {
          Bi.setCreateFolderModalVisible(!0);
        }, children: [
          /* @__PURE__ */ jsxRuntimeExports.jsx(P$1, { size: 18 }),
          " Create Folder"
        ] }) })
      ] })
    ] }),
    /* @__PURE__ */ jsxRuntimeExports.jsxs(
      "button",
      {
        className: "inline text-black pb-2 hover:text-neutral-300 hover:fill-neutral-300",
        onClick: () => Bi.popToRoot(),
        children: [
          e,
          "/"
        ]
      }
    ),
    Bi.currentPath.map((ta, na) => /* @__PURE__ */ jsxRuntimeExports.jsxs(
      "button",
      {
        className: "inline text-black pb-2 hover:text-neutral-300",
        onClick: () => {
          na !== Bi.currentPath.length - 1 && Bi.popFolderHistoryToIndex(na);
        },
        children: [
          pathBrowserifyExports.basename(ta),
          "/"
        ]
      },
      `${ta}-${na}`
    ))
  ] })
);
function UploadToast({ files: Bi }) {
  return /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx("p", { className: "m-2", children: "Uploading:" }),
    /* @__PURE__ */ jsxRuntimeExports.jsx("ul", { children: Bi.map((e) => /* @__PURE__ */ jsxRuntimeExports.jsx("li", { className: "pl-4 list-none", children: e.name }, e.name)) })
  ] });
}
class FileBrowserStore {
  constructor(e) {
    hd(this, "searchQuery", null);
    hd(this, "currentPath", []);
    hd(this, "searchResults", null);
    hd(this, "createFolderModalVisible", !1);
    hd(this, "onSearch");
    hd(this, "onUpload");
    hd(this, "onNavigate");
    hd(this, "searchLoading", !1);
    e ? this.currentPath = e : this.currentPath = [], makeAutoObservable(this), this.onDrop = this.onDrop.bind(this), this.pushPathPart = this.pushPathPart.bind(this), this.setCreateFolderModalVisible = this.setCreateFolderModalVisible.bind(this), this.setSearchQuery = this.setSearchQuery.bind(this), this.popFolderHistory = this.popFolderHistory.bind(this), this.popFolderHistoryToIndex = this.popFolderHistoryToIndex.bind(this), this.setSearchResults = this.setSearchResults.bind(this);
  }
  setCreateFolderModalVisible(e) {
    this.createFolderModalVisible = e;
  }
  pushPathPart(e) {
    this.currentPath.push(e);
  }
  popFolderHistory() {
    this.currentPath.pop(), this.onNavigate?.(
      this.currentPath
    );
  }
  popToRoot() {
    this.currentPath = [], this.onNavigate?.([]);
  }
  popFolderHistoryToIndex(e) {
    this.currentPath = this.currentPath.slice(0, e + 1), this.onNavigate?.(
      this.currentPath
    );
  }
  async setSearchResults(e) {
    this.searchResults = e;
  }
  async setSearchQuery(e) {
    if (this.searchQuery = e, e) {
      if (!this.onSearch)
        return;
    } else {
      this.searchResults = null, this.searchLoading = !1;
      return;
    }
    this.onSearch(e);
  }
  // get currentFolderPath() {
  //     if (this.currentPath.length === 0) {
  //         return "";
  //     }
  //     // return this.folderHistory.reduce((acc, f) => acc + f, "");
  //     return this.currentPath[this.currentPath.length - 1];
  // }
  async onDrop(e) {
    if (e[0].size / (1024 * 1024 * 1024) > 1)
      throw toast("File cannot be bigger than 1GB"), new Error("File cannot be bigger than 1GB");
    if (this.onUpload)
      try {
        const ta = await this.onUpload(e);
        if (!ta)
          return;
        const na = toast(/* @__PURE__ */ jsxRuntimeExports.jsx(UploadToast, { files: e }), {
          progress: 0
        });
        ta.subscribe({
          onProgress: (ia) => {
            toast.update(na, {
              progress: ia
            });
          },
          onError: (ia) => {
            toast.error("Something went wrong!: " + ia.message);
          },
          onComplete: () => {
            toast.dismiss(na);
          }
        });
      } catch (ta) {
        toast.error("Something went wrong!: " + ta);
      }
  }
}
function selectionIncludes(Bi, e) {
  return !!e.find(
    ({ path: Ui, isFolder: Zi }) => Bi.path === Ui && Zi === Bi.isFolder
  );
}
function getNewSelection(Bi, e, Ui) {
  switch (Ui) {
    case Re$2.ALL:
      return selectionIncludes(e, Bi) ? Bi.filter((Zi) => Zi.path !== e.path) : [...Bi, e];
    case Re$2.FILE:
      return e.isFolder ? Bi : selectionIncludes(e, Bi) ? [] : [e];
    case Re$2.DIR:
      return e.isFolder ? selectionIncludes(e, Bi) ? [] : [e] : Bi;
    case Re$2.FILE_LIST:
      return e.isFolder ? Bi : selectionIncludes(e, Bi) ? Bi.filter((Zi) => Zi.path !== e.path) : [...Bi, e];
    case Re$2.NONE:
    default:
      return Bi;
  }
}
const Spacer = () => /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "flex-grow" });
function PathActions({
  onDelete: Bi,
  path: e,
  onPreview: Ui,
  onDownload: Zi,
  onMoveUpAFolder: ta,
  className: na = "",
  isOpen: ia,
  setOpen: aa
}) {
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(
    Menu,
    {
      button: /* @__PURE__ */ jsxRuntimeExports.jsx(L, { className: na, size: 18, "data-testid": `path-actions-${e.path}` }),
      isOpen: ia,
      setOpen: aa,
      children: [
        !e.isFolder && Zi && /* @__PURE__ */ jsxRuntimeExports.jsx(
          MenuItem,
          {
            onAction: async () => {
              Zi(e);
            },
            children: "Download"
          }
        ),
        ta && /* @__PURE__ */ jsxRuntimeExports.jsx(
          MenuItem,
          {
            onAction: async () => {
              const da = pathBrowserifyExports.dirname(pathBrowserifyExports.dirname(e.path)), La = pathBrowserifyExports.basename(e.path), qa = `${da}/${La}`;
              ta(da === "." ? null : { path: e, parent: da, newPath: qa });
            },
            children: "Move Up a Folder"
          }
        ),
        Bi && /* @__PURE__ */ jsxRuntimeExports.jsx(MenuItem, { onAction: () => Bi(), children: "Delete" }),
        !e.isFolder && Ui && /* @__PURE__ */ jsxRuntimeExports.jsx(MenuItem, { onAction: () => Ui(e), children: "Preview" })
      ]
    }
  );
}
const containerStyles = cva(
  [
    "relative",
    "flex",
    "gap-2",
    "p-1",
    "select-none",
    "hover:bg-neutral-200",
    "dark:hover:bg-neutral-600",
    "items-center",
    "w-full",
    "group"
  ],
  {
    variants: {
      selected: {
        true: ["text-blue-500", "hover:after:h-0"],
        false: ["text-neutral-800", "dark:text-neutral-200"]
      },
      isOver: {
        true: ["bg-neutral-300", "dark:bg-neutral-600"],
        false: ["bg-transparent"]
      }
    }
  }
), S3Container = forwardRef(
  (Bi, e) => {
    const {
      children: Ui,
      selected: Zi,
      showCheckbox: ta = !0,
      style: na,
      onCheckboxValueChange: ia,
      onClick: aa,
      isOver: da,
      path: La
    } = Bi;
    return /* @__PURE__ */ jsxRuntimeExports.jsxs(
      motion.div,
      {
        "data-testid": `file-${La}`,
        className: containerStyles({ selected: Zi, isOver: da }),
        ref: e,
        style: na,
        onClick: (qa) => {
          qa.stopPropagation, aa?.(qa);
        },
        layout: !0,
        children: [
          ta && /* @__PURE__ */ jsxRuntimeExports.jsx(
            CheckBox,
            {
              onClick: (qa) => qa.stopPropagation(),
              onChange: (qa) => {
                ia(qa.currentTarget.checked);
              },
              className: "mr-2",
              checked: Zi
            }
          ),
          Ui
        ]
      }
    );
  }
), S3File = ({
  path: Bi,
  onClick: e,
  selected: Ui,
  readOnly: Zi = !1,
  showFullPath: ta = !1,
  onDelete: na,
  style: ia,
  onPreview: aa,
  onDownload: da,
  onMoveUpAFolder: La,
  showCheckbox: qa = !0
}) => {
  const [, io] = useDrag({
    canDrag: !Zi,
    type: "S3File",
    item: { ...Bi },
    collect: (lo) => ({
      isDragging: lo.isDragging()
    })
  }), ao = pathBrowserifyExports.basename(Bi.path), [oo, no] = useState(!1);
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(
    S3Container,
    {
      path: Bi.path,
      style: { ...ia },
      onClick: (lo) => {
        lo.stopPropagation();
      },
      showCheckbox: qa,
      onCheckboxValueChange: () => e(Bi),
      selected: Ui,
      ref: io,
      children: [
        /* @__PURE__ */ jsxRuntimeExports.jsx(I, { size: 18, className: "pr-1 flex-shrink-0" }),
        /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "flex flex-col justify-around flex-shrink h-full overflow-hidden", children: /* @__PURE__ */ jsxRuntimeExports.jsx("p", { children: ta ? Bi.path : ao }) }),
        /* @__PURE__ */ jsxRuntimeExports.jsx(Spacer, {}),
        /* @__PURE__ */ jsxRuntimeExports.jsx(
          PathActions,
          {
            className: `${oo ? "" : "opacity-0 focus:opacity-100"} group-hover:opacity-100 focus:opacity-100`,
            onPreview: aa,
            path: Bi,
            onDelete: na ? () => na?.(Bi) : void 0,
            onMoveUpAFolder: La,
            onDownload: da,
            isOpen: oo,
            setOpen: no
          }
        )
      ]
    }
  );
}, S3Folder = ({
  path: Bi,
  onClick: e,
  onDblClick: Ui,
  selected: Zi,
  onDrop: ta,
  readOnly: na = !1,
  style: ia,
  onDelete: aa,
  showActions: da,
  onPreview: La,
  showFullPath: qa,
  showCheckbox: io = !0
}) => {
  const ao = li$1(
    () => {
    },
    () => Ui(Bi)
  ), [, oo] = useDrag({
    canDrag: !na,
    type: "S3Folder",
    item: { ...Bi },
    collect: (bs) => ({
      isDragging: bs.isDragging()
    })
  }), [no] = useState(!1), [{ isOver: lo }, so] = useDrop({
    canDrop: () => !na,
    accept: ["S3Folder", "S3File"],
    drop: (bs) => ta(bs),
    collect: (bs) => ({
      isOver: bs.isOver()
    })
  });
  return /* @__PURE__ */ jsxRuntimeExports.jsx("div", { ref: so, style: ia, children: /* @__PURE__ */ jsxRuntimeExports.jsxs(
    S3Container,
    {
      path: Bi.path,
      selected: Zi,
      isOver: lo,
      onClick: (bs) => {
        bs.stopPropagation(), ao();
      },
      ref: oo,
      showCheckbox: io,
      onCheckboxValueChange: () => e(Bi),
      children: [
        /* @__PURE__ */ jsxRuntimeExports.jsx(w$1, { size: 18, className: "pr-1 flex-shrink-0" }),
        /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "flex flex-col justify-around h-full", children: /* @__PURE__ */ jsxRuntimeExports.jsx("p", { children: qa ? Bi.path : pathBrowserifyExports.basename(Bi.path) }) }),
        /* @__PURE__ */ jsxRuntimeExports.jsx(Spacer, {}),
        da && La && aa && no && /* @__PURE__ */ jsxRuntimeExports.jsx(
          PathActions,
          {
            onPreview: La,
            path: Bi,
            onDelete: aa ? () => aa(Bi) : void 0
          }
        )
      ]
    }
  ) });
};
function useMobxPropSync(Bi, e) {
  useEffect(() => {
    for (const Ui in Bi)
      Bi.hasOwnProperty(Ui) && Bi[Ui] && (e[Ui] = Bi[Ui]);
  }, [Bi, e]);
}
const FileBrowser = observer(
  ({
    selectionMode: Bi = Re$2.NONE,
    // files,
    selection: e,
    onSelectionChange: Ui,
    readOnly: Zi = !1,
    className: ta,
    showActions: na = !0,
    onDownload: ia,
    onMoveUpAFolder: aa,
    style: da,
    onPreview: La,
    onDelete: qa,
    onMove: io,
    onCreateFolder: ao,
    onSearch: oo,
    searchDisabled: no = !1,
    onNavigate: lo,
    filePathHomeDirectory: so = "~",
    onUpload: bs,
    searchBarExtras: Rs,
    files: js,
    loading: qs,
    // getFiles,
    path: jo
  }) => {
    const fs = useLocalObservable(() => new FileBrowserStore(jo)), { getRootProps: Ao, getInputProps: co, isDragActive: Co } = useDropzone({
      noClick: !0,
      onDrop: fs.onDrop
    }), Zs = useCallback(
      (Ol) => getNewSelection(e, Ol, Bi),
      [e, Bi]
    ), xl = useCallback(async () => {
      fs.searchLoading = !0;
      const Ol = fs.searchQuery;
      if (!oo || !Ol) {
        fs.searchLoading = !1;
        return;
      }
      fs.setSearchResults([]), setTimeout(async () => {
        if (fs.searchQuery === Ol && Ol) {
          const Bl = await oo(Ol);
          if (!Bl) return;
          fs.setSearchResults(Bl), fs.searchLoading = !1;
        }
      }, 500);
    }, [oo, fs.searchQuery]);
    useEffect(() => {
      fs.onSearch = xl;
    }, [xl]), useMobxPropSync(
      {
        onUpload: bs,
        onNavigate: lo,
        currentPath: jo
      },
      fs
    );
    const Cl = fs.searchResults || js || [], Al = useRef(null);
    return /* @__PURE__ */ jsxRuntimeExports.jsxs(
      "div",
      {
        className: twMerge(
          "grid-rows-[2rem 1fr] box-border relative flex flex-col justify-start flex-grow w-full gap-2 overflow-auto text-neutral-800 bg-white",
          ta
        ),
        style: da,
        ...Ao(),
        children: [
          Co && /* @__PURE__ */ jsxRuntimeExports.jsx(
            "div",
            {
              style: { zIndex: 999 },
              className: "w-full h-full absolute top-0 left-0 flex justify-center items-center z-[999] bg-opacity-20 text-orange-2 pointer-events-none bg-white text-4xl",
              children: "Drop files here"
            }
          ),
          /* @__PURE__ */ jsxRuntimeExports.jsx("input", { className: "z-50 bg-purple-500", ...co() }),
          /* @__PURE__ */ jsxRuntimeExports.jsx("div", { children: /* @__PURE__ */ jsxRuntimeExports.jsx(
            FileBrowserHeader,
            {
              searchDisabled: no,
              selection: e,
              store: fs,
              homeDirectory: so,
              searchBarExtras: Rs
            }
          ) }),
          Bi !== Re$2.NONE && /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "mr-auto ml-1 flex items-center gap-2 text-neutral-400", children: [
            /* @__PURE__ */ jsxRuntimeExports.jsx(
              CheckBox,
              {
                checked: e.length > 0,
                onChange: () => {
                  Cl && (e.length === 0 ? Ui?.([...e, ...Cl]) : Ui?.([]));
                }
              }
            ),
            /* @__PURE__ */ jsxRuntimeExports.jsxs("p", { className: "text-xs", children: [
              e.length,
              " file",
              e.length !== 1 && "s",
              " selected"
            ] })
          ] }),
          /* @__PURE__ */ jsxRuntimeExports.jsx(
            "div",
            {
              ref: Al,
              className: "relative flex-grow overflow-auto",
              children: /* @__PURE__ */ jsxRuntimeExports.jsx(DndProvider, { backend: HTML5Backend, children: /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "row-start-2 row-span-1 flex-grow relative", children: [
                qs ? /* @__PURE__ */ jsxRuntimeExports.jsx("p", { className: "py-2 italic text-neutral-600", children: "Loading..." }) : null,
                Cl?.length === 0 && !fs.searchLoading && !qs && /* @__PURE__ */ jsxRuntimeExports.jsx("p", { className: "py-2 italic text-neutral-600", children: "No files" }),
                fs.searchLoading && /* @__PURE__ */ jsxRuntimeExports.jsx("p", { className: "py-2 italic text-neutral-600", children: "Searching..." }),
                Cl && Cl.length > 0 && Cl.map((Ol) => {
                  const Bl = {
                    key: getKey(Ol),
                    showActions: na,
                    readOnly: Zi,
                    onDelete: qa ? () => {
                      qa([Ol]), Ui?.([]);
                    } : void 0,
                    onClick: (Ml) => {
                      const Vl = Zs(Ml);
                      Ui?.(Vl);
                    },
                    showFullPath: !!fs.searchQuery,
                    // show full path if searching
                    path: Ol,
                    selected: selectionIncludes(Ol, e),
                    onPreview: La
                  };
                  return Ol.isFolder ? /* @__PURE__ */ jsxRuntimeExports.jsx(
                    S3Folder,
                    {
                      ...Bl,
                      showCheckbox: Bi !== Re$2.NONE && Bi !== Re$2.FILE && Bi !== Re$2.FILE_LIST,
                      onDblClick: (Ml) => {
                        const Vl = Ml.path.split("/").filter(Boolean).pop();
                        Vl && (fs.pushPathPart(Vl), lo?.(fs.currentPath));
                      },
                      onDrop: (Ml) => io?.(Ml, Ol)
                    }
                  ) : /* @__PURE__ */ jsxRuntimeExports.jsx(
                    S3File,
                    {
                      ...Bl,
                      showCheckbox: Bi !== Re$2.NONE && Bi !== Re$2.DIR && Bi !== Re$2.DIR_LIST,
                      onMoveUpAFolder: aa,
                      onDownload: ia
                    }
                  );
                })
              ] }) })
            }
          ),
          /* @__PURE__ */ jsxRuntimeExports.jsx(
            CreateFolderModal,
            {
              visible: fs.createFolderModalVisible,
              onClose: () => fs.setCreateFolderModalVisible(!1),
              onCreateFolder: async (Ol) => {
                ao?.(Ol, fs.currentPath), fs.setCreateFolderModalVisible(!1);
              }
            }
          )
        ]
      }
    );
  }
), getKey = (Bi) => `${Bi.isFolder ? "folder" : "file"}-${Bi.path}`;
var ds = Object.defineProperty, hs = (Bi, e, Ui) => e in Bi ? ds(Bi, e, { enumerable: !0, configurable: !0, writable: !0, value: Ui }) : Bi[e] = Ui, mt = (Bi, e, Ui) => hs(Bi, e + "", Ui), Qr = function(Bi, e) {
  return Qr = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(Ui, Zi) {
    Ui.__proto__ = Zi;
  } || function(Ui, Zi) {
    for (var ta in Zi) Object.prototype.hasOwnProperty.call(Zi, ta) && (Ui[ta] = Zi[ta]);
  }, Qr(Bi, e);
};
function ps(Bi, e) {
  if (typeof e != "function" && e !== null)
    throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
  Qr(Bi, e);
  function Ui() {
    this.constructor = Bi;
  }
  Bi.prototype = e === null ? Object.create(e) : (Ui.prototype = e.prototype, new Ui());
}
var Sr = "Invariant Violation", Jn = Object.setPrototypeOf, ys = Jn === void 0 ? function(Bi, e) {
  return Bi.__proto__ = e, Bi;
} : Jn, B = (
  /** @class */
  function(Bi) {
    ps(e, Bi);
    function e(Ui) {
      Ui === void 0 && (Ui = Sr);
      var Zi = Bi.call(this, typeof Ui == "number" ? Sr + ": " + Ui + " (see https://github.com/apollographql/invariant-packages)" : Ui) || this;
      return Zi.framesToPop = 1, Zi.name = Sr, ys(Zi, e.prototype), Zi;
    }
    return e;
  }(Error)
);
function E(Bi, e) {
  if (!Bi)
    throw new B(e);
}
var Ji = ["debug", "log", "warn", "error", "silent"], vs = Ji.indexOf("log");
function Ht(Bi) {
  return function() {
    if (Ji.indexOf(Bi) >= vs) {
      var e = console[Bi] || console.log;
      return e.apply(console, arguments);
    }
  };
}
(function(Bi) {
  Bi.debug = Ht("debug"), Bi.log = Ht("log"), Bi.warn = Ht("warn"), Bi.error = Ht("error");
})(E || (E = {}));
function he(Bi) {
  try {
    return Bi();
  } catch {
  }
}
const Hn = he(function() {
  return globalThis;
}) || he(function() {
  return window;
}) || he(function() {
  return self;
}) || he(function() {
  return global;
}) || he(function() {
  return he.constructor("return this")();
});
var Yn = "__", Kn = [Yn, Yn].join("DEV");
function ms() {
  try {
    return !!__DEV__;
  } catch {
    return Object.defineProperty(Hn, Kn, {
      value: he(function() {
        return process.env.NODE_ENV;
      }) !== "production",
      enumerable: !1,
      configurable: !0,
      writable: !0
    }), Hn[Kn];
  }
}
const Or = ms();
function Pe(Bi) {
  try {
    return Bi();
  } catch {
  }
}
var Br = Pe(function() {
  return globalThis;
}) || Pe(function() {
  return window;
}) || Pe(function() {
  return self;
}) || Pe(function() {
  return global;
}) || // We don't expect the Function constructor ever to be invoked at runtime, as
// long as at least one of globalThis, window, self, or global is defined, so
// we are under no obligation to make it easy for static analysis tools to
// detect syntactic usage of the Function constructor. If you think you can
// improve your static analysis to detect this obfuscation, think again. This
// is an arms race you cannot win, at least not in JavaScript.
Pe(function() {
  return Pe.constructor("return this")();
}), Ur = !1;
function gs() {
  Br && !Pe(function() {
    return process.env.NODE_ENV;
  }) && !Pe(function() {
    return process;
  }) && (Object.defineProperty(Br, "process", {
    value: {
      env: {
        // This default needs to be "production" instead of "development", to
        // avoid the problem https://github.com/graphql/graphql-js/pull/2894
        // will eventually solve, once merged and released.
        NODE_ENV: "production"
      }
    },
    // Let anyone else change global.process as they see fit, but hide it from
    // Object.keys(global) enumeration.
    configurable: !0,
    enumerable: !1,
    writable: !0
  }), Ur = !0);
}
gs();
function Xn() {
  Ur && (delete Br.process, Ur = !1);
}
var Hi = Object.freeze({
  // Name
  NAME: "Name",
  // Document
  DOCUMENT: "Document",
  OPERATION_DEFINITION: "OperationDefinition",
  VARIABLE_DEFINITION: "VariableDefinition",
  SELECTION_SET: "SelectionSet",
  FIELD: "Field",
  ARGUMENT: "Argument",
  // Fragments
  FRAGMENT_SPREAD: "FragmentSpread",
  INLINE_FRAGMENT: "InlineFragment",
  FRAGMENT_DEFINITION: "FragmentDefinition",
  // Values
  VARIABLE: "Variable",
  INT: "IntValue",
  FLOAT: "FloatValue",
  STRING: "StringValue",
  BOOLEAN: "BooleanValue",
  NULL: "NullValue",
  ENUM: "EnumValue",
  LIST: "ListValue",
  OBJECT: "ObjectValue",
  OBJECT_FIELD: "ObjectField",
  // Directives
  DIRECTIVE: "Directive",
  // Types
  NAMED_TYPE: "NamedType",
  LIST_TYPE: "ListType",
  NON_NULL_TYPE: "NonNullType",
  // Type System Definitions
  SCHEMA_DEFINITION: "SchemaDefinition",
  OPERATION_TYPE_DEFINITION: "OperationTypeDefinition",
  // Type Definitions
  SCALAR_TYPE_DEFINITION: "ScalarTypeDefinition",
  OBJECT_TYPE_DEFINITION: "ObjectTypeDefinition",
  FIELD_DEFINITION: "FieldDefinition",
  INPUT_VALUE_DEFINITION: "InputValueDefinition",
  INTERFACE_TYPE_DEFINITION: "InterfaceTypeDefinition",
  UNION_TYPE_DEFINITION: "UnionTypeDefinition",
  ENUM_TYPE_DEFINITION: "EnumTypeDefinition",
  ENUM_VALUE_DEFINITION: "EnumValueDefinition",
  INPUT_OBJECT_TYPE_DEFINITION: "InputObjectTypeDefinition",
  // Directive Definitions
  DIRECTIVE_DEFINITION: "DirectiveDefinition",
  // Type System Extensions
  SCHEMA_EXTENSION: "SchemaExtension",
  // Type Extensions
  SCALAR_TYPE_EXTENSION: "ScalarTypeExtension",
  OBJECT_TYPE_EXTENSION: "ObjectTypeExtension",
  INTERFACE_TYPE_EXTENSION: "InterfaceTypeExtension",
  UNION_TYPE_EXTENSION: "UnionTypeExtension",
  ENUM_TYPE_EXTENSION: "EnumTypeExtension",
  INPUT_OBJECT_TYPE_EXTENSION: "InputObjectTypeExtension"
});
function _s(Bi, e) {
  throw new Error("Unexpected invariant triggered.");
}
var Zr = typeof Symbol == "function" && typeof Symbol.for == "function" ? Symbol.for("nodejs.util.inspect.custom") : void 0;
function Yi(Bi) {
  var e = Bi.prototype.toJSON;
  typeof e == "function" || _s(), Bi.prototype.inspect = e, Zr && (Bi.prototype[Zr] = e);
}
var ws = /* @__PURE__ */ function() {
  function Bi(Ui, Zi, ta) {
    this.start = Ui.start, this.end = Zi.end, this.startToken = Ui, this.endToken = Zi, this.source = ta;
  }
  var e = Bi.prototype;
  return e.toJSON = function() {
    return {
      start: this.start,
      end: this.end
    };
  }, Bi;
}();
Yi(ws);
var ks = /* @__PURE__ */ function() {
  function Bi(Ui, Zi, ta, na, ia, aa, da) {
    this.kind = Ui, this.start = Zi, this.end = ta, this.line = na, this.column = ia, this.value = da, this.prev = aa, this.next = null;
  }
  var e = Bi.prototype;
  return e.toJSON = function() {
    return {
      kind: this.kind,
      value: this.value,
      line: this.line,
      column: this.column
    };
  }, Bi;
}();
Yi(ks);
function ei(Bi) {
  return Bi != null && typeof Bi.kind == "string";
}
function Xt(Bi) {
  "@babel/helpers - typeof";
  return typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? Xt = function(e) {
    return typeof e;
  } : Xt = function(e) {
    return e && typeof Symbol == "function" && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
  }, Xt(Bi);
}
var Es = 10, Ki = 2;
function Xi(Bi) {
  return yr(Bi, []);
}
function yr(Bi, e) {
  switch (Xt(Bi)) {
    case "string":
      return JSON.stringify(Bi);
    case "function":
      return Bi.name ? "[function ".concat(Bi.name, "]") : "[function]";
    case "object":
      return Bi === null ? "null" : Ss(Bi, e);
    default:
      return String(Bi);
  }
}
function Ss(Bi, e) {
  if (e.indexOf(Bi) !== -1)
    return "[Circular]";
  var Ui = [].concat(e, [Bi]), Zi = Ts(Bi);
  if (Zi !== void 0) {
    var ta = Zi.call(Bi);
    if (ta !== Bi)
      return typeof ta == "string" ? ta : yr(ta, Ui);
  } else if (Array.isArray(Bi))
    return xs(Bi, Ui);
  return Os(Bi, Ui);
}
function Os(Bi, e) {
  var Ui = Object.keys(Bi);
  if (Ui.length === 0)
    return "{}";
  if (e.length > Ki)
    return "[" + Ds(Bi) + "]";
  var Zi = Ui.map(function(ta) {
    var na = yr(Bi[ta], e);
    return ta + ": " + na;
  });
  return "{ " + Zi.join(", ") + " }";
}
function xs(Bi, e) {
  if (Bi.length === 0)
    return "[]";
  if (e.length > Ki)
    return "[Array]";
  for (var Ui = Math.min(Es, Bi.length), Zi = Bi.length - Ui, ta = [], na = 0; na < Ui; ++na)
    ta.push(yr(Bi[na], e));
  return Zi === 1 ? ta.push("... 1 more item") : Zi > 1 && ta.push("... ".concat(Zi, " more items")), "[" + ta.join(", ") + "]";
}
function Ts(Bi) {
  var e = Bi[String(Zr)];
  if (typeof e == "function")
    return e;
  if (typeof Bi.inspect == "function")
    return Bi.inspect;
}
function Ds(Bi) {
  var e = Object.prototype.toString.call(Bi).replace(/^\[object /, "").replace(/]$/, "");
  if (e === "Object" && typeof Bi.constructor == "function") {
    var Ui = Bi.constructor.name;
    if (typeof Ui == "string" && Ui !== "")
      return Ui;
  }
  return e;
}
function Cs(Bi) {
  var e = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "", Ui = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : !1, Zi = Bi.indexOf(`
`) === -1, ta = Bi[0] === " " || Bi[0] === "	", na = Bi[Bi.length - 1] === '"', ia = Bi[Bi.length - 1] === "\\", aa = !Zi || na || ia || Ui, da = "";
  return aa && !(Zi && ta) && (da += `
` + e), da += e ? Bi.replace(/\n/g, `
` + e) : Bi, aa && (da += `
`), '"""' + da.replace(/"""/g, '\\"""') + '"""';
}
var As = {
  Name: [],
  Document: ["definitions"],
  OperationDefinition: ["name", "variableDefinitions", "directives", "selectionSet"],
  VariableDefinition: ["variable", "type", "defaultValue", "directives"],
  Variable: ["name"],
  SelectionSet: ["selections"],
  Field: ["alias", "name", "arguments", "directives", "selectionSet"],
  Argument: ["name", "value"],
  FragmentSpread: ["name", "directives"],
  InlineFragment: ["typeCondition", "directives", "selectionSet"],
  FragmentDefinition: [
    "name",
    // Note: fragment variable definitions are experimental and may be changed
    // or removed in the future.
    "variableDefinitions",
    "typeCondition",
    "directives",
    "selectionSet"
  ],
  IntValue: [],
  FloatValue: [],
  StringValue: [],
  BooleanValue: [],
  NullValue: [],
  EnumValue: [],
  ListValue: ["values"],
  ObjectValue: ["fields"],
  ObjectField: ["name", "value"],
  Directive: ["name", "arguments"],
  NamedType: ["name"],
  ListType: ["type"],
  NonNullType: ["type"],
  SchemaDefinition: ["description", "directives", "operationTypes"],
  OperationTypeDefinition: ["type"],
  ScalarTypeDefinition: ["description", "name", "directives"],
  ObjectTypeDefinition: ["description", "name", "interfaces", "directives", "fields"],
  FieldDefinition: ["description", "name", "arguments", "type", "directives"],
  InputValueDefinition: ["description", "name", "type", "defaultValue", "directives"],
  InterfaceTypeDefinition: ["description", "name", "interfaces", "directives", "fields"],
  UnionTypeDefinition: ["description", "name", "directives", "types"],
  EnumTypeDefinition: ["description", "name", "directives", "values"],
  EnumValueDefinition: ["description", "name", "directives"],
  InputObjectTypeDefinition: ["description", "name", "directives", "fields"],
  DirectiveDefinition: ["description", "name", "arguments", "locations"],
  SchemaExtension: ["directives", "operationTypes"],
  ScalarTypeExtension: ["name", "directives"],
  ObjectTypeExtension: ["name", "interfaces", "directives", "fields"],
  InterfaceTypeExtension: ["name", "interfaces", "directives", "fields"],
  UnionTypeExtension: ["name", "directives", "types"],
  EnumTypeExtension: ["name", "directives", "values"],
  InputObjectTypeExtension: ["name", "directives", "fields"]
}, gn = Object.freeze({});
function Te(Bi, e) {
  var Ui = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : As, Zi = void 0, ta = Array.isArray(Bi), na = [Bi], ia = -1, aa = [], da = void 0, La = void 0, qa = void 0, io = [], ao = [], oo = Bi;
  do {
    ia++;
    var no = ia === na.length, lo = no && aa.length !== 0;
    if (no) {
      if (La = ao.length === 0 ? void 0 : io[io.length - 1], da = qa, qa = ao.pop(), lo) {
        if (ta)
          da = da.slice();
        else {
          for (var so = {}, bs = 0, Rs = Object.keys(da); bs < Rs.length; bs++) {
            var js = Rs[bs];
            so[js] = da[js];
          }
          da = so;
        }
        for (var qs = 0, jo = 0; jo < aa.length; jo++) {
          var fs = aa[jo][0], Ao = aa[jo][1];
          ta && (fs -= qs), ta && Ao === null ? (da.splice(fs, 1), qs++) : da[fs] = Ao;
        }
      }
      ia = Zi.index, na = Zi.keys, aa = Zi.edits, ta = Zi.inArray, Zi = Zi.prev;
    } else {
      if (La = qa ? ta ? ia : na[ia] : void 0, da = qa ? qa[La] : oo, da == null)
        continue;
      qa && io.push(La);
    }
    var co = void 0;
    if (!Array.isArray(da)) {
      if (!ei(da))
        throw new Error("Invalid AST Node: ".concat(Xi(da), "."));
      var Co = Ns(e, da.kind, no);
      if (Co) {
        if (co = Co.call(e, da, La, qa, io, ao), co === gn)
          break;
        if (co === !1) {
          if (!no) {
            io.pop();
            continue;
          }
        } else if (co !== void 0 && (aa.push([La, co]), !no))
          if (ei(co))
            da = co;
          else {
            io.pop();
            continue;
          }
      }
    }
    if (co === void 0 && lo && aa.push([La, da]), no)
      io.pop();
    else {
      var Zs;
      Zi = {
        inArray: ta,
        index: ia,
        keys: na,
        edits: aa,
        prev: Zi
      }, ta = Array.isArray(da), na = ta ? da : (Zs = Ui[da.kind]) !== null && Zs !== void 0 ? Zs : [], ia = -1, aa = [], qa && ao.push(qa), qa = da;
    }
  } while (Zi !== void 0);
  return aa.length !== 0 && (oo = aa[aa.length - 1][1]), oo;
}
function Ns(Bi, e, Ui) {
  var Zi = Bi[e];
  if (Zi) {
    if (!Ui && typeof Zi == "function")
      return Zi;
    var ta = Ui ? Zi.leave : Zi.enter;
    if (typeof ta == "function")
      return ta;
  } else {
    var na = Ui ? Bi.leave : Bi.enter;
    if (na) {
      if (typeof na == "function")
        return na;
      var ia = na[e];
      if (typeof ia == "function")
        return ia;
    }
  }
}
function ea(Bi) {
  return Te(Bi, {
    leave: Fs
  });
}
var Ps = 80, Fs = {
  Name: function(Bi) {
    return Bi.value;
  },
  Variable: function(Bi) {
    return "$" + Bi.name;
  },
  // Document
  Document: function(Bi) {
    return x(Bi.definitions, `

`) + `
`;
  },
  OperationDefinition: function(Bi) {
    var e = Bi.operation, Ui = Bi.name, Zi = J("(", x(Bi.variableDefinitions, ", "), ")"), ta = x(Bi.directives, " "), na = Bi.selectionSet;
    return !Ui && !ta && !Zi && e === "query" ? na : x([e, x([Ui, Zi]), ta, na], " ");
  },
  VariableDefinition: function(Bi) {
    var e = Bi.variable, Ui = Bi.type, Zi = Bi.defaultValue, ta = Bi.directives;
    return e + ": " + Ui + J(" = ", Zi) + J(" ", x(ta, " "));
  },
  SelectionSet: function(Bi) {
    var e = Bi.selections;
    return ye(e);
  },
  Field: function(Bi) {
    var e = Bi.alias, Ui = Bi.name, Zi = Bi.arguments, ta = Bi.directives, na = Bi.selectionSet, ia = J("", e, ": ") + Ui, aa = ia + J("(", x(Zi, ", "), ")");
    return aa.length > Ps && (aa = ia + J(`(
`, er(x(Zi, `
`)), `
)`)), x([aa, x(ta, " "), na], " ");
  },
  Argument: function(Bi) {
    var e = Bi.name, Ui = Bi.value;
    return e + ": " + Ui;
  },
  // Fragments
  FragmentSpread: function(Bi) {
    var e = Bi.name, Ui = Bi.directives;
    return "..." + e + J(" ", x(Ui, " "));
  },
  InlineFragment: function(Bi) {
    var e = Bi.typeCondition, Ui = Bi.directives, Zi = Bi.selectionSet;
    return x(["...", J("on ", e), x(Ui, " "), Zi], " ");
  },
  FragmentDefinition: function(Bi) {
    var e = Bi.name, Ui = Bi.typeCondition, Zi = Bi.variableDefinitions, ta = Bi.directives, na = Bi.selectionSet;
    return (
      // Note: fragment variable definitions are experimental and may be changed
      // or removed in the future.
      "fragment ".concat(e).concat(J("(", x(Zi, ", "), ")"), " ") + "on ".concat(Ui, " ").concat(J("", x(ta, " "), " ")) + na
    );
  },
  // Value
  IntValue: function(Bi) {
    var e = Bi.value;
    return e;
  },
  FloatValue: function(Bi) {
    var e = Bi.value;
    return e;
  },
  StringValue: function(Bi, e) {
    var Ui = Bi.value, Zi = Bi.block;
    return Zi ? Cs(Ui, e === "description" ? "" : "  ") : JSON.stringify(Ui);
  },
  BooleanValue: function(Bi) {
    var e = Bi.value;
    return e ? "true" : "false";
  },
  NullValue: function() {
    return "null";
  },
  EnumValue: function(Bi) {
    var e = Bi.value;
    return e;
  },
  ListValue: function(Bi) {
    var e = Bi.values;
    return "[" + x(e, ", ") + "]";
  },
  ObjectValue: function(Bi) {
    var e = Bi.fields;
    return "{" + x(e, ", ") + "}";
  },
  ObjectField: function(Bi) {
    var e = Bi.name, Ui = Bi.value;
    return e + ": " + Ui;
  },
  // Directive
  Directive: function(Bi) {
    var e = Bi.name, Ui = Bi.arguments;
    return "@" + e + J("(", x(Ui, ", "), ")");
  },
  // Type
  NamedType: function(Bi) {
    var e = Bi.name;
    return e;
  },
  ListType: function(Bi) {
    var e = Bi.type;
    return "[" + e + "]";
  },
  NonNullType: function(Bi) {
    var e = Bi.type;
    return e + "!";
  },
  // Type System Definitions
  SchemaDefinition: pe(function(Bi) {
    var e = Bi.directives, Ui = Bi.operationTypes;
    return x(["schema", x(e, " "), ye(Ui)], " ");
  }),
  OperationTypeDefinition: function(Bi) {
    var e = Bi.operation, Ui = Bi.type;
    return e + ": " + Ui;
  },
  ScalarTypeDefinition: pe(function(Bi) {
    var e = Bi.name, Ui = Bi.directives;
    return x(["scalar", e, x(Ui, " ")], " ");
  }),
  ObjectTypeDefinition: pe(function(Bi) {
    var e = Bi.name, Ui = Bi.interfaces, Zi = Bi.directives, ta = Bi.fields;
    return x(["type", e, J("implements ", x(Ui, " & ")), x(Zi, " "), ye(ta)], " ");
  }),
  FieldDefinition: pe(function(Bi) {
    var e = Bi.name, Ui = Bi.arguments, Zi = Bi.type, ta = Bi.directives;
    return e + (ti(Ui) ? J(`(
`, er(x(Ui, `
`)), `
)`) : J("(", x(Ui, ", "), ")")) + ": " + Zi + J(" ", x(ta, " "));
  }),
  InputValueDefinition: pe(function(Bi) {
    var e = Bi.name, Ui = Bi.type, Zi = Bi.defaultValue, ta = Bi.directives;
    return x([e + ": " + Ui, J("= ", Zi), x(ta, " ")], " ");
  }),
  InterfaceTypeDefinition: pe(function(Bi) {
    var e = Bi.name, Ui = Bi.interfaces, Zi = Bi.directives, ta = Bi.fields;
    return x(["interface", e, J("implements ", x(Ui, " & ")), x(Zi, " "), ye(ta)], " ");
  }),
  UnionTypeDefinition: pe(function(Bi) {
    var e = Bi.name, Ui = Bi.directives, Zi = Bi.types;
    return x(["union", e, x(Ui, " "), Zi && Zi.length !== 0 ? "= " + x(Zi, " | ") : ""], " ");
  }),
  EnumTypeDefinition: pe(function(Bi) {
    var e = Bi.name, Ui = Bi.directives, Zi = Bi.values;
    return x(["enum", e, x(Ui, " "), ye(Zi)], " ");
  }),
  EnumValueDefinition: pe(function(Bi) {
    var e = Bi.name, Ui = Bi.directives;
    return x([e, x(Ui, " ")], " ");
  }),
  InputObjectTypeDefinition: pe(function(Bi) {
    var e = Bi.name, Ui = Bi.directives, Zi = Bi.fields;
    return x(["input", e, x(Ui, " "), ye(Zi)], " ");
  }),
  DirectiveDefinition: pe(function(Bi) {
    var e = Bi.name, Ui = Bi.arguments, Zi = Bi.repeatable, ta = Bi.locations;
    return "directive @" + e + (ti(Ui) ? J(`(
`, er(x(Ui, `
`)), `
)`) : J("(", x(Ui, ", "), ")")) + (Zi ? " repeatable" : "") + " on " + x(ta, " | ");
  }),
  SchemaExtension: function(Bi) {
    var e = Bi.directives, Ui = Bi.operationTypes;
    return x(["extend schema", x(e, " "), ye(Ui)], " ");
  },
  ScalarTypeExtension: function(Bi) {
    var e = Bi.name, Ui = Bi.directives;
    return x(["extend scalar", e, x(Ui, " ")], " ");
  },
  ObjectTypeExtension: function(Bi) {
    var e = Bi.name, Ui = Bi.interfaces, Zi = Bi.directives, ta = Bi.fields;
    return x(["extend type", e, J("implements ", x(Ui, " & ")), x(Zi, " "), ye(ta)], " ");
  },
  InterfaceTypeExtension: function(Bi) {
    var e = Bi.name, Ui = Bi.interfaces, Zi = Bi.directives, ta = Bi.fields;
    return x(["extend interface", e, J("implements ", x(Ui, " & ")), x(Zi, " "), ye(ta)], " ");
  },
  UnionTypeExtension: function(Bi) {
    var e = Bi.name, Ui = Bi.directives, Zi = Bi.types;
    return x(["extend union", e, x(Ui, " "), Zi && Zi.length !== 0 ? "= " + x(Zi, " | ") : ""], " ");
  },
  EnumTypeExtension: function(Bi) {
    var e = Bi.name, Ui = Bi.directives, Zi = Bi.values;
    return x(["extend enum", e, x(Ui, " "), ye(Zi)], " ");
  },
  InputObjectTypeExtension: function(Bi) {
    var e = Bi.name, Ui = Bi.directives, Zi = Bi.fields;
    return x(["extend input", e, x(Ui, " "), ye(Zi)], " ");
  }
};
function pe(Bi) {
  return function(e) {
    return x([e.description, Bi(e)], `
`);
  };
}
function x(Bi) {
  var e, Ui = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "";
  return (e = Bi?.filter(function(Zi) {
    return Zi;
  }).join(Ui)) !== null && e !== void 0 ? e : "";
}
function ye(Bi) {
  return J(`{
`, er(x(Bi, `
`)), `
}`);
}
function J(Bi, e) {
  var Ui = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : "";
  return e != null && e !== "" ? Bi + e + Ui : "";
}
function er(Bi) {
  return J("  ", Bi.replace(/\n/g, `
  `));
}
function Ms(Bi) {
  return Bi.indexOf(`
`) !== -1;
}
function ti(Bi) {
  return Bi != null && Bi.some(Ms);
}
function Vs() {
  return Xn();
}
function Ls() {
  __DEV__ ? E(typeof Or == "boolean", Or) : E(typeof Or == "boolean", 38);
}
Vs();
Ls();
var zr = function(Bi, e) {
  return zr = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(Ui, Zi) {
    Ui.__proto__ = Zi;
  } || function(Ui, Zi) {
    for (var ta in Zi) Object.prototype.hasOwnProperty.call(Zi, ta) && (Ui[ta] = Zi[ta]);
  }, zr(Bi, e);
};
function be(Bi, e) {
  if (typeof e != "function" && e !== null)
    throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
  zr(Bi, e);
  function Ui() {
    this.constructor = Bi;
  }
  Bi.prototype = e === null ? Object.create(e) : (Ui.prototype = e.prototype, new Ui());
}
var y = function() {
  return y = Object.assign || function(Bi) {
    for (var e, Ui = 1, Zi = arguments.length; Ui < Zi; Ui++) {
      e = arguments[Ui];
      for (var ta in e) Object.prototype.hasOwnProperty.call(e, ta) && (Bi[ta] = e[ta]);
    }
    return Bi;
  }, y.apply(this, arguments);
};
function lt(Bi, e) {
  var Ui = {};
  for (var Zi in Bi) Object.prototype.hasOwnProperty.call(Bi, Zi) && e.indexOf(Zi) < 0 && (Ui[Zi] = Bi[Zi]);
  if (Bi != null && typeof Object.getOwnPropertySymbols == "function")
    for (var ta = 0, Zi = Object.getOwnPropertySymbols(Bi); ta < Zi.length; ta++)
      e.indexOf(Zi[ta]) < 0 && Object.prototype.propertyIsEnumerable.call(Bi, Zi[ta]) && (Ui[Zi[ta]] = Bi[Zi[ta]]);
  return Ui;
}
function Fe(Bi, e, Ui, Zi) {
  function ta(na) {
    return na instanceof Ui ? na : new Ui(function(ia) {
      ia(na);
    });
  }
  return new (Ui || (Ui = Promise))(function(na, ia) {
    function aa(qa) {
      try {
        La(Zi.next(qa));
      } catch (io) {
        ia(io);
      }
    }
    function da(qa) {
      try {
        La(Zi.throw(qa));
      } catch (io) {
        ia(io);
      }
    }
    function La(qa) {
      qa.done ? na(qa.value) : ta(qa.value).then(aa, da);
    }
    La((Zi = Zi.apply(Bi, [])).next());
  });
}
function Me(Bi, e) {
  var Ui = { label: 0, sent: function() {
    if (na[0] & 1) throw na[1];
    return na[1];
  }, trys: [], ops: [] }, Zi, ta, na, ia;
  return ia = { next: aa(0), throw: aa(1), return: aa(2) }, typeof Symbol == "function" && (ia[Symbol.iterator] = function() {
    return this;
  }), ia;
  function aa(La) {
    return function(qa) {
      return da([La, qa]);
    };
  }
  function da(La) {
    if (Zi) throw new TypeError("Generator is already executing.");
    for (; Ui; ) try {
      if (Zi = 1, ta && (na = La[0] & 2 ? ta.return : La[0] ? ta.throw || ((na = ta.return) && na.call(ta), 0) : ta.next) && !(na = na.call(ta, La[1])).done) return na;
      switch (ta = 0, na && (La = [La[0] & 2, na.value]), La[0]) {
        case 0:
        case 1:
          na = La;
          break;
        case 4:
          return Ui.label++, { value: La[1], done: !1 };
        case 5:
          Ui.label++, ta = La[1], La = [0];
          continue;
        case 7:
          La = Ui.ops.pop(), Ui.trys.pop();
          continue;
        default:
          if (na = Ui.trys, !(na = na.length > 0 && na[na.length - 1]) && (La[0] === 6 || La[0] === 2)) {
            Ui = 0;
            continue;
          }
          if (La[0] === 3 && (!na || La[1] > na[0] && La[1] < na[3])) {
            Ui.label = La[1];
            break;
          }
          if (La[0] === 6 && Ui.label < na[1]) {
            Ui.label = na[1], na = La;
            break;
          }
          if (na && Ui.label < na[2]) {
            Ui.label = na[2], Ui.ops.push(La);
            break;
          }
          na[2] && Ui.ops.pop(), Ui.trys.pop();
          continue;
      }
      La = e.call(Bi, Ui);
    } catch (qa) {
      La = [6, qa], ta = 0;
    } finally {
      Zi = na = 0;
    }
    if (La[0] & 5) throw La[1];
    return { value: La[0] ? La[1] : void 0, done: !0 };
  }
}
function ir(Bi, e, Ui) {
  if (Ui || arguments.length === 2) for (var Zi = 0, ta = e.length, na; Zi < ta; Zi++)
    (na || !(Zi in e)) && (na || (na = Array.prototype.slice.call(e, 0, Zi)), na[Zi] = e[Zi]);
  return Bi.concat(na || Array.prototype.slice.call(e));
}
function vr(Bi, e) {
  var Ui = Bi.directives;
  return !Ui || !Ui.length ? !0 : Bs(Ui).every(function(Zi) {
    var ta = Zi.directive, na = Zi.ifArgument, ia = !1;
    return na.value.kind === "Variable" ? (ia = e && e[na.value.name.value], __DEV__ ? E(ia !== void 0, "Invalid variable referenced in @".concat(ta.name.value, " directive.")) : E(ia !== void 0, 39)) : ia = na.value.value, ta.name.value === "skip" ? !ia : ia;
  });
}
function bn(Bi, e, Ui) {
  var Zi = new Set(Bi), ta = Zi.size;
  return Te(e, {
    Directive: function(na) {
      if (Zi.delete(na.name.value) && !Ui)
        return gn;
    }
  }), Ui ? !Zi.size : Zi.size < ta;
}
function Qs(Bi) {
  var e = Bi.name.value;
  return e === "skip" || e === "include";
}
function Bs(Bi) {
  var e = [];
  return Bi && Bi.length && Bi.forEach(function(Ui) {
    if (Qs(Ui)) {
      var Zi = Ui.arguments, ta = Ui.name.value;
      __DEV__ ? E(Zi && Zi.length === 1, "Incorrect number of arguments for the @".concat(ta, " directive.")) : E(Zi && Zi.length === 1, 40);
      var na = Zi[0];
      __DEV__ ? E(na.name && na.name.value === "if", "Invalid argument for the @".concat(ta, " directive.")) : E(na.name && na.name.value === "if", 41);
      var ia = na.value;
      __DEV__ ? E(ia && (ia.kind === "Variable" || ia.kind === "BooleanValue"), "Argument for the @".concat(ta, " directive must be a variable or a boolean value.")) : E(ia && (ia.kind === "Variable" || ia.kind === "BooleanValue"), 42), e.push({ directive: Ui, ifArgument: na });
    }
  }), e;
}
function Us(Bi, e) {
  var Ui = e, Zi = [];
  Bi.definitions.forEach(function(na) {
    if (na.kind === "OperationDefinition")
      throw __DEV__ ? new B("Found a ".concat(na.operation, " operation").concat(na.name ? " named '".concat(na.name.value, "'") : "", ". ") + "No operations are allowed when using a fragment as a query. Only fragments are allowed.") : new B(43);
    na.kind === "FragmentDefinition" && Zi.push(na);
  }), typeof Ui > "u" && (__DEV__ ? E(Zi.length === 1, "Found ".concat(Zi.length, " fragments. `fragmentName` must be provided when there is not exactly 1 fragment.")) : E(Zi.length === 1, 44), Ui = Zi[0].name.value);
  var ta = y(y({}, Bi), { definitions: ir([
    {
      kind: "OperationDefinition",
      operation: "query",
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "FragmentSpread",
            name: {
              kind: "Name",
              value: Ui
            }
          }
        ]
      }
    }
  ], Bi.definitions, !0) });
  return ta;
}
function _n(Bi) {
  Bi === void 0 && (Bi = []);
  var e = {};
  return Bi.forEach(function(Ui) {
    e[Ui.name.value] = Ui;
  }), e;
}
function wn(Bi, e) {
  switch (Bi.kind) {
    case "InlineFragment":
      return Bi;
    case "FragmentSpread": {
      var Ui = Bi.name.value;
      if (typeof e == "function")
        return e(Ui);
      var Zi = e && e[Ui];
      return __DEV__ ? E(Zi, "No fragment named ".concat(Ui)) : E(Zi, 45), Zi || null;
    }
    default:
      return null;
  }
}
function Y(Bi) {
  return Bi !== null && typeof Bi == "object";
}
function ot(Bi) {
  return { __ref: String(Bi) };
}
function Z(Bi) {
  return !!(Bi && typeof Bi == "object" && typeof Bi.__ref == "string");
}
function zs(Bi) {
  return Bi.kind === "StringValue";
}
function $s(Bi) {
  return Bi.kind === "BooleanValue";
}
function Ws(Bi) {
  return Bi.kind === "IntValue";
}
function Gs(Bi) {
  return Bi.kind === "FloatValue";
}
function Js(Bi) {
  return Bi.kind === "Variable";
}
function Hs(Bi) {
  return Bi.kind === "ObjectValue";
}
function Ys(Bi) {
  return Bi.kind === "ListValue";
}
function Ks(Bi) {
  return Bi.kind === "EnumValue";
}
function Xs(Bi) {
  return Bi.kind === "NullValue";
}
function ft(Bi, e, Ui, Zi) {
  if (Ws(Ui) || Gs(Ui))
    Bi[e.value] = Number(Ui.value);
  else if ($s(Ui) || zs(Ui))
    Bi[e.value] = Ui.value;
  else if (Hs(Ui)) {
    var ta = {};
    Ui.fields.map(function(ia) {
      return ft(ta, ia.name, ia.value, Zi);
    }), Bi[e.value] = ta;
  } else if (Js(Ui)) {
    var na = (Zi || {})[Ui.name.value];
    Bi[e.value] = na;
  } else if (Ys(Ui))
    Bi[e.value] = Ui.values.map(function(ia) {
      var aa = {};
      return ft(aa, e, ia, Zi), aa[e.value];
    });
  else if (Ks(Ui))
    Bi[e.value] = Ui.value;
  else if (Xs(Ui))
    Bi[e.value] = null;
  else
    throw __DEV__ ? new B('The inline argument "'.concat(e.value, '" of kind "').concat(Ui.kind, '"') + "is not supported. Use variables instead of inline arguments to overcome this limitation.") : new B(54);
}
function eo(Bi, e) {
  var Ui = null;
  Bi.directives && (Ui = {}, Bi.directives.forEach(function(ta) {
    Ui[ta.name.value] = {}, ta.arguments && ta.arguments.forEach(function(na) {
      var ia = na.name, aa = na.value;
      return ft(Ui[ta.name.value], ia, aa, e);
    });
  }));
  var Zi = null;
  return Bi.arguments && Bi.arguments.length && (Zi = {}, Bi.arguments.forEach(function(ta) {
    var na = ta.name, ia = ta.value;
    return ft(Zi, na, ia, e);
  })), kn(Bi.name.value, Zi, Ui);
}
var to = [
  "connection",
  "include",
  "skip",
  "client",
  "rest",
  "export"
], kn = Object.assign(function(Bi, e, Ui) {
  if (e && Ui && Ui.connection && Ui.connection.key)
    if (Ui.connection.filter && Ui.connection.filter.length > 0) {
      var Zi = Ui.connection.filter ? Ui.connection.filter : [];
      Zi.sort();
      var ta = {};
      return Zi.forEach(function(aa) {
        ta[aa] = e[aa];
      }), "".concat(Ui.connection.key, "(").concat(gt(ta), ")");
    } else
      return Ui.connection.key;
  var na = Bi;
  if (e) {
    var ia = gt(e);
    na += "(".concat(ia, ")");
  }
  return Ui && Object.keys(Ui).forEach(function(aa) {
    to.indexOf(aa) === -1 && (Ui[aa] && Object.keys(Ui[aa]).length ? na += "@".concat(aa, "(").concat(gt(Ui[aa]), ")") : na += "@".concat(aa));
  }), na;
}, {
  setStringify: function(Bi) {
    var e = gt;
    return gt = Bi, e;
  }
}), gt = function(Bi) {
  return JSON.stringify(Bi, ro);
};
function ro(Bi, e) {
  return Y(e) && !Array.isArray(e) && (e = Object.keys(e).sort().reduce(function(Ui, Zi) {
    return Ui[Zi] = e[Zi], Ui;
  }, {})), e;
}
function mr(Bi, e) {
  if (Bi.arguments && Bi.arguments.length) {
    var Ui = {};
    return Bi.arguments.forEach(function(Zi) {
      var ta = Zi.name, na = Zi.value;
      return ft(Ui, ta, na, e);
    }), Ui;
  }
  return null;
}
function Je(Bi) {
  return Bi.alias ? Bi.alias.value : Bi.name.value;
}
function $r(Bi, e, Ui) {
  if (typeof Bi.__typename == "string")
    return Bi.__typename;
  for (var Zi = 0, ta = e.selections; Zi < ta.length; Zi++) {
    var na = ta[Zi];
    if (je(na)) {
      if (na.name.value === "__typename")
        return Bi[Je(na)];
    } else {
      var ia = $r(Bi, wn(na, Ui).selectionSet, Ui);
      if (typeof ia == "string")
        return ia;
    }
  }
}
function je(Bi) {
  return Bi.kind === "Field";
}
function gr(Bi) {
  __DEV__ ? E(Bi && Bi.kind === "Document", 'Expecting a parsed GraphQL document. Perhaps you need to wrap the query string in a "gql" tag? http://docs.apollostack.com/apollo-client/core.html#gql') : E(Bi && Bi.kind === "Document", 46);
  var e = Bi.definitions.filter(function(Ui) {
    return Ui.kind !== "FragmentDefinition";
  }).map(function(Ui) {
    if (Ui.kind !== "OperationDefinition")
      throw __DEV__ ? new B('Schema type definitions not allowed in queries. Found: "'.concat(Ui.kind, '"')) : new B(47);
    return Ui;
  });
  return __DEV__ ? E(e.length <= 1, "Ambiguous GraphQL document: contains ".concat(e.length, " operations")) : E(e.length <= 1, 48), Bi;
}
function zt(Bi) {
  return gr(Bi), Bi.definitions.filter(function(e) {
    return e.kind === "OperationDefinition";
  })[0];
}
function Wr(Bi) {
  return Bi.definitions.filter(function(e) {
    return e.kind === "OperationDefinition" && e.name;
  }).map(function(e) {
    return e.name.value;
  })[0] || null;
}
function En(Bi) {
  return Bi.definitions.filter(function(e) {
    return e.kind === "FragmentDefinition";
  });
}
function ra(Bi) {
  var e = zt(Bi);
  return __DEV__ ? E(e && e.operation === "query", "Must contain a query definition.") : E(e && e.operation === "query", 49), e;
}
function br(Bi) {
  gr(Bi);
  for (var e, Ui = 0, Zi = Bi.definitions; Ui < Zi.length; Ui++) {
    var ta = Zi[Ui];
    if (ta.kind === "OperationDefinition") {
      var na = ta.operation;
      if (na === "query" || na === "mutation" || na === "subscription")
        return ta;
    }
    ta.kind === "FragmentDefinition" && !e && (e = ta);
  }
  if (e)
    return e;
  throw __DEV__ ? new B("Expected a parsed GraphQL query with a query, mutation, subscription, or a fragment.") : new B(53);
}
function Sn(Bi) {
  var e = /* @__PURE__ */ Object.create(null), Ui = Bi && Bi.variableDefinitions;
  return Ui && Ui.length && Ui.forEach(function(Zi) {
    Zi.defaultValue && ft(e, Zi.variable.name, Zi.defaultValue);
  }), e;
}
var ni = {
  kind: "Field",
  name: {
    kind: "Name",
    value: "__typename"
  }
}, xn = Object.assign(function(Bi) {
  return Te(Bi, {
    SelectionSet: {
      enter: function(e, Ui, Zi) {
        if (!(Zi && Zi.kind === "OperationDefinition")) {
          var ta = e.selections;
          if (ta) {
            var na = ta.some(function(aa) {
              return je(aa) && (aa.name.value === "__typename" || aa.name.value.lastIndexOf("__", 0) === 0);
            });
            if (!na) {
              var ia = Zi;
              if (!(je(ia) && ia.directives && ia.directives.some(function(aa) {
                return aa.name.value === "export";
              })))
                return y(y({}, e), { selections: ir(ir([], ta, !0), [ni], !1) });
            }
          }
        }
      }
    }
  });
}, {
  added: function(Bi) {
    return Bi === ni;
  }
}), fo = Object.prototype.hasOwnProperty;
function Tn(Bi) {
  var e = Bi[0] || {}, Ui = Bi.length;
  if (Ui > 1)
    for (var Zi = new He(), ta = 1; ta < Ui; ++ta)
      e = Zi.merge(e, Bi[ta]);
  return e;
}
var ho = function(Bi, e, Ui) {
  return this.merge(Bi[Ui], e[Ui]);
}, He = function() {
  function Bi(e) {
    e === void 0 && (e = ho), this.reconciler = e, this.isObject = Y, this.pastCopies = /* @__PURE__ */ new Set();
  }
  return Bi.prototype.merge = function(e, Ui) {
    for (var Zi = this, ta = [], na = 2; na < arguments.length; na++)
      ta[na - 2] = arguments[na];
    return Y(Ui) && Y(e) ? (Object.keys(Ui).forEach(function(ia) {
      if (fo.call(e, ia)) {
        var aa = e[ia];
        if (Ui[ia] !== aa) {
          var da = Zi.reconciler.apply(Zi, ir([e, Ui, ia], ta, !1));
          da !== aa && (e = Zi.shallowCopyForMerge(e), e[ia] = da);
        }
      } else
        e = Zi.shallowCopyForMerge(e), e[ia] = Ui[ia];
    }), e) : Ui;
  }, Bi.prototype.shallowCopyForMerge = function(e) {
    return Y(e) && (this.pastCopies.has(e) || (Array.isArray(e) ? e = e.slice(0) : e = y({ __proto__: Object.getPrototypeOf(e) }, e), this.pastCopies.add(e))), e;
  }, Bi;
}();
function po(Bi, e) {
  var Ui = typeof Symbol < "u" && Bi[Symbol.iterator] || Bi["@@iterator"];
  if (Ui) return (Ui = Ui.call(Bi)).next.bind(Ui);
  if (Array.isArray(Bi) || (Ui = yo(Bi)) || e) {
    Ui && (Bi = Ui);
    var Zi = 0;
    return function() {
      return Zi >= Bi.length ? { done: !0 } : { done: !1, value: Bi[Zi++] };
    };
  }
  throw new TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function yo(Bi, e) {
  if (Bi) {
    if (typeof Bi == "string") return si(Bi, e);
    var Ui = Object.prototype.toString.call(Bi).slice(8, -1);
    if (Ui === "Object" && Bi.constructor && (Ui = Bi.constructor.name), Ui === "Map" || Ui === "Set") return Array.from(Bi);
    if (Ui === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(Ui)) return si(Bi, e);
  }
}
function si(Bi, e) {
  (e == null || e > Bi.length) && (e = Bi.length);
  for (var Ui = 0, Zi = new Array(e); Ui < e; Ui++)
    Zi[Ui] = Bi[Ui];
  return Zi;
}
function oi(Bi, e) {
  for (var Ui = 0; Ui < e.length; Ui++) {
    var Zi = e[Ui];
    Zi.enumerable = Zi.enumerable || !1, Zi.configurable = !0, "value" in Zi && (Zi.writable = !0), Object.defineProperty(Bi, Zi.key, Zi);
  }
}
function Dn(Bi, e, Ui) {
  return e && oi(Bi.prototype, e), Ui && oi(Bi, Ui), Object.defineProperty(Bi, "prototype", { writable: !1 }), Bi;
}
var In = function() {
  return typeof Symbol == "function";
}, Rn = function(Bi) {
  return In() && !!Symbol[Bi];
}, jn = function(Bi) {
  return Rn(Bi) ? Symbol[Bi] : "@@" + Bi;
};
In() && !Rn("observable") && (Symbol.observable = Symbol("observable"));
var vo = jn("iterator"), Gr = jn("observable"), sa = jn("species");
function ar(Bi, e) {
  var Ui = Bi[e];
  if (Ui != null) {
    if (typeof Ui != "function") throw new TypeError(Ui + " is not a function");
    return Ui;
  }
}
function bt(Bi) {
  var e = Bi.constructor;
  return e !== void 0 && (e = e[sa], e === null && (e = void 0)), e !== void 0 ? e : G;
}
function mo(Bi) {
  return Bi instanceof G;
}
function dt(Bi) {
  dt.log ? dt.log(Bi) : setTimeout(function() {
    throw Bi;
  });
}
function tr(Bi) {
  Promise.resolve().then(function() {
    try {
      Bi();
    } catch (e) {
      dt(e);
    }
  });
}
function oa(Bi) {
  var e = Bi._cleanup;
  if (e !== void 0 && (Bi._cleanup = void 0, !!e))
    try {
      if (typeof e == "function")
        e();
      else {
        var Ui = ar(e, "unsubscribe");
        Ui && Ui.call(e);
      }
    } catch (Zi) {
      dt(Zi);
    }
}
function Jr(Bi) {
  Bi._observer = void 0, Bi._queue = void 0, Bi._state = "closed";
}
function go(Bi) {
  var e = Bi._queue;
  if (e) {
    Bi._queue = void 0, Bi._state = "ready";
    for (var Ui = 0; Ui < e.length && (ua(Bi, e[Ui].type, e[Ui].value), Bi._state !== "closed"); ++Ui)
      ;
  }
}
function ua(Bi, e, Ui) {
  Bi._state = "running";
  var Zi = Bi._observer;
  try {
    var ta = ar(Zi, e);
    switch (e) {
      case "next":
        ta && ta.call(Zi, Ui);
        break;
      case "error":
        if (Jr(Bi), ta) ta.call(Zi, Ui);
        else throw Ui;
        break;
      case "complete":
        Jr(Bi), ta && ta.call(Zi);
        break;
    }
  } catch (na) {
    dt(na);
  }
  Bi._state === "closed" ? oa(Bi) : Bi._state === "running" && (Bi._state = "ready");
}
function Tr(Bi, e, Ui) {
  if (Bi._state !== "closed") {
    if (Bi._state === "buffering") {
      Bi._queue.push({
        type: e,
        value: Ui
      });
      return;
    }
    if (Bi._state !== "ready") {
      Bi._state = "buffering", Bi._queue = [{
        type: e,
        value: Ui
      }], tr(function() {
        return go(Bi);
      });
      return;
    }
    ua(Bi, e, Ui);
  }
}
var bo = /* @__PURE__ */ function() {
  function Bi(Ui, Zi) {
    this._cleanup = void 0, this._observer = Ui, this._queue = void 0, this._state = "initializing";
    var ta = new _o(this);
    try {
      this._cleanup = Zi.call(void 0, ta);
    } catch (na) {
      ta.error(na);
    }
    this._state === "initializing" && (this._state = "ready");
  }
  var e = Bi.prototype;
  return e.unsubscribe = function() {
    this._state !== "closed" && (Jr(this), oa(this));
  }, Dn(Bi, [{
    key: "closed",
    get: function() {
      return this._state === "closed";
    }
  }]), Bi;
}(), _o = /* @__PURE__ */ function() {
  function Bi(Ui) {
    this._subscription = Ui;
  }
  var e = Bi.prototype;
  return e.next = function(Ui) {
    Tr(this._subscription, "next", Ui);
  }, e.error = function(Ui) {
    Tr(this._subscription, "error", Ui);
  }, e.complete = function() {
    Tr(this._subscription, "complete");
  }, Dn(Bi, [{
    key: "closed",
    get: function() {
      return this._subscription._state === "closed";
    }
  }]), Bi;
}(), G = /* @__PURE__ */ function() {
  function Bi(Ui) {
    if (!(this instanceof Bi)) throw new TypeError("Observable cannot be called as a function");
    if (typeof Ui != "function") throw new TypeError("Observable initializer must be a function");
    this._subscriber = Ui;
  }
  var e = Bi.prototype;
  return e.subscribe = function(Ui) {
    return (typeof Ui != "object" || Ui === null) && (Ui = {
      next: Ui,
      error: arguments[1],
      complete: arguments[2]
    }), new bo(Ui, this._subscriber);
  }, e.forEach = function(Ui) {
    var Zi = this;
    return new Promise(function(ta, na) {
      if (typeof Ui != "function") {
        na(new TypeError(Ui + " is not a function"));
        return;
      }
      function ia() {
        aa.unsubscribe(), ta();
      }
      var aa = Zi.subscribe({
        next: function(da) {
          try {
            Ui(da, ia);
          } catch (La) {
            na(La), aa.unsubscribe();
          }
        },
        error: na,
        complete: ta
      });
    });
  }, e.map = function(Ui) {
    var Zi = this;
    if (typeof Ui != "function") throw new TypeError(Ui + " is not a function");
    var ta = bt(this);
    return new ta(function(na) {
      return Zi.subscribe({
        next: function(ia) {
          try {
            ia = Ui(ia);
          } catch (aa) {
            return na.error(aa);
          }
          na.next(ia);
        },
        error: function(ia) {
          na.error(ia);
        },
        complete: function() {
          na.complete();
        }
      });
    });
  }, e.filter = function(Ui) {
    var Zi = this;
    if (typeof Ui != "function") throw new TypeError(Ui + " is not a function");
    var ta = bt(this);
    return new ta(function(na) {
      return Zi.subscribe({
        next: function(ia) {
          try {
            if (!Ui(ia)) return;
          } catch (aa) {
            return na.error(aa);
          }
          na.next(ia);
        },
        error: function(ia) {
          na.error(ia);
        },
        complete: function() {
          na.complete();
        }
      });
    });
  }, e.reduce = function(Ui) {
    var Zi = this;
    if (typeof Ui != "function") throw new TypeError(Ui + " is not a function");
    var ta = bt(this), na = arguments.length > 1, ia = !1, aa = arguments[1], da = aa;
    return new ta(function(La) {
      return Zi.subscribe({
        next: function(qa) {
          var io = !ia;
          if (ia = !0, !io || na)
            try {
              da = Ui(da, qa);
            } catch (ao) {
              return La.error(ao);
            }
          else
            da = qa;
        },
        error: function(qa) {
          La.error(qa);
        },
        complete: function() {
          if (!ia && !na) return La.error(new TypeError("Cannot reduce an empty sequence"));
          La.next(da), La.complete();
        }
      });
    });
  }, e.concat = function() {
    for (var Ui = this, Zi = arguments.length, ta = new Array(Zi), na = 0; na < Zi; na++)
      ta[na] = arguments[na];
    var ia = bt(this);
    return new ia(function(aa) {
      var da, La = 0;
      function qa(io) {
        da = io.subscribe({
          next: function(ao) {
            aa.next(ao);
          },
          error: function(ao) {
            aa.error(ao);
          },
          complete: function() {
            La === ta.length ? (da = void 0, aa.complete()) : qa(ia.from(ta[La++]));
          }
        });
      }
      return qa(Ui), function() {
        da && (da.unsubscribe(), da = void 0);
      };
    });
  }, e.flatMap = function(Ui) {
    var Zi = this;
    if (typeof Ui != "function") throw new TypeError(Ui + " is not a function");
    var ta = bt(this);
    return new ta(function(na) {
      var ia = [], aa = Zi.subscribe({
        next: function(La) {
          if (Ui)
            try {
              La = Ui(La);
            } catch (io) {
              return na.error(io);
            }
          var qa = ta.from(La).subscribe({
            next: function(io) {
              na.next(io);
            },
            error: function(io) {
              na.error(io);
            },
            complete: function() {
              var io = ia.indexOf(qa);
              io >= 0 && ia.splice(io, 1), da();
            }
          });
          ia.push(qa);
        },
        error: function(La) {
          na.error(La);
        },
        complete: function() {
          da();
        }
      });
      function da() {
        aa.closed && ia.length === 0 && na.complete();
      }
      return function() {
        ia.forEach(function(La) {
          return La.unsubscribe();
        }), aa.unsubscribe();
      };
    });
  }, e[Gr] = function() {
    return this;
  }, Bi.from = function(Ui) {
    var Zi = typeof this == "function" ? this : Bi;
    if (Ui == null) throw new TypeError(Ui + " is not an object");
    var ta = ar(Ui, Gr);
    if (ta) {
      var na = ta.call(Ui);
      if (Object(na) !== na) throw new TypeError(na + " is not an object");
      return mo(na) && na.constructor === Zi ? na : new Zi(function(ia) {
        return na.subscribe(ia);
      });
    }
    if (Rn("iterator") && (ta = ar(Ui, vo), ta))
      return new Zi(function(ia) {
        tr(function() {
          if (!ia.closed) {
            for (var aa = po(ta.call(Ui)), da; !(da = aa()).done; ) {
              var La = da.value;
              if (ia.next(La), ia.closed) return;
            }
            ia.complete();
          }
        });
      });
    if (Array.isArray(Ui))
      return new Zi(function(ia) {
        tr(function() {
          if (!ia.closed) {
            for (var aa = 0; aa < Ui.length; ++aa)
              if (ia.next(Ui[aa]), ia.closed) return;
            ia.complete();
          }
        });
      });
    throw new TypeError(Ui + " is not observable");
  }, Bi.of = function() {
    for (var Ui = arguments.length, Zi = new Array(Ui), ta = 0; ta < Ui; ta++)
      Zi[ta] = arguments[ta];
    var na = typeof this == "function" ? this : Bi;
    return new na(function(ia) {
      tr(function() {
        if (!ia.closed) {
          for (var aa = 0; aa < Zi.length; ++aa)
            if (ia.next(Zi[aa]), ia.closed) return;
          ia.complete();
        }
      });
    });
  }, Dn(Bi, null, [{
    key: sa,
    get: function() {
      return this;
    }
  }]), Bi;
}();
In() && Object.defineProperty(G, Symbol("extensions"), {
  value: {
    symbol: Gr,
    hostReportError: dt
  },
  configurable: !0
});
function wo(Bi) {
  var e, Ui = Bi.Symbol;
  if (typeof Ui == "function")
    if (Ui.observable)
      e = Ui.observable;
    else {
      typeof Ui.for == "function" ? e = Ui.for("https://github.com/benlesh/symbol-observable") : e = Ui("https://github.com/benlesh/symbol-observable");
      try {
        Ui.observable = e;
      } catch {
      }
    }
  else
    e = "@@observable";
  return e;
}
var rt;
typeof self < "u" ? rt = self : typeof window < "u" ? rt = window : typeof global < "u" ? rt = global : typeof module < "u" ? rt = module : rt = Function("return this")();
wo(rt);
var ui = G.prototype, ci = "@@observable";
ui[ci] || (ui[ci] = function() {
  return this;
});
var ko = Object.prototype.toString;
function Cn(Bi) {
  return Hr(Bi);
}
function Hr(Bi, e) {
  switch (ko.call(Bi)) {
    case "[object Array]": {
      if (e = e || /* @__PURE__ */ new Map(), e.has(Bi))
        return e.get(Bi);
      var Ui = Bi.slice(0);
      return e.set(Bi, Ui), Ui.forEach(function(ta, na) {
        Ui[na] = Hr(ta, e);
      }), Ui;
    }
    case "[object Object]": {
      if (e = e || /* @__PURE__ */ new Map(), e.has(Bi))
        return e.get(Bi);
      var Zi = Object.create(Object.getPrototypeOf(Bi));
      return e.set(Bi, Zi), Object.keys(Bi).forEach(function(ta) {
        Zi[ta] = Hr(Bi[ta], e);
      }), Zi;
    }
    default:
      return Bi;
  }
}
function Eo(Bi) {
  var e = /* @__PURE__ */ new Set([Bi]);
  return e.forEach(function(Ui) {
    Y(Ui) && So(Ui) === Ui && Object.getOwnPropertyNames(Ui).forEach(function(Zi) {
      Y(Ui[Zi]) && e.add(Ui[Zi]);
    });
  }), Bi;
}
function So(Bi) {
  if (__DEV__ && !Object.isFrozen(Bi))
    try {
      Object.freeze(Bi);
    } catch (e) {
      if (e instanceof TypeError)
        return null;
      throw e;
    }
  return Bi;
}
function Yr(Bi) {
  return __DEV__ && Eo(Bi), Bi;
}
function xt(Bi, e, Ui) {
  var Zi = [];
  Bi.forEach(function(ta) {
    return ta[e] && Zi.push(ta);
  }), Zi.forEach(function(ta) {
    return ta[e](Ui);
  });
}
var et = typeof WeakMap == "function" && he(function() {
  return navigator.product;
}) !== "ReactNative", Oo = typeof WeakSet == "function", ca = typeof Symbol == "function" && typeof Symbol.for == "function", _r = ca && Symbol.asyncIterator;
he(function() {
  return window.document.createElement;
});
he(function() {
  return navigator.userAgent.indexOf("jsdom") >= 0;
});
function la(Bi) {
  function e(Ui) {
    Object.defineProperty(Bi, Ui, { value: G });
  }
  return ca && Symbol.species && e(Symbol.species), e("@@species"), Bi;
}
function li(Bi) {
  return Bi && typeof Bi.then == "function";
}
var Et = function(Bi) {
  be(e, Bi);
  function e(Ui) {
    var Zi = Bi.call(this, function(ta) {
      return Zi.addObserver(ta), function() {
        return Zi.removeObserver(ta);
      };
    }) || this;
    return Zi.observers = /* @__PURE__ */ new Set(), Zi.promise = new Promise(function(ta, na) {
      Zi.resolve = ta, Zi.reject = na;
    }), Zi.handlers = {
      next: function(ta) {
        Zi.sub !== null && (Zi.latest = ["next", ta], Zi.notify("next", ta), xt(Zi.observers, "next", ta));
      },
      error: function(ta) {
        var na = Zi.sub;
        na !== null && (na && setTimeout(function() {
          return na.unsubscribe();
        }), Zi.sub = null, Zi.latest = ["error", ta], Zi.reject(ta), Zi.notify("error", ta), xt(Zi.observers, "error", ta));
      },
      complete: function() {
        var ta = Zi.sub;
        if (ta !== null) {
          var na = Zi.sources.shift();
          na ? li(na) ? na.then(function(ia) {
            return Zi.sub = ia.subscribe(Zi.handlers);
          }) : Zi.sub = na.subscribe(Zi.handlers) : (ta && setTimeout(function() {
            return ta.unsubscribe();
          }), Zi.sub = null, Zi.latest && Zi.latest[0] === "next" ? Zi.resolve(Zi.latest[1]) : Zi.resolve(), Zi.notify("complete"), xt(Zi.observers, "complete"));
        }
      }
    }, Zi.nextResultListeners = /* @__PURE__ */ new Set(), Zi.cancel = function(ta) {
      Zi.reject(ta), Zi.sources = [], Zi.handlers.complete();
    }, Zi.promise.catch(function(ta) {
    }), typeof Ui == "function" && (Ui = [new G(Ui)]), li(Ui) ? Ui.then(function(ta) {
      return Zi.start(ta);
    }, Zi.handlers.error) : Zi.start(Ui), Zi;
  }
  return e.prototype.start = function(Ui) {
    this.sub === void 0 && (this.sources = Array.from(Ui), this.handlers.complete());
  }, e.prototype.deliverLastMessage = function(Ui) {
    if (this.latest) {
      var Zi = this.latest[0], ta = Ui[Zi];
      ta && ta.call(Ui, this.latest[1]), this.sub === null && Zi === "next" && Ui.complete && Ui.complete();
    }
  }, e.prototype.addObserver = function(Ui) {
    this.observers.has(Ui) || (this.deliverLastMessage(Ui), this.observers.add(Ui));
  }, e.prototype.removeObserver = function(Ui) {
    this.observers.delete(Ui) && this.observers.size < 1 && this.handlers.complete();
  }, e.prototype.notify = function(Ui, Zi) {
    var ta = this.nextResultListeners;
    ta.size && (this.nextResultListeners = /* @__PURE__ */ new Set(), ta.forEach(function(na) {
      return na(Ui, Zi);
    }));
  }, e.prototype.beforeNext = function(Ui) {
    var Zi = !1;
    this.nextResultListeners.add(function(ta, na) {
      Zi || (Zi = !0, Ui(ta, na));
    });
  }, e;
}(G);
la(Et);
function Ee(Bi) {
  return Array.isArray(Bi) && Bi.length > 0;
}
function wr() {
  for (var Bi = [], e = 0; e < arguments.length; e++)
    Bi[e] = arguments[e];
  var Ui = /* @__PURE__ */ Object.create(null);
  return Bi.forEach(function(Zi) {
    Zi && Object.keys(Zi).forEach(function(ta) {
      var na = Zi[ta];
      na !== void 0 && (Ui[ta] = na);
    });
  }), Ui;
}
var fi = /* @__PURE__ */ new Map();
function Kr(Bi) {
  var e = fi.get(Bi) || 1;
  return fi.set(Bi, e + 1), "".concat(Bi, ":").concat(e, ":").concat(Math.random().toString(36).slice(2));
}
function xo(Bi) {
  var e = Kr("stringifyForDisplay");
  return JSON.stringify(Bi, function(Ui, Zi) {
    return Zi === void 0 ? e : Zi;
  }).split(JSON.stringify(e)).join("<undefined>");
}
function di(Bi) {
  return new G(function(e) {
    e.error(Bi);
  });
}
var Xr = function(Bi, e, Ui) {
  var Zi = new Error(Ui);
  throw Zi.name = "ServerError", Zi.response = Bi, Zi.statusCode = Bi.status, Zi.result = e, Zi;
};
function To(Bi) {
  for (var e = [
    "query",
    "operationName",
    "variables",
    "extensions",
    "context"
  ], Ui = 0, Zi = Object.keys(Bi); Ui < Zi.length; Ui++) {
    var ta = Zi[Ui];
    if (e.indexOf(ta) < 0)
      throw __DEV__ ? new B("illegal argument: ".concat(ta)) : new B(26);
  }
  return Bi;
}
function Do(Bi, e) {
  var Ui = y({}, Bi), Zi = function(na) {
    typeof na == "function" ? Ui = y(y({}, Ui), na(Ui)) : Ui = y(y({}, Ui), na);
  }, ta = function() {
    return y({}, Ui);
  };
  return Object.defineProperty(e, "setContext", {
    enumerable: !1,
    value: Zi
  }), Object.defineProperty(e, "getContext", {
    enumerable: !1,
    value: ta
  }), e;
}
function Io(Bi) {
  var e = {
    variables: Bi.variables || {},
    extensions: Bi.extensions || {},
    operationName: Bi.operationName,
    query: Bi.query
  };
  return e.operationName || (e.operationName = typeof e.query != "string" ? Wr(e.query) || void 0 : ""), e;
}
function hi(Bi, e) {
  return e ? e(Bi) : G.of();
}
function _t(Bi) {
  return typeof Bi == "function" ? new Ze(Bi) : Bi;
}
function Yt(Bi) {
  return Bi.request.length <= 1;
}
var Ro = function(Bi) {
  be(e, Bi);
  function e(Ui, Zi) {
    var ta = Bi.call(this, Ui) || this;
    return ta.link = Zi, ta;
  }
  return e;
}(Error), Ze = function() {
  function Bi(e) {
    e && (this.request = e);
  }
  return Bi.empty = function() {
    return new Bi(function() {
      return G.of();
    });
  }, Bi.from = function(e) {
    return e.length === 0 ? Bi.empty() : e.map(_t).reduce(function(Ui, Zi) {
      return Ui.concat(Zi);
    });
  }, Bi.split = function(e, Ui, Zi) {
    var ta = _t(Ui), na = _t(Zi || new Bi(hi));
    return Yt(ta) && Yt(na) ? new Bi(function(ia) {
      return e(ia) ? ta.request(ia) || G.of() : na.request(ia) || G.of();
    }) : new Bi(function(ia, aa) {
      return e(ia) ? ta.request(ia, aa) || G.of() : na.request(ia, aa) || G.of();
    });
  }, Bi.execute = function(e, Ui) {
    return e.request(Do(Ui.context, Io(To(Ui)))) || G.of();
  }, Bi.concat = function(e, Ui) {
    var Zi = _t(e);
    if (Yt(Zi))
      return __DEV__ && E.warn(new Ro("You are calling concat on a terminating link, which will have no effect", Zi)), Zi;
    var ta = _t(Ui);
    return Yt(ta) ? new Bi(function(na) {
      return Zi.request(na, function(ia) {
        return ta.request(ia) || G.of();
      }) || G.of();
    }) : new Bi(function(na, ia) {
      return Zi.request(na, function(aa) {
        return ta.request(aa, ia) || G.of();
      }) || G.of();
    });
  }, Bi.prototype.split = function(e, Ui, Zi) {
    return this.concat(Bi.split(e, Ui, Zi || new Bi(hi)));
  }, Bi.prototype.concat = function(e) {
    return Bi.concat(this, e);
  }, Bi.prototype.request = function(e, Ui) {
    throw __DEV__ ? new B("request is not implemented") : new B(21);
  }, Bi.prototype.onError = function(e, Ui) {
    if (Ui && Ui.error)
      return Ui.error(e), !1;
    throw e;
  }, Bi.prototype.setOnError = function(e) {
    return this.onError = e, this;
  }, Bi;
}();
Ze.from;
Ze.split;
Ze.execute;
function No(Bi) {
  return !!Bi.body;
}
function Po(Bi) {
  return !!Bi.getReader;
}
function Fo(Bi) {
  return !!(_r && Bi[Symbol.asyncIterator]);
}
function Mo(Bi) {
  return !!Bi.stream;
}
function Vo(Bi) {
  return !!Bi.arrayBuffer;
}
function Lo(Bi) {
  return !!Bi.pipe;
}
function qo(Bi) {
  var e, Ui = Bi[Symbol.asyncIterator]();
  return e = {
    next: function() {
      return Ui.next();
    }
  }, e[Symbol.asyncIterator] = function() {
    return this;
  }, e;
}
function Qo(Bi) {
  var e = null, Ui = null, Zi = !1, ta = [], na = [];
  function ia(io) {
    if (!Ui) {
      if (na.length) {
        var ao = na.shift();
        if (Array.isArray(ao) && ao[0])
          return ao[0]({ value: io, done: !1 });
      }
      ta.push(io);
    }
  }
  function aa(io) {
    Ui = io;
    var ao = na.slice();
    ao.forEach(function(oo) {
      oo[1](io);
    }), !e || e();
  }
  function da() {
    Zi = !0;
    var io = na.slice();
    io.forEach(function(ao) {
      ao[0]({ value: void 0, done: !0 });
    }), !e || e();
  }
  e = function() {
    e = null, Bi.removeListener("data", ia), Bi.removeListener("error", aa), Bi.removeListener("end", da), Bi.removeListener("finish", da), Bi.removeListener("close", da);
  }, Bi.on("data", ia), Bi.on("error", aa), Bi.on("end", da), Bi.on("finish", da), Bi.on("close", da);
  function La() {
    return new Promise(function(io, ao) {
      if (Ui)
        return ao(Ui);
      if (ta.length)
        return io({ value: ta.shift(), done: !1 });
      if (Zi)
        return io({ value: void 0, done: !0 });
      na.push([io, ao]);
    });
  }
  var qa = {
    next: function() {
      return La();
    }
  };
  return _r && (qa[Symbol.asyncIterator] = function() {
    return this;
  }), qa;
}
function Bo(Bi) {
  var e = !1, Ui = {
    next: function() {
      return e ? Promise.resolve({
        value: void 0,
        done: !0
      }) : (e = !0, new Promise(function(Zi, ta) {
        Bi.then(function(na) {
          Zi({ value: na, done: !1 });
        }).catch(ta);
      }));
    }
  };
  return _r && (Ui[Symbol.asyncIterator] = function() {
    return this;
  }), Ui;
}
function pi(Bi) {
  var e = {
    next: function() {
      return Bi.read();
    }
  };
  return _r && (e[Symbol.asyncIterator] = function() {
    return this;
  }), e;
}
function Uo(Bi) {
  var e = Bi;
  if (No(Bi) && (e = Bi.body), Fo(e))
    return qo(e);
  if (Po(e))
    return pi(e.getReader());
  if (Mo(e))
    return pi(e.stream().getReader());
  if (Vo(e))
    return Bo(e.arrayBuffer());
  if (Lo(e))
    return Qo(e);
  throw new Error("Unknown body type for responseIterator. Please pass a streamable response.");
}
var yi = Object.prototype.hasOwnProperty;
function Zo(Bi, e) {
  var Ui, Zi, ta;
  return Fe(this, void 0, void 0, function() {
    var na, ia, aa, da, La, qa, io, ao, oo, no, lo, so, bs, Rs, js, qs, jo, fs, Ao, co;
    return Me(this, function(Co) {
      switch (Co.label) {
        case 0:
          if (TextDecoder === void 0)
            throw new Error("TextDecoder must be defined in the environment: please import a polyfill.");
          na = new TextDecoder("utf-8"), ia = (Ui = Bi.headers) === null || Ui === void 0 ? void 0 : Ui.get("content-type"), aa = "boundary=", da = ia != null && ia.includes(aa) ? ia?.substring(ia?.indexOf(aa) + aa.length).replace(/['"]/g, "").replace(/\;(.*)/gm, "").trim() : "-", La = "--".concat(da), qa = "", io = Uo(Bi), ao = !0, Co.label = 1;
        case 1:
          return ao ? [4, io.next()] : [3, 3];
        case 2:
          for (oo = Co.sent(), no = oo.value, lo = oo.done, so = typeof no == "string" ? no : na.decode(no), ao = !lo, qa += so, bs = qa.indexOf(La); bs > -1; ) {
            if (Rs = void 0, co = [
              qa.slice(0, bs),
              qa.slice(bs + La.length)
            ], Rs = co[0], qa = co[1], Rs.trim()) {
              if (js = Rs.indexOf(`\r
\r
`), qs = zo(Rs.slice(0, js)), jo = qs["content-type"], jo && jo.toLowerCase().indexOf("application/json") === -1)
                throw new Error("Unsupported patch content type: application/json is required.");
              fs = Rs.slice(js);
              try {
                Ao = fa(Bi, fs.replace(`\r
`, "")), (Object.keys(Ao).length > 1 || "data" in Ao || "incremental" in Ao || "errors" in Ao) && ((Zi = e.next) === null || Zi === void 0 || Zi.call(e, Ao));
              } catch (Zs) {
                An(Zs, e);
              }
            }
            bs = qa.indexOf(La);
          }
          return [3, 1];
        case 3:
          return (ta = e.complete) === null || ta === void 0 || ta.call(e), [2];
      }
    });
  });
}
function zo(Bi) {
  var e = {};
  return Bi.split(`
`).forEach(function(Ui) {
    var Zi = Ui.indexOf(":");
    if (Zi > -1) {
      var ta = Ui.slice(0, Zi).trim().toLowerCase(), na = Ui.slice(Zi + 1).trim();
      e[ta] = na;
    }
  }), e;
}
function fa(Bi, e) {
  if (Bi.status >= 300) {
    var Ui = function() {
      try {
        return JSON.parse(e);
      } catch {
        return e;
      }
    };
    Xr(Bi, Ui(), "Response not successful: Received status code ".concat(Bi.status));
  }
  try {
    return JSON.parse(e);
  } catch (ta) {
    var Zi = ta;
    throw Zi.name = "ServerParseError", Zi.response = Bi, Zi.statusCode = Bi.status, Zi.bodyText = e, Zi;
  }
}
function An(Bi, e) {
  var Ui, Zi;
  Bi.name !== "AbortError" && (Bi.result && Bi.result.errors && Bi.result.data && ((Ui = e.next) === null || Ui === void 0 || Ui.call(e, Bi.result)), (Zi = e.error) === null || Zi === void 0 || Zi.call(e, Bi));
}
function $o(Bi, e, Ui) {
  Wo(e)(Bi).then(function(Zi) {
    var ta, na;
    (ta = Ui.next) === null || ta === void 0 || ta.call(Ui, Zi), (na = Ui.complete) === null || na === void 0 || na.call(Ui);
  }).catch(function(Zi) {
    return An(Zi, Ui);
  });
}
function Wo(Bi) {
  return function(e) {
    return e.text().then(function(Ui) {
      return fa(e, Ui);
    }).then(function(Ui) {
      return e.status >= 300 && Xr(e, Ui, "Response not successful: Received status code ".concat(e.status)), !Array.isArray(Ui) && !yi.call(Ui, "data") && !yi.call(Ui, "errors") && Xr(e, Ui, "Server response was missing for query '".concat(Array.isArray(Bi) ? Bi.map(function(Zi) {
        return Zi.operationName;
      }) : Bi.operationName, "'.")), Ui;
    });
  };
}
var tn = function(Bi, e) {
  var Ui;
  try {
    Ui = JSON.stringify(Bi);
  } catch (ta) {
    var Zi = __DEV__ ? new B("Network request failed. ".concat(e, " is not serializable: ").concat(ta.message)) : new B(23);
    throw Zi.parseError = ta, Zi;
  }
  return Ui;
}, Go = {
  includeQuery: !0,
  includeExtensions: !1,
  preserveHeaderCase: !1
}, Jo = {
  accept: "*/*",
  "content-type": "application/json"
}, Ho = {
  method: "POST"
}, Yo = {
  http: Go,
  headers: Jo,
  options: Ho
}, Ko = function(Bi, e) {
  return e(Bi);
};
function Xo(Bi, e) {
  for (var Ui = [], Zi = 2; Zi < arguments.length; Zi++)
    Ui[Zi - 2] = arguments[Zi];
  var ta = {}, na = {};
  Ui.forEach(function(io) {
    ta = y(y(y({}, ta), io.options), { headers: y(y({}, ta.headers), io.headers) }), io.credentials && (ta.credentials = io.credentials), na = y(y({}, na), io.http);
  }), ta.headers = eu(ta.headers, na.preserveHeaderCase);
  var ia = Bi.operationName, aa = Bi.extensions, da = Bi.variables, La = Bi.query, qa = { operationName: ia, variables: da };
  return na.includeExtensions && (qa.extensions = aa), na.includeQuery && (qa.query = e(La, ea)), {
    options: ta,
    body: qa
  };
}
function eu(Bi, e) {
  if (!e) {
    var Ui = /* @__PURE__ */ Object.create(null);
    return Object.keys(Object(Bi)).forEach(function(na) {
      Ui[na.toLowerCase()] = Bi[na];
    }), Ui;
  }
  var Zi = /* @__PURE__ */ Object.create(null);
  Object.keys(Object(Bi)).forEach(function(na) {
    Zi[na.toLowerCase()] = { originalName: na, value: Bi[na] };
  });
  var ta = /* @__PURE__ */ Object.create(null);
  return Object.keys(Zi).forEach(function(na) {
    ta[Zi[na].originalName] = Zi[na].value;
  }), ta;
}
var tu = function(Bi) {
  if (!Bi && typeof fetch > "u")
    throw __DEV__ ? new B(`
"fetch" has not been found globally and no fetcher has been configured. To fix this, install a fetch package (like https://www.npmjs.com/package/cross-fetch), instantiate the fetcher, and pass it into your HttpLink constructor. For example:

import fetch from 'cross-fetch';
import { ApolloClient, HttpLink } from '@apollo/client';
const client = new ApolloClient({
  link: new HttpLink({ uri: '/graphql', fetch })
});
    `) : new B(22);
}, ru = function() {
  if (typeof AbortController > "u")
    return { controller: !1, signal: !1 };
  var Bi = new AbortController(), e = Bi.signal;
  return { controller: Bi, signal: e };
}, nu = function(Bi, e) {
  var Ui = Bi.getContext(), Zi = Ui.uri;
  return Zi || (typeof e == "function" ? e(Bi) : e || "/graphql");
};
function iu(Bi, e) {
  var Ui = [], Zi = function(io, ao) {
    Ui.push("".concat(io, "=").concat(encodeURIComponent(ao)));
  };
  if ("query" in e && Zi("query", e.query), e.operationName && Zi("operationName", e.operationName), e.variables) {
    var ta = void 0;
    try {
      ta = tn(e.variables, "Variables map");
    } catch (io) {
      return { parseError: io };
    }
    Zi("variables", ta);
  }
  if (e.extensions) {
    var na = void 0;
    try {
      na = tn(e.extensions, "Extensions map");
    } catch (io) {
      return { parseError: io };
    }
    Zi("extensions", na);
  }
  var ia = "", aa = Bi, da = Bi.indexOf("#");
  da !== -1 && (ia = Bi.substr(da), aa = Bi.substr(0, da));
  var La = aa.indexOf("?") === -1 ? "?" : "&", qa = aa + La + Ui.join("&") + ia;
  return { newURI: qa };
}
var vi = he(function() {
  return fetch;
}), au = function(Bi) {
  Bi === void 0 && (Bi = {});
  var e = Bi.uri, Ui = e === void 0 ? "/graphql" : e, Zi = Bi.fetch, ta = Bi.print, na = ta === void 0 ? Ko : ta, ia = Bi.includeExtensions, aa = Bi.preserveHeaderCase, da = Bi.useGETForQueries, La = Bi.includeUnusedVariables, qa = La === void 0 ? !1 : La, io = lt(Bi, ["uri", "fetch", "print", "includeExtensions", "preserveHeaderCase", "useGETForQueries", "includeUnusedVariables"]);
  __DEV__ && tu(Zi || vi);
  var ao = {
    http: { includeExtensions: ia, preserveHeaderCase: aa },
    options: io.fetchOptions,
    credentials: io.credentials,
    headers: io.headers
  };
  return new Ze(function(oo) {
    var no = nu(oo, Ui), lo = oo.getContext(), so = {};
    if (lo.clientAwareness) {
      var bs = lo.clientAwareness, Rs = bs.name, js = bs.version;
      Rs && (so["apollographql-client-name"] = Rs), js && (so["apollographql-client-version"] = js);
    }
    var qs = y(y({}, so), lo.headers), jo = {
      http: lo.http,
      options: lo.fetchOptions,
      credentials: lo.credentials,
      headers: qs
    }, fs = Xo(oo, na, Yo, ao, jo), Ao = fs.options, co = fs.body;
    if (co.variables && !qa) {
      var Co = new Set(Object.keys(co.variables));
      Te(oo.query, {
        Variable: function(Ll, Yl, Zl) {
          Zl && Zl.kind !== "VariableDefinition" && Co.delete(Ll.name.value);
        }
      }), Co.size && (co.variables = y({}, co.variables), Co.forEach(function(Ll) {
        delete co.variables[Ll];
      }));
    }
    var Zs;
    if (!Ao.signal) {
      var xl = ru(), Cl = xl.controller, Al = xl.signal;
      Zs = Cl, Zs && (Ao.signal = Al);
    }
    var Ol = function(Ll) {
      return Ll.kind === "OperationDefinition" && Ll.operation === "mutation";
    };
    if (da && !oo.query.definitions.some(Ol) && (Ao.method = "GET"), bn(["defer"], oo.query) && (Ao.headers.accept = "multipart/mixed; deferSpec=20220824, application/json"), Ao.method === "GET") {
      var Bl = iu(no, co), Ml = Bl.newURI, Vl = Bl.parseError;
      if (Vl)
        return di(Vl);
      no = Ml;
    } else
      try {
        Ao.body = tn(co, "Payload");
      } catch (Ll) {
        return di(Ll);
      }
    return new G(function(Ll) {
      var Yl = Zi || he(function() {
        return fetch;
      }) || vi;
      return Yl(no, Ao).then(function(Zl) {
        var tc;
        oo.setContext({ response: Zl });
        var Nl = (tc = Zl.headers) === null || tc === void 0 ? void 0 : tc.get("content-type");
        return Nl !== null && /^multipart\/mixed/i.test(Nl) ? Zo(Zl, Ll) : $o(Zl, oo, Ll);
      }).catch(function(Zl) {
        return An(Zl, Ll);
      }), function() {
        Zs && Zs.abort();
      };
    });
  });
};
(function(Bi) {
  be(e, Bi);
  function e(Ui) {
    Ui === void 0 && (Ui = {});
    var Zi = Bi.call(this, au(Ui).request) || this;
    return Zi.options = Ui, Zi;
  }
  return e;
})(Ze);
var ha = Object.prototype, mi = ha.toString, su = ha.hasOwnProperty, gi = Function.prototype.toString, rn = /* @__PURE__ */ new Map();
function re(Bi, e) {
  try {
    return nn(Bi, e);
  } finally {
    rn.clear();
  }
}
function nn(Bi, e) {
  if (Bi === e)
    return !0;
  var Ui = mi.call(Bi), Zi = mi.call(e);
  if (Ui !== Zi)
    return !1;
  switch (Ui) {
    case "[object Array]":
      if (Bi.length !== e.length)
        return !1;
    // Fall through to object case...
    case "[object Object]": {
      if (_i(Bi, e))
        return !0;
      var ta = bi(Bi), na = bi(e), ia = ta.length;
      if (ia !== na.length)
        return !1;
      for (var aa = 0; aa < ia; ++aa)
        if (!su.call(e, ta[aa]))
          return !1;
      for (var aa = 0; aa < ia; ++aa) {
        var da = ta[aa];
        if (!nn(Bi[da], e[da]))
          return !1;
      }
      return !0;
    }
    case "[object Error]":
      return Bi.name === e.name && Bi.message === e.message;
    case "[object Number]":
      if (Bi !== Bi)
        return e !== e;
    // Fall through to shared +a === +b case...
    case "[object Boolean]":
    case "[object Date]":
      return +Bi == +e;
    case "[object RegExp]":
    case "[object String]":
      return Bi == "" + e;
    case "[object Map]":
    case "[object Set]": {
      if (Bi.size !== e.size)
        return !1;
      if (_i(Bi, e))
        return !0;
      for (var La = Bi.entries(), qa = Ui === "[object Map]"; ; ) {
        var io = La.next();
        if (io.done)
          break;
        var ao = io.value, oo = ao[0], no = ao[1];
        if (!e.has(oo) || qa && !nn(no, e.get(oo)))
          return !1;
      }
      return !0;
    }
    case "[object Uint16Array]":
    case "[object Uint8Array]":
    // Buffer, in Node.js.
    case "[object Uint32Array]":
    case "[object Int32Array]":
    case "[object Int8Array]":
    case "[object Int16Array]":
    case "[object ArrayBuffer]":
      Bi = new Uint8Array(Bi), e = new Uint8Array(e);
    // Fall through...
    case "[object DataView]": {
      var lo = Bi.byteLength;
      if (lo === e.byteLength)
        for (; lo-- && Bi[lo] === e[lo]; )
          ;
      return lo === -1;
    }
    case "[object AsyncFunction]":
    case "[object GeneratorFunction]":
    case "[object AsyncGeneratorFunction]":
    case "[object Function]": {
      var so = gi.call(Bi);
      return so !== gi.call(e) ? !1 : !cu(so, uu);
    }
  }
  return !1;
}
function bi(Bi) {
  return Object.keys(Bi).filter(ou, Bi);
}
function ou(Bi) {
  return this[Bi] !== void 0;
}
var uu = "{ [native code] }";
function cu(Bi, e) {
  var Ui = Bi.length - e.length;
  return Ui >= 0 && Bi.indexOf(e, Ui) === Ui;
}
function _i(Bi, e) {
  var Ui = rn.get(Bi);
  if (Ui) {
    if (Ui.has(e))
      return !0;
  } else
    rn.set(Bi, Ui = /* @__PURE__ */ new Set());
  return Ui.add(e), !1;
}
var fu = function() {
  return /* @__PURE__ */ Object.create(null);
}, pa = Array.prototype, du = pa.forEach, hu = pa.slice, $t = (
  /** @class */
  function() {
    function Bi(e, Ui) {
      e === void 0 && (e = !0), Ui === void 0 && (Ui = fu), this.weakness = e, this.makeData = Ui;
    }
    return Bi.prototype.lookup = function() {
      for (var e = [], Ui = 0; Ui < arguments.length; Ui++)
        e[Ui] = arguments[Ui];
      return this.lookupArray(e);
    }, Bi.prototype.lookupArray = function(e) {
      var Ui = this;
      return du.call(e, function(Zi) {
        return Ui = Ui.getChildTrie(Zi);
      }), Ui.data || (Ui.data = this.makeData(hu.call(e)));
    }, Bi.prototype.getChildTrie = function(e) {
      var Ui = this.weakness && pu(e) ? this.weak || (this.weak = /* @__PURE__ */ new WeakMap()) : this.strong || (this.strong = /* @__PURE__ */ new Map()), Zi = Ui.get(e);
      return Zi || Ui.set(e, Zi = new Bi(this.weakness, this.makeData)), Zi;
    }, Bi;
  }()
);
function pu(Bi) {
  switch (typeof Bi) {
    case "object":
      if (Bi === null)
        break;
    // Fall through to return true...
    case "function":
      return !0;
  }
  return !1;
}
var ae = null, wi = {}, yu = 1, vu = function() {
  return (
    /** @class */
    function() {
      function Bi() {
        this.id = [
          "slot",
          yu++,
          Date.now(),
          Math.random().toString(36).slice(2)
        ].join(":");
      }
      return Bi.prototype.hasValue = function() {
        for (var e = ae; e; e = e.parent)
          if (this.id in e.slots) {
            var Ui = e.slots[this.id];
            if (Ui === wi)
              break;
            return e !== ae && (ae.slots[this.id] = Ui), !0;
          }
        return ae && (ae.slots[this.id] = wi), !1;
      }, Bi.prototype.getValue = function() {
        if (this.hasValue())
          return ae.slots[this.id];
      }, Bi.prototype.withValue = function(e, Ui, Zi, ta) {
        var na, ia = (na = {
          __proto__: null
        }, na[this.id] = e, na), aa = ae;
        ae = { parent: aa, slots: ia };
        try {
          return Ui.apply(ta, Zi);
        } finally {
          ae = aa;
        }
      }, Bi.bind = function(e) {
        var Ui = ae;
        return function() {
          var Zi = ae;
          try {
            return ae = Ui, e.apply(this, arguments);
          } finally {
            ae = Zi;
          }
        };
      }, Bi.noContext = function(e, Ui, Zi) {
        if (ae) {
          var ta = ae;
          try {
            return ae = null, e.apply(Zi, Ui);
          } finally {
            ae = ta;
          }
        } else
          return e.apply(Zi, Ui);
      }, Bi;
    }()
  );
}, Rr = "@wry/context:Slot", jr = Array, Nn = jr[Rr] || function() {
  var Bi = vu();
  try {
    Object.defineProperty(jr, Rr, {
      value: jr[Rr] = Bi,
      enumerable: !1,
      writable: !1,
      configurable: !1
    });
  } finally {
    return Bi;
  }
}();
Nn.bind;
Nn.noContext;
function mu() {
}
var gu = (
  /** @class */
  function() {
    function Bi(e, Ui) {
      e === void 0 && (e = 1 / 0), Ui === void 0 && (Ui = mu), this.max = e, this.dispose = Ui, this.map = /* @__PURE__ */ new Map(), this.newest = null, this.oldest = null;
    }
    return Bi.prototype.has = function(e) {
      return this.map.has(e);
    }, Bi.prototype.get = function(e) {
      var Ui = this.getNode(e);
      return Ui && Ui.value;
    }, Bi.prototype.getNode = function(e) {
      var Ui = this.map.get(e);
      if (Ui && Ui !== this.newest) {
        var Zi = Ui.older, ta = Ui.newer;
        ta && (ta.older = Zi), Zi && (Zi.newer = ta), Ui.older = this.newest, Ui.older.newer = Ui, Ui.newer = null, this.newest = Ui, Ui === this.oldest && (this.oldest = ta);
      }
      return Ui;
    }, Bi.prototype.set = function(e, Ui) {
      var Zi = this.getNode(e);
      return Zi ? Zi.value = Ui : (Zi = {
        key: e,
        value: Ui,
        newer: null,
        older: this.newest
      }, this.newest && (this.newest.newer = Zi), this.newest = Zi, this.oldest = this.oldest || Zi, this.map.set(e, Zi), Zi.value);
    }, Bi.prototype.clean = function() {
      for (; this.oldest && this.map.size > this.max; )
        this.delete(this.oldest.key);
    }, Bi.prototype.delete = function(e) {
      var Ui = this.map.get(e);
      return Ui ? (Ui === this.newest && (this.newest = Ui.older), Ui === this.oldest && (this.oldest = Ui.newer), Ui.newer && (Ui.newer.older = Ui.older), Ui.older && (Ui.older.newer = Ui.newer), this.map.delete(e), this.dispose(Ui.value, e), !0) : !1;
    }, Bi;
  }()
), kr = new Nn(), Cr, bu = Object.prototype.hasOwnProperty, Pn = (Cr = Array.from, Cr === void 0 ? function(Bi) {
  var e = [];
  return Bi.forEach(function(Ui) {
    return e.push(Ui);
  }), e;
} : Cr);
function Fn(Bi) {
  var e = Bi.unsubscribe;
  typeof e == "function" && (Bi.unsubscribe = void 0, e());
}
var It = [], _u = 100;
function ht(Bi, e) {
  if (!Bi)
    throw new Error(e || "assertion failure");
}
function wu(Bi, e) {
  var Ui = Bi.length;
  return (
    // Unknown values are not equal to each other.
    Ui > 0 && // Both values must be ordinary (or both exceptional) to be equal.
    Ui === e.length && // The underlying value or exception must be the same.
    Bi[Ui - 1] === e[Ui - 1]
  );
}
function ya(Bi) {
  switch (Bi.length) {
    case 0:
      throw new Error("unknown value");
    case 1:
      return Bi[0];
    case 2:
      throw Bi[1];
  }
}
function ku(Bi) {
  return Bi.slice(0);
}
var Eu = (
  /** @class */
  function() {
    function Bi(e) {
      this.fn = e, this.parents = /* @__PURE__ */ new Set(), this.childValues = /* @__PURE__ */ new Map(), this.dirtyChildren = null, this.dirty = !0, this.recomputing = !1, this.value = [], this.deps = null, ++Bi.count;
    }
    return Bi.prototype.peek = function() {
      if (this.value.length === 1 && !Ve(this))
        return ki(this), this.value[0];
    }, Bi.prototype.recompute = function(e) {
      return ht(!this.recomputing, "already recomputing"), ki(this), Ve(this) ? Su(this, e) : ya(this.value);
    }, Bi.prototype.setDirty = function() {
      this.dirty || (this.dirty = !0, this.value.length = 0, va(this), Fn(this));
    }, Bi.prototype.dispose = function() {
      var e = this;
      this.setDirty(), wa(this), Mn(this, function(Ui, Zi) {
        Ui.setDirty(), ka(Ui, e);
      });
    }, Bi.prototype.forget = function() {
      this.dispose();
    }, Bi.prototype.dependOn = function(e) {
      e.add(this), this.deps || (this.deps = It.pop() || /* @__PURE__ */ new Set()), this.deps.add(e);
    }, Bi.prototype.forgetDeps = function() {
      var e = this;
      this.deps && (Pn(this.deps).forEach(function(Ui) {
        return Ui.delete(e);
      }), this.deps.clear(), It.push(this.deps), this.deps = null);
    }, Bi.count = 0, Bi;
  }()
);
function ki(Bi) {
  var e = kr.getValue();
  if (e)
    return Bi.parents.add(e), e.childValues.has(Bi) || e.childValues.set(Bi, []), Ve(Bi) ? ga(e, Bi) : ba(e, Bi), e;
}
function Su(Bi, e) {
  return wa(Bi), kr.withValue(Bi, Ou, [Bi, e]), Tu(Bi, e) && xu(Bi), ya(Bi.value);
}
function Ou(Bi, e) {
  Bi.recomputing = !0, Bi.value.length = 0;
  try {
    Bi.value[0] = Bi.fn.apply(null, e);
  } catch (Ui) {
    Bi.value[1] = Ui;
  }
  Bi.recomputing = !1;
}
function Ve(Bi) {
  return Bi.dirty || !!(Bi.dirtyChildren && Bi.dirtyChildren.size);
}
function xu(Bi) {
  Bi.dirty = !1, !Ve(Bi) && ma(Bi);
}
function va(Bi) {
  Mn(Bi, ga);
}
function ma(Bi) {
  Mn(Bi, ba);
}
function Mn(Bi, e) {
  var Ui = Bi.parents.size;
  if (Ui)
    for (var Zi = Pn(Bi.parents), ta = 0; ta < Ui; ++ta)
      e(Zi[ta], Bi);
}
function ga(Bi, e) {
  ht(Bi.childValues.has(e)), ht(Ve(e));
  var Ui = !Ve(Bi);
  if (!Bi.dirtyChildren)
    Bi.dirtyChildren = It.pop() || /* @__PURE__ */ new Set();
  else if (Bi.dirtyChildren.has(e))
    return;
  Bi.dirtyChildren.add(e), Ui && va(Bi);
}
function ba(Bi, e) {
  ht(Bi.childValues.has(e)), ht(!Ve(e));
  var Ui = Bi.childValues.get(e);
  Ui.length === 0 ? Bi.childValues.set(e, ku(e.value)) : wu(Ui, e.value) || Bi.setDirty(), _a(Bi, e), !Ve(Bi) && ma(Bi);
}
function _a(Bi, e) {
  var Ui = Bi.dirtyChildren;
  Ui && (Ui.delete(e), Ui.size === 0 && (It.length < _u && It.push(Ui), Bi.dirtyChildren = null));
}
function wa(Bi) {
  Bi.childValues.size > 0 && Bi.childValues.forEach(function(e, Ui) {
    ka(Bi, Ui);
  }), Bi.forgetDeps(), ht(Bi.dirtyChildren === null);
}
function ka(Bi, e) {
  e.parents.delete(Bi), Bi.childValues.delete(e), _a(Bi, e);
}
function Tu(Bi, e) {
  if (typeof Bi.subscribe == "function")
    try {
      Fn(Bi), Bi.unsubscribe = Bi.subscribe.apply(null, e);
    } catch {
      return Bi.setDirty(), !1;
    }
  return !0;
}
var Du = {
  setDirty: !0,
  dispose: !0,
  forget: !0
};
function Ea(Bi) {
  var e = /* @__PURE__ */ new Map();
  function Ui(Zi) {
    var ta = kr.getValue();
    if (ta) {
      var na = e.get(Zi);
      na || e.set(Zi, na = /* @__PURE__ */ new Set()), ta.dependOn(na);
    }
  }
  return Ui.dirty = function(Zi, ta) {
    var na = e.get(Zi);
    if (na) {
      var ia = ta && bu.call(Du, ta) ? ta : "setDirty";
      Pn(na).forEach(function(aa) {
        return aa[ia]();
      }), e.delete(Zi), Fn(na);
    }
  }, Ui;
}
function Sa() {
  var Bi = new $t(typeof WeakMap == "function");
  return function() {
    return Bi.lookupArray(arguments);
  };
}
Sa();
var Ar = /* @__PURE__ */ new Set();
function sr(Bi, e) {
  e === void 0 && (e = /* @__PURE__ */ Object.create(null));
  var Ui = new gu(e.max || Math.pow(2, 16), function(La) {
    return La.dispose();
  }), Zi = e.keyArgs, ta = e.makeCacheKey || Sa(), na = function() {
    var La = ta.apply(null, Zi ? Zi.apply(null, arguments) : arguments);
    if (La === void 0)
      return Bi.apply(null, arguments);
    var qa = Ui.get(La);
    qa || (Ui.set(La, qa = new Eu(Bi)), qa.subscribe = e.subscribe, qa.forget = function() {
      return Ui.delete(La);
    });
    var io = qa.recompute(Array.prototype.slice.call(arguments));
    return Ui.set(La, qa), Ar.add(Ui), kr.hasValue() || (Ar.forEach(function(ao) {
      return ao.clean();
    }), Ar.clear()), io;
  };
  Object.defineProperty(na, "size", {
    get: function() {
      return Ui.map.size;
    },
    configurable: !1,
    enumerable: !1
  });
  function ia(La) {
    var qa = Ui.get(La);
    qa && qa.setDirty();
  }
  na.dirtyKey = ia, na.dirty = function() {
    ia(ta.apply(null, arguments));
  };
  function aa(La) {
    var qa = Ui.get(La);
    if (qa)
      return qa.peek();
  }
  na.peekKey = aa, na.peek = function() {
    return aa(ta.apply(null, arguments));
  };
  function da(La) {
    return Ui.delete(La);
  }
  return na.forgetKey = da, na.forget = function() {
    return da(ta.apply(null, arguments));
  }, na.makeCacheKey = ta, na.getKey = Zi ? function() {
    return ta.apply(null, Zi.apply(null, arguments));
  } : ta, Object.freeze(na);
}
var Iu = function() {
  function Bi() {
    this.getFragmentDoc = sr(Us);
  }
  return Bi.prototype.batch = function(e) {
    var Ui = this, Zi = typeof e.optimistic == "string" ? e.optimistic : e.optimistic === !1 ? null : void 0, ta;
    return this.performTransaction(function() {
      return ta = e.update(Ui);
    }, Zi), ta;
  }, Bi.prototype.recordOptimisticTransaction = function(e, Ui) {
    this.performTransaction(e, Ui);
  }, Bi.prototype.transformDocument = function(e) {
    return e;
  }, Bi.prototype.transformForLink = function(e) {
    return e;
  }, Bi.prototype.identify = function(e) {
  }, Bi.prototype.gc = function() {
    return [];
  }, Bi.prototype.modify = function(e) {
    return !1;
  }, Bi.prototype.readQuery = function(e, Ui) {
    return Ui === void 0 && (Ui = !!e.optimistic), this.read(y(y({}, e), { rootId: e.id || "ROOT_QUERY", optimistic: Ui }));
  }, Bi.prototype.readFragment = function(e, Ui) {
    return Ui === void 0 && (Ui = !!e.optimistic), this.read(y(y({}, e), { query: this.getFragmentDoc(e.fragment, e.fragmentName), rootId: e.id, optimistic: Ui }));
  }, Bi.prototype.writeQuery = function(e) {
    var Ui = e.id, Zi = e.data, ta = lt(e, ["id", "data"]);
    return this.write(Object.assign(ta, {
      dataId: Ui || "ROOT_QUERY",
      result: Zi
    }));
  }, Bi.prototype.writeFragment = function(e) {
    var Ui = e.id, Zi = e.data, ta = e.fragment, na = e.fragmentName, ia = lt(e, ["id", "data", "fragment", "fragmentName"]);
    return this.write(Object.assign(ia, {
      query: this.getFragmentDoc(ta, na),
      dataId: Ui,
      result: Zi
    }));
  }, Bi.prototype.updateQuery = function(e, Ui) {
    return this.batch({
      update: function(Zi) {
        var ta = Zi.readQuery(e), na = Ui(ta);
        return na == null ? ta : (Zi.writeQuery(y(y({}, e), { data: na })), na);
      }
    });
  }, Bi.prototype.updateFragment = function(e, Ui) {
    return this.batch({
      update: function(Zi) {
        var ta = Zi.readFragment(e), na = Ui(ta);
        return na == null ? ta : (Zi.writeFragment(y(y({}, e), { data: na })), na);
      }
    });
  }, Bi;
}(), Oa = function(Bi) {
  be(e, Bi);
  function e(Ui, Zi, ta, na) {
    var ia, aa = Bi.call(this, Ui) || this;
    if (aa.message = Ui, aa.path = Zi, aa.query = ta, aa.variables = na, Array.isArray(aa.path)) {
      aa.missing = aa.message;
      for (var da = aa.path.length - 1; da >= 0; --da)
        aa.missing = (ia = {}, ia[aa.path[da]] = aa.missing, ia);
    } else
      aa.missing = aa.path;
    return aa.__proto__ = e.prototype, aa;
  }
  return e;
}(Error), te = Object.prototype.hasOwnProperty;
function wt(Bi) {
  return Bi == null;
}
var ee = Array.isArray;
function xa(Bi, e) {
  var Ui = Bi.__typename, Zi = Bi.id, ta = Bi._id;
  if (typeof Ui == "string" && (e && (e.keyObject = wt(Zi) ? wt(ta) ? void 0 : { _id: ta } : { id: Zi }), wt(Zi) && !wt(ta) && (Zi = ta), !wt(Zi)))
    return "".concat(Ui, ":").concat(typeof Zi == "number" || typeof Zi == "string" ? Zi : JSON.stringify(Zi));
}
var Ta = {
  dataIdFromObject: xa,
  addTypename: !0,
  resultCaching: !0,
  canonizeResults: !1
};
function Ru(Bi) {
  return wr(Ta, Bi);
}
function Da(Bi) {
  var e = Bi.canonizeResults;
  return e === void 0 ? Ta.canonizeResults : e;
}
function ju(Bi, e) {
  return Z(e) ? Bi.get(e.__ref, "__typename") : e && e.__typename;
}
var Ia = /^[_a-z][_0-9a-z]*/i;
function Le(Bi) {
  var e = Bi.match(Ia);
  return e ? e[0] : Bi;
}
function an(Bi, e, Ui) {
  return Y(e) ? ee(e) ? e.every(function(Zi) {
    return an(Bi, Zi, Ui);
  }) : Bi.selections.every(function(Zi) {
    if (je(Zi) && vr(Zi, Ui)) {
      var ta = Je(Zi);
      return te.call(e, ta) && (!Zi.selectionSet || an(Zi.selectionSet, e[ta], Ui));
    }
    return !0;
  }) : !1;
}
function it(Bi) {
  return Y(Bi) && !Z(Bi) && !ee(Bi);
}
function Cu() {
  return new He();
}
function Ra(Bi, e) {
  var Ui = _n(En(Bi));
  return {
    fragmentMap: Ui,
    lookupFragment: function(Zi) {
      var ta = Ui[Zi];
      return !ta && e && (ta = e.lookup(Zi)), ta || null;
    }
  };
}
var nr = /* @__PURE__ */ Object.create(null), Nr = function() {
  return nr;
}, Ei = /* @__PURE__ */ Object.create(null), Rt = function() {
  function Bi(e, Ui) {
    var Zi = this;
    this.policies = e, this.group = Ui, this.data = /* @__PURE__ */ Object.create(null), this.rootIds = /* @__PURE__ */ Object.create(null), this.refs = /* @__PURE__ */ Object.create(null), this.getFieldValue = function(ta, na) {
      return Yr(Z(ta) ? Zi.get(ta.__ref, na) : ta && ta[na]);
    }, this.canRead = function(ta) {
      return Z(ta) ? Zi.has(ta.__ref) : typeof ta == "object";
    }, this.toReference = function(ta, na) {
      if (typeof ta == "string")
        return ot(ta);
      if (Z(ta))
        return ta;
      var ia = Zi.policies.identify(ta)[0];
      if (ia) {
        var aa = ot(ia);
        return na && Zi.merge(ia, ta), aa;
      }
    };
  }
  return Bi.prototype.toObject = function() {
    return y({}, this.data);
  }, Bi.prototype.has = function(e) {
    return this.lookup(e, !0) !== void 0;
  }, Bi.prototype.get = function(e, Ui) {
    if (this.group.depend(e, Ui), te.call(this.data, e)) {
      var Zi = this.data[e];
      if (Zi && te.call(Zi, Ui))
        return Zi[Ui];
    }
    if (Ui === "__typename" && te.call(this.policies.rootTypenamesById, e))
      return this.policies.rootTypenamesById[e];
    if (this instanceof Ne)
      return this.parent.get(e, Ui);
  }, Bi.prototype.lookup = function(e, Ui) {
    if (Ui && this.group.depend(e, "__exists"), te.call(this.data, e))
      return this.data[e];
    if (this instanceof Ne)
      return this.parent.lookup(e, Ui);
    if (this.policies.rootTypenamesById[e])
      return /* @__PURE__ */ Object.create(null);
  }, Bi.prototype.merge = function(e, Ui) {
    var Zi = this, ta;
    Z(e) && (e = e.__ref), Z(Ui) && (Ui = Ui.__ref);
    var na = typeof e == "string" ? this.lookup(ta = e) : e, ia = typeof Ui == "string" ? this.lookup(ta = Ui) : Ui;
    if (ia) {
      __DEV__ ? E(typeof ta == "string", "store.merge expects a string ID") : E(typeof ta == "string", 1);
      var aa = new He(Nu).merge(na, ia);
      if (this.data[ta] = aa, aa !== na && (delete this.refs[ta], this.group.caching)) {
        var da = /* @__PURE__ */ Object.create(null);
        na || (da.__exists = 1), Object.keys(ia).forEach(function(La) {
          if (!na || na[La] !== aa[La]) {
            da[La] = 1;
            var qa = Le(La);
            qa !== La && !Zi.policies.hasKeyArgs(aa.__typename, qa) && (da[qa] = 1), aa[La] === void 0 && !(Zi instanceof Ne) && delete aa[La];
          }
        }), da.__typename && !(na && na.__typename) && this.policies.rootTypenamesById[ta] === aa.__typename && delete da.__typename, Object.keys(da).forEach(function(La) {
          return Zi.group.dirty(ta, La);
        });
      }
    }
  }, Bi.prototype.modify = function(e, Ui) {
    var Zi = this, ta = this.lookup(e);
    if (ta) {
      var na = /* @__PURE__ */ Object.create(null), ia = !1, aa = !0, da = {
        DELETE: nr,
        INVALIDATE: Ei,
        isReference: Z,
        toReference: this.toReference,
        canRead: this.canRead,
        readField: function(La, qa) {
          return Zi.policies.readField(typeof La == "string" ? {
            fieldName: La,
            from: qa || ot(e)
          } : La, { store: Zi });
        }
      };
      if (Object.keys(ta).forEach(function(La) {
        var qa = Le(La), io = ta[La];
        if (io !== void 0) {
          var ao = typeof Ui == "function" ? Ui : Ui[La] || Ui[qa];
          if (ao) {
            var oo = ao === Nr ? nr : ao(Yr(io), y(y({}, da), { fieldName: qa, storeFieldName: La, storage: Zi.getStorage(e, La) }));
            oo === Ei ? Zi.group.dirty(e, La) : (oo === nr && (oo = void 0), oo !== io && (na[La] = oo, ia = !0, io = oo));
          }
          io !== void 0 && (aa = !1);
        }
      }), ia)
        return this.merge(e, na), aa && (this instanceof Ne ? this.data[e] = void 0 : delete this.data[e], this.group.dirty(e, "__exists")), !0;
    }
    return !1;
  }, Bi.prototype.delete = function(e, Ui, Zi) {
    var ta, na = this.lookup(e);
    if (na) {
      var ia = this.getFieldValue(na, "__typename"), aa = Ui && Zi ? this.policies.getStoreFieldName({ typename: ia, fieldName: Ui, args: Zi }) : Ui;
      return this.modify(e, aa ? (ta = {}, ta[aa] = Nr, ta) : Nr);
    }
    return !1;
  }, Bi.prototype.evict = function(e, Ui) {
    var Zi = !1;
    return e.id && (te.call(this.data, e.id) && (Zi = this.delete(e.id, e.fieldName, e.args)), this instanceof Ne && this !== Ui && (Zi = this.parent.evict(e, Ui) || Zi), (e.fieldName || Zi) && this.group.dirty(e.id, e.fieldName || "__exists")), Zi;
  }, Bi.prototype.clear = function() {
    this.replace(null);
  }, Bi.prototype.extract = function() {
    var e = this, Ui = this.toObject(), Zi = [];
    return this.getRootIdSet().forEach(function(ta) {
      te.call(e.policies.rootTypenamesById, ta) || Zi.push(ta);
    }), Zi.length && (Ui.__META = { extraRootIds: Zi.sort() }), Ui;
  }, Bi.prototype.replace = function(e) {
    var Ui = this;
    if (Object.keys(this.data).forEach(function(na) {
      e && te.call(e, na) || Ui.delete(na);
    }), e) {
      var Zi = e.__META, ta = lt(e, ["__META"]);
      Object.keys(ta).forEach(function(na) {
        Ui.merge(na, ta[na]);
      }), Zi && Zi.extraRootIds.forEach(this.retain, this);
    }
  }, Bi.prototype.retain = function(e) {
    return this.rootIds[e] = (this.rootIds[e] || 0) + 1;
  }, Bi.prototype.release = function(e) {
    if (this.rootIds[e] > 0) {
      var Ui = --this.rootIds[e];
      return Ui || delete this.rootIds[e], Ui;
    }
    return 0;
  }, Bi.prototype.getRootIdSet = function(e) {
    return e === void 0 && (e = /* @__PURE__ */ new Set()), Object.keys(this.rootIds).forEach(e.add, e), this instanceof Ne ? this.parent.getRootIdSet(e) : Object.keys(this.policies.rootTypenamesById).forEach(e.add, e), e;
  }, Bi.prototype.gc = function() {
    var e = this, Ui = this.getRootIdSet(), Zi = this.toObject();
    Ui.forEach(function(ia) {
      te.call(Zi, ia) && (Object.keys(e.findChildRefIds(ia)).forEach(Ui.add, Ui), delete Zi[ia]);
    });
    var ta = Object.keys(Zi);
    if (ta.length) {
      for (var na = this; na instanceof Ne; )
        na = na.parent;
      ta.forEach(function(ia) {
        return na.delete(ia);
      });
    }
    return ta;
  }, Bi.prototype.findChildRefIds = function(e) {
    if (!te.call(this.refs, e)) {
      var Ui = this.refs[e] = /* @__PURE__ */ Object.create(null), Zi = this.data[e];
      if (!Zi)
        return Ui;
      var ta = /* @__PURE__ */ new Set([Zi]);
      ta.forEach(function(na) {
        Z(na) && (Ui[na.__ref] = !0), Y(na) && Object.keys(na).forEach(function(ia) {
          var aa = na[ia];
          Y(aa) && ta.add(aa);
        });
      });
    }
    return this.refs[e];
  }, Bi.prototype.makeCacheKey = function() {
    return this.group.keyMaker.lookupArray(arguments);
  }, Bi;
}(), ja = function() {
  function Bi(e, Ui) {
    Ui === void 0 && (Ui = null), this.caching = e, this.parent = Ui, this.d = null, this.resetCaching();
  }
  return Bi.prototype.resetCaching = function() {
    this.d = this.caching ? Ea() : null, this.keyMaker = new $t(et);
  }, Bi.prototype.depend = function(e, Ui) {
    if (this.d) {
      this.d(Pr(e, Ui));
      var Zi = Le(Ui);
      Zi !== Ui && this.d(Pr(e, Zi)), this.parent && this.parent.depend(e, Ui);
    }
  }, Bi.prototype.dirty = function(e, Ui) {
    this.d && this.d.dirty(Pr(e, Ui), Ui === "__exists" ? "forget" : "setDirty");
  }, Bi;
}();
function Pr(Bi, e) {
  return e + "#" + Bi;
}
function Si(Bi, e) {
  Tt(Bi) && Bi.group.depend(e, "__exists");
}
(function(Bi) {
  var e = function(Ui) {
    be(Zi, Ui);
    function Zi(ta) {
      var na = ta.policies, ia = ta.resultCaching, aa = ia === void 0 ? !0 : ia, da = ta.seed, La = Ui.call(this, na, new ja(aa)) || this;
      return La.stump = new Au(La), La.storageTrie = new $t(et), da && La.replace(da), La;
    }
    return Zi.prototype.addLayer = function(ta, na) {
      return this.stump.addLayer(ta, na);
    }, Zi.prototype.removeLayer = function() {
      return this;
    }, Zi.prototype.getStorage = function() {
      return this.storageTrie.lookupArray(arguments);
    }, Zi;
  }(Bi);
  Bi.Root = e;
})(Rt || (Rt = {}));
var Ne = function(Bi) {
  be(e, Bi);
  function e(Ui, Zi, ta, na) {
    var ia = Bi.call(this, Zi.policies, na) || this;
    return ia.id = Ui, ia.parent = Zi, ia.replay = ta, ia.group = na, ta(ia), ia;
  }
  return e.prototype.addLayer = function(Ui, Zi) {
    return new e(Ui, this, Zi, this.group);
  }, e.prototype.removeLayer = function(Ui) {
    var Zi = this, ta = this.parent.removeLayer(Ui);
    return Ui === this.id ? (this.group.caching && Object.keys(this.data).forEach(function(na) {
      var ia = Zi.data[na], aa = ta.lookup(na);
      aa ? ia ? ia !== aa && Object.keys(ia).forEach(function(da) {
        re(ia[da], aa[da]) || Zi.group.dirty(na, da);
      }) : (Zi.group.dirty(na, "__exists"), Object.keys(aa).forEach(function(da) {
        Zi.group.dirty(na, da);
      })) : Zi.delete(na);
    }), ta) : ta === this.parent ? this : ta.addLayer(this.id, this.replay);
  }, e.prototype.toObject = function() {
    return y(y({}, this.parent.toObject()), this.data);
  }, e.prototype.findChildRefIds = function(Ui) {
    var Zi = this.parent.findChildRefIds(Ui);
    return te.call(this.data, Ui) ? y(y({}, Zi), Bi.prototype.findChildRefIds.call(this, Ui)) : Zi;
  }, e.prototype.getStorage = function() {
    for (var Ui = this.parent; Ui.parent; )
      Ui = Ui.parent;
    return Ui.getStorage.apply(Ui, arguments);
  }, e;
}(Rt), Au = function(Bi) {
  be(e, Bi);
  function e(Ui) {
    return Bi.call(this, "EntityStore.Stump", Ui, function() {
    }, new ja(Ui.group.caching, Ui.group)) || this;
  }
  return e.prototype.removeLayer = function() {
    return this;
  }, e.prototype.merge = function() {
    return this.parent.merge.apply(this.parent, arguments);
  }, e;
}(Ne);
function Nu(Bi, e, Ui) {
  var Zi = Bi[Ui], ta = e[Ui];
  return re(Zi, ta) ? Zi : ta;
}
function Tt(Bi) {
  return !!(Bi instanceof Rt && Bi.group.caching);
}
function Pu(Bi) {
  return Y(Bi) ? ee(Bi) ? Bi.slice(0) : y({ __proto__: Object.getPrototypeOf(Bi) }, Bi) : Bi;
}
var sn = function() {
  function Bi() {
    this.known = new (Oo ? WeakSet : Set)(), this.pool = new $t(et), this.passes = /* @__PURE__ */ new WeakMap(), this.keysByJSON = /* @__PURE__ */ new Map(), this.empty = this.admit({});
  }
  return Bi.prototype.isKnown = function(e) {
    return Y(e) && this.known.has(e);
  }, Bi.prototype.pass = function(e) {
    if (Y(e)) {
      var Ui = Pu(e);
      return this.passes.set(Ui, e), Ui;
    }
    return e;
  }, Bi.prototype.admit = function(e) {
    var Ui = this;
    if (Y(e)) {
      var Zi = this.passes.get(e);
      if (Zi)
        return Zi;
      var ta = Object.getPrototypeOf(e);
      switch (ta) {
        case Array.prototype: {
          if (this.known.has(e))
            return e;
          var na = e.map(this.admit, this), ia = this.pool.lookupArray(na);
          return ia.array || (this.known.add(ia.array = na), __DEV__ && Object.freeze(na)), ia.array;
        }
        case null:
        case Object.prototype: {
          if (this.known.has(e))
            return e;
          var aa = Object.getPrototypeOf(e), da = [aa], La = this.sortedKeys(e);
          da.push(La.json);
          var qa = da.length;
          La.sorted.forEach(function(oo) {
            da.push(Ui.admit(e[oo]));
          });
          var ia = this.pool.lookupArray(da);
          if (!ia.object) {
            var io = ia.object = Object.create(aa);
            this.known.add(io), La.sorted.forEach(function(oo, no) {
              io[oo] = da[qa + no];
            }), __DEV__ && Object.freeze(io);
          }
          return ia.object;
        }
      }
    }
    return e;
  }, Bi.prototype.sortedKeys = function(e) {
    var Ui = Object.keys(e), Zi = this.pool.lookupArray(Ui);
    if (!Zi.keys) {
      Ui.sort();
      var ta = JSON.stringify(Ui);
      (Zi.keys = this.keysByJSON.get(ta)) || this.keysByJSON.set(ta, Zi.keys = { sorted: Ui, json: ta });
    }
    return Zi.keys;
  }, Bi;
}(), We = Object.assign(function(Bi) {
  if (Y(Bi)) {
    on === void 0 && Oi();
    var e = on.admit(Bi), Ui = un.get(e);
    return Ui === void 0 && un.set(e, Ui = JSON.stringify(e)), Ui;
  }
  return JSON.stringify(Bi);
}, {
  reset: Oi
}), on, un;
function Oi() {
  on = new sn(), un = new (et ? WeakMap : Map)();
}
function xi(Bi) {
  return [
    Bi.selectionSet,
    Bi.objectOrReference,
    Bi.context,
    Bi.context.canonizeResults
  ];
}
var Fu = function() {
  function Bi(e) {
    var Ui = this;
    this.knownResults = new (et ? WeakMap : Map)(), this.config = wr(e, {
      addTypename: e.addTypename !== !1,
      canonizeResults: Da(e)
    }), this.canon = e.canon || new sn(), this.executeSelectionSet = sr(function(Zi) {
      var ta, na = Zi.context.canonizeResults, ia = xi(Zi);
      ia[3] = !na;
      var aa = (ta = Ui.executeSelectionSet).peek.apply(ta, ia);
      return aa ? na ? y(y({}, aa), { result: Ui.canon.admit(aa.result) }) : aa : (Si(Zi.context.store, Zi.enclosingRef.__ref), Ui.execSelectionSetImpl(Zi));
    }, {
      max: this.config.resultCacheMaxSize,
      keyArgs: xi,
      makeCacheKey: function(Zi, ta, na, ia) {
        if (Tt(na.store))
          return na.store.makeCacheKey(Zi, Z(ta) ? ta.__ref : ta, na.varString, ia);
      }
    }), this.executeSubSelectedArray = sr(function(Zi) {
      return Si(Zi.context.store, Zi.enclosingRef.__ref), Ui.execSubSelectedArrayImpl(Zi);
    }, {
      max: this.config.resultCacheMaxSize,
      makeCacheKey: function(Zi) {
        var ta = Zi.field, na = Zi.array, ia = Zi.context;
        if (Tt(ia.store))
          return ia.store.makeCacheKey(ta, na, ia.varString);
      }
    });
  }
  return Bi.prototype.resetCanon = function() {
    this.canon = new sn();
  }, Bi.prototype.diffQueryAgainstStore = function(e) {
    var Ui = e.store, Zi = e.query, ta = e.rootId, na = ta === void 0 ? "ROOT_QUERY" : ta, ia = e.variables, aa = e.returnPartialData, da = aa === void 0 ? !0 : aa, La = e.canonizeResults, qa = La === void 0 ? this.config.canonizeResults : La, io = this.config.cache.policies;
    ia = y(y({}, Sn(ra(Zi))), ia);
    var ao = ot(na), oo = this.executeSelectionSet({
      selectionSet: br(Zi).selectionSet,
      objectOrReference: ao,
      enclosingRef: ao,
      context: y({ store: Ui, query: Zi, policies: io, variables: ia, varString: We(ia), canonizeResults: qa }, Ra(Zi, this.config.fragments))
    }), no;
    if (oo.missing && (no = [new Oa(Mu(oo.missing), oo.missing, Zi, ia)], !da))
      throw no[0];
    return {
      result: oo.result,
      complete: !no,
      missing: no
    };
  }, Bi.prototype.isFresh = function(e, Ui, Zi, ta) {
    if (Tt(ta.store) && this.knownResults.get(e) === Zi) {
      var na = this.executeSelectionSet.peek(Zi, Ui, ta, this.canon.isKnown(e));
      if (na && e === na.result)
        return !0;
    }
    return !1;
  }, Bi.prototype.execSelectionSetImpl = function(e) {
    var Ui = this, Zi = e.selectionSet, ta = e.objectOrReference, na = e.enclosingRef, ia = e.context;
    if (Z(ta) && !ia.policies.rootTypenamesById[ta.__ref] && !ia.store.has(ta.__ref))
      return {
        result: this.canon.empty,
        missing: "Dangling reference to missing ".concat(ta.__ref, " object")
      };
    var aa = ia.variables, da = ia.policies, La = ia.store, qa = La.getFieldValue(ta, "__typename"), io = [], ao, oo = new He();
    this.config.addTypename && typeof qa == "string" && !da.rootIdsByTypename[qa] && io.push({ __typename: qa });
    function no(js, qs) {
      var jo;
      return js.missing && (ao = oo.merge(ao, (jo = {}, jo[qs] = js.missing, jo))), js.result;
    }
    var lo = new Set(Zi.selections);
    lo.forEach(function(js) {
      var qs, jo;
      if (vr(js, aa))
        if (je(js)) {
          var fs = da.readField({
            fieldName: js.name.value,
            field: js,
            variables: ia.variables,
            from: ta
          }, ia), Ao = Je(js);
          fs === void 0 ? xn.added(js) || (ao = oo.merge(ao, (qs = {}, qs[Ao] = "Can't find field '".concat(js.name.value, "' on ").concat(Z(ta) ? ta.__ref + " object" : "object " + JSON.stringify(ta, null, 2)), qs))) : ee(fs) ? fs = no(Ui.executeSubSelectedArray({
            field: js,
            array: fs,
            enclosingRef: na,
            context: ia
          }), Ao) : js.selectionSet ? fs != null && (fs = no(Ui.executeSelectionSet({
            selectionSet: js.selectionSet,
            objectOrReference: fs,
            enclosingRef: Z(fs) ? fs : na,
            context: ia
          }), Ao)) : ia.canonizeResults && (fs = Ui.canon.pass(fs)), fs !== void 0 && io.push((jo = {}, jo[Ao] = fs, jo));
        } else {
          var co = wn(js, ia.lookupFragment);
          if (!co && js.kind === Hi.FRAGMENT_SPREAD)
            throw __DEV__ ? new B("No fragment named ".concat(js.name.value)) : new B(5);
          co && da.fragmentMatches(co, qa) && co.selectionSet.selections.forEach(lo.add, lo);
        }
    });
    var so = Tn(io), bs = { result: so, missing: ao }, Rs = ia.canonizeResults ? this.canon.admit(bs) : Yr(bs);
    return Rs.result && this.knownResults.set(Rs.result, Zi), Rs;
  }, Bi.prototype.execSubSelectedArrayImpl = function(e) {
    var Ui = this, Zi = e.field, ta = e.array, na = e.enclosingRef, ia = e.context, aa, da = new He();
    function La(qa, io) {
      var ao;
      return qa.missing && (aa = da.merge(aa, (ao = {}, ao[io] = qa.missing, ao))), qa.result;
    }
    return Zi.selectionSet && (ta = ta.filter(ia.store.canRead)), ta = ta.map(function(qa, io) {
      return qa === null ? null : ee(qa) ? La(Ui.executeSubSelectedArray({
        field: Zi,
        array: qa,
        enclosingRef: na,
        context: ia
      }), io) : Zi.selectionSet ? La(Ui.executeSelectionSet({
        selectionSet: Zi.selectionSet,
        objectOrReference: qa,
        enclosingRef: Z(qa) ? qa : na,
        context: ia
      }), io) : (__DEV__ && Vu(ia.store, Zi, qa), qa);
    }), {
      result: ia.canonizeResults ? this.canon.admit(ta) : ta,
      missing: aa
    };
  }, Bi;
}();
function Mu(Bi) {
  try {
    JSON.stringify(Bi, function(e, Ui) {
      if (typeof Ui == "string")
        throw Ui;
      return Ui;
    });
  } catch (e) {
    return e;
  }
}
function Vu(Bi, e, Ui) {
  if (!e.selectionSet) {
    var Zi = /* @__PURE__ */ new Set([Ui]);
    Zi.forEach(function(ta) {
      Y(ta) && (__DEV__ ? E(!Z(ta), "Missing selection set for object of type ".concat(ju(Bi, ta), " returned for query field ").concat(e.name.value)) : E(!Z(ta), 6), Object.values(ta).forEach(Zi.add, Zi));
    });
  }
}
var se = null, Ti = {}, Lu = 1, qu = function() {
  return (
    /** @class */
    function() {
      function Bi() {
        this.id = [
          "slot",
          Lu++,
          Date.now(),
          Math.random().toString(36).slice(2)
        ].join(":");
      }
      return Bi.prototype.hasValue = function() {
        for (var e = se; e; e = e.parent)
          if (this.id in e.slots) {
            var Ui = e.slots[this.id];
            if (Ui === Ti)
              break;
            return e !== se && (se.slots[this.id] = Ui), !0;
          }
        return se && (se.slots[this.id] = Ti), !1;
      }, Bi.prototype.getValue = function() {
        if (this.hasValue())
          return se.slots[this.id];
      }, Bi.prototype.withValue = function(e, Ui, Zi, ta) {
        var na, ia = (na = {
          __proto__: null
        }, na[this.id] = e, na), aa = se;
        se = { parent: aa, slots: ia };
        try {
          return Ui.apply(ta, Zi);
        } finally {
          se = aa;
        }
      }, Bi.bind = function(e) {
        var Ui = se;
        return function() {
          var Zi = se;
          try {
            return se = Ui, e.apply(this, arguments);
          } finally {
            se = Zi;
          }
        };
      }, Bi.noContext = function(e, Ui, Zi) {
        if (se) {
          var ta = se;
          try {
            return se = null, e.apply(Zi, Ui);
          } finally {
            se = ta;
          }
        } else
          return e.apply(Zi, Ui);
      }, Bi;
    }()
  );
};
function Di(Bi) {
  try {
    return Bi();
  } catch {
  }
}
var Fr = "@wry/context:Slot", Qu = (
  // Prefer globalThis when available.
  // https://github.com/benjamn/wryware/issues/347
  Di(function() {
    return globalThis;
  }) || // Fall back to global, which works in Node.js and may be converted by some
  // bundlers to the appropriate identifier (window, self, ...) depending on the
  // bundling target. https://github.com/endojs/endo/issues/576#issuecomment-1178515224
  Di(function() {
    return global;
  }) || // Otherwise, use a dummy host that's local to this module. We used to fall
  // back to using the Array constructor as a namespace, but that was flagged in
  // https://github.com/benjamn/wryware/issues/347, and can be avoided.
  /* @__PURE__ */ Object.create(null)
), Ii = Qu, Vn = Ii[Fr] || // Earlier versions of this package stored the globalKey property on the Array
// constructor, so we check there as well, to prevent Slot class duplication.
Array[Fr] || function(Bi) {
  try {
    Object.defineProperty(Ii, Fr, {
      value: Bi,
      enumerable: !1,
      writable: !1,
      // When it was possible for globalHost to be the Array constructor (a
      // legacy Slot dedup strategy), it was important for the property to be
      // configurable:true so it could be deleted. That does not seem to be as
      // important when globalHost is the global object, but I don't want to
      // cause similar problems again, and configurable:true seems safest.
      // https://github.com/endojs/endo/issues/576#issuecomment-1178274008
      configurable: !0
    });
  } finally {
    return Bi;
  }
}(qu());
Vn.bind;
Vn.noContext;
var Ln = new Vn(), Ri = /* @__PURE__ */ new WeakMap();
function Dt(Bi) {
  var e = Ri.get(Bi);
  return e || Ri.set(Bi, e = {
    vars: /* @__PURE__ */ new Set(),
    dep: Ea()
  }), e;
}
function ji(Bi) {
  Dt(Bi).vars.forEach(function(e) {
    return e.forgetCache(Bi);
  });
}
function Bu(Bi) {
  Dt(Bi).vars.forEach(function(e) {
    return e.attachCache(Bi);
  });
}
function Uu(Bi) {
  var e = /* @__PURE__ */ new Set(), Ui = /* @__PURE__ */ new Set(), Zi = function(na) {
    if (arguments.length > 0) {
      if (Bi !== na) {
        Bi = na, e.forEach(function(da) {
          Dt(da).dep.dirty(Zi), Zu(da);
        });
        var ia = Array.from(Ui);
        Ui.clear(), ia.forEach(function(da) {
          return da(Bi);
        });
      }
    } else {
      var aa = Ln.getValue();
      aa && (ta(aa), Dt(aa).dep(Zi));
    }
    return Bi;
  };
  Zi.onNextChange = function(na) {
    return Ui.add(na), function() {
      Ui.delete(na);
    };
  };
  var ta = Zi.attachCache = function(na) {
    return e.add(na), Dt(na).vars.add(Zi), Zi;
  };
  return Zi.forgetCache = function(na) {
    return e.delete(na);
  }, Zi;
}
function Zu(Bi) {
  Bi.broadcastWatches && Bi.broadcastWatches();
}
var Ci = /* @__PURE__ */ Object.create(null);
function qn(Bi) {
  var e = JSON.stringify(Bi);
  return Ci[e] || (Ci[e] = /* @__PURE__ */ Object.create(null));
}
function Ai(Bi) {
  var e = qn(Bi);
  return e.keyFieldsFn || (e.keyFieldsFn = function(Ui, Zi) {
    var ta = function(ia, aa) {
      return Zi.readField(aa, ia);
    }, na = Zi.keyObject = Qn(Bi, function(ia) {
      var aa = ut(Zi.storeObject, ia, ta);
      return aa === void 0 && Ui !== Zi.storeObject && te.call(Ui, ia[0]) && (aa = ut(Ui, ia, Aa)), __DEV__ ? E(aa !== void 0, "Missing field '".concat(ia.join("."), "' while extracting keyFields from ").concat(JSON.stringify(Ui))) : E(aa !== void 0, 2), aa;
    });
    return "".concat(Zi.typename, ":").concat(JSON.stringify(na));
  });
}
function Ni(Bi) {
  var e = qn(Bi);
  return e.keyArgsFn || (e.keyArgsFn = function(Ui, Zi) {
    var ta = Zi.field, na = Zi.variables, ia = Zi.fieldName, aa = Qn(Bi, function(La) {
      var qa = La[0], io = qa.charAt(0);
      if (io === "@") {
        if (ta && Ee(ta.directives)) {
          var ao = qa.slice(1), oo = ta.directives.find(function(bs) {
            return bs.name.value === ao;
          }), no = oo && mr(oo, na);
          return no && ut(no, La.slice(1));
        }
        return;
      }
      if (io === "$") {
        var lo = qa.slice(1);
        if (na && te.call(na, lo)) {
          var so = La.slice(0);
          return so[0] = lo, ut(na, so);
        }
        return;
      }
      if (Ui)
        return ut(Ui, La);
    }), da = JSON.stringify(aa);
    return (Ui || da !== "{}") && (ia += ":" + da), ia;
  });
}
function Qn(Bi, e) {
  var Ui = new He();
  return Ca(Bi).reduce(function(Zi, ta) {
    var na, ia = e(ta);
    if (ia !== void 0) {
      for (var aa = ta.length - 1; aa >= 0; --aa)
        ia = (na = {}, na[ta[aa]] = ia, na);
      Zi = Ui.merge(Zi, ia);
    }
    return Zi;
  }, /* @__PURE__ */ Object.create(null));
}
function Ca(Bi) {
  var e = qn(Bi);
  if (!e.paths) {
    var Ui = e.paths = [], Zi = [];
    Bi.forEach(function(ta, na) {
      ee(ta) ? (Ca(ta).forEach(function(ia) {
        return Ui.push(Zi.concat(ia));
      }), Zi.length = 0) : (Zi.push(ta), ee(Bi[na + 1]) || (Ui.push(Zi.slice(0)), Zi.length = 0));
    });
  }
  return e.paths;
}
function Aa(Bi, e) {
  return Bi[e];
}
function ut(Bi, e, Ui) {
  return Ui = Ui || Aa, Na(e.reduce(function Zi(ta, na) {
    return ee(ta) ? ta.map(function(ia) {
      return Zi(ia, na);
    }) : ta && Ui(ta, na);
  }, Bi));
}
function Na(Bi) {
  return Y(Bi) ? ee(Bi) ? Bi.map(Na) : Qn(Object.keys(Bi).sort(), function(e) {
    return ut(Bi, e);
  }) : Bi;
}
kn.setStringify(We);
function cn(Bi) {
  return Bi.args !== void 0 ? Bi.args : Bi.field ? mr(Bi.field, Bi.variables) : null;
}
var zu = function() {
}, Pi = function(Bi, e) {
  return e.fieldName;
}, Fi = function(Bi, e, Ui) {
  var Zi = Ui.mergeObjects;
  return Zi(Bi, e);
}, Mi = function(Bi, e) {
  return e;
}, $u = function() {
  function Bi(e) {
    this.config = e, this.typePolicies = /* @__PURE__ */ Object.create(null), this.toBeAdded = /* @__PURE__ */ Object.create(null), this.supertypeMap = /* @__PURE__ */ new Map(), this.fuzzySubtypes = /* @__PURE__ */ new Map(), this.rootIdsByTypename = /* @__PURE__ */ Object.create(null), this.rootTypenamesById = /* @__PURE__ */ Object.create(null), this.usingPossibleTypes = !1, this.config = y({ dataIdFromObject: xa }, e), this.cache = this.config.cache, this.setRootTypename("Query"), this.setRootTypename("Mutation"), this.setRootTypename("Subscription"), e.possibleTypes && this.addPossibleTypes(e.possibleTypes), e.typePolicies && this.addTypePolicies(e.typePolicies);
  }
  return Bi.prototype.identify = function(e, Ui) {
    var Zi, ta = this, na = Ui && (Ui.typename || ((Zi = Ui.storeObject) === null || Zi === void 0 ? void 0 : Zi.__typename)) || e.__typename;
    if (na === this.rootTypenamesById.ROOT_QUERY)
      return ["ROOT_QUERY"];
    for (var ia = Ui && Ui.storeObject || e, aa = y(y({}, Ui), { typename: na, storeObject: ia, readField: Ui && Ui.readField || function() {
      var ao = Bn(arguments, ia);
      return ta.readField(ao, {
        store: ta.cache.data,
        variables: ao.variables
      });
    } }), da, La = na && this.getTypePolicy(na), qa = La && La.keyFn || this.config.dataIdFromObject; qa; ) {
      var io = qa(e, aa);
      if (ee(io))
        qa = Ai(io);
      else {
        da = io;
        break;
      }
    }
    return da = da ? String(da) : void 0, aa.keyObject ? [da, aa.keyObject] : [da];
  }, Bi.prototype.addTypePolicies = function(e) {
    var Ui = this;
    Object.keys(e).forEach(function(Zi) {
      var ta = e[Zi], na = ta.queryType, ia = ta.mutationType, aa = ta.subscriptionType, da = lt(ta, ["queryType", "mutationType", "subscriptionType"]);
      na && Ui.setRootTypename("Query", Zi), ia && Ui.setRootTypename("Mutation", Zi), aa && Ui.setRootTypename("Subscription", Zi), te.call(Ui.toBeAdded, Zi) ? Ui.toBeAdded[Zi].push(da) : Ui.toBeAdded[Zi] = [da];
    });
  }, Bi.prototype.updateTypePolicy = function(e, Ui) {
    var Zi = this, ta = this.getTypePolicy(e), na = Ui.keyFields, ia = Ui.fields;
    function aa(da, La) {
      da.merge = typeof La == "function" ? La : La === !0 ? Fi : La === !1 ? Mi : da.merge;
    }
    aa(ta, Ui.merge), ta.keyFn = na === !1 ? zu : ee(na) ? Ai(na) : typeof na == "function" ? na : ta.keyFn, ia && Object.keys(ia).forEach(function(da) {
      var La = Zi.getFieldPolicy(e, da, !0), qa = ia[da];
      if (typeof qa == "function")
        La.read = qa;
      else {
        var io = qa.keyArgs, ao = qa.read, oo = qa.merge;
        La.keyFn = io === !1 ? Pi : ee(io) ? Ni(io) : typeof io == "function" ? io : La.keyFn, typeof ao == "function" && (La.read = ao), aa(La, oo);
      }
      La.read && La.merge && (La.keyFn = La.keyFn || Pi);
    });
  }, Bi.prototype.setRootTypename = function(e, Ui) {
    Ui === void 0 && (Ui = e);
    var Zi = "ROOT_" + e.toUpperCase(), ta = this.rootTypenamesById[Zi];
    Ui !== ta && (__DEV__ ? E(!ta || ta === e, "Cannot change root ".concat(e, " __typename more than once")) : E(!ta || ta === e, 3), ta && delete this.rootIdsByTypename[ta], this.rootIdsByTypename[Ui] = Zi, this.rootTypenamesById[Zi] = Ui);
  }, Bi.prototype.addPossibleTypes = function(e) {
    var Ui = this;
    this.usingPossibleTypes = !0, Object.keys(e).forEach(function(Zi) {
      Ui.getSupertypeSet(Zi, !0), e[Zi].forEach(function(ta) {
        Ui.getSupertypeSet(ta, !0).add(Zi);
        var na = ta.match(Ia);
        (!na || na[0] !== ta) && Ui.fuzzySubtypes.set(ta, new RegExp(ta));
      });
    });
  }, Bi.prototype.getTypePolicy = function(e) {
    var Ui = this;
    if (!te.call(this.typePolicies, e)) {
      var Zi = this.typePolicies[e] = /* @__PURE__ */ Object.create(null);
      Zi.fields = /* @__PURE__ */ Object.create(null);
      var ta = this.supertypeMap.get(e);
      ta && ta.size && ta.forEach(function(ia) {
        var aa = Ui.getTypePolicy(ia), da = aa.fields, La = lt(aa, ["fields"]);
        Object.assign(Zi, La), Object.assign(Zi.fields, da);
      });
    }
    var na = this.toBeAdded[e];
    return na && na.length && na.splice(0).forEach(function(ia) {
      Ui.updateTypePolicy(e, ia);
    }), this.typePolicies[e];
  }, Bi.prototype.getFieldPolicy = function(e, Ui, Zi) {
    if (e) {
      var ta = this.getTypePolicy(e).fields;
      return ta[Ui] || Zi && (ta[Ui] = /* @__PURE__ */ Object.create(null));
    }
  }, Bi.prototype.getSupertypeSet = function(e, Ui) {
    var Zi = this.supertypeMap.get(e);
    return !Zi && Ui && this.supertypeMap.set(e, Zi = /* @__PURE__ */ new Set()), Zi;
  }, Bi.prototype.fragmentMatches = function(e, Ui, Zi, ta) {
    var na = this;
    if (!e.typeCondition)
      return !0;
    if (!Ui)
      return !1;
    var ia = e.typeCondition.name.value;
    if (Ui === ia)
      return !0;
    if (this.usingPossibleTypes && this.supertypeMap.has(ia))
      for (var aa = this.getSupertypeSet(Ui, !0), da = [aa], La = function(no) {
        var lo = na.getSupertypeSet(no, !1);
        lo && lo.size && da.indexOf(lo) < 0 && da.push(lo);
      }, qa = !!(Zi && this.fuzzySubtypes.size), io = !1, ao = 0; ao < da.length; ++ao) {
        var oo = da[ao];
        if (oo.has(ia))
          return aa.has(ia) || (io && __DEV__ && E.warn("Inferring subtype ".concat(Ui, " of supertype ").concat(ia)), aa.add(ia)), !0;
        oo.forEach(La), qa && ao === da.length - 1 && an(e.selectionSet, Zi, ta) && (qa = !1, io = !0, this.fuzzySubtypes.forEach(function(no, lo) {
          var so = Ui.match(no);
          so && so[0] === Ui && La(lo);
        }));
      }
    return !1;
  }, Bi.prototype.hasKeyArgs = function(e, Ui) {
    var Zi = this.getFieldPolicy(e, Ui, !1);
    return !!(Zi && Zi.keyFn);
  }, Bi.prototype.getStoreFieldName = function(e) {
    var Ui = e.typename, Zi = e.fieldName, ta = this.getFieldPolicy(Ui, Zi, !1), na, ia = ta && ta.keyFn;
    if (ia && Ui)
      for (var aa = {
        typename: Ui,
        fieldName: Zi,
        field: e.field || null,
        variables: e.variables
      }, da = cn(e); ia; ) {
        var La = ia(da, aa);
        if (ee(La))
          ia = Ni(La);
        else {
          na = La || Zi;
          break;
        }
      }
    return na === void 0 && (na = e.field ? eo(e.field, e.variables) : kn(Zi, cn(e))), na === !1 ? Zi : Zi === Le(na) ? na : Zi + ":" + na;
  }, Bi.prototype.readField = function(e, Ui) {
    var Zi = e.from;
    if (Zi) {
      var ta = e.field || e.fieldName;
      if (ta) {
        if (e.typename === void 0) {
          var na = Ui.store.getFieldValue(Zi, "__typename");
          na && (e.typename = na);
        }
        var ia = this.getStoreFieldName(e), aa = Le(ia), da = Ui.store.getFieldValue(Zi, ia), La = this.getFieldPolicy(e.typename, aa, !1), qa = La && La.read;
        if (qa) {
          var io = Vi(this, Zi, e, Ui, Ui.store.getStorage(Z(Zi) ? Zi.__ref : Zi, ia));
          return Ln.withValue(this.cache, qa, [da, io]);
        }
        return da;
      }
    }
  }, Bi.prototype.getReadFunction = function(e, Ui) {
    var Zi = this.getFieldPolicy(e, Ui, !1);
    return Zi && Zi.read;
  }, Bi.prototype.getMergeFunction = function(e, Ui, Zi) {
    var ta = this.getFieldPolicy(e, Ui, !1), na = ta && ta.merge;
    return !na && Zi && (ta = this.getTypePolicy(Zi), na = ta && ta.merge), na;
  }, Bi.prototype.runMergeFunction = function(e, Ui, Zi, ta, na) {
    var ia = Zi.field, aa = Zi.typename, da = Zi.merge;
    return da === Fi ? Pa(ta.store)(e, Ui) : da === Mi ? Ui : (ta.overwrite && (e = void 0), da(e, Ui, Vi(this, void 0, { typename: aa, fieldName: ia.name.value, field: ia, variables: ta.variables }, ta, na || /* @__PURE__ */ Object.create(null))));
  }, Bi;
}();
function Vi(Bi, e, Ui, Zi, ta) {
  var na = Bi.getStoreFieldName(Ui), ia = Le(na), aa = Ui.variables || Zi.variables, da = Zi.store, La = da.toReference, qa = da.canRead;
  return {
    args: cn(Ui),
    field: Ui.field || null,
    fieldName: ia,
    storeFieldName: na,
    variables: aa,
    isReference: Z,
    toReference: La,
    storage: ta,
    cache: Bi.cache,
    canRead: qa,
    readField: function() {
      return Bi.readField(Bn(arguments, e, aa), Zi);
    },
    mergeObjects: Pa(Zi.store)
  };
}
function Bn(Bi, e, Ui) {
  var Zi = Bi[0], ta = Bi[1], na = Bi.length, ia;
  return typeof Zi == "string" ? ia = {
    fieldName: Zi,
    from: na > 1 ? ta : e
  } : (ia = y({}, Zi), te.call(ia, "from") || (ia.from = e)), __DEV__ && ia.from === void 0 && __DEV__ && E.warn("Undefined 'from' passed to readField with arguments ".concat(xo(Array.from(Bi)))), ia.variables === void 0 && (ia.variables = Ui), ia;
}
function Pa(Bi) {
  return function(e, Ui) {
    if (ee(e) || ee(Ui))
      throw __DEV__ ? new B("Cannot automatically merge arrays") : new B(4);
    if (Y(e) && Y(Ui)) {
      var Zi = Bi.getFieldValue(e, "__typename"), ta = Bi.getFieldValue(Ui, "__typename"), na = Zi && ta && Zi !== ta;
      if (na)
        return Ui;
      if (Z(e) && it(Ui))
        return Bi.merge(e.__ref, Ui), e;
      if (it(e) && Z(Ui))
        return Bi.merge(e, Ui.__ref), Ui;
      if (it(e) && it(Ui))
        return y(y({}, e), Ui);
    }
    return Ui;
  };
}
function Mr(Bi, e, Ui) {
  var Zi = "".concat(e).concat(Ui), ta = Bi.flavors.get(Zi);
  return ta || Bi.flavors.set(Zi, ta = Bi.clientOnly === e && Bi.deferred === Ui ? Bi : y(y({}, Bi), { clientOnly: e, deferred: Ui })), ta;
}
var Wu = function() {
  function Bi(e, Ui, Zi) {
    this.cache = e, this.reader = Ui, this.fragments = Zi;
  }
  return Bi.prototype.writeToStore = function(e, Ui) {
    var Zi = this, ta = Ui.query, na = Ui.result, ia = Ui.dataId, aa = Ui.variables, da = Ui.overwrite, La = zt(ta), qa = Cu();
    aa = y(y({}, Sn(La)), aa);
    var io = y(y({ store: e, written: /* @__PURE__ */ Object.create(null), merge: function(oo, no) {
      return qa.merge(oo, no);
    }, variables: aa, varString: We(aa) }, Ra(ta, this.fragments)), { overwrite: !!da, incomingById: /* @__PURE__ */ new Map(), clientOnly: !1, deferred: !1, flavors: /* @__PURE__ */ new Map() }), ao = this.processSelectionSet({
      result: na || /* @__PURE__ */ Object.create(null),
      dataId: ia,
      selectionSet: La.selectionSet,
      mergeTree: { map: /* @__PURE__ */ new Map() },
      context: io
    });
    if (!Z(ao))
      throw __DEV__ ? new B("Could not identify object ".concat(JSON.stringify(na))) : new B(7);
    return io.incomingById.forEach(function(oo, no) {
      var lo = oo.storeObject, so = oo.mergeTree, bs = oo.fieldNodeSet, Rs = ot(no);
      if (so && so.map.size) {
        var js = Zi.applyMerges(so, Rs, lo, io);
        if (Z(js))
          return;
        lo = js;
      }
      if (__DEV__ && !io.overwrite) {
        var qs = /* @__PURE__ */ Object.create(null);
        bs.forEach(function(Ao) {
          Ao.selectionSet && (qs[Ao.name.value] = !0);
        });
        var jo = function(Ao) {
          return qs[Le(Ao)] === !0;
        }, fs = function(Ao) {
          var co = so && so.map.get(Ao);
          return !!(co && co.info && co.info.merge);
        };
        Object.keys(lo).forEach(function(Ao) {
          jo(Ao) && !fs(Ao) && Gu(Rs, lo, Ao, io.store);
        });
      }
      e.merge(no, lo);
    }), e.retain(ao.__ref), ao;
  }, Bi.prototype.processSelectionSet = function(e) {
    var Ui = this, Zi = e.dataId, ta = e.result, na = e.selectionSet, ia = e.context, aa = e.mergeTree, da = this.cache.policies, La = /* @__PURE__ */ Object.create(null), qa = Zi && da.rootTypenamesById[Zi] || $r(ta, na, ia.fragmentMap) || Zi && ia.store.get(Zi, "__typename");
    typeof qa == "string" && (La.__typename = qa);
    var io = function() {
      var js = Bn(arguments, La, ia.variables);
      if (Z(js.from)) {
        var qs = ia.incomingById.get(js.from.__ref);
        if (qs) {
          var jo = da.readField(y(y({}, js), { from: qs.storeObject }), ia);
          if (jo !== void 0)
            return jo;
        }
      }
      return da.readField(js, ia);
    }, ao = /* @__PURE__ */ new Set();
    this.flattenFields(na, ta, ia, qa).forEach(function(js, qs) {
      var jo, fs = Je(qs), Ao = ta[fs];
      if (ao.add(qs), Ao !== void 0) {
        var co = da.getStoreFieldName({
          typename: qa,
          fieldName: qs.name.value,
          field: qs,
          variables: js.variables
        }), Co = Li(aa, co), Zs = Ui.processFieldValue(Ao, qs, qs.selectionSet ? Mr(js, !1, !1) : js, Co), xl = void 0;
        qs.selectionSet && (Z(Zs) || it(Zs)) && (xl = io("__typename", Zs));
        var Cl = da.getMergeFunction(qa, qs.name.value, xl);
        Cl ? Co.info = {
          field: qs,
          typename: qa,
          merge: Cl
        } : qi(aa, co), La = js.merge(La, (jo = {}, jo[co] = Zs, jo));
      } else __DEV__ && !js.clientOnly && !js.deferred && !xn.added(qs) && !da.getReadFunction(qa, qs.name.value) && __DEV__ && E.error("Missing field '".concat(Je(qs), "' while writing result ").concat(JSON.stringify(ta, null, 2)).substring(0, 1e3));
    });
    try {
      var oo = da.identify(ta, {
        typename: qa,
        selectionSet: na,
        fragmentMap: ia.fragmentMap,
        storeObject: La,
        readField: io
      }), no = oo[0], lo = oo[1];
      Zi = Zi || no, lo && (La = ia.merge(La, lo));
    } catch (js) {
      if (!Zi)
        throw js;
    }
    if (typeof Zi == "string") {
      var so = ot(Zi), bs = ia.written[Zi] || (ia.written[Zi] = []);
      if (bs.indexOf(na) >= 0 || (bs.push(na), this.reader && this.reader.isFresh(ta, so, na, ia)))
        return so;
      var Rs = ia.incomingById.get(Zi);
      return Rs ? (Rs.storeObject = ia.merge(Rs.storeObject, La), Rs.mergeTree = ln(Rs.mergeTree, aa), ao.forEach(function(js) {
        return Rs.fieldNodeSet.add(js);
      })) : ia.incomingById.set(Zi, {
        storeObject: La,
        mergeTree: or(aa) ? void 0 : aa,
        fieldNodeSet: ao
      }), so;
    }
    return La;
  }, Bi.prototype.processFieldValue = function(e, Ui, Zi, ta) {
    var na = this;
    return !Ui.selectionSet || e === null ? __DEV__ ? Cn(e) : e : ee(e) ? e.map(function(ia, aa) {
      var da = na.processFieldValue(ia, Ui, Zi, Li(ta, aa));
      return qi(ta, aa), da;
    }) : this.processSelectionSet({
      result: e,
      selectionSet: Ui.selectionSet,
      context: Zi,
      mergeTree: ta
    });
  }, Bi.prototype.flattenFields = function(e, Ui, Zi, ta) {
    ta === void 0 && (ta = $r(Ui, e, Zi.fragmentMap));
    var na = /* @__PURE__ */ new Map(), ia = this.cache.policies, aa = new $t(!1);
    return function da(La, qa) {
      var io = aa.lookup(La, qa.clientOnly, qa.deferred);
      io.visited || (io.visited = !0, La.selections.forEach(function(ao) {
        if (vr(ao, Zi.variables)) {
          var oo = qa.clientOnly, no = qa.deferred;
          if (!(oo && no) && Ee(ao.directives) && ao.directives.forEach(function(bs) {
            var Rs = bs.name.value;
            if (Rs === "client" && (oo = !0), Rs === "defer") {
              var js = mr(bs, Zi.variables);
              (!js || js.if !== !1) && (no = !0);
            }
          }), je(ao)) {
            var lo = na.get(ao);
            lo && (oo = oo && lo.clientOnly, no = no && lo.deferred), na.set(ao, Mr(Zi, oo, no));
          } else {
            var so = wn(ao, Zi.lookupFragment);
            if (!so && ao.kind === Hi.FRAGMENT_SPREAD)
              throw __DEV__ ? new B("No fragment named ".concat(ao.name.value)) : new B(8);
            so && ia.fragmentMatches(so, ta, Ui, Zi.variables) && da(so.selectionSet, Mr(Zi, oo, no));
          }
        }
      }));
    }(e, Zi), na;
  }, Bi.prototype.applyMerges = function(e, Ui, Zi, ta, na) {
    var ia, aa = this;
    if (e.map.size && !Z(Zi)) {
      var da = !ee(Zi) && (Z(Ui) || it(Ui)) ? Ui : void 0, La = Zi;
      da && !na && (na = [Z(da) ? da.__ref : da]);
      var qa, io = function(ao, oo) {
        return ee(ao) ? typeof oo == "number" ? ao[oo] : void 0 : ta.store.getFieldValue(ao, String(oo));
      };
      e.map.forEach(function(ao, oo) {
        var no = io(da, oo), lo = io(La, oo);
        if (lo !== void 0) {
          na && na.push(oo);
          var so = aa.applyMerges(ao, no, lo, ta, na);
          so !== lo && (qa = qa || /* @__PURE__ */ new Map(), qa.set(oo, so)), na && E(na.pop() === oo);
        }
      }), qa && (Zi = ee(La) ? La.slice(0) : y({}, La), qa.forEach(function(ao, oo) {
        Zi[oo] = ao;
      }));
    }
    return e.info ? this.cache.policies.runMergeFunction(Ui, Zi, e.info, ta, na && (ia = ta.store).getStorage.apply(ia, na)) : Zi;
  }, Bi;
}(), Fa = [];
function Li(Bi, e) {
  var Ui = Bi.map;
  return Ui.has(e) || Ui.set(e, Fa.pop() || { map: /* @__PURE__ */ new Map() }), Ui.get(e);
}
function ln(Bi, e) {
  if (Bi === e || !e || or(e))
    return Bi;
  if (!Bi || or(Bi))
    return e;
  var Ui = Bi.info && e.info ? y(y({}, Bi.info), e.info) : Bi.info || e.info, Zi = Bi.map.size && e.map.size, ta = Zi ? /* @__PURE__ */ new Map() : Bi.map.size ? Bi.map : e.map, na = { info: Ui, map: ta };
  if (Zi) {
    var ia = new Set(e.map.keys());
    Bi.map.forEach(function(aa, da) {
      na.map.set(da, ln(aa, e.map.get(da))), ia.delete(da);
    }), ia.forEach(function(aa) {
      na.map.set(aa, ln(e.map.get(aa), Bi.map.get(aa)));
    });
  }
  return na;
}
function or(Bi) {
  return !Bi || !(Bi.info || Bi.map.size);
}
function qi(Bi, e) {
  var Ui = Bi.map, Zi = Ui.get(e);
  Zi && or(Zi) && (Fa.push(Zi), Ui.delete(e));
}
var Qi = /* @__PURE__ */ new Set();
function Gu(Bi, e, Ui, Zi) {
  var ta = function(io) {
    var ao = Zi.getFieldValue(io, Ui);
    return typeof ao == "object" && ao;
  }, na = ta(Bi);
  if (na) {
    var ia = ta(e);
    if (ia && !Z(na) && !re(na, ia) && !Object.keys(na).every(function(io) {
      return Zi.getFieldValue(ia, io) !== void 0;
    })) {
      var aa = Zi.getFieldValue(Bi, "__typename") || Zi.getFieldValue(e, "__typename"), da = Le(Ui), La = "".concat(aa, ".").concat(da);
      if (!Qi.has(La)) {
        Qi.add(La);
        var qa = [];
        !ee(na) && !ee(ia) && [na, ia].forEach(function(io) {
          var ao = Zi.getFieldValue(io, "__typename");
          typeof ao == "string" && !qa.includes(ao) && qa.push(ao);
        }), __DEV__ && E.warn("Cache data may be lost when replacing the ".concat(da, " field of a ").concat(aa, ` object.

To address this problem (which is not a bug in Apollo Client), `).concat(qa.length ? "either ensure all objects of type " + qa.join(" and ") + " have an ID or a custom merge function, or " : "", "define a custom merge function for the ").concat(La, ` field, so InMemoryCache can safely merge these objects:

  existing: `).concat(JSON.stringify(na).slice(0, 1e3), `
  incoming: `).concat(JSON.stringify(ia).slice(0, 1e3), `

For more information about these options, please refer to the documentation:

  * Ensuring entity objects have IDs: https://go.apollo.dev/c/generating-unique-identifiers
  * Defining custom merge functions: https://go.apollo.dev/c/merging-non-normalized-objects
`));
      }
    }
  }
}
(function(Bi) {
  be(e, Bi);
  function e(Ui) {
    Ui === void 0 && (Ui = {});
    var Zi = Bi.call(this) || this;
    return Zi.watches = /* @__PURE__ */ new Set(), Zi.typenameDocumentCache = /* @__PURE__ */ new Map(), Zi.makeVar = Uu, Zi.txCount = 0, Zi.config = Ru(Ui), Zi.addTypename = !!Zi.config.addTypename, Zi.policies = new $u({
      cache: Zi,
      dataIdFromObject: Zi.config.dataIdFromObject,
      possibleTypes: Zi.config.possibleTypes,
      typePolicies: Zi.config.typePolicies
    }), Zi.init(), Zi;
  }
  return e.prototype.init = function() {
    var Ui = this.data = new Rt.Root({
      policies: this.policies,
      resultCaching: this.config.resultCaching
    });
    this.optimisticData = Ui.stump, this.resetResultCache();
  }, e.prototype.resetResultCache = function(Ui) {
    var Zi = this, ta = this.storeReader, na = this.config.fragments;
    this.storeWriter = new Wu(this, this.storeReader = new Fu({
      cache: this,
      addTypename: this.addTypename,
      resultCacheMaxSize: this.config.resultCacheMaxSize,
      canonizeResults: Da(this.config),
      canon: Ui ? void 0 : ta && ta.canon,
      fragments: na
    }), na), this.maybeBroadcastWatch = sr(function(ia, aa) {
      return Zi.broadcastWatch(ia, aa);
    }, {
      max: this.config.resultCacheMaxSize,
      makeCacheKey: function(ia) {
        var aa = ia.optimistic ? Zi.optimisticData : Zi.data;
        if (Tt(aa)) {
          var da = ia.optimistic, La = ia.id, qa = ia.variables;
          return aa.makeCacheKey(ia.query, ia.callback, We({ optimistic: da, id: La, variables: qa }));
        }
      }
    }), (/* @__PURE__ */ new Set([
      this.data.group,
      this.optimisticData.group
    ])).forEach(function(ia) {
      return ia.resetCaching();
    });
  }, e.prototype.restore = function(Ui) {
    return this.init(), Ui && this.data.replace(Ui), this;
  }, e.prototype.extract = function(Ui) {
    return Ui === void 0 && (Ui = !1), (Ui ? this.optimisticData : this.data).extract();
  }, e.prototype.read = function(Ui) {
    var Zi = Ui.returnPartialData, ta = Zi === void 0 ? !1 : Zi;
    try {
      return this.storeReader.diffQueryAgainstStore(y(y({}, Ui), { store: Ui.optimistic ? this.optimisticData : this.data, config: this.config, returnPartialData: ta })).result || null;
    } catch (na) {
      if (na instanceof Oa)
        return null;
      throw na;
    }
  }, e.prototype.write = function(Ui) {
    try {
      return ++this.txCount, this.storeWriter.writeToStore(this.data, Ui);
    } finally {
      !--this.txCount && Ui.broadcast !== !1 && this.broadcastWatches();
    }
  }, e.prototype.modify = function(Ui) {
    if (te.call(Ui, "id") && !Ui.id)
      return !1;
    var Zi = Ui.optimistic ? this.optimisticData : this.data;
    try {
      return ++this.txCount, Zi.modify(Ui.id || "ROOT_QUERY", Ui.fields);
    } finally {
      !--this.txCount && Ui.broadcast !== !1 && this.broadcastWatches();
    }
  }, e.prototype.diff = function(Ui) {
    return this.storeReader.diffQueryAgainstStore(y(y({}, Ui), { store: Ui.optimistic ? this.optimisticData : this.data, rootId: Ui.id || "ROOT_QUERY", config: this.config }));
  }, e.prototype.watch = function(Ui) {
    var Zi = this;
    return this.watches.size || Bu(this), this.watches.add(Ui), Ui.immediate && this.maybeBroadcastWatch(Ui), function() {
      Zi.watches.delete(Ui) && !Zi.watches.size && ji(Zi), Zi.maybeBroadcastWatch.forget(Ui);
    };
  }, e.prototype.gc = function(Ui) {
    We.reset();
    var Zi = this.optimisticData.gc();
    return Ui && !this.txCount && (Ui.resetResultCache ? this.resetResultCache(Ui.resetResultIdentities) : Ui.resetResultIdentities && this.storeReader.resetCanon()), Zi;
  }, e.prototype.retain = function(Ui, Zi) {
    return (Zi ? this.optimisticData : this.data).retain(Ui);
  }, e.prototype.release = function(Ui, Zi) {
    return (Zi ? this.optimisticData : this.data).release(Ui);
  }, e.prototype.identify = function(Ui) {
    if (Z(Ui))
      return Ui.__ref;
    try {
      return this.policies.identify(Ui)[0];
    } catch (Zi) {
      __DEV__ && E.warn(Zi);
    }
  }, e.prototype.evict = function(Ui) {
    if (!Ui.id) {
      if (te.call(Ui, "id"))
        return !1;
      Ui = y(y({}, Ui), { id: "ROOT_QUERY" });
    }
    try {
      return ++this.txCount, this.optimisticData.evict(Ui, this.data);
    } finally {
      !--this.txCount && Ui.broadcast !== !1 && this.broadcastWatches();
    }
  }, e.prototype.reset = function(Ui) {
    var Zi = this;
    return this.init(), We.reset(), Ui && Ui.discardWatches ? (this.watches.forEach(function(ta) {
      return Zi.maybeBroadcastWatch.forget(ta);
    }), this.watches.clear(), ji(this)) : this.broadcastWatches(), Promise.resolve();
  }, e.prototype.removeOptimistic = function(Ui) {
    var Zi = this.optimisticData.removeLayer(Ui);
    Zi !== this.optimisticData && (this.optimisticData = Zi, this.broadcastWatches());
  }, e.prototype.batch = function(Ui) {
    var Zi = this, ta = Ui.update, na = Ui.optimistic, ia = na === void 0 ? !0 : na, aa = Ui.removeOptimistic, da = Ui.onWatchUpdated, La, qa = function(ao) {
      var oo = Zi, no = oo.data, lo = oo.optimisticData;
      ++Zi.txCount, ao && (Zi.data = Zi.optimisticData = ao);
      try {
        return La = ta(Zi);
      } finally {
        --Zi.txCount, Zi.data = no, Zi.optimisticData = lo;
      }
    }, io = /* @__PURE__ */ new Set();
    return da && !this.txCount && this.broadcastWatches(y(y({}, Ui), { onWatchUpdated: function(ao) {
      return io.add(ao), !1;
    } })), typeof ia == "string" ? this.optimisticData = this.optimisticData.addLayer(ia, qa) : ia === !1 ? qa(this.data) : qa(), typeof aa == "string" && (this.optimisticData = this.optimisticData.removeLayer(aa)), da && io.size ? (this.broadcastWatches(y(y({}, Ui), { onWatchUpdated: function(ao, oo) {
      var no = da.call(this, ao, oo);
      return no !== !1 && io.delete(ao), no;
    } })), io.size && io.forEach(function(ao) {
      return Zi.maybeBroadcastWatch.dirty(ao);
    })) : this.broadcastWatches(Ui), La;
  }, e.prototype.performTransaction = function(Ui, Zi) {
    return this.batch({
      update: Ui,
      optimistic: Zi || Zi !== null
    });
  }, e.prototype.transformDocument = function(Ui) {
    if (this.addTypename) {
      var Zi = this.typenameDocumentCache.get(Ui);
      return Zi || (Zi = xn(Ui), this.typenameDocumentCache.set(Ui, Zi), this.typenameDocumentCache.set(Zi, Zi)), Zi;
    }
    return Ui;
  }, e.prototype.transformForLink = function(Ui) {
    var Zi = this.config.fragments;
    return Zi ? Zi.transform(Ui) : Ui;
  }, e.prototype.broadcastWatches = function(Ui) {
    var Zi = this;
    this.txCount || this.watches.forEach(function(ta) {
      return Zi.maybeBroadcastWatch(ta, Ui);
    });
  }, e.prototype.broadcastWatch = function(Ui, Zi) {
    var ta = Ui.lastDiff, na = this.diff(Ui);
    Zi && (Ui.optimistic && typeof Zi.optimistic == "string" && (na.fromOptimisticTransaction = !0), Zi.onWatchUpdated && Zi.onWatchUpdated.call(this, Ui, na, ta) === !1) || (!ta || !re(ta.result, na.result)) && Ui.callback(Ui.lastDiff = na, ta);
  }, e;
})(Iu);
var Yu = function(Bi) {
  var e = "";
  if (Ee(Bi.graphQLErrors) || Ee(Bi.clientErrors)) {
    var Ui = (Bi.graphQLErrors || []).concat(Bi.clientErrors || []);
    Ui.forEach(function(Zi) {
      var ta = Zi ? Zi.message : "Error message not found.";
      e += "".concat(ta, `
`);
    });
  }
  return Bi.networkError && (e += "".concat(Bi.networkError.message, `
`)), e = e.replace(/\n$/, ""), e;
}, ze = function(Bi) {
  be(e, Bi);
  function e(Ui) {
    var Zi = Ui.graphQLErrors, ta = Ui.clientErrors, na = Ui.networkError, ia = Ui.errorMessage, aa = Ui.extraInfo, da = Bi.call(this, ia) || this;
    return da.graphQLErrors = Zi || [], da.clientErrors = ta || [], da.networkError = na || null, da.message = ia || Yu(da), da.extraInfo = aa, da.__proto__ = e.prototype, da;
  }
  return e;
}(Error), W;
(function(Bi) {
  Bi[Bi.loading = 1] = "loading", Bi[Bi.setVariables = 2] = "setVariables", Bi[Bi.fetchMore = 3] = "fetchMore", Bi[Bi.refetch = 4] = "refetch", Bi[Bi.poll = 6] = "poll", Bi[Bi.ready = 7] = "ready", Bi[Bi.error = 8] = "error";
})(W || (W = {}));
function jt(Bi) {
  return Bi ? Bi < 7 : !1;
}
var Ku = Object.assign, Xu = Object.hasOwnProperty, fn = function(Bi) {
  be(e, Bi);
  function e(Ui) {
    var Zi = Ui.queryManager, ta = Ui.queryInfo, na = Ui.options, ia = Bi.call(this, function(so) {
      try {
        var bs = so._subscription._observer;
        bs && !bs.error && (bs.error = ec);
      } catch {
      }
      var Rs = !ia.observers.size;
      ia.observers.add(so);
      var js = ia.last;
      return js && js.error ? so.error && so.error(js.error) : js && js.result && so.next && so.next(js.result), Rs && ia.reobserve().catch(function() {
      }), function() {
        ia.observers.delete(so) && !ia.observers.size && ia.tearDownQuery();
      };
    }) || this;
    ia.observers = /* @__PURE__ */ new Set(), ia.subscriptions = /* @__PURE__ */ new Set(), ia.queryInfo = ta, ia.queryManager = Zi, ia.isTornDown = !1;
    var aa = Zi.defaultOptions.watchQuery, da = aa === void 0 ? {} : aa, La = da.fetchPolicy, qa = La === void 0 ? "cache-first" : La, io = na.fetchPolicy, ao = io === void 0 ? qa : io, oo = na.initialFetchPolicy, no = oo === void 0 ? ao === "standby" ? qa : ao : oo;
    ia.options = y(y({}, na), { initialFetchPolicy: no, fetchPolicy: ao }), ia.queryId = ta.queryId || Zi.generateQueryId();
    var lo = zt(ia.query);
    return ia.queryName = lo && lo.name && lo.name.value, ia;
  }
  return Object.defineProperty(e.prototype, "query", {
    get: function() {
      return this.queryManager.transform(this.options.query).document;
    },
    enumerable: !1,
    configurable: !0
  }), Object.defineProperty(e.prototype, "variables", {
    get: function() {
      return this.options.variables;
    },
    enumerable: !1,
    configurable: !0
  }), e.prototype.result = function() {
    var Ui = this;
    return new Promise(function(Zi, ta) {
      var na = {
        next: function(aa) {
          Zi(aa), Ui.observers.delete(na), Ui.observers.size || Ui.queryManager.removeQuery(Ui.queryId), setTimeout(function() {
            ia.unsubscribe();
          }, 0);
        },
        error: ta
      }, ia = Ui.subscribe(na);
    });
  }, e.prototype.getCurrentResult = function(Ui) {
    Ui === void 0 && (Ui = !0);
    var Zi = this.getLastResult(!0), ta = this.queryInfo.networkStatus || Zi && Zi.networkStatus || W.ready, na = y(y({}, Zi), { loading: jt(ta), networkStatus: ta }), ia = this.options.fetchPolicy, aa = ia === void 0 ? "cache-first" : ia;
    if (!(aa === "network-only" || aa === "no-cache" || aa === "standby" || this.queryManager.transform(this.options.query).hasForcedResolvers)) {
      var da = this.queryInfo.getDiff();
      (da.complete || this.options.returnPartialData) && (na.data = da.result), re(na.data, {}) && (na.data = void 0), da.complete ? (delete na.partial, da.complete && na.networkStatus === W.loading && (aa === "cache-first" || aa === "cache-only") && (na.networkStatus = W.ready, na.loading = !1)) : na.partial = !0, __DEV__ && !da.complete && !this.options.partialRefetch && !na.loading && !na.data && !na.error && Va(da.missing);
    }
    return Ui && this.updateLastResult(na), na;
  }, e.prototype.isDifferentFromLastResult = function(Ui) {
    return !this.last || !re(this.last.result, Ui);
  }, e.prototype.getLast = function(Ui, Zi) {
    var ta = this.last;
    if (ta && ta[Ui] && (!Zi || re(ta.variables, this.variables)))
      return ta[Ui];
  }, e.prototype.getLastResult = function(Ui) {
    return this.getLast("result", Ui);
  }, e.prototype.getLastError = function(Ui) {
    return this.getLast("error", Ui);
  }, e.prototype.resetLastResults = function() {
    delete this.last, this.isTornDown = !1;
  }, e.prototype.resetQueryStoreErrors = function() {
    this.queryManager.resetErrors(this.queryId);
  }, e.prototype.refetch = function(Ui) {
    var Zi, ta = {
      pollInterval: 0
    }, na = this.options.fetchPolicy;
    if (na === "cache-and-network" ? ta.fetchPolicy = na : na === "no-cache" ? ta.fetchPolicy = "no-cache" : ta.fetchPolicy = "network-only", __DEV__ && Ui && Xu.call(Ui, "variables")) {
      var ia = ra(this.query), aa = ia.variableDefinitions;
      (!aa || !aa.some(function(da) {
        return da.variable.name.value === "variables";
      })) && __DEV__ && E.warn("Called refetch(".concat(JSON.stringify(Ui), ") for query ").concat(((Zi = ia.name) === null || Zi === void 0 ? void 0 : Zi.value) || JSON.stringify(ia), `, which does not declare a $variables variable.
Did you mean to call refetch(variables) instead of refetch({ variables })?`));
    }
    return Ui && !re(this.options.variables, Ui) && (ta.variables = this.options.variables = y(y({}, this.options.variables), Ui)), this.queryInfo.resetLastWrite(), this.reobserve(ta, W.refetch);
  }, e.prototype.fetchMore = function(Ui) {
    var Zi = this, ta = y(y({}, Ui.query ? Ui : y(y(y(y({}, this.options), { query: this.query }), Ui), { variables: y(y({}, this.options.variables), Ui.variables) })), { fetchPolicy: "no-cache" }), na = this.queryManager.generateQueryId(), ia = this.queryInfo, aa = ia.networkStatus;
    ia.networkStatus = W.fetchMore, ta.notifyOnNetworkStatusChange && this.observe();
    var da = /* @__PURE__ */ new Set();
    return this.queryManager.fetchQuery(na, ta, W.fetchMore).then(function(La) {
      return Zi.queryManager.removeQuery(na), ia.networkStatus === W.fetchMore && (ia.networkStatus = aa), Zi.queryManager.cache.batch({
        update: function(qa) {
          var io = Ui.updateQuery;
          io ? qa.updateQuery({
            query: Zi.query,
            variables: Zi.variables,
            returnPartialData: !0,
            optimistic: !1
          }, function(ao) {
            return io(ao, {
              fetchMoreResult: La.data,
              variables: ta.variables
            });
          }) : qa.writeQuery({
            query: ta.query,
            variables: ta.variables,
            data: La.data
          });
        },
        onWatchUpdated: function(qa) {
          da.add(qa.query);
        }
      }), La;
    }).finally(function() {
      da.has(Zi.query) || Ma(Zi);
    });
  }, e.prototype.subscribeToMore = function(Ui) {
    var Zi = this, ta = this.queryManager.startGraphQLSubscription({
      query: Ui.document,
      variables: Ui.variables,
      context: Ui.context
    }).subscribe({
      next: function(na) {
        var ia = Ui.updateQuery;
        ia && Zi.updateQuery(function(aa, da) {
          var La = da.variables;
          return ia(aa, {
            subscriptionData: na,
            variables: La
          });
        });
      },
      error: function(na) {
        if (Ui.onError) {
          Ui.onError(na);
          return;
        }
        __DEV__ && E.error("Unhandled GraphQL subscription error", na);
      }
    });
    return this.subscriptions.add(ta), function() {
      Zi.subscriptions.delete(ta) && ta.unsubscribe();
    };
  }, e.prototype.setOptions = function(Ui) {
    return this.reobserve(Ui);
  }, e.prototype.setVariables = function(Ui) {
    return re(this.variables, Ui) ? this.observers.size ? this.result() : Promise.resolve() : (this.options.variables = Ui, this.observers.size ? this.reobserve({
      fetchPolicy: this.options.initialFetchPolicy,
      variables: Ui
    }, W.setVariables) : Promise.resolve());
  }, e.prototype.updateQuery = function(Ui) {
    var Zi = this.queryManager, ta = Zi.cache.diff({
      query: this.options.query,
      variables: this.variables,
      returnPartialData: !0,
      optimistic: !1
    }).result, na = Ui(ta, {
      variables: this.variables
    });
    na && (Zi.cache.writeQuery({
      query: this.options.query,
      data: na,
      variables: this.variables
    }), Zi.broadcastQueries());
  }, e.prototype.startPolling = function(Ui) {
    this.options.pollInterval = Ui, this.updatePolling();
  }, e.prototype.stopPolling = function() {
    this.options.pollInterval = 0, this.updatePolling();
  }, e.prototype.applyNextFetchPolicy = function(Ui, Zi) {
    if (Zi.nextFetchPolicy) {
      var ta = Zi.fetchPolicy, na = ta === void 0 ? "cache-first" : ta, ia = Zi.initialFetchPolicy, aa = ia === void 0 ? na : ia;
      na === "standby" || (typeof Zi.nextFetchPolicy == "function" ? Zi.fetchPolicy = Zi.nextFetchPolicy(na, {
        reason: Ui,
        options: Zi,
        observable: this,
        initialFetchPolicy: aa
      }) : Ui === "variables-changed" ? Zi.fetchPolicy = aa : Zi.fetchPolicy = Zi.nextFetchPolicy);
    }
    return Zi.fetchPolicy;
  }, e.prototype.fetch = function(Ui, Zi) {
    return this.queryManager.setObservableQuery(this), this.queryManager.fetchQueryObservable(this.queryId, Ui, Zi);
  }, e.prototype.updatePolling = function() {
    var Ui = this;
    if (!this.queryManager.ssrMode) {
      var Zi = this, ta = Zi.pollingInfo, na = Zi.options.pollInterval;
      if (!na) {
        ta && (clearTimeout(ta.timeout), delete this.pollingInfo);
        return;
      }
      if (!(ta && ta.interval === na)) {
        __DEV__ ? E(na, "Attempted to start a polling query without a polling interval.") : E(na, 12);
        var ia = ta || (this.pollingInfo = {});
        ia.interval = na;
        var aa = function() {
          Ui.pollingInfo && (jt(Ui.queryInfo.networkStatus) ? da() : Ui.reobserve({
            fetchPolicy: Ui.options.initialFetchPolicy === "no-cache" ? "no-cache" : "network-only"
          }, W.poll).then(da, da));
        }, da = function() {
          var La = Ui.pollingInfo;
          La && (clearTimeout(La.timeout), La.timeout = setTimeout(aa, La.interval));
        };
        da();
      }
    }
  }, e.prototype.updateLastResult = function(Ui, Zi) {
    return Zi === void 0 && (Zi = this.variables), this.last = y(y({}, this.last), { result: this.queryManager.assumeImmutableResults ? Ui : Cn(Ui), variables: Zi }), Ee(Ui.errors) || delete this.last.error, this.last;
  }, e.prototype.reobserve = function(Ui, Zi) {
    var ta = this;
    this.isTornDown = !1;
    var na = Zi === W.refetch || Zi === W.fetchMore || Zi === W.poll, ia = this.options.variables, aa = this.options.fetchPolicy, da = wr(this.options, Ui || {}), La = na ? da : Ku(this.options, da);
    na || (this.updatePolling(), Ui && Ui.variables && !re(Ui.variables, ia) && La.fetchPolicy !== "standby" && La.fetchPolicy === aa && (this.applyNextFetchPolicy("variables-changed", La), Zi === void 0 && (Zi = W.setVariables)));
    var qa = La.variables && y({}, La.variables), io = this.fetch(La, Zi), ao = {
      next: function(oo) {
        ta.reportResult(oo, qa);
      },
      error: function(oo) {
        ta.reportError(oo, qa);
      }
    };
    return na || (this.concast && this.observer && this.concast.removeObserver(this.observer), this.concast = io, this.observer = ao), io.addObserver(ao), io.promise;
  }, e.prototype.observe = function() {
    this.reportResult(this.getCurrentResult(!1), this.variables);
  }, e.prototype.reportResult = function(Ui, Zi) {
    var ta = this.getLastError();
    (ta || this.isDifferentFromLastResult(Ui)) && ((ta || !Ui.partial || this.options.returnPartialData) && this.updateLastResult(Ui, Zi), xt(this.observers, "next", Ui));
  }, e.prototype.reportError = function(Ui, Zi) {
    var ta = y(y({}, this.getLastResult()), { error: Ui, errors: Ui.graphQLErrors, networkStatus: W.error, loading: !1 });
    this.updateLastResult(ta, Zi), xt(this.observers, "error", this.last.error = Ui);
  }, e.prototype.hasObservers = function() {
    return this.observers.size > 0;
  }, e.prototype.tearDownQuery = function() {
    this.isTornDown || (this.concast && this.observer && (this.concast.removeObserver(this.observer), delete this.concast, delete this.observer), this.stopPolling(), this.subscriptions.forEach(function(Ui) {
      return Ui.unsubscribe();
    }), this.subscriptions.clear(), this.queryManager.stopQuery(this.queryId), this.observers.clear(), this.isTornDown = !0);
  }, e;
}(G);
la(fn);
function Ma(Bi) {
  var e = Bi.options, Ui = e.fetchPolicy, Zi = e.nextFetchPolicy;
  return Ui === "cache-and-network" || Ui === "network-only" ? Bi.reobserve({
    fetchPolicy: "cache-first",
    nextFetchPolicy: function() {
      return this.nextFetchPolicy = Zi, typeof Zi == "function" ? Zi.apply(this, arguments) : Ui;
    }
  }) : Bi.reobserve();
}
function ec(Bi) {
  __DEV__ && E.error("Unhandled error", Bi.message, Bi.stack);
}
function Va(Bi) {
  __DEV__ && Bi && __DEV__ && E.debug("Missing cache result fields: ".concat(JSON.stringify(Bi)), Bi);
}
function ic(Bi) {
  return Y(Bi) && "code" in Bi && "reason" in Bi;
}
(function(Bi) {
  be(e, Bi);
  function e(Ui) {
    var Zi = Bi.call(this) || this;
    return Zi.client = Ui, Zi;
  }
  return e.prototype.request = function(Ui) {
    var Zi = this;
    return new G(function(ta) {
      return Zi.client.subscribe(y(y({}, Ui), { query: ea(Ui.query) }), {
        next: ta.next.bind(ta),
        complete: ta.complete.bind(ta),
        error: function(na) {
          return na instanceof Error ? ta.error(na) : ic(na) ? ta.error(new Error("Socket closed with event ".concat(na.code, " ").concat(na.reason || ""))) : ta.error(new ze({
            graphQLErrors: Array.isArray(na) ? na : [na]
          }));
        }
      });
    });
  }, e;
})(Ze);
var fe;
(function(Bi) {
  Bi[Bi.InternalServerError = 4500] = "InternalServerError", Bi[Bi.InternalClientError = 4005] = "InternalClientError", Bi[Bi.BadRequest = 4400] = "BadRequest", Bi[Bi.BadResponse = 4004] = "BadResponse", Bi[Bi.Unauthorized = 4401] = "Unauthorized", Bi[Bi.Forbidden = 4403] = "Forbidden", Bi[Bi.SubprotocolNotAcceptable = 4406] = "SubprotocolNotAcceptable", Bi[Bi.ConnectionInitialisationTimeout = 4408] = "ConnectionInitialisationTimeout", Bi[Bi.ConnectionAcknowledgementTimeout = 4504] = "ConnectionAcknowledgementTimeout", Bi[Bi.SubscriberAlreadyExists = 4409] = "SubscriberAlreadyExists", Bi[Bi.TooManyInitialisationRequests = 4429] = "TooManyInitialisationRequests";
})(fe || (fe = {}));
var X;
(function(Bi) {
  Bi.ConnectionInit = "connection_init", Bi.ConnectionAck = "connection_ack", Bi.Ping = "ping", Bi.Pong = "pong", Bi.Subscribe = "subscribe", Bi.Next = "next", Bi.Error = "error", Bi.Complete = "complete";
})(X || (X = {}));
var Q;
(function(Bi) {
  Bi.assertEqual = (ta) => ta;
  function e(ta) {
  }
  Bi.assertIs = e;
  function Ui(ta) {
    throw new Error();
  }
  Bi.assertNever = Ui, Bi.arrayToEnum = (ta) => {
    const na = {};
    for (const ia of ta)
      na[ia] = ia;
    return na;
  }, Bi.getValidEnumValues = (ta) => {
    const na = Bi.objectKeys(ta).filter((aa) => typeof ta[ta[aa]] != "number"), ia = {};
    for (const aa of na)
      ia[aa] = ta[aa];
    return Bi.objectValues(ia);
  }, Bi.objectValues = (ta) => Bi.objectKeys(ta).map(function(na) {
    return ta[na];
  }), Bi.objectKeys = typeof Object.keys == "function" ? (ta) => Object.keys(ta) : (ta) => {
    const na = [];
    for (const ia in ta)
      Object.prototype.hasOwnProperty.call(ta, ia) && na.push(ia);
    return na;
  }, Bi.find = (ta, na) => {
    for (const ia of ta)
      if (na(ia))
        return ia;
  }, Bi.isInteger = typeof Number.isInteger == "function" ? (ta) => Number.isInteger(ta) : (ta) => typeof ta == "number" && isFinite(ta) && Math.floor(ta) === ta;
  function Zi(ta, na = " | ") {
    return ta.map((ia) => typeof ia == "string" ? `'${ia}'` : ia).join(na);
  }
  Bi.joinValues = Zi, Bi.jsonStringifyReplacer = (ta, na) => typeof na == "bigint" ? na.toString() : na;
})(Q || (Q = {}));
var hn;
(function(Bi) {
  Bi.mergeShapes = (e, Ui) => ({
    ...e,
    ...Ui
    // second overwrites first
  });
})(hn || (hn = {}));
const O = Q.arrayToEnum([
  "string",
  "nan",
  "number",
  "integer",
  "float",
  "boolean",
  "date",
  "bigint",
  "symbol",
  "function",
  "undefined",
  "null",
  "array",
  "object",
  "unknown",
  "promise",
  "void",
  "never",
  "map",
  "set"
]), Re = (Bi) => {
  switch (typeof Bi) {
    case "undefined":
      return O.undefined;
    case "string":
      return O.string;
    case "number":
      return isNaN(Bi) ? O.nan : O.number;
    case "boolean":
      return O.boolean;
    case "function":
      return O.function;
    case "bigint":
      return O.bigint;
    case "symbol":
      return O.symbol;
    case "object":
      return Array.isArray(Bi) ? O.array : Bi === null ? O.null : Bi.then && typeof Bi.then == "function" && Bi.catch && typeof Bi.catch == "function" ? O.promise : typeof Map < "u" && Bi instanceof Map ? O.map : typeof Set < "u" && Bi instanceof Set ? O.set : typeof Date < "u" && Bi instanceof Date ? O.date : O.object;
    default:
      return O.unknown;
  }
}, g = Q.arrayToEnum([
  "invalid_type",
  "invalid_literal",
  "custom",
  "invalid_union",
  "invalid_union_discriminator",
  "invalid_enum_value",
  "unrecognized_keys",
  "invalid_arguments",
  "invalid_return_type",
  "invalid_date",
  "invalid_string",
  "too_small",
  "too_big",
  "invalid_intersection_types",
  "not_multiple_of",
  "not_finite"
]), hc = (Bi) => JSON.stringify(Bi, null, 2).replace(/"([^"]+)":/g, "$1:");
class de extends Error {
  get errors() {
    return this.issues;
  }
  constructor(e) {
    super(), this.issues = [], this.addIssue = (Zi) => {
      this.issues = [...this.issues, Zi];
    }, this.addIssues = (Zi = []) => {
      this.issues = [...this.issues, ...Zi];
    };
    const Ui = new.target.prototype;
    Object.setPrototypeOf ? Object.setPrototypeOf(this, Ui) : this.__proto__ = Ui, this.name = "ZodError", this.issues = e;
  }
  format(e) {
    const Ui = e || function(na) {
      return na.message;
    }, Zi = { _errors: [] }, ta = (na) => {
      for (const ia of na.issues)
        if (ia.code === "invalid_union")
          ia.unionErrors.map(ta);
        else if (ia.code === "invalid_return_type")
          ta(ia.returnTypeError);
        else if (ia.code === "invalid_arguments")
          ta(ia.argumentsError);
        else if (ia.path.length === 0)
          Zi._errors.push(Ui(ia));
        else {
          let aa = Zi, da = 0;
          for (; da < ia.path.length; ) {
            const La = ia.path[da];
            da === ia.path.length - 1 ? (aa[La] = aa[La] || { _errors: [] }, aa[La]._errors.push(Ui(ia))) : aa[La] = aa[La] || { _errors: [] }, aa = aa[La], da++;
          }
        }
    };
    return ta(this), Zi;
  }
  static assert(e) {
    if (!(e instanceof de))
      throw new Error(`Not a ZodError: ${e}`);
  }
  toString() {
    return this.message;
  }
  get message() {
    return JSON.stringify(this.issues, Q.jsonStringifyReplacer, 2);
  }
  get isEmpty() {
    return this.issues.length === 0;
  }
  flatten(e = (Ui) => Ui.message) {
    const Ui = {}, Zi = [];
    for (const ta of this.issues)
      ta.path.length > 0 ? (Ui[ta.path[0]] = Ui[ta.path[0]] || [], Ui[ta.path[0]].push(e(ta))) : Zi.push(e(ta));
    return { formErrors: Zi, fieldErrors: Ui };
  }
  get formErrors() {
    return this.flatten();
  }
}
de.create = (Bi) => new de(Bi);
const pt = (Bi, e) => {
  let Ui;
  switch (Bi.code) {
    case g.invalid_type:
      Bi.received === O.undefined ? Ui = "Required" : Ui = `Expected ${Bi.expected}, received ${Bi.received}`;
      break;
    case g.invalid_literal:
      Ui = `Invalid literal value, expected ${JSON.stringify(Bi.expected, Q.jsonStringifyReplacer)}`;
      break;
    case g.unrecognized_keys:
      Ui = `Unrecognized key(s) in object: ${Q.joinValues(Bi.keys, ", ")}`;
      break;
    case g.invalid_union:
      Ui = "Invalid input";
      break;
    case g.invalid_union_discriminator:
      Ui = `Invalid discriminator value. Expected ${Q.joinValues(Bi.options)}`;
      break;
    case g.invalid_enum_value:
      Ui = `Invalid enum value. Expected ${Q.joinValues(Bi.options)}, received '${Bi.received}'`;
      break;
    case g.invalid_arguments:
      Ui = "Invalid function arguments";
      break;
    case g.invalid_return_type:
      Ui = "Invalid function return type";
      break;
    case g.invalid_date:
      Ui = "Invalid date";
      break;
    case g.invalid_string:
      typeof Bi.validation == "object" ? "includes" in Bi.validation ? (Ui = `Invalid input: must include "${Bi.validation.includes}"`, typeof Bi.validation.position == "number" && (Ui = `${Ui} at one or more positions greater than or equal to ${Bi.validation.position}`)) : "startsWith" in Bi.validation ? Ui = `Invalid input: must start with "${Bi.validation.startsWith}"` : "endsWith" in Bi.validation ? Ui = `Invalid input: must end with "${Bi.validation.endsWith}"` : Q.assertNever(Bi.validation) : Bi.validation !== "regex" ? Ui = `Invalid ${Bi.validation}` : Ui = "Invalid";
      break;
    case g.too_small:
      Bi.type === "array" ? Ui = `Array must contain ${Bi.exact ? "exactly" : Bi.inclusive ? "at least" : "more than"} ${Bi.minimum} element(s)` : Bi.type === "string" ? Ui = `String must contain ${Bi.exact ? "exactly" : Bi.inclusive ? "at least" : "over"} ${Bi.minimum} character(s)` : Bi.type === "number" ? Ui = `Number must be ${Bi.exact ? "exactly equal to " : Bi.inclusive ? "greater than or equal to " : "greater than "}${Bi.minimum}` : Bi.type === "date" ? Ui = `Date must be ${Bi.exact ? "exactly equal to " : Bi.inclusive ? "greater than or equal to " : "greater than "}${new Date(Number(Bi.minimum))}` : Ui = "Invalid input";
      break;
    case g.too_big:
      Bi.type === "array" ? Ui = `Array must contain ${Bi.exact ? "exactly" : Bi.inclusive ? "at most" : "less than"} ${Bi.maximum} element(s)` : Bi.type === "string" ? Ui = `String must contain ${Bi.exact ? "exactly" : Bi.inclusive ? "at most" : "under"} ${Bi.maximum} character(s)` : Bi.type === "number" ? Ui = `Number must be ${Bi.exact ? "exactly" : Bi.inclusive ? "less than or equal to" : "less than"} ${Bi.maximum}` : Bi.type === "bigint" ? Ui = `BigInt must be ${Bi.exact ? "exactly" : Bi.inclusive ? "less than or equal to" : "less than"} ${Bi.maximum}` : Bi.type === "date" ? Ui = `Date must be ${Bi.exact ? "exactly" : Bi.inclusive ? "smaller than or equal to" : "smaller than"} ${new Date(Number(Bi.maximum))}` : Ui = "Invalid input";
      break;
    case g.custom:
      Ui = "Invalid input";
      break;
    case g.invalid_intersection_types:
      Ui = "Intersection results could not be merged";
      break;
    case g.not_multiple_of:
      Ui = `Number must be a multiple of ${Bi.multipleOf}`;
      break;
    case g.not_finite:
      Ui = "Number must be finite";
      break;
    default:
      Ui = e.defaultError, Q.assertNever(Bi);
  }
  return { message: Ui };
};
let Qa = pt;
function pc(Bi) {
  Qa = Bi;
}
function ur() {
  return Qa;
}
const cr = (Bi) => {
  const { data: e, path: Ui, errorMaps: Zi, issueData: ta } = Bi, na = [...Ui, ...ta.path || []], ia = {
    ...ta,
    path: na
  };
  if (ta.message !== void 0)
    return {
      ...ta,
      path: na,
      message: ta.message
    };
  let aa = "";
  const da = Zi.filter((La) => !!La).slice().reverse();
  for (const La of da)
    aa = La(ia, { data: e, defaultError: aa }).message;
  return {
    ...ta,
    path: na,
    message: aa
  };
}, yc = [];
function w(Bi, e) {
  const Ui = ur(), Zi = cr({
    issueData: e,
    data: Bi.data,
    path: Bi.path,
    errorMaps: [
      Bi.common.contextualErrorMap,
      // contextual error map is first priority
      Bi.schemaErrorMap,
      // then schema-bound map if available
      Ui,
      // then global override map
      Ui === pt ? void 0 : pt
      // then global default map
    ].filter((ta) => !!ta)
  });
  Bi.common.issues.push(Zi);
}
class oe {
  constructor() {
    this.value = "valid";
  }
  dirty() {
    this.value === "valid" && (this.value = "dirty");
  }
  abort() {
    this.value !== "aborted" && (this.value = "aborted");
  }
  static mergeArray(e, Ui) {
    const Zi = [];
    for (const ta of Ui) {
      if (ta.status === "aborted")
        return A;
      ta.status === "dirty" && e.dirty(), Zi.push(ta.value);
    }
    return { status: e.value, value: Zi };
  }
  static async mergeObjectAsync(e, Ui) {
    const Zi = [];
    for (const ta of Ui) {
      const na = await ta.key, ia = await ta.value;
      Zi.push({
        key: na,
        value: ia
      });
    }
    return oe.mergeObjectSync(e, Zi);
  }
  static mergeObjectSync(e, Ui) {
    const Zi = {};
    for (const ta of Ui) {
      const { key: na, value: ia } = ta;
      if (na.status === "aborted" || ia.status === "aborted")
        return A;
      na.status === "dirty" && e.dirty(), ia.status === "dirty" && e.dirty(), na.value !== "__proto__" && (typeof ia.value < "u" || ta.alwaysSet) && (Zi[na.value] = ia.value);
    }
    return { status: e.value, value: Zi };
  }
}
const A = Object.freeze({
  status: "aborted"
}), st = (Bi) => ({ status: "dirty", value: Bi }), ce = (Bi) => ({ status: "valid", value: Bi }), pn = (Bi) => Bi.status === "aborted", yn = (Bi) => Bi.status === "dirty", Ye = (Bi) => Bi.status === "valid", Ct = (Bi) => typeof Promise < "u" && Bi instanceof Promise;
function lr(Bi, e, Ui, Zi) {
  if (typeof e == "function" ? Bi !== e || !0 : !e.has(Bi)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
  return e.get(Bi);
}
function Ba(Bi, e, Ui, Zi, ta) {
  if (typeof e == "function" ? Bi !== e || !0 : !e.has(Bi)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
  return e.set(Bi, Ui), Ui;
}
var T;
(function(Bi) {
  Bi.errToObj = (e) => typeof e == "string" ? { message: e } : e || {}, Bi.toString = (e) => typeof e == "string" ? e : e?.message;
})(T || (T = {}));
var St, Ot;
class Oe {
  constructor(e, Ui, Zi, ta) {
    this._cachedPath = [], this.parent = e, this.data = Ui, this._path = Zi, this._key = ta;
  }
  get path() {
    return this._cachedPath.length || (this._key instanceof Array ? this._cachedPath.push(...this._path, ...this._key) : this._cachedPath.push(...this._path, this._key)), this._cachedPath;
  }
}
const zi = (Bi, e) => {
  if (Ye(e))
    return { success: !0, data: e.value };
  if (!Bi.common.issues.length)
    throw new Error("Validation failed but no issues detected.");
  return {
    success: !1,
    get error() {
      if (this._error)
        return this._error;
      const Ui = new de(Bi.common.issues);
      return this._error = Ui, this._error;
    }
  };
};
function P(Bi) {
  if (!Bi)
    return {};
  const { errorMap: e, invalid_type_error: Ui, required_error: Zi, description: ta } = Bi;
  if (e && (Ui || Zi))
    throw new Error(`Can't use "invalid_type_error" or "required_error" in conjunction with custom error map.`);
  return e ? { errorMap: e, description: ta } : { errorMap: (na, ia) => {
    var aa, da;
    const { message: La } = Bi;
    return na.code === "invalid_enum_value" ? { message: La ?? ia.defaultError } : typeof ia.data > "u" ? { message: (aa = La ?? Zi) !== null && aa !== void 0 ? aa : ia.defaultError } : na.code !== "invalid_type" ? { message: ia.defaultError } : { message: (da = La ?? Ui) !== null && da !== void 0 ? da : ia.defaultError };
  }, description: ta };
}
class M {
  get description() {
    return this._def.description;
  }
  _getType(e) {
    return Re(e.data);
  }
  _getOrReturnCtx(e, Ui) {
    return Ui || {
      common: e.parent.common,
      data: e.data,
      parsedType: Re(e.data),
      schemaErrorMap: this._def.errorMap,
      path: e.path,
      parent: e.parent
    };
  }
  _processInputParams(e) {
    return {
      status: new oe(),
      ctx: {
        common: e.parent.common,
        data: e.data,
        parsedType: Re(e.data),
        schemaErrorMap: this._def.errorMap,
        path: e.path,
        parent: e.parent
      }
    };
  }
  _parseSync(e) {
    const Ui = this._parse(e);
    if (Ct(Ui))
      throw new Error("Synchronous parse encountered promise.");
    return Ui;
  }
  _parseAsync(e) {
    const Ui = this._parse(e);
    return Promise.resolve(Ui);
  }
  parse(e, Ui) {
    const Zi = this.safeParse(e, Ui);
    if (Zi.success)
      return Zi.data;
    throw Zi.error;
  }
  safeParse(e, Ui) {
    var Zi;
    const ta = {
      common: {
        issues: [],
        async: (Zi = Ui?.async) !== null && Zi !== void 0 ? Zi : !1,
        contextualErrorMap: Ui?.errorMap
      },
      path: Ui?.path || [],
      schemaErrorMap: this._def.errorMap,
      parent: null,
      data: e,
      parsedType: Re(e)
    }, na = this._parseSync({ data: e, path: ta.path, parent: ta });
    return zi(ta, na);
  }
  "~validate"(e) {
    var Ui, Zi;
    const ta = {
      common: {
        issues: [],
        async: !!this["~standard"].async
      },
      path: [],
      schemaErrorMap: this._def.errorMap,
      parent: null,
      data: e,
      parsedType: Re(e)
    };
    if (!this["~standard"].async)
      try {
        const na = this._parseSync({ data: e, path: [], parent: ta });
        return Ye(na) ? {
          value: na.value
        } : {
          issues: ta.common.issues
        };
      } catch (na) {
        !((Zi = (Ui = na?.message) === null || Ui === void 0 ? void 0 : Ui.toLowerCase()) === null || Zi === void 0) && Zi.includes("encountered") && (this["~standard"].async = !0), ta.common = {
          issues: [],
          async: !0
        };
      }
    return this._parseAsync({ data: e, path: [], parent: ta }).then((na) => Ye(na) ? {
      value: na.value
    } : {
      issues: ta.common.issues
    });
  }
  async parseAsync(e, Ui) {
    const Zi = await this.safeParseAsync(e, Ui);
    if (Zi.success)
      return Zi.data;
    throw Zi.error;
  }
  async safeParseAsync(e, Ui) {
    const Zi = {
      common: {
        issues: [],
        contextualErrorMap: Ui?.errorMap,
        async: !0
      },
      path: Ui?.path || [],
      schemaErrorMap: this._def.errorMap,
      parent: null,
      data: e,
      parsedType: Re(e)
    }, ta = this._parse({ data: e, path: Zi.path, parent: Zi }), na = await (Ct(ta) ? ta : Promise.resolve(ta));
    return zi(Zi, na);
  }
  refine(e, Ui) {
    const Zi = (ta) => typeof Ui == "string" || typeof Ui > "u" ? { message: Ui } : typeof Ui == "function" ? Ui(ta) : Ui;
    return this._refinement((ta, na) => {
      const ia = e(ta), aa = () => na.addIssue({
        code: g.custom,
        ...Zi(ta)
      });
      return typeof Promise < "u" && ia instanceof Promise ? ia.then((da) => da ? !0 : (aa(), !1)) : ia ? !0 : (aa(), !1);
    });
  }
  refinement(e, Ui) {
    return this._refinement((Zi, ta) => e(Zi) ? !0 : (ta.addIssue(typeof Ui == "function" ? Ui(Zi, ta) : Ui), !1));
  }
  _refinement(e) {
    return new ge({
      schema: this,
      typeName: C.ZodEffects,
      effect: { type: "refinement", refinement: e }
    });
  }
  superRefine(e) {
    return this._refinement(e);
  }
  constructor(e) {
    this.spa = this.safeParseAsync, this._def = e, this.parse = this.parse.bind(this), this.safeParse = this.safeParse.bind(this), this.parseAsync = this.parseAsync.bind(this), this.safeParseAsync = this.safeParseAsync.bind(this), this.spa = this.spa.bind(this), this.refine = this.refine.bind(this), this.refinement = this.refinement.bind(this), this.superRefine = this.superRefine.bind(this), this.optional = this.optional.bind(this), this.nullable = this.nullable.bind(this), this.nullish = this.nullish.bind(this), this.array = this.array.bind(this), this.promise = this.promise.bind(this), this.or = this.or.bind(this), this.and = this.and.bind(this), this.transform = this.transform.bind(this), this.brand = this.brand.bind(this), this.default = this.default.bind(this), this.catch = this.catch.bind(this), this.describe = this.describe.bind(this), this.pipe = this.pipe.bind(this), this.readonly = this.readonly.bind(this), this.isNullable = this.isNullable.bind(this), this.isOptional = this.isOptional.bind(this), this["~standard"] = {
      version: 1,
      vendor: "zod",
      validate: (Ui) => this["~validate"](Ui)
    };
  }
  optional() {
    return Se.create(this, this._def);
  }
  nullable() {
    return Ue.create(this, this._def);
  }
  nullish() {
    return this.nullable().optional();
  }
  array() {
    return me.create(this);
  }
  promise() {
    return vt.create(this, this._def);
  }
  or(e) {
    return Ft.create([this, e], this._def);
  }
  and(e) {
    return Mt.create(this, e, this._def);
  }
  transform(e) {
    return new ge({
      ...P(this._def),
      schema: this,
      typeName: C.ZodEffects,
      effect: { type: "transform", transform: e }
    });
  }
  default(e) {
    const Ui = typeof e == "function" ? e : () => e;
    return new Bt({
      ...P(this._def),
      innerType: this,
      defaultValue: Ui,
      typeName: C.ZodDefault
    });
  }
  brand() {
    return new Un({
      typeName: C.ZodBranded,
      type: this,
      ...P(this._def)
    });
  }
  catch(e) {
    const Ui = typeof e == "function" ? e : () => e;
    return new Ut({
      ...P(this._def),
      innerType: this,
      catchValue: Ui,
      typeName: C.ZodCatch
    });
  }
  describe(e) {
    const Ui = this.constructor;
    return new Ui({
      ...this._def,
      description: e
    });
  }
  pipe(e) {
    return Wt.create(this, e);
  }
  readonly() {
    return Zt.create(this);
  }
  isOptional() {
    return this.safeParse(void 0).success;
  }
  isNullable() {
    return this.safeParse(null).success;
  }
}
const vc = /^c[^\s-]{8,}$/i, mc = /^[0-9a-z]+$/, gc = /^[0-9A-HJKMNP-TV-Z]{26}$/i, bc = /^[0-9a-fA-F]{8}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{12}$/i, _c = /^[a-z0-9_-]{21}$/i, wc = /^[A-Za-z0-9-_]+\.[A-Za-z0-9-_]+\.[A-Za-z0-9-_]*$/, kc = /^[-+]?P(?!$)(?:(?:[-+]?\d+Y)|(?:[-+]?\d+[.,]\d+Y$))?(?:(?:[-+]?\d+M)|(?:[-+]?\d+[.,]\d+M$))?(?:(?:[-+]?\d+W)|(?:[-+]?\d+[.,]\d+W$))?(?:(?:[-+]?\d+D)|(?:[-+]?\d+[.,]\d+D$))?(?:T(?=[\d+-])(?:(?:[-+]?\d+H)|(?:[-+]?\d+[.,]\d+H$))?(?:(?:[-+]?\d+M)|(?:[-+]?\d+[.,]\d+M$))?(?:[-+]?\d+(?:[.,]\d+)?S)?)??$/, Ec = /^(?!\.)(?!.*\.\.)([A-Z0-9_'+\-\.]*)[A-Z0-9_+-]@([A-Z0-9][A-Z0-9\-]*\.)+[A-Z]{2,}$/i, Sc = "^(\\p{Extended_Pictographic}|\\p{Emoji_Component})+$";
let qr;
const Oc = /^(?:(?:25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])\.){3}(?:25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])$/, xc = /^(?:(?:25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])\.){3}(?:25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])\/(3[0-2]|[12]?[0-9])$/, Tc = /^(([0-9a-fA-F]{1,4}:){7,7}[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,7}:|([0-9a-fA-F]{1,4}:){1,6}:[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,5}(:[0-9a-fA-F]{1,4}){1,2}|([0-9a-fA-F]{1,4}:){1,4}(:[0-9a-fA-F]{1,4}){1,3}|([0-9a-fA-F]{1,4}:){1,3}(:[0-9a-fA-F]{1,4}){1,4}|([0-9a-fA-F]{1,4}:){1,2}(:[0-9a-fA-F]{1,4}){1,5}|[0-9a-fA-F]{1,4}:((:[0-9a-fA-F]{1,4}){1,6})|:((:[0-9a-fA-F]{1,4}){1,7}|:)|fe80:(:[0-9a-fA-F]{0,4}){0,4}%[0-9a-zA-Z]{1,}|::(ffff(:0{1,4}){0,1}:){0,1}((25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])\.){3,3}(25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])|([0-9a-fA-F]{1,4}:){1,4}:((25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])\.){3,3}(25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9]))$/, Dc = /^(([0-9a-fA-F]{1,4}:){7,7}[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,7}:|([0-9a-fA-F]{1,4}:){1,6}:[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,5}(:[0-9a-fA-F]{1,4}){1,2}|([0-9a-fA-F]{1,4}:){1,4}(:[0-9a-fA-F]{1,4}){1,3}|([0-9a-fA-F]{1,4}:){1,3}(:[0-9a-fA-F]{1,4}){1,4}|([0-9a-fA-F]{1,4}:){1,2}(:[0-9a-fA-F]{1,4}){1,5}|[0-9a-fA-F]{1,4}:((:[0-9a-fA-F]{1,4}){1,6})|:((:[0-9a-fA-F]{1,4}){1,7}|:)|fe80:(:[0-9a-fA-F]{0,4}){0,4}%[0-9a-zA-Z]{1,}|::(ffff(:0{1,4}){0,1}:){0,1}((25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])\.){3,3}(25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])|([0-9a-fA-F]{1,4}:){1,4}:((25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])\.){3,3}(25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9]))\/(12[0-8]|1[01][0-9]|[1-9]?[0-9])$/, Ic = /^([0-9a-zA-Z+/]{4})*(([0-9a-zA-Z+/]{2}==)|([0-9a-zA-Z+/]{3}=))?$/, Rc = /^([0-9a-zA-Z-_]{4})*(([0-9a-zA-Z-_]{2}(==)?)|([0-9a-zA-Z-_]{3}(=)?))?$/, Ua = "((\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-((0[13578]|1[02])-(0[1-9]|[12]\\d|3[01])|(0[469]|11)-(0[1-9]|[12]\\d|30)|(02)-(0[1-9]|1\\d|2[0-8])))", jc = new RegExp(`^${Ua}$`);
function Za(Bi) {
  let e = "([01]\\d|2[0-3]):[0-5]\\d:[0-5]\\d";
  return Bi.precision ? e = `${e}\\.\\d{${Bi.precision}}` : Bi.precision == null && (e = `${e}(\\.\\d+)?`), e;
}
function Cc(Bi) {
  return new RegExp(`^${Za(Bi)}$`);
}
function za(Bi) {
  let e = `${Ua}T${Za(Bi)}`;
  const Ui = [];
  return Ui.push(Bi.local ? "Z?" : "Z"), Bi.offset && Ui.push("([+-]\\d{2}:?\\d{2})"), e = `${e}(${Ui.join("|")})`, new RegExp(`^${e}$`);
}
function Ac(Bi, e) {
  return !!((e === "v4" || !e) && Oc.test(Bi) || (e === "v6" || !e) && Tc.test(Bi));
}
function Nc(Bi, e) {
  if (!wc.test(Bi))
    return !1;
  try {
    const [Ui] = Bi.split("."), Zi = Ui.replace(/-/g, "+").replace(/_/g, "/").padEnd(Ui.length + (4 - Ui.length % 4) % 4, "="), ta = JSON.parse(atob(Zi));
    return !(typeof ta != "object" || ta === null || !ta.typ || !ta.alg || e && ta.alg !== e);
  } catch {
    return !1;
  }
}
function Pc(Bi, e) {
  return !!((e === "v4" || !e) && xc.test(Bi) || (e === "v6" || !e) && Dc.test(Bi));
}
class ve extends M {
  _parse(e) {
    if (this._def.coerce && (e.data = String(e.data)), this._getType(e) !== O.string) {
      const ta = this._getOrReturnCtx(e);
      return w(ta, {
        code: g.invalid_type,
        expected: O.string,
        received: ta.parsedType
      }), A;
    }
    const Ui = new oe();
    let Zi;
    for (const ta of this._def.checks)
      if (ta.kind === "min")
        e.data.length < ta.value && (Zi = this._getOrReturnCtx(e, Zi), w(Zi, {
          code: g.too_small,
          minimum: ta.value,
          type: "string",
          inclusive: !0,
          exact: !1,
          message: ta.message
        }), Ui.dirty());
      else if (ta.kind === "max")
        e.data.length > ta.value && (Zi = this._getOrReturnCtx(e, Zi), w(Zi, {
          code: g.too_big,
          maximum: ta.value,
          type: "string",
          inclusive: !0,
          exact: !1,
          message: ta.message
        }), Ui.dirty());
      else if (ta.kind === "length") {
        const na = e.data.length > ta.value, ia = e.data.length < ta.value;
        (na || ia) && (Zi = this._getOrReturnCtx(e, Zi), na ? w(Zi, {
          code: g.too_big,
          maximum: ta.value,
          type: "string",
          inclusive: !0,
          exact: !0,
          message: ta.message
        }) : ia && w(Zi, {
          code: g.too_small,
          minimum: ta.value,
          type: "string",
          inclusive: !0,
          exact: !0,
          message: ta.message
        }), Ui.dirty());
      } else if (ta.kind === "email")
        Ec.test(e.data) || (Zi = this._getOrReturnCtx(e, Zi), w(Zi, {
          validation: "email",
          code: g.invalid_string,
          message: ta.message
        }), Ui.dirty());
      else if (ta.kind === "emoji")
        qr || (qr = new RegExp(Sc, "u")), qr.test(e.data) || (Zi = this._getOrReturnCtx(e, Zi), w(Zi, {
          validation: "emoji",
          code: g.invalid_string,
          message: ta.message
        }), Ui.dirty());
      else if (ta.kind === "uuid")
        bc.test(e.data) || (Zi = this._getOrReturnCtx(e, Zi), w(Zi, {
          validation: "uuid",
          code: g.invalid_string,
          message: ta.message
        }), Ui.dirty());
      else if (ta.kind === "nanoid")
        _c.test(e.data) || (Zi = this._getOrReturnCtx(e, Zi), w(Zi, {
          validation: "nanoid",
          code: g.invalid_string,
          message: ta.message
        }), Ui.dirty());
      else if (ta.kind === "cuid")
        vc.test(e.data) || (Zi = this._getOrReturnCtx(e, Zi), w(Zi, {
          validation: "cuid",
          code: g.invalid_string,
          message: ta.message
        }), Ui.dirty());
      else if (ta.kind === "cuid2")
        mc.test(e.data) || (Zi = this._getOrReturnCtx(e, Zi), w(Zi, {
          validation: "cuid2",
          code: g.invalid_string,
          message: ta.message
        }), Ui.dirty());
      else if (ta.kind === "ulid")
        gc.test(e.data) || (Zi = this._getOrReturnCtx(e, Zi), w(Zi, {
          validation: "ulid",
          code: g.invalid_string,
          message: ta.message
        }), Ui.dirty());
      else if (ta.kind === "url")
        try {
          new URL(e.data);
        } catch {
          Zi = this._getOrReturnCtx(e, Zi), w(Zi, {
            validation: "url",
            code: g.invalid_string,
            message: ta.message
          }), Ui.dirty();
        }
      else ta.kind === "regex" ? (ta.regex.lastIndex = 0, ta.regex.test(e.data) || (Zi = this._getOrReturnCtx(e, Zi), w(Zi, {
        validation: "regex",
        code: g.invalid_string,
        message: ta.message
      }), Ui.dirty())) : ta.kind === "trim" ? e.data = e.data.trim() : ta.kind === "includes" ? e.data.includes(ta.value, ta.position) || (Zi = this._getOrReturnCtx(e, Zi), w(Zi, {
        code: g.invalid_string,
        validation: { includes: ta.value, position: ta.position },
        message: ta.message
      }), Ui.dirty()) : ta.kind === "toLowerCase" ? e.data = e.data.toLowerCase() : ta.kind === "toUpperCase" ? e.data = e.data.toUpperCase() : ta.kind === "startsWith" ? e.data.startsWith(ta.value) || (Zi = this._getOrReturnCtx(e, Zi), w(Zi, {
        code: g.invalid_string,
        validation: { startsWith: ta.value },
        message: ta.message
      }), Ui.dirty()) : ta.kind === "endsWith" ? e.data.endsWith(ta.value) || (Zi = this._getOrReturnCtx(e, Zi), w(Zi, {
        code: g.invalid_string,
        validation: { endsWith: ta.value },
        message: ta.message
      }), Ui.dirty()) : ta.kind === "datetime" ? za(ta).test(e.data) || (Zi = this._getOrReturnCtx(e, Zi), w(Zi, {
        code: g.invalid_string,
        validation: "datetime",
        message: ta.message
      }), Ui.dirty()) : ta.kind === "date" ? jc.test(e.data) || (Zi = this._getOrReturnCtx(e, Zi), w(Zi, {
        code: g.invalid_string,
        validation: "date",
        message: ta.message
      }), Ui.dirty()) : ta.kind === "time" ? Cc(ta).test(e.data) || (Zi = this._getOrReturnCtx(e, Zi), w(Zi, {
        code: g.invalid_string,
        validation: "time",
        message: ta.message
      }), Ui.dirty()) : ta.kind === "duration" ? kc.test(e.data) || (Zi = this._getOrReturnCtx(e, Zi), w(Zi, {
        validation: "duration",
        code: g.invalid_string,
        message: ta.message
      }), Ui.dirty()) : ta.kind === "ip" ? Ac(e.data, ta.version) || (Zi = this._getOrReturnCtx(e, Zi), w(Zi, {
        validation: "ip",
        code: g.invalid_string,
        message: ta.message
      }), Ui.dirty()) : ta.kind === "jwt" ? Nc(e.data, ta.alg) || (Zi = this._getOrReturnCtx(e, Zi), w(Zi, {
        validation: "jwt",
        code: g.invalid_string,
        message: ta.message
      }), Ui.dirty()) : ta.kind === "cidr" ? Pc(e.data, ta.version) || (Zi = this._getOrReturnCtx(e, Zi), w(Zi, {
        validation: "cidr",
        code: g.invalid_string,
        message: ta.message
      }), Ui.dirty()) : ta.kind === "base64" ? Ic.test(e.data) || (Zi = this._getOrReturnCtx(e, Zi), w(Zi, {
        validation: "base64",
        code: g.invalid_string,
        message: ta.message
      }), Ui.dirty()) : ta.kind === "base64url" ? Rc.test(e.data) || (Zi = this._getOrReturnCtx(e, Zi), w(Zi, {
        validation: "base64url",
        code: g.invalid_string,
        message: ta.message
      }), Ui.dirty()) : Q.assertNever(ta);
    return { status: Ui.value, value: e.data };
  }
  _regex(e, Ui, Zi) {
    return this.refinement((ta) => e.test(ta), {
      validation: Ui,
      code: g.invalid_string,
      ...T.errToObj(Zi)
    });
  }
  _addCheck(e) {
    return new ve({
      ...this._def,
      checks: [...this._def.checks, e]
    });
  }
  email(e) {
    return this._addCheck({ kind: "email", ...T.errToObj(e) });
  }
  url(e) {
    return this._addCheck({ kind: "url", ...T.errToObj(e) });
  }
  emoji(e) {
    return this._addCheck({ kind: "emoji", ...T.errToObj(e) });
  }
  uuid(e) {
    return this._addCheck({ kind: "uuid", ...T.errToObj(e) });
  }
  nanoid(e) {
    return this._addCheck({ kind: "nanoid", ...T.errToObj(e) });
  }
  cuid(e) {
    return this._addCheck({ kind: "cuid", ...T.errToObj(e) });
  }
  cuid2(e) {
    return this._addCheck({ kind: "cuid2", ...T.errToObj(e) });
  }
  ulid(e) {
    return this._addCheck({ kind: "ulid", ...T.errToObj(e) });
  }
  base64(e) {
    return this._addCheck({ kind: "base64", ...T.errToObj(e) });
  }
  base64url(e) {
    return this._addCheck({
      kind: "base64url",
      ...T.errToObj(e)
    });
  }
  jwt(e) {
    return this._addCheck({ kind: "jwt", ...T.errToObj(e) });
  }
  ip(e) {
    return this._addCheck({ kind: "ip", ...T.errToObj(e) });
  }
  cidr(e) {
    return this._addCheck({ kind: "cidr", ...T.errToObj(e) });
  }
  datetime(e) {
    var Ui, Zi;
    return typeof e == "string" ? this._addCheck({
      kind: "datetime",
      precision: null,
      offset: !1,
      local: !1,
      message: e
    }) : this._addCheck({
      kind: "datetime",
      precision: typeof e?.precision > "u" ? null : e?.precision,
      offset: (Ui = e?.offset) !== null && Ui !== void 0 ? Ui : !1,
      local: (Zi = e?.local) !== null && Zi !== void 0 ? Zi : !1,
      ...T.errToObj(e?.message)
    });
  }
  date(e) {
    return this._addCheck({ kind: "date", message: e });
  }
  time(e) {
    return typeof e == "string" ? this._addCheck({
      kind: "time",
      precision: null,
      message: e
    }) : this._addCheck({
      kind: "time",
      precision: typeof e?.precision > "u" ? null : e?.precision,
      ...T.errToObj(e?.message)
    });
  }
  duration(e) {
    return this._addCheck({ kind: "duration", ...T.errToObj(e) });
  }
  regex(e, Ui) {
    return this._addCheck({
      kind: "regex",
      regex: e,
      ...T.errToObj(Ui)
    });
  }
  includes(e, Ui) {
    return this._addCheck({
      kind: "includes",
      value: e,
      position: Ui?.position,
      ...T.errToObj(Ui?.message)
    });
  }
  startsWith(e, Ui) {
    return this._addCheck({
      kind: "startsWith",
      value: e,
      ...T.errToObj(Ui)
    });
  }
  endsWith(e, Ui) {
    return this._addCheck({
      kind: "endsWith",
      value: e,
      ...T.errToObj(Ui)
    });
  }
  min(e, Ui) {
    return this._addCheck({
      kind: "min",
      value: e,
      ...T.errToObj(Ui)
    });
  }
  max(e, Ui) {
    return this._addCheck({
      kind: "max",
      value: e,
      ...T.errToObj(Ui)
    });
  }
  length(e, Ui) {
    return this._addCheck({
      kind: "length",
      value: e,
      ...T.errToObj(Ui)
    });
  }
  /**
   * Equivalent to `.min(1)`
   */
  nonempty(e) {
    return this.min(1, T.errToObj(e));
  }
  trim() {
    return new ve({
      ...this._def,
      checks: [...this._def.checks, { kind: "trim" }]
    });
  }
  toLowerCase() {
    return new ve({
      ...this._def,
      checks: [...this._def.checks, { kind: "toLowerCase" }]
    });
  }
  toUpperCase() {
    return new ve({
      ...this._def,
      checks: [...this._def.checks, { kind: "toUpperCase" }]
    });
  }
  get isDatetime() {
    return !!this._def.checks.find((e) => e.kind === "datetime");
  }
  get isDate() {
    return !!this._def.checks.find((e) => e.kind === "date");
  }
  get isTime() {
    return !!this._def.checks.find((e) => e.kind === "time");
  }
  get isDuration() {
    return !!this._def.checks.find((e) => e.kind === "duration");
  }
  get isEmail() {
    return !!this._def.checks.find((e) => e.kind === "email");
  }
  get isURL() {
    return !!this._def.checks.find((e) => e.kind === "url");
  }
  get isEmoji() {
    return !!this._def.checks.find((e) => e.kind === "emoji");
  }
  get isUUID() {
    return !!this._def.checks.find((e) => e.kind === "uuid");
  }
  get isNANOID() {
    return !!this._def.checks.find((e) => e.kind === "nanoid");
  }
  get isCUID() {
    return !!this._def.checks.find((e) => e.kind === "cuid");
  }
  get isCUID2() {
    return !!this._def.checks.find((e) => e.kind === "cuid2");
  }
  get isULID() {
    return !!this._def.checks.find((e) => e.kind === "ulid");
  }
  get isIP() {
    return !!this._def.checks.find((e) => e.kind === "ip");
  }
  get isCIDR() {
    return !!this._def.checks.find((e) => e.kind === "cidr");
  }
  get isBase64() {
    return !!this._def.checks.find((e) => e.kind === "base64");
  }
  get isBase64url() {
    return !!this._def.checks.find((e) => e.kind === "base64url");
  }
  get minLength() {
    let e = null;
    for (const Ui of this._def.checks)
      Ui.kind === "min" && (e === null || Ui.value > e) && (e = Ui.value);
    return e;
  }
  get maxLength() {
    let e = null;
    for (const Ui of this._def.checks)
      Ui.kind === "max" && (e === null || Ui.value < e) && (e = Ui.value);
    return e;
  }
}
ve.create = (Bi) => {
  var e;
  return new ve({
    checks: [],
    typeName: C.ZodString,
    coerce: (e = Bi?.coerce) !== null && e !== void 0 ? e : !1,
    ...P(Bi)
  });
};
function Fc(Bi, e) {
  const Ui = (Bi.toString().split(".")[1] || "").length, Zi = (e.toString().split(".")[1] || "").length, ta = Ui > Zi ? Ui : Zi, na = parseInt(Bi.toFixed(ta).replace(".", "")), ia = parseInt(e.toFixed(ta).replace(".", ""));
  return na % ia / Math.pow(10, ta);
}
class qe extends M {
  constructor() {
    super(...arguments), this.min = this.gte, this.max = this.lte, this.step = this.multipleOf;
  }
  _parse(e) {
    if (this._def.coerce && (e.data = Number(e.data)), this._getType(e) !== O.number) {
      const ta = this._getOrReturnCtx(e);
      return w(ta, {
        code: g.invalid_type,
        expected: O.number,
        received: ta.parsedType
      }), A;
    }
    let Ui;
    const Zi = new oe();
    for (const ta of this._def.checks)
      ta.kind === "int" ? Q.isInteger(e.data) || (Ui = this._getOrReturnCtx(e, Ui), w(Ui, {
        code: g.invalid_type,
        expected: "integer",
        received: "float",
        message: ta.message
      }), Zi.dirty()) : ta.kind === "min" ? (ta.inclusive ? e.data < ta.value : e.data <= ta.value) && (Ui = this._getOrReturnCtx(e, Ui), w(Ui, {
        code: g.too_small,
        minimum: ta.value,
        type: "number",
        inclusive: ta.inclusive,
        exact: !1,
        message: ta.message
      }), Zi.dirty()) : ta.kind === "max" ? (ta.inclusive ? e.data > ta.value : e.data >= ta.value) && (Ui = this._getOrReturnCtx(e, Ui), w(Ui, {
        code: g.too_big,
        maximum: ta.value,
        type: "number",
        inclusive: ta.inclusive,
        exact: !1,
        message: ta.message
      }), Zi.dirty()) : ta.kind === "multipleOf" ? Fc(e.data, ta.value) !== 0 && (Ui = this._getOrReturnCtx(e, Ui), w(Ui, {
        code: g.not_multiple_of,
        multipleOf: ta.value,
        message: ta.message
      }), Zi.dirty()) : ta.kind === "finite" ? Number.isFinite(e.data) || (Ui = this._getOrReturnCtx(e, Ui), w(Ui, {
        code: g.not_finite,
        message: ta.message
      }), Zi.dirty()) : Q.assertNever(ta);
    return { status: Zi.value, value: e.data };
  }
  gte(e, Ui) {
    return this.setLimit("min", e, !0, T.toString(Ui));
  }
  gt(e, Ui) {
    return this.setLimit("min", e, !1, T.toString(Ui));
  }
  lte(e, Ui) {
    return this.setLimit("max", e, !0, T.toString(Ui));
  }
  lt(e, Ui) {
    return this.setLimit("max", e, !1, T.toString(Ui));
  }
  setLimit(e, Ui, Zi, ta) {
    return new qe({
      ...this._def,
      checks: [
        ...this._def.checks,
        {
          kind: e,
          value: Ui,
          inclusive: Zi,
          message: T.toString(ta)
        }
      ]
    });
  }
  _addCheck(e) {
    return new qe({
      ...this._def,
      checks: [...this._def.checks, e]
    });
  }
  int(e) {
    return this._addCheck({
      kind: "int",
      message: T.toString(e)
    });
  }
  positive(e) {
    return this._addCheck({
      kind: "min",
      value: 0,
      inclusive: !1,
      message: T.toString(e)
    });
  }
  negative(e) {
    return this._addCheck({
      kind: "max",
      value: 0,
      inclusive: !1,
      message: T.toString(e)
    });
  }
  nonpositive(e) {
    return this._addCheck({
      kind: "max",
      value: 0,
      inclusive: !0,
      message: T.toString(e)
    });
  }
  nonnegative(e) {
    return this._addCheck({
      kind: "min",
      value: 0,
      inclusive: !0,
      message: T.toString(e)
    });
  }
  multipleOf(e, Ui) {
    return this._addCheck({
      kind: "multipleOf",
      value: e,
      message: T.toString(Ui)
    });
  }
  finite(e) {
    return this._addCheck({
      kind: "finite",
      message: T.toString(e)
    });
  }
  safe(e) {
    return this._addCheck({
      kind: "min",
      inclusive: !0,
      value: Number.MIN_SAFE_INTEGER,
      message: T.toString(e)
    })._addCheck({
      kind: "max",
      inclusive: !0,
      value: Number.MAX_SAFE_INTEGER,
      message: T.toString(e)
    });
  }
  get minValue() {
    let e = null;
    for (const Ui of this._def.checks)
      Ui.kind === "min" && (e === null || Ui.value > e) && (e = Ui.value);
    return e;
  }
  get maxValue() {
    let e = null;
    for (const Ui of this._def.checks)
      Ui.kind === "max" && (e === null || Ui.value < e) && (e = Ui.value);
    return e;
  }
  get isInt() {
    return !!this._def.checks.find((e) => e.kind === "int" || e.kind === "multipleOf" && Q.isInteger(e.value));
  }
  get isFinite() {
    let e = null, Ui = null;
    for (const Zi of this._def.checks) {
      if (Zi.kind === "finite" || Zi.kind === "int" || Zi.kind === "multipleOf")
        return !0;
      Zi.kind === "min" ? (Ui === null || Zi.value > Ui) && (Ui = Zi.value) : Zi.kind === "max" && (e === null || Zi.value < e) && (e = Zi.value);
    }
    return Number.isFinite(Ui) && Number.isFinite(e);
  }
}
qe.create = (Bi) => new qe({
  checks: [],
  typeName: C.ZodNumber,
  coerce: Bi?.coerce || !1,
  ...P(Bi)
});
class Qe extends M {
  constructor() {
    super(...arguments), this.min = this.gte, this.max = this.lte;
  }
  _parse(e) {
    if (this._def.coerce)
      try {
        e.data = BigInt(e.data);
      } catch {
        return this._getInvalidInput(e);
      }
    if (this._getType(e) !== O.bigint)
      return this._getInvalidInput(e);
    let Ui;
    const Zi = new oe();
    for (const ta of this._def.checks)
      ta.kind === "min" ? (ta.inclusive ? e.data < ta.value : e.data <= ta.value) && (Ui = this._getOrReturnCtx(e, Ui), w(Ui, {
        code: g.too_small,
        type: "bigint",
        minimum: ta.value,
        inclusive: ta.inclusive,
        message: ta.message
      }), Zi.dirty()) : ta.kind === "max" ? (ta.inclusive ? e.data > ta.value : e.data >= ta.value) && (Ui = this._getOrReturnCtx(e, Ui), w(Ui, {
        code: g.too_big,
        type: "bigint",
        maximum: ta.value,
        inclusive: ta.inclusive,
        message: ta.message
      }), Zi.dirty()) : ta.kind === "multipleOf" ? e.data % ta.value !== BigInt(0) && (Ui = this._getOrReturnCtx(e, Ui), w(Ui, {
        code: g.not_multiple_of,
        multipleOf: ta.value,
        message: ta.message
      }), Zi.dirty()) : Q.assertNever(ta);
    return { status: Zi.value, value: e.data };
  }
  _getInvalidInput(e) {
    const Ui = this._getOrReturnCtx(e);
    return w(Ui, {
      code: g.invalid_type,
      expected: O.bigint,
      received: Ui.parsedType
    }), A;
  }
  gte(e, Ui) {
    return this.setLimit("min", e, !0, T.toString(Ui));
  }
  gt(e, Ui) {
    return this.setLimit("min", e, !1, T.toString(Ui));
  }
  lte(e, Ui) {
    return this.setLimit("max", e, !0, T.toString(Ui));
  }
  lt(e, Ui) {
    return this.setLimit("max", e, !1, T.toString(Ui));
  }
  setLimit(e, Ui, Zi, ta) {
    return new Qe({
      ...this._def,
      checks: [
        ...this._def.checks,
        {
          kind: e,
          value: Ui,
          inclusive: Zi,
          message: T.toString(ta)
        }
      ]
    });
  }
  _addCheck(e) {
    return new Qe({
      ...this._def,
      checks: [...this._def.checks, e]
    });
  }
  positive(e) {
    return this._addCheck({
      kind: "min",
      value: BigInt(0),
      inclusive: !1,
      message: T.toString(e)
    });
  }
  negative(e) {
    return this._addCheck({
      kind: "max",
      value: BigInt(0),
      inclusive: !1,
      message: T.toString(e)
    });
  }
  nonpositive(e) {
    return this._addCheck({
      kind: "max",
      value: BigInt(0),
      inclusive: !0,
      message: T.toString(e)
    });
  }
  nonnegative(e) {
    return this._addCheck({
      kind: "min",
      value: BigInt(0),
      inclusive: !0,
      message: T.toString(e)
    });
  }
  multipleOf(e, Ui) {
    return this._addCheck({
      kind: "multipleOf",
      value: e,
      message: T.toString(Ui)
    });
  }
  get minValue() {
    let e = null;
    for (const Ui of this._def.checks)
      Ui.kind === "min" && (e === null || Ui.value > e) && (e = Ui.value);
    return e;
  }
  get maxValue() {
    let e = null;
    for (const Ui of this._def.checks)
      Ui.kind === "max" && (e === null || Ui.value < e) && (e = Ui.value);
    return e;
  }
}
Qe.create = (Bi) => {
  var e;
  return new Qe({
    checks: [],
    typeName: C.ZodBigInt,
    coerce: (e = Bi?.coerce) !== null && e !== void 0 ? e : !1,
    ...P(Bi)
  });
};
class At extends M {
  _parse(e) {
    if (this._def.coerce && (e.data = !!e.data), this._getType(e) !== O.boolean) {
      const Ui = this._getOrReturnCtx(e);
      return w(Ui, {
        code: g.invalid_type,
        expected: O.boolean,
        received: Ui.parsedType
      }), A;
    }
    return ce(e.data);
  }
}
At.create = (Bi) => new At({
  typeName: C.ZodBoolean,
  coerce: Bi?.coerce || !1,
  ...P(Bi)
});
class Ke extends M {
  _parse(e) {
    if (this._def.coerce && (e.data = new Date(e.data)), this._getType(e) !== O.date) {
      const ta = this._getOrReturnCtx(e);
      return w(ta, {
        code: g.invalid_type,
        expected: O.date,
        received: ta.parsedType
      }), A;
    }
    if (isNaN(e.data.getTime())) {
      const ta = this._getOrReturnCtx(e);
      return w(ta, {
        code: g.invalid_date
      }), A;
    }
    const Ui = new oe();
    let Zi;
    for (const ta of this._def.checks)
      ta.kind === "min" ? e.data.getTime() < ta.value && (Zi = this._getOrReturnCtx(e, Zi), w(Zi, {
        code: g.too_small,
        message: ta.message,
        inclusive: !0,
        exact: !1,
        minimum: ta.value,
        type: "date"
      }), Ui.dirty()) : ta.kind === "max" ? e.data.getTime() > ta.value && (Zi = this._getOrReturnCtx(e, Zi), w(Zi, {
        code: g.too_big,
        message: ta.message,
        inclusive: !0,
        exact: !1,
        maximum: ta.value,
        type: "date"
      }), Ui.dirty()) : Q.assertNever(ta);
    return {
      status: Ui.value,
      value: new Date(e.data.getTime())
    };
  }
  _addCheck(e) {
    return new Ke({
      ...this._def,
      checks: [...this._def.checks, e]
    });
  }
  min(e, Ui) {
    return this._addCheck({
      kind: "min",
      value: e.getTime(),
      message: T.toString(Ui)
    });
  }
  max(e, Ui) {
    return this._addCheck({
      kind: "max",
      value: e.getTime(),
      message: T.toString(Ui)
    });
  }
  get minDate() {
    let e = null;
    for (const Ui of this._def.checks)
      Ui.kind === "min" && (e === null || Ui.value > e) && (e = Ui.value);
    return e != null ? new Date(e) : null;
  }
  get maxDate() {
    let e = null;
    for (const Ui of this._def.checks)
      Ui.kind === "max" && (e === null || Ui.value < e) && (e = Ui.value);
    return e != null ? new Date(e) : null;
  }
}
Ke.create = (Bi) => new Ke({
  checks: [],
  coerce: Bi?.coerce || !1,
  typeName: C.ZodDate,
  ...P(Bi)
});
class fr extends M {
  _parse(e) {
    if (this._getType(e) !== O.symbol) {
      const Ui = this._getOrReturnCtx(e);
      return w(Ui, {
        code: g.invalid_type,
        expected: O.symbol,
        received: Ui.parsedType
      }), A;
    }
    return ce(e.data);
  }
}
fr.create = (Bi) => new fr({
  typeName: C.ZodSymbol,
  ...P(Bi)
});
class Nt extends M {
  _parse(e) {
    if (this._getType(e) !== O.undefined) {
      const Ui = this._getOrReturnCtx(e);
      return w(Ui, {
        code: g.invalid_type,
        expected: O.undefined,
        received: Ui.parsedType
      }), A;
    }
    return ce(e.data);
  }
}
Nt.create = (Bi) => new Nt({
  typeName: C.ZodUndefined,
  ...P(Bi)
});
class Pt extends M {
  _parse(e) {
    if (this._getType(e) !== O.null) {
      const Ui = this._getOrReturnCtx(e);
      return w(Ui, {
        code: g.invalid_type,
        expected: O.null,
        received: Ui.parsedType
      }), A;
    }
    return ce(e.data);
  }
}
Pt.create = (Bi) => new Pt({
  typeName: C.ZodNull,
  ...P(Bi)
});
class yt extends M {
  constructor() {
    super(...arguments), this._any = !0;
  }
  _parse(e) {
    return ce(e.data);
  }
}
yt.create = (Bi) => new yt({
  typeName: C.ZodAny,
  ...P(Bi)
});
class Ge extends M {
  constructor() {
    super(...arguments), this._unknown = !0;
  }
  _parse(e) {
    return ce(e.data);
  }
}
Ge.create = (Bi) => new Ge({
  typeName: C.ZodUnknown,
  ...P(Bi)
});
class Ce extends M {
  _parse(e) {
    const Ui = this._getOrReturnCtx(e);
    return w(Ui, {
      code: g.invalid_type,
      expected: O.never,
      received: Ui.parsedType
    }), A;
  }
}
Ce.create = (Bi) => new Ce({
  typeName: C.ZodNever,
  ...P(Bi)
});
class dr extends M {
  _parse(e) {
    if (this._getType(e) !== O.undefined) {
      const Ui = this._getOrReturnCtx(e);
      return w(Ui, {
        code: g.invalid_type,
        expected: O.void,
        received: Ui.parsedType
      }), A;
    }
    return ce(e.data);
  }
}
dr.create = (Bi) => new dr({
  typeName: C.ZodVoid,
  ...P(Bi)
});
class me extends M {
  _parse(e) {
    const { ctx: Ui, status: Zi } = this._processInputParams(e), ta = this._def;
    if (Ui.parsedType !== O.array)
      return w(Ui, {
        code: g.invalid_type,
        expected: O.array,
        received: Ui.parsedType
      }), A;
    if (ta.exactLength !== null) {
      const ia = Ui.data.length > ta.exactLength.value, aa = Ui.data.length < ta.exactLength.value;
      (ia || aa) && (w(Ui, {
        code: ia ? g.too_big : g.too_small,
        minimum: aa ? ta.exactLength.value : void 0,
        maximum: ia ? ta.exactLength.value : void 0,
        type: "array",
        inclusive: !0,
        exact: !0,
        message: ta.exactLength.message
      }), Zi.dirty());
    }
    if (ta.minLength !== null && Ui.data.length < ta.minLength.value && (w(Ui, {
      code: g.too_small,
      minimum: ta.minLength.value,
      type: "array",
      inclusive: !0,
      exact: !1,
      message: ta.minLength.message
    }), Zi.dirty()), ta.maxLength !== null && Ui.data.length > ta.maxLength.value && (w(Ui, {
      code: g.too_big,
      maximum: ta.maxLength.value,
      type: "array",
      inclusive: !0,
      exact: !1,
      message: ta.maxLength.message
    }), Zi.dirty()), Ui.common.async)
      return Promise.all([...Ui.data].map((ia, aa) => ta.type._parseAsync(new Oe(Ui, ia, Ui.path, aa)))).then((ia) => oe.mergeArray(Zi, ia));
    const na = [...Ui.data].map((ia, aa) => ta.type._parseSync(new Oe(Ui, ia, Ui.path, aa)));
    return oe.mergeArray(Zi, na);
  }
  get element() {
    return this._def.type;
  }
  min(e, Ui) {
    return new me({
      ...this._def,
      minLength: { value: e, message: T.toString(Ui) }
    });
  }
  max(e, Ui) {
    return new me({
      ...this._def,
      maxLength: { value: e, message: T.toString(Ui) }
    });
  }
  length(e, Ui) {
    return new me({
      ...this._def,
      exactLength: { value: e, message: T.toString(Ui) }
    });
  }
  nonempty(e) {
    return this.min(1, e);
  }
}
me.create = (Bi, e) => new me({
  type: Bi,
  minLength: null,
  maxLength: null,
  exactLength: null,
  typeName: C.ZodArray,
  ...P(e)
});
function nt(Bi) {
  if (Bi instanceof H) {
    const e = {};
    for (const Ui in Bi.shape) {
      const Zi = Bi.shape[Ui];
      e[Ui] = Se.create(nt(Zi));
    }
    return new H({
      ...Bi._def,
      shape: () => e
    });
  } else return Bi instanceof me ? new me({
    ...Bi._def,
    type: nt(Bi.element)
  }) : Bi instanceof Se ? Se.create(nt(Bi.unwrap())) : Bi instanceof Ue ? Ue.create(nt(Bi.unwrap())) : Bi instanceof xe ? xe.create(Bi.items.map((e) => nt(e))) : Bi;
}
class H extends M {
  constructor() {
    super(...arguments), this._cached = null, this.nonstrict = this.passthrough, this.augment = this.extend;
  }
  _getCached() {
    if (this._cached !== null)
      return this._cached;
    const e = this._def.shape(), Ui = Q.objectKeys(e);
    return this._cached = { shape: e, keys: Ui };
  }
  _parse(e) {
    if (this._getType(e) !== O.object) {
      const da = this._getOrReturnCtx(e);
      return w(da, {
        code: g.invalid_type,
        expected: O.object,
        received: da.parsedType
      }), A;
    }
    const { status: Ui, ctx: Zi } = this._processInputParams(e), { shape: ta, keys: na } = this._getCached(), ia = [];
    if (!(this._def.catchall instanceof Ce && this._def.unknownKeys === "strip"))
      for (const da in Zi.data)
        na.includes(da) || ia.push(da);
    const aa = [];
    for (const da of na) {
      const La = ta[da], qa = Zi.data[da];
      aa.push({
        key: { status: "valid", value: da },
        value: La._parse(new Oe(Zi, qa, Zi.path, da)),
        alwaysSet: da in Zi.data
      });
    }
    if (this._def.catchall instanceof Ce) {
      const da = this._def.unknownKeys;
      if (da === "passthrough")
        for (const La of ia)
          aa.push({
            key: { status: "valid", value: La },
            value: { status: "valid", value: Zi.data[La] }
          });
      else if (da === "strict")
        ia.length > 0 && (w(Zi, {
          code: g.unrecognized_keys,
          keys: ia
        }), Ui.dirty());
      else if (da !== "strip") throw new Error("Internal ZodObject error: invalid unknownKeys value.");
    } else {
      const da = this._def.catchall;
      for (const La of ia) {
        const qa = Zi.data[La];
        aa.push({
          key: { status: "valid", value: La },
          value: da._parse(
            new Oe(Zi, qa, Zi.path, La)
            //, ctx.child(key), value, getParsedType(value)
          ),
          alwaysSet: La in Zi.data
        });
      }
    }
    return Zi.common.async ? Promise.resolve().then(async () => {
      const da = [];
      for (const La of aa) {
        const qa = await La.key, io = await La.value;
        da.push({
          key: qa,
          value: io,
          alwaysSet: La.alwaysSet
        });
      }
      return da;
    }).then((da) => oe.mergeObjectSync(Ui, da)) : oe.mergeObjectSync(Ui, aa);
  }
  get shape() {
    return this._def.shape();
  }
  strict(e) {
    return T.errToObj, new H({
      ...this._def,
      unknownKeys: "strict",
      ...e !== void 0 ? {
        errorMap: (Ui, Zi) => {
          var ta, na, ia, aa;
          const da = (ia = (na = (ta = this._def).errorMap) === null || na === void 0 ? void 0 : na.call(ta, Ui, Zi).message) !== null && ia !== void 0 ? ia : Zi.defaultError;
          return Ui.code === "unrecognized_keys" ? {
            message: (aa = T.errToObj(e).message) !== null && aa !== void 0 ? aa : da
          } : {
            message: da
          };
        }
      } : {}
    });
  }
  strip() {
    return new H({
      ...this._def,
      unknownKeys: "strip"
    });
  }
  passthrough() {
    return new H({
      ...this._def,
      unknownKeys: "passthrough"
    });
  }
  // const AugmentFactory =
  //   <Def extends ZodObjectDef>(def: Def) =>
  //   <Augmentation extends ZodRawShape>(
  //     augmentation: Augmentation
  //   ): ZodObject<
  //     extendShape<ReturnType<Def["shape"]>, Augmentation>,
  //     Def["unknownKeys"],
  //     Def["catchall"]
  //   > => {
  //     return new ZodObject({
  //       ...def,
  //       shape: () => ({
  //         ...def.shape(),
  //         ...augmentation,
  //       }),
  //     }) as any;
  //   };
  extend(e) {
    return new H({
      ...this._def,
      shape: () => ({
        ...this._def.shape(),
        ...e
      })
    });
  }
  /**
   * Prior to zod@1.0.12 there was a bug in the
   * inferred type of merged objects. Please
   * upgrade if you are experiencing issues.
   */
  merge(e) {
    return new H({
      unknownKeys: e._def.unknownKeys,
      catchall: e._def.catchall,
      shape: () => ({
        ...this._def.shape(),
        ...e._def.shape()
      }),
      typeName: C.ZodObject
    });
  }
  // merge<
  //   Incoming extends AnyZodObject,
  //   Augmentation extends Incoming["shape"],
  //   NewOutput extends {
  //     [k in keyof Augmentation | keyof Output]: k extends keyof Augmentation
  //       ? Augmentation[k]["_output"]
  //       : k extends keyof Output
  //       ? Output[k]
  //       : never;
  //   },
  //   NewInput extends {
  //     [k in keyof Augmentation | keyof Input]: k extends keyof Augmentation
  //       ? Augmentation[k]["_input"]
  //       : k extends keyof Input
  //       ? Input[k]
  //       : never;
  //   }
  // >(
  //   merging: Incoming
  // ): ZodObject<
  //   extendShape<T, ReturnType<Incoming["_def"]["shape"]>>,
  //   Incoming["_def"]["unknownKeys"],
  //   Incoming["_def"]["catchall"],
  //   NewOutput,
  //   NewInput
  // > {
  //   const merged: any = new ZodObject({
  //     unknownKeys: merging._def.unknownKeys,
  //     catchall: merging._def.catchall,
  //     shape: () =>
  //       objectUtil.mergeShapes(this._def.shape(), merging._def.shape()),
  //     typeName: ZodFirstPartyTypeKind.ZodObject,
  //   }) as any;
  //   return merged;
  // }
  setKey(e, Ui) {
    return this.augment({ [e]: Ui });
  }
  // merge<Incoming extends AnyZodObject>(
  //   merging: Incoming
  // ): //ZodObject<T & Incoming["_shape"], UnknownKeys, Catchall> = (merging) => {
  // ZodObject<
  //   extendShape<T, ReturnType<Incoming["_def"]["shape"]>>,
  //   Incoming["_def"]["unknownKeys"],
  //   Incoming["_def"]["catchall"]
  // > {
  //   // const mergedShape = objectUtil.mergeShapes(
  //   //   this._def.shape(),
  //   //   merging._def.shape()
  //   // );
  //   const merged: any = new ZodObject({
  //     unknownKeys: merging._def.unknownKeys,
  //     catchall: merging._def.catchall,
  //     shape: () =>
  //       objectUtil.mergeShapes(this._def.shape(), merging._def.shape()),
  //     typeName: ZodFirstPartyTypeKind.ZodObject,
  //   }) as any;
  //   return merged;
  // }
  catchall(e) {
    return new H({
      ...this._def,
      catchall: e
    });
  }
  pick(e) {
    const Ui = {};
    return Q.objectKeys(e).forEach((Zi) => {
      e[Zi] && this.shape[Zi] && (Ui[Zi] = this.shape[Zi]);
    }), new H({
      ...this._def,
      shape: () => Ui
    });
  }
  omit(e) {
    const Ui = {};
    return Q.objectKeys(this.shape).forEach((Zi) => {
      e[Zi] || (Ui[Zi] = this.shape[Zi]);
    }), new H({
      ...this._def,
      shape: () => Ui
    });
  }
  /**
   * @deprecated
   */
  deepPartial() {
    return nt(this);
  }
  partial(e) {
    const Ui = {};
    return Q.objectKeys(this.shape).forEach((Zi) => {
      const ta = this.shape[Zi];
      e && !e[Zi] ? Ui[Zi] = ta : Ui[Zi] = ta.optional();
    }), new H({
      ...this._def,
      shape: () => Ui
    });
  }
  required(e) {
    const Ui = {};
    return Q.objectKeys(this.shape).forEach((Zi) => {
      if (e && !e[Zi])
        Ui[Zi] = this.shape[Zi];
      else {
        let ta = this.shape[Zi];
        for (; ta instanceof Se; )
          ta = ta._def.innerType;
        Ui[Zi] = ta;
      }
    }), new H({
      ...this._def,
      shape: () => Ui
    });
  }
  keyof() {
    return $a(Q.objectKeys(this.shape));
  }
}
H.create = (Bi, e) => new H({
  shape: () => Bi,
  unknownKeys: "strip",
  catchall: Ce.create(),
  typeName: C.ZodObject,
  ...P(e)
});
H.strictCreate = (Bi, e) => new H({
  shape: () => Bi,
  unknownKeys: "strict",
  catchall: Ce.create(),
  typeName: C.ZodObject,
  ...P(e)
});
H.lazycreate = (Bi, e) => new H({
  shape: Bi,
  unknownKeys: "strip",
  catchall: Ce.create(),
  typeName: C.ZodObject,
  ...P(e)
});
class Ft extends M {
  _parse(e) {
    const { ctx: Ui } = this._processInputParams(e), Zi = this._def.options;
    function ta(na) {
      for (const aa of na)
        if (aa.result.status === "valid")
          return aa.result;
      for (const aa of na)
        if (aa.result.status === "dirty")
          return Ui.common.issues.push(...aa.ctx.common.issues), aa.result;
      const ia = na.map((aa) => new de(aa.ctx.common.issues));
      return w(Ui, {
        code: g.invalid_union,
        unionErrors: ia
      }), A;
    }
    if (Ui.common.async)
      return Promise.all(Zi.map(async (na) => {
        const ia = {
          ...Ui,
          common: {
            ...Ui.common,
            issues: []
          },
          parent: null
        };
        return {
          result: await na._parseAsync({
            data: Ui.data,
            path: Ui.path,
            parent: ia
          }),
          ctx: ia
        };
      })).then(ta);
    {
      let na;
      const ia = [];
      for (const da of Zi) {
        const La = {
          ...Ui,
          common: {
            ...Ui.common,
            issues: []
          },
          parent: null
        }, qa = da._parseSync({
          data: Ui.data,
          path: Ui.path,
          parent: La
        });
        if (qa.status === "valid")
          return qa;
        qa.status === "dirty" && !na && (na = { result: qa, ctx: La }), La.common.issues.length && ia.push(La.common.issues);
      }
      if (na)
        return Ui.common.issues.push(...na.ctx.common.issues), na.result;
      const aa = ia.map((da) => new de(da));
      return w(Ui, {
        code: g.invalid_union,
        unionErrors: aa
      }), A;
    }
  }
  get options() {
    return this._def.options;
  }
}
Ft.create = (Bi, e) => new Ft({
  options: Bi,
  typeName: C.ZodUnion,
  ...P(e)
});
const Ie = (Bi) => Bi instanceof Lt ? Ie(Bi.schema) : Bi instanceof ge ? Ie(Bi.innerType()) : Bi instanceof qt ? [Bi.value] : Bi instanceof Be ? Bi.options : Bi instanceof Qt ? Q.objectValues(Bi.enum) : Bi instanceof Bt ? Ie(Bi._def.innerType) : Bi instanceof Nt ? [void 0] : Bi instanceof Pt ? [null] : Bi instanceof Se ? [void 0, ...Ie(Bi.unwrap())] : Bi instanceof Ue ? [null, ...Ie(Bi.unwrap())] : Bi instanceof Un || Bi instanceof Zt ? Ie(Bi.unwrap()) : Bi instanceof Ut ? Ie(Bi._def.innerType) : [];
class Er extends M {
  _parse(e) {
    const { ctx: Ui } = this._processInputParams(e);
    if (Ui.parsedType !== O.object)
      return w(Ui, {
        code: g.invalid_type,
        expected: O.object,
        received: Ui.parsedType
      }), A;
    const Zi = this.discriminator, ta = Ui.data[Zi], na = this.optionsMap.get(ta);
    return na ? Ui.common.async ? na._parseAsync({
      data: Ui.data,
      path: Ui.path,
      parent: Ui
    }) : na._parseSync({
      data: Ui.data,
      path: Ui.path,
      parent: Ui
    }) : (w(Ui, {
      code: g.invalid_union_discriminator,
      options: Array.from(this.optionsMap.keys()),
      path: [Zi]
    }), A);
  }
  get discriminator() {
    return this._def.discriminator;
  }
  get options() {
    return this._def.options;
  }
  get optionsMap() {
    return this._def.optionsMap;
  }
  /**
   * The constructor of the discriminated union schema. Its behaviour is very similar to that of the normal z.union() constructor.
   * However, it only allows a union of objects, all of which need to share a discriminator property. This property must
   * have a different value for each object in the union.
   * @param discriminator the name of the discriminator property
   * @param types an array of object schemas
   * @param params
   */
  static create(e, Ui, Zi) {
    const ta = /* @__PURE__ */ new Map();
    for (const na of Ui) {
      const ia = Ie(na.shape[e]);
      if (!ia.length)
        throw new Error(`A discriminator value for key \`${e}\` could not be extracted from all schema options`);
      for (const aa of ia) {
        if (ta.has(aa))
          throw new Error(`Discriminator property ${String(e)} has duplicate value ${String(aa)}`);
        ta.set(aa, na);
      }
    }
    return new Er({
      typeName: C.ZodDiscriminatedUnion,
      discriminator: e,
      options: Ui,
      optionsMap: ta,
      ...P(Zi)
    });
  }
}
function vn(Bi, e) {
  const Ui = Re(Bi), Zi = Re(e);
  if (Bi === e)
    return { valid: !0, data: Bi };
  if (Ui === O.object && Zi === O.object) {
    const ta = Q.objectKeys(e), na = Q.objectKeys(Bi).filter((aa) => ta.indexOf(aa) !== -1), ia = { ...Bi, ...e };
    for (const aa of na) {
      const da = vn(Bi[aa], e[aa]);
      if (!da.valid)
        return { valid: !1 };
      ia[aa] = da.data;
    }
    return { valid: !0, data: ia };
  } else if (Ui === O.array && Zi === O.array) {
    if (Bi.length !== e.length)
      return { valid: !1 };
    const ta = [];
    for (let na = 0; na < Bi.length; na++) {
      const ia = Bi[na], aa = e[na], da = vn(ia, aa);
      if (!da.valid)
        return { valid: !1 };
      ta.push(da.data);
    }
    return { valid: !0, data: ta };
  } else return Ui === O.date && Zi === O.date && +Bi == +e ? { valid: !0, data: Bi } : { valid: !1 };
}
class Mt extends M {
  _parse(e) {
    const { status: Ui, ctx: Zi } = this._processInputParams(e), ta = (na, ia) => {
      if (pn(na) || pn(ia))
        return A;
      const aa = vn(na.value, ia.value);
      return aa.valid ? ((yn(na) || yn(ia)) && Ui.dirty(), { status: Ui.value, value: aa.data }) : (w(Zi, {
        code: g.invalid_intersection_types
      }), A);
    };
    return Zi.common.async ? Promise.all([
      this._def.left._parseAsync({
        data: Zi.data,
        path: Zi.path,
        parent: Zi
      }),
      this._def.right._parseAsync({
        data: Zi.data,
        path: Zi.path,
        parent: Zi
      })
    ]).then(([na, ia]) => ta(na, ia)) : ta(this._def.left._parseSync({
      data: Zi.data,
      path: Zi.path,
      parent: Zi
    }), this._def.right._parseSync({
      data: Zi.data,
      path: Zi.path,
      parent: Zi
    }));
  }
}
Mt.create = (Bi, e, Ui) => new Mt({
  left: Bi,
  right: e,
  typeName: C.ZodIntersection,
  ...P(Ui)
});
class xe extends M {
  _parse(e) {
    const { status: Ui, ctx: Zi } = this._processInputParams(e);
    if (Zi.parsedType !== O.array)
      return w(Zi, {
        code: g.invalid_type,
        expected: O.array,
        received: Zi.parsedType
      }), A;
    if (Zi.data.length < this._def.items.length)
      return w(Zi, {
        code: g.too_small,
        minimum: this._def.items.length,
        inclusive: !0,
        exact: !1,
        type: "array"
      }), A;
    !this._def.rest && Zi.data.length > this._def.items.length && (w(Zi, {
      code: g.too_big,
      maximum: this._def.items.length,
      inclusive: !0,
      exact: !1,
      type: "array"
    }), Ui.dirty());
    const ta = [...Zi.data].map((na, ia) => {
      const aa = this._def.items[ia] || this._def.rest;
      return aa ? aa._parse(new Oe(Zi, na, Zi.path, ia)) : null;
    }).filter((na) => !!na);
    return Zi.common.async ? Promise.all(ta).then((na) => oe.mergeArray(Ui, na)) : oe.mergeArray(Ui, ta);
  }
  get items() {
    return this._def.items;
  }
  rest(e) {
    return new xe({
      ...this._def,
      rest: e
    });
  }
}
xe.create = (Bi, e) => {
  if (!Array.isArray(Bi))
    throw new Error("You must pass an array of schemas to z.tuple([ ... ])");
  return new xe({
    items: Bi,
    typeName: C.ZodTuple,
    rest: null,
    ...P(e)
  });
};
class Vt extends M {
  get keySchema() {
    return this._def.keyType;
  }
  get valueSchema() {
    return this._def.valueType;
  }
  _parse(e) {
    const { status: Ui, ctx: Zi } = this._processInputParams(e);
    if (Zi.parsedType !== O.object)
      return w(Zi, {
        code: g.invalid_type,
        expected: O.object,
        received: Zi.parsedType
      }), A;
    const ta = [], na = this._def.keyType, ia = this._def.valueType;
    for (const aa in Zi.data)
      ta.push({
        key: na._parse(new Oe(Zi, aa, Zi.path, aa)),
        value: ia._parse(new Oe(Zi, Zi.data[aa], Zi.path, aa)),
        alwaysSet: aa in Zi.data
      });
    return Zi.common.async ? oe.mergeObjectAsync(Ui, ta) : oe.mergeObjectSync(Ui, ta);
  }
  get element() {
    return this._def.valueType;
  }
  static create(e, Ui, Zi) {
    return Ui instanceof M ? new Vt({
      keyType: e,
      valueType: Ui,
      typeName: C.ZodRecord,
      ...P(Zi)
    }) : new Vt({
      keyType: ve.create(),
      valueType: e,
      typeName: C.ZodRecord,
      ...P(Ui)
    });
  }
}
class hr extends M {
  get keySchema() {
    return this._def.keyType;
  }
  get valueSchema() {
    return this._def.valueType;
  }
  _parse(e) {
    const { status: Ui, ctx: Zi } = this._processInputParams(e);
    if (Zi.parsedType !== O.map)
      return w(Zi, {
        code: g.invalid_type,
        expected: O.map,
        received: Zi.parsedType
      }), A;
    const ta = this._def.keyType, na = this._def.valueType, ia = [...Zi.data.entries()].map(([aa, da], La) => ({
      key: ta._parse(new Oe(Zi, aa, Zi.path, [La, "key"])),
      value: na._parse(new Oe(Zi, da, Zi.path, [La, "value"]))
    }));
    if (Zi.common.async) {
      const aa = /* @__PURE__ */ new Map();
      return Promise.resolve().then(async () => {
        for (const da of ia) {
          const La = await da.key, qa = await da.value;
          if (La.status === "aborted" || qa.status === "aborted")
            return A;
          (La.status === "dirty" || qa.status === "dirty") && Ui.dirty(), aa.set(La.value, qa.value);
        }
        return { status: Ui.value, value: aa };
      });
    } else {
      const aa = /* @__PURE__ */ new Map();
      for (const da of ia) {
        const La = da.key, qa = da.value;
        if (La.status === "aborted" || qa.status === "aborted")
          return A;
        (La.status === "dirty" || qa.status === "dirty") && Ui.dirty(), aa.set(La.value, qa.value);
      }
      return { status: Ui.value, value: aa };
    }
  }
}
hr.create = (Bi, e, Ui) => new hr({
  valueType: e,
  keyType: Bi,
  typeName: C.ZodMap,
  ...P(Ui)
});
class Xe extends M {
  _parse(e) {
    const { status: Ui, ctx: Zi } = this._processInputParams(e);
    if (Zi.parsedType !== O.set)
      return w(Zi, {
        code: g.invalid_type,
        expected: O.set,
        received: Zi.parsedType
      }), A;
    const ta = this._def;
    ta.minSize !== null && Zi.data.size < ta.minSize.value && (w(Zi, {
      code: g.too_small,
      minimum: ta.minSize.value,
      type: "set",
      inclusive: !0,
      exact: !1,
      message: ta.minSize.message
    }), Ui.dirty()), ta.maxSize !== null && Zi.data.size > ta.maxSize.value && (w(Zi, {
      code: g.too_big,
      maximum: ta.maxSize.value,
      type: "set",
      inclusive: !0,
      exact: !1,
      message: ta.maxSize.message
    }), Ui.dirty());
    const na = this._def.valueType;
    function ia(da) {
      const La = /* @__PURE__ */ new Set();
      for (const qa of da) {
        if (qa.status === "aborted")
          return A;
        qa.status === "dirty" && Ui.dirty(), La.add(qa.value);
      }
      return { status: Ui.value, value: La };
    }
    const aa = [...Zi.data.values()].map((da, La) => na._parse(new Oe(Zi, da, Zi.path, La)));
    return Zi.common.async ? Promise.all(aa).then((da) => ia(da)) : ia(aa);
  }
  min(e, Ui) {
    return new Xe({
      ...this._def,
      minSize: { value: e, message: T.toString(Ui) }
    });
  }
  max(e, Ui) {
    return new Xe({
      ...this._def,
      maxSize: { value: e, message: T.toString(Ui) }
    });
  }
  size(e, Ui) {
    return this.min(e, Ui).max(e, Ui);
  }
  nonempty(e) {
    return this.min(1, e);
  }
}
Xe.create = (Bi, e) => new Xe({
  valueType: Bi,
  minSize: null,
  maxSize: null,
  typeName: C.ZodSet,
  ...P(e)
});
class ct extends M {
  constructor() {
    super(...arguments), this.validate = this.implement;
  }
  _parse(e) {
    const { ctx: Ui } = this._processInputParams(e);
    if (Ui.parsedType !== O.function)
      return w(Ui, {
        code: g.invalid_type,
        expected: O.function,
        received: Ui.parsedType
      }), A;
    function Zi(aa, da) {
      return cr({
        data: aa,
        path: Ui.path,
        errorMaps: [
          Ui.common.contextualErrorMap,
          Ui.schemaErrorMap,
          ur(),
          pt
        ].filter((La) => !!La),
        issueData: {
          code: g.invalid_arguments,
          argumentsError: da
        }
      });
    }
    function ta(aa, da) {
      return cr({
        data: aa,
        path: Ui.path,
        errorMaps: [
          Ui.common.contextualErrorMap,
          Ui.schemaErrorMap,
          ur(),
          pt
        ].filter((La) => !!La),
        issueData: {
          code: g.invalid_return_type,
          returnTypeError: da
        }
      });
    }
    const na = { errorMap: Ui.common.contextualErrorMap }, ia = Ui.data;
    if (this._def.returns instanceof vt) {
      const aa = this;
      return ce(async function(...da) {
        const La = new de([]), qa = await aa._def.args.parseAsync(da, na).catch((ao) => {
          throw La.addIssue(Zi(da, ao)), La;
        }), io = await Reflect.apply(ia, this, qa);
        return await aa._def.returns._def.type.parseAsync(io, na).catch((ao) => {
          throw La.addIssue(ta(io, ao)), La;
        });
      });
    } else {
      const aa = this;
      return ce(function(...da) {
        const La = aa._def.args.safeParse(da, na);
        if (!La.success)
          throw new de([Zi(da, La.error)]);
        const qa = Reflect.apply(ia, this, La.data), io = aa._def.returns.safeParse(qa, na);
        if (!io.success)
          throw new de([ta(qa, io.error)]);
        return io.data;
      });
    }
  }
  parameters() {
    return this._def.args;
  }
  returnType() {
    return this._def.returns;
  }
  args(...e) {
    return new ct({
      ...this._def,
      args: xe.create(e).rest(Ge.create())
    });
  }
  returns(e) {
    return new ct({
      ...this._def,
      returns: e
    });
  }
  implement(e) {
    return this.parse(e);
  }
  strictImplement(e) {
    return this.parse(e);
  }
  static create(e, Ui, Zi) {
    return new ct({
      args: e || xe.create([]).rest(Ge.create()),
      returns: Ui || Ge.create(),
      typeName: C.ZodFunction,
      ...P(Zi)
    });
  }
}
class Lt extends M {
  get schema() {
    return this._def.getter();
  }
  _parse(e) {
    const { ctx: Ui } = this._processInputParams(e);
    return this._def.getter()._parse({ data: Ui.data, path: Ui.path, parent: Ui });
  }
}
Lt.create = (Bi, e) => new Lt({
  getter: Bi,
  typeName: C.ZodLazy,
  ...P(e)
});
class qt extends M {
  _parse(e) {
    if (e.data !== this._def.value) {
      const Ui = this._getOrReturnCtx(e);
      return w(Ui, {
        received: Ui.data,
        code: g.invalid_literal,
        expected: this._def.value
      }), A;
    }
    return { status: "valid", value: e.data };
  }
  get value() {
    return this._def.value;
  }
}
qt.create = (Bi, e) => new qt({
  value: Bi,
  typeName: C.ZodLiteral,
  ...P(e)
});
function $a(Bi, e) {
  return new Be({
    values: Bi,
    typeName: C.ZodEnum,
    ...P(e)
  });
}
class Be extends M {
  constructor() {
    super(...arguments), St.set(this, void 0);
  }
  _parse(e) {
    if (typeof e.data != "string") {
      const Ui = this._getOrReturnCtx(e), Zi = this._def.values;
      return w(Ui, {
        expected: Q.joinValues(Zi),
        received: Ui.parsedType,
        code: g.invalid_type
      }), A;
    }
    if (lr(this, St) || Ba(this, St, new Set(this._def.values)), !lr(this, St).has(e.data)) {
      const Ui = this._getOrReturnCtx(e), Zi = this._def.values;
      return w(Ui, {
        received: Ui.data,
        code: g.invalid_enum_value,
        options: Zi
      }), A;
    }
    return ce(e.data);
  }
  get options() {
    return this._def.values;
  }
  get enum() {
    const e = {};
    for (const Ui of this._def.values)
      e[Ui] = Ui;
    return e;
  }
  get Values() {
    const e = {};
    for (const Ui of this._def.values)
      e[Ui] = Ui;
    return e;
  }
  get Enum() {
    const e = {};
    for (const Ui of this._def.values)
      e[Ui] = Ui;
    return e;
  }
  extract(e, Ui = this._def) {
    return Be.create(e, {
      ...this._def,
      ...Ui
    });
  }
  exclude(e, Ui = this._def) {
    return Be.create(this.options.filter((Zi) => !e.includes(Zi)), {
      ...this._def,
      ...Ui
    });
  }
}
St = /* @__PURE__ */ new WeakMap();
Be.create = $a;
class Qt extends M {
  constructor() {
    super(...arguments), Ot.set(this, void 0);
  }
  _parse(e) {
    const Ui = Q.getValidEnumValues(this._def.values), Zi = this._getOrReturnCtx(e);
    if (Zi.parsedType !== O.string && Zi.parsedType !== O.number) {
      const ta = Q.objectValues(Ui);
      return w(Zi, {
        expected: Q.joinValues(ta),
        received: Zi.parsedType,
        code: g.invalid_type
      }), A;
    }
    if (lr(this, Ot) || Ba(this, Ot, new Set(Q.getValidEnumValues(this._def.values))), !lr(this, Ot).has(e.data)) {
      const ta = Q.objectValues(Ui);
      return w(Zi, {
        received: Zi.data,
        code: g.invalid_enum_value,
        options: ta
      }), A;
    }
    return ce(e.data);
  }
  get enum() {
    return this._def.values;
  }
}
Ot = /* @__PURE__ */ new WeakMap();
Qt.create = (Bi, e) => new Qt({
  values: Bi,
  typeName: C.ZodNativeEnum,
  ...P(e)
});
class vt extends M {
  unwrap() {
    return this._def.type;
  }
  _parse(e) {
    const { ctx: Ui } = this._processInputParams(e);
    if (Ui.parsedType !== O.promise && Ui.common.async === !1)
      return w(Ui, {
        code: g.invalid_type,
        expected: O.promise,
        received: Ui.parsedType
      }), A;
    const Zi = Ui.parsedType === O.promise ? Ui.data : Promise.resolve(Ui.data);
    return ce(Zi.then((ta) => this._def.type.parseAsync(ta, {
      path: Ui.path,
      errorMap: Ui.common.contextualErrorMap
    })));
  }
}
vt.create = (Bi, e) => new vt({
  type: Bi,
  typeName: C.ZodPromise,
  ...P(e)
});
class ge extends M {
  innerType() {
    return this._def.schema;
  }
  sourceType() {
    return this._def.schema._def.typeName === C.ZodEffects ? this._def.schema.sourceType() : this._def.schema;
  }
  _parse(e) {
    const { status: Ui, ctx: Zi } = this._processInputParams(e), ta = this._def.effect || null, na = {
      addIssue: (ia) => {
        w(Zi, ia), ia.fatal ? Ui.abort() : Ui.dirty();
      },
      get path() {
        return Zi.path;
      }
    };
    if (na.addIssue = na.addIssue.bind(na), ta.type === "preprocess") {
      const ia = ta.transform(Zi.data, na);
      if (Zi.common.async)
        return Promise.resolve(ia).then(async (aa) => {
          if (Ui.value === "aborted")
            return A;
          const da = await this._def.schema._parseAsync({
            data: aa,
            path: Zi.path,
            parent: Zi
          });
          return da.status === "aborted" ? A : da.status === "dirty" || Ui.value === "dirty" ? st(da.value) : da;
        });
      {
        if (Ui.value === "aborted")
          return A;
        const aa = this._def.schema._parseSync({
          data: ia,
          path: Zi.path,
          parent: Zi
        });
        return aa.status === "aborted" ? A : aa.status === "dirty" || Ui.value === "dirty" ? st(aa.value) : aa;
      }
    }
    if (ta.type === "refinement") {
      const ia = (aa) => {
        const da = ta.refinement(aa, na);
        if (Zi.common.async)
          return Promise.resolve(da);
        if (da instanceof Promise)
          throw new Error("Async refinement encountered during synchronous parse operation. Use .parseAsync instead.");
        return aa;
      };
      if (Zi.common.async === !1) {
        const aa = this._def.schema._parseSync({
          data: Zi.data,
          path: Zi.path,
          parent: Zi
        });
        return aa.status === "aborted" ? A : (aa.status === "dirty" && Ui.dirty(), ia(aa.value), { status: Ui.value, value: aa.value });
      } else
        return this._def.schema._parseAsync({ data: Zi.data, path: Zi.path, parent: Zi }).then((aa) => aa.status === "aborted" ? A : (aa.status === "dirty" && Ui.dirty(), ia(aa.value).then(() => ({ status: Ui.value, value: aa.value }))));
    }
    if (ta.type === "transform")
      if (Zi.common.async === !1) {
        const ia = this._def.schema._parseSync({
          data: Zi.data,
          path: Zi.path,
          parent: Zi
        });
        if (!Ye(ia))
          return ia;
        const aa = ta.transform(ia.value, na);
        if (aa instanceof Promise)
          throw new Error("Asynchronous transform encountered during synchronous parse operation. Use .parseAsync instead.");
        return { status: Ui.value, value: aa };
      } else
        return this._def.schema._parseAsync({ data: Zi.data, path: Zi.path, parent: Zi }).then((ia) => Ye(ia) ? Promise.resolve(ta.transform(ia.value, na)).then((aa) => ({ status: Ui.value, value: aa })) : ia);
    Q.assertNever(ta);
  }
}
ge.create = (Bi, e, Ui) => new ge({
  schema: Bi,
  typeName: C.ZodEffects,
  effect: e,
  ...P(Ui)
});
ge.createWithPreprocess = (Bi, e, Ui) => new ge({
  schema: e,
  effect: { type: "preprocess", transform: Bi },
  typeName: C.ZodEffects,
  ...P(Ui)
});
class Se extends M {
  _parse(e) {
    return this._getType(e) === O.undefined ? ce(void 0) : this._def.innerType._parse(e);
  }
  unwrap() {
    return this._def.innerType;
  }
}
Se.create = (Bi, e) => new Se({
  innerType: Bi,
  typeName: C.ZodOptional,
  ...P(e)
});
class Ue extends M {
  _parse(e) {
    return this._getType(e) === O.null ? ce(null) : this._def.innerType._parse(e);
  }
  unwrap() {
    return this._def.innerType;
  }
}
Ue.create = (Bi, e) => new Ue({
  innerType: Bi,
  typeName: C.ZodNullable,
  ...P(e)
});
class Bt extends M {
  _parse(e) {
    const { ctx: Ui } = this._processInputParams(e);
    let Zi = Ui.data;
    return Ui.parsedType === O.undefined && (Zi = this._def.defaultValue()), this._def.innerType._parse({
      data: Zi,
      path: Ui.path,
      parent: Ui
    });
  }
  removeDefault() {
    return this._def.innerType;
  }
}
Bt.create = (Bi, e) => new Bt({
  innerType: Bi,
  typeName: C.ZodDefault,
  defaultValue: typeof e.default == "function" ? e.default : () => e.default,
  ...P(e)
});
class Ut extends M {
  _parse(e) {
    const { ctx: Ui } = this._processInputParams(e), Zi = {
      ...Ui,
      common: {
        ...Ui.common,
        issues: []
      }
    }, ta = this._def.innerType._parse({
      data: Zi.data,
      path: Zi.path,
      parent: {
        ...Zi
      }
    });
    return Ct(ta) ? ta.then((na) => ({
      status: "valid",
      value: na.status === "valid" ? na.value : this._def.catchValue({
        get error() {
          return new de(Zi.common.issues);
        },
        input: Zi.data
      })
    })) : {
      status: "valid",
      value: ta.status === "valid" ? ta.value : this._def.catchValue({
        get error() {
          return new de(Zi.common.issues);
        },
        input: Zi.data
      })
    };
  }
  removeCatch() {
    return this._def.innerType;
  }
}
Ut.create = (Bi, e) => new Ut({
  innerType: Bi,
  typeName: C.ZodCatch,
  catchValue: typeof e.catch == "function" ? e.catch : () => e.catch,
  ...P(e)
});
class pr extends M {
  _parse(e) {
    if (this._getType(e) !== O.nan) {
      const Ui = this._getOrReturnCtx(e);
      return w(Ui, {
        code: g.invalid_type,
        expected: O.nan,
        received: Ui.parsedType
      }), A;
    }
    return { status: "valid", value: e.data };
  }
}
pr.create = (Bi) => new pr({
  typeName: C.ZodNaN,
  ...P(Bi)
});
const Mc = Symbol("zod_brand");
class Un extends M {
  _parse(e) {
    const { ctx: Ui } = this._processInputParams(e), Zi = Ui.data;
    return this._def.type._parse({
      data: Zi,
      path: Ui.path,
      parent: Ui
    });
  }
  unwrap() {
    return this._def.type;
  }
}
class Wt extends M {
  _parse(e) {
    const { status: Ui, ctx: Zi } = this._processInputParams(e);
    if (Zi.common.async)
      return (async () => {
        const ta = await this._def.in._parseAsync({
          data: Zi.data,
          path: Zi.path,
          parent: Zi
        });
        return ta.status === "aborted" ? A : ta.status === "dirty" ? (Ui.dirty(), st(ta.value)) : this._def.out._parseAsync({
          data: ta.value,
          path: Zi.path,
          parent: Zi
        });
      })();
    {
      const ta = this._def.in._parseSync({
        data: Zi.data,
        path: Zi.path,
        parent: Zi
      });
      return ta.status === "aborted" ? A : ta.status === "dirty" ? (Ui.dirty(), {
        status: "dirty",
        value: ta.value
      }) : this._def.out._parseSync({
        data: ta.value,
        path: Zi.path,
        parent: Zi
      });
    }
  }
  static create(e, Ui) {
    return new Wt({
      in: e,
      out: Ui,
      typeName: C.ZodPipeline
    });
  }
}
class Zt extends M {
  _parse(e) {
    const Ui = this._def.innerType._parse(e), Zi = (ta) => (Ye(ta) && (ta.value = Object.freeze(ta.value)), ta);
    return Ct(Ui) ? Ui.then((ta) => Zi(ta)) : Zi(Ui);
  }
  unwrap() {
    return this._def.innerType;
  }
}
Zt.create = (Bi, e) => new Zt({
  innerType: Bi,
  typeName: C.ZodReadonly,
  ...P(e)
});
function $i(Bi, e) {
  const Ui = typeof Bi == "function" ? Bi(e) : typeof Bi == "string" ? { message: Bi } : Bi;
  return typeof Ui == "string" ? { message: Ui } : Ui;
}
function Wa(Bi, e = {}, Ui) {
  return Bi ? yt.create().superRefine((Zi, ta) => {
    var na, ia;
    const aa = Bi(Zi);
    if (aa instanceof Promise)
      return aa.then((da) => {
        var La, qa;
        if (!da) {
          const io = $i(e, Zi), ao = (qa = (La = io.fatal) !== null && La !== void 0 ? La : Ui) !== null && qa !== void 0 ? qa : !0;
          ta.addIssue({ code: "custom", ...io, fatal: ao });
        }
      });
    if (!aa) {
      const da = $i(e, Zi), La = (ia = (na = da.fatal) !== null && na !== void 0 ? na : Ui) !== null && ia !== void 0 ? ia : !0;
      ta.addIssue({ code: "custom", ...da, fatal: La });
    }
  }) : yt.create();
}
const Vc = {
  object: H.lazycreate
};
var C;
(function(Bi) {
  Bi.ZodString = "ZodString", Bi.ZodNumber = "ZodNumber", Bi.ZodNaN = "ZodNaN", Bi.ZodBigInt = "ZodBigInt", Bi.ZodBoolean = "ZodBoolean", Bi.ZodDate = "ZodDate", Bi.ZodSymbol = "ZodSymbol", Bi.ZodUndefined = "ZodUndefined", Bi.ZodNull = "ZodNull", Bi.ZodAny = "ZodAny", Bi.ZodUnknown = "ZodUnknown", Bi.ZodNever = "ZodNever", Bi.ZodVoid = "ZodVoid", Bi.ZodArray = "ZodArray", Bi.ZodObject = "ZodObject", Bi.ZodUnion = "ZodUnion", Bi.ZodDiscriminatedUnion = "ZodDiscriminatedUnion", Bi.ZodIntersection = "ZodIntersection", Bi.ZodTuple = "ZodTuple", Bi.ZodRecord = "ZodRecord", Bi.ZodMap = "ZodMap", Bi.ZodSet = "ZodSet", Bi.ZodFunction = "ZodFunction", Bi.ZodLazy = "ZodLazy", Bi.ZodLiteral = "ZodLiteral", Bi.ZodEnum = "ZodEnum", Bi.ZodEffects = "ZodEffects", Bi.ZodNativeEnum = "ZodNativeEnum", Bi.ZodOptional = "ZodOptional", Bi.ZodNullable = "ZodNullable", Bi.ZodDefault = "ZodDefault", Bi.ZodCatch = "ZodCatch", Bi.ZodPromise = "ZodPromise", Bi.ZodBranded = "ZodBranded", Bi.ZodPipeline = "ZodPipeline", Bi.ZodReadonly = "ZodReadonly";
})(C || (C = {}));
const Lc = (Bi, e = {
  message: `Input not instance of ${Bi.name}`
}) => Wa((Ui) => Ui instanceof Bi, e), Ga = ve.create, Ja = qe.create, qc = pr.create, Qc = Qe.create, Ha = At.create, Bc = Ke.create, Uc = fr.create, Zc = Nt.create, zc = Pt.create, $c = yt.create, Wc = Ge.create, Gc = Ce.create, Jc = dr.create, Hc = me.create, Yc = H.create, Kc = H.strictCreate, Xc = Ft.create, el = Er.create, tl = Mt.create, rl = xe.create, nl = Vt.create, il = hr.create, al = Xe.create, sl = ct.create, ol = Lt.create, ul = qt.create, cl = Be.create, ll = Qt.create, fl = vt.create, Wi = ge.create, dl = Se.create, hl = Ue.create, pl = ge.createWithPreprocess, yl = Wt.create, vl = () => Ga().optional(), ml = () => Ja().optional(), gl = () => Ha().optional(), bl = {
  string: (Bi) => ve.create({ ...Bi, coerce: !0 }),
  number: (Bi) => qe.create({ ...Bi, coerce: !0 }),
  boolean: (Bi) => At.create({
    ...Bi,
    coerce: !0
  }),
  bigint: (Bi) => Qe.create({ ...Bi, coerce: !0 }),
  date: (Bi) => Ke.create({ ...Bi, coerce: !0 })
}, _l = A;
var l = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  defaultErrorMap: pt,
  setErrorMap: pc,
  getErrorMap: ur,
  makeIssue: cr,
  EMPTY_PATH: yc,
  addIssueToContext: w,
  ParseStatus: oe,
  INVALID: A,
  DIRTY: st,
  OK: ce,
  isAborted: pn,
  isDirty: yn,
  isValid: Ye,
  isAsync: Ct,
  get util() {
    return Q;
  },
  get objectUtil() {
    return hn;
  },
  ZodParsedType: O,
  getParsedType: Re,
  ZodType: M,
  datetimeRegex: za,
  ZodString: ve,
  ZodNumber: qe,
  ZodBigInt: Qe,
  ZodBoolean: At,
  ZodDate: Ke,
  ZodSymbol: fr,
  ZodUndefined: Nt,
  ZodNull: Pt,
  ZodAny: yt,
  ZodUnknown: Ge,
  ZodNever: Ce,
  ZodVoid: dr,
  ZodArray: me,
  ZodObject: H,
  ZodUnion: Ft,
  ZodDiscriminatedUnion: Er,
  ZodIntersection: Mt,
  ZodTuple: xe,
  ZodRecord: Vt,
  ZodMap: hr,
  ZodSet: Xe,
  ZodFunction: ct,
  ZodLazy: Lt,
  ZodLiteral: qt,
  ZodEnum: Be,
  ZodNativeEnum: Qt,
  ZodPromise: vt,
  ZodEffects: ge,
  ZodTransformer: ge,
  ZodOptional: Se,
  ZodNullable: Ue,
  ZodDefault: Bt,
  ZodCatch: Ut,
  ZodNaN: pr,
  BRAND: Mc,
  ZodBranded: Un,
  ZodPipeline: Wt,
  ZodReadonly: Zt,
  custom: Wa,
  Schema: M,
  ZodSchema: M,
  late: Vc,
  get ZodFirstPartyTypeKind() {
    return C;
  },
  coerce: bl,
  any: $c,
  array: Hc,
  bigint: Qc,
  boolean: Ha,
  date: Bc,
  discriminatedUnion: el,
  effect: Wi,
  enum: cl,
  function: sl,
  instanceof: Lc,
  intersection: tl,
  lazy: ol,
  literal: ul,
  map: il,
  nan: qc,
  nativeEnum: ll,
  never: Gc,
  null: zc,
  nullable: hl,
  number: Ja,
  object: Yc,
  oboolean: gl,
  onumber: ml,
  optional: dl,
  ostring: vl,
  pipeline: yl,
  preprocess: pl,
  promise: fl,
  record: nl,
  set: al,
  strictObject: Kc,
  string: Ga,
  symbol: Uc,
  transformer: Wi,
  tuple: rl,
  undefined: Zc,
  union: Xc,
  unknown: Wc,
  void: Jc,
  NEVER: _l,
  ZodIssueCode: g,
  quotelessJson: hc,
  ZodError: de
});
const Ya = l.object({
  id: l.string(),
  name: l.string(),
  slug: l.string(),
  status: l.enum(["PENDING", "COMPLETED", "FAILED", "CANCELLED"]),
  input: l.object({}).partial().passthrough(),
  output: l.object({}).partial().passthrough().nullable(),
  createdAt: l.string(),
  startedAt: l.string().nullable(),
  endedAt: l.string().nullable()
}).passthrough();
l.object({ analyses: l.array(Ya) }).passthrough();
l.object({
  name: l.string().min(1).max(100),
  outputLocation: l.object({ s3BucketId: l.number(), path: l.string().optional() }).passthrough(),
  analysisSchemaId: l.number().int().gt(0),
  version: l.number(),
  input: l.unknown()
}).passthrough();
l.object({
  analysisId: l.string().nullable(),
  analysisSlug: l.string().nullable(),
  success: l.boolean()
}).passthrough();
const Ka = l.object({ id: l.number(), name: l.string(), versions: l.array(l.number()) }).passthrough();
l.object({ analysisSchemas: l.array(Ka) }).passthrough();
const Zn = l.object({
  id: l.number(),
  name: l.string(),
  schema: l.object({}).partial().passthrough()
}).passthrough(), mn = l.object({ id: l.number(), name: l.string(), valueSchema: Zn }).passthrough(), Xa = l.object({
  analysisSchemaId: l.number(),
  version: l.number(),
  createdAt: l.string(),
  description: l.object({ short: l.string().nullable(), long: l.string().nullable() }).partial().passthrough(),
  inputs: l.array(mn),
  outputs: l.array(mn)
}).passthrough();
l.object({ versions: l.array(Xa) }).passthrough();
l.object({ logs: l.array(l.string()) }).passthrough();
const es = l.object({
  id: l.string(),
  name: l.string(),
  status: l.string(),
  analysisId: l.string(),
  startedAt: l.string(),
  endedAt: l.string(),
  memory: l.number(),
  vcpus: l.number(),
  cost: l.number()
}).passthrough();
l.object({ tasks: l.array(es) }).passthrough();
l.object({
  totalCost: l.number(),
  tasks: l.array(
    l.object({ name: l.string(), cost: l.number(), index: l.number() }).passthrough()
  ),
  runner: l.number()
}).passthrough();
const ts = l.object({
  analysisSchemaId: l.number(),
  version: l.number(),
  name: l.string()
}).passthrough();
l.object({ next: l.array(ts) }).passthrough();
l.object({ valueSchemas: l.array(Zn) }).passthrough();
const rs = l.enum([
  "ADMIN",
  "USER",
  "PROFESSOR",
  "PREMIUM_USER",
  "FREE_USER"
]), zn = l.enum([
  "admin",
  "credits_unlimited",
  "files_read",
  "keypair_read",
  "lab_create",
  "labmember_read",
  "labmember_write",
  "lab_read",
  "plexus_read",
  "plexus_write",
  "tinkerbox_launch",
  "tinkerbox_read",
  "user_update"
]), $n = l.object({
  id: l.string(),
  firstname: l.string().nullable(),
  lastname: l.string().nullable(),
  email: l.string().nullable(),
  keyPairId: l.number(),
  roles: l.array(rs),
  permissions: l.array(zn)
}).passthrough();
l.object({ user: $n }).partial().passthrough();
l.object({ email: l.string() }).passthrough();
l.object({ success: l.boolean() }).passthrough();
l.object({ otp: l.string() }).passthrough();
l.object({ success: l.boolean() }).passthrough();
const Fl = l.object({ success: l.boolean() }).passthrough();
l.object({ token: l.string() }).passthrough();
l.object({ token: l.string() }).passthrough();
l.object({ valid: l.boolean() }).passthrough();
l.object({ name: l.string(), permissions: l.array(zn) }).passthrough();
const ns = l.object({
  id: l.number(),
  instanceProfile: l.string().nullable(),
  securityGroup: l.string().nullable()
}).passthrough(), Gt = l.object({
  id: l.number(),
  name: l.string(),
  labId: l.number().nullish(),
  userId: l.string().nullish(),
  status: l.enum([
    "pending",
    "running",
    "stopping",
    "stopped",
    "shutting_down",
    "terminated"
  ]),
  ipAddress: l.string().nullish(),
  lastLogin: l.string().nullish(),
  keypairId: l.number().nullish()
}).passthrough();
l.object({
  infra: l.array(ns),
  keyPairs: l.array(l.string()),
  tinkerBoxes: l.array(Gt)
}).passthrough();
l.object({ count: l.number().gte(1).lte(15) }).passthrough();
l.object({
  firstname: l.string().min(1),
  lastname: l.string().min(1),
  email: l.string().email(),
  password: l.string().min(8)
}).passthrough();
l.object({ users: l.array($n) }).passthrough();
l.object({
  firstname: l.string().nullable(),
  lastname: l.string().nullable(),
  email: l.string().nullable()
}).partial().passthrough();
const is = l.object({ tinkerBox: Gt, keyMaterial: l.string() }).passthrough();
l.object({ tinkerBoxes: l.array(is) }).passthrough();
const as = l.object({
  labName: l.string(),
  ec2Cost: l.number(),
  s3Cost: l.number(),
  efsCost: l.number(),
  totalCost: l.number()
}).passthrough();
l.object({ clients: l.array(as) }).passthrough();
const ss = l.object({
  name: l.string(),
  labName: l.string(),
  usage: l.string(),
  cost: l.number()
}).passthrough();
l.object({ tinkerBoxes: l.array(ss) }).passthrough();
l.object({ tinkerboxes: l.array(Gt) }).passthrough();
l.object({ tinkerBox: Gt }).passthrough();
l.object({ name: l.string(), autoStop: l.boolean() }).passthrough();
const os = l.object({
  id: l.number(),
  date: l.string(),
  tinkerBoxName: l.string(),
  lastLoginDate: l.string().nullable(),
  lastCommandDate: l.string().nullable(),
  lastCommand: l.string().nullable(),
  activeProcesses: l.boolean(),
  status: l.enum([
    "pending",
    "running",
    "stopping",
    "stopped",
    "shutting_down",
    "terminated"
  ]),
  tinkerBoxId: l.number(),
  autoStop: l.boolean()
}).passthrough();
l.object({ allLastActivity: l.array(os) }).passthrough();
l.object({ name: l.string().nullable() }).partial().passthrough();
const us = l.object({
  id: l.number(),
  name: l.string(),
  s3BucketId: l.number(),
  keyPairId: l.number()
}).passthrough();
l.object({ labs: l.array(us) }).passthrough();
l.object({
  name: l.string(),
  numTinkerBoxes: l.number().optional().default(1)
}).passthrough();
l.object({ labId: l.number(), taskId: l.string() }).passthrough();
l.object({ id: l.string(), labId: l.number(), logs: l.string() }).passthrough();
const Wn = l.object({
  id: l.number(),
  labId: l.number(),
  userId: l.string(),
  role: l.enum(["OWNER", "MEMBER"]),
  user: l.object({
    firstname: l.string().nullable(),
    lastname: l.string().nullable(),
    email: l.string().nullable(),
    id: l.string()
  }).partial().passthrough()
}).passthrough();
l.object({ labMember: Wn.nullable() }).passthrough();
l.object({ labMembers: l.array(Wn) }).passthrough();
l.object({
  labMember: l.object({
    id: l.number().int(),
    labId: l.number().int(),
    userId: l.string(),
    role: l.enum(["OWNER", "MEMBER"])
  }).passthrough()
}).passthrough();
l.object({ role: l.string() }).passthrough();
l.object({ labMemberId: l.number(), role: l.string() }).passthrough();
l.object({ success: l.boolean() }).passthrough();
l.object({
  client_secret: l.string().nullable(),
  status: l.string().nullable(),
  payment_status: l.string()
}).passthrough();
l.object({ name: l.string(), email: l.string().email(), message: l.string() }).passthrough();
l.object({ path: l.string(), s3BucketId: l.number().optional() }).passthrough();
const pf = l.object({ success: l.boolean() }).passthrough(), yf = l.object({ url: l.string() }).passthrough(), cs = l.object({
  isFolder: l.boolean(),
  bucketId: l.number().optional(),
  path: l.string()
}).passthrough(), vf = l.object({ contents: l.array(cs) }).passthrough(), mf = l.object({ files: l.array(l.string()) }).passthrough();
l.object({
  buckets: l.array(
    l.object({
      id: l.number().int(),
      bucket: l.string(),
      region: l.string(),
      prefix: l.string().nullish()
    }).passthrough()
  )
}).passthrough();
l.object({
  source: l.object({
    isFolder: l.boolean(),
    bucketId: l.number().optional(),
    path: l.string()
  }).passthrough(),
  target: l.object({
    isFolder: l.boolean(),
    bucketId: l.number().optional(),
    path: l.string()
  }).passthrough()
}).passthrough();
const _f = l.object({
  fileTransfers: l.array(
    l.object({
      id: l.number().int(),
      name: l.string(),
      userId: l.string(),
      progress: l.number()
    }).passthrough()
  )
}).passthrough(), ls = l.object({
  id: l.number(),
  name: l.string(),
  analysisSchemaId: l.number(),
  analysisSchemaVersion: l.number(),
  config: l.object({}).partial().passthrough()
}).passthrough();
l.object({ templates: l.array(ls) }).passthrough();
l.object({
  name: l.string().min(1).max(255),
  analysisSchemaId: l.number().int(),
  analysisSchemaVersion: l.number().int().gt(0),
  triggerLocation: l.object({
    bucketId: l.number().int().gt(0),
    folderPath: l.string().max(2048)
  }).passthrough(),
  config: l.unknown()
}).passthrough();
l.object({
  id: l.number(),
  name: l.string(),
  s3BucketId: l.number(),
  triggerFolder: l.string(),
  analysisSchemaId: l.number(),
  analysisSchemaVersion: l.number(),
  config: l.object({}).partial().passthrough()
}).passthrough();
l.object({ name: l.string(), enabled: l.boolean() }).passthrough();
l.object({
  id: l.number(),
  name: l.string(),
  schema: l.object({}).partial().passthrough()
}).passthrough();
l.object({
  id: l.number(),
  formId: l.number(),
  data: l.object({}).partial().passthrough(),
  dateCreated: l.string()
}).passthrough();
l.object({
  id: l.number(),
  name: l.string(),
  displayName: l.string(),
  hichip: l.string(),
  source: l.string(),
  bucket: l.string(),
  bedpeKey: l.string(),
  hicKey: l.string(),
  category: l.string()
}).passthrough();
l.object({
  id: l.number(),
  sampleId: l.number(),
  cluster: l.string(),
  chr: l.string(),
  start: l.number(),
  end: l.number(),
  size: l.number(),
  genes: l.string()
}).passthrough();
l.object({
  plotId: l.string(),
  status: l.enum(["PENDING", "COMPLETED", "FAILED", "CANCELLED"]),
  outputBucket: l.string(),
  outputKey: l.string(),
  inputs: l.object({}).partial().passthrough(),
  endedAt: l.string().nullable(),
  downloadUrl: l.string().nullable()
}).passthrough();
l.object({
  sample: l.string(),
  range: l.string(),
  genomeBuild: l.enum(["hg19", "hg38"]),
  color: l.string().regex(/^#?([A-Fa-f0-9]{6}|[A-Fa-f0-9]{3})$/),
  inherent: l.string(),
  flank: l.number(),
  bedpe: l.string()
}).passthrough();
const Gn = l.object({
  id: l.number(),
  title: l.string(),
  content: l.string(),
  createdAt: l.string(),
  updatedAt: l.string(),
  isActive: l.boolean()
}).passthrough();
l.object({ announcements: l.array(Gn) }).passthrough();
l.object({ announcement: Gn.nullable() }).passthrough();
const Gi = {
  SuccessDto: Fl,
  CreateDirectoryResponse: pf,
  PresignedUrlResponse: yf,
  ContentsResponse: vf,
  DeleteFilesResponse: mf,
  FileTransfersResponse: _f
};
class Mf {
  constructor(e) {
    mt(this, "fetch"), this.fetch = e;
  }
  async download(e, Ui, Zi = null, ta = !0) {
    let na = `/files/presigned/${encodeURIComponent(Ui)}/url?method=download`;
    e && (na += `&bucket=${e}`), Zi && (na += `&limit=${Zi}`);
    const ia = (await this.fetch(
      na,
      { method: "GET" },
      Gi.PresignedUrlResponse
    )).url;
    if (ta) {
      const aa = document.createElement("a");
      aa.href = ia, aa.download = "", aa.target = "_blank", aa.click(), document.body.appendChild(aa), aa.click(), setTimeout(() => {
        document.body.removeChild(aa);
      });
    }
    return ia;
  }
  async upload(e, Ui, Zi) {
    const ta = [];
    let na = `/files/presigned/${encodeURIComponent(Zi)}/url?method=upload`;
    Ui && (na = na += `&bucket=${Ui}`);
    const ia = (await this.fetch(
      na,
      { method: "GET" },
      Gi.PresignedUrlResponse
    )).url, aa = new XMLHttpRequest();
    return aa.open("PUT", ia), aa.addEventListener("error", () => {
      for (const da of ta)
        da.onError(new Error("Failed to upload file"));
    }), aa.onerror = () => {
      for (const da of ta)
        da.onError(new Error("Failed to upload file"));
    }, aa.upload.addEventListener("progress", (da) => {
      const La = da.loaded / da.total;
      for (const qa of ta)
        qa.onProgress(La);
    }), aa.upload.addEventListener("load", () => {
      for (const da of ta)
        da.onComplete();
      aa.upload.removeEventListener("progress", () => null);
    }), aa.send(e), {
      subscribe(da) {
        ta.push(da);
      }
    };
  }
}
const Logo = ({ className: Bi = "" }) => /* @__PURE__ */ jsxRuntimeExports.jsx(
  "svg",
  {
    className: `${Bi} block`,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 260.81 296.2",
    children: /* @__PURE__ */ jsxRuntimeExports.jsx("g", { children: /* @__PURE__ */ jsxRuntimeExports.jsx("path", { d: "M64.3,112.5C28.5,174.6-.4,225.4,0,225.6s34.7-9.2,76.2-20.7,76.3-21.1,77.4-21.3c1.8-.3,2.3,2.8,9.6,56,4.2,31,7.8,56.5,8,56.6s20.5-15.2,45.2-34.3c29.3-22.7,44.6-35.1,44.4-36.1C260.2,223.6,131.2.4,130.2,0,129.8-.1,100.1,50.5,64.3,112.5Z" }) })
  }
);
function useErrorToast(Bi) {
  useEffect(() => {
    Bi && toast.error(Bi.toString());
  }, [Bi]);
}
async function createFolder(Bi, e, Ui) {
  await Bi(
    "/files/directory",
    {
      method: "POST",
      body: JSON.stringify({ s3BucketId: e, path: Ui })
    },
    Gi.CreateDirectoryResponse
  );
}
const useCreateFolder = (Bi) => {
  const e = useMutation({
    mutationKey: ["createFolder"],
    mutationFn: async (Ui) => createFolder(Bi, Ui.s3BucketId, Ui.path)
  });
  return { ...e, createFolder: e.mutateAsync };
};
async function deleteFiles(Bi, e, Ui) {
  let ta = `/files/${encodeURIComponent(e)}?`;
  return Ui && (ta += `&bucket=${Ui}`), await Bi(
    ta,
    { method: "DELETE" },
    Gi.DeleteFilesResponse
  );
}
const useDeleteFiles = (Bi) => {
  const e = useMutation({
    mutationKey: ["deleteFiles"],
    mutationFn: (Ui) => deleteFiles(Bi, Ui.path, Ui.s3BucketId)
  });
  return { ...e, deleteFiles: e.mutateAsync };
};
async function getFileTranfsers(Bi) {
  return Bi(
    "/file-transfer",
    { method: "GET" },
    Gi.FileTransfersResponse
  );
}
const useFileTransfersQuery = (Bi, e) => useQuery({
  queryKey: ["file-transfers"],
  queryFn: () => getFileTranfsers(e),
  refetchInterval: 500,
  enabled: Bi
}), searchFiles = async (Bi, e, Ui) => await Ui(
  `/files/?search=${e}&bucket=${Bi}`,
  {},
  Gi.ContentsResponse
), getFolderContents = async (Bi, e, Ui) => {
  let ta = `/files/${encodeURIComponent(e || "")}?`;
  return Bi && (ta += `bucket=${Bi}`), await Ui(ta, { method: "GET" }, Gi.ContentsResponse);
}, useFolderContentsQuery = (Bi, e, Ui) => useQuery({
  queryKey: ["files", Bi, e],
  queryFn: async () => getFolderContents(Bi, e, Ui),
  refetchInterval: 2e3
});
async function moveFiles(Bi, e, Ui) {
  return Ui(
    "/files/move",
    {
      method: "POST",
      body: JSON.stringify({ source: Bi, target: e })
    },
    Gi.SuccessDto
  );
}
function useMoveFilesMutation(Bi) {
  const e = useMutation({
    mutationKey: ["moveFiles"],
    mutationFn: ({ src: Ui, dest: Zi }) => moveFiles(Ui, Zi, Bi)
  });
  return { ...e, moveFiles: e.mutateAsync };
}
function _S3FileBrowser({
  s3BucketId: Bi,
  fetch: e,
  selectionMode: Ui,
  onSelectionChange: Zi,
  path: ta,
  setPath: na,
  readOnly: ia = !1,
  selection: aa = [],
  className: da = ""
}) {
  const La = ta.join("/"), { error: qa, refetch: io } = useFolderContentsQuery(
    Bi,
    La,
    e
  ), [ao, oo] = useState(!1), { createFolder: no } = useCreateFolder(e), { deleteFiles: lo, error: so } = useDeleteFiles(e), { moveFiles: bs, error: Rs } = useMoveFilesMutation(e), { data: js, error: qs } = useFileTransfersQuery(ao, e);
  useEffect(() => {
    js?.fileTransfers && js.fileTransfers.length > 0;
  }, [js]), useErrorToast(Rs), useErrorToast(qs), useFileTranfersProgress(js), useEffect(() => {
    qa && toast.error(qa.message), so && toast.error(so.message);
  }, [qa, so]);
  const jo = useFolderContentsQuery(
    Bi,
    La,
    e
  ), fs = jo.data?.contents ?? [];
  return /* @__PURE__ */ jsxRuntimeExports.jsx(
    FileBrowser,
    {
      className: da,
      selectionMode: Ui,
      filePathHomeDirectory: /* @__PURE__ */ jsxRuntimeExports.jsx(Logo, { className: "inline w-3 h-3" }),
      files: fs,
      loading: jo.isLoading,
      selection: aa,
      readOnly: ia,
      onSelectionChange: Zi,
      onDownload: async (Ao) => {
        await new Mf(e).download(Bi, Ao.path, null, !0), io();
      },
      path: ta,
      onMoveUpAFolder: async (Ao) => {
        if (!Ao) {
          toast.error("Already at root folder");
          return;
        }
        const { path: co, parent: Co } = Ao;
        await bs({
          src: co,
          dest: { isFolder: !0, path: Co, bucketId: co.bucketId }
        }), oo(!0), await io();
      },
      onNavigate: (Ao) => {
        na(Ao);
      },
      onMove: async (Ao, co) => {
        if (!co.isFolder) {
          toast.error("Target must be a folder");
          return;
        }
        await bs({ src: Ao, dest: co }), await io(), oo(!0);
      },
      onSearch: async (Ao) => {
        const co = await searchFiles(Bi, Ao, e);
        return console.log("searchFiles", co), co.contents;
      },
      onUpload: function(Ao) {
        const co = new Mf(e), Co = `${La}/${Ao[0].name}`;
        return co.upload(Ao[0], Bi, Co);
      },
      onDelete: async (Ao) => {
        await lo({ s3BucketId: Bi, path: Ao[0].path }), await io();
      },
      onCreateFolder: async (Ao) => {
        await no({ s3BucketId: Bi, path: Ao }), await io();
      },
      onPreview: async (Ao) => {
        await new Mf(e).download(Bi, Ao.path), io();
      }
    }
  );
}
const useFileTranfersProgress = (Bi) => {
  useEffect(() => {
    if (Bi?.fileTransfers.length)
      for (const e of Bi.fileTransfers)
        toast(e.name, {
          progress: e.progress,
          toastId: e.id
        });
  }, [Bi]);
};
function S3FileBrowser(Bi) {
  return /* @__PURE__ */ jsxRuntimeExports.jsx(QueryClientProvider, { client: Bi.queryClient, children: /* @__PURE__ */ jsxRuntimeExports.jsx(_S3FileBrowser, { ...Bi }) });
}
var getRandomValues, rnds8 = new Uint8Array(16);
function rng() {
  if (!getRandomValues && (getRandomValues = typeof crypto < "u" && crypto.getRandomValues && crypto.getRandomValues.bind(crypto) || typeof msCrypto < "u" && typeof msCrypto.getRandomValues == "function" && msCrypto.getRandomValues.bind(msCrypto), !getRandomValues))
    throw new Error("crypto.getRandomValues() not supported. See https://github.com/uuidjs/uuid#getrandomvalues-not-supported");
  return getRandomValues(rnds8);
}
const REGEX = /^(?:[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}|00000000-0000-0000-0000-000000000000)$/i;
function validate(Bi) {
  return typeof Bi == "string" && REGEX.test(Bi);
}
var byteToHex = [];
for (var i = 0; i < 256; ++i)
  byteToHex.push((i + 256).toString(16).substr(1));
function stringify(Bi) {
  var e = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0, Ui = (byteToHex[Bi[e + 0]] + byteToHex[Bi[e + 1]] + byteToHex[Bi[e + 2]] + byteToHex[Bi[e + 3]] + "-" + byteToHex[Bi[e + 4]] + byteToHex[Bi[e + 5]] + "-" + byteToHex[Bi[e + 6]] + byteToHex[Bi[e + 7]] + "-" + byteToHex[Bi[e + 8]] + byteToHex[Bi[e + 9]] + "-" + byteToHex[Bi[e + 10]] + byteToHex[Bi[e + 11]] + byteToHex[Bi[e + 12]] + byteToHex[Bi[e + 13]] + byteToHex[Bi[e + 14]] + byteToHex[Bi[e + 15]]).toLowerCase();
  if (!validate(Ui))
    throw TypeError("Stringified UUID is invalid");
  return Ui;
}
function v4(Bi, e, Ui) {
  Bi = Bi || {};
  var Zi = Bi.random || (Bi.rng || rng)();
  return Zi[6] = Zi[6] & 15 | 64, Zi[8] = Zi[8] & 63 | 128, stringify(Zi);
}
const fileListToArray = (Bi) => {
  const e = [];
  for (let Ui = 0; Ui < Bi.length; Ui++) {
    const Zi = Bi.item(Ui);
    Zi && e.push(Zi);
  }
  return e;
}, FileInput = ({
  children: Bi,
  onChange: e,
  className: Ui
}) => {
  const Zi = useRef(v4());
  return /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: `${Ui} cursor-pointer`, children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(
      "label",
      {
        htmlFor: Zi.current,
        onClick: (ta) => ta.stopPropagation(),
        className: "cursor-pointer",
        onKeyDown: (ta) => {
          ta.key === "Enter" && ta.stopPropagation();
        },
        children: Bi
      }
    ),
    /* @__PURE__ */ jsxRuntimeExports.jsx(
      "input",
      {
        onClick: (ta) => ta.stopPropagation(),
        onChange: (ta) => {
          e(ta.target.files ? fileListToArray(ta.target.files) : []);
        },
        className: "absolute w-0 h-0",
        type: "file",
        id: Zi.current
      }
    )
  ] });
}, FormikField = ({ name: Bi, ...e }) => {
  const [Ui, Zi] = useField(Bi), { capture: ta, ...na } = e;
  return /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(Field, { ...na, ...Ui, placeholder: e.placeholder || Bi }),
    Zi.touched && Zi.error && /* @__PURE__ */ jsxRuntimeExports.jsx(Error$1, { children: Zi.error })
  ] });
};
function GridArea({ area: Bi, children: e, className: Ui }) {
  return /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: `${Ui || ""}`, style: { gridArea: Bi }, children: e });
}
var reactResponsive$1 = { exports: {} }, reactResponsive = reactResponsive$1.exports, hasRequiredReactResponsive;
function requireReactResponsive() {
  return hasRequiredReactResponsive || (hasRequiredReactResponsive = 1, function(Bi, e) {
    (function(Zi, ta) {
      Bi.exports = ta(a__default);
    })(reactResponsive, (Ui) => (
      /******/
      (() => {
        var Zi = {
          /***/
          "./node_modules/css-mediaquery/index.js": (
            /*!**********************************************!*\
              !*** ./node_modules/css-mediaquery/index.js ***!
              \**********************************************/
            /***/
            (aa, da) => {
              da.match = no, da.parse = lo;
              var La = /(?:(only|not)?\s*([^\s\(\)]+)(?:\s*and)?\s*)?(.+)?/i, qa = /\(\s*([^\s\:\)]+)\s*(?:\:\s*([^\s\)]+))?\s*\)/, io = /^(?:(min|max)-)?(.+)/, ao = /(em|rem|px|cm|mm|in|pt|pc)?$/, oo = /(dpi|dpcm|dppx)?$/;
              function no(js, qs) {
                return lo(js).some(function(jo) {
                  var fs = jo.inverse, Ao = jo.type === "all" || qs.type === jo.type;
                  if (Ao && fs || !(Ao || fs))
                    return !1;
                  var co = jo.expressions.every(function(Co) {
                    var Zs = Co.feature, xl = Co.modifier, Cl = Co.value, Al = qs[Zs];
                    if (!Al)
                      return !1;
                    switch (Zs) {
                      case "orientation":
                      case "scan":
                        return Al.toLowerCase() === Cl.toLowerCase();
                      case "width":
                      case "height":
                      case "device-width":
                      case "device-height":
                        Cl = Rs(Cl), Al = Rs(Al);
                        break;
                      case "resolution":
                        Cl = bs(Cl), Al = bs(Al);
                        break;
                      case "aspect-ratio":
                      case "device-aspect-ratio":
                      case /* Deprecated */
                      "device-pixel-ratio":
                        Cl = so(Cl), Al = so(Al);
                        break;
                      case "grid":
                      case "color":
                      case "color-index":
                      case "monochrome":
                        Cl = parseInt(Cl, 10) || 1, Al = parseInt(Al, 10) || 0;
                        break;
                    }
                    switch (xl) {
                      case "min":
                        return Al >= Cl;
                      case "max":
                        return Al <= Cl;
                      default:
                        return Al === Cl;
                    }
                  });
                  return co && !fs || !co && fs;
                });
              }
              function lo(js) {
                return js.split(",").map(function(qs) {
                  qs = qs.trim();
                  var jo = qs.match(La), fs = jo[1], Ao = jo[2], co = jo[3] || "", Co = {};
                  return Co.inverse = !!fs && fs.toLowerCase() === "not", Co.type = Ao ? Ao.toLowerCase() : "all", co = co.match(/\([^\)]+\)/g) || [], Co.expressions = co.map(function(Zs) {
                    var xl = Zs.match(qa), Cl = xl[1].toLowerCase().match(io);
                    return {
                      modifier: Cl[1],
                      feature: Cl[2],
                      value: xl[2]
                    };
                  }), Co;
                });
              }
              function so(js) {
                var qs = Number(js), jo;
                return qs || (jo = js.match(/^(\d+)\s*\/\s*(\d+)$/), qs = jo[1] / jo[2]), qs;
              }
              function bs(js) {
                var qs = parseFloat(js), jo = String(js).match(oo)[1];
                switch (jo) {
                  case "dpcm":
                    return qs / 2.54;
                  case "dppx":
                    return qs * 96;
                  default:
                    return qs;
                }
              }
              function Rs(js) {
                var qs = parseFloat(js), jo = String(js).match(ao)[1];
                switch (jo) {
                  case "em":
                    return qs * 16;
                  case "rem":
                    return qs * 16;
                  case "cm":
                    return qs * 96 / 2.54;
                  case "mm":
                    return qs * 96 / 2.54 / 10;
                  case "in":
                    return qs * 96;
                  case "pt":
                    return qs * 72;
                  case "pc":
                    return qs * 72 / 12;
                  default:
                    return qs;
                }
              }
            }
          ),
          /***/
          "./node_modules/hyphenate-style-name/index.js": (
            /*!****************************************************!*\
              !*** ./node_modules/hyphenate-style-name/index.js ***!
              \****************************************************/
            /***/
            (aa, da, La) => {
              La.r(da), La.d(da, {
                /* harmony export */
                default: () => lo
                /* harmony export */
              });
              var qa = /[A-Z]/g, io = /^ms-/, ao = {};
              function oo(so) {
                return "-" + so.toLowerCase();
              }
              function no(so) {
                if (ao.hasOwnProperty(so))
                  return ao[so];
                var bs = so.replace(qa, oo);
                return ao[so] = io.test(bs) ? "-" + bs : bs;
              }
              const lo = no;
            }
          ),
          /***/
          "./node_modules/matchmediaquery/index.js": (
            /*!***********************************************!*\
              !*** ./node_modules/matchmediaquery/index.js ***!
              \***********************************************/
            /***/
            (aa, da, La) => {
              var qa = La(
                /*! css-mediaquery */
                "./node_modules/css-mediaquery/index.js"
              ).match, io = typeof window < "u" ? window.matchMedia : null;
              function ao(no, lo, so) {
                var bs = this;
                if (io && !so) {
                  var Rs = io.call(window, no);
                  this.matches = Rs.matches, this.media = Rs.media, Rs.addListener(jo);
                } else
                  this.matches = qa(no, lo), this.media = no;
                this.addListener = js, this.removeListener = qs, this.dispose = fs;
                function js(Ao) {
                  Rs && Rs.addListener(Ao);
                }
                function qs(Ao) {
                  Rs && Rs.removeListener(Ao);
                }
                function jo(Ao) {
                  bs.matches = Ao.matches, bs.media = Ao.media;
                }
                function fs() {
                  Rs && Rs.removeListener(jo);
                }
              }
              function oo(no, lo, so) {
                return new ao(no, lo, so);
              }
              aa.exports = oo;
            }
          ),
          /***/
          "./node_modules/object-assign/index.js": (
            /*!*********************************************!*\
              !*** ./node_modules/object-assign/index.js ***!
              \*********************************************/
            /***/
            (aa) => {
              /*
              object-assign
              (c) Sindre Sorhus
              @license MIT
              */
              var da = Object.getOwnPropertySymbols, La = Object.prototype.hasOwnProperty, qa = Object.prototype.propertyIsEnumerable;
              function io(oo) {
                if (oo == null)
                  throw new TypeError("Object.assign cannot be called with null or undefined");
                return Object(oo);
              }
              function ao() {
                try {
                  if (!Object.assign)
                    return !1;
                  var oo = new String("abc");
                  if (oo[5] = "de", Object.getOwnPropertyNames(oo)[0] === "5")
                    return !1;
                  for (var no = {}, lo = 0; lo < 10; lo++)
                    no["_" + String.fromCharCode(lo)] = lo;
                  var so = Object.getOwnPropertyNames(no).map(function(Rs) {
                    return no[Rs];
                  });
                  if (so.join("") !== "0123456789")
                    return !1;
                  var bs = {};
                  return "abcdefghijklmnopqrst".split("").forEach(function(Rs) {
                    bs[Rs] = Rs;
                  }), Object.keys(Object.assign({}, bs)).join("") === "abcdefghijklmnopqrst";
                } catch {
                  return !1;
                }
              }
              aa.exports = ao() ? Object.assign : function(oo, no) {
                for (var lo, so = io(oo), bs, Rs = 1; Rs < arguments.length; Rs++) {
                  lo = Object(arguments[Rs]);
                  for (var js in lo)
                    La.call(lo, js) && (so[js] = lo[js]);
                  if (da) {
                    bs = da(lo);
                    for (var qs = 0; qs < bs.length; qs++)
                      qa.call(lo, bs[qs]) && (so[bs[qs]] = lo[bs[qs]]);
                  }
                }
                return so;
              };
            }
          ),
          /***/
          "./node_modules/prop-types/checkPropTypes.js": (
            /*!***************************************************!*\
              !*** ./node_modules/prop-types/checkPropTypes.js ***!
              \***************************************************/
            /***/
            (aa, da, La) => {
              var qa = function() {
              };
              {
                var io = La(
                  /*! ./lib/ReactPropTypesSecret */
                  "./node_modules/prop-types/lib/ReactPropTypesSecret.js"
                ), ao = {}, oo = La(
                  /*! ./lib/has */
                  "./node_modules/prop-types/lib/has.js"
                );
                qa = function(lo) {
                  var so = "Warning: " + lo;
                  typeof console < "u" && console.error(so);
                  try {
                    throw new Error(so);
                  } catch {
                  }
                };
              }
              function no(lo, so, bs, Rs, js) {
                for (var qs in lo)
                  if (oo(lo, qs)) {
                    var jo;
                    try {
                      if (typeof lo[qs] != "function") {
                        var fs = Error(
                          (Rs || "React class") + ": " + bs + " type `" + qs + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof lo[qs] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`."
                        );
                        throw fs.name = "Invariant Violation", fs;
                      }
                      jo = lo[qs](so, qs, Rs, bs, null, io);
                    } catch (co) {
                      jo = co;
                    }
                    if (jo && !(jo instanceof Error) && qa(
                      (Rs || "React class") + ": type specification of " + bs + " `" + qs + "` is invalid; the type checker function must return `null` or an `Error` but returned a " + typeof jo + ". You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument)."
                    ), jo instanceof Error && !(jo.message in ao)) {
                      ao[jo.message] = !0;
                      var Ao = js ? js() : "";
                      qa(
                        "Failed " + bs + " type: " + jo.message + (Ao ?? "")
                      );
                    }
                  }
              }
              no.resetWarningCache = function() {
                ao = {};
              }, aa.exports = no;
            }
          ),
          /***/
          "./node_modules/prop-types/factoryWithTypeCheckers.js": (
            /*!************************************************************!*\
              !*** ./node_modules/prop-types/factoryWithTypeCheckers.js ***!
              \************************************************************/
            /***/
            (aa, da, La) => {
              var qa = La(
                /*! react-is */
                "./node_modules/react-is/index.js"
              ), io = La(
                /*! object-assign */
                "./node_modules/object-assign/index.js"
              ), ao = La(
                /*! ./lib/ReactPropTypesSecret */
                "./node_modules/prop-types/lib/ReactPropTypesSecret.js"
              ), oo = La(
                /*! ./lib/has */
                "./node_modules/prop-types/lib/has.js"
              ), no = La(
                /*! ./checkPropTypes */
                "./node_modules/prop-types/checkPropTypes.js"
              ), lo = function() {
              };
              lo = function(bs) {
                var Rs = "Warning: " + bs;
                typeof console < "u" && console.error(Rs);
                try {
                  throw new Error(Rs);
                } catch {
                }
              };
              function so() {
                return null;
              }
              aa.exports = function(bs, Rs) {
                var js = typeof Symbol == "function" && Symbol.iterator, qs = "@@iterator";
                function jo(Is) {
                  var Sl = Is && (js && Is[js] || Is[qs]);
                  if (typeof Sl == "function")
                    return Sl;
                }
                var fs = "<<anonymous>>", Ao = {
                  array: xl("array"),
                  bigint: xl("bigint"),
                  bool: xl("boolean"),
                  func: xl("function"),
                  number: xl("number"),
                  object: xl("object"),
                  string: xl("string"),
                  symbol: xl("symbol"),
                  any: Cl(),
                  arrayOf: Al,
                  element: Ol(),
                  elementType: Bl(),
                  instanceOf: Ml,
                  node: Zl(),
                  objectOf: Ll,
                  oneOf: Vl,
                  oneOfType: Yl,
                  shape: Nl,
                  exact: Tl
                };
                function co(Is, Sl) {
                  return Is === Sl ? Is !== 0 || 1 / Is === 1 / Sl : Is !== Is && Sl !== Sl;
                }
                function Co(Is, Sl) {
                  this.message = Is, this.data = Sl && typeof Sl == "object" ? Sl : {}, this.stack = "";
                }
                Co.prototype = Error.prototype;
                function Zs(Is) {
                  var Sl = {}, wl = 0;
                  function Pl(Dl, $l, kl, zl, Hl, Wl, ql) {
                    if (zl = zl || fs, Wl = Wl || kl, ql !== ao) {
                      if (Rs) {
                        var Jl = new Error(
                          "Calling PropTypes validators directly is not supported by the `prop-types` package. Use `PropTypes.checkPropTypes()` to call them. Read more at http://fb.me/use-check-prop-types"
                        );
                        throw Jl.name = "Invariant Violation", Jl;
                      } else if (typeof console < "u") {
                        var ac = zl + ":" + kl;
                        !Sl[ac] && // Avoid spamming the console because they are often not actionable except for lib authors
                        wl < 3 && (lo(
                          "You are manually calling a React.PropTypes validation function for the `" + Wl + "` prop on `" + zl + "`. This is deprecated and will throw in the standalone `prop-types` package. You may be seeing this warning due to a third-party PropTypes library. See https://fb.me/react-warning-dont-call-proptypes for details."
                        ), Sl[ac] = !0, wl++);
                      }
                    }
                    return $l[kl] == null ? Dl ? $l[kl] === null ? new Co("The " + Hl + " `" + Wl + "` is marked as required " + ("in `" + zl + "`, but its value is `null`.")) : new Co("The " + Hl + " `" + Wl + "` is marked as required in " + ("`" + zl + "`, but its value is `undefined`.")) : null : Is($l, kl, zl, Hl, Wl);
                  }
                  var jl = Pl.bind(null, !1);
                  return jl.isRequired = Pl.bind(null, !0), jl;
                }
                function xl(Is) {
                  function Sl(wl, Pl, jl, Dl, $l, kl) {
                    var zl = wl[Pl], Hl = Ul(zl);
                    if (Hl !== Is) {
                      var Wl = Kl(zl);
                      return new Co(
                        "Invalid " + Dl + " `" + $l + "` of type " + ("`" + Wl + "` supplied to `" + jl + "`, expected ") + ("`" + Is + "`."),
                        { expectedType: Is }
                      );
                    }
                    return null;
                  }
                  return Zs(Sl);
                }
                function Cl() {
                  return Zs(so);
                }
                function Al(Is) {
                  function Sl(wl, Pl, jl, Dl, $l) {
                    if (typeof Is != "function")
                      return new Co("Property `" + $l + "` of component `" + jl + "` has invalid PropType notation inside arrayOf.");
                    var kl = wl[Pl];
                    if (!Array.isArray(kl)) {
                      var zl = Ul(kl);
                      return new Co("Invalid " + Dl + " `" + $l + "` of type " + ("`" + zl + "` supplied to `" + jl + "`, expected an array."));
                    }
                    for (var Hl = 0; Hl < kl.length; Hl++) {
                      var Wl = Is(kl, Hl, jl, Dl, $l + "[" + Hl + "]", ao);
                      if (Wl instanceof Error)
                        return Wl;
                    }
                    return null;
                  }
                  return Zs(Sl);
                }
                function Ol() {
                  function Is(Sl, wl, Pl, jl, Dl) {
                    var $l = Sl[wl];
                    if (!bs($l)) {
                      var kl = Ul($l);
                      return new Co("Invalid " + jl + " `" + Dl + "` of type " + ("`" + kl + "` supplied to `" + Pl + "`, expected a single ReactElement."));
                    }
                    return null;
                  }
                  return Zs(Is);
                }
                function Bl() {
                  function Is(Sl, wl, Pl, jl, Dl) {
                    var $l = Sl[wl];
                    if (!qa.isValidElementType($l)) {
                      var kl = Ul($l);
                      return new Co("Invalid " + jl + " `" + Dl + "` of type " + ("`" + kl + "` supplied to `" + Pl + "`, expected a single ReactElement type."));
                    }
                    return null;
                  }
                  return Zs(Is);
                }
                function Ml(Is) {
                  function Sl(wl, Pl, jl, Dl, $l) {
                    if (!(wl[Pl] instanceof Is)) {
                      var kl = Is.name || fs, zl = uo(wl[Pl]);
                      return new Co("Invalid " + Dl + " `" + $l + "` of type " + ("`" + zl + "` supplied to `" + jl + "`, expected ") + ("instance of `" + kl + "`."));
                    }
                    return null;
                  }
                  return Zs(Sl);
                }
                function Vl(Is) {
                  if (!Array.isArray(Is))
                    return arguments.length > 1 ? lo(
                      "Invalid arguments supplied to oneOf, expected an array, got " + arguments.length + " arguments. A common mistake is to write oneOf(x, y, z) instead of oneOf([x, y, z])."
                    ) : lo("Invalid argument supplied to oneOf, expected an array."), so;
                  function Sl(wl, Pl, jl, Dl, $l) {
                    for (var kl = wl[Pl], zl = 0; zl < Is.length; zl++)
                      if (co(kl, Is[zl]))
                        return null;
                    var Hl = JSON.stringify(Is, function(ql, Jl) {
                      var ac = Kl(Jl);
                      return ac === "symbol" ? String(Jl) : Jl;
                    });
                    return new Co("Invalid " + Dl + " `" + $l + "` of value `" + String(kl) + "` " + ("supplied to `" + jl + "`, expected one of " + Hl + "."));
                  }
                  return Zs(Sl);
                }
                function Ll(Is) {
                  function Sl(wl, Pl, jl, Dl, $l) {
                    if (typeof Is != "function")
                      return new Co("Property `" + $l + "` of component `" + jl + "` has invalid PropType notation inside objectOf.");
                    var kl = wl[Pl], zl = Ul(kl);
                    if (zl !== "object")
                      return new Co("Invalid " + Dl + " `" + $l + "` of type " + ("`" + zl + "` supplied to `" + jl + "`, expected an object."));
                    for (var Hl in kl)
                      if (oo(kl, Hl)) {
                        var Wl = Is(kl, Hl, jl, Dl, $l + "." + Hl, ao);
                        if (Wl instanceof Error)
                          return Wl;
                      }
                    return null;
                  }
                  return Zs(Sl);
                }
                function Yl(Is) {
                  if (!Array.isArray(Is))
                    return lo("Invalid argument supplied to oneOfType, expected an instance of array."), so;
                  for (var Sl = 0; Sl < Is.length; Sl++) {
                    var wl = Is[Sl];
                    if (typeof wl != "function")
                      return lo(
                        "Invalid argument supplied to oneOfType. Expected an array of check functions, but received " + Rl(wl) + " at index " + Sl + "."
                      ), so;
                  }
                  function Pl(jl, Dl, $l, kl, zl) {
                    for (var Hl = [], Wl = 0; Wl < Is.length; Wl++) {
                      var ql = Is[Wl], Jl = ql(jl, Dl, $l, kl, zl, ao);
                      if (Jl == null)
                        return null;
                      Jl.data && oo(Jl.data, "expectedType") && Hl.push(Jl.data.expectedType);
                    }
                    var ac = Hl.length > 0 ? ", expected one of type [" + Hl.join(", ") + "]" : "";
                    return new Co("Invalid " + kl + " `" + zl + "` supplied to " + ("`" + $l + "`" + ac + "."));
                  }
                  return Zs(Pl);
                }
                function Zl() {
                  function Is(Sl, wl, Pl, jl, Dl) {
                    return El(Sl[wl]) ? null : new Co("Invalid " + jl + " `" + Dl + "` supplied to " + ("`" + Pl + "`, expected a ReactNode."));
                  }
                  return Zs(Is);
                }
                function tc(Is, Sl, wl, Pl, jl) {
                  return new Co(
                    (Is || "React class") + ": " + Sl + " type `" + wl + "." + Pl + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + jl + "`."
                  );
                }
                function Nl(Is) {
                  function Sl(wl, Pl, jl, Dl, $l) {
                    var kl = wl[Pl], zl = Ul(kl);
                    if (zl !== "object")
                      return new Co("Invalid " + Dl + " `" + $l + "` of type `" + zl + "` " + ("supplied to `" + jl + "`, expected `object`."));
                    for (var Hl in Is) {
                      var Wl = Is[Hl];
                      if (typeof Wl != "function")
                        return tc(jl, Dl, $l, Hl, Kl(Wl));
                      var ql = Wl(kl, Hl, jl, Dl, $l + "." + Hl, ao);
                      if (ql)
                        return ql;
                    }
                    return null;
                  }
                  return Zs(Sl);
                }
                function Tl(Is) {
                  function Sl(wl, Pl, jl, Dl, $l) {
                    var kl = wl[Pl], zl = Ul(kl);
                    if (zl !== "object")
                      return new Co("Invalid " + Dl + " `" + $l + "` of type `" + zl + "` " + ("supplied to `" + jl + "`, expected `object`."));
                    var Hl = io({}, wl[Pl], Is);
                    for (var Wl in Hl) {
                      var ql = Is[Wl];
                      if (oo(Is, Wl) && typeof ql != "function")
                        return tc(jl, Dl, $l, Wl, Kl(ql));
                      if (!ql)
                        return new Co(
                          "Invalid " + Dl + " `" + $l + "` key `" + Wl + "` supplied to `" + jl + "`.\nBad object: " + JSON.stringify(wl[Pl], null, "  ") + `
Valid keys: ` + JSON.stringify(Object.keys(Is), null, "  ")
                        );
                      var Jl = ql(kl, Wl, jl, Dl, $l + "." + Wl, ao);
                      if (Jl)
                        return Jl;
                    }
                    return null;
                  }
                  return Zs(Sl);
                }
                function El(Is) {
                  switch (typeof Is) {
                    case "number":
                    case "string":
                    case "undefined":
                      return !0;
                    case "boolean":
                      return !Is;
                    case "object":
                      if (Array.isArray(Is))
                        return Is.every(El);
                      if (Is === null || bs(Is))
                        return !0;
                      var Sl = jo(Is);
                      if (Sl) {
                        var wl = Sl.call(Is), Pl;
                        if (Sl !== Is.entries) {
                          for (; !(Pl = wl.next()).done; )
                            if (!El(Pl.value))
                              return !1;
                        } else
                          for (; !(Pl = wl.next()).done; ) {
                            var jl = Pl.value;
                            if (jl && !El(jl[1]))
                              return !1;
                          }
                      } else
                        return !1;
                      return !0;
                    default:
                      return !1;
                  }
                }
                function Il(Is, Sl) {
                  return Is === "symbol" ? !0 : Sl ? Sl["@@toStringTag"] === "Symbol" || typeof Symbol == "function" && Sl instanceof Symbol : !1;
                }
                function Ul(Is) {
                  var Sl = typeof Is;
                  return Array.isArray(Is) ? "array" : Is instanceof RegExp ? "object" : Il(Sl, Is) ? "symbol" : Sl;
                }
                function Kl(Is) {
                  if (typeof Is > "u" || Is === null)
                    return "" + Is;
                  var Sl = Ul(Is);
                  if (Sl === "object") {
                    if (Is instanceof Date)
                      return "date";
                    if (Is instanceof RegExp)
                      return "regexp";
                  }
                  return Sl;
                }
                function Rl(Is) {
                  var Sl = Kl(Is);
                  switch (Sl) {
                    case "array":
                    case "object":
                      return "an " + Sl;
                    case "boolean":
                    case "date":
                    case "regexp":
                      return "a " + Sl;
                    default:
                      return Sl;
                  }
                }
                function uo(Is) {
                  return !Is.constructor || !Is.constructor.name ? fs : Is.constructor.name;
                }
                return Ao.checkPropTypes = no, Ao.resetWarningCache = no.resetWarningCache, Ao.PropTypes = Ao, Ao;
              };
            }
          ),
          /***/
          "./node_modules/prop-types/index.js": (
            /*!******************************************!*\
              !*** ./node_modules/prop-types/index.js ***!
              \******************************************/
            /***/
            (aa, da, La) => {
              {
                var qa = La(
                  /*! react-is */
                  "./node_modules/react-is/index.js"
                ), io = !0;
                aa.exports = La(
                  /*! ./factoryWithTypeCheckers */
                  "./node_modules/prop-types/factoryWithTypeCheckers.js"
                )(qa.isElement, io);
              }
            }
          ),
          /***/
          "./node_modules/prop-types/lib/ReactPropTypesSecret.js": (
            /*!*************************************************************!*\
              !*** ./node_modules/prop-types/lib/ReactPropTypesSecret.js ***!
              \*************************************************************/
            /***/
            (aa) => {
              var da = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
              aa.exports = da;
            }
          ),
          /***/
          "./node_modules/prop-types/lib/has.js": (
            /*!********************************************!*\
              !*** ./node_modules/prop-types/lib/has.js ***!
              \********************************************/
            /***/
            (aa) => {
              aa.exports = Function.call.bind(Object.prototype.hasOwnProperty);
            }
          ),
          /***/
          "./node_modules/react-is/cjs/react-is.development.js": (
            /*!***********************************************************!*\
              !*** ./node_modules/react-is/cjs/react-is.development.js ***!
              \***********************************************************/
            /***/
            (aa, da) => {
              /** @license React v16.13.1
               * react-is.development.js
               *
               * Copyright (c) Facebook, Inc. and its affiliates.
               *
               * This source code is licensed under the MIT license found in the
               * LICENSE file in the root directory of this source tree.
               */
              (function() {
                var La = typeof Symbol == "function" && Symbol.for, qa = La ? Symbol.for("react.element") : 60103, io = La ? Symbol.for("react.portal") : 60106, ao = La ? Symbol.for("react.fragment") : 60107, oo = La ? Symbol.for("react.strict_mode") : 60108, no = La ? Symbol.for("react.profiler") : 60114, lo = La ? Symbol.for("react.provider") : 60109, so = La ? Symbol.for("react.context") : 60110, bs = La ? Symbol.for("react.async_mode") : 60111, Rs = La ? Symbol.for("react.concurrent_mode") : 60111, js = La ? Symbol.for("react.forward_ref") : 60112, qs = La ? Symbol.for("react.suspense") : 60113, jo = La ? Symbol.for("react.suspense_list") : 60120, fs = La ? Symbol.for("react.memo") : 60115, Ao = La ? Symbol.for("react.lazy") : 60116, co = La ? Symbol.for("react.block") : 60121, Co = La ? Symbol.for("react.fundamental") : 60117, Zs = La ? Symbol.for("react.responder") : 60118, xl = La ? Symbol.for("react.scope") : 60119;
                function Cl(ql) {
                  return typeof ql == "string" || typeof ql == "function" || // Note: its typeof might be other than 'symbol' or 'number' if it's a polyfill.
                  ql === ao || ql === Rs || ql === no || ql === oo || ql === qs || ql === jo || typeof ql == "object" && ql !== null && (ql.$$typeof === Ao || ql.$$typeof === fs || ql.$$typeof === lo || ql.$$typeof === so || ql.$$typeof === js || ql.$$typeof === Co || ql.$$typeof === Zs || ql.$$typeof === xl || ql.$$typeof === co);
                }
                function Al(ql) {
                  if (typeof ql == "object" && ql !== null) {
                    var Jl = ql.$$typeof;
                    switch (Jl) {
                      case qa:
                        var ac = ql.type;
                        switch (ac) {
                          case bs:
                          case Rs:
                          case ao:
                          case no:
                          case oo:
                          case qs:
                            return ac;
                          default:
                            var Xl = ac && ac.$$typeof;
                            switch (Xl) {
                              case so:
                              case js:
                              case Ao:
                              case fs:
                              case lo:
                                return Xl;
                              default:
                                return Jl;
                            }
                        }
                      case io:
                        return Jl;
                    }
                  }
                }
                var Ol = bs, Bl = Rs, Ml = so, Vl = lo, Ll = qa, Yl = js, Zl = ao, tc = Ao, Nl = fs, Tl = io, El = no, Il = oo, Ul = qs, Kl = !1;
                function Rl(ql) {
                  return Kl || (Kl = !0, console.warn("The ReactIs.isAsyncMode() alias has been deprecated, and will be removed in React 17+. Update your code to use ReactIs.isConcurrentMode() instead. It has the exact same API.")), uo(ql) || Al(ql) === bs;
                }
                function uo(ql) {
                  return Al(ql) === Rs;
                }
                function Is(ql) {
                  return Al(ql) === so;
                }
                function Sl(ql) {
                  return Al(ql) === lo;
                }
                function wl(ql) {
                  return typeof ql == "object" && ql !== null && ql.$$typeof === qa;
                }
                function Pl(ql) {
                  return Al(ql) === js;
                }
                function jl(ql) {
                  return Al(ql) === ao;
                }
                function Dl(ql) {
                  return Al(ql) === Ao;
                }
                function $l(ql) {
                  return Al(ql) === fs;
                }
                function kl(ql) {
                  return Al(ql) === io;
                }
                function zl(ql) {
                  return Al(ql) === no;
                }
                function Hl(ql) {
                  return Al(ql) === oo;
                }
                function Wl(ql) {
                  return Al(ql) === qs;
                }
                da.AsyncMode = Ol, da.ConcurrentMode = Bl, da.ContextConsumer = Ml, da.ContextProvider = Vl, da.Element = Ll, da.ForwardRef = Yl, da.Fragment = Zl, da.Lazy = tc, da.Memo = Nl, da.Portal = Tl, da.Profiler = El, da.StrictMode = Il, da.Suspense = Ul, da.isAsyncMode = Rl, da.isConcurrentMode = uo, da.isContextConsumer = Is, da.isContextProvider = Sl, da.isElement = wl, da.isForwardRef = Pl, da.isFragment = jl, da.isLazy = Dl, da.isMemo = $l, da.isPortal = kl, da.isProfiler = zl, da.isStrictMode = Hl, da.isSuspense = Wl, da.isValidElementType = Cl, da.typeOf = Al;
              })();
            }
          ),
          /***/
          "./node_modules/react-is/index.js": (
            /*!****************************************!*\
              !*** ./node_modules/react-is/index.js ***!
              \****************************************/
            /***/
            (aa, da, La) => {
              aa.exports = La(
                /*! ./cjs/react-is.development.js */
                "./node_modules/react-is/cjs/react-is.development.js"
              );
            }
          ),
          /***/
          "./node_modules/shallow-equal/dist/index.esm.js": (
            /*!******************************************************!*\
              !*** ./node_modules/shallow-equal/dist/index.esm.js ***!
              \******************************************************/
            /***/
            (aa, da, La) => {
              La.r(da), La.d(da, {
                /* harmony export */
                shallowEqualArrays: () => (
                  /* binding */
                  io
                ),
                /* harmony export */
                shallowEqualObjects: () => (
                  /* binding */
                  qa
                )
                /* harmony export */
              });
              function qa(ao, oo) {
                if (ao === oo)
                  return !0;
                if (!ao || !oo)
                  return !1;
                var no = Object.keys(ao), lo = Object.keys(oo), so = no.length;
                if (lo.length !== so)
                  return !1;
                for (var bs = 0; bs < so; bs++) {
                  var Rs = no[bs];
                  if (ao[Rs] !== oo[Rs] || !Object.prototype.hasOwnProperty.call(oo, Rs))
                    return !1;
                }
                return !0;
              }
              function io(ao, oo) {
                if (ao === oo)
                  return !0;
                if (!ao || !oo)
                  return !1;
                var no = ao.length;
                if (oo.length !== no)
                  return !1;
                for (var lo = 0; lo < no; lo++)
                  if (ao[lo] !== oo[lo])
                    return !1;
                return !0;
              }
            }
          ),
          /***/
          "./src/Component.ts": (
            /*!**************************!*\
              !*** ./src/Component.ts ***!
              \**************************/
            /***/
            function(aa, da, La) {
              var qa = this && this.__rest || function(no, lo) {
                var so = {};
                for (var bs in no) Object.prototype.hasOwnProperty.call(no, bs) && lo.indexOf(bs) < 0 && (so[bs] = no[bs]);
                if (no != null && typeof Object.getOwnPropertySymbols == "function")
                  for (var Rs = 0, bs = Object.getOwnPropertySymbols(no); Rs < bs.length; Rs++)
                    lo.indexOf(bs[Rs]) < 0 && Object.prototype.propertyIsEnumerable.call(no, bs[Rs]) && (so[bs[Rs]] = no[bs[Rs]]);
                return so;
              }, io = this && this.__importDefault || function(no) {
                return no && no.__esModule ? no : { default: no };
              };
              Object.defineProperty(da, "__esModule", { value: !0 });
              var ao = io(La(
                /*! ./useMediaQuery */
                "./src/useMediaQuery.ts"
              )), oo = function(no) {
                var lo = no.children, so = no.device, bs = no.onChange, Rs = qa(no, ["children", "device", "onChange"]), js = (0, ao.default)(Rs, so, bs);
                return typeof lo == "function" ? lo(js) : js ? lo : null;
              };
              da.default = oo;
            }
          ),
          /***/
          "./src/Context.ts": (
            /*!************************!*\
              !*** ./src/Context.ts ***!
              \************************/
            /***/
            (aa, da, La) => {
              Object.defineProperty(da, "__esModule", { value: !0 });
              var qa = La(
                /*! react */
                "react"
              ), io = (0, qa.createContext)(void 0);
              da.default = io;
            }
          ),
          /***/
          "./src/index.ts": (
            /*!**********************!*\
              !*** ./src/index.ts ***!
              \**********************/
            /***/
            function(aa, da, La) {
              var qa = this && this.__importDefault || function(lo) {
                return lo && lo.__esModule ? lo : { default: lo };
              };
              Object.defineProperty(da, "__esModule", { value: !0 }), da.Context = da.toQuery = da.useMediaQuery = da.default = void 0;
              var io = qa(La(
                /*! ./useMediaQuery */
                "./src/useMediaQuery.ts"
              ));
              da.useMediaQuery = io.default;
              var ao = qa(La(
                /*! ./Component */
                "./src/Component.ts"
              ));
              da.default = ao.default;
              var oo = qa(La(
                /*! ./toQuery */
                "./src/toQuery.ts"
              ));
              da.toQuery = oo.default;
              var no = qa(La(
                /*! ./Context */
                "./src/Context.ts"
              ));
              da.Context = no.default;
            }
          ),
          /***/
          "./src/mediaQuery.ts": (
            /*!***************************!*\
              !*** ./src/mediaQuery.ts ***!
              \***************************/
            /***/
            function(aa, da, La) {
              var qa = this && this.__assign || function() {
                return qa = Object.assign || function(qs) {
                  for (var jo, fs = 1, Ao = arguments.length; fs < Ao; fs++) {
                    jo = arguments[fs];
                    for (var co in jo) Object.prototype.hasOwnProperty.call(jo, co) && (qs[co] = jo[co]);
                  }
                  return qs;
                }, qa.apply(this, arguments);
              }, io = this && this.__rest || function(qs, jo) {
                var fs = {};
                for (var Ao in qs) Object.prototype.hasOwnProperty.call(qs, Ao) && jo.indexOf(Ao) < 0 && (fs[Ao] = qs[Ao]);
                if (qs != null && typeof Object.getOwnPropertySymbols == "function")
                  for (var co = 0, Ao = Object.getOwnPropertySymbols(qs); co < Ao.length; co++)
                    jo.indexOf(Ao[co]) < 0 && Object.prototype.propertyIsEnumerable.call(qs, Ao[co]) && (fs[Ao[co]] = qs[Ao[co]]);
                return fs;
              }, ao = this && this.__importDefault || function(qs) {
                return qs && qs.__esModule ? qs : { default: qs };
              };
              Object.defineProperty(da, "__esModule", { value: !0 });
              var oo = ao(La(
                /*! prop-types */
                "./node_modules/prop-types/index.js"
              )), no = oo.default.oneOfType([
                oo.default.string,
                oo.default.number
              ]), lo = {
                all: oo.default.bool,
                grid: oo.default.bool,
                aural: oo.default.bool,
                braille: oo.default.bool,
                handheld: oo.default.bool,
                print: oo.default.bool,
                projection: oo.default.bool,
                screen: oo.default.bool,
                tty: oo.default.bool,
                tv: oo.default.bool,
                embossed: oo.default.bool
              }, so = {
                orientation: oo.default.oneOf([
                  "portrait",
                  "landscape"
                ]),
                scan: oo.default.oneOf([
                  "progressive",
                  "interlace"
                ]),
                aspectRatio: oo.default.string,
                deviceAspectRatio: oo.default.string,
                height: no,
                deviceHeight: no,
                width: no,
                deviceWidth: no,
                color: oo.default.bool,
                colorIndex: oo.default.bool,
                monochrome: oo.default.bool,
                resolution: no,
                type: Object.keys(lo)
              };
              so.type;
              var bs = io(
                so,
                ["type"]
              ), Rs = qa({ minAspectRatio: oo.default.string, maxAspectRatio: oo.default.string, minDeviceAspectRatio: oo.default.string, maxDeviceAspectRatio: oo.default.string, minHeight: no, maxHeight: no, minDeviceHeight: no, maxDeviceHeight: no, minWidth: no, maxWidth: no, minDeviceWidth: no, maxDeviceWidth: no, minColor: oo.default.number, maxColor: oo.default.number, minColorIndex: oo.default.number, maxColorIndex: oo.default.number, minMonochrome: oo.default.number, maxMonochrome: oo.default.number, minResolution: no, maxResolution: no }, bs), js = qa(qa({}, lo), Rs);
              da.default = {
                all: js,
                types: lo,
                matchers: so,
                features: Rs
              };
            }
          ),
          /***/
          "./src/toQuery.ts": (
            /*!************************!*\
              !*** ./src/toQuery.ts ***!
              \************************/
            /***/
            function(aa, da, La) {
              var qa = this && this.__importDefault || function(bs) {
                return bs && bs.__esModule ? bs : { default: bs };
              };
              Object.defineProperty(da, "__esModule", { value: !0 });
              var io = qa(La(
                /*! hyphenate-style-name */
                "./node_modules/hyphenate-style-name/index.js"
              )), ao = qa(La(
                /*! ./mediaQuery */
                "./src/mediaQuery.ts"
              )), oo = function(bs) {
                return "not ".concat(bs);
              }, no = function(bs, Rs) {
                var js = (0, io.default)(bs);
                return typeof Rs == "number" && (Rs = "".concat(Rs, "px")), Rs === !0 ? js : Rs === !1 ? oo(js) : "(".concat(js, ": ").concat(Rs, ")");
              }, lo = function(bs) {
                return bs.join(" and ");
              }, so = function(bs) {
                var Rs = [];
                return Object.keys(ao.default.all).forEach(function(js) {
                  var qs = bs[js];
                  qs != null && Rs.push(no(js, qs));
                }), lo(Rs);
              };
              da.default = so;
            }
          ),
          /***/
          "./src/useMediaQuery.ts": (
            /*!******************************!*\
              !*** ./src/useMediaQuery.ts ***!
              \******************************/
            /***/
            function(aa, da, La) {
              var qa = this && this.__importDefault || function(Co) {
                return Co && Co.__esModule ? Co : { default: Co };
              };
              Object.defineProperty(da, "__esModule", { value: !0 });
              var io = La(
                /*! react */
                "react"
              ), ao = qa(La(
                /*! matchmediaquery */
                "./node_modules/matchmediaquery/index.js"
              )), oo = qa(La(
                /*! hyphenate-style-name */
                "./node_modules/hyphenate-style-name/index.js"
              )), no = La(
                /*! shallow-equal */
                "./node_modules/shallow-equal/dist/index.esm.js"
              ), lo = qa(La(
                /*! ./toQuery */
                "./src/toQuery.ts"
              )), so = qa(La(
                /*! ./Context */
                "./src/Context.ts"
              )), bs = function(Co) {
                return Co.query || (0, lo.default)(Co);
              }, Rs = function(Co) {
                if (Co) {
                  var Zs = Object.keys(Co);
                  return Zs.reduce(function(xl, Cl) {
                    return xl[(0, oo.default)(Cl)] = Co[Cl], xl;
                  }, {});
                }
              }, js = function() {
                var Co = (0, io.useRef)(!1);
                return (0, io.useEffect)(function() {
                  Co.current = !0;
                }, []), Co.current;
              }, qs = function(Co) {
                var Zs = (0, io.useContext)(so.default), xl = function() {
                  return Rs(Co) || Rs(Zs);
                }, Cl = (0, io.useState)(xl), Al = Cl[0], Ol = Cl[1];
                return (0, io.useEffect)(function() {
                  var Bl = xl();
                  (0, no.shallowEqualObjects)(Al, Bl) || Ol(Bl);
                }, [Co, Zs]), Al;
              }, jo = function(Co) {
                var Zs = function() {
                  return bs(Co);
                }, xl = (0, io.useState)(Zs), Cl = xl[0], Al = xl[1];
                return (0, io.useEffect)(function() {
                  var Ol = Zs();
                  Cl !== Ol && Al(Ol);
                }, [Co]), Cl;
              }, fs = function(Co, Zs) {
                var xl = function() {
                  return (0, ao.default)(Co, Zs || {}, !!Zs);
                }, Cl = (0, io.useState)(xl), Al = Cl[0], Ol = Cl[1], Bl = js();
                return (0, io.useEffect)(function() {
                  if (Bl) {
                    var Ml = xl();
                    return Ol(Ml), function() {
                      Ml && Ml.dispose();
                    };
                  }
                }, [Co, Zs]), Al;
              }, Ao = function(Co) {
                var Zs = (0, io.useState)(Co.matches), xl = Zs[0], Cl = Zs[1];
                return (0, io.useEffect)(function() {
                  var Al = function(Ol) {
                    Cl(Ol.matches);
                  };
                  return Co.addListener(Al), Cl(Co.matches), function() {
                    Co.removeListener(Al);
                  };
                }, [Co]), xl;
              }, co = function(Co, Zs, xl) {
                var Cl = qs(Zs), Al = jo(Co);
                if (!Al)
                  throw new Error("Invalid or missing MediaQuery!");
                var Ol = fs(Al, Cl), Bl = Ao(Ol), Ml = js();
                return (0, io.useEffect)(function() {
                  Ml && xl && xl(Bl);
                }, [Bl]), (0, io.useEffect)(function() {
                  return function() {
                    Ol && Ol.dispose();
                  };
                }, []), Bl;
              };
              da.default = co;
            }
          ),
          /***/
          react: (
            /*!**************************************************************************************!*\
              !*** external {"commonjs":"react","commonjs2":"react","amd":"react","root":"React"} ***!
              \**************************************************************************************/
            /***/
            (aa) => {
              aa.exports = Ui;
            }
          )
          /******/
        }, ta = {};
        function na(aa) {
          var da = ta[aa];
          if (da !== void 0)
            return da.exports;
          var La = ta[aa] = {
            /******/
            // no module.id needed
            /******/
            // no module.loaded needed
            /******/
            exports: {}
            /******/
          };
          return Zi[aa].call(La.exports, La, La.exports, na), La.exports;
        }
        na.d = (aa, da) => {
          for (var La in da)
            na.o(da, La) && !na.o(aa, La) && Object.defineProperty(aa, La, { enumerable: !0, get: da[La] });
        }, na.o = (aa, da) => Object.prototype.hasOwnProperty.call(aa, da), na.r = (aa) => {
          typeof Symbol < "u" && Symbol.toStringTag && Object.defineProperty(aa, Symbol.toStringTag, { value: "Module" }), Object.defineProperty(aa, "__esModule", { value: !0 });
        };
        var ia = na("./src/index.ts");
        return ia;
      })()
    ));
  }(reactResponsive$1)), reactResponsive$1.exports;
}
var reactResponsiveExports = /* @__PURE__ */ requireReactResponsive();
const breakpoints = {
  sm: 640,
  md: 768,
  lg: 1024,
  xl: 1280,
  "2xl": 1536
}, useTailwindBreakpoint = (Bi) => reactResponsiveExports.useMediaQuery({ minWidth: breakpoints[Bi] }), AppLayoutContext = createContext({}), useAppLayoutContext = () => useContext(AppLayoutContext), AppBar$1 = ({
  children: Bi,
  className: e = "",
  style: Ui = {},
  hideDrawerButton: Zi = !0
}) => {
  const { menuVisible: ta, onMenuToggle: na, layoutRef: ia } = useAppLayoutContext(), aa = useTailwindBreakpoint("sm");
  return ia ? createPortal(
    /* @__PURE__ */ jsxRuntimeExports.jsxs(
      "nav",
      {
        className: twMerge(
          "col-span-full bg-blue-500 flex justify-start items-center text-white px-4 col-start-1 row-span-1 w-full h-full",
          e
        ),
        style: Ui,
        children: [
          aa && !Zi && /* @__PURE__ */ jsxRuntimeExports.jsx(
            DrawerButton,
            {
              className: "mr-8",
              sideBarVisible: ta,
              onClick: () => na?.(!ta)
            }
          ),
          Bi,
          !aa && /* @__PURE__ */ jsxRuntimeExports.jsx(jsxRuntimeExports.Fragment, { children: /* @__PURE__ */ jsxRuntimeExports.jsx(
            DrawerButton,
            {
              sideBarVisible: ta,
              onClick: () => na?.(!ta)
            }
          ) })
        ]
      }
    ),
    ia
  ) : null;
}, AppLayoutBody = ({ children: Bi }) => {
  const { layoutRef: e } = useAppLayoutContext();
  return e ? createPortal(
    /* @__PURE__ */ jsxRuntimeExports.jsx("main", { className: "w-full h-full overflow-hidden row-start-2 col-start-2 col-span-full", children: Bi }),
    e
  ) : null;
}, styles = cva(
  [
    "bg-neutral-200",
    "h-full",
    "overflow-auto",
    "row-start-2",
    "col-span-1",
    "col-start-1"
  ],
  {
    variants: {
      size: {
        sm: ["sm:hidden", "block", "z-50"],
        lg: ["sm:block"]
      }
    }
  }
), AppLayoutMenu = ({ children: Bi }) => {
  const { onMenuToggle: e, menuVisible: Ui, layoutRef: Zi } = useAppLayoutContext(), ta = useTailwindBreakpoint("sm");
  return Zi ? ta ? Ui ? createPortal(
    /* @__PURE__ */ jsxRuntimeExports.jsx(
      "aside",
      {
        className: styles({ size: "lg" }),
        children: Bi
      },
      "app-layout-menu"
    ),
    Zi
  ) : null : Ui ? createPortal(
    /* @__PURE__ */ jsxRuntimeExports.jsxs(
      "aside",
      {
        className: styles({ size: "sm" }),
        children: [
          /* @__PURE__ */ jsxRuntimeExports.jsx(
            "button",
            {
              onClick: () => e?.(!1),
              className: "ml-auto text-neutral-700",
              children: /* @__PURE__ */ jsxRuntimeExports.jsx(FontAwesomeIcon, { icon: faX, size: "sm" })
            }
          ),
          Bi
        ]
      },
      "app-layout-menu"
    ),
    Zi
  ) : null : null;
};
function AppLayoutMenuLink({
  to: Bi,
  icon: e,
  name: Ui,
  hasNotifications: Zi,
  children: ta,
  href: na,
  linkProps: ia
}) {
  if (!na && !Bi)
    throw new Error("to or href is required");
  return /* @__PURE__ */ jsxRuntimeExports.jsx(AnimateSharedLayout, { children: /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "flex flex-col my-2", children: na ? /* @__PURE__ */ jsxRuntimeExports.jsxs(
    "a",
    {
      className: "flex p-2 my-2 list-none rounded-md cursor-pointer hover:bg-neutral-500",
      href: na,
      target: "_blank",
      rel: "noreferrer",
      children: [
        /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "flex align-middle ", children: [
          Zi && /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "absolute w-2.5 h-2.5 transform -translate-x-2 -translate-y-2 bg-red-400 rounded-full" }),
          /* @__PURE__ */ jsxRuntimeExports.jsx(
            FontAwesomeIcon,
            {
              icon: e,
              color: "gray",
              className: "my-auto mr-6",
              size: "1x"
            }
          ),
          /* @__PURE__ */ jsxRuntimeExports.jsx("p", { children: Ui })
        ] }),
        /* @__PURE__ */ jsxRuntimeExports.jsx(Spacer, {}),
        ta
      ]
    }
  ) : /* @__PURE__ */ jsxRuntimeExports.jsxs(
    Link,
    {
      to: Bi,
      ...ia || {},
      className: "flex p-2 my-2 list-none rounded-md cursor-pointer hover:bg-neutral-500",
      children: [
        /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "flex align-middle ", children: [
          Zi && /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "absolute w-2.5 h-2.5 transform -translate-x-2 -translate-y-2 bg-red-400 rounded-full" }),
          /* @__PURE__ */ jsxRuntimeExports.jsx(
            FontAwesomeIcon,
            {
              icon: e,
              color: "gray",
              className: "my-auto mr-6",
              size: "1x"
            }
          ),
          /* @__PURE__ */ jsxRuntimeExports.jsx("p", { children: Ui })
        ] }),
        /* @__PURE__ */ jsxRuntimeExports.jsx(Spacer, {}),
        ta
      ]
    }
  ) }) });
}
const layoutRootStyles = cva([
  "grid",
  "w-screen",
  "h-screen",
  "overflow-hidden",
  "bg-neutral-100",
  "flex-col",
  "app-layout",
  "grid-cols-[min-content_minmax(0,1fr)]",
  "grid-rows-[6rem_minmax(0,1fr)]"
]), AppLayout = ({
  menuVisible: Bi = !1,
  children: e,
  onMenuToggle: Ui
}) => {
  const [Zi, ta] = a__default.useState(null), [na, ia] = a__default.useState(null), [aa, da] = a__default.useState(null);
  return /* @__PURE__ */ jsxRuntimeExports.jsx(
    AppLayoutContext.Provider,
    {
      value: {
        menuVisible: Bi,
        menuRef: aa,
        onMenuToggle: Ui,
        layoutRef: Zi,
        headerRef: na
      },
      children: /* @__PURE__ */ jsxRuntimeExports.jsx(
        "div",
        {
          className: layoutRootStyles(),
          ref: ta,
          children: e
        }
      )
    }
  );
};
AppLayout.Header = AppBar$1;
AppLayout.Body = AppLayoutBody;
AppLayout.Menu = AppLayoutMenu;
AppLayout.Link = AppLayoutMenuLink;
const AppBar = ({
  onClick: Bi,
  sideBarVisible: e,
  className: Ui,
  showMenu: Zi = !0,
  isLoggedIn: ta = !1,
  children: na
}) => /* @__PURE__ */ jsxRuntimeExports.jsxs(
  "nav",
  {
    className: twMerge(
      "w-screen h-full flex justify-between col-span-12 row-span-1 px-4 bg-blue-500",
      Ui
    ),
    children: [
      /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "flex", children: [
        Zi && /* @__PURE__ */ jsxRuntimeExports.jsx(
          DrawerButton,
          {
            sideBarVisible: e,
            onClick: Bi || (() => null)
          }
        ),
        /* @__PURE__ */ jsxRuntimeExports.jsx(Link, { to: "/app", className: "block mx-4 my-auto h-1/2", children: /* @__PURE__ */ jsxRuntimeExports.jsx(Logo, { className: "w-8 h-8" }) }),
        /* @__PURE__ */ jsxRuntimeExports.jsx("h1", { className: "my-auto text-xl text-white uppercase font-terminal ", children: na })
      ] }),
      /* @__PURE__ */ jsxRuntimeExports.jsxs(
        Menu,
        {
          className: "my-auto",
          button: /* @__PURE__ */ jsxRuntimeExports.jsx(FontAwesomeIcon, { color: "white", size: "1x", icon: faUserCog }),
          children: [
            ta && /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [
              /* @__PURE__ */ jsxRuntimeExports.jsx("p", { className: "mb-8 border-b border-opacity-30 border-b-black" }),
              /* @__PURE__ */ jsxRuntimeExports.jsx(Link, { className: "menu-item", to: "/app/account", children: "Account" }),
              /* @__PURE__ */ jsxRuntimeExports.jsx(Link, { className: "menu-item", to: "/app/account/change-password", children: "Change Password" }),
              /* @__PURE__ */ jsxRuntimeExports.jsx(Link, { className: "menu-item", to: "/app/account/tokens", children: "CLI Tokens" }),
              /* @__PURE__ */ jsxRuntimeExports.jsx(
                MenuItem,
                {
                  onAction: async () => {
                  },
                  children: "Logout"
                }
              )
            ] }),
            !ta && /* @__PURE__ */ jsxRuntimeExports.jsx(Link, { to: "/login", children: /* @__PURE__ */ jsxRuntimeExports.jsx(MenuItem, { children: "Login" }) })
          ]
        }
      )
    ]
  }
), defaultOptions = {};
gql`
    mutation CreateFolder($newFolder: String!, $currentFolder: String!, $s3BucketId: Float) {
  createFolder(
    newFolder: $newFolder
    currentFolder: $currentFolder
    s3BucketId: $s3BucketId
  )
}
    `;
gql`
    mutation DeleteFiles($paths: [S3ObjectInput!]!) {
  deleteFilesResolver(paths: $paths)
}
    `;
gql`
    mutation MoveS3Files($target: S3ObjectInput!, $source: S3ObjectInput!) {
  moveS3Files(target: $target, source: $source)
}
    `;
gql`
    mutation MoveUpAFolder($moveUpAFolderPath: S3ObjectInput!) {
  moveUpAFolder(path: $moveUpAFolderPath)
}
    `;
gql`
    query FileTransfers {
  fileTransfers {
    name
    progress
    id
  }
}
    `;
gql`
    query FolderContents($s3BucketId: Float, $folder: String) {
  folderContents(s3BucketId: $s3BucketId, folder: $folder) {
    contents {
      key
      name
      isFolder
      fullPath
      bucket
    }
    errors
  }
  me {
    id
    awsUsername
  }
}
    `;
gql`
    query folderContentsSearch($search: String!, $s3BucketId: Int) {
  fileSearch(search: $search, s3BucketId: $s3BucketId) {
    results {
      fullPath
      key
      name
      isFolder
      bucket
    }
    errors
  }
}
    `;
const MeDocument = gql`
    query Me {
  me {
    id
    email
    awsUsername
    firstname
    lastname
    roles {
      role
    }
  }
}
    `;
function useMeQuery(Bi) {
  const e = { ...defaultOptions, ...Bi };
  return Apollo.useQuery(MeDocument, e);
}
function useMeLazyQuery(Bi) {
  const e = { ...defaultOptions, ...Bi };
  return Apollo.useLazyQuery(MeDocument, e);
}
const PresignedDownloadUrlDocument = gql`
    query PresignedDownloadUrl($bucket: String!, $key: String!, $limit: Float) {
  presignedDownloadUrl(bucket: $bucket, key: $key, limit: $limit)
}
    `;
function usePresignedDownloadUrlQuery(Bi) {
  const e = { ...defaultOptions, ...Bi };
  return Apollo.useQuery(PresignedDownloadUrlDocument, e);
}
function usePresignedDownloadUrlLazyQuery(Bi) {
  const e = { ...defaultOptions, ...Bi };
  return Apollo.useLazyQuery(PresignedDownloadUrlDocument, e);
}
gql`
    subscription FileTranfersUpdated {
  fileTransfersUpdated {
    progress
    id
    name
  }
}
    `;
const TaskQueueLogsDocument = gql`
    subscription TaskQueueLogs($jobId: String!) {
  taskQueueLogs(jobId: $jobId) {
    message
    timestamp
  }
}
    `;
function useTaskQueueLogsSubscription(Bi) {
  const e = { ...defaultOptions, ...Bi };
  return Apollo.useSubscription(TaskQueueLogsDocument, e);
}
const ReaderLayout = ({ appBarTitle: Bi }) => {
  const { data: e } = useMeQuery();
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(motion.div, { className: "grid w-screen h-screen bg-neutral-300 grid-rows-[4rem minmax(0, 1fr)] grid-cols-1", children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(
      AppBar,
      {
        className: "h-16 bg-blue-600 ",
        onClick: () => null,
        sideBarVisible: !1,
        showMenu: !1,
        isLoggedIn: !!e?.me,
        children: Bi
      }
    ),
    /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "flex justify-around w-full h-full ", children: /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "w-full h-full max-w-6xl p-4 overflow-scroll bg-neutral-100", children: /* @__PURE__ */ jsxRuntimeExports.jsx(Outlet, {}) }) })
  ] });
}, pageVariants = {
  initial: {
    opacity: 0
  },
  in: {
    opacity: 1
  },
  out: {
    opacity: 0
  }
}, Page = ({
  children: Bi,
  className: e
}) => /* @__PURE__ */ jsxRuntimeExports.jsx(
  motion.div,
  {
    className: twMerge("w-full min-h-full overflow-scroll", e),
    initial: "initial",
    animate: "in",
    exit: "out",
    variants: pageVariants,
    children: Bi
  }
), PageHeaderTitle = (Bi) => /* @__PURE__ */ jsxRuntimeExports.jsx("h1", { className: "text-2xl flex-grow border-opacity-25", children: Bi.children }), PageHeader = ({ children: Bi, title: e, className: Ui }) => /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: `flex py-2 mb-4 border-b border-black ${Ui}`, children: /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [
  typeof e == "string" ? /* @__PURE__ */ jsxRuntimeExports.jsx(PageHeaderTitle, { children: e }) : e,
  Bi
] }) }), NotFound = () => /* @__PURE__ */ jsxRuntimeExports.jsx(Page, { children: /* @__PURE__ */ jsxRuntimeExports.jsx(PageHeader, { title: "Page not found" }) }), ImagePreview = ({ data: Bi }) => {
  const e = URL.createObjectURL(Bi);
  return /* @__PURE__ */ jsxRuntimeExports.jsx("div", { children: /* @__PURE__ */ jsxRuntimeExports.jsx("img", { src: e, alt: "" }) });
}, Spinner = () => /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "loader" }), CircleSpinner = () => /* @__PURE__ */ jsxRuntimeExports.jsx("p", { children: "Loading..." });
function commonjsRequire(Bi) {
  throw new Error('Could not dynamically require "' + Bi + '". Please configure the dynamicRequireTargets or/and ignoreDynamicRequires option of @rollup/plugin-commonjs appropriately for this require call to work.');
}
var pdf = { exports: {} };
const __viteBrowserExternal = {}, __viteBrowserExternal$1 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: __viteBrowserExternal
}, Symbol.toStringTag, { value: "Module" })), require$$5 = /* @__PURE__ */ getAugmentedNamespace(__viteBrowserExternal$1);
var hasRequiredPdf;
function requirePdf() {
  return hasRequiredPdf || (hasRequiredPdf = 1, function(module, exports) {
    (function(e, Ui) {
      module.exports = Ui();
    })(globalThis, () => (
      /******/
      (() => {
        var __webpack_modules__ = [
          ,
          /* 1 */
          /***/
          (Bi, e, Ui) => {
            Object.defineProperty(e, "__esModule", {
              value: !0
            }), e.VerbosityLevel = e.Util = e.UnknownErrorException = e.UnexpectedResponseException = e.UNSUPPORTED_FEATURES = e.TextRenderingMode = e.StreamType = e.RenderingIntentFlag = e.PermissionFlag = e.PasswordResponses = e.PasswordException = e.PageActionEventType = e.OPS = e.MissingPDFException = e.LINE_FACTOR = e.LINE_DESCENT_FACTOR = e.InvalidPDFException = e.ImageKind = e.IDENTITY_MATRIX = e.FormatError = e.FontType = e.FeatureTest = e.FONT_IDENTITY_MATRIX = e.DocumentActionEventType = e.CMapCompressionType = e.BaseException = e.AnnotationType = e.AnnotationStateModelType = e.AnnotationReviewState = e.AnnotationReplyType = e.AnnotationMode = e.AnnotationMarkedState = e.AnnotationFlag = e.AnnotationFieldFlag = e.AnnotationEditorType = e.AnnotationEditorPrefix = e.AnnotationEditorParamsType = e.AnnotationBorderStyleType = e.AnnotationActionEventType = e.AbortException = void 0, e.arrayByteLength = kl, e.arraysToBytes = zl, e.assert = Tl, e.bytesToString = Dl, e.createPromiseCapability = Ad, e.createValidAbsoluteUrl = Il, e.escapeString = ad, e.getModificationDate = wd, e.getVerbosityLevel = Yl, e.info = Zl, e.isArrayBuffer = fd, e.isArrayEqual = Ed, e.isAscii = od, e.objectFromMap = ql, e.objectSize = Wl, e.setVerbosityLevel = Ll, e.shadow = Ul, e.string32 = Hl, e.stringToBytes = $l, e.stringToPDFString = td, e.stringToUTF16BEString = sd, e.stringToUTF8String = dd, e.unreachable = Nl, e.utf8StringToString = pd, e.warn = tc, Ui(2);
            const Zi = [1, 0, 0, 1, 0, 0];
            e.IDENTITY_MATRIX = Zi;
            const ta = [1e-3, 0, 0, 1e-3, 0, 0];
            e.FONT_IDENTITY_MATRIX = ta;
            const na = 1.35;
            e.LINE_FACTOR = na;
            const ia = 0.35;
            e.LINE_DESCENT_FACTOR = ia;
            const aa = {
              ANY: 1,
              DISPLAY: 2,
              PRINT: 4,
              ANNOTATIONS_FORMS: 16,
              ANNOTATIONS_STORAGE: 32,
              ANNOTATIONS_DISABLE: 64,
              OPLIST: 256
            };
            e.RenderingIntentFlag = aa;
            const da = {
              DISABLE: 0,
              ENABLE: 1,
              ENABLE_FORMS: 2,
              ENABLE_STORAGE: 3
            };
            e.AnnotationMode = da;
            const La = "pdfjs_internal_editor_";
            e.AnnotationEditorPrefix = La;
            const qa = {
              DISABLE: -1,
              NONE: 0,
              FREETEXT: 3,
              INK: 15
            };
            e.AnnotationEditorType = qa;
            const io = {
              FREETEXT_SIZE: 1,
              FREETEXT_COLOR: 2,
              FREETEXT_OPACITY: 3,
              INK_COLOR: 11,
              INK_THICKNESS: 12,
              INK_OPACITY: 13
            };
            e.AnnotationEditorParamsType = io;
            const ao = {
              PRINT: 4,
              MODIFY_CONTENTS: 8,
              COPY: 16,
              MODIFY_ANNOTATIONS: 32,
              FILL_INTERACTIVE_FORMS: 256,
              COPY_FOR_ACCESSIBILITY: 512,
              ASSEMBLE: 1024,
              PRINT_HIGH_QUALITY: 2048
            };
            e.PermissionFlag = ao;
            const oo = {
              FILL: 0,
              STROKE: 1,
              FILL_STROKE: 2,
              INVISIBLE: 3,
              FILL_ADD_TO_PATH: 4,
              STROKE_ADD_TO_PATH: 5,
              FILL_STROKE_ADD_TO_PATH: 6,
              ADD_TO_PATH: 7,
              FILL_STROKE_MASK: 3,
              ADD_TO_PATH_FLAG: 4
            };
            e.TextRenderingMode = oo;
            const no = {
              GRAYSCALE_1BPP: 1,
              RGB_24BPP: 2,
              RGBA_32BPP: 3
            };
            e.ImageKind = no;
            const lo = {
              TEXT: 1,
              LINK: 2,
              FREETEXT: 3,
              LINE: 4,
              SQUARE: 5,
              CIRCLE: 6,
              POLYGON: 7,
              POLYLINE: 8,
              HIGHLIGHT: 9,
              UNDERLINE: 10,
              SQUIGGLY: 11,
              STRIKEOUT: 12,
              STAMP: 13,
              CARET: 14,
              INK: 15,
              POPUP: 16,
              FILEATTACHMENT: 17,
              SOUND: 18,
              MOVIE: 19,
              WIDGET: 20,
              SCREEN: 21,
              PRINTERMARK: 22,
              TRAPNET: 23,
              WATERMARK: 24,
              THREED: 25,
              REDACT: 26
            };
            e.AnnotationType = lo;
            const so = {
              MARKED: "Marked",
              REVIEW: "Review"
            };
            e.AnnotationStateModelType = so;
            const bs = {
              MARKED: "Marked",
              UNMARKED: "Unmarked"
            };
            e.AnnotationMarkedState = bs;
            const Rs = {
              ACCEPTED: "Accepted",
              REJECTED: "Rejected",
              CANCELLED: "Cancelled",
              COMPLETED: "Completed",
              NONE: "None"
            };
            e.AnnotationReviewState = Rs;
            const js = {
              GROUP: "Group",
              REPLY: "R"
            };
            e.AnnotationReplyType = js;
            const qs = {
              INVISIBLE: 1,
              HIDDEN: 2,
              PRINT: 4,
              NOZOOM: 8,
              NOROTATE: 16,
              NOVIEW: 32,
              READONLY: 64,
              LOCKED: 128,
              TOGGLENOVIEW: 256,
              LOCKEDCONTENTS: 512
            };
            e.AnnotationFlag = qs;
            const jo = {
              READONLY: 1,
              REQUIRED: 2,
              NOEXPORT: 4,
              MULTILINE: 4096,
              PASSWORD: 8192,
              NOTOGGLETOOFF: 16384,
              RADIO: 32768,
              PUSHBUTTON: 65536,
              COMBO: 131072,
              EDIT: 262144,
              SORT: 524288,
              FILESELECT: 1048576,
              MULTISELECT: 2097152,
              DONOTSPELLCHECK: 4194304,
              DONOTSCROLL: 8388608,
              COMB: 16777216,
              RICHTEXT: 33554432,
              RADIOSINUNISON: 33554432,
              COMMITONSELCHANGE: 67108864
            };
            e.AnnotationFieldFlag = jo;
            const fs = {
              SOLID: 1,
              DASHED: 2,
              BEVELED: 3,
              INSET: 4,
              UNDERLINE: 5
            };
            e.AnnotationBorderStyleType = fs;
            const Ao = {
              E: "Mouse Enter",
              X: "Mouse Exit",
              D: "Mouse Down",
              U: "Mouse Up",
              Fo: "Focus",
              Bl: "Blur",
              PO: "PageOpen",
              PC: "PageClose",
              PV: "PageVisible",
              PI: "PageInvisible",
              K: "Keystroke",
              F: "Format",
              V: "Validate",
              C: "Calculate"
            };
            e.AnnotationActionEventType = Ao;
            const co = {
              WC: "WillClose",
              WS: "WillSave",
              DS: "DidSave",
              WP: "WillPrint",
              DP: "DidPrint"
            };
            e.DocumentActionEventType = co;
            const Co = {
              O: "PageOpen",
              C: "PageClose"
            };
            e.PageActionEventType = Co;
            const Zs = {
              UNKNOWN: "UNKNOWN",
              FLATE: "FLATE",
              LZW: "LZW",
              DCT: "DCT",
              JPX: "JPX",
              JBIG: "JBIG",
              A85: "A85",
              AHX: "AHX",
              CCF: "CCF",
              RLX: "RLX"
            };
            e.StreamType = Zs;
            const xl = {
              UNKNOWN: "UNKNOWN",
              TYPE1: "TYPE1",
              TYPE1STANDARD: "TYPE1STANDARD",
              TYPE1C: "TYPE1C",
              CIDFONTTYPE0: "CIDFONTTYPE0",
              CIDFONTTYPE0C: "CIDFONTTYPE0C",
              TRUETYPE: "TRUETYPE",
              CIDFONTTYPE2: "CIDFONTTYPE2",
              TYPE3: "TYPE3",
              OPENTYPE: "OPENTYPE",
              TYPE0: "TYPE0",
              MMTYPE1: "MMTYPE1"
            };
            e.FontType = xl;
            const Cl = {
              ERRORS: 0,
              WARNINGS: 1,
              INFOS: 5
            };
            e.VerbosityLevel = Cl;
            const Al = {
              NONE: 0,
              BINARY: 1,
              STREAM: 2
            };
            e.CMapCompressionType = Al;
            const Ol = {
              dependency: 1,
              setLineWidth: 2,
              setLineCap: 3,
              setLineJoin: 4,
              setMiterLimit: 5,
              setDash: 6,
              setRenderingIntent: 7,
              setFlatness: 8,
              setGState: 9,
              save: 10,
              restore: 11,
              transform: 12,
              moveTo: 13,
              lineTo: 14,
              curveTo: 15,
              curveTo2: 16,
              curveTo3: 17,
              closePath: 18,
              rectangle: 19,
              stroke: 20,
              closeStroke: 21,
              fill: 22,
              eoFill: 23,
              fillStroke: 24,
              eoFillStroke: 25,
              closeFillStroke: 26,
              closeEOFillStroke: 27,
              endPath: 28,
              clip: 29,
              eoClip: 30,
              beginText: 31,
              endText: 32,
              setCharSpacing: 33,
              setWordSpacing: 34,
              setHScale: 35,
              setLeading: 36,
              setFont: 37,
              setTextRenderingMode: 38,
              setTextRise: 39,
              moveText: 40,
              setLeadingMoveText: 41,
              setTextMatrix: 42,
              nextLine: 43,
              showText: 44,
              showSpacedText: 45,
              nextLineShowText: 46,
              nextLineSetSpacingShowText: 47,
              setCharWidth: 48,
              setCharWidthAndBounds: 49,
              setStrokeColorSpace: 50,
              setFillColorSpace: 51,
              setStrokeColor: 52,
              setStrokeColorN: 53,
              setFillColor: 54,
              setFillColorN: 55,
              setStrokeGray: 56,
              setFillGray: 57,
              setStrokeRGBColor: 58,
              setFillRGBColor: 59,
              setStrokeCMYKColor: 60,
              setFillCMYKColor: 61,
              shadingFill: 62,
              beginInlineImage: 63,
              beginImageData: 64,
              endInlineImage: 65,
              paintXObject: 66,
              markPoint: 67,
              markPointProps: 68,
              beginMarkedContent: 69,
              beginMarkedContentProps: 70,
              endMarkedContent: 71,
              beginCompat: 72,
              endCompat: 73,
              paintFormXObjectBegin: 74,
              paintFormXObjectEnd: 75,
              beginGroup: 76,
              endGroup: 77,
              beginAnnotations: 78,
              endAnnotations: 79,
              beginAnnotation: 80,
              endAnnotation: 81,
              paintJpegXObject: 82,
              paintImageMaskXObject: 83,
              paintImageMaskXObjectGroup: 84,
              paintImageXObject: 85,
              paintInlineImageXObject: 86,
              paintInlineImageXObjectGroup: 87,
              paintImageXObjectRepeat: 88,
              paintImageMaskXObjectRepeat: 89,
              paintSolidColorImageMask: 90,
              constructPath: 91
            };
            e.OPS = Ol;
            const Bl = {
              unknown: "unknown",
              forms: "forms",
              javaScript: "javaScript",
              signatures: "signatures",
              smask: "smask",
              shadingPattern: "shadingPattern",
              font: "font",
              errorTilingPattern: "errorTilingPattern",
              errorExtGState: "errorExtGState",
              errorXObject: "errorXObject",
              errorFontLoadType3: "errorFontLoadType3",
              errorFontState: "errorFontState",
              errorFontMissing: "errorFontMissing",
              errorFontTranslate: "errorFontTranslate",
              errorColorSpace: "errorColorSpace",
              errorOperatorList: "errorOperatorList",
              errorFontToUnicode: "errorFontToUnicode",
              errorFontLoadNative: "errorFontLoadNative",
              errorFontBuildPath: "errorFontBuildPath",
              errorFontGetPath: "errorFontGetPath",
              errorMarkedContent: "errorMarkedContent",
              errorContentSubStream: "errorContentSubStream"
            };
            e.UNSUPPORTED_FEATURES = Bl;
            const Ml = {
              NEED_PASSWORD: 1,
              INCORRECT_PASSWORD: 2
            };
            e.PasswordResponses = Ml;
            let Vl = Cl.WARNINGS;
            function Ll(oc) {
              Number.isInteger(oc) && (Vl = oc);
            }
            function Yl() {
              return Vl;
            }
            function Zl(oc) {
              Vl >= Cl.INFOS && console.log(`Info: ${oc}`);
            }
            function tc(oc) {
              Vl >= Cl.WARNINGS && console.log(`Warning: ${oc}`);
            }
            function Nl(oc) {
              throw new Error(oc);
            }
            function Tl(oc, rc) {
              oc || Nl(rc);
            }
            function El(oc) {
              if (!oc)
                return !1;
              switch (oc.protocol) {
                case "http:":
                case "https:":
                case "ftp:":
                case "mailto:":
                case "tel:":
                  return !0;
                default:
                  return !1;
              }
            }
            function Il(oc, rc = null, nc = null) {
              if (!oc)
                return null;
              try {
                if (nc && typeof oc == "string") {
                  if (nc.addDefaultProtocol && oc.startsWith("www.")) {
                    const nd = oc.match(/\./g);
                    nd && nd.length >= 2 && (oc = `http://${oc}`);
                  }
                  if (nc.tryConvertEncoding)
                    try {
                      oc = dd(oc);
                    } catch {
                    }
                }
                const ed = rc ? new URL(oc, rc) : new URL(oc);
                if (El(ed))
                  return ed;
              } catch {
              }
              return null;
            }
            function Ul(oc, rc, nc) {
              return Object.defineProperty(oc, rc, {
                value: nc,
                enumerable: !0,
                configurable: !0,
                writable: !1
              }), nc;
            }
            const Kl = function() {
              function rc(nc, ed) {
                this.constructor === rc && Nl("Cannot initialize BaseException."), this.message = nc, this.name = ed;
              }
              return rc.prototype = new Error(), rc.constructor = rc, rc;
            }();
            e.BaseException = Kl;
            class Rl extends Kl {
              constructor(rc, nc) {
                super(rc, "PasswordException"), this.code = nc;
              }
            }
            e.PasswordException = Rl;
            class uo extends Kl {
              constructor(rc, nc) {
                super(rc, "UnknownErrorException"), this.details = nc;
              }
            }
            e.UnknownErrorException = uo;
            class Is extends Kl {
              constructor(rc) {
                super(rc, "InvalidPDFException");
              }
            }
            e.InvalidPDFException = Is;
            class Sl extends Kl {
              constructor(rc) {
                super(rc, "MissingPDFException");
              }
            }
            e.MissingPDFException = Sl;
            class wl extends Kl {
              constructor(rc, nc) {
                super(rc, "UnexpectedResponseException"), this.status = nc;
              }
            }
            e.UnexpectedResponseException = wl;
            class Pl extends Kl {
              constructor(rc) {
                super(rc, "FormatError");
              }
            }
            e.FormatError = Pl;
            class jl extends Kl {
              constructor(rc) {
                super(rc, "AbortException");
              }
            }
            e.AbortException = jl;
            function Dl(oc) {
              (typeof oc != "object" || oc === null || oc.length === void 0) && Nl("Invalid argument for bytesToString");
              const rc = oc.length, nc = 8192;
              if (rc < nc)
                return String.fromCharCode.apply(null, oc);
              const ed = [];
              for (let nd = 0; nd < rc; nd += nc) {
                const md = Math.min(nd + nc, rc), vd = oc.subarray(nd, md);
                ed.push(String.fromCharCode.apply(null, vd));
              }
              return ed.join("");
            }
            function $l(oc) {
              typeof oc != "string" && Nl("Invalid argument for stringToBytes");
              const rc = oc.length, nc = new Uint8Array(rc);
              for (let ed = 0; ed < rc; ++ed)
                nc[ed] = oc.charCodeAt(ed) & 255;
              return nc;
            }
            function kl(oc) {
              if (oc.length !== void 0)
                return oc.length;
              if (oc.byteLength !== void 0)
                return oc.byteLength;
              Nl("Invalid argument for arrayByteLength");
            }
            function zl(oc) {
              const rc = oc.length;
              if (rc === 1 && oc[0] instanceof Uint8Array)
                return oc[0];
              let nc = 0;
              for (let md = 0; md < rc; md++)
                nc += kl(oc[md]);
              let ed = 0;
              const nd = new Uint8Array(nc);
              for (let md = 0; md < rc; md++) {
                let vd = oc[md];
                vd instanceof Uint8Array || (typeof vd == "string" ? vd = $l(vd) : vd = new Uint8Array(vd));
                const Cd = vd.byteLength;
                nd.set(vd, ed), ed += Cd;
              }
              return nd;
            }
            function Hl(oc) {
              return String.fromCharCode(oc >> 24 & 255, oc >> 16 & 255, oc >> 8 & 255, oc & 255);
            }
            function Wl(oc) {
              return Object.keys(oc).length;
            }
            function ql(oc) {
              const rc = /* @__PURE__ */ Object.create(null);
              for (const [nc, ed] of oc)
                rc[nc] = ed;
              return rc;
            }
            function Jl() {
              const oc = new Uint8Array(4);
              return oc[0] = 1, new Uint32Array(oc.buffer, 0, 1)[0] === 1;
            }
            function ac() {
              try {
                return new Function(""), !0;
              } catch {
                return !1;
              }
            }
            class Xl {
              static get isLittleEndian() {
                return Ul(this, "isLittleEndian", Jl());
              }
              static get isEvalSupported() {
                return Ul(this, "isEvalSupported", ac());
              }
              static get isOffscreenCanvasSupported() {
                return Ul(this, "isOffscreenCanvasSupported", typeof OffscreenCanvas < "u");
              }
            }
            e.FeatureTest = Xl;
            const sc = [...Array(256).keys()].map((oc) => oc.toString(16).padStart(2, "0"));
            class Hu {
              static makeHexColor(rc, nc, ed) {
                return `#${sc[rc]}${sc[nc]}${sc[ed]}`;
              }
              static scaleMinMax(rc, nc) {
                let ed;
                rc[0] ? (rc[0] < 0 && (ed = nc[0], nc[0] = nc[1], nc[1] = ed), nc[0] *= rc[0], nc[1] *= rc[0], rc[3] < 0 && (ed = nc[2], nc[2] = nc[3], nc[3] = ed), nc[2] *= rc[3], nc[3] *= rc[3]) : (ed = nc[0], nc[0] = nc[2], nc[2] = ed, ed = nc[1], nc[1] = nc[3], nc[3] = ed, rc[1] < 0 && (ed = nc[2], nc[2] = nc[3], nc[3] = ed), nc[2] *= rc[1], nc[3] *= rc[1], rc[2] < 0 && (ed = nc[0], nc[0] = nc[1], nc[1] = ed), nc[0] *= rc[2], nc[1] *= rc[2]), nc[0] += rc[4], nc[1] += rc[4], nc[2] += rc[5], nc[3] += rc[5];
              }
              static transform(rc, nc) {
                return [rc[0] * nc[0] + rc[2] * nc[1], rc[1] * nc[0] + rc[3] * nc[1], rc[0] * nc[2] + rc[2] * nc[3], rc[1] * nc[2] + rc[3] * nc[3], rc[0] * nc[4] + rc[2] * nc[5] + rc[4], rc[1] * nc[4] + rc[3] * nc[5] + rc[5]];
              }
              static applyTransform(rc, nc) {
                const ed = rc[0] * nc[0] + rc[1] * nc[2] + nc[4], nd = rc[0] * nc[1] + rc[1] * nc[3] + nc[5];
                return [ed, nd];
              }
              static applyInverseTransform(rc, nc) {
                const ed = nc[0] * nc[3] - nc[1] * nc[2], nd = (rc[0] * nc[3] - rc[1] * nc[2] + nc[2] * nc[5] - nc[4] * nc[3]) / ed, md = (-rc[0] * nc[1] + rc[1] * nc[0] + nc[4] * nc[1] - nc[5] * nc[0]) / ed;
                return [nd, md];
              }
              static getAxialAlignedBoundingBox(rc, nc) {
                const ed = Hu.applyTransform(rc, nc), nd = Hu.applyTransform(rc.slice(2, 4), nc), md = Hu.applyTransform([rc[0], rc[3]], nc), vd = Hu.applyTransform([rc[2], rc[1]], nc);
                return [Math.min(ed[0], nd[0], md[0], vd[0]), Math.min(ed[1], nd[1], md[1], vd[1]), Math.max(ed[0], nd[0], md[0], vd[0]), Math.max(ed[1], nd[1], md[1], vd[1])];
              }
              static inverseTransform(rc) {
                const nc = rc[0] * rc[3] - rc[1] * rc[2];
                return [rc[3] / nc, -rc[1] / nc, -rc[2] / nc, rc[0] / nc, (rc[2] * rc[5] - rc[4] * rc[3]) / nc, (rc[4] * rc[1] - rc[5] * rc[0]) / nc];
              }
              static apply3dTransform(rc, nc) {
                return [rc[0] * nc[0] + rc[1] * nc[1] + rc[2] * nc[2], rc[3] * nc[0] + rc[4] * nc[1] + rc[5] * nc[2], rc[6] * nc[0] + rc[7] * nc[1] + rc[8] * nc[2]];
              }
              static singularValueDecompose2dScale(rc) {
                const nc = [rc[0], rc[2], rc[1], rc[3]], ed = rc[0] * nc[0] + rc[1] * nc[2], nd = rc[0] * nc[1] + rc[1] * nc[3], md = rc[2] * nc[0] + rc[3] * nc[2], vd = rc[2] * nc[1] + rc[3] * nc[3], Cd = (ed + vd) / 2, Id = Math.sqrt((ed + vd) ** 2 - 4 * (ed * vd - md * nd)) / 2, Pd = Cd + Id || 1, _d = Cd - Id || 1;
                return [Math.sqrt(Pd), Math.sqrt(_d)];
              }
              static normalizeRect(rc) {
                const nc = rc.slice(0);
                return rc[0] > rc[2] && (nc[0] = rc[2], nc[2] = rc[0]), rc[1] > rc[3] && (nc[1] = rc[3], nc[3] = rc[1]), nc;
              }
              static intersect(rc, nc) {
                const ed = Math.max(Math.min(rc[0], rc[2]), Math.min(nc[0], nc[2])), nd = Math.min(Math.max(rc[0], rc[2]), Math.max(nc[0], nc[2]));
                if (ed > nd)
                  return null;
                const md = Math.max(Math.min(rc[1], rc[3]), Math.min(nc[1], nc[3])), vd = Math.min(Math.max(rc[1], rc[3]), Math.max(nc[1], nc[3]));
                return md > vd ? null : [ed, md, nd, vd];
              }
              static bezierBoundingBox(rc, nc, ed, nd, md, vd, Cd, Id) {
                const Pd = [], _d = [[], []];
                let Md, kd, jd, yd, Fd, Nd, Ud, Ql;
                for (let cd = 0; cd < 2; ++cd) {
                  if (cd === 0 ? (kd = 6 * rc - 12 * ed + 6 * md, Md = -3 * rc + 9 * ed - 9 * md + 3 * Cd, jd = 3 * ed - 3 * rc) : (kd = 6 * nc - 12 * nd + 6 * vd, Md = -3 * nc + 9 * nd - 9 * vd + 3 * Id, jd = 3 * nd - 3 * nc), Math.abs(Md) < 1e-12) {
                    if (Math.abs(kd) < 1e-12)
                      continue;
                    yd = -jd / kd, 0 < yd && yd < 1 && Pd.push(yd);
                    continue;
                  }
                  Ud = kd * kd - 4 * jd * Md, Ql = Math.sqrt(Ud), !(Ud < 0) && (Fd = (-kd + Ql) / (2 * Md), 0 < Fd && Fd < 1 && Pd.push(Fd), Nd = (-kd - Ql) / (2 * Md), 0 < Nd && Nd < 1 && Pd.push(Nd));
                }
                let uc = Pd.length, Ju;
                const rd = uc;
                for (; uc--; )
                  yd = Pd[uc], Ju = 1 - yd, _d[0][uc] = Ju * Ju * Ju * rc + 3 * Ju * Ju * yd * ed + 3 * Ju * yd * yd * md + yd * yd * yd * Cd, _d[1][uc] = Ju * Ju * Ju * nc + 3 * Ju * Ju * yd * nd + 3 * Ju * yd * yd * vd + yd * yd * yd * Id;
                return _d[0][rd] = rc, _d[1][rd] = nc, _d[0][rd + 1] = Cd, _d[1][rd + 1] = Id, _d[0].length = _d[1].length = rd + 2, [Math.min(..._d[0]), Math.min(..._d[1]), Math.max(..._d[0]), Math.max(..._d[1])];
              }
            }
            e.Util = Hu;
            const dc = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 728, 711, 710, 729, 733, 731, 730, 732, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 8226, 8224, 8225, 8230, 8212, 8211, 402, 8260, 8249, 8250, 8722, 8240, 8222, 8220, 8221, 8216, 8217, 8218, 8482, 64257, 64258, 321, 338, 352, 376, 381, 305, 322, 339, 353, 382, 0, 8364];
            function td(oc) {
              if (oc[0] >= "ï") {
                let nc;
                if (oc[0] === "þ" && oc[1] === "ÿ" ? nc = "utf-16be" : oc[0] === "ÿ" && oc[1] === "þ" ? nc = "utf-16le" : oc[0] === "ï" && oc[1] === "»" && oc[2] === "¿" && (nc = "utf-8"), nc)
                  try {
                    const ed = new TextDecoder(nc, {
                      fatal: !0
                    }), nd = $l(oc);
                    return ed.decode(nd);
                  } catch (ed) {
                    tc(`stringToPDFString: "${ed}".`);
                  }
              }
              const rc = [];
              for (let nc = 0, ed = oc.length; nc < ed; nc++) {
                const nd = dc[oc.charCodeAt(nc)];
                rc.push(nd ? String.fromCharCode(nd) : oc.charAt(nc));
              }
              return rc.join("");
            }
            function ad(oc) {
              return oc.replace(/([()\\\n\r])/g, (rc) => rc === `
` ? "\\n" : rc === "\r" ? "\\r" : `\\${rc}`);
            }
            function od(oc) {
              return /^[\x00-\x7F]*$/.test(oc);
            }
            function sd(oc) {
              const rc = ["þÿ"];
              for (let nc = 0, ed = oc.length; nc < ed; nc++) {
                const nd = oc.charCodeAt(nc);
                rc.push(String.fromCharCode(nd >> 8 & 255), String.fromCharCode(nd & 255));
              }
              return rc.join("");
            }
            function dd(oc) {
              return decodeURIComponent(escape(oc));
            }
            function pd(oc) {
              return unescape(encodeURIComponent(oc));
            }
            function fd(oc) {
              return typeof oc == "object" && oc !== null && oc.byteLength !== void 0;
            }
            function Ed(oc, rc) {
              if (oc.length !== rc.length)
                return !1;
              for (let nc = 0, ed = oc.length; nc < ed; nc++)
                if (oc[nc] !== rc[nc])
                  return !1;
              return !0;
            }
            function wd(oc = /* @__PURE__ */ new Date()) {
              return [oc.getUTCFullYear().toString(), (oc.getUTCMonth() + 1).toString().padStart(2, "0"), oc.getUTCDate().toString().padStart(2, "0"), oc.getUTCHours().toString().padStart(2, "0"), oc.getUTCMinutes().toString().padStart(2, "0"), oc.getUTCSeconds().toString().padStart(2, "0")].join("");
            }
            function Ad() {
              const oc = /* @__PURE__ */ Object.create(null);
              let rc = !1;
              return Object.defineProperty(oc, "settled", {
                get() {
                  return rc;
                }
              }), oc.promise = new Promise(function(nc, ed) {
                oc.resolve = function(nd) {
                  rc = !0, nc(nd);
                }, oc.reject = function(nd) {
                  rc = !0, ed(nd);
                };
              }), oc;
            }
          },
          /* 2 */
          /***/
          (Bi, e, Ui) => {
            Ui(3);
          },
          /* 3 */
          /***/
          (Bi, e) => {
            Object.defineProperty(e, "__esModule", {
              value: !0
            }), e.isNodeJS = void 0;
            const Ui = typeof process == "object" && process + "" == "[object process]" && !process.versions.nw && !(process.versions.electron && process.type && process.type !== "browser");
            e.isNodeJS = Ui;
          },
          /* 4 */
          /***/
          (__unused_webpack_module, exports, __w_pdfjs_require__) => {
            var Bi, Ui, Zi, ta, na, ia, aa, da, sf, qa, io;
            Object.defineProperty(exports, "__esModule", {
              value: !0
            }), exports.build = exports.RenderTask = exports.PDFWorkerUtil = exports.PDFWorker = exports.PDFPageProxy = exports.PDFDocumentProxy = exports.PDFDocumentLoadingTask = exports.PDFDataRangeTransport = exports.LoopbackPort = exports.DefaultStandardFontDataFactory = exports.DefaultCanvasFactory = exports.DefaultCMapReaderFactory = void 0, exports.getDocument = getDocument, exports.setPDFNetworkStreamFactory = setPDFNetworkStreamFactory, exports.version = void 0;
            var _util = __w_pdfjs_require__(1), _annotation_storage = __w_pdfjs_require__(5), _display_utils = __w_pdfjs_require__(8), _font_loader = __w_pdfjs_require__(11), _canvas = __w_pdfjs_require__(12), _worker_options = __w_pdfjs_require__(15), _is_node = __w_pdfjs_require__(3), _message_handler = __w_pdfjs_require__(16), _metadata = __w_pdfjs_require__(17), _optional_content_config = __w_pdfjs_require__(18), _transport_stream = __w_pdfjs_require__(19), _xfa_text = __w_pdfjs_require__(20);
            const DEFAULT_RANGE_CHUNK_SIZE = 65536, RENDERING_CANCELLED_TIMEOUT = 100;
            let DefaultCanvasFactory = _display_utils.DOMCanvasFactory;
            exports.DefaultCanvasFactory = DefaultCanvasFactory;
            let DefaultCMapReaderFactory = _display_utils.DOMCMapReaderFactory;
            exports.DefaultCMapReaderFactory = DefaultCMapReaderFactory;
            let DefaultStandardFontDataFactory = _display_utils.DOMStandardFontDataFactory;
            if (exports.DefaultStandardFontDataFactory = DefaultStandardFontDataFactory, _is_node.isNodeJS) {
              const {
                NodeCanvasFactory: oo,
                NodeCMapReaderFactory: no,
                NodeStandardFontDataFactory: lo
              } = __w_pdfjs_require__(21);
              exports.DefaultCanvasFactory = DefaultCanvasFactory = oo, exports.DefaultCMapReaderFactory = DefaultCMapReaderFactory = no, exports.DefaultStandardFontDataFactory = DefaultStandardFontDataFactory = lo;
            }
            let createPDFNetworkStream;
            function setPDFNetworkStreamFactory(oo) {
              createPDFNetworkStream = oo;
            }
            function getDocument(oo) {
              const no = new PDFDocumentLoadingTask();
              let lo;
              if (typeof oo == "string" || oo instanceof URL)
                lo = {
                  url: oo
                };
              else if ((0, _util.isArrayBuffer)(oo))
                lo = {
                  data: oo
                };
              else if (oo instanceof PDFDataRangeTransport)
                lo = {
                  range: oo
                };
              else {
                if (typeof oo != "object")
                  throw new Error("Invalid parameter in getDocument, need either string, URL, TypedArray, or parameter object.");
                if (!oo.url && !oo.data && !oo.range)
                  throw new Error("Invalid parameter object: need either .data, .range or .url");
                lo = oo;
              }
              const so = /* @__PURE__ */ Object.create(null);
              let bs = null, Rs = null;
              for (const qs in lo) {
                const jo = lo[qs];
                switch (qs) {
                  case "url":
                    if (typeof window < "u")
                      try {
                        so[qs] = new URL(jo, window.location).href;
                        continue;
                      } catch (fs) {
                        (0, _util.warn)(`Cannot create valid URL: "${fs}".`);
                      }
                    else if (typeof jo == "string" || jo instanceof URL) {
                      so[qs] = jo.toString();
                      continue;
                    }
                    throw new Error("Invalid PDF url data: either string or URL-object is expected in the url property.");
                  case "range":
                    bs = jo;
                    continue;
                  case "worker":
                    Rs = jo;
                    continue;
                  case "data":
                    if (_is_node.isNodeJS && typeof Buffer < "u" && jo instanceof Buffer)
                      so[qs] = new Uint8Array(jo);
                    else {
                      if (jo instanceof Uint8Array)
                        break;
                      if (typeof jo == "string")
                        so[qs] = (0, _util.stringToBytes)(jo);
                      else if (typeof jo == "object" && jo !== null && !isNaN(jo.length))
                        so[qs] = new Uint8Array(jo);
                      else if ((0, _util.isArrayBuffer)(jo))
                        so[qs] = new Uint8Array(jo);
                      else
                        throw new Error("Invalid PDF binary data: either TypedArray, string, or array-like object is expected in the data property.");
                    }
                    continue;
                }
                so[qs] = jo;
              }
              if (so.CMapReaderFactory = so.CMapReaderFactory || DefaultCMapReaderFactory, so.StandardFontDataFactory = so.StandardFontDataFactory || DefaultStandardFontDataFactory, so.ignoreErrors = so.stopAtErrors !== !0, so.fontExtraProperties = so.fontExtraProperties === !0, so.pdfBug = so.pdfBug === !0, so.enableXfa = so.enableXfa === !0, (!Number.isInteger(so.rangeChunkSize) || so.rangeChunkSize < 1) && (so.rangeChunkSize = DEFAULT_RANGE_CHUNK_SIZE), (typeof so.docBaseUrl != "string" || (0, _display_utils.isDataScheme)(so.docBaseUrl)) && (so.docBaseUrl = null), (!Number.isInteger(so.maxImageSize) || so.maxImageSize < -1) && (so.maxImageSize = -1), typeof so.cMapUrl != "string" && (so.cMapUrl = null), typeof so.standardFontDataUrl != "string" && (so.standardFontDataUrl = null), typeof so.useWorkerFetch != "boolean" && (so.useWorkerFetch = so.CMapReaderFactory === _display_utils.DOMCMapReaderFactory && so.StandardFontDataFactory === _display_utils.DOMStandardFontDataFactory), typeof so.isEvalSupported != "boolean" && (so.isEvalSupported = !0), typeof so.disableFontFace != "boolean" && (so.disableFontFace = _is_node.isNodeJS), typeof so.useSystemFonts != "boolean" && (so.useSystemFonts = !_is_node.isNodeJS && !so.disableFontFace), (typeof so.ownerDocument != "object" || so.ownerDocument === null) && (so.ownerDocument = globalThis.document), typeof so.disableRange != "boolean" && (so.disableRange = !1), typeof so.disableStream != "boolean" && (so.disableStream = !1), typeof so.disableAutoFetch != "boolean" && (so.disableAutoFetch = !1), (0, _util.setVerbosityLevel)(so.verbosity), !Rs) {
                const qs = {
                  verbosity: so.verbosity,
                  port: _worker_options.GlobalWorkerOptions.workerPort
                };
                Rs = qs.port ? PDFWorker.fromPort(qs) : new PDFWorker(qs), no._worker = Rs;
              }
              const js = no.docId;
              return Rs.promise.then(function() {
                if (no.destroyed)
                  throw new Error("Loading aborted");
                const qs = _fetchDocument(Rs, so, bs, js), jo = new Promise(function(fs) {
                  let Ao;
                  bs ? Ao = new _transport_stream.PDFDataTransportStream({
                    length: so.length,
                    initialData: so.initialData,
                    progressiveDone: so.progressiveDone,
                    contentDispositionFilename: so.contentDispositionFilename,
                    disableRange: so.disableRange,
                    disableStream: so.disableStream
                  }, bs) : so.data || (Ao = createPDFNetworkStream({
                    url: so.url,
                    length: so.length,
                    httpHeaders: so.httpHeaders,
                    withCredentials: so.withCredentials,
                    rangeChunkSize: so.rangeChunkSize,
                    disableRange: so.disableRange,
                    disableStream: so.disableStream
                  })), fs(Ao);
                });
                return Promise.all([qs, jo]).then(function([fs, Ao]) {
                  if (no.destroyed)
                    throw new Error("Loading aborted");
                  const co = new _message_handler.MessageHandler(js, fs, Rs.port), Co = new WorkerTransport(co, no, Ao, so);
                  no._transport = Co, co.send("Ready", null);
                });
              }).catch(no._capability.reject), no;
            }
            async function _fetchDocument(oo, no, lo, so) {
              if (oo.destroyed)
                throw new Error("Worker was destroyed");
              lo && (no.length = lo.length, no.initialData = lo.initialData, no.progressiveDone = lo.progressiveDone, no.contentDispositionFilename = lo.contentDispositionFilename);
              const bs = await oo.messageHandler.sendWithPromise("GetDocRequest", {
                docId: so,
                apiVersion: "2.16.105",
                source: {
                  data: no.data,
                  url: no.url,
                  password: no.password,
                  disableAutoFetch: no.disableAutoFetch,
                  rangeChunkSize: no.rangeChunkSize,
                  length: no.length
                },
                maxImageSize: no.maxImageSize,
                disableFontFace: no.disableFontFace,
                docBaseUrl: no.docBaseUrl,
                ignoreErrors: no.ignoreErrors,
                isEvalSupported: no.isEvalSupported,
                fontExtraProperties: no.fontExtraProperties,
                enableXfa: no.enableXfa,
                useSystemFonts: no.useSystemFonts,
                cMapUrl: no.useWorkerFetch ? no.cMapUrl : null,
                standardFontDataUrl: no.useWorkerFetch ? no.standardFontDataUrl : null
              });
              if (no.data && (no.data = null), oo.destroyed)
                throw new Error("Worker was destroyed");
              return bs;
            }
            const e = class e {
              constructor() {
                this._capability = (0, _util.createPromiseCapability)(), this._transport = null, this._worker = null, this.docId = `d${ef(e, Bi)._++}`, this.destroyed = !1, this.onPassword = null, this.onProgress = null, this.onUnsupportedFeature = null;
              }
              get promise() {
                return this._capability.promise;
              }
              async destroy() {
                this.destroyed = !0, await this._transport?.destroy(), this._transport = null, this._worker && (this._worker.destroy(), this._worker = null);
              }
            };
            Bi = new WeakMap(), fc(e, Bi, 0);
            let PDFDocumentLoadingTask = e;
            exports.PDFDocumentLoadingTask = PDFDocumentLoadingTask;
            class PDFDataRangeTransport {
              constructor(no, lo, so = !1, bs = null) {
                this.length = no, this.initialData = lo, this.progressiveDone = so, this.contentDispositionFilename = bs, this._rangeListeners = [], this._progressListeners = [], this._progressiveReadListeners = [], this._progressiveDoneListeners = [], this._readyCapability = (0, _util.createPromiseCapability)();
              }
              addRangeListener(no) {
                this._rangeListeners.push(no);
              }
              addProgressListener(no) {
                this._progressListeners.push(no);
              }
              addProgressiveReadListener(no) {
                this._progressiveReadListeners.push(no);
              }
              addProgressiveDoneListener(no) {
                this._progressiveDoneListeners.push(no);
              }
              onDataRange(no, lo) {
                for (const so of this._rangeListeners)
                  so(no, lo);
              }
              onDataProgress(no, lo) {
                this._readyCapability.promise.then(() => {
                  for (const so of this._progressListeners)
                    so(no, lo);
                });
              }
              onDataProgressiveRead(no) {
                this._readyCapability.promise.then(() => {
                  for (const lo of this._progressiveReadListeners)
                    lo(no);
                });
              }
              onDataProgressiveDone() {
                this._readyCapability.promise.then(() => {
                  for (const no of this._progressiveDoneListeners)
                    no();
                });
              }
              transportReady() {
                this._readyCapability.resolve();
              }
              requestDataRange(no, lo) {
                (0, _util.unreachable)("Abstract method PDFDataRangeTransport.requestDataRange");
              }
              abort() {
              }
            }
            exports.PDFDataRangeTransport = PDFDataRangeTransport;
            class PDFDocumentProxy {
              constructor(no, lo) {
                this._pdfInfo = no, this._transport = lo, Object.defineProperty(this, "fingerprint", {
                  get() {
                    return (0, _display_utils.deprecated)("`PDFDocumentProxy.fingerprint`, please use `PDFDocumentProxy.fingerprints` instead."), this.fingerprints[0];
                  }
                }), Object.defineProperty(this, "getStats", {
                  value: async () => ((0, _display_utils.deprecated)("`PDFDocumentProxy.getStats`, please use the `PDFDocumentProxy.stats`-getter instead."), this.stats || {
                    streamTypes: {},
                    fontTypes: {}
                  })
                });
              }
              get annotationStorage() {
                return this._transport.annotationStorage;
              }
              get numPages() {
                return this._pdfInfo.numPages;
              }
              get fingerprints() {
                return this._pdfInfo.fingerprints;
              }
              get stats() {
                return this._transport.stats;
              }
              get isPureXfa() {
                return !!this._transport._htmlForXfa;
              }
              get allXfaHtml() {
                return this._transport._htmlForXfa;
              }
              getPage(no) {
                return this._transport.getPage(no);
              }
              getPageIndex(no) {
                return this._transport.getPageIndex(no);
              }
              getDestinations() {
                return this._transport.getDestinations();
              }
              getDestination(no) {
                return this._transport.getDestination(no);
              }
              getPageLabels() {
                return this._transport.getPageLabels();
              }
              getPageLayout() {
                return this._transport.getPageLayout();
              }
              getPageMode() {
                return this._transport.getPageMode();
              }
              getViewerPreferences() {
                return this._transport.getViewerPreferences();
              }
              getOpenAction() {
                return this._transport.getOpenAction();
              }
              getAttachments() {
                return this._transport.getAttachments();
              }
              getJavaScript() {
                return this._transport.getJavaScript();
              }
              getJSActions() {
                return this._transport.getDocJSActions();
              }
              getOutline() {
                return this._transport.getOutline();
              }
              getOptionalContentConfig() {
                return this._transport.getOptionalContentConfig();
              }
              getPermissions() {
                return this._transport.getPermissions();
              }
              getMetadata() {
                return this._transport.getMetadata();
              }
              getMarkInfo() {
                return this._transport.getMarkInfo();
              }
              getData() {
                return this._transport.getData();
              }
              getDownloadInfo() {
                return this._transport.downloadInfoCapability.promise;
              }
              cleanup(no = !1) {
                return this._transport.startCleanup(no || this.isPureXfa);
              }
              destroy() {
                return this.loadingTask.destroy();
              }
              get loadingParams() {
                return this._transport.loadingParams;
              }
              get loadingTask() {
                return this._transport.loadingTask;
              }
              saveDocument() {
                return this._transport.annotationStorage.size <= 0 && (0, _display_utils.deprecated)("saveDocument called while `annotationStorage` is empty, please use the getData-method instead."), this._transport.saveDocument();
              }
              getFieldObjects() {
                return this._transport.getFieldObjects();
              }
              hasJSActions() {
                return this._transport.hasJSActions();
              }
              getCalculationOrderIds() {
                return this._transport.getCalculationOrderIds();
              }
            }
            exports.PDFDocumentProxy = PDFDocumentProxy;
            class PDFPageProxy {
              constructor(no, lo, so, bs, Rs = !1) {
                this._pageIndex = no, this._pageInfo = lo, this._ownerDocument = bs, this._transport = so, this._stats = Rs ? new _display_utils.StatTimer() : null, this._pdfBug = Rs, this.commonObjs = so.commonObjs, this.objs = new PDFObjects(), this._bitmaps = /* @__PURE__ */ new Set(), this.cleanupAfterRender = !1, this.pendingCleanup = !1, this._intentStates = /* @__PURE__ */ new Map(), this._annotationPromises = /* @__PURE__ */ new Map(), this.destroyed = !1;
              }
              get pageNumber() {
                return this._pageIndex + 1;
              }
              get rotate() {
                return this._pageInfo.rotate;
              }
              get ref() {
                return this._pageInfo.ref;
              }
              get userUnit() {
                return this._pageInfo.userUnit;
              }
              get view() {
                return this._pageInfo.view;
              }
              getViewport({
                scale: no,
                rotation: lo = this.rotate,
                offsetX: so = 0,
                offsetY: bs = 0,
                dontFlip: Rs = !1
              } = {}) {
                return new _display_utils.PageViewport({
                  viewBox: this.view,
                  scale: no,
                  rotation: lo,
                  offsetX: so,
                  offsetY: bs,
                  dontFlip: Rs
                });
              }
              getAnnotations({
                intent: no = "display"
              } = {}) {
                const lo = this._transport.getRenderingIntent(no);
                let so = this._annotationPromises.get(lo.cacheKey);
                return so || (so = this._transport.getAnnotations(this._pageIndex, lo.renderingIntent), this._annotationPromises.set(lo.cacheKey, so), so = so.then((bs) => {
                  for (const Rs of bs)
                    Rs.titleObj !== void 0 && Object.defineProperty(Rs, "title", {
                      get() {
                        return (0, _display_utils.deprecated)("`title`-property on annotation, please use `titleObj` instead."), Rs.titleObj.str;
                      }
                    }), Rs.contentsObj !== void 0 && Object.defineProperty(Rs, "contents", {
                      get() {
                        return (0, _display_utils.deprecated)("`contents`-property on annotation, please use `contentsObj` instead."), Rs.contentsObj.str;
                      }
                    });
                  return bs;
                })), so;
              }
              getJSActions() {
                return this._jsActionsPromise || (this._jsActionsPromise = this._transport.getPageJSActions(this._pageIndex));
              }
              async getXfa() {
                return this._transport._htmlForXfa?.children[this._pageIndex] || null;
              }
              render({
                canvasContext: no,
                viewport: lo,
                intent: so = "display",
                annotationMode: bs = _util.AnnotationMode.ENABLE,
                transform: Rs = null,
                imageLayer: js = null,
                canvasFactory: qs = null,
                background: jo = null,
                optionalContentConfigPromise: fs = null,
                annotationCanvasMap: Ao = null,
                pageColors: co = null,
                printAnnotationStorage: Co = null
              }) {
                arguments[0]?.renderInteractiveForms !== void 0 && ((0, _display_utils.deprecated)("render no longer accepts the `renderInteractiveForms`-option, please use the `annotationMode`-option instead."), arguments[0].renderInteractiveForms === !0 && bs === _util.AnnotationMode.ENABLE && (bs = _util.AnnotationMode.ENABLE_FORMS)), arguments[0]?.includeAnnotationStorage !== void 0 && ((0, _display_utils.deprecated)("render no longer accepts the `includeAnnotationStorage`-option, please use the `annotationMode`-option instead."), arguments[0].includeAnnotationStorage === !0 && bs === _util.AnnotationMode.ENABLE && (bs = _util.AnnotationMode.ENABLE_STORAGE)), this._stats && this._stats.time("Overall");
                const Zs = this._transport.getRenderingIntent(so, bs, Co);
                this.pendingCleanup = !1, fs || (fs = this._transport.getOptionalContentConfig());
                let xl = this._intentStates.get(Zs.cacheKey);
                xl || (xl = /* @__PURE__ */ Object.create(null), this._intentStates.set(Zs.cacheKey, xl)), xl.streamReaderCancelTimeout && (clearTimeout(xl.streamReaderCancelTimeout), xl.streamReaderCancelTimeout = null);
                const Cl = qs || new DefaultCanvasFactory({
                  ownerDocument: this._ownerDocument
                }), Al = !!(Zs.renderingIntent & _util.RenderingIntentFlag.PRINT);
                xl.displayReadyCapability || (xl.displayReadyCapability = (0, _util.createPromiseCapability)(), xl.operatorList = {
                  fnArray: [],
                  argsArray: [],
                  lastChunk: !1,
                  separateAnnots: null
                }, this._stats && this._stats.time("Page Request"), this._pumpOperatorList(Zs));
                const Ol = (Vl) => {
                  xl.renderTasks.delete(Bl), (this.cleanupAfterRender || Al) && (this.pendingCleanup = !0), this._tryCleanup(), Vl ? (Bl.capability.reject(Vl), this._abortOperatorList({
                    intentState: xl,
                    reason: Vl instanceof Error ? Vl : new Error(Vl)
                  })) : Bl.capability.resolve(), this._stats && (this._stats.timeEnd("Rendering"), this._stats.timeEnd("Overall"));
                }, Bl = new InternalRenderTask({
                  callback: Ol,
                  params: {
                    canvasContext: no,
                    viewport: lo,
                    transform: Rs,
                    imageLayer: js,
                    background: jo
                  },
                  objs: this.objs,
                  commonObjs: this.commonObjs,
                  annotationCanvasMap: Ao,
                  operatorList: xl.operatorList,
                  pageIndex: this._pageIndex,
                  canvasFactory: Cl,
                  useRequestAnimationFrame: !Al,
                  pdfBug: this._pdfBug,
                  pageColors: co
                });
                (xl.renderTasks || (xl.renderTasks = /* @__PURE__ */ new Set())).add(Bl);
                const Ml = Bl.task;
                return Promise.all([xl.displayReadyCapability.promise, fs]).then(([Vl, Ll]) => {
                  if (this.pendingCleanup) {
                    Ol();
                    return;
                  }
                  this._stats && this._stats.time("Rendering"), Bl.initializeGraphics({
                    transparency: Vl,
                    optionalContentConfig: Ll
                  }), Bl.operatorListChanged();
                }).catch(Ol), Ml;
              }
              getOperatorList({
                intent: no = "display",
                annotationMode: lo = _util.AnnotationMode.ENABLE,
                printAnnotationStorage: so = null
              } = {}) {
                function bs() {
                  js.operatorList.lastChunk && (js.opListReadCapability.resolve(js.operatorList), js.renderTasks.delete(qs));
                }
                const Rs = this._transport.getRenderingIntent(no, lo, so, !0);
                let js = this._intentStates.get(Rs.cacheKey);
                js || (js = /* @__PURE__ */ Object.create(null), this._intentStates.set(Rs.cacheKey, js));
                let qs;
                return js.opListReadCapability || (qs = /* @__PURE__ */ Object.create(null), qs.operatorListChanged = bs, js.opListReadCapability = (0, _util.createPromiseCapability)(), (js.renderTasks || (js.renderTasks = /* @__PURE__ */ new Set())).add(qs), js.operatorList = {
                  fnArray: [],
                  argsArray: [],
                  lastChunk: !1,
                  separateAnnots: null
                }, this._stats && this._stats.time("Page Request"), this._pumpOperatorList(Rs)), js.opListReadCapability.promise;
              }
              streamTextContent({
                disableCombineTextItems: no = !1,
                includeMarkedContent: lo = !1
              } = {}) {
                return this._transport.messageHandler.sendWithStream("GetTextContent", {
                  pageIndex: this._pageIndex,
                  combineTextItems: no !== !0,
                  includeMarkedContent: lo === !0
                }, {
                  highWaterMark: 100,
                  size(bs) {
                    return bs.items.length;
                  }
                });
              }
              getTextContent(no = {}) {
                if (this._transport._htmlForXfa)
                  return this.getXfa().then((so) => _xfa_text.XfaText.textContent(so));
                const lo = this.streamTextContent(no);
                return new Promise(function(so, bs) {
                  function Rs() {
                    js.read().then(function({
                      value: jo,
                      done: fs
                    }) {
                      if (fs) {
                        so(qs);
                        return;
                      }
                      Object.assign(qs.styles, jo.styles), qs.items.push(...jo.items), Rs();
                    }, bs);
                  }
                  const js = lo.getReader(), qs = {
                    items: [],
                    styles: /* @__PURE__ */ Object.create(null)
                  };
                  Rs();
                });
              }
              getStructTree() {
                return this._structTreePromise || (this._structTreePromise = this._transport.getStructTree(this._pageIndex));
              }
              _destroy() {
                this.destroyed = !0;
                const no = [];
                for (const lo of this._intentStates.values())
                  if (this._abortOperatorList({
                    intentState: lo,
                    reason: new Error("Page was destroyed."),
                    force: !0
                  }), !lo.opListReadCapability)
                    for (const so of lo.renderTasks)
                      no.push(so.completed), so.cancel();
                this.objs.clear();
                for (const lo of this._bitmaps)
                  lo.close();
                return this._bitmaps.clear(), this._annotationPromises.clear(), this._jsActionsPromise = null, this._structTreePromise = null, this.pendingCleanup = !1, Promise.all(no);
              }
              cleanup(no = !1) {
                return this.pendingCleanup = !0, this._tryCleanup(no);
              }
              _tryCleanup(no = !1) {
                if (!this.pendingCleanup)
                  return !1;
                for (const {
                  renderTasks: lo,
                  operatorList: so
                } of this._intentStates.values())
                  if (lo.size > 0 || !so.lastChunk)
                    return !1;
                this._intentStates.clear(), this.objs.clear(), this._annotationPromises.clear(), this._jsActionsPromise = null, this._structTreePromise = null, no && this._stats && (this._stats = new _display_utils.StatTimer());
                for (const lo of this._bitmaps)
                  lo.close();
                return this._bitmaps.clear(), this.pendingCleanup = !1, !0;
              }
              _startRenderPage(no, lo) {
                const so = this._intentStates.get(lo);
                so && (this._stats && this._stats.timeEnd("Page Request"), so.displayReadyCapability && so.displayReadyCapability.resolve(no));
              }
              _renderPageChunk(no, lo) {
                for (let so = 0, bs = no.length; so < bs; so++)
                  lo.operatorList.fnArray.push(no.fnArray[so]), lo.operatorList.argsArray.push(no.argsArray[so]);
                lo.operatorList.lastChunk = no.lastChunk, lo.operatorList.separateAnnots = no.separateAnnots;
                for (const so of lo.renderTasks)
                  so.operatorListChanged();
                no.lastChunk && this._tryCleanup();
              }
              _pumpOperatorList({
                renderingIntent: no,
                cacheKey: lo,
                annotationStorageMap: so
              }) {
                const Rs = this._transport.messageHandler.sendWithStream("GetOperatorList", {
                  pageIndex: this._pageIndex,
                  intent: no,
                  cacheKey: lo,
                  annotationStorage: so
                }).getReader(), js = this._intentStates.get(lo);
                js.streamReader = Rs;
                const qs = () => {
                  Rs.read().then(({
                    value: jo,
                    done: fs
                  }) => {
                    if (fs) {
                      js.streamReader = null;
                      return;
                    }
                    this._transport.destroyed || (this._renderPageChunk(jo, js), qs());
                  }, (jo) => {
                    if (js.streamReader = null, !this._transport.destroyed) {
                      if (js.operatorList) {
                        js.operatorList.lastChunk = !0;
                        for (const fs of js.renderTasks)
                          fs.operatorListChanged();
                        this._tryCleanup();
                      }
                      if (js.displayReadyCapability)
                        js.displayReadyCapability.reject(jo);
                      else if (js.opListReadCapability)
                        js.opListReadCapability.reject(jo);
                      else
                        throw jo;
                    }
                  });
                };
                qs();
              }
              _abortOperatorList({
                intentState: no,
                reason: lo,
                force: so = !1
              }) {
                if (no.streamReader) {
                  if (!so) {
                    if (no.renderTasks.size > 0)
                      return;
                    if (lo instanceof _display_utils.RenderingCancelledException) {
                      no.streamReaderCancelTimeout = setTimeout(() => {
                        this._abortOperatorList({
                          intentState: no,
                          reason: lo,
                          force: !0
                        }), no.streamReaderCancelTimeout = null;
                      }, RENDERING_CANCELLED_TIMEOUT);
                      return;
                    }
                  }
                  if (no.streamReader.cancel(new _util.AbortException(lo.message)).catch(() => {
                  }), no.streamReader = null, !this._transport.destroyed) {
                    for (const [bs, Rs] of this._intentStates)
                      if (Rs === no) {
                        this._intentStates.delete(bs);
                        break;
                      }
                    this.cleanup();
                  }
                }
              }
              get stats() {
                return this._stats;
              }
            }
            exports.PDFPageProxy = PDFPageProxy;
            class LoopbackPort {
              constructor() {
                this._listeners = [], this._deferred = Promise.resolve();
              }
              postMessage(no, lo) {
                const so = {
                  data: structuredClone(no, lo)
                };
                this._deferred.then(() => {
                  for (const bs of this._listeners)
                    bs.call(this, so);
                });
              }
              addEventListener(no, lo) {
                this._listeners.push(lo);
              }
              removeEventListener(no, lo) {
                const so = this._listeners.indexOf(lo);
                this._listeners.splice(so, 1);
              }
              terminate() {
                this._listeners.length = 0;
              }
            }
            exports.LoopbackPort = LoopbackPort;
            const PDFWorkerUtil = {
              isWorkerDisabled: !1,
              fallbackWorkerSrc: null,
              fakeWorkerId: 0
            };
            exports.PDFWorkerUtil = PDFWorkerUtil;
            {
              if (_is_node.isNodeJS && typeof commonjsRequire == "function")
                PDFWorkerUtil.isWorkerDisabled = !0, PDFWorkerUtil.fallbackWorkerSrc = "./pdf.worker.js";
              else if (typeof document == "object") {
                const oo = document?.currentScript?.src;
                oo && (PDFWorkerUtil.fallbackWorkerSrc = oo.replace(/(\.(?:min\.)?js)(\?.*)?$/i, ".worker$1$2"));
              }
              PDFWorkerUtil.isSameOrigin = function(oo, no) {
                let lo;
                try {
                  if (lo = new URL(oo), !lo.origin || lo.origin === "null")
                    return !1;
                } catch {
                  return !1;
                }
                const so = new URL(no, lo);
                return lo.origin === so.origin;
              }, PDFWorkerUtil.createCDNWrapper = function(oo) {
                const no = `importScripts("${oo}");`;
                return URL.createObjectURL(new Blob([no]));
              };
            }
            const _PDFWorker = class _PDFWorker {
              constructor({
                name: oo = null,
                port: no = null,
                verbosity: lo = (0, _util.getVerbosityLevel)()
              } = {}) {
                if (no && Gl(_PDFWorker, Ui).has(no))
                  throw new Error("Cannot use more than one PDFWorker per port.");
                if (this.name = oo, this.destroyed = !1, this.verbosity = lo, this._readyCapability = (0, _util.createPromiseCapability)(), this._port = null, this._webWorker = null, this._messageHandler = null, no) {
                  Gl(_PDFWorker, Ui).set(no, this), this._initializeFromPort(no);
                  return;
                }
                this._initialize();
              }
              get promise() {
                return this._readyCapability.promise;
              }
              get port() {
                return this._port;
              }
              get messageHandler() {
                return this._messageHandler;
              }
              _initializeFromPort(oo) {
                this._port = oo, this._messageHandler = new _message_handler.MessageHandler("main", "worker", oo), this._messageHandler.on("ready", function() {
                }), this._readyCapability.resolve();
              }
              _initialize() {
                if (!PDFWorkerUtil.isWorkerDisabled && !_PDFWorker._mainThreadWorkerMessageHandler) {
                  let {
                    workerSrc: oo
                  } = _PDFWorker;
                  try {
                    PDFWorkerUtil.isSameOrigin(window.location.href, oo) || (oo = PDFWorkerUtil.createCDNWrapper(new URL(oo, window.location).href));
                    const no = new Worker(oo), lo = new _message_handler.MessageHandler("main", "worker", no), so = () => {
                      no.removeEventListener("error", bs), lo.destroy(), no.terminate(), this.destroyed ? this._readyCapability.reject(new Error("Worker was destroyed")) : this._setupFakeWorker();
                    }, bs = () => {
                      this._webWorker || so();
                    };
                    no.addEventListener("error", bs), lo.on("test", (js) => {
                      if (no.removeEventListener("error", bs), this.destroyed) {
                        so();
                        return;
                      }
                      js ? (this._messageHandler = lo, this._port = no, this._webWorker = no, this._readyCapability.resolve(), lo.send("configure", {
                        verbosity: this.verbosity
                      })) : (this._setupFakeWorker(), lo.destroy(), no.terminate());
                    }), lo.on("ready", (js) => {
                      if (no.removeEventListener("error", bs), this.destroyed) {
                        so();
                        return;
                      }
                      try {
                        Rs();
                      } catch {
                        this._setupFakeWorker();
                      }
                    });
                    const Rs = () => {
                      const js = new Uint8Array();
                      lo.send("test", js, [js.buffer]);
                    };
                    Rs();
                    return;
                  } catch {
                    (0, _util.info)("The worker has been disabled.");
                  }
                }
                this._setupFakeWorker();
              }
              _setupFakeWorker() {
                PDFWorkerUtil.isWorkerDisabled || ((0, _util.warn)("Setting up fake worker."), PDFWorkerUtil.isWorkerDisabled = !0), _PDFWorker._setupFakeWorkerGlobal.then((oo) => {
                  if (this.destroyed) {
                    this._readyCapability.reject(new Error("Worker was destroyed"));
                    return;
                  }
                  const no = new LoopbackPort();
                  this._port = no;
                  const lo = `fake${PDFWorkerUtil.fakeWorkerId++}`, so = new _message_handler.MessageHandler(lo + "_worker", lo, no);
                  oo.setup(so, no);
                  const bs = new _message_handler.MessageHandler(lo, lo + "_worker", no);
                  this._messageHandler = bs, this._readyCapability.resolve(), bs.send("configure", {
                    verbosity: this.verbosity
                  });
                }).catch((oo) => {
                  this._readyCapability.reject(new Error(`Setting up fake worker failed: "${oo.message}".`));
                });
              }
              destroy() {
                this.destroyed = !0, this._webWorker && (this._webWorker.terminate(), this._webWorker = null), Gl(_PDFWorker, Ui).delete(this._port), this._port = null, this._messageHandler && (this._messageHandler.destroy(), this._messageHandler = null);
              }
              static fromPort(oo) {
                if (!oo?.port)
                  throw new Error("PDFWorker.fromPort - invalid method signature.");
                return Gl(this, Ui).has(oo.port) ? Gl(this, Ui).get(oo.port) : new _PDFWorker(oo);
              }
              static get workerSrc() {
                if (_worker_options.GlobalWorkerOptions.workerSrc)
                  return _worker_options.GlobalWorkerOptions.workerSrc;
                if (PDFWorkerUtil.fallbackWorkerSrc !== null)
                  return _is_node.isNodeJS || (0, _display_utils.deprecated)('No "GlobalWorkerOptions.workerSrc" specified.'), PDFWorkerUtil.fallbackWorkerSrc;
                throw new Error('No "GlobalWorkerOptions.workerSrc" specified.');
              }
              static get _mainThreadWorkerMessageHandler() {
                try {
                  return globalThis.pdfjsWorker?.WorkerMessageHandler || null;
                } catch {
                  return null;
                }
              }
              static get _setupFakeWorkerGlobal() {
                const loader = async () => {
                  const mainWorkerMessageHandler = this._mainThreadWorkerMessageHandler;
                  if (mainWorkerMessageHandler)
                    return mainWorkerMessageHandler;
                  if (_is_node.isNodeJS && typeof commonjsRequire == "function") {
                    const worker = eval("require")(this.workerSrc);
                    return worker.WorkerMessageHandler;
                  }
                  return await (0, _display_utils.loadScript)(this.workerSrc), window.pdfjsWorker.WorkerMessageHandler;
                };
                return (0, _util.shadow)(this, "_setupFakeWorkerGlobal", loader());
              }
            };
            Ui = new WeakMap(), fc(_PDFWorker, Ui, /* @__PURE__ */ new WeakMap());
            let PDFWorker = _PDFWorker;
            exports.PDFWorker = PDFWorker, PDFWorker.getWorkerSrc = function() {
              return (0, _display_utils.deprecated)("`PDFWorker.getWorkerSrc()`, please use `PDFWorker.workerSrc` instead."), this.workerSrc;
            };
            class WorkerTransport {
              constructor(no, lo, so, bs) {
                fc(this, Zi, null);
                fc(this, ta, /* @__PURE__ */ new Map());
                fc(this, na, /* @__PURE__ */ new Map());
                fc(this, ia, null);
                this.messageHandler = no, this.loadingTask = lo, this.commonObjs = new PDFObjects(), this.fontLoader = new _font_loader.FontLoader({
                  docId: lo.docId,
                  onUnsupportedFeature: this._onUnsupportedFeature.bind(this),
                  ownerDocument: bs.ownerDocument,
                  styleElement: bs.styleElement
                }), this._params = bs, bs.useWorkerFetch || (this.CMapReaderFactory = new bs.CMapReaderFactory({
                  baseUrl: bs.cMapUrl,
                  isCompressed: bs.cMapPacked
                }), this.StandardFontDataFactory = new bs.StandardFontDataFactory({
                  baseUrl: bs.standardFontDataUrl
                })), this.destroyed = !1, this.destroyCapability = null, this._passwordCapability = null, this._networkStream = so, this._fullReader = null, this._lastProgress = null, this.downloadInfoCapability = (0, _util.createPromiseCapability)(), this.setupMessageHandler();
              }
              get annotationStorage() {
                return (0, _util.shadow)(this, "annotationStorage", new _annotation_storage.AnnotationStorage());
              }
              get stats() {
                return Gl(this, Zi);
              }
              getRenderingIntent(no, lo = _util.AnnotationMode.ENABLE, so = null, bs = !1) {
                let Rs = _util.RenderingIntentFlag.DISPLAY, js = null;
                switch (no) {
                  case "any":
                    Rs = _util.RenderingIntentFlag.ANY;
                    break;
                  case "display":
                    break;
                  case "print":
                    Rs = _util.RenderingIntentFlag.PRINT;
                    break;
                  default:
                    (0, _util.warn)(`getRenderingIntent - invalid intent: ${no}`);
                }
                switch (lo) {
                  case _util.AnnotationMode.DISABLE:
                    Rs += _util.RenderingIntentFlag.ANNOTATIONS_DISABLE;
                    break;
                  case _util.AnnotationMode.ENABLE:
                    break;
                  case _util.AnnotationMode.ENABLE_FORMS:
                    Rs += _util.RenderingIntentFlag.ANNOTATIONS_FORMS;
                    break;
                  case _util.AnnotationMode.ENABLE_STORAGE:
                    Rs += _util.RenderingIntentFlag.ANNOTATIONS_STORAGE, js = (Rs & _util.RenderingIntentFlag.PRINT && so instanceof _annotation_storage.PrintAnnotationStorage ? so : this.annotationStorage).serializable;
                    break;
                  default:
                    (0, _util.warn)(`getRenderingIntent - invalid annotationMode: ${lo}`);
                }
                return bs && (Rs += _util.RenderingIntentFlag.OPLIST), {
                  renderingIntent: Rs,
                  cacheKey: `${Rs}_${_annotation_storage.AnnotationStorage.getHash(js)}`,
                  annotationStorageMap: js
                };
              }
              destroy() {
                if (this.destroyCapability)
                  return this.destroyCapability.promise;
                this.destroyed = !0, this.destroyCapability = (0, _util.createPromiseCapability)(), this._passwordCapability && this._passwordCapability.reject(new Error("Worker was destroyed during onPassword callback"));
                const no = [];
                for (const so of Gl(this, ta).values())
                  no.push(so._destroy());
                Gl(this, ta).clear(), Gl(this, na).clear(), this.hasOwnProperty("annotationStorage") && this.annotationStorage.resetModified();
                const lo = this.messageHandler.sendWithPromise("Terminate", null);
                return no.push(lo), Promise.all(no).then(() => {
                  this.commonObjs.clear(), this.fontLoader.clear(), lu(this, ia, null), this._getFieldObjectsPromise = null, this._hasJSActionsPromise = null, this._networkStream && this._networkStream.cancelAllRequests(new _util.AbortException("Worker was terminated.")), this.messageHandler && (this.messageHandler.destroy(), this.messageHandler = null), this.destroyCapability.resolve();
                }, this.destroyCapability.reject), this.destroyCapability.promise;
              }
              setupMessageHandler() {
                const {
                  messageHandler: no,
                  loadingTask: lo
                } = this;
                no.on("GetReader", (so, bs) => {
                  (0, _util.assert)(this._networkStream, "GetReader - no `IPDFStream` instance available."), this._fullReader = this._networkStream.getFullReader(), this._fullReader.onProgress = (Rs) => {
                    this._lastProgress = {
                      loaded: Rs.loaded,
                      total: Rs.total
                    };
                  }, bs.onPull = () => {
                    this._fullReader.read().then(function({
                      value: Rs,
                      done: js
                    }) {
                      if (js) {
                        bs.close();
                        return;
                      }
                      (0, _util.assert)((0, _util.isArrayBuffer)(Rs), "GetReader - expected an ArrayBuffer."), bs.enqueue(new Uint8Array(Rs), 1, [Rs]);
                    }).catch((Rs) => {
                      bs.error(Rs);
                    });
                  }, bs.onCancel = (Rs) => {
                    this._fullReader.cancel(Rs), bs.ready.catch((js) => {
                      if (!this.destroyed)
                        throw js;
                    });
                  };
                }), no.on("ReaderHeadersReady", (so) => {
                  const bs = (0, _util.createPromiseCapability)(), Rs = this._fullReader;
                  return Rs.headersReady.then(() => {
                    (!Rs.isStreamingSupported || !Rs.isRangeSupported) && (this._lastProgress && lo.onProgress?.(this._lastProgress), Rs.onProgress = (js) => {
                      lo.onProgress?.({
                        loaded: js.loaded,
                        total: js.total
                      });
                    }), bs.resolve({
                      isStreamingSupported: Rs.isStreamingSupported,
                      isRangeSupported: Rs.isRangeSupported,
                      contentLength: Rs.contentLength
                    });
                  }, bs.reject), bs.promise;
                }), no.on("GetRangeReader", (so, bs) => {
                  (0, _util.assert)(this._networkStream, "GetRangeReader - no `IPDFStream` instance available.");
                  const Rs = this._networkStream.getRangeReader(so.begin, so.end);
                  if (!Rs) {
                    bs.close();
                    return;
                  }
                  bs.onPull = () => {
                    Rs.read().then(function({
                      value: js,
                      done: qs
                    }) {
                      if (qs) {
                        bs.close();
                        return;
                      }
                      (0, _util.assert)((0, _util.isArrayBuffer)(js), "GetRangeReader - expected an ArrayBuffer."), bs.enqueue(new Uint8Array(js), 1, [js]);
                    }).catch((js) => {
                      bs.error(js);
                    });
                  }, bs.onCancel = (js) => {
                    Rs.cancel(js), bs.ready.catch((qs) => {
                      if (!this.destroyed)
                        throw qs;
                    });
                  };
                }), no.on("GetDoc", ({
                  pdfInfo: so
                }) => {
                  this._numPages = so.numPages, this._htmlForXfa = so.htmlForXfa, delete so.htmlForXfa, lo._capability.resolve(new PDFDocumentProxy(so, this));
                }), no.on("DocException", function(so) {
                  let bs;
                  switch (so.name) {
                    case "PasswordException":
                      bs = new _util.PasswordException(so.message, so.code);
                      break;
                    case "InvalidPDFException":
                      bs = new _util.InvalidPDFException(so.message);
                      break;
                    case "MissingPDFException":
                      bs = new _util.MissingPDFException(so.message);
                      break;
                    case "UnexpectedResponseException":
                      bs = new _util.UnexpectedResponseException(so.message, so.status);
                      break;
                    case "UnknownErrorException":
                      bs = new _util.UnknownErrorException(so.message, so.details);
                      break;
                    default:
                      (0, _util.unreachable)("DocException - expected a valid Error.");
                  }
                  lo._capability.reject(bs);
                }), no.on("PasswordRequest", (so) => {
                  if (this._passwordCapability = (0, _util.createPromiseCapability)(), lo.onPassword) {
                    const bs = (Rs) => {
                      Rs instanceof Error ? this._passwordCapability.reject(Rs) : this._passwordCapability.resolve({
                        password: Rs
                      });
                    };
                    try {
                      lo.onPassword(bs, so.code);
                    } catch (Rs) {
                      this._passwordCapability.reject(Rs);
                    }
                  } else
                    this._passwordCapability.reject(new _util.PasswordException(so.message, so.code));
                  return this._passwordCapability.promise;
                }), no.on("DataLoaded", (so) => {
                  lo.onProgress?.({
                    loaded: so.length,
                    total: so.length
                  }), this.downloadInfoCapability.resolve(so);
                }), no.on("StartRenderPage", (so) => {
                  if (this.destroyed)
                    return;
                  Gl(this, ta).get(so.pageIndex)._startRenderPage(so.transparency, so.cacheKey);
                }), no.on("commonobj", ([so, bs, Rs]) => {
                  if (!this.destroyed && !this.commonObjs.has(so))
                    switch (bs) {
                      case "Font":
                        const js = this._params;
                        if ("error" in Rs) {
                          const fs = Rs.error;
                          (0, _util.warn)(`Error during font loading: ${fs}`), this.commonObjs.resolve(so, fs);
                          break;
                        }
                        let qs = null;
                        js.pdfBug && globalThis.FontInspector?.enabled && (qs = {
                          registerFont(fs, Ao) {
                            globalThis.FontInspector.fontAdded(fs, Ao);
                          }
                        });
                        const jo = new _font_loader.FontFaceObject(Rs, {
                          isEvalSupported: js.isEvalSupported,
                          disableFontFace: js.disableFontFace,
                          ignoreErrors: js.ignoreErrors,
                          onUnsupportedFeature: this._onUnsupportedFeature.bind(this),
                          fontRegistry: qs
                        });
                        this.fontLoader.bind(jo).catch((fs) => no.sendWithPromise("FontFallback", {
                          id: so
                        })).finally(() => {
                          !js.fontExtraProperties && jo.data && (jo.data = null), this.commonObjs.resolve(so, jo);
                        });
                        break;
                      case "FontPath":
                      case "Image":
                        this.commonObjs.resolve(so, Rs);
                        break;
                      default:
                        throw new Error(`Got unknown common object type ${bs}`);
                    }
                }), no.on("obj", ([so, bs, Rs, js]) => {
                  if (this.destroyed)
                    return;
                  const qs = Gl(this, ta).get(bs);
                  if (!qs.objs.has(so))
                    switch (Rs) {
                      case "Image":
                        qs.objs.resolve(so, js);
                        const jo = 8e6;
                        if (js) {
                          let fs;
                          if (js.bitmap) {
                            const {
                              bitmap: Ao,
                              width: co,
                              height: Co
                            } = js;
                            fs = co * Co * 4, qs._bitmaps.add(Ao);
                          } else
                            fs = js.data?.length || 0;
                          fs > jo && (qs.cleanupAfterRender = !0);
                        }
                        break;
                      case "Pattern":
                        qs.objs.resolve(so, js);
                        break;
                      default:
                        throw new Error(`Got unknown object type ${Rs}`);
                    }
                }), no.on("DocProgress", (so) => {
                  this.destroyed || lo.onProgress?.({
                    loaded: so.loaded,
                    total: so.total
                  });
                }), no.on("DocStats", (so) => {
                  this.destroyed || lu(this, Zi, Object.freeze({
                    streamTypes: Object.freeze(so.streamTypes),
                    fontTypes: Object.freeze(so.fontTypes)
                  }));
                }), no.on("UnsupportedFeature", this._onUnsupportedFeature.bind(this)), no.on("FetchBuiltInCMap", (so) => this.destroyed ? Promise.reject(new Error("Worker was destroyed.")) : this.CMapReaderFactory ? this.CMapReaderFactory.fetch(so) : Promise.reject(new Error("CMapReaderFactory not initialized, see the `useWorkerFetch` parameter."))), no.on("FetchStandardFontData", (so) => this.destroyed ? Promise.reject(new Error("Worker was destroyed.")) : this.StandardFontDataFactory ? this.StandardFontDataFactory.fetch(so) : Promise.reject(new Error("StandardFontDataFactory not initialized, see the `useWorkerFetch` parameter.")));
              }
              _onUnsupportedFeature({
                featureId: no
              }) {
                this.destroyed || this.loadingTask.onUnsupportedFeature?.(no);
              }
              getData() {
                return this.messageHandler.sendWithPromise("GetData", null);
              }
              getPage(no) {
                if (!Number.isInteger(no) || no <= 0 || no > this._numPages)
                  return Promise.reject(new Error("Invalid page request."));
                const lo = no - 1, so = Gl(this, na).get(lo);
                if (so)
                  return so;
                const bs = this.messageHandler.sendWithPromise("GetPage", {
                  pageIndex: lo
                }).then((Rs) => {
                  if (this.destroyed)
                    throw new Error("Transport destroyed");
                  const js = new PDFPageProxy(lo, Rs, this, this._params.ownerDocument, this._params.pdfBug);
                  return Gl(this, ta).set(lo, js), js;
                });
                return Gl(this, na).set(lo, bs), bs;
              }
              getPageIndex(no) {
                return typeof no != "object" || no === null || !Number.isInteger(no.num) || no.num < 0 || !Number.isInteger(no.gen) || no.gen < 0 ? Promise.reject(new Error("Invalid pageIndex request.")) : this.messageHandler.sendWithPromise("GetPageIndex", {
                  num: no.num,
                  gen: no.gen
                });
              }
              getAnnotations(no, lo) {
                return this.messageHandler.sendWithPromise("GetAnnotations", {
                  pageIndex: no,
                  intent: lo
                });
              }
              saveDocument() {
                return this.messageHandler.sendWithPromise("SaveDocument", {
                  isPureXfa: !!this._htmlForXfa,
                  numPages: this._numPages,
                  annotationStorage: this.annotationStorage.serializable,
                  filename: this._fullReader?.filename ?? null
                }).finally(() => {
                  this.annotationStorage.resetModified();
                });
              }
              getFieldObjects() {
                return this._getFieldObjectsPromise || (this._getFieldObjectsPromise = this.messageHandler.sendWithPromise("GetFieldObjects", null));
              }
              hasJSActions() {
                return this._hasJSActionsPromise || (this._hasJSActionsPromise = this.messageHandler.sendWithPromise("HasJSActions", null));
              }
              getCalculationOrderIds() {
                return this.messageHandler.sendWithPromise("GetCalculationOrderIds", null);
              }
              getDestinations() {
                return this.messageHandler.sendWithPromise("GetDestinations", null);
              }
              getDestination(no) {
                return typeof no != "string" ? Promise.reject(new Error("Invalid destination request.")) : this.messageHandler.sendWithPromise("GetDestination", {
                  id: no
                });
              }
              getPageLabels() {
                return this.messageHandler.sendWithPromise("GetPageLabels", null);
              }
              getPageLayout() {
                return this.messageHandler.sendWithPromise("GetPageLayout", null);
              }
              getPageMode() {
                return this.messageHandler.sendWithPromise("GetPageMode", null);
              }
              getViewerPreferences() {
                return this.messageHandler.sendWithPromise("GetViewerPreferences", null);
              }
              getOpenAction() {
                return this.messageHandler.sendWithPromise("GetOpenAction", null);
              }
              getAttachments() {
                return this.messageHandler.sendWithPromise("GetAttachments", null);
              }
              getJavaScript() {
                return this.messageHandler.sendWithPromise("GetJavaScript", null);
              }
              getDocJSActions() {
                return this.messageHandler.sendWithPromise("GetDocJSActions", null);
              }
              getPageJSActions(no) {
                return this.messageHandler.sendWithPromise("GetPageJSActions", {
                  pageIndex: no
                });
              }
              getStructTree(no) {
                return this.messageHandler.sendWithPromise("GetStructTree", {
                  pageIndex: no
                });
              }
              getOutline() {
                return this.messageHandler.sendWithPromise("GetOutline", null);
              }
              getOptionalContentConfig() {
                return this.messageHandler.sendWithPromise("GetOptionalContentConfig", null).then((no) => new _optional_content_config.OptionalContentConfig(no));
              }
              getPermissions() {
                return this.messageHandler.sendWithPromise("GetPermissions", null);
              }
              getMetadata() {
                return Gl(this, ia) || lu(this, ia, this.messageHandler.sendWithPromise("GetMetadata", null).then((no) => ({
                  info: no[0],
                  metadata: no[1] ? new _metadata.Metadata(no[1]) : null,
                  contentDispositionFilename: this._fullReader?.filename ?? null,
                  contentLength: this._fullReader?.contentLength ?? null
                })));
              }
              getMarkInfo() {
                return this.messageHandler.sendWithPromise("GetMarkInfo", null);
              }
              async startCleanup(no = !1) {
                if (await this.messageHandler.sendWithPromise("Cleanup", null), !this.destroyed) {
                  for (const lo of Gl(this, ta).values())
                    if (!lo.cleanup())
                      throw new Error(`startCleanup: Page ${lo.pageNumber} is currently rendering.`);
                  this.commonObjs.clear(), no || this.fontLoader.clear(), lu(this, ia, null), this._getFieldObjectsPromise = null, this._hasJSActionsPromise = null;
                }
              }
              get loadingParams() {
                const no = this._params;
                return (0, _util.shadow)(this, "loadingParams", {
                  disableAutoFetch: no.disableAutoFetch,
                  enableXfa: no.enableXfa
                });
              }
            }
            Zi = new WeakMap(), ta = new WeakMap(), na = new WeakMap(), ia = new WeakMap();
            class PDFObjects {
              constructor() {
                fc(this, da);
                fc(this, aa, /* @__PURE__ */ Object.create(null));
              }
              get(no, lo = null) {
                if (lo) {
                  const bs = lc(this, da, sf).call(this, no);
                  return bs.capability.promise.then(() => lo(bs.data)), null;
                }
                const so = Gl(this, aa)[no];
                if (!so?.capability.settled)
                  throw new Error(`Requesting object that isn't resolved yet ${no}.`);
                return so.data;
              }
              has(no) {
                return Gl(this, aa)[no]?.capability.settled || !1;
              }
              resolve(no, lo = null) {
                const so = lc(this, da, sf).call(this, no);
                so.data = lo, so.capability.resolve();
              }
              clear() {
                lu(this, aa, /* @__PURE__ */ Object.create(null));
              }
            }
            aa = new WeakMap(), da = new WeakSet(), sf = function(no) {
              const lo = Gl(this, aa)[no];
              return lo || (Gl(this, aa)[no] = {
                capability: (0, _util.createPromiseCapability)(),
                data: null
              });
            };
            class RenderTask {
              constructor(no) {
                fc(this, qa, null);
                lu(this, qa, no), this.onContinue = null;
              }
              get promise() {
                return Gl(this, qa).capability.promise;
              }
              cancel() {
                Gl(this, qa).cancel();
              }
              get separateAnnots() {
                const {
                  separateAnnots: no
                } = Gl(this, qa).operatorList;
                if (!no)
                  return !1;
                const {
                  annotationCanvasMap: lo
                } = Gl(this, qa);
                return no.form || no.canvas && lo?.size > 0;
              }
            }
            qa = new WeakMap(), exports.RenderTask = RenderTask;
            const ao = class ao {
              constructor({
                callback: no,
                params: lo,
                objs: so,
                commonObjs: bs,
                annotationCanvasMap: Rs,
                operatorList: js,
                pageIndex: qs,
                canvasFactory: jo,
                useRequestAnimationFrame: fs = !1,
                pdfBug: Ao = !1,
                pageColors: co = null
              }) {
                this.callback = no, this.params = lo, this.objs = so, this.commonObjs = bs, this.annotationCanvasMap = Rs, this.operatorListIdx = null, this.operatorList = js, this._pageIndex = qs, this.canvasFactory = jo, this._pdfBug = Ao, this.pageColors = co, this.running = !1, this.graphicsReadyCallback = null, this.graphicsReady = !1, this._useRequestAnimationFrame = fs === !0 && typeof window < "u", this.cancelled = !1, this.capability = (0, _util.createPromiseCapability)(), this.task = new RenderTask(this), this._cancelBound = this.cancel.bind(this), this._continueBound = this._continue.bind(this), this._scheduleNextBound = this._scheduleNext.bind(this), this._nextBound = this._next.bind(this), this._canvas = lo.canvasContext.canvas;
              }
              get completed() {
                return this.capability.promise.catch(function() {
                });
              }
              initializeGraphics({
                transparency: no = !1,
                optionalContentConfig: lo
              }) {
                if (this.cancelled)
                  return;
                if (this._canvas) {
                  if (Gl(ao, io).has(this._canvas))
                    throw new Error("Cannot use the same canvas during multiple render() operations. Use different canvas or ensure previous operations were cancelled or completed.");
                  Gl(ao, io).add(this._canvas);
                }
                this._pdfBug && globalThis.StepperManager?.enabled && (this.stepper = globalThis.StepperManager.create(this._pageIndex), this.stepper.init(this.operatorList), this.stepper.nextBreakPoint = this.stepper.getNextBreakPoint());
                const {
                  canvasContext: so,
                  viewport: bs,
                  transform: Rs,
                  imageLayer: js,
                  background: qs
                } = this.params;
                this.gfx = new _canvas.CanvasGraphics(so, this.commonObjs, this.objs, this.canvasFactory, js, lo, this.annotationCanvasMap, this.pageColors), this.gfx.beginDrawing({
                  transform: Rs,
                  viewport: bs,
                  transparency: no,
                  background: qs
                }), this.operatorListIdx = 0, this.graphicsReady = !0, this.graphicsReadyCallback && this.graphicsReadyCallback();
              }
              cancel(no = null) {
                this.running = !1, this.cancelled = !0, this.gfx && this.gfx.endDrawing(), this._canvas && Gl(ao, io).delete(this._canvas), this.callback(no || new _display_utils.RenderingCancelledException(`Rendering cancelled, page ${this._pageIndex + 1}`, "canvas"));
              }
              operatorListChanged() {
                if (!this.graphicsReady) {
                  this.graphicsReadyCallback || (this.graphicsReadyCallback = this._continueBound);
                  return;
                }
                this.stepper && this.stepper.updateOperatorList(this.operatorList), !this.running && this._continue();
              }
              _continue() {
                this.running = !0, !this.cancelled && (this.task.onContinue ? this.task.onContinue(this._scheduleNextBound) : this._scheduleNext());
              }
              _scheduleNext() {
                this._useRequestAnimationFrame ? window.requestAnimationFrame(() => {
                  this._nextBound().catch(this._cancelBound);
                }) : Promise.resolve().then(this._nextBound).catch(this._cancelBound);
              }
              async _next() {
                this.cancelled || (this.operatorListIdx = this.gfx.executeOperatorList(this.operatorList, this.operatorListIdx, this._continueBound, this.stepper), this.operatorListIdx === this.operatorList.argsArray.length && (this.running = !1, this.operatorList.lastChunk && (this.gfx.endDrawing(), this._canvas && Gl(ao, io).delete(this._canvas), this.callback())));
              }
            };
            io = new WeakMap(), fc(ao, io, /* @__PURE__ */ new WeakSet());
            let InternalRenderTask = ao;
            const version = "2.16.105";
            exports.version = version;
            const build = "172ccdbe5";
            exports.build = build;
          },
          /* 5 */
          /***/
          (Bi, e, Ui) => {
            var da, Ff, qa;
            Object.defineProperty(e, "__esModule", {
              value: !0
            }), e.PrintAnnotationStorage = e.AnnotationStorage = void 0;
            var Zi = Ui(1), ta = Ui(6), na = Ui(10);
            class ia {
              constructor() {
                fc(this, da);
                this._storage = /* @__PURE__ */ new Map(), this._modified = !1, this.onSetModified = null, this.onResetModified = null, this.onAnnotationEditor = null;
              }
              getValue(ao, oo) {
                const no = this._storage.get(ao);
                return no === void 0 ? oo : Object.assign(oo, no);
              }
              getRawValue(ao) {
                return this._storage.get(ao);
              }
              remove(ao) {
                if (this._storage.delete(ao), this._storage.size === 0 && this.resetModified(), typeof this.onAnnotationEditor == "function") {
                  for (const oo of this._storage.values())
                    if (oo instanceof ta.AnnotationEditor)
                      return;
                  this.onAnnotationEditor(null);
                }
              }
              setValue(ao, oo) {
                const no = this._storage.get(ao);
                let lo = !1;
                if (no !== void 0)
                  for (const [so, bs] of Object.entries(oo))
                    no[so] !== bs && (lo = !0, no[so] = bs);
                else
                  lo = !0, this._storage.set(ao, oo);
                lo && lc(this, da, Ff).call(this), oo instanceof ta.AnnotationEditor && typeof this.onAnnotationEditor == "function" && this.onAnnotationEditor(oo.constructor._type);
              }
              has(ao) {
                return this._storage.has(ao);
              }
              getAll() {
                return this._storage.size > 0 ? (0, Zi.objectFromMap)(this._storage) : null;
              }
              get size() {
                return this._storage.size;
              }
              resetModified() {
                this._modified && (this._modified = !1, typeof this.onResetModified == "function" && this.onResetModified());
              }
              get print() {
                return new aa(this);
              }
              get serializable() {
                if (this._storage.size === 0)
                  return null;
                const ao = /* @__PURE__ */ new Map();
                for (const [oo, no] of this._storage) {
                  const lo = no instanceof ta.AnnotationEditor ? no.serialize() : no;
                  lo && ao.set(oo, lo);
                }
                return ao;
              }
              static getHash(ao) {
                if (!ao)
                  return "";
                const oo = new na.MurmurHash3_64();
                for (const [no, lo] of ao)
                  oo.update(`${no}:${JSON.stringify(lo)}`);
                return oo.hexdigest();
              }
            }
            da = new WeakSet(), Ff = function() {
              this._modified || (this._modified = !0, typeof this.onSetModified == "function" && this.onSetModified());
            }, e.AnnotationStorage = ia;
            class aa extends ia {
              constructor(oo) {
                super();
                fc(this, qa, null);
                lu(this, qa, structuredClone(oo.serializable));
              }
              get print() {
                (0, Zi.unreachable)("Should not call PrintAnnotationStorage.print");
              }
              get serializable() {
                return Gl(this, qa);
              }
            }
            qa = new WeakMap(), e.PrintAnnotationStorage = aa;
          },
          /* 6 */
          /***/
          (Bi, e, Ui) => {
            var ia, aa, da, La, qa, io;
            Object.defineProperty(e, "__esModule", {
              value: !0
            }), e.AnnotationEditor = void 0;
            var Zi = Ui(7), ta = Ui(1);
            const ao = class ao {
              constructor(no) {
                fc(this, ia, this.focusin.bind(this));
                fc(this, aa, this.focusout.bind(this));
                fc(this, da, !1);
                fc(this, La, !1);
                fc(this, qa, !1);
                fc(this, io, ao._zIndex++);
                this.constructor === ao && (0, ta.unreachable)("Cannot initialize AnnotationEditor."), this.parent = no.parent, this.id = no.id, this.width = this.height = null, this.pageIndex = no.parent.pageIndex, this.name = no.name, this.div = null;
                const [lo, so] = this.parent.viewportBaseDimensions;
                this.x = no.x / lo, this.y = no.y / so, this.rotation = this.parent.viewport.rotation, this.isAttachedToDOM = !1;
              }
              static get _defaultLineColor() {
                return (0, ta.shadow)(this, "_defaultLineColor", this._colorManager.getHexCode("CanvasText"));
              }
              setInBackground() {
                this.div.style.zIndex = 0;
              }
              setInForeground() {
                this.div.style.zIndex = Gl(this, io);
              }
              focusin(no) {
                Gl(this, da) ? lu(this, da, !1) : this.parent.setSelected(this);
              }
              focusout(no) {
                !this.isAttachedToDOM || no.relatedTarget?.closest(`#${this.id}`) || (no.preventDefault(), this.parent.isMultipleSelection || this.commitOrRemove());
              }
              commitOrRemove() {
                this.isEmpty() ? this.remove() : this.commit();
              }
              commit() {
                this.parent.addToAnnotationStorage(this);
              }
              dragstart(no) {
                const lo = this.parent.div.getBoundingClientRect();
                this.startX = no.clientX - lo.x, this.startY = no.clientY - lo.y, no.dataTransfer.setData("text/plain", this.id), no.dataTransfer.effectAllowed = "move";
              }
              setAt(no, lo, so, bs) {
                const [Rs, js] = this.parent.viewportBaseDimensions;
                [so, bs] = this.screenToPageTranslation(so, bs), this.x = (no + so) / Rs, this.y = (lo + bs) / js, this.div.style.left = `${100 * this.x}%`, this.div.style.top = `${100 * this.y}%`;
              }
              translate(no, lo) {
                const [so, bs] = this.parent.viewportBaseDimensions;
                [no, lo] = this.screenToPageTranslation(no, lo), this.x += no / so, this.y += lo / bs, this.div.style.left = `${100 * this.x}%`, this.div.style.top = `${100 * this.y}%`;
              }
              screenToPageTranslation(no, lo) {
                const {
                  rotation: so
                } = this.parent.viewport;
                switch (so) {
                  case 90:
                    return [lo, -no];
                  case 180:
                    return [-no, -lo];
                  case 270:
                    return [-lo, no];
                  default:
                    return [no, lo];
                }
              }
              setDims(no, lo) {
                const [so, bs] = this.parent.viewportBaseDimensions;
                this.div.style.width = `${100 * no / so}%`, this.div.style.height = `${100 * lo / bs}%`;
              }
              getInitialTranslation() {
                return [0, 0];
              }
              render() {
                this.div = document.createElement("div"), this.div.setAttribute("data-editor-rotation", (360 - this.rotation) % 360), this.div.className = this.name, this.div.setAttribute("id", this.id), this.div.setAttribute("tabIndex", 0), this.setInForeground(), this.div.addEventListener("focusin", Gl(this, ia)), this.div.addEventListener("focusout", Gl(this, aa));
                const [no, lo] = this.getInitialTranslation();
                return this.translate(no, lo), (0, Zi.bindEvents)(this, this.div, ["dragstart", "pointerdown"]), this.div;
              }
              pointerdown(no) {
                const lo = Zi.KeyboardManager.platform.isMac;
                if (no.button !== 0 || no.ctrlKey && lo) {
                  no.preventDefault();
                  return;
                }
                no.ctrlKey && !lo || no.shiftKey || no.metaKey && lo ? this.parent.toggleSelected(this) : this.parent.setSelected(this), lu(this, da, !0);
              }
              getRect(no, lo) {
                const [so, bs] = this.parent.viewportBaseDimensions, [Rs, js] = this.parent.pageDimensions, qs = Rs * no / so, jo = js * lo / bs, fs = this.x * Rs, Ao = this.y * js, co = this.width * Rs, Co = this.height * js;
                switch (this.rotation) {
                  case 0:
                    return [fs + qs, js - Ao - jo - Co, fs + qs + co, js - Ao - jo];
                  case 90:
                    return [fs + jo, js - Ao + qs, fs + jo + Co, js - Ao + qs + co];
                  case 180:
                    return [fs - qs - co, js - Ao + jo, fs - qs, js - Ao + jo + Co];
                  case 270:
                    return [fs - jo - Co, js - Ao - qs - co, fs - jo, js - Ao - qs];
                  default:
                    throw new Error("Invalid rotation");
                }
              }
              getRectInCurrentCoords(no, lo) {
                const [so, bs, Rs, js] = no, qs = Rs - so, jo = js - bs;
                switch (this.rotation) {
                  case 0:
                    return [so, lo - js, qs, jo];
                  case 90:
                    return [so, lo - bs, jo, qs];
                  case 180:
                    return [Rs, lo - bs, qs, jo];
                  case 270:
                    return [Rs, lo - js, jo, qs];
                  default:
                    throw new Error("Invalid rotation");
                }
              }
              onceAdded() {
              }
              isEmpty() {
                return !1;
              }
              enableEditMode() {
                lu(this, qa, !0);
              }
              disableEditMode() {
                lu(this, qa, !1);
              }
              isInEditMode() {
                return Gl(this, qa);
              }
              shouldGetKeyboardEvents() {
                return !1;
              }
              needsToBeRebuilt() {
                return this.div && !this.isAttachedToDOM;
              }
              rebuild() {
                this.div?.addEventListener("focusin", Gl(this, ia));
              }
              serialize() {
                (0, ta.unreachable)("An editor must be serializable");
              }
              static deserialize(no, lo) {
                const so = new this.prototype.constructor({
                  parent: lo,
                  id: lo.getNextId()
                });
                so.rotation = no.rotation;
                const [bs, Rs] = lo.pageDimensions, [js, qs, jo, fs] = so.getRectInCurrentCoords(no.rect, Rs);
                return so.x = js / bs, so.y = qs / Rs, so.width = jo / bs, so.height = fs / Rs, so;
              }
              remove() {
                this.div.removeEventListener("focusin", Gl(this, ia)), this.div.removeEventListener("focusout", Gl(this, aa)), this.isEmpty() || this.commit(), this.parent.remove(this);
              }
              select() {
                this.div?.classList.add("selectedEditor");
              }
              unselect() {
                this.div?.classList.remove("selectedEditor");
              }
              updateParams(no, lo) {
              }
              disableEditing() {
              }
              enableEditing() {
              }
              get propertiesToUpdate() {
                return {};
              }
              get contentDiv() {
                return this.div;
              }
              get isEditing() {
                return Gl(this, La);
              }
              set isEditing(no) {
                lu(this, La, no), no ? (this.parent.setSelected(this), this.parent.setActiveEditor(this)) : this.parent.setActiveEditor(null);
              }
            };
            ia = new WeakMap(), aa = new WeakMap(), da = new WeakMap(), La = new WeakMap(), qa = new WeakMap(), io = new WeakMap(), hd(ao, "_colorManager", new Zi.ColorManager()), hd(ao, "_zIndex", 1);
            let na = ao;
            e.AnnotationEditor = na;
          },
          /* 7 */
          /***/
          (Bi, e, Ui) => {
            var oo, no, lo, so, bs, Rs, Nf, jo, Ao, co, Co, Zs, xl, Cl, Al, Ol, Bl, Ml, Vl, Ll, Yl, Zl, tc, Nl, Tl, El, Lf, lf, Sd, Hd, Vf, Bf, cf, Kd, Gd;
            Object.defineProperty(e, "__esModule", {
              value: !0
            }), e.KeyboardManager = e.CommandManager = e.ColorManager = e.AnnotationEditorUIManager = void 0, e.bindEvents = na, e.opacityToHex = ia;
            var Zi = Ui(1), ta = Ui(8);
            function na(Dl, $l, kl) {
              for (const zl of kl)
                $l.addEventListener(zl, Dl[zl].bind(Dl));
            }
            function ia(Dl) {
              return Math.round(Math.min(255, Math.max(1, 255 * Dl))).toString(16).padStart(2, "0");
            }
            class aa {
              constructor() {
                fc(this, oo, 0);
              }
              getId() {
                return `${Zi.AnnotationEditorPrefix}${ef(this, oo)._++}`;
              }
            }
            oo = new WeakMap();
            class da {
              constructor($l = 128) {
                fc(this, no, []);
                fc(this, lo, !1);
                fc(this, so);
                fc(this, bs, -1);
                lu(this, so, $l);
              }
              add({
                cmd: $l,
                undo: kl,
                mustExec: zl,
                type: Hl = NaN,
                overwriteIfSameType: Wl = !1,
                keepUndo: ql = !1
              }) {
                if (zl && $l(), Gl(this, lo))
                  return;
                const Jl = {
                  cmd: $l,
                  undo: kl,
                  type: Hl
                };
                if (Gl(this, bs) === -1) {
                  Gl(this, no).length > 0 && (Gl(this, no).length = 0), lu(this, bs, 0), Gl(this, no).push(Jl);
                  return;
                }
                if (Wl && Gl(this, no)[Gl(this, bs)].type === Hl) {
                  ql && (Jl.undo = Gl(this, no)[Gl(this, bs)].undo), Gl(this, no)[Gl(this, bs)] = Jl;
                  return;
                }
                const ac = Gl(this, bs) + 1;
                ac === Gl(this, so) ? Gl(this, no).splice(0, 1) : (lu(this, bs, ac), ac < Gl(this, no).length && Gl(this, no).splice(ac)), Gl(this, no).push(Jl);
              }
              undo() {
                Gl(this, bs) !== -1 && (lu(this, lo, !0), Gl(this, no)[Gl(this, bs)].undo(), lu(this, lo, !1), lu(this, bs, Gl(this, bs) - 1));
              }
              redo() {
                Gl(this, bs) < Gl(this, no).length - 1 && (lu(this, bs, Gl(this, bs) + 1), lu(this, lo, !0), Gl(this, no)[Gl(this, bs)].cmd(), lu(this, lo, !1));
              }
              hasSomethingToUndo() {
                return Gl(this, bs) !== -1;
              }
              hasSomethingToRedo() {
                return Gl(this, bs) < Gl(this, no).length - 1;
              }
              destroy() {
                lu(this, no, null);
              }
            }
            no = new WeakMap(), lo = new WeakMap(), so = new WeakMap(), bs = new WeakMap(), e.CommandManager = da;
            const qs = class qs {
              constructor($l) {
                fc(this, Rs);
                this.buffer = [], this.callbacks = /* @__PURE__ */ new Map(), this.allKeys = /* @__PURE__ */ new Set();
                const kl = qs.platform.isMac;
                for (const [zl, Hl] of $l)
                  for (const Wl of zl) {
                    const ql = Wl.startsWith("mac+");
                    kl && ql ? (this.callbacks.set(Wl.slice(4), Hl), this.allKeys.add(Wl.split("+").at(-1))) : !kl && !ql && (this.callbacks.set(Wl, Hl), this.allKeys.add(Wl.split("+").at(-1)));
                  }
              }
              static get platform() {
                const $l = typeof navigator < "u" ? navigator.platform : "";
                return (0, Zi.shadow)(this, "platform", {
                  isWin: $l.includes("Win"),
                  isMac: $l.includes("Mac")
                });
              }
              exec($l, kl) {
                if (!this.allKeys.has(kl.key))
                  return;
                const zl = this.callbacks.get(lc(this, Rs, Nf).call(this, kl));
                zl && (zl.bind($l)(), kl.stopPropagation(), kl.preventDefault());
              }
            };
            Rs = new WeakSet(), Nf = function($l) {
              $l.altKey && this.buffer.push("alt"), $l.ctrlKey && this.buffer.push("ctrl"), $l.metaKey && this.buffer.push("meta"), $l.shiftKey && this.buffer.push("shift"), this.buffer.push($l.key);
              const kl = this.buffer.join("+");
              return this.buffer.length = 0, kl;
            };
            let La = qs;
            e.KeyboardManager = La;
            class qa {
              constructor() {
                fc(this, jo, null);
              }
              copy($l) {
                $l && (Array.isArray($l) ? lu(this, jo, $l.map((kl) => kl.serialize())) : lu(this, jo, [$l.serialize()]), lu(this, jo, Gl(this, jo).filter((kl) => !!kl)), Gl(this, jo).length === 0 && lu(this, jo, null));
              }
              paste() {
                return Gl(this, jo);
              }
              isEmpty() {
                return Gl(this, jo) === null;
              }
              destroy() {
                lu(this, jo, null);
              }
            }
            jo = new WeakMap();
            const fs = class fs {
              get _colors() {
                const $l = /* @__PURE__ */ new Map([["CanvasText", null], ["Canvas", null]]);
                return (0, ta.getColorValues)($l), (0, Zi.shadow)(this, "_colors", $l);
              }
              convert($l) {
                const kl = (0, ta.getRGB)($l);
                if (!window.matchMedia("(forced-colors: active)").matches)
                  return kl;
                for (const [zl, Hl] of this._colors)
                  if (Hl.every((Wl, ql) => Wl === kl[ql]))
                    return fs._colorsMapping.get(zl);
                return kl;
              }
              getHexCode($l) {
                const kl = this._colors.get($l);
                return kl ? Zi.Util.makeHexColor(...kl) : $l;
              }
            };
            hd(fs, "_colorsMapping", /* @__PURE__ */ new Map([["CanvasText", [0, 0, 0]], ["Canvas", [255, 255, 255]]]));
            let io = fs;
            e.ColorManager = io;
            const jl = class jl {
              constructor($l, kl) {
                fc(this, El);
                fc(this, Ao, null);
                fc(this, co, /* @__PURE__ */ new Map());
                fc(this, Co, /* @__PURE__ */ new Map());
                fc(this, Zs, new qa());
                fc(this, xl, new da());
                fc(this, Cl, 0);
                fc(this, Al, null);
                fc(this, Ol, null);
                fc(this, Bl, new aa());
                fc(this, Ml, !1);
                fc(this, Vl, Zi.AnnotationEditorType.NONE);
                fc(this, Ll, /* @__PURE__ */ new Set());
                fc(this, Yl, this.keydown.bind(this));
                fc(this, Zl, this.onEditingAction.bind(this));
                fc(this, tc, this.onPageChanging.bind(this));
                fc(this, Nl, {
                  isEditing: !1,
                  isEmpty: !0,
                  hasEmptyClipboard: !0,
                  hasSomethingToUndo: !1,
                  hasSomethingToRedo: !1,
                  hasSelectedEditor: !1
                });
                fc(this, Tl, null);
                lu(this, Tl, $l), lu(this, Ol, kl), Gl(this, Ol)._on("editingaction", Gl(this, Zl)), Gl(this, Ol)._on("pagechanging", Gl(this, tc));
              }
              destroy() {
                lc(this, El, lf).call(this), Gl(this, Ol)._off("editingaction", Gl(this, Zl)), Gl(this, Ol)._off("pagechanging", Gl(this, tc));
                for (const $l of Gl(this, Co).values())
                  $l.destroy();
                Gl(this, Co).clear(), Gl(this, co).clear(), lu(this, Ao, null), Gl(this, Ll).clear(), Gl(this, Zs).destroy(), Gl(this, xl).destroy();
              }
              onPageChanging({
                pageNumber: $l
              }) {
                lu(this, Cl, $l - 1);
              }
              focusMainContainer() {
                Gl(this, Tl).focus();
              }
              keydown($l) {
                this.getActive()?.shouldGetKeyboardEvents() || jl._keyboardManager.exec(this, $l);
              }
              onEditingAction($l) {
                ["undo", "redo", "cut", "copy", "paste", "delete", "selectAll"].includes($l.name) && this[$l.name]();
              }
              setEditingState($l) {
                $l ? (lc(this, El, Lf).call(this), lc(this, El, Sd).call(this, {
                  isEditing: Gl(this, Vl) !== Zi.AnnotationEditorType.NONE,
                  isEmpty: lc(this, El, Kd).call(this),
                  hasSomethingToUndo: Gl(this, xl).hasSomethingToUndo(),
                  hasSomethingToRedo: Gl(this, xl).hasSomethingToRedo(),
                  hasSelectedEditor: !1,
                  hasEmptyClipboard: Gl(this, Zs).isEmpty()
                })) : (lc(this, El, lf).call(this), lc(this, El, Sd).call(this, {
                  isEditing: !1
                }));
              }
              registerEditorTypes($l) {
                lu(this, Al, $l);
                for (const kl of Gl(this, Al))
                  lc(this, El, Hd).call(this, kl.defaultPropertiesToUpdate);
              }
              getId() {
                return Gl(this, Bl).getId();
              }
              addLayer($l) {
                Gl(this, Co).set($l.pageIndex, $l), Gl(this, Ml) ? $l.enable() : $l.disable();
              }
              removeLayer($l) {
                Gl(this, Co).delete($l.pageIndex);
              }
              updateMode($l) {
                if (lu(this, Vl, $l), $l === Zi.AnnotationEditorType.NONE)
                  this.setEditingState(!1), lc(this, El, Bf).call(this);
                else {
                  this.setEditingState(!0), lc(this, El, Vf).call(this);
                  for (const kl of Gl(this, Co).values())
                    kl.updateMode($l);
                }
              }
              updateToolbar($l) {
                $l !== Gl(this, Vl) && Gl(this, Ol).dispatch("switchannotationeditormode", {
                  source: this,
                  mode: $l
                });
              }
              updateParams($l, kl) {
                for (const zl of Gl(this, Ll))
                  zl.updateParams($l, kl);
                for (const zl of Gl(this, Al))
                  zl.updateDefaultParams($l, kl);
              }
              getEditors($l) {
                const kl = [];
                for (const zl of Gl(this, co).values())
                  zl.pageIndex === $l && kl.push(zl);
                return kl;
              }
              getEditor($l) {
                return Gl(this, co).get($l);
              }
              addEditor($l) {
                Gl(this, co).set($l.id, $l);
              }
              removeEditor($l) {
                Gl(this, co).delete($l.id), this.unselect($l);
              }
              setActiveEditor($l) {
                Gl(this, Ao) !== $l && (lu(this, Ao, $l), $l && lc(this, El, Hd).call(this, $l.propertiesToUpdate));
              }
              toggleSelected($l) {
                if (Gl(this, Ll).has($l)) {
                  Gl(this, Ll).delete($l), $l.unselect(), lc(this, El, Sd).call(this, {
                    hasSelectedEditor: this.hasSelection
                  });
                  return;
                }
                Gl(this, Ll).add($l), $l.select(), lc(this, El, Hd).call(this, $l.propertiesToUpdate), lc(this, El, Sd).call(this, {
                  hasSelectedEditor: !0
                });
              }
              setSelected($l) {
                for (const kl of Gl(this, Ll))
                  kl !== $l && kl.unselect();
                Gl(this, Ll).clear(), Gl(this, Ll).add($l), $l.select(), lc(this, El, Hd).call(this, $l.propertiesToUpdate), lc(this, El, Sd).call(this, {
                  hasSelectedEditor: !0
                });
              }
              isSelected($l) {
                return Gl(this, Ll).has($l);
              }
              unselect($l) {
                $l.unselect(), Gl(this, Ll).delete($l), lc(this, El, Sd).call(this, {
                  hasSelectedEditor: this.hasSelection
                });
              }
              get hasSelection() {
                return Gl(this, Ll).size !== 0;
              }
              undo() {
                Gl(this, xl).undo(), lc(this, El, Sd).call(this, {
                  hasSomethingToUndo: Gl(this, xl).hasSomethingToUndo(),
                  hasSomethingToRedo: !0,
                  isEmpty: lc(this, El, Kd).call(this)
                });
              }
              redo() {
                Gl(this, xl).redo(), lc(this, El, Sd).call(this, {
                  hasSomethingToUndo: !0,
                  hasSomethingToRedo: Gl(this, xl).hasSomethingToRedo(),
                  isEmpty: lc(this, El, Kd).call(this)
                });
              }
              addCommands($l) {
                Gl(this, xl).add($l), lc(this, El, Sd).call(this, {
                  hasSomethingToUndo: !0,
                  hasSomethingToRedo: !1,
                  isEmpty: lc(this, El, Kd).call(this)
                });
              }
              delete() {
                if (Gl(this, Ao) && Gl(this, Ao).commitOrRemove(), !this.hasSelection)
                  return;
                const $l = [...Gl(this, Ll)], kl = () => {
                  for (const Hl of $l)
                    Hl.remove();
                }, zl = () => {
                  for (const Hl of $l)
                    lc(this, El, cf).call(this, Hl);
                };
                this.addCommands({
                  cmd: kl,
                  undo: zl,
                  mustExec: !0
                });
              }
              copy() {
                if (Gl(this, Ao) && Gl(this, Ao).commitOrRemove(), this.hasSelection) {
                  const $l = [];
                  for (const kl of Gl(this, Ll))
                    kl.isEmpty() || $l.push(kl);
                  if ($l.length === 0)
                    return;
                  Gl(this, Zs).copy($l), lc(this, El, Sd).call(this, {
                    hasEmptyClipboard: !1
                  });
                }
              }
              cut() {
                this.copy(), this.delete();
              }
              paste() {
                if (Gl(this, Zs).isEmpty())
                  return;
                this.unselectAll();
                const $l = Gl(this, Co).get(Gl(this, Cl)), kl = Gl(this, Zs).paste().map((Wl) => $l.deserialize(Wl)), zl = () => {
                  for (const Wl of kl)
                    lc(this, El, cf).call(this, Wl);
                  lc(this, El, Gd).call(this, kl);
                }, Hl = () => {
                  for (const Wl of kl)
                    Wl.remove();
                };
                this.addCommands({
                  cmd: zl,
                  undo: Hl,
                  mustExec: !0
                });
              }
              selectAll() {
                for (const $l of Gl(this, Ll))
                  $l.commit();
                lc(this, El, Gd).call(this, Gl(this, co).values());
              }
              unselectAll() {
                if (Gl(this, Ao)) {
                  Gl(this, Ao).commitOrRemove();
                  return;
                }
                if (lc(this, El, Gd).size !== 0) {
                  for (const $l of Gl(this, Ll))
                    $l.unselect();
                  Gl(this, Ll).clear(), lc(this, El, Sd).call(this, {
                    hasSelectedEditor: !1
                  });
                }
              }
              isActive($l) {
                return Gl(this, Ao) === $l;
              }
              getActive() {
                return Gl(this, Ao);
              }
              getMode() {
                return Gl(this, Vl);
              }
            };
            Ao = new WeakMap(), co = new WeakMap(), Co = new WeakMap(), Zs = new WeakMap(), xl = new WeakMap(), Cl = new WeakMap(), Al = new WeakMap(), Ol = new WeakMap(), Bl = new WeakMap(), Ml = new WeakMap(), Vl = new WeakMap(), Ll = new WeakMap(), Yl = new WeakMap(), Zl = new WeakMap(), tc = new WeakMap(), Nl = new WeakMap(), Tl = new WeakMap(), El = new WeakSet(), Lf = function() {
              Gl(this, Tl).addEventListener("keydown", Gl(this, Yl));
            }, lf = function() {
              Gl(this, Tl).removeEventListener("keydown", Gl(this, Yl));
            }, Sd = function($l) {
              Object.entries($l).some(([zl, Hl]) => Gl(this, Nl)[zl] !== Hl) && Gl(this, Ol).dispatch("annotationeditorstateschanged", {
                source: this,
                details: Object.assign(Gl(this, Nl), $l)
              });
            }, Hd = function($l) {
              Gl(this, Ol).dispatch("annotationeditorparamschanged", {
                source: this,
                details: $l
              });
            }, Vf = function() {
              if (!Gl(this, Ml)) {
                lu(this, Ml, !0);
                for (const $l of Gl(this, Co).values())
                  $l.enable();
              }
            }, Bf = function() {
              if (this.unselectAll(), Gl(this, Ml)) {
                lu(this, Ml, !1);
                for (const $l of Gl(this, Co).values())
                  $l.disable();
              }
            }, cf = function($l) {
              const kl = Gl(this, Co).get($l.pageIndex);
              kl ? kl.addOrRebuild($l) : this.addEditor($l);
            }, Kd = function() {
              if (Gl(this, co).size === 0)
                return !0;
              if (Gl(this, co).size === 1)
                for (const $l of Gl(this, co).values())
                  return $l.isEmpty();
              return !1;
            }, Gd = function($l) {
              Gl(this, Ll).clear();
              for (const kl of $l)
                kl.isEmpty() || (Gl(this, Ll).add(kl), kl.select());
              lc(this, El, Sd).call(this, {
                hasSelectedEditor: !0
              });
            }, hd(jl, "_keyboardManager", new La([[["ctrl+a", "mac+meta+a"], jl.prototype.selectAll], [["ctrl+c", "mac+meta+c"], jl.prototype.copy], [["ctrl+v", "mac+meta+v"], jl.prototype.paste], [["ctrl+x", "mac+meta+x"], jl.prototype.cut], [["ctrl+z", "mac+meta+z"], jl.prototype.undo], [["ctrl+y", "ctrl+shift+Z", "mac+meta+shift+Z"], jl.prototype.redo], [["Backspace", "alt+Backspace", "ctrl+Backspace", "shift+Backspace", "mac+Backspace", "mac+alt+Backspace", "mac+ctrl+Backspace", "Delete", "ctrl+Delete", "shift+Delete"], jl.prototype.delete], [["Escape", "mac+Escape"], jl.prototype.unselectAll]]));
            let ao = jl;
            e.AnnotationEditorUIManager = ao;
          },
          /* 8 */
          /***/
          (Bi, e, Ui) => {
            Object.defineProperty(e, "__esModule", {
              value: !0
            }), e.StatTimer = e.RenderingCancelledException = e.PixelsPerInch = e.PageViewport = e.PDFDateString = e.DOMStandardFontDataFactory = e.DOMSVGFactory = e.DOMCanvasFactory = e.DOMCMapReaderFactory = e.AnnotationPrefix = void 0, e.deprecated = fs, e.getColorValues = xl, e.getCurrentTransform = Cl, e.getCurrentTransformInverse = Al, e.getFilenameFromUrl = bs, e.getPdfFilenameFromUrl = Rs, e.getRGB = Zs, e.getXfaPageViewport = Co, e.isDataScheme = lo, e.isPdfFile = so, e.isValidFetchUrl = qs, e.loadScript = jo;
            var Zi = Ui(9), ta = Ui(1);
            const na = "http://www.w3.org/2000/svg", ia = "pdfjs_internal_id_";
            e.AnnotationPrefix = ia;
            const Ol = class Ol {
            };
            hd(Ol, "CSS", 96), hd(Ol, "PDF", 72), hd(Ol, "PDF_TO_CSS_UNITS", Ol.CSS / Ol.PDF);
            let aa = Ol;
            e.PixelsPerInch = aa;
            class da extends Zi.BaseCanvasFactory {
              constructor({
                ownerDocument: Ml = globalThis.document
              } = {}) {
                super(), this._document = Ml;
              }
              _createCanvas(Ml, Vl) {
                const Ll = this._document.createElement("canvas");
                return Ll.width = Ml, Ll.height = Vl, Ll;
              }
            }
            e.DOMCanvasFactory = da;
            async function La(Bl, Ml = !1) {
              if (qs(Bl, document.baseURI)) {
                const Vl = await fetch(Bl);
                if (!Vl.ok)
                  throw new Error(Vl.statusText);
                return Ml ? new Uint8Array(await Vl.arrayBuffer()) : (0, ta.stringToBytes)(await Vl.text());
              }
              return new Promise((Vl, Ll) => {
                const Yl = new XMLHttpRequest();
                Yl.open("GET", Bl, !0), Ml && (Yl.responseType = "arraybuffer"), Yl.onreadystatechange = () => {
                  if (Yl.readyState === XMLHttpRequest.DONE) {
                    if (Yl.status === 200 || Yl.status === 0) {
                      let Zl;
                      if (Ml && Yl.response ? Zl = new Uint8Array(Yl.response) : !Ml && Yl.responseText && (Zl = (0, ta.stringToBytes)(Yl.responseText)), Zl) {
                        Vl(Zl);
                        return;
                      }
                    }
                    Ll(new Error(Yl.statusText));
                  }
                }, Yl.send(null);
              });
            }
            class qa extends Zi.BaseCMapReaderFactory {
              _fetchData(Ml, Vl) {
                return La(Ml, this.isCompressed).then((Ll) => ({
                  cMapData: Ll,
                  compressionType: Vl
                }));
              }
            }
            e.DOMCMapReaderFactory = qa;
            class io extends Zi.BaseStandardFontDataFactory {
              _fetchData(Ml) {
                return La(Ml, !0);
              }
            }
            e.DOMStandardFontDataFactory = io;
            class ao extends Zi.BaseSVGFactory {
              _createSVG(Ml) {
                return document.createElementNS(na, Ml);
              }
            }
            e.DOMSVGFactory = ao;
            class oo {
              constructor({
                viewBox: Ml,
                scale: Vl,
                rotation: Ll,
                offsetX: Yl = 0,
                offsetY: Zl = 0,
                dontFlip: tc = !1
              }) {
                this.viewBox = Ml, this.scale = Vl, this.rotation = Ll, this.offsetX = Yl, this.offsetY = Zl;
                const Nl = (Ml[2] + Ml[0]) / 2, Tl = (Ml[3] + Ml[1]) / 2;
                let El, Il, Ul, Kl;
                switch (Ll %= 360, Ll < 0 && (Ll += 360), Ll) {
                  case 180:
                    El = -1, Il = 0, Ul = 0, Kl = 1;
                    break;
                  case 90:
                    El = 0, Il = 1, Ul = 1, Kl = 0;
                    break;
                  case 270:
                    El = 0, Il = -1, Ul = -1, Kl = 0;
                    break;
                  case 0:
                    El = 1, Il = 0, Ul = 0, Kl = -1;
                    break;
                  default:
                    throw new Error("PageViewport: Invalid rotation, must be a multiple of 90 degrees.");
                }
                tc && (Ul = -Ul, Kl = -Kl);
                let Rl, uo, Is, Sl;
                El === 0 ? (Rl = Math.abs(Tl - Ml[1]) * Vl + Yl, uo = Math.abs(Nl - Ml[0]) * Vl + Zl, Is = Math.abs(Ml[3] - Ml[1]) * Vl, Sl = Math.abs(Ml[2] - Ml[0]) * Vl) : (Rl = Math.abs(Nl - Ml[0]) * Vl + Yl, uo = Math.abs(Tl - Ml[1]) * Vl + Zl, Is = Math.abs(Ml[2] - Ml[0]) * Vl, Sl = Math.abs(Ml[3] - Ml[1]) * Vl), this.transform = [El * Vl, Il * Vl, Ul * Vl, Kl * Vl, Rl - El * Vl * Nl - Ul * Vl * Tl, uo - Il * Vl * Nl - Kl * Vl * Tl], this.width = Is, this.height = Sl;
              }
              clone({
                scale: Ml = this.scale,
                rotation: Vl = this.rotation,
                offsetX: Ll = this.offsetX,
                offsetY: Yl = this.offsetY,
                dontFlip: Zl = !1
              } = {}) {
                return new oo({
                  viewBox: this.viewBox.slice(),
                  scale: Ml,
                  rotation: Vl,
                  offsetX: Ll,
                  offsetY: Yl,
                  dontFlip: Zl
                });
              }
              convertToViewportPoint(Ml, Vl) {
                return ta.Util.applyTransform([Ml, Vl], this.transform);
              }
              convertToViewportRectangle(Ml) {
                const Vl = ta.Util.applyTransform([Ml[0], Ml[1]], this.transform), Ll = ta.Util.applyTransform([Ml[2], Ml[3]], this.transform);
                return [Vl[0], Vl[1], Ll[0], Ll[1]];
              }
              convertToPdfPoint(Ml, Vl) {
                return ta.Util.applyInverseTransform([Ml, Vl], this.transform);
              }
            }
            e.PageViewport = oo;
            class no extends ta.BaseException {
              constructor(Ml, Vl) {
                super(Ml, "RenderingCancelledException"), this.type = Vl;
              }
            }
            e.RenderingCancelledException = no;
            function lo(Bl) {
              const Ml = Bl.length;
              let Vl = 0;
              for (; Vl < Ml && Bl[Vl].trim() === ""; )
                Vl++;
              return Bl.substring(Vl, Vl + 5).toLowerCase() === "data:";
            }
            function so(Bl) {
              return typeof Bl == "string" && /\.pdf$/i.test(Bl);
            }
            function bs(Bl) {
              const Ml = Bl.indexOf("#"), Vl = Bl.indexOf("?"), Ll = Math.min(Ml > 0 ? Ml : Bl.length, Vl > 0 ? Vl : Bl.length);
              return Bl.substring(Bl.lastIndexOf("/", Ll) + 1, Ll);
            }
            function Rs(Bl, Ml = "document.pdf") {
              if (typeof Bl != "string")
                return Ml;
              if (lo(Bl))
                return (0, ta.warn)('getPdfFilenameFromUrl: ignore "data:"-URL for performance reasons.'), Ml;
              const Vl = /^(?:(?:[^:]+:)?\/\/[^/]+)?([^?#]*)(\?[^#]*)?(#.*)?$/, Ll = /[^/?#=]+\.pdf\b(?!.*\.pdf\b)/i, Yl = Vl.exec(Bl);
              let Zl = Ll.exec(Yl[1]) || Ll.exec(Yl[2]) || Ll.exec(Yl[3]);
              if (Zl && (Zl = Zl[0], Zl.includes("%")))
                try {
                  Zl = Ll.exec(decodeURIComponent(Zl))[0];
                } catch {
                }
              return Zl || Ml;
            }
            class js {
              constructor() {
                this.started = /* @__PURE__ */ Object.create(null), this.times = [];
              }
              time(Ml) {
                Ml in this.started && (0, ta.warn)(`Timer is already running for ${Ml}`), this.started[Ml] = Date.now();
              }
              timeEnd(Ml) {
                Ml in this.started || (0, ta.warn)(`Timer has not been started for ${Ml}`), this.times.push({
                  name: Ml,
                  start: this.started[Ml],
                  end: Date.now()
                }), delete this.started[Ml];
              }
              toString() {
                const Ml = [];
                let Vl = 0;
                for (const Ll of this.times) {
                  const Yl = Ll.name;
                  Yl.length > Vl && (Vl = Yl.length);
                }
                for (const Ll of this.times) {
                  const Yl = Ll.end - Ll.start;
                  Ml.push(`${Ll.name.padEnd(Vl)} ${Yl}ms
`);
                }
                return Ml.join("");
              }
            }
            e.StatTimer = js;
            function qs(Bl, Ml) {
              try {
                const {
                  protocol: Vl
                } = Ml ? new URL(Bl, Ml) : new URL(Bl);
                return Vl === "http:" || Vl === "https:";
              } catch {
                return !1;
              }
            }
            function jo(Bl, Ml = !1) {
              return new Promise((Vl, Ll) => {
                const Yl = document.createElement("script");
                Yl.src = Bl, Yl.onload = function(Zl) {
                  Ml && Yl.remove(), Vl(Zl);
                }, Yl.onerror = function() {
                  Ll(new Error(`Cannot load script at: ${Yl.src}`));
                }, (document.head || document.documentElement).append(Yl);
              });
            }
            function fs(Bl) {
              console.log("Deprecated API usage: " + Bl);
            }
            let Ao;
            class co {
              static toDateObject(Ml) {
                if (!Ml || typeof Ml != "string")
                  return null;
                Ao || (Ao = new RegExp("^D:(\\d{4})(\\d{2})?(\\d{2})?(\\d{2})?(\\d{2})?(\\d{2})?([Z|+|-])?(\\d{2})?'?(\\d{2})?'?"));
                const Vl = Ao.exec(Ml);
                if (!Vl)
                  return null;
                const Ll = parseInt(Vl[1], 10);
                let Yl = parseInt(Vl[2], 10);
                Yl = Yl >= 1 && Yl <= 12 ? Yl - 1 : 0;
                let Zl = parseInt(Vl[3], 10);
                Zl = Zl >= 1 && Zl <= 31 ? Zl : 1;
                let tc = parseInt(Vl[4], 10);
                tc = tc >= 0 && tc <= 23 ? tc : 0;
                let Nl = parseInt(Vl[5], 10);
                Nl = Nl >= 0 && Nl <= 59 ? Nl : 0;
                let Tl = parseInt(Vl[6], 10);
                Tl = Tl >= 0 && Tl <= 59 ? Tl : 0;
                const El = Vl[7] || "Z";
                let Il = parseInt(Vl[8], 10);
                Il = Il >= 0 && Il <= 23 ? Il : 0;
                let Ul = parseInt(Vl[9], 10) || 0;
                return Ul = Ul >= 0 && Ul <= 59 ? Ul : 0, El === "-" ? (tc += Il, Nl += Ul) : El === "+" && (tc -= Il, Nl -= Ul), new Date(Date.UTC(Ll, Yl, Zl, tc, Nl, Tl));
              }
            }
            e.PDFDateString = co;
            function Co(Bl, {
              scale: Ml = 1,
              rotation: Vl = 0
            }) {
              const {
                width: Ll,
                height: Yl
              } = Bl.attributes.style, Zl = [0, 0, parseInt(Ll), parseInt(Yl)];
              return new oo({
                viewBox: Zl,
                scale: Ml,
                rotation: Vl
              });
            }
            function Zs(Bl) {
              if (Bl.startsWith("#")) {
                const Ml = parseInt(Bl.slice(1), 16);
                return [(Ml & 16711680) >> 16, (Ml & 65280) >> 8, Ml & 255];
              }
              return Bl.startsWith("rgb(") ? Bl.slice(4, -1).split(",").map((Ml) => parseInt(Ml)) : Bl.startsWith("rgba(") ? Bl.slice(5, -1).split(",").map((Ml) => parseInt(Ml)).slice(0, 3) : ((0, ta.warn)(`Not a valid color format: "${Bl}"`), [0, 0, 0]);
            }
            function xl(Bl) {
              const Ml = document.createElement("span");
              Ml.style.visibility = "hidden", document.body.append(Ml);
              for (const Vl of Bl.keys()) {
                Ml.style.color = Vl;
                const Ll = window.getComputedStyle(Ml).color;
                Bl.set(Vl, Zs(Ll));
              }
              Ml.remove();
            }
            function Cl(Bl) {
              const {
                a: Ml,
                b: Vl,
                c: Ll,
                d: Yl,
                e: Zl,
                f: tc
              } = Bl.getTransform();
              return [Ml, Vl, Ll, Yl, Zl, tc];
            }
            function Al(Bl) {
              const {
                a: Ml,
                b: Vl,
                c: Ll,
                d: Yl,
                e: Zl,
                f: tc
              } = Bl.getTransform().invertSelf();
              return [Ml, Vl, Ll, Yl, Zl, tc];
            }
          },
          /* 9 */
          /***/
          (Bi, e, Ui) => {
            Object.defineProperty(e, "__esModule", {
              value: !0
            }), e.BaseStandardFontDataFactory = e.BaseSVGFactory = e.BaseCanvasFactory = e.BaseCMapReaderFactory = void 0;
            var Zi = Ui(1);
            class ta {
              constructor() {
                this.constructor === ta && (0, Zi.unreachable)("Cannot initialize BaseCanvasFactory.");
              }
              create(La, qa) {
                if (La <= 0 || qa <= 0)
                  throw new Error("Invalid canvas size");
                const io = this._createCanvas(La, qa);
                return {
                  canvas: io,
                  context: io.getContext("2d")
                };
              }
              reset(La, qa, io) {
                if (!La.canvas)
                  throw new Error("Canvas is not specified");
                if (qa <= 0 || io <= 0)
                  throw new Error("Invalid canvas size");
                La.canvas.width = qa, La.canvas.height = io;
              }
              destroy(La) {
                if (!La.canvas)
                  throw new Error("Canvas is not specified");
                La.canvas.width = 0, La.canvas.height = 0, La.canvas = null, La.context = null;
              }
              _createCanvas(La, qa) {
                (0, Zi.unreachable)("Abstract method `_createCanvas` called.");
              }
            }
            e.BaseCanvasFactory = ta;
            class na {
              constructor({
                baseUrl: La = null,
                isCompressed: qa = !1
              }) {
                this.constructor === na && (0, Zi.unreachable)("Cannot initialize BaseCMapReaderFactory."), this.baseUrl = La, this.isCompressed = qa;
              }
              async fetch({
                name: La
              }) {
                if (!this.baseUrl)
                  throw new Error('The CMap "baseUrl" parameter must be specified, ensure that the "cMapUrl" and "cMapPacked" API parameters are provided.');
                if (!La)
                  throw new Error("CMap name must be specified.");
                const qa = this.baseUrl + La + (this.isCompressed ? ".bcmap" : ""), io = this.isCompressed ? Zi.CMapCompressionType.BINARY : Zi.CMapCompressionType.NONE;
                return this._fetchData(qa, io).catch((ao) => {
                  throw new Error(`Unable to load ${this.isCompressed ? "binary " : ""}CMap at: ${qa}`);
                });
              }
              _fetchData(La, qa) {
                (0, Zi.unreachable)("Abstract method `_fetchData` called.");
              }
            }
            e.BaseCMapReaderFactory = na;
            class ia {
              constructor({
                baseUrl: La = null
              }) {
                this.constructor === ia && (0, Zi.unreachable)("Cannot initialize BaseStandardFontDataFactory."), this.baseUrl = La;
              }
              async fetch({
                filename: La
              }) {
                if (!this.baseUrl)
                  throw new Error('The standard font "baseUrl" parameter must be specified, ensure that the "standardFontDataUrl" API parameter is provided.');
                if (!La)
                  throw new Error("Font filename must be specified.");
                const qa = `${this.baseUrl}${La}`;
                return this._fetchData(qa).catch((io) => {
                  throw new Error(`Unable to load font data at: ${qa}`);
                });
              }
              _fetchData(La) {
                (0, Zi.unreachable)("Abstract method `_fetchData` called.");
              }
            }
            e.BaseStandardFontDataFactory = ia;
            class aa {
              constructor() {
                this.constructor === aa && (0, Zi.unreachable)("Cannot initialize BaseSVGFactory.");
              }
              create(La, qa, io = !1) {
                if (La <= 0 || qa <= 0)
                  throw new Error("Invalid SVG dimensions");
                const ao = this._createSVG("svg:svg");
                return ao.setAttribute("version", "1.1"), io || (ao.setAttribute("width", `${La}px`), ao.setAttribute("height", `${qa}px`)), ao.setAttribute("preserveAspectRatio", "none"), ao.setAttribute("viewBox", `0 0 ${La} ${qa}`), ao;
              }
              createElement(La) {
                if (typeof La != "string")
                  throw new Error("Invalid SVG element type");
                return this._createSVG(La);
              }
              _createSVG(La) {
                (0, Zi.unreachable)("Abstract method `_createSVG` called.");
              }
            }
            e.BaseSVGFactory = aa;
          },
          /* 10 */
          /***/
          (Bi, e, Ui) => {
            Object.defineProperty(e, "__esModule", {
              value: !0
            }), e.MurmurHash3_64 = void 0;
            var Zi = Ui(1);
            const ta = 3285377520, na = 4294901760, ia = 65535;
            class aa {
              constructor(La) {
                this.h1 = La ? La & 4294967295 : ta, this.h2 = La ? La & 4294967295 : ta;
              }
              update(La) {
                let qa, io;
                if (typeof La == "string") {
                  qa = new Uint8Array(La.length * 2), io = 0;
                  for (let Ao = 0, co = La.length; Ao < co; Ao++) {
                    const Co = La.charCodeAt(Ao);
                    Co <= 255 ? qa[io++] = Co : (qa[io++] = Co >>> 8, qa[io++] = Co & 255);
                  }
                } else if ((0, Zi.isArrayBuffer)(La))
                  qa = La.slice(), io = qa.byteLength;
                else
                  throw new Error("Wrong data format in MurmurHash3_64_update. Input must be a string or array.");
                const ao = io >> 2, oo = io - ao * 4, no = new Uint32Array(qa.buffer, 0, ao);
                let lo = 0, so = 0, bs = this.h1, Rs = this.h2;
                const js = 3432918353, qs = 461845907, jo = js & ia, fs = qs & ia;
                for (let Ao = 0; Ao < ao; Ao++)
                  Ao & 1 ? (lo = no[Ao], lo = lo * js & na | lo * jo & ia, lo = lo << 15 | lo >>> 17, lo = lo * qs & na | lo * fs & ia, bs ^= lo, bs = bs << 13 | bs >>> 19, bs = bs * 5 + 3864292196) : (so = no[Ao], so = so * js & na | so * jo & ia, so = so << 15 | so >>> 17, so = so * qs & na | so * fs & ia, Rs ^= so, Rs = Rs << 13 | Rs >>> 19, Rs = Rs * 5 + 3864292196);
                switch (lo = 0, oo) {
                  case 3:
                    lo ^= qa[ao * 4 + 2] << 16;
                  case 2:
                    lo ^= qa[ao * 4 + 1] << 8;
                  case 1:
                    lo ^= qa[ao * 4], lo = lo * js & na | lo * jo & ia, lo = lo << 15 | lo >>> 17, lo = lo * qs & na | lo * fs & ia, ao & 1 ? bs ^= lo : Rs ^= lo;
                }
                this.h1 = bs, this.h2 = Rs;
              }
              hexdigest() {
                let La = this.h1, qa = this.h2;
                La ^= qa >>> 1, La = La * 3981806797 & na | La * 36045 & ia, qa = qa * 4283543511 & na | ((qa << 16 | La >>> 16) * 2950163797 & na) >>> 16, La ^= qa >>> 1, La = La * 444984403 & na | La * 60499 & ia, qa = qa * 3301882366 & na | ((qa << 16 | La >>> 16) * 3120437893 & na) >>> 16, La ^= qa >>> 1;
                const io = (La >>> 0).toString(16), ao = (qa >>> 0).toString(16);
                return io.padStart(8, "0") + ao.padStart(8, "0");
              }
            }
            e.MurmurHash3_64 = aa;
          },
          /* 11 */
          /***/
          (Bi, e, Ui) => {
            Object.defineProperty(e, "__esModule", {
              value: !0
            }), e.FontLoader = e.FontFaceObject = void 0;
            var Zi = Ui(1);
            class ta {
              constructor({
                docId: da,
                onUnsupportedFeature: La,
                ownerDocument: qa = globalThis.document,
                styleElement: io = null
              }) {
                this.constructor === ta && (0, Zi.unreachable)("Cannot initialize BaseFontLoader."), this.docId = da, this._onUnsupportedFeature = La, this._document = qa, this.nativeFontFaces = [], this.styleElement = null;
              }
              addNativeFontFace(da) {
                this.nativeFontFaces.push(da), this._document.fonts.add(da);
              }
              insertRule(da) {
                let La = this.styleElement;
                La || (La = this.styleElement = this._document.createElement("style"), La.id = `PDFJS_FONT_STYLE_TAG_${this.docId}`, this._document.documentElement.getElementsByTagName("head")[0].append(La));
                const qa = La.sheet;
                qa.insertRule(da, qa.cssRules.length);
              }
              clear() {
                for (const da of this.nativeFontFaces)
                  this._document.fonts.delete(da);
                this.nativeFontFaces.length = 0, this.styleElement && (this.styleElement.remove(), this.styleElement = null);
              }
              async bind(da) {
                if (da.attached || da.missingFile)
                  return;
                if (da.attached = !0, this.isFontLoadingAPISupported) {
                  const qa = da.createNativeFontFace();
                  if (qa) {
                    this.addNativeFontFace(qa);
                    try {
                      await qa.loaded;
                    } catch (io) {
                      throw this._onUnsupportedFeature({
                        featureId: Zi.UNSUPPORTED_FEATURES.errorFontLoadNative
                      }), (0, Zi.warn)(`Failed to load font '${qa.family}': '${io}'.`), da.disableFontFace = !0, io;
                    }
                  }
                  return;
                }
                const La = da.createFontFaceRule();
                if (La) {
                  if (this.insertRule(La), this.isSyncFontLoadingSupported)
                    return;
                  await new Promise((qa) => {
                    const io = this._queueLoadingCallback(qa);
                    this._prepareFontLoadEvent([La], [da], io);
                  });
                }
              }
              _queueLoadingCallback(da) {
                (0, Zi.unreachable)("Abstract method `_queueLoadingCallback`.");
              }
              get isFontLoadingAPISupported() {
                const da = !!this._document?.fonts;
                return (0, Zi.shadow)(this, "isFontLoadingAPISupported", da);
              }
              get isSyncFontLoadingSupported() {
                (0, Zi.unreachable)("Abstract method `isSyncFontLoadingSupported`.");
              }
              get _loadTestFont() {
                (0, Zi.unreachable)("Abstract method `_loadTestFont`.");
              }
              _prepareFontLoadEvent(da, La, qa) {
                (0, Zi.unreachable)("Abstract method `_prepareFontLoadEvent`.");
              }
            }
            let na;
            e.FontLoader = na, e.FontLoader = na = class extends ta {
              constructor(da) {
                super(da), this.loadingContext = {
                  requests: [],
                  nextRequestId: 0
                }, this.loadTestFontId = 0;
              }
              get isSyncFontLoadingSupported() {
                let da = !1;
                return (typeof navigator > "u" || /Mozilla\/5.0.*?rv:(\d+).*? Gecko/.exec(navigator.userAgent)?.[1] >= 14) && (da = !0), (0, Zi.shadow)(this, "isSyncFontLoadingSupported", da);
              }
              _queueLoadingCallback(da) {
                function La() {
                  for ((0, Zi.assert)(!io.done, "completeRequest() cannot be called twice."), io.done = !0; qa.requests.length > 0 && qa.requests[0].done; ) {
                    const ao = qa.requests.shift();
                    setTimeout(ao.callback, 0);
                  }
                }
                const qa = this.loadingContext, io = {
                  id: `pdfjs-font-loading-${qa.nextRequestId++}`,
                  done: !1,
                  complete: La,
                  callback: da
                };
                return qa.requests.push(io), io;
              }
              get _loadTestFont() {
                const da = function() {
                  return atob("T1RUTwALAIAAAwAwQ0ZGIDHtZg4AAAOYAAAAgUZGVE1lkzZwAAAEHAAAABxHREVGABQAFQAABDgAAAAeT1MvMlYNYwkAAAEgAAAAYGNtYXABDQLUAAACNAAAAUJoZWFk/xVFDQAAALwAAAA2aGhlYQdkA+oAAAD0AAAAJGhtdHgD6AAAAAAEWAAAAAZtYXhwAAJQAAAAARgAAAAGbmFtZVjmdH4AAAGAAAAAsXBvc3T/hgAzAAADeAAAACAAAQAAAAEAALZRFsRfDzz1AAsD6AAAAADOBOTLAAAAAM4KHDwAAAAAA+gDIQAAAAgAAgAAAAAAAAABAAADIQAAAFoD6AAAAAAD6AABAAAAAAAAAAAAAAAAAAAAAQAAUAAAAgAAAAQD6AH0AAUAAAKKArwAAACMAooCvAAAAeAAMQECAAACAAYJAAAAAAAAAAAAAQAAAAAAAAAAAAAAAFBmRWQAwAAuAC4DIP84AFoDIQAAAAAAAQAAAAAAAAAAACAAIAABAAAADgCuAAEAAAAAAAAAAQAAAAEAAAAAAAEAAQAAAAEAAAAAAAIAAQAAAAEAAAAAAAMAAQAAAAEAAAAAAAQAAQAAAAEAAAAAAAUAAQAAAAEAAAAAAAYAAQAAAAMAAQQJAAAAAgABAAMAAQQJAAEAAgABAAMAAQQJAAIAAgABAAMAAQQJAAMAAgABAAMAAQQJAAQAAgABAAMAAQQJAAUAAgABAAMAAQQJAAYAAgABWABYAAAAAAAAAwAAAAMAAAAcAAEAAAAAADwAAwABAAAAHAAEACAAAAAEAAQAAQAAAC7//wAAAC7////TAAEAAAAAAAABBgAAAQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAEAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMAAAAAAAD/gwAyAAAAAQAAAAAAAAAAAAAAAAAAAAABAAQEAAEBAQJYAAEBASH4DwD4GwHEAvgcA/gXBIwMAYuL+nz5tQXkD5j3CBLnEQACAQEBIVhYWFhYWFhYWFhYWFhYWFhYWFhYWFhYWFhYWFhYWFhYAAABAQAADwACAQEEE/t3Dov6fAH6fAT+fPp8+nwHDosMCvm1Cvm1DAz6fBQAAAAAAAABAAAAAMmJbzEAAAAAzgTjFQAAAADOBOQpAAEAAAAAAAAADAAUAAQAAAABAAAAAgABAAAAAAAAAAAD6AAAAAAAAA==");
                };
                return (0, Zi.shadow)(this, "_loadTestFont", da());
              }
              _prepareFontLoadEvent(da, La, qa) {
                function io(Al, Ol) {
                  return Al.charCodeAt(Ol) << 24 | Al.charCodeAt(Ol + 1) << 16 | Al.charCodeAt(Ol + 2) << 8 | Al.charCodeAt(Ol + 3) & 255;
                }
                function ao(Al, Ol, Bl, Ml) {
                  const Vl = Al.substring(0, Ol), Ll = Al.substring(Ol + Bl);
                  return Vl + Ml + Ll;
                }
                let oo, no;
                const lo = this._document.createElement("canvas");
                lo.width = 1, lo.height = 1;
                const so = lo.getContext("2d");
                let bs = 0;
                function Rs(Al, Ol) {
                  if (bs++, bs > 30) {
                    (0, Zi.warn)("Load test font never loaded."), Ol();
                    return;
                  }
                  if (so.font = "30px " + Al, so.fillText(".", 0, 20), so.getImageData(0, 0, 1, 1).data[3] > 0) {
                    Ol();
                    return;
                  }
                  setTimeout(Rs.bind(null, Al, Ol));
                }
                const js = `lt${Date.now()}${this.loadTestFontId++}`;
                let qs = this._loadTestFont;
                qs = ao(qs, 976, js.length, js);
                const fs = 16, Ao = 1482184792;
                let co = io(qs, fs);
                for (oo = 0, no = js.length - 3; oo < no; oo += 4)
                  co = co - Ao + io(js, oo) | 0;
                oo < js.length && (co = co - Ao + io(js + "XXX", oo) | 0), qs = ao(qs, fs, 4, (0, Zi.string32)(co));
                const Co = `url(data:font/opentype;base64,${btoa(qs)});`, Zs = `@font-face {font-family:"${js}";src:${Co}}`;
                this.insertRule(Zs);
                const xl = [];
                for (const Al of La)
                  xl.push(Al.loadedName);
                xl.push(js);
                const Cl = this._document.createElement("div");
                Cl.style.visibility = "hidden", Cl.style.width = Cl.style.height = "10px", Cl.style.position = "absolute", Cl.style.top = Cl.style.left = "0px";
                for (const Al of xl) {
                  const Ol = this._document.createElement("span");
                  Ol.textContent = "Hi", Ol.style.fontFamily = Al, Cl.append(Ol);
                }
                this._document.body.append(Cl), Rs(js, () => {
                  Cl.remove(), qa.complete();
                });
              }
            };
            class ia {
              constructor(da, {
                isEvalSupported: La = !0,
                disableFontFace: qa = !1,
                ignoreErrors: io = !1,
                onUnsupportedFeature: ao,
                fontRegistry: oo = null
              }) {
                this.compiledGlyphs = /* @__PURE__ */ Object.create(null);
                for (const no in da)
                  this[no] = da[no];
                this.isEvalSupported = La !== !1, this.disableFontFace = qa === !0, this.ignoreErrors = io === !0, this._onUnsupportedFeature = ao, this.fontRegistry = oo;
              }
              createNativeFontFace() {
                if (!this.data || this.disableFontFace)
                  return null;
                let da;
                if (!this.cssFontInfo)
                  da = new FontFace(this.loadedName, this.data, {});
                else {
                  const La = {
                    weight: this.cssFontInfo.fontWeight
                  };
                  this.cssFontInfo.italicAngle && (La.style = `oblique ${this.cssFontInfo.italicAngle}deg`), da = new FontFace(this.cssFontInfo.fontFamily, this.data, La);
                }
                return this.fontRegistry && this.fontRegistry.registerFont(this), da;
              }
              createFontFaceRule() {
                if (!this.data || this.disableFontFace)
                  return null;
                const da = (0, Zi.bytesToString)(this.data), La = `url(data:${this.mimetype};base64,${btoa(da)});`;
                let qa;
                if (!this.cssFontInfo)
                  qa = `@font-face {font-family:"${this.loadedName}";src:${La}}`;
                else {
                  let io = `font-weight: ${this.cssFontInfo.fontWeight};`;
                  this.cssFontInfo.italicAngle && (io += `font-style: oblique ${this.cssFontInfo.italicAngle}deg;`), qa = `@font-face {font-family:"${this.cssFontInfo.fontFamily}";${io}src:${La}}`;
                }
                return this.fontRegistry && this.fontRegistry.registerFont(this, La), qa;
              }
              getPathGenerator(da, La) {
                if (this.compiledGlyphs[La] !== void 0)
                  return this.compiledGlyphs[La];
                let qa;
                try {
                  qa = da.get(this.loadedName + "_path_" + La);
                } catch (io) {
                  if (!this.ignoreErrors)
                    throw io;
                  return this._onUnsupportedFeature({
                    featureId: Zi.UNSUPPORTED_FEATURES.errorFontGetPath
                  }), (0, Zi.warn)(`getPathGenerator - ignoring character: "${io}".`), this.compiledGlyphs[La] = function(ao, oo) {
                  };
                }
                if (this.isEvalSupported && Zi.FeatureTest.isEvalSupported) {
                  const io = [];
                  for (const ao of qa) {
                    const oo = ao.args !== void 0 ? ao.args.join(",") : "";
                    io.push("c.", ao.cmd, "(", oo, `);
`);
                  }
                  return this.compiledGlyphs[La] = new Function("c", "size", io.join(""));
                }
                return this.compiledGlyphs[La] = function(io, ao) {
                  for (const oo of qa)
                    oo.cmd === "scale" && (oo.args = [ao, -ao]), io[oo.cmd].apply(io, oo.args);
                };
              }
            }
            e.FontFaceObject = ia;
          },
          /* 12 */
          /***/
          (Bi, e, Ui) => {
            var Yl, uf;
            Object.defineProperty(e, "__esModule", {
              value: !0
            }), e.CanvasGraphics = void 0;
            var Zi = Ui(8), ta = Ui(1), na = Ui(13), ia = Ui(14), aa = Ui(3);
            const da = 16, La = 100, qa = 4096, io = 15, ao = 10, oo = aa.isNodeJS && typeof Path2D > "u" ? -1 : 1e3, no = 16;
            function lo(Nl, Tl) {
              if (Nl._removeMirroring)
                throw new Error("Context is already forwarding operations.");
              Nl.__originalSave = Nl.save, Nl.__originalRestore = Nl.restore, Nl.__originalRotate = Nl.rotate, Nl.__originalScale = Nl.scale, Nl.__originalTranslate = Nl.translate, Nl.__originalTransform = Nl.transform, Nl.__originalSetTransform = Nl.setTransform, Nl.__originalResetTransform = Nl.resetTransform, Nl.__originalClip = Nl.clip, Nl.__originalMoveTo = Nl.moveTo, Nl.__originalLineTo = Nl.lineTo, Nl.__originalBezierCurveTo = Nl.bezierCurveTo, Nl.__originalRect = Nl.rect, Nl.__originalClosePath = Nl.closePath, Nl.__originalBeginPath = Nl.beginPath, Nl._removeMirroring = () => {
                Nl.save = Nl.__originalSave, Nl.restore = Nl.__originalRestore, Nl.rotate = Nl.__originalRotate, Nl.scale = Nl.__originalScale, Nl.translate = Nl.__originalTranslate, Nl.transform = Nl.__originalTransform, Nl.setTransform = Nl.__originalSetTransform, Nl.resetTransform = Nl.__originalResetTransform, Nl.clip = Nl.__originalClip, Nl.moveTo = Nl.__originalMoveTo, Nl.lineTo = Nl.__originalLineTo, Nl.bezierCurveTo = Nl.__originalBezierCurveTo, Nl.rect = Nl.__originalRect, Nl.closePath = Nl.__originalClosePath, Nl.beginPath = Nl.__originalBeginPath, delete Nl._removeMirroring;
              }, Nl.save = function() {
                Tl.save(), this.__originalSave();
              }, Nl.restore = function() {
                Tl.restore(), this.__originalRestore();
              }, Nl.translate = function(Il, Ul) {
                Tl.translate(Il, Ul), this.__originalTranslate(Il, Ul);
              }, Nl.scale = function(Il, Ul) {
                Tl.scale(Il, Ul), this.__originalScale(Il, Ul);
              }, Nl.transform = function(Il, Ul, Kl, Rl, uo, Is) {
                Tl.transform(Il, Ul, Kl, Rl, uo, Is), this.__originalTransform(Il, Ul, Kl, Rl, uo, Is);
              }, Nl.setTransform = function(Il, Ul, Kl, Rl, uo, Is) {
                Tl.setTransform(Il, Ul, Kl, Rl, uo, Is), this.__originalSetTransform(Il, Ul, Kl, Rl, uo, Is);
              }, Nl.resetTransform = function() {
                Tl.resetTransform(), this.__originalResetTransform();
              }, Nl.rotate = function(Il) {
                Tl.rotate(Il), this.__originalRotate(Il);
              }, Nl.clip = function(Il) {
                Tl.clip(Il), this.__originalClip(Il);
              }, Nl.moveTo = function(El, Il) {
                Tl.moveTo(El, Il), this.__originalMoveTo(El, Il);
              }, Nl.lineTo = function(El, Il) {
                Tl.lineTo(El, Il), this.__originalLineTo(El, Il);
              }, Nl.bezierCurveTo = function(El, Il, Ul, Kl, Rl, uo) {
                Tl.bezierCurveTo(El, Il, Ul, Kl, Rl, uo), this.__originalBezierCurveTo(El, Il, Ul, Kl, Rl, uo);
              }, Nl.rect = function(El, Il, Ul, Kl) {
                Tl.rect(El, Il, Ul, Kl), this.__originalRect(El, Il, Ul, Kl);
              }, Nl.closePath = function() {
                Tl.closePath(), this.__originalClosePath();
              }, Nl.beginPath = function() {
                Tl.beginPath(), this.__originalBeginPath();
              };
            }
            class so {
              constructor(Tl) {
                this.canvasFactory = Tl, this.cache = /* @__PURE__ */ Object.create(null);
              }
              getCanvas(Tl, El, Il) {
                let Ul;
                return this.cache[Tl] !== void 0 ? (Ul = this.cache[Tl], this.canvasFactory.reset(Ul, El, Il)) : (Ul = this.canvasFactory.create(El, Il), this.cache[Tl] = Ul), Ul;
              }
              delete(Tl) {
                delete this.cache[Tl];
              }
              clear() {
                for (const Tl in this.cache) {
                  const El = this.cache[Tl];
                  this.canvasFactory.destroy(El), delete this.cache[Tl];
                }
              }
            }
            function bs(Nl, Tl, El, Il, Ul, Kl, Rl, uo, Is, Sl) {
              const [wl, Pl, jl, Dl, $l, kl] = (0, Zi.getCurrentTransform)(Nl);
              if (Pl === 0 && jl === 0) {
                const Wl = Rl * wl + $l, ql = Math.round(Wl), Jl = uo * Dl + kl, ac = Math.round(Jl), Xl = (Rl + Is) * wl + $l, sc = Math.abs(Math.round(Xl) - ql) || 1, Hu = (uo + Sl) * Dl + kl, dc = Math.abs(Math.round(Hu) - ac) || 1;
                return Nl.setTransform(Math.sign(wl), 0, 0, Math.sign(Dl), ql, ac), Nl.drawImage(Tl, El, Il, Ul, Kl, 0, 0, sc, dc), Nl.setTransform(wl, Pl, jl, Dl, $l, kl), [sc, dc];
              }
              if (wl === 0 && Dl === 0) {
                const Wl = uo * jl + $l, ql = Math.round(Wl), Jl = Rl * Pl + kl, ac = Math.round(Jl), Xl = (uo + Sl) * jl + $l, sc = Math.abs(Math.round(Xl) - ql) || 1, Hu = (Rl + Is) * Pl + kl, dc = Math.abs(Math.round(Hu) - ac) || 1;
                return Nl.setTransform(0, Math.sign(Pl), Math.sign(jl), 0, ql, ac), Nl.drawImage(Tl, El, Il, Ul, Kl, 0, 0, dc, sc), Nl.setTransform(wl, Pl, jl, Dl, $l, kl), [dc, sc];
              }
              Nl.drawImage(Tl, El, Il, Ul, Kl, Rl, uo, Is, Sl);
              const zl = Math.hypot(wl, Pl), Hl = Math.hypot(jl, Dl);
              return [zl * Is, Hl * Sl];
            }
            function Rs(Nl) {
              const {
                width: Tl,
                height: El
              } = Nl;
              if (Tl > oo || El > oo)
                return null;
              const Il = 1e3, Ul = new Uint8Array([0, 2, 4, 0, 1, 0, 5, 4, 8, 10, 0, 8, 0, 2, 1, 0]), Kl = Tl + 1;
              let Rl = new Uint8Array(Kl * (El + 1)), uo, Is, Sl;
              const wl = Tl + 7 & -8;
              let Pl = new Uint8Array(wl * El), jl = 0;
              for (const Hl of Nl.data) {
                let Wl = 128;
                for (; Wl > 0; )
                  Pl[jl++] = Hl & Wl ? 0 : 255, Wl >>= 1;
              }
              let Dl = 0;
              for (jl = 0, Pl[jl] !== 0 && (Rl[0] = 1, ++Dl), Is = 1; Is < Tl; Is++)
                Pl[jl] !== Pl[jl + 1] && (Rl[Is] = Pl[jl] ? 2 : 1, ++Dl), jl++;
              for (Pl[jl] !== 0 && (Rl[Is] = 2, ++Dl), uo = 1; uo < El; uo++) {
                jl = uo * wl, Sl = uo * Kl, Pl[jl - wl] !== Pl[jl] && (Rl[Sl] = Pl[jl] ? 1 : 8, ++Dl);
                let Hl = (Pl[jl] ? 4 : 0) + (Pl[jl - wl] ? 8 : 0);
                for (Is = 1; Is < Tl; Is++)
                  Hl = (Hl >> 2) + (Pl[jl + 1] ? 4 : 0) + (Pl[jl - wl + 1] ? 8 : 0), Ul[Hl] && (Rl[Sl + Is] = Ul[Hl], ++Dl), jl++;
                if (Pl[jl - wl] !== Pl[jl] && (Rl[Sl + Is] = Pl[jl] ? 2 : 4, ++Dl), Dl > Il)
                  return null;
              }
              for (jl = wl * (El - 1), Sl = uo * Kl, Pl[jl] !== 0 && (Rl[Sl] = 8, ++Dl), Is = 1; Is < Tl; Is++)
                Pl[jl] !== Pl[jl + 1] && (Rl[Sl + Is] = Pl[jl] ? 4 : 8, ++Dl), jl++;
              if (Pl[jl] !== 0 && (Rl[Sl + Is] = 4, ++Dl), Dl > Il)
                return null;
              const $l = new Int32Array([0, Kl, -1, 0, -Kl, 0, 0, 0, 1]), kl = new Path2D();
              for (uo = 0; Dl && uo <= El; uo++) {
                let Hl = uo * Kl;
                const Wl = Hl + Tl;
                for (; Hl < Wl && !Rl[Hl]; )
                  Hl++;
                if (Hl === Wl)
                  continue;
                kl.moveTo(Hl % Kl, uo);
                const ql = Hl;
                let Jl = Rl[Hl];
                do {
                  const ac = $l[Jl];
                  do
                    Hl += ac;
                  while (!Rl[Hl]);
                  const Xl = Rl[Hl];
                  Xl !== 5 && Xl !== 10 ? (Jl = Xl, Rl[Hl] = 0) : (Jl = Xl & 51 * Jl >> 4, Rl[Hl] &= Jl >> 2 | Jl << 2), kl.lineTo(Hl % Kl, Hl / Kl | 0), Rl[Hl] || --Dl;
                } while (ql !== Hl);
                --uo;
              }
              return Pl = null, Rl = null, function(Hl) {
                Hl.save(), Hl.scale(1 / Tl, -1 / El), Hl.translate(0, -El), Hl.fill(kl), Hl.beginPath(), Hl.restore();
              };
            }
            class js {
              constructor(Tl, El) {
                this.alphaIsShape = !1, this.fontSize = 0, this.fontSizeScale = 1, this.textMatrix = ta.IDENTITY_MATRIX, this.textMatrixScale = 1, this.fontMatrix = ta.FONT_IDENTITY_MATRIX, this.leading = 0, this.x = 0, this.y = 0, this.lineX = 0, this.lineY = 0, this.charSpacing = 0, this.wordSpacing = 0, this.textHScale = 1, this.textRenderingMode = ta.TextRenderingMode.FILL, this.textRise = 0, this.fillColor = "#000000", this.strokeColor = "#000000", this.patternFill = !1, this.fillAlpha = 1, this.strokeAlpha = 1, this.lineWidth = 1, this.activeSMask = null, this.transferMaps = null, this.startNewPathAndClipBox([0, 0, Tl, El]);
              }
              clone() {
                const Tl = Object.create(this);
                return Tl.clipBox = this.clipBox.slice(), Tl;
              }
              setCurrentPoint(Tl, El) {
                this.x = Tl, this.y = El;
              }
              updatePathMinMax(Tl, El, Il) {
                [El, Il] = ta.Util.applyTransform([El, Il], Tl), this.minX = Math.min(this.minX, El), this.minY = Math.min(this.minY, Il), this.maxX = Math.max(this.maxX, El), this.maxY = Math.max(this.maxY, Il);
              }
              updateRectMinMax(Tl, El) {
                const Il = ta.Util.applyTransform(El, Tl), Ul = ta.Util.applyTransform(El.slice(2), Tl);
                this.minX = Math.min(this.minX, Il[0], Ul[0]), this.minY = Math.min(this.minY, Il[1], Ul[1]), this.maxX = Math.max(this.maxX, Il[0], Ul[0]), this.maxY = Math.max(this.maxY, Il[1], Ul[1]);
              }
              updateScalingPathMinMax(Tl, El) {
                ta.Util.scaleMinMax(Tl, El), this.minX = Math.min(this.minX, El[0]), this.maxX = Math.max(this.maxX, El[1]), this.minY = Math.min(this.minY, El[2]), this.maxY = Math.max(this.maxY, El[3]);
              }
              updateCurvePathMinMax(Tl, El, Il, Ul, Kl, Rl, uo, Is, Sl, wl) {
                const Pl = ta.Util.bezierBoundingBox(El, Il, Ul, Kl, Rl, uo, Is, Sl);
                if (wl) {
                  wl[0] = Math.min(wl[0], Pl[0], Pl[2]), wl[1] = Math.max(wl[1], Pl[0], Pl[2]), wl[2] = Math.min(wl[2], Pl[1], Pl[3]), wl[3] = Math.max(wl[3], Pl[1], Pl[3]);
                  return;
                }
                this.updateRectMinMax(Tl, Pl);
              }
              getPathBoundingBox(Tl = na.PathType.FILL, El = null) {
                const Il = [this.minX, this.minY, this.maxX, this.maxY];
                if (Tl === na.PathType.STROKE) {
                  El || (0, ta.unreachable)("Stroke bounding box must include transform.");
                  const Ul = ta.Util.singularValueDecompose2dScale(El), Kl = Ul[0] * this.lineWidth / 2, Rl = Ul[1] * this.lineWidth / 2;
                  Il[0] -= Kl, Il[1] -= Rl, Il[2] += Kl, Il[3] += Rl;
                }
                return Il;
              }
              updateClipFromPath() {
                const Tl = ta.Util.intersect(this.clipBox, this.getPathBoundingBox());
                this.startNewPathAndClipBox(Tl || [0, 0, 0, 0]);
              }
              isEmptyClip() {
                return this.minX === 1 / 0;
              }
              startNewPathAndClipBox(Tl) {
                this.clipBox = Tl, this.minX = 1 / 0, this.minY = 1 / 0, this.maxX = 0, this.maxY = 0;
              }
              getClippedPathBoundingBox(Tl = na.PathType.FILL, El = null) {
                return ta.Util.intersect(this.clipBox, this.getPathBoundingBox(Tl, El));
              }
            }
            function qs(Nl, Tl, El = null) {
              if (typeof ImageData < "u" && Tl instanceof ImageData) {
                Nl.putImageData(Tl, 0, 0);
                return;
              }
              const Il = Tl.height, Ul = Tl.width, Kl = Il % no, Rl = (Il - Kl) / no, uo = Kl === 0 ? Rl : Rl + 1, Is = Nl.createImageData(Ul, no);
              let Sl = 0, wl;
              const Pl = Tl.data, jl = Is.data;
              let Dl, $l, kl, zl, Hl, Wl, ql, Jl;
              if (El)
                switch (El.length) {
                  case 1:
                    Hl = El[0], Wl = El[0], ql = El[0], Jl = El[0];
                    break;
                  case 4:
                    Hl = El[0], Wl = El[1], ql = El[2], Jl = El[3];
                    break;
                }
              if (Tl.kind === ta.ImageKind.GRAYSCALE_1BPP) {
                const ac = Pl.byteLength, Xl = new Uint32Array(jl.buffer, 0, jl.byteLength >> 2), sc = Xl.length, Hu = Ul + 7 >> 3;
                let dc = 4294967295, td = ta.FeatureTest.isLittleEndian ? 4278190080 : 255;
                for (Jl && Jl[0] === 255 && Jl[255] === 0 && ([dc, td] = [td, dc]), Dl = 0; Dl < uo; Dl++) {
                  for (kl = Dl < Rl ? no : Kl, wl = 0, $l = 0; $l < kl; $l++) {
                    const ad = ac - Sl;
                    let od = 0;
                    const sd = ad > Hu ? Ul : ad * 8 - 7, dd = sd & -8;
                    let pd = 0, fd = 0;
                    for (; od < dd; od += 8)
                      fd = Pl[Sl++], Xl[wl++] = fd & 128 ? dc : td, Xl[wl++] = fd & 64 ? dc : td, Xl[wl++] = fd & 32 ? dc : td, Xl[wl++] = fd & 16 ? dc : td, Xl[wl++] = fd & 8 ? dc : td, Xl[wl++] = fd & 4 ? dc : td, Xl[wl++] = fd & 2 ? dc : td, Xl[wl++] = fd & 1 ? dc : td;
                    for (; od < sd; od++)
                      pd === 0 && (fd = Pl[Sl++], pd = 128), Xl[wl++] = fd & pd ? dc : td, pd >>= 1;
                  }
                  for (; wl < sc; )
                    Xl[wl++] = 0;
                  Nl.putImageData(Is, 0, Dl * no);
                }
              } else if (Tl.kind === ta.ImageKind.RGBA_32BPP) {
                const ac = !!(Hl || Wl || ql);
                for ($l = 0, zl = Ul * no * 4, Dl = 0; Dl < Rl; Dl++) {
                  if (jl.set(Pl.subarray(Sl, Sl + zl)), Sl += zl, ac)
                    for (let Xl = 0; Xl < zl; Xl += 4)
                      Hl && (jl[Xl + 0] = Hl[jl[Xl + 0]]), Wl && (jl[Xl + 1] = Wl[jl[Xl + 1]]), ql && (jl[Xl + 2] = ql[jl[Xl + 2]]);
                  Nl.putImageData(Is, 0, $l), $l += no;
                }
                if (Dl < uo) {
                  if (zl = Ul * Kl * 4, jl.set(Pl.subarray(Sl, Sl + zl)), ac)
                    for (let Xl = 0; Xl < zl; Xl += 4)
                      Hl && (jl[Xl + 0] = Hl[jl[Xl + 0]]), Wl && (jl[Xl + 1] = Wl[jl[Xl + 1]]), ql && (jl[Xl + 2] = ql[jl[Xl + 2]]);
                  Nl.putImageData(Is, 0, $l);
                }
              } else if (Tl.kind === ta.ImageKind.RGB_24BPP) {
                const ac = !!(Hl || Wl || ql);
                for (kl = no, zl = Ul * kl, Dl = 0; Dl < uo; Dl++) {
                  for (Dl >= Rl && (kl = Kl, zl = Ul * kl), wl = 0, $l = zl; $l--; )
                    jl[wl++] = Pl[Sl++], jl[wl++] = Pl[Sl++], jl[wl++] = Pl[Sl++], jl[wl++] = 255;
                  if (ac)
                    for (let Xl = 0; Xl < wl; Xl += 4)
                      Hl && (jl[Xl + 0] = Hl[jl[Xl + 0]]), Wl && (jl[Xl + 1] = Wl[jl[Xl + 1]]), ql && (jl[Xl + 2] = ql[jl[Xl + 2]]);
                  Nl.putImageData(Is, 0, Dl * no);
                }
              } else
                throw new Error(`bad image kind: ${Tl.kind}`);
            }
            function jo(Nl, Tl) {
              if (Tl.bitmap) {
                Nl.drawImage(Tl.bitmap, 0, 0);
                return;
              }
              const El = Tl.height, Il = Tl.width, Ul = El % no, Kl = (El - Ul) / no, Rl = Ul === 0 ? Kl : Kl + 1, uo = Nl.createImageData(Il, no);
              let Is = 0;
              const Sl = Tl.data, wl = uo.data;
              for (let Pl = 0; Pl < Rl; Pl++) {
                const jl = Pl < Kl ? no : Ul;
                ({
                  srcPos: Is
                } = (0, ia.applyMaskImageData)({
                  src: Sl,
                  srcPos: Is,
                  dest: wl,
                  width: Il,
                  height: jl
                })), Nl.putImageData(uo, 0, Pl * no);
              }
            }
            function fs(Nl, Tl) {
              const El = ["strokeStyle", "fillStyle", "fillRule", "globalAlpha", "lineWidth", "lineCap", "lineJoin", "miterLimit", "globalCompositeOperation", "font"];
              for (let Il = 0, Ul = El.length; Il < Ul; Il++) {
                const Kl = El[Il];
                Nl[Kl] !== void 0 && (Tl[Kl] = Nl[Kl]);
              }
              Nl.setLineDash !== void 0 && (Tl.setLineDash(Nl.getLineDash()), Tl.lineDashOffset = Nl.lineDashOffset);
            }
            function Ao(Nl, Tl) {
              Nl.strokeStyle = Nl.fillStyle = Tl || "#000000", Nl.fillRule = "nonzero", Nl.globalAlpha = 1, Nl.lineWidth = 1, Nl.lineCap = "butt", Nl.lineJoin = "miter", Nl.miterLimit = 10, Nl.globalCompositeOperation = "source-over", Nl.font = "10px sans-serif", Nl.setLineDash !== void 0 && (Nl.setLineDash([]), Nl.lineDashOffset = 0);
            }
            function co(Nl, Tl, El, Il) {
              const Ul = Nl.length;
              for (let Kl = 3; Kl < Ul; Kl += 4) {
                const Rl = Nl[Kl];
                if (Rl === 0)
                  Nl[Kl - 3] = Tl, Nl[Kl - 2] = El, Nl[Kl - 1] = Il;
                else if (Rl < 255) {
                  const uo = 255 - Rl;
                  Nl[Kl - 3] = Nl[Kl - 3] * Rl + Tl * uo >> 8, Nl[Kl - 2] = Nl[Kl - 2] * Rl + El * uo >> 8, Nl[Kl - 1] = Nl[Kl - 1] * Rl + Il * uo >> 8;
                }
              }
            }
            function Co(Nl, Tl, El) {
              const Il = Nl.length, Ul = 1 / 255;
              for (let Kl = 3; Kl < Il; Kl += 4) {
                const Rl = El ? El[Nl[Kl]] : Nl[Kl];
                Tl[Kl] = Tl[Kl] * Rl * Ul | 0;
              }
            }
            function Zs(Nl, Tl, El) {
              const Il = Nl.length;
              for (let Ul = 3; Ul < Il; Ul += 4) {
                const Kl = Nl[Ul - 3] * 77 + Nl[Ul - 2] * 152 + Nl[Ul - 1] * 28;
                Tl[Ul] = El ? Tl[Ul] * El[Kl >> 8] >> 8 : Tl[Ul] * Kl >> 16;
              }
            }
            function xl(Nl, Tl, El, Il, Ul, Kl, Rl, uo, Is, Sl, wl) {
              const Pl = !!Kl, jl = Pl ? Kl[0] : 0, Dl = Pl ? Kl[1] : 0, $l = Pl ? Kl[2] : 0;
              let kl;
              Ul === "Luminosity" ? kl = Zs : kl = Co;
              const Hl = Math.min(Il, Math.ceil(1048576 / El));
              for (let Wl = 0; Wl < Il; Wl += Hl) {
                const ql = Math.min(Hl, Il - Wl), Jl = Nl.getImageData(uo - Sl, Wl + (Is - wl), El, ql), ac = Tl.getImageData(uo, Wl + Is, El, ql);
                Pl && co(Jl.data, jl, Dl, $l), kl(Jl.data, ac.data, Rl), Tl.putImageData(ac, uo, Wl + Is);
              }
            }
            function Cl(Nl, Tl, El, Il) {
              const Ul = Il[0], Kl = Il[1], Rl = Il[2] - Ul, uo = Il[3] - Kl;
              Rl === 0 || uo === 0 || (xl(Tl.context, El, Rl, uo, Tl.subtype, Tl.backdrop, Tl.transferMap, Ul, Kl, Tl.offsetX, Tl.offsetY), Nl.save(), Nl.globalAlpha = 1, Nl.globalCompositeOperation = "source-over", Nl.setTransform(1, 0, 0, 1, 0, 0), Nl.drawImage(El.canvas, 0, 0), Nl.restore());
            }
            function Al(Nl, Tl) {
              const El = ta.Util.singularValueDecompose2dScale(Nl);
              El[0] = Math.fround(El[0]), El[1] = Math.fround(El[1]);
              const Il = Math.fround((globalThis.devicePixelRatio || 1) * Zi.PixelsPerInch.PDF_TO_CSS_UNITS);
              return Tl !== void 0 ? Tl : El[0] <= Il || El[1] <= Il;
            }
            const Ol = ["butt", "round", "square"], Bl = ["miter", "round", "bevel"], Ml = {}, Vl = {}, tc = class tc {
              constructor(Tl, El, Il, Ul, Kl, Rl, uo, Is) {
                fc(this, Yl);
                this.ctx = Tl, this.current = new js(this.ctx.canvas.width, this.ctx.canvas.height), this.stateStack = [], this.pendingClip = null, this.pendingEOFill = !1, this.res = null, this.xobjs = null, this.commonObjs = El, this.objs = Il, this.canvasFactory = Ul, this.imageLayer = Kl, this.groupStack = [], this.processingType3 = null, this.baseTransform = null, this.baseTransformStack = [], this.groupLevel = 0, this.smaskStack = [], this.smaskCounter = 0, this.tempSMask = null, this.suspendedCtx = null, this.contentVisible = !0, this.markedContentStack = [], this.optionalContentConfig = Rl, this.cachedCanvases = new so(this.canvasFactory), this.cachedPatterns = /* @__PURE__ */ new Map(), this.annotationCanvasMap = uo, this.viewportScale = 1, this.outputScaleX = 1, this.outputScaleY = 1, this.backgroundColor = Is?.background || null, this.foregroundColor = Is?.foreground || null, this._cachedScaleForStroking = null, this._cachedGetSinglePixelWidth = null, this._cachedBitmapsMap = /* @__PURE__ */ new Map();
              }
              getObject(Tl, El = null) {
                return typeof Tl == "string" ? Tl.startsWith("g_") ? this.commonObjs.get(Tl) : this.objs.get(Tl) : El;
              }
              beginDrawing({
                transform: Tl,
                viewport: El,
                transparency: Il = !1,
                background: Ul = null
              }) {
                const Kl = this.ctx.canvas.width, Rl = this.ctx.canvas.height, uo = Ul || "#ffffff";
                if (this.ctx.save(), this.foregroundColor && this.backgroundColor) {
                  this.ctx.fillStyle = this.foregroundColor;
                  const Is = this.foregroundColor = this.ctx.fillStyle;
                  this.ctx.fillStyle = this.backgroundColor;
                  const Sl = this.backgroundColor = this.ctx.fillStyle;
                  let wl = !0, Pl = uo;
                  if (this.ctx.fillStyle = uo, Pl = this.ctx.fillStyle, wl = typeof Pl == "string" && /^#[0-9A-Fa-f]{6}$/.test(Pl), Is === "#000000" && Sl === "#ffffff" || Is === Sl || !wl)
                    this.foregroundColor = this.backgroundColor = null;
                  else {
                    const [jl, Dl, $l] = (0, Zi.getRGB)(Pl), kl = (Hl) => (Hl /= 255, Hl <= 0.03928 ? Hl / 12.92 : ((Hl + 0.055) / 1.055) ** 2.4), zl = Math.round(0.2126 * kl(jl) + 0.7152 * kl(Dl) + 0.0722 * kl($l));
                    this.selectColor = (Hl, Wl, ql) => {
                      const Jl = 0.2126 * kl(Hl) + 0.7152 * kl(Wl) + 0.0722 * kl(ql);
                      return Math.round(Jl) === zl ? Sl : Is;
                    };
                  }
                }
                if (this.ctx.fillStyle = this.backgroundColor || uo, this.ctx.fillRect(0, 0, Kl, Rl), this.ctx.restore(), Il) {
                  const Is = this.cachedCanvases.getCanvas("transparent", Kl, Rl);
                  this.compositeCtx = this.ctx, this.transparentCanvas = Is.canvas, this.ctx = Is.context, this.ctx.save(), this.ctx.transform(...(0, Zi.getCurrentTransform)(this.compositeCtx));
                }
                this.ctx.save(), Ao(this.ctx, this.foregroundColor), Tl && (this.ctx.transform(...Tl), this.outputScaleX = Tl[0], this.outputScaleY = Tl[0]), this.ctx.transform(...El.transform), this.viewportScale = El.scale, this.baseTransform = (0, Zi.getCurrentTransform)(this.ctx), this.imageLayer && ((0, Zi.deprecated)("The `imageLayer` functionality will be removed in the future."), this.imageLayer.beginLayout());
              }
              executeOperatorList(Tl, El, Il, Ul) {
                const Kl = Tl.argsArray, Rl = Tl.fnArray;
                let uo = El || 0;
                const Is = Kl.length;
                if (Is === uo)
                  return uo;
                const Sl = Is - uo > ao && typeof Il == "function", wl = Sl ? Date.now() + io : 0;
                let Pl = 0;
                const jl = this.commonObjs, Dl = this.objs;
                let $l;
                for (; ; ) {
                  if (Ul !== void 0 && uo === Ul.nextBreakPoint)
                    return Ul.breakIt(uo, Il), uo;
                  if ($l = Rl[uo], $l !== ta.OPS.dependency)
                    this[$l].apply(this, Kl[uo]);
                  else
                    for (const kl of Kl[uo]) {
                      const zl = kl.startsWith("g_") ? jl : Dl;
                      if (!zl.has(kl))
                        return zl.get(kl, Il), uo;
                    }
                  if (uo++, uo === Is)
                    return uo;
                  if (Sl && ++Pl > ao) {
                    if (Date.now() > wl)
                      return Il(), uo;
                    Pl = 0;
                  }
                }
              }
              endDrawing() {
                lc(this, Yl, uf).call(this), this.cachedCanvases.clear(), this.cachedPatterns.clear();
                for (const Tl of this._cachedBitmapsMap.values()) {
                  for (const El of Tl.values())
                    typeof HTMLCanvasElement < "u" && El instanceof HTMLCanvasElement && (El.width = El.height = 0);
                  Tl.clear();
                }
                this._cachedBitmapsMap.clear(), this.imageLayer && this.imageLayer.endLayout();
              }
              _scaleImage(Tl, El) {
                const Il = Tl.width, Ul = Tl.height;
                let Kl = Math.max(Math.hypot(El[0], El[1]), 1), Rl = Math.max(Math.hypot(El[2], El[3]), 1), uo = Il, Is = Ul, Sl = "prescale1", wl, Pl;
                for (; Kl > 2 && uo > 1 || Rl > 2 && Is > 1; ) {
                  let jl = uo, Dl = Is;
                  Kl > 2 && uo > 1 && (jl = Math.ceil(uo / 2), Kl /= uo / jl), Rl > 2 && Is > 1 && (Dl = Math.ceil(Is / 2), Rl /= Is / Dl), wl = this.cachedCanvases.getCanvas(Sl, jl, Dl), Pl = wl.context, Pl.clearRect(0, 0, jl, Dl), Pl.drawImage(Tl, 0, 0, uo, Is, 0, 0, jl, Dl), Tl = wl.canvas, uo = jl, Is = Dl, Sl = Sl === "prescale1" ? "prescale2" : "prescale1";
                }
                return {
                  img: Tl,
                  paintWidth: uo,
                  paintHeight: Is
                };
              }
              _createMaskCanvas(Tl) {
                const El = this.ctx, {
                  width: Il,
                  height: Ul
                } = Tl, Kl = this.current.fillColor, Rl = this.current.patternFill, uo = (0, Zi.getCurrentTransform)(El);
                let Is, Sl, wl, Pl;
                if ((Tl.bitmap || Tl.data) && Tl.count > 1) {
                  const sc = Tl.bitmap || Tl.data.buffer, Hu = uo.slice(0, 4);
                  Sl = JSON.stringify(Rl ? Hu : [Hu, Kl]), Is = this._cachedBitmapsMap.get(sc), Is || (Is = /* @__PURE__ */ new Map(), this._cachedBitmapsMap.set(sc, Is));
                  const dc = Is.get(Sl);
                  if (dc && !Rl) {
                    const td = Math.round(Math.min(uo[0], uo[2]) + uo[4]), ad = Math.round(Math.min(uo[1], uo[3]) + uo[5]);
                    return {
                      canvas: dc,
                      offsetX: td,
                      offsetY: ad
                    };
                  }
                  wl = dc;
                }
                wl || (Pl = this.cachedCanvases.getCanvas("maskCanvas", Il, Ul), jo(Pl.context, Tl));
                let jl = ta.Util.transform(uo, [1 / Il, 0, 0, -1 / Ul, 0, 0]);
                jl = ta.Util.transform(jl, [1, 0, 0, 1, 0, -Ul]);
                const Dl = ta.Util.applyTransform([0, 0], jl), $l = ta.Util.applyTransform([Il, Ul], jl), kl = ta.Util.normalizeRect([Dl[0], Dl[1], $l[0], $l[1]]), zl = Math.round(kl[2] - kl[0]) || 1, Hl = Math.round(kl[3] - kl[1]) || 1, Wl = this.cachedCanvases.getCanvas("fillCanvas", zl, Hl), ql = Wl.context, Jl = Math.min(Dl[0], $l[0]), ac = Math.min(Dl[1], $l[1]);
                ql.translate(-Jl, -ac), ql.transform(...jl), wl || (wl = this._scaleImage(Pl.canvas, (0, Zi.getCurrentTransformInverse)(ql)), wl = wl.img, Is && Rl && Is.set(Sl, wl)), ql.imageSmoothingEnabled = Al((0, Zi.getCurrentTransform)(ql), Tl.interpolate), bs(ql, wl, 0, 0, wl.width, wl.height, 0, 0, Il, Ul), ql.globalCompositeOperation = "source-in";
                const Xl = ta.Util.transform((0, Zi.getCurrentTransformInverse)(ql), [1, 0, 0, 1, -Jl, -ac]);
                return ql.fillStyle = Rl ? Kl.getPattern(El, this, Xl, na.PathType.FILL) : Kl, ql.fillRect(0, 0, Il, Ul), Is && !Rl && (this.cachedCanvases.delete("fillCanvas"), Is.set(Sl, Wl.canvas)), {
                  canvas: Wl.canvas,
                  offsetX: Math.round(Jl),
                  offsetY: Math.round(ac)
                };
              }
              setLineWidth(Tl) {
                Tl !== this.current.lineWidth && (this._cachedScaleForStroking = null), this.current.lineWidth = Tl, this.ctx.lineWidth = Tl;
              }
              setLineCap(Tl) {
                this.ctx.lineCap = Ol[Tl];
              }
              setLineJoin(Tl) {
                this.ctx.lineJoin = Bl[Tl];
              }
              setMiterLimit(Tl) {
                this.ctx.miterLimit = Tl;
              }
              setDash(Tl, El) {
                const Il = this.ctx;
                Il.setLineDash !== void 0 && (Il.setLineDash(Tl), Il.lineDashOffset = El);
              }
              setRenderingIntent(Tl) {
              }
              setFlatness(Tl) {
              }
              setGState(Tl) {
                for (let El = 0, Il = Tl.length; El < Il; El++) {
                  const Ul = Tl[El], Kl = Ul[0], Rl = Ul[1];
                  switch (Kl) {
                    case "LW":
                      this.setLineWidth(Rl);
                      break;
                    case "LC":
                      this.setLineCap(Rl);
                      break;
                    case "LJ":
                      this.setLineJoin(Rl);
                      break;
                    case "ML":
                      this.setMiterLimit(Rl);
                      break;
                    case "D":
                      this.setDash(Rl[0], Rl[1]);
                      break;
                    case "RI":
                      this.setRenderingIntent(Rl);
                      break;
                    case "FL":
                      this.setFlatness(Rl);
                      break;
                    case "Font":
                      this.setFont(Rl[0], Rl[1]);
                      break;
                    case "CA":
                      this.current.strokeAlpha = Ul[1];
                      break;
                    case "ca":
                      this.current.fillAlpha = Ul[1], this.ctx.globalAlpha = Ul[1];
                      break;
                    case "BM":
                      this.ctx.globalCompositeOperation = Rl;
                      break;
                    case "SMask":
                      this.current.activeSMask = Rl ? this.tempSMask : null, this.tempSMask = null, this.checkSMaskState();
                      break;
                    case "TR":
                      this.current.transferMaps = Rl;
                  }
                }
              }
              get inSMaskMode() {
                return !!this.suspendedCtx;
              }
              checkSMaskState() {
                const Tl = this.inSMaskMode;
                this.current.activeSMask && !Tl ? this.beginSMaskMode() : !this.current.activeSMask && Tl && this.endSMaskMode();
              }
              beginSMaskMode() {
                if (this.inSMaskMode)
                  throw new Error("beginSMaskMode called while already in smask mode");
                const Tl = this.ctx.canvas.width, El = this.ctx.canvas.height, Il = "smaskGroupAt" + this.groupLevel, Ul = this.cachedCanvases.getCanvas(Il, Tl, El);
                this.suspendedCtx = this.ctx, this.ctx = Ul.context;
                const Kl = this.ctx;
                Kl.setTransform(...(0, Zi.getCurrentTransform)(this.suspendedCtx)), fs(this.suspendedCtx, Kl), lo(Kl, this.suspendedCtx), this.setGState([["BM", "source-over"], ["ca", 1], ["CA", 1]]);
              }
              endSMaskMode() {
                if (!this.inSMaskMode)
                  throw new Error("endSMaskMode called while not in smask mode");
                this.ctx._removeMirroring(), fs(this.ctx, this.suspendedCtx), this.ctx = this.suspendedCtx, this.suspendedCtx = null;
              }
              compose(Tl) {
                if (!this.current.activeSMask)
                  return;
                Tl ? (Tl[0] = Math.floor(Tl[0]), Tl[1] = Math.floor(Tl[1]), Tl[2] = Math.ceil(Tl[2]), Tl[3] = Math.ceil(Tl[3])) : Tl = [0, 0, this.ctx.canvas.width, this.ctx.canvas.height];
                const El = this.current.activeSMask, Il = this.suspendedCtx;
                Cl(Il, El, this.ctx, Tl), this.ctx.save(), this.ctx.setTransform(1, 0, 0, 1, 0, 0), this.ctx.clearRect(0, 0, this.ctx.canvas.width, this.ctx.canvas.height), this.ctx.restore();
              }
              save() {
                this.inSMaskMode ? (fs(this.ctx, this.suspendedCtx), this.suspendedCtx.save()) : this.ctx.save();
                const Tl = this.current;
                this.stateStack.push(Tl), this.current = Tl.clone();
              }
              restore() {
                this.stateStack.length === 0 && this.inSMaskMode && this.endSMaskMode(), this.stateStack.length !== 0 && (this.current = this.stateStack.pop(), this.inSMaskMode ? (this.suspendedCtx.restore(), fs(this.suspendedCtx, this.ctx)) : this.ctx.restore(), this.checkSMaskState(), this.pendingClip = null, this._cachedScaleForStroking = null, this._cachedGetSinglePixelWidth = null);
              }
              transform(Tl, El, Il, Ul, Kl, Rl) {
                this.ctx.transform(Tl, El, Il, Ul, Kl, Rl), this._cachedScaleForStroking = null, this._cachedGetSinglePixelWidth = null;
              }
              constructPath(Tl, El, Il) {
                const Ul = this.ctx, Kl = this.current;
                let Rl = Kl.x, uo = Kl.y, Is, Sl;
                const wl = (0, Zi.getCurrentTransform)(Ul), Pl = wl[0] === 0 && wl[3] === 0 || wl[1] === 0 && wl[2] === 0, jl = Pl ? Il.slice(0) : null;
                for (let Dl = 0, $l = 0, kl = Tl.length; Dl < kl; Dl++)
                  switch (Tl[Dl] | 0) {
                    case ta.OPS.rectangle:
                      Rl = El[$l++], uo = El[$l++];
                      const zl = El[$l++], Hl = El[$l++], Wl = Rl + zl, ql = uo + Hl;
                      Ul.moveTo(Rl, uo), zl === 0 || Hl === 0 ? Ul.lineTo(Wl, ql) : (Ul.lineTo(Wl, uo), Ul.lineTo(Wl, ql), Ul.lineTo(Rl, ql)), Pl || Kl.updateRectMinMax(wl, [Rl, uo, Wl, ql]), Ul.closePath();
                      break;
                    case ta.OPS.moveTo:
                      Rl = El[$l++], uo = El[$l++], Ul.moveTo(Rl, uo), Pl || Kl.updatePathMinMax(wl, Rl, uo);
                      break;
                    case ta.OPS.lineTo:
                      Rl = El[$l++], uo = El[$l++], Ul.lineTo(Rl, uo), Pl || Kl.updatePathMinMax(wl, Rl, uo);
                      break;
                    case ta.OPS.curveTo:
                      Is = Rl, Sl = uo, Rl = El[$l + 4], uo = El[$l + 5], Ul.bezierCurveTo(El[$l], El[$l + 1], El[$l + 2], El[$l + 3], Rl, uo), Kl.updateCurvePathMinMax(wl, Is, Sl, El[$l], El[$l + 1], El[$l + 2], El[$l + 3], Rl, uo, jl), $l += 6;
                      break;
                    case ta.OPS.curveTo2:
                      Is = Rl, Sl = uo, Ul.bezierCurveTo(Rl, uo, El[$l], El[$l + 1], El[$l + 2], El[$l + 3]), Kl.updateCurvePathMinMax(wl, Is, Sl, Rl, uo, El[$l], El[$l + 1], El[$l + 2], El[$l + 3], jl), Rl = El[$l + 2], uo = El[$l + 3], $l += 4;
                      break;
                    case ta.OPS.curveTo3:
                      Is = Rl, Sl = uo, Rl = El[$l + 2], uo = El[$l + 3], Ul.bezierCurveTo(El[$l], El[$l + 1], Rl, uo, Rl, uo), Kl.updateCurvePathMinMax(wl, Is, Sl, El[$l], El[$l + 1], Rl, uo, Rl, uo, jl), $l += 4;
                      break;
                    case ta.OPS.closePath:
                      Ul.closePath();
                      break;
                  }
                Pl && Kl.updateScalingPathMinMax(wl, jl), Kl.setCurrentPoint(Rl, uo);
              }
              closePath() {
                this.ctx.closePath();
              }
              stroke(Tl) {
                Tl = typeof Tl < "u" ? Tl : !0;
                const El = this.ctx, Il = this.current.strokeColor;
                El.globalAlpha = this.current.strokeAlpha, this.contentVisible && (typeof Il == "object" && Il?.getPattern ? (El.save(), El.strokeStyle = Il.getPattern(El, this, (0, Zi.getCurrentTransformInverse)(El), na.PathType.STROKE), this.rescaleAndStroke(!1), El.restore()) : this.rescaleAndStroke(!0)), Tl && this.consumePath(this.current.getClippedPathBoundingBox()), El.globalAlpha = this.current.fillAlpha;
              }
              closeStroke() {
                this.closePath(), this.stroke();
              }
              fill(Tl) {
                Tl = typeof Tl < "u" ? Tl : !0;
                const El = this.ctx, Il = this.current.fillColor, Ul = this.current.patternFill;
                let Kl = !1;
                Ul && (El.save(), El.fillStyle = Il.getPattern(El, this, (0, Zi.getCurrentTransformInverse)(El), na.PathType.FILL), Kl = !0);
                const Rl = this.current.getClippedPathBoundingBox();
                this.contentVisible && Rl !== null && (this.pendingEOFill ? (El.fill("evenodd"), this.pendingEOFill = !1) : El.fill()), Kl && El.restore(), Tl && this.consumePath(Rl);
              }
              eoFill() {
                this.pendingEOFill = !0, this.fill();
              }
              fillStroke() {
                this.fill(!1), this.stroke(!1), this.consumePath();
              }
              eoFillStroke() {
                this.pendingEOFill = !0, this.fillStroke();
              }
              closeFillStroke() {
                this.closePath(), this.fillStroke();
              }
              closeEOFillStroke() {
                this.pendingEOFill = !0, this.closePath(), this.fillStroke();
              }
              endPath() {
                this.consumePath();
              }
              clip() {
                this.pendingClip = Ml;
              }
              eoClip() {
                this.pendingClip = Vl;
              }
              beginText() {
                this.current.textMatrix = ta.IDENTITY_MATRIX, this.current.textMatrixScale = 1, this.current.x = this.current.lineX = 0, this.current.y = this.current.lineY = 0;
              }
              endText() {
                const Tl = this.pendingTextPaths, El = this.ctx;
                if (Tl === void 0) {
                  El.beginPath();
                  return;
                }
                El.save(), El.beginPath();
                for (const Il of Tl)
                  El.setTransform(...Il.transform), El.translate(Il.x, Il.y), Il.addToPath(El, Il.fontSize);
                El.restore(), El.clip(), El.beginPath(), delete this.pendingTextPaths;
              }
              setCharSpacing(Tl) {
                this.current.charSpacing = Tl;
              }
              setWordSpacing(Tl) {
                this.current.wordSpacing = Tl;
              }
              setHScale(Tl) {
                this.current.textHScale = Tl / 100;
              }
              setLeading(Tl) {
                this.current.leading = -Tl;
              }
              setFont(Tl, El) {
                const Il = this.commonObjs.get(Tl), Ul = this.current;
                if (!Il)
                  throw new Error(`Can't find font for ${Tl}`);
                if (Ul.fontMatrix = Il.fontMatrix || ta.FONT_IDENTITY_MATRIX, (Ul.fontMatrix[0] === 0 || Ul.fontMatrix[3] === 0) && (0, ta.warn)("Invalid font matrix for font " + Tl), El < 0 ? (El = -El, Ul.fontDirection = -1) : Ul.fontDirection = 1, this.current.font = Il, this.current.fontSize = El, Il.isType3Font)
                  return;
                const Kl = Il.loadedName || "sans-serif";
                let Rl = "normal";
                Il.black ? Rl = "900" : Il.bold && (Rl = "bold");
                const uo = Il.italic ? "italic" : "normal", Is = `"${Kl}", ${Il.fallbackName}`;
                let Sl = El;
                El < da ? Sl = da : El > La && (Sl = La), this.current.fontSizeScale = El / Sl, this.ctx.font = `${uo} ${Rl} ${Sl}px ${Is}`;
              }
              setTextRenderingMode(Tl) {
                this.current.textRenderingMode = Tl;
              }
              setTextRise(Tl) {
                this.current.textRise = Tl;
              }
              moveText(Tl, El) {
                this.current.x = this.current.lineX += Tl, this.current.y = this.current.lineY += El;
              }
              setLeadingMoveText(Tl, El) {
                this.setLeading(-El), this.moveText(Tl, El);
              }
              setTextMatrix(Tl, El, Il, Ul, Kl, Rl) {
                this.current.textMatrix = [Tl, El, Il, Ul, Kl, Rl], this.current.textMatrixScale = Math.hypot(Tl, El), this.current.x = this.current.lineX = 0, this.current.y = this.current.lineY = 0;
              }
              nextLine() {
                this.moveText(0, this.current.leading);
              }
              paintChar(Tl, El, Il, Ul) {
                const Kl = this.ctx, Rl = this.current, uo = Rl.font, Is = Rl.textRenderingMode, Sl = Rl.fontSize / Rl.fontSizeScale, wl = Is & ta.TextRenderingMode.FILL_STROKE_MASK, Pl = !!(Is & ta.TextRenderingMode.ADD_TO_PATH_FLAG), jl = Rl.patternFill && !uo.missingFile;
                let Dl;
                (uo.disableFontFace || Pl || jl) && (Dl = uo.getPathGenerator(this.commonObjs, Tl)), uo.disableFontFace || jl ? (Kl.save(), Kl.translate(El, Il), Kl.beginPath(), Dl(Kl, Sl), Ul && Kl.setTransform(...Ul), (wl === ta.TextRenderingMode.FILL || wl === ta.TextRenderingMode.FILL_STROKE) && Kl.fill(), (wl === ta.TextRenderingMode.STROKE || wl === ta.TextRenderingMode.FILL_STROKE) && Kl.stroke(), Kl.restore()) : ((wl === ta.TextRenderingMode.FILL || wl === ta.TextRenderingMode.FILL_STROKE) && Kl.fillText(Tl, El, Il), (wl === ta.TextRenderingMode.STROKE || wl === ta.TextRenderingMode.FILL_STROKE) && Kl.strokeText(Tl, El, Il)), Pl && (this.pendingTextPaths || (this.pendingTextPaths = [])).push({
                  transform: (0, Zi.getCurrentTransform)(Kl),
                  x: El,
                  y: Il,
                  fontSize: Sl,
                  addToPath: Dl
                });
              }
              get isFontSubpixelAAEnabled() {
                const {
                  context: Tl
                } = this.cachedCanvases.getCanvas("isFontSubpixelAAEnabled", 10, 10);
                Tl.scale(1.5, 1), Tl.fillText("I", 0, 10);
                const El = Tl.getImageData(0, 0, 10, 10).data;
                let Il = !1;
                for (let Ul = 3; Ul < El.length; Ul += 4)
                  if (El[Ul] > 0 && El[Ul] < 255) {
                    Il = !0;
                    break;
                  }
                return (0, ta.shadow)(this, "isFontSubpixelAAEnabled", Il);
              }
              showText(Tl) {
                const El = this.current, Il = El.font;
                if (Il.isType3Font)
                  return this.showType3Text(Tl);
                const Ul = El.fontSize;
                if (Ul === 0)
                  return;
                const Kl = this.ctx, Rl = El.fontSizeScale, uo = El.charSpacing, Is = El.wordSpacing, Sl = El.fontDirection, wl = El.textHScale * Sl, Pl = Tl.length, jl = Il.vertical, Dl = jl ? 1 : -1, $l = Il.defaultVMetrics, kl = Ul * El.fontMatrix[0], zl = El.textRenderingMode === ta.TextRenderingMode.FILL && !Il.disableFontFace && !El.patternFill;
                Kl.save(), Kl.transform(...El.textMatrix), Kl.translate(El.x, El.y + El.textRise), Sl > 0 ? Kl.scale(wl, -1) : Kl.scale(wl, 1);
                let Hl;
                if (El.patternFill) {
                  Kl.save();
                  const Xl = El.fillColor.getPattern(Kl, this, (0, Zi.getCurrentTransformInverse)(Kl), na.PathType.FILL);
                  Hl = (0, Zi.getCurrentTransform)(Kl), Kl.restore(), Kl.fillStyle = Xl;
                }
                let Wl = El.lineWidth;
                const ql = El.textMatrixScale;
                if (ql === 0 || Wl === 0) {
                  const Xl = El.textRenderingMode & ta.TextRenderingMode.FILL_STROKE_MASK;
                  (Xl === ta.TextRenderingMode.STROKE || Xl === ta.TextRenderingMode.FILL_STROKE) && (Wl = this.getSinglePixelWidth());
                } else
                  Wl /= ql;
                Rl !== 1 && (Kl.scale(Rl, Rl), Wl /= Rl), Kl.lineWidth = Wl;
                let Jl = 0, ac;
                for (ac = 0; ac < Pl; ++ac) {
                  const Xl = Tl[ac];
                  if (typeof Xl == "number") {
                    Jl += Dl * Xl * Ul / 1e3;
                    continue;
                  }
                  let sc = !1;
                  const Hu = (Xl.isSpace ? Is : 0) + uo, dc = Xl.fontChar, td = Xl.accent;
                  let ad, od, sd = Xl.width;
                  if (jl) {
                    const pd = Xl.vmetric || $l, fd = -(Xl.vmetric ? pd[1] : sd * 0.5) * kl, Ed = pd[2] * kl;
                    sd = pd ? -pd[0] : sd, ad = fd / Rl, od = (Jl + Ed) / Rl;
                  } else
                    ad = Jl / Rl, od = 0;
                  if (Il.remeasure && sd > 0) {
                    const pd = Kl.measureText(dc).width * 1e3 / Ul * Rl;
                    if (sd < pd && this.isFontSubpixelAAEnabled) {
                      const fd = sd / pd;
                      sc = !0, Kl.save(), Kl.scale(fd, 1), ad /= fd;
                    } else sd !== pd && (ad += (sd - pd) / 2e3 * Ul / Rl);
                  }
                  if (this.contentVisible && (Xl.isInFont || Il.missingFile)) {
                    if (zl && !td)
                      Kl.fillText(dc, ad, od);
                    else if (this.paintChar(dc, ad, od, Hl), td) {
                      const pd = ad + Ul * td.offset.x / Rl, fd = od - Ul * td.offset.y / Rl;
                      this.paintChar(td.fontChar, pd, fd, Hl);
                    }
                  }
                  let dd;
                  jl ? dd = sd * kl - Hu * Sl : dd = sd * kl + Hu * Sl, Jl += dd, sc && Kl.restore();
                }
                jl ? El.y -= Jl : El.x += Jl * wl, Kl.restore(), this.compose();
              }
              showType3Text(Tl) {
                const El = this.ctx, Il = this.current, Ul = Il.font, Kl = Il.fontSize, Rl = Il.fontDirection, uo = Ul.vertical ? 1 : -1, Is = Il.charSpacing, Sl = Il.wordSpacing, wl = Il.textHScale * Rl, Pl = Il.fontMatrix || ta.FONT_IDENTITY_MATRIX, jl = Tl.length, Dl = Il.textRenderingMode === ta.TextRenderingMode.INVISIBLE;
                let $l, kl, zl, Hl;
                if (!(Dl || Kl === 0)) {
                  for (this._cachedScaleForStroking = null, this._cachedGetSinglePixelWidth = null, El.save(), El.transform(...Il.textMatrix), El.translate(Il.x, Il.y), El.scale(wl, Rl), $l = 0; $l < jl; ++$l) {
                    if (kl = Tl[$l], typeof kl == "number") {
                      Hl = uo * kl * Kl / 1e3, this.ctx.translate(Hl, 0), Il.x += Hl * wl;
                      continue;
                    }
                    const Wl = (kl.isSpace ? Sl : 0) + Is, ql = Ul.charProcOperatorList[kl.operatorListId];
                    if (!ql) {
                      (0, ta.warn)(`Type3 character "${kl.operatorListId}" is not available.`);
                      continue;
                    }
                    this.contentVisible && (this.processingType3 = kl, this.save(), El.scale(Kl, Kl), El.transform(...Pl), this.executeOperatorList(ql), this.restore()), zl = ta.Util.applyTransform([kl.width, 0], Pl)[0] * Kl + Wl, El.translate(zl, 0), Il.x += zl * wl;
                  }
                  El.restore(), this.processingType3 = null;
                }
              }
              setCharWidth(Tl, El) {
              }
              setCharWidthAndBounds(Tl, El, Il, Ul, Kl, Rl) {
                this.ctx.rect(Il, Ul, Kl - Il, Rl - Ul), this.ctx.clip(), this.endPath();
              }
              getColorN_Pattern(Tl) {
                let El;
                if (Tl[0] === "TilingPattern") {
                  const Il = Tl[1], Ul = this.baseTransform || (0, Zi.getCurrentTransform)(this.ctx), Kl = {
                    createCanvasGraphics: (Rl) => new tc(Rl, this.commonObjs, this.objs, this.canvasFactory)
                  };
                  El = new na.TilingPattern(Tl, Il, this.ctx, Kl, Ul);
                } else
                  El = this._getPattern(Tl[1], Tl[2]);
                return El;
              }
              setStrokeColorN() {
                this.current.strokeColor = this.getColorN_Pattern(arguments);
              }
              setFillColorN() {
                this.current.fillColor = this.getColorN_Pattern(arguments), this.current.patternFill = !0;
              }
              setStrokeRGBColor(Tl, El, Il) {
                const Ul = this.selectColor?.(Tl, El, Il) || ta.Util.makeHexColor(Tl, El, Il);
                this.ctx.strokeStyle = Ul, this.current.strokeColor = Ul;
              }
              setFillRGBColor(Tl, El, Il) {
                const Ul = this.selectColor?.(Tl, El, Il) || ta.Util.makeHexColor(Tl, El, Il);
                this.ctx.fillStyle = Ul, this.current.fillColor = Ul, this.current.patternFill = !1;
              }
              _getPattern(Tl, El = null) {
                let Il;
                return this.cachedPatterns.has(Tl) ? Il = this.cachedPatterns.get(Tl) : (Il = (0, na.getShadingPattern)(this.objs.get(Tl)), this.cachedPatterns.set(Tl, Il)), El && (Il.matrix = El), Il;
              }
              shadingFill(Tl) {
                if (!this.contentVisible)
                  return;
                const El = this.ctx;
                this.save();
                const Il = this._getPattern(Tl);
                El.fillStyle = Il.getPattern(El, this, (0, Zi.getCurrentTransformInverse)(El), na.PathType.SHADING);
                const Ul = (0, Zi.getCurrentTransformInverse)(El);
                if (Ul) {
                  const Kl = El.canvas, Rl = Kl.width, uo = Kl.height, Is = ta.Util.applyTransform([0, 0], Ul), Sl = ta.Util.applyTransform([0, uo], Ul), wl = ta.Util.applyTransform([Rl, 0], Ul), Pl = ta.Util.applyTransform([Rl, uo], Ul), jl = Math.min(Is[0], Sl[0], wl[0], Pl[0]), Dl = Math.min(Is[1], Sl[1], wl[1], Pl[1]), $l = Math.max(Is[0], Sl[0], wl[0], Pl[0]), kl = Math.max(Is[1], Sl[1], wl[1], Pl[1]);
                  this.ctx.fillRect(jl, Dl, $l - jl, kl - Dl);
                } else
                  this.ctx.fillRect(-1e10, -1e10, 2e10, 2e10);
                this.compose(this.current.getClippedPathBoundingBox()), this.restore();
              }
              beginInlineImage() {
                (0, ta.unreachable)("Should not call beginInlineImage");
              }
              beginImageData() {
                (0, ta.unreachable)("Should not call beginImageData");
              }
              paintFormXObjectBegin(Tl, El) {
                if (this.contentVisible && (this.save(), this.baseTransformStack.push(this.baseTransform), Array.isArray(Tl) && Tl.length === 6 && this.transform(...Tl), this.baseTransform = (0, Zi.getCurrentTransform)(this.ctx), El)) {
                  const Il = El[2] - El[0], Ul = El[3] - El[1];
                  this.ctx.rect(El[0], El[1], Il, Ul), this.current.updateRectMinMax((0, Zi.getCurrentTransform)(this.ctx), El), this.clip(), this.endPath();
                }
              }
              paintFormXObjectEnd() {
                this.contentVisible && (this.restore(), this.baseTransform = this.baseTransformStack.pop());
              }
              beginGroup(Tl) {
                if (!this.contentVisible)
                  return;
                this.save(), this.inSMaskMode && (this.endSMaskMode(), this.current.activeSMask = null);
                const El = this.ctx;
                Tl.isolated || (0, ta.info)("TODO: Support non-isolated groups."), Tl.knockout && (0, ta.warn)("Knockout groups not supported.");
                const Il = (0, Zi.getCurrentTransform)(El);
                if (Tl.matrix && El.transform(...Tl.matrix), !Tl.bbox)
                  throw new Error("Bounding box is required.");
                let Ul = ta.Util.getAxialAlignedBoundingBox(Tl.bbox, (0, Zi.getCurrentTransform)(El));
                const Kl = [0, 0, El.canvas.width, El.canvas.height];
                Ul = ta.Util.intersect(Ul, Kl) || [0, 0, 0, 0];
                const Rl = Math.floor(Ul[0]), uo = Math.floor(Ul[1]);
                let Is = Math.max(Math.ceil(Ul[2]) - Rl, 1), Sl = Math.max(Math.ceil(Ul[3]) - uo, 1), wl = 1, Pl = 1;
                Is > qa && (wl = Is / qa, Is = qa), Sl > qa && (Pl = Sl / qa, Sl = qa), this.current.startNewPathAndClipBox([0, 0, Is, Sl]);
                let jl = "groupAt" + this.groupLevel;
                Tl.smask && (jl += "_smask_" + this.smaskCounter++ % 2);
                const Dl = this.cachedCanvases.getCanvas(jl, Is, Sl), $l = Dl.context;
                $l.scale(1 / wl, 1 / Pl), $l.translate(-Rl, -uo), $l.transform(...Il), Tl.smask ? this.smaskStack.push({
                  canvas: Dl.canvas,
                  context: $l,
                  offsetX: Rl,
                  offsetY: uo,
                  scaleX: wl,
                  scaleY: Pl,
                  subtype: Tl.smask.subtype,
                  backdrop: Tl.smask.backdrop,
                  transferMap: Tl.smask.transferMap || null,
                  startTransformInverse: null
                }) : (El.setTransform(1, 0, 0, 1, 0, 0), El.translate(Rl, uo), El.scale(wl, Pl), El.save()), fs(El, $l), this.ctx = $l, this.setGState([["BM", "source-over"], ["ca", 1], ["CA", 1]]), this.groupStack.push(El), this.groupLevel++;
              }
              endGroup(Tl) {
                if (!this.contentVisible)
                  return;
                this.groupLevel--;
                const El = this.ctx, Il = this.groupStack.pop();
                if (this.ctx = Il, this.ctx.imageSmoothingEnabled = !1, Tl.smask)
                  this.tempSMask = this.smaskStack.pop(), this.restore();
                else {
                  this.ctx.restore();
                  const Ul = (0, Zi.getCurrentTransform)(this.ctx);
                  this.restore(), this.ctx.save(), this.ctx.setTransform(...Ul);
                  const Kl = ta.Util.getAxialAlignedBoundingBox([0, 0, El.canvas.width, El.canvas.height], Ul);
                  this.ctx.drawImage(El.canvas, 0, 0), this.ctx.restore(), this.compose(Kl);
                }
              }
              beginAnnotation(Tl, El, Il, Ul, Kl) {
                if (lc(this, Yl, uf).call(this), Ao(this.ctx, this.foregroundColor), this.ctx.save(), this.save(), this.baseTransform && this.ctx.setTransform(...this.baseTransform), Array.isArray(El) && El.length === 4) {
                  const Rl = El[2] - El[0], uo = El[3] - El[1];
                  if (Kl && this.annotationCanvasMap) {
                    Il = Il.slice(), Il[4] -= El[0], Il[5] -= El[1], El = El.slice(), El[0] = El[1] = 0, El[2] = Rl, El[3] = uo;
                    const [Is, Sl] = ta.Util.singularValueDecompose2dScale((0, Zi.getCurrentTransform)(this.ctx)), {
                      viewportScale: wl
                    } = this, Pl = Math.ceil(Rl * this.outputScaleX * wl), jl = Math.ceil(uo * this.outputScaleY * wl);
                    this.annotationCanvas = this.canvasFactory.create(Pl, jl);
                    const {
                      canvas: Dl,
                      context: $l
                    } = this.annotationCanvas;
                    this.annotationCanvasMap.set(Tl, Dl), this.annotationCanvas.savedCtx = this.ctx, this.ctx = $l, this.ctx.setTransform(Is, 0, 0, -Sl, 0, uo * Sl), Ao(this.ctx, this.foregroundColor);
                  } else
                    Ao(this.ctx, this.foregroundColor), this.ctx.rect(El[0], El[1], Rl, uo), this.ctx.clip(), this.endPath();
                }
                this.current = new js(this.ctx.canvas.width, this.ctx.canvas.height), this.transform(...Il), this.transform(...Ul);
              }
              endAnnotation() {
                this.annotationCanvas && (this.ctx = this.annotationCanvas.savedCtx, delete this.annotationCanvas.savedCtx, delete this.annotationCanvas);
              }
              paintImageMaskXObject(Tl) {
                if (!this.contentVisible)
                  return;
                const El = Tl.count;
                Tl = this.getObject(Tl.data, Tl), Tl.count = El;
                const Il = this.ctx, Ul = this.processingType3;
                if (Ul && (Ul.compiled === void 0 && (Ul.compiled = Rs(Tl)), Ul.compiled)) {
                  Ul.compiled(Il);
                  return;
                }
                const Kl = this._createMaskCanvas(Tl), Rl = Kl.canvas;
                Il.save(), Il.setTransform(1, 0, 0, 1, 0, 0), Il.drawImage(Rl, Kl.offsetX, Kl.offsetY), Il.restore(), this.compose();
              }
              paintImageMaskXObjectRepeat(Tl, El, Il = 0, Ul = 0, Kl, Rl) {
                if (!this.contentVisible)
                  return;
                Tl = this.getObject(Tl.data, Tl);
                const uo = this.ctx;
                uo.save();
                const Is = (0, Zi.getCurrentTransform)(uo);
                uo.transform(El, Il, Ul, Kl, 0, 0);
                const Sl = this._createMaskCanvas(Tl);
                uo.setTransform(1, 0, 0, 1, 0, 0);
                for (let wl = 0, Pl = Rl.length; wl < Pl; wl += 2) {
                  const jl = ta.Util.transform(Is, [El, Il, Ul, Kl, Rl[wl], Rl[wl + 1]]), [Dl, $l] = ta.Util.applyTransform([0, 0], jl);
                  uo.drawImage(Sl.canvas, Dl, $l);
                }
                uo.restore(), this.compose();
              }
              paintImageMaskXObjectGroup(Tl) {
                if (!this.contentVisible)
                  return;
                const El = this.ctx, Il = this.current.fillColor, Ul = this.current.patternFill;
                for (const Kl of Tl) {
                  const {
                    data: Rl,
                    width: uo,
                    height: Is,
                    transform: Sl
                  } = Kl, wl = this.cachedCanvases.getCanvas("maskCanvas", uo, Is), Pl = wl.context;
                  Pl.save();
                  const jl = this.getObject(Rl, Kl);
                  jo(Pl, jl), Pl.globalCompositeOperation = "source-in", Pl.fillStyle = Ul ? Il.getPattern(Pl, this, (0, Zi.getCurrentTransformInverse)(El), na.PathType.FILL) : Il, Pl.fillRect(0, 0, uo, Is), Pl.restore(), El.save(), El.transform(...Sl), El.scale(1, -1), bs(El, wl.canvas, 0, 0, uo, Is, 0, -1, 1, 1), El.restore();
                }
                this.compose();
              }
              paintImageXObject(Tl) {
                if (!this.contentVisible)
                  return;
                const El = this.getObject(Tl);
                if (!El) {
                  (0, ta.warn)("Dependent image isn't ready yet");
                  return;
                }
                this.paintInlineImageXObject(El);
              }
              paintImageXObjectRepeat(Tl, El, Il, Ul) {
                if (!this.contentVisible)
                  return;
                const Kl = this.getObject(Tl);
                if (!Kl) {
                  (0, ta.warn)("Dependent image isn't ready yet");
                  return;
                }
                const Rl = Kl.width, uo = Kl.height, Is = [];
                for (let Sl = 0, wl = Ul.length; Sl < wl; Sl += 2)
                  Is.push({
                    transform: [El, 0, 0, Il, Ul[Sl], Ul[Sl + 1]],
                    x: 0,
                    y: 0,
                    w: Rl,
                    h: uo
                  });
                this.paintInlineImageXObjectGroup(Kl, Is);
              }
              paintInlineImageXObject(Tl) {
                if (!this.contentVisible)
                  return;
                const El = Tl.width, Il = Tl.height, Ul = this.ctx;
                this.save(), Ul.scale(1 / El, -1 / Il);
                let Kl;
                if (typeof HTMLElement == "function" && Tl instanceof HTMLElement || !Tl.data)
                  Kl = Tl;
                else {
                  const Sl = this.cachedCanvases.getCanvas("inlineImage", El, Il), wl = Sl.context;
                  qs(wl, Tl, this.current.transferMaps), Kl = Sl.canvas;
                }
                const Rl = this._scaleImage(Kl, (0, Zi.getCurrentTransformInverse)(Ul));
                Ul.imageSmoothingEnabled = Al((0, Zi.getCurrentTransform)(Ul), Tl.interpolate);
                const [uo, Is] = bs(Ul, Rl.img, 0, 0, Rl.paintWidth, Rl.paintHeight, 0, -Il, El, Il);
                if (this.imageLayer) {
                  const [Sl, wl] = ta.Util.applyTransform([0, -Il], (0, Zi.getCurrentTransform)(this.ctx));
                  this.imageLayer.appendImage({
                    imgData: Tl,
                    left: Sl,
                    top: wl,
                    width: uo,
                    height: Is
                  });
                }
                this.compose(), this.restore();
              }
              paintInlineImageXObjectGroup(Tl, El) {
                if (!this.contentVisible)
                  return;
                const Il = this.ctx, Ul = Tl.width, Kl = Tl.height, Rl = this.cachedCanvases.getCanvas("inlineImage", Ul, Kl), uo = Rl.context;
                qs(uo, Tl, this.current.transferMaps);
                for (const Is of El) {
                  if (Il.save(), Il.transform(...Is.transform), Il.scale(1, -1), bs(Il, Rl.canvas, Is.x, Is.y, Is.w, Is.h, 0, -1, 1, 1), this.imageLayer) {
                    const [Sl, wl] = ta.Util.applyTransform([Is.x, Is.y], (0, Zi.getCurrentTransform)(this.ctx));
                    this.imageLayer.appendImage({
                      imgData: Tl,
                      left: Sl,
                      top: wl,
                      width: Ul,
                      height: Kl
                    });
                  }
                  Il.restore();
                }
                this.compose();
              }
              paintSolidColorImageMask() {
                this.contentVisible && (this.ctx.fillRect(0, 0, 1, 1), this.compose());
              }
              markPoint(Tl) {
              }
              markPointProps(Tl, El) {
              }
              beginMarkedContent(Tl) {
                this.markedContentStack.push({
                  visible: !0
                });
              }
              beginMarkedContentProps(Tl, El) {
                Tl === "OC" ? this.markedContentStack.push({
                  visible: this.optionalContentConfig.isVisible(El)
                }) : this.markedContentStack.push({
                  visible: !0
                }), this.contentVisible = this.isContentVisible();
              }
              endMarkedContent() {
                this.markedContentStack.pop(), this.contentVisible = this.isContentVisible();
              }
              beginCompat() {
              }
              endCompat() {
              }
              consumePath(Tl) {
                const El = this.current.isEmptyClip();
                this.pendingClip && this.current.updateClipFromPath(), this.pendingClip || this.compose(Tl);
                const Il = this.ctx;
                this.pendingClip && (El || (this.pendingClip === Vl ? Il.clip("evenodd") : Il.clip()), this.pendingClip = null), this.current.startNewPathAndClipBox(this.current.clipBox), Il.beginPath();
              }
              getSinglePixelWidth() {
                if (!this._cachedGetSinglePixelWidth) {
                  const Tl = (0, Zi.getCurrentTransform)(this.ctx);
                  if (Tl[1] === 0 && Tl[2] === 0)
                    this._cachedGetSinglePixelWidth = 1 / Math.min(Math.abs(Tl[0]), Math.abs(Tl[3]));
                  else {
                    const El = Math.abs(Tl[0] * Tl[3] - Tl[2] * Tl[1]), Il = Math.hypot(Tl[0], Tl[2]), Ul = Math.hypot(Tl[1], Tl[3]);
                    this._cachedGetSinglePixelWidth = Math.max(Il, Ul) / El;
                  }
                }
                return this._cachedGetSinglePixelWidth;
              }
              getScaleForStroking() {
                if (!this._cachedScaleForStroking) {
                  const {
                    lineWidth: Tl
                  } = this.current, El = (0, Zi.getCurrentTransform)(this.ctx);
                  let Il, Ul;
                  if (El[1] === 0 && El[2] === 0) {
                    const Kl = Math.abs(El[0]), Rl = Math.abs(El[3]);
                    if (Tl === 0)
                      Il = 1 / Kl, Ul = 1 / Rl;
                    else {
                      const uo = Kl * Tl, Is = Rl * Tl;
                      Il = uo < 1 ? 1 / uo : 1, Ul = Is < 1 ? 1 / Is : 1;
                    }
                  } else {
                    const Kl = Math.abs(El[0] * El[3] - El[2] * El[1]), Rl = Math.hypot(El[0], El[1]), uo = Math.hypot(El[2], El[3]);
                    if (Tl === 0)
                      Il = uo / Kl, Ul = Rl / Kl;
                    else {
                      const Is = Tl * Kl;
                      Il = uo > Is ? uo / Is : 1, Ul = Rl > Is ? Rl / Is : 1;
                    }
                  }
                  this._cachedScaleForStroking = [Il, Ul];
                }
                return this._cachedScaleForStroking;
              }
              rescaleAndStroke(Tl) {
                const {
                  ctx: El
                } = this, {
                  lineWidth: Il
                } = this.current, [Ul, Kl] = this.getScaleForStroking();
                if (El.lineWidth = Il || 1, Ul === 1 && Kl === 1) {
                  El.stroke();
                  return;
                }
                let Rl, uo, Is;
                Tl && (Rl = (0, Zi.getCurrentTransform)(El), uo = El.getLineDash().slice(), Is = El.lineDashOffset), El.scale(Ul, Kl);
                const Sl = Math.max(Ul, Kl);
                El.setLineDash(El.getLineDash().map((wl) => wl / Sl)), El.lineDashOffset /= Sl, El.stroke(), Tl && (El.setTransform(...Rl), El.setLineDash(uo), El.lineDashOffset = Is);
              }
              isContentVisible() {
                for (let Tl = this.markedContentStack.length - 1; Tl >= 0; Tl--)
                  if (!this.markedContentStack[Tl].visible)
                    return !1;
                return !0;
              }
            };
            Yl = new WeakSet(), uf = function() {
              for (; this.stateStack.length || this.inSMaskMode; )
                this.restore();
              this.ctx.restore(), this.transparentCanvas && (this.ctx = this.compositeCtx, this.ctx.save(), this.ctx.setTransform(1, 0, 0, 1, 0, 0), this.ctx.drawImage(this.transparentCanvas, 0, 0), this.ctx.restore(), this.transparentCanvas = null);
            };
            let Ll = tc;
            e.CanvasGraphics = Ll;
            for (const Nl in ta.OPS)
              Ll.prototype[Nl] !== void 0 && (Ll.prototype[ta.OPS[Nl]] = Ll.prototype[Nl]);
          },
          /* 13 */
          /***/
          (Bi, e, Ui) => {
            Object.defineProperty(e, "__esModule", {
              value: !0
            }), e.TilingPattern = e.PathType = void 0, e.getShadingPattern = no;
            var Zi = Ui(1), ta = Ui(8), na = Ui(3);
            const ia = {
              FILL: "Fill",
              STROKE: "Stroke",
              SHADING: "Shading"
            };
            e.PathType = ia;
            function aa(bs, Rs) {
              if (!Rs || na.isNodeJS)
                return;
              const js = Rs[2] - Rs[0], qs = Rs[3] - Rs[1], jo = new Path2D();
              jo.rect(Rs[0], Rs[1], js, qs), bs.clip(jo);
            }
            class da {
              constructor() {
                this.constructor === da && (0, Zi.unreachable)("Cannot initialize BaseShadingPattern.");
              }
              getPattern() {
                (0, Zi.unreachable)("Abstract method `getPattern` called.");
              }
            }
            class La extends da {
              constructor(Rs) {
                super(), this._type = Rs[1], this._bbox = Rs[2], this._colorStops = Rs[3], this._p0 = Rs[4], this._p1 = Rs[5], this._r0 = Rs[6], this._r1 = Rs[7], this.matrix = null;
              }
              _createGradient(Rs) {
                let js;
                this._type === "axial" ? js = Rs.createLinearGradient(this._p0[0], this._p0[1], this._p1[0], this._p1[1]) : this._type === "radial" && (js = Rs.createRadialGradient(this._p0[0], this._p0[1], this._r0, this._p1[0], this._p1[1], this._r1));
                for (const qs of this._colorStops)
                  js.addColorStop(qs[0], qs[1]);
                return js;
              }
              getPattern(Rs, js, qs, jo) {
                let fs;
                if (jo === ia.STROKE || jo === ia.FILL) {
                  const Ao = js.current.getClippedPathBoundingBox(jo, (0, ta.getCurrentTransform)(Rs)) || [0, 0, 0, 0], co = Math.ceil(Ao[2] - Ao[0]) || 1, Co = Math.ceil(Ao[3] - Ao[1]) || 1, Zs = js.cachedCanvases.getCanvas("pattern", co, Co, !0), xl = Zs.context;
                  xl.clearRect(0, 0, xl.canvas.width, xl.canvas.height), xl.beginPath(), xl.rect(0, 0, xl.canvas.width, xl.canvas.height), xl.translate(-Ao[0], -Ao[1]), qs = Zi.Util.transform(qs, [1, 0, 0, 1, Ao[0], Ao[1]]), xl.transform(...js.baseTransform), this.matrix && xl.transform(...this.matrix), aa(xl, this._bbox), xl.fillStyle = this._createGradient(xl), xl.fill(), fs = Rs.createPattern(Zs.canvas, "no-repeat");
                  const Cl = new DOMMatrix(qs);
                  try {
                    fs.setTransform(Cl);
                  } catch (Al) {
                    (0, Zi.warn)(`RadialAxialShadingPattern.getPattern: "${Al?.message}".`);
                  }
                } else
                  aa(Rs, this._bbox), fs = this._createGradient(Rs);
                return fs;
              }
            }
            function qa(bs, Rs, js, qs, jo, fs, Ao, co) {
              const Co = Rs.coords, Zs = Rs.colors, xl = bs.data, Cl = bs.width * 4;
              let Al;
              Co[js + 1] > Co[qs + 1] && (Al = js, js = qs, qs = Al, Al = fs, fs = Ao, Ao = Al), Co[qs + 1] > Co[jo + 1] && (Al = qs, qs = jo, jo = Al, Al = Ao, Ao = co, co = Al), Co[js + 1] > Co[qs + 1] && (Al = js, js = qs, qs = Al, Al = fs, fs = Ao, Ao = Al);
              const Ol = (Co[js] + Rs.offsetX) * Rs.scaleX, Bl = (Co[js + 1] + Rs.offsetY) * Rs.scaleY, Ml = (Co[qs] + Rs.offsetX) * Rs.scaleX, Vl = (Co[qs + 1] + Rs.offsetY) * Rs.scaleY, Ll = (Co[jo] + Rs.offsetX) * Rs.scaleX, Yl = (Co[jo + 1] + Rs.offsetY) * Rs.scaleY;
              if (Bl >= Yl)
                return;
              const Zl = Zs[fs], tc = Zs[fs + 1], Nl = Zs[fs + 2], Tl = Zs[Ao], El = Zs[Ao + 1], Il = Zs[Ao + 2], Ul = Zs[co], Kl = Zs[co + 1], Rl = Zs[co + 2], uo = Math.round(Bl), Is = Math.round(Yl);
              let Sl, wl, Pl, jl, Dl, $l, kl, zl;
              for (let Hl = uo; Hl <= Is; Hl++) {
                if (Hl < Vl) {
                  let Xl;
                  Hl < Bl ? Xl = 0 : Xl = (Bl - Hl) / (Bl - Vl), Sl = Ol - (Ol - Ml) * Xl, wl = Zl - (Zl - Tl) * Xl, Pl = tc - (tc - El) * Xl, jl = Nl - (Nl - Il) * Xl;
                } else {
                  let Xl;
                  Hl > Yl ? Xl = 1 : Vl === Yl ? Xl = 0 : Xl = (Vl - Hl) / (Vl - Yl), Sl = Ml - (Ml - Ll) * Xl, wl = Tl - (Tl - Ul) * Xl, Pl = El - (El - Kl) * Xl, jl = Il - (Il - Rl) * Xl;
                }
                let Wl;
                Hl < Bl ? Wl = 0 : Hl > Yl ? Wl = 1 : Wl = (Bl - Hl) / (Bl - Yl), Dl = Ol - (Ol - Ll) * Wl, $l = Zl - (Zl - Ul) * Wl, kl = tc - (tc - Kl) * Wl, zl = Nl - (Nl - Rl) * Wl;
                const ql = Math.round(Math.min(Sl, Dl)), Jl = Math.round(Math.max(Sl, Dl));
                let ac = Cl * Hl + ql * 4;
                for (let Xl = ql; Xl <= Jl; Xl++)
                  Wl = (Sl - Xl) / (Sl - Dl), Wl < 0 ? Wl = 0 : Wl > 1 && (Wl = 1), xl[ac++] = wl - (wl - $l) * Wl | 0, xl[ac++] = Pl - (Pl - kl) * Wl | 0, xl[ac++] = jl - (jl - zl) * Wl | 0, xl[ac++] = 255;
              }
            }
            function io(bs, Rs, js) {
              const qs = Rs.coords, jo = Rs.colors;
              let fs, Ao;
              switch (Rs.type) {
                case "lattice":
                  const co = Rs.verticesPerRow, Co = Math.floor(qs.length / co) - 1, Zs = co - 1;
                  for (fs = 0; fs < Co; fs++) {
                    let xl = fs * co;
                    for (let Cl = 0; Cl < Zs; Cl++, xl++)
                      qa(bs, js, qs[xl], qs[xl + 1], qs[xl + co], jo[xl], jo[xl + 1], jo[xl + co]), qa(bs, js, qs[xl + co + 1], qs[xl + 1], qs[xl + co], jo[xl + co + 1], jo[xl + 1], jo[xl + co]);
                  }
                  break;
                case "triangles":
                  for (fs = 0, Ao = qs.length; fs < Ao; fs += 3)
                    qa(bs, js, qs[fs], qs[fs + 1], qs[fs + 2], jo[fs], jo[fs + 1], jo[fs + 2]);
                  break;
                default:
                  throw new Error("illegal figure");
              }
            }
            class ao extends da {
              constructor(Rs) {
                super(), this._coords = Rs[2], this._colors = Rs[3], this._figures = Rs[4], this._bounds = Rs[5], this._bbox = Rs[7], this._background = Rs[8], this.matrix = null;
              }
              _createMeshCanvas(Rs, js, qs) {
                const co = Math.floor(this._bounds[0]), Co = Math.floor(this._bounds[1]), Zs = Math.ceil(this._bounds[2]) - co, xl = Math.ceil(this._bounds[3]) - Co, Cl = Math.min(Math.ceil(Math.abs(Zs * Rs[0] * 1.1)), 3e3), Al = Math.min(Math.ceil(Math.abs(xl * Rs[1] * 1.1)), 3e3), Ol = Zs / Cl, Bl = xl / Al, Ml = {
                  coords: this._coords,
                  colors: this._colors,
                  offsetX: -co,
                  offsetY: -Co,
                  scaleX: 1 / Ol,
                  scaleY: 1 / Bl
                }, Vl = Cl + 4, Ll = Al + 4, Yl = qs.getCanvas("mesh", Vl, Ll, !1), Zl = Yl.context, tc = Zl.createImageData(Cl, Al);
                if (js) {
                  const Tl = tc.data;
                  for (let El = 0, Il = Tl.length; El < Il; El += 4)
                    Tl[El] = js[0], Tl[El + 1] = js[1], Tl[El + 2] = js[2], Tl[El + 3] = 255;
                }
                for (const Tl of this._figures)
                  io(tc, Tl, Ml);
                return Zl.putImageData(tc, 2, 2), {
                  canvas: Yl.canvas,
                  offsetX: co - 2 * Ol,
                  offsetY: Co - 2 * Bl,
                  scaleX: Ol,
                  scaleY: Bl
                };
              }
              getPattern(Rs, js, qs, jo) {
                aa(Rs, this._bbox);
                let fs;
                if (jo === ia.SHADING)
                  fs = Zi.Util.singularValueDecompose2dScale((0, ta.getCurrentTransform)(Rs));
                else if (fs = Zi.Util.singularValueDecompose2dScale(js.baseTransform), this.matrix) {
                  const co = Zi.Util.singularValueDecompose2dScale(this.matrix);
                  fs = [fs[0] * co[0], fs[1] * co[1]];
                }
                const Ao = this._createMeshCanvas(fs, jo === ia.SHADING ? null : this._background, js.cachedCanvases);
                return jo !== ia.SHADING && (Rs.setTransform(...js.baseTransform), this.matrix && Rs.transform(...this.matrix)), Rs.translate(Ao.offsetX, Ao.offsetY), Rs.scale(Ao.scaleX, Ao.scaleY), Rs.createPattern(Ao.canvas, "no-repeat");
              }
            }
            class oo extends da {
              getPattern() {
                return "hotpink";
              }
            }
            function no(bs) {
              switch (bs[0]) {
                case "RadialAxial":
                  return new La(bs);
                case "Mesh":
                  return new ao(bs);
                case "Dummy":
                  return new oo();
              }
              throw new Error(`Unknown IR type: ${bs[0]}`);
            }
            const lo = {
              COLORED: 1,
              UNCOLORED: 2
            };
            class so {
              static get MAX_PATTERN_SIZE() {
                return (0, Zi.shadow)(this, "MAX_PATTERN_SIZE", 3e3);
              }
              constructor(Rs, js, qs, jo, fs) {
                this.operatorList = Rs[2], this.matrix = Rs[3] || [1, 0, 0, 1, 0, 0], this.bbox = Rs[4], this.xstep = Rs[5], this.ystep = Rs[6], this.paintType = Rs[7], this.tilingType = Rs[8], this.color = js, this.ctx = qs, this.canvasGraphicsFactory = jo, this.baseTransform = fs;
              }
              createPatternCanvas(Rs) {
                const js = this.operatorList, qs = this.bbox, jo = this.xstep, fs = this.ystep, Ao = this.paintType, co = this.tilingType, Co = this.color, Zs = this.canvasGraphicsFactory;
                (0, Zi.info)("TilingType: " + co);
                const xl = qs[0], Cl = qs[1], Al = qs[2], Ol = qs[3], Bl = Zi.Util.singularValueDecompose2dScale(this.matrix), Ml = Zi.Util.singularValueDecompose2dScale(this.baseTransform), Vl = [Bl[0] * Ml[0], Bl[1] * Ml[1]], Ll = this.getSizeAndScale(jo, this.ctx.canvas.width, Vl[0]), Yl = this.getSizeAndScale(fs, this.ctx.canvas.height, Vl[1]), Zl = Rs.cachedCanvases.getCanvas("pattern", Ll.size, Yl.size, !0), tc = Zl.context, Nl = Zs.createCanvasGraphics(tc);
                Nl.groupLevel = Rs.groupLevel, this.setFillAndStrokeStyleToContext(Nl, Ao, Co);
                let Tl = xl, El = Cl, Il = Al, Ul = Ol;
                return xl < 0 && (Tl = 0, Il += Math.abs(xl)), Cl < 0 && (El = 0, Ul += Math.abs(Cl)), tc.translate(-(Ll.scale * Tl), -(Yl.scale * El)), Nl.transform(Ll.scale, 0, 0, Yl.scale, 0, 0), tc.save(), this.clipBbox(Nl, Tl, El, Il, Ul), Nl.baseTransform = (0, ta.getCurrentTransform)(Nl.ctx), Nl.executeOperatorList(js), Nl.endDrawing(), {
                  canvas: Zl.canvas,
                  scaleX: Ll.scale,
                  scaleY: Yl.scale,
                  offsetX: Tl,
                  offsetY: El
                };
              }
              getSizeAndScale(Rs, js, qs) {
                Rs = Math.abs(Rs);
                const jo = Math.max(so.MAX_PATTERN_SIZE, js);
                let fs = Math.ceil(Rs * qs);
                return fs >= jo ? fs = jo : qs = fs / Rs, {
                  scale: qs,
                  size: fs
                };
              }
              clipBbox(Rs, js, qs, jo, fs) {
                const Ao = jo - js, co = fs - qs;
                Rs.ctx.rect(js, qs, Ao, co), Rs.current.updateRectMinMax((0, ta.getCurrentTransform)(Rs.ctx), [js, qs, jo, fs]), Rs.clip(), Rs.endPath();
              }
              setFillAndStrokeStyleToContext(Rs, js, qs) {
                const jo = Rs.ctx, fs = Rs.current;
                switch (js) {
                  case lo.COLORED:
                    const Ao = this.ctx;
                    jo.fillStyle = Ao.fillStyle, jo.strokeStyle = Ao.strokeStyle, fs.fillColor = Ao.fillStyle, fs.strokeColor = Ao.strokeStyle;
                    break;
                  case lo.UNCOLORED:
                    const co = Zi.Util.makeHexColor(qs[0], qs[1], qs[2]);
                    jo.fillStyle = co, jo.strokeStyle = co, fs.fillColor = co, fs.strokeColor = co;
                    break;
                  default:
                    throw new Zi.FormatError(`Unsupported paint type: ${js}`);
                }
              }
              getPattern(Rs, js, qs, jo) {
                let fs = qs;
                jo !== ia.SHADING && (fs = Zi.Util.transform(fs, js.baseTransform), this.matrix && (fs = Zi.Util.transform(fs, this.matrix)));
                const Ao = this.createPatternCanvas(js);
                let co = new DOMMatrix(fs);
                co = co.translate(Ao.offsetX, Ao.offsetY), co = co.scale(1 / Ao.scaleX, 1 / Ao.scaleY);
                const Co = Rs.createPattern(Ao.canvas, "repeat");
                try {
                  Co.setTransform(co);
                } catch (Zs) {
                  (0, Zi.warn)(`TilingPattern.getPattern: "${Zs?.message}".`);
                }
                return Co;
              }
            }
            e.TilingPattern = so;
          },
          /* 14 */
          /***/
          (Bi, e, Ui) => {
            Object.defineProperty(e, "__esModule", {
              value: !0
            }), e.applyMaskImageData = ta;
            var Zi = Ui(1);
            function ta({
              src: na,
              srcPos: ia = 0,
              dest: aa,
              destPos: da = 0,
              width: La,
              height: qa,
              inverseDecode: io = !1
            }) {
              const ao = Zi.FeatureTest.isLittleEndian ? 4278190080 : 255, [oo, no] = io ? [0, ao] : [ao, 0], lo = La >> 3, so = La & 7, bs = na.length;
              aa = new Uint32Array(aa.buffer);
              for (let Rs = 0; Rs < qa; Rs++) {
                for (const qs = ia + lo; ia < qs; ia++) {
                  const jo = ia < bs ? na[ia] : 255;
                  aa[da++] = jo & 128 ? no : oo, aa[da++] = jo & 64 ? no : oo, aa[da++] = jo & 32 ? no : oo, aa[da++] = jo & 16 ? no : oo, aa[da++] = jo & 8 ? no : oo, aa[da++] = jo & 4 ? no : oo, aa[da++] = jo & 2 ? no : oo, aa[da++] = jo & 1 ? no : oo;
                }
                if (so === 0)
                  continue;
                const js = ia < bs ? na[ia++] : 255;
                for (let qs = 0; qs < so; qs++)
                  aa[da++] = js & 1 << 7 - qs ? no : oo;
              }
              return {
                srcPos: ia,
                destPos: da
              };
            }
          },
          /* 15 */
          /***/
          (Bi, e) => {
            Object.defineProperty(e, "__esModule", {
              value: !0
            }), e.GlobalWorkerOptions = void 0;
            const Ui = /* @__PURE__ */ Object.create(null);
            e.GlobalWorkerOptions = Ui, Ui.workerPort = Ui.workerPort === void 0 ? null : Ui.workerPort, Ui.workerSrc = Ui.workerSrc === void 0 ? "" : Ui.workerSrc;
          },
          /* 16 */
          /***/
          (Bi, e, Ui) => {
            Object.defineProperty(e, "__esModule", {
              value: !0
            }), e.MessageHandler = void 0;
            var Zi = Ui(1);
            const ta = {
              DATA: 1,
              ERROR: 2
            }, na = {
              CANCEL: 1,
              CANCEL_COMPLETE: 2,
              CLOSE: 3,
              ENQUEUE: 4,
              ERROR: 5,
              PULL: 6,
              PULL_COMPLETE: 7,
              START_COMPLETE: 8
            };
            function ia(da) {
              switch (da instanceof Error || typeof da == "object" && da !== null || (0, Zi.unreachable)('wrapReason: Expected "reason" to be a (possibly cloned) Error.'), da.name) {
                case "AbortException":
                  return new Zi.AbortException(da.message);
                case "MissingPDFException":
                  return new Zi.MissingPDFException(da.message);
                case "PasswordException":
                  return new Zi.PasswordException(da.message, da.code);
                case "UnexpectedResponseException":
                  return new Zi.UnexpectedResponseException(da.message, da.status);
                case "UnknownErrorException":
                  return new Zi.UnknownErrorException(da.message, da.details);
                default:
                  return new Zi.UnknownErrorException(da.message, da.toString());
              }
            }
            class aa {
              constructor(La, qa, io) {
                this.sourceName = La, this.targetName = qa, this.comObj = io, this.callbackId = 1, this.streamId = 1, this.streamSinks = /* @__PURE__ */ Object.create(null), this.streamControllers = /* @__PURE__ */ Object.create(null), this.callbackCapabilities = /* @__PURE__ */ Object.create(null), this.actionHandler = /* @__PURE__ */ Object.create(null), this._onComObjOnMessage = (ao) => {
                  const oo = ao.data;
                  if (oo.targetName !== this.sourceName)
                    return;
                  if (oo.stream) {
                    this._processStreamMessage(oo);
                    return;
                  }
                  if (oo.callback) {
                    const lo = oo.callbackId, so = this.callbackCapabilities[lo];
                    if (!so)
                      throw new Error(`Cannot resolve callback ${lo}`);
                    if (delete this.callbackCapabilities[lo], oo.callback === ta.DATA)
                      so.resolve(oo.data);
                    else if (oo.callback === ta.ERROR)
                      so.reject(ia(oo.reason));
                    else
                      throw new Error("Unexpected callback case");
                    return;
                  }
                  const no = this.actionHandler[oo.action];
                  if (!no)
                    throw new Error(`Unknown action from worker: ${oo.action}`);
                  if (oo.callbackId) {
                    const lo = this.sourceName, so = oo.sourceName;
                    new Promise(function(bs) {
                      bs(no(oo.data));
                    }).then(function(bs) {
                      io.postMessage({
                        sourceName: lo,
                        targetName: so,
                        callback: ta.DATA,
                        callbackId: oo.callbackId,
                        data: bs
                      });
                    }, function(bs) {
                      io.postMessage({
                        sourceName: lo,
                        targetName: so,
                        callback: ta.ERROR,
                        callbackId: oo.callbackId,
                        reason: ia(bs)
                      });
                    });
                    return;
                  }
                  if (oo.streamId) {
                    this._createStreamSink(oo);
                    return;
                  }
                  no(oo.data);
                }, io.addEventListener("message", this._onComObjOnMessage);
              }
              on(La, qa) {
                const io = this.actionHandler;
                if (io[La])
                  throw new Error(`There is already an actionName called "${La}"`);
                io[La] = qa;
              }
              send(La, qa, io) {
                this.comObj.postMessage({
                  sourceName: this.sourceName,
                  targetName: this.targetName,
                  action: La,
                  data: qa
                }, io);
              }
              sendWithPromise(La, qa, io) {
                const ao = this.callbackId++, oo = (0, Zi.createPromiseCapability)();
                this.callbackCapabilities[ao] = oo;
                try {
                  this.comObj.postMessage({
                    sourceName: this.sourceName,
                    targetName: this.targetName,
                    action: La,
                    callbackId: ao,
                    data: qa
                  }, io);
                } catch (no) {
                  oo.reject(no);
                }
                return oo.promise;
              }
              sendWithStream(La, qa, io, ao) {
                const oo = this.streamId++, no = this.sourceName, lo = this.targetName, so = this.comObj;
                return new ReadableStream({
                  start: (bs) => {
                    const Rs = (0, Zi.createPromiseCapability)();
                    return this.streamControllers[oo] = {
                      controller: bs,
                      startCall: Rs,
                      pullCall: null,
                      cancelCall: null,
                      isClosed: !1
                    }, so.postMessage({
                      sourceName: no,
                      targetName: lo,
                      action: La,
                      streamId: oo,
                      data: qa,
                      desiredSize: bs.desiredSize
                    }, ao), Rs.promise;
                  },
                  pull: (bs) => {
                    const Rs = (0, Zi.createPromiseCapability)();
                    return this.streamControllers[oo].pullCall = Rs, so.postMessage({
                      sourceName: no,
                      targetName: lo,
                      stream: na.PULL,
                      streamId: oo,
                      desiredSize: bs.desiredSize
                    }), Rs.promise;
                  },
                  cancel: (bs) => {
                    (0, Zi.assert)(bs instanceof Error, "cancel must have a valid reason");
                    const Rs = (0, Zi.createPromiseCapability)();
                    return this.streamControllers[oo].cancelCall = Rs, this.streamControllers[oo].isClosed = !0, so.postMessage({
                      sourceName: no,
                      targetName: lo,
                      stream: na.CANCEL,
                      streamId: oo,
                      reason: ia(bs)
                    }), Rs.promise;
                  }
                }, io);
              }
              _createStreamSink(La) {
                const qa = La.streamId, io = this.sourceName, ao = La.sourceName, oo = this.comObj, no = this, lo = this.actionHandler[La.action], so = {
                  enqueue(bs, Rs = 1, js) {
                    if (this.isCancelled)
                      return;
                    const qs = this.desiredSize;
                    this.desiredSize -= Rs, qs > 0 && this.desiredSize <= 0 && (this.sinkCapability = (0, Zi.createPromiseCapability)(), this.ready = this.sinkCapability.promise), oo.postMessage({
                      sourceName: io,
                      targetName: ao,
                      stream: na.ENQUEUE,
                      streamId: qa,
                      chunk: bs
                    }, js);
                  },
                  close() {
                    this.isCancelled || (this.isCancelled = !0, oo.postMessage({
                      sourceName: io,
                      targetName: ao,
                      stream: na.CLOSE,
                      streamId: qa
                    }), delete no.streamSinks[qa]);
                  },
                  error(bs) {
                    (0, Zi.assert)(bs instanceof Error, "error must have a valid reason"), !this.isCancelled && (this.isCancelled = !0, oo.postMessage({
                      sourceName: io,
                      targetName: ao,
                      stream: na.ERROR,
                      streamId: qa,
                      reason: ia(bs)
                    }));
                  },
                  sinkCapability: (0, Zi.createPromiseCapability)(),
                  onPull: null,
                  onCancel: null,
                  isCancelled: !1,
                  desiredSize: La.desiredSize,
                  ready: null
                };
                so.sinkCapability.resolve(), so.ready = so.sinkCapability.promise, this.streamSinks[qa] = so, new Promise(function(bs) {
                  bs(lo(La.data, so));
                }).then(function() {
                  oo.postMessage({
                    sourceName: io,
                    targetName: ao,
                    stream: na.START_COMPLETE,
                    streamId: qa,
                    success: !0
                  });
                }, function(bs) {
                  oo.postMessage({
                    sourceName: io,
                    targetName: ao,
                    stream: na.START_COMPLETE,
                    streamId: qa,
                    reason: ia(bs)
                  });
                });
              }
              _processStreamMessage(La) {
                const qa = La.streamId, io = this.sourceName, ao = La.sourceName, oo = this.comObj, no = this.streamControllers[qa], lo = this.streamSinks[qa];
                switch (La.stream) {
                  case na.START_COMPLETE:
                    La.success ? no.startCall.resolve() : no.startCall.reject(ia(La.reason));
                    break;
                  case na.PULL_COMPLETE:
                    La.success ? no.pullCall.resolve() : no.pullCall.reject(ia(La.reason));
                    break;
                  case na.PULL:
                    if (!lo) {
                      oo.postMessage({
                        sourceName: io,
                        targetName: ao,
                        stream: na.PULL_COMPLETE,
                        streamId: qa,
                        success: !0
                      });
                      break;
                    }
                    lo.desiredSize <= 0 && La.desiredSize > 0 && lo.sinkCapability.resolve(), lo.desiredSize = La.desiredSize, new Promise(function(so) {
                      so(lo.onPull && lo.onPull());
                    }).then(function() {
                      oo.postMessage({
                        sourceName: io,
                        targetName: ao,
                        stream: na.PULL_COMPLETE,
                        streamId: qa,
                        success: !0
                      });
                    }, function(so) {
                      oo.postMessage({
                        sourceName: io,
                        targetName: ao,
                        stream: na.PULL_COMPLETE,
                        streamId: qa,
                        reason: ia(so)
                      });
                    });
                    break;
                  case na.ENQUEUE:
                    if ((0, Zi.assert)(no, "enqueue should have stream controller"), no.isClosed)
                      break;
                    no.controller.enqueue(La.chunk);
                    break;
                  case na.CLOSE:
                    if ((0, Zi.assert)(no, "close should have stream controller"), no.isClosed)
                      break;
                    no.isClosed = !0, no.controller.close(), this._deleteStreamController(no, qa);
                    break;
                  case na.ERROR:
                    (0, Zi.assert)(no, "error should have stream controller"), no.controller.error(ia(La.reason)), this._deleteStreamController(no, qa);
                    break;
                  case na.CANCEL_COMPLETE:
                    La.success ? no.cancelCall.resolve() : no.cancelCall.reject(ia(La.reason)), this._deleteStreamController(no, qa);
                    break;
                  case na.CANCEL:
                    if (!lo)
                      break;
                    new Promise(function(so) {
                      so(lo.onCancel && lo.onCancel(ia(La.reason)));
                    }).then(function() {
                      oo.postMessage({
                        sourceName: io,
                        targetName: ao,
                        stream: na.CANCEL_COMPLETE,
                        streamId: qa,
                        success: !0
                      });
                    }, function(so) {
                      oo.postMessage({
                        sourceName: io,
                        targetName: ao,
                        stream: na.CANCEL_COMPLETE,
                        streamId: qa,
                        reason: ia(so)
                      });
                    }), lo.sinkCapability.reject(ia(La.reason)), lo.isCancelled = !0, delete this.streamSinks[qa];
                    break;
                  default:
                    throw new Error("Unexpected stream case");
                }
              }
              async _deleteStreamController(La, qa) {
                await Promise.allSettled([La.startCall && La.startCall.promise, La.pullCall && La.pullCall.promise, La.cancelCall && La.cancelCall.promise]), delete this.streamControllers[qa];
              }
              destroy() {
                this.comObj.removeEventListener("message", this._onComObjOnMessage);
              }
            }
            e.MessageHandler = aa;
          },
          /* 17 */
          /***/
          (Bi, e, Ui) => {
            var na, ia;
            Object.defineProperty(e, "__esModule", {
              value: !0
            }), e.Metadata = void 0;
            var Zi = Ui(1);
            class ta {
              constructor({
                parsedData: da,
                rawData: La
              }) {
                fc(this, na);
                fc(this, ia);
                lu(this, na, da), lu(this, ia, La);
              }
              getRaw() {
                return Gl(this, ia);
              }
              get(da) {
                return Gl(this, na).get(da) ?? null;
              }
              getAll() {
                return (0, Zi.objectFromMap)(Gl(this, na));
              }
              has(da) {
                return Gl(this, na).has(da);
              }
            }
            na = new WeakMap(), ia = new WeakMap(), e.Metadata = ta;
          },
          /* 18 */
          /***/
          (Bi, e, Ui) => {
            var aa, da, La, qa, io, ao, df;
            Object.defineProperty(e, "__esModule", {
              value: !0
            }), e.OptionalContentConfig = void 0;
            var Zi = Ui(1);
            const ta = Symbol("INTERNAL");
            class na {
              constructor(lo, so) {
                fc(this, aa, !0);
                this.name = lo, this.intent = so;
              }
              get visible() {
                return Gl(this, aa);
              }
              _setVisible(lo, so) {
                lo !== ta && (0, Zi.unreachable)("Internal method `_setVisible` called."), lu(this, aa, so);
              }
            }
            aa = new WeakMap();
            class ia {
              constructor(lo) {
                fc(this, ao);
                fc(this, da, !0);
                fc(this, La, /* @__PURE__ */ new Map());
                fc(this, qa, null);
                fc(this, io, null);
                if (this.name = null, this.creator = null, lo !== null) {
                  this.name = lo.name, this.creator = lo.creator, lu(this, io, lo.order);
                  for (const so of lo.groups)
                    Gl(this, La).set(so.id, new na(so.name, so.intent));
                  if (lo.baseState === "OFF")
                    for (const so of Gl(this, La).values())
                      so._setVisible(ta, !1);
                  for (const so of lo.on)
                    Gl(this, La).get(so)._setVisible(ta, !0);
                  for (const so of lo.off)
                    Gl(this, La).get(so)._setVisible(ta, !1);
                  lu(this, qa, /* @__PURE__ */ new Map());
                  for (const [so, bs] of Gl(this, La))
                    Gl(this, qa).set(so, bs.visible);
                }
              }
              isVisible(lo) {
                if (Gl(this, La).size === 0)
                  return !0;
                if (!lo)
                  return (0, Zi.warn)("Optional content group not defined."), !0;
                if (lo.type === "OCG")
                  return Gl(this, La).has(lo.id) ? Gl(this, La).get(lo.id).visible : ((0, Zi.warn)(`Optional content group not found: ${lo.id}`), !0);
                if (lo.type === "OCMD") {
                  if (lo.expression)
                    return lc(this, ao, df).call(this, lo.expression);
                  if (!lo.policy || lo.policy === "AnyOn") {
                    for (const so of lo.ids) {
                      if (!Gl(this, La).has(so))
                        return (0, Zi.warn)(`Optional content group not found: ${so}`), !0;
                      if (Gl(this, La).get(so).visible)
                        return !0;
                    }
                    return !1;
                  } else if (lo.policy === "AllOn") {
                    for (const so of lo.ids) {
                      if (!Gl(this, La).has(so))
                        return (0, Zi.warn)(`Optional content group not found: ${so}`), !0;
                      if (!Gl(this, La).get(so).visible)
                        return !1;
                    }
                    return !0;
                  } else if (lo.policy === "AnyOff") {
                    for (const so of lo.ids) {
                      if (!Gl(this, La).has(so))
                        return (0, Zi.warn)(`Optional content group not found: ${so}`), !0;
                      if (!Gl(this, La).get(so).visible)
                        return !0;
                    }
                    return !1;
                  } else if (lo.policy === "AllOff") {
                    for (const so of lo.ids) {
                      if (!Gl(this, La).has(so))
                        return (0, Zi.warn)(`Optional content group not found: ${so}`), !0;
                      if (Gl(this, La).get(so).visible)
                        return !1;
                    }
                    return !0;
                  }
                  return (0, Zi.warn)(`Unknown optional content policy ${lo.policy}.`), !0;
                }
                return (0, Zi.warn)(`Unknown group type ${lo.type}.`), !0;
              }
              setVisibility(lo, so = !0) {
                if (!Gl(this, La).has(lo)) {
                  (0, Zi.warn)(`Optional content group not found: ${lo}`);
                  return;
                }
                Gl(this, La).get(lo)._setVisible(ta, !!so), lu(this, da, null);
              }
              get hasInitialVisibility() {
                if (Gl(this, da) !== null)
                  return Gl(this, da);
                for (const [lo, so] of Gl(this, La)) {
                  const bs = Gl(this, qa).get(lo);
                  if (so.visible !== bs)
                    return lu(this, da, !1);
                }
                return lu(this, da, !0);
              }
              getOrder() {
                return Gl(this, La).size ? Gl(this, io) ? Gl(this, io).slice() : [...Gl(this, La).keys()] : null;
              }
              getGroups() {
                return Gl(this, La).size > 0 ? (0, Zi.objectFromMap)(Gl(this, La)) : null;
              }
              getGroup(lo) {
                return Gl(this, La).get(lo) || null;
              }
            }
            da = new WeakMap(), La = new WeakMap(), qa = new WeakMap(), io = new WeakMap(), ao = new WeakSet(), df = function(lo) {
              const so = lo.length;
              if (so < 2)
                return !0;
              const bs = lo[0];
              for (let Rs = 1; Rs < so; Rs++) {
                const js = lo[Rs];
                let qs;
                if (Array.isArray(js))
                  qs = lc(this, ao, df).call(this, js);
                else if (Gl(this, La).has(js))
                  qs = Gl(this, La).get(js).visible;
                else
                  return (0, Zi.warn)(`Optional content group not found: ${js}`), !0;
                switch (bs) {
                  case "And":
                    if (!qs)
                      return !1;
                    break;
                  case "Or":
                    if (qs)
                      return !0;
                    break;
                  case "Not":
                    return !qs;
                  default:
                    return !0;
                }
              }
              return bs === "And";
            }, e.OptionalContentConfig = ia;
          },
          /* 19 */
          /***/
          (Bi, e, Ui) => {
            Object.defineProperty(e, "__esModule", {
              value: !0
            }), e.PDFDataTransportStream = void 0;
            var Zi = Ui(1), ta = Ui(8);
            class na {
              constructor(La, qa) {
                (0, Zi.assert)(qa, 'PDFDataTransportStream - missing required "pdfDataRangeTransport" argument.'), this._queuedChunks = [], this._progressiveDone = La.progressiveDone || !1, this._contentDispositionFilename = La.contentDispositionFilename || null;
                const io = La.initialData;
                if (io?.length > 0) {
                  const ao = new Uint8Array(io).buffer;
                  this._queuedChunks.push(ao);
                }
                this._pdfDataRangeTransport = qa, this._isStreamingSupported = !La.disableStream, this._isRangeSupported = !La.disableRange, this._contentLength = La.length, this._fullRequestReader = null, this._rangeReaders = [], this._pdfDataRangeTransport.addRangeListener((ao, oo) => {
                  this._onReceiveData({
                    begin: ao,
                    chunk: oo
                  });
                }), this._pdfDataRangeTransport.addProgressListener((ao, oo) => {
                  this._onProgress({
                    loaded: ao,
                    total: oo
                  });
                }), this._pdfDataRangeTransport.addProgressiveReadListener((ao) => {
                  this._onReceiveData({
                    chunk: ao
                  });
                }), this._pdfDataRangeTransport.addProgressiveDoneListener(() => {
                  this._onProgressiveDone();
                }), this._pdfDataRangeTransport.transportReady();
              }
              _onReceiveData(La) {
                const qa = new Uint8Array(La.chunk).buffer;
                if (La.begin === void 0)
                  this._fullRequestReader ? this._fullRequestReader._enqueue(qa) : this._queuedChunks.push(qa);
                else {
                  const io = this._rangeReaders.some(function(ao) {
                    return ao._begin !== La.begin ? !1 : (ao._enqueue(qa), !0);
                  });
                  (0, Zi.assert)(io, "_onReceiveData - no `PDFDataTransportStreamRangeReader` instance found.");
                }
              }
              get _progressiveDataLength() {
                return this._fullRequestReader?._loaded ?? 0;
              }
              _onProgress(La) {
                if (La.total === void 0) {
                  const qa = this._rangeReaders[0];
                  qa?.onProgress && qa.onProgress({
                    loaded: La.loaded
                  });
                } else {
                  const qa = this._fullRequestReader;
                  qa?.onProgress && qa.onProgress({
                    loaded: La.loaded,
                    total: La.total
                  });
                }
              }
              _onProgressiveDone() {
                this._fullRequestReader && this._fullRequestReader.progressiveDone(), this._progressiveDone = !0;
              }
              _removeRangeReader(La) {
                const qa = this._rangeReaders.indexOf(La);
                qa >= 0 && this._rangeReaders.splice(qa, 1);
              }
              getFullReader() {
                (0, Zi.assert)(!this._fullRequestReader, "PDFDataTransportStream.getFullReader can only be called once.");
                const La = this._queuedChunks;
                return this._queuedChunks = null, new ia(this, La, this._progressiveDone, this._contentDispositionFilename);
              }
              getRangeReader(La, qa) {
                if (qa <= this._progressiveDataLength)
                  return null;
                const io = new aa(this, La, qa);
                return this._pdfDataRangeTransport.requestDataRange(La, qa), this._rangeReaders.push(io), io;
              }
              cancelAllRequests(La) {
                this._fullRequestReader && this._fullRequestReader.cancel(La);
                for (const qa of this._rangeReaders.slice(0))
                  qa.cancel(La);
                this._pdfDataRangeTransport.abort();
              }
            }
            e.PDFDataTransportStream = na;
            class ia {
              constructor(La, qa, io = !1, ao = null) {
                this._stream = La, this._done = io || !1, this._filename = (0, ta.isPdfFile)(ao) ? ao : null, this._queuedChunks = qa || [], this._loaded = 0;
                for (const oo of this._queuedChunks)
                  this._loaded += oo.byteLength;
                this._requests = [], this._headersReady = Promise.resolve(), La._fullRequestReader = this, this.onProgress = null;
              }
              _enqueue(La) {
                this._done || (this._requests.length > 0 ? this._requests.shift().resolve({
                  value: La,
                  done: !1
                }) : this._queuedChunks.push(La), this._loaded += La.byteLength);
              }
              get headersReady() {
                return this._headersReady;
              }
              get filename() {
                return this._filename;
              }
              get isRangeSupported() {
                return this._stream._isRangeSupported;
              }
              get isStreamingSupported() {
                return this._stream._isStreamingSupported;
              }
              get contentLength() {
                return this._stream._contentLength;
              }
              async read() {
                if (this._queuedChunks.length > 0)
                  return {
                    value: this._queuedChunks.shift(),
                    done: !1
                  };
                if (this._done)
                  return {
                    value: void 0,
                    done: !0
                  };
                const La = (0, Zi.createPromiseCapability)();
                return this._requests.push(La), La.promise;
              }
              cancel(La) {
                this._done = !0;
                for (const qa of this._requests)
                  qa.resolve({
                    value: void 0,
                    done: !0
                  });
                this._requests.length = 0;
              }
              progressiveDone() {
                this._done || (this._done = !0);
              }
            }
            class aa {
              constructor(La, qa, io) {
                this._stream = La, this._begin = qa, this._end = io, this._queuedChunk = null, this._requests = [], this._done = !1, this.onProgress = null;
              }
              _enqueue(La) {
                if (!this._done) {
                  if (this._requests.length === 0)
                    this._queuedChunk = La;
                  else {
                    this._requests.shift().resolve({
                      value: La,
                      done: !1
                    });
                    for (const io of this._requests)
                      io.resolve({
                        value: void 0,
                        done: !0
                      });
                    this._requests.length = 0;
                  }
                  this._done = !0, this._stream._removeRangeReader(this);
                }
              }
              get isStreamingSupported() {
                return !1;
              }
              async read() {
                if (this._queuedChunk) {
                  const qa = this._queuedChunk;
                  return this._queuedChunk = null, {
                    value: qa,
                    done: !1
                  };
                }
                if (this._done)
                  return {
                    value: void 0,
                    done: !0
                  };
                const La = (0, Zi.createPromiseCapability)();
                return this._requests.push(La), La.promise;
              }
              cancel(La) {
                this._done = !0;
                for (const qa of this._requests)
                  qa.resolve({
                    value: void 0,
                    done: !0
                  });
                this._requests.length = 0, this._stream._removeRangeReader(this);
              }
            }
          },
          /* 20 */
          /***/
          (Bi, e) => {
            Object.defineProperty(e, "__esModule", {
              value: !0
            }), e.XfaText = void 0;
            class Ui {
              static textContent(ta) {
                const na = [], ia = {
                  items: na,
                  styles: /* @__PURE__ */ Object.create(null)
                };
                function aa(da) {
                  if (!da)
                    return;
                  let La = null;
                  const qa = da.name;
                  if (qa === "#text")
                    La = da.value;
                  else if (Ui.shouldBuildText(qa))
                    da?.attributes?.textContent ? La = da.attributes.textContent : da.value && (La = da.value);
                  else return;
                  if (La !== null && na.push({
                    str: La
                  }), !!da.children)
                    for (const io of da.children)
                      aa(io);
                }
                return aa(ta), ia;
              }
              static shouldBuildText(ta) {
                return !(ta === "textarea" || ta === "input" || ta === "option" || ta === "select");
              }
            }
            e.XfaText = Ui;
          },
          /* 21 */
          /***/
          (Bi, e, Ui) => {
            Object.defineProperty(e, "__esModule", {
              value: !0
            }), e.NodeStandardFontDataFactory = e.NodeCanvasFactory = e.NodeCMapReaderFactory = void 0;
            var Zi = Ui(9);
            const ta = function(da) {
              return new Promise((La, qa) => {
                require$$5.readFile(da, (ao, oo) => {
                  if (ao || !oo) {
                    qa(new Error(ao));
                    return;
                  }
                  La(new Uint8Array(oo));
                });
              });
            };
            class na extends Zi.BaseCanvasFactory {
              _createCanvas(La, qa) {
                return require$$5.createCanvas(La, qa);
              }
            }
            e.NodeCanvasFactory = na;
            class ia extends Zi.BaseCMapReaderFactory {
              _fetchData(La, qa) {
                return ta(La).then((io) => ({
                  cMapData: io,
                  compressionType: qa
                }));
              }
            }
            e.NodeCMapReaderFactory = ia;
            class aa extends Zi.BaseStandardFontDataFactory {
              _fetchData(La) {
                return ta(La);
              }
            }
            e.NodeStandardFontDataFactory = aa;
          },
          /* 22 */
          /***/
          (Bi, e, Ui) => {
            var da, La, qa, io, ao, oo, no, lo, so, ff, Uf, hf, zf;
            Object.defineProperty(e, "__esModule", {
              value: !0
            }), e.AnnotationEditorLayer = void 0;
            var Zi = Ui(7), ta = Ui(1), na = Ui(23), ia = Ui(24);
            const jo = class jo {
              constructor(Ao) {
                fc(this, so);
                fc(this, da);
                fc(this, La, !1);
                fc(this, qa, this.pointerup.bind(this));
                fc(this, io, this.pointerdown.bind(this));
                fc(this, ao, /* @__PURE__ */ new Map());
                fc(this, oo, !1);
                fc(this, no, !1);
                fc(this, lo);
                jo._initialized || (jo._initialized = !0, na.FreeTextEditor.initialize(Ao.l10n), ia.InkEditor.initialize(Ao.l10n), Ao.uiManager.registerEditorTypes([na.FreeTextEditor, ia.InkEditor])), lu(this, lo, Ao.uiManager), this.annotationStorage = Ao.annotationStorage, this.pageIndex = Ao.pageIndex, this.div = Ao.div, lu(this, da, Ao.accessibilityManager), Gl(this, lo).addLayer(this);
              }
              updateToolbar(Ao) {
                Gl(this, lo).updateToolbar(Ao);
              }
              updateMode(Ao = Gl(this, lo).getMode()) {
                lc(this, so, zf).call(this), Ao === ta.AnnotationEditorType.INK ? (this.addInkEditorIfNeeded(!1), this.disableClick()) : this.enableClick(), Gl(this, lo).unselectAll();
              }
              addInkEditorIfNeeded(Ao) {
                if (!Ao && Gl(this, lo).getMode() !== ta.AnnotationEditorType.INK)
                  return;
                if (!Ao) {
                  for (const Co of Gl(this, ao).values())
                    if (Co.isEmpty()) {
                      Co.setInBackground();
                      return;
                    }
                }
                lc(this, so, hf).call(this, {
                  offsetX: 0,
                  offsetY: 0
                }).setInBackground();
              }
              setEditingState(Ao) {
                Gl(this, lo).setEditingState(Ao);
              }
              addCommands(Ao) {
                Gl(this, lo).addCommands(Ao);
              }
              enable() {
                this.div.style.pointerEvents = "auto";
                for (const Ao of Gl(this, ao).values())
                  Ao.enableEditing();
              }
              disable() {
                this.div.style.pointerEvents = "none";
                for (const Ao of Gl(this, ao).values())
                  Ao.disableEditing();
              }
              setActiveEditor(Ao) {
                Gl(this, lo).getActive() !== Ao && Gl(this, lo).setActiveEditor(Ao);
              }
              enableClick() {
                this.div.addEventListener("pointerdown", Gl(this, io)), this.div.addEventListener("pointerup", Gl(this, qa));
              }
              disableClick() {
                this.div.removeEventListener("pointerdown", Gl(this, io)), this.div.removeEventListener("pointerup", Gl(this, qa));
              }
              attach(Ao) {
                Gl(this, ao).set(Ao.id, Ao);
              }
              detach(Ao) {
                Gl(this, ao).delete(Ao.id), Gl(this, da)?.removePointerInTextLayer(Ao.contentDiv);
              }
              remove(Ao) {
                Gl(this, lo).removeEditor(Ao), this.detach(Ao), this.annotationStorage.remove(Ao.id), Ao.div.style.display = "none", setTimeout(() => {
                  Ao.div.style.display = "", Ao.div.remove(), Ao.isAttachedToDOM = !1, document.activeElement === document.body && Gl(this, lo).focusMainContainer();
                }, 0), Gl(this, no) || this.addInkEditorIfNeeded(!1);
              }
              add(Ao) {
                if (lc(this, so, ff).call(this, Ao), Gl(this, lo).addEditor(Ao), this.attach(Ao), !Ao.isAttachedToDOM) {
                  const co = Ao.render();
                  this.div.append(co), Ao.isAttachedToDOM = !0;
                }
                this.moveEditorInDOM(Ao), Ao.onceAdded(), this.addToAnnotationStorage(Ao);
              }
              moveEditorInDOM(Ao) {
                Gl(this, da)?.moveElementInDOM(this.div, Ao.div, Ao.contentDiv, !0);
              }
              addToAnnotationStorage(Ao) {
                !Ao.isEmpty() && !this.annotationStorage.has(Ao.id) && this.annotationStorage.setValue(Ao.id, Ao);
              }
              addOrRebuild(Ao) {
                Ao.needsToBeRebuilt() ? Ao.rebuild() : this.add(Ao);
              }
              addANewEditor(Ao) {
                const co = () => {
                  this.addOrRebuild(Ao);
                }, Co = () => {
                  Ao.remove();
                };
                this.addCommands({
                  cmd: co,
                  undo: Co,
                  mustExec: !0
                });
              }
              addUndoableEditor(Ao) {
                const co = () => {
                  this.addOrRebuild(Ao);
                }, Co = () => {
                  Ao.remove();
                };
                this.addCommands({
                  cmd: co,
                  undo: Co,
                  mustExec: !1
                });
              }
              getNextId() {
                return Gl(this, lo).getId();
              }
              deserialize(Ao) {
                switch (Ao.annotationType) {
                  case ta.AnnotationEditorType.FREETEXT:
                    return na.FreeTextEditor.deserialize(Ao, this);
                  case ta.AnnotationEditorType.INK:
                    return ia.InkEditor.deserialize(Ao, this);
                }
                return null;
              }
              setSelected(Ao) {
                Gl(this, lo).setSelected(Ao);
              }
              toggleSelected(Ao) {
                Gl(this, lo).toggleSelected(Ao);
              }
              isSelected(Ao) {
                return Gl(this, lo).isSelected(Ao);
              }
              unselect(Ao) {
                Gl(this, lo).unselect(Ao);
              }
              pointerup(Ao) {
                const co = Zi.KeyboardManager.platform.isMac;
                if (!(Ao.button !== 0 || Ao.ctrlKey && co) && Ao.target === this.div && Gl(this, oo)) {
                  if (lu(this, oo, !1), !Gl(this, La)) {
                    lu(this, La, !0);
                    return;
                  }
                  lc(this, so, hf).call(this, Ao);
                }
              }
              pointerdown(Ao) {
                const co = Zi.KeyboardManager.platform.isMac;
                if (Ao.button !== 0 || Ao.ctrlKey && co || Ao.target !== this.div)
                  return;
                lu(this, oo, !0);
                const Co = Gl(this, lo).getActive();
                lu(this, La, !Co || Co.isEmpty());
              }
              drop(Ao) {
                const co = Ao.dataTransfer.getData("text/plain"), Co = Gl(this, lo).getEditor(co);
                if (!Co)
                  return;
                Ao.preventDefault(), Ao.dataTransfer.dropEffect = "move", lc(this, so, ff).call(this, Co);
                const Zs = this.div.getBoundingClientRect(), xl = Ao.clientX - Zs.x, Cl = Ao.clientY - Zs.y;
                Co.translate(xl - Co.startX, Cl - Co.startY), this.moveEditorInDOM(Co), Co.div.focus();
              }
              dragover(Ao) {
                Ao.preventDefault();
              }
              destroy() {
                Gl(this, lo).getActive()?.parent === this && Gl(this, lo).setActiveEditor(null);
                for (const Ao of Gl(this, ao).values())
                  Gl(this, da)?.removePointerInTextLayer(Ao.contentDiv), Ao.isAttachedToDOM = !1, Ao.div.remove(), Ao.parent = null;
                this.div = null, Gl(this, ao).clear(), Gl(this, lo).removeLayer(this);
              }
              render(Ao) {
                this.viewport = Ao.viewport, (0, Zi.bindEvents)(this, this.div, ["dragover", "drop"]), this.setDimensions();
                for (const co of Gl(this, lo).getEditors(this.pageIndex))
                  this.add(co);
                this.updateMode();
              }
              update(Ao) {
                this.viewport = Ao.viewport, this.setDimensions(), this.updateMode();
              }
              get scaleFactor() {
                return this.viewport.scale;
              }
              get pageDimensions() {
                const [Ao, co, Co, Zs] = this.viewport.viewBox, xl = Co - Ao, Cl = Zs - co;
                return [xl, Cl];
              }
              get viewportBaseDimensions() {
                const {
                  width: Ao,
                  height: co,
                  rotation: Co
                } = this.viewport;
                return Co % 180 === 0 ? [Ao, co] : [co, Ao];
              }
              setDimensions() {
                const {
                  width: Ao,
                  height: co,
                  rotation: Co
                } = this.viewport, Zs = Co % 180 !== 0, xl = Math.floor(Ao) + "px", Cl = Math.floor(co) + "px";
                this.div.style.width = Zs ? Cl : xl, this.div.style.height = Zs ? xl : Cl, this.div.setAttribute("data-main-rotation", Co);
              }
            };
            da = new WeakMap(), La = new WeakMap(), qa = new WeakMap(), io = new WeakMap(), ao = new WeakMap(), oo = new WeakMap(), no = new WeakMap(), lo = new WeakMap(), so = new WeakSet(), ff = function(Ao) {
              Ao.parent !== this && (this.attach(Ao), Ao.pageIndex = this.pageIndex, Ao.parent?.detach(Ao), Ao.parent = this, Ao.div && Ao.isAttachedToDOM && (Ao.div.remove(), this.div.append(Ao.div)));
            }, Uf = function(Ao) {
              switch (Gl(this, lo).getMode()) {
                case ta.AnnotationEditorType.FREETEXT:
                  return new na.FreeTextEditor(Ao);
                case ta.AnnotationEditorType.INK:
                  return new ia.InkEditor(Ao);
              }
              return null;
            }, hf = function(Ao) {
              const co = this.getNextId(), Co = lc(this, so, Uf).call(this, {
                parent: this,
                id: co,
                x: Ao.offsetX,
                y: Ao.offsetY
              });
              return Co && this.add(Co), Co;
            }, zf = function() {
              lu(this, no, !0);
              for (const Ao of Gl(this, ao).values())
                Ao.isEmpty() && Ao.remove();
              lu(this, no, !1);
            }, hd(jo, "_initialized", !1);
            let aa = jo;
            e.AnnotationEditorLayer = aa;
          },
          /* 23 */
          /***/
          (Bi, e, Ui) => {
            var aa, da, La, qa, io, ao, oo, no, Hf, Kf, qf, gf;
            Object.defineProperty(e, "__esModule", {
              value: !0
            }), e.FreeTextEditor = void 0;
            var Zi = Ui(1), ta = Ui(7), na = Ui(6);
            const js = class js extends na.AnnotationEditor {
              constructor(fs) {
                super({
                  ...fs,
                  name: "freeTextEditor"
                });
                fc(this, no);
                fc(this, aa, this.editorDivBlur.bind(this));
                fc(this, da, this.editorDivFocus.bind(this));
                fc(this, La, this.editorDivKeydown.bind(this));
                fc(this, qa);
                fc(this, io, "");
                fc(this, ao, !1);
                fc(this, oo);
                lu(this, qa, fs.color || js._defaultColor || na.AnnotationEditor._defaultLineColor), lu(this, oo, fs.fontSize || js._defaultFontSize);
              }
              static initialize(fs) {
                this._l10nPromise = new Map(["free_text_default_content", "editor_free_text_aria_label"].map((co) => [co, fs.get(co)]));
                const Ao = getComputedStyle(document.documentElement);
                this._internalPadding = parseFloat(Ao.getPropertyValue("--freetext-padding"));
              }
              static updateDefaultParams(fs, Ao) {
                switch (fs) {
                  case Zi.AnnotationEditorParamsType.FREETEXT_SIZE:
                    js._defaultFontSize = Ao;
                    break;
                  case Zi.AnnotationEditorParamsType.FREETEXT_COLOR:
                    js._defaultColor = Ao;
                    break;
                }
              }
              updateParams(fs, Ao) {
                switch (fs) {
                  case Zi.AnnotationEditorParamsType.FREETEXT_SIZE:
                    lc(this, no, Hf).call(this, Ao);
                    break;
                  case Zi.AnnotationEditorParamsType.FREETEXT_COLOR:
                    lc(this, no, Kf).call(this, Ao);
                    break;
                }
              }
              static get defaultPropertiesToUpdate() {
                return [[Zi.AnnotationEditorParamsType.FREETEXT_SIZE, js._defaultFontSize], [Zi.AnnotationEditorParamsType.FREETEXT_COLOR, js._defaultColor || na.AnnotationEditor._defaultLineColor]];
              }
              get propertiesToUpdate() {
                return [[Zi.AnnotationEditorParamsType.FREETEXT_SIZE, Gl(this, oo)], [Zi.AnnotationEditorParamsType.FREETEXT_COLOR, Gl(this, qa)]];
              }
              getInitialTranslation() {
                return [-js._internalPadding * this.parent.scaleFactor, -(js._internalPadding + Gl(this, oo)) * this.parent.scaleFactor];
              }
              rebuild() {
                super.rebuild(), this.div !== null && (this.isAttachedToDOM || this.parent.add(this));
              }
              enableEditMode() {
                this.isInEditMode() || (this.parent.setEditingState(!1), this.parent.updateToolbar(Zi.AnnotationEditorType.FREETEXT), super.enableEditMode(), this.enableEditing(), this.overlayDiv.classList.remove("enabled"), this.editorDiv.contentEditable = !0, this.div.draggable = !1, this.editorDiv.addEventListener("keydown", Gl(this, La)), this.editorDiv.addEventListener("focus", Gl(this, da)), this.editorDiv.addEventListener("blur", Gl(this, aa)));
              }
              disableEditMode() {
                this.isInEditMode() && (this.parent.setEditingState(!0), super.disableEditMode(), this.disableEditing(), this.overlayDiv.classList.add("enabled"), this.editorDiv.contentEditable = !1, this.div.draggable = !0, this.editorDiv.removeEventListener("keydown", Gl(this, La)), this.editorDiv.removeEventListener("focus", Gl(this, da)), this.editorDiv.removeEventListener("blur", Gl(this, aa)), this.div.focus(), this.isEditing = !1);
              }
              focusin(fs) {
                super.focusin(fs), fs.target !== this.editorDiv && this.editorDiv.focus();
              }
              onceAdded() {
                this.width || (this.enableEditMode(), this.editorDiv.focus());
              }
              isEmpty() {
                return !this.editorDiv || this.editorDiv.innerText.trim() === "";
              }
              remove() {
                this.isEditing = !1, this.parent.setEditingState(!0), super.remove();
              }
              commit() {
                super.commit(), Gl(this, ao) || (lu(this, ao, !0), this.parent.addUndoableEditor(this)), this.disableEditMode(), lu(this, io, lc(this, no, qf).call(this).trimEnd()), lc(this, no, gf).call(this);
              }
              shouldGetKeyboardEvents() {
                return this.isInEditMode();
              }
              dblclick(fs) {
                this.enableEditMode(), this.editorDiv.focus();
              }
              keydown(fs) {
                fs.target === this.div && fs.key === "Enter" && (this.enableEditMode(), this.editorDiv.focus());
              }
              editorDivKeydown(fs) {
                js._keyboardManager.exec(this, fs);
              }
              editorDivFocus(fs) {
                this.isEditing = !0;
              }
              editorDivBlur(fs) {
                this.isEditing = !1;
              }
              disableEditing() {
                this.editorDiv.setAttribute("role", "comment"), this.editorDiv.removeAttribute("aria-multiline");
              }
              enableEditing() {
                this.editorDiv.setAttribute("role", "textbox"), this.editorDiv.setAttribute("aria-multiline", !0);
              }
              render() {
                if (this.div)
                  return this.div;
                let fs, Ao;
                this.width && (fs = this.x, Ao = this.y), super.render(), this.editorDiv = document.createElement("div"), this.editorDiv.className = "internal", this.editorDiv.setAttribute("id", `${this.id}-editor`), this.enableEditing(), js._l10nPromise.get("editor_free_text_aria_label").then((Co) => this.editorDiv?.setAttribute("aria-label", Co)), js._l10nPromise.get("free_text_default_content").then((Co) => this.editorDiv?.setAttribute("default-content", Co)), this.editorDiv.contentEditable = !0;
                const {
                  style: co
                } = this.editorDiv;
                if (co.fontSize = `calc(${Gl(this, oo)}px * var(--scale-factor))`, co.color = Gl(this, qa), this.div.append(this.editorDiv), this.overlayDiv = document.createElement("div"), this.overlayDiv.classList.add("overlay", "enabled"), this.div.append(this.overlayDiv), (0, ta.bindEvents)(this, this.div, ["dblclick", "keydown"]), this.width) {
                  const [Co, Zs] = this.parent.viewportBaseDimensions;
                  this.setAt(fs * Co, Ao * Zs, this.width * Co, this.height * Zs);
                  for (const xl of Gl(this, io).split(`
`)) {
                    const Cl = document.createElement("div");
                    Cl.append(xl ? document.createTextNode(xl) : document.createElement("br")), this.editorDiv.append(Cl);
                  }
                  this.div.draggable = !0, this.editorDiv.contentEditable = !1;
                } else
                  this.div.draggable = !1, this.editorDiv.contentEditable = !0;
                return this.div;
              }
              get contentDiv() {
                return this.editorDiv;
              }
              static deserialize(fs, Ao) {
                const co = super.deserialize(fs, Ao);
                return lu(co, oo, fs.fontSize), lu(co, qa, Zi.Util.makeHexColor(...fs.color)), lu(co, io, fs.value), co;
              }
              serialize() {
                if (this.isEmpty())
                  return null;
                const fs = js._internalPadding * this.parent.scaleFactor, Ao = this.getRect(fs, fs), co = na.AnnotationEditor._colorManager.convert(getComputedStyle(this.editorDiv).color);
                return {
                  annotationType: Zi.AnnotationEditorType.FREETEXT,
                  color: co,
                  fontSize: Gl(this, oo),
                  value: Gl(this, io),
                  pageIndex: this.parent.pageIndex,
                  rect: Ao,
                  rotation: this.rotation
                };
              }
            };
            aa = new WeakMap(), da = new WeakMap(), La = new WeakMap(), qa = new WeakMap(), io = new WeakMap(), ao = new WeakMap(), oo = new WeakMap(), no = new WeakSet(), Hf = function(fs) {
              const Ao = (Co) => {
                this.editorDiv.style.fontSize = `calc(${Co}px * var(--scale-factor))`, this.translate(0, -(Co - Gl(this, oo)) * this.parent.scaleFactor), lu(this, oo, Co), lc(this, no, gf).call(this);
              }, co = Gl(this, oo);
              this.parent.addCommands({
                cmd: () => {
                  Ao(fs);
                },
                undo: () => {
                  Ao(co);
                },
                mustExec: !0,
                type: Zi.AnnotationEditorParamsType.FREETEXT_SIZE,
                overwriteIfSameType: !0,
                keepUndo: !0
              });
            }, Kf = function(fs) {
              const Ao = Gl(this, qa);
              this.parent.addCommands({
                cmd: () => {
                  lu(this, qa, fs), this.editorDiv.style.color = fs;
                },
                undo: () => {
                  lu(this, qa, Ao), this.editorDiv.style.color = Ao;
                },
                mustExec: !0,
                type: Zi.AnnotationEditorParamsType.FREETEXT_COLOR,
                overwriteIfSameType: !0,
                keepUndo: !0
              });
            }, qf = function() {
              const fs = this.editorDiv.getElementsByTagName("div");
              if (fs.length === 0)
                return this.editorDiv.innerText;
              const Ao = [];
              for (let co = 0, Co = fs.length; co < Co; co++) {
                const xl = fs[co].firstChild;
                xl?.nodeName === "#text" ? Ao.push(xl.data) : Ao.push("");
              }
              return Ao.join(`
`);
            }, gf = function() {
              const [fs, Ao] = this.parent.viewportBaseDimensions, co = this.div.getBoundingClientRect();
              this.width = co.width / fs, this.height = co.height / Ao;
            }, hd(js, "_freeTextDefaultContent", ""), hd(js, "_l10nPromise"), hd(js, "_internalPadding", 0), hd(js, "_defaultColor", null), hd(js, "_defaultFontSize", 10), hd(js, "_keyboardManager", new ta.KeyboardManager([[["ctrl+Enter", "mac+meta+Enter", "Escape", "mac+Escape"], js.prototype.commitOrRemove]])), hd(js, "_type", "freetext");
            let ia = js;
            e.FreeTextEditor = ia;
          },
          /* 24 */
          /***/
          (Bi, e, Ui) => {
            var La, qa, io, ao, oo, no, lo, so, bs, Rs, js, qs, jo, fs, Ao, Wf, Gf, Zf, Yf, bf, Xf, Qf, Jf, Dd, $f, Zd, Yd, Vd, xf, Xd, Tl, Ef, ep, tp, rp, Sf, Qd, Bd, wf;
            Object.defineProperty(e, "__esModule", {
              value: !0
            }), e.InkEditor = void 0, Object.defineProperty(e, "fitCurve", {
              enumerable: !0,
              get: function() {
                return na.fitCurve;
              }
            });
            var Zi = Ui(1), ta = Ui(6), na = Ui(25), ia = Ui(7);
            const aa = 16, wl = class wl extends ta.AnnotationEditor {
              constructor(Dl) {
                super({
                  ...Dl,
                  name: "inkEditor"
                });
                fc(this, Ao);
                fc(this, La, 0);
                fc(this, qa, 0);
                fc(this, io, 0);
                fc(this, ao, this.canvasPointermove.bind(this));
                fc(this, oo, this.canvasPointerleave.bind(this));
                fc(this, no, this.canvasPointerup.bind(this));
                fc(this, lo, this.canvasPointerdown.bind(this));
                fc(this, so, !1);
                fc(this, bs, !1);
                fc(this, Rs, null);
                fc(this, js, null);
                fc(this, qs, 0);
                fc(this, jo, 0);
                fc(this, fs, null);
                this.color = Dl.color || null, this.thickness = Dl.thickness || null, this.opacity = Dl.opacity || null, this.paths = [], this.bezierPath2D = [], this.currentPath = [], this.scaleFactor = 1, this.translationX = this.translationY = 0, this.x = 0, this.y = 0;
              }
              static initialize(Dl) {
                this._l10nPromise = new Map(["editor_ink_canvas_aria_label", "editor_ink_aria_label"].map(($l) => [$l, Dl.get($l)]));
              }
              static updateDefaultParams(Dl, $l) {
                switch (Dl) {
                  case Zi.AnnotationEditorParamsType.INK_THICKNESS:
                    wl._defaultThickness = $l;
                    break;
                  case Zi.AnnotationEditorParamsType.INK_COLOR:
                    wl._defaultColor = $l;
                    break;
                  case Zi.AnnotationEditorParamsType.INK_OPACITY:
                    wl._defaultOpacity = $l / 100;
                    break;
                }
              }
              updateParams(Dl, $l) {
                switch (Dl) {
                  case Zi.AnnotationEditorParamsType.INK_THICKNESS:
                    lc(this, Ao, Wf).call(this, $l);
                    break;
                  case Zi.AnnotationEditorParamsType.INK_COLOR:
                    lc(this, Ao, Gf).call(this, $l);
                    break;
                  case Zi.AnnotationEditorParamsType.INK_OPACITY:
                    lc(this, Ao, Zf).call(this, $l);
                    break;
                }
              }
              static get defaultPropertiesToUpdate() {
                return [[Zi.AnnotationEditorParamsType.INK_THICKNESS, wl._defaultThickness], [Zi.AnnotationEditorParamsType.INK_COLOR, wl._defaultColor || ta.AnnotationEditor._defaultLineColor], [Zi.AnnotationEditorParamsType.INK_OPACITY, Math.round(wl._defaultOpacity * 100)]];
              }
              get propertiesToUpdate() {
                return [[Zi.AnnotationEditorParamsType.INK_THICKNESS, this.thickness || wl._defaultThickness], [Zi.AnnotationEditorParamsType.INK_COLOR, this.color || wl._defaultColor || ta.AnnotationEditor._defaultLineColor], [Zi.AnnotationEditorParamsType.INK_OPACITY, Math.round(100 * (this.opacity ?? wl._defaultOpacity))]];
              }
              rebuild() {
                super.rebuild(), this.div !== null && (this.canvas || (lc(this, Ao, Zd).call(this), lc(this, Ao, Yd).call(this)), this.isAttachedToDOM || (this.parent.add(this), lc(this, Ao, Vd).call(this)), lc(this, Ao, Bd).call(this));
              }
              remove() {
                this.canvas !== null && (this.isEmpty() || this.commit(), this.canvas.width = this.canvas.height = 0, this.canvas.remove(), this.canvas = null, Gl(this, js).disconnect(), lu(this, js, null), super.remove());
              }
              enableEditMode() {
                Gl(this, so) || this.canvas === null || (super.enableEditMode(), this.div.draggable = !1, this.canvas.addEventListener("pointerdown", Gl(this, lo)), this.canvas.addEventListener("pointerup", Gl(this, no)));
              }
              disableEditMode() {
                !this.isInEditMode() || this.canvas === null || (super.disableEditMode(), this.div.draggable = !this.isEmpty(), this.div.classList.remove("editing"), this.canvas.removeEventListener("pointerdown", Gl(this, lo)), this.canvas.removeEventListener("pointerup", Gl(this, no)));
              }
              onceAdded() {
                this.div.draggable = !this.isEmpty();
              }
              isEmpty() {
                return this.paths.length === 0 || this.paths.length === 1 && this.paths[0].length === 0;
              }
              commit() {
                Gl(this, so) || (super.commit(), this.isEditing = !1, this.disableEditMode(), this.setInForeground(), lu(this, so, !0), this.div.classList.add("disabled"), lc(this, Ao, Bd).call(this, !0), this.parent.addInkEditorIfNeeded(!0), this.parent.moveEditorInDOM(this), this.div.focus());
              }
              focusin(Dl) {
                super.focusin(Dl), this.enableEditMode();
              }
              canvasPointerdown(Dl) {
                Dl.button !== 0 || !this.isInEditMode() || Gl(this, so) || (this.setInForeground(), Dl.type !== "mouse" && this.div.focus(), Dl.stopPropagation(), this.canvas.addEventListener("pointerleave", Gl(this, oo)), this.canvas.addEventListener("pointermove", Gl(this, ao)), lc(this, Ao, Xf).call(this, Dl.offsetX, Dl.offsetY));
              }
              canvasPointermove(Dl) {
                Dl.stopPropagation(), lc(this, Ao, Qf).call(this, Dl.offsetX, Dl.offsetY);
              }
              canvasPointerup(Dl) {
                Dl.button === 0 && this.isInEditMode() && this.currentPath.length !== 0 && (Dl.stopPropagation(), lc(this, Ao, $f).call(this, Dl), this.setInBackground());
              }
              canvasPointerleave(Dl) {
                lc(this, Ao, $f).call(this, Dl), this.setInBackground();
              }
              render() {
                if (this.div)
                  return this.div;
                let Dl, $l;
                this.width && (Dl = this.x, $l = this.y), super.render(), wl._l10nPromise.get("editor_ink_aria_label").then((ql) => this.div?.setAttribute("aria-label", ql));
                const [kl, zl, Hl, Wl] = lc(this, Ao, Yf).call(this);
                if (this.setAt(kl, zl, 0, 0), this.setDims(Hl, Wl), lc(this, Ao, Zd).call(this), this.width) {
                  const [ql, Jl] = this.parent.viewportBaseDimensions;
                  this.setAt(Dl * ql, $l * Jl, this.width * ql, this.height * Jl), lu(this, bs, !0), lc(this, Ao, Vd).call(this), this.setDims(this.width * ql, this.height * Jl), lc(this, Ao, Dd).call(this), lc(this, Ao, wf).call(this), this.div.classList.add("disabled");
                } else
                  this.div.classList.add("editing"), this.enableEditMode();
                return lc(this, Ao, Yd).call(this), this.div;
              }
              setDimensions(Dl, $l) {
                const kl = Math.round(Dl), zl = Math.round($l);
                if (Gl(this, qs) === kl && Gl(this, jo) === zl)
                  return;
                lu(this, qs, kl), lu(this, jo, zl), this.canvas.style.visibility = "hidden", Gl(this, La) && Math.abs(Gl(this, La) - Dl / $l) > 0.01 && ($l = Math.ceil(Dl / Gl(this, La)), this.setDims(Dl, $l));
                const [Hl, Wl] = this.parent.viewportBaseDimensions;
                this.width = Dl / Hl, this.height = $l / Wl, Gl(this, so) && lc(this, Ao, xf).call(this, Dl, $l), lc(this, Ao, Vd).call(this), lc(this, Ao, Dd).call(this), this.canvas.style.visibility = "visible";
              }
              static deserialize(Dl, $l) {
                var sc, Hu;
                const kl = super.deserialize(Dl, $l);
                kl.thickness = Dl.thickness, kl.color = Zi.Util.makeHexColor(...Dl.color), kl.opacity = Dl.opacity;
                const [zl, Hl] = $l.pageDimensions, Wl = kl.width * zl, ql = kl.height * Hl, Jl = $l.scaleFactor, ac = Dl.thickness / 2;
                lu(kl, La, Wl / ql), lu(kl, so, !0), lu(kl, qs, Math.round(Wl)), lu(kl, jo, Math.round(ql));
                for (const {
                  bezier: dc
                } of Dl.paths) {
                  const td = [];
                  kl.paths.push(td);
                  let ad = Jl * (dc[0] - ac), od = Jl * (ql - dc[1] - ac);
                  for (let dd = 2, pd = dc.length; dd < pd; dd += 6) {
                    const fd = Jl * (dc[dd] - ac), Ed = Jl * (ql - dc[dd + 1] - ac), wd = Jl * (dc[dd + 2] - ac), Ad = Jl * (ql - dc[dd + 3] - ac), oc = Jl * (dc[dd + 4] - ac), rc = Jl * (ql - dc[dd + 5] - ac);
                    td.push([[ad, od], [fd, Ed], [wd, Ad], [oc, rc]]), ad = oc, od = rc;
                  }
                  const sd = lc(this, Tl, Ef).call(this, td);
                  kl.bezierPath2D.push(sd);
                }
                const Xl = lc(sc = kl, Ao, Sf).call(sc);
                return lu(kl, io, Math.max(aa, Xl[2] - Xl[0])), lu(kl, qa, Math.max(aa, Xl[3] - Xl[1])), lc(Hu = kl, Ao, xf).call(Hu, Wl, ql), kl;
              }
              serialize() {
                if (this.isEmpty())
                  return null;
                const Dl = this.getRect(0, 0), $l = this.rotation % 180 === 0 ? Dl[3] - Dl[1] : Dl[2] - Dl[0], kl = ta.AnnotationEditor._colorManager.convert(this.ctx.strokeStyle);
                return {
                  annotationType: Zi.AnnotationEditorType.INK,
                  color: kl,
                  thickness: this.thickness,
                  opacity: this.opacity,
                  paths: lc(this, Ao, ep).call(this, this.scaleFactor / this.parent.scaleFactor, this.translationX, this.translationY, $l),
                  pageIndex: this.parent.pageIndex,
                  rect: Dl,
                  rotation: this.rotation
                };
              }
            };
            La = new WeakMap(), qa = new WeakMap(), io = new WeakMap(), ao = new WeakMap(), oo = new WeakMap(), no = new WeakMap(), lo = new WeakMap(), so = new WeakMap(), bs = new WeakMap(), Rs = new WeakMap(), js = new WeakMap(), qs = new WeakMap(), jo = new WeakMap(), fs = new WeakMap(), Ao = new WeakSet(), Wf = function(Dl) {
              const $l = this.thickness;
              this.parent.addCommands({
                cmd: () => {
                  this.thickness = Dl, lc(this, Ao, Bd).call(this);
                },
                undo: () => {
                  this.thickness = $l, lc(this, Ao, Bd).call(this);
                },
                mustExec: !0,
                type: Zi.AnnotationEditorParamsType.INK_THICKNESS,
                overwriteIfSameType: !0,
                keepUndo: !0
              });
            }, Gf = function(Dl) {
              const $l = this.color;
              this.parent.addCommands({
                cmd: () => {
                  this.color = Dl, lc(this, Ao, Dd).call(this);
                },
                undo: () => {
                  this.color = $l, lc(this, Ao, Dd).call(this);
                },
                mustExec: !0,
                type: Zi.AnnotationEditorParamsType.INK_COLOR,
                overwriteIfSameType: !0,
                keepUndo: !0
              });
            }, Zf = function(Dl) {
              Dl /= 100;
              const $l = this.opacity;
              this.parent.addCommands({
                cmd: () => {
                  this.opacity = Dl, lc(this, Ao, Dd).call(this);
                },
                undo: () => {
                  this.opacity = $l, lc(this, Ao, Dd).call(this);
                },
                mustExec: !0,
                type: Zi.AnnotationEditorParamsType.INK_OPACITY,
                overwriteIfSameType: !0,
                keepUndo: !0
              });
            }, Yf = function() {
              const {
                width: Dl,
                height: $l,
                rotation: kl
              } = this.parent.viewport;
              switch (kl) {
                case 90:
                  return [0, Dl, Dl, $l];
                case 180:
                  return [Dl, $l, Dl, $l];
                case 270:
                  return [$l, 0, Dl, $l];
                default:
                  return [0, 0, Dl, $l];
              }
            }, bf = function() {
              this.ctx.lineWidth = this.thickness * this.parent.scaleFactor / this.scaleFactor, this.ctx.lineCap = "round", this.ctx.lineJoin = "round", this.ctx.miterLimit = 10, this.ctx.strokeStyle = `${this.color}${(0, ia.opacityToHex)(this.opacity)}`;
            }, Xf = function(Dl, $l) {
              this.isEditing = !0, Gl(this, bs) || (lu(this, bs, !0), lc(this, Ao, Vd).call(this), this.thickness || (this.thickness = wl._defaultThickness), this.color || (this.color = wl._defaultColor || ta.AnnotationEditor._defaultLineColor), this.opacity ?? (this.opacity = wl._defaultOpacity)), this.currentPath.push([Dl, $l]), lu(this, Rs, null), lc(this, Ao, bf).call(this), this.ctx.beginPath(), this.ctx.moveTo(Dl, $l), lu(this, fs, () => {
                Gl(this, fs) && (Gl(this, Rs) && (this.isEmpty() ? (this.ctx.setTransform(1, 0, 0, 1, 0, 0), this.ctx.clearRect(0, 0, this.canvas.width, this.canvas.height)) : lc(this, Ao, Dd).call(this), this.ctx.lineTo(...Gl(this, Rs)), lu(this, Rs, null), this.ctx.stroke()), window.requestAnimationFrame(Gl(this, fs)));
              }), window.requestAnimationFrame(Gl(this, fs));
            }, Qf = function(Dl, $l) {
              const [kl, zl] = this.currentPath.at(-1);
              Dl === kl && $l === zl || (this.currentPath.push([Dl, $l]), lu(this, Rs, [Dl, $l]));
            }, Jf = function(Dl, $l) {
              var ac;
              this.ctx.closePath(), lu(this, fs, null), Dl = Math.min(Math.max(Dl, 0), this.canvas.width), $l = Math.min(Math.max($l, 0), this.canvas.height);
              const [kl, zl] = this.currentPath.at(-1);
              (Dl !== kl || $l !== zl) && this.currentPath.push([Dl, $l]);
              let Hl;
              if (this.currentPath.length !== 1)
                Hl = (0, na.fitCurve)(this.currentPath, 30, null);
              else {
                const Xl = [Dl, $l];
                Hl = [[Xl, Xl.slice(), Xl.slice(), Xl]];
              }
              const Wl = lc(ac = wl, Tl, Ef).call(ac, Hl);
              this.currentPath.length = 0;
              const ql = () => {
                this.paths.push(Hl), this.bezierPath2D.push(Wl), this.rebuild();
              }, Jl = () => {
                this.paths.pop(), this.bezierPath2D.pop(), this.paths.length === 0 ? this.remove() : (this.canvas || (lc(this, Ao, Zd).call(this), lc(this, Ao, Yd).call(this)), lc(this, Ao, Bd).call(this));
              };
              this.parent.addCommands({
                cmd: ql,
                undo: Jl,
                mustExec: !0
              });
            }, Dd = function() {
              if (this.isEmpty()) {
                lc(this, Ao, Xd).call(this);
                return;
              }
              lc(this, Ao, bf).call(this);
              const {
                canvas: Dl,
                ctx: $l
              } = this;
              $l.setTransform(1, 0, 0, 1, 0, 0), $l.clearRect(0, 0, Dl.width, Dl.height), lc(this, Ao, Xd).call(this);
              for (const kl of this.bezierPath2D)
                $l.stroke(kl);
            }, $f = function(Dl) {
              lc(this, Ao, Jf).call(this, Dl.offsetX, Dl.offsetY), this.canvas.removeEventListener("pointerleave", Gl(this, oo)), this.canvas.removeEventListener("pointermove", Gl(this, ao)), this.parent.addToAnnotationStorage(this);
            }, Zd = function() {
              this.canvas = document.createElement("canvas"), this.canvas.width = this.canvas.height = 0, this.canvas.className = "inkEditorCanvas", wl._l10nPromise.get("editor_ink_canvas_aria_label").then((Dl) => this.canvas?.setAttribute("aria-label", Dl)), this.div.append(this.canvas), this.ctx = this.canvas.getContext("2d");
            }, Yd = function() {
              lu(this, js, new ResizeObserver((Dl) => {
                const $l = Dl[0].contentRect;
                $l.width && $l.height && this.setDimensions($l.width, $l.height);
              })), Gl(this, js).observe(this.div);
            }, Vd = function() {
              if (!Gl(this, bs))
                return;
              const [Dl, $l] = this.parent.viewportBaseDimensions;
              this.canvas.width = Math.ceil(this.width * Dl), this.canvas.height = Math.ceil(this.height * $l), lc(this, Ao, Xd).call(this);
            }, xf = function(Dl, $l) {
              const kl = lc(this, Ao, Qd).call(this), zl = (Dl - kl) / Gl(this, io), Hl = ($l - kl) / Gl(this, qa);
              this.scaleFactor = Math.min(zl, Hl);
            }, Xd = function() {
              const Dl = lc(this, Ao, Qd).call(this) / 2;
              this.ctx.setTransform(this.scaleFactor, 0, 0, this.scaleFactor, this.translationX * this.scaleFactor + Dl, this.translationY * this.scaleFactor + Dl);
            }, Tl = new WeakSet(), Ef = function(Dl) {
              const $l = new Path2D();
              for (let kl = 0, zl = Dl.length; kl < zl; kl++) {
                const [Hl, Wl, ql, Jl] = Dl[kl];
                kl === 0 && $l.moveTo(...Hl), $l.bezierCurveTo(Wl[0], Wl[1], ql[0], ql[1], Jl[0], Jl[1]);
              }
              return $l;
            }, ep = function(Dl, $l, kl, zl) {
              const Wl = [], ql = this.thickness / 2;
              let Jl, ac;
              for (const Xl of this.paths) {
                Jl = [], ac = [];
                for (let sc = 0, Hu = Xl.length; sc < Hu; sc++) {
                  const [dc, td, ad, od] = Xl[sc], sd = Dl * (dc[0] + $l) + ql, dd = zl - Dl * (dc[1] + kl) - ql, pd = Dl * (td[0] + $l) + ql, fd = zl - Dl * (td[1] + kl) - ql, Ed = Dl * (ad[0] + $l) + ql, wd = zl - Dl * (ad[1] + kl) - ql, Ad = Dl * (od[0] + $l) + ql, oc = zl - Dl * (od[1] + kl) - ql;
                  sc === 0 && (Jl.push(sd, dd), ac.push(sd, dd)), Jl.push(pd, fd, Ed, wd, Ad, oc), lc(this, Ao, tp).call(this, sd, dd, pd, fd, Ed, wd, Ad, oc, 4, ac);
                }
                Wl.push({
                  bezier: Jl,
                  points: ac
                });
              }
              return Wl;
            }, tp = function(Dl, $l, kl, zl, Hl, Wl, ql, Jl, ac, Xl) {
              if (lc(this, Ao, rp).call(this, Dl, $l, kl, zl, Hl, Wl, ql, Jl)) {
                Xl.push(ql, Jl);
                return;
              }
              for (let sc = 1; sc < ac - 1; sc++) {
                const Hu = sc / ac, dc = 1 - Hu;
                let td = Hu * Dl + dc * kl, ad = Hu * $l + dc * zl, od = Hu * kl + dc * Hl, sd = Hu * zl + dc * Wl;
                const dd = Hu * Hl + dc * ql, pd = Hu * Wl + dc * Jl;
                td = Hu * td + dc * od, ad = Hu * ad + dc * sd, od = Hu * od + dc * dd, sd = Hu * sd + dc * pd, td = Hu * td + dc * od, ad = Hu * ad + dc * sd, Xl.push(td, ad);
              }
              Xl.push(ql, Jl);
            }, rp = function(Dl, $l, kl, zl, Hl, Wl, ql, Jl) {
              const Xl = (3 * kl - 2 * Dl - ql) ** 2, sc = (3 * zl - 2 * $l - Jl) ** 2, Hu = (3 * Hl - Dl - 2 * ql) ** 2, dc = (3 * Wl - $l - 2 * Jl) ** 2;
              return Math.max(Xl, Hu) + Math.max(sc, dc) <= 10;
            }, Sf = function() {
              let Dl = 1 / 0, $l = -1 / 0, kl = 1 / 0, zl = -1 / 0;
              for (const Hl of this.paths)
                for (const [Wl, ql, Jl, ac] of Hl) {
                  const Xl = Zi.Util.bezierBoundingBox(...Wl, ...ql, ...Jl, ...ac);
                  Dl = Math.min(Dl, Xl[0]), kl = Math.min(kl, Xl[1]), $l = Math.max($l, Xl[2]), zl = Math.max(zl, Xl[3]);
                }
              return [Dl, kl, $l, zl];
            }, Qd = function() {
              return Gl(this, so) ? Math.ceil(this.thickness * this.parent.scaleFactor) : 0;
            }, Bd = function(Dl = !1) {
              if (this.isEmpty())
                return;
              if (!Gl(this, so)) {
                lc(this, Ao, Dd).call(this);
                return;
              }
              const $l = lc(this, Ao, Sf).call(this), kl = lc(this, Ao, Qd).call(this);
              lu(this, io, Math.max(aa, $l[2] - $l[0])), lu(this, qa, Math.max(aa, $l[3] - $l[1]));
              const zl = Math.ceil(kl + Gl(this, io) * this.scaleFactor), Hl = Math.ceil(kl + Gl(this, qa) * this.scaleFactor), [Wl, ql] = this.parent.viewportBaseDimensions;
              this.width = zl / Wl, this.height = Hl / ql, lu(this, La, zl / Hl), lc(this, Ao, wf).call(this);
              const Jl = this.translationX, ac = this.translationY;
              this.translationX = -$l[0], this.translationY = -$l[1], lc(this, Ao, Vd).call(this), lc(this, Ao, Dd).call(this), lu(this, qs, zl), lu(this, jo, Hl), this.setDims(zl, Hl);
              const Xl = Dl ? kl / this.scaleFactor / 2 : 0;
              this.translate(Jl - this.translationX - Xl, ac - this.translationY - Xl);
            }, wf = function() {
              const {
                style: Dl
              } = this.div;
              Gl(this, La) >= 1 ? (Dl.minHeight = `${aa}px`, Dl.minWidth = `${Math.round(Gl(this, La) * aa)}px`) : (Dl.minWidth = `${aa}px`, Dl.minHeight = `${Math.round(aa / Gl(this, La))}px`);
            }, fc(wl, Tl), hd(wl, "_defaultColor", null), hd(wl, "_defaultOpacity", 1), hd(wl, "_defaultThickness", 1), hd(wl, "_l10nPromise"), hd(wl, "_type", "ink");
            let da = wl;
            e.InkEditor = da;
          },
          /* 25 */
          /***/
          (Bi, e, Ui) => {
            Object.defineProperty(e, "__esModule", {
              value: !0
            }), e.fitCurve = void 0;
            const Zi = Ui(26);
            e.fitCurve = Zi;
          },
          /* 26 */
          /***/
          (Bi) => {
            function e(no, lo, so) {
              if (!Array.isArray(no))
                throw new TypeError("First argument should be an array");
              if (no.forEach((qs) => {
                if (!Array.isArray(qs) || qs.some((jo) => typeof jo != "number") || qs.length !== no[0].length)
                  throw Error("Each point should be an array of numbers. Each point should have the same amount of numbers.");
              }), no = no.filter((qs, jo) => jo === 0 || !qs.every((fs, Ao) => fs === no[jo - 1][Ao])), no.length < 2)
                return [];
              const bs = no.length, Rs = io(no[1], no[0]), js = io(no[bs - 2], no[bs - 1]);
              return Ui(no, Rs, js, lo, so);
            }
            function Ui(no, lo, so, bs, Rs) {
              var qs, jo, fs, Ao, co, Co, Zs, xl, Cl, Al, Ol, Bl, Ml;
              if (no.length === 2)
                return Bl = ao.vectorLen(ao.subtract(no[0], no[1])) / 3, qs = [no[0], ao.addArrays(no[0], ao.mulItems(lo, Bl)), ao.addArrays(no[1], ao.mulItems(so, Bl)), no[1]], [qs];
              if (jo = aa(no), [qs, Ao, Co] = Zi(no, jo, jo, lo, so, Rs), Ao === 0 || Ao < bs)
                return [qs];
              if (Ao < bs * bs)
                for (fs = jo, co = Ao, Zs = Co, Ml = 0; Ml < 20; Ml++) {
                  if (fs = na(qs, no, fs), [qs, Ao, Co] = Zi(no, jo, fs, lo, so, Rs), Ao < bs)
                    return [qs];
                  if (Co === Zs) {
                    let Vl = Ao / co;
                    if (Vl > 0.9999 && Vl < 1.0001)
                      break;
                  }
                  co = Ao, Zs = Co;
                }
              return Ol = [], xl = ao.subtract(no[Co - 1], no[Co + 1]), xl.every((Vl) => Vl === 0) && (xl = ao.subtract(no[Co - 1], no[Co]), [xl[0], xl[1]] = [-xl[1], xl[0]]), Cl = ao.normalize(xl), Al = ao.mulItems(Cl, -1), Ol = Ol.concat(Ui(no.slice(0, Co + 1), lo, Cl, bs, Rs)), Ol = Ol.concat(Ui(no.slice(Co), Al, so, bs, Rs)), Ol;
            }
            function Zi(no, lo, so, bs, Rs, js) {
              var qs, jo, fs;
              return qs = ta(no, so, bs, Rs), [jo, fs] = da(no, qs, lo), js && js({
                bez: qs,
                points: no,
                params: lo,
                maxErr: jo,
                maxPoint: fs
              }), [qs, jo, fs];
            }
            function ta(no, lo, so, bs) {
              var Rs, js, qs, jo, fs, Ao, co, Co, Zs, xl, Cl, Al, Ol, Bl, Ml, Vl, Ll, Yl = no[0], Zl = no[no.length - 1];
              for (Rs = [Yl, null, null, Zl], js = ao.zeros_Xx2x2(lo.length), Ol = 0, Bl = lo.length; Ol < Bl; Ol++)
                Vl = lo[Ol], Ll = 1 - Vl, qs = js[Ol], qs[0] = ao.mulItems(so, 3 * Vl * (Ll * Ll)), qs[1] = ao.mulItems(bs, 3 * Ll * (Vl * Vl));
              for (jo = [[0, 0], [0, 0]], fs = [0, 0], Ol = 0, Bl = no.length; Ol < Bl; Ol++)
                Vl = lo[Ol], qs = js[Ol], jo[0][0] += ao.dot(qs[0], qs[0]), jo[0][1] += ao.dot(qs[0], qs[1]), jo[1][0] += ao.dot(qs[0], qs[1]), jo[1][1] += ao.dot(qs[1], qs[1]), Ml = ao.subtract(no[Ol], oo.q([Yl, Yl, Zl, Zl], Vl)), fs[0] += ao.dot(qs[0], Ml), fs[1] += ao.dot(qs[1], Ml);
              return Ao = jo[0][0] * jo[1][1] - jo[1][0] * jo[0][1], co = jo[0][0] * fs[1] - jo[1][0] * fs[0], Co = fs[0] * jo[1][1] - fs[1] * jo[0][1], Zs = Ao === 0 ? 0 : Co / Ao, xl = Ao === 0 ? 0 : co / Ao, Al = ao.vectorLen(ao.subtract(Yl, Zl)), Cl = 1e-6 * Al, Zs < Cl || xl < Cl ? (Rs[1] = ao.addArrays(Yl, ao.mulItems(so, Al / 3)), Rs[2] = ao.addArrays(Zl, ao.mulItems(bs, Al / 3))) : (Rs[1] = ao.addArrays(Yl, ao.mulItems(so, Zs)), Rs[2] = ao.addArrays(Zl, ao.mulItems(bs, xl))), Rs;
            }
            function na(no, lo, so) {
              return so.map((bs, Rs) => ia(no, lo[Rs], bs));
            }
            function ia(no, lo, so) {
              var bs = ao.subtract(oo.q(no, so), lo), Rs = oo.qprime(no, so), js = ao.mulMatrix(bs, Rs), qs = ao.sum(ao.squareItems(Rs)) + 2 * ao.mulMatrix(bs, oo.qprimeprime(no, so));
              return qs === 0 ? so : so - js / qs;
            }
            function aa(no) {
              var lo = [], so, bs, Rs;
              return no.forEach((js, qs) => {
                so = qs ? bs + ao.vectorLen(ao.subtract(js, Rs)) : 0, lo.push(so), bs = so, Rs = js;
              }), lo = lo.map((js) => js / bs), lo;
            }
            function da(no, lo, so) {
              var bs, Rs, js, qs, jo, fs, Ao, co;
              Rs = 0, js = Math.floor(no.length / 2);
              const Co = La(lo, 10);
              for (jo = 0, fs = no.length; jo < fs; jo++)
                Ao = no[jo], co = qa(lo, so[jo], Co, 10), qs = ao.subtract(oo.q(lo, co), Ao), bs = qs[0] * qs[0] + qs[1] * qs[1], bs > Rs && (Rs = bs, js = jo);
              return [Rs, js];
            }
            var La = function(no, lo) {
              for (var so, bs = [0], Rs = no[0], js = 0, qs = 1; qs <= lo; qs++)
                so = oo.q(no, qs / lo), js += ao.vectorLen(ao.subtract(so, Rs)), bs.push(js), Rs = so;
              return bs = bs.map((jo) => jo / js), bs;
            };
            function qa(no, lo, so, bs) {
              if (lo < 0)
                return 0;
              if (lo > 1)
                return 1;
              for (var Rs, js, qs, jo, fs, Ao = 1; Ao <= bs; Ao++)
                if (lo <= so[Ao]) {
                  jo = (Ao - 1) / bs, qs = Ao / bs, js = so[Ao - 1], Rs = so[Ao], fs = (lo - js) / (Rs - js) * (qs - jo) + jo;
                  break;
                }
              return fs;
            }
            function io(no, lo) {
              return ao.normalize(ao.subtract(no, lo));
            }
            class ao {
              static zeros_Xx2x2(lo) {
                for (var so = []; lo--; )
                  so.push([0, 0]);
                return so;
              }
              static mulItems(lo, so) {
                return lo.map((bs) => bs * so);
              }
              static mulMatrix(lo, so) {
                return lo.reduce((bs, Rs, js) => bs + Rs * so[js], 0);
              }
              static subtract(lo, so) {
                return lo.map((bs, Rs) => bs - so[Rs]);
              }
              static addArrays(lo, so) {
                return lo.map((bs, Rs) => bs + so[Rs]);
              }
              static addItems(lo, so) {
                return lo.map((bs) => bs + so);
              }
              static sum(lo) {
                return lo.reduce((so, bs) => so + bs);
              }
              static dot(lo, so) {
                return ao.mulMatrix(lo, so);
              }
              static vectorLen(lo) {
                return Math.hypot(...lo);
              }
              static divItems(lo, so) {
                return lo.map((bs) => bs / so);
              }
              static squareItems(lo) {
                return lo.map((so) => so * so);
              }
              static normalize(lo) {
                return this.divItems(lo, this.vectorLen(lo));
              }
            }
            class oo {
              static q(lo, so) {
                var bs = 1 - so, Rs = ao.mulItems(lo[0], bs * bs * bs), js = ao.mulItems(lo[1], 3 * bs * bs * so), qs = ao.mulItems(lo[2], 3 * bs * so * so), jo = ao.mulItems(lo[3], so * so * so);
                return ao.addArrays(ao.addArrays(Rs, js), ao.addArrays(qs, jo));
              }
              static qprime(lo, so) {
                var bs = 1 - so, Rs = ao.mulItems(ao.subtract(lo[1], lo[0]), 3 * bs * bs), js = ao.mulItems(ao.subtract(lo[2], lo[1]), 6 * bs * so), qs = ao.mulItems(ao.subtract(lo[3], lo[2]), 3 * so * so);
                return ao.addArrays(ao.addArrays(Rs, js), qs);
              }
              static qprimeprime(lo, so) {
                return ao.addArrays(ao.mulItems(ao.addArrays(ao.subtract(lo[2], ao.mulItems(lo[1], 2)), lo[0]), 6 * (1 - so)), ao.mulItems(ao.addArrays(ao.subtract(lo[3], ao.mulItems(lo[2], 2)), lo[1]), 6 * so));
              }
            }
            Bi.exports = e, Bi.exports.fitCubic = Ui, Bi.exports.createTangent = io;
          },
          /* 27 */
          /***/
          (Bi, e, Ui) => {
            var Tl, Af, Tf, Cf;
            Object.defineProperty(e, "__esModule", {
              value: !0
            }), e.AnnotationLayer = void 0;
            var Zi = Ui(1), ta = Ui(8), na = Ui(5), ia = Ui(28), aa = Ui(29);
            const da = 1e3, La = 9, qa = /* @__PURE__ */ new WeakSet();
            function io(Rl) {
              return {
                width: Rl[2] - Rl[0],
                height: Rl[3] - Rl[1]
              };
            }
            class ao {
              static create(uo) {
                switch (uo.data.annotationType) {
                  case Zi.AnnotationType.LINK:
                    return new no(uo);
                  case Zi.AnnotationType.TEXT:
                    return new lo(uo);
                  case Zi.AnnotationType.WIDGET:
                    switch (uo.data.fieldType) {
                      case "Tx":
                        return new bs(uo);
                      case "Btn":
                        return uo.data.radioButton ? new js(uo) : uo.data.checkBox ? new Rs(uo) : new qs(uo);
                      case "Ch":
                        return new jo(uo);
                    }
                    return new so(uo);
                  case Zi.AnnotationType.POPUP:
                    return new fs(uo);
                  case Zi.AnnotationType.FREETEXT:
                    return new co(uo);
                  case Zi.AnnotationType.LINE:
                    return new Co(uo);
                  case Zi.AnnotationType.SQUARE:
                    return new Zs(uo);
                  case Zi.AnnotationType.CIRCLE:
                    return new xl(uo);
                  case Zi.AnnotationType.POLYLINE:
                    return new Cl(uo);
                  case Zi.AnnotationType.CARET:
                    return new Ol(uo);
                  case Zi.AnnotationType.INK:
                    return new Bl(uo);
                  case Zi.AnnotationType.POLYGON:
                    return new Al(uo);
                  case Zi.AnnotationType.HIGHLIGHT:
                    return new Ml(uo);
                  case Zi.AnnotationType.UNDERLINE:
                    return new Vl(uo);
                  case Zi.AnnotationType.SQUIGGLY:
                    return new Ll(uo);
                  case Zi.AnnotationType.STRIKEOUT:
                    return new Yl(uo);
                  case Zi.AnnotationType.STAMP:
                    return new Zl(uo);
                  case Zi.AnnotationType.FILEATTACHMENT:
                    return new tc(uo);
                  default:
                    return new oo(uo);
                }
              }
            }
            class oo {
              constructor(uo, {
                isRenderable: Is = !1,
                ignoreBorder: Sl = !1,
                createQuadrilaterals: wl = !1
              } = {}) {
                this.isRenderable = Is, this.data = uo.data, this.layer = uo.layer, this.page = uo.page, this.viewport = uo.viewport, this.linkService = uo.linkService, this.downloadManager = uo.downloadManager, this.imageResourcesPath = uo.imageResourcesPath, this.renderForms = uo.renderForms, this.svgFactory = uo.svgFactory, this.annotationStorage = uo.annotationStorage, this.enableScripting = uo.enableScripting, this.hasJSActions = uo.hasJSActions, this._fieldObjects = uo.fieldObjects, this._mouseState = uo.mouseState, Is && (this.container = this._createContainer(Sl)), wl && (this.quadrilaterals = this._createQuadrilaterals(Sl));
              }
              _createContainer(uo = !1) {
                const Is = this.data, Sl = this.page, wl = this.viewport, Pl = document.createElement("section"), {
                  width: jl,
                  height: Dl
                } = io(Is.rect), [$l, kl, zl, Hl] = wl.viewBox, Wl = zl - $l, ql = Hl - kl;
                Pl.setAttribute("data-annotation-id", Is.id);
                const Jl = Zi.Util.normalizeRect([Is.rect[0], Sl.view[3] - Is.rect[1] + Sl.view[1], Is.rect[2], Sl.view[3] - Is.rect[3] + Sl.view[1]]);
                if (!uo && Is.borderStyle.width > 0) {
                  Pl.style.borderWidth = `${Is.borderStyle.width}px`;
                  const Xl = Is.borderStyle.horizontalCornerRadius, sc = Is.borderStyle.verticalCornerRadius;
                  if (Xl > 0 || sc > 0) {
                    const dc = `calc(${Xl}px * var(--scale-factor)) / calc(${sc}px * var(--scale-factor))`;
                    Pl.style.borderRadius = dc;
                  } else if (this instanceof js) {
                    const dc = `calc(${jl}px * var(--scale-factor)) / calc(${Dl}px * var(--scale-factor))`;
                    Pl.style.borderRadius = dc;
                  }
                  switch (Is.borderStyle.style) {
                    case Zi.AnnotationBorderStyleType.SOLID:
                      Pl.style.borderStyle = "solid";
                      break;
                    case Zi.AnnotationBorderStyleType.DASHED:
                      Pl.style.borderStyle = "dashed";
                      break;
                    case Zi.AnnotationBorderStyleType.BEVELED:
                      (0, Zi.warn)("Unimplemented border style: beveled");
                      break;
                    case Zi.AnnotationBorderStyleType.INSET:
                      (0, Zi.warn)("Unimplemented border style: inset");
                      break;
                    case Zi.AnnotationBorderStyleType.UNDERLINE:
                      Pl.style.borderBottomStyle = "solid";
                      break;
                  }
                  const Hu = Is.borderColor || null;
                  Hu ? Pl.style.borderColor = Zi.Util.makeHexColor(Hu[0] | 0, Hu[1] | 0, Hu[2] | 0) : Pl.style.borderWidth = 0;
                }
                Pl.style.left = `${100 * (Jl[0] - $l) / Wl}%`, Pl.style.top = `${100 * (Jl[1] - kl) / ql}%`;
                const {
                  rotation: ac
                } = Is;
                return Is.hasOwnCanvas || ac === 0 ? (Pl.style.width = `${100 * jl / Wl}%`, Pl.style.height = `${100 * Dl / ql}%`) : this.setRotation(ac, Pl), Pl;
              }
              setRotation(uo, Is = this.container) {
                const [Sl, wl, Pl, jl] = this.viewport.viewBox, Dl = Pl - Sl, $l = jl - wl, {
                  width: kl,
                  height: zl
                } = io(this.data.rect);
                let Hl, Wl;
                uo % 180 === 0 ? (Hl = 100 * kl / Dl, Wl = 100 * zl / $l) : (Hl = 100 * zl / Dl, Wl = 100 * kl / $l), Is.style.width = `${Hl}%`, Is.style.height = `${Wl}%`, Is.setAttribute("data-main-rotation", (360 - uo) % 360);
              }
              get _commonActions() {
                const uo = (Is, Sl, wl) => {
                  const Pl = wl.detail[Is];
                  wl.target.style[Sl] = ia.ColorConverters[`${Pl[0]}_HTML`](Pl.slice(1));
                };
                return (0, Zi.shadow)(this, "_commonActions", {
                  display: (Is) => {
                    const Sl = Is.detail.display % 2 === 1;
                    this.container.style.visibility = Sl ? "hidden" : "visible", this.annotationStorage.setValue(this.data.id, {
                      hidden: Sl,
                      print: Is.detail.display === 0 || Is.detail.display === 3
                    });
                  },
                  print: (Is) => {
                    this.annotationStorage.setValue(this.data.id, {
                      print: Is.detail.print
                    });
                  },
                  hidden: (Is) => {
                    this.container.style.visibility = Is.detail.hidden ? "hidden" : "visible", this.annotationStorage.setValue(this.data.id, {
                      hidden: Is.detail.hidden
                    });
                  },
                  focus: (Is) => {
                    setTimeout(() => Is.target.focus({
                      preventScroll: !1
                    }), 0);
                  },
                  userName: (Is) => {
                    Is.target.title = Is.detail.userName;
                  },
                  readonly: (Is) => {
                    Is.detail.readonly ? Is.target.setAttribute("readonly", "") : Is.target.removeAttribute("readonly");
                  },
                  required: (Is) => {
                    this._setRequired(Is.target, Is.detail.required);
                  },
                  bgColor: (Is) => {
                    uo("bgColor", "backgroundColor", Is);
                  },
                  fillColor: (Is) => {
                    uo("fillColor", "backgroundColor", Is);
                  },
                  fgColor: (Is) => {
                    uo("fgColor", "color", Is);
                  },
                  textColor: (Is) => {
                    uo("textColor", "color", Is);
                  },
                  borderColor: (Is) => {
                    uo("borderColor", "borderColor", Is);
                  },
                  strokeColor: (Is) => {
                    uo("strokeColor", "borderColor", Is);
                  },
                  rotation: (Is) => {
                    const Sl = Is.detail.rotation;
                    this.setRotation(Sl), this.annotationStorage.setValue(this.data.id, {
                      rotation: Sl
                    });
                  }
                });
              }
              _dispatchEventFromSandbox(uo, Is) {
                const Sl = this._commonActions;
                for (const wl of Object.keys(Is.detail)) {
                  const Pl = uo[wl] || Sl[wl];
                  Pl && Pl(Is);
                }
              }
              _setDefaultPropertiesFromJS(uo) {
                if (!this.enableScripting)
                  return;
                const Is = this.annotationStorage.getRawValue(this.data.id);
                if (!Is)
                  return;
                const Sl = this._commonActions;
                for (const [wl, Pl] of Object.entries(Is)) {
                  const jl = Sl[wl];
                  if (jl) {
                    const Dl = {
                      detail: {
                        [wl]: Pl
                      },
                      target: uo
                    };
                    jl(Dl), delete Is[wl];
                  }
                }
              }
              _createQuadrilaterals(uo = !1) {
                if (!this.data.quadPoints)
                  return null;
                const Is = [], Sl = this.data.rect;
                for (const wl of this.data.quadPoints)
                  this.data.rect = [wl[2].x, wl[2].y, wl[1].x, wl[1].y], Is.push(this._createContainer(uo));
                return this.data.rect = Sl, Is;
              }
              _createPopup(uo, Is) {
                let Sl = this.container;
                this.quadrilaterals && (uo = uo || this.quadrilaterals, Sl = this.quadrilaterals[0]), uo || (uo = document.createElement("div"), uo.className = "popupTriggerArea", Sl.append(uo));
                const Pl = new Ao({
                  container: Sl,
                  trigger: uo,
                  color: Is.color,
                  titleObj: Is.titleObj,
                  modificationDate: Is.modificationDate,
                  contentsObj: Is.contentsObj,
                  richText: Is.richText,
                  hideWrapper: !0
                }).render();
                Pl.style.left = "100%", Sl.append(Pl);
              }
              _renderQuadrilaterals(uo) {
                for (const Is of this.quadrilaterals)
                  Is.className = uo;
                return this.quadrilaterals;
              }
              render() {
                (0, Zi.unreachable)("Abstract method `AnnotationElement.render` called");
              }
              _getElementsByName(uo, Is = null) {
                const Sl = [];
                if (this._fieldObjects) {
                  const wl = this._fieldObjects[uo];
                  if (wl)
                    for (const {
                      page: Pl,
                      id: jl,
                      exportValues: Dl
                    } of wl) {
                      if (Pl === -1 || jl === Is)
                        continue;
                      const $l = typeof Dl == "string" ? Dl : null, kl = document.querySelector(`[data-element-id="${jl}"]`);
                      if (kl && !qa.has(kl)) {
                        (0, Zi.warn)(`_getElementsByName - element not allowed: ${jl}`);
                        continue;
                      }
                      Sl.push({
                        id: jl,
                        exportValue: $l,
                        domElement: kl
                      });
                    }
                  return Sl;
                }
                for (const wl of document.getElementsByName(uo)) {
                  const {
                    id: Pl,
                    exportValue: jl
                  } = wl;
                  Pl !== Is && qa.has(wl) && Sl.push({
                    id: Pl,
                    exportValue: jl,
                    domElement: wl
                  });
                }
                return Sl;
              }
              static get platform() {
                const uo = typeof navigator < "u" ? navigator.platform : "";
                return (0, Zi.shadow)(this, "platform", {
                  isWin: uo.includes("Win"),
                  isMac: uo.includes("Mac")
                });
              }
            }
            class no extends oo {
              constructor(uo, Is = null) {
                super(uo, {
                  isRenderable: !0,
                  ignoreBorder: !!Is?.ignoreBorder,
                  createQuadrilaterals: !0
                }), this.isTooltipOnly = uo.data.isTooltipOnly;
              }
              render() {
                const {
                  data: uo,
                  linkService: Is
                } = this, Sl = document.createElement("a");
                Sl.setAttribute("data-element-id", uo.id);
                let wl = !1;
                return uo.url ? (Is.addLinkAttributes(Sl, uo.url, uo.newWindow), wl = !0) : uo.action ? (this._bindNamedAction(Sl, uo.action), wl = !0) : uo.dest ? (this._bindLink(Sl, uo.dest), wl = !0) : (uo.actions && (uo.actions.Action || uo.actions["Mouse Up"] || uo.actions["Mouse Down"]) && this.enableScripting && this.hasJSActions && (this._bindJSAction(Sl, uo), wl = !0), uo.resetForm ? (this._bindResetFormAction(Sl, uo.resetForm), wl = !0) : this.isTooltipOnly && !wl && (this._bindLink(Sl, ""), wl = !0)), this.quadrilaterals ? this._renderQuadrilaterals("linkAnnotation").map((Pl, jl) => {
                  const Dl = jl === 0 ? Sl : Sl.cloneNode();
                  return Pl.append(Dl), Pl;
                }) : (this.container.className = "linkAnnotation", wl && this.container.append(Sl), this.container);
              }
              _bindLink(uo, Is) {
                uo.href = this.linkService.getDestinationHash(Is), uo.onclick = () => (Is && this.linkService.goToDestination(Is), !1), (Is || Is === "") && (uo.className = "internalLink");
              }
              _bindNamedAction(uo, Is) {
                uo.href = this.linkService.getAnchorUrl(""), uo.onclick = () => (this.linkService.executeNamedAction(Is), !1), uo.className = "internalLink";
              }
              _bindJSAction(uo, Is) {
                uo.href = this.linkService.getAnchorUrl("");
                const Sl = /* @__PURE__ */ new Map([["Action", "onclick"], ["Mouse Up", "onmouseup"], ["Mouse Down", "onmousedown"]]);
                for (const wl of Object.keys(Is.actions)) {
                  const Pl = Sl.get(wl);
                  Pl && (uo[Pl] = () => (this.linkService.eventBus?.dispatch("dispatcheventinsandbox", {
                    source: this,
                    detail: {
                      id: Is.id,
                      name: wl
                    }
                  }), !1));
                }
                uo.onclick || (uo.onclick = () => !1), uo.className = "internalLink";
              }
              _bindResetFormAction(uo, Is) {
                const Sl = uo.onclick;
                if (Sl || (uo.href = this.linkService.getAnchorUrl("")), uo.className = "internalLink", !this._fieldObjects) {
                  (0, Zi.warn)('_bindResetFormAction - "resetForm" action not supported, ensure that the `fieldObjects` parameter is provided.'), Sl || (uo.onclick = () => !1);
                  return;
                }
                uo.onclick = () => {
                  Sl && Sl();
                  const {
                    fields: wl,
                    refs: Pl,
                    include: jl
                  } = Is, Dl = [];
                  if (wl.length !== 0 || Pl.length !== 0) {
                    const zl = new Set(Pl);
                    for (const Hl of wl) {
                      const Wl = this._fieldObjects[Hl] || [];
                      for (const {
                        id: ql
                      } of Wl)
                        zl.add(ql);
                    }
                    for (const Hl of Object.values(this._fieldObjects))
                      for (const Wl of Hl)
                        zl.has(Wl.id) === jl && Dl.push(Wl);
                  } else
                    for (const zl of Object.values(this._fieldObjects))
                      Dl.push(...zl);
                  const $l = this.annotationStorage, kl = [];
                  for (const zl of Dl) {
                    const {
                      id: Hl
                    } = zl;
                    switch (kl.push(Hl), zl.type) {
                      case "text": {
                        const ql = zl.defaultValue || "";
                        $l.setValue(Hl, {
                          value: ql
                        });
                        break;
                      }
                      case "checkbox":
                      case "radiobutton": {
                        const ql = zl.defaultValue === zl.exportValues;
                        $l.setValue(Hl, {
                          value: ql
                        });
                        break;
                      }
                      case "combobox":
                      case "listbox": {
                        const ql = zl.defaultValue || "";
                        $l.setValue(Hl, {
                          value: ql
                        });
                        break;
                      }
                      default:
                        continue;
                    }
                    const Wl = document.querySelector(`[data-element-id="${Hl}"]`);
                    if (Wl) {
                      if (!qa.has(Wl)) {
                        (0, Zi.warn)(`_bindResetFormAction - element not allowed: ${Hl}`);
                        continue;
                      }
                    } else continue;
                    Wl.dispatchEvent(new Event("resetform"));
                  }
                  return this.enableScripting && this.linkService.eventBus?.dispatch("dispatcheventinsandbox", {
                    source: this,
                    detail: {
                      id: "app",
                      ids: kl,
                      name: "ResetForm"
                    }
                  }), !1;
                };
              }
            }
            class lo extends oo {
              constructor(uo) {
                const Is = !!(uo.data.hasPopup || uo.data.titleObj?.str || uo.data.contentsObj?.str || uo.data.richText?.str);
                super(uo, {
                  isRenderable: Is
                });
              }
              render() {
                this.container.className = "textAnnotation";
                const uo = document.createElement("img");
                return uo.src = this.imageResourcesPath + "annotation-" + this.data.name.toLowerCase() + ".svg", uo.alt = "[{{type}} Annotation]", uo.dataset.l10nId = "text_annotation_type", uo.dataset.l10nArgs = JSON.stringify({
                  type: this.data.name
                }), this.data.hasPopup || this._createPopup(uo, this.data), this.container.append(uo), this.container;
              }
            }
            class so extends oo {
              render() {
                return this.data.alternativeText && (this.container.title = this.data.alternativeText), this.container;
              }
              _getKeyModifier(uo) {
                const {
                  isWin: Is,
                  isMac: Sl
                } = oo.platform;
                return Is && uo.ctrlKey || Sl && uo.metaKey;
              }
              _setEventListener(uo, Is, Sl, wl) {
                Is.includes("mouse") ? uo.addEventListener(Is, (Pl) => {
                  this.linkService.eventBus?.dispatch("dispatcheventinsandbox", {
                    source: this,
                    detail: {
                      id: this.data.id,
                      name: Sl,
                      value: wl(Pl),
                      shift: Pl.shiftKey,
                      modifier: this._getKeyModifier(Pl)
                    }
                  });
                }) : uo.addEventListener(Is, (Pl) => {
                  this.linkService.eventBus?.dispatch("dispatcheventinsandbox", {
                    source: this,
                    detail: {
                      id: this.data.id,
                      name: Sl,
                      value: wl(Pl)
                    }
                  });
                });
              }
              _setEventListeners(uo, Is, Sl) {
                for (const [wl, Pl] of Is)
                  (Pl === "Action" || this.data.actions?.[Pl]) && this._setEventListener(uo, wl, Pl, Sl);
              }
              _setBackgroundColor(uo) {
                const Is = this.data.backgroundColor || null;
                uo.style.backgroundColor = Is === null ? "transparent" : Zi.Util.makeHexColor(Is[0], Is[1], Is[2]);
              }
              _setTextStyle(uo) {
                const Is = ["left", "center", "right"], {
                  fontColor: Sl
                } = this.data.defaultAppearanceData, wl = this.data.defaultAppearanceData.fontSize || La, Pl = uo.style;
                let jl;
                if (this.data.multiLine) {
                  const Dl = Math.abs(this.data.rect[3] - this.data.rect[1]), $l = Math.round(Dl / (Zi.LINE_FACTOR * wl)) || 1, kl = Dl / $l;
                  jl = Math.min(wl, Math.round(kl / Zi.LINE_FACTOR));
                } else {
                  const Dl = Math.abs(this.data.rect[3] - this.data.rect[1]);
                  jl = Math.min(wl, Math.round(Dl / Zi.LINE_FACTOR));
                }
                Pl.fontSize = `calc(${jl}px * var(--scale-factor))`, Pl.color = Zi.Util.makeHexColor(Sl[0], Sl[1], Sl[2]), this.data.textAlignment !== null && (Pl.textAlign = Is[this.data.textAlignment]);
              }
              _setRequired(uo, Is) {
                Is ? uo.setAttribute("required", !0) : uo.removeAttribute("required"), uo.setAttribute("aria-required", Is);
              }
            }
            class bs extends so {
              constructor(uo) {
                const Is = uo.renderForms || !uo.data.hasAppearance && !!uo.data.fieldValue;
                super(uo, {
                  isRenderable: Is
                });
              }
              setPropertyOnSiblings(uo, Is, Sl, wl) {
                const Pl = this.annotationStorage;
                for (const jl of this._getElementsByName(uo.name, uo.id))
                  jl.domElement && (jl.domElement[Is] = Sl), Pl.setValue(jl.id, {
                    [wl]: Sl
                  });
              }
              render() {
                const uo = this.annotationStorage, Is = this.data.id;
                this.container.className = "textWidgetAnnotation";
                let Sl = null;
                if (this.renderForms) {
                  const wl = uo.getValue(Is, {
                    value: this.data.fieldValue
                  });
                  let Pl = wl.formattedValue || wl.value || "";
                  const jl = uo.getValue(Is, {
                    charLimit: this.data.maxLen
                  }).charLimit;
                  jl && Pl.length > jl && (Pl = Pl.slice(0, jl));
                  const Dl = {
                    userValue: Pl,
                    formattedValue: null,
                    valueOnFocus: ""
                  };
                  this.data.multiLine ? (Sl = document.createElement("textarea"), Sl.textContent = Pl, this.data.doNotScroll && (Sl.style.overflowY = "hidden")) : (Sl = document.createElement("input"), Sl.type = "text", Sl.setAttribute("value", Pl), this.data.doNotScroll && (Sl.style.overflowX = "hidden")), qa.add(Sl), Sl.setAttribute("data-element-id", Is), Sl.disabled = this.data.readOnly, Sl.name = this.data.fieldName, Sl.tabIndex = da, this._setRequired(Sl, this.data.required), jl && (Sl.maxLength = jl), Sl.addEventListener("input", (kl) => {
                    uo.setValue(Is, {
                      value: kl.target.value
                    }), this.setPropertyOnSiblings(Sl, "value", kl.target.value, "value");
                  }), Sl.addEventListener("resetform", (kl) => {
                    const zl = this.data.defaultFieldValue ?? "";
                    Sl.value = Dl.userValue = zl, Dl.formattedValue = null;
                  });
                  let $l = (kl) => {
                    const {
                      formattedValue: zl
                    } = Dl;
                    zl != null && (kl.target.value = zl), kl.target.scrollLeft = 0;
                  };
                  if (this.enableScripting && this.hasJSActions) {
                    Sl.addEventListener("focus", (zl) => {
                      Dl.userValue && (zl.target.value = Dl.userValue), Dl.valueOnFocus = zl.target.value;
                    }), Sl.addEventListener("updatefromsandbox", (zl) => {
                      const Hl = {
                        value(Wl) {
                          Dl.userValue = Wl.detail.value ?? "", uo.setValue(Is, {
                            value: Dl.userValue.toString()
                          }), Wl.target.value = Dl.userValue;
                        },
                        formattedValue(Wl) {
                          const {
                            formattedValue: ql
                          } = Wl.detail;
                          Dl.formattedValue = ql, ql != null && Wl.target !== document.activeElement && (Wl.target.value = ql), uo.setValue(Is, {
                            formattedValue: ql
                          });
                        },
                        selRange(Wl) {
                          Wl.target.setSelectionRange(...Wl.detail.selRange);
                        },
                        charLimit: (Wl) => {
                          const {
                            charLimit: ql
                          } = Wl.detail, {
                            target: Jl
                          } = Wl;
                          if (ql === 0) {
                            Jl.removeAttribute("maxLength");
                            return;
                          }
                          Jl.setAttribute("maxLength", ql);
                          let ac = Dl.userValue;
                          !ac || ac.length <= ql || (ac = ac.slice(0, ql), Jl.value = Dl.userValue = ac, uo.setValue(Is, {
                            value: ac
                          }), this.linkService.eventBus?.dispatch("dispatcheventinsandbox", {
                            source: this,
                            detail: {
                              id: Is,
                              name: "Keystroke",
                              value: ac,
                              willCommit: !0,
                              commitKey: 1,
                              selStart: Jl.selectionStart,
                              selEnd: Jl.selectionEnd
                            }
                          }));
                        }
                      };
                      this._dispatchEventFromSandbox(Hl, zl);
                    }), Sl.addEventListener("keydown", (zl) => {
                      let Hl = -1;
                      if (zl.key === "Escape" ? Hl = 0 : zl.key === "Enter" ? Hl = 2 : zl.key === "Tab" && (Hl = 3), Hl === -1)
                        return;
                      const {
                        value: Wl
                      } = zl.target;
                      Dl.valueOnFocus !== Wl && (Dl.userValue = Wl, this.linkService.eventBus?.dispatch("dispatcheventinsandbox", {
                        source: this,
                        detail: {
                          id: Is,
                          name: "Keystroke",
                          value: Wl,
                          willCommit: !0,
                          commitKey: Hl,
                          selStart: zl.target.selectionStart,
                          selEnd: zl.target.selectionEnd
                        }
                      }));
                    });
                    const kl = $l;
                    $l = null, Sl.addEventListener("blur", (zl) => {
                      const {
                        value: Hl
                      } = zl.target;
                      Dl.userValue = Hl, this._mouseState.isDown && Dl.valueOnFocus !== Hl && this.linkService.eventBus?.dispatch("dispatcheventinsandbox", {
                        source: this,
                        detail: {
                          id: Is,
                          name: "Keystroke",
                          value: Hl,
                          willCommit: !0,
                          commitKey: 1,
                          selStart: zl.target.selectionStart,
                          selEnd: zl.target.selectionEnd
                        }
                      }), kl(zl);
                    }), this.data.actions?.Keystroke && Sl.addEventListener("beforeinput", (zl) => {
                      const {
                        data: Hl,
                        target: Wl
                      } = zl, {
                        value: ql,
                        selectionStart: Jl,
                        selectionEnd: ac
                      } = Wl;
                      let Xl = Jl, sc = ac;
                      switch (zl.inputType) {
                        case "deleteWordBackward": {
                          const Hu = ql.substring(0, Jl).match(/\w*[^\w]*$/);
                          Hu && (Xl -= Hu[0].length);
                          break;
                        }
                        case "deleteWordForward": {
                          const Hu = ql.substring(Jl).match(/^[^\w]*\w*/);
                          Hu && (sc += Hu[0].length);
                          break;
                        }
                        case "deleteContentBackward":
                          Jl === ac && (Xl -= 1);
                          break;
                        case "deleteContentForward":
                          Jl === ac && (sc += 1);
                          break;
                      }
                      zl.preventDefault(), this.linkService.eventBus?.dispatch("dispatcheventinsandbox", {
                        source: this,
                        detail: {
                          id: Is,
                          name: "Keystroke",
                          value: ql,
                          change: Hl || "",
                          willCommit: !1,
                          selStart: Xl,
                          selEnd: sc
                        }
                      });
                    }), this._setEventListeners(Sl, [["focus", "Focus"], ["blur", "Blur"], ["mousedown", "Mouse Down"], ["mouseenter", "Mouse Enter"], ["mouseleave", "Mouse Exit"], ["mouseup", "Mouse Up"]], (zl) => zl.target.value);
                  }
                  if ($l && Sl.addEventListener("blur", $l), this.data.comb) {
                    const zl = (this.data.rect[2] - this.data.rect[0]) / jl;
                    Sl.classList.add("comb"), Sl.style.letterSpacing = `calc(${zl}px * var(--scale-factor) - 1ch)`;
                  }
                } else
                  Sl = document.createElement("div"), Sl.textContent = this.data.fieldValue, Sl.style.verticalAlign = "middle", Sl.style.display = "table-cell";
                return this._setTextStyle(Sl), this._setBackgroundColor(Sl), this._setDefaultPropertiesFromJS(Sl), this.container.append(Sl), this.container;
              }
            }
            class Rs extends so {
              constructor(uo) {
                super(uo, {
                  isRenderable: uo.renderForms
                });
              }
              render() {
                const uo = this.annotationStorage, Is = this.data, Sl = Is.id;
                let wl = uo.getValue(Sl, {
                  value: Is.exportValue === Is.fieldValue
                }).value;
                typeof wl == "string" && (wl = wl !== "Off", uo.setValue(Sl, {
                  value: wl
                })), this.container.className = "buttonWidgetAnnotation checkBox";
                const Pl = document.createElement("input");
                return qa.add(Pl), Pl.setAttribute("data-element-id", Sl), Pl.disabled = Is.readOnly, this._setRequired(Pl, this.data.required), Pl.type = "checkbox", Pl.name = Is.fieldName, wl && Pl.setAttribute("checked", !0), Pl.setAttribute("exportValue", Is.exportValue), Pl.tabIndex = da, Pl.addEventListener("change", (jl) => {
                  const {
                    name: Dl,
                    checked: $l
                  } = jl.target;
                  for (const kl of this._getElementsByName(Dl, Sl)) {
                    const zl = $l && kl.exportValue === Is.exportValue;
                    kl.domElement && (kl.domElement.checked = zl), uo.setValue(kl.id, {
                      value: zl
                    });
                  }
                  uo.setValue(Sl, {
                    value: $l
                  });
                }), Pl.addEventListener("resetform", (jl) => {
                  const Dl = Is.defaultFieldValue || "Off";
                  jl.target.checked = Dl === Is.exportValue;
                }), this.enableScripting && this.hasJSActions && (Pl.addEventListener("updatefromsandbox", (jl) => {
                  const Dl = {
                    value($l) {
                      $l.target.checked = $l.detail.value !== "Off", uo.setValue(Sl, {
                        value: $l.target.checked
                      });
                    }
                  };
                  this._dispatchEventFromSandbox(Dl, jl);
                }), this._setEventListeners(Pl, [["change", "Validate"], ["change", "Action"], ["focus", "Focus"], ["blur", "Blur"], ["mousedown", "Mouse Down"], ["mouseenter", "Mouse Enter"], ["mouseleave", "Mouse Exit"], ["mouseup", "Mouse Up"]], (jl) => jl.target.checked)), this._setBackgroundColor(Pl), this._setDefaultPropertiesFromJS(Pl), this.container.append(Pl), this.container;
              }
            }
            class js extends so {
              constructor(uo) {
                super(uo, {
                  isRenderable: uo.renderForms
                });
              }
              render() {
                this.container.className = "buttonWidgetAnnotation radioButton";
                const uo = this.annotationStorage, Is = this.data, Sl = Is.id;
                let wl = uo.getValue(Sl, {
                  value: Is.fieldValue === Is.buttonValue
                }).value;
                typeof wl == "string" && (wl = wl !== Is.buttonValue, uo.setValue(Sl, {
                  value: wl
                }));
                const Pl = document.createElement("input");
                if (qa.add(Pl), Pl.setAttribute("data-element-id", Sl), Pl.disabled = Is.readOnly, this._setRequired(Pl, this.data.required), Pl.type = "radio", Pl.name = Is.fieldName, wl && Pl.setAttribute("checked", !0), Pl.tabIndex = da, Pl.addEventListener("change", (jl) => {
                  const {
                    name: Dl,
                    checked: $l
                  } = jl.target;
                  for (const kl of this._getElementsByName(Dl, Sl))
                    uo.setValue(kl.id, {
                      value: !1
                    });
                  uo.setValue(Sl, {
                    value: $l
                  });
                }), Pl.addEventListener("resetform", (jl) => {
                  const Dl = Is.defaultFieldValue;
                  jl.target.checked = Dl != null && Dl === Is.buttonValue;
                }), this.enableScripting && this.hasJSActions) {
                  const jl = Is.buttonValue;
                  Pl.addEventListener("updatefromsandbox", (Dl) => {
                    const $l = {
                      value: (kl) => {
                        const zl = jl === kl.detail.value;
                        for (const Hl of this._getElementsByName(kl.target.name)) {
                          const Wl = zl && Hl.id === Sl;
                          Hl.domElement && (Hl.domElement.checked = Wl), uo.setValue(Hl.id, {
                            value: Wl
                          });
                        }
                      }
                    };
                    this._dispatchEventFromSandbox($l, Dl);
                  }), this._setEventListeners(Pl, [["change", "Validate"], ["change", "Action"], ["focus", "Focus"], ["blur", "Blur"], ["mousedown", "Mouse Down"], ["mouseenter", "Mouse Enter"], ["mouseleave", "Mouse Exit"], ["mouseup", "Mouse Up"]], (Dl) => Dl.target.checked);
                }
                return this._setBackgroundColor(Pl), this._setDefaultPropertiesFromJS(Pl), this.container.append(Pl), this.container;
              }
            }
            class qs extends no {
              constructor(uo) {
                super(uo, {
                  ignoreBorder: uo.data.hasAppearance
                });
              }
              render() {
                const uo = super.render();
                uo.className = "buttonWidgetAnnotation pushButton", this.data.alternativeText && (uo.title = this.data.alternativeText);
                const Is = uo.lastChild;
                return this.enableScripting && this.hasJSActions && Is && (this._setDefaultPropertiesFromJS(Is), Is.addEventListener("updatefromsandbox", (Sl) => {
                  this._dispatchEventFromSandbox({}, Sl);
                })), uo;
              }
            }
            class jo extends so {
              constructor(uo) {
                super(uo, {
                  isRenderable: uo.renderForms
                });
              }
              render() {
                this.container.className = "choiceWidgetAnnotation";
                const uo = this.annotationStorage, Is = this.data.id, Sl = uo.getValue(Is, {
                  value: this.data.fieldValue
                }), wl = document.createElement("select");
                qa.add(wl), wl.setAttribute("data-element-id", Is), wl.disabled = this.data.readOnly, this._setRequired(wl, this.data.required), wl.name = this.data.fieldName, wl.tabIndex = da;
                let Pl = this.data.combo && this.data.options.length > 0;
                this.data.combo || (wl.size = this.data.options.length, this.data.multiSelect && (wl.multiple = !0)), wl.addEventListener("resetform", (kl) => {
                  const zl = this.data.defaultFieldValue;
                  for (const Hl of wl.options)
                    Hl.selected = Hl.value === zl;
                });
                for (const kl of this.data.options) {
                  const zl = document.createElement("option");
                  zl.textContent = kl.displayValue, zl.value = kl.exportValue, Sl.value.includes(kl.exportValue) && (zl.setAttribute("selected", !0), Pl = !1), wl.append(zl);
                }
                let jl = null;
                if (Pl) {
                  const kl = document.createElement("option");
                  kl.value = " ", kl.setAttribute("hidden", !0), kl.setAttribute("selected", !0), wl.prepend(kl), jl = () => {
                    kl.remove(), wl.removeEventListener("input", jl), jl = null;
                  }, wl.addEventListener("input", jl);
                }
                const Dl = (kl, zl) => {
                  const Hl = zl ? "value" : "textContent", Wl = kl.target.options;
                  return kl.target.multiple ? Array.prototype.filter.call(Wl, (ql) => ql.selected).map((ql) => ql[Hl]) : Wl.selectedIndex === -1 ? null : Wl[Wl.selectedIndex][Hl];
                }, $l = (kl) => {
                  const zl = kl.target.options;
                  return Array.prototype.map.call(zl, (Hl) => ({
                    displayValue: Hl.textContent,
                    exportValue: Hl.value
                  }));
                };
                return this.enableScripting && this.hasJSActions ? (wl.addEventListener("updatefromsandbox", (kl) => {
                  const zl = {
                    value(Hl) {
                      jl?.();
                      const Wl = Hl.detail.value, ql = new Set(Array.isArray(Wl) ? Wl : [Wl]);
                      for (const Jl of wl.options)
                        Jl.selected = ql.has(Jl.value);
                      uo.setValue(Is, {
                        value: Dl(Hl, !0)
                      });
                    },
                    multipleSelection(Hl) {
                      wl.multiple = !0;
                    },
                    remove(Hl) {
                      const Wl = wl.options, ql = Hl.detail.remove;
                      Wl[ql].selected = !1, wl.remove(ql), Wl.length > 0 && Array.prototype.findIndex.call(Wl, (ac) => ac.selected) === -1 && (Wl[0].selected = !0), uo.setValue(Is, {
                        value: Dl(Hl, !0),
                        items: $l(Hl)
                      });
                    },
                    clear(Hl) {
                      for (; wl.length !== 0; )
                        wl.remove(0);
                      uo.setValue(Is, {
                        value: null,
                        items: []
                      });
                    },
                    insert(Hl) {
                      const {
                        index: Wl,
                        displayValue: ql,
                        exportValue: Jl
                      } = Hl.detail.insert, ac = wl.children[Wl], Xl = document.createElement("option");
                      Xl.textContent = ql, Xl.value = Jl, ac ? ac.before(Xl) : wl.append(Xl), uo.setValue(Is, {
                        value: Dl(Hl, !0),
                        items: $l(Hl)
                      });
                    },
                    items(Hl) {
                      const {
                        items: Wl
                      } = Hl.detail;
                      for (; wl.length !== 0; )
                        wl.remove(0);
                      for (const ql of Wl) {
                        const {
                          displayValue: Jl,
                          exportValue: ac
                        } = ql, Xl = document.createElement("option");
                        Xl.textContent = Jl, Xl.value = ac, wl.append(Xl);
                      }
                      wl.options.length > 0 && (wl.options[0].selected = !0), uo.setValue(Is, {
                        value: Dl(Hl, !0),
                        items: $l(Hl)
                      });
                    },
                    indices(Hl) {
                      const Wl = new Set(Hl.detail.indices);
                      for (const ql of Hl.target.options)
                        ql.selected = Wl.has(ql.index);
                      uo.setValue(Is, {
                        value: Dl(Hl, !0)
                      });
                    },
                    editable(Hl) {
                      Hl.target.disabled = !Hl.detail.editable;
                    }
                  };
                  this._dispatchEventFromSandbox(zl, kl);
                }), wl.addEventListener("input", (kl) => {
                  const zl = Dl(kl, !0), Hl = Dl(kl, !1);
                  uo.setValue(Is, {
                    value: zl
                  }), this.linkService.eventBus?.dispatch("dispatcheventinsandbox", {
                    source: this,
                    detail: {
                      id: Is,
                      name: "Keystroke",
                      value: Hl,
                      changeEx: zl,
                      willCommit: !0,
                      commitKey: 1,
                      keyDown: !1
                    }
                  });
                }), this._setEventListeners(wl, [["focus", "Focus"], ["blur", "Blur"], ["mousedown", "Mouse Down"], ["mouseenter", "Mouse Enter"], ["mouseleave", "Mouse Exit"], ["mouseup", "Mouse Up"], ["input", "Action"]], (kl) => kl.target.checked)) : wl.addEventListener("input", function(kl) {
                  uo.setValue(Is, {
                    value: Dl(kl, !0)
                  });
                }), this.data.combo && this._setTextStyle(wl), this._setBackgroundColor(wl), this._setDefaultPropertiesFromJS(wl), this.container.append(wl), this.container;
              }
            }
            class fs extends oo {
              constructor(uo) {
                const Is = !!(uo.data.titleObj?.str || uo.data.contentsObj?.str || uo.data.richText?.str);
                super(uo, {
                  isRenderable: Is
                });
              }
              render() {
                const uo = ["Line", "Square", "Circle", "PolyLine", "Polygon", "Ink"];
                if (this.container.className = "popupAnnotation", uo.includes(this.data.parentType))
                  return this.container;
                const Is = `[data-annotation-id="${this.data.parentId}"]`, Sl = this.layer.querySelectorAll(Is);
                if (Sl.length === 0)
                  return this.container;
                const wl = new Ao({
                  container: this.container,
                  trigger: Array.from(Sl),
                  color: this.data.color,
                  titleObj: this.data.titleObj,
                  modificationDate: this.data.modificationDate,
                  contentsObj: this.data.contentsObj,
                  richText: this.data.richText
                }), Pl = this.page, jl = Zi.Util.normalizeRect([this.data.parentRect[0], Pl.view[3] - this.data.parentRect[1] + Pl.view[1], this.data.parentRect[2], Pl.view[3] - this.data.parentRect[3] + Pl.view[1]]), Dl = jl[0] + this.data.parentRect[2] - this.data.parentRect[0], $l = jl[1], [kl, zl, Hl, Wl] = this.viewport.viewBox, ql = Hl - kl, Jl = Wl - zl;
                return this.container.style.left = `${100 * (Dl - kl) / ql}%`, this.container.style.top = `${100 * ($l - zl) / Jl}%`, this.container.append(wl.render()), this.container;
              }
            }
            class Ao {
              constructor(uo) {
                this.container = uo.container, this.trigger = uo.trigger, this.color = uo.color, this.titleObj = uo.titleObj, this.modificationDate = uo.modificationDate, this.contentsObj = uo.contentsObj, this.richText = uo.richText, this.hideWrapper = uo.hideWrapper || !1, this.pinned = !1;
              }
              render() {
                const Is = document.createElement("div");
                Is.className = "popupWrapper", this.hideElement = this.hideWrapper ? Is : this.container, this.hideElement.hidden = !0;
                const Sl = document.createElement("div");
                Sl.className = "popup";
                const wl = this.color;
                if (wl) {
                  const Dl = 0.7 * (255 - wl[0]) + wl[0], $l = 0.7 * (255 - wl[1]) + wl[1], kl = 0.7 * (255 - wl[2]) + wl[2];
                  Sl.style.backgroundColor = Zi.Util.makeHexColor(Dl | 0, $l | 0, kl | 0);
                }
                const Pl = document.createElement("h1");
                Pl.dir = this.titleObj.dir, Pl.textContent = this.titleObj.str, Sl.append(Pl);
                const jl = ta.PDFDateString.toDateObject(this.modificationDate);
                if (jl) {
                  const Dl = document.createElement("span");
                  Dl.className = "popupDate", Dl.textContent = "{{date}}, {{time}}", Dl.dataset.l10nId = "annotation_date_string", Dl.dataset.l10nArgs = JSON.stringify({
                    date: jl.toLocaleDateString(),
                    time: jl.toLocaleTimeString()
                  }), Sl.append(Dl);
                }
                if (this.richText?.str && (!this.contentsObj?.str || this.contentsObj.str === this.richText.str))
                  aa.XfaLayer.render({
                    xfaHtml: this.richText.html,
                    intent: "richText",
                    div: Sl
                  }), Sl.lastChild.className = "richText popupContent";
                else {
                  const Dl = this._formatContents(this.contentsObj);
                  Sl.append(Dl);
                }
                Array.isArray(this.trigger) || (this.trigger = [this.trigger]);
                for (const Dl of this.trigger)
                  Dl.addEventListener("click", this._toggle.bind(this)), Dl.addEventListener("mouseover", this._show.bind(this, !1)), Dl.addEventListener("mouseout", this._hide.bind(this, !1));
                return Sl.addEventListener("click", this._hide.bind(this, !0)), Is.append(Sl), Is;
              }
              _formatContents({
                str: uo,
                dir: Is
              }) {
                const Sl = document.createElement("p");
                Sl.className = "popupContent", Sl.dir = Is;
                const wl = uo.split(/(?:\r\n?|\n)/);
                for (let Pl = 0, jl = wl.length; Pl < jl; ++Pl) {
                  const Dl = wl[Pl];
                  Sl.append(document.createTextNode(Dl)), Pl < jl - 1 && Sl.append(document.createElement("br"));
                }
                return Sl;
              }
              _toggle() {
                this.pinned ? this._hide(!0) : this._show(!0);
              }
              _show(uo = !1) {
                uo && (this.pinned = !0), this.hideElement.hidden && (this.hideElement.hidden = !1, this.container.style.zIndex = parseInt(this.container.style.zIndex) + 1e3);
              }
              _hide(uo = !0) {
                uo && (this.pinned = !1), !this.hideElement.hidden && !this.pinned && (this.hideElement.hidden = !0, this.container.style.zIndex = parseInt(this.container.style.zIndex) - 1e3);
              }
            }
            class co extends oo {
              constructor(uo) {
                const Is = !!(uo.data.hasPopup || uo.data.titleObj?.str || uo.data.contentsObj?.str || uo.data.richText?.str);
                super(uo, {
                  isRenderable: Is,
                  ignoreBorder: !0
                }), this.textContent = uo.data.textContent;
              }
              render() {
                if (this.container.className = "freeTextAnnotation", this.textContent) {
                  const uo = document.createElement("div");
                  uo.className = "annotationTextContent", uo.setAttribute("role", "comment");
                  for (const Is of this.textContent) {
                    const Sl = document.createElement("span");
                    Sl.textContent = Is, uo.append(Sl);
                  }
                  this.container.append(uo);
                }
                return this.data.hasPopup || this._createPopup(null, this.data), this.container;
              }
            }
            class Co extends oo {
              constructor(uo) {
                const Is = !!(uo.data.hasPopup || uo.data.titleObj?.str || uo.data.contentsObj?.str || uo.data.richText?.str);
                super(uo, {
                  isRenderable: Is,
                  ignoreBorder: !0
                });
              }
              render() {
                this.container.className = "lineAnnotation";
                const uo = this.data, {
                  width: Is,
                  height: Sl
                } = io(uo.rect), wl = this.svgFactory.create(Is, Sl, !0), Pl = this.svgFactory.createElement("svg:line");
                return Pl.setAttribute("x1", uo.rect[2] - uo.lineCoordinates[0]), Pl.setAttribute("y1", uo.rect[3] - uo.lineCoordinates[1]), Pl.setAttribute("x2", uo.rect[2] - uo.lineCoordinates[2]), Pl.setAttribute("y2", uo.rect[3] - uo.lineCoordinates[3]), Pl.setAttribute("stroke-width", uo.borderStyle.width || 1), Pl.setAttribute("stroke", "transparent"), Pl.setAttribute("fill", "transparent"), wl.append(Pl), this.container.append(wl), this._createPopup(Pl, uo), this.container;
              }
            }
            class Zs extends oo {
              constructor(uo) {
                const Is = !!(uo.data.hasPopup || uo.data.titleObj?.str || uo.data.contentsObj?.str || uo.data.richText?.str);
                super(uo, {
                  isRenderable: Is,
                  ignoreBorder: !0
                });
              }
              render() {
                this.container.className = "squareAnnotation";
                const uo = this.data, {
                  width: Is,
                  height: Sl
                } = io(uo.rect), wl = this.svgFactory.create(Is, Sl, !0), Pl = uo.borderStyle.width, jl = this.svgFactory.createElement("svg:rect");
                return jl.setAttribute("x", Pl / 2), jl.setAttribute("y", Pl / 2), jl.setAttribute("width", Is - Pl), jl.setAttribute("height", Sl - Pl), jl.setAttribute("stroke-width", Pl || 1), jl.setAttribute("stroke", "transparent"), jl.setAttribute("fill", "transparent"), wl.append(jl), this.container.append(wl), this._createPopup(jl, uo), this.container;
              }
            }
            class xl extends oo {
              constructor(uo) {
                const Is = !!(uo.data.hasPopup || uo.data.titleObj?.str || uo.data.contentsObj?.str || uo.data.richText?.str);
                super(uo, {
                  isRenderable: Is,
                  ignoreBorder: !0
                });
              }
              render() {
                this.container.className = "circleAnnotation";
                const uo = this.data, {
                  width: Is,
                  height: Sl
                } = io(uo.rect), wl = this.svgFactory.create(Is, Sl, !0), Pl = uo.borderStyle.width, jl = this.svgFactory.createElement("svg:ellipse");
                return jl.setAttribute("cx", Is / 2), jl.setAttribute("cy", Sl / 2), jl.setAttribute("rx", Is / 2 - Pl / 2), jl.setAttribute("ry", Sl / 2 - Pl / 2), jl.setAttribute("stroke-width", Pl || 1), jl.setAttribute("stroke", "transparent"), jl.setAttribute("fill", "transparent"), wl.append(jl), this.container.append(wl), this._createPopup(jl, uo), this.container;
              }
            }
            class Cl extends oo {
              constructor(uo) {
                const Is = !!(uo.data.hasPopup || uo.data.titleObj?.str || uo.data.contentsObj?.str || uo.data.richText?.str);
                super(uo, {
                  isRenderable: Is,
                  ignoreBorder: !0
                }), this.containerClassName = "polylineAnnotation", this.svgElementName = "svg:polyline";
              }
              render() {
                this.container.className = this.containerClassName;
                const uo = this.data, {
                  width: Is,
                  height: Sl
                } = io(uo.rect), wl = this.svgFactory.create(Is, Sl, !0);
                let Pl = [];
                for (const Dl of uo.vertices) {
                  const $l = Dl.x - uo.rect[0], kl = uo.rect[3] - Dl.y;
                  Pl.push($l + "," + kl);
                }
                Pl = Pl.join(" ");
                const jl = this.svgFactory.createElement(this.svgElementName);
                return jl.setAttribute("points", Pl), jl.setAttribute("stroke-width", uo.borderStyle.width || 1), jl.setAttribute("stroke", "transparent"), jl.setAttribute("fill", "transparent"), wl.append(jl), this.container.append(wl), this._createPopup(jl, uo), this.container;
              }
            }
            class Al extends Cl {
              constructor(uo) {
                super(uo), this.containerClassName = "polygonAnnotation", this.svgElementName = "svg:polygon";
              }
            }
            class Ol extends oo {
              constructor(uo) {
                const Is = !!(uo.data.hasPopup || uo.data.titleObj?.str || uo.data.contentsObj?.str || uo.data.richText?.str);
                super(uo, {
                  isRenderable: Is,
                  ignoreBorder: !0
                });
              }
              render() {
                return this.container.className = "caretAnnotation", this.data.hasPopup || this._createPopup(null, this.data), this.container;
              }
            }
            class Bl extends oo {
              constructor(uo) {
                const Is = !!(uo.data.hasPopup || uo.data.titleObj?.str || uo.data.contentsObj?.str || uo.data.richText?.str);
                super(uo, {
                  isRenderable: Is,
                  ignoreBorder: !0
                }), this.containerClassName = "inkAnnotation", this.svgElementName = "svg:polyline";
              }
              render() {
                this.container.className = this.containerClassName;
                const uo = this.data, {
                  width: Is,
                  height: Sl
                } = io(uo.rect), wl = this.svgFactory.create(Is, Sl, !0);
                for (const Pl of uo.inkLists) {
                  let jl = [];
                  for (const $l of Pl) {
                    const kl = $l.x - uo.rect[0], zl = uo.rect[3] - $l.y;
                    jl.push(`${kl},${zl}`);
                  }
                  jl = jl.join(" ");
                  const Dl = this.svgFactory.createElement(this.svgElementName);
                  Dl.setAttribute("points", jl), Dl.setAttribute("stroke-width", uo.borderStyle.width || 1), Dl.setAttribute("stroke", "transparent"), Dl.setAttribute("fill", "transparent"), this._createPopup(Dl, uo), wl.append(Dl);
                }
                return this.container.append(wl), this.container;
              }
            }
            class Ml extends oo {
              constructor(uo) {
                const Is = !!(uo.data.hasPopup || uo.data.titleObj?.str || uo.data.contentsObj?.str || uo.data.richText?.str);
                super(uo, {
                  isRenderable: Is,
                  ignoreBorder: !0,
                  createQuadrilaterals: !0
                });
              }
              render() {
                return this.data.hasPopup || this._createPopup(null, this.data), this.quadrilaterals ? this._renderQuadrilaterals("highlightAnnotation") : (this.container.className = "highlightAnnotation", this.container);
              }
            }
            class Vl extends oo {
              constructor(uo) {
                const Is = !!(uo.data.hasPopup || uo.data.titleObj?.str || uo.data.contentsObj?.str || uo.data.richText?.str);
                super(uo, {
                  isRenderable: Is,
                  ignoreBorder: !0,
                  createQuadrilaterals: !0
                });
              }
              render() {
                return this.data.hasPopup || this._createPopup(null, this.data), this.quadrilaterals ? this._renderQuadrilaterals("underlineAnnotation") : (this.container.className = "underlineAnnotation", this.container);
              }
            }
            class Ll extends oo {
              constructor(uo) {
                const Is = !!(uo.data.hasPopup || uo.data.titleObj?.str || uo.data.contentsObj?.str || uo.data.richText?.str);
                super(uo, {
                  isRenderable: Is,
                  ignoreBorder: !0,
                  createQuadrilaterals: !0
                });
              }
              render() {
                return this.data.hasPopup || this._createPopup(null, this.data), this.quadrilaterals ? this._renderQuadrilaterals("squigglyAnnotation") : (this.container.className = "squigglyAnnotation", this.container);
              }
            }
            class Yl extends oo {
              constructor(uo) {
                const Is = !!(uo.data.hasPopup || uo.data.titleObj?.str || uo.data.contentsObj?.str || uo.data.richText?.str);
                super(uo, {
                  isRenderable: Is,
                  ignoreBorder: !0,
                  createQuadrilaterals: !0
                });
              }
              render() {
                return this.data.hasPopup || this._createPopup(null, this.data), this.quadrilaterals ? this._renderQuadrilaterals("strikeoutAnnotation") : (this.container.className = "strikeoutAnnotation", this.container);
              }
            }
            class Zl extends oo {
              constructor(uo) {
                const Is = !!(uo.data.hasPopup || uo.data.titleObj?.str || uo.data.contentsObj?.str || uo.data.richText?.str);
                super(uo, {
                  isRenderable: Is,
                  ignoreBorder: !0
                });
              }
              render() {
                return this.container.className = "stampAnnotation", this.data.hasPopup || this._createPopup(null, this.data), this.container;
              }
            }
            class tc extends oo {
              constructor(uo) {
                super(uo, {
                  isRenderable: !0
                });
                const {
                  filename: Is,
                  content: Sl
                } = this.data.file;
                this.filename = (0, ta.getFilenameFromUrl)(Is), this.content = Sl, this.linkService.eventBus?.dispatch("fileattachmentannotation", {
                  source: this,
                  filename: Is,
                  content: Sl
                });
              }
              render() {
                this.container.className = "fileAttachmentAnnotation";
                const uo = document.createElement("div");
                return uo.className = "popupTriggerArea", uo.addEventListener("dblclick", this._download.bind(this)), !this.data.hasPopup && (this.data.titleObj?.str || this.data.contentsObj?.str || this.data.richText) && this._createPopup(uo, this.data), this.container.append(uo), this.container;
              }
              _download() {
                this.downloadManager?.openOrDownloadData(this.container, this.content, this.filename);
              }
            }
            const Kl = class Kl {
              static render(uo) {
                var Dl, $l;
                const {
                  annotations: Is,
                  div: Sl,
                  viewport: wl,
                  accessibilityManager: Pl
                } = uo;
                lc(this, Tl, Tf).call(this, Sl, wl);
                let jl = 0;
                for (const kl of Is) {
                  if (kl.annotationType !== Zi.AnnotationType.POPUP) {
                    const {
                      width: Hl,
                      height: Wl
                    } = io(kl.rect);
                    if (Hl <= 0 || Wl <= 0)
                      continue;
                  }
                  const zl = ao.create({
                    data: kl,
                    layer: Sl,
                    page: uo.page,
                    viewport: wl,
                    linkService: uo.linkService,
                    downloadManager: uo.downloadManager,
                    imageResourcesPath: uo.imageResourcesPath || "",
                    renderForms: uo.renderForms !== !1,
                    svgFactory: new ta.DOMSVGFactory(),
                    annotationStorage: uo.annotationStorage || new na.AnnotationStorage(),
                    enableScripting: uo.enableScripting,
                    hasJSActions: uo.hasJSActions,
                    fieldObjects: uo.fieldObjects,
                    mouseState: uo.mouseState || {
                      isDown: !1
                    }
                  });
                  if (zl.isRenderable) {
                    const Hl = zl.render();
                    if (kl.hidden && (Hl.style.visibility = "hidden"), Array.isArray(Hl))
                      for (const Wl of Hl)
                        Wl.style.zIndex = jl++, lc(Dl = Kl, Tl, Af).call(Dl, Wl, kl.id, Sl, Pl);
                    else
                      Hl.style.zIndex = jl++, zl instanceof fs ? Sl.prepend(Hl) : lc($l = Kl, Tl, Af).call($l, Hl, kl.id, Sl, Pl);
                  }
                }
                lc(this, Tl, Cf).call(this, Sl, uo.annotationCanvasMap);
              }
              static update(uo) {
                const {
                  annotationCanvasMap: Is,
                  div: Sl,
                  viewport: wl
                } = uo;
                lc(this, Tl, Tf).call(this, Sl, wl), lc(this, Tl, Cf).call(this, Sl, Is), Sl.hidden = !1;
              }
            };
            Tl = new WeakSet(), Af = function(uo, Is, Sl, wl) {
              const Pl = uo.firstChild || uo;
              Pl.id = `${ta.AnnotationPrefix}${Is}`, Sl.append(uo), wl?.moveElementInDOM(Sl, uo, Pl, !1);
            }, Tf = function(uo, {
              width: Is,
              height: Sl,
              rotation: wl
            }) {
              const {
                style: Pl
              } = uo, jl = wl % 180 !== 0, Dl = Math.floor(Is) + "px", $l = Math.floor(Sl) + "px";
              Pl.width = jl ? $l : Dl, Pl.height = jl ? Dl : $l, uo.setAttribute("data-main-rotation", wl);
            }, Cf = function(uo, Is) {
              if (Is) {
                for (const [Sl, wl] of Is) {
                  const Pl = uo.querySelector(`[data-annotation-id="${Sl}"]`);
                  if (!Pl)
                    continue;
                  const {
                    firstChild: jl
                  } = Pl;
                  jl ? jl.nodeName === "CANVAS" ? jl.replaceWith(wl) : jl.before(wl) : Pl.append(wl);
                }
                Is.clear();
              }
            }, fc(Kl, Tl);
            let Nl = Kl;
            e.AnnotationLayer = Nl;
          },
          /* 28 */
          /***/
          (Bi, e) => {
            Object.defineProperty(e, "__esModule", {
              value: !0
            }), e.ColorConverters = void 0;
            function Ui(ta) {
              return Math.floor(Math.max(0, Math.min(1, ta)) * 255).toString(16).padStart(2, "0");
            }
            class Zi {
              static CMYK_G([na, ia, aa, da]) {
                return ["G", 1 - Math.min(1, 0.3 * na + 0.59 * aa + 0.11 * ia + da)];
              }
              static G_CMYK([na]) {
                return ["CMYK", 0, 0, 0, 1 - na];
              }
              static G_RGB([na]) {
                return ["RGB", na, na, na];
              }
              static G_HTML([na]) {
                const ia = Ui(na);
                return `#${ia}${ia}${ia}`;
              }
              static RGB_G([na, ia, aa]) {
                return ["G", 0.3 * na + 0.59 * ia + 0.11 * aa];
              }
              static RGB_HTML([na, ia, aa]) {
                const da = Ui(na), La = Ui(ia), qa = Ui(aa);
                return `#${da}${La}${qa}`;
              }
              static T_HTML() {
                return "#00000000";
              }
              static CMYK_RGB([na, ia, aa, da]) {
                return ["RGB", 1 - Math.min(1, na + da), 1 - Math.min(1, aa + da), 1 - Math.min(1, ia + da)];
              }
              static CMYK_HTML(na) {
                const ia = this.CMYK_RGB(na).slice(1);
                return this.RGB_HTML(ia);
              }
              static RGB_CMYK([na, ia, aa]) {
                const da = 1 - na, La = 1 - ia, qa = 1 - aa, io = Math.min(da, La, qa);
                return ["CMYK", da, La, qa, io];
              }
            }
            e.ColorConverters = Zi;
          },
          /* 29 */
          /***/
          (Bi, e, Ui) => {
            Object.defineProperty(e, "__esModule", {
              value: !0
            }), e.XfaLayer = void 0;
            var Zi = Ui(20);
            class ta {
              static setupStorage(ia, aa, da, La, qa) {
                const io = La.getValue(aa, {
                  value: null
                });
                switch (da.name) {
                  case "textarea":
                    if (io.value !== null && (ia.textContent = io.value), qa === "print")
                      break;
                    ia.addEventListener("input", (ao) => {
                      La.setValue(aa, {
                        value: ao.target.value
                      });
                    });
                    break;
                  case "input":
                    if (da.attributes.type === "radio" || da.attributes.type === "checkbox") {
                      if (io.value === da.attributes.xfaOn ? ia.setAttribute("checked", !0) : io.value === da.attributes.xfaOff && ia.removeAttribute("checked"), qa === "print")
                        break;
                      ia.addEventListener("change", (ao) => {
                        La.setValue(aa, {
                          value: ao.target.checked ? ao.target.getAttribute("xfaOn") : ao.target.getAttribute("xfaOff")
                        });
                      });
                    } else {
                      if (io.value !== null && ia.setAttribute("value", io.value), qa === "print")
                        break;
                      ia.addEventListener("input", (ao) => {
                        La.setValue(aa, {
                          value: ao.target.value
                        });
                      });
                    }
                    break;
                  case "select":
                    if (io.value !== null)
                      for (const ao of da.children)
                        ao.attributes.value === io.value && (ao.attributes.selected = !0);
                    ia.addEventListener("input", (ao) => {
                      const oo = ao.target.options, no = oo.selectedIndex === -1 ? "" : oo[oo.selectedIndex].value;
                      La.setValue(aa, {
                        value: no
                      });
                    });
                    break;
                }
              }
              static setAttributes({
                html: ia,
                element: aa,
                storage: da = null,
                intent: La,
                linkService: qa
              }) {
                const {
                  attributes: io
                } = aa, ao = ia instanceof HTMLAnchorElement;
                io.type === "radio" && (io.name = `${io.name}-${La}`);
                for (const [oo, no] of Object.entries(io))
                  if (no != null)
                    switch (oo) {
                      case "class":
                        no.length && ia.setAttribute(oo, no.join(" "));
                        break;
                      case "dataId":
                        break;
                      case "id":
                        ia.setAttribute("data-element-id", no);
                        break;
                      case "style":
                        Object.assign(ia.style, no);
                        break;
                      case "textContent":
                        ia.textContent = no;
                        break;
                      default:
                        (!ao || oo !== "href" && oo !== "newWindow") && ia.setAttribute(oo, no);
                    }
                ao && qa.addLinkAttributes(ia, io.href, io.newWindow), da && io.dataId && this.setupStorage(ia, io.dataId, aa, da);
              }
              static render(ia) {
                const aa = ia.annotationStorage, da = ia.linkService, La = ia.xfaHtml, qa = ia.intent || "display", io = document.createElement(La.name);
                La.attributes && this.setAttributes({
                  html: io,
                  element: La,
                  intent: qa,
                  linkService: da
                });
                const ao = [[La, -1, io]], oo = ia.div;
                if (oo.append(io), ia.viewport) {
                  const lo = `matrix(${ia.viewport.transform.join(",")})`;
                  oo.style.transform = lo;
                }
                qa !== "richText" && oo.setAttribute("class", "xfaLayer xfaFont");
                const no = [];
                for (; ao.length > 0; ) {
                  const [lo, so, bs] = ao.at(-1);
                  if (so + 1 === lo.children.length) {
                    ao.pop();
                    continue;
                  }
                  const Rs = lo.children[++ao.at(-1)[1]];
                  if (Rs === null)
                    continue;
                  const {
                    name: js
                  } = Rs;
                  if (js === "#text") {
                    const jo = document.createTextNode(Rs.value);
                    no.push(jo), bs.append(jo);
                    continue;
                  }
                  let qs;
                  if (Rs?.attributes?.xmlns ? qs = document.createElementNS(Rs.attributes.xmlns, js) : qs = document.createElement(js), bs.append(qs), Rs.attributes && this.setAttributes({
                    html: qs,
                    element: Rs,
                    storage: aa,
                    intent: qa,
                    linkService: da
                  }), Rs.children && Rs.children.length > 0)
                    ao.push([Rs, -1, qs]);
                  else if (Rs.value) {
                    const jo = document.createTextNode(Rs.value);
                    Zi.XfaText.shouldBuildText(js) && no.push(jo), qs.append(jo);
                  }
                }
                for (const lo of oo.querySelectorAll(".xfaNonInteractive input, .xfaNonInteractive textarea"))
                  lo.setAttribute("readOnly", !0);
                return {
                  textDivs: no
                };
              }
              static update(ia) {
                const aa = `matrix(${ia.viewport.transform.join(",")})`;
                ia.div.style.transform = aa, ia.div.hidden = !1;
              }
            }
            e.XfaLayer = ta;
          },
          /* 30 */
          /***/
          (Bi, e, Ui) => {
            Object.defineProperty(e, "__esModule", {
              value: !0
            }), e.TextLayerRenderTask = void 0, e.renderTextLayer = Rs;
            var Zi = Ui(1), ta = Ui(8);
            const na = 1e5, ia = 30, aa = 0.8, da = /* @__PURE__ */ new Map(), La = /^\s+$/g;
            function qa(js, qs) {
              const jo = da.get(js);
              if (jo)
                return jo;
              qs.save(), qs.font = `${ia}px ${js}`;
              const fs = qs.measureText("");
              let Ao = fs.fontBoundingBoxAscent, co = Math.abs(fs.fontBoundingBoxDescent);
              if (Ao) {
                qs.restore();
                const Zs = Ao / (Ao + co);
                return da.set(js, Zs), Zs;
              }
              qs.strokeStyle = "red", qs.clearRect(0, 0, ia, ia), qs.strokeText("g", 0, 0);
              let Co = qs.getImageData(0, 0, ia, ia).data;
              co = 0;
              for (let Zs = Co.length - 1 - 3; Zs >= 0; Zs -= 4)
                if (Co[Zs] > 0) {
                  co = Math.ceil(Zs / 4 / ia);
                  break;
                }
              qs.clearRect(0, 0, ia, ia), qs.strokeText("A", 0, ia), Co = qs.getImageData(0, 0, ia, ia).data, Ao = 0;
              for (let Zs = 0, xl = Co.length; Zs < xl; Zs += 4)
                if (Co[Zs] > 0) {
                  Ao = ia - Math.floor(Zs / 4 / ia);
                  break;
                }
              if (qs.restore(), Ao) {
                const Zs = Ao / (Ao + co);
                return da.set(js, Zs), Zs;
              }
              return da.set(js, aa), aa;
            }
            function io(js, qs, jo, fs) {
              const Ao = document.createElement("span"), co = js._enhanceTextSelection ? {
                angle: 0,
                canvasWidth: 0,
                hasText: qs.str !== "",
                hasEOL: qs.hasEOL,
                originalTransform: null,
                paddingBottom: 0,
                paddingLeft: 0,
                paddingRight: 0,
                paddingTop: 0,
                scale: 1,
                fontSize: 0
              } : {
                angle: 0,
                canvasWidth: 0,
                hasText: qs.str !== "",
                hasEOL: qs.hasEOL,
                fontSize: 0
              };
              js._textDivs.push(Ao);
              const Co = Zi.Util.transform(js._viewport.transform, qs.transform);
              let Zs = Math.atan2(Co[1], Co[0]);
              const xl = jo[qs.fontName];
              xl.vertical && (Zs += Math.PI / 2);
              const Cl = Math.hypot(Co[2], Co[3]), Al = Cl * qa(xl.fontFamily, fs);
              let Ol, Bl;
              Zs === 0 ? (Ol = Co[4], Bl = Co[5] - Al) : (Ol = Co[4] + Al * Math.sin(Zs), Bl = Co[5] - Al * Math.cos(Zs)), Ao.style.left = `${Ol}px`, Ao.style.top = `${Bl}px`, Ao.style.fontSize = `${Cl}px`, Ao.style.fontFamily = xl.fontFamily, co.fontSize = Cl, Ao.setAttribute("role", "presentation"), Ao.textContent = qs.str, Ao.dir = qs.dir, js._fontInspectorEnabled && (Ao.dataset.fontName = qs.fontName), Zs !== 0 && (co.angle = Zs * (180 / Math.PI));
              let Ml = !1;
              if (qs.str.length > 1 || js._enhanceTextSelection && La.test(qs.str))
                Ml = !0;
              else if (qs.str !== " " && qs.transform[0] !== qs.transform[3]) {
                const Vl = Math.abs(qs.transform[0]), Ll = Math.abs(qs.transform[3]);
                Vl !== Ll && Math.max(Vl, Ll) / Math.min(Vl, Ll) > 1.5 && (Ml = !0);
              }
              if (Ml && (xl.vertical ? co.canvasWidth = qs.height * js._viewport.scale : co.canvasWidth = qs.width * js._viewport.scale), js._textDivProperties.set(Ao, co), js._textContentStream && js._layoutText(Ao), js._enhanceTextSelection && co.hasText) {
                let Vl = 1, Ll = 0;
                Zs !== 0 && (Vl = Math.cos(Zs), Ll = Math.sin(Zs));
                const Yl = (xl.vertical ? qs.height : qs.width) * js._viewport.scale, Zl = Cl;
                let tc, Nl;
                Zs !== 0 ? (tc = [Vl, Ll, -Ll, Vl, Ol, Bl], Nl = Zi.Util.getAxialAlignedBoundingBox([0, 0, Yl, Zl], tc)) : Nl = [Ol, Bl, Ol + Yl, Bl + Zl], js._bounds.push({
                  left: Nl[0],
                  top: Nl[1],
                  right: Nl[2],
                  bottom: Nl[3],
                  div: Ao,
                  size: [Yl, Zl],
                  m: tc
                });
              }
            }
            function ao(js) {
              if (js._canceled)
                return;
              const qs = js._textDivs, jo = js._capability, fs = qs.length;
              if (fs > na) {
                js._renderingDone = !0, jo.resolve();
                return;
              }
              if (!js._textContentStream)
                for (let Ao = 0; Ao < fs; Ao++)
                  js._layoutText(qs[Ao]);
              js._renderingDone = !0, jo.resolve();
            }
            function oo(js, qs, jo) {
              let fs = 0;
              for (let Ao = 0; Ao < jo; Ao++) {
                const co = js[qs++];
                co > 0 && (fs = fs ? Math.min(co, fs) : co);
              }
              return fs;
            }
            function no(js) {
              const qs = js._bounds, jo = js._viewport, fs = lo(jo.width, jo.height, qs);
              for (let Ao = 0; Ao < fs.length; Ao++) {
                const co = qs[Ao].div, Co = js._textDivProperties.get(co);
                if (Co.angle === 0) {
                  Co.paddingLeft = qs[Ao].left - fs[Ao].left, Co.paddingTop = qs[Ao].top - fs[Ao].top, Co.paddingRight = fs[Ao].right - qs[Ao].right, Co.paddingBottom = fs[Ao].bottom - qs[Ao].bottom, js._textDivProperties.set(co, Co);
                  continue;
                }
                const Zs = fs[Ao], xl = qs[Ao], Cl = xl.m, Al = Cl[0], Ol = Cl[1], Bl = [[0, 0], [0, xl.size[1]], [xl.size[0], 0], xl.size], Ml = new Float64Array(64);
                for (let Ll = 0, Yl = Bl.length; Ll < Yl; Ll++) {
                  const Zl = Zi.Util.applyTransform(Bl[Ll], Cl);
                  Ml[Ll + 0] = Al && (Zs.left - Zl[0]) / Al, Ml[Ll + 4] = Ol && (Zs.top - Zl[1]) / Ol, Ml[Ll + 8] = Al && (Zs.right - Zl[0]) / Al, Ml[Ll + 12] = Ol && (Zs.bottom - Zl[1]) / Ol, Ml[Ll + 16] = Ol && (Zs.left - Zl[0]) / -Ol, Ml[Ll + 20] = Al && (Zs.top - Zl[1]) / Al, Ml[Ll + 24] = Ol && (Zs.right - Zl[0]) / -Ol, Ml[Ll + 28] = Al && (Zs.bottom - Zl[1]) / Al, Ml[Ll + 32] = Al && (Zs.left - Zl[0]) / -Al, Ml[Ll + 36] = Ol && (Zs.top - Zl[1]) / -Ol, Ml[Ll + 40] = Al && (Zs.right - Zl[0]) / -Al, Ml[Ll + 44] = Ol && (Zs.bottom - Zl[1]) / -Ol, Ml[Ll + 48] = Ol && (Zs.left - Zl[0]) / Ol, Ml[Ll + 52] = Al && (Zs.top - Zl[1]) / -Al, Ml[Ll + 56] = Ol && (Zs.right - Zl[0]) / Ol, Ml[Ll + 60] = Al && (Zs.bottom - Zl[1]) / -Al;
                }
                const Vl = 1 + Math.min(Math.abs(Al), Math.abs(Ol));
                Co.paddingLeft = oo(Ml, 32, 16) / Vl, Co.paddingTop = oo(Ml, 48, 16) / Vl, Co.paddingRight = oo(Ml, 0, 16) / Vl, Co.paddingBottom = oo(Ml, 16, 16) / Vl, js._textDivProperties.set(co, Co);
              }
            }
            function lo(js, qs, jo) {
              const fs = jo.map(function(co, Co) {
                return {
                  x1: co.left,
                  y1: co.top,
                  x2: co.right,
                  y2: co.bottom,
                  index: Co,
                  x1New: void 0,
                  x2New: void 0
                };
              });
              so(js, fs);
              const Ao = new Array(jo.length);
              for (const co of fs) {
                const Co = co.index;
                Ao[Co] = {
                  left: co.x1New,
                  top: 0,
                  right: co.x2New,
                  bottom: 0
                };
              }
              jo.map(function(co, Co) {
                const Zs = Ao[Co], xl = fs[Co];
                xl.x1 = co.top, xl.y1 = js - Zs.right, xl.x2 = co.bottom, xl.y2 = js - Zs.left, xl.index = Co, xl.x1New = void 0, xl.x2New = void 0;
              }), so(qs, fs);
              for (const co of fs) {
                const Co = co.index;
                Ao[Co].top = co.x1New, Ao[Co].bottom = co.x2New;
              }
              return Ao;
            }
            function so(js, qs) {
              qs.sort(function(Ao, co) {
                return Ao.x1 - co.x1 || Ao.index - co.index;
              });
              const fs = [{
                start: -1 / 0,
                end: 1 / 0,
                boundary: {
                  x1: -1 / 0,
                  y1: -1 / 0,
                  x2: 0,
                  y2: 1 / 0,
                  index: -1,
                  x1New: 0,
                  x2New: 0
                }
              }];
              for (const Ao of qs) {
                let co = 0;
                for (; co < fs.length && fs[co].end <= Ao.y1; )
                  co++;
                let Co = fs.length - 1;
                for (; Co >= 0 && fs[Co].start >= Ao.y2; )
                  Co--;
                let Zs, xl, Cl, Al, Ol = -1 / 0;
                for (Cl = co; Cl <= Co; Cl++) {
                  Zs = fs[Cl], xl = Zs.boundary;
                  let Vl;
                  xl.x2 > Ao.x1 ? Vl = xl.index > Ao.index ? xl.x1New : Ao.x1 : xl.x2New === void 0 ? Vl = (xl.x2 + Ao.x1) / 2 : Vl = xl.x2New, Vl > Ol && (Ol = Vl);
                }
                for (Ao.x1New = Ol, Cl = co; Cl <= Co; Cl++)
                  Zs = fs[Cl], xl = Zs.boundary, xl.x2New === void 0 ? xl.x2 > Ao.x1 ? xl.index > Ao.index && (xl.x2New = xl.x2) : xl.x2New = Ol : xl.x2New > Ol && (xl.x2New = Math.max(Ol, xl.x2));
                const Bl = [];
                let Ml = null;
                for (Cl = co; Cl <= Co; Cl++) {
                  Zs = fs[Cl], xl = Zs.boundary;
                  const Vl = xl.x2 > Ao.x2 ? xl : Ao;
                  Ml === Vl ? Bl.at(-1).end = Zs.end : (Bl.push({
                    start: Zs.start,
                    end: Zs.end,
                    boundary: Vl
                  }), Ml = Vl);
                }
                for (fs[co].start < Ao.y1 && (Bl[0].start = Ao.y1, Bl.unshift({
                  start: fs[co].start,
                  end: Ao.y1,
                  boundary: fs[co].boundary
                })), Ao.y2 < fs[Co].end && (Bl.at(-1).end = Ao.y2, Bl.push({
                  start: Ao.y2,
                  end: fs[Co].end,
                  boundary: fs[Co].boundary
                })), Cl = co; Cl <= Co; Cl++) {
                  if (Zs = fs[Cl], xl = Zs.boundary, xl.x2New !== void 0)
                    continue;
                  let Vl = !1;
                  for (Al = co - 1; !Vl && Al >= 0 && fs[Al].start >= xl.y1; Al--)
                    Vl = fs[Al].boundary === xl;
                  for (Al = Co + 1; !Vl && Al < fs.length && fs[Al].end <= xl.y2; Al++)
                    Vl = fs[Al].boundary === xl;
                  for (Al = 0; !Vl && Al < Bl.length; Al++)
                    Vl = Bl[Al].boundary === xl;
                  Vl || (xl.x2New = Ol);
                }
                Array.prototype.splice.apply(fs, [co, Co - co + 1, ...Bl]);
              }
              for (const Ao of fs) {
                const co = Ao.boundary;
                co.x2New === void 0 && (co.x2New = Math.max(js, co.x2));
              }
            }
            class bs {
              constructor({
                textContent: qs,
                textContentStream: jo,
                container: fs,
                viewport: Ao,
                textDivs: co,
                textContentItemsStr: Co,
                enhanceTextSelection: Zs
              }) {
                Zs && (0, ta.deprecated)("The `enhanceTextSelection` functionality will be removed in the future."), this._textContent = qs, this._textContentStream = jo, this._container = fs, this._document = fs.ownerDocument, this._viewport = Ao, this._textDivs = co || [], this._textContentItemsStr = Co || [], this._enhanceTextSelection = !!Zs, this._fontInspectorEnabled = !!globalThis.FontInspector?.enabled, this._reader = null, this._layoutTextLastFontSize = null, this._layoutTextLastFontFamily = null, this._layoutTextCtx = null, this._textDivProperties = /* @__PURE__ */ new WeakMap(), this._renderingDone = !1, this._canceled = !1, this._capability = (0, Zi.createPromiseCapability)(), this._renderTimer = null, this._bounds = [], this._devicePixelRatio = globalThis.devicePixelRatio || 1, this._capability.promise.finally(() => {
                  this._enhanceTextSelection || (this._textDivProperties = null), this._layoutTextCtx && (this._layoutTextCtx.canvas.width = 0, this._layoutTextCtx.canvas.height = 0, this._layoutTextCtx = null);
                }).catch(() => {
                });
              }
              get promise() {
                return this._capability.promise;
              }
              cancel() {
                this._canceled = !0, this._reader && (this._reader.cancel(new Zi.AbortException("TextLayer task cancelled.")).catch(() => {
                }), this._reader = null), this._renderTimer !== null && (clearTimeout(this._renderTimer), this._renderTimer = null), this._capability.reject(new Error("TextLayer task cancelled."));
              }
              _processItems(qs, jo) {
                for (let fs = 0, Ao = qs.length; fs < Ao; fs++) {
                  if (qs[fs].str === void 0) {
                    if (qs[fs].type === "beginMarkedContentProps" || qs[fs].type === "beginMarkedContent") {
                      const co = this._container;
                      this._container = document.createElement("span"), this._container.classList.add("markedContent"), qs[fs].id !== null && this._container.setAttribute("id", `${qs[fs].id}`), co.append(this._container);
                    } else qs[fs].type === "endMarkedContent" && (this._container = this._container.parentNode);
                    continue;
                  }
                  this._textContentItemsStr.push(qs[fs].str), io(this, qs[fs], jo, this._layoutTextCtx);
                }
              }
              _layoutText(qs) {
                const jo = this._textDivProperties.get(qs);
                let fs = "";
                if (jo.canvasWidth !== 0 && jo.hasText) {
                  const {
                    fontFamily: Ao
                  } = qs.style, {
                    fontSize: co
                  } = jo;
                  (co !== this._layoutTextLastFontSize || Ao !== this._layoutTextLastFontFamily) && (this._layoutTextCtx.font = `${co * this._devicePixelRatio}px ${Ao}`, this._layoutTextLastFontSize = co, this._layoutTextLastFontFamily = Ao);
                  const {
                    width: Co
                  } = this._layoutTextCtx.measureText(qs.textContent);
                  if (Co > 0) {
                    const Zs = this._devicePixelRatio * jo.canvasWidth / Co;
                    this._enhanceTextSelection && (jo.scale = Zs), fs = `scaleX(${Zs})`;
                  }
                }
                if (jo.angle !== 0 && (fs = `rotate(${jo.angle}deg) ${fs}`), fs.length > 0 && (this._enhanceTextSelection && (jo.originalTransform = fs), qs.style.transform = fs), jo.hasText && this._container.append(qs), jo.hasEOL) {
                  const Ao = document.createElement("br");
                  Ao.setAttribute("role", "presentation"), this._container.append(Ao);
                }
              }
              _render(qs = 0) {
                const jo = (0, Zi.createPromiseCapability)();
                let fs = /* @__PURE__ */ Object.create(null);
                const Ao = this._document.createElement("canvas");
                if (Ao.height = Ao.width = ia, this._layoutTextCtx = Ao.getContext("2d", {
                  alpha: !1
                }), this._textContent) {
                  const co = this._textContent.items, Co = this._textContent.styles;
                  this._processItems(co, Co), jo.resolve();
                } else if (this._textContentStream) {
                  const co = () => {
                    this._reader.read().then(({
                      value: Co,
                      done: Zs
                    }) => {
                      if (Zs) {
                        jo.resolve();
                        return;
                      }
                      Object.assign(fs, Co.styles), this._processItems(Co.items, fs), co();
                    }, jo.reject);
                  };
                  this._reader = this._textContentStream.getReader(), co();
                } else
                  throw new Error('Neither "textContent" nor "textContentStream" parameters specified.');
                jo.promise.then(() => {
                  fs = null, qs ? this._renderTimer = setTimeout(() => {
                    ao(this), this._renderTimer = null;
                  }, qs) : ao(this);
                }, this._capability.reject);
              }
              expandTextDivs(qs = !1) {
                if (!this._enhanceTextSelection || !this._renderingDone)
                  return;
                this._bounds !== null && (no(this), this._bounds = null);
                const jo = [], fs = [];
                for (let Ao = 0, co = this._textDivs.length; Ao < co; Ao++) {
                  const Co = this._textDivs[Ao], Zs = this._textDivProperties.get(Co);
                  Zs.hasText && (qs ? (jo.length = 0, fs.length = 0, Zs.originalTransform && jo.push(Zs.originalTransform), Zs.paddingTop > 0 ? (fs.push(`${Zs.paddingTop}px`), jo.push(`translateY(${-Zs.paddingTop}px)`)) : fs.push(0), Zs.paddingRight > 0 ? fs.push(`${Zs.paddingRight / Zs.scale}px`) : fs.push(0), Zs.paddingBottom > 0 ? fs.push(`${Zs.paddingBottom}px`) : fs.push(0), Zs.paddingLeft > 0 ? (fs.push(`${Zs.paddingLeft / Zs.scale}px`), jo.push(`translateX(${-Zs.paddingLeft / Zs.scale}px)`)) : fs.push(0), Co.style.padding = fs.join(" "), jo.length && (Co.style.transform = jo.join(" "))) : (Co.style.padding = null, Co.style.transform = Zs.originalTransform));
                }
              }
            }
            e.TextLayerRenderTask = bs;
            function Rs(js) {
              const qs = new bs({
                textContent: js.textContent,
                textContentStream: js.textContentStream,
                container: js.container,
                viewport: js.viewport,
                textDivs: js.textDivs,
                textContentItemsStr: js.textContentItemsStr,
                enhanceTextSelection: js.enhanceTextSelection
              });
              return qs._render(js.timeout), qs;
            }
          },
          /* 31 */
          /***/
          (Bi, e, Ui) => {
            Object.defineProperty(e, "__esModule", {
              value: !0
            }), e.SVGGraphics = void 0;
            var Zi = Ui(8), ta = Ui(1), na = Ui(3);
            let ia = class {
              constructor() {
                (0, ta.unreachable)("Not implemented: SVGGraphics");
              }
            };
            e.SVGGraphics = ia;
            {
              let lo = function(jo) {
                let fs = [];
                const Ao = [];
                for (const co of jo) {
                  if (co.fn === "save") {
                    fs.push({
                      fnId: 92,
                      fn: "group",
                      items: []
                    }), Ao.push(fs), fs = fs.at(-1).items;
                    continue;
                  }
                  co.fn === "restore" ? fs = Ao.pop() : fs.push(co);
                }
                return fs;
              }, so = function(jo) {
                if (Number.isInteger(jo))
                  return jo.toString();
                const fs = jo.toFixed(10);
                let Ao = fs.length - 1;
                if (fs[Ao] !== "0")
                  return fs;
                do
                  Ao--;
                while (fs[Ao] === "0");
                return fs.substring(0, fs[Ao] === "." ? Ao : Ao + 1);
              }, bs = function(jo) {
                if (jo[4] === 0 && jo[5] === 0) {
                  if (jo[1] === 0 && jo[2] === 0)
                    return jo[0] === 1 && jo[3] === 1 ? "" : `scale(${so(jo[0])} ${so(jo[3])})`;
                  if (jo[0] === jo[3] && jo[1] === -jo[2]) {
                    const fs = Math.acos(jo[0]) * 180 / Math.PI;
                    return `rotate(${so(fs)})`;
                  }
                } else if (jo[0] === 1 && jo[1] === 0 && jo[2] === 0 && jo[3] === 1)
                  return `translate(${so(jo[4])} ${so(jo[5])})`;
                return `matrix(${so(jo[0])} ${so(jo[1])} ${so(jo[2])} ${so(jo[3])} ${so(jo[4])} ${so(jo[5])})`;
              };
              const aa = {
                fontStyle: "normal",
                fontWeight: "normal",
                fillColor: "#000000"
              }, da = "http://www.w3.org/XML/1998/namespace", La = "http://www.w3.org/1999/xlink", qa = ["butt", "round", "square"], io = ["miter", "round", "bevel"], ao = function(jo, fs = "", Ao = !1) {
                if (URL.createObjectURL && typeof Blob < "u" && !Ao)
                  return URL.createObjectURL(new Blob([jo], {
                    type: fs
                  }));
                const co = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=";
                let Co = `data:${fs};base64,`;
                for (let Zs = 0, xl = jo.length; Zs < xl; Zs += 3) {
                  const Cl = jo[Zs] & 255, Al = jo[Zs + 1] & 255, Ol = jo[Zs + 2] & 255, Bl = Cl >> 2, Ml = (Cl & 3) << 4 | Al >> 4, Vl = Zs + 1 < xl ? (Al & 15) << 2 | Ol >> 6 : 64, Ll = Zs + 2 < xl ? Ol & 63 : 64;
                  Co += co[Bl] + co[Ml] + co[Vl] + co[Ll];
                }
                return Co;
              }, oo = function() {
                const jo = new Uint8Array([137, 80, 78, 71, 13, 10, 26, 10]), fs = 12, Ao = new Int32Array(256);
                for (let Ol = 0; Ol < 256; Ol++) {
                  let Bl = Ol;
                  for (let Ml = 0; Ml < 8; Ml++)
                    Bl & 1 ? Bl = 3988292384 ^ Bl >> 1 & 2147483647 : Bl = Bl >> 1 & 2147483647;
                  Ao[Ol] = Bl;
                }
                function co(Ol, Bl, Ml) {
                  let Vl = -1;
                  for (let Ll = Bl; Ll < Ml; Ll++) {
                    const Yl = (Vl ^ Ol[Ll]) & 255, Zl = Ao[Yl];
                    Vl = Vl >>> 8 ^ Zl;
                  }
                  return Vl ^ -1;
                }
                function Co(Ol, Bl, Ml, Vl) {
                  let Ll = Vl;
                  const Yl = Bl.length;
                  Ml[Ll] = Yl >> 24 & 255, Ml[Ll + 1] = Yl >> 16 & 255, Ml[Ll + 2] = Yl >> 8 & 255, Ml[Ll + 3] = Yl & 255, Ll += 4, Ml[Ll] = Ol.charCodeAt(0) & 255, Ml[Ll + 1] = Ol.charCodeAt(1) & 255, Ml[Ll + 2] = Ol.charCodeAt(2) & 255, Ml[Ll + 3] = Ol.charCodeAt(3) & 255, Ll += 4, Ml.set(Bl, Ll), Ll += Bl.length;
                  const Zl = co(Ml, Vl + 4, Ll);
                  Ml[Ll] = Zl >> 24 & 255, Ml[Ll + 1] = Zl >> 16 & 255, Ml[Ll + 2] = Zl >> 8 & 255, Ml[Ll + 3] = Zl & 255;
                }
                function Zs(Ol, Bl, Ml) {
                  let Vl = 1, Ll = 0;
                  for (let Yl = Bl; Yl < Ml; ++Yl)
                    Vl = (Vl + (Ol[Yl] & 255)) % 65521, Ll = (Ll + Vl) % 65521;
                  return Ll << 16 | Vl;
                }
                function xl(Ol) {
                  if (!na.isNodeJS)
                    return Cl(Ol);
                  try {
                    let Bl;
                    parseInt(process.versions.node) >= 8 ? Bl = Ol : Bl = Buffer.from(Ol);
                    const Ml = require$$5.deflateSync(Bl, {
                      level: 9
                    });
                    return Ml instanceof Uint8Array ? Ml : new Uint8Array(Ml);
                  } catch (Bl) {
                    (0, ta.warn)("Not compressing PNG because zlib.deflateSync is unavailable: " + Bl);
                  }
                  return Cl(Ol);
                }
                function Cl(Ol) {
                  let Bl = Ol.length;
                  const Ml = 65535, Vl = Math.ceil(Bl / Ml), Ll = new Uint8Array(2 + Bl + Vl * 5 + 4);
                  let Yl = 0;
                  Ll[Yl++] = 120, Ll[Yl++] = 156;
                  let Zl = 0;
                  for (; Bl > Ml; )
                    Ll[Yl++] = 0, Ll[Yl++] = 255, Ll[Yl++] = 255, Ll[Yl++] = 0, Ll[Yl++] = 0, Ll.set(Ol.subarray(Zl, Zl + Ml), Yl), Yl += Ml, Zl += Ml, Bl -= Ml;
                  Ll[Yl++] = 1, Ll[Yl++] = Bl & 255, Ll[Yl++] = Bl >> 8 & 255, Ll[Yl++] = ~Bl & 65535 & 255, Ll[Yl++] = (~Bl & 65535) >> 8 & 255, Ll.set(Ol.subarray(Zl), Yl), Yl += Ol.length - Zl;
                  const tc = Zs(Ol, 0, Ol.length);
                  return Ll[Yl++] = tc >> 24 & 255, Ll[Yl++] = tc >> 16 & 255, Ll[Yl++] = tc >> 8 & 255, Ll[Yl++] = tc & 255, Ll;
                }
                function Al(Ol, Bl, Ml, Vl) {
                  const Ll = Ol.width, Yl = Ol.height;
                  let Zl, tc, Nl;
                  const Tl = Ol.data;
                  switch (Bl) {
                    case ta.ImageKind.GRAYSCALE_1BPP:
                      tc = 0, Zl = 1, Nl = Ll + 7 >> 3;
                      break;
                    case ta.ImageKind.RGB_24BPP:
                      tc = 2, Zl = 8, Nl = Ll * 3;
                      break;
                    case ta.ImageKind.RGBA_32BPP:
                      tc = 6, Zl = 8, Nl = Ll * 4;
                      break;
                    default:
                      throw new Error("invalid format");
                  }
                  const El = new Uint8Array((1 + Nl) * Yl);
                  let Il = 0, Ul = 0;
                  for (let wl = 0; wl < Yl; ++wl)
                    El[Il++] = 0, El.set(Tl.subarray(Ul, Ul + Nl), Il), Ul += Nl, Il += Nl;
                  if (Bl === ta.ImageKind.GRAYSCALE_1BPP && Vl) {
                    Il = 0;
                    for (let wl = 0; wl < Yl; wl++) {
                      Il++;
                      for (let Pl = 0; Pl < Nl; Pl++)
                        El[Il++] ^= 255;
                    }
                  }
                  const Kl = new Uint8Array([Ll >> 24 & 255, Ll >> 16 & 255, Ll >> 8 & 255, Ll & 255, Yl >> 24 & 255, Yl >> 16 & 255, Yl >> 8 & 255, Yl & 255, Zl, tc, 0, 0, 0]), Rl = xl(El), uo = jo.length + fs * 3 + Kl.length + Rl.length, Is = new Uint8Array(uo);
                  let Sl = 0;
                  return Is.set(jo, Sl), Sl += jo.length, Co("IHDR", Kl, Is, Sl), Sl += fs + Kl.length, Co("IDATA", Rl, Is, Sl), Sl += fs + Rl.length, Co("IEND", new Uint8Array(0), Is, Sl), ao(Is, "image/png", Ml);
                }
                return function(Bl, Ml, Vl) {
                  const Ll = Bl.kind === void 0 ? ta.ImageKind.GRAYSCALE_1BPP : Bl.kind;
                  return Al(Bl, Ll, Ml, Vl);
                };
              }();
              class no {
                constructor() {
                  this.fontSizeScale = 1, this.fontWeight = aa.fontWeight, this.fontSize = 0, this.textMatrix = ta.IDENTITY_MATRIX, this.fontMatrix = ta.FONT_IDENTITY_MATRIX, this.leading = 0, this.textRenderingMode = ta.TextRenderingMode.FILL, this.textMatrixScale = 1, this.x = 0, this.y = 0, this.lineX = 0, this.lineY = 0, this.charSpacing = 0, this.wordSpacing = 0, this.textHScale = 1, this.textRise = 0, this.fillColor = aa.fillColor, this.strokeColor = "#000000", this.fillAlpha = 1, this.strokeAlpha = 1, this.lineWidth = 1, this.lineJoin = "", this.lineCap = "", this.miterLimit = 0, this.dashArray = [], this.dashPhase = 0, this.dependencies = [], this.activeClipUrl = null, this.clipGroup = null, this.maskId = "";
                }
                clone() {
                  return Object.create(this);
                }
                setCurrentPoint(fs, Ao) {
                  this.x = fs, this.y = Ao;
                }
              }
              let Rs = 0, js = 0, qs = 0;
              e.SVGGraphics = ia = class {
                constructor(jo, fs, Ao = !1) {
                  (0, Zi.deprecated)("The SVG back-end is no longer maintained and *may* be removed in the future."), this.svgFactory = new Zi.DOMSVGFactory(), this.current = new no(), this.transformMatrix = ta.IDENTITY_MATRIX, this.transformStack = [], this.extraStack = [], this.commonObjs = jo, this.objs = fs, this.pendingClip = null, this.pendingEOFill = !1, this.embedFonts = !1, this.embeddedFonts = /* @__PURE__ */ Object.create(null), this.cssStyle = null, this.forceDataSchema = !!Ao, this._operatorIdMapping = [];
                  for (const co in ta.OPS)
                    this._operatorIdMapping[ta.OPS[co]] = co;
                }
                save() {
                  this.transformStack.push(this.transformMatrix);
                  const jo = this.current;
                  this.extraStack.push(jo), this.current = jo.clone();
                }
                restore() {
                  this.transformMatrix = this.transformStack.pop(), this.current = this.extraStack.pop(), this.pendingClip = null, this.tgrp = null;
                }
                group(jo) {
                  this.save(), this.executeOpTree(jo), this.restore();
                }
                loadDependencies(jo) {
                  const fs = jo.fnArray, Ao = jo.argsArray;
                  for (let co = 0, Co = fs.length; co < Co; co++)
                    if (fs[co] === ta.OPS.dependency)
                      for (const Zs of Ao[co]) {
                        const xl = Zs.startsWith("g_") ? this.commonObjs : this.objs, Cl = new Promise((Al) => {
                          xl.get(Zs, Al);
                        });
                        this.current.dependencies.push(Cl);
                      }
                  return Promise.all(this.current.dependencies);
                }
                transform(jo, fs, Ao, co, Co, Zs) {
                  const xl = [jo, fs, Ao, co, Co, Zs];
                  this.transformMatrix = ta.Util.transform(this.transformMatrix, xl), this.tgrp = null;
                }
                getSVG(jo, fs) {
                  this.viewport = fs;
                  const Ao = this._initialize(fs);
                  return this.loadDependencies(jo).then(() => (this.transformMatrix = ta.IDENTITY_MATRIX, this.executeOpTree(this.convertOpList(jo)), Ao));
                }
                convertOpList(jo) {
                  const fs = this._operatorIdMapping, Ao = jo.argsArray, co = jo.fnArray, Co = [];
                  for (let Zs = 0, xl = co.length; Zs < xl; Zs++) {
                    const Cl = co[Zs];
                    Co.push({
                      fnId: Cl,
                      fn: fs[Cl],
                      args: Ao[Zs]
                    });
                  }
                  return lo(Co);
                }
                executeOpTree(jo) {
                  for (const fs of jo) {
                    const Ao = fs.fn, co = fs.fnId, Co = fs.args;
                    switch (co | 0) {
                      case ta.OPS.beginText:
                        this.beginText();
                        break;
                      case ta.OPS.dependency:
                        break;
                      case ta.OPS.setLeading:
                        this.setLeading(Co);
                        break;
                      case ta.OPS.setLeadingMoveText:
                        this.setLeadingMoveText(Co[0], Co[1]);
                        break;
                      case ta.OPS.setFont:
                        this.setFont(Co);
                        break;
                      case ta.OPS.showText:
                        this.showText(Co[0]);
                        break;
                      case ta.OPS.showSpacedText:
                        this.showText(Co[0]);
                        break;
                      case ta.OPS.endText:
                        this.endText();
                        break;
                      case ta.OPS.moveText:
                        this.moveText(Co[0], Co[1]);
                        break;
                      case ta.OPS.setCharSpacing:
                        this.setCharSpacing(Co[0]);
                        break;
                      case ta.OPS.setWordSpacing:
                        this.setWordSpacing(Co[0]);
                        break;
                      case ta.OPS.setHScale:
                        this.setHScale(Co[0]);
                        break;
                      case ta.OPS.setTextMatrix:
                        this.setTextMatrix(Co[0], Co[1], Co[2], Co[3], Co[4], Co[5]);
                        break;
                      case ta.OPS.setTextRise:
                        this.setTextRise(Co[0]);
                        break;
                      case ta.OPS.setTextRenderingMode:
                        this.setTextRenderingMode(Co[0]);
                        break;
                      case ta.OPS.setLineWidth:
                        this.setLineWidth(Co[0]);
                        break;
                      case ta.OPS.setLineJoin:
                        this.setLineJoin(Co[0]);
                        break;
                      case ta.OPS.setLineCap:
                        this.setLineCap(Co[0]);
                        break;
                      case ta.OPS.setMiterLimit:
                        this.setMiterLimit(Co[0]);
                        break;
                      case ta.OPS.setFillRGBColor:
                        this.setFillRGBColor(Co[0], Co[1], Co[2]);
                        break;
                      case ta.OPS.setStrokeRGBColor:
                        this.setStrokeRGBColor(Co[0], Co[1], Co[2]);
                        break;
                      case ta.OPS.setStrokeColorN:
                        this.setStrokeColorN(Co);
                        break;
                      case ta.OPS.setFillColorN:
                        this.setFillColorN(Co);
                        break;
                      case ta.OPS.shadingFill:
                        this.shadingFill(Co[0]);
                        break;
                      case ta.OPS.setDash:
                        this.setDash(Co[0], Co[1]);
                        break;
                      case ta.OPS.setRenderingIntent:
                        this.setRenderingIntent(Co[0]);
                        break;
                      case ta.OPS.setFlatness:
                        this.setFlatness(Co[0]);
                        break;
                      case ta.OPS.setGState:
                        this.setGState(Co[0]);
                        break;
                      case ta.OPS.fill:
                        this.fill();
                        break;
                      case ta.OPS.eoFill:
                        this.eoFill();
                        break;
                      case ta.OPS.stroke:
                        this.stroke();
                        break;
                      case ta.OPS.fillStroke:
                        this.fillStroke();
                        break;
                      case ta.OPS.eoFillStroke:
                        this.eoFillStroke();
                        break;
                      case ta.OPS.clip:
                        this.clip("nonzero");
                        break;
                      case ta.OPS.eoClip:
                        this.clip("evenodd");
                        break;
                      case ta.OPS.paintSolidColorImageMask:
                        this.paintSolidColorImageMask();
                        break;
                      case ta.OPS.paintImageXObject:
                        this.paintImageXObject(Co[0]);
                        break;
                      case ta.OPS.paintInlineImageXObject:
                        this.paintInlineImageXObject(Co[0]);
                        break;
                      case ta.OPS.paintImageMaskXObject:
                        this.paintImageMaskXObject(Co[0]);
                        break;
                      case ta.OPS.paintFormXObjectBegin:
                        this.paintFormXObjectBegin(Co[0], Co[1]);
                        break;
                      case ta.OPS.paintFormXObjectEnd:
                        this.paintFormXObjectEnd();
                        break;
                      case ta.OPS.closePath:
                        this.closePath();
                        break;
                      case ta.OPS.closeStroke:
                        this.closeStroke();
                        break;
                      case ta.OPS.closeFillStroke:
                        this.closeFillStroke();
                        break;
                      case ta.OPS.closeEOFillStroke:
                        this.closeEOFillStroke();
                        break;
                      case ta.OPS.nextLine:
                        this.nextLine();
                        break;
                      case ta.OPS.transform:
                        this.transform(Co[0], Co[1], Co[2], Co[3], Co[4], Co[5]);
                        break;
                      case ta.OPS.constructPath:
                        this.constructPath(Co[0], Co[1]);
                        break;
                      case ta.OPS.endPath:
                        this.endPath();
                        break;
                      case 92:
                        this.group(fs.items);
                        break;
                      default:
                        (0, ta.warn)(`Unimplemented operator ${Ao}`);
                        break;
                    }
                  }
                }
                setWordSpacing(jo) {
                  this.current.wordSpacing = jo;
                }
                setCharSpacing(jo) {
                  this.current.charSpacing = jo;
                }
                nextLine() {
                  this.moveText(0, this.current.leading);
                }
                setTextMatrix(jo, fs, Ao, co, Co, Zs) {
                  const xl = this.current;
                  xl.textMatrix = xl.lineMatrix = [jo, fs, Ao, co, Co, Zs], xl.textMatrixScale = Math.hypot(jo, fs), xl.x = xl.lineX = 0, xl.y = xl.lineY = 0, xl.xcoords = [], xl.ycoords = [], xl.tspan = this.svgFactory.createElement("svg:tspan"), xl.tspan.setAttributeNS(null, "font-family", xl.fontFamily), xl.tspan.setAttributeNS(null, "font-size", `${so(xl.fontSize)}px`), xl.tspan.setAttributeNS(null, "y", so(-xl.y)), xl.txtElement = this.svgFactory.createElement("svg:text"), xl.txtElement.append(xl.tspan);
                }
                beginText() {
                  const jo = this.current;
                  jo.x = jo.lineX = 0, jo.y = jo.lineY = 0, jo.textMatrix = ta.IDENTITY_MATRIX, jo.lineMatrix = ta.IDENTITY_MATRIX, jo.textMatrixScale = 1, jo.tspan = this.svgFactory.createElement("svg:tspan"), jo.txtElement = this.svgFactory.createElement("svg:text"), jo.txtgrp = this.svgFactory.createElement("svg:g"), jo.xcoords = [], jo.ycoords = [];
                }
                moveText(jo, fs) {
                  const Ao = this.current;
                  Ao.x = Ao.lineX += jo, Ao.y = Ao.lineY += fs, Ao.xcoords = [], Ao.ycoords = [], Ao.tspan = this.svgFactory.createElement("svg:tspan"), Ao.tspan.setAttributeNS(null, "font-family", Ao.fontFamily), Ao.tspan.setAttributeNS(null, "font-size", `${so(Ao.fontSize)}px`), Ao.tspan.setAttributeNS(null, "y", so(-Ao.y));
                }
                showText(jo) {
                  const fs = this.current, Ao = fs.font, co = fs.fontSize;
                  if (co === 0)
                    return;
                  const Co = fs.fontSizeScale, Zs = fs.charSpacing, xl = fs.wordSpacing, Cl = fs.fontDirection, Al = fs.textHScale * Cl, Ol = Ao.vertical, Bl = Ol ? 1 : -1, Ml = Ao.defaultVMetrics, Vl = co * fs.fontMatrix[0];
                  let Ll = 0;
                  for (const tc of jo) {
                    if (tc === null) {
                      Ll += Cl * xl;
                      continue;
                    } else if (typeof tc == "number") {
                      Ll += Bl * tc * co / 1e3;
                      continue;
                    }
                    const Nl = (tc.isSpace ? xl : 0) + Zs, Tl = tc.fontChar;
                    let El, Il, Ul = tc.width;
                    if (Ol) {
                      let Rl;
                      const uo = tc.vmetric || Ml;
                      Rl = tc.vmetric ? uo[1] : Ul * 0.5, Rl = -Rl * Vl;
                      const Is = uo[2] * Vl;
                      Ul = uo ? -uo[0] : Ul, El = Rl / Co, Il = (Ll + Is) / Co;
                    } else
                      El = Ll / Co, Il = 0;
                    (tc.isInFont || Ao.missingFile) && (fs.xcoords.push(fs.x + El), Ol && fs.ycoords.push(-fs.y + Il), fs.tspan.textContent += Tl);
                    let Kl;
                    Ol ? Kl = Ul * Vl - Nl * Cl : Kl = Ul * Vl + Nl * Cl, Ll += Kl;
                  }
                  fs.tspan.setAttributeNS(null, "x", fs.xcoords.map(so).join(" ")), Ol ? fs.tspan.setAttributeNS(null, "y", fs.ycoords.map(so).join(" ")) : fs.tspan.setAttributeNS(null, "y", so(-fs.y)), Ol ? fs.y -= Ll : fs.x += Ll * Al, fs.tspan.setAttributeNS(null, "font-family", fs.fontFamily), fs.tspan.setAttributeNS(null, "font-size", `${so(fs.fontSize)}px`), fs.fontStyle !== aa.fontStyle && fs.tspan.setAttributeNS(null, "font-style", fs.fontStyle), fs.fontWeight !== aa.fontWeight && fs.tspan.setAttributeNS(null, "font-weight", fs.fontWeight);
                  const Yl = fs.textRenderingMode & ta.TextRenderingMode.FILL_STROKE_MASK;
                  if (Yl === ta.TextRenderingMode.FILL || Yl === ta.TextRenderingMode.FILL_STROKE ? (fs.fillColor !== aa.fillColor && fs.tspan.setAttributeNS(null, "fill", fs.fillColor), fs.fillAlpha < 1 && fs.tspan.setAttributeNS(null, "fill-opacity", fs.fillAlpha)) : fs.textRenderingMode === ta.TextRenderingMode.ADD_TO_PATH ? fs.tspan.setAttributeNS(null, "fill", "transparent") : fs.tspan.setAttributeNS(null, "fill", "none"), Yl === ta.TextRenderingMode.STROKE || Yl === ta.TextRenderingMode.FILL_STROKE) {
                    const tc = 1 / (fs.textMatrixScale || 1);
                    this._setStrokeAttributes(fs.tspan, tc);
                  }
                  let Zl = fs.textMatrix;
                  fs.textRise !== 0 && (Zl = Zl.slice(), Zl[5] += fs.textRise), fs.txtElement.setAttributeNS(null, "transform", `${bs(Zl)} scale(${so(Al)}, -1)`), fs.txtElement.setAttributeNS(da, "xml:space", "preserve"), fs.txtElement.append(fs.tspan), fs.txtgrp.append(fs.txtElement), this._ensureTransformGroup().append(fs.txtElement);
                }
                setLeadingMoveText(jo, fs) {
                  this.setLeading(-fs), this.moveText(jo, fs);
                }
                addFontStyle(jo) {
                  if (!jo.data)
                    throw new Error('addFontStyle: No font data available, ensure that the "fontExtraProperties" API parameter is set.');
                  this.cssStyle || (this.cssStyle = this.svgFactory.createElement("svg:style"), this.cssStyle.setAttributeNS(null, "type", "text/css"), this.defs.append(this.cssStyle));
                  const fs = ao(jo.data, jo.mimetype, this.forceDataSchema);
                  this.cssStyle.textContent += `@font-face { font-family: "${jo.loadedName}"; src: url(${fs}); }
`;
                }
                setFont(jo) {
                  const fs = this.current, Ao = this.commonObjs.get(jo[0]);
                  let co = jo[1];
                  fs.font = Ao, this.embedFonts && !Ao.missingFile && !this.embeddedFonts[Ao.loadedName] && (this.addFontStyle(Ao), this.embeddedFonts[Ao.loadedName] = Ao), fs.fontMatrix = Ao.fontMatrix || ta.FONT_IDENTITY_MATRIX;
                  let Co = "normal";
                  Ao.black ? Co = "900" : Ao.bold && (Co = "bold");
                  const Zs = Ao.italic ? "italic" : "normal";
                  co < 0 ? (co = -co, fs.fontDirection = -1) : fs.fontDirection = 1, fs.fontSize = co, fs.fontFamily = Ao.loadedName, fs.fontWeight = Co, fs.fontStyle = Zs, fs.tspan = this.svgFactory.createElement("svg:tspan"), fs.tspan.setAttributeNS(null, "y", so(-fs.y)), fs.xcoords = [], fs.ycoords = [];
                }
                endText() {
                  const jo = this.current;
                  jo.textRenderingMode & ta.TextRenderingMode.ADD_TO_PATH_FLAG && jo.txtElement?.hasChildNodes() && (jo.element = jo.txtElement, this.clip("nonzero"), this.endPath());
                }
                setLineWidth(jo) {
                  jo > 0 && (this.current.lineWidth = jo);
                }
                setLineCap(jo) {
                  this.current.lineCap = qa[jo];
                }
                setLineJoin(jo) {
                  this.current.lineJoin = io[jo];
                }
                setMiterLimit(jo) {
                  this.current.miterLimit = jo;
                }
                setStrokeAlpha(jo) {
                  this.current.strokeAlpha = jo;
                }
                setStrokeRGBColor(jo, fs, Ao) {
                  this.current.strokeColor = ta.Util.makeHexColor(jo, fs, Ao);
                }
                setFillAlpha(jo) {
                  this.current.fillAlpha = jo;
                }
                setFillRGBColor(jo, fs, Ao) {
                  this.current.fillColor = ta.Util.makeHexColor(jo, fs, Ao), this.current.tspan = this.svgFactory.createElement("svg:tspan"), this.current.xcoords = [], this.current.ycoords = [];
                }
                setStrokeColorN(jo) {
                  this.current.strokeColor = this._makeColorN_Pattern(jo);
                }
                setFillColorN(jo) {
                  this.current.fillColor = this._makeColorN_Pattern(jo);
                }
                shadingFill(jo) {
                  const fs = this.viewport.width, Ao = this.viewport.height, co = ta.Util.inverseTransform(this.transformMatrix), Co = ta.Util.applyTransform([0, 0], co), Zs = ta.Util.applyTransform([0, Ao], co), xl = ta.Util.applyTransform([fs, 0], co), Cl = ta.Util.applyTransform([fs, Ao], co), Al = Math.min(Co[0], Zs[0], xl[0], Cl[0]), Ol = Math.min(Co[1], Zs[1], xl[1], Cl[1]), Bl = Math.max(Co[0], Zs[0], xl[0], Cl[0]), Ml = Math.max(Co[1], Zs[1], xl[1], Cl[1]), Vl = this.svgFactory.createElement("svg:rect");
                  Vl.setAttributeNS(null, "x", Al), Vl.setAttributeNS(null, "y", Ol), Vl.setAttributeNS(null, "width", Bl - Al), Vl.setAttributeNS(null, "height", Ml - Ol), Vl.setAttributeNS(null, "fill", this._makeShadingPattern(jo)), this.current.fillAlpha < 1 && Vl.setAttributeNS(null, "fill-opacity", this.current.fillAlpha), this._ensureTransformGroup().append(Vl);
                }
                _makeColorN_Pattern(jo) {
                  return jo[0] === "TilingPattern" ? this._makeTilingPattern(jo) : this._makeShadingPattern(jo);
                }
                _makeTilingPattern(jo) {
                  const fs = jo[1], Ao = jo[2], co = jo[3] || ta.IDENTITY_MATRIX, [Co, Zs, xl, Cl] = jo[4], Al = jo[5], Ol = jo[6], Bl = jo[7], Ml = `shading${qs++}`, [Vl, Ll, Yl, Zl] = ta.Util.normalizeRect([...ta.Util.applyTransform([Co, Zs], co), ...ta.Util.applyTransform([xl, Cl], co)]), [tc, Nl] = ta.Util.singularValueDecompose2dScale(co), Tl = Al * tc, El = Ol * Nl, Il = this.svgFactory.createElement("svg:pattern");
                  Il.setAttributeNS(null, "id", Ml), Il.setAttributeNS(null, "patternUnits", "userSpaceOnUse"), Il.setAttributeNS(null, "width", Tl), Il.setAttributeNS(null, "height", El), Il.setAttributeNS(null, "x", `${Vl}`), Il.setAttributeNS(null, "y", `${Ll}`);
                  const Ul = this.svg, Kl = this.transformMatrix, Rl = this.current.fillColor, uo = this.current.strokeColor, Is = this.svgFactory.create(Yl - Vl, Zl - Ll);
                  if (this.svg = Is, this.transformMatrix = co, Bl === 2) {
                    const Sl = ta.Util.makeHexColor(...fs);
                    this.current.fillColor = Sl, this.current.strokeColor = Sl;
                  }
                  return this.executeOpTree(this.convertOpList(Ao)), this.svg = Ul, this.transformMatrix = Kl, this.current.fillColor = Rl, this.current.strokeColor = uo, Il.append(Is.childNodes[0]), this.defs.append(Il), `url(#${Ml})`;
                }
                _makeShadingPattern(jo) {
                  switch (typeof jo == "string" && (jo = this.objs.get(jo)), jo[0]) {
                    case "RadialAxial":
                      const fs = `shading${qs++}`, Ao = jo[3];
                      let co;
                      switch (jo[1]) {
                        case "axial":
                          const Co = jo[4], Zs = jo[5];
                          co = this.svgFactory.createElement("svg:linearGradient"), co.setAttributeNS(null, "id", fs), co.setAttributeNS(null, "gradientUnits", "userSpaceOnUse"), co.setAttributeNS(null, "x1", Co[0]), co.setAttributeNS(null, "y1", Co[1]), co.setAttributeNS(null, "x2", Zs[0]), co.setAttributeNS(null, "y2", Zs[1]);
                          break;
                        case "radial":
                          const xl = jo[4], Cl = jo[5], Al = jo[6], Ol = jo[7];
                          co = this.svgFactory.createElement("svg:radialGradient"), co.setAttributeNS(null, "id", fs), co.setAttributeNS(null, "gradientUnits", "userSpaceOnUse"), co.setAttributeNS(null, "cx", Cl[0]), co.setAttributeNS(null, "cy", Cl[1]), co.setAttributeNS(null, "r", Ol), co.setAttributeNS(null, "fx", xl[0]), co.setAttributeNS(null, "fy", xl[1]), co.setAttributeNS(null, "fr", Al);
                          break;
                        default:
                          throw new Error(`Unknown RadialAxial type: ${jo[1]}`);
                      }
                      for (const Co of Ao) {
                        const Zs = this.svgFactory.createElement("svg:stop");
                        Zs.setAttributeNS(null, "offset", Co[0]), Zs.setAttributeNS(null, "stop-color", Co[1]), co.append(Zs);
                      }
                      return this.defs.append(co), `url(#${fs})`;
                    case "Mesh":
                      return (0, ta.warn)("Unimplemented pattern Mesh"), null;
                    case "Dummy":
                      return "hotpink";
                    default:
                      throw new Error(`Unknown IR type: ${jo[0]}`);
                  }
                }
                setDash(jo, fs) {
                  this.current.dashArray = jo, this.current.dashPhase = fs;
                }
                constructPath(jo, fs) {
                  const Ao = this.current;
                  let co = Ao.x, Co = Ao.y, Zs = [], xl = 0;
                  for (const Cl of jo)
                    switch (Cl | 0) {
                      case ta.OPS.rectangle:
                        co = fs[xl++], Co = fs[xl++];
                        const Al = fs[xl++], Ol = fs[xl++], Bl = co + Al, Ml = Co + Ol;
                        Zs.push("M", so(co), so(Co), "L", so(Bl), so(Co), "L", so(Bl), so(Ml), "L", so(co), so(Ml), "Z");
                        break;
                      case ta.OPS.moveTo:
                        co = fs[xl++], Co = fs[xl++], Zs.push("M", so(co), so(Co));
                        break;
                      case ta.OPS.lineTo:
                        co = fs[xl++], Co = fs[xl++], Zs.push("L", so(co), so(Co));
                        break;
                      case ta.OPS.curveTo:
                        co = fs[xl + 4], Co = fs[xl + 5], Zs.push("C", so(fs[xl]), so(fs[xl + 1]), so(fs[xl + 2]), so(fs[xl + 3]), so(co), so(Co)), xl += 6;
                        break;
                      case ta.OPS.curveTo2:
                        Zs.push("C", so(co), so(Co), so(fs[xl]), so(fs[xl + 1]), so(fs[xl + 2]), so(fs[xl + 3])), co = fs[xl + 2], Co = fs[xl + 3], xl += 4;
                        break;
                      case ta.OPS.curveTo3:
                        co = fs[xl + 2], Co = fs[xl + 3], Zs.push("C", so(fs[xl]), so(fs[xl + 1]), so(co), so(Co), so(co), so(Co)), xl += 4;
                        break;
                      case ta.OPS.closePath:
                        Zs.push("Z");
                        break;
                    }
                  Zs = Zs.join(" "), Ao.path && jo.length > 0 && jo[0] !== ta.OPS.rectangle && jo[0] !== ta.OPS.moveTo ? Zs = Ao.path.getAttributeNS(null, "d") + Zs : (Ao.path = this.svgFactory.createElement("svg:path"), this._ensureTransformGroup().append(Ao.path)), Ao.path.setAttributeNS(null, "d", Zs), Ao.path.setAttributeNS(null, "fill", "none"), Ao.element = Ao.path, Ao.setCurrentPoint(co, Co);
                }
                endPath() {
                  const jo = this.current;
                  if (jo.path = null, !this.pendingClip)
                    return;
                  if (!jo.element) {
                    this.pendingClip = null;
                    return;
                  }
                  const fs = `clippath${Rs++}`, Ao = this.svgFactory.createElement("svg:clipPath");
                  Ao.setAttributeNS(null, "id", fs), Ao.setAttributeNS(null, "transform", bs(this.transformMatrix));
                  const co = jo.element.cloneNode(!0);
                  if (this.pendingClip === "evenodd" ? co.setAttributeNS(null, "clip-rule", "evenodd") : co.setAttributeNS(null, "clip-rule", "nonzero"), this.pendingClip = null, Ao.append(co), this.defs.append(Ao), jo.activeClipUrl) {
                    jo.clipGroup = null;
                    for (const Co of this.extraStack)
                      Co.clipGroup = null;
                    Ao.setAttributeNS(null, "clip-path", jo.activeClipUrl);
                  }
                  jo.activeClipUrl = `url(#${fs})`, this.tgrp = null;
                }
                clip(jo) {
                  this.pendingClip = jo;
                }
                closePath() {
                  const jo = this.current;
                  if (jo.path) {
                    const fs = `${jo.path.getAttributeNS(null, "d")}Z`;
                    jo.path.setAttributeNS(null, "d", fs);
                  }
                }
                setLeading(jo) {
                  this.current.leading = -jo;
                }
                setTextRise(jo) {
                  this.current.textRise = jo;
                }
                setTextRenderingMode(jo) {
                  this.current.textRenderingMode = jo;
                }
                setHScale(jo) {
                  this.current.textHScale = jo / 100;
                }
                setRenderingIntent(jo) {
                }
                setFlatness(jo) {
                }
                setGState(jo) {
                  for (const [fs, Ao] of jo)
                    switch (fs) {
                      case "LW":
                        this.setLineWidth(Ao);
                        break;
                      case "LC":
                        this.setLineCap(Ao);
                        break;
                      case "LJ":
                        this.setLineJoin(Ao);
                        break;
                      case "ML":
                        this.setMiterLimit(Ao);
                        break;
                      case "D":
                        this.setDash(Ao[0], Ao[1]);
                        break;
                      case "RI":
                        this.setRenderingIntent(Ao);
                        break;
                      case "FL":
                        this.setFlatness(Ao);
                        break;
                      case "Font":
                        this.setFont(Ao);
                        break;
                      case "CA":
                        this.setStrokeAlpha(Ao);
                        break;
                      case "ca":
                        this.setFillAlpha(Ao);
                        break;
                      default:
                        (0, ta.warn)(`Unimplemented graphic state operator ${fs}`);
                        break;
                    }
                }
                fill() {
                  const jo = this.current;
                  jo.element && (jo.element.setAttributeNS(null, "fill", jo.fillColor), jo.element.setAttributeNS(null, "fill-opacity", jo.fillAlpha), this.endPath());
                }
                stroke() {
                  const jo = this.current;
                  jo.element && (this._setStrokeAttributes(jo.element), jo.element.setAttributeNS(null, "fill", "none"), this.endPath());
                }
                _setStrokeAttributes(jo, fs = 1) {
                  const Ao = this.current;
                  let co = Ao.dashArray;
                  fs !== 1 && co.length > 0 && (co = co.map(function(Co) {
                    return fs * Co;
                  })), jo.setAttributeNS(null, "stroke", Ao.strokeColor), jo.setAttributeNS(null, "stroke-opacity", Ao.strokeAlpha), jo.setAttributeNS(null, "stroke-miterlimit", so(Ao.miterLimit)), jo.setAttributeNS(null, "stroke-linecap", Ao.lineCap), jo.setAttributeNS(null, "stroke-linejoin", Ao.lineJoin), jo.setAttributeNS(null, "stroke-width", so(fs * Ao.lineWidth) + "px"), jo.setAttributeNS(null, "stroke-dasharray", co.map(so).join(" ")), jo.setAttributeNS(null, "stroke-dashoffset", so(fs * Ao.dashPhase) + "px");
                }
                eoFill() {
                  this.current.element && this.current.element.setAttributeNS(null, "fill-rule", "evenodd"), this.fill();
                }
                fillStroke() {
                  this.stroke(), this.fill();
                }
                eoFillStroke() {
                  this.current.element && this.current.element.setAttributeNS(null, "fill-rule", "evenodd"), this.fillStroke();
                }
                closeStroke() {
                  this.closePath(), this.stroke();
                }
                closeFillStroke() {
                  this.closePath(), this.fillStroke();
                }
                closeEOFillStroke() {
                  this.closePath(), this.eoFillStroke();
                }
                paintSolidColorImageMask() {
                  const jo = this.svgFactory.createElement("svg:rect");
                  jo.setAttributeNS(null, "x", "0"), jo.setAttributeNS(null, "y", "0"), jo.setAttributeNS(null, "width", "1px"), jo.setAttributeNS(null, "height", "1px"), jo.setAttributeNS(null, "fill", this.current.fillColor), this._ensureTransformGroup().append(jo);
                }
                paintImageXObject(jo) {
                  const fs = jo.startsWith("g_") ? this.commonObjs.get(jo) : this.objs.get(jo);
                  if (!fs) {
                    (0, ta.warn)(`Dependent image with object ID ${jo} is not ready yet`);
                    return;
                  }
                  this.paintInlineImageXObject(fs);
                }
                paintInlineImageXObject(jo, fs) {
                  const Ao = jo.width, co = jo.height, Co = oo(jo, this.forceDataSchema, !!fs), Zs = this.svgFactory.createElement("svg:rect");
                  Zs.setAttributeNS(null, "x", "0"), Zs.setAttributeNS(null, "y", "0"), Zs.setAttributeNS(null, "width", so(Ao)), Zs.setAttributeNS(null, "height", so(co)), this.current.element = Zs, this.clip("nonzero");
                  const xl = this.svgFactory.createElement("svg:image");
                  xl.setAttributeNS(La, "xlink:href", Co), xl.setAttributeNS(null, "x", "0"), xl.setAttributeNS(null, "y", so(-co)), xl.setAttributeNS(null, "width", so(Ao) + "px"), xl.setAttributeNS(null, "height", so(co) + "px"), xl.setAttributeNS(null, "transform", `scale(${so(1 / Ao)} ${so(-1 / co)})`), fs ? fs.append(xl) : this._ensureTransformGroup().append(xl);
                }
                paintImageMaskXObject(jo) {
                  const fs = this.current, Ao = jo.width, co = jo.height, Co = fs.fillColor;
                  fs.maskId = `mask${js++}`;
                  const Zs = this.svgFactory.createElement("svg:mask");
                  Zs.setAttributeNS(null, "id", fs.maskId);
                  const xl = this.svgFactory.createElement("svg:rect");
                  xl.setAttributeNS(null, "x", "0"), xl.setAttributeNS(null, "y", "0"), xl.setAttributeNS(null, "width", so(Ao)), xl.setAttributeNS(null, "height", so(co)), xl.setAttributeNS(null, "fill", Co), xl.setAttributeNS(null, "mask", `url(#${fs.maskId})`), this.defs.append(Zs), this._ensureTransformGroup().append(xl), this.paintInlineImageXObject(jo, Zs);
                }
                paintFormXObjectBegin(jo, fs) {
                  if (Array.isArray(jo) && jo.length === 6 && this.transform(jo[0], jo[1], jo[2], jo[3], jo[4], jo[5]), fs) {
                    const Ao = fs[2] - fs[0], co = fs[3] - fs[1], Co = this.svgFactory.createElement("svg:rect");
                    Co.setAttributeNS(null, "x", fs[0]), Co.setAttributeNS(null, "y", fs[1]), Co.setAttributeNS(null, "width", so(Ao)), Co.setAttributeNS(null, "height", so(co)), this.current.element = Co, this.clip("nonzero"), this.endPath();
                  }
                }
                paintFormXObjectEnd() {
                }
                _initialize(jo) {
                  const fs = this.svgFactory.create(jo.width, jo.height), Ao = this.svgFactory.createElement("svg:defs");
                  fs.append(Ao), this.defs = Ao;
                  const co = this.svgFactory.createElement("svg:g");
                  return co.setAttributeNS(null, "transform", bs(jo.transform)), fs.append(co), this.svg = co, fs;
                }
                _ensureClipGroup() {
                  if (!this.current.clipGroup) {
                    const jo = this.svgFactory.createElement("svg:g");
                    jo.setAttributeNS(null, "clip-path", this.current.activeClipUrl), this.svg.append(jo), this.current.clipGroup = jo;
                  }
                  return this.current.clipGroup;
                }
                _ensureTransformGroup() {
                  return this.tgrp || (this.tgrp = this.svgFactory.createElement("svg:g"), this.tgrp.setAttributeNS(null, "transform", bs(this.transformMatrix)), this.current.activeClipUrl ? this._ensureClipGroup().append(this.tgrp) : this.svg.append(this.tgrp)), this.tgrp;
                }
              };
            }
          },
          /* 32 */
          /***/
          (Bi, e, Ui) => {
            Object.defineProperty(e, "__esModule", {
              value: !0
            }), e.PDFNodeStream = void 0;
            var Zi = Ui(1), ta = Ui(33);
            const na = require$$5, ia = require$$5, aa = require$$5, da = require$$5, La = /^file:\/\/\/[a-zA-Z]:\//;
            function qa(js) {
              const qs = da.parse(js);
              return qs.protocol === "file:" || qs.host ? qs : /^[a-z]:[/\\]/i.test(js) ? da.parse(`file:///${js}`) : (qs.host || (qs.protocol = "file:"), qs);
            }
            class io {
              constructor(qs) {
                this.source = qs, this.url = qa(qs.url), this.isHttp = this.url.protocol === "http:" || this.url.protocol === "https:", this.isFsUrl = this.url.protocol === "file:", this.httpHeaders = this.isHttp && qs.httpHeaders || {}, this._fullRequestReader = null, this._rangeRequestReaders = [];
              }
              get _progressiveDataLength() {
                return this._fullRequestReader?._loaded ?? 0;
              }
              getFullReader() {
                return (0, Zi.assert)(!this._fullRequestReader, "PDFNodeStream.getFullReader can only be called once."), this._fullRequestReader = this.isFsUrl ? new bs(this) : new lo(this), this._fullRequestReader;
              }
              getRangeReader(qs, jo) {
                if (jo <= this._progressiveDataLength)
                  return null;
                const fs = this.isFsUrl ? new Rs(this, qs, jo) : new so(this, qs, jo);
                return this._rangeRequestReaders.push(fs), fs;
              }
              cancelAllRequests(qs) {
                this._fullRequestReader && this._fullRequestReader.cancel(qs);
                for (const jo of this._rangeRequestReaders.slice(0))
                  jo.cancel(qs);
              }
            }
            e.PDFNodeStream = io;
            class ao {
              constructor(qs) {
                this._url = qs.url, this._done = !1, this._storedError = null, this.onProgress = null;
                const jo = qs.source;
                this._contentLength = jo.length, this._loaded = 0, this._filename = null, this._disableRange = jo.disableRange || !1, this._rangeChunkSize = jo.rangeChunkSize, !this._rangeChunkSize && !this._disableRange && (this._disableRange = !0), this._isStreamingSupported = !jo.disableStream, this._isRangeSupported = !jo.disableRange, this._readableStream = null, this._readCapability = (0, Zi.createPromiseCapability)(), this._headersCapability = (0, Zi.createPromiseCapability)();
              }
              get headersReady() {
                return this._headersCapability.promise;
              }
              get filename() {
                return this._filename;
              }
              get contentLength() {
                return this._contentLength;
              }
              get isRangeSupported() {
                return this._isRangeSupported;
              }
              get isStreamingSupported() {
                return this._isStreamingSupported;
              }
              async read() {
                if (await this._readCapability.promise, this._done)
                  return {
                    value: void 0,
                    done: !0
                  };
                if (this._storedError)
                  throw this._storedError;
                const qs = this._readableStream.read();
                return qs === null ? (this._readCapability = (0, Zi.createPromiseCapability)(), this.read()) : (this._loaded += qs.length, this.onProgress && this.onProgress({
                  loaded: this._loaded,
                  total: this._contentLength
                }), {
                  value: new Uint8Array(qs).buffer,
                  done: !1
                });
              }
              cancel(qs) {
                if (!this._readableStream) {
                  this._error(qs);
                  return;
                }
                this._readableStream.destroy(qs);
              }
              _error(qs) {
                this._storedError = qs, this._readCapability.resolve();
              }
              _setReadableStream(qs) {
                this._readableStream = qs, qs.on("readable", () => {
                  this._readCapability.resolve();
                }), qs.on("end", () => {
                  qs.destroy(), this._done = !0, this._readCapability.resolve();
                }), qs.on("error", (jo) => {
                  this._error(jo);
                }), !this._isStreamingSupported && this._isRangeSupported && this._error(new Zi.AbortException("streaming is disabled")), this._storedError && this._readableStream.destroy(this._storedError);
              }
            }
            class oo {
              constructor(qs) {
                this._url = qs.url, this._done = !1, this._storedError = null, this.onProgress = null, this._loaded = 0, this._readableStream = null, this._readCapability = (0, Zi.createPromiseCapability)();
                const jo = qs.source;
                this._isStreamingSupported = !jo.disableStream;
              }
              get isStreamingSupported() {
                return this._isStreamingSupported;
              }
              async read() {
                if (await this._readCapability.promise, this._done)
                  return {
                    value: void 0,
                    done: !0
                  };
                if (this._storedError)
                  throw this._storedError;
                const qs = this._readableStream.read();
                return qs === null ? (this._readCapability = (0, Zi.createPromiseCapability)(), this.read()) : (this._loaded += qs.length, this.onProgress && this.onProgress({
                  loaded: this._loaded
                }), {
                  value: new Uint8Array(qs).buffer,
                  done: !1
                });
              }
              cancel(qs) {
                if (!this._readableStream) {
                  this._error(qs);
                  return;
                }
                this._readableStream.destroy(qs);
              }
              _error(qs) {
                this._storedError = qs, this._readCapability.resolve();
              }
              _setReadableStream(qs) {
                this._readableStream = qs, qs.on("readable", () => {
                  this._readCapability.resolve();
                }), qs.on("end", () => {
                  qs.destroy(), this._done = !0, this._readCapability.resolve();
                }), qs.on("error", (jo) => {
                  this._error(jo);
                }), this._storedError && this._readableStream.destroy(this._storedError);
              }
            }
            function no(js, qs) {
              return {
                protocol: js.protocol,
                auth: js.auth,
                host: js.hostname,
                port: js.port,
                path: js.path,
                method: "GET",
                headers: qs
              };
            }
            class lo extends ao {
              constructor(qs) {
                super(qs);
                const jo = (fs) => {
                  if (fs.statusCode === 404) {
                    const Zs = new Zi.MissingPDFException(`Missing PDF "${this._url}".`);
                    this._storedError = Zs, this._headersCapability.reject(Zs);
                    return;
                  }
                  this._headersCapability.resolve(), this._setReadableStream(fs);
                  const Ao = (Zs) => this._readableStream.headers[Zs.toLowerCase()], {
                    allowRangeRequests: co,
                    suggestedLength: Co
                  } = (0, ta.validateRangeRequestCapabilities)({
                    getResponseHeader: Ao,
                    isHttp: qs.isHttp,
                    rangeChunkSize: this._rangeChunkSize,
                    disableRange: this._disableRange
                  });
                  this._isRangeSupported = co, this._contentLength = Co || this._contentLength, this._filename = (0, ta.extractFilenameFromHeader)(Ao);
                };
                this._request = null, this._url.protocol === "http:" ? this._request = ia.request(no(this._url, qs.httpHeaders), jo) : this._request = aa.request(no(this._url, qs.httpHeaders), jo), this._request.on("error", (fs) => {
                  this._storedError = fs, this._headersCapability.reject(fs);
                }), this._request.end();
              }
            }
            class so extends oo {
              constructor(qs, jo, fs) {
                super(qs), this._httpHeaders = {};
                for (const co in qs.httpHeaders) {
                  const Co = qs.httpHeaders[co];
                  typeof Co > "u" || (this._httpHeaders[co] = Co);
                }
                this._httpHeaders.Range = `bytes=${jo}-${fs - 1}`;
                const Ao = (co) => {
                  if (co.statusCode === 404) {
                    const Co = new Zi.MissingPDFException(`Missing PDF "${this._url}".`);
                    this._storedError = Co;
                    return;
                  }
                  this._setReadableStream(co);
                };
                this._request = null, this._url.protocol === "http:" ? this._request = ia.request(no(this._url, this._httpHeaders), Ao) : this._request = aa.request(no(this._url, this._httpHeaders), Ao), this._request.on("error", (co) => {
                  this._storedError = co;
                }), this._request.end();
              }
            }
            class bs extends ao {
              constructor(qs) {
                super(qs);
                let jo = decodeURIComponent(this._url.path);
                La.test(this._url.href) && (jo = jo.replace(/^\//, "")), na.lstat(jo, (fs, Ao) => {
                  if (fs) {
                    fs.code === "ENOENT" && (fs = new Zi.MissingPDFException(`Missing PDF "${jo}".`)), this._storedError = fs, this._headersCapability.reject(fs);
                    return;
                  }
                  this._contentLength = Ao.size, this._setReadableStream(na.createReadStream(jo)), this._headersCapability.resolve();
                });
              }
            }
            class Rs extends oo {
              constructor(qs, jo, fs) {
                super(qs);
                let Ao = decodeURIComponent(this._url.path);
                La.test(this._url.href) && (Ao = Ao.replace(/^\//, "")), this._setReadableStream(na.createReadStream(Ao, {
                  start: jo,
                  end: fs - 1
                }));
              }
            }
          },
          /* 33 */
          /***/
          (Bi, e, Ui) => {
            Object.defineProperty(e, "__esModule", {
              value: !0
            }), e.createResponseStatusError = da, e.extractFilenameFromHeader = aa, e.validateRangeRequestCapabilities = ia, e.validateResponseStatus = La;
            var Zi = Ui(1), ta = Ui(34), na = Ui(8);
            function ia({
              getResponseHeader: qa,
              isHttp: io,
              rangeChunkSize: ao,
              disableRange: oo
            }) {
              const no = {
                allowRangeRequests: !1,
                suggestedLength: void 0
              }, lo = parseInt(qa("Content-Length"), 10);
              return !Number.isInteger(lo) || (no.suggestedLength = lo, lo <= 2 * ao) || oo || !io || qa("Accept-Ranges") !== "bytes" || (qa("Content-Encoding") || "identity") !== "identity" || (no.allowRangeRequests = !0), no;
            }
            function aa(qa) {
              const io = qa("Content-Disposition");
              if (io) {
                let ao = (0, ta.getFilenameFromContentDispositionHeader)(io);
                if (ao.includes("%"))
                  try {
                    ao = decodeURIComponent(ao);
                  } catch {
                  }
                if ((0, na.isPdfFile)(ao))
                  return ao;
              }
              return null;
            }
            function da(qa, io) {
              return qa === 404 || qa === 0 && io.startsWith("file:") ? new Zi.MissingPDFException('Missing PDF "' + io + '".') : new Zi.UnexpectedResponseException(`Unexpected server response (${qa}) while retrieving PDF "${io}".`, qa);
            }
            function La(qa) {
              return qa === 200 || qa === 206;
            }
          },
          /* 34 */
          /***/
          (Bi, e, Ui) => {
            Object.defineProperty(e, "__esModule", {
              value: !0
            }), e.getFilenameFromContentDispositionHeader = ta;
            var Zi = Ui(1);
            function ta(na) {
              let ia = !0, aa = da("filename\\*", "i").exec(na);
              if (aa) {
                aa = aa[1];
                let lo = ao(aa);
                return lo = unescape(lo), lo = oo(lo), lo = no(lo), qa(lo);
              }
              if (aa = io(na), aa) {
                const lo = no(aa);
                return qa(lo);
              }
              if (aa = da("filename", "i").exec(na), aa) {
                aa = aa[1];
                let lo = ao(aa);
                return lo = no(lo), qa(lo);
              }
              function da(lo, so) {
                return new RegExp("(?:^|;)\\s*" + lo + '\\s*=\\s*([^";\\s][^;\\s]*|"(?:[^"\\\\]|\\\\"?)+"?)', so);
              }
              function La(lo, so) {
                if (lo) {
                  if (!/^[\x00-\xFF]+$/.test(so))
                    return so;
                  try {
                    const bs = new TextDecoder(lo, {
                      fatal: !0
                    }), Rs = (0, Zi.stringToBytes)(so);
                    so = bs.decode(Rs), ia = !1;
                  } catch {
                  }
                }
                return so;
              }
              function qa(lo) {
                return ia && /[\x80-\xff]/.test(lo) && (lo = La("utf-8", lo), ia && (lo = La("iso-8859-1", lo))), lo;
              }
              function io(lo) {
                const so = [];
                let bs;
                const Rs = da("filename\\*((?!0\\d)\\d+)(\\*?)", "ig");
                for (; (bs = Rs.exec(lo)) !== null; ) {
                  let [, qs, jo, fs] = bs;
                  if (qs = parseInt(qs, 10), qs in so) {
                    if (qs === 0)
                      break;
                    continue;
                  }
                  so[qs] = [jo, fs];
                }
                const js = [];
                for (let qs = 0; qs < so.length && qs in so; ++qs) {
                  let [jo, fs] = so[qs];
                  fs = ao(fs), jo && (fs = unescape(fs), qs === 0 && (fs = oo(fs))), js.push(fs);
                }
                return js.join("");
              }
              function ao(lo) {
                if (lo.startsWith('"')) {
                  const so = lo.slice(1).split('\\"');
                  for (let bs = 0; bs < so.length; ++bs) {
                    const Rs = so[bs].indexOf('"');
                    Rs !== -1 && (so[bs] = so[bs].slice(0, Rs), so.length = bs + 1), so[bs] = so[bs].replace(/\\(.)/g, "$1");
                  }
                  lo = so.join('"');
                }
                return lo;
              }
              function oo(lo) {
                const so = lo.indexOf("'");
                if (so === -1)
                  return lo;
                const bs = lo.slice(0, so), js = lo.slice(so + 1).replace(/^[^']*'/, "");
                return La(bs, js);
              }
              function no(lo) {
                return !lo.startsWith("=?") || /[\x00-\x19\x80-\xff]/.test(lo) ? lo : lo.replace(/=\?([\w-]*)\?([QqBb])\?((?:[^?]|\?(?!=))*)\?=/g, function(so, bs, Rs, js) {
                  if (Rs === "q" || Rs === "Q")
                    return js = js.replace(/_/g, " "), js = js.replace(/=([0-9a-fA-F]{2})/g, function(qs, jo) {
                      return String.fromCharCode(parseInt(jo, 16));
                    }), La(bs, js);
                  try {
                    js = atob(js);
                  } catch {
                  }
                  return La(bs, js);
                });
              }
              return "";
            }
          },
          /* 35 */
          /***/
          (Bi, e, Ui) => {
            Object.defineProperty(e, "__esModule", {
              value: !0
            }), e.PDFNetworkStream = void 0;
            var Zi = Ui(1), ta = Ui(33);
            const na = 200, ia = 206;
            function aa(ao) {
              const oo = ao.response;
              return typeof oo != "string" ? oo : (0, Zi.stringToBytes)(oo).buffer;
            }
            class da {
              constructor(oo, no = {}) {
                this.url = oo, this.isHttp = /^https?:/i.test(oo), this.httpHeaders = this.isHttp && no.httpHeaders || /* @__PURE__ */ Object.create(null), this.withCredentials = no.withCredentials || !1, this.getXhr = no.getXhr || function() {
                  return new XMLHttpRequest();
                }, this.currXhrId = 0, this.pendingRequests = /* @__PURE__ */ Object.create(null);
              }
              requestRange(oo, no, lo) {
                const so = {
                  begin: oo,
                  end: no
                };
                for (const bs in lo)
                  so[bs] = lo[bs];
                return this.request(so);
              }
              requestFull(oo) {
                return this.request(oo);
              }
              request(oo) {
                const no = this.getXhr(), lo = this.currXhrId++, so = this.pendingRequests[lo] = {
                  xhr: no
                };
                no.open("GET", this.url), no.withCredentials = this.withCredentials;
                for (const bs in this.httpHeaders) {
                  const Rs = this.httpHeaders[bs];
                  typeof Rs > "u" || no.setRequestHeader(bs, Rs);
                }
                return this.isHttp && "begin" in oo && "end" in oo ? (no.setRequestHeader("Range", `bytes=${oo.begin}-${oo.end - 1}`), so.expectedStatus = ia) : so.expectedStatus = na, no.responseType = "arraybuffer", oo.onError && (no.onerror = function(bs) {
                  oo.onError(no.status);
                }), no.onreadystatechange = this.onStateChange.bind(this, lo), no.onprogress = this.onProgress.bind(this, lo), so.onHeadersReceived = oo.onHeadersReceived, so.onDone = oo.onDone, so.onError = oo.onError, so.onProgress = oo.onProgress, no.send(null), lo;
              }
              onProgress(oo, no) {
                const lo = this.pendingRequests[oo];
                lo && lo.onProgress?.(no);
              }
              onStateChange(oo, no) {
                const lo = this.pendingRequests[oo];
                if (!lo)
                  return;
                const so = lo.xhr;
                if (so.readyState >= 2 && lo.onHeadersReceived && (lo.onHeadersReceived(), delete lo.onHeadersReceived), so.readyState !== 4 || !(oo in this.pendingRequests))
                  return;
                if (delete this.pendingRequests[oo], so.status === 0 && this.isHttp) {
                  lo.onError?.(so.status);
                  return;
                }
                const bs = so.status || na;
                if (!(bs === na && lo.expectedStatus === ia) && bs !== lo.expectedStatus) {
                  lo.onError?.(so.status);
                  return;
                }
                const js = aa(so);
                if (bs === ia) {
                  const qs = so.getResponseHeader("Content-Range"), jo = /bytes (\d+)-(\d+)\/(\d+)/.exec(qs);
                  lo.onDone({
                    begin: parseInt(jo[1], 10),
                    chunk: js
                  });
                } else js ? lo.onDone({
                  begin: 0,
                  chunk: js
                }) : lo.onError?.(so.status);
              }
              getRequestXhr(oo) {
                return this.pendingRequests[oo].xhr;
              }
              isPendingRequest(oo) {
                return oo in this.pendingRequests;
              }
              abortRequest(oo) {
                const no = this.pendingRequests[oo].xhr;
                delete this.pendingRequests[oo], no.abort();
              }
            }
            class La {
              constructor(oo) {
                this._source = oo, this._manager = new da(oo.url, {
                  httpHeaders: oo.httpHeaders,
                  withCredentials: oo.withCredentials
                }), this._rangeChunkSize = oo.rangeChunkSize, this._fullRequestReader = null, this._rangeRequestReaders = [];
              }
              _onRangeRequestReaderClosed(oo) {
                const no = this._rangeRequestReaders.indexOf(oo);
                no >= 0 && this._rangeRequestReaders.splice(no, 1);
              }
              getFullReader() {
                return (0, Zi.assert)(!this._fullRequestReader, "PDFNetworkStream.getFullReader can only be called once."), this._fullRequestReader = new qa(this._manager, this._source), this._fullRequestReader;
              }
              getRangeReader(oo, no) {
                const lo = new io(this._manager, oo, no);
                return lo.onClosed = this._onRangeRequestReaderClosed.bind(this), this._rangeRequestReaders.push(lo), lo;
              }
              cancelAllRequests(oo) {
                this._fullRequestReader?.cancel(oo);
                for (const no of this._rangeRequestReaders.slice(0))
                  no.cancel(oo);
              }
            }
            e.PDFNetworkStream = La;
            class qa {
              constructor(oo, no) {
                this._manager = oo;
                const lo = {
                  onHeadersReceived: this._onHeadersReceived.bind(this),
                  onDone: this._onDone.bind(this),
                  onError: this._onError.bind(this),
                  onProgress: this._onProgress.bind(this)
                };
                this._url = no.url, this._fullRequestId = oo.requestFull(lo), this._headersReceivedCapability = (0, Zi.createPromiseCapability)(), this._disableRange = no.disableRange || !1, this._contentLength = no.length, this._rangeChunkSize = no.rangeChunkSize, !this._rangeChunkSize && !this._disableRange && (this._disableRange = !0), this._isStreamingSupported = !1, this._isRangeSupported = !1, this._cachedChunks = [], this._requests = [], this._done = !1, this._storedError = void 0, this._filename = null, this.onProgress = null;
              }
              _onHeadersReceived() {
                const oo = this._fullRequestId, no = this._manager.getRequestXhr(oo), lo = (Rs) => no.getResponseHeader(Rs), {
                  allowRangeRequests: so,
                  suggestedLength: bs
                } = (0, ta.validateRangeRequestCapabilities)({
                  getResponseHeader: lo,
                  isHttp: this._manager.isHttp,
                  rangeChunkSize: this._rangeChunkSize,
                  disableRange: this._disableRange
                });
                so && (this._isRangeSupported = !0), this._contentLength = bs || this._contentLength, this._filename = (0, ta.extractFilenameFromHeader)(lo), this._isRangeSupported && this._manager.abortRequest(oo), this._headersReceivedCapability.resolve();
              }
              _onDone(oo) {
                if (oo && (this._requests.length > 0 ? this._requests.shift().resolve({
                  value: oo.chunk,
                  done: !1
                }) : this._cachedChunks.push(oo.chunk)), this._done = !0, !(this._cachedChunks.length > 0)) {
                  for (const no of this._requests)
                    no.resolve({
                      value: void 0,
                      done: !0
                    });
                  this._requests.length = 0;
                }
              }
              _onError(oo) {
                this._storedError = (0, ta.createResponseStatusError)(oo, this._url), this._headersReceivedCapability.reject(this._storedError);
                for (const no of this._requests)
                  no.reject(this._storedError);
                this._requests.length = 0, this._cachedChunks.length = 0;
              }
              _onProgress(oo) {
                this.onProgress?.({
                  loaded: oo.loaded,
                  total: oo.lengthComputable ? oo.total : this._contentLength
                });
              }
              get filename() {
                return this._filename;
              }
              get isRangeSupported() {
                return this._isRangeSupported;
              }
              get isStreamingSupported() {
                return this._isStreamingSupported;
              }
              get contentLength() {
                return this._contentLength;
              }
              get headersReady() {
                return this._headersReceivedCapability.promise;
              }
              async read() {
                if (this._storedError)
                  throw this._storedError;
                if (this._cachedChunks.length > 0)
                  return {
                    value: this._cachedChunks.shift(),
                    done: !1
                  };
                if (this._done)
                  return {
                    value: void 0,
                    done: !0
                  };
                const oo = (0, Zi.createPromiseCapability)();
                return this._requests.push(oo), oo.promise;
              }
              cancel(oo) {
                this._done = !0, this._headersReceivedCapability.reject(oo);
                for (const no of this._requests)
                  no.resolve({
                    value: void 0,
                    done: !0
                  });
                this._requests.length = 0, this._manager.isPendingRequest(this._fullRequestId) && this._manager.abortRequest(this._fullRequestId), this._fullRequestReader = null;
              }
            }
            class io {
              constructor(oo, no, lo) {
                this._manager = oo;
                const so = {
                  onDone: this._onDone.bind(this),
                  onError: this._onError.bind(this),
                  onProgress: this._onProgress.bind(this)
                };
                this._url = oo.url, this._requestId = oo.requestRange(no, lo, so), this._requests = [], this._queuedChunk = null, this._done = !1, this._storedError = void 0, this.onProgress = null, this.onClosed = null;
              }
              _close() {
                this.onClosed?.(this);
              }
              _onDone(oo) {
                const no = oo.chunk;
                this._requests.length > 0 ? this._requests.shift().resolve({
                  value: no,
                  done: !1
                }) : this._queuedChunk = no, this._done = !0;
                for (const lo of this._requests)
                  lo.resolve({
                    value: void 0,
                    done: !0
                  });
                this._requests.length = 0, this._close();
              }
              _onError(oo) {
                this._storedError = (0, ta.createResponseStatusError)(oo, this._url);
                for (const no of this._requests)
                  no.reject(this._storedError);
                this._requests.length = 0, this._queuedChunk = null;
              }
              _onProgress(oo) {
                this.isStreamingSupported || this.onProgress?.({
                  loaded: oo.loaded
                });
              }
              get isStreamingSupported() {
                return !1;
              }
              async read() {
                if (this._storedError)
                  throw this._storedError;
                if (this._queuedChunk !== null) {
                  const no = this._queuedChunk;
                  return this._queuedChunk = null, {
                    value: no,
                    done: !1
                  };
                }
                if (this._done)
                  return {
                    value: void 0,
                    done: !0
                  };
                const oo = (0, Zi.createPromiseCapability)();
                return this._requests.push(oo), oo.promise;
              }
              cancel(oo) {
                this._done = !0;
                for (const no of this._requests)
                  no.resolve({
                    value: void 0,
                    done: !0
                  });
                this._requests.length = 0, this._manager.isPendingRequest(this._requestId) && this._manager.abortRequest(this._requestId), this._close();
              }
            }
          },
          /* 36 */
          /***/
          (Bi, e, Ui) => {
            Object.defineProperty(e, "__esModule", {
              value: !0
            }), e.PDFFetchStream = void 0;
            var Zi = Ui(1), ta = Ui(33);
            function na(qa, io, ao) {
              return {
                method: "GET",
                headers: qa,
                signal: ao.signal,
                mode: "cors",
                credentials: io ? "include" : "same-origin",
                redirect: "follow"
              };
            }
            function ia(qa) {
              const io = new Headers();
              for (const ao in qa) {
                const oo = qa[ao];
                typeof oo > "u" || io.append(ao, oo);
              }
              return io;
            }
            class aa {
              constructor(io) {
                this.source = io, this.isHttp = /^https?:/i.test(io.url), this.httpHeaders = this.isHttp && io.httpHeaders || {}, this._fullRequestReader = null, this._rangeRequestReaders = [];
              }
              get _progressiveDataLength() {
                return this._fullRequestReader?._loaded ?? 0;
              }
              getFullReader() {
                return (0, Zi.assert)(!this._fullRequestReader, "PDFFetchStream.getFullReader can only be called once."), this._fullRequestReader = new da(this), this._fullRequestReader;
              }
              getRangeReader(io, ao) {
                if (ao <= this._progressiveDataLength)
                  return null;
                const oo = new La(this, io, ao);
                return this._rangeRequestReaders.push(oo), oo;
              }
              cancelAllRequests(io) {
                this._fullRequestReader && this._fullRequestReader.cancel(io);
                for (const ao of this._rangeRequestReaders.slice(0))
                  ao.cancel(io);
              }
            }
            e.PDFFetchStream = aa;
            class da {
              constructor(io) {
                this._stream = io, this._reader = null, this._loaded = 0, this._filename = null;
                const ao = io.source;
                this._withCredentials = ao.withCredentials || !1, this._contentLength = ao.length, this._headersCapability = (0, Zi.createPromiseCapability)(), this._disableRange = ao.disableRange || !1, this._rangeChunkSize = ao.rangeChunkSize, !this._rangeChunkSize && !this._disableRange && (this._disableRange = !0), this._abortController = new AbortController(), this._isStreamingSupported = !ao.disableStream, this._isRangeSupported = !ao.disableRange, this._headers = ia(this._stream.httpHeaders);
                const oo = ao.url;
                fetch(oo, na(this._headers, this._withCredentials, this._abortController)).then((no) => {
                  if (!(0, ta.validateResponseStatus)(no.status))
                    throw (0, ta.createResponseStatusError)(no.status, oo);
                  this._reader = no.body.getReader(), this._headersCapability.resolve();
                  const lo = (Rs) => no.headers.get(Rs), {
                    allowRangeRequests: so,
                    suggestedLength: bs
                  } = (0, ta.validateRangeRequestCapabilities)({
                    getResponseHeader: lo,
                    isHttp: this._stream.isHttp,
                    rangeChunkSize: this._rangeChunkSize,
                    disableRange: this._disableRange
                  });
                  this._isRangeSupported = so, this._contentLength = bs || this._contentLength, this._filename = (0, ta.extractFilenameFromHeader)(lo), !this._isStreamingSupported && this._isRangeSupported && this.cancel(new Zi.AbortException("Streaming is disabled."));
                }).catch(this._headersCapability.reject), this.onProgress = null;
              }
              get headersReady() {
                return this._headersCapability.promise;
              }
              get filename() {
                return this._filename;
              }
              get contentLength() {
                return this._contentLength;
              }
              get isRangeSupported() {
                return this._isRangeSupported;
              }
              get isStreamingSupported() {
                return this._isStreamingSupported;
              }
              async read() {
                await this._headersCapability.promise;
                const {
                  value: io,
                  done: ao
                } = await this._reader.read();
                return ao ? {
                  value: io,
                  done: ao
                } : (this._loaded += io.byteLength, this.onProgress && this.onProgress({
                  loaded: this._loaded,
                  total: this._contentLength
                }), {
                  value: new Uint8Array(io).buffer,
                  done: !1
                });
              }
              cancel(io) {
                this._reader && this._reader.cancel(io), this._abortController.abort();
              }
            }
            class La {
              constructor(io, ao, oo) {
                this._stream = io, this._reader = null, this._loaded = 0;
                const no = io.source;
                this._withCredentials = no.withCredentials || !1, this._readCapability = (0, Zi.createPromiseCapability)(), this._isStreamingSupported = !no.disableStream, this._abortController = new AbortController(), this._headers = ia(this._stream.httpHeaders), this._headers.append("Range", `bytes=${ao}-${oo - 1}`);
                const lo = no.url;
                fetch(lo, na(this._headers, this._withCredentials, this._abortController)).then((so) => {
                  if (!(0, ta.validateResponseStatus)(so.status))
                    throw (0, ta.createResponseStatusError)(so.status, lo);
                  this._readCapability.resolve(), this._reader = so.body.getReader();
                }).catch(this._readCapability.reject), this.onProgress = null;
              }
              get isStreamingSupported() {
                return this._isStreamingSupported;
              }
              async read() {
                await this._readCapability.promise;
                const {
                  value: io,
                  done: ao
                } = await this._reader.read();
                return ao ? {
                  value: io,
                  done: ao
                } : (this._loaded += io.byteLength, this.onProgress && this.onProgress({
                  loaded: this._loaded
                }), {
                  value: new Uint8Array(io).buffer,
                  done: !1
                });
              }
              cancel(io) {
                this._reader && this._reader.cancel(io), this._abortController.abort();
              }
            }
          }
          /******/
        ], __webpack_module_cache__ = {};
        function __w_pdfjs_require__(Bi) {
          var e = __webpack_module_cache__[Bi];
          if (e !== void 0)
            return e.exports;
          var Ui = __webpack_module_cache__[Bi] = {
            /******/
            // no module.id needed
            /******/
            // no module.loaded needed
            /******/
            exports: {}
            /******/
          };
          return __webpack_modules__[Bi](Ui, Ui.exports, __w_pdfjs_require__), Ui.exports;
        }
        var __webpack_exports__ = {};
        return (() => {
          var Bi = __webpack_exports__;
          Object.defineProperty(Bi, "__esModule", {
            value: !0
          }), Object.defineProperty(Bi, "AnnotationEditorLayer", {
            enumerable: !0,
            get: function() {
              return ta.AnnotationEditorLayer;
            }
          }), Object.defineProperty(Bi, "AnnotationEditorParamsType", {
            enumerable: !0,
            get: function() {
              return e.AnnotationEditorParamsType;
            }
          }), Object.defineProperty(Bi, "AnnotationEditorType", {
            enumerable: !0,
            get: function() {
              return e.AnnotationEditorType;
            }
          }), Object.defineProperty(Bi, "AnnotationEditorUIManager", {
            enumerable: !0,
            get: function() {
              return na.AnnotationEditorUIManager;
            }
          }), Object.defineProperty(Bi, "AnnotationLayer", {
            enumerable: !0,
            get: function() {
              return ia.AnnotationLayer;
            }
          }), Object.defineProperty(Bi, "AnnotationMode", {
            enumerable: !0,
            get: function() {
              return e.AnnotationMode;
            }
          }), Object.defineProperty(Bi, "CMapCompressionType", {
            enumerable: !0,
            get: function() {
              return e.CMapCompressionType;
            }
          }), Object.defineProperty(Bi, "GlobalWorkerOptions", {
            enumerable: !0,
            get: function() {
              return aa.GlobalWorkerOptions;
            }
          }), Object.defineProperty(Bi, "InvalidPDFException", {
            enumerable: !0,
            get: function() {
              return e.InvalidPDFException;
            }
          }), Object.defineProperty(Bi, "LoopbackPort", {
            enumerable: !0,
            get: function() {
              return Ui.LoopbackPort;
            }
          }), Object.defineProperty(Bi, "MissingPDFException", {
            enumerable: !0,
            get: function() {
              return e.MissingPDFException;
            }
          }), Object.defineProperty(Bi, "OPS", {
            enumerable: !0,
            get: function() {
              return e.OPS;
            }
          }), Object.defineProperty(Bi, "PDFDataRangeTransport", {
            enumerable: !0,
            get: function() {
              return Ui.PDFDataRangeTransport;
            }
          }), Object.defineProperty(Bi, "PDFDateString", {
            enumerable: !0,
            get: function() {
              return Zi.PDFDateString;
            }
          }), Object.defineProperty(Bi, "PDFWorker", {
            enumerable: !0,
            get: function() {
              return Ui.PDFWorker;
            }
          }), Object.defineProperty(Bi, "PasswordResponses", {
            enumerable: !0,
            get: function() {
              return e.PasswordResponses;
            }
          }), Object.defineProperty(Bi, "PermissionFlag", {
            enumerable: !0,
            get: function() {
              return e.PermissionFlag;
            }
          }), Object.defineProperty(Bi, "PixelsPerInch", {
            enumerable: !0,
            get: function() {
              return Zi.PixelsPerInch;
            }
          }), Object.defineProperty(Bi, "RenderingCancelledException", {
            enumerable: !0,
            get: function() {
              return Zi.RenderingCancelledException;
            }
          }), Object.defineProperty(Bi, "SVGGraphics", {
            enumerable: !0,
            get: function() {
              return qa.SVGGraphics;
            }
          }), Object.defineProperty(Bi, "UNSUPPORTED_FEATURES", {
            enumerable: !0,
            get: function() {
              return e.UNSUPPORTED_FEATURES;
            }
          }), Object.defineProperty(Bi, "UnexpectedResponseException", {
            enumerable: !0,
            get: function() {
              return e.UnexpectedResponseException;
            }
          }), Object.defineProperty(Bi, "Util", {
            enumerable: !0,
            get: function() {
              return e.Util;
            }
          }), Object.defineProperty(Bi, "VerbosityLevel", {
            enumerable: !0,
            get: function() {
              return e.VerbosityLevel;
            }
          }), Object.defineProperty(Bi, "XfaLayer", {
            enumerable: !0,
            get: function() {
              return io.XfaLayer;
            }
          }), Object.defineProperty(Bi, "build", {
            enumerable: !0,
            get: function() {
              return Ui.build;
            }
          }), Object.defineProperty(Bi, "createPromiseCapability", {
            enumerable: !0,
            get: function() {
              return e.createPromiseCapability;
            }
          }), Object.defineProperty(Bi, "createValidAbsoluteUrl", {
            enumerable: !0,
            get: function() {
              return e.createValidAbsoluteUrl;
            }
          }), Object.defineProperty(Bi, "getDocument", {
            enumerable: !0,
            get: function() {
              return Ui.getDocument;
            }
          }), Object.defineProperty(Bi, "getFilenameFromUrl", {
            enumerable: !0,
            get: function() {
              return Zi.getFilenameFromUrl;
            }
          }), Object.defineProperty(Bi, "getPdfFilenameFromUrl", {
            enumerable: !0,
            get: function() {
              return Zi.getPdfFilenameFromUrl;
            }
          }), Object.defineProperty(Bi, "getXfaPageViewport", {
            enumerable: !0,
            get: function() {
              return Zi.getXfaPageViewport;
            }
          }), Object.defineProperty(Bi, "isPdfFile", {
            enumerable: !0,
            get: function() {
              return Zi.isPdfFile;
            }
          }), Object.defineProperty(Bi, "loadScript", {
            enumerable: !0,
            get: function() {
              return Zi.loadScript;
            }
          }), Object.defineProperty(Bi, "renderTextLayer", {
            enumerable: !0,
            get: function() {
              return La.renderTextLayer;
            }
          }), Object.defineProperty(Bi, "shadow", {
            enumerable: !0,
            get: function() {
              return e.shadow;
            }
          }), Object.defineProperty(Bi, "version", {
            enumerable: !0,
            get: function() {
              return Ui.version;
            }
          });
          var e = __w_pdfjs_require__(1), Ui = __w_pdfjs_require__(4), Zi = __w_pdfjs_require__(8), ta = __w_pdfjs_require__(22), na = __w_pdfjs_require__(7), ia = __w_pdfjs_require__(27), aa = __w_pdfjs_require__(15), da = __w_pdfjs_require__(3), La = __w_pdfjs_require__(30), qa = __w_pdfjs_require__(31), io = __w_pdfjs_require__(29);
          if (da.isNodeJS) {
            const {
              PDFNodeStream: ao
            } = __w_pdfjs_require__(32);
            (0, Ui.setPDFNetworkStreamFactory)((oo) => new ao(oo));
          } else {
            const {
              PDFNetworkStream: ao
            } = __w_pdfjs_require__(35), {
              PDFFetchStream: oo
            } = __w_pdfjs_require__(36);
            (0, Ui.setPDFNetworkStreamFactory)((no) => (0, Zi.isValidFetchUrl)(no.url) ? new oo(no) : new ao(no));
          }
        })(), __webpack_exports__;
      })()
    ));
  }(pdf)), pdf.exports;
}
var pdfExports = requirePdf();
async function renderPage(Bi, e, Ui, Zi) {
  const ta = await Bi.getPage(Ui), na = ta.getViewport({ scale: 5 });
  e.height = na.height, e.width = na.width;
  const ia = e.getContext("2d");
  if (!ia)
    return;
  const aa = {
    canvasContext: ia,
    viewport: na
  }, da = na.height * (Ui - 1);
  await ta.render(aa).promise, ia.setTransform(1, 0, 0, 1, 0, 0), Zi.push({
    data: e.toDataURL(),
    offset: da,
    page: Ui
  }), Ui + 1 <= Bi.numPages && await renderPage(Bi, e, Ui + 1, Zi);
}
const usePDF = ({ url: Bi, canvas: e }) => {
  const [Ui, Zi] = useState(null), [ta, na] = useState([]), [ia, aa] = useState(!1), da = useCallback(
    async (La) => {
      if (!e || !Ui) return;
      const qa = { data: [] };
      await renderPage(Ui, e, La, qa.data), na(qa.data), aa(!0);
    },
    [Ui, aa]
  );
  return useEffect(() => {
    da(1);
  }, [Ui, da]), useEffect(() => {
    pdfExports.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfExports.version}/pdf.worker.js`, pdfExports.getDocument({ url: Bi }).promise.then((qa) => {
      Zi(qa);
    });
  }, []), {
    ready: ia,
    pageData: ta,
    totalPages: Ui?.numPages
  };
}, PDFPreview = ({ url: Bi }) => {
  const e = useRef(null), { ready: Ui, pageData: Zi } = usePDF({
    url: Bi,
    canvas: e.current
  });
  return /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { children: [
    !Ui && /* @__PURE__ */ jsxRuntimeExports.jsx("canvas", { ref: e }),
    Zi.map(({ data: ta }, na) => /* @__PURE__ */ jsxRuntimeExports.jsx(
      "img",
      {
        className: "mb-2 max-w-xl",
        src: ta
      },
      `pdf-preview-${Bi}=${na}`
    ))
  ] });
}, SVGPreview = ({ data: Bi }) => {
  const [e, Ui] = useState(null), Zi = async () => {
    const ta = await Bi.text();
    Ui(ta);
  };
  return useEffect(() => {
    Zi();
  }, [Bi]), e ? /* @__PURE__ */ jsxRuntimeExports.jsx("div", { children: /* @__PURE__ */ jsxRuntimeExports.jsx("div", { dangerouslySetInnerHTML: { __html: e } }) }) : null;
};
var papaparse_min$1 = { exports: {} };
/* @license
Papa Parse
v5.3.2
https://github.com/mholt/PapaParse
License: MIT
*/
var papaparse_min = papaparse_min$1.exports, hasRequiredPapaparse_min;
function requirePapaparse_min() {
  return hasRequiredPapaparse_min || (hasRequiredPapaparse_min = 1, function(Bi, e) {
    (function(Ui, Zi) {
      Bi.exports = Zi();
    })(papaparse_min, function Ui() {
      var Zi = typeof self < "u" ? self : typeof window < "u" ? window : Zi !== void 0 ? Zi : {}, ta = !Zi.document && !!Zi.postMessage, na = ta && /blob:/i.test((Zi.location || {}).protocol), ia = {}, aa = 0, da = { parse: function(co, Co) {
        var Zs = (Co = Co || {}).dynamicTyping || !1;
        if (Ao(Zs) && (Co.dynamicTypingFunction = Zs, Zs = {}), Co.dynamicTyping = Zs, Co.transform = !!Ao(Co.transform) && Co.transform, Co.worker && da.WORKERS_SUPPORTED) {
          var xl = function() {
            if (!da.WORKERS_SUPPORTED) return !1;
            var Al = (Bl = Zi.URL || Zi.webkitURL || null, Ml = Ui.toString(), da.BLOB_URL || (da.BLOB_URL = Bl.createObjectURL(new Blob(["(", Ml, ")();"], { type: "text/javascript" })))), Ol = new Zi.Worker(Al), Bl, Ml;
            return Ol.onmessage = Rs, Ol.id = aa++, ia[Ol.id] = Ol;
          }();
          return xl.userStep = Co.step, xl.userChunk = Co.chunk, xl.userComplete = Co.complete, xl.userError = Co.error, Co.step = Ao(Co.step), Co.chunk = Ao(Co.chunk), Co.complete = Ao(Co.complete), Co.error = Ao(Co.error), delete Co.worker, void xl.postMessage({ input: co, config: Co, workerId: xl.id });
        }
        var Cl = null;
        return da.NODE_STREAM_INPUT, typeof co == "string" ? Cl = Co.download ? new io(Co) : new oo(Co) : co.readable === !0 && Ao(co.read) && Ao(co.on) ? Cl = new no(Co) : (Zi.File && co instanceof File || co instanceof Object) && (Cl = new ao(Co)), Cl.stream(co);
      }, unparse: function(co, Co) {
        var Zs = !1, xl = !0, Cl = ",", Al = `\r
`, Ol = '"', Bl = Ol + Ol, Ml = !1, Vl = null, Ll = !1;
        (function() {
          if (typeof Co == "object") {
            if (typeof Co.delimiter != "string" || da.BAD_DELIMITERS.filter(function(Nl) {
              return Co.delimiter.indexOf(Nl) !== -1;
            }).length || (Cl = Co.delimiter), (typeof Co.quotes == "boolean" || typeof Co.quotes == "function" || Array.isArray(Co.quotes)) && (Zs = Co.quotes), typeof Co.skipEmptyLines != "boolean" && typeof Co.skipEmptyLines != "string" || (Ml = Co.skipEmptyLines), typeof Co.newline == "string" && (Al = Co.newline), typeof Co.quoteChar == "string" && (Ol = Co.quoteChar), typeof Co.header == "boolean" && (xl = Co.header), Array.isArray(Co.columns)) {
              if (Co.columns.length === 0) throw new Error("Option columns is empty");
              Vl = Co.columns;
            }
            Co.escapeChar !== void 0 && (Bl = Co.escapeChar + Ol), (typeof Co.escapeFormulae == "boolean" || Co.escapeFormulae instanceof RegExp) && (Ll = Co.escapeFormulae instanceof RegExp ? Co.escapeFormulae : /^[=+\-@\t\r].*$/);
          }
        })();
        var Yl = new RegExp(so(Ol), "g");
        if (typeof co == "string" && (co = JSON.parse(co)), Array.isArray(co)) {
          if (!co.length || Array.isArray(co[0])) return Zl(null, co, Ml);
          if (typeof co[0] == "object") return Zl(Vl || Object.keys(co[0]), co, Ml);
        } else if (typeof co == "object") return typeof co.data == "string" && (co.data = JSON.parse(co.data)), Array.isArray(co.data) && (co.fields || (co.fields = co.meta && co.meta.fields || Vl), co.fields || (co.fields = Array.isArray(co.data[0]) ? co.fields : typeof co.data[0] == "object" ? Object.keys(co.data[0]) : []), Array.isArray(co.data[0]) || typeof co.data[0] == "object" || (co.data = [co.data])), Zl(co.fields || [], co.data || [], Ml);
        throw new Error("Unable to serialize unrecognized input");
        function Zl(Nl, Tl, El) {
          var Il = "";
          typeof Nl == "string" && (Nl = JSON.parse(Nl)), typeof Tl == "string" && (Tl = JSON.parse(Tl));
          var Ul = Array.isArray(Nl) && 0 < Nl.length, Kl = !Array.isArray(Tl[0]);
          if (Ul && xl) {
            for (var Rl = 0; Rl < Nl.length; Rl++) 0 < Rl && (Il += Cl), Il += tc(Nl[Rl], Rl);
            0 < Tl.length && (Il += Al);
          }
          for (var uo = 0; uo < Tl.length; uo++) {
            var Is = Ul ? Nl.length : Tl[uo].length, Sl = !1, wl = Ul ? Object.keys(Tl[uo]).length === 0 : Tl[uo].length === 0;
            if (El && !Ul && (Sl = El === "greedy" ? Tl[uo].join("").trim() === "" : Tl[uo].length === 1 && Tl[uo][0].length === 0), El === "greedy" && Ul) {
              for (var Pl = [], jl = 0; jl < Is; jl++) {
                var Dl = Kl ? Nl[jl] : jl;
                Pl.push(Tl[uo][Dl]);
              }
              Sl = Pl.join("").trim() === "";
            }
            if (!Sl) {
              for (var $l = 0; $l < Is; $l++) {
                0 < $l && !wl && (Il += Cl);
                var kl = Ul && Kl ? Nl[$l] : $l;
                Il += tc(Tl[uo][kl], $l);
              }
              uo < Tl.length - 1 && (!El || 0 < Is && !wl) && (Il += Al);
            }
          }
          return Il;
        }
        function tc(Nl, Tl) {
          if (Nl == null) return "";
          if (Nl.constructor === Date) return JSON.stringify(Nl).slice(1, 25);
          var El = !1;
          Ll && typeof Nl == "string" && Ll.test(Nl) && (Nl = "'" + Nl, El = !0);
          var Il = Nl.toString().replace(Yl, Bl);
          return (El = El || Zs === !0 || typeof Zs == "function" && Zs(Nl, Tl) || Array.isArray(Zs) && Zs[Tl] || function(Ul, Kl) {
            for (var Rl = 0; Rl < Kl.length; Rl++) if (-1 < Ul.indexOf(Kl[Rl])) return !0;
            return !1;
          }(Il, da.BAD_DELIMITERS) || -1 < Il.indexOf(Cl) || Il.charAt(0) === " " || Il.charAt(Il.length - 1) === " ") ? Ol + Il + Ol : Il;
        }
      } };
      if (da.RECORD_SEP = "", da.UNIT_SEP = "", da.BYTE_ORDER_MARK = "\uFEFF", da.BAD_DELIMITERS = ["\r", `
`, '"', da.BYTE_ORDER_MARK], da.WORKERS_SUPPORTED = !ta && !!Zi.Worker, da.NODE_STREAM_INPUT = 1, da.LocalChunkSize = 10485760, da.RemoteChunkSize = 5242880, da.DefaultDelimiter = ",", da.Parser = bs, da.ParserHandle = lo, da.NetworkStreamer = io, da.FileStreamer = ao, da.StringStreamer = oo, da.ReadableStreamStreamer = no, Zi.jQuery) {
        var La = Zi.jQuery;
        La.fn.parse = function(co) {
          var Co = co.config || {}, Zs = [];
          return this.each(function(Al) {
            if (!(La(this).prop("tagName").toUpperCase() === "INPUT" && La(this).attr("type").toLowerCase() === "file" && Zi.FileReader) || !this.files || this.files.length === 0) return !0;
            for (var Ol = 0; Ol < this.files.length; Ol++) Zs.push({ file: this.files[Ol], inputElem: this, instanceConfig: La.extend({}, Co) });
          }), xl(), this;
          function xl() {
            if (Zs.length !== 0) {
              var Al, Ol, Bl, Ml, Vl = Zs[0];
              if (Ao(co.before)) {
                var Ll = co.before(Vl.file, Vl.inputElem);
                if (typeof Ll == "object") {
                  if (Ll.action === "abort") return Al = "AbortError", Ol = Vl.file, Bl = Vl.inputElem, Ml = Ll.reason, void (Ao(co.error) && co.error({ name: Al }, Ol, Bl, Ml));
                  if (Ll.action === "skip") return void Cl();
                  typeof Ll.config == "object" && (Vl.instanceConfig = La.extend(Vl.instanceConfig, Ll.config));
                } else if (Ll === "skip") return void Cl();
              }
              var Yl = Vl.instanceConfig.complete;
              Vl.instanceConfig.complete = function(Zl) {
                Ao(Yl) && Yl(Zl, Vl.file, Vl.inputElem), Cl();
              }, da.parse(Vl.file, Vl.instanceConfig);
            } else Ao(co.complete) && co.complete();
          }
          function Cl() {
            Zs.splice(0, 1), xl();
          }
        };
      }
      function qa(co) {
        this._handle = null, this._finished = !1, this._completed = !1, this._halted = !1, this._input = null, this._baseIndex = 0, this._partialLine = "", this._rowCount = 0, this._start = 0, this._nextChunk = null, this.isFirstChunk = !0, this._completeResults = { data: [], errors: [], meta: {} }, function(Co) {
          var Zs = jo(Co);
          Zs.chunkSize = parseInt(Zs.chunkSize), Co.step || Co.chunk || (Zs.chunkSize = null), this._handle = new lo(Zs), (this._handle.streamer = this)._config = Zs;
        }.call(this, co), this.parseChunk = function(Co, Zs) {
          if (this.isFirstChunk && Ao(this._config.beforeFirstChunk)) {
            var xl = this._config.beforeFirstChunk(Co);
            xl !== void 0 && (Co = xl);
          }
          this.isFirstChunk = !1, this._halted = !1;
          var Cl = this._partialLine + Co;
          this._partialLine = "";
          var Al = this._handle.parse(Cl, this._baseIndex, !this._finished);
          if (!this._handle.paused() && !this._handle.aborted()) {
            var Ol = Al.meta.cursor;
            this._finished || (this._partialLine = Cl.substring(Ol - this._baseIndex), this._baseIndex = Ol), Al && Al.data && (this._rowCount += Al.data.length);
            var Bl = this._finished || this._config.preview && this._rowCount >= this._config.preview;
            if (na) Zi.postMessage({ results: Al, workerId: da.WORKER_ID, finished: Bl });
            else if (Ao(this._config.chunk) && !Zs) {
              if (this._config.chunk(Al, this._handle), this._handle.paused() || this._handle.aborted()) return void (this._halted = !0);
              Al = void 0, this._completeResults = void 0;
            }
            return this._config.step || this._config.chunk || (this._completeResults.data = this._completeResults.data.concat(Al.data), this._completeResults.errors = this._completeResults.errors.concat(Al.errors), this._completeResults.meta = Al.meta), this._completed || !Bl || !Ao(this._config.complete) || Al && Al.meta.aborted || (this._config.complete(this._completeResults, this._input), this._completed = !0), Bl || Al && Al.meta.paused || this._nextChunk(), Al;
          }
          this._halted = !0;
        }, this._sendError = function(Co) {
          Ao(this._config.error) ? this._config.error(Co) : na && this._config.error && Zi.postMessage({ workerId: da.WORKER_ID, error: Co, finished: !1 });
        };
      }
      function io(co) {
        var Co;
        (co = co || {}).chunkSize || (co.chunkSize = da.RemoteChunkSize), qa.call(this, co), this._nextChunk = ta ? function() {
          this._readChunk(), this._chunkLoaded();
        } : function() {
          this._readChunk();
        }, this.stream = function(Zs) {
          this._input = Zs, this._nextChunk();
        }, this._readChunk = function() {
          if (this._finished) this._chunkLoaded();
          else {
            if (Co = new XMLHttpRequest(), this._config.withCredentials && (Co.withCredentials = this._config.withCredentials), ta || (Co.onload = fs(this._chunkLoaded, this), Co.onerror = fs(this._chunkError, this)), Co.open(this._config.downloadRequestBody ? "POST" : "GET", this._input, !ta), this._config.downloadRequestHeaders) {
              var Zs = this._config.downloadRequestHeaders;
              for (var xl in Zs) Co.setRequestHeader(xl, Zs[xl]);
            }
            if (this._config.chunkSize) {
              var Cl = this._start + this._config.chunkSize - 1;
              Co.setRequestHeader("Range", "bytes=" + this._start + "-" + Cl);
            }
            try {
              Co.send(this._config.downloadRequestBody);
            } catch (Al) {
              this._chunkError(Al.message);
            }
            ta && Co.status === 0 && this._chunkError();
          }
        }, this._chunkLoaded = function() {
          Co.readyState === 4 && (Co.status < 200 || 400 <= Co.status ? this._chunkError() : (this._start += this._config.chunkSize ? this._config.chunkSize : Co.responseText.length, this._finished = !this._config.chunkSize || this._start >= function(Zs) {
            var xl = Zs.getResponseHeader("Content-Range");
            return xl === null ? -1 : parseInt(xl.substring(xl.lastIndexOf("/") + 1));
          }(Co), this.parseChunk(Co.responseText)));
        }, this._chunkError = function(Zs) {
          var xl = Co.statusText || Zs;
          this._sendError(new Error(xl));
        };
      }
      function ao(co) {
        var Co, Zs;
        (co = co || {}).chunkSize || (co.chunkSize = da.LocalChunkSize), qa.call(this, co);
        var xl = typeof FileReader < "u";
        this.stream = function(Cl) {
          this._input = Cl, Zs = Cl.slice || Cl.webkitSlice || Cl.mozSlice, xl ? ((Co = new FileReader()).onload = fs(this._chunkLoaded, this), Co.onerror = fs(this._chunkError, this)) : Co = new FileReaderSync(), this._nextChunk();
        }, this._nextChunk = function() {
          this._finished || this._config.preview && !(this._rowCount < this._config.preview) || this._readChunk();
        }, this._readChunk = function() {
          var Cl = this._input;
          if (this._config.chunkSize) {
            var Al = Math.min(this._start + this._config.chunkSize, this._input.size);
            Cl = Zs.call(Cl, this._start, Al);
          }
          var Ol = Co.readAsText(Cl, this._config.encoding);
          xl || this._chunkLoaded({ target: { result: Ol } });
        }, this._chunkLoaded = function(Cl) {
          this._start += this._config.chunkSize, this._finished = !this._config.chunkSize || this._start >= this._input.size, this.parseChunk(Cl.target.result);
        }, this._chunkError = function() {
          this._sendError(Co.error);
        };
      }
      function oo(co) {
        var Co;
        qa.call(this, co = co || {}), this.stream = function(Zs) {
          return Co = Zs, this._nextChunk();
        }, this._nextChunk = function() {
          if (!this._finished) {
            var Zs, xl = this._config.chunkSize;
            return xl ? (Zs = Co.substring(0, xl), Co = Co.substring(xl)) : (Zs = Co, Co = ""), this._finished = !Co, this.parseChunk(Zs);
          }
        };
      }
      function no(co) {
        qa.call(this, co = co || {});
        var Co = [], Zs = !0, xl = !1;
        this.pause = function() {
          qa.prototype.pause.apply(this, arguments), this._input.pause();
        }, this.resume = function() {
          qa.prototype.resume.apply(this, arguments), this._input.resume();
        }, this.stream = function(Cl) {
          this._input = Cl, this._input.on("data", this._streamData), this._input.on("end", this._streamEnd), this._input.on("error", this._streamError);
        }, this._checkIsFinished = function() {
          xl && Co.length === 1 && (this._finished = !0);
        }, this._nextChunk = function() {
          this._checkIsFinished(), Co.length ? this.parseChunk(Co.shift()) : Zs = !0;
        }, this._streamData = fs(function(Cl) {
          try {
            Co.push(typeof Cl == "string" ? Cl : Cl.toString(this._config.encoding)), Zs && (Zs = !1, this._checkIsFinished(), this.parseChunk(Co.shift()));
          } catch (Al) {
            this._streamError(Al);
          }
        }, this), this._streamError = fs(function(Cl) {
          this._streamCleanUp(), this._sendError(Cl);
        }, this), this._streamEnd = fs(function() {
          this._streamCleanUp(), xl = !0, this._streamData("");
        }, this), this._streamCleanUp = fs(function() {
          this._input.removeListener("data", this._streamData), this._input.removeListener("end", this._streamEnd), this._input.removeListener("error", this._streamError);
        }, this);
      }
      function lo(co) {
        var Co, Zs, xl, Cl = Math.pow(2, 53), Al = -Cl, Ol = /^\s*-?(\d+\.?|\.\d+|\d+\.\d+)([eE][-+]?\d+)?\s*$/, Bl = /^(\d{4}-[01]\d-[0-3]\dT[0-2]\d:[0-5]\d:[0-5]\d\.\d+([+-][0-2]\d:[0-5]\d|Z))|(\d{4}-[01]\d-[0-3]\dT[0-2]\d:[0-5]\d:[0-5]\d([+-][0-2]\d:[0-5]\d|Z))|(\d{4}-[01]\d-[0-3]\dT[0-2]\d:[0-5]\d([+-][0-2]\d:[0-5]\d|Z))$/, Ml = this, Vl = 0, Ll = 0, Yl = !1, Zl = !1, tc = [], Nl = { data: [], errors: [], meta: {} };
        if (Ao(co.step)) {
          var Tl = co.step;
          co.step = function(uo) {
            if (Nl = uo, Ul()) Il();
            else {
              if (Il(), Nl.data.length === 0) return;
              Vl += uo.data.length, co.preview && Vl > co.preview ? Zs.abort() : (Nl.data = Nl.data[0], Tl(Nl, Ml));
            }
          };
        }
        function El(uo) {
          return co.skipEmptyLines === "greedy" ? uo.join("").trim() === "" : uo.length === 1 && uo[0].length === 0;
        }
        function Il() {
          return Nl && xl && (Rl("Delimiter", "UndetectableDelimiter", "Unable to auto-detect delimiting character; defaulted to '" + da.DefaultDelimiter + "'"), xl = !1), co.skipEmptyLines && (Nl.data = Nl.data.filter(function(uo) {
            return !El(uo);
          })), Ul() && function() {
            if (!Nl) return;
            function uo(Sl, wl) {
              Ao(co.transformHeader) && (Sl = co.transformHeader(Sl, wl)), tc.push(Sl);
            }
            if (Array.isArray(Nl.data[0])) {
              for (var Is = 0; Ul() && Is < Nl.data.length; Is++) Nl.data[Is].forEach(uo);
              Nl.data.splice(0, 1);
            } else Nl.data.forEach(uo);
          }(), function() {
            if (!Nl || !co.header && !co.dynamicTyping && !co.transform) return Nl;
            function uo(Sl, wl) {
              var Pl, jl = co.header ? {} : [];
              for (Pl = 0; Pl < Sl.length; Pl++) {
                var Dl = Pl, $l = Sl[Pl];
                co.header && (Dl = Pl >= tc.length ? "__parsed_extra" : tc[Pl]), co.transform && ($l = co.transform($l, Dl)), $l = Kl(Dl, $l), Dl === "__parsed_extra" ? (jl[Dl] = jl[Dl] || [], jl[Dl].push($l)) : jl[Dl] = $l;
              }
              return co.header && (Pl > tc.length ? Rl("FieldMismatch", "TooManyFields", "Too many fields: expected " + tc.length + " fields but parsed " + Pl, Ll + wl) : Pl < tc.length && Rl("FieldMismatch", "TooFewFields", "Too few fields: expected " + tc.length + " fields but parsed " + Pl, Ll + wl)), jl;
            }
            var Is = 1;
            return !Nl.data.length || Array.isArray(Nl.data[0]) ? (Nl.data = Nl.data.map(uo), Is = Nl.data.length) : Nl.data = uo(Nl.data, 0), co.header && Nl.meta && (Nl.meta.fields = tc), Ll += Is, Nl;
          }();
        }
        function Ul() {
          return co.header && tc.length === 0;
        }
        function Kl(uo, Is) {
          return Sl = uo, co.dynamicTypingFunction && co.dynamicTyping[Sl] === void 0 && (co.dynamicTyping[Sl] = co.dynamicTypingFunction(Sl)), (co.dynamicTyping[Sl] || co.dynamicTyping) === !0 ? Is === "true" || Is === "TRUE" || Is !== "false" && Is !== "FALSE" && (function(wl) {
            if (Ol.test(wl)) {
              var Pl = parseFloat(wl);
              if (Al < Pl && Pl < Cl) return !0;
            }
            return !1;
          }(Is) ? parseFloat(Is) : Bl.test(Is) ? new Date(Is) : Is === "" ? null : Is) : Is;
          var Sl;
        }
        function Rl(uo, Is, Sl, wl) {
          var Pl = { type: uo, code: Is, message: Sl };
          wl !== void 0 && (Pl.row = wl), Nl.errors.push(Pl);
        }
        this.parse = function(uo, Is, Sl) {
          var wl = co.quoteChar || '"';
          if (co.newline || (co.newline = function(Dl, $l) {
            Dl = Dl.substring(0, 1048576);
            var kl = new RegExp(so($l) + "([^]*?)" + so($l), "gm"), zl = (Dl = Dl.replace(kl, "")).split("\r"), Hl = Dl.split(`
`), Wl = 1 < Hl.length && Hl[0].length < zl[0].length;
            if (zl.length === 1 || Wl) return `
`;
            for (var ql = 0, Jl = 0; Jl < zl.length; Jl++) zl[Jl][0] === `
` && ql++;
            return ql >= zl.length / 2 ? `\r
` : "\r";
          }(uo, wl)), xl = !1, co.delimiter) Ao(co.delimiter) && (co.delimiter = co.delimiter(uo), Nl.meta.delimiter = co.delimiter);
          else {
            var Pl = function(Dl, $l, kl, zl, Hl) {
              var Wl, ql, Jl, ac;
              Hl = Hl || [",", "	", "|", ";", da.RECORD_SEP, da.UNIT_SEP];
              for (var Xl = 0; Xl < Hl.length; Xl++) {
                var sc = Hl[Xl], Hu = 0, dc = 0, td = 0;
                Jl = void 0;
                for (var ad = new bs({ comments: zl, delimiter: sc, newline: $l, preview: 10 }).parse(Dl), od = 0; od < ad.data.length; od++) if (kl && El(ad.data[od])) td++;
                else {
                  var sd = ad.data[od].length;
                  dc += sd, Jl !== void 0 ? 0 < sd && (Hu += Math.abs(sd - Jl), Jl = sd) : Jl = sd;
                }
                0 < ad.data.length && (dc /= ad.data.length - td), (ql === void 0 || Hu <= ql) && (ac === void 0 || ac < dc) && 1.99 < dc && (ql = Hu, Wl = sc, ac = dc);
              }
              return { successful: !!(co.delimiter = Wl), bestDelimiter: Wl };
            }(uo, co.newline, co.skipEmptyLines, co.comments, co.delimitersToGuess);
            Pl.successful ? co.delimiter = Pl.bestDelimiter : (xl = !0, co.delimiter = da.DefaultDelimiter), Nl.meta.delimiter = co.delimiter;
          }
          var jl = jo(co);
          return co.preview && co.header && jl.preview++, Co = uo, Zs = new bs(jl), Nl = Zs.parse(Co, Is, Sl), Il(), Yl ? { meta: { paused: !0 } } : Nl || { meta: { paused: !1 } };
        }, this.paused = function() {
          return Yl;
        }, this.pause = function() {
          Yl = !0, Zs.abort(), Co = Ao(co.chunk) ? "" : Co.substring(Zs.getCharIndex());
        }, this.resume = function() {
          Ml.streamer._halted ? (Yl = !1, Ml.streamer.parseChunk(Co, !0)) : setTimeout(Ml.resume, 3);
        }, this.aborted = function() {
          return Zl;
        }, this.abort = function() {
          Zl = !0, Zs.abort(), Nl.meta.aborted = !0, Ao(co.complete) && co.complete(Nl), Co = "";
        };
      }
      function so(co) {
        return co.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
      }
      function bs(co) {
        var Co, Zs = (co = co || {}).delimiter, xl = co.newline, Cl = co.comments, Al = co.step, Ol = co.preview, Bl = co.fastMode, Ml = Co = co.quoteChar === void 0 || co.quoteChar === null ? '"' : co.quoteChar;
        if (co.escapeChar !== void 0 && (Ml = co.escapeChar), (typeof Zs != "string" || -1 < da.BAD_DELIMITERS.indexOf(Zs)) && (Zs = ","), Cl === Zs) throw new Error("Comment character same as delimiter");
        Cl === !0 ? Cl = "#" : (typeof Cl != "string" || -1 < da.BAD_DELIMITERS.indexOf(Cl)) && (Cl = !1), xl !== `
` && xl !== "\r" && xl !== `\r
` && (xl = `
`);
        var Vl = 0, Ll = !1;
        this.parse = function(Yl, Zl, tc) {
          if (typeof Yl != "string") throw new Error("Input must be a string");
          var Nl = Yl.length, Tl = Zs.length, El = xl.length, Il = Cl.length, Ul = Ao(Al), Kl = [], Rl = [], uo = [], Is = Vl = 0;
          if (!Yl) return ac();
          if (Bl || Bl !== !1 && Yl.indexOf(Co) === -1) {
            for (var Sl = Yl.split(xl), wl = 0; wl < Sl.length; wl++) {
              if (uo = Sl[wl], Vl += uo.length, wl !== Sl.length - 1) Vl += xl.length;
              else if (tc) return ac();
              if (!Cl || uo.substring(0, Il) !== Cl) {
                if (Ul) {
                  if (Kl = [], Hl(uo.split(Zs)), Xl(), Ll) return ac();
                } else Hl(uo.split(Zs));
                if (Ol && Ol <= wl) return Kl = Kl.slice(0, Ol), ac(!0);
              }
            }
            return ac();
          }
          for (var Pl = Yl.indexOf(Zs, Vl), jl = Yl.indexOf(xl, Vl), Dl = new RegExp(so(Ml) + so(Co), "g"), $l = Yl.indexOf(Co, Vl); ; ) if (Yl[Vl] !== Co) if (Cl && uo.length === 0 && Yl.substring(Vl, Vl + Il) === Cl) {
            if (jl === -1) return ac();
            Vl = jl + El, jl = Yl.indexOf(xl, Vl), Pl = Yl.indexOf(Zs, Vl);
          } else if (Pl !== -1 && (Pl < jl || jl === -1)) uo.push(Yl.substring(Vl, Pl)), Vl = Pl + Tl, Pl = Yl.indexOf(Zs, Vl);
          else {
            if (jl === -1) break;
            if (uo.push(Yl.substring(Vl, jl)), Jl(jl + El), Ul && (Xl(), Ll)) return ac();
            if (Ol && Kl.length >= Ol) return ac(!0);
          }
          else for ($l = Vl, Vl++; ; ) {
            if (($l = Yl.indexOf(Co, $l + 1)) === -1) return tc || Rl.push({ type: "Quotes", code: "MissingQuotes", message: "Quoted field unterminated", row: Kl.length, index: Vl }), ql();
            if ($l === Nl - 1) return ql(Yl.substring(Vl, $l).replace(Dl, Co));
            if (Co !== Ml || Yl[$l + 1] !== Ml) {
              if (Co === Ml || $l === 0 || Yl[$l - 1] !== Ml) {
                Pl !== -1 && Pl < $l + 1 && (Pl = Yl.indexOf(Zs, $l + 1)), jl !== -1 && jl < $l + 1 && (jl = Yl.indexOf(xl, $l + 1));
                var kl = Wl(jl === -1 ? Pl : Math.min(Pl, jl));
                if (Yl.substr($l + 1 + kl, Tl) === Zs) {
                  uo.push(Yl.substring(Vl, $l).replace(Dl, Co)), Yl[Vl = $l + 1 + kl + Tl] !== Co && ($l = Yl.indexOf(Co, Vl)), Pl = Yl.indexOf(Zs, Vl), jl = Yl.indexOf(xl, Vl);
                  break;
                }
                var zl = Wl(jl);
                if (Yl.substring($l + 1 + zl, $l + 1 + zl + El) === xl) {
                  if (uo.push(Yl.substring(Vl, $l).replace(Dl, Co)), Jl($l + 1 + zl + El), Pl = Yl.indexOf(Zs, Vl), $l = Yl.indexOf(Co, Vl), Ul && (Xl(), Ll)) return ac();
                  if (Ol && Kl.length >= Ol) return ac(!0);
                  break;
                }
                Rl.push({ type: "Quotes", code: "InvalidQuotes", message: "Trailing quote on quoted field is malformed", row: Kl.length, index: Vl }), $l++;
              }
            } else $l++;
          }
          return ql();
          function Hl(sc) {
            Kl.push(sc), Is = Vl;
          }
          function Wl(sc) {
            var Hu = 0;
            if (sc !== -1) {
              var dc = Yl.substring($l + 1, sc);
              dc && dc.trim() === "" && (Hu = dc.length);
            }
            return Hu;
          }
          function ql(sc) {
            return tc || (sc === void 0 && (sc = Yl.substring(Vl)), uo.push(sc), Vl = Nl, Hl(uo), Ul && Xl()), ac();
          }
          function Jl(sc) {
            Vl = sc, Hl(uo), uo = [], jl = Yl.indexOf(xl, Vl);
          }
          function ac(sc) {
            return { data: Kl, errors: Rl, meta: { delimiter: Zs, linebreak: xl, aborted: Ll, truncated: !!sc, cursor: Is + (Zl || 0) } };
          }
          function Xl() {
            Al(ac()), Kl = [], Rl = [];
          }
        }, this.abort = function() {
          Ll = !0;
        }, this.getCharIndex = function() {
          return Vl;
        };
      }
      function Rs(co) {
        var Co = co.data, Zs = ia[Co.workerId], xl = !1;
        if (Co.error) Zs.userError(Co.error, Co.file);
        else if (Co.results && Co.results.data) {
          var Cl = { abort: function() {
            xl = !0, js(Co.workerId, { data: [], errors: [], meta: { aborted: !0 } });
          }, pause: qs, resume: qs };
          if (Ao(Zs.userStep)) {
            for (var Al = 0; Al < Co.results.data.length && (Zs.userStep({ data: Co.results.data[Al], errors: Co.results.errors, meta: Co.results.meta }, Cl), !xl); Al++) ;
            delete Co.results;
          } else Ao(Zs.userChunk) && (Zs.userChunk(Co.results, Cl, Co.file), delete Co.results);
        }
        Co.finished && !xl && js(Co.workerId, Co.results);
      }
      function js(co, Co) {
        var Zs = ia[co];
        Ao(Zs.userComplete) && Zs.userComplete(Co), Zs.terminate(), delete ia[co];
      }
      function qs() {
        throw new Error("Not implemented.");
      }
      function jo(co) {
        if (typeof co != "object" || co === null) return co;
        var Co = Array.isArray(co) ? [] : {};
        for (var Zs in co) Co[Zs] = jo(co[Zs]);
        return Co;
      }
      function fs(co, Co) {
        return function() {
          co.apply(Co, arguments);
        };
      }
      function Ao(co) {
        return typeof co == "function";
      }
      return na && (Zi.onmessage = function(co) {
        var Co = co.data;
        if (da.WORKER_ID === void 0 && Co && (da.WORKER_ID = Co.workerId), typeof Co.input == "string") Zi.postMessage({ workerId: da.WORKER_ID, results: da.parse(Co.input, Co.config), finished: !0 });
        else if (Zi.File && Co.input instanceof File || Co.input instanceof Object) {
          var Zs = da.parse(Co.input, Co.config);
          Zs && Zi.postMessage({ workerId: da.WORKER_ID, results: Zs, finished: !0 });
        }
      }), (io.prototype = Object.create(qa.prototype)).constructor = io, (ao.prototype = Object.create(qa.prototype)).constructor = ao, (oo.prototype = Object.create(oo.prototype)).constructor = oo, (no.prototype = Object.create(qa.prototype)).constructor = no, da;
    });
  }(papaparse_min$1)), papaparse_min$1.exports;
}
var papaparse_minExports = requirePapaparse_min();
const Table$1 = (Bi) => /* @__PURE__ */ jsxRuntimeExports.jsx(
  "table",
  {
    className: "bg-neutral-200 mb-4 border-collapse rounded border-none",
    ...Bi
  }
), TablePreview = ({ data: Bi }) => {
  const [e, Ui] = useState(null), Zi = async () => {
    const ta = await Bi.text();
    papaparse_minExports.parse(ta, {
      complete: (na) => Ui(na.data)
    });
  };
  return useEffect(() => {
    Zi();
  }, [Bi]), e ? /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "p-4 rounded-md bg-neutral-200", children: /* @__PURE__ */ jsxRuntimeExports.jsx(Table$1, { children: /* @__PURE__ */ jsxRuntimeExports.jsx("tbody", { children: e.map((ta, na) => /* @__PURE__ */ jsxRuntimeExports.jsx("tr", { children: Object.keys(ta).map((ia, aa) => /* @__PURE__ */ jsxRuntimeExports.jsx("td", { children: ta[ia] }, `cell-${na * aa}`)) }, `row-${na}`)) }) }) }) : /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "grid w-full h-full place-items-center", children: /* @__PURE__ */ jsxRuntimeExports.jsx("p", { children: "Loading..." }) });
}, fileLimitBytes = 5e3, Preview = ({ bucket: Bi, fileKey: e }) => {
  if (!Bi || !e)
    return /* @__PURE__ */ jsxRuntimeExports.jsx("div", { children: "Invalid URL" });
  const Ui = e, Zi = Ui.endsWith(".pdf"), ta = Ui.split(".").pop(), na = usePresignedDownloadUrlQuery({
    variables: { bucket: Bi, key: Ui, limit: Zi ? void 0 : fileLimitBytes }
  }), [ia] = usePresignedDownloadUrlLazyQuery(), [aa, da] = useState(null), La = Ui.split("/").pop() || Ui, qa = useCallback(
    async (ao) => {
      const no = await (await fetch(ao, {
        headers: { Range: `bytes=0-${fileLimitBytes}` }
      })).blob();
      da(no);
    },
    [da]
  );
  if (useEffect(() => {
    na.data?.presignedDownloadUrl && qa(na.data.presignedDownloadUrl);
  }, [na.data?.presignedDownloadUrl, qa]), !aa)
    return /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "grid w-full h-full place-items-center", children: /* @__PURE__ */ jsxRuntimeExports.jsx(Spinner, {}) });
  let io;
  switch (ta) {
    case "svg":
      io = /* @__PURE__ */ jsxRuntimeExports.jsx(SVGPreview, { data: aa });
      break;
    case "csv":
    case "bed":
    case "fastq":
    case "tsv":
      io = /* @__PURE__ */ jsxRuntimeExports.jsx(TablePreview, { data: aa });
      break;
    case "jpg":
    case "jpeg":
    case "png":
    case "gif":
    case "bmp":
    case "webp":
    case "tiff":
    case "tif":
    case "ico":
    case "jfif":
      io = /* @__PURE__ */ jsxRuntimeExports.jsx(ImagePreview, { data: aa });
      break;
    case "pdf":
      io = /* @__PURE__ */ jsxRuntimeExports.jsx(PDFPreview, { url: na.data?.presignedDownloadUrl || "" });
      break;
    default:
      io = /* @__PURE__ */ jsxRuntimeExports.jsx("div", { children: "Preview not available for this file type" });
      break;
  }
  return /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "flex flex-col w-full h-full overflow-scroll", children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(PageHeader, { title: La, children: /* @__PURE__ */ jsxRuntimeExports.jsx(
      Button,
      {
        onClick: async () => {
          const oo = (await ia({ variables: { bucket: Bi, key: Ui } })).data?.presignedDownloadUrl;
          oo && window.open(oo);
        },
        variant: "gray",
        children: "Download"
      }
    ) }),
    /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "flex justify-around w-full", children: io })
  ] });
}, Protected = ({
  validate: Bi,
  children: e,
  onFailure: Ui
}) => {
  const [Zi, ta] = useState(!0), na = useCallback(async () => {
    await Bi() ? ta(!1) : Ui();
  }, []);
  return useEffect(() => {
    na();
  }, []), Zi ? null : /* @__PURE__ */ jsxRuntimeExports.jsx(jsxRuntimeExports.Fragment, { children: e });
};
function hasRole(Bi, e) {
  return e.some(
    (Ui) => Bi.some((Zi) => Zi.role === Ui)
  );
}
const RequireRoles = ({
  roles: Bi,
  children: e,
  loginUrl: Ui
}) => {
  const [Zi] = useMeLazyQuery({ fetchPolicy: "cache-first" });
  return /* @__PURE__ */ jsxRuntimeExports.jsx(
    Protected,
    {
      onFailure: () => {
        window.location.href = `${Ui}?redirect=${encodeURIComponent(
          window.location.href
        )}`;
      },
      validate: async () => {
        const ta = await Zi();
        return !(!ta.data?.me || !hasRole(ta.data.me.roles || [], Bi));
      },
      children: e
    }
  );
}, S3DownloadLink = ({
  path: Bi,
  className: e,
  children: Ui,
  endpoint: Zi
}) => {
  const ta = `${Zi}/download?bucket=${Bi}&key=${Bi}&isFolder=${Bi.isFolder ? 1 : 0}`;
  return /* @__PURE__ */ jsxRuntimeExports.jsx("a", { className: e, href: ta, download: "asfdkl", children: Ui });
};
var object_hash = { exports: {} }, hasRequiredObject_hash;
function requireObject_hash() {
  return hasRequiredObject_hash || (hasRequiredObject_hash = 1, function(Bi, e) {
    (function(Ui) {
      Bi.exports = Ui();
    })(function() {
      return function Ui(Zi, ta, na) {
        function ia(La, qa) {
          if (!ta[La]) {
            if (!Zi[La]) {
              var io = typeof commonjsRequire == "function" && commonjsRequire;
              if (!qa && io) return io(La, !0);
              if (aa) return aa(La, !0);
              throw new Error("Cannot find module '" + La + "'");
            }
            qa = ta[La] = { exports: {} }, Zi[La][0].call(qa.exports, function(ao) {
              var oo = Zi[La][1][ao];
              return ia(oo || ao);
            }, qa, qa.exports, Ui, Zi, ta, na);
          }
          return ta[La].exports;
        }
        for (var aa = typeof commonjsRequire == "function" && commonjsRequire, da = 0; da < na.length; da++) ia(na[da]);
        return ia;
      }({ 1: [function(Ui, Zi, ta) {
        (function(na, ia, aa, da, La, qa, io, ao, oo) {
          var no = Ui("crypto");
          function lo(fs, Ao) {
            Ao = Rs(fs, Ao);
            var co;
            return (co = Ao.algorithm !== "passthrough" ? no.createHash(Ao.algorithm) : new jo()).write === void 0 && (co.write = co.update, co.end = co.update), qs(Ao, co).dispatch(fs), co.update || co.end(""), co.digest ? co.digest(Ao.encoding === "buffer" ? void 0 : Ao.encoding) : (fs = co.read(), Ao.encoding !== "buffer" ? fs.toString(Ao.encoding) : fs);
          }
          (ta = Zi.exports = lo).sha1 = function(fs) {
            return lo(fs);
          }, ta.keys = function(fs) {
            return lo(fs, { excludeValues: !0, algorithm: "sha1", encoding: "hex" });
          }, ta.MD5 = function(fs) {
            return lo(fs, { algorithm: "md5", encoding: "hex" });
          }, ta.keysMD5 = function(fs) {
            return lo(fs, { algorithm: "md5", encoding: "hex", excludeValues: !0 });
          };
          var so = no.getHashes ? no.getHashes().slice() : ["sha1", "md5"], bs = (so.push("passthrough"), ["buffer", "hex", "binary", "base64"]);
          function Rs(fs, Ao) {
            var co = {};
            if (co.algorithm = (Ao = Ao || {}).algorithm || "sha1", co.encoding = Ao.encoding || "hex", co.excludeValues = !!Ao.excludeValues, co.algorithm = co.algorithm.toLowerCase(), co.encoding = co.encoding.toLowerCase(), co.ignoreUnknown = Ao.ignoreUnknown === !0, co.respectType = Ao.respectType !== !1, co.respectFunctionNames = Ao.respectFunctionNames !== !1, co.respectFunctionProperties = Ao.respectFunctionProperties !== !1, co.unorderedArrays = Ao.unorderedArrays === !0, co.unorderedSets = Ao.unorderedSets !== !1, co.unorderedObjects = Ao.unorderedObjects !== !1, co.replacer = Ao.replacer || void 0, co.excludeKeys = Ao.excludeKeys || void 0, fs === void 0) throw new Error("Object argument required.");
            for (var Co = 0; Co < so.length; ++Co) so[Co].toLowerCase() === co.algorithm.toLowerCase() && (co.algorithm = so[Co]);
            if (so.indexOf(co.algorithm) === -1) throw new Error('Algorithm "' + co.algorithm + '"  not supported. supported values: ' + so.join(", "));
            if (bs.indexOf(co.encoding) === -1 && co.algorithm !== "passthrough") throw new Error('Encoding "' + co.encoding + '"  not supported. supported values: ' + bs.join(", "));
            return co;
          }
          function js(fs) {
            if (typeof fs == "function") return /^function\s+\w*\s*\(\s*\)\s*{\s+\[native code\]\s+}$/i.exec(Function.prototype.toString.call(fs)) != null;
          }
          function qs(fs, Ao, co) {
            co = co || [];
            function Co(Zs) {
              return Ao.update ? Ao.update(Zs, "utf8") : Ao.write(Zs, "utf8");
            }
            return { dispatch: function(Zs) {
              return this["_" + ((Zs = fs.replacer ? fs.replacer(Zs) : Zs) === null ? "null" : typeof Zs)](Zs);
            }, _object: function(Zs) {
              var xl, Cl = Object.prototype.toString.call(Zs), Al = /\[object (.*)\]/i.exec(Cl);
              if (Al = (Al = Al ? Al[1] : "unknown:[" + Cl + "]").toLowerCase(), 0 <= (Cl = co.indexOf(Zs))) return this.dispatch("[CIRCULAR:" + Cl + "]");
              if (co.push(Zs), aa !== void 0 && aa.isBuffer && aa.isBuffer(Zs)) return Co("buffer:"), Co(Zs);
              if (Al === "object" || Al === "function" || Al === "asyncfunction") return Cl = Object.keys(Zs), fs.unorderedObjects && (Cl = Cl.sort()), fs.respectType === !1 || js(Zs) || Cl.splice(0, 0, "prototype", "__proto__", "constructor"), fs.excludeKeys && (Cl = Cl.filter(function(Ol) {
                return !fs.excludeKeys(Ol);
              })), Co("object:" + Cl.length + ":"), xl = this, Cl.forEach(function(Ol) {
                xl.dispatch(Ol), Co(":"), fs.excludeValues || xl.dispatch(Zs[Ol]), Co(",");
              });
              if (!this["_" + Al]) {
                if (fs.ignoreUnknown) return Co("[" + Al + "]");
                throw new Error('Unknown object type "' + Al + '"');
              }
              this["_" + Al](Zs);
            }, _array: function(Zs, Ol) {
              Ol = Ol !== void 0 ? Ol : fs.unorderedArrays !== !1;
              var Cl = this;
              if (Co("array:" + Zs.length + ":"), !Ol || Zs.length <= 1) return Zs.forEach(function(Bl) {
                return Cl.dispatch(Bl);
              });
              var Al = [], Ol = Zs.map(function(Bl) {
                var Ml = new jo(), Vl = co.slice();
                return qs(fs, Ml, Vl).dispatch(Bl), Al = Al.concat(Vl.slice(co.length)), Ml.read().toString();
              });
              return co = co.concat(Al), Ol.sort(), this._array(Ol, !1);
            }, _date: function(Zs) {
              return Co("date:" + Zs.toJSON());
            }, _symbol: function(Zs) {
              return Co("symbol:" + Zs.toString());
            }, _error: function(Zs) {
              return Co("error:" + Zs.toString());
            }, _boolean: function(Zs) {
              return Co("bool:" + Zs.toString());
            }, _string: function(Zs) {
              Co("string:" + Zs.length + ":"), Co(Zs.toString());
            }, _function: function(Zs) {
              Co("fn:"), js(Zs) ? this.dispatch("[native]") : this.dispatch(Zs.toString()), fs.respectFunctionNames !== !1 && this.dispatch("function-name:" + String(Zs.name)), fs.respectFunctionProperties && this._object(Zs);
            }, _number: function(Zs) {
              return Co("number:" + Zs.toString());
            }, _xml: function(Zs) {
              return Co("xml:" + Zs.toString());
            }, _null: function() {
              return Co("Null");
            }, _undefined: function() {
              return Co("Undefined");
            }, _regexp: function(Zs) {
              return Co("regex:" + Zs.toString());
            }, _uint8array: function(Zs) {
              return Co("uint8array:"), this.dispatch(Array.prototype.slice.call(Zs));
            }, _uint8clampedarray: function(Zs) {
              return Co("uint8clampedarray:"), this.dispatch(Array.prototype.slice.call(Zs));
            }, _int8array: function(Zs) {
              return Co("int8array:"), this.dispatch(Array.prototype.slice.call(Zs));
            }, _uint16array: function(Zs) {
              return Co("uint16array:"), this.dispatch(Array.prototype.slice.call(Zs));
            }, _int16array: function(Zs) {
              return Co("int16array:"), this.dispatch(Array.prototype.slice.call(Zs));
            }, _uint32array: function(Zs) {
              return Co("uint32array:"), this.dispatch(Array.prototype.slice.call(Zs));
            }, _int32array: function(Zs) {
              return Co("int32array:"), this.dispatch(Array.prototype.slice.call(Zs));
            }, _float32array: function(Zs) {
              return Co("float32array:"), this.dispatch(Array.prototype.slice.call(Zs));
            }, _float64array: function(Zs) {
              return Co("float64array:"), this.dispatch(Array.prototype.slice.call(Zs));
            }, _arraybuffer: function(Zs) {
              return Co("arraybuffer:"), this.dispatch(new Uint8Array(Zs));
            }, _url: function(Zs) {
              return Co("url:" + Zs.toString());
            }, _map: function(Zs) {
              return Co("map:"), Zs = Array.from(Zs), this._array(Zs, fs.unorderedSets !== !1);
            }, _set: function(Zs) {
              return Co("set:"), Zs = Array.from(Zs), this._array(Zs, fs.unorderedSets !== !1);
            }, _file: function(Zs) {
              return Co("file:"), this.dispatch([Zs.name, Zs.size, Zs.type, Zs.lastModfied]);
            }, _blob: function() {
              if (fs.ignoreUnknown) return Co("[blob]");
              throw Error(`Hashing Blob objects is currently not supported
(see https://github.com/puleos/object-hash/issues/26)
Use "options.replacer" or "options.ignoreUnknown"
`);
            }, _domwindow: function() {
              return Co("domwindow");
            }, _bigint: function(Zs) {
              return Co("bigint:" + Zs.toString());
            }, _process: function() {
              return Co("process");
            }, _timer: function() {
              return Co("timer");
            }, _pipe: function() {
              return Co("pipe");
            }, _tcp: function() {
              return Co("tcp");
            }, _udp: function() {
              return Co("udp");
            }, _tty: function() {
              return Co("tty");
            }, _statwatcher: function() {
              return Co("statwatcher");
            }, _securecontext: function() {
              return Co("securecontext");
            }, _connection: function() {
              return Co("connection");
            }, _zlib: function() {
              return Co("zlib");
            }, _context: function() {
              return Co("context");
            }, _nodescript: function() {
              return Co("nodescript");
            }, _httpparser: function() {
              return Co("httpparser");
            }, _dataview: function() {
              return Co("dataview");
            }, _signal: function() {
              return Co("signal");
            }, _fsevent: function() {
              return Co("fsevent");
            }, _tlswrap: function() {
              return Co("tlswrap");
            } };
          }
          function jo() {
            return { buf: "", write: function(fs) {
              this.buf += fs;
            }, end: function(fs) {
              this.buf += fs;
            }, read: function() {
              return this.buf;
            } };
          }
          ta.writeToStream = function(fs, Ao, co) {
            return co === void 0 && (co = Ao, Ao = {}), qs(Ao = Rs(fs, Ao), co).dispatch(fs);
          };
        }).call(this, Ui("lYpoI2"), typeof self < "u" ? self : typeof window < "u" ? window : {}, Ui("buffer").Buffer, arguments[3], arguments[4], arguments[5], arguments[6], "/fake_9a5aa49d.js", "/");
      }, { buffer: 3, crypto: 5, lYpoI2: 11 }], 2: [function(Ui, Zi, ta) {
        (function(na, ia, aa, da, La, qa, io, ao, oo) {
          (function(no) {
            var lo = typeof Uint8Array < "u" ? Uint8Array : Array, so = 43, bs = 47, Rs = 48, js = 97, qs = 65, jo = 45, fs = 95;
            function Ao(co) {
              return co = co.charCodeAt(0), co === so || co === jo ? 62 : co === bs || co === fs ? 63 : co < Rs ? -1 : co < Rs + 10 ? co - Rs + 26 + 26 : co < qs + 26 ? co - qs : co < js + 26 ? co - js + 26 : void 0;
            }
            no.toByteArray = function(co) {
              var Co, Zs;
              if (0 < co.length % 4) throw new Error("Invalid string. Length must be a multiple of 4");
              var xl = co.length, xl = co.charAt(xl - 2) === "=" ? 2 : co.charAt(xl - 1) === "=" ? 1 : 0, Cl = new lo(3 * co.length / 4 - xl), Al = 0 < xl ? co.length - 4 : co.length, Ol = 0;
              function Bl(Ml) {
                Cl[Ol++] = Ml;
              }
              for (Co = 0; Co < Al; Co += 4, 0) Bl((16711680 & (Zs = Ao(co.charAt(Co)) << 18 | Ao(co.charAt(Co + 1)) << 12 | Ao(co.charAt(Co + 2)) << 6 | Ao(co.charAt(Co + 3)))) >> 16), Bl((65280 & Zs) >> 8), Bl(255 & Zs);
              return xl == 2 ? Bl(255 & (Zs = Ao(co.charAt(Co)) << 2 | Ao(co.charAt(Co + 1)) >> 4)) : xl == 1 && (Bl((Zs = Ao(co.charAt(Co)) << 10 | Ao(co.charAt(Co + 1)) << 4 | Ao(co.charAt(Co + 2)) >> 2) >> 8 & 255), Bl(255 & Zs)), Cl;
            }, no.fromByteArray = function(co) {
              var Co, Zs, xl, Cl, Al = co.length % 3, Ol = "";
              function Bl(Ml) {
                return "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/".charAt(Ml);
              }
              for (Co = 0, xl = co.length - Al; Co < xl; Co += 3) Zs = (co[Co] << 16) + (co[Co + 1] << 8) + co[Co + 2], Ol += Bl((Cl = Zs) >> 18 & 63) + Bl(Cl >> 12 & 63) + Bl(Cl >> 6 & 63) + Bl(63 & Cl);
              switch (Al) {
                case 1:
                  Ol = (Ol += Bl((Zs = co[co.length - 1]) >> 2)) + Bl(Zs << 4 & 63) + "==";
                  break;
                case 2:
                  Ol = (Ol = (Ol += Bl((Zs = (co[co.length - 2] << 8) + co[co.length - 1]) >> 10)) + Bl(Zs >> 4 & 63)) + Bl(Zs << 2 & 63) + "=";
              }
              return Ol;
            };
          })(ta === void 0 ? this.base64js = {} : ta);
        }).call(this, Ui("lYpoI2"), typeof self < "u" ? self : typeof window < "u" ? window : {}, Ui("buffer").Buffer, arguments[3], arguments[4], arguments[5], arguments[6], "/node_modules/gulp-browserify/node_modules/base64-js/lib/b64.js", "/node_modules/gulp-browserify/node_modules/base64-js/lib");
      }, { buffer: 3, lYpoI2: 11 }], 3: [function(Ui, Zi, ta) {
        (function(na, ia, so, da, La, qa, io, ao, oo) {
          var no = Ui("base64-js"), lo = Ui("ieee754");
          function so(uo, Is, Sl) {
            if (!(this instanceof so)) return new so(uo, Is, Sl);
            var wl, Pl, jl, Dl, $l = typeof uo;
            if (Is === "base64" && $l == "string") for (uo = (Dl = uo).trim ? Dl.trim() : Dl.replace(/^\s+|\s+$/g, ""); uo.length % 4 != 0; ) uo += "=";
            if ($l == "number") wl = Ll(uo);
            else if ($l == "string") wl = so.byteLength(uo, Is);
            else {
              if ($l != "object") throw new Error("First argument needs to be a number, array or string.");
              wl = Ll(uo.length);
            }
            if (so._useTypedArrays ? Pl = so._augment(new Uint8Array(wl)) : ((Pl = this).length = wl, Pl._isBuffer = !0), so._useTypedArrays && typeof uo.byteLength == "number") Pl._set(uo);
            else if (Yl(Dl = uo) || so.isBuffer(Dl) || Dl && typeof Dl == "object" && typeof Dl.length == "number") for (jl = 0; jl < wl; jl++) so.isBuffer(uo) ? Pl[jl] = uo.readUInt8(jl) : Pl[jl] = uo[jl];
            else if ($l == "string") Pl.write(uo, 0, Is);
            else if ($l == "number" && !so._useTypedArrays && !Sl) for (jl = 0; jl < wl; jl++) Pl[jl] = 0;
            return Pl;
          }
          function bs(uo, Is, Sl, wl) {
            return so._charsWritten = Tl(function(Pl) {
              for (var jl = [], Dl = 0; Dl < Pl.length; Dl++) jl.push(255 & Pl.charCodeAt(Dl));
              return jl;
            }(Is), uo, Sl, wl);
          }
          function Rs(uo, Is, Sl, wl) {
            return so._charsWritten = Tl(function(Pl) {
              for (var jl, Dl, $l = [], kl = 0; kl < Pl.length; kl++) Dl = Pl.charCodeAt(kl), jl = Dl >> 8, Dl = Dl % 256, $l.push(Dl), $l.push(jl);
              return $l;
            }(Is), uo, Sl, wl);
          }
          function js(uo, Is, Sl) {
            var wl = "";
            Sl = Math.min(uo.length, Sl);
            for (var Pl = Is; Pl < Sl; Pl++) wl += String.fromCharCode(uo[Pl]);
            return wl;
          }
          function qs(uo, Is, Sl, jl) {
            jl || (Rl(typeof Sl == "boolean", "missing or invalid endian"), Rl(Is != null, "missing offset"), Rl(Is + 1 < uo.length, "Trying to read beyond buffer length"));
            var Pl, jl = uo.length;
            if (!(jl <= Is)) return Sl ? (Pl = uo[Is], Is + 1 < jl && (Pl |= uo[Is + 1] << 8)) : (Pl = uo[Is] << 8, Is + 1 < jl && (Pl |= uo[Is + 1])), Pl;
          }
          function jo(uo, Is, Sl, jl) {
            jl || (Rl(typeof Sl == "boolean", "missing or invalid endian"), Rl(Is != null, "missing offset"), Rl(Is + 3 < uo.length, "Trying to read beyond buffer length"));
            var Pl, jl = uo.length;
            if (!(jl <= Is)) return Sl ? (Is + 2 < jl && (Pl = uo[Is + 2] << 16), Is + 1 < jl && (Pl |= uo[Is + 1] << 8), Pl |= uo[Is], Is + 3 < jl && (Pl += uo[Is + 3] << 24 >>> 0)) : (Is + 1 < jl && (Pl = uo[Is + 1] << 16), Is + 2 < jl && (Pl |= uo[Is + 2] << 8), Is + 3 < jl && (Pl |= uo[Is + 3]), Pl += uo[Is] << 24 >>> 0), Pl;
          }
          function fs(uo, Is, Sl, wl) {
            if (wl || (Rl(typeof Sl == "boolean", "missing or invalid endian"), Rl(Is != null, "missing offset"), Rl(Is + 1 < uo.length, "Trying to read beyond buffer length")), !(uo.length <= Is)) return wl = qs(uo, Is, Sl, !0), 32768 & wl ? -1 * (65535 - wl + 1) : wl;
          }
          function Ao(uo, Is, Sl, wl) {
            if (wl || (Rl(typeof Sl == "boolean", "missing or invalid endian"), Rl(Is != null, "missing offset"), Rl(Is + 3 < uo.length, "Trying to read beyond buffer length")), !(uo.length <= Is)) return wl = jo(uo, Is, Sl, !0), 2147483648 & wl ? -1 * (4294967295 - wl + 1) : wl;
          }
          function co(uo, Is, Sl, wl) {
            return wl || (Rl(typeof Sl == "boolean", "missing or invalid endian"), Rl(Is + 3 < uo.length, "Trying to read beyond buffer length")), lo.read(uo, Is, Sl, 23, 4);
          }
          function Co(uo, Is, Sl, wl) {
            return wl || (Rl(typeof Sl == "boolean", "missing or invalid endian"), Rl(Is + 7 < uo.length, "Trying to read beyond buffer length")), lo.read(uo, Is, Sl, 52, 8);
          }
          function Zs(uo, Is, Sl, wl, Pl) {
            if (Pl || (Rl(Is != null, "missing value"), Rl(typeof wl == "boolean", "missing or invalid endian"), Rl(Sl != null, "missing offset"), Rl(Sl + 1 < uo.length, "trying to write beyond buffer length"), Il(Is, 65535)), Pl = uo.length, !(Pl <= Sl)) for (var jl = 0, Dl = Math.min(Pl - Sl, 2); jl < Dl; jl++) uo[Sl + jl] = (Is & 255 << 8 * (wl ? jl : 1 - jl)) >>> 8 * (wl ? jl : 1 - jl);
          }
          function xl(uo, Is, Sl, wl, Pl) {
            if (Pl || (Rl(Is != null, "missing value"), Rl(typeof wl == "boolean", "missing or invalid endian"), Rl(Sl != null, "missing offset"), Rl(Sl + 3 < uo.length, "trying to write beyond buffer length"), Il(Is, 4294967295)), Pl = uo.length, !(Pl <= Sl)) for (var jl = 0, Dl = Math.min(Pl - Sl, 4); jl < Dl; jl++) uo[Sl + jl] = Is >>> 8 * (wl ? jl : 3 - jl) & 255;
          }
          function Cl(uo, Is, Sl, wl, Pl) {
            Pl || (Rl(Is != null, "missing value"), Rl(typeof wl == "boolean", "missing or invalid endian"), Rl(Sl != null, "missing offset"), Rl(Sl + 1 < uo.length, "Trying to write beyond buffer length"), Ul(Is, 32767, -32768)), uo.length <= Sl || Zs(uo, 0 <= Is ? Is : 65535 + Is + 1, Sl, wl, Pl);
          }
          function Al(uo, Is, Sl, wl, Pl) {
            Pl || (Rl(Is != null, "missing value"), Rl(typeof wl == "boolean", "missing or invalid endian"), Rl(Sl != null, "missing offset"), Rl(Sl + 3 < uo.length, "Trying to write beyond buffer length"), Ul(Is, 2147483647, -2147483648)), uo.length <= Sl || xl(uo, 0 <= Is ? Is : 4294967295 + Is + 1, Sl, wl, Pl);
          }
          function Ol(uo, Is, Sl, wl, Pl) {
            Pl || (Rl(Is != null, "missing value"), Rl(typeof wl == "boolean", "missing or invalid endian"), Rl(Sl != null, "missing offset"), Rl(Sl + 3 < uo.length, "Trying to write beyond buffer length"), Kl(Is, 34028234663852886e22, -34028234663852886e22)), uo.length <= Sl || lo.write(uo, Is, Sl, wl, 23, 4);
          }
          function Bl(uo, Is, Sl, wl, Pl) {
            Pl || (Rl(Is != null, "missing value"), Rl(typeof wl == "boolean", "missing or invalid endian"), Rl(Sl != null, "missing offset"), Rl(Sl + 7 < uo.length, "Trying to write beyond buffer length"), Kl(Is, 17976931348623157e292, -17976931348623157e292)), uo.length <= Sl || lo.write(uo, Is, Sl, wl, 52, 8);
          }
          ta.Buffer = so, ta.SlowBuffer = so, ta.INSPECT_MAX_BYTES = 50, so.poolSize = 8192, so._useTypedArrays = function() {
            try {
              var uo = new ArrayBuffer(0), Is = new Uint8Array(uo);
              return Is.foo = function() {
                return 42;
              }, Is.foo() === 42 && typeof Is.subarray == "function";
            } catch {
              return !1;
            }
          }(), so.isEncoding = function(uo) {
            switch (String(uo).toLowerCase()) {
              case "hex":
              case "utf8":
              case "utf-8":
              case "ascii":
              case "binary":
              case "base64":
              case "raw":
              case "ucs2":
              case "ucs-2":
              case "utf16le":
              case "utf-16le":
                return !0;
              default:
                return !1;
            }
          }, so.isBuffer = function(uo) {
            return !(uo == null || !uo._isBuffer);
          }, so.byteLength = function(uo, Is) {
            var Sl;
            switch (uo += "", Is || "utf8") {
              case "hex":
                Sl = uo.length / 2;
                break;
              case "utf8":
              case "utf-8":
                Sl = tc(uo).length;
                break;
              case "ascii":
              case "binary":
              case "raw":
                Sl = uo.length;
                break;
              case "base64":
                Sl = Nl(uo).length;
                break;
              case "ucs2":
              case "ucs-2":
              case "utf16le":
              case "utf-16le":
                Sl = 2 * uo.length;
                break;
              default:
                throw new Error("Unknown encoding");
            }
            return Sl;
          }, so.concat = function(uo, Is) {
            if (Rl(Yl(uo), `Usage: Buffer.concat(list, [totalLength])
list should be an Array.`), uo.length === 0) return new so(0);
            if (uo.length === 1) return uo[0];
            if (typeof Is != "number") for (Pl = Is = 0; Pl < uo.length; Pl++) Is += uo[Pl].length;
            for (var Sl = new so(Is), wl = 0, Pl = 0; Pl < uo.length; Pl++) {
              var jl = uo[Pl];
              jl.copy(Sl, wl), wl += jl.length;
            }
            return Sl;
          }, so.prototype.write = function(uo, Is, Sl, wl) {
            isFinite(Is) ? isFinite(Sl) || (wl = Sl, Sl = void 0) : (kl = wl, wl = Is, Is = Sl, Sl = kl), Is = Number(Is) || 0;
            var Pl, jl, Dl, $l, kl = this.length - Is;
            switch ((!Sl || kl < (Sl = Number(Sl))) && (Sl = kl), wl = String(wl || "utf8").toLowerCase()) {
              case "hex":
                Pl = function(zl, Hl, Wl, ql) {
                  Wl = Number(Wl) || 0;
                  var Jl = zl.length - Wl;
                  (!ql || Jl < (ql = Number(ql))) && (ql = Jl), Rl((Jl = Hl.length) % 2 == 0, "Invalid hex string"), Jl / 2 < ql && (ql = Jl / 2);
                  for (var ac = 0; ac < ql; ac++) {
                    var Xl = parseInt(Hl.substr(2 * ac, 2), 16);
                    Rl(!isNaN(Xl), "Invalid hex string"), zl[Wl + ac] = Xl;
                  }
                  return so._charsWritten = 2 * ac, ac;
                }(this, uo, Is, Sl);
                break;
              case "utf8":
              case "utf-8":
                jl = this, Dl = Is, $l = Sl, Pl = so._charsWritten = Tl(tc(uo), jl, Dl, $l);
                break;
              case "ascii":
              case "binary":
                Pl = bs(this, uo, Is, Sl);
                break;
              case "base64":
                jl = this, Dl = Is, $l = Sl, Pl = so._charsWritten = Tl(Nl(uo), jl, Dl, $l);
                break;
              case "ucs2":
              case "ucs-2":
              case "utf16le":
              case "utf-16le":
                Pl = Rs(this, uo, Is, Sl);
                break;
              default:
                throw new Error("Unknown encoding");
            }
            return Pl;
          }, so.prototype.toString = function(uo, Is, Sl) {
            var wl, Pl, jl, Dl, $l = this;
            if (uo = String(uo || "utf8").toLowerCase(), Is = Number(Is) || 0, (Sl = Sl !== void 0 ? Number(Sl) : $l.length) === Is) return "";
            switch (uo) {
              case "hex":
                wl = function(kl, zl, Hl) {
                  var Wl = kl.length;
                  (!zl || zl < 0) && (zl = 0), (!Hl || Hl < 0 || Wl < Hl) && (Hl = Wl);
                  for (var ql = "", Jl = zl; Jl < Hl; Jl++) ql += Zl(kl[Jl]);
                  return ql;
                }($l, Is, Sl);
                break;
              case "utf8":
              case "utf-8":
                wl = function(kl, zl, Hl) {
                  var Wl = "", ql = "";
                  Hl = Math.min(kl.length, Hl);
                  for (var Jl = zl; Jl < Hl; Jl++) kl[Jl] <= 127 ? (Wl += El(ql) + String.fromCharCode(kl[Jl]), ql = "") : ql += "%" + kl[Jl].toString(16);
                  return Wl + El(ql);
                }($l, Is, Sl);
                break;
              case "ascii":
              case "binary":
                wl = js($l, Is, Sl);
                break;
              case "base64":
                Pl = $l, Dl = Sl, wl = (jl = Is) === 0 && Dl === Pl.length ? no.fromByteArray(Pl) : no.fromByteArray(Pl.slice(jl, Dl));
                break;
              case "ucs2":
              case "ucs-2":
              case "utf16le":
              case "utf-16le":
                wl = function(kl, zl, Hl) {
                  for (var Wl = kl.slice(zl, Hl), ql = "", Jl = 0; Jl < Wl.length; Jl += 2) ql += String.fromCharCode(Wl[Jl] + 256 * Wl[Jl + 1]);
                  return ql;
                }($l, Is, Sl);
                break;
              default:
                throw new Error("Unknown encoding");
            }
            return wl;
          }, so.prototype.toJSON = function() {
            return { type: "Buffer", data: Array.prototype.slice.call(this._arr || this, 0) };
          }, so.prototype.copy = function(uo, Is, Sl, wl) {
            if (Is = Is || 0, (wl = wl || wl === 0 ? wl : this.length) !== (Sl = Sl || 0) && uo.length !== 0 && this.length !== 0) {
              Rl(Sl <= wl, "sourceEnd < sourceStart"), Rl(0 <= Is && Is < uo.length, "targetStart out of bounds"), Rl(0 <= Sl && Sl < this.length, "sourceStart out of bounds"), Rl(0 <= wl && wl <= this.length, "sourceEnd out of bounds"), wl > this.length && (wl = this.length);
              var Pl = (wl = uo.length - Is < wl - Sl ? uo.length - Is + Sl : wl) - Sl;
              if (Pl < 100 || !so._useTypedArrays) for (var jl = 0; jl < Pl; jl++) uo[jl + Is] = this[jl + Sl];
              else uo._set(this.subarray(Sl, Sl + Pl), Is);
            }
          }, so.prototype.slice = function(uo, Is) {
            var Sl = this.length;
            if (uo = Vl(uo, Sl, 0), Is = Vl(Is, Sl, Sl), so._useTypedArrays) return so._augment(this.subarray(uo, Is));
            for (var wl = Is - uo, Pl = new so(wl, void 0, !0), jl = 0; jl < wl; jl++) Pl[jl] = this[jl + uo];
            return Pl;
          }, so.prototype.get = function(uo) {
            return console.log(".get() is deprecated. Access using array indexes instead."), this.readUInt8(uo);
          }, so.prototype.set = function(uo, Is) {
            return console.log(".set() is deprecated. Access using array indexes instead."), this.writeUInt8(uo, Is);
          }, so.prototype.readUInt8 = function(uo, Is) {
            if (Is || (Rl(uo != null, "missing offset"), Rl(uo < this.length, "Trying to read beyond buffer length")), !(uo >= this.length)) return this[uo];
          }, so.prototype.readUInt16LE = function(uo, Is) {
            return qs(this, uo, !0, Is);
          }, so.prototype.readUInt16BE = function(uo, Is) {
            return qs(this, uo, !1, Is);
          }, so.prototype.readUInt32LE = function(uo, Is) {
            return jo(this, uo, !0, Is);
          }, so.prototype.readUInt32BE = function(uo, Is) {
            return jo(this, uo, !1, Is);
          }, so.prototype.readInt8 = function(uo, Is) {
            if (Is || (Rl(uo != null, "missing offset"), Rl(uo < this.length, "Trying to read beyond buffer length")), !(uo >= this.length)) return 128 & this[uo] ? -1 * (255 - this[uo] + 1) : this[uo];
          }, so.prototype.readInt16LE = function(uo, Is) {
            return fs(this, uo, !0, Is);
          }, so.prototype.readInt16BE = function(uo, Is) {
            return fs(this, uo, !1, Is);
          }, so.prototype.readInt32LE = function(uo, Is) {
            return Ao(this, uo, !0, Is);
          }, so.prototype.readInt32BE = function(uo, Is) {
            return Ao(this, uo, !1, Is);
          }, so.prototype.readFloatLE = function(uo, Is) {
            return co(this, uo, !0, Is);
          }, so.prototype.readFloatBE = function(uo, Is) {
            return co(this, uo, !1, Is);
          }, so.prototype.readDoubleLE = function(uo, Is) {
            return Co(this, uo, !0, Is);
          }, so.prototype.readDoubleBE = function(uo, Is) {
            return Co(this, uo, !1, Is);
          }, so.prototype.writeUInt8 = function(uo, Is, Sl) {
            Sl || (Rl(uo != null, "missing value"), Rl(Is != null, "missing offset"), Rl(Is < this.length, "trying to write beyond buffer length"), Il(uo, 255)), Is >= this.length || (this[Is] = uo);
          }, so.prototype.writeUInt16LE = function(uo, Is, Sl) {
            Zs(this, uo, Is, !0, Sl);
          }, so.prototype.writeUInt16BE = function(uo, Is, Sl) {
            Zs(this, uo, Is, !1, Sl);
          }, so.prototype.writeUInt32LE = function(uo, Is, Sl) {
            xl(this, uo, Is, !0, Sl);
          }, so.prototype.writeUInt32BE = function(uo, Is, Sl) {
            xl(this, uo, Is, !1, Sl);
          }, so.prototype.writeInt8 = function(uo, Is, Sl) {
            Sl || (Rl(uo != null, "missing value"), Rl(Is != null, "missing offset"), Rl(Is < this.length, "Trying to write beyond buffer length"), Ul(uo, 127, -128)), Is >= this.length || (0 <= uo ? this.writeUInt8(uo, Is, Sl) : this.writeUInt8(255 + uo + 1, Is, Sl));
          }, so.prototype.writeInt16LE = function(uo, Is, Sl) {
            Cl(this, uo, Is, !0, Sl);
          }, so.prototype.writeInt16BE = function(uo, Is, Sl) {
            Cl(this, uo, Is, !1, Sl);
          }, so.prototype.writeInt32LE = function(uo, Is, Sl) {
            Al(this, uo, Is, !0, Sl);
          }, so.prototype.writeInt32BE = function(uo, Is, Sl) {
            Al(this, uo, Is, !1, Sl);
          }, so.prototype.writeFloatLE = function(uo, Is, Sl) {
            Ol(this, uo, Is, !0, Sl);
          }, so.prototype.writeFloatBE = function(uo, Is, Sl) {
            Ol(this, uo, Is, !1, Sl);
          }, so.prototype.writeDoubleLE = function(uo, Is, Sl) {
            Bl(this, uo, Is, !0, Sl);
          }, so.prototype.writeDoubleBE = function(uo, Is, Sl) {
            Bl(this, uo, Is, !1, Sl);
          }, so.prototype.fill = function(uo, Is, Sl) {
            if (Is = Is || 0, Sl = Sl || this.length, Rl(typeof (uo = typeof (uo = uo || 0) == "string" ? uo.charCodeAt(0) : uo) == "number" && !isNaN(uo), "value is not a number"), Rl(Is <= Sl, "end < start"), Sl !== Is && this.length !== 0) {
              Rl(0 <= Is && Is < this.length, "start out of bounds"), Rl(0 <= Sl && Sl <= this.length, "end out of bounds");
              for (var wl = Is; wl < Sl; wl++) this[wl] = uo;
            }
          }, so.prototype.inspect = function() {
            for (var uo = [], Is = this.length, Sl = 0; Sl < Is; Sl++) if (uo[Sl] = Zl(this[Sl]), Sl === ta.INSPECT_MAX_BYTES) {
              uo[Sl + 1] = "...";
              break;
            }
            return "<Buffer " + uo.join(" ") + ">";
          }, so.prototype.toArrayBuffer = function() {
            if (typeof Uint8Array > "u") throw new Error("Buffer.toArrayBuffer not supported in this browser");
            if (so._useTypedArrays) return new so(this).buffer;
            for (var uo = new Uint8Array(this.length), Is = 0, Sl = uo.length; Is < Sl; Is += 1) uo[Is] = this[Is];
            return uo.buffer;
          };
          var Ml = so.prototype;
          function Vl(uo, Is, Sl) {
            return typeof uo != "number" ? Sl : Is <= (uo = ~~uo) ? Is : 0 <= uo || 0 <= (uo += Is) ? uo : 0;
          }
          function Ll(uo) {
            return (uo = ~~Math.ceil(+uo)) < 0 ? 0 : uo;
          }
          function Yl(uo) {
            return (Array.isArray || function(Is) {
              return Object.prototype.toString.call(Is) === "[object Array]";
            })(uo);
          }
          function Zl(uo) {
            return uo < 16 ? "0" + uo.toString(16) : uo.toString(16);
          }
          function tc(uo) {
            for (var Is = [], Sl = 0; Sl < uo.length; Sl++) {
              var wl = uo.charCodeAt(Sl);
              if (wl <= 127) Is.push(uo.charCodeAt(Sl));
              else for (var Pl = Sl, jl = (55296 <= wl && wl <= 57343 && Sl++, encodeURIComponent(uo.slice(Pl, Sl + 1)).substr(1).split("%")), Dl = 0; Dl < jl.length; Dl++) Is.push(parseInt(jl[Dl], 16));
            }
            return Is;
          }
          function Nl(uo) {
            return no.toByteArray(uo);
          }
          function Tl(uo, Is, Sl, wl) {
            for (var Pl = 0; Pl < wl && !(Pl + Sl >= Is.length || Pl >= uo.length); Pl++) Is[Pl + Sl] = uo[Pl];
            return Pl;
          }
          function El(uo) {
            try {
              return decodeURIComponent(uo);
            } catch {
              return "�";
            }
          }
          function Il(uo, Is) {
            Rl(typeof uo == "number", "cannot write a non-number as a number"), Rl(0 <= uo, "specified a negative value for writing an unsigned value"), Rl(uo <= Is, "value is larger than maximum value for type"), Rl(Math.floor(uo) === uo, "value has a fractional component");
          }
          function Ul(uo, Is, Sl) {
            Rl(typeof uo == "number", "cannot write a non-number as a number"), Rl(uo <= Is, "value larger than maximum allowed value"), Rl(Sl <= uo, "value smaller than minimum allowed value"), Rl(Math.floor(uo) === uo, "value has a fractional component");
          }
          function Kl(uo, Is, Sl) {
            Rl(typeof uo == "number", "cannot write a non-number as a number"), Rl(uo <= Is, "value larger than maximum allowed value"), Rl(Sl <= uo, "value smaller than minimum allowed value");
          }
          function Rl(uo, Is) {
            if (!uo) throw new Error(Is || "Failed assertion");
          }
          so._augment = function(uo) {
            return uo._isBuffer = !0, uo._get = uo.get, uo._set = uo.set, uo.get = Ml.get, uo.set = Ml.set, uo.write = Ml.write, uo.toString = Ml.toString, uo.toLocaleString = Ml.toString, uo.toJSON = Ml.toJSON, uo.copy = Ml.copy, uo.slice = Ml.slice, uo.readUInt8 = Ml.readUInt8, uo.readUInt16LE = Ml.readUInt16LE, uo.readUInt16BE = Ml.readUInt16BE, uo.readUInt32LE = Ml.readUInt32LE, uo.readUInt32BE = Ml.readUInt32BE, uo.readInt8 = Ml.readInt8, uo.readInt16LE = Ml.readInt16LE, uo.readInt16BE = Ml.readInt16BE, uo.readInt32LE = Ml.readInt32LE, uo.readInt32BE = Ml.readInt32BE, uo.readFloatLE = Ml.readFloatLE, uo.readFloatBE = Ml.readFloatBE, uo.readDoubleLE = Ml.readDoubleLE, uo.readDoubleBE = Ml.readDoubleBE, uo.writeUInt8 = Ml.writeUInt8, uo.writeUInt16LE = Ml.writeUInt16LE, uo.writeUInt16BE = Ml.writeUInt16BE, uo.writeUInt32LE = Ml.writeUInt32LE, uo.writeUInt32BE = Ml.writeUInt32BE, uo.writeInt8 = Ml.writeInt8, uo.writeInt16LE = Ml.writeInt16LE, uo.writeInt16BE = Ml.writeInt16BE, uo.writeInt32LE = Ml.writeInt32LE, uo.writeInt32BE = Ml.writeInt32BE, uo.writeFloatLE = Ml.writeFloatLE, uo.writeFloatBE = Ml.writeFloatBE, uo.writeDoubleLE = Ml.writeDoubleLE, uo.writeDoubleBE = Ml.writeDoubleBE, uo.fill = Ml.fill, uo.inspect = Ml.inspect, uo.toArrayBuffer = Ml.toArrayBuffer, uo;
          };
        }).call(this, Ui("lYpoI2"), typeof self < "u" ? self : typeof window < "u" ? window : {}, Ui("buffer").Buffer, arguments[3], arguments[4], arguments[5], arguments[6], "/node_modules/gulp-browserify/node_modules/buffer/index.js", "/node_modules/gulp-browserify/node_modules/buffer");
      }, { "base64-js": 2, buffer: 3, ieee754: 10, lYpoI2: 11 }], 4: [function(Ui, Zi, ta) {
        (function(na, ia, no, da, La, qa, io, ao, oo) {
          var no = Ui("buffer").Buffer, lo = 4, so = new no(lo);
          so.fill(0), Zi.exports = { hash: function(bs, Rs, js, qs) {
            for (var jo = Rs(function(Zs, xl) {
              Zs.length % lo != 0 && (Cl = Zs.length + (lo - Zs.length % lo), Zs = no.concat([Zs, so], Cl));
              for (var Cl, Al = [], Ol = xl ? Zs.readInt32BE : Zs.readInt32LE, Bl = 0; Bl < Zs.length; Bl += lo) Al.push(Ol.call(Zs, Bl));
              return Al;
            }(bs = no.isBuffer(bs) ? bs : new no(bs), qs), 8 * bs.length), Rs = qs, fs = new no(js), Ao = Rs ? fs.writeInt32BE : fs.writeInt32LE, co = 0; co < jo.length; co++) Ao.call(fs, jo[co], 4 * co, !0);
            return fs;
          } };
        }).call(this, Ui("lYpoI2"), typeof self < "u" ? self : typeof window < "u" ? window : {}, Ui("buffer").Buffer, arguments[3], arguments[4], arguments[5], arguments[6], "/node_modules/gulp-browserify/node_modules/crypto-browserify/helpers.js", "/node_modules/gulp-browserify/node_modules/crypto-browserify");
      }, { buffer: 3, lYpoI2: 11 }], 5: [function(Ui, Zi, ta) {
        (function(na, ia, no, da, La, qa, io, ao, oo) {
          var no = Ui("buffer").Buffer, lo = Ui("./sha"), so = Ui("./sha256"), bs = Ui("./rng"), Rs = { sha1: lo, sha256: so, md5: Ui("./md5") }, js = 64, qs = new no(js);
          function jo(Zs, xl) {
            var Cl = Rs[Zs = Zs || "sha1"], Al = [];
            return Cl || fs("algorithm:", Zs, "is not yet supported"), { update: function(Ol) {
              return no.isBuffer(Ol) || (Ol = new no(Ol)), Al.push(Ol), Ol.length, this;
            }, digest: function(Ol) {
              var Bl = no.concat(Al), Bl = xl ? function(Ml, Vl, Ll) {
                no.isBuffer(Vl) || (Vl = new no(Vl)), no.isBuffer(Ll) || (Ll = new no(Ll)), Vl.length > js ? Vl = Ml(Vl) : Vl.length < js && (Vl = no.concat([Vl, qs], js));
                for (var Yl = new no(js), Zl = new no(js), tc = 0; tc < js; tc++) Yl[tc] = 54 ^ Vl[tc], Zl[tc] = 92 ^ Vl[tc];
                return Ll = Ml(no.concat([Yl, Ll])), Ml(no.concat([Zl, Ll]));
              }(Cl, xl, Bl) : Cl(Bl);
              return Al = null, Ol ? Bl.toString(Ol) : Bl;
            } };
          }
          function fs() {
            var Zs = [].slice.call(arguments).join(" ");
            throw new Error([Zs, "we accept pull requests", "http://github.com/dominictarr/crypto-browserify"].join(`
`));
          }
          qs.fill(0), ta.createHash = function(Zs) {
            return jo(Zs);
          }, ta.createHmac = jo, ta.randomBytes = function(Zs, xl) {
            if (!xl || !xl.call) return new no(bs(Zs));
            try {
              xl.call(this, void 0, new no(bs(Zs)));
            } catch (Cl) {
              xl(Cl);
            }
          };
          var Ao, co = ["createCredentials", "createCipher", "createCipheriv", "createDecipher", "createDecipheriv", "createSign", "createVerify", "createDiffieHellman", "pbkdf2"], Co = function(Zs) {
            ta[Zs] = function() {
              fs("sorry,", Zs, "is not implemented yet");
            };
          };
          for (Ao in co) Co(co[Ao]);
        }).call(this, Ui("lYpoI2"), typeof self < "u" ? self : typeof window < "u" ? window : {}, Ui("buffer").Buffer, arguments[3], arguments[4], arguments[5], arguments[6], "/node_modules/gulp-browserify/node_modules/crypto-browserify/index.js", "/node_modules/gulp-browserify/node_modules/crypto-browserify");
      }, { "./md5": 6, "./rng": 7, "./sha": 8, "./sha256": 9, buffer: 3, lYpoI2: 11 }], 6: [function(Ui, Zi, ta) {
        (function(na, ia, aa, da, La, qa, io, ao, oo) {
          var no = Ui("./helpers");
          function lo(fs, Ao) {
            fs[Ao >> 5] |= 128 << Ao % 32, fs[14 + (Ao + 64 >>> 9 << 4)] = Ao;
            for (var co = 1732584193, Co = -271733879, Zs = -1732584194, xl = 271733878, Cl = 0; Cl < fs.length; Cl += 16) {
              var Al = co, Ol = Co, Bl = Zs, Ml = xl, co = bs(co, Co, Zs, xl, fs[Cl + 0], 7, -680876936), xl = bs(xl, co, Co, Zs, fs[Cl + 1], 12, -389564586), Zs = bs(Zs, xl, co, Co, fs[Cl + 2], 17, 606105819), Co = bs(Co, Zs, xl, co, fs[Cl + 3], 22, -1044525330);
              co = bs(co, Co, Zs, xl, fs[Cl + 4], 7, -176418897), xl = bs(xl, co, Co, Zs, fs[Cl + 5], 12, 1200080426), Zs = bs(Zs, xl, co, Co, fs[Cl + 6], 17, -1473231341), Co = bs(Co, Zs, xl, co, fs[Cl + 7], 22, -45705983), co = bs(co, Co, Zs, xl, fs[Cl + 8], 7, 1770035416), xl = bs(xl, co, Co, Zs, fs[Cl + 9], 12, -1958414417), Zs = bs(Zs, xl, co, Co, fs[Cl + 10], 17, -42063), Co = bs(Co, Zs, xl, co, fs[Cl + 11], 22, -1990404162), co = bs(co, Co, Zs, xl, fs[Cl + 12], 7, 1804603682), xl = bs(xl, co, Co, Zs, fs[Cl + 13], 12, -40341101), Zs = bs(Zs, xl, co, Co, fs[Cl + 14], 17, -1502002290), co = Rs(co, Co = bs(Co, Zs, xl, co, fs[Cl + 15], 22, 1236535329), Zs, xl, fs[Cl + 1], 5, -165796510), xl = Rs(xl, co, Co, Zs, fs[Cl + 6], 9, -1069501632), Zs = Rs(Zs, xl, co, Co, fs[Cl + 11], 14, 643717713), Co = Rs(Co, Zs, xl, co, fs[Cl + 0], 20, -373897302), co = Rs(co, Co, Zs, xl, fs[Cl + 5], 5, -701558691), xl = Rs(xl, co, Co, Zs, fs[Cl + 10], 9, 38016083), Zs = Rs(Zs, xl, co, Co, fs[Cl + 15], 14, -660478335), Co = Rs(Co, Zs, xl, co, fs[Cl + 4], 20, -405537848), co = Rs(co, Co, Zs, xl, fs[Cl + 9], 5, 568446438), xl = Rs(xl, co, Co, Zs, fs[Cl + 14], 9, -1019803690), Zs = Rs(Zs, xl, co, Co, fs[Cl + 3], 14, -187363961), Co = Rs(Co, Zs, xl, co, fs[Cl + 8], 20, 1163531501), co = Rs(co, Co, Zs, xl, fs[Cl + 13], 5, -1444681467), xl = Rs(xl, co, Co, Zs, fs[Cl + 2], 9, -51403784), Zs = Rs(Zs, xl, co, Co, fs[Cl + 7], 14, 1735328473), co = js(co, Co = Rs(Co, Zs, xl, co, fs[Cl + 12], 20, -1926607734), Zs, xl, fs[Cl + 5], 4, -378558), xl = js(xl, co, Co, Zs, fs[Cl + 8], 11, -2022574463), Zs = js(Zs, xl, co, Co, fs[Cl + 11], 16, 1839030562), Co = js(Co, Zs, xl, co, fs[Cl + 14], 23, -35309556), co = js(co, Co, Zs, xl, fs[Cl + 1], 4, -1530992060), xl = js(xl, co, Co, Zs, fs[Cl + 4], 11, 1272893353), Zs = js(Zs, xl, co, Co, fs[Cl + 7], 16, -155497632), Co = js(Co, Zs, xl, co, fs[Cl + 10], 23, -1094730640), co = js(co, Co, Zs, xl, fs[Cl + 13], 4, 681279174), xl = js(xl, co, Co, Zs, fs[Cl + 0], 11, -358537222), Zs = js(Zs, xl, co, Co, fs[Cl + 3], 16, -722521979), Co = js(Co, Zs, xl, co, fs[Cl + 6], 23, 76029189), co = js(co, Co, Zs, xl, fs[Cl + 9], 4, -640364487), xl = js(xl, co, Co, Zs, fs[Cl + 12], 11, -421815835), Zs = js(Zs, xl, co, Co, fs[Cl + 15], 16, 530742520), co = qs(co, Co = js(Co, Zs, xl, co, fs[Cl + 2], 23, -995338651), Zs, xl, fs[Cl + 0], 6, -198630844), xl = qs(xl, co, Co, Zs, fs[Cl + 7], 10, 1126891415), Zs = qs(Zs, xl, co, Co, fs[Cl + 14], 15, -1416354905), Co = qs(Co, Zs, xl, co, fs[Cl + 5], 21, -57434055), co = qs(co, Co, Zs, xl, fs[Cl + 12], 6, 1700485571), xl = qs(xl, co, Co, Zs, fs[Cl + 3], 10, -1894986606), Zs = qs(Zs, xl, co, Co, fs[Cl + 10], 15, -1051523), Co = qs(Co, Zs, xl, co, fs[Cl + 1], 21, -2054922799), co = qs(co, Co, Zs, xl, fs[Cl + 8], 6, 1873313359), xl = qs(xl, co, Co, Zs, fs[Cl + 15], 10, -30611744), Zs = qs(Zs, xl, co, Co, fs[Cl + 6], 15, -1560198380), Co = qs(Co, Zs, xl, co, fs[Cl + 13], 21, 1309151649), co = qs(co, Co, Zs, xl, fs[Cl + 4], 6, -145523070), xl = qs(xl, co, Co, Zs, fs[Cl + 11], 10, -1120210379), Zs = qs(Zs, xl, co, Co, fs[Cl + 2], 15, 718787259), Co = qs(Co, Zs, xl, co, fs[Cl + 9], 21, -343485551), co = jo(co, Al), Co = jo(Co, Ol), Zs = jo(Zs, Bl), xl = jo(xl, Ml);
            }
            return Array(co, Co, Zs, xl);
          }
          function so(fs, Ao, co, Co, Zs, xl) {
            return jo((Ao = jo(jo(Ao, fs), jo(Co, xl))) << Zs | Ao >>> 32 - Zs, co);
          }
          function bs(fs, Ao, co, Co, Zs, xl, Cl) {
            return so(Ao & co | ~Ao & Co, fs, Ao, Zs, xl, Cl);
          }
          function Rs(fs, Ao, co, Co, Zs, xl, Cl) {
            return so(Ao & Co | co & ~Co, fs, Ao, Zs, xl, Cl);
          }
          function js(fs, Ao, co, Co, Zs, xl, Cl) {
            return so(Ao ^ co ^ Co, fs, Ao, Zs, xl, Cl);
          }
          function qs(fs, Ao, co, Co, Zs, xl, Cl) {
            return so(co ^ (Ao | ~Co), fs, Ao, Zs, xl, Cl);
          }
          function jo(fs, Ao) {
            var co = (65535 & fs) + (65535 & Ao);
            return (fs >> 16) + (Ao >> 16) + (co >> 16) << 16 | 65535 & co;
          }
          Zi.exports = function(fs) {
            return no.hash(fs, lo, 16);
          };
        }).call(this, Ui("lYpoI2"), typeof self < "u" ? self : typeof window < "u" ? window : {}, Ui("buffer").Buffer, arguments[3], arguments[4], arguments[5], arguments[6], "/node_modules/gulp-browserify/node_modules/crypto-browserify/md5.js", "/node_modules/gulp-browserify/node_modules/crypto-browserify");
      }, { "./helpers": 4, buffer: 3, lYpoI2: 11 }], 7: [function(Ui, Zi, ta) {
        (function(na, ia, aa, da, La, qa, io, ao, oo) {
          Zi.exports = function(no) {
            for (var lo, so = new Array(no), bs = 0; bs < no; bs++) (3 & bs) == 0 && (lo = 4294967296 * Math.random()), so[bs] = lo >>> ((3 & bs) << 3) & 255;
            return so;
          };
        }).call(this, Ui("lYpoI2"), typeof self < "u" ? self : typeof window < "u" ? window : {}, Ui("buffer").Buffer, arguments[3], arguments[4], arguments[5], arguments[6], "/node_modules/gulp-browserify/node_modules/crypto-browserify/rng.js", "/node_modules/gulp-browserify/node_modules/crypto-browserify");
      }, { buffer: 3, lYpoI2: 11 }], 8: [function(Ui, Zi, ta) {
        (function(na, ia, aa, da, La, qa, io, ao, oo) {
          var no = Ui("./helpers");
          function lo(Rs, js) {
            Rs[js >> 5] |= 128 << 24 - js % 32, Rs[15 + (js + 64 >> 9 << 4)] = js;
            for (var qs, jo, fs, Ao = Array(80), co = 1732584193, Co = -271733879, Zs = -1732584194, xl = 271733878, Cl = -1009589776, Al = 0; Al < Rs.length; Al += 16) {
              for (var Ol = co, Bl = Co, Ml = Zs, Vl = xl, Ll = Cl, Yl = 0; Yl < 80; Yl++) {
                Ao[Yl] = Yl < 16 ? Rs[Al + Yl] : bs(Ao[Yl - 3] ^ Ao[Yl - 8] ^ Ao[Yl - 14] ^ Ao[Yl - 16], 1);
                var Zl = so(so(bs(co, 5), (Zl = Co, jo = Zs, fs = xl, (qs = Yl) < 20 ? Zl & jo | ~Zl & fs : !(qs < 40) && qs < 60 ? Zl & jo | Zl & fs | jo & fs : Zl ^ jo ^ fs)), so(so(Cl, Ao[Yl]), (qs = Yl) < 20 ? 1518500249 : qs < 40 ? 1859775393 : qs < 60 ? -1894007588 : -899497514)), Cl = xl, xl = Zs, Zs = bs(Co, 30), Co = co, co = Zl;
              }
              co = so(co, Ol), Co = so(Co, Bl), Zs = so(Zs, Ml), xl = so(xl, Vl), Cl = so(Cl, Ll);
            }
            return Array(co, Co, Zs, xl, Cl);
          }
          function so(Rs, js) {
            var qs = (65535 & Rs) + (65535 & js);
            return (Rs >> 16) + (js >> 16) + (qs >> 16) << 16 | 65535 & qs;
          }
          function bs(Rs, js) {
            return Rs << js | Rs >>> 32 - js;
          }
          Zi.exports = function(Rs) {
            return no.hash(Rs, lo, 20, !0);
          };
        }).call(this, Ui("lYpoI2"), typeof self < "u" ? self : typeof window < "u" ? window : {}, Ui("buffer").Buffer, arguments[3], arguments[4], arguments[5], arguments[6], "/node_modules/gulp-browserify/node_modules/crypto-browserify/sha.js", "/node_modules/gulp-browserify/node_modules/crypto-browserify");
      }, { "./helpers": 4, buffer: 3, lYpoI2: 11 }], 9: [function(Ui, Zi, ta) {
        (function(na, ia, aa, da, La, qa, io, ao, oo) {
          function no(js, qs) {
            var jo = (65535 & js) + (65535 & qs);
            return (js >> 16) + (qs >> 16) + (jo >> 16) << 16 | 65535 & jo;
          }
          function lo(js, qs) {
            var jo, fs = new Array(1116352408, 1899447441, 3049323471, 3921009573, 961987163, 1508970993, 2453635748, 2870763221, 3624381080, 310598401, 607225278, 1426881987, 1925078388, 2162078206, 2614888103, 3248222580, 3835390401, 4022224774, 264347078, 604807628, 770255983, 1249150122, 1555081692, 1996064986, 2554220882, 2821834349, 2952996808, 3210313671, 3336571891, 3584528711, 113926993, 338241895, 666307205, 773529912, 1294757372, 1396182291, 1695183700, 1986661051, 2177026350, 2456956037, 2730485921, 2820302411, 3259730800, 3345764771, 3516065817, 3600352804, 4094571909, 275423344, 430227734, 506948616, 659060556, 883997877, 958139571, 1322822218, 1537002063, 1747873779, 1955562222, 2024104815, 2227730452, 2361852424, 2428436474, 2756734187, 3204031479, 3329325298), Ao = new Array(1779033703, 3144134277, 1013904242, 2773480762, 1359893119, 2600822924, 528734635, 1541459225), co = new Array(64);
            js[qs >> 5] |= 128 << 24 - qs % 32, js[15 + (qs + 64 >> 9 << 4)] = qs;
            for (var Co, Zs, xl = 0; xl < js.length; xl += 16) {
              for (var Cl = Ao[0], Al = Ao[1], Ol = Ao[2], Bl = Ao[3], Ml = Ao[4], Vl = Ao[5], Ll = Ao[6], Yl = Ao[7], Zl = 0; Zl < 64; Zl++) co[Zl] = Zl < 16 ? js[Zl + xl] : no(no(no((Zs = co[Zl - 2], bs(Zs, 17) ^ bs(Zs, 19) ^ Rs(Zs, 10)), co[Zl - 7]), (Zs = co[Zl - 15], bs(Zs, 7) ^ bs(Zs, 18) ^ Rs(Zs, 3))), co[Zl - 16]), jo = no(no(no(no(Yl, bs(Zs = Ml, 6) ^ bs(Zs, 11) ^ bs(Zs, 25)), Ml & Vl ^ ~Ml & Ll), fs[Zl]), co[Zl]), Co = no(bs(Co = Cl, 2) ^ bs(Co, 13) ^ bs(Co, 22), Cl & Al ^ Cl & Ol ^ Al & Ol), Yl = Ll, Ll = Vl, Vl = Ml, Ml = no(Bl, jo), Bl = Ol, Ol = Al, Al = Cl, Cl = no(jo, Co);
              Ao[0] = no(Cl, Ao[0]), Ao[1] = no(Al, Ao[1]), Ao[2] = no(Ol, Ao[2]), Ao[3] = no(Bl, Ao[3]), Ao[4] = no(Ml, Ao[4]), Ao[5] = no(Vl, Ao[5]), Ao[6] = no(Ll, Ao[6]), Ao[7] = no(Yl, Ao[7]);
            }
            return Ao;
          }
          var so = Ui("./helpers"), bs = function(js, qs) {
            return js >>> qs | js << 32 - qs;
          }, Rs = function(js, qs) {
            return js >>> qs;
          };
          Zi.exports = function(js) {
            return so.hash(js, lo, 32, !0);
          };
        }).call(this, Ui("lYpoI2"), typeof self < "u" ? self : typeof window < "u" ? window : {}, Ui("buffer").Buffer, arguments[3], arguments[4], arguments[5], arguments[6], "/node_modules/gulp-browserify/node_modules/crypto-browserify/sha256.js", "/node_modules/gulp-browserify/node_modules/crypto-browserify");
      }, { "./helpers": 4, buffer: 3, lYpoI2: 11 }], 10: [function(Ui, Zi, ta) {
        (function(na, ia, aa, da, La, qa, io, ao, oo) {
          ta.read = function(no, lo, so, bs, xl) {
            var js, qs, jo = 8 * xl - bs - 1, fs = (1 << jo) - 1, Ao = fs >> 1, co = -7, Co = so ? xl - 1 : 0, Zs = so ? -1 : 1, xl = no[lo + Co];
            for (Co += Zs, js = xl & (1 << -co) - 1, xl >>= -co, co += jo; 0 < co; js = 256 * js + no[lo + Co], Co += Zs, co -= 8) ;
            for (qs = js & (1 << -co) - 1, js >>= -co, co += bs; 0 < co; qs = 256 * qs + no[lo + Co], Co += Zs, co -= 8) ;
            if (js === 0) js = 1 - Ao;
            else {
              if (js === fs) return qs ? NaN : 1 / 0 * (xl ? -1 : 1);
              qs += Math.pow(2, bs), js -= Ao;
            }
            return (xl ? -1 : 1) * qs * Math.pow(2, js - bs);
          }, ta.write = function(no, lo, so, bs, Rs, Cl) {
            var qs, jo, fs = 8 * Cl - Rs - 1, Ao = (1 << fs) - 1, co = Ao >> 1, Co = Rs === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0, Zs = bs ? 0 : Cl - 1, xl = bs ? 1 : -1, Cl = lo < 0 || lo === 0 && 1 / lo < 0 ? 1 : 0;
            for (lo = Math.abs(lo), isNaN(lo) || lo === 1 / 0 ? (jo = isNaN(lo) ? 1 : 0, qs = Ao) : (qs = Math.floor(Math.log(lo) / Math.LN2), lo * (bs = Math.pow(2, -qs)) < 1 && (qs--, bs *= 2), 2 <= (lo += 1 <= qs + co ? Co / bs : Co * Math.pow(2, 1 - co)) * bs && (qs++, bs /= 2), Ao <= qs + co ? (jo = 0, qs = Ao) : 1 <= qs + co ? (jo = (lo * bs - 1) * Math.pow(2, Rs), qs += co) : (jo = lo * Math.pow(2, co - 1) * Math.pow(2, Rs), qs = 0)); 8 <= Rs; no[so + Zs] = 255 & jo, Zs += xl, jo /= 256, Rs -= 8) ;
            for (qs = qs << Rs | jo, fs += Rs; 0 < fs; no[so + Zs] = 255 & qs, Zs += xl, qs /= 256, fs -= 8) ;
            no[so + Zs - xl] |= 128 * Cl;
          };
        }).call(this, Ui("lYpoI2"), typeof self < "u" ? self : typeof window < "u" ? window : {}, Ui("buffer").Buffer, arguments[3], arguments[4], arguments[5], arguments[6], "/node_modules/gulp-browserify/node_modules/ieee754/index.js", "/node_modules/gulp-browserify/node_modules/ieee754");
      }, { buffer: 3, lYpoI2: 11 }], 11: [function(Ui, Zi, ta) {
        (function(na, ia, aa, da, La, qa, io, ao, oo) {
          var no, lo, so;
          function bs() {
          }
          (na = Zi.exports = {}).nextTick = (lo = typeof window < "u" && window.setImmediate, so = typeof window < "u" && window.postMessage && window.addEventListener, lo ? function(Rs) {
            return window.setImmediate(Rs);
          } : so ? (no = [], window.addEventListener("message", function(Rs) {
            var js = Rs.source;
            js !== window && js !== null || Rs.data !== "process-tick" || (Rs.stopPropagation(), 0 < no.length && no.shift()());
          }, !0), function(Rs) {
            no.push(Rs), window.postMessage("process-tick", "*");
          }) : function(Rs) {
            setTimeout(Rs, 0);
          }), na.title = "browser", na.browser = !0, na.env = {}, na.argv = [], na.on = bs, na.addListener = bs, na.once = bs, na.off = bs, na.removeListener = bs, na.removeAllListeners = bs, na.emit = bs, na.binding = function(Rs) {
            throw new Error("process.binding is not supported");
          }, na.cwd = function() {
            return "/";
          }, na.chdir = function(Rs) {
            throw new Error("process.chdir is not supported");
          };
        }).call(this, Ui("lYpoI2"), typeof self < "u" ? self : typeof window < "u" ? window : {}, Ui("buffer").Buffer, arguments[3], arguments[4], arguments[5], arguments[6], "/node_modules/gulp-browserify/node_modules/process/browser.js", "/node_modules/gulp-browserify/node_modules/process");
      }, { buffer: 3, lYpoI2: 11 }] }, {}, [1])(1);
    });
  }(object_hash)), object_hash.exports;
}
var object_hashExports = requireObject_hash();
const hash = /* @__PURE__ */ getDefaultExportFromCjs(object_hashExports), OptionsContainer = ({
  children: Bi,
  showMenu: e
}) => /* @__PURE__ */ jsxRuntimeExports.jsx(
  "div",
  {
    className: `absolute left-0 right-0 z-50 overflow-scroll rounded max-h-40 ${e ? "block" : "hidden"}`,
    children: Bi
  }
);
function SelectionSearch({
  options: Bi,
  onSelect: e,
  displayKey: Ui
}) {
  const [Zi, ta] = useState(!1), na = useRef(null), ia = () => ta(!0), [aa, da] = useState(""), La = useMemo(() => {
    if (!aa) return Bi;
    const qa = new RegExp(aa, "i");
    return Bi.filter((io) => Ui ? io[Ui].match(qa) : io.match(qa));
  }, [aa, Bi]);
  return vi$1(na, () => ta(!1)), Si$1(
    {
      Escape: () => ta(!1)
    },
    [ta]
  ), /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "relative", onFocus: ia, children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(
      Field,
      {
        autoComplete: "off",
        ref: na,
        type: "text",
        onChange: (qa) => da(qa.target.value),
        value: aa
      }
    ),
    /* @__PURE__ */ jsxRuntimeExports.jsx(OptionsContainer, { showMenu: Zi, children: /* @__PURE__ */ jsxRuntimeExports.jsxs(
      motion.ul,
      {
        className: "flex flex-col w-full h-full p-2 rounded shadow-lg bg-neutral-200",
        layout: !0,
        children: [
          La.length > 0 && La.map((qa) => /* @__PURE__ */ jsxRuntimeExports.jsx("li", { className: "hover:text-blue-500", children: /* @__PURE__ */ jsxRuntimeExports.jsx(
            "button",
            {
              onClick: () => {
                e(qa), da(
                  Ui ? qa[Ui] : qa
                );
              },
              children: Ui ? qa[Ui] : qa
            }
          ) }, hash(qa))),
          Zi && La.length === 0 && /* @__PURE__ */ jsxRuntimeExports.jsx("p", { className: "italic", children: "No Results" })
        ]
      }
    ) })
  ] });
}
function Table({
  row: Bi,
  data: e,
  extras: Ui = [],
  hide: Zi,
  transform: ta,
  editable: na = !1,
  onEdit: ia,
  defaultSortKey: aa,
  className: da = "",
  render: La,
  renderHeading: qa,
  cell: io
}) {
  const [ao, oo] = useState(aa ?? ""), [no, lo] = useState(
    "desc"
    /* Descending */
  ), [so, bs] = useState({
    key: "",
    newValue: "",
    value: "",
    hashedRow: ""
  }), Rs = useMemo(() => [...e], [e]), js = useRef(null), qs = useMemo(() => ao ? Rs.sort((xl, Cl) => {
    const Al = xl[ao] ?? "", Ol = Cl[ao] ?? "";
    return Al < Ol ? no === "asc" ? -1 : 1 : Al > Ol ? no === "asc" ? 1 : -1 : 0;
  }) : Rs, [ao, Rs, no]), jo = useMemo(() => Rs.length === 0 ? [] : Object.getOwnPropertyNames(Rs[0]).reduce((Cl, Al) => {
    if (Zi?.[Al])
      return Cl;
    if (ta && ta[Al]) {
      const Ol = ta[Al](Al);
      return [
        ...Cl,
        {
          key: Al,
          transformed: Ol
        }
      ];
    } else
      return console.log(
        `No transform for column ${Al}, using key as transformed value`
      ), [...Cl, { key: Al, transformed: Al }];
  }, []), [Rs]), fs = useCallback(
    (xl, Cl) => La?.[xl] ? La[xl](Cl) : xl === so.key && hash(Cl) === so.hashedRow && na ? /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx(
        "form",
        {
          className: "absolute left-0 right-0 top-0 bottom-0",
          onSubmit: (Al) => {
            Al.preventDefault(), ia && ia({
              column: so.key,
              newValue: so.newValue,
              oldValue: so.value,
              rowData: Cl
            }), bs({
              key: "",
              value: "",
              newValue: "",
              hashedRow: ""
            }), js.current?.blur();
          },
          children: /* @__PURE__ */ jsxRuntimeExports.jsx(
            "textarea",
            {
              className: "w-full h-full",
              onBlur: () => {
                ia?.({
                  column: so.key,
                  newValue: so.newValue,
                  oldValue: so.value,
                  rowData: Cl
                }), bs({
                  key: "",
                  value: "",
                  newValue: "",
                  hashedRow: ""
                });
              },
              ref: js,
              autoFocus: !0,
              value: so.newValue,
              onChange: (Al) => bs({
                key: xl,
                value: Cl[xl],
                newValue: Al.target.value,
                hashedRow: hash(Cl)
              })
            },
            `${hash(Cl)}}-${xl}-${Cl[xl]}-input`
          )
        }
      ),
      /* @__PURE__ */ jsxRuntimeExports.jsx("p", { className: "invisible", children: Cl[xl] })
    ] }) : /* @__PURE__ */ jsxRuntimeExports.jsx("div", { children: Cl[xl] }),
    [so, La]
  ), Ao = Bi ?? ((xl) => /* @__PURE__ */ jsxRuntimeExports.jsx("tr", { ...xl })), co = (xl) => qa ? /* @__PURE__ */ jsxRuntimeExports.jsx(jsxRuntimeExports.Fragment, { children: qa(xl.children) }) : /* @__PURE__ */ jsxRuntimeExports.jsx("tr", { ...xl });
  let Co = !0;
  isBoolean(qa) && (qa ? Co = !0 : Co = !1);
  const Zs = io ?? "td";
  return /* @__PURE__ */ jsxRuntimeExports.jsxs("table", { className: da, children: [
    Co && /* @__PURE__ */ jsxRuntimeExports.jsx("thead", { children: /* @__PURE__ */ jsxRuntimeExports.jsxs(co, { children: [
      jo.map(
        ({ key: xl, transformed: Cl }) => !Zi?.[xl] && /* @__PURE__ */ jsxRuntimeExports.jsx(
          "th",
          {
            onClick: () => {
              ao == xl ? lo(
                () => no === "asc" ? "desc" : "asc"
                /* Ascending */
              ) : (oo(xl), lo(
                "asc"
                /* Ascending */
              ));
            },
            children: /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "flex justify-start items-center", children: [
              Cl,
              xl === ao && no === "asc" && /* @__PURE__ */ jsxRuntimeExports.jsx(
                FontAwesomeIcon,
                {
                  className: "mx-1",
                  size: "sm",
                  icon: faChevronUp
                }
              ),
              xl === ao && no === "desc" && /* @__PURE__ */ jsxRuntimeExports.jsx(
                FontAwesomeIcon,
                {
                  className: "mx-1",
                  size: "sm",
                  icon: faChevronDown
                }
              )
            ] })
          },
          xl
        )
      ),
      (Ui || []).map(({ key: xl }, Cl) => /* @__PURE__ */ jsxRuntimeExports.jsx("th", { children: xl }, `extras-${xl}-${Cl}`))
    ] }) }),
    /* @__PURE__ */ jsxRuntimeExports.jsx("tbody", { children: qs.map(
      (xl) => Ao(
        {
          key: hash(xl),
          children: Object.entries(xl).map(([Cl, Al]) => Zi?.[Cl] ? null : !Zi?.[Cl] && /* @__PURE__ */ jsxRuntimeExports.jsx(
            Zs,
            {
              title: Al,
              onClick: () => {
                na && !La?.[Cl] && bs({
                  key: Cl,
                  value: Al,
                  newValue: Al,
                  hashedRow: hash(xl)
                });
              },
              children: fs(Cl, xl)
            },
            `${hash(xl)}}-${Cl}-${Al}`
          ))
        },
        xl
      )
    ) })
  ] });
}
function isBoolean(Bi) {
  return typeof Bi == "boolean";
}
const TabsContext = createContext(
  {}
);
function TabsProvider(Bi) {
  return /* @__PURE__ */ jsxRuntimeExports.jsx(TabsContext.Provider, { value: Bi.value, children: Bi.children });
}
const useTabsContext = () => useContext(TabsContext);
function TabsList({ items: Bi }) {
  const { activeTab: e, setActiveTab: Ui } = useTabsContext();
  return /* @__PURE__ */ jsxRuntimeExports.jsx(
    "div",
    {
      className: "flex w-full bg-black overflow-x-scroll self-baseline tabs-list overflow-y-hidden",
      children: Bi.map((Zi) => /* @__PURE__ */ jsxRuntimeExports.jsx(
        Tab$1,
        {
          label: Zi.label,
          active: e === Zi.value,
          value: Zi.value,
          onClick: (ta) => {
            Ui(ta);
          }
        },
        `tab-${Zi.value}`
      ))
    }
  );
}
const tabStyle = cva(
  [
    "last:border-none",
    "border-r",
    "flex-shrink-0",
    "px-4",
    "pb-4",
    "hover:bg-gray-200",
    "whitespace-nowrap",
    "overflow-hidden",
    "text-ellipsis",
    "self-baseline"
  ],
  {
    variants: {
      active: {
        false: "bg-black text-white",
        true: "bg-white text-black"
      }
    }
  }
);
function Tab$1(Bi) {
  return /* @__PURE__ */ jsxRuntimeExports.jsx(
    "button",
    {
      onClick: () => Bi.onClick(Bi.value),
      className: tabStyle({ active: Bi.active }),
      children: Bi.label
    }
  );
}
function TabContent({
  children: Bi,
  className: e,
  value: Ui
}) {
  const { activeTab: Zi, contentRef: ta } = useTabsContext();
  return Zi !== Ui || !ta ? null : createPortal(
    /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: `flex flex-col flex-grow h-full w-full ${e || ""} overflow-hidden`, children: Bi }),
    ta
  );
}
const Tabs = ({
  children: Bi,
  items: e,
  onChange: Ui,
  activeTab: Zi
}) => {
  const [ta, na] = useState(null);
  return /* @__PURE__ */ jsxRuntimeExports.jsx(
    TabsProvider,
    {
      value: {
        activeTab: Zi,
        setActiveTab: (ia) => {
          Ui?.(ia);
        },
        contentRef: ta
      },
      children: /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "flex flex-col tabs h-full overflow-hidden", children: [
        /* @__PURE__ */ jsxRuntimeExports.jsx(TabsList, { items: e }),
        /* @__PURE__ */ jsxRuntimeExports.jsx(
          "div",
          {
            className: "flex flex-col flex-grow-[2] h-full w-full overflow-hidden",
            ref: na,
            children: Bi
          }
        )
      ] })
    }
  );
};
Tabs.Tab = TabContent;
const tabStyles = cva([
  "rounded",
  "px-4",
  "py-2",
  "bg-neutral-50",
  "mr-1",
  "hover:bg-neutral-100",
  "hover:text-black",
  "text-neutral-800"
], {
  variants: {
    active: {
      true: ["bg-black", "hover:bg-black", "text-white"],
      false: []
    }
  }
}), Tab = ({ value: Bi, children: e }) => {
  const { activeTab: Ui, setActiveTab: Zi } = useTabsContext();
  return /* @__PURE__ */ jsxRuntimeExports.jsx(
    "button",
    {
      className: tabStyles({ active: Ui === Bi }),
      onClick: () => Zi(Bi),
      children: e
    }
  );
}, TaskQueueLogs = ({
  jobId: Bi,
  className: e = ""
}) => {
  const { data: Ui } = useTaskQueueLogsSubscription({ variables: { jobId: Bi } }), [Zi, ta] = useState([]);
  return useEffect(() => {
    Ui?.taskQueueLogs && ta((na) => [...na, Ui.taskQueueLogs]);
  }, [Ui]), /* @__PURE__ */ jsxRuntimeExports.jsx(
    "div",
    {
      className: `${e} relative h-full p-4 overflow-y-scroll rounded bg-neutral-200 text-neutral-800`,
      children: Zi.map((na, ia) => /* @__PURE__ */ jsxRuntimeExports.jsx("pre", { children: na.message }, `task-queue-${Bi}-${na.timestamp}-${ia}`))
    }
  );
}, ThemeContext = createContext({}), useTheme = () => useContext(ThemeContext), useDarkModeState = (Bi = !1) => {
  const [e, Ui] = useState(Bi);
  return useEffect(() => {
    const Zi = localStorage.getItem("darkMode");
    try {
      const ta = JSON.parse(Zi || "");
      Ui(ta.darkMode);
    } catch {
      localStorage.setItem(
        "darkMode",
        JSON.stringify({ darkMode: Bi })
      );
    }
  }, [Ui]), useEffect(() => {
    localStorage.setItem("darkMode", JSON.stringify({ darkMode: e }));
  }, [e]), {
    darkMode: !1,
    // disable dark mode for now
    setDarkMode: (Zi) => {
      localStorage.setItem("darkMode", JSON.stringify({ darkMode: !Zi })), Ui(Zi);
    }
  };
}, ThemeProvider = ({ children: Bi }) => {
  const { darkMode: e, setDarkMode: Ui } = useDarkModeState();
  return useEffect(() => {
    const Zi = document.querySelector("body");
    Zi && Zi.classList.remove("dark");
  }, [e]), /* @__PURE__ */ jsxRuntimeExports.jsx(ThemeContext.Provider, { value: { darkMode: e, setDarkMode: Ui }, children: /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "", children: Bi }) });
}, Title = ({
  order: Bi,
  children: e,
  className: Ui = ""
}) => {
  function Zi(ta, na) {
    switch (ta) {
      case 1:
        return /* @__PURE__ */ jsxRuntimeExports.jsx("h1", { className: `${Ui} text-2xl text-brand-500`, children: na });
      case 2:
        return /* @__PURE__ */ jsxRuntimeExports.jsx("h2", { className: `${Ui} text-xl text-brand-600`, children: na });
      case 3:
        return /* @__PURE__ */ jsxRuntimeExports.jsx("h3", { className: `${Ui} text-brand-800`, children: na });
      case 4:
        return /* @__PURE__ */ jsxRuntimeExports.jsx("h4", { children: na });
      case 5:
        return /* @__PURE__ */ jsxRuntimeExports.jsx("h5", { children: na });
      default:
      case 6:
        return /* @__PURE__ */ jsxRuntimeExports.jsx("h6", { children: na });
    }
  }
  return Zi(Bi, e);
};
function Toggle({ on: Bi, onChange: e, className: Ui = "" }) {
  return /* @__PURE__ */ jsxRuntimeExports.jsx(
    motion.button,
    {
      layout: !0,
      onClick: () => e(!Bi),
      className: `
                w-12 h-4 p-1 items-center ${Ui} flex rounded transition-colors 
                ${Bi ? "justify-end bg-black" : "justify-start bg-neutral-100"}
            `,
      children: /* @__PURE__ */ jsxRuntimeExports.jsx(
        motion.div,
        {
          layout: !0,
          className: `w-4 h-2 rounded-sm transition-colors ${Bi ? "bg-neutral-100" : "bg-neutral-800"}`
        }
      )
    }
  );
}
const Textarea = forwardRef(
  ({ className: Bi, ...e }, Ui) => /* @__PURE__ */ jsxRuntimeExports.jsx("textarea", { ref: Ui, ...e, className: twMerge(
    "dark:bg-neutral-800 dark:text-neutral-200 bg-white text-black px-2 border-black border font-body",
    Bi
  ) })
);
export {
  AppLayout,
  Button,
  CircleSpinner,
  CopyButton,
  Delete,
  Divider,
  Drawer,
  DrawerButton,
  Dropdown,
  DynamicFormInput,
  Ellipses,
  Error$1 as Error,
  ErrorBoundary,
  Field,
  FileBrowser,
  FileInput,
  FlexBox,
  FormikField,
  GridArea,
  ImagePreview,
  Input,
  Logo,
  Menu,
  MenuItem,
  MenuItemStyle,
  MenuStyle,
  Modal,
  ModalContainer,
  NotFound,
  Note,
  Page,
  PageHeader,
  PageHeaderTitle,
  Preview,
  Protected,
  ReaderLayout,
  RequireRoles,
  S3DownloadLink,
  S3FileBrowser,
  SVGPreview,
  Select,
  SelectionSearch,
  Spacer,
  Spinner,
  Tab,
  TabContent,
  Table,
  TablePreview,
  Tabs,
  TabsList,
  TaskQueueLogs,
  Textarea,
  ThemeContext,
  ThemeProvider,
  Title,
  Toggle,
  UploadToast,
  _S3FileBrowser,
  fileListToArray,
  pageVariants,
  useModalContext,
  useTailwindBreakpoint,
  useTheme
};
//# sourceMappingURL=components.js.map
